import * as React from "react";
import React__default, { createContext, useContext, useMemo, useRef, useCallback, useState, useEffect, useLayoutEffect, useId as useId$1, Fragment, createElement, useInsertionEffect, forwardRef, Component, isValidElement, cloneElement, Children } from "react";
import { SvgIcon as SvgIcon$2, alpha as alpha$2, createTheme as createTheme$2, StyledEngineProvider, ThemeProvider as ThemeProvider$4, CssBaseline as CssBaseline$1, Card as Card$1, Typography as Typography$2, Box, useTheme as useTheme$4, IconButton as IconButton$1, DialogContent as DialogContent$3, Button as Button$5, Dialog as Dialog$2, Stack, Skeleton as Skeleton$1, styled as styled$2, CircularProgress as CircularProgress$1, Popover as Popover$2, CardContent, CardHeader, TextField as TextField$1, Grid, FormControl as FormControl$1, InputLabel as InputLabel$1, Select as Select$2, MenuItem, Divider, useMediaQuery as useMediaQuery$1, InputAdornment as InputAdornment$1, Autocomplete as Autocomplete$1, Tabs as Tabs$1, Tab } from "@mui/material";
import styled$1, { ThemeContext as ThemeContext$1, GlobalStyles as GlobalStyles$2, internal_serializeStyles, internal_mutateStyles, keyframes as keyframes$1, css } from "@mui/styled-engine-sc";
import * as ReactDOM from "react-dom";
import ReactDOM__default from "react-dom";
const isString$2 = (e) => typeof e == "string", defer = () => {
  let e, t;
  const o = new Promise((n, s) => {
    e = n, t = s;
  });
  return o.resolve = e, o.reject = t, o;
}, makeString = (e) => e == null ? "" : "" + e, copy = (e, t, o) => {
  e.forEach((n) => {
    t[n] && (o[n] = t[n]);
  });
}, lastOfPathSeparatorRegExp = /###/g, cleanKey = (e) => e && e.indexOf("###") > -1 ? e.replace(lastOfPathSeparatorRegExp, ".") : e, canNotTraverseDeeper = (e) => !e || isString$2(e), getLastOfPath = (e, t, o) => {
  const n = isString$2(t) ? t.split(".") : t;
  let s = 0;
  for (; s < n.length - 1; ) {
    if (canNotTraverseDeeper(e)) return {};
    const i = cleanKey(n[s]);
    !e[i] && o && (e[i] = new o()), Object.prototype.hasOwnProperty.call(e, i) ? e = e[i] : e = {}, ++s;
  }
  return canNotTraverseDeeper(e) ? {} : {
    obj: e,
    k: cleanKey(n[s])
  };
}, setPath = (e, t, o) => {
  const {
    obj: n,
    k: s
  } = getLastOfPath(e, t, Object);
  if (n !== void 0 || t.length === 1) {
    n[s] = o;
    return;
  }
  let i = t[t.length - 1], l = t.slice(0, t.length - 1), d = getLastOfPath(e, l, Object);
  for (; d.obj === void 0 && l.length; )
    i = `${l[l.length - 1]}.${i}`, l = l.slice(0, l.length - 1), d = getLastOfPath(e, l, Object), d?.obj && typeof d.obj[`${d.k}.${i}`] < "u" && (d.obj = void 0);
  d.obj[`${d.k}.${i}`] = o;
}, pushPath = (e, t, o, n) => {
  const {
    obj: s,
    k: i
  } = getLastOfPath(e, t, Object);
  s[i] = s[i] || [], s[i].push(o);
}, getPath$1 = (e, t) => {
  const {
    obj: o,
    k: n
  } = getLastOfPath(e, t);
  if (o && Object.prototype.hasOwnProperty.call(o, n))
    return o[n];
}, getPathWithDefaults = (e, t, o) => {
  const n = getPath$1(e, o);
  return n !== void 0 ? n : getPath$1(t, o);
}, deepExtend = (e, t, o) => {
  for (const n in t)
    n !== "__proto__" && n !== "constructor" && (n in e ? isString$2(e[n]) || e[n] instanceof String || isString$2(t[n]) || t[n] instanceof String ? o && (e[n] = t[n]) : deepExtend(e[n], t[n], o) : e[n] = t[n]);
  return e;
}, regexEscape = (e) => e.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
var _entityMap = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
  "/": "&#x2F;"
};
const escape = (e) => isString$2(e) ? e.replace(/[&<>"'\/]/g, (t) => _entityMap[t]) : e;
class RegExpCache {
  constructor(t) {
    this.capacity = t, this.regExpMap = /* @__PURE__ */ new Map(), this.regExpQueue = [];
  }
  getRegExp(t) {
    const o = this.regExpMap.get(t);
    if (o !== void 0)
      return o;
    const n = new RegExp(t);
    return this.regExpQueue.length === this.capacity && this.regExpMap.delete(this.regExpQueue.shift()), this.regExpMap.set(t, n), this.regExpQueue.push(t), n;
  }
}
const chars = [" ", ",", "?", "!", ";"], looksLikeObjectPathRegExpCache = new RegExpCache(20), looksLikeObjectPath = (e, t, o) => {
  t = t || "", o = o || "";
  const n = chars.filter((l) => t.indexOf(l) < 0 && o.indexOf(l) < 0);
  if (n.length === 0) return !0;
  const s = looksLikeObjectPathRegExpCache.getRegExp(`(${n.map((l) => l === "?" ? "\\?" : l).join("|")})`);
  let i = !s.test(e);
  if (!i) {
    const l = e.indexOf(o);
    l > 0 && !s.test(e.substring(0, l)) && (i = !0);
  }
  return i;
}, deepFind = (e, t, o = ".") => {
  if (!e) return;
  if (e[t])
    return Object.prototype.hasOwnProperty.call(e, t) ? e[t] : void 0;
  const n = t.split(o);
  let s = e;
  for (let i = 0; i < n.length; ) {
    if (!s || typeof s != "object")
      return;
    let l, d = "";
    for (let u = i; u < n.length; ++u)
      if (u !== i && (d += o), d += n[u], l = s[d], l !== void 0) {
        if (["string", "number", "boolean"].indexOf(typeof l) > -1 && u < n.length - 1)
          continue;
        i += u - i + 1;
        break;
      }
    s = l;
  }
  return s;
}, getCleanedCode = (e) => e?.replace("_", "-"), consoleLogger = {
  type: "logger",
  log(e) {
    this.output("log", e);
  },
  warn(e) {
    this.output("warn", e);
  },
  error(e) {
    this.output("error", e);
  },
  output(e, t) {
    console?.[e]?.apply?.(console, t);
  }
};
class Logger {
  constructor(t, o = {}) {
    this.init(t, o);
  }
  init(t, o = {}) {
    this.prefix = o.prefix || "i18next:", this.logger = t || consoleLogger, this.options = o, this.debug = o.debug;
  }
  log(...t) {
    return this.forward(t, "log", "", !0);
  }
  warn(...t) {
    return this.forward(t, "warn", "", !0);
  }
  error(...t) {
    return this.forward(t, "error", "");
  }
  deprecate(...t) {
    return this.forward(t, "warn", "WARNING DEPRECATED: ", !0);
  }
  forward(t, o, n, s) {
    return s && !this.debug ? null : (isString$2(t[0]) && (t[0] = `${n}${this.prefix} ${t[0]}`), this.logger[o](t));
  }
  create(t) {
    return new Logger(this.logger, {
      prefix: `${this.prefix}:${t}:`,
      ...this.options
    });
  }
  clone(t) {
    return t = t || this.options, t.prefix = t.prefix || this.prefix, new Logger(this.logger, t);
  }
}
var baseLogger = new Logger();
class EventEmitter {
  constructor() {
    this.observers = {};
  }
  on(t, o) {
    return t.split(" ").forEach((n) => {
      this.observers[n] || (this.observers[n] = /* @__PURE__ */ new Map());
      const s = this.observers[n].get(o) || 0;
      this.observers[n].set(o, s + 1);
    }), this;
  }
  off(t, o) {
    if (this.observers[t]) {
      if (!o) {
        delete this.observers[t];
        return;
      }
      this.observers[t].delete(o);
    }
  }
  emit(t, ...o) {
    this.observers[t] && Array.from(this.observers[t].entries()).forEach(([s, i]) => {
      for (let l = 0; l < i; l++)
        s(...o);
    }), this.observers["*"] && Array.from(this.observers["*"].entries()).forEach(([s, i]) => {
      for (let l = 0; l < i; l++)
        s.apply(s, [t, ...o]);
    });
  }
}
class ResourceStore extends EventEmitter {
  constructor(t, o = {
    ns: ["translation"],
    defaultNS: "translation"
  }) {
    super(), this.data = t || {}, this.options = o, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.options.ignoreJSONStructure === void 0 && (this.options.ignoreJSONStructure = !0);
  }
  addNamespaces(t) {
    this.options.ns.indexOf(t) < 0 && this.options.ns.push(t);
  }
  removeNamespaces(t) {
    const o = this.options.ns.indexOf(t);
    o > -1 && this.options.ns.splice(o, 1);
  }
  getResource(t, o, n, s = {}) {
    const i = s.keySeparator !== void 0 ? s.keySeparator : this.options.keySeparator, l = s.ignoreJSONStructure !== void 0 ? s.ignoreJSONStructure : this.options.ignoreJSONStructure;
    let d;
    t.indexOf(".") > -1 ? d = t.split(".") : (d = [t, o], n && (Array.isArray(n) ? d.push(...n) : isString$2(n) && i ? d.push(...n.split(i)) : d.push(n)));
    const u = getPath$1(this.data, d);
    return !u && !o && !n && t.indexOf(".") > -1 && (t = d[0], o = d[1], n = d.slice(2).join(".")), u || !l || !isString$2(n) ? u : deepFind(this.data?.[t]?.[o], n, i);
  }
  addResource(t, o, n, s, i = {
    silent: !1
  }) {
    const l = i.keySeparator !== void 0 ? i.keySeparator : this.options.keySeparator;
    let d = [t, o];
    n && (d = d.concat(l ? n.split(l) : n)), t.indexOf(".") > -1 && (d = t.split("."), s = o, o = d[1]), this.addNamespaces(o), setPath(this.data, d, s), i.silent || this.emit("added", t, o, n, s);
  }
  addResources(t, o, n, s = {
    silent: !1
  }) {
    for (const i in n)
      (isString$2(n[i]) || Array.isArray(n[i])) && this.addResource(t, o, i, n[i], {
        silent: !0
      });
    s.silent || this.emit("added", t, o, n);
  }
  addResourceBundle(t, o, n, s, i, l = {
    silent: !1,
    skipCopy: !1
  }) {
    let d = [t, o];
    t.indexOf(".") > -1 && (d = t.split("."), s = n, n = o, o = d[1]), this.addNamespaces(o);
    let u = getPath$1(this.data, d) || {};
    l.skipCopy || (n = JSON.parse(JSON.stringify(n))), s ? deepExtend(u, n, i) : u = {
      ...u,
      ...n
    }, setPath(this.data, d, u), l.silent || this.emit("added", t, o, n);
  }
  removeResourceBundle(t, o) {
    this.hasResourceBundle(t, o) && delete this.data[t][o], this.removeNamespaces(o), this.emit("removed", t, o);
  }
  hasResourceBundle(t, o) {
    return this.getResource(t, o) !== void 0;
  }
  getResourceBundle(t, o) {
    return o || (o = this.options.defaultNS), this.getResource(t, o);
  }
  getDataByLanguage(t) {
    return this.data[t];
  }
  hasLanguageSomeTranslations(t) {
    const o = this.getDataByLanguage(t);
    return !!(o && Object.keys(o) || []).find((s) => o[s] && Object.keys(o[s]).length > 0);
  }
  toJSON() {
    return this.data;
  }
}
var postProcessor = {
  processors: {},
  addPostProcessor(e) {
    this.processors[e.name] = e;
  },
  handle(e, t, o, n, s) {
    return e.forEach((i) => {
      t = this.processors[i]?.process(t, o, n, s) ?? t;
    }), t;
  }
};
const PATH_KEY = Symbol("i18next/PATH_KEY");
function createProxy() {
  const e = [], t = /* @__PURE__ */ Object.create(null);
  let o;
  return t.get = (n, s) => (o?.revoke?.(), s === PATH_KEY ? e : (e.push(s), o = Proxy.revocable(n, t), o.proxy)), Proxy.revocable(/* @__PURE__ */ Object.create(null), t).proxy;
}
function keysFromSelector(e, t) {
  const {
    [PATH_KEY]: o
  } = e(createProxy());
  return o.join(t?.keySeparator ?? ".");
}
const checkedLoadedFor = {}, shouldHandleAsObject = (e) => !isString$2(e) && typeof e != "boolean" && typeof e != "number";
class Translator extends EventEmitter {
  constructor(t, o = {}) {
    super(), copy(["resourceStore", "languageUtils", "pluralResolver", "interpolator", "backendConnector", "i18nFormat", "utils"], t, this), this.options = o, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.logger = baseLogger.create("translator");
  }
  changeLanguage(t) {
    t && (this.language = t);
  }
  exists(t, o = {
    interpolation: {}
  }) {
    const n = {
      ...o
    };
    if (t == null) return !1;
    const s = this.resolve(t, n);
    if (s?.res === void 0) return !1;
    const i = shouldHandleAsObject(s.res);
    return !(n.returnObjects === !1 && i);
  }
  extractFromKey(t, o) {
    let n = o.nsSeparator !== void 0 ? o.nsSeparator : this.options.nsSeparator;
    n === void 0 && (n = ":");
    const s = o.keySeparator !== void 0 ? o.keySeparator : this.options.keySeparator;
    let i = o.ns || this.options.defaultNS || [];
    const l = n && t.indexOf(n) > -1, d = !this.options.userDefinedKeySeparator && !o.keySeparator && !this.options.userDefinedNsSeparator && !o.nsSeparator && !looksLikeObjectPath(t, n, s);
    if (l && !d) {
      const u = t.match(this.interpolator.nestingRegexp);
      if (u && u.length > 0)
        return {
          key: t,
          namespaces: isString$2(i) ? [i] : i
        };
      const c = t.split(n);
      (n !== s || n === s && this.options.ns.indexOf(c[0]) > -1) && (i = c.shift()), t = c.join(s);
    }
    return {
      key: t,
      namespaces: isString$2(i) ? [i] : i
    };
  }
  translate(t, o, n) {
    let s = typeof o == "object" ? {
      ...o
    } : o;
    if (typeof s != "object" && this.options.overloadTranslationOptionHandler && (s = this.options.overloadTranslationOptionHandler(arguments)), typeof s == "object" && (s = {
      ...s
    }), s || (s = {}), t == null) return "";
    typeof t == "function" && (t = keysFromSelector(t, {
      ...this.options,
      ...s
    })), Array.isArray(t) || (t = [String(t)]);
    const i = s.returnDetails !== void 0 ? s.returnDetails : this.options.returnDetails, l = s.keySeparator !== void 0 ? s.keySeparator : this.options.keySeparator, {
      key: d,
      namespaces: u
    } = this.extractFromKey(t[t.length - 1], s), c = u[u.length - 1];
    let p = s.nsSeparator !== void 0 ? s.nsSeparator : this.options.nsSeparator;
    p === void 0 && (p = ":");
    const f = s.lng || this.language, g = s.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
    if (f?.toLowerCase() === "cimode")
      return g ? i ? {
        res: `${c}${p}${d}`,
        usedKey: d,
        exactUsedKey: d,
        usedLng: f,
        usedNS: c,
        usedParams: this.getUsedParamsDetails(s)
      } : `${c}${p}${d}` : i ? {
        res: d,
        usedKey: d,
        exactUsedKey: d,
        usedLng: f,
        usedNS: c,
        usedParams: this.getUsedParamsDetails(s)
      } : d;
    const y = this.resolve(t, s);
    let h = y?.res;
    const T = y?.usedKey || d, P = y?.exactUsedKey || d, E = ["[object Number]", "[object Function]", "[object RegExp]"], $ = s.joinArrays !== void 0 ? s.joinArrays : this.options.joinArrays, R = !this.i18nFormat || this.i18nFormat.handleAsObject, C = s.count !== void 0 && !isString$2(s.count), x = Translator.hasDefaultValue(s), _ = C ? this.pluralResolver.getSuffix(f, s.count, s) : "", D = s.ordinal && C ? this.pluralResolver.getSuffix(f, s.count, {
      ordinal: !1
    }) : "", O = C && !s.ordinal && s.count === 0, v = O && s[`defaultValue${this.options.pluralSeparator}zero`] || s[`defaultValue${_}`] || s[`defaultValue${D}`] || s.defaultValue;
    let w = h;
    R && !h && x && (w = v);
    const M = shouldHandleAsObject(w), S = Object.prototype.toString.apply(w);
    if (R && w && M && E.indexOf(S) < 0 && !(isString$2($) && Array.isArray(w))) {
      if (!s.returnObjects && !this.options.returnObjects) {
        this.options.returnedObjectHandler || this.logger.warn("accessing an object - but returnObjects options is not enabled!");
        const I = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(T, w, {
          ...s,
          ns: u
        }) : `key '${d} (${this.language})' returned an object instead of string.`;
        return i ? (y.res = I, y.usedParams = this.getUsedParamsDetails(s), y) : I;
      }
      if (l) {
        const I = Array.isArray(w), N = I ? [] : {}, F = I ? P : T;
        for (const L in w)
          if (Object.prototype.hasOwnProperty.call(w, L)) {
            const k = `${F}${l}${L}`;
            x && !h ? N[L] = this.translate(k, {
              ...s,
              defaultValue: shouldHandleAsObject(v) ? v[L] : void 0,
              joinArrays: !1,
              ns: u
            }) : N[L] = this.translate(k, {
              ...s,
              joinArrays: !1,
              ns: u
            }), N[L] === k && (N[L] = w[L]);
          }
        h = N;
      }
    } else if (R && isString$2($) && Array.isArray(h))
      h = h.join($), h && (h = this.extendTranslation(h, t, s, n));
    else {
      let I = !1, N = !1;
      !this.isValidLookup(h) && x && (I = !0, h = v), this.isValidLookup(h) || (N = !0, h = d);
      const L = (s.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey) && N ? void 0 : h, k = x && v !== h && this.options.updateMissing;
      if (N || I || k) {
        if (this.logger.log(k ? "updateKey" : "missingKey", f, c, d, k ? v : h), l) {
          const A = this.resolve(d, {
            ...s,
            keySeparator: !1
          });
          A && A.res && this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
        }
        let W = [];
        const V = this.languageUtils.getFallbackCodes(this.options.fallbackLng, s.lng || this.language);
        if (this.options.saveMissingTo === "fallback" && V && V[0])
          for (let A = 0; A < V.length; A++)
            W.push(V[A]);
        else this.options.saveMissingTo === "all" ? W = this.languageUtils.toResolveHierarchy(s.lng || this.language) : W.push(s.lng || this.language);
        const j = (A, U, G) => {
          const Y = x && G !== h ? G : L;
          this.options.missingKeyHandler ? this.options.missingKeyHandler(A, c, U, Y, k, s) : this.backendConnector?.saveMissing && this.backendConnector.saveMissing(A, c, U, Y, k, s), this.emit("missingKey", A, c, U, h);
        };
        this.options.saveMissing && (this.options.saveMissingPlurals && C ? W.forEach((A) => {
          const U = this.pluralResolver.getSuffixes(A, s);
          O && s[`defaultValue${this.options.pluralSeparator}zero`] && U.indexOf(`${this.options.pluralSeparator}zero`) < 0 && U.push(`${this.options.pluralSeparator}zero`), U.forEach((G) => {
            j([A], d + G, s[`defaultValue${G}`] || v);
          });
        }) : j(W, d, v));
      }
      h = this.extendTranslation(h, t, s, y, n), N && h === d && this.options.appendNamespaceToMissingKey && (h = `${c}${p}${d}`), (N || I) && this.options.parseMissingKeyHandler && (h = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${c}${p}${d}` : d, I ? h : void 0, s));
    }
    return i ? (y.res = h, y.usedParams = this.getUsedParamsDetails(s), y) : h;
  }
  extendTranslation(t, o, n, s, i) {
    if (this.i18nFormat?.parse)
      t = this.i18nFormat.parse(t, {
        ...this.options.interpolation.defaultVariables,
        ...n
      }, n.lng || this.language || s.usedLng, s.usedNS, s.usedKey, {
        resolved: s
      });
    else if (!n.skipInterpolation) {
      n.interpolation && this.interpolator.init({
        ...n,
        interpolation: {
          ...this.options.interpolation,
          ...n.interpolation
        }
      });
      const u = isString$2(t) && (n?.interpolation?.skipOnVariables !== void 0 ? n.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
      let c;
      if (u) {
        const f = t.match(this.interpolator.nestingRegexp);
        c = f && f.length;
      }
      let p = n.replace && !isString$2(n.replace) ? n.replace : n;
      if (this.options.interpolation.defaultVariables && (p = {
        ...this.options.interpolation.defaultVariables,
        ...p
      }), t = this.interpolator.interpolate(t, p, n.lng || this.language || s.usedLng, n), u) {
        const f = t.match(this.interpolator.nestingRegexp), g = f && f.length;
        c < g && (n.nest = !1);
      }
      !n.lng && s && s.res && (n.lng = this.language || s.usedLng), n.nest !== !1 && (t = this.interpolator.nest(t, (...f) => i?.[0] === f[0] && !n.context ? (this.logger.warn(`It seems you are nesting recursively key: ${f[0]} in key: ${o[0]}`), null) : this.translate(...f, o), n)), n.interpolation && this.interpolator.reset();
    }
    const l = n.postProcess || this.options.postProcess, d = isString$2(l) ? [l] : l;
    return t != null && d?.length && n.applyPostProcessor !== !1 && (t = postProcessor.handle(d, t, o, this.options && this.options.postProcessPassResolved ? {
      i18nResolved: {
        ...s,
        usedParams: this.getUsedParamsDetails(n)
      },
      ...n
    } : n, this)), t;
  }
  resolve(t, o = {}) {
    let n, s, i, l, d;
    return isString$2(t) && (t = [t]), t.forEach((u) => {
      if (this.isValidLookup(n)) return;
      const c = this.extractFromKey(u, o), p = c.key;
      s = p;
      let f = c.namespaces;
      this.options.fallbackNS && (f = f.concat(this.options.fallbackNS));
      const g = o.count !== void 0 && !isString$2(o.count), y = g && !o.ordinal && o.count === 0, h = o.context !== void 0 && (isString$2(o.context) || typeof o.context == "number") && o.context !== "", T = o.lngs ? o.lngs : this.languageUtils.toResolveHierarchy(o.lng || this.language, o.fallbackLng);
      f.forEach((P) => {
        this.isValidLookup(n) || (d = P, !checkedLoadedFor[`${T[0]}-${P}`] && this.utils?.hasLoadedNamespace && !this.utils?.hasLoadedNamespace(d) && (checkedLoadedFor[`${T[0]}-${P}`] = !0, this.logger.warn(`key "${s}" for languages "${T.join(", ")}" won't get resolved as namespace "${d}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!")), T.forEach((E) => {
          if (this.isValidLookup(n)) return;
          l = E;
          const $ = [p];
          if (this.i18nFormat?.addLookupKeys)
            this.i18nFormat.addLookupKeys($, p, E, P, o);
          else {
            let C;
            g && (C = this.pluralResolver.getSuffix(E, o.count, o));
            const x = `${this.options.pluralSeparator}zero`, _ = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
            if (g && (o.ordinal && C.indexOf(_) === 0 && $.push(p + C.replace(_, this.options.pluralSeparator)), $.push(p + C), y && $.push(p + x)), h) {
              const D = `${p}${this.options.contextSeparator || "_"}${o.context}`;
              $.push(D), g && (o.ordinal && C.indexOf(_) === 0 && $.push(D + C.replace(_, this.options.pluralSeparator)), $.push(D + C), y && $.push(D + x));
            }
          }
          let R;
          for (; R = $.pop(); )
            this.isValidLookup(n) || (i = R, n = this.getResource(E, P, R, o));
        }));
      });
    }), {
      res: n,
      usedKey: s,
      exactUsedKey: i,
      usedLng: l,
      usedNS: d
    };
  }
  isValidLookup(t) {
    return t !== void 0 && !(!this.options.returnNull && t === null) && !(!this.options.returnEmptyString && t === "");
  }
  getResource(t, o, n, s = {}) {
    return this.i18nFormat?.getResource ? this.i18nFormat.getResource(t, o, n, s) : this.resourceStore.getResource(t, o, n, s);
  }
  getUsedParamsDetails(t = {}) {
    const o = ["defaultValue", "ordinal", "context", "replace", "lng", "lngs", "fallbackLng", "ns", "keySeparator", "nsSeparator", "returnObjects", "returnDetails", "joinArrays", "postProcess", "interpolation"], n = t.replace && !isString$2(t.replace);
    let s = n ? t.replace : t;
    if (n && typeof t.count < "u" && (s.count = t.count), this.options.interpolation.defaultVariables && (s = {
      ...this.options.interpolation.defaultVariables,
      ...s
    }), !n) {
      s = {
        ...s
      };
      for (const i of o)
        delete s[i];
    }
    return s;
  }
  static hasDefaultValue(t) {
    const o = "defaultValue";
    for (const n in t)
      if (Object.prototype.hasOwnProperty.call(t, n) && o === n.substring(0, o.length) && t[n] !== void 0)
        return !0;
    return !1;
  }
}
class LanguageUtil {
  constructor(t) {
    this.options = t, this.supportedLngs = this.options.supportedLngs || !1, this.logger = baseLogger.create("languageUtils");
  }
  getScriptPartFromCode(t) {
    if (t = getCleanedCode(t), !t || t.indexOf("-") < 0) return null;
    const o = t.split("-");
    return o.length === 2 || (o.pop(), o[o.length - 1].toLowerCase() === "x") ? null : this.formatLanguageCode(o.join("-"));
  }
  getLanguagePartFromCode(t) {
    if (t = getCleanedCode(t), !t || t.indexOf("-") < 0) return t;
    const o = t.split("-");
    return this.formatLanguageCode(o[0]);
  }
  formatLanguageCode(t) {
    if (isString$2(t) && t.indexOf("-") > -1) {
      let o;
      try {
        o = Intl.getCanonicalLocales(t)[0];
      } catch {
      }
      return o && this.options.lowerCaseLng && (o = o.toLowerCase()), o || (this.options.lowerCaseLng ? t.toLowerCase() : t);
    }
    return this.options.cleanCode || this.options.lowerCaseLng ? t.toLowerCase() : t;
  }
  isSupportedCode(t) {
    return (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) && (t = this.getLanguagePartFromCode(t)), !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(t) > -1;
  }
  getBestMatchFromCodes(t) {
    if (!t) return null;
    let o;
    return t.forEach((n) => {
      if (o) return;
      const s = this.formatLanguageCode(n);
      (!this.options.supportedLngs || this.isSupportedCode(s)) && (o = s);
    }), !o && this.options.supportedLngs && t.forEach((n) => {
      if (o) return;
      const s = this.getScriptPartFromCode(n);
      if (this.isSupportedCode(s)) return o = s;
      const i = this.getLanguagePartFromCode(n);
      if (this.isSupportedCode(i)) return o = i;
      o = this.options.supportedLngs.find((l) => {
        if (l === i) return l;
        if (!(l.indexOf("-") < 0 && i.indexOf("-") < 0) && (l.indexOf("-") > 0 && i.indexOf("-") < 0 && l.substring(0, l.indexOf("-")) === i || l.indexOf(i) === 0 && i.length > 1))
          return l;
      });
    }), o || (o = this.getFallbackCodes(this.options.fallbackLng)[0]), o;
  }
  getFallbackCodes(t, o) {
    if (!t) return [];
    if (typeof t == "function" && (t = t(o)), isString$2(t) && (t = [t]), Array.isArray(t)) return t;
    if (!o) return t.default || [];
    let n = t[o];
    return n || (n = t[this.getScriptPartFromCode(o)]), n || (n = t[this.formatLanguageCode(o)]), n || (n = t[this.getLanguagePartFromCode(o)]), n || (n = t.default), n || [];
  }
  toResolveHierarchy(t, o) {
    const n = this.getFallbackCodes((o === !1 ? [] : o) || this.options.fallbackLng || [], t), s = [], i = (l) => {
      l && (this.isSupportedCode(l) ? s.push(l) : this.logger.warn(`rejecting language code not found in supportedLngs: ${l}`));
    };
    return isString$2(t) && (t.indexOf("-") > -1 || t.indexOf("_") > -1) ? (this.options.load !== "languageOnly" && i(this.formatLanguageCode(t)), this.options.load !== "languageOnly" && this.options.load !== "currentOnly" && i(this.getScriptPartFromCode(t)), this.options.load !== "currentOnly" && i(this.getLanguagePartFromCode(t))) : isString$2(t) && i(this.formatLanguageCode(t)), n.forEach((l) => {
      s.indexOf(l) < 0 && i(this.formatLanguageCode(l));
    }), s;
  }
}
const suffixesOrder = {
  zero: 0,
  one: 1,
  two: 2,
  few: 3,
  many: 4,
  other: 5
}, dummyRule = {
  select: (e) => e === 1 ? "one" : "other",
  resolvedOptions: () => ({
    pluralCategories: ["one", "other"]
  })
};
class PluralResolver {
  constructor(t, o = {}) {
    this.languageUtils = t, this.options = o, this.logger = baseLogger.create("pluralResolver"), this.pluralRulesCache = {};
  }
  addRule(t, o) {
    this.rules[t] = o;
  }
  clearCache() {
    this.pluralRulesCache = {};
  }
  getRule(t, o = {}) {
    const n = getCleanedCode(t === "dev" ? "en" : t), s = o.ordinal ? "ordinal" : "cardinal", i = JSON.stringify({
      cleanedCode: n,
      type: s
    });
    if (i in this.pluralRulesCache)
      return this.pluralRulesCache[i];
    let l;
    try {
      l = new Intl.PluralRules(n, {
        type: s
      });
    } catch {
      if (!Intl)
        return this.logger.error("No Intl support, please use an Intl polyfill!"), dummyRule;
      if (!t.match(/-|_/)) return dummyRule;
      const u = this.languageUtils.getLanguagePartFromCode(t);
      l = this.getRule(u, o);
    }
    return this.pluralRulesCache[i] = l, l;
  }
  needsPlural(t, o = {}) {
    let n = this.getRule(t, o);
    return n || (n = this.getRule("dev", o)), n?.resolvedOptions().pluralCategories.length > 1;
  }
  getPluralFormsOfKey(t, o, n = {}) {
    return this.getSuffixes(t, n).map((s) => `${o}${s}`);
  }
  getSuffixes(t, o = {}) {
    let n = this.getRule(t, o);
    return n || (n = this.getRule("dev", o)), n ? n.resolvedOptions().pluralCategories.sort((s, i) => suffixesOrder[s] - suffixesOrder[i]).map((s) => `${this.options.prepend}${o.ordinal ? `ordinal${this.options.prepend}` : ""}${s}`) : [];
  }
  getSuffix(t, o, n = {}) {
    const s = this.getRule(t, n);
    return s ? `${this.options.prepend}${n.ordinal ? `ordinal${this.options.prepend}` : ""}${s.select(o)}` : (this.logger.warn(`no plural rule found for: ${t}`), this.getSuffix("dev", o, n));
  }
}
const deepFindWithDefaults = (e, t, o, n = ".", s = !0) => {
  let i = getPathWithDefaults(e, t, o);
  return !i && s && isString$2(o) && (i = deepFind(e, o, n), i === void 0 && (i = deepFind(t, o, n))), i;
}, regexSafe = (e) => e.replace(/\$/g, "$$$$");
class Interpolator {
  constructor(t = {}) {
    this.logger = baseLogger.create("interpolator"), this.options = t, this.format = t?.interpolation?.format || ((o) => o), this.init(t);
  }
  init(t = {}) {
    t.interpolation || (t.interpolation = {
      escapeValue: !0
    });
    const {
      escape: o,
      escapeValue: n,
      useRawValueToEscape: s,
      prefix: i,
      prefixEscaped: l,
      suffix: d,
      suffixEscaped: u,
      formatSeparator: c,
      unescapeSuffix: p,
      unescapePrefix: f,
      nestingPrefix: g,
      nestingPrefixEscaped: y,
      nestingSuffix: h,
      nestingSuffixEscaped: T,
      nestingOptionsSeparator: P,
      maxReplaces: E,
      alwaysFormat: $
    } = t.interpolation;
    this.escape = o !== void 0 ? o : escape, this.escapeValue = n !== void 0 ? n : !0, this.useRawValueToEscape = s !== void 0 ? s : !1, this.prefix = i ? regexEscape(i) : l || "{{", this.suffix = d ? regexEscape(d) : u || "}}", this.formatSeparator = c || ",", this.unescapePrefix = p ? "" : f || "-", this.unescapeSuffix = this.unescapePrefix ? "" : p || "", this.nestingPrefix = g ? regexEscape(g) : y || regexEscape("$t("), this.nestingSuffix = h ? regexEscape(h) : T || regexEscape(")"), this.nestingOptionsSeparator = P || ",", this.maxReplaces = E || 1e3, this.alwaysFormat = $ !== void 0 ? $ : !1, this.resetRegExp();
  }
  reset() {
    this.options && this.init(this.options);
  }
  resetRegExp() {
    const t = (o, n) => o?.source === n ? (o.lastIndex = 0, o) : new RegExp(n, "g");
    this.regexp = t(this.regexp, `${this.prefix}(.+?)${this.suffix}`), this.regexpUnescape = t(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`), this.nestingRegexp = t(this.nestingRegexp, `${this.nestingPrefix}((?:[^()"']+|"[^"]*"|'[^']*'|\\((?:[^()]|"[^"]*"|'[^']*')*\\))*?)${this.nestingSuffix}`);
  }
  interpolate(t, o, n, s) {
    let i, l, d;
    const u = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {}, c = (y) => {
      if (y.indexOf(this.formatSeparator) < 0) {
        const E = deepFindWithDefaults(o, u, y, this.options.keySeparator, this.options.ignoreJSONStructure);
        return this.alwaysFormat ? this.format(E, void 0, n, {
          ...s,
          ...o,
          interpolationkey: y
        }) : E;
      }
      const h = y.split(this.formatSeparator), T = h.shift().trim(), P = h.join(this.formatSeparator).trim();
      return this.format(deepFindWithDefaults(o, u, T, this.options.keySeparator, this.options.ignoreJSONStructure), P, n, {
        ...s,
        ...o,
        interpolationkey: T
      });
    };
    this.resetRegExp();
    const p = s?.missingInterpolationHandler || this.options.missingInterpolationHandler, f = s?.interpolation?.skipOnVariables !== void 0 ? s.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
    return [{
      regex: this.regexpUnescape,
      safeValue: (y) => regexSafe(y)
    }, {
      regex: this.regexp,
      safeValue: (y) => this.escapeValue ? regexSafe(this.escape(y)) : regexSafe(y)
    }].forEach((y) => {
      for (d = 0; i = y.regex.exec(t); ) {
        const h = i[1].trim();
        if (l = c(h), l === void 0)
          if (typeof p == "function") {
            const P = p(t, i, s);
            l = isString$2(P) ? P : "";
          } else if (s && Object.prototype.hasOwnProperty.call(s, h))
            l = "";
          else if (f) {
            l = i[0];
            continue;
          } else
            this.logger.warn(`missed to pass in variable ${h} for interpolating ${t}`), l = "";
        else !isString$2(l) && !this.useRawValueToEscape && (l = makeString(l));
        const T = y.safeValue(l);
        if (t = t.replace(i[0], T), f ? (y.regex.lastIndex += l.length, y.regex.lastIndex -= i[0].length) : y.regex.lastIndex = 0, d++, d >= this.maxReplaces)
          break;
      }
    }), t;
  }
  nest(t, o, n = {}) {
    let s, i, l;
    const d = (u, c) => {
      const p = this.nestingOptionsSeparator;
      if (u.indexOf(p) < 0) return u;
      const f = u.split(new RegExp(`${p}[ ]*{`));
      let g = `{${f[1]}`;
      u = f[0], g = this.interpolate(g, l);
      const y = g.match(/'/g), h = g.match(/"/g);
      ((y?.length ?? 0) % 2 === 0 && !h || h.length % 2 !== 0) && (g = g.replace(/'/g, '"'));
      try {
        l = JSON.parse(g), c && (l = {
          ...c,
          ...l
        });
      } catch (T) {
        return this.logger.warn(`failed parsing options string in nesting for key ${u}`, T), `${u}${p}${g}`;
      }
      return l.defaultValue && l.defaultValue.indexOf(this.prefix) > -1 && delete l.defaultValue, u;
    };
    for (; s = this.nestingRegexp.exec(t); ) {
      let u = [];
      l = {
        ...n
      }, l = l.replace && !isString$2(l.replace) ? l.replace : l, l.applyPostProcessor = !1, delete l.defaultValue;
      const c = /{.*}/.test(s[1]) ? s[1].lastIndexOf("}") + 1 : s[1].indexOf(this.formatSeparator);
      if (c !== -1 && (u = s[1].slice(c).split(this.formatSeparator).map((p) => p.trim()).filter(Boolean), s[1] = s[1].slice(0, c)), i = o(d.call(this, s[1].trim(), l), l), i && s[0] === t && !isString$2(i)) return i;
      isString$2(i) || (i = makeString(i)), i || (this.logger.warn(`missed to resolve ${s[1]} for nesting ${t}`), i = ""), u.length && (i = u.reduce((p, f) => this.format(p, f, n.lng, {
        ...n,
        interpolationkey: s[1].trim()
      }), i.trim())), t = t.replace(s[0], i), this.regexp.lastIndex = 0;
    }
    return t;
  }
}
const parseFormatStr = (e) => {
  let t = e.toLowerCase().trim();
  const o = {};
  if (e.indexOf("(") > -1) {
    const n = e.split("(");
    t = n[0].toLowerCase().trim();
    const s = n[1].substring(0, n[1].length - 1);
    t === "currency" && s.indexOf(":") < 0 ? o.currency || (o.currency = s.trim()) : t === "relativetime" && s.indexOf(":") < 0 ? o.range || (o.range = s.trim()) : s.split(";").forEach((l) => {
      if (l) {
        const [d, ...u] = l.split(":"), c = u.join(":").trim().replace(/^'+|'+$/g, ""), p = d.trim();
        o[p] || (o[p] = c), c === "false" && (o[p] = !1), c === "true" && (o[p] = !0), isNaN(c) || (o[p] = parseInt(c, 10));
      }
    });
  }
  return {
    formatName: t,
    formatOptions: o
  };
}, createCachedFormatter = (e) => {
  const t = {};
  return (o, n, s) => {
    let i = s;
    s && s.interpolationkey && s.formatParams && s.formatParams[s.interpolationkey] && s[s.interpolationkey] && (i = {
      ...i,
      [s.interpolationkey]: void 0
    });
    const l = n + JSON.stringify(i);
    let d = t[l];
    return d || (d = e(getCleanedCode(n), s), t[l] = d), d(o);
  };
}, createNonCachedFormatter = (e) => (t, o, n) => e(getCleanedCode(o), n)(t);
class Formatter {
  constructor(t = {}) {
    this.logger = baseLogger.create("formatter"), this.options = t, this.init(t);
  }
  init(t, o = {
    interpolation: {}
  }) {
    this.formatSeparator = o.interpolation.formatSeparator || ",";
    const n = o.cacheInBuiltFormats ? createCachedFormatter : createNonCachedFormatter;
    this.formats = {
      number: n((s, i) => {
        const l = new Intl.NumberFormat(s, {
          ...i
        });
        return (d) => l.format(d);
      }),
      currency: n((s, i) => {
        const l = new Intl.NumberFormat(s, {
          ...i,
          style: "currency"
        });
        return (d) => l.format(d);
      }),
      datetime: n((s, i) => {
        const l = new Intl.DateTimeFormat(s, {
          ...i
        });
        return (d) => l.format(d);
      }),
      relativetime: n((s, i) => {
        const l = new Intl.RelativeTimeFormat(s, {
          ...i
        });
        return (d) => l.format(d, i.range || "day");
      }),
      list: n((s, i) => {
        const l = new Intl.ListFormat(s, {
          ...i
        });
        return (d) => l.format(d);
      })
    };
  }
  add(t, o) {
    this.formats[t.toLowerCase().trim()] = o;
  }
  addCached(t, o) {
    this.formats[t.toLowerCase().trim()] = createCachedFormatter(o);
  }
  format(t, o, n, s = {}) {
    const i = o.split(this.formatSeparator);
    if (i.length > 1 && i[0].indexOf("(") > 1 && i[0].indexOf(")") < 0 && i.find((d) => d.indexOf(")") > -1)) {
      const d = i.findIndex((u) => u.indexOf(")") > -1);
      i[0] = [i[0], ...i.splice(1, d)].join(this.formatSeparator);
    }
    return i.reduce((d, u) => {
      const {
        formatName: c,
        formatOptions: p
      } = parseFormatStr(u);
      if (this.formats[c]) {
        let f = d;
        try {
          const g = s?.formatParams?.[s.interpolationkey] || {}, y = g.locale || g.lng || s.locale || s.lng || n;
          f = this.formats[c](d, y, {
            ...p,
            ...s,
            ...g
          });
        } catch (g) {
          this.logger.warn(g);
        }
        return f;
      } else
        this.logger.warn(`there was no format function for ${c}`);
      return d;
    }, t);
  }
}
const removePending = (e, t) => {
  e.pending[t] !== void 0 && (delete e.pending[t], e.pendingCount--);
};
class Connector extends EventEmitter {
  constructor(t, o, n, s = {}) {
    super(), this.backend = t, this.store = o, this.services = n, this.languageUtils = n.languageUtils, this.options = s, this.logger = baseLogger.create("backendConnector"), this.waitingReads = [], this.maxParallelReads = s.maxParallelReads || 10, this.readingCalls = 0, this.maxRetries = s.maxRetries >= 0 ? s.maxRetries : 5, this.retryTimeout = s.retryTimeout >= 1 ? s.retryTimeout : 350, this.state = {}, this.queue = [], this.backend?.init?.(n, s.backend, s);
  }
  queueLoad(t, o, n, s) {
    const i = {}, l = {}, d = {}, u = {};
    return t.forEach((c) => {
      let p = !0;
      o.forEach((f) => {
        const g = `${c}|${f}`;
        !n.reload && this.store.hasResourceBundle(c, f) ? this.state[g] = 2 : this.state[g] < 0 || (this.state[g] === 1 ? l[g] === void 0 && (l[g] = !0) : (this.state[g] = 1, p = !1, l[g] === void 0 && (l[g] = !0), i[g] === void 0 && (i[g] = !0), u[f] === void 0 && (u[f] = !0)));
      }), p || (d[c] = !0);
    }), (Object.keys(i).length || Object.keys(l).length) && this.queue.push({
      pending: l,
      pendingCount: Object.keys(l).length,
      loaded: {},
      errors: [],
      callback: s
    }), {
      toLoad: Object.keys(i),
      pending: Object.keys(l),
      toLoadLanguages: Object.keys(d),
      toLoadNamespaces: Object.keys(u)
    };
  }
  loaded(t, o, n) {
    const s = t.split("|"), i = s[0], l = s[1];
    o && this.emit("failedLoading", i, l, o), !o && n && this.store.addResourceBundle(i, l, n, void 0, void 0, {
      skipCopy: !0
    }), this.state[t] = o ? -1 : 2, o && n && (this.state[t] = 0);
    const d = {};
    this.queue.forEach((u) => {
      pushPath(u.loaded, [i], l), removePending(u, t), o && u.errors.push(o), u.pendingCount === 0 && !u.done && (Object.keys(u.loaded).forEach((c) => {
        d[c] || (d[c] = {});
        const p = u.loaded[c];
        p.length && p.forEach((f) => {
          d[c][f] === void 0 && (d[c][f] = !0);
        });
      }), u.done = !0, u.errors.length ? u.callback(u.errors) : u.callback());
    }), this.emit("loaded", d), this.queue = this.queue.filter((u) => !u.done);
  }
  read(t, o, n, s = 0, i = this.retryTimeout, l) {
    if (!t.length) return l(null, {});
    if (this.readingCalls >= this.maxParallelReads) {
      this.waitingReads.push({
        lng: t,
        ns: o,
        fcName: n,
        tried: s,
        wait: i,
        callback: l
      });
      return;
    }
    this.readingCalls++;
    const d = (c, p) => {
      if (this.readingCalls--, this.waitingReads.length > 0) {
        const f = this.waitingReads.shift();
        this.read(f.lng, f.ns, f.fcName, f.tried, f.wait, f.callback);
      }
      if (c && p && s < this.maxRetries) {
        setTimeout(() => {
          this.read.call(this, t, o, n, s + 1, i * 2, l);
        }, i);
        return;
      }
      l(c, p);
    }, u = this.backend[n].bind(this.backend);
    if (u.length === 2) {
      try {
        const c = u(t, o);
        c && typeof c.then == "function" ? c.then((p) => d(null, p)).catch(d) : d(null, c);
      } catch (c) {
        d(c);
      }
      return;
    }
    return u(t, o, d);
  }
  prepareLoading(t, o, n = {}, s) {
    if (!this.backend)
      return this.logger.warn("No backend was added via i18next.use. Will not load resources."), s && s();
    isString$2(t) && (t = this.languageUtils.toResolveHierarchy(t)), isString$2(o) && (o = [o]);
    const i = this.queueLoad(t, o, n, s);
    if (!i.toLoad.length)
      return i.pending.length || s(), null;
    i.toLoad.forEach((l) => {
      this.loadOne(l);
    });
  }
  load(t, o, n) {
    this.prepareLoading(t, o, {}, n);
  }
  reload(t, o, n) {
    this.prepareLoading(t, o, {
      reload: !0
    }, n);
  }
  loadOne(t, o = "") {
    const n = t.split("|"), s = n[0], i = n[1];
    this.read(s, i, "read", void 0, void 0, (l, d) => {
      l && this.logger.warn(`${o}loading namespace ${i} for language ${s} failed`, l), !l && d && this.logger.log(`${o}loaded namespace ${i} for language ${s}`, d), this.loaded(t, l, d);
    });
  }
  saveMissing(t, o, n, s, i, l = {}, d = () => {
  }) {
    if (this.services?.utils?.hasLoadedNamespace && !this.services?.utils?.hasLoadedNamespace(o)) {
      this.logger.warn(`did not save key "${n}" as the namespace "${o}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
      return;
    }
    if (!(n == null || n === "")) {
      if (this.backend?.create) {
        const u = {
          ...l,
          isUpdate: i
        }, c = this.backend.create.bind(this.backend);
        if (c.length < 6)
          try {
            let p;
            c.length === 5 ? p = c(t, o, n, s, u) : p = c(t, o, n, s), p && typeof p.then == "function" ? p.then((f) => d(null, f)).catch(d) : d(null, p);
          } catch (p) {
            d(p);
          }
        else
          c(t, o, n, s, d, u);
      }
      !t || !t[0] || this.store.addResource(t[0], o, n, s);
    }
  }
}
const get = () => ({
  debug: !1,
  initAsync: !0,
  ns: ["translation"],
  defaultNS: ["translation"],
  fallbackLng: ["dev"],
  fallbackNS: !1,
  supportedLngs: !1,
  nonExplicitSupportedLngs: !1,
  load: "all",
  preload: !1,
  simplifyPluralSuffix: !0,
  keySeparator: ".",
  nsSeparator: ":",
  pluralSeparator: "_",
  contextSeparator: "_",
  partialBundledLanguages: !1,
  saveMissing: !1,
  updateMissing: !1,
  saveMissingTo: "fallback",
  saveMissingPlurals: !0,
  missingKeyHandler: !1,
  missingInterpolationHandler: !1,
  postProcess: !1,
  postProcessPassResolved: !1,
  returnNull: !1,
  returnEmptyString: !0,
  returnObjects: !1,
  joinArrays: !1,
  returnedObjectHandler: !1,
  parseMissingKeyHandler: !1,
  appendNamespaceToMissingKey: !1,
  appendNamespaceToCIMode: !1,
  overloadTranslationOptionHandler: (e) => {
    let t = {};
    if (typeof e[1] == "object" && (t = e[1]), isString$2(e[1]) && (t.defaultValue = e[1]), isString$2(e[2]) && (t.tDescription = e[2]), typeof e[2] == "object" || typeof e[3] == "object") {
      const o = e[3] || e[2];
      Object.keys(o).forEach((n) => {
        t[n] = o[n];
      });
    }
    return t;
  },
  interpolation: {
    escapeValue: !0,
    format: (e) => e,
    prefix: "{{",
    suffix: "}}",
    formatSeparator: ",",
    unescapePrefix: "-",
    nestingPrefix: "$t(",
    nestingSuffix: ")",
    nestingOptionsSeparator: ",",
    maxReplaces: 1e3,
    skipOnVariables: !0
  },
  cacheInBuiltFormats: !0
}), transformOptions = (e) => (isString$2(e.ns) && (e.ns = [e.ns]), isString$2(e.fallbackLng) && (e.fallbackLng = [e.fallbackLng]), isString$2(e.fallbackNS) && (e.fallbackNS = [e.fallbackNS]), e.supportedLngs?.indexOf?.("cimode") < 0 && (e.supportedLngs = e.supportedLngs.concat(["cimode"])), typeof e.initImmediate == "boolean" && (e.initAsync = e.initImmediate), e), noop$8 = () => {
}, bindMemberFunctions = (e) => {
  Object.getOwnPropertyNames(Object.getPrototypeOf(e)).forEach((o) => {
    typeof e[o] == "function" && (e[o] = e[o].bind(e));
  });
};
class I18n extends EventEmitter {
  constructor(t = {}, o) {
    if (super(), this.options = transformOptions(t), this.services = {}, this.logger = baseLogger, this.modules = {
      external: []
    }, bindMemberFunctions(this), o && !this.isInitialized && !t.isClone) {
      if (!this.options.initAsync)
        return this.init(t, o), this;
      setTimeout(() => {
        this.init(t, o);
      }, 0);
    }
  }
  init(t = {}, o) {
    this.isInitializing = !0, typeof t == "function" && (o = t, t = {}), t.defaultNS == null && t.ns && (isString$2(t.ns) ? t.defaultNS = t.ns : t.ns.indexOf("translation") < 0 && (t.defaultNS = t.ns[0]));
    const n = get();
    this.options = {
      ...n,
      ...this.options,
      ...transformOptions(t)
    }, this.options.interpolation = {
      ...n.interpolation,
      ...this.options.interpolation
    }, t.keySeparator !== void 0 && (this.options.userDefinedKeySeparator = t.keySeparator), t.nsSeparator !== void 0 && (this.options.userDefinedNsSeparator = t.nsSeparator);
    const s = (c) => c ? typeof c == "function" ? new c() : c : null;
    if (!this.options.isClone) {
      this.modules.logger ? baseLogger.init(s(this.modules.logger), this.options) : baseLogger.init(null, this.options);
      let c;
      this.modules.formatter ? c = this.modules.formatter : c = Formatter;
      const p = new LanguageUtil(this.options);
      this.store = new ResourceStore(this.options.resources, this.options);
      const f = this.services;
      f.logger = baseLogger, f.resourceStore = this.store, f.languageUtils = p, f.pluralResolver = new PluralResolver(p, {
        prepend: this.options.pluralSeparator,
        simplifyPluralSuffix: this.options.simplifyPluralSuffix
      }), this.options.interpolation.format && this.options.interpolation.format !== n.interpolation.format && this.logger.deprecate("init: you are still using the legacy format function, please use the new approach: https://www.i18next.com/translation-function/formatting"), c && (!this.options.interpolation.format || this.options.interpolation.format === n.interpolation.format) && (f.formatter = s(c), f.formatter.init && f.formatter.init(f, this.options), this.options.interpolation.format = f.formatter.format.bind(f.formatter)), f.interpolator = new Interpolator(this.options), f.utils = {
        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
      }, f.backendConnector = new Connector(s(this.modules.backend), f.resourceStore, f, this.options), f.backendConnector.on("*", (y, ...h) => {
        this.emit(y, ...h);
      }), this.modules.languageDetector && (f.languageDetector = s(this.modules.languageDetector), f.languageDetector.init && f.languageDetector.init(f, this.options.detection, this.options)), this.modules.i18nFormat && (f.i18nFormat = s(this.modules.i18nFormat), f.i18nFormat.init && f.i18nFormat.init(this)), this.translator = new Translator(this.services, this.options), this.translator.on("*", (y, ...h) => {
        this.emit(y, ...h);
      }), this.modules.external.forEach((y) => {
        y.init && y.init(this);
      });
    }
    if (this.format = this.options.interpolation.format, o || (o = noop$8), this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
      const c = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
      c.length > 0 && c[0] !== "dev" && (this.options.lng = c[0]);
    }
    !this.services.languageDetector && !this.options.lng && this.logger.warn("init: no languageDetector is used and no lng is defined"), ["getResource", "hasResourceBundle", "getResourceBundle", "getDataByLanguage"].forEach((c) => {
      this[c] = (...p) => this.store[c](...p);
    }), ["addResource", "addResources", "addResourceBundle", "removeResourceBundle"].forEach((c) => {
      this[c] = (...p) => (this.store[c](...p), this);
    });
    const d = defer(), u = () => {
      const c = (p, f) => {
        this.isInitializing = !1, this.isInitialized && !this.initializedStoreOnce && this.logger.warn("init: i18next is already initialized. You should call init just once!"), this.isInitialized = !0, this.options.isClone || this.logger.log("initialized", this.options), this.emit("initialized", this.options), d.resolve(f), o(p, f);
      };
      if (this.languages && !this.isInitialized) return c(null, this.t.bind(this));
      this.changeLanguage(this.options.lng, c);
    };
    return this.options.resources || !this.options.initAsync ? u() : setTimeout(u, 0), d;
  }
  loadResources(t, o = noop$8) {
    let n = o;
    const s = isString$2(t) ? t : this.language;
    if (typeof t == "function" && (n = t), !this.options.resources || this.options.partialBundledLanguages) {
      if (s?.toLowerCase() === "cimode" && (!this.options.preload || this.options.preload.length === 0)) return n();
      const i = [], l = (d) => {
        if (!d || d === "cimode") return;
        this.services.languageUtils.toResolveHierarchy(d).forEach((c) => {
          c !== "cimode" && i.indexOf(c) < 0 && i.push(c);
        });
      };
      s ? l(s) : this.services.languageUtils.getFallbackCodes(this.options.fallbackLng).forEach((u) => l(u)), this.options.preload?.forEach?.((d) => l(d)), this.services.backendConnector.load(i, this.options.ns, (d) => {
        !d && !this.resolvedLanguage && this.language && this.setResolvedLanguage(this.language), n(d);
      });
    } else
      n(null);
  }
  reloadResources(t, o, n) {
    const s = defer();
    return typeof t == "function" && (n = t, t = void 0), typeof o == "function" && (n = o, o = void 0), t || (t = this.languages), o || (o = this.options.ns), n || (n = noop$8), this.services.backendConnector.reload(t, o, (i) => {
      s.resolve(), n(i);
    }), s;
  }
  use(t) {
    if (!t) throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
    if (!t.type) throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
    return t.type === "backend" && (this.modules.backend = t), (t.type === "logger" || t.log && t.warn && t.error) && (this.modules.logger = t), t.type === "languageDetector" && (this.modules.languageDetector = t), t.type === "i18nFormat" && (this.modules.i18nFormat = t), t.type === "postProcessor" && postProcessor.addPostProcessor(t), t.type === "formatter" && (this.modules.formatter = t), t.type === "3rdParty" && this.modules.external.push(t), this;
  }
  setResolvedLanguage(t) {
    if (!(!t || !this.languages) && !(["cimode", "dev"].indexOf(t) > -1)) {
      for (let o = 0; o < this.languages.length; o++) {
        const n = this.languages[o];
        if (!(["cimode", "dev"].indexOf(n) > -1) && this.store.hasLanguageSomeTranslations(n)) {
          this.resolvedLanguage = n;
          break;
        }
      }
      !this.resolvedLanguage && this.languages.indexOf(t) < 0 && this.store.hasLanguageSomeTranslations(t) && (this.resolvedLanguage = t, this.languages.unshift(t));
    }
  }
  changeLanguage(t, o) {
    this.isLanguageChangingTo = t;
    const n = defer();
    this.emit("languageChanging", t);
    const s = (d) => {
      this.language = d, this.languages = this.services.languageUtils.toResolveHierarchy(d), this.resolvedLanguage = void 0, this.setResolvedLanguage(d);
    }, i = (d, u) => {
      u ? this.isLanguageChangingTo === t && (s(u), this.translator.changeLanguage(u), this.isLanguageChangingTo = void 0, this.emit("languageChanged", u), this.logger.log("languageChanged", u)) : this.isLanguageChangingTo = void 0, n.resolve((...c) => this.t(...c)), o && o(d, (...c) => this.t(...c));
    }, l = (d) => {
      !t && !d && this.services.languageDetector && (d = []);
      const u = isString$2(d) ? d : d && d[0], c = this.store.hasLanguageSomeTranslations(u) ? u : this.services.languageUtils.getBestMatchFromCodes(isString$2(d) ? [d] : d);
      c && (this.language || s(c), this.translator.language || this.translator.changeLanguage(c), this.services.languageDetector?.cacheUserLanguage?.(c)), this.loadResources(c, (p) => {
        i(p, c);
      });
    };
    return !t && this.services.languageDetector && !this.services.languageDetector.async ? l(this.services.languageDetector.detect()) : !t && this.services.languageDetector && this.services.languageDetector.async ? this.services.languageDetector.detect.length === 0 ? this.services.languageDetector.detect().then(l) : this.services.languageDetector.detect(l) : l(t), n;
  }
  getFixedT(t, o, n) {
    const s = (i, l, ...d) => {
      let u;
      typeof l != "object" ? u = this.options.overloadTranslationOptionHandler([i, l].concat(d)) : u = {
        ...l
      }, u.lng = u.lng || s.lng, u.lngs = u.lngs || s.lngs, u.ns = u.ns || s.ns, u.keyPrefix !== "" && (u.keyPrefix = u.keyPrefix || n || s.keyPrefix);
      const c = this.options.keySeparator || ".";
      let p;
      return u.keyPrefix && Array.isArray(i) ? p = i.map((f) => (typeof f == "function" && (f = keysFromSelector(f, {
        ...this.options,
        ...l
      })), `${u.keyPrefix}${c}${f}`)) : (typeof i == "function" && (i = keysFromSelector(i, {
        ...this.options,
        ...l
      })), p = u.keyPrefix ? `${u.keyPrefix}${c}${i}` : i), this.t(p, u);
    };
    return isString$2(t) ? s.lng = t : s.lngs = t, s.ns = o, s.keyPrefix = n, s;
  }
  t(...t) {
    return this.translator?.translate(...t);
  }
  exists(...t) {
    return this.translator?.exists(...t);
  }
  setDefaultNamespace(t) {
    this.options.defaultNS = t;
  }
  hasLoadedNamespace(t, o = {}) {
    if (!this.isInitialized)
      return this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages), !1;
    if (!this.languages || !this.languages.length)
      return this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages), !1;
    const n = o.lng || this.resolvedLanguage || this.languages[0], s = this.options ? this.options.fallbackLng : !1, i = this.languages[this.languages.length - 1];
    if (n.toLowerCase() === "cimode") return !0;
    const l = (d, u) => {
      const c = this.services.backendConnector.state[`${d}|${u}`];
      return c === -1 || c === 0 || c === 2;
    };
    if (o.precheck) {
      const d = o.precheck(this, l);
      if (d !== void 0) return d;
    }
    return !!(this.hasResourceBundle(n, t) || !this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages || l(n, t) && (!s || l(i, t)));
  }
  loadNamespaces(t, o) {
    const n = defer();
    return this.options.ns ? (isString$2(t) && (t = [t]), t.forEach((s) => {
      this.options.ns.indexOf(s) < 0 && this.options.ns.push(s);
    }), this.loadResources((s) => {
      n.resolve(), o && o(s);
    }), n) : (o && o(), Promise.resolve());
  }
  loadLanguages(t, o) {
    const n = defer();
    isString$2(t) && (t = [t]);
    const s = this.options.preload || [], i = t.filter((l) => s.indexOf(l) < 0 && this.services.languageUtils.isSupportedCode(l));
    return i.length ? (this.options.preload = s.concat(i), this.loadResources((l) => {
      n.resolve(), o && o(l);
    }), n) : (o && o(), Promise.resolve());
  }
  dir(t) {
    if (t || (t = this.resolvedLanguage || (this.languages?.length > 0 ? this.languages[0] : this.language)), !t) return "rtl";
    try {
      const s = new Intl.Locale(t);
      if (s && s.getTextInfo) {
        const i = s.getTextInfo();
        if (i && i.direction) return i.direction;
      }
    } catch {
    }
    const o = ["ar", "shu", "sqr", "ssh", "xaa", "yhd", "yud", "aao", "abh", "abv", "acm", "acq", "acw", "acx", "acy", "adf", "ads", "aeb", "aec", "afb", "ajp", "apc", "apd", "arb", "arq", "ars", "ary", "arz", "auz", "avl", "ayh", "ayl", "ayn", "ayp", "bbz", "pga", "he", "iw", "ps", "pbt", "pbu", "pst", "prp", "prd", "ug", "ur", "ydd", "yds", "yih", "ji", "yi", "hbo", "men", "xmn", "fa", "jpr", "peo", "pes", "prs", "dv", "sam", "ckb"], n = this.services?.languageUtils || new LanguageUtil(get());
    return t.toLowerCase().indexOf("-latn") > 1 ? "ltr" : o.indexOf(n.getLanguagePartFromCode(t)) > -1 || t.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
  }
  static createInstance(t = {}, o) {
    const n = new I18n(t, o);
    return n.createInstance = I18n.createInstance, n;
  }
  cloneInstance(t = {}, o = noop$8) {
    const n = t.forkResourceStore;
    n && delete t.forkResourceStore;
    const s = {
      ...this.options,
      ...t,
      isClone: !0
    }, i = new I18n(s);
    if ((t.debug !== void 0 || t.prefix !== void 0) && (i.logger = i.logger.clone(t)), ["store", "services", "language"].forEach((d) => {
      i[d] = this[d];
    }), i.services = {
      ...this.services
    }, i.services.utils = {
      hasLoadedNamespace: i.hasLoadedNamespace.bind(i)
    }, n) {
      const d = Object.keys(this.store.data).reduce((u, c) => (u[c] = {
        ...this.store.data[c]
      }, u[c] = Object.keys(u[c]).reduce((p, f) => (p[f] = {
        ...u[c][f]
      }, p), u[c]), u), {});
      i.store = new ResourceStore(d, s), i.services.resourceStore = i.store;
    }
    return i.translator = new Translator(i.services, s), i.translator.on("*", (d, ...u) => {
      i.emit(d, ...u);
    }), i.init(s, o), i.translator.options = s, i.translator.backendConnector.services.utils = {
      hasLoadedNamespace: i.hasLoadedNamespace.bind(i)
    }, i;
  }
  toJSON() {
    return {
      options: this.options,
      store: this.store,
      language: this.language,
      languages: this.languages,
      resolvedLanguage: this.resolvedLanguage
    };
  }
}
const instance = I18n.createInstance();
instance.createInstance;
instance.dir;
instance.init;
instance.loadResources;
instance.reloadResources;
instance.use;
instance.changeLanguage;
instance.getFixedT;
instance.t;
instance.exists;
instance.setDefaultNamespace;
instance.hasLoadedNamespace;
instance.loadNamespaces;
instance.loadLanguages;
const {
  slice,
  forEach: forEach$1
} = [];
function defaults$1(e) {
  return forEach$1.call(slice.call(arguments, 1), (t) => {
    if (t)
      for (const o in t)
        e[o] === void 0 && (e[o] = t[o]);
  }), e;
}
function hasXSS(e) {
  return typeof e != "string" ? !1 : [/<\s*script.*?>/i, /<\s*\/\s*script\s*>/i, /<\s*img.*?on\w+\s*=/i, /<\s*\w+\s*on\w+\s*=.*?>/i, /javascript\s*:/i, /vbscript\s*:/i, /expression\s*\(/i, /eval\s*\(/i, /alert\s*\(/i, /document\.cookie/i, /document\.write\s*\(/i, /window\.location/i, /innerHTML/i].some((o) => o.test(e));
}
const fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/, serializeCookie = function(e, t) {
  const n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
    path: "/"
  }, s = encodeURIComponent(t);
  let i = `${e}=${s}`;
  if (n.maxAge > 0) {
    const l = n.maxAge - 0;
    if (Number.isNaN(l)) throw new Error("maxAge should be a Number");
    i += `; Max-Age=${Math.floor(l)}`;
  }
  if (n.domain) {
    if (!fieldContentRegExp.test(n.domain))
      throw new TypeError("option domain is invalid");
    i += `; Domain=${n.domain}`;
  }
  if (n.path) {
    if (!fieldContentRegExp.test(n.path))
      throw new TypeError("option path is invalid");
    i += `; Path=${n.path}`;
  }
  if (n.expires) {
    if (typeof n.expires.toUTCString != "function")
      throw new TypeError("option expires is invalid");
    i += `; Expires=${n.expires.toUTCString()}`;
  }
  if (n.httpOnly && (i += "; HttpOnly"), n.secure && (i += "; Secure"), n.sameSite)
    switch (typeof n.sameSite == "string" ? n.sameSite.toLowerCase() : n.sameSite) {
      case !0:
        i += "; SameSite=Strict";
        break;
      case "lax":
        i += "; SameSite=Lax";
        break;
      case "strict":
        i += "; SameSite=Strict";
        break;
      case "none":
        i += "; SameSite=None";
        break;
      default:
        throw new TypeError("option sameSite is invalid");
    }
  return n.partitioned && (i += "; Partitioned"), i;
}, cookie = {
  create(e, t, o, n) {
    let s = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {
      path: "/",
      sameSite: "strict"
    };
    o && (s.expires = /* @__PURE__ */ new Date(), s.expires.setTime(s.expires.getTime() + o * 60 * 1e3)), n && (s.domain = n), document.cookie = serializeCookie(e, t, s);
  },
  read(e) {
    const t = `${e}=`, o = document.cookie.split(";");
    for (let n = 0; n < o.length; n++) {
      let s = o[n];
      for (; s.charAt(0) === " "; ) s = s.substring(1, s.length);
      if (s.indexOf(t) === 0) return s.substring(t.length, s.length);
    }
    return null;
  },
  remove(e, t) {
    this.create(e, "", -1, t);
  }
};
var cookie$1 = {
  name: "cookie",
  // Deconstruct the options object and extract the lookupCookie property
  lookup(e) {
    let {
      lookupCookie: t
    } = e;
    if (t && typeof document < "u")
      return cookie.read(t) || void 0;
  },
  // Deconstruct the options object and extract the lookupCookie, cookieMinutes, cookieDomain, and cookieOptions properties
  cacheUserLanguage(e, t) {
    let {
      lookupCookie: o,
      cookieMinutes: n,
      cookieDomain: s,
      cookieOptions: i
    } = t;
    o && typeof document < "u" && cookie.create(o, e, n, s, i);
  }
}, querystring = {
  name: "querystring",
  // Deconstruct the options object and extract the lookupQuerystring property
  lookup(e) {
    let {
      lookupQuerystring: t
    } = e, o;
    if (typeof window < "u") {
      let {
        search: n
      } = window.location;
      !window.location.search && window.location.hash?.indexOf("?") > -1 && (n = window.location.hash.substring(window.location.hash.indexOf("?")));
      const i = n.substring(1).split("&");
      for (let l = 0; l < i.length; l++) {
        const d = i[l].indexOf("=");
        d > 0 && i[l].substring(0, d) === t && (o = i[l].substring(d + 1));
      }
    }
    return o;
  }
}, hash$2 = {
  name: "hash",
  // Deconstruct the options object and extract the lookupHash property and the lookupFromHashIndex property
  lookup(e) {
    let {
      lookupHash: t,
      lookupFromHashIndex: o
    } = e, n;
    if (typeof window < "u") {
      const {
        hash: s
      } = window.location;
      if (s && s.length > 2) {
        const i = s.substring(1);
        if (t) {
          const l = i.split("&");
          for (let d = 0; d < l.length; d++) {
            const u = l[d].indexOf("=");
            u > 0 && l[d].substring(0, u) === t && (n = l[d].substring(u + 1));
          }
        }
        if (n) return n;
        if (!n && o > -1) {
          const l = s.match(/\/([a-zA-Z-]*)/g);
          return Array.isArray(l) ? l[typeof o == "number" ? o : 0]?.replace("/", "") : void 0;
        }
      }
    }
    return n;
  }
};
let hasLocalStorageSupport = null;
const localStorageAvailable = () => {
  if (hasLocalStorageSupport !== null) return hasLocalStorageSupport;
  try {
    if (hasLocalStorageSupport = typeof window < "u" && window.localStorage !== null, !hasLocalStorageSupport)
      return !1;
    const e = "i18next.translate.boo";
    window.localStorage.setItem(e, "foo"), window.localStorage.removeItem(e);
  } catch {
    hasLocalStorageSupport = !1;
  }
  return hasLocalStorageSupport;
};
var localStorage = {
  name: "localStorage",
  // Deconstruct the options object and extract the lookupLocalStorage property
  lookup(e) {
    let {
      lookupLocalStorage: t
    } = e;
    if (t && localStorageAvailable())
      return window.localStorage.getItem(t) || void 0;
  },
  // Deconstruct the options object and extract the lookupLocalStorage property
  cacheUserLanguage(e, t) {
    let {
      lookupLocalStorage: o
    } = t;
    o && localStorageAvailable() && window.localStorage.setItem(o, e);
  }
};
let hasSessionStorageSupport = null;
const sessionStorageAvailable = () => {
  if (hasSessionStorageSupport !== null) return hasSessionStorageSupport;
  try {
    if (hasSessionStorageSupport = typeof window < "u" && window.sessionStorage !== null, !hasSessionStorageSupport)
      return !1;
    const e = "i18next.translate.boo";
    window.sessionStorage.setItem(e, "foo"), window.sessionStorage.removeItem(e);
  } catch {
    hasSessionStorageSupport = !1;
  }
  return hasSessionStorageSupport;
};
var sessionStorage = {
  name: "sessionStorage",
  lookup(e) {
    let {
      lookupSessionStorage: t
    } = e;
    if (t && sessionStorageAvailable())
      return window.sessionStorage.getItem(t) || void 0;
  },
  cacheUserLanguage(e, t) {
    let {
      lookupSessionStorage: o
    } = t;
    o && sessionStorageAvailable() && window.sessionStorage.setItem(o, e);
  }
}, navigator$1 = {
  name: "navigator",
  lookup(e) {
    const t = [];
    if (typeof navigator < "u") {
      const {
        languages: o,
        userLanguage: n,
        language: s
      } = navigator;
      if (o)
        for (let i = 0; i < o.length; i++)
          t.push(o[i]);
      n && t.push(n), s && t.push(s);
    }
    return t.length > 0 ? t : void 0;
  }
}, htmlTag = {
  name: "htmlTag",
  // Deconstruct the options object and extract the htmlTag property
  lookup(e) {
    let {
      htmlTag: t
    } = e, o;
    const n = t || (typeof document < "u" ? document.documentElement : null);
    return n && typeof n.getAttribute == "function" && (o = n.getAttribute("lang")), o;
  }
}, path = {
  name: "path",
  // Deconstruct the options object and extract the lookupFromPathIndex property
  lookup(e) {
    let {
      lookupFromPathIndex: t
    } = e;
    if (typeof window > "u") return;
    const o = window.location.pathname.match(/\/([a-zA-Z-]*)/g);
    return Array.isArray(o) ? o[typeof t == "number" ? t : 0]?.replace("/", "") : void 0;
  }
}, subdomain = {
  name: "subdomain",
  lookup(e) {
    let {
      lookupFromSubdomainIndex: t
    } = e;
    const o = typeof t == "number" ? t + 1 : 1, n = typeof window < "u" && window.location?.hostname?.match(/^(\w{2,5})\.(([a-z0-9-]{1,63}\.[a-z]{2,6})|localhost)/i);
    if (n)
      return n[o];
  }
};
let canCookies = !1;
try {
  document.cookie, canCookies = !0;
} catch {
}
const order$1 = ["querystring", "cookie", "localStorage", "sessionStorage", "navigator", "htmlTag"];
canCookies || order$1.splice(1, 1);
const getDefaults$2 = () => ({
  order: order$1,
  lookupQuerystring: "lng",
  lookupCookie: "i18next",
  lookupLocalStorage: "i18nextLng",
  lookupSessionStorage: "i18nextLng",
  // cache user language
  caches: ["localStorage"],
  excludeCacheFor: ["cimode"],
  // cookieMinutes: 10,
  // cookieDomain: 'myDomain'
  convertDetectedLanguage: (e) => e
});
class Browser {
  constructor(t) {
    let o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.type = "languageDetector", this.detectors = {}, this.init(t, o);
  }
  init() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
      languageUtils: {}
    }, o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    this.services = t, this.options = defaults$1(o, this.options || {}, getDefaults$2()), typeof this.options.convertDetectedLanguage == "string" && this.options.convertDetectedLanguage.indexOf("15897") > -1 && (this.options.convertDetectedLanguage = (s) => s.replace("-", "_")), this.options.lookupFromUrlIndex && (this.options.lookupFromPathIndex = this.options.lookupFromUrlIndex), this.i18nOptions = n, this.addDetector(cookie$1), this.addDetector(querystring), this.addDetector(localStorage), this.addDetector(sessionStorage), this.addDetector(navigator$1), this.addDetector(htmlTag), this.addDetector(path), this.addDetector(subdomain), this.addDetector(hash$2);
  }
  addDetector(t) {
    return this.detectors[t.name] = t, this;
  }
  detect() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.options.order, o = [];
    return t.forEach((n) => {
      if (this.detectors[n]) {
        let s = this.detectors[n].lookup(this.options);
        s && typeof s == "string" && (s = [s]), s && (o = o.concat(s));
      }
    }), o = o.filter((n) => n != null && !hasXSS(n)).map((n) => this.options.convertDetectedLanguage(n)), this.services && this.services.languageUtils && this.services.languageUtils.getBestMatchFromCodes ? o : o.length > 0 ? o[0] : null;
  }
  cacheUserLanguage(t) {
    let o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.options.caches;
    o && (this.options.excludeCacheFor && this.options.excludeCacheFor.indexOf(t) > -1 || o.forEach((n) => {
      this.detectors[n] && this.detectors[n].cacheUserLanguage(t, this.options);
    }));
  }
}
Browser.type = "languageDetector";
function _typeof$2(e) {
  "@babel/helpers - typeof";
  return _typeof$2 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, _typeof$2(e);
}
function hasXMLHttpRequest() {
  return typeof XMLHttpRequest == "function" || (typeof XMLHttpRequest > "u" ? "undefined" : _typeof$2(XMLHttpRequest)) === "object";
}
function isPromise(e) {
  return !!e && typeof e.then == "function";
}
function makePromise(e) {
  return isPromise(e) ? e : Promise.resolve(e);
}
function ownKeys$1(e, t) {
  var o = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(s) {
      return Object.getOwnPropertyDescriptor(e, s).enumerable;
    })), o.push.apply(o, n);
  }
  return o;
}
function _objectSpread$1(e) {
  for (var t = 1; t < arguments.length; t++) {
    var o = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ownKeys$1(Object(o), !0).forEach(function(n) {
      _defineProperty$1(e, n, o[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(o)) : ownKeys$1(Object(o)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(o, n));
    });
  }
  return e;
}
function _defineProperty$1(e, t, o) {
  return (t = _toPropertyKey$1(t)) in e ? Object.defineProperty(e, t, { value: o, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = o, e;
}
function _toPropertyKey$1(e) {
  var t = _toPrimitive$1(e, "string");
  return _typeof$1(t) == "symbol" ? t : t + "";
}
function _toPrimitive$1(e, t) {
  if (_typeof$1(e) != "object" || !e) return e;
  var o = e[Symbol.toPrimitive];
  if (o !== void 0) {
    var n = o.call(e, t);
    if (_typeof$1(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function _typeof$1(e) {
  "@babel/helpers - typeof";
  return _typeof$1 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, _typeof$1(e);
}
var fetchApi = typeof fetch == "function" ? fetch : void 0;
typeof global < "u" && global.fetch ? fetchApi = global.fetch : typeof window < "u" && window.fetch && (fetchApi = window.fetch);
var XmlHttpRequestApi;
hasXMLHttpRequest() && (typeof global < "u" && global.XMLHttpRequest ? XmlHttpRequestApi = global.XMLHttpRequest : typeof window < "u" && window.XMLHttpRequest && (XmlHttpRequestApi = window.XMLHttpRequest));
var ActiveXObjectApi;
typeof ActiveXObject == "function" && (typeof global < "u" && global.ActiveXObject ? ActiveXObjectApi = global.ActiveXObject : typeof window < "u" && window.ActiveXObject && (ActiveXObjectApi = window.ActiveXObject));
typeof fetchApi != "function" && (fetchApi = void 0);
if (!fetchApi && !XmlHttpRequestApi && !ActiveXObjectApi)
  try {
    import("./browser-ponyfill-DbwLAGoU.js").then((e) => e.b).then(function(e) {
      fetchApi = e.default;
    }).catch(function() {
    });
  } catch {
  }
var addQueryString = function(t, o) {
  if (o && _typeof$1(o) === "object") {
    var n = "";
    for (var s in o)
      n += "&" + encodeURIComponent(s) + "=" + encodeURIComponent(o[s]);
    if (!n) return t;
    t = t + (t.indexOf("?") !== -1 ? "&" : "?") + n.slice(1);
  }
  return t;
}, fetchIt = function(t, o, n, s) {
  var i = function(u) {
    if (!u.ok) return n(u.statusText || "Error", {
      status: u.status
    });
    u.text().then(function(c) {
      n(null, {
        status: u.status,
        data: c
      });
    }).catch(n);
  };
  if (s) {
    var l = s(t, o);
    if (l instanceof Promise) {
      l.then(i).catch(n);
      return;
    }
  }
  typeof fetch == "function" ? fetch(t, o).then(i).catch(n) : fetchApi(t, o).then(i).catch(n);
}, omitFetchOptions = !1, requestWithFetch = function(t, o, n, s) {
  t.queryStringParams && (o = addQueryString(o, t.queryStringParams));
  var i = _objectSpread$1({}, typeof t.customHeaders == "function" ? t.customHeaders() : t.customHeaders);
  typeof window > "u" && typeof global < "u" && typeof global.process < "u" && global.process.versions && global.process.versions.node && (i["User-Agent"] = "i18next-http-backend (node/".concat(global.process.version, "; ").concat(global.process.platform, " ").concat(global.process.arch, ")")), n && (i["Content-Type"] = "application/json");
  var l = typeof t.requestOptions == "function" ? t.requestOptions(n) : t.requestOptions, d = _objectSpread$1({
    method: n ? "POST" : "GET",
    body: n ? t.stringify(n) : void 0,
    headers: i
  }, omitFetchOptions ? {} : l), u = typeof t.alternateFetch == "function" && t.alternateFetch.length >= 1 ? t.alternateFetch : void 0;
  try {
    fetchIt(o, d, s, u);
  } catch (c) {
    if (!l || Object.keys(l).length === 0 || !c.message || c.message.indexOf("not implemented") < 0)
      return s(c);
    try {
      Object.keys(l).forEach(function(p) {
        delete d[p];
      }), fetchIt(o, d, s, u), omitFetchOptions = !0;
    } catch (p) {
      s(p);
    }
  }
}, requestWithXmlHttpRequest = function(t, o, n, s) {
  n && _typeof$1(n) === "object" && (n = addQueryString("", n).slice(1)), t.queryStringParams && (o = addQueryString(o, t.queryStringParams));
  try {
    var i = XmlHttpRequestApi ? new XmlHttpRequestApi() : new ActiveXObjectApi("MSXML2.XMLHTTP.3.0");
    i.open(n ? "POST" : "GET", o, 1), t.crossDomain || i.setRequestHeader("X-Requested-With", "XMLHttpRequest"), i.withCredentials = !!t.withCredentials, n && i.setRequestHeader("Content-Type", "application/x-www-form-urlencoded"), i.overrideMimeType && i.overrideMimeType("application/json");
    var l = t.customHeaders;
    if (l = typeof l == "function" ? l() : l, l)
      for (var d in l)
        i.setRequestHeader(d, l[d]);
    i.onreadystatechange = function() {
      i.readyState > 3 && s(i.status >= 400 ? i.statusText : null, {
        status: i.status,
        data: i.responseText
      });
    }, i.send(n);
  } catch (u) {
    console && console.log(u);
  }
}, request = function(t, o, n, s) {
  if (typeof n == "function" && (s = n, n = void 0), s = s || function() {
  }, fetchApi && o.indexOf("file:") !== 0)
    return requestWithFetch(t, o, n, s);
  if (hasXMLHttpRequest() || typeof ActiveXObject == "function")
    return requestWithXmlHttpRequest(t, o, n, s);
  s(new Error("No fetch and no xhr implementation found!"));
};
function _typeof(e) {
  "@babel/helpers - typeof";
  return _typeof = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, _typeof(e);
}
function ownKeys(e, t) {
  var o = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(s) {
      return Object.getOwnPropertyDescriptor(e, s).enumerable;
    })), o.push.apply(o, n);
  }
  return o;
}
function _objectSpread(e) {
  for (var t = 1; t < arguments.length; t++) {
    var o = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ownKeys(Object(o), !0).forEach(function(n) {
      _defineProperty(e, n, o[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(o)) : ownKeys(Object(o)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(o, n));
    });
  }
  return e;
}
function _classCallCheck(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, t) {
  for (var o = 0; o < t.length; o++) {
    var n = t[o];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, _toPropertyKey(n.key), n);
  }
}
function _createClass(e, t, o) {
  return t && _defineProperties(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function _defineProperty(e, t, o) {
  return (t = _toPropertyKey(t)) in e ? Object.defineProperty(e, t, { value: o, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = o, e;
}
function _toPropertyKey(e) {
  var t = _toPrimitive(e, "string");
  return _typeof(t) == "symbol" ? t : t + "";
}
function _toPrimitive(e, t) {
  if (_typeof(e) != "object" || !e) return e;
  var o = e[Symbol.toPrimitive];
  if (o !== void 0) {
    var n = o.call(e, t);
    if (_typeof(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var getDefaults$1 = function() {
  return {
    loadPath: "/locales/{{lng}}/{{ns}}.json",
    addPath: "/locales/add/{{lng}}/{{ns}}",
    parse: function(o) {
      return JSON.parse(o);
    },
    stringify: JSON.stringify,
    parsePayload: function(o, n, s) {
      return _defineProperty({}, n, s || "");
    },
    parseLoadPayload: function(o, n) {
    },
    request,
    reloadInterval: typeof window < "u" ? !1 : 3600 * 1e3,
    customHeaders: {},
    queryStringParams: {},
    crossDomain: !1,
    withCredentials: !1,
    overrideMimeType: !1,
    requestOptions: {
      mode: "cors",
      credentials: "same-origin",
      cache: "default"
    }
  };
}, Backend = (function() {
  function e(t) {
    var o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    _classCallCheck(this, e), this.services = t, this.options = o, this.allOptions = n, this.type = "backend", this.init(t, o, n);
  }
  return _createClass(e, [{
    key: "init",
    value: function(o) {
      var n = this, s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      if (this.services = o, this.options = _objectSpread(_objectSpread(_objectSpread({}, getDefaults$1()), this.options || {}), s), this.allOptions = i, this.services && this.options.reloadInterval) {
        var l = setInterval(function() {
          return n.reload();
        }, this.options.reloadInterval);
        _typeof(l) === "object" && typeof l.unref == "function" && l.unref();
      }
    }
  }, {
    key: "readMulti",
    value: function(o, n, s) {
      this._readAny(o, o, n, n, s);
    }
  }, {
    key: "read",
    value: function(o, n, s) {
      this._readAny([o], o, [n], n, s);
    }
  }, {
    key: "_readAny",
    value: function(o, n, s, i, l) {
      var d = this, u = this.options.loadPath;
      typeof this.options.loadPath == "function" && (u = this.options.loadPath(o, s)), u = makePromise(u), u.then(function(c) {
        if (!c) return l(null, {});
        var p = d.services.interpolator.interpolate(c, {
          lng: o.join("+"),
          ns: s.join("+")
        });
        d.loadUrl(p, l, n, i);
      });
    }
  }, {
    key: "loadUrl",
    value: function(o, n, s, i) {
      var l = this, d = typeof s == "string" ? [s] : s, u = typeof i == "string" ? [i] : i, c = this.options.parseLoadPayload(d, u);
      this.options.request(this.options, o, c, function(p, f) {
        if (f && (f.status >= 500 && f.status < 600 || !f.status)) return n("failed loading " + o + "; status code: " + f.status, !0);
        if (f && f.status >= 400 && f.status < 500) return n("failed loading " + o + "; status code: " + f.status, !1);
        if (!f && p && p.message) {
          var g = p.message.toLowerCase(), y = ["failed", "fetch", "network", "load"].find(function(P) {
            return g.indexOf(P) > -1;
          });
          if (y)
            return n("failed loading " + o + ": " + p.message, !0);
        }
        if (p) return n(p, !1);
        var h, T;
        try {
          typeof f.data == "string" ? h = l.options.parse(f.data, s, i) : h = f.data;
        } catch {
          T = "failed parsing " + o + " to json";
        }
        if (T) return n(T, !1);
        n(null, h);
      });
    }
  }, {
    key: "create",
    value: function(o, n, s, i, l) {
      var d = this;
      if (this.options.addPath) {
        typeof o == "string" && (o = [o]);
        var u = this.options.parsePayload(n, s, i), c = 0, p = [], f = [];
        o.forEach(function(g) {
          var y = d.options.addPath;
          typeof d.options.addPath == "function" && (y = d.options.addPath(g, n));
          var h = d.services.interpolator.interpolate(y, {
            lng: g,
            ns: n
          });
          d.options.request(d.options, h, u, function(T, P) {
            c += 1, p.push(T), f.push(P), c === o.length && typeof l == "function" && l(p, f);
          });
        });
      }
    }
  }, {
    key: "reload",
    value: function() {
      var o = this, n = this.services, s = n.backendConnector, i = n.languageUtils, l = n.logger, d = s.language;
      if (!(d && d.toLowerCase() === "cimode")) {
        var u = [], c = function(f) {
          var g = i.toResolveHierarchy(f);
          g.forEach(function(y) {
            u.indexOf(y) < 0 && u.push(y);
          });
        };
        c(d), this.allOptions.preload && this.allOptions.preload.forEach(function(p) {
          return c(p);
        }), u.forEach(function(p) {
          o.allOptions.ns.forEach(function(f) {
            s.read(p, f, "read", null, null, function(g, y) {
              g && l.warn("loading namespace ".concat(f, " for language ").concat(p, " failed"), g), !g && y && l.log("loaded namespace ".concat(f, " for language ").concat(p), y), s.loaded("".concat(p, "|").concat(f), g, y);
            });
          });
        });
      }
    }
  }]);
})();
Backend.type = "backend";
var commonjsGlobal = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function getDefaultExportFromCjs(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function getAugmentedNamespace(e) {
  if (Object.prototype.hasOwnProperty.call(e, "__esModule")) return e;
  var t = e.default;
  if (typeof t == "function") {
    var o = function n() {
      var s = !1;
      try {
        s = this instanceof n;
      } catch {
      }
      return s ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    o.prototype = t.prototype;
  } else o = {};
  return Object.defineProperty(o, "__esModule", { value: !0 }), Object.keys(e).forEach(function(n) {
    var s = Object.getOwnPropertyDescriptor(e, n);
    Object.defineProperty(o, n, s.get ? s : {
      enumerable: !0,
      get: function() {
        return e[n];
      }
    });
  }), o;
}
const warn = (e, t, o, n) => {
  const s = [o, {
    code: t,
    ...n || {}
  }];
  if (e?.services?.logger?.forward)
    return e.services.logger.forward(s, "warn", "react-i18next::", !0);
  isString$1(s[0]) && (s[0] = `react-i18next:: ${s[0]}`), e?.services?.logger?.warn ? e.services.logger.warn(...s) : console?.warn && console.warn(...s);
}, alreadyWarned = {}, warnOnce$2 = (e, t, o, n) => {
  isString$1(o) && alreadyWarned[o] || (isString$1(o) && (alreadyWarned[o] = /* @__PURE__ */ new Date()), warn(e, t, o, n));
}, loadedClb = (e, t) => () => {
  if (e.isInitialized)
    t();
  else {
    const o = () => {
      setTimeout(() => {
        e.off("initialized", o);
      }, 0), t();
    };
    e.on("initialized", o);
  }
}, loadNamespaces = (e, t, o) => {
  e.loadNamespaces(t, loadedClb(e, o));
}, loadLanguages = (e, t, o, n) => {
  if (isString$1(o) && (o = [o]), e.options.preload && e.options.preload.indexOf(t) > -1) return loadNamespaces(e, o, n);
  o.forEach((s) => {
    e.options.ns.indexOf(s) < 0 && e.options.ns.push(s);
  }), e.loadLanguages(t, loadedClb(e, n));
}, hasLoadedNamespace = (e, t, o = {}) => !t.languages || !t.languages.length ? (warnOnce$2(t, "NO_LANGUAGES", "i18n.languages were undefined or empty", {
  languages: t.languages
}), !0) : t.hasLoadedNamespace(e, {
  lng: o.lng,
  precheck: (n, s) => {
    if (o.bindI18n && o.bindI18n.indexOf("languageChanging") > -1 && n.services.backendConnector.backend && n.isLanguageChangingTo && !s(n.isLanguageChangingTo, e)) return !1;
  }
}), isString$1 = (e) => typeof e == "string", isObject$2 = (e) => typeof e == "object" && e !== null, matchHtmlEntity = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g, htmlEntities = {
  "&amp;": "&",
  "&#38;": "&",
  "&lt;": "<",
  "&#60;": "<",
  "&gt;": ">",
  "&#62;": ">",
  "&apos;": "'",
  "&#39;": "'",
  "&quot;": '"',
  "&#34;": '"',
  "&nbsp;": " ",
  "&#160;": " ",
  "&copy;": "©",
  "&#169;": "©",
  "&reg;": "®",
  "&#174;": "®",
  "&hellip;": "…",
  "&#8230;": "…",
  "&#x2F;": "/",
  "&#47;": "/"
}, unescapeHtmlEntity = (e) => htmlEntities[e], unescape$1 = (e) => e.replace(matchHtmlEntity, unescapeHtmlEntity);
let defaultOptions$1 = {
  bindI18n: "languageChanged",
  bindI18nStore: "",
  transEmptyNodeValue: "",
  transSupportBasicHtmlNodes: !0,
  transWrapTextNodes: "",
  transKeepBasicHtmlNodesFor: ["br", "strong", "i", "p"],
  useSuspense: !0,
  unescape: unescape$1
};
const setDefaults = (e = {}) => {
  defaultOptions$1 = {
    ...defaultOptions$1,
    ...e
  };
}, getDefaults = () => defaultOptions$1;
let i18nInstance;
const setI18n = (e) => {
  i18nInstance = e;
}, getI18n = () => i18nInstance, initReactI18next = {
  type: "3rdParty",
  init(e) {
    setDefaults(e.options.react), setI18n(e);
  }
}, I18nContext = createContext();
class ReportNamespaces {
  constructor() {
    this.usedNamespaces = {};
  }
  addUsedNamespaces(t) {
    t.forEach((o) => {
      this.usedNamespaces[o] || (this.usedNamespaces[o] = !0);
    });
  }
  getUsedNamespaces() {
    return Object.keys(this.usedNamespaces);
  }
}
var shim = { exports: {} }, useSyncExternalStoreShim_production = {};
var hasRequiredUseSyncExternalStoreShim_production;
function requireUseSyncExternalStoreShim_production() {
  if (hasRequiredUseSyncExternalStoreShim_production) return useSyncExternalStoreShim_production;
  hasRequiredUseSyncExternalStoreShim_production = 1;
  var e = React__default;
  function t(f, g) {
    return f === g && (f !== 0 || 1 / f === 1 / g) || f !== f && g !== g;
  }
  var o = typeof Object.is == "function" ? Object.is : t, n = e.useState, s = e.useEffect, i = e.useLayoutEffect, l = e.useDebugValue;
  function d(f, g) {
    var y = g(), h = n({ inst: { value: y, getSnapshot: g } }), T = h[0].inst, P = h[1];
    return i(
      function() {
        T.value = y, T.getSnapshot = g, u(T) && P({ inst: T });
      },
      [f, y, g]
    ), s(
      function() {
        return u(T) && P({ inst: T }), f(function() {
          u(T) && P({ inst: T });
        });
      },
      [f]
    ), l(y), y;
  }
  function u(f) {
    var g = f.getSnapshot;
    f = f.value;
    try {
      var y = g();
      return !o(f, y);
    } catch {
      return !0;
    }
  }
  function c(f, g) {
    return g();
  }
  var p = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? c : d;
  return useSyncExternalStoreShim_production.useSyncExternalStore = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : p, useSyncExternalStoreShim_production;
}
var useSyncExternalStoreShim_development = {};
var hasRequiredUseSyncExternalStoreShim_development;
function requireUseSyncExternalStoreShim_development() {
  return hasRequiredUseSyncExternalStoreShim_development || (hasRequiredUseSyncExternalStoreShim_development = 1, process.env.NODE_ENV !== "production" && (function() {
    function e(y, h) {
      return y === h && (y !== 0 || 1 / y === 1 / h) || y !== y && h !== h;
    }
    function t(y, h) {
      p || s.startTransition === void 0 || (p = !0, console.error(
        "You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."
      ));
      var T = h();
      if (!f) {
        var P = h();
        i(T, P) || (console.error(
          "The result of getSnapshot should be cached to avoid an infinite loop"
        ), f = !0);
      }
      P = l({
        inst: { value: T, getSnapshot: h }
      });
      var E = P[0].inst, $ = P[1];
      return u(
        function() {
          E.value = T, E.getSnapshot = h, o(E) && $({ inst: E });
        },
        [y, T, h]
      ), d(
        function() {
          return o(E) && $({ inst: E }), y(function() {
            o(E) && $({ inst: E });
          });
        },
        [y]
      ), c(T), T;
    }
    function o(y) {
      var h = y.getSnapshot;
      y = y.value;
      try {
        var T = h();
        return !i(y, T);
      } catch {
        return !0;
      }
    }
    function n(y, h) {
      return h();
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var s = React__default, i = typeof Object.is == "function" ? Object.is : e, l = s.useState, d = s.useEffect, u = s.useLayoutEffect, c = s.useDebugValue, p = !1, f = !1, g = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? n : t;
    useSyncExternalStoreShim_development.useSyncExternalStore = s.useSyncExternalStore !== void 0 ? s.useSyncExternalStore : g, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  })()), useSyncExternalStoreShim_development;
}
var hasRequiredShim;
function requireShim() {
  return hasRequiredShim || (hasRequiredShim = 1, process.env.NODE_ENV === "production" ? shim.exports = requireUseSyncExternalStoreShim_production() : shim.exports = requireUseSyncExternalStoreShim_development()), shim.exports;
}
var shimExports = requireShim();
const notReadyT = (e, t) => isString$1(t) ? t : isObject$2(t) && isString$1(t.defaultValue) ? t.defaultValue : Array.isArray(e) ? e[e.length - 1] : e, notReadySnapshot = {
  t: notReadyT,
  ready: !1
}, dummySubscribe = () => () => {
}, useTranslation = (e, t = {}) => {
  const {
    i18n: o
  } = t, {
    i18n: n,
    defaultNS: s
  } = useContext(I18nContext) || {}, i = o || n || getI18n();
  i && !i.reportNamespaces && (i.reportNamespaces = new ReportNamespaces()), i || warnOnce$2(i, "NO_I18NEXT_INSTANCE", "useTranslation: You will need to pass in an i18next instance by using initReactI18next");
  const l = useMemo(() => ({
    ...getDefaults(),
    ...i?.options?.react,
    ...t
  }), [i, t]), {
    useSuspense: d,
    keyPrefix: u
  } = l, c = useMemo(() => {
    const C = s || i?.options?.defaultNS;
    return isString$1(C) ? [C] : C || ["translation"];
  }, [e, s, i]);
  i?.reportNamespaces?.addUsedNamespaces?.(c);
  const p = useRef(0), f = useCallback((C) => {
    if (!i) return dummySubscribe;
    const {
      bindI18n: x,
      bindI18nStore: _
    } = l, D = () => {
      p.current += 1, C();
    };
    return x && i.on(x, D), _ && i.store.on(_, D), () => {
      x && x.split(" ").forEach((O) => i.off(O, D)), _ && _.split(" ").forEach((O) => i.store.off(O, D));
    };
  }, [i, l]), g = useRef(), y = useCallback(() => {
    if (!i)
      return notReadySnapshot;
    const C = !!(i.isInitialized || i.initializedStoreOnce) && c.every((w) => hasLoadedNamespace(w, i, l)), x = t.lng || i.language, _ = p.current, D = g.current;
    if (D && D.ready === C && D.lng === x && D.keyPrefix === u && D.revision === _)
      return D;
    const v = {
      t: i.getFixedT(x, l.nsMode === "fallback" ? c : c[0], u),
      ready: C,
      lng: x,
      keyPrefix: u,
      revision: _
    };
    return g.current = v, v;
  }, [i, c, u, l, t.lng]), [h, T] = useState(0), {
    t: P,
    ready: E
  } = shimExports.useSyncExternalStore(f, y, y);
  useEffect(() => {
    if (i && !E && !d) {
      const C = () => T((x) => x + 1);
      t.lng ? loadLanguages(i, t.lng, c, C) : loadNamespaces(i, c, C);
    }
  }, [i, t.lng, c, E, d, h]);
  const $ = i || {}, R = useMemo(() => {
    const C = Object.create(Object.getPrototypeOf($), Object.getOwnPropertyDescriptors($));
    Object.defineProperty(C, "__original", {
      value: $,
      writable: !1,
      enumerable: !1,
      configurable: !1
    });
    const x = [P, C, E];
    return x.t = P, x.i18n = C, x.ready = E, x;
  }, [P, $, E, $.resolvedLanguage, $.language, $.languages]);
  if (i && d && !E)
    throw new Promise((C) => {
      const x = () => C();
      t.lng ? loadLanguages(i, t.lng, c, x) : loadNamespaces(i, c, x);
    });
  return R;
};
instance.use(Backend).use(initReactI18next).use(Browser).init({
  debug: !1,
  fallbackLng: "en",
  supportedLngs: ["en", "de"],
  load: "languageOnly",
  interpolation: {
    escapeValue: !1
  },
  backend: {
    loadPath: "https://ysstatic.fsn1.your-objectstorage.com/tolgee/interact/production/{{lng}}.json"
  }
});
var DataPermissionTypeDataEnum = /* @__PURE__ */ ((e) => (e.ADD_ACADEMIC_TITLE = "ADD_ACADEMIC_TITLE", e.ADD_ACTIVITY_CONFLICT_GROUP = "ADD_ACTIVITY_CONFLICT_GROUP", e.ADD_ACTIVITY_TYPE = "ADD_ACTIVITY_TYPE", e.ADD_EXTERNAL_SYSTEM_REFERENCE = "ADD_EXTERNAL_SYSTEM_REFERENCE", e.EDIT_EXTERNAL_SYSTEM_REFERENCE = "EDIT_EXTERNAL_SYSTEM_REFERENCE", e.READ_EXTERNAL_SYSTEM_REFERENCE = "READ_EXTERNAL_SYSTEM_REFERENCE", e.ADD_EXTERNAL_SYSTEM_REFERENCE_TYPE = "ADD_EXTERNAL_SYSTEM_REFERENCE_TYPE", e.EDIT_EXTERNAL_SYSTEM_REFERENCE_TYPE = "EDIT_EXTERNAL_SYSTEM_REFERENCE_TYPE", e.READ_EXTERNAL_SYSTEM_REFERENCE_TYPE = "READ_EXTERNAL_SYSTEM_REFERENCE_TYPE", e.ADMIN_PURCHASE_ORDER = "ADMIN_PURCHASE_ORDER", e.ASSIGN_PURCHASE_ORDER_TYPE = "ASSIGN_PURCHASE_ORDER_TYPE", e.ADD_ACTIVITY_PRESET = "ADD_ACTIVITY_PRESET", e.EDIT_ACTIVITY_PRESET = "EDIT_ACTIVITY_PRESET", e.READ_ACTIVITY_PRESET = "READ_ACTIVITY_PRESET", e.ADD_COACHING_INSTANCE = "ADD_COACHING_INSTANCE", e.EDIT_COACHING_INSTANCE = "EDIT_COACHING_INSTANCE", e.READ_COACHING_INSTANCE = "READ_COACHING_INSTANCE", e.ADD_MEDICAL_REQUEST_TOPIC = "ADD_MEDICAL_REQUEST_TOPIC", e.EDIT_MEDICAL_REQUEST_TOPIC = "EDIT_MEDICAL_REQUEST_TOPIC", e.READ_MEDICAL_REQUEST_TOPIC = "READ_MEDICAL_REQUEST_TOPIC", e.DELETE_MEDICAL_REQUEST_TOPIC = "DELETE_MEDICAL_REQUEST_TOPIC", e.ADD_PERSON_ASSIGNMENT_TYPE = "ADD_PERSON_ASSIGNMENT_TYPE", e.DELETE_PERSON_ASSIGNMENT_TYPE = "DELETE_PERSON_ASSIGNMENT_TYPE", e.EDIT_PERSON_ASSIGNMENT_TYPE = "EDIT_PERSON_ASSIGNMENT_TYPE", e.READ_PERSON_ASSIGNMENT_TYPE = "READ_PERSON_ASSIGNMENT_TYPE", e.ADD_DAILY_ALLOWANCE_CONFIGURATION = "ADD_DAILY_ALLOWANCE_CONFIGURATION", e.ADD_DAILY_ALLOWANCE_REDUCTION_TYPE = "ADD_DAILY_ALLOWANCE_REDUCTION_TYPE", e.ADD_ADDRESS = "ADD_ADDRESS", e.ADD_AGENDA_ITEM_TYPE = "ADD_AGENDA_ITEM_TYPE", e.ADD_AGENDA_TYPE = "ADD_AGENDA_TYPE", e.ADD_APPROVAL = "ADD_APPROVAL", e.ADD_ATTACHMENT = "ADD_ATTACHMENT", e.ADD_ATTRIBUTE = "ADD_ATTRIBUTE", e.ADD_ATTRIBUTE_CATEGORY = "ADD_ATTRIBUTE_CATEGORY", e.ADD_BUSINESS_EVENT = "ADD_BUSINESS_EVENT", e.ADD_BUSINESS_EVENT_INVITATION_STATUS = "ADD_BUSINESS_EVENT_INVITATION_STATUS", e.ADD_BUSINESS_EVENT_PARTICIPATION_STATUS = "ADD_BUSINESS_EVENT_PARTICIPATION_STATUS", e.ADD_CALL_OUTCOME = "ADD_CALL_OUTCOME", e.ADD_CAMPAIGN = "ADD_CAMPAIGN", e.ADD_CAMPAIGN_TARGET_PERSON = "ADD_CAMPAIGN_TARGET_PERSON", e.ADD_COMMENT = "ADD_COMMENT", e.ADD_COMMENT_TYPE = "ADD_COMMENT_TYPE", e.ADD_CONSENT_DOCUMENT = "ADD_CONSENT_DOCUMENT", e.ADD_CONSENT_TYPE = "ADD_CONSENT_TYPE", e.ADD_COST_TYPE = "ADD_COST_TYPE", e.ADD_DATA_SCOPE = "ADD_DATA_SCOPE", e.ADD_DELIVERY_STATUS = "ADD_DELIVERY_STATUS", e.ADD_DELIVERY_TIME_FRAME = "ADD_DELIVERY_TIME_FRAME", e.ADD_DOCUMENT = "ADD_DOCUMENT", e.ADD_EMPLOYEE = "ADD_EMPLOYEE", e.ADD_EVENT_ORGANIZATION_ROLE = "ADD_EVENT_ORGANIZATION_ROLE", e.ADD_EVENT_PERSON_ROLE = "ADD_EVENT_PERSON_ROLE", e.ADD_EVENT_STATUS = "ADD_EVENT_STATUS", e.ADD_EVENT_STATUS_TRANSITION_REASON = "ADD_EVENT_STATUS_TRANSITION_REASON", e.ADD_EVENT_TYPE = "ADD_EVENT_TYPE", e.ADD_KEY_MESSAGE = "ADD_KEY_MESSAGE", e.ADD_FEEDBACK = "ADD_FEEDBACK", e.ADD_LIST = "ADD_LIST", e.ADD_MEDIA = "ADD_MEDIA", e.ADD_MEDIA_TRACKING_INFO = "ADD_MEDIA_TRACKING_INFO", e.ADD_MEDICAL_REQUEST = "ADD_MEDICAL_REQUEST", e.ADD_NOTIFICATION = "ADD_NOTIFICATION", e.ADD_ORGANIZATION = "ADD_ORGANIZATION", e.ADD_ORGANIZATION_ASSIGNMENT = "ADD_ORGANIZATION_ASSIGNMENT", e.ADD_PERSON = "ADD_PERSON", e.ADD_PERSON_ASSIGNMENT = "ADD_PERSON_ASSIGNMENT", e.ADD_POSTAL_CODE_CITY = "ADD_POSTAL_CODE_CITY", e.ADD_PRIVILEGE = "ADD_PRIVILEGE", e.ADD_PROMOTIONAL_MATERIAL = "ADD_PROMOTIONAL_MATERIAL", e.ADD_PURCHASE_ORDER = "ADD_PURCHASE_ORDER", e.ADD_PURCHASE_ORDER_REQUEST = "ADD_PURCHASE_ORDER_REQUEST", e.ADD_QUICK_ATTRIBUTE_GROUP = "ADD_QUICK_ATTRIBUTE_GROUP", e.ADD_RELATIONSHIP = "ADD_RELATIONSHIP", e.ADD_RELATIONSHIP_TYPE = "ADD_RELATIONSHIP_TYPE", e.ADD_ROLE = "ADD_ROLE", e.ADD_SAMPLE_REQUEST_CONFIGURATION = "ADD_SAMPLE_REQUEST_CONFIGURATION", e.ADD_SAMPLE_REQUEST_FORM = "ADD_SAMPLE_REQUEST_FORM", e.ADD_SPECIALITY = "ADD_SPECIALITY", e.ADD_SPECIALITY_GROUP = "ADD_SPECIALITY_GROUP", e.ADD_STOCK_TRANSACTION_REASON = "ADD_STOCK_TRANSACTION_REASON", e.ADD_SURVEY = "ADD_SURVEY", e.ADD_SURVEY_INSTANCE = "ADD_SURVEY_INSTANCE", e.ADD_SURVEY_QUESTION = "ADD_SURVEY_QUESTION", e.ADD_SYSTEM_CONFIGURATION = "ADD_SYSTEM_CONFIGURATION", e.ADD_SYSTEM_NOTIFICATION = "ADD_SYSTEM_NOTIFICATION", e.ADD_TEMPLATE_TOKEN = "ADD_TEMPLATE_TOKEN", e.ADD_TERRITORY_LIST_TO_ORGANIZATIONAL_UNIT = "ADD_TERRITORY_LIST_TO_ORGANIZATIONAL_UNIT", e.ADD_TIME_ON_TERRITORY = "ADD_TIME_ON_TERRITORY", e.ADD_TIME_ON_TERRITORY_TYPE = "ADD_TIME_ON_TERRITORY_TYPE", e.ADD_TOUCH_POINT_PLAN = "ADD_TOUCH_POINT_PLAN", e.ADD_TO_DO = "ADD_TO_DO", e.ADD_TO_DO_CATEGORY = "ADD_TO_DO_CATEGORY", e.ADD_USER = "ADD_USER", e.ADD_USER_GROUP = "ADD_USER_GROUP", e.ADD_WIZARD_CONFIGURATION = "ADD_WIZARD_CONFIGURATION", e.ADMINISTRATE_PERSON_CONSENT = "ADMINISTRATE_PERSON_CONSENT", e.ADMINISTRATE_PURCHASE_ORDER = "ADMINISTRATE_PURCHASE_ORDER", e.ADMIN_BUSINESS_EVENT = "ADMIN_BUSINESS_EVENT", e.ADMIN_DATA_CHANGE_REQUEST = "ADMIN_DATA_CHANGE_REQUEST", e.ADMIN_EXECUTE = "ADMIN_EXECUTE", e.APPROVE_APPROVAL = "APPROVE_APPROVAL", e.ASSIGN_ACTIVITY_TYPE = "ASSIGN_ACTIVITY_TYPE", e.ASSIGN_ATTRIBUTE = "ASSIGN_ATTRIBUTE", e.ASSIGN_COMMENT_TYPE = "ASSIGN_COMMENT_TYPE", e.ASSIGN_CONSENT_TYPE = "ASSIGN_CONSENT_TYPE", e.ASSIGN_COST_TYPE = "ASSIGN_COST_TYPE", e.ASSIGN_EVENT_TYPE = "ASSIGN_EVENT_TYPE", e.ASSIGN_MEDIA = "ASSIGN_MEDIA", e.ASSIGN_RELATIONSHIP_TYPE = "ASSIGN_RELATIONSHIP_TYPE", e.ASSIGN_SURVEY = "ASSIGN_SURVEY", e.ASSIGN_SAMPLE_REQUEST_CONFIGURATION = "ASSIGN_SAMPLE_REQUEST_CONFIGURATION", e.ASSIGN_TEMPLATE = "ASSIGN_TEMPLATE", e.ASSIGN_TIME_ON_TERRITORY_TYPE = "ASSIGN_TIME_ON_TERRITORY_TYPE", e.BULK_EDIT_PURCHASE_ORDER = "BULK_EDIT_PURCHASE_ORDER", e.CANCEL_PURCHASE_ORDER = "CANCEL_PURCHASE_ORDER", e.CHANGE_PASSWORD_FOR_OTHER_USERS = "CHANGE_PASSWORD_FOR_OTHER_USERS", e.CLOSE_PURCHASE_ORDER = "CLOSE_PURCHASE_ORDER", e.COLLECT_PERSON_CONSENT = "COLLECT_PERSON_CONSENT", e.COMPLETE_TO_DO = "COMPLETE_TO_DO", e.CORRECT_ACTIVITY_PROMOTIONAL_MATERIAL = "CORRECT_ACTIVITY_PROMOTIONAL_MATERIAL", e.DELETE_ACTIVITY_CONFLICT_GROUP = "DELETE_ACTIVITY_CONFLICT_GROUP", e.DELETE_ACTIVITY_PRESET = "DELETE_ACTIVITY_PRESET", e.DELETE_ACTIVITY_TYPE = "DELETE_ACTIVITY_TYPE", e.DELETE_ADDRESS = "DELETE_ADDRESS", e.DELETE_AGENDA_ITEM_TYPE = "DELETE_AGENDA_ITEM_TYPE", e.DELETE_AGENDA_TYPE = "DELETE_AGENDA_TYPE", e.DELETE_APPROVAL = "DELETE_APPROVAL", e.DELETE_ATTACHMENT = "DELETE_ATTACHMENT", e.DELETE_ATTRIBUTE = "DELETE_ATTRIBUTE", e.DELETE_ATTRIBUTE_CATEGORY = "DELETE_ATTRIBUTE_CATEGORY", e.DELETE_BUSINESS_EVENT = "DELETE_BUSINESS_EVENT", e.DELETE_CALL_OUTCOME = "DELETE_CALL_OUTCOME", e.DELETE_CAMPAIGN = "DELETE_CAMPAIGN", e.DELETE_CAMPAIGN_TARGET_PERSON = "DELETE_CAMPAIGN_TARGET_PERSON", e.DELETE_CONSENT_TYPE = "DELETE_CONSENT_TYPE", e.DELETE_DATA_SCOPE = "DELETE_DATA_SCOPE", e.DELETE_DISCOUNT_TYPE = "DELETE_DISCOUNT_TYPE", e.DELETE_DOCUMENT = "DELETE_DOCUMENT", e.DELETE_EMPLOYEE = "DELETE_EMPLOYEE", e.DELETE_EVENT_TYPE = "DELETE_EVENT_TYPE", e.DELETE_KEY_MESSAGE = "DELETE_KEY_MESSAGE", e.DELETE_LIST = "DELETE_LIST", e.DELETE_MEDIA = "DELETE_MEDIA", e.DELETE_MEDIA_TRACKING_INFO = "DELETE_MEDIA_TRACKING_INFO", e.DELETE_MEDICAL_REQUEST = "DELETE_MEDICAL_REQUEST", e.DELETE_ORGANIZATION = "DELETE_ORGANIZATION", e.DELETE_ORGANIZATION_TYPE = "DELETE_ORGANIZATION_TYPE", e.DELETE_PERSON = "DELETE_PERSON", e.DELETE_PERSON_TYPE = "DELETE_PERSON_TYPE", e.DELETE_POSTAL_CODE_CITY = "DELETE_POSTAL_CODE_CITY", e.DELETE_PRICE_LIST = "DELETE_PRICE_LIST", e.DELETE_PRODUCT = "DELETE_PRODUCT", e.DELETE_PROMOTIONAL_MATERIAL = "DELETE_PROMOTIONAL_MATERIAL", e.DELETE_PURCHASE_ORDER = "DELETE_PURCHASE_ORDER", e.DELETE_PURCHASE_ORDER_REQUEST = "DELETE_PURCHASE_ORDER_REQUEST", e.DELETE_PURCHASE_ORDER_TYPE = "DELETE_PURCHASE_ORDER_TYPE", e.DELETE_RELATIONSHIP = "DELETE_RELATIONSHIP", e.DELETE_RELATIONSHIP_TYPE = "DELETE_RELATIONSHIP_TYPE", e.DELETE_SAMPLE_REQUEST_FORM = "DELETE_SAMPLE_REQUEST_FORM", e.DELETE_SPECIALITY = "DELETE_SPECIALITY", e.DELETE_SPECIALITY_GROUP = "DELETE_SPECIALITY_GROUP", e.DELETE_SYSTEM_NOTIFICATION = "DELETE_SYSTEM_NOTIFICATION", e.DELETE_TEMPLATE = "DELETE_TEMPLATE", e.DELETE_TEMPLATE_TOKEN = "DELETE_TEMPLATE_TOKEN", e.DELETE_TIME_ON_TERRITORY = "DELETE_TIME_ON_TERRITORY", e.DELETE_TIME_ON_TERRITORY_TYPE = "DELETE_TIME_ON_TERRITORY_TYPE", e.DELETE_TOUCH_POINT_PLAN = "DELETE_TOUCH_POINT_PLAN", e.DELETE_TO_DO = "DELETE_TO_DO", e.DELETE_TO_DO_CATEGORY = "DELETE_TO_DO_CATEGORY", e.DELETE_USER = "DELETE_USER", e.DELETE_USER_GROUP = "DELETE_USER_GROUP", e.DISTRIBUTE_STOCK = "DISTRIBUTE_STOCK", e.EDITOR_PURCHASE_ORDER = "EDITOR_PURCHASE_ORDER", e.EDIT_ACADEMIC_TITLE = "EDIT_ACADEMIC_TITLE", e.EDIT_ACTIVITY = "EDIT_ACTIVITY", e.EDIT_ACTIVITY_CONFLICT_GROUP = "EDIT_ACTIVITY_CONFLICT_GROUP", e.EDIT_ACTIVITY_TYPE = "EDIT_ACTIVITY_TYPE", e.EDIT_ADDRESS = "EDIT_ADDRESS", e.EDIT_AGENDA_ITEM_TYPE = "EDIT_AGENDA_ITEM_TYPE", e.EDIT_AGENDA_TYPE = "EDIT_AGENDA_TYPE", e.EDIT_APPROVAL = "EDIT_APPROVAL", e.EDIT_ATTACHMENT = "EDIT_ATTACHMENT", e.EDIT_ATTRIBUTE = "EDIT_ATTRIBUTE", e.EDIT_ATTRIBUTE_CATEGORY = "EDIT_ATTRIBUTE_CATEGORY", e.EDIT_BUSINESS_EVENT = "EDIT_BUSINESS_EVENT", e.EDIT_BUSINESS_EVENT_INVITATION_STATUS = "EDIT_BUSINESS_EVENT_INVITATION_STATUS", e.EDIT_BUSINESS_EVENT_PARTICIPATION_STATUS = "EDIT_BUSINESS_EVENT_PARTICIPATION_STATUS", e.EDIT_CALENDAR_CONFIGURATION = "EDIT_CALENDAR_CONFIGURATION", e.EDIT_CALL_OUTCOME = "EDIT_CALL_OUTCOME", e.EDIT_CAMPAIGN = "EDIT_CAMPAIGN", e.EDIT_CAMPAIGN_TARGET_PERSON = "EDIT_CAMPAIGN_TARGET_PERSON", e.EDIT_COMMENT = "EDIT_COMMENT", e.EDIT_COMMENT_TYPE = "EDIT_COMMENT_TYPE", e.EDIT_CONSENT_MAIL = "EDIT_CONSENT_MAIL", e.EDIT_CONSENT_TYPE = "EDIT_CONSENT_TYPE", e.EDIT_COST_TYPE = "EDIT_COST_TYPE", e.EDIT_COUNTRY_CONFIGURATION = "EDIT_COUNTRY_CONFIGURATION", e.EDIT_DATA_SCOPE = "EDIT_DATA_SCOPE", e.EDIT_DELIVERY_STATUS = "EDIT_DELIVERY_STATUS", e.EDIT_DELIVERY_TIME_FRAME = "EDIT_DELIVERY_TIME_FRAME", e.EDIT_DISCOUNT_TYPE = "EDIT_DISCOUNT_TYPE", e.EDIT_DOCUMENT = "EDIT_DOCUMENT", e.EDIT_EMPLOYEE = "EDIT_EMPLOYEE", e.EDIT_EMPLOYEE_FUNCTION = "EDIT_EMPLOYEE_FUNCTION", e.EDIT_EVENT_ORGANIZATION_ROLE = "EDIT_EVENT_ORGANIZATION_ROLE", e.EDIT_EVENT_PERSON_ROLE = "EDIT_EVENT_PERSON_ROLE", e.EDIT_EVENT_STATUS = "EDIT_EVENT_STATUS", e.EDIT_EVENT_STATUS_TRANSITION_REASON = "EDIT_EVENT_STATUS_TRANSITION_REASON", e.EDIT_EVENT_TYPE = "EDIT_EVENT_TYPE", e.EDIT_GIVEN_PROMOTIONAL_MATERIAL_CUSTOM_CHANGE_REASON = "EDIT_GIVEN_PROMOTIONAL_MATERIAL_CUSTOM_CHANGE_REASON", e.EDIT_INVENTORY = "EDIT_INVENTORY", e.EDIT_FEEDBACK = "EDIT_FEEDBACK", e.EDIT_KEY_MESSAGE = "EDIT_KEY_MESSAGE", e.EDIT_LIST = "EDIT_LIST", e.EDIT_MEDIA = "EDIT_MEDIA", e.EDIT_MEDIA_TRACKING_INFO = "EDIT_MEDIA_TRACKING_INFO", e.EDIT_MEDICAL_REQUEST = "EDIT_MEDICAL_REQUEST", e.EDIT_NOTIFICATION = "EDIT_NOTIFICATION", e.EDIT_ORGANIZATION = "EDIT_ORGANIZATION", e.EDIT_ORGANIZATION_ASSIGNMENT = "EDIT_ORGANIZATION_ASSIGNMENT", e.EDIT_ORGANIZATION_TYPE = "EDIT_ORGANIZATION_TYPE", e.EDIT_PAYMENT_METHOD = "EDIT_PAYMENT_METHOD", e.EDIT_PERSON = "EDIT_PERSON", e.EDIT_PERSON_ASSIGNMENT = "EDIT_PERSON_ASSIGNMENT", e.EDIT_PERSON_CONSENT = "EDIT_PERSON_CONSENT", e.EDIT_PERSON_TYPE = "EDIT_PERSON_TYPE", e.EDIT_POSTAL_CODE_CITY = "EDIT_POSTAL_CODE_CITY", e.EDIT_PRICE_LIST = "EDIT_PRICE_LIST", e.EDIT_PRICE_TYPE = "EDIT_PRICE_TYPE", e.EDIT_PRIVILEGE = "EDIT_PRIVILEGE", e.EDIT_PRODUCT = "EDIT_PRODUCT", e.EDIT_PRODUCT_TYPE = "EDIT_PRODUCT_TYPE", e.EDIT_PROMOTIONAL_MATERIAL = "EDIT_PROMOTIONAL_MATERIAL", e.EDIT_PURCHASE_ORDER = "EDIT_PURCHASE_ORDER", e.EDIT_PURCHASE_ORDER_REQUEST = "EDIT_PURCHASE_ORDER_REQUEST", e.EDIT_PURCHASE_ORDER_TYPE = "EDIT_PURCHASE_ORDER_TYPE", e.EDIT_QUICK_ATTRIBUTE_GROUP = "EDIT_QUICK_ATTRIBUTE_GROUP", e.EDIT_RELATIONSHIP = "EDIT_RELATIONSHIP", e.EDIT_RELATIONSHIP_TYPE = "EDIT_RELATIONSHIP_TYPE", e.EDIT_REMOTE_INTERACTION = "EDIT_REMOTE_INTERACTION", e.EDIT_ROLE = "EDIT_ROLE", e.EDIT_SAMPLE_REQUEST_CONFIGURATION = "EDIT_SAMPLE_REQUEST_CONFIGURATION", e.EDIT_SPECIALITY = "EDIT_SPECIALITY", e.EDIT_SPECIALITY_GROUP = "EDIT_SPECIALITY_GROUP", e.EDIT_SPECIALITY_GROUP_MAPPING = "EDIT_SPECIALITY_GROUP_MAPPING", e.EDIT_STAND_IN = "EDIT_STAND_IN", e.EDIT_STOCK = "EDIT_STOCK", e.EDIT_STOCK_TRANSACTION_REASON = "EDIT_STOCK_TRANSACTION_REASON", e.EDIT_SURVEY = "EDIT_SURVEY", e.EDIT_SURVEY_INSTANCE = "EDIT_SURVEY_INSTANCE", e.EDIT_SURVEY_QUESTION = "EDIT_SURVEY_QUESTION", e.EDIT_SYSTEM_CONFIGURATION = "EDIT_SYSTEM_CONFIGURATION", e.EDIT_TEMPLATE = "EDIT_TEMPLATE", e.EDIT_TEMPLATE_TOKEN = "EDIT_TEMPLATE_TOKEN", e.EDIT_TIME_ON_TERRITORY = "EDIT_TIME_ON_TERRITORY", e.EDIT_TIME_ON_TERRITORY_TYPE = "EDIT_TIME_ON_TERRITORY_TYPE", e.EDIT_TOUCH_POINT_PLAN = "EDIT_TOUCH_POINT_PLAN", e.EDIT_TO_DO = "EDIT_TO_DO", e.EDIT_TO_DO_CATEGORY = "EDIT_TO_DO_CATEGORY", e.EDIT_USER = "EDIT_USER", e.EDIT_USER_GROUP = "EDIT_USER_GROUP", e.EDIT_WIZARD_CONFIGURATION = "EDIT_WIZARD_CONFIGURATION", e.HANDLE_TEMPLATE_PLACEHOLDER_COLLECTION = "HANDLE_TEMPLATE_PLACEHOLDER_COLLECTION", e.IMPERSONATE_USER = "IMPERSONATE_USER", e.IMPORT_PURCHASE_ORDER = "IMPORT_PURCHASE_ORDER", e.MERGE_ORGANIZATION = "MERGE_ORGANIZATION", e.MERGE_PERSON = "MERGE_PERSON", e.PROCESS_PURCHASE_ORDER = "PROCESS_PURCHASE_ORDER", e.READ_ACADEMIC_TITLE = "READ_ACADEMIC_TITLE", e.READ_ACTIVITY_TYPE = "READ_ACTIVITY_TYPE", e.READ_ADDRESS = "READ_ADDRESS", e.READ_APPROVAL = "READ_APPROVAL", e.READ_ATTRIBUTE = "READ_ATTRIBUTE", e.READ_ATTRIBUTE_CATEGORY = "READ_ATTRIBUTE_CATEGORY", e.READ_BUSINESS_EVENT = "READ_BUSINESS_EVENT", e.READ_BUSINESS_EVENT_INVITATION_STATUS = "READ_BUSINESS_EVENT_INVITATION_STATUS", e.READ_BUSINESS_EVENT_PARTICIPATION_STATUS = "READ_BUSINESS_EVENT_PARTICIPATION_STATUS", e.READ_CALENDAR_CONFIGURATION = "READ_CALENDAR_CONFIGURATION", e.READ_CALL_OUTCOME = "READ_CALL_OUTCOME", e.READ_CAMPAIGN = "READ_CAMPAIGN", e.READ_CAMPAIGN_STATISTICS = "READ_CAMPAIGN_STATISTICS", e.READ_CAMPAIGN_TARGET_PERSON = "READ_CAMPAIGN_TARGET_PERSON", e.READ_COMMENT = "READ_COMMENT", e.READ_COMMENT_TYPE = "READ_COMMENT_TYPE", e.READ_COMMUNICATION_DATA_TYPE = "READ_COMMUNICATION_DATA_TYPE", e.READ_CONSENT_TYPE = "READ_CONSENT_TYPE", e.READ_COST_TYPE = "READ_COST_TYPE", e.READ_COUNTRY_CONFIGURATION = "READ_COUNTRY_CONFIGURATION", e.READ_DATA_SCOPE = "READ_DATA_SCOPE", e.READ_DELIVERY_STATUS = "READ_DELIVERY_STATUS", e.READ_DELIVERY_TIME_FRAME = "READ_DELIVERY_TIME_FRAME", e.READ_DISCOUNT_TYPE = "READ_DISCOUNT_TYPE", e.READ_DOCUMENT = "READ_DOCUMENT", e.READ_EMPLOYEE = "READ_EMPLOYEE", e.READ_EMPLOYEE_DEPARTMENT = "READ_EMPLOYEE_DEPARTMENT", e.READ_EMPLOYEE_FUNCTION = "READ_EMPLOYEE_FUNCTION", e.READ_EVENT_ORGANIZATION_ROLE = "READ_EVENT_ORGANIZATION_ROLE", e.READ_EVENT_PERSON_ROLE = "READ_EVENT_PERSON_ROLE", e.READ_EVENT_STATUS = "READ_EVENT_STATUS", e.READ_EVENT_STATUS_TRANSITION_REASON = "READ_EVENT_STATUS_TRANSITION_REASON", e.READ_EVENT_TYPE = "READ_EVENT_TYPE", e.READ_GIVEN_PROMOTIONAL_MATERIAL_CUSTOM_CHANGE_REASON = "READ_GIVEN_PROMOTIONAL_MATERIAL_CUSTOM_CHANGE_REASON", e.READ_INVENTORY = "READ_INVENTORY", e.READ_FEEDBACK = "READ_FEEDBACK", e.READ_KEY_MESSAGE = "READ_KEY_MESSAGE", e.READ_LIST = "READ_LIST", e.READ_MEDIA = "READ_MEDIA", e.READ_MEDIA_TRACKING_INFO = "READ_MEDIA_TRACKING_INFO", e.READ_MEDICAL_REQUEST = "READ_MEDICAL_REQUEST", e.READ_ORGANIZATION = "READ_ORGANIZATION", e.READ_ORGANIZATION_ASSIGNMENT = "READ_ORGANIZATION_ASSIGNMENT", e.READ_ORGANIZATION_TYPE = "READ_ORGANIZATION_TYPE", e.READ_PAYMENT_METHOD = "READ_PAYMENT_METHOD", e.READ_PERSON = "READ_PERSON", e.READ_PERSON_ASSIGNMENT = "READ_PERSON_ASSIGNMENT", e.READ_PERSON_CONSENT = "READ_PERSON_CONSENT", e.READ_PERSON_TYPE = "READ_PERSON_TYPE", e.READ_POSTAL_CODE_CITY = "READ_POSTAL_CODE_CITY", e.READ_PRICE_LIST = "READ_PRICE_LIST", e.READ_PRICE_TYPE = "READ_PRICE_TYPE", e.READ_PRIVILEGE = "READ_PRIVILEGE", e.READ_PRODUCT = "READ_PRODUCT", e.READ_PRODUCT_FAMILY = "READ_PRODUCT_FAMILY", e.READ_PRODUCT_TYPE = "READ_PRODUCT_TYPE", e.READ_PROMOTIONAL_MATERIAL = "READ_PROMOTIONAL_MATERIAL", e.READ_PURCHASE_ORDER = "READ_PURCHASE_ORDER", e.READ_PURCHASE_ORDER_REQUEST = "READ_PURCHASE_ORDER_REQUEST", e.READ_PURCHASE_ORDER_TYPE = "READ_PURCHASE_ORDER_TYPE", e.READ_QUICK_ATTRIBUTE_GROUP = "READ_QUICK_ATTRIBUTE_GROUP", e.READ_RELATIONSHIP = "READ_RELATIONSHIP", e.READ_RELATIONSHIP_TYPE = "READ_RELATIONSHIP_TYPE", e.READ_REMOTE_INTERACTION = "READ_REMOTE_INTERACTION", e.READ_ROLE = "READ_ROLE", e.READ_SAMPLE_REQUEST_CONFIGURATION = "READ_SAMPLE_REQUEST_CONFIGURATION", e.READ_SAMPLE_REQUEST_FORM = "READ_SAMPLE_REQUEST_FORM", e.READ_SPECIALITY = "READ_SPECIALITY", e.READ_SPECIALITY_GROUP = "READ_SPECIALITY_GROUP", e.READ_SURVEY = "READ_SURVEY", e.READ_SURVEY_INSTANCE = "READ_SURVEY_INSTANCE", e.READ_SURVEY_QUESTION = "READ_SURVEY_QUESTION", e.READ_TEMPLATE = "READ_TEMPLATE", e.READ_TIME_ON_TERRITORY = "READ_TIME_ON_TERRITORY", e.READ_TIME_ON_TERRITORY_TYPE = "READ_TIME_ON_TERRITORY_TYPE", e.READ_TOPIC = "READ_TOPIC", e.READ_TOUCH_POINT_PLAN = "READ_TOUCH_POINT_PLAN", e.READ_TO_DO = "READ_TO_DO", e.READ_TO_DO_CATEGORY = "READ_TO_DO_CATEGORY", e.READ_USER = "READ_USER", e.READ_USER_GROUP = "READ_USER_GROUP", e.READ_WIZARD_CONFIGURATION = "READ_WIZARD_CONFIGURATION", e.REQUEST_ACTIVITY_APPROVAL = "REQUEST_ACTIVITY_APPROVAL", e.SEND_REPORT = "SEND_REPORT", e.SET_GDPR_STATUS_PERSON = "SET_GDPR_STATUS_PERSON", e.SET_TOUCH_POINT_PLAN_INSTANCE = "SET_TOUCH_POINT_PLAN_INSTANCE", e.SKIP_ACTIVITY_ATTENDEES_RULES_VALIDATOR = "SKIP_ACTIVITY_ATTENDEES_RULES_VALIDATOR", e.SKIP_ACTIVITY_CONFLICT_GROUP_VALIDATOR = "SKIP_ACTIVITY_CONFLICT_GROUP_VALIDATOR", e.SKIP_ACTIVITY_EDITOR_VALIDATOR = "SKIP_ACTIVITY_EDITOR_VALIDATOR", e.SKIP_ACTIVITY_EXPENSE_COST_VALIDATOR = "SKIP_ACTIVITY_EXPENSE_COST_VALIDATOR", e.SKIP_ACTIVITY_MEDIA_RULES_VALIDATOR = "SKIP_ACTIVITY_MEDIA_RULES_VALIDATOR", e.SKIP_ACTIVITY_PLANNED_STATUS_VALIDATOR = "SKIP_ACTIVITY_PLANNED_STATUS_VALIDATOR", e.SKIP_ACTIVITY_PROMOTIONAL_MATERIAL_HANDOUT_PERIOD_VALIDATOR = "SKIP_ACTIVITY_PROMOTIONAL_MATERIAL_HANDOUT_PERIOD_VALIDATOR", e.SKIP_ACTIVITY_PROMOTIONAL_MATERIAL_INVENTORY_VALIDATOR = "SKIP_ACTIVITY_PROMOTIONAL_MATERIAL_INVENTORY_VALIDATOR", e.SKIP_ACTIVITY_PROMOTIONAL_MATERIAL_RULES_VALIDATOR = "SKIP_ACTIVITY_PROMOTIONAL_MATERIAL_RULES_VALIDATOR", e.SKIP_ACTIVITY_SAMPLE_REQUEST_FORM_SIGNATURE_VALIDATOR = "SKIP_ACTIVITY_SAMPLE_REQUEST_FORM_SIGNATURE_VALIDATOR", e.SKIP_ACTIVITY_SAMPLE_REQUEST_FORM_VALIDATOR = "SKIP_ACTIVITY_SAMPLE_REQUEST_FORM_VALIDATOR", e.SKIP_ACTIVITY_SEALED_VALIDATOR = "SKIP_ACTIVITY_SEALED_VALIDATOR", e.SKIP_ACTIVITY_SIMILAR_EXISTS_VALIDATOR = "SKIP_ACTIVITY_SIMILAR_EXISTS_VALIDATOR", e.SKIP_ACTIVITY_STATUS_VALIDATOR = "SKIP_ACTIVITY_STATUS_VALIDATOR", e.SKIP_ACTIVITY_TIME_IN_PAST_VALIDATOR = "SKIP_ACTIVITY_TIME_IN_PAST_VALIDATOR", e.SKIP_ACTIVITY_WITH_SAMPLES_CANNOT_BE_DELETED_VALIDATOR = "SKIP_ACTIVITY_WITH_SAMPLES_CANNOT_BE_DELETED_VALIDATOR", e.SKIP_ATTRIBUTE_CONSTRAINTS_VALIDATION = "SKIP_ATTRIBUTE_CONSTRAINTS_VALIDATION", e.SKIP_DATA_CHANGE_REQUEST = "SKIP_DATA_CHANGE_REQUEST", e.SKIP_PERSON_ASSIGNMENT_VALIDATOR = "SKIP_PERSON_ASSIGNMENT_VALIDATOR", e.SKIP_PERSON_CONSENT_EDITOR_VALIDATOR = "SKIP_PERSON_CONSENT_EDITOR_VALIDATOR", e.SKIP_PERSON_CONSENT_FORM_LIMITS_CHECK = "SKIP_PERSON_CONSENT_FORM_LIMITS_CHECK", e.SKIP_PURCHASE_ORDER_PAYMENT_METHOD_VALIDATION = "SKIP_PURCHASE_ORDER_PAYMENT_METHOD_VALIDATION", e.SYSTEM_RELEVANT_LIST = "SYSTEM_RELEVANT_LIST", e.DELETE_DAILY_ALLOWANCE_CONFIGURATION = "DELETE_DAILY_ALLOWANCE_CONFIGURATION", e.DELETE_DAILY_ALLOWANCE_REDUCTION_TYPE = "DELETE_DAILY_ALLOWANCE_REDUCTION_TYPE", e.EDIT_DAILY_ALLOWANCE_CONFIGURATION = "EDIT_DAILY_ALLOWANCE_CONFIGURATION", e.EDIT_DAILY_ALLOWANCE_REDUCTION_TYPE = "EDIT_DAILY_ALLOWANCE_REDUCTION_TYPE", e.READ_DAILY_ALLOWANCE_CONFIGURATION = "READ_DAILY_ALLOWANCE_CONFIGURATION", e.READ_DAILY_ALLOWANCE_REDUCTION_TYPE = "READ_DAILY_ALLOWANCE_REDUCTION_TYPE", e.ADD_BUSINESS_TRIP = "ADD_BUSINESS_TRIP", e.ADD_PURCHASE_ORDER_STATUS = "ADD_PURCHASE_ORDER_STATUS", e.ADD_TERM_OF_CREDIT = "ADD_TERM_OF_CREDIT", e.CHANGE_PURCHASE_ORDER_STATUS = "CHANGE_PURCHASE_ORDER_STATUS", e.DELETE_TERM_OF_CREDIT = "DELETE_TERM_OF_CREDIT", e.EDIT_BUSINESS_TRIP = "EDIT_BUSINESS_TRIP", e.EDIT_PURCHASE_ORDER_STATUS = "EDIT_PURCHASE_ORDER_STATUS", e.EDIT_TERM_OF_CREDIT = "EDIT_TERM_OF_CREDIT", e.READ_ACTIVITY_LOCATION_TRACKING = "READ_ACTIVITY_LOCATION_TRACKING", e.READ_BUSINESS_TRIP = "READ_BUSINESS_TRIP", e.READ_PURCHASE_ORDER_STATUS = "READ_PURCHASE_ORDER_STATUS", e.READ_TERM_OF_CREDIT = "READ_TERM_OF_CREDIT", e.SET_ACTIVITY_LOCATION_TRACKING = "SET_ACTIVITY_LOCATION_TRACKING", e))(DataPermissionTypeDataEnum || {}), StateDataEnum = /* @__PURE__ */ ((e) => (e.ACTIVE = "ACTIVE", e.DELETED = "DELETED", e.INACTIVE = "INACTIVE", e.LIMBO = "LIMBO", e))(StateDataEnum || {}), LifecycleStatusDataEnum = /* @__PURE__ */ ((e) => (e.ACTIVE = "ACTIVE", e.FINISHED = "FINISHED", e.INACTIVE = "INACTIVE", e.IN_PREPARATION = "IN_PREPARATION", e.PREPARED = "PREPARED", e))(LifecycleStatusDataEnum || {}), GenderDataEnum = /* @__PURE__ */ ((e) => (e.FEMALE = "FEMALE", e.MALE = "MALE", e.NOT_APPLICABLE = "NOT_APPLICABLE", e.NOT_KNOWN = "NOT_KNOWN", e))(GenderDataEnum || {}), CommunicationDataBaseTypeDataEnum = /* @__PURE__ */ ((e) => (e.EMAIL = "EMAIL", e.FAX = "FAX", e.INTERNET = "INTERNET", e.PHONE = "PHONE", e.OTHER = "OTHER", e.WEB_CONFERENCE_URL = "WEB_CONFERENCE_URL", e))(CommunicationDataBaseTypeDataEnum || {}), OrganizationBaseTypeDataEnum = /* @__PURE__ */ ((e) => (e.AGENCY = "AGENCY", e.CUSTOMER = "CUSTOMER", e.EVENT = "EVENT", e.INTERNAL = "INTERNAL", e))(OrganizationBaseTypeDataEnum || {}), AddressTypeDataEnum = /* @__PURE__ */ ((e) => (e.DELIVERY = "DELIVERY", e.LEGAL = "LEGAL", e.STANDARD = "STANDARD", e.VISIT = "VISIT", e))(AddressTypeDataEnum || {}), ActivityStatusDataEnum = /* @__PURE__ */ ((e) => (e.CLOSED = "CLOSED", e.PLANNED = "PLANNED", e))(ActivityStatusDataEnum || {}), ActivityTypeBaseTypeDataEnum = /* @__PURE__ */ ((e) => (e.CUSTOM = "CUSTOM", e.DIRECT_CONTACT = "DIRECT_CONTACT", e.EMAIL = "EMAIL", e.EVENT_CONTACT = "EVENT_CONTACT", e.FAX = "FAX", e.MAIL = "MAIL", e.TELEPHONE = "TELEPHONE", e.TEMPLATED_EMAIL = "TEMPLATED_EMAIL", e.WEBINAR = "WEBINAR", e.REMOTE = "REMOTE", e))(ActivityTypeBaseTypeDataEnum || {}), ActivityTypeSchedulingDataEnum = /* @__PURE__ */ ((e) => (e.START_AND_END_DATE = "START_AND_END_DATE", e.START_AND_END_DATE_TIME = "START_AND_END_DATE_TIME", e.START_DATE = "START_DATE", e.START_DATE_TIME = "START_DATE_TIME", e))(ActivityTypeSchedulingDataEnum || {}), CallTypeDataEnum = /* @__PURE__ */ ((e) => (e.INBOUND = "INBOUND", e.OUTBOUND = "OUTBOUND", e))(CallTypeDataEnum || {}), CommentTargetTypeDataEnum = /* @__PURE__ */ ((e) => (e.ACTIVITY = "ACTIVITY", e.ACTIVITY_GIVEN_PROMOTIONAL_MATERIAL = "ACTIVITY_GIVEN_PROMOTIONAL_MATERIAL", e))(CommentTargetTypeDataEnum || {}), GivenPromotionalMaterialChangeReasonDataEnum = /* @__PURE__ */ ((e) => (e.CANCELLATION = "CANCELLATION", e.OUT_OF_STOCKS = "OUT_OF_STOCKS", e.RETURNED_BY_RECEIVER = "RETURNED_BY_RECEIVER", e.RULE_VALIDATION = "RULE_VALIDATION", e.UNDELIVERABLE = "UNDELIVERABLE", e.UNKNOWN = "UNKNOWN", e))(GivenPromotionalMaterialChangeReasonDataEnum || {}), PromotionalMaterialTypeDataEnum = /* @__PURE__ */ ((e) => (e.MARKETING_MATERIAL = "MARKETING_MATERIAL", e.MARKETING_SERVICE = "MARKETING_SERVICE", e.PRODUCT = "PRODUCT", e))(PromotionalMaterialTypeDataEnum || {}), SupportedMediaTypeDataEnum = /* @__PURE__ */ ((e) => (e.HTML = "HTML", e.IMAGE = "IMAGE", e.PDF = "PDF", e.ZIP = "ZIP", e))(SupportedMediaTypeDataEnum || {}), ReactionDataEnum = /* @__PURE__ */ ((e) => (e.NEGATIVE = "NEGATIVE", e.NEUTRAL = "NEUTRAL", e.NONE = "NONE", e.POSITIVE = "POSITIVE", e))(ReactionDataEnum || {}), StockTypeDataEnum = /* @__PURE__ */ ((e) => (e.PHYSICAL = "PHYSICAL", e.VIRTUAL = "VIRTUAL", e))(StockTypeDataEnum || {}), TemplateTypeDataEnum = /* @__PURE__ */ ((e) => (e.ACTIVITY_DELIVERY_CONFIRMATION = "ACTIVITY_DELIVERY_CONFIRMATION", e.CONTRACT = "CONTRACT", e.CUSTOM = "CUSTOM", e.DIGITAL_CONSENT = "DIGITAL_CONSENT", e.DOUBLE_OPT_IN_COLLECTION_PAGE = "DOUBLE_OPT_IN_COLLECTION_PAGE", e.DOUBLE_OPT_IN_EMAIL = "DOUBLE_OPT_IN_EMAIL", e.DOUBLE_OPT_IN_ERROR_PAGE = "DOUBLE_OPT_IN_ERROR_PAGE", e.DOUBLE_OPT_IN_SMS = "DOUBLE_OPT_IN_SMS", e.DOUBLE_OPT_IN_SUCCESS_PAGE = "DOUBLE_OPT_IN_SUCCESS_PAGE", e.MAIL_CONSENT_RECEIVED = "MAIL_CONSENT_RECEIVED", e.MAIL_MEDICAL_REQUEST = "MAIL_MEDICAL_REQUEST", e.MAIL_PERSONAL = "MAIL_PERSONAL", e.MAIL_REPORT = "MAIL_REPORT", e.MAIL_TO_DO_REMINDER = "MAIL_TO_DO_REMINDER", e.PAPER_CONSENT = "PAPER_CONSENT", e.PURCHASE_ORDER_NOTIFICATION = "PURCHASE_ORDER_NOTIFICATION", e.SAMPLE_REQUEST_FORM = "SAMPLE_REQUEST_FORM", e))(TemplateTypeDataEnum || {}), PersonConsentLifecycleStateDataEnum = /* @__PURE__ */ ((e) => (e.ACCEPTED = "ACCEPTED", e.DEFAULT = "DEFAULT", e.MERGED = "MERGED", e.PENDING_DOUBLE_OPT_IN = "PENDING_DOUBLE_OPT_IN", e.PENDING_PAPER = "PENDING_PAPER", e.REJECTED = "REJECTED", e))(PersonConsentLifecycleStateDataEnum || {}), ConsentActionDataEnum = /* @__PURE__ */ ((e) => (e.COLLECT_DIGITAL_CONSENT = "COLLECT_DIGITAL_CONSENT", e.COLLECT_MANUAL_CONSENT = "COLLECT_MANUAL_CONSENT", e.COLLECT_PAPER_CONSENT = "COLLECT_PAPER_CONSENT", e.EXPIRE_CONSENT = "EXPIRE_CONSENT", e.EXPIRE_PENDING_CONSENT = "EXPIRE_PENDING_CONSENT", e.MERGED_CONSENT = "MERGED_CONSENT", e.RECEIVE_DOUBLE_OPT_IN_CONSENT = "RECEIVE_DOUBLE_OPT_IN_CONSENT", e.RECEIVE_PAPER_CONSENT = "RECEIVE_PAPER_CONSENT", e.REJECT_CONSENT = "REJECT_CONSENT", e.RESEND_DOUBLE_OPT_IN = "RESEND_DOUBLE_OPT_IN", e.RESET_CONSENT = "RESET_CONSENT", e.REVOKE_CONSENT = "REVOKE_CONSENT", e.SET_CONSENT_ITEMS = "SET_CONSENT_ITEMS", e.TRANSFER_CONSENT = "TRANSFER_CONSENT", e))(ConsentActionDataEnum || {}), ConsentTypeValidityModeDateEnum = /* @__PURE__ */ ((e) => (e.END_DATE = "END_DATE", e.INFINITE = "INFINITE", e.PERIOD = "PERIOD", e))(ConsentTypeValidityModeDateEnum || {}), ConsentItemStateChangeDataEnum = /* @__PURE__ */ ((e) => (e.TURN_OFF = "TURN_OFF", e.TURN_ON = "TURN_ON", e))(ConsentItemStateChangeDataEnum || {}), TouchpointStatusTypeDataEnum = /* @__PURE__ */ ((e) => (e.DoneTouchpoint = "doneTouchpoint", e.PlannedTouchpoint = "plannedTouchpoint", e.ConfirmedPlannedTouchpoint = "confirmedPlannedTouchpoint", e))(TouchpointStatusTypeDataEnum || {}), ResponsibleBodyDataEnum = /* @__PURE__ */ ((e) => (e.Pri = "PRI", e.Pub = "PUB", e.Uni = "UNI", e.Unknown = "UNKNOWN", e))(ResponsibleBodyDataEnum || {}), PersonAssignmentBaseTypeDataEnum = /* @__PURE__ */ ((e) => (e.BACK_OFFICE = "BACK_OFFICE", e.FIELD_SERVICE = "FIELD_SERVICE", e))(PersonAssignmentBaseTypeDataEnum || {}), AttributeTypeDataEnum = /* @__PURE__ */ ((e) => (e.BOOLEAN = "BOOLEAN", e.DATE = "DATE", e.DOCUMENT = "DOCUMENT", e.MULTI_SELECTION = "MULTI_SELECTION", e.NUMERIC = "NUMERIC", e.ORGANIZATION = "ORGANIZATION", e.PERSON = "PERSON", e.SINGLE_SELECTION = "SINGLE_SELECTION", e.SURVEY_INSTANCE = "SURVEY_INSTANCE", e.TEXT = "TEXT", e.USER_PERSON = "USER_PERSON", e))(AttributeTypeDataEnum || {}), BooleanEnumData = /* @__PURE__ */ ((e) => (e.TRUE = "TRUE", e.FALSE = "FALSE", e))(BooleanEnumData || {}), SpecialityClassificationDataEnum = /* @__PURE__ */ ((e) => (e.FOCUS = "FOCUS", e.SPECIALITY = "SPECIALITY", e.SUBSPECIALITY = "SUBSPECIALITY", e))(SpecialityClassificationDataEnum || {}), EntityFilterTypeDataEnum = /* @__PURE__ */ ((e) => (e[e.PERSON = 0] = "PERSON", e[e.ORGANIZATION = 1] = "ORGANIZATION", e))(EntityFilterTypeDataEnum || {});
const CUSTOM_BREAKPOINTS = {
  MOBILE_LANDSCAPE_MAX_HEIGHT: "420px"
}, REMOTE_INTERACTION = {
  DESKTOP: {
    VIDEO_CONTAINER_FULLSCREEN_WIDTH: "74px",
    SHARING_CONTAINER_HEIGHT: "calc(100vh - 116px - 40px)",
    AUDIO_VIDEO_CONTROLS_HEIGHT: "64px",
    MINIMIZED_VIDEO_WIDTH: "48px",
    MINIMIZED_VIDEO_HEIGHT: "48px",
    OWN_VIDEO_FIXED_WIDTH: "162px",
    OWN_VIDEO_FIXED_HEIGHT: "120px"
  },
  MOBILE: {
    VIDEO_WITH_CONTROLS_HEIGHT_PORTRAIT: "304px",
    VIDEO_HEIGHT_PORTRAIT: "256px",
    DRAWER_HEIGHT_PORTRAIT: "200px",
    DRAWER_HEIGHT_LANDSCAPE: "41px",
    AUDIO_VIDEO_CONTROLS_WIDTH_LANDSCAPE: "72px",
    AUDIO_VIDEO_CONTROLS_HEIGHT_PORTRAIT: "56px",
    VIDEO_AND_CONTROLS_HEIGHT_PORTRAIT: "80px"
  },
  COMMON: {
    VIDEO_OFF_PARTICIPANT_INITIALS_BOX_SIZE: "max(33%, 100px)"
  }
}, ERROR_PAGE = {
  DESKTOP: {
    WIDTH: 760
  },
  MOBILE: {
    LANDSCAPE: {
      WIDTH: 606
    }
  }
}, WAITING_ROOM = {
  MOBILE: {
    DRAWER_HEIGHT_PORTRAIT: "355px"
  }
};
function buildFormatLongFn(e) {
  return (t = {}) => {
    const o = t.width ? String(t.width) : e.defaultWidth;
    return e.formats[o] || e.formats[e.defaultWidth];
  };
}
function buildLocalizeFn(e) {
  return (t, o) => {
    const n = o?.context ? String(o.context) : "standalone";
    let s;
    if (n === "formatting" && e.formattingValues) {
      const l = e.defaultFormattingWidth || e.defaultWidth, d = o?.width ? String(o.width) : l;
      s = e.formattingValues[d] || e.formattingValues[l];
    } else {
      const l = e.defaultWidth, d = o?.width ? String(o.width) : e.defaultWidth;
      s = e.values[d] || e.values[l];
    }
    const i = e.argumentCallback ? e.argumentCallback(t) : t;
    return s[i];
  };
}
function buildMatchFn(e) {
  return (t, o = {}) => {
    const n = o.width, s = n && e.matchPatterns[n] || e.matchPatterns[e.defaultMatchWidth], i = t.match(s);
    if (!i)
      return null;
    const l = i[0], d = n && e.parsePatterns[n] || e.parsePatterns[e.defaultParseWidth], u = Array.isArray(d) ? findIndex(d, (f) => f.test(l)) : (
      // [TODO] -- I challenge you to fix the type
      findKey$1(d, (f) => f.test(l))
    );
    let c;
    c = e.valueCallback ? e.valueCallback(u) : u, c = o.valueCallback ? (
      // [TODO] -- I challenge you to fix the type
      o.valueCallback(c)
    ) : c;
    const p = t.slice(l.length);
    return { value: c, rest: p };
  };
}
function findKey$1(e, t) {
  for (const o in e)
    if (Object.prototype.hasOwnProperty.call(e, o) && t(e[o]))
      return o;
}
function findIndex(e, t) {
  for (let o = 0; o < e.length; o++)
    if (t(e[o]))
      return o;
}
function buildMatchPatternFn(e) {
  return (t, o = {}) => {
    const n = t.match(e.matchPattern);
    if (!n) return null;
    const s = n[0], i = t.match(e.parsePattern);
    if (!i) return null;
    let l = e.valueCallback ? e.valueCallback(i[0]) : i[0];
    l = o.valueCallback ? o.valueCallback(l) : l;
    const d = t.slice(s.length);
    return { value: l, rest: d };
  };
}
const millisecondsInWeek = 6048e5, millisecondsInDay = 864e5, millisecondsInMinute = 6e4, millisecondsInHour = 36e5, millisecondsInSecond = 1e3, constructFromSymbol = Symbol.for("constructDateFrom");
function constructFrom(e, t) {
  return typeof e == "function" ? e(t) : e && typeof e == "object" && constructFromSymbol in e ? e[constructFromSymbol](t) : e instanceof Date ? new e.constructor(t) : new Date(t);
}
function normalizeDates(e, ...t) {
  const o = constructFrom.bind(
    null,
    t.find((n) => typeof n == "object")
  );
  return t.map(o);
}
let defaultOptions = {};
function getDefaultOptions$1() {
  return defaultOptions;
}
function toDate(e, t) {
  return constructFrom(t || e, e);
}
function startOfWeek(e, t) {
  const o = getDefaultOptions$1(), n = t?.weekStartsOn ?? t?.locale?.options?.weekStartsOn ?? o.weekStartsOn ?? o.locale?.options?.weekStartsOn ?? 0, s = toDate(e, t?.in), i = s.getDay(), l = (i < n ? 7 : 0) + i - n;
  return s.setDate(s.getDate() - l), s.setHours(0, 0, 0, 0), s;
}
const formatDistanceLocale$1 = {
  lessThanXSeconds: {
    standalone: {
      one: "weniger als 1 Sekunde",
      other: "weniger als {{count}} Sekunden"
    },
    withPreposition: {
      one: "weniger als 1 Sekunde",
      other: "weniger als {{count}} Sekunden"
    }
  },
  xSeconds: {
    standalone: {
      one: "1 Sekunde",
      other: "{{count}} Sekunden"
    },
    withPreposition: {
      one: "1 Sekunde",
      other: "{{count}} Sekunden"
    }
  },
  halfAMinute: {
    standalone: "eine halbe Minute",
    withPreposition: "einer halben Minute"
  },
  lessThanXMinutes: {
    standalone: {
      one: "weniger als 1 Minute",
      other: "weniger als {{count}} Minuten"
    },
    withPreposition: {
      one: "weniger als 1 Minute",
      other: "weniger als {{count}} Minuten"
    }
  },
  xMinutes: {
    standalone: {
      one: "1 Minute",
      other: "{{count}} Minuten"
    },
    withPreposition: {
      one: "1 Minute",
      other: "{{count}} Minuten"
    }
  },
  aboutXHours: {
    standalone: {
      one: "etwa 1 Stunde",
      other: "etwa {{count}} Stunden"
    },
    withPreposition: {
      one: "etwa 1 Stunde",
      other: "etwa {{count}} Stunden"
    }
  },
  xHours: {
    standalone: {
      one: "1 Stunde",
      other: "{{count}} Stunden"
    },
    withPreposition: {
      one: "1 Stunde",
      other: "{{count}} Stunden"
    }
  },
  xDays: {
    standalone: {
      one: "1 Tag",
      other: "{{count}} Tage"
    },
    withPreposition: {
      one: "1 Tag",
      other: "{{count}} Tagen"
    }
  },
  aboutXWeeks: {
    standalone: {
      one: "etwa 1 Woche",
      other: "etwa {{count}} Wochen"
    },
    withPreposition: {
      one: "etwa 1 Woche",
      other: "etwa {{count}} Wochen"
    }
  },
  xWeeks: {
    standalone: {
      one: "1 Woche",
      other: "{{count}} Wochen"
    },
    withPreposition: {
      one: "1 Woche",
      other: "{{count}} Wochen"
    }
  },
  aboutXMonths: {
    standalone: {
      one: "etwa 1 Monat",
      other: "etwa {{count}} Monate"
    },
    withPreposition: {
      one: "etwa 1 Monat",
      other: "etwa {{count}} Monaten"
    }
  },
  xMonths: {
    standalone: {
      one: "1 Monat",
      other: "{{count}} Monate"
    },
    withPreposition: {
      one: "1 Monat",
      other: "{{count}} Monaten"
    }
  },
  aboutXYears: {
    standalone: {
      one: "etwa 1 Jahr",
      other: "etwa {{count}} Jahre"
    },
    withPreposition: {
      one: "etwa 1 Jahr",
      other: "etwa {{count}} Jahren"
    }
  },
  xYears: {
    standalone: {
      one: "1 Jahr",
      other: "{{count}} Jahre"
    },
    withPreposition: {
      one: "1 Jahr",
      other: "{{count}} Jahren"
    }
  },
  overXYears: {
    standalone: {
      one: "mehr als 1 Jahr",
      other: "mehr als {{count}} Jahre"
    },
    withPreposition: {
      one: "mehr als 1 Jahr",
      other: "mehr als {{count}} Jahren"
    }
  },
  almostXYears: {
    standalone: {
      one: "fast 1 Jahr",
      other: "fast {{count}} Jahre"
    },
    withPreposition: {
      one: "fast 1 Jahr",
      other: "fast {{count}} Jahren"
    }
  }
}, formatDistance$1 = (e, t, o) => {
  let n;
  const s = o?.addSuffix ? formatDistanceLocale$1[e].withPreposition : formatDistanceLocale$1[e].standalone;
  return typeof s == "string" ? n = s : t === 1 ? n = s.one : n = s.other.replace("{{count}}", String(t)), o?.addSuffix ? o.comparison && o.comparison > 0 ? "in " + n : "vor " + n : n;
}, dateFormats$1 = {
  full: "EEEE, do MMMM y",
  // Montag, 7. Januar 2018
  long: "do MMMM y",
  // 7. Januar 2018
  medium: "do MMM y",
  // 7. Jan. 2018
  short: "dd.MM.y"
  // 07.01.2018
}, timeFormats$1 = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, dateTimeFormats$1 = {
  full: "{{date}} 'um' {{time}}",
  long: "{{date}} 'um' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, formatLong$1 = {
  date: buildFormatLongFn({
    formats: dateFormats$1,
    defaultWidth: "full"
  }),
  time: buildFormatLongFn({
    formats: timeFormats$1,
    defaultWidth: "full"
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$1,
    defaultWidth: "full"
  })
}, formatRelativeLocale$1 = {
  lastWeek: "'letzten' eeee 'um' p",
  yesterday: "'gestern um' p",
  today: "'heute um' p",
  tomorrow: "'morgen um' p",
  nextWeek: "eeee 'um' p",
  other: "P"
}, formatRelative$1 = (e, t, o, n) => formatRelativeLocale$1[e], eraValues$1 = {
  narrow: ["v.Chr.", "n.Chr."],
  abbreviated: ["v.Chr.", "n.Chr."],
  wide: ["vor Christus", "nach Christus"]
}, quarterValues$1 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1. Quartal", "2. Quartal", "3. Quartal", "4. Quartal"]
}, monthValues$1 = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mär",
    "Apr",
    "Mai",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Okt",
    "Nov",
    "Dez"
  ],
  wide: [
    "Januar",
    "Februar",
    "März",
    "April",
    "Mai",
    "Juni",
    "Juli",
    "August",
    "September",
    "Oktober",
    "November",
    "Dezember"
  ]
}, formattingMonthValues = {
  narrow: monthValues$1.narrow,
  abbreviated: [
    "Jan.",
    "Feb.",
    "März",
    "Apr.",
    "Mai",
    "Juni",
    "Juli",
    "Aug.",
    "Sep.",
    "Okt.",
    "Nov.",
    "Dez."
  ],
  wide: monthValues$1.wide
}, dayValues$1 = {
  narrow: ["S", "M", "D", "M", "D", "F", "S"],
  short: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
  abbreviated: ["So.", "Mo.", "Di.", "Mi.", "Do.", "Fr.", "Sa."],
  wide: [
    "Sonntag",
    "Montag",
    "Dienstag",
    "Mittwoch",
    "Donnerstag",
    "Freitag",
    "Samstag"
  ]
}, dayPeriodValues$1 = {
  narrow: {
    am: "vm.",
    pm: "nm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "Morgen",
    afternoon: "Nachm.",
    evening: "Abend",
    night: "Nacht"
  },
  abbreviated: {
    am: "vorm.",
    pm: "nachm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "Morgen",
    afternoon: "Nachmittag",
    evening: "Abend",
    night: "Nacht"
  },
  wide: {
    am: "vormittags",
    pm: "nachmittags",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "Morgen",
    afternoon: "Nachmittag",
    evening: "Abend",
    night: "Nacht"
  }
}, formattingDayPeriodValues$1 = {
  narrow: {
    am: "vm.",
    pm: "nm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "morgens",
    afternoon: "nachm.",
    evening: "abends",
    night: "nachts"
  },
  abbreviated: {
    am: "vorm.",
    pm: "nachm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "morgens",
    afternoon: "nachmittags",
    evening: "abends",
    night: "nachts"
  },
  wide: {
    am: "vormittags",
    pm: "nachmittags",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "morgens",
    afternoon: "nachmittags",
    evening: "abends",
    night: "nachts"
  }
}, ordinalNumber$1 = (e) => Number(e) + ".", localize$1 = {
  ordinalNumber: ordinalNumber$1,
  era: buildLocalizeFn({
    values: eraValues$1,
    defaultWidth: "wide"
  }),
  quarter: buildLocalizeFn({
    values: quarterValues$1,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: buildLocalizeFn({
    values: monthValues$1,
    formattingValues: formattingMonthValues,
    defaultWidth: "wide"
  }),
  day: buildLocalizeFn({
    values: dayValues$1,
    defaultWidth: "wide"
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$1,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues$1,
    defaultFormattingWidth: "wide"
  })
}, matchOrdinalNumberPattern$1 = /^(\d+)(\.)?/i, parseOrdinalNumberPattern$1 = /\d+/i, matchEraPatterns$1 = {
  narrow: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
  abbreviated: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
  wide: /^(vor Christus|vor unserer Zeitrechnung|nach Christus|unserer Zeitrechnung)/i
}, parseEraPatterns$1 = {
  any: [/^v/i, /^n/i]
}, matchQuarterPatterns$1 = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](\.)? Quartal/i
}, parseQuarterPatterns$1 = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, matchMonthPatterns$1 = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(j[aä]n|feb|mär[z]?|apr|mai|jun[i]?|jul[i]?|aug|sep|okt|nov|dez)\.?/i,
  wide: /^(januar|februar|märz|april|mai|juni|juli|august|september|oktober|november|dezember)/i
}, parseMonthPatterns$1 = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^j[aä]/i,
    /^f/i,
    /^mär/i,
    /^ap/i,
    /^mai/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, matchDayPatterns$1 = {
  narrow: /^[smdmf]/i,
  short: /^(so|mo|di|mi|do|fr|sa)/i,
  abbreviated: /^(son?|mon?|die?|mit?|don?|fre?|sam?)\.?/i,
  wide: /^(sonntag|montag|dienstag|mittwoch|donnerstag|freitag|samstag)/i
}, parseDayPatterns$1 = {
  any: [/^so/i, /^mo/i, /^di/i, /^mi/i, /^do/i, /^f/i, /^sa/i]
}, matchDayPeriodPatterns$1 = {
  narrow: /^(vm\.?|nm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
  abbreviated: /^(vorm\.?|nachm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
  wide: /^(vormittags|nachmittags|Mitternacht|Mittag|morgens|nachmittags|abends|nachts)/i
}, parseDayPeriodPatterns$1 = {
  any: {
    am: /^v/i,
    pm: /^n/i,
    midnight: /^Mitte/i,
    noon: /^Mitta/i,
    morning: /morgens/i,
    afternoon: /nachmittags/i,
    // will never be matched. Afternoon is matched by `pm`
    evening: /abends/i,
    night: /nachts/i
    // will never be matched. Night is matched by `pm`
  }
}, match$1 = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern$1,
    parsePattern: parseOrdinalNumberPattern$1,
    valueCallback: (e) => parseInt(e)
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns$1,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns$1,
    defaultParseWidth: "any"
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns$1,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns$1,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns$1,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns$1,
    defaultParseWidth: "any"
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns$1,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns$1,
    defaultParseWidth: "any"
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns$1,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPeriodPatterns$1,
    defaultParseWidth: "any"
  })
}, de = {
  code: "de",
  formatDistance: formatDistance$1,
  formatLong: formatLong$1,
  formatRelative: formatRelative$1,
  localize: localize$1,
  match: match$1,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, formatDistanceLocale = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, formatDistance = (e, t, o) => {
  let n;
  const s = formatDistanceLocale[e];
  return typeof s == "string" ? n = s : t === 1 ? n = s.one : n = s.other.replace("{{count}}", t.toString()), o?.addSuffix ? o.comparison && o.comparison > 0 ? "in " + n : n + " ago" : n;
}, formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, formatRelative = (e, t, o, n) => formatRelativeLocale[e], eraValues = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, quarterValues = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, monthValues = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, dayValues = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, dayPeriodValues = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, formattingDayPeriodValues = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, ordinalNumber = (e, t) => {
  const o = Number(e), n = o % 100;
  if (n > 20 || n < 10)
    switch (n % 10) {
      case 1:
        return o + "st";
      case 2:
        return o + "nd";
      case 3:
        return o + "rd";
    }
  return o + "th";
}, localize = {
  ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: "wide"
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: "wide"
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: "wide"
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: "wide"
  })
}, matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i, parseOrdinalNumberPattern = /\d+/i, matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i]
}, matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, parseMonthPatterns = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns,
    defaultParseWidth: "any"
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: "any"
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns,
    defaultParseWidth: "any"
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: "any"
  })
}, dateFormats = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, timeFormats = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: "full"
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: "full"
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: "full"
  })
}, enUS = {
  code: "en-US",
  formatDistance,
  formatLong,
  formatRelative,
  localize,
  match,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
}, LOCALE_MAPPING = {
  de,
  en: enUS,
  dev: enUS,
  default: enUS
}, useDateLocale = () => {
  const e = instance?.languages?.[0] || "en-US";
  let t;
  {
    const o = e.split("-")[0];
    t = LOCALE_MAPPING[o] || LOCALE_MAPPING.default;
  }
  return { dateLocale: t };
}, useElementSize = (e) => {
  const [t, o] = useState({ height: 0, width: 0 });
  return useLayoutEffect(() => {
    const n = () => {
      e.current && o({
        height: e.current.clientHeight,
        width: e.current.clientWidth
      });
    };
    return window.addEventListener("resize", n), n(), () => {
      window.removeEventListener("resize", n);
    };
  }, [e]), t;
};
function addDays(e, t, o) {
  const n = toDate(e, o?.in);
  return isNaN(t) ? constructFrom(o?.in || e, NaN) : (t && n.setDate(n.getDate() + t), n);
}
function addMonths(e, t, o) {
  const n = toDate(e, o?.in);
  if (isNaN(t)) return constructFrom(e, NaN);
  if (!t)
    return n;
  const s = n.getDate(), i = constructFrom(e, n.getTime());
  i.setMonth(n.getMonth() + t + 1, 0);
  const l = i.getDate();
  return s >= l ? i : (n.setFullYear(
    i.getFullYear(),
    i.getMonth(),
    s
  ), n);
}
function add(e, t, o) {
  const {
    years: n = 0,
    months: s = 0,
    weeks: i = 0,
    days: l = 0,
    hours: d = 0,
    minutes: u = 0,
    seconds: c = 0
  } = t, p = toDate(e, o?.in), f = s || n ? addMonths(p, s + n * 12) : p, g = l || i ? addDays(f, l + i * 7) : f, y = u + d * 60, T = (c + y * 60) * 1e3;
  return constructFrom(e, +g + T);
}
function addMilliseconds(e, t, o) {
  return constructFrom(e, +toDate(e) + t);
}
function addHours(e, t, o) {
  return addMilliseconds(e, t * millisecondsInHour);
}
function startOfISOWeek(e, t) {
  return startOfWeek(e, { ...t, weekStartsOn: 1 });
}
function getISOWeekYear(e, t) {
  const o = toDate(e, t?.in), n = o.getFullYear(), s = constructFrom(o, 0);
  s.setFullYear(n + 1, 0, 4), s.setHours(0, 0, 0, 0);
  const i = startOfISOWeek(s), l = constructFrom(o, 0);
  l.setFullYear(n, 0, 4), l.setHours(0, 0, 0, 0);
  const d = startOfISOWeek(l);
  return o.getTime() >= i.getTime() ? n + 1 : o.getTime() >= d.getTime() ? n : n - 1;
}
function getTimezoneOffsetInMilliseconds(e) {
  const t = toDate(e), o = new Date(
    Date.UTC(
      t.getFullYear(),
      t.getMonth(),
      t.getDate(),
      t.getHours(),
      t.getMinutes(),
      t.getSeconds(),
      t.getMilliseconds()
    )
  );
  return o.setUTCFullYear(t.getFullYear()), +e - +o;
}
function startOfDay(e, t) {
  const o = toDate(e, t?.in);
  return o.setHours(0, 0, 0, 0), o;
}
function differenceInCalendarDays(e, t, o) {
  const [n, s] = normalizeDates(
    o?.in,
    e,
    t
  ), i = startOfDay(n), l = startOfDay(s), d = +i - getTimezoneOffsetInMilliseconds(i), u = +l - getTimezoneOffsetInMilliseconds(l);
  return Math.round((d - u) / millisecondsInDay);
}
function startOfISOWeekYear(e, t) {
  const o = getISOWeekYear(e, t), n = constructFrom(e, 0);
  return n.setFullYear(o, 0, 4), n.setHours(0, 0, 0, 0), startOfISOWeek(n);
}
function addMinutes(e, t, o) {
  const n = toDate(e, o?.in);
  return n.setTime(n.getTime() + t * millisecondsInMinute), n;
}
function addSeconds(e, t, o) {
  return addMilliseconds(e, t * 1e3);
}
function addWeeks(e, t, o) {
  return addDays(e, t * 7, o);
}
function addYears(e, t, o) {
  return addMonths(e, t * 12, o);
}
function isSameDay(e, t, o) {
  const [n, s] = normalizeDates(
    o?.in,
    e,
    t
  );
  return +startOfDay(n) == +startOfDay(s);
}
function isDate$2(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function isValid(e) {
  return !(!isDate$2(e) && typeof e != "number" || isNaN(+toDate(e)));
}
function endOfDay(e, t) {
  const o = toDate(e, t?.in);
  return o.setHours(23, 59, 59, 999), o;
}
function endOfMonth(e, t) {
  const o = toDate(e, t?.in), n = o.getMonth();
  return o.setFullYear(o.getFullYear(), n + 1, 0), o.setHours(23, 59, 59, 999), o;
}
function startOfMonth(e, t) {
  const o = toDate(e, t?.in);
  return o.setDate(1), o.setHours(0, 0, 0, 0), o;
}
function endOfYear(e, t) {
  const o = toDate(e, t?.in), n = o.getFullYear();
  return o.setFullYear(n + 1, 0, 0), o.setHours(23, 59, 59, 999), o;
}
function startOfYear(e, t) {
  const o = toDate(e, t?.in);
  return o.setFullYear(o.getFullYear(), 0, 1), o.setHours(0, 0, 0, 0), o;
}
function endOfWeek(e, t) {
  const o = getDefaultOptions$1(), n = t?.weekStartsOn ?? t?.locale?.options?.weekStartsOn ?? o.weekStartsOn ?? o.locale?.options?.weekStartsOn ?? 0, s = toDate(e, t?.in), i = s.getDay(), l = (i < n ? -7 : 0) + 6 - (i - n);
  return s.setDate(s.getDate() + l), s.setHours(23, 59, 59, 999), s;
}
function getDayOfYear(e, t) {
  const o = toDate(e, t?.in);
  return differenceInCalendarDays(o, startOfYear(o)) + 1;
}
function getISOWeek(e, t) {
  const o = toDate(e, t?.in), n = +startOfISOWeek(o) - +startOfISOWeekYear(o);
  return Math.round(n / millisecondsInWeek) + 1;
}
function getWeekYear(e, t) {
  const o = toDate(e, t?.in), n = o.getFullYear(), s = getDefaultOptions$1(), i = t?.firstWeekContainsDate ?? t?.locale?.options?.firstWeekContainsDate ?? s.firstWeekContainsDate ?? s.locale?.options?.firstWeekContainsDate ?? 1, l = constructFrom(t?.in || e, 0);
  l.setFullYear(n + 1, 0, i), l.setHours(0, 0, 0, 0);
  const d = startOfWeek(l, t), u = constructFrom(t?.in || e, 0);
  u.setFullYear(n, 0, i), u.setHours(0, 0, 0, 0);
  const c = startOfWeek(u, t);
  return +o >= +d ? n + 1 : +o >= +c ? n : n - 1;
}
function startOfWeekYear(e, t) {
  const o = getDefaultOptions$1(), n = t?.firstWeekContainsDate ?? t?.locale?.options?.firstWeekContainsDate ?? o.firstWeekContainsDate ?? o.locale?.options?.firstWeekContainsDate ?? 1, s = getWeekYear(e, t), i = constructFrom(t?.in || e, 0);
  return i.setFullYear(s, 0, n), i.setHours(0, 0, 0, 0), startOfWeek(i, t);
}
function getWeek(e, t) {
  const o = toDate(e, t?.in), n = +startOfWeek(o, t) - +startOfWeekYear(o, t);
  return Math.round(n / millisecondsInWeek) + 1;
}
function addLeadingZeros(e, t) {
  const o = e < 0 ? "-" : "", n = Math.abs(e).toString().padStart(t, "0");
  return o + n;
}
const lightFormatters = {
  // Year
  y(e, t) {
    const o = e.getFullYear(), n = o > 0 ? o : 1 - o;
    return addLeadingZeros(t === "yy" ? n % 100 : n, t.length);
  },
  // Month
  M(e, t) {
    const o = e.getMonth();
    return t === "M" ? String(o + 1) : addLeadingZeros(o + 1, 2);
  },
  // Day of the month
  d(e, t) {
    return addLeadingZeros(e.getDate(), t.length);
  },
  // AM or PM
  a(e, t) {
    const o = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return o.toUpperCase();
      case "aaa":
        return o;
      case "aaaaa":
        return o[0];
      case "aaaa":
      default:
        return o === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(e, t) {
    return addLeadingZeros(e.getHours() % 12 || 12, t.length);
  },
  // Hour [0-23]
  H(e, t) {
    return addLeadingZeros(e.getHours(), t.length);
  },
  // Minute
  m(e, t) {
    return addLeadingZeros(e.getMinutes(), t.length);
  },
  // Second
  s(e, t) {
    return addLeadingZeros(e.getSeconds(), t.length);
  },
  // Fraction of second
  S(e, t) {
    const o = t.length, n = e.getMilliseconds(), s = Math.trunc(
      n * Math.pow(10, o - 3)
    );
    return addLeadingZeros(s, t.length);
  }
}, dayPeriodEnum = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, formatters = {
  // Era
  G: function(e, t, o) {
    const n = e.getFullYear() > 0 ? 1 : 0;
    switch (t) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return o.era(n, { width: "abbreviated" });
      // A, B
      case "GGGGG":
        return o.era(n, { width: "narrow" });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return o.era(n, { width: "wide" });
    }
  },
  // Year
  y: function(e, t, o) {
    if (t === "yo") {
      const n = e.getFullYear(), s = n > 0 ? n : 1 - n;
      return o.ordinalNumber(s, { unit: "year" });
    }
    return lightFormatters.y(e, t);
  },
  // Local week-numbering year
  Y: function(e, t, o, n) {
    const s = getWeekYear(e, n), i = s > 0 ? s : 1 - s;
    if (t === "YY") {
      const l = i % 100;
      return addLeadingZeros(l, 2);
    }
    return t === "Yo" ? o.ordinalNumber(i, { unit: "year" }) : addLeadingZeros(i, t.length);
  },
  // ISO week-numbering year
  R: function(e, t) {
    const o = getISOWeekYear(e);
    return addLeadingZeros(o, t.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, t) {
    const o = e.getFullYear();
    return addLeadingZeros(o, t.length);
  },
  // Quarter
  Q: function(e, t, o) {
    const n = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      // 1, 2, 3, 4
      case "Q":
        return String(n);
      // 01, 02, 03, 04
      case "QQ":
        return addLeadingZeros(n, 2);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return o.ordinalNumber(n, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return o.quarter(n, {
          width: "abbreviated",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return o.quarter(n, {
          width: "narrow",
          context: "formatting"
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return o.quarter(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, t, o) {
    const n = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      // 1, 2, 3, 4
      case "q":
        return String(n);
      // 01, 02, 03, 04
      case "qq":
        return addLeadingZeros(n, 2);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return o.ordinalNumber(n, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return o.quarter(n, {
          width: "abbreviated",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return o.quarter(n, {
          width: "narrow",
          context: "standalone"
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return o.quarter(n, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, t, o) {
    const n = e.getMonth();
    switch (t) {
      case "M":
      case "MM":
        return lightFormatters.M(e, t);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return o.ordinalNumber(n + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "MMM":
        return o.month(n, {
          width: "abbreviated",
          context: "formatting"
        });
      // J, F, ..., D
      case "MMMMM":
        return o.month(n, {
          width: "narrow",
          context: "formatting"
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return o.month(n, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(e, t, o) {
    const n = e.getMonth();
    switch (t) {
      // 1, 2, ..., 12
      case "L":
        return String(n + 1);
      // 01, 02, ..., 12
      case "LL":
        return addLeadingZeros(n + 1, 2);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return o.ordinalNumber(n + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "LLL":
        return o.month(n, {
          width: "abbreviated",
          context: "standalone"
        });
      // J, F, ..., D
      case "LLLLL":
        return o.month(n, {
          width: "narrow",
          context: "standalone"
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return o.month(n, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(e, t, o, n) {
    const s = getWeek(e, n);
    return t === "wo" ? o.ordinalNumber(s, { unit: "week" }) : addLeadingZeros(s, t.length);
  },
  // ISO week of year
  I: function(e, t, o) {
    const n = getISOWeek(e);
    return t === "Io" ? o.ordinalNumber(n, { unit: "week" }) : addLeadingZeros(n, t.length);
  },
  // Day of the month
  d: function(e, t, o) {
    return t === "do" ? o.ordinalNumber(e.getDate(), { unit: "date" }) : lightFormatters.d(e, t);
  },
  // Day of year
  D: function(e, t, o) {
    const n = getDayOfYear(e);
    return t === "Do" ? o.ordinalNumber(n, { unit: "dayOfYear" }) : addLeadingZeros(n, t.length);
  },
  // Day of week
  E: function(e, t, o) {
    const n = e.getDay();
    switch (t) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return o.day(n, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "EEEEE":
        return o.day(n, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return o.day(n, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "EEEE":
      default:
        return o.day(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, t, o, n) {
    const s = e.getDay(), i = (s - n.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case "e":
        return String(i);
      // Padded numerical value
      case "ee":
        return addLeadingZeros(i, 2);
      // 1st, 2nd, ..., 7th
      case "eo":
        return o.ordinalNumber(i, { unit: "day" });
      case "eee":
        return o.day(s, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "eeeee":
        return o.day(s, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return o.day(s, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "eeee":
      default:
        return o.day(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, t, o, n) {
    const s = e.getDay(), i = (s - n.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      // Numerical value (same as in `e`)
      case "c":
        return String(i);
      // Padded numerical value
      case "cc":
        return addLeadingZeros(i, t.length);
      // 1st, 2nd, ..., 7th
      case "co":
        return o.ordinalNumber(i, { unit: "day" });
      case "ccc":
        return o.day(s, {
          width: "abbreviated",
          context: "standalone"
        });
      // T
      case "ccccc":
        return o.day(s, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return o.day(s, {
          width: "short",
          context: "standalone"
        });
      // Tuesday
      case "cccc":
      default:
        return o.day(s, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, t, o) {
    const n = e.getDay(), s = n === 0 ? 7 : n;
    switch (t) {
      // 2
      case "i":
        return String(s);
      // 02
      case "ii":
        return addLeadingZeros(s, t.length);
      // 2nd
      case "io":
        return o.ordinalNumber(s, { unit: "day" });
      // Tue
      case "iii":
        return o.day(n, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "iiiii":
        return o.day(n, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "iiiiii":
        return o.day(n, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "iiii":
      default:
        return o.day(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, t, o) {
    const s = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return o.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return o.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return o.dayPeriod(s, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return o.dayPeriod(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, t, o) {
    const n = e.getHours();
    let s;
    switch (n === 12 ? s = dayPeriodEnum.noon : n === 0 ? s = dayPeriodEnum.midnight : s = n / 12 >= 1 ? "pm" : "am", t) {
      case "b":
      case "bb":
        return o.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return o.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return o.dayPeriod(s, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return o.dayPeriod(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, t, o) {
    const n = e.getHours();
    let s;
    switch (n >= 17 ? s = dayPeriodEnum.evening : n >= 12 ? s = dayPeriodEnum.afternoon : n >= 4 ? s = dayPeriodEnum.morning : s = dayPeriodEnum.night, t) {
      case "B":
      case "BB":
      case "BBB":
        return o.dayPeriod(s, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return o.dayPeriod(s, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return o.dayPeriod(s, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, t, o) {
    if (t === "ho") {
      let n = e.getHours() % 12;
      return n === 0 && (n = 12), o.ordinalNumber(n, { unit: "hour" });
    }
    return lightFormatters.h(e, t);
  },
  // Hour [0-23]
  H: function(e, t, o) {
    return t === "Ho" ? o.ordinalNumber(e.getHours(), { unit: "hour" }) : lightFormatters.H(e, t);
  },
  // Hour [0-11]
  K: function(e, t, o) {
    const n = e.getHours() % 12;
    return t === "Ko" ? o.ordinalNumber(n, { unit: "hour" }) : addLeadingZeros(n, t.length);
  },
  // Hour [1-24]
  k: function(e, t, o) {
    let n = e.getHours();
    return n === 0 && (n = 24), t === "ko" ? o.ordinalNumber(n, { unit: "hour" }) : addLeadingZeros(n, t.length);
  },
  // Minute
  m: function(e, t, o) {
    return t === "mo" ? o.ordinalNumber(e.getMinutes(), { unit: "minute" }) : lightFormatters.m(e, t);
  },
  // Second
  s: function(e, t, o) {
    return t === "so" ? o.ordinalNumber(e.getSeconds(), { unit: "second" }) : lightFormatters.s(e, t);
  },
  // Fraction of second
  S: function(e, t) {
    return lightFormatters.S(e, t);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, t, o) {
    const n = e.getTimezoneOffset();
    if (n === 0)
      return "Z";
    switch (t) {
      // Hours and optional minutes
      case "X":
        return formatTimezoneWithOptionalMinutes(n);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX":
        return formatTimezone(n);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case "XXXXX":
      case "XXX":
      // Hours and minutes with `:` delimiter
      default:
        return formatTimezone(n, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, t, o) {
    const n = e.getTimezoneOffset();
    switch (t) {
      // Hours and optional minutes
      case "x":
        return formatTimezoneWithOptionalMinutes(n);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx":
        return formatTimezone(n);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case "xxxxx":
      case "xxx":
      // Hours and minutes with `:` delimiter
      default:
        return formatTimezone(n, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, t, o) {
    const n = e.getTimezoneOffset();
    switch (t) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + formatTimezoneShort(n, ":");
      // Long
      case "OOOO":
      default:
        return "GMT" + formatTimezone(n, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, t, o) {
    const n = e.getTimezoneOffset();
    switch (t) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + formatTimezoneShort(n, ":");
      // Long
      case "zzzz":
      default:
        return "GMT" + formatTimezone(n, ":");
    }
  },
  // Seconds timestamp
  t: function(e, t, o) {
    const n = Math.trunc(+e / 1e3);
    return addLeadingZeros(n, t.length);
  },
  // Milliseconds timestamp
  T: function(e, t, o) {
    return addLeadingZeros(+e, t.length);
  }
};
function formatTimezoneShort(e, t = "") {
  const o = e > 0 ? "-" : "+", n = Math.abs(e), s = Math.trunc(n / 60), i = n % 60;
  return i === 0 ? o + String(s) : o + String(s) + t + addLeadingZeros(i, 2);
}
function formatTimezoneWithOptionalMinutes(e, t) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + addLeadingZeros(Math.abs(e) / 60, 2) : formatTimezone(e, t);
}
function formatTimezone(e, t = "") {
  const o = e > 0 ? "-" : "+", n = Math.abs(e), s = addLeadingZeros(Math.trunc(n / 60), 2), i = addLeadingZeros(n % 60, 2);
  return o + s + t + i;
}
const dateLongFormatter = (e, t) => {
  switch (e) {
    case "P":
      return t.date({ width: "short" });
    case "PP":
      return t.date({ width: "medium" });
    case "PPP":
      return t.date({ width: "long" });
    case "PPPP":
    default:
      return t.date({ width: "full" });
  }
}, timeLongFormatter = (e, t) => {
  switch (e) {
    case "p":
      return t.time({ width: "short" });
    case "pp":
      return t.time({ width: "medium" });
    case "ppp":
      return t.time({ width: "long" });
    case "pppp":
    default:
      return t.time({ width: "full" });
  }
}, dateTimeLongFormatter = (e, t) => {
  const o = e.match(/(P+)(p+)?/) || [], n = o[1], s = o[2];
  if (!s)
    return dateLongFormatter(e, t);
  let i;
  switch (n) {
    case "P":
      i = t.dateTime({ width: "short" });
      break;
    case "PP":
      i = t.dateTime({ width: "medium" });
      break;
    case "PPP":
      i = t.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      i = t.dateTime({ width: "full" });
      break;
  }
  return i.replace("{{date}}", dateLongFormatter(n, t)).replace("{{time}}", timeLongFormatter(s, t));
}, longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
}, dayOfYearTokenRE = /^D+$/, weekYearTokenRE = /^Y+$/, throwTokens = ["D", "DD", "YY", "YYYY"];
function isProtectedDayOfYearToken(e) {
  return dayOfYearTokenRE.test(e);
}
function isProtectedWeekYearToken(e) {
  return weekYearTokenRE.test(e);
}
function warnOrThrowProtectedError(e, t, o) {
  const n = message(e, t, o);
  if (console.warn(n), throwTokens.includes(e)) throw new RangeError(n);
}
function message(e, t, o) {
  const n = e[0] === "Y" ? "years" : "days of the month";
  return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${t}\`) for formatting ${n} to the input \`${o}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const formattingTokensRegExp$1 = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, longFormattingTokensRegExp$1 = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, escapedStringRegExp$1 = /^'([^]*?)'?$/, doubleQuoteRegExp$1 = /''/g, unescapedLatinCharacterRegExp$1 = /[a-zA-Z]/;
function format(e, t, o) {
  const n = getDefaultOptions$1(), s = o?.locale ?? n.locale ?? enUS, i = o?.firstWeekContainsDate ?? o?.locale?.options?.firstWeekContainsDate ?? n.firstWeekContainsDate ?? n.locale?.options?.firstWeekContainsDate ?? 1, l = o?.weekStartsOn ?? o?.locale?.options?.weekStartsOn ?? n.weekStartsOn ?? n.locale?.options?.weekStartsOn ?? 0, d = toDate(e, o?.in);
  if (!isValid(d))
    throw new RangeError("Invalid time value");
  let u = t.match(longFormattingTokensRegExp$1).map((p) => {
    const f = p[0];
    if (f === "p" || f === "P") {
      const g = longFormatters[f];
      return g(p, s.formatLong);
    }
    return p;
  }).join("").match(formattingTokensRegExp$1).map((p) => {
    if (p === "''")
      return { isToken: !1, value: "'" };
    const f = p[0];
    if (f === "'")
      return { isToken: !1, value: cleanEscapedString$1(p) };
    if (formatters[f])
      return { isToken: !0, value: p };
    if (f.match(unescapedLatinCharacterRegExp$1))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + f + "`"
      );
    return { isToken: !1, value: p };
  });
  s.localize.preprocessor && (u = s.localize.preprocessor(d, u));
  const c = {
    firstWeekContainsDate: i,
    weekStartsOn: l,
    locale: s
  };
  return u.map((p) => {
    if (!p.isToken) return p.value;
    const f = p.value;
    (!o?.useAdditionalWeekYearTokens && isProtectedWeekYearToken(f) || !o?.useAdditionalDayOfYearTokens && isProtectedDayOfYearToken(f)) && warnOrThrowProtectedError(f, t, String(e));
    const g = formatters[f[0]];
    return g(d, f, s.localize, c);
  }).join("");
}
function cleanEscapedString$1(e) {
  const t = e.match(escapedStringRegExp$1);
  return t ? t[1].replace(doubleQuoteRegExp$1, "'") : e;
}
function getDate(e, t) {
  return toDate(e, t?.in).getDate();
}
function getDaysInMonth(e, t) {
  const o = toDate(e, t?.in), n = o.getFullYear(), s = o.getMonth(), i = constructFrom(o, 0);
  return i.setFullYear(n, s + 1, 0), i.setHours(0, 0, 0, 0), i.getDate();
}
function getDefaultOptions() {
  return Object.assign({}, getDefaultOptions$1());
}
function getHours(e, t) {
  return toDate(e, t?.in).getHours();
}
function getISODay(e, t) {
  const o = toDate(e, t?.in).getDay();
  return o === 0 ? 7 : o;
}
function getMilliseconds(e) {
  return toDate(e).getMilliseconds();
}
function getMinutes(e, t) {
  return toDate(e, t?.in).getMinutes();
}
function getMonth(e, t) {
  return toDate(e, t?.in).getMonth();
}
function getSeconds(e) {
  return toDate(e).getSeconds();
}
function getYear(e, t) {
  return toDate(e, t?.in).getFullYear();
}
function isAfter(e, t) {
  return +toDate(e) > +toDate(t);
}
function isBefore(e, t) {
  return +toDate(e) < +toDate(t);
}
function isEqual(e, t) {
  return +toDate(e) == +toDate(t);
}
function transpose(e, t) {
  const o = isConstructor(t) ? new t(0) : constructFrom(t, 0);
  return o.setFullYear(e.getFullYear(), e.getMonth(), e.getDate()), o.setHours(
    e.getHours(),
    e.getMinutes(),
    e.getSeconds(),
    e.getMilliseconds()
  ), o;
}
function isConstructor(e) {
  return typeof e == "function" && e.prototype?.constructor === e;
}
const TIMEZONE_UNIT_PRIORITY = 10;
class Setter {
  subPriority = 0;
  validate(t, o) {
    return !0;
  }
}
class ValueSetter extends Setter {
  constructor(t, o, n, s, i) {
    super(), this.value = t, this.validateValue = o, this.setValue = n, this.priority = s, i && (this.subPriority = i);
  }
  validate(t, o) {
    return this.validateValue(t, this.value, o);
  }
  set(t, o, n) {
    return this.setValue(t, o, this.value, n);
  }
}
class DateTimezoneSetter extends Setter {
  priority = TIMEZONE_UNIT_PRIORITY;
  subPriority = -1;
  constructor(t, o) {
    super(), this.context = t || ((n) => constructFrom(o, n));
  }
  set(t, o) {
    return o.timestampIsSet ? t : constructFrom(t, transpose(t, this.context));
  }
}
class Parser {
  run(t, o, n, s) {
    const i = this.parse(t, o, n, s);
    return i ? {
      setter: new ValueSetter(
        i.value,
        this.validate,
        this.set,
        this.priority,
        this.subPriority
      ),
      rest: i.rest
    } : null;
  }
  validate(t, o, n) {
    return !0;
  }
}
class EraParser extends Parser {
  priority = 140;
  parse(t, o, n) {
    switch (o) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return n.era(t, { width: "abbreviated" }) || n.era(t, { width: "narrow" });
      // A, B
      case "GGGGG":
        return n.era(t, { width: "narrow" });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return n.era(t, { width: "wide" }) || n.era(t, { width: "abbreviated" }) || n.era(t, { width: "narrow" });
    }
  }
  set(t, o, n) {
    return o.era = n, t.setFullYear(n, 0, 1), t.setHours(0, 0, 0, 0), t;
  }
  incompatibleTokens = ["R", "u", "t", "T"];
}
const numericPatterns = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, timezonePatterns = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function mapValue(e, t) {
  return e && {
    value: t(e.value),
    rest: e.rest
  };
}
function parseNumericPattern(e, t) {
  const o = t.match(e);
  return o ? {
    value: parseInt(o[0], 10),
    rest: t.slice(o[0].length)
  } : null;
}
function parseTimezonePattern(e, t) {
  const o = t.match(e);
  if (!o)
    return null;
  if (o[0] === "Z")
    return {
      value: 0,
      rest: t.slice(1)
    };
  const n = o[1] === "+" ? 1 : -1, s = o[2] ? parseInt(o[2], 10) : 0, i = o[3] ? parseInt(o[3], 10) : 0, l = o[5] ? parseInt(o[5], 10) : 0;
  return {
    value: n * (s * millisecondsInHour + i * millisecondsInMinute + l * millisecondsInSecond),
    rest: t.slice(o[0].length)
  };
}
function parseAnyDigitsSigned(e) {
  return parseNumericPattern(numericPatterns.anyDigitsSigned, e);
}
function parseNDigits(e, t) {
  switch (e) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigit, t);
    case 2:
      return parseNumericPattern(numericPatterns.twoDigits, t);
    case 3:
      return parseNumericPattern(numericPatterns.threeDigits, t);
    case 4:
      return parseNumericPattern(numericPatterns.fourDigits, t);
    default:
      return parseNumericPattern(new RegExp("^\\d{1," + e + "}"), t);
  }
}
function parseNDigitsSigned(e, t) {
  switch (e) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigitSigned, t);
    case 2:
      return parseNumericPattern(numericPatterns.twoDigitsSigned, t);
    case 3:
      return parseNumericPattern(numericPatterns.threeDigitsSigned, t);
    case 4:
      return parseNumericPattern(numericPatterns.fourDigitsSigned, t);
    default:
      return parseNumericPattern(new RegExp("^-?\\d{1," + e + "}"), t);
  }
}
function dayPeriodEnumToHours(e) {
  switch (e) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function normalizeTwoDigitYear(e, t) {
  const o = t > 0, n = o ? t : 1 - t;
  let s;
  if (n <= 50)
    s = e || 100;
  else {
    const i = n + 50, l = Math.trunc(i / 100) * 100, d = e >= i % 100;
    s = e + l - (d ? 100 : 0);
  }
  return o ? s : 1 - s;
}
function isLeapYearIndex(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
class YearParser extends Parser {
  priority = 130;
  incompatibleTokens = ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"];
  parse(t, o, n) {
    const s = (i) => ({
      year: i,
      isTwoDigitYear: o === "yy"
    });
    switch (o) {
      case "y":
        return mapValue(parseNDigits(4, t), s);
      case "yo":
        return mapValue(
          n.ordinalNumber(t, {
            unit: "year"
          }),
          s
        );
      default:
        return mapValue(parseNDigits(o.length, t), s);
    }
  }
  validate(t, o) {
    return o.isTwoDigitYear || o.year > 0;
  }
  set(t, o, n) {
    const s = t.getFullYear();
    if (n.isTwoDigitYear) {
      const l = normalizeTwoDigitYear(
        n.year,
        s
      );
      return t.setFullYear(l, 0, 1), t.setHours(0, 0, 0, 0), t;
    }
    const i = !("era" in o) || o.era === 1 ? n.year : 1 - n.year;
    return t.setFullYear(i, 0, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class LocalWeekYearParser extends Parser {
  priority = 130;
  parse(t, o, n) {
    const s = (i) => ({
      year: i,
      isTwoDigitYear: o === "YY"
    });
    switch (o) {
      case "Y":
        return mapValue(parseNDigits(4, t), s);
      case "Yo":
        return mapValue(
          n.ordinalNumber(t, {
            unit: "year"
          }),
          s
        );
      default:
        return mapValue(parseNDigits(o.length, t), s);
    }
  }
  validate(t, o) {
    return o.isTwoDigitYear || o.year > 0;
  }
  set(t, o, n, s) {
    const i = getWeekYear(t, s);
    if (n.isTwoDigitYear) {
      const d = normalizeTwoDigitYear(
        n.year,
        i
      );
      return t.setFullYear(
        d,
        0,
        s.firstWeekContainsDate
      ), t.setHours(0, 0, 0, 0), startOfWeek(t, s);
    }
    const l = !("era" in o) || o.era === 1 ? n.year : 1 - n.year;
    return t.setFullYear(l, 0, s.firstWeekContainsDate), t.setHours(0, 0, 0, 0), startOfWeek(t, s);
  }
  incompatibleTokens = [
    "y",
    "R",
    "u",
    "Q",
    "q",
    "M",
    "L",
    "I",
    "d",
    "D",
    "i",
    "t",
    "T"
  ];
}
class ISOWeekYearParser extends Parser {
  priority = 130;
  parse(t, o) {
    return parseNDigitsSigned(o === "R" ? 4 : o.length, t);
  }
  set(t, o, n) {
    const s = constructFrom(t, 0);
    return s.setFullYear(n, 0, 4), s.setHours(0, 0, 0, 0), startOfISOWeek(s);
  }
  incompatibleTokens = [
    "G",
    "y",
    "Y",
    "u",
    "Q",
    "q",
    "M",
    "L",
    "w",
    "d",
    "D",
    "e",
    "c",
    "t",
    "T"
  ];
}
class ExtendedYearParser extends Parser {
  priority = 130;
  parse(t, o) {
    return parseNDigitsSigned(o === "u" ? 4 : o.length, t);
  }
  set(t, o, n) {
    return t.setFullYear(n, 0, 1), t.setHours(0, 0, 0, 0), t;
  }
  incompatibleTokens = ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"];
}
class QuarterParser extends Parser {
  priority = 120;
  parse(t, o, n) {
    switch (o) {
      // 1, 2, 3, 4
      case "Q":
      case "QQ":
        return parseNDigits(o.length, t);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return n.ordinalNumber(t, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return n.quarter(t, {
          width: "abbreviated",
          context: "formatting"
        }) || n.quarter(t, {
          width: "narrow",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return n.quarter(t, {
          width: "narrow",
          context: "formatting"
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return n.quarter(t, {
          width: "wide",
          context: "formatting"
        }) || n.quarter(t, {
          width: "abbreviated",
          context: "formatting"
        }) || n.quarter(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  validate(t, o) {
    return o >= 1 && o <= 4;
  }
  set(t, o, n) {
    return t.setMonth((n - 1) * 3, 1), t.setHours(0, 0, 0, 0), t;
  }
  incompatibleTokens = [
    "Y",
    "R",
    "q",
    "M",
    "L",
    "w",
    "I",
    "d",
    "D",
    "i",
    "e",
    "c",
    "t",
    "T"
  ];
}
class StandAloneQuarterParser extends Parser {
  priority = 120;
  parse(t, o, n) {
    switch (o) {
      // 1, 2, 3, 4
      case "q":
      case "qq":
        return parseNDigits(o.length, t);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return n.ordinalNumber(t, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return n.quarter(t, {
          width: "abbreviated",
          context: "standalone"
        }) || n.quarter(t, {
          width: "narrow",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return n.quarter(t, {
          width: "narrow",
          context: "standalone"
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return n.quarter(t, {
          width: "wide",
          context: "standalone"
        }) || n.quarter(t, {
          width: "abbreviated",
          context: "standalone"
        }) || n.quarter(t, {
          width: "narrow",
          context: "standalone"
        });
    }
  }
  validate(t, o) {
    return o >= 1 && o <= 4;
  }
  set(t, o, n) {
    return t.setMonth((n - 1) * 3, 1), t.setHours(0, 0, 0, 0), t;
  }
  incompatibleTokens = [
    "Y",
    "R",
    "Q",
    "M",
    "L",
    "w",
    "I",
    "d",
    "D",
    "i",
    "e",
    "c",
    "t",
    "T"
  ];
}
class MonthParser extends Parser {
  incompatibleTokens = [
    "Y",
    "R",
    "q",
    "Q",
    "L",
    "w",
    "I",
    "D",
    "i",
    "e",
    "c",
    "t",
    "T"
  ];
  priority = 110;
  parse(t, o, n) {
    const s = (i) => i - 1;
    switch (o) {
      // 1, 2, ..., 12
      case "M":
        return mapValue(
          parseNumericPattern(numericPatterns.month, t),
          s
        );
      // 01, 02, ..., 12
      case "MM":
        return mapValue(parseNDigits(2, t), s);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return mapValue(
          n.ordinalNumber(t, {
            unit: "month"
          }),
          s
        );
      // Jan, Feb, ..., Dec
      case "MMM":
        return n.month(t, {
          width: "abbreviated",
          context: "formatting"
        }) || n.month(t, { width: "narrow", context: "formatting" });
      // J, F, ..., D
      case "MMMMM":
        return n.month(t, {
          width: "narrow",
          context: "formatting"
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return n.month(t, { width: "wide", context: "formatting" }) || n.month(t, {
          width: "abbreviated",
          context: "formatting"
        }) || n.month(t, { width: "narrow", context: "formatting" });
    }
  }
  validate(t, o) {
    return o >= 0 && o <= 11;
  }
  set(t, o, n) {
    return t.setMonth(n, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class StandAloneMonthParser extends Parser {
  priority = 110;
  parse(t, o, n) {
    const s = (i) => i - 1;
    switch (o) {
      // 1, 2, ..., 12
      case "L":
        return mapValue(
          parseNumericPattern(numericPatterns.month, t),
          s
        );
      // 01, 02, ..., 12
      case "LL":
        return mapValue(parseNDigits(2, t), s);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return mapValue(
          n.ordinalNumber(t, {
            unit: "month"
          }),
          s
        );
      // Jan, Feb, ..., Dec
      case "LLL":
        return n.month(t, {
          width: "abbreviated",
          context: "standalone"
        }) || n.month(t, { width: "narrow", context: "standalone" });
      // J, F, ..., D
      case "LLLLL":
        return n.month(t, {
          width: "narrow",
          context: "standalone"
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return n.month(t, { width: "wide", context: "standalone" }) || n.month(t, {
          width: "abbreviated",
          context: "standalone"
        }) || n.month(t, { width: "narrow", context: "standalone" });
    }
  }
  validate(t, o) {
    return o >= 0 && o <= 11;
  }
  set(t, o, n) {
    return t.setMonth(n, 1), t.setHours(0, 0, 0, 0), t;
  }
  incompatibleTokens = [
    "Y",
    "R",
    "q",
    "Q",
    "M",
    "w",
    "I",
    "D",
    "i",
    "e",
    "c",
    "t",
    "T"
  ];
}
function setWeek(e, t, o) {
  const n = toDate(e, o?.in), s = getWeek(n, o) - t;
  return n.setDate(n.getDate() - s * 7), toDate(n, o?.in);
}
class LocalWeekParser extends Parser {
  priority = 100;
  parse(t, o, n) {
    switch (o) {
      case "w":
        return parseNumericPattern(numericPatterns.week, t);
      case "wo":
        return n.ordinalNumber(t, { unit: "week" });
      default:
        return parseNDigits(o.length, t);
    }
  }
  validate(t, o) {
    return o >= 1 && o <= 53;
  }
  set(t, o, n, s) {
    return startOfWeek(setWeek(t, n, s), s);
  }
  incompatibleTokens = [
    "y",
    "R",
    "u",
    "q",
    "Q",
    "M",
    "L",
    "I",
    "d",
    "D",
    "i",
    "t",
    "T"
  ];
}
function setISOWeek(e, t, o) {
  const n = toDate(e, o?.in), s = getISOWeek(n, o) - t;
  return n.setDate(n.getDate() - s * 7), n;
}
class ISOWeekParser extends Parser {
  priority = 100;
  parse(t, o, n) {
    switch (o) {
      case "I":
        return parseNumericPattern(numericPatterns.week, t);
      case "Io":
        return n.ordinalNumber(t, { unit: "week" });
      default:
        return parseNDigits(o.length, t);
    }
  }
  validate(t, o) {
    return o >= 1 && o <= 53;
  }
  set(t, o, n) {
    return startOfISOWeek(setISOWeek(t, n));
  }
  incompatibleTokens = [
    "y",
    "Y",
    "u",
    "q",
    "Q",
    "M",
    "L",
    "w",
    "d",
    "D",
    "e",
    "c",
    "t",
    "T"
  ];
}
const DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], DAYS_IN_MONTH_LEAP_YEAR = [
  31,
  29,
  31,
  30,
  31,
  30,
  31,
  31,
  30,
  31,
  30,
  31
];
class DateParser extends Parser {
  priority = 90;
  subPriority = 1;
  parse(t, o, n) {
    switch (o) {
      case "d":
        return parseNumericPattern(numericPatterns.date, t);
      case "do":
        return n.ordinalNumber(t, { unit: "date" });
      default:
        return parseNDigits(o.length, t);
    }
  }
  validate(t, o) {
    const n = t.getFullYear(), s = isLeapYearIndex(n), i = t.getMonth();
    return s ? o >= 1 && o <= DAYS_IN_MONTH_LEAP_YEAR[i] : o >= 1 && o <= DAYS_IN_MONTH[i];
  }
  set(t, o, n) {
    return t.setDate(n), t.setHours(0, 0, 0, 0), t;
  }
  incompatibleTokens = [
    "Y",
    "R",
    "q",
    "Q",
    "w",
    "I",
    "D",
    "i",
    "e",
    "c",
    "t",
    "T"
  ];
}
class DayOfYearParser extends Parser {
  priority = 90;
  subpriority = 1;
  parse(t, o, n) {
    switch (o) {
      case "D":
      case "DD":
        return parseNumericPattern(numericPatterns.dayOfYear, t);
      case "Do":
        return n.ordinalNumber(t, { unit: "date" });
      default:
        return parseNDigits(o.length, t);
    }
  }
  validate(t, o) {
    const n = t.getFullYear();
    return isLeapYearIndex(n) ? o >= 1 && o <= 366 : o >= 1 && o <= 365;
  }
  set(t, o, n) {
    return t.setMonth(0, n), t.setHours(0, 0, 0, 0), t;
  }
  incompatibleTokens = [
    "Y",
    "R",
    "q",
    "Q",
    "M",
    "L",
    "w",
    "I",
    "d",
    "E",
    "i",
    "e",
    "c",
    "t",
    "T"
  ];
}
function setDay(e, t, o) {
  const n = getDefaultOptions$1(), s = o?.weekStartsOn ?? o?.locale?.options?.weekStartsOn ?? n.weekStartsOn ?? n.locale?.options?.weekStartsOn ?? 0, i = toDate(e, o?.in), l = i.getDay(), u = (t % 7 + 7) % 7, c = 7 - s, p = t < 0 || t > 6 ? t - (l + c) % 7 : (u + c) % 7 - (l + c) % 7;
  return addDays(i, p, o);
}
class DayParser extends Parser {
  priority = 90;
  parse(t, o, n) {
    switch (o) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return n.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || n.day(t, { width: "short", context: "formatting" }) || n.day(t, { width: "narrow", context: "formatting" });
      // T
      case "EEEEE":
        return n.day(t, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return n.day(t, { width: "short", context: "formatting" }) || n.day(t, { width: "narrow", context: "formatting" });
      // Tuesday
      case "EEEE":
      default:
        return n.day(t, { width: "wide", context: "formatting" }) || n.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || n.day(t, { width: "short", context: "formatting" }) || n.day(t, { width: "narrow", context: "formatting" });
    }
  }
  validate(t, o) {
    return o >= 0 && o <= 6;
  }
  set(t, o, n, s) {
    return t = setDay(t, n, s), t.setHours(0, 0, 0, 0), t;
  }
  incompatibleTokens = ["D", "i", "e", "c", "t", "T"];
}
class LocalDayParser extends Parser {
  priority = 90;
  parse(t, o, n, s) {
    const i = (l) => {
      const d = Math.floor((l - 1) / 7) * 7;
      return (l + s.weekStartsOn + 6) % 7 + d;
    };
    switch (o) {
      // 3
      case "e":
      case "ee":
        return mapValue(parseNDigits(o.length, t), i);
      // 3rd
      case "eo":
        return mapValue(
          n.ordinalNumber(t, {
            unit: "day"
          }),
          i
        );
      // Tue
      case "eee":
        return n.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || n.day(t, { width: "short", context: "formatting" }) || n.day(t, { width: "narrow", context: "formatting" });
      // T
      case "eeeee":
        return n.day(t, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return n.day(t, { width: "short", context: "formatting" }) || n.day(t, { width: "narrow", context: "formatting" });
      // Tuesday
      case "eeee":
      default:
        return n.day(t, { width: "wide", context: "formatting" }) || n.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || n.day(t, { width: "short", context: "formatting" }) || n.day(t, { width: "narrow", context: "formatting" });
    }
  }
  validate(t, o) {
    return o >= 0 && o <= 6;
  }
  set(t, o, n, s) {
    return t = setDay(t, n, s), t.setHours(0, 0, 0, 0), t;
  }
  incompatibleTokens = [
    "y",
    "R",
    "u",
    "q",
    "Q",
    "M",
    "L",
    "I",
    "d",
    "D",
    "E",
    "i",
    "c",
    "t",
    "T"
  ];
}
class StandAloneLocalDayParser extends Parser {
  priority = 90;
  parse(t, o, n, s) {
    const i = (l) => {
      const d = Math.floor((l - 1) / 7) * 7;
      return (l + s.weekStartsOn + 6) % 7 + d;
    };
    switch (o) {
      // 3
      case "c":
      case "cc":
        return mapValue(parseNDigits(o.length, t), i);
      // 3rd
      case "co":
        return mapValue(
          n.ordinalNumber(t, {
            unit: "day"
          }),
          i
        );
      // Tue
      case "ccc":
        return n.day(t, {
          width: "abbreviated",
          context: "standalone"
        }) || n.day(t, { width: "short", context: "standalone" }) || n.day(t, { width: "narrow", context: "standalone" });
      // T
      case "ccccc":
        return n.day(t, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return n.day(t, { width: "short", context: "standalone" }) || n.day(t, { width: "narrow", context: "standalone" });
      // Tuesday
      case "cccc":
      default:
        return n.day(t, { width: "wide", context: "standalone" }) || n.day(t, {
          width: "abbreviated",
          context: "standalone"
        }) || n.day(t, { width: "short", context: "standalone" }) || n.day(t, { width: "narrow", context: "standalone" });
    }
  }
  validate(t, o) {
    return o >= 0 && o <= 6;
  }
  set(t, o, n, s) {
    return t = setDay(t, n, s), t.setHours(0, 0, 0, 0), t;
  }
  incompatibleTokens = [
    "y",
    "R",
    "u",
    "q",
    "Q",
    "M",
    "L",
    "I",
    "d",
    "D",
    "E",
    "i",
    "e",
    "t",
    "T"
  ];
}
function setISODay(e, t, o) {
  const n = toDate(e, o?.in), s = getISODay(n, o), i = t - s;
  return addDays(n, i, o);
}
class ISODayParser extends Parser {
  priority = 90;
  parse(t, o, n) {
    const s = (i) => i === 0 ? 7 : i;
    switch (o) {
      // 2
      case "i":
      case "ii":
        return parseNDigits(o.length, t);
      // 2nd
      case "io":
        return n.ordinalNumber(t, { unit: "day" });
      // Tue
      case "iii":
        return mapValue(
          n.day(t, {
            width: "abbreviated",
            context: "formatting"
          }) || n.day(t, {
            width: "short",
            context: "formatting"
          }) || n.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          s
        );
      // T
      case "iiiii":
        return mapValue(
          n.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          s
        );
      // Tu
      case "iiiiii":
        return mapValue(
          n.day(t, {
            width: "short",
            context: "formatting"
          }) || n.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          s
        );
      // Tuesday
      case "iiii":
      default:
        return mapValue(
          n.day(t, {
            width: "wide",
            context: "formatting"
          }) || n.day(t, {
            width: "abbreviated",
            context: "formatting"
          }) || n.day(t, {
            width: "short",
            context: "formatting"
          }) || n.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          s
        );
    }
  }
  validate(t, o) {
    return o >= 1 && o <= 7;
  }
  set(t, o, n) {
    return t = setISODay(t, n), t.setHours(0, 0, 0, 0), t;
  }
  incompatibleTokens = [
    "y",
    "Y",
    "u",
    "q",
    "Q",
    "M",
    "L",
    "w",
    "d",
    "D",
    "E",
    "e",
    "c",
    "t",
    "T"
  ];
}
class AMPMParser extends Parser {
  priority = 80;
  parse(t, o, n) {
    switch (o) {
      case "a":
      case "aa":
      case "aaa":
        return n.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || n.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaaa":
        return n.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return n.dayPeriod(t, {
          width: "wide",
          context: "formatting"
        }) || n.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || n.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(t, o, n) {
    return t.setHours(dayPeriodEnumToHours(n), 0, 0, 0), t;
  }
  incompatibleTokens = ["b", "B", "H", "k", "t", "T"];
}
class AMPMMidnightParser extends Parser {
  priority = 80;
  parse(t, o, n) {
    switch (o) {
      case "b":
      case "bb":
      case "bbb":
        return n.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || n.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbbb":
        return n.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return n.dayPeriod(t, {
          width: "wide",
          context: "formatting"
        }) || n.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || n.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(t, o, n) {
    return t.setHours(dayPeriodEnumToHours(n), 0, 0, 0), t;
  }
  incompatibleTokens = ["a", "B", "H", "k", "t", "T"];
}
class DayPeriodParser extends Parser {
  priority = 80;
  parse(t, o, n) {
    switch (o) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || n.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return n.dayPeriod(t, {
          width: "wide",
          context: "formatting"
        }) || n.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || n.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(t, o, n) {
    return t.setHours(dayPeriodEnumToHours(n), 0, 0, 0), t;
  }
  incompatibleTokens = ["a", "b", "t", "T"];
}
class Hour1to12Parser extends Parser {
  priority = 70;
  parse(t, o, n) {
    switch (o) {
      case "h":
        return parseNumericPattern(numericPatterns.hour12h, t);
      case "ho":
        return n.ordinalNumber(t, { unit: "hour" });
      default:
        return parseNDigits(o.length, t);
    }
  }
  validate(t, o) {
    return o >= 1 && o <= 12;
  }
  set(t, o, n) {
    const s = t.getHours() >= 12;
    return s && n < 12 ? t.setHours(n + 12, 0, 0, 0) : !s && n === 12 ? t.setHours(0, 0, 0, 0) : t.setHours(n, 0, 0, 0), t;
  }
  incompatibleTokens = ["H", "K", "k", "t", "T"];
}
class Hour0to23Parser extends Parser {
  priority = 70;
  parse(t, o, n) {
    switch (o) {
      case "H":
        return parseNumericPattern(numericPatterns.hour23h, t);
      case "Ho":
        return n.ordinalNumber(t, { unit: "hour" });
      default:
        return parseNDigits(o.length, t);
    }
  }
  validate(t, o) {
    return o >= 0 && o <= 23;
  }
  set(t, o, n) {
    return t.setHours(n, 0, 0, 0), t;
  }
  incompatibleTokens = ["a", "b", "h", "K", "k", "t", "T"];
}
class Hour0To11Parser extends Parser {
  priority = 70;
  parse(t, o, n) {
    switch (o) {
      case "K":
        return parseNumericPattern(numericPatterns.hour11h, t);
      case "Ko":
        return n.ordinalNumber(t, { unit: "hour" });
      default:
        return parseNDigits(o.length, t);
    }
  }
  validate(t, o) {
    return o >= 0 && o <= 11;
  }
  set(t, o, n) {
    return t.getHours() >= 12 && n < 12 ? t.setHours(n + 12, 0, 0, 0) : t.setHours(n, 0, 0, 0), t;
  }
  incompatibleTokens = ["h", "H", "k", "t", "T"];
}
class Hour1To24Parser extends Parser {
  priority = 70;
  parse(t, o, n) {
    switch (o) {
      case "k":
        return parseNumericPattern(numericPatterns.hour24h, t);
      case "ko":
        return n.ordinalNumber(t, { unit: "hour" });
      default:
        return parseNDigits(o.length, t);
    }
  }
  validate(t, o) {
    return o >= 1 && o <= 24;
  }
  set(t, o, n) {
    const s = n <= 24 ? n % 24 : n;
    return t.setHours(s, 0, 0, 0), t;
  }
  incompatibleTokens = ["a", "b", "h", "H", "K", "t", "T"];
}
class MinuteParser extends Parser {
  priority = 60;
  parse(t, o, n) {
    switch (o) {
      case "m":
        return parseNumericPattern(numericPatterns.minute, t);
      case "mo":
        return n.ordinalNumber(t, { unit: "minute" });
      default:
        return parseNDigits(o.length, t);
    }
  }
  validate(t, o) {
    return o >= 0 && o <= 59;
  }
  set(t, o, n) {
    return t.setMinutes(n, 0, 0), t;
  }
  incompatibleTokens = ["t", "T"];
}
class SecondParser extends Parser {
  priority = 50;
  parse(t, o, n) {
    switch (o) {
      case "s":
        return parseNumericPattern(numericPatterns.second, t);
      case "so":
        return n.ordinalNumber(t, { unit: "second" });
      default:
        return parseNDigits(o.length, t);
    }
  }
  validate(t, o) {
    return o >= 0 && o <= 59;
  }
  set(t, o, n) {
    return t.setSeconds(n, 0), t;
  }
  incompatibleTokens = ["t", "T"];
}
class FractionOfSecondParser extends Parser {
  priority = 30;
  parse(t, o) {
    const n = (s) => Math.trunc(s * Math.pow(10, -o.length + 3));
    return mapValue(parseNDigits(o.length, t), n);
  }
  set(t, o, n) {
    return t.setMilliseconds(n), t;
  }
  incompatibleTokens = ["t", "T"];
}
class ISOTimezoneWithZParser extends Parser {
  priority = 10;
  parse(t, o) {
    switch (o) {
      case "X":
        return parseTimezonePattern(
          timezonePatterns.basicOptionalMinutes,
          t
        );
      case "XX":
        return parseTimezonePattern(timezonePatterns.basic, t);
      case "XXXX":
        return parseTimezonePattern(
          timezonePatterns.basicOptionalSeconds,
          t
        );
      case "XXXXX":
        return parseTimezonePattern(
          timezonePatterns.extendedOptionalSeconds,
          t
        );
      case "XXX":
      default:
        return parseTimezonePattern(timezonePatterns.extended, t);
    }
  }
  set(t, o, n) {
    return o.timestampIsSet ? t : constructFrom(
      t,
      t.getTime() - getTimezoneOffsetInMilliseconds(t) - n
    );
  }
  incompatibleTokens = ["t", "T", "x"];
}
class ISOTimezoneParser extends Parser {
  priority = 10;
  parse(t, o) {
    switch (o) {
      case "x":
        return parseTimezonePattern(
          timezonePatterns.basicOptionalMinutes,
          t
        );
      case "xx":
        return parseTimezonePattern(timezonePatterns.basic, t);
      case "xxxx":
        return parseTimezonePattern(
          timezonePatterns.basicOptionalSeconds,
          t
        );
      case "xxxxx":
        return parseTimezonePattern(
          timezonePatterns.extendedOptionalSeconds,
          t
        );
      case "xxx":
      default:
        return parseTimezonePattern(timezonePatterns.extended, t);
    }
  }
  set(t, o, n) {
    return o.timestampIsSet ? t : constructFrom(
      t,
      t.getTime() - getTimezoneOffsetInMilliseconds(t) - n
    );
  }
  incompatibleTokens = ["t", "T", "X"];
}
class TimestampSecondsParser extends Parser {
  priority = 40;
  parse(t) {
    return parseAnyDigitsSigned(t);
  }
  set(t, o, n) {
    return [constructFrom(t, n * 1e3), { timestampIsSet: !0 }];
  }
  incompatibleTokens = "*";
}
class TimestampMillisecondsParser extends Parser {
  priority = 20;
  parse(t) {
    return parseAnyDigitsSigned(t);
  }
  set(t, o, n) {
    return [constructFrom(t, n), { timestampIsSet: !0 }];
  }
  incompatibleTokens = "*";
}
const parsers = {
  G: new EraParser(),
  y: new YearParser(),
  Y: new LocalWeekYearParser(),
  R: new ISOWeekYearParser(),
  u: new ExtendedYearParser(),
  Q: new QuarterParser(),
  q: new StandAloneQuarterParser(),
  M: new MonthParser(),
  L: new StandAloneMonthParser(),
  w: new LocalWeekParser(),
  I: new ISOWeekParser(),
  d: new DateParser(),
  D: new DayOfYearParser(),
  E: new DayParser(),
  e: new LocalDayParser(),
  c: new StandAloneLocalDayParser(),
  i: new ISODayParser(),
  a: new AMPMParser(),
  b: new AMPMMidnightParser(),
  B: new DayPeriodParser(),
  h: new Hour1to12Parser(),
  H: new Hour0to23Parser(),
  K: new Hour0To11Parser(),
  k: new Hour1To24Parser(),
  m: new MinuteParser(),
  s: new SecondParser(),
  S: new FractionOfSecondParser(),
  X: new ISOTimezoneWithZParser(),
  x: new ISOTimezoneParser(),
  t: new TimestampSecondsParser(),
  T: new TimestampMillisecondsParser()
}, formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, escapedStringRegExp = /^'([^]*?)'?$/, doubleQuoteRegExp = /''/g, notWhitespaceRegExp = /\S/, unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function parse(e, t, o, n) {
  const s = () => constructFrom(n?.in || o, NaN), i = getDefaultOptions(), l = n?.locale ?? i.locale ?? enUS, d = n?.firstWeekContainsDate ?? n?.locale?.options?.firstWeekContainsDate ?? i.firstWeekContainsDate ?? i.locale?.options?.firstWeekContainsDate ?? 1, u = n?.weekStartsOn ?? n?.locale?.options?.weekStartsOn ?? i.weekStartsOn ?? i.locale?.options?.weekStartsOn ?? 0;
  if (!t)
    return e ? s() : toDate(o, n?.in);
  const c = {
    firstWeekContainsDate: d,
    weekStartsOn: u,
    locale: l
  }, p = [new DateTimezoneSetter(n?.in, o)], f = t.match(longFormattingTokensRegExp).map((P) => {
    const E = P[0];
    if (E in longFormatters) {
      const $ = longFormatters[E];
      return $(P, l.formatLong);
    }
    return P;
  }).join("").match(formattingTokensRegExp), g = [];
  for (let P of f) {
    !n?.useAdditionalWeekYearTokens && isProtectedWeekYearToken(P) && warnOrThrowProtectedError(P, t, e), !n?.useAdditionalDayOfYearTokens && isProtectedDayOfYearToken(P) && warnOrThrowProtectedError(P, t, e);
    const E = P[0], $ = parsers[E];
    if ($) {
      const { incompatibleTokens: R } = $;
      if (Array.isArray(R)) {
        const x = g.find(
          (_) => R.includes(_.token) || _.token === E
        );
        if (x)
          throw new RangeError(
            `The format string mustn't contain \`${x.fullToken}\` and \`${P}\` at the same time`
          );
      } else if ($.incompatibleTokens === "*" && g.length > 0)
        throw new RangeError(
          `The format string mustn't contain \`${P}\` and any other token at the same time`
        );
      g.push({ token: E, fullToken: P });
      const C = $.run(
        e,
        P,
        l.match,
        c
      );
      if (!C)
        return s();
      p.push(C.setter), e = C.rest;
    } else {
      if (E.match(unescapedLatinCharacterRegExp))
        throw new RangeError(
          "Format string contains an unescaped latin alphabet character `" + E + "`"
        );
      if (P === "''" ? P = "'" : E === "'" && (P = cleanEscapedString(P)), e.indexOf(P) === 0)
        e = e.slice(P.length);
      else
        return s();
    }
  }
  if (e.length > 0 && notWhitespaceRegExp.test(e))
    return s();
  const y = p.map((P) => P.priority).sort((P, E) => E - P).filter((P, E, $) => $.indexOf(P) === E).map(
    (P) => p.filter((E) => E.priority === P).sort((E, $) => $.subPriority - E.subPriority)
  ).map((P) => P[0]);
  let h = toDate(o, n?.in);
  if (isNaN(+h)) return s();
  const T = {};
  for (const P of y) {
    if (!P.validate(h, c))
      return s();
    const E = P.set(h, T, c);
    Array.isArray(E) ? (h = E[0], Object.assign(T, E[1])) : h = E;
  }
  return h;
}
function cleanEscapedString(e) {
  return e.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
}
function startOfHour(e, t) {
  const o = toDate(e, t?.in);
  return o.setMinutes(0, 0, 0), o;
}
function isSameHour(e, t, o) {
  const [n, s] = normalizeDates(
    o?.in,
    e,
    t
  );
  return +startOfHour(n) == +startOfHour(s);
}
function isSameMonth$1(e, t, o) {
  const [n, s] = normalizeDates(
    o?.in,
    e,
    t
  );
  return n.getFullYear() === s.getFullYear() && n.getMonth() === s.getMonth();
}
function isSameYear(e, t, o) {
  const [n, s] = normalizeDates(
    o?.in,
    e,
    t
  );
  return n.getFullYear() === s.getFullYear();
}
function isWithinInterval(e, t, o) {
  const n = +toDate(e, o?.in), [s, i] = [
    +toDate(t.start, o?.in),
    +toDate(t.end, o?.in)
  ].sort((l, d) => l - d);
  return n >= s && n <= i;
}
function setMonth(e, t, o) {
  const n = toDate(e, o?.in), s = n.getFullYear(), i = n.getDate(), l = constructFrom(e, 0);
  l.setFullYear(s, t, 15), l.setHours(0, 0, 0, 0);
  const d = getDaysInMonth(l);
  return n.setMonth(t, Math.min(i, d)), n;
}
function setDate(e, t, o) {
  const n = toDate(e, o?.in);
  return n.setDate(t), n;
}
function setHours(e, t, o) {
  const n = toDate(e, o?.in);
  return n.setHours(t), n;
}
function setMilliseconds(e, t, o) {
  const n = toDate(e, o?.in);
  return n.setMilliseconds(t), n;
}
function setMinutes(e, t, o) {
  const n = toDate(e, o?.in);
  return n.setMinutes(t), n;
}
function setSeconds(e, t, o) {
  const n = toDate(e, o?.in);
  return n.setSeconds(t), n;
}
function setYear(e, t, o) {
  const n = toDate(e, o?.in);
  return isNaN(+n) ? constructFrom(e, NaN) : (n.setFullYear(t), n);
}
const useFormatDate = () => {
  const { dateLocale: e } = useDateLocale(), t = (n, s) => {
    let i = "";
    try {
      i = format(n, s, { locale: e });
    } catch {
      console.warn("Invalid date!");
    }
    return i;
  };
  return {
    formatDate: t,
    formatLocalizedDate: (n) => n ? t(new Date(n), "PP") : ""
  };
}, useLocalStorage = (e, t) => {
  const o = useCallback(() => {
    if (typeof window > "u")
      return t;
    try {
      const l = window.localStorage.getItem(e);
      return l ? JSON.parse(l) : t;
    } catch (l) {
      return console.log(l), t;
    }
  }, [t, e]), [n, s] = useState(() => o()), i = useCallback(
    (l) => {
      try {
        let d;
        if (l instanceof Function) {
          const u = o();
          d = l(u);
        } else
          d = l;
        s(d), typeof window < "u" && window.localStorage.setItem(e, JSON.stringify(d));
      } catch (d) {
        console.log(d);
      }
    },
    [o, e]
  );
  return [n, i];
}, breakpoints = {
  values: {
    xs: 0,
    sm: 600,
    md: 900,
    lg: 1200,
    xl: 1536
  }
};
function formatMuiErrorMessage(e, ...t) {
  const o = new URL(`https://mui.com/production-error/?code=${e}`);
  return t.forEach((n) => o.searchParams.append("args[]", n)), `Minified MUI error #${e}; visit ${o} for the full message.`;
}
const THEME_ID = "$$material";
var propTypes = { exports: {} }, reactIs$1 = { exports: {} }, reactIs_production_min = {};
var hasRequiredReactIs_production_min;
function requireReactIs_production_min() {
  if (hasRequiredReactIs_production_min) return reactIs_production_min;
  hasRequiredReactIs_production_min = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, o = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, s = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, l = e ? Symbol.for("react.provider") : 60109, d = e ? Symbol.for("react.context") : 60110, u = e ? Symbol.for("react.async_mode") : 60111, c = e ? Symbol.for("react.concurrent_mode") : 60111, p = e ? Symbol.for("react.forward_ref") : 60112, f = e ? Symbol.for("react.suspense") : 60113, g = e ? Symbol.for("react.suspense_list") : 60120, y = e ? Symbol.for("react.memo") : 60115, h = e ? Symbol.for("react.lazy") : 60116, T = e ? Symbol.for("react.block") : 60121, P = e ? Symbol.for("react.fundamental") : 60117, E = e ? Symbol.for("react.responder") : 60118, $ = e ? Symbol.for("react.scope") : 60119;
  function R(x) {
    if (typeof x == "object" && x !== null) {
      var _ = x.$$typeof;
      switch (_) {
        case t:
          switch (x = x.type, x) {
            case u:
            case c:
            case n:
            case i:
            case s:
            case f:
              return x;
            default:
              switch (x = x && x.$$typeof, x) {
                case d:
                case p:
                case h:
                case y:
                case l:
                  return x;
                default:
                  return _;
              }
          }
        case o:
          return _;
      }
    }
  }
  function C(x) {
    return R(x) === c;
  }
  return reactIs_production_min.AsyncMode = u, reactIs_production_min.ConcurrentMode = c, reactIs_production_min.ContextConsumer = d, reactIs_production_min.ContextProvider = l, reactIs_production_min.Element = t, reactIs_production_min.ForwardRef = p, reactIs_production_min.Fragment = n, reactIs_production_min.Lazy = h, reactIs_production_min.Memo = y, reactIs_production_min.Portal = o, reactIs_production_min.Profiler = i, reactIs_production_min.StrictMode = s, reactIs_production_min.Suspense = f, reactIs_production_min.isAsyncMode = function(x) {
    return C(x) || R(x) === u;
  }, reactIs_production_min.isConcurrentMode = C, reactIs_production_min.isContextConsumer = function(x) {
    return R(x) === d;
  }, reactIs_production_min.isContextProvider = function(x) {
    return R(x) === l;
  }, reactIs_production_min.isElement = function(x) {
    return typeof x == "object" && x !== null && x.$$typeof === t;
  }, reactIs_production_min.isForwardRef = function(x) {
    return R(x) === p;
  }, reactIs_production_min.isFragment = function(x) {
    return R(x) === n;
  }, reactIs_production_min.isLazy = function(x) {
    return R(x) === h;
  }, reactIs_production_min.isMemo = function(x) {
    return R(x) === y;
  }, reactIs_production_min.isPortal = function(x) {
    return R(x) === o;
  }, reactIs_production_min.isProfiler = function(x) {
    return R(x) === i;
  }, reactIs_production_min.isStrictMode = function(x) {
    return R(x) === s;
  }, reactIs_production_min.isSuspense = function(x) {
    return R(x) === f;
  }, reactIs_production_min.isValidElementType = function(x) {
    return typeof x == "string" || typeof x == "function" || x === n || x === c || x === i || x === s || x === f || x === g || typeof x == "object" && x !== null && (x.$$typeof === h || x.$$typeof === y || x.$$typeof === l || x.$$typeof === d || x.$$typeof === p || x.$$typeof === P || x.$$typeof === E || x.$$typeof === $ || x.$$typeof === T);
  }, reactIs_production_min.typeOf = R, reactIs_production_min;
}
var reactIs_development$1 = {};
var hasRequiredReactIs_development$1;
function requireReactIs_development$1() {
  return hasRequiredReactIs_development$1 || (hasRequiredReactIs_development$1 = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, o = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, s = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, l = e ? Symbol.for("react.provider") : 60109, d = e ? Symbol.for("react.context") : 60110, u = e ? Symbol.for("react.async_mode") : 60111, c = e ? Symbol.for("react.concurrent_mode") : 60111, p = e ? Symbol.for("react.forward_ref") : 60112, f = e ? Symbol.for("react.suspense") : 60113, g = e ? Symbol.for("react.suspense_list") : 60120, y = e ? Symbol.for("react.memo") : 60115, h = e ? Symbol.for("react.lazy") : 60116, T = e ? Symbol.for("react.block") : 60121, P = e ? Symbol.for("react.fundamental") : 60117, E = e ? Symbol.for("react.responder") : 60118, $ = e ? Symbol.for("react.scope") : 60119;
    function R(B) {
      return typeof B == "string" || typeof B == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      B === n || B === c || B === i || B === s || B === f || B === g || typeof B == "object" && B !== null && (B.$$typeof === h || B.$$typeof === y || B.$$typeof === l || B.$$typeof === d || B.$$typeof === p || B.$$typeof === P || B.$$typeof === E || B.$$typeof === $ || B.$$typeof === T);
    }
    function C(B) {
      if (typeof B == "object" && B !== null) {
        var ue = B.$$typeof;
        switch (ue) {
          case t:
            var re = B.type;
            switch (re) {
              case u:
              case c:
              case n:
              case i:
              case s:
              case f:
                return re;
              default:
                var be = re && re.$$typeof;
                switch (be) {
                  case d:
                  case p:
                  case h:
                  case y:
                  case l:
                    return be;
                  default:
                    return ue;
                }
            }
          case o:
            return ue;
        }
      }
    }
    var x = u, _ = c, D = d, O = l, v = t, w = p, M = n, S = h, I = y, N = o, F = i, L = s, k = f, W = !1;
    function V(B) {
      return W || (W = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), j(B) || C(B) === u;
    }
    function j(B) {
      return C(B) === c;
    }
    function A(B) {
      return C(B) === d;
    }
    function U(B) {
      return C(B) === l;
    }
    function G(B) {
      return typeof B == "object" && B !== null && B.$$typeof === t;
    }
    function Y(B) {
      return C(B) === p;
    }
    function ee(B) {
      return C(B) === n;
    }
    function J(B) {
      return C(B) === h;
    }
    function Z(B) {
      return C(B) === y;
    }
    function le(B) {
      return C(B) === o;
    }
    function se(B) {
      return C(B) === i;
    }
    function K(B) {
      return C(B) === s;
    }
    function q(B) {
      return C(B) === f;
    }
    reactIs_development$1.AsyncMode = x, reactIs_development$1.ConcurrentMode = _, reactIs_development$1.ContextConsumer = D, reactIs_development$1.ContextProvider = O, reactIs_development$1.Element = v, reactIs_development$1.ForwardRef = w, reactIs_development$1.Fragment = M, reactIs_development$1.Lazy = S, reactIs_development$1.Memo = I, reactIs_development$1.Portal = N, reactIs_development$1.Profiler = F, reactIs_development$1.StrictMode = L, reactIs_development$1.Suspense = k, reactIs_development$1.isAsyncMode = V, reactIs_development$1.isConcurrentMode = j, reactIs_development$1.isContextConsumer = A, reactIs_development$1.isContextProvider = U, reactIs_development$1.isElement = G, reactIs_development$1.isForwardRef = Y, reactIs_development$1.isFragment = ee, reactIs_development$1.isLazy = J, reactIs_development$1.isMemo = Z, reactIs_development$1.isPortal = le, reactIs_development$1.isProfiler = se, reactIs_development$1.isStrictMode = K, reactIs_development$1.isSuspense = q, reactIs_development$1.isValidElementType = R, reactIs_development$1.typeOf = C;
  })()), reactIs_development$1;
}
var hasRequiredReactIs$1;
function requireReactIs$1() {
  return hasRequiredReactIs$1 || (hasRequiredReactIs$1 = 1, process.env.NODE_ENV === "production" ? reactIs$1.exports = requireReactIs_production_min() : reactIs$1.exports = requireReactIs_development$1()), reactIs$1.exports;
}
var objectAssign, hasRequiredObjectAssign;
function requireObjectAssign() {
  if (hasRequiredObjectAssign) return objectAssign;
  hasRequiredObjectAssign = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, o = Object.prototype.propertyIsEnumerable;
  function n(i) {
    if (i == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(i);
  }
  function s() {
    try {
      if (!Object.assign)
        return !1;
      var i = new String("abc");
      if (i[5] = "de", Object.getOwnPropertyNames(i)[0] === "5")
        return !1;
      for (var l = {}, d = 0; d < 10; d++)
        l["_" + String.fromCharCode(d)] = d;
      var u = Object.getOwnPropertyNames(l).map(function(p) {
        return l[p];
      });
      if (u.join("") !== "0123456789")
        return !1;
      var c = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(p) {
        c[p] = p;
      }), Object.keys(Object.assign({}, c)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return objectAssign = s() ? Object.assign : function(i, l) {
    for (var d, u = n(i), c, p = 1; p < arguments.length; p++) {
      d = Object(arguments[p]);
      for (var f in d)
        t.call(d, f) && (u[f] = d[f]);
      if (e) {
        c = e(d);
        for (var g = 0; g < c.length; g++)
          o.call(d, c[g]) && (u[c[g]] = d[c[g]]);
      }
    }
    return u;
  }, objectAssign;
}
var ReactPropTypesSecret_1, hasRequiredReactPropTypesSecret;
function requireReactPropTypesSecret() {
  if (hasRequiredReactPropTypesSecret) return ReactPropTypesSecret_1;
  hasRequiredReactPropTypesSecret = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return ReactPropTypesSecret_1 = e, ReactPropTypesSecret_1;
}
var has, hasRequiredHas;
function requireHas() {
  return hasRequiredHas || (hasRequiredHas = 1, has = Function.call.bind(Object.prototype.hasOwnProperty)), has;
}
var checkPropTypes_1, hasRequiredCheckPropTypes;
function requireCheckPropTypes() {
  if (hasRequiredCheckPropTypes) return checkPropTypes_1;
  hasRequiredCheckPropTypes = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = /* @__PURE__ */ requireReactPropTypesSecret(), o = {}, n = /* @__PURE__ */ requireHas();
    e = function(i) {
      var l = "Warning: " + i;
      typeof console < "u" && console.error(l);
      try {
        throw new Error(l);
      } catch {
      }
    };
  }
  function s(i, l, d, u, c) {
    if (process.env.NODE_ENV !== "production") {
      for (var p in i)
        if (n(i, p)) {
          var f;
          try {
            if (typeof i[p] != "function") {
              var g = Error(
                (u || "React class") + ": " + d + " type `" + p + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof i[p] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw g.name = "Invariant Violation", g;
            }
            f = i[p](l, p, u, d, null, t);
          } catch (h) {
            f = h;
          }
          if (f && !(f instanceof Error) && e(
            (u || "React class") + ": type specification of " + d + " `" + p + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof f + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), f instanceof Error && !(f.message in o)) {
            o[f.message] = !0;
            var y = c ? c() : "";
            e(
              "Failed " + d + " type: " + f.message + (y ?? "")
            );
          }
        }
    }
  }
  return s.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (o = {});
  }, checkPropTypes_1 = s, checkPropTypes_1;
}
var factoryWithTypeCheckers, hasRequiredFactoryWithTypeCheckers;
function requireFactoryWithTypeCheckers() {
  if (hasRequiredFactoryWithTypeCheckers) return factoryWithTypeCheckers;
  hasRequiredFactoryWithTypeCheckers = 1;
  var e = requireReactIs$1(), t = requireObjectAssign(), o = /* @__PURE__ */ requireReactPropTypesSecret(), n = /* @__PURE__ */ requireHas(), s = /* @__PURE__ */ requireCheckPropTypes(), i = function() {
  };
  process.env.NODE_ENV !== "production" && (i = function(d) {
    var u = "Warning: " + d;
    typeof console < "u" && console.error(u);
    try {
      throw new Error(u);
    } catch {
    }
  });
  function l() {
    return null;
  }
  return factoryWithTypeCheckers = function(d, u) {
    var c = typeof Symbol == "function" && Symbol.iterator, p = "@@iterator";
    function f(j) {
      var A = j && (c && j[c] || j[p]);
      if (typeof A == "function")
        return A;
    }
    var g = "<<anonymous>>", y = {
      array: E("array"),
      bigint: E("bigint"),
      bool: E("boolean"),
      func: E("function"),
      number: E("number"),
      object: E("object"),
      string: E("string"),
      symbol: E("symbol"),
      any: $(),
      arrayOf: R,
      element: C(),
      elementType: x(),
      instanceOf: _,
      node: w(),
      objectOf: O,
      oneOf: D,
      oneOfType: v,
      shape: S,
      exact: I
    };
    function h(j, A) {
      return j === A ? j !== 0 || 1 / j === 1 / A : j !== j && A !== A;
    }
    function T(j, A) {
      this.message = j, this.data = A && typeof A == "object" ? A : {}, this.stack = "";
    }
    T.prototype = Error.prototype;
    function P(j) {
      if (process.env.NODE_ENV !== "production")
        var A = {}, U = 0;
      function G(ee, J, Z, le, se, K, q) {
        if (le = le || g, K = K || Z, q !== o) {
          if (u) {
            var B = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw B.name = "Invariant Violation", B;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var ue = le + ":" + Z;
            !A[ue] && // Avoid spamming the console because they are often not actionable except for lib authors
            U < 3 && (i(
              "You are manually calling a React.PropTypes validation function for the `" + K + "` prop on `" + le + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), A[ue] = !0, U++);
          }
        }
        return J[Z] == null ? ee ? J[Z] === null ? new T("The " + se + " `" + K + "` is marked as required " + ("in `" + le + "`, but its value is `null`.")) : new T("The " + se + " `" + K + "` is marked as required in " + ("`" + le + "`, but its value is `undefined`.")) : null : j(J, Z, le, se, K);
      }
      var Y = G.bind(null, !1);
      return Y.isRequired = G.bind(null, !0), Y;
    }
    function E(j) {
      function A(U, G, Y, ee, J, Z) {
        var le = U[G], se = L(le);
        if (se !== j) {
          var K = k(le);
          return new T(
            "Invalid " + ee + " `" + J + "` of type " + ("`" + K + "` supplied to `" + Y + "`, expected ") + ("`" + j + "`."),
            { expectedType: j }
          );
        }
        return null;
      }
      return P(A);
    }
    function $() {
      return P(l);
    }
    function R(j) {
      function A(U, G, Y, ee, J) {
        if (typeof j != "function")
          return new T("Property `" + J + "` of component `" + Y + "` has invalid PropType notation inside arrayOf.");
        var Z = U[G];
        if (!Array.isArray(Z)) {
          var le = L(Z);
          return new T("Invalid " + ee + " `" + J + "` of type " + ("`" + le + "` supplied to `" + Y + "`, expected an array."));
        }
        for (var se = 0; se < Z.length; se++) {
          var K = j(Z, se, Y, ee, J + "[" + se + "]", o);
          if (K instanceof Error)
            return K;
        }
        return null;
      }
      return P(A);
    }
    function C() {
      function j(A, U, G, Y, ee) {
        var J = A[U];
        if (!d(J)) {
          var Z = L(J);
          return new T("Invalid " + Y + " `" + ee + "` of type " + ("`" + Z + "` supplied to `" + G + "`, expected a single ReactElement."));
        }
        return null;
      }
      return P(j);
    }
    function x() {
      function j(A, U, G, Y, ee) {
        var J = A[U];
        if (!e.isValidElementType(J)) {
          var Z = L(J);
          return new T("Invalid " + Y + " `" + ee + "` of type " + ("`" + Z + "` supplied to `" + G + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return P(j);
    }
    function _(j) {
      function A(U, G, Y, ee, J) {
        if (!(U[G] instanceof j)) {
          var Z = j.name || g, le = V(U[G]);
          return new T("Invalid " + ee + " `" + J + "` of type " + ("`" + le + "` supplied to `" + Y + "`, expected ") + ("instance of `" + Z + "`."));
        }
        return null;
      }
      return P(A);
    }
    function D(j) {
      if (!Array.isArray(j))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? i(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : i("Invalid argument supplied to oneOf, expected an array.")), l;
      function A(U, G, Y, ee, J) {
        for (var Z = U[G], le = 0; le < j.length; le++)
          if (h(Z, j[le]))
            return null;
        var se = JSON.stringify(j, function(q, B) {
          var ue = k(B);
          return ue === "symbol" ? String(B) : B;
        });
        return new T("Invalid " + ee + " `" + J + "` of value `" + String(Z) + "` " + ("supplied to `" + Y + "`, expected one of " + se + "."));
      }
      return P(A);
    }
    function O(j) {
      function A(U, G, Y, ee, J) {
        if (typeof j != "function")
          return new T("Property `" + J + "` of component `" + Y + "` has invalid PropType notation inside objectOf.");
        var Z = U[G], le = L(Z);
        if (le !== "object")
          return new T("Invalid " + ee + " `" + J + "` of type " + ("`" + le + "` supplied to `" + Y + "`, expected an object."));
        for (var se in Z)
          if (n(Z, se)) {
            var K = j(Z, se, Y, ee, J + "." + se, o);
            if (K instanceof Error)
              return K;
          }
        return null;
      }
      return P(A);
    }
    function v(j) {
      if (!Array.isArray(j))
        return process.env.NODE_ENV !== "production" && i("Invalid argument supplied to oneOfType, expected an instance of array."), l;
      for (var A = 0; A < j.length; A++) {
        var U = j[A];
        if (typeof U != "function")
          return i(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + W(U) + " at index " + A + "."
          ), l;
      }
      function G(Y, ee, J, Z, le) {
        for (var se = [], K = 0; K < j.length; K++) {
          var q = j[K], B = q(Y, ee, J, Z, le, o);
          if (B == null)
            return null;
          B.data && n(B.data, "expectedType") && se.push(B.data.expectedType);
        }
        var ue = se.length > 0 ? ", expected one of type [" + se.join(", ") + "]" : "";
        return new T("Invalid " + Z + " `" + le + "` supplied to " + ("`" + J + "`" + ue + "."));
      }
      return P(G);
    }
    function w() {
      function j(A, U, G, Y, ee) {
        return N(A[U]) ? null : new T("Invalid " + Y + " `" + ee + "` supplied to " + ("`" + G + "`, expected a ReactNode."));
      }
      return P(j);
    }
    function M(j, A, U, G, Y) {
      return new T(
        (j || "React class") + ": " + A + " type `" + U + "." + G + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + Y + "`."
      );
    }
    function S(j) {
      function A(U, G, Y, ee, J) {
        var Z = U[G], le = L(Z);
        if (le !== "object")
          return new T("Invalid " + ee + " `" + J + "` of type `" + le + "` " + ("supplied to `" + Y + "`, expected `object`."));
        for (var se in j) {
          var K = j[se];
          if (typeof K != "function")
            return M(Y, ee, J, se, k(K));
          var q = K(Z, se, Y, ee, J + "." + se, o);
          if (q)
            return q;
        }
        return null;
      }
      return P(A);
    }
    function I(j) {
      function A(U, G, Y, ee, J) {
        var Z = U[G], le = L(Z);
        if (le !== "object")
          return new T("Invalid " + ee + " `" + J + "` of type `" + le + "` " + ("supplied to `" + Y + "`, expected `object`."));
        var se = t({}, U[G], j);
        for (var K in se) {
          var q = j[K];
          if (n(j, K) && typeof q != "function")
            return M(Y, ee, J, K, k(q));
          if (!q)
            return new T(
              "Invalid " + ee + " `" + J + "` key `" + K + "` supplied to `" + Y + "`.\nBad object: " + JSON.stringify(U[G], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(j), null, "  ")
            );
          var B = q(Z, K, Y, ee, J + "." + K, o);
          if (B)
            return B;
        }
        return null;
      }
      return P(A);
    }
    function N(j) {
      switch (typeof j) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !j;
        case "object":
          if (Array.isArray(j))
            return j.every(N);
          if (j === null || d(j))
            return !0;
          var A = f(j);
          if (A) {
            var U = A.call(j), G;
            if (A !== j.entries) {
              for (; !(G = U.next()).done; )
                if (!N(G.value))
                  return !1;
            } else
              for (; !(G = U.next()).done; ) {
                var Y = G.value;
                if (Y && !N(Y[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function F(j, A) {
      return j === "symbol" ? !0 : A ? A["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && A instanceof Symbol : !1;
    }
    function L(j) {
      var A = typeof j;
      return Array.isArray(j) ? "array" : j instanceof RegExp ? "object" : F(A, j) ? "symbol" : A;
    }
    function k(j) {
      if (typeof j > "u" || j === null)
        return "" + j;
      var A = L(j);
      if (A === "object") {
        if (j instanceof Date)
          return "date";
        if (j instanceof RegExp)
          return "regexp";
      }
      return A;
    }
    function W(j) {
      var A = k(j);
      switch (A) {
        case "array":
        case "object":
          return "an " + A;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + A;
        default:
          return A;
      }
    }
    function V(j) {
      return !j.constructor || !j.constructor.name ? g : j.constructor.name;
    }
    return y.checkPropTypes = s, y.resetWarningCache = s.resetWarningCache, y.PropTypes = y, y;
  }, factoryWithTypeCheckers;
}
var factoryWithThrowingShims, hasRequiredFactoryWithThrowingShims;
function requireFactoryWithThrowingShims() {
  if (hasRequiredFactoryWithThrowingShims) return factoryWithThrowingShims;
  hasRequiredFactoryWithThrowingShims = 1;
  var e = /* @__PURE__ */ requireReactPropTypesSecret();
  function t() {
  }
  function o() {
  }
  return o.resetWarningCache = t, factoryWithThrowingShims = function() {
    function n(l, d, u, c, p, f) {
      if (f !== e) {
        var g = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw g.name = "Invariant Violation", g;
      }
    }
    n.isRequired = n;
    function s() {
      return n;
    }
    var i = {
      array: n,
      bigint: n,
      bool: n,
      func: n,
      number: n,
      object: n,
      string: n,
      symbol: n,
      any: n,
      arrayOf: s,
      element: n,
      elementType: n,
      instanceOf: s,
      node: n,
      objectOf: s,
      oneOf: s,
      oneOfType: s,
      shape: s,
      exact: s,
      checkPropTypes: o,
      resetWarningCache: t
    };
    return i.PropTypes = i, i;
  }, factoryWithThrowingShims;
}
var hasRequiredPropTypes;
function requirePropTypes() {
  if (hasRequiredPropTypes) return propTypes.exports;
  if (hasRequiredPropTypes = 1, process.env.NODE_ENV !== "production") {
    var e = requireReactIs$1(), t = !0;
    propTypes.exports = /* @__PURE__ */ requireFactoryWithTypeCheckers()(e.isElement, t);
  } else
    propTypes.exports = /* @__PURE__ */ requireFactoryWithThrowingShims()();
  return propTypes.exports;
}
var propTypesExports = /* @__PURE__ */ requirePropTypes();
const PropTypes = /* @__PURE__ */ getDefaultExportFromCjs(propTypesExports);
var reactIs = { exports: {} }, reactIs_production = {};
var hasRequiredReactIs_production;
function requireReactIs_production() {
  if (hasRequiredReactIs_production) return reactIs_production;
  hasRequiredReactIs_production = 1;
  var e = Symbol.for("react.transitional.element"), t = Symbol.for("react.portal"), o = Symbol.for("react.fragment"), n = Symbol.for("react.strict_mode"), s = Symbol.for("react.profiler"), i = Symbol.for("react.consumer"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), u = Symbol.for("react.suspense"), c = Symbol.for("react.suspense_list"), p = Symbol.for("react.memo"), f = Symbol.for("react.lazy"), g = Symbol.for("react.view_transition"), y = Symbol.for("react.client.reference");
  function h(T) {
    if (typeof T == "object" && T !== null) {
      var P = T.$$typeof;
      switch (P) {
        case e:
          switch (T = T.type, T) {
            case o:
            case s:
            case n:
            case u:
            case c:
            case g:
              return T;
            default:
              switch (T = T && T.$$typeof, T) {
                case l:
                case d:
                case f:
                case p:
                  return T;
                case i:
                  return T;
                default:
                  return P;
              }
          }
        case t:
          return P;
      }
    }
  }
  return reactIs_production.ContextConsumer = i, reactIs_production.ContextProvider = l, reactIs_production.Element = e, reactIs_production.ForwardRef = d, reactIs_production.Fragment = o, reactIs_production.Lazy = f, reactIs_production.Memo = p, reactIs_production.Portal = t, reactIs_production.Profiler = s, reactIs_production.StrictMode = n, reactIs_production.Suspense = u, reactIs_production.SuspenseList = c, reactIs_production.isContextConsumer = function(T) {
    return h(T) === i;
  }, reactIs_production.isContextProvider = function(T) {
    return h(T) === l;
  }, reactIs_production.isElement = function(T) {
    return typeof T == "object" && T !== null && T.$$typeof === e;
  }, reactIs_production.isForwardRef = function(T) {
    return h(T) === d;
  }, reactIs_production.isFragment = function(T) {
    return h(T) === o;
  }, reactIs_production.isLazy = function(T) {
    return h(T) === f;
  }, reactIs_production.isMemo = function(T) {
    return h(T) === p;
  }, reactIs_production.isPortal = function(T) {
    return h(T) === t;
  }, reactIs_production.isProfiler = function(T) {
    return h(T) === s;
  }, reactIs_production.isStrictMode = function(T) {
    return h(T) === n;
  }, reactIs_production.isSuspense = function(T) {
    return h(T) === u;
  }, reactIs_production.isSuspenseList = function(T) {
    return h(T) === c;
  }, reactIs_production.isValidElementType = function(T) {
    return typeof T == "string" || typeof T == "function" || T === o || T === s || T === n || T === u || T === c || typeof T == "object" && T !== null && (T.$$typeof === f || T.$$typeof === p || T.$$typeof === l || T.$$typeof === i || T.$$typeof === d || T.$$typeof === y || T.getModuleId !== void 0);
  }, reactIs_production.typeOf = h, reactIs_production;
}
var reactIs_development = {};
var hasRequiredReactIs_development;
function requireReactIs_development() {
  return hasRequiredReactIs_development || (hasRequiredReactIs_development = 1, process.env.NODE_ENV !== "production" && (function() {
    function e(T) {
      if (typeof T == "object" && T !== null) {
        var P = T.$$typeof;
        switch (P) {
          case t:
            switch (T = T.type, T) {
              case n:
              case i:
              case s:
              case c:
              case p:
              case y:
                return T;
              default:
                switch (T = T && T.$$typeof, T) {
                  case d:
                  case u:
                  case g:
                  case f:
                    return T;
                  case l:
                    return T;
                  default:
                    return P;
                }
            }
          case o:
            return P;
        }
      }
    }
    var t = Symbol.for("react.transitional.element"), o = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), s = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), l = Symbol.for("react.consumer"), d = Symbol.for("react.context"), u = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), p = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), g = Symbol.for("react.lazy"), y = Symbol.for("react.view_transition"), h = Symbol.for("react.client.reference");
    reactIs_development.ContextConsumer = l, reactIs_development.ContextProvider = d, reactIs_development.Element = t, reactIs_development.ForwardRef = u, reactIs_development.Fragment = n, reactIs_development.Lazy = g, reactIs_development.Memo = f, reactIs_development.Portal = o, reactIs_development.Profiler = i, reactIs_development.StrictMode = s, reactIs_development.Suspense = c, reactIs_development.SuspenseList = p, reactIs_development.isContextConsumer = function(T) {
      return e(T) === l;
    }, reactIs_development.isContextProvider = function(T) {
      return e(T) === d;
    }, reactIs_development.isElement = function(T) {
      return typeof T == "object" && T !== null && T.$$typeof === t;
    }, reactIs_development.isForwardRef = function(T) {
      return e(T) === u;
    }, reactIs_development.isFragment = function(T) {
      return e(T) === n;
    }, reactIs_development.isLazy = function(T) {
      return e(T) === g;
    }, reactIs_development.isMemo = function(T) {
      return e(T) === f;
    }, reactIs_development.isPortal = function(T) {
      return e(T) === o;
    }, reactIs_development.isProfiler = function(T) {
      return e(T) === i;
    }, reactIs_development.isStrictMode = function(T) {
      return e(T) === s;
    }, reactIs_development.isSuspense = function(T) {
      return e(T) === c;
    }, reactIs_development.isSuspenseList = function(T) {
      return e(T) === p;
    }, reactIs_development.isValidElementType = function(T) {
      return typeof T == "string" || typeof T == "function" || T === n || T === i || T === s || T === c || T === p || typeof T == "object" && T !== null && (T.$$typeof === g || T.$$typeof === f || T.$$typeof === d || T.$$typeof === l || T.$$typeof === u || T.$$typeof === h || T.getModuleId !== void 0);
    }, reactIs_development.typeOf = e;
  })()), reactIs_development;
}
var hasRequiredReactIs;
function requireReactIs() {
  return hasRequiredReactIs || (hasRequiredReactIs = 1, process.env.NODE_ENV === "production" ? reactIs.exports = /* @__PURE__ */ requireReactIs_production() : reactIs.exports = /* @__PURE__ */ requireReactIs_development()), reactIs.exports;
}
var reactIsExports = /* @__PURE__ */ requireReactIs();
function isPlainObject$1(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const t = Object.getPrototypeOf(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function deepClone(e) {
  if (/* @__PURE__ */ React.isValidElement(e) || reactIsExports.isValidElementType(e) || !isPlainObject$1(e))
    return e;
  const t = {};
  return Object.keys(e).forEach((o) => {
    t[o] = deepClone(e[o]);
  }), t;
}
function deepmerge(e, t, o = {
  clone: !0
}) {
  const n = o.clone ? {
    ...e
  } : e;
  return isPlainObject$1(e) && isPlainObject$1(t) && Object.keys(t).forEach((s) => {
    /* @__PURE__ */ React.isValidElement(t[s]) || reactIsExports.isValidElementType(t[s]) ? n[s] = t[s] : isPlainObject$1(t[s]) && // Avoid prototype pollution
    Object.prototype.hasOwnProperty.call(e, s) && isPlainObject$1(e[s]) ? n[s] = deepmerge(e[s], t[s], o) : o.clone ? n[s] = isPlainObject$1(t[s]) ? deepClone(t[s]) : t[s] : n[s] = t[s];
  }), n;
}
const sortBreakpointsValues = (e) => {
  const t = Object.keys(e).map((o) => ({
    key: o,
    val: e[o]
  })) || [];
  return t.sort((o, n) => o.val - n.val), t.reduce((o, n) => ({
    ...o,
    [n.key]: n.val
  }), {});
};
function createBreakpoints(e) {
  const {
    // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values: t = {
      xs: 0,
      // phone
      sm: 600,
      // tablet
      md: 900,
      // small laptop
      lg: 1200,
      // desktop
      xl: 1536
      // large screen
    },
    unit: o = "px",
    step: n = 5,
    ...s
  } = e, i = sortBreakpointsValues(t), l = Object.keys(i);
  function d(g) {
    return `@media (min-width:${typeof t[g] == "number" ? t[g] : g}${o})`;
  }
  function u(g) {
    return `@media (max-width:${(typeof t[g] == "number" ? t[g] : g) - n / 100}${o})`;
  }
  function c(g, y) {
    const h = l.indexOf(y);
    return `@media (min-width:${typeof t[g] == "number" ? t[g] : g}${o}) and (max-width:${(h !== -1 && typeof t[l[h]] == "number" ? t[l[h]] : y) - n / 100}${o})`;
  }
  function p(g) {
    return l.indexOf(g) + 1 < l.length ? c(g, l[l.indexOf(g) + 1]) : d(g);
  }
  function f(g) {
    const y = l.indexOf(g);
    return y === 0 ? d(l[1]) : y === l.length - 1 ? u(l[y]) : c(g, l[l.indexOf(g) + 1]).replace("@media", "@media not all and");
  }
  return {
    keys: l,
    values: i,
    up: d,
    down: u,
    between: c,
    only: p,
    not: f,
    unit: o,
    ...s
  };
}
function sortContainerQueries(e, t) {
  if (!e.containerQueries)
    return t;
  const o = Object.keys(t).filter((n) => n.startsWith("@container")).sort((n, s) => {
    const i = /min-width:\s*([0-9.]+)/;
    return +(n.match(i)?.[1] || 0) - +(s.match(i)?.[1] || 0);
  });
  return o.length ? o.reduce((n, s) => {
    const i = t[s];
    return delete n[s], n[s] = i, n;
  }, {
    ...t
  }) : t;
}
function isCqShorthand(e, t) {
  return t === "@" || t.startsWith("@") && (e.some((o) => t.startsWith(`@${o}`)) || !!t.match(/^@\d/));
}
function getContainerQuery(e, t) {
  const o = t.match(/^@([^/]+)?\/?(.+)?$/);
  if (!o) {
    if (process.env.NODE_ENV !== "production")
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The provided shorthand ${`(${t})`} is invalid. The format should be \`@<breakpoint | number>\` or \`@<breakpoint | number>/<container>\`.
For example, \`@sm\` or \`@600\` or \`@40rem/sidebar\`.` : formatMuiErrorMessage(18, `(${t})`));
    return null;
  }
  const [, n, s] = o, i = Number.isNaN(+n) ? n || 0 : +n;
  return e.containerQueries(s).up(i);
}
function cssContainerQueries(e) {
  const t = (i, l) => i.replace("@media", l ? `@container ${l}` : "@container");
  function o(i, l) {
    i.up = (...d) => t(e.breakpoints.up(...d), l), i.down = (...d) => t(e.breakpoints.down(...d), l), i.between = (...d) => t(e.breakpoints.between(...d), l), i.only = (...d) => t(e.breakpoints.only(...d), l), i.not = (...d) => {
      const u = t(e.breakpoints.not(...d), l);
      return u.includes("not all and") ? u.replace("not all and ", "").replace("min-width:", "width<").replace("max-width:", "width>").replace("and", "or") : u;
    };
  }
  const n = {}, s = (i) => (o(n, i), n);
  return o(s), {
    ...e,
    containerQueries: s
  };
}
const shape = {
  borderRadius: 4
}, responsivePropType = process.env.NODE_ENV !== "production" ? PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.object, PropTypes.array]) : {};
function merge$1(e, t) {
  return t ? deepmerge(e, t, {
    clone: !1
    // No need to clone deep, it's way faster.
  }) : e;
}
const values$1 = {
  xs: 0,
  // phone
  sm: 600,
  // tablet
  md: 900,
  // small laptop
  lg: 1200,
  // desktop
  xl: 1536
  // large screen
}, defaultBreakpoints = {
  // Sorted ASC by size. That's important.
  // It can't be configured as it's used statically for propTypes.
  keys: ["xs", "sm", "md", "lg", "xl"],
  up: (e) => `@media (min-width:${values$1[e]}px)`
}, defaultContainerQueries = {
  containerQueries: (e) => ({
    up: (t) => {
      let o = typeof t == "number" ? t : values$1[t] || t;
      return typeof o == "number" && (o = `${o}px`), e ? `@container ${e} (min-width:${o})` : `@container (min-width:${o})`;
    }
  })
};
function handleBreakpoints(e, t, o) {
  const n = e.theme || {};
  if (Array.isArray(t)) {
    const i = n.breakpoints || defaultBreakpoints;
    return t.reduce((l, d, u) => (l[i.up(i.keys[u])] = o(t[u]), l), {});
  }
  if (typeof t == "object") {
    const i = n.breakpoints || defaultBreakpoints;
    return Object.keys(t).reduce((l, d) => {
      if (isCqShorthand(i.keys, d)) {
        const u = getContainerQuery(n.containerQueries ? n : defaultContainerQueries, d);
        u && (l[u] = o(t[d], d));
      } else if (Object.keys(i.values || values$1).includes(d)) {
        const u = i.up(d);
        l[u] = o(t[d], d);
      } else {
        const u = d;
        l[u] = t[u];
      }
      return l;
    }, {});
  }
  return o(t);
}
function createEmptyBreakpointObject(e = {}) {
  return e.keys?.reduce((o, n) => {
    const s = e.up(n);
    return o[s] = {}, o;
  }, {}) || {};
}
function removeUnusedBreakpoints(e, t) {
  return e.reduce((o, n) => {
    const s = o[n];
    return (!s || Object.keys(s).length === 0) && delete o[n], o;
  }, t);
}
function capitalize(e) {
  if (typeof e != "string")
    throw new Error(process.env.NODE_ENV !== "production" ? "MUI: `capitalize(string)` expects a string argument." : formatMuiErrorMessage(7));
  return e.charAt(0).toUpperCase() + e.slice(1);
}
function getPath(e, t, o = !0) {
  if (!t || typeof t != "string")
    return null;
  if (e && e.vars && o) {
    const n = `vars.${t}`.split(".").reduce((s, i) => s && s[i] ? s[i] : null, e);
    if (n != null)
      return n;
  }
  return t.split(".").reduce((n, s) => n && n[s] != null ? n[s] : null, e);
}
function getStyleValue$1(e, t, o, n = o) {
  let s;
  return typeof e == "function" ? s = e(o) : Array.isArray(e) ? s = e[o] || n : s = getPath(e, o) || n, t && (s = t(s, n, e)), s;
}
function style$1(e) {
  const {
    prop: t,
    cssProperty: o = e.prop,
    themeKey: n,
    transform: s
  } = e, i = (l) => {
    if (l[t] == null)
      return null;
    const d = l[t], u = l.theme, c = getPath(u, n) || {};
    return handleBreakpoints(l, d, (f) => {
      let g = getStyleValue$1(c, s, f);
      return f === g && typeof f == "string" && (g = getStyleValue$1(c, s, `${t}${f === "default" ? "" : capitalize(f)}`, f)), o === !1 ? g : {
        [o]: g
      };
    });
  };
  return i.propTypes = process.env.NODE_ENV !== "production" ? {
    [t]: responsivePropType
  } : {}, i.filterProps = [t], i;
}
function memoize(e) {
  const t = {};
  return (o) => (t[o] === void 0 && (t[o] = e(o)), t[o]);
}
const properties = {
  m: "margin",
  p: "padding"
}, directions = {
  t: "Top",
  r: "Right",
  b: "Bottom",
  l: "Left",
  x: ["Left", "Right"],
  y: ["Top", "Bottom"]
}, aliases = {
  marginX: "mx",
  marginY: "my",
  paddingX: "px",
  paddingY: "py"
}, getCssProperties = memoize((e) => {
  if (e.length > 2)
    if (aliases[e])
      e = aliases[e];
    else
      return [e];
  const [t, o] = e.split(""), n = properties[t], s = directions[o] || "";
  return Array.isArray(s) ? s.map((i) => n + i) : [n + s];
}), marginKeys = ["m", "mt", "mr", "mb", "ml", "mx", "my", "margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "marginX", "marginY", "marginInline", "marginInlineStart", "marginInlineEnd", "marginBlock", "marginBlockStart", "marginBlockEnd"], paddingKeys = ["p", "pt", "pr", "pb", "pl", "px", "py", "padding", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft", "paddingX", "paddingY", "paddingInline", "paddingInlineStart", "paddingInlineEnd", "paddingBlock", "paddingBlockStart", "paddingBlockEnd"], spacingKeys = [...marginKeys, ...paddingKeys];
function createUnaryUnit(e, t, o, n) {
  const s = getPath(e, t, !0) ?? o;
  return typeof s == "number" || typeof s == "string" ? (i) => typeof i == "string" ? i : (process.env.NODE_ENV !== "production" && typeof i != "number" && console.error(`MUI: Expected ${n} argument to be a number or a string, got ${i}.`), typeof s == "string" ? s.startsWith("var(") && i === 0 ? 0 : s.startsWith("var(") && i === 1 ? s : `calc(${i} * ${s})` : s * i) : Array.isArray(s) ? (i) => {
    if (typeof i == "string")
      return i;
    const l = Math.abs(i);
    process.env.NODE_ENV !== "production" && (Number.isInteger(l) ? l > s.length - 1 && console.error([`MUI: The value provided (${l}) overflows.`, `The supported values are: ${JSON.stringify(s)}.`, `${l} > ${s.length - 1}, you need to add the missing values.`].join(`
`)) : console.error([`MUI: The \`theme.${t}\` array type cannot be combined with non integer values.You should either use an integer value that can be used as index, or define the \`theme.${t}\` as a number.`].join(`
`)));
    const d = s[l];
    return i >= 0 ? d : typeof d == "number" ? -d : typeof d == "string" && d.startsWith("var(") ? `calc(-1 * ${d})` : `-${d}`;
  } : typeof s == "function" ? s : (process.env.NODE_ENV !== "production" && console.error([`MUI: The \`theme.${t}\` value (${s}) is invalid.`, "It should be a number, an array or a function."].join(`
`)), () => {
  });
}
function createUnarySpacing(e) {
  return createUnaryUnit(e, "spacing", 8, "spacing");
}
function getValue(e, t) {
  return typeof t == "string" || t == null ? t : e(t);
}
function getStyleFromPropValue(e, t) {
  return (o) => e.reduce((n, s) => (n[s] = getValue(t, o), n), {});
}
function resolveCssProperty(e, t, o, n) {
  if (!t.includes(o))
    return null;
  const s = getCssProperties(o), i = getStyleFromPropValue(s, n), l = e[o];
  return handleBreakpoints(e, l, i);
}
function style(e, t) {
  const o = createUnarySpacing(e.theme);
  return Object.keys(e).map((n) => resolveCssProperty(e, t, n, o)).reduce(merge$1, {});
}
function margin(e) {
  return style(e, marginKeys);
}
margin.propTypes = process.env.NODE_ENV !== "production" ? marginKeys.reduce((e, t) => (e[t] = responsivePropType, e), {}) : {};
margin.filterProps = marginKeys;
function padding(e) {
  return style(e, paddingKeys);
}
padding.propTypes = process.env.NODE_ENV !== "production" ? paddingKeys.reduce((e, t) => (e[t] = responsivePropType, e), {}) : {};
padding.filterProps = paddingKeys;
process.env.NODE_ENV !== "production" && spacingKeys.reduce((e, t) => (e[t] = responsivePropType, e), {});
function createSpacing(e = 8, t = createUnarySpacing({
  spacing: e
})) {
  if (e.mui)
    return e;
  const o = (...n) => (process.env.NODE_ENV !== "production" && (n.length <= 4 || console.error(`MUI: Too many arguments provided, expected between 0 and 4, got ${n.length}`)), (n.length === 0 ? [1] : n).map((i) => {
    const l = t(i);
    return typeof l == "number" ? `${l}px` : l;
  }).join(" "));
  return o.mui = !0, o;
}
function compose(...e) {
  const t = e.reduce((n, s) => (s.filterProps.forEach((i) => {
    n[i] = s;
  }), n), {}), o = (n) => Object.keys(n).reduce((s, i) => t[i] ? merge$1(s, t[i](n)) : s, {});
  return o.propTypes = process.env.NODE_ENV !== "production" ? e.reduce((n, s) => Object.assign(n, s.propTypes), {}) : {}, o.filterProps = e.reduce((n, s) => n.concat(s.filterProps), []), o;
}
function borderTransform(e) {
  return typeof e != "number" ? e : `${e}px solid`;
}
function createBorderStyle(e, t) {
  return style$1({
    prop: e,
    themeKey: "borders",
    transform: t
  });
}
const border = createBorderStyle("border", borderTransform), borderTop = createBorderStyle("borderTop", borderTransform), borderRight = createBorderStyle("borderRight", borderTransform), borderBottom = createBorderStyle("borderBottom", borderTransform), borderLeft = createBorderStyle("borderLeft", borderTransform), borderColor = createBorderStyle("borderColor"), borderTopColor = createBorderStyle("borderTopColor"), borderRightColor = createBorderStyle("borderRightColor"), borderBottomColor = createBorderStyle("borderBottomColor"), borderLeftColor = createBorderStyle("borderLeftColor"), outline = createBorderStyle("outline", borderTransform), outlineColor = createBorderStyle("outlineColor"), borderRadius = (e) => {
  if (e.borderRadius !== void 0 && e.borderRadius !== null) {
    const t = createUnaryUnit(e.theme, "shape.borderRadius", 4, "borderRadius"), o = (n) => ({
      borderRadius: getValue(t, n)
    });
    return handleBreakpoints(e, e.borderRadius, o);
  }
  return null;
};
borderRadius.propTypes = process.env.NODE_ENV !== "production" ? {
  borderRadius: responsivePropType
} : {};
borderRadius.filterProps = ["borderRadius"];
compose(border, borderTop, borderRight, borderBottom, borderLeft, borderColor, borderTopColor, borderRightColor, borderBottomColor, borderLeftColor, borderRadius, outline, outlineColor);
const gap = (e) => {
  if (e.gap !== void 0 && e.gap !== null) {
    const t = createUnaryUnit(e.theme, "spacing", 8, "gap"), o = (n) => ({
      gap: getValue(t, n)
    });
    return handleBreakpoints(e, e.gap, o);
  }
  return null;
};
gap.propTypes = process.env.NODE_ENV !== "production" ? {
  gap: responsivePropType
} : {};
gap.filterProps = ["gap"];
const columnGap = (e) => {
  if (e.columnGap !== void 0 && e.columnGap !== null) {
    const t = createUnaryUnit(e.theme, "spacing", 8, "columnGap"), o = (n) => ({
      columnGap: getValue(t, n)
    });
    return handleBreakpoints(e, e.columnGap, o);
  }
  return null;
};
columnGap.propTypes = process.env.NODE_ENV !== "production" ? {
  columnGap: responsivePropType
} : {};
columnGap.filterProps = ["columnGap"];
const rowGap = (e) => {
  if (e.rowGap !== void 0 && e.rowGap !== null) {
    const t = createUnaryUnit(e.theme, "spacing", 8, "rowGap"), o = (n) => ({
      rowGap: getValue(t, n)
    });
    return handleBreakpoints(e, e.rowGap, o);
  }
  return null;
};
rowGap.propTypes = process.env.NODE_ENV !== "production" ? {
  rowGap: responsivePropType
} : {};
rowGap.filterProps = ["rowGap"];
const gridColumn = style$1({
  prop: "gridColumn"
}), gridRow = style$1({
  prop: "gridRow"
}), gridAutoFlow = style$1({
  prop: "gridAutoFlow"
}), gridAutoColumns = style$1({
  prop: "gridAutoColumns"
}), gridAutoRows = style$1({
  prop: "gridAutoRows"
}), gridTemplateColumns = style$1({
  prop: "gridTemplateColumns"
}), gridTemplateRows = style$1({
  prop: "gridTemplateRows"
}), gridTemplateAreas = style$1({
  prop: "gridTemplateAreas"
}), gridArea = style$1({
  prop: "gridArea"
});
compose(gap, columnGap, rowGap, gridColumn, gridRow, gridAutoFlow, gridAutoColumns, gridAutoRows, gridTemplateColumns, gridTemplateRows, gridTemplateAreas, gridArea);
function paletteTransform(e, t) {
  return t === "grey" ? t : e;
}
const color$1 = style$1({
  prop: "color",
  themeKey: "palette",
  transform: paletteTransform
}), bgcolor = style$1({
  prop: "bgcolor",
  cssProperty: "backgroundColor",
  themeKey: "palette",
  transform: paletteTransform
}), backgroundColor = style$1({
  prop: "backgroundColor",
  themeKey: "palette",
  transform: paletteTransform
});
compose(color$1, bgcolor, backgroundColor);
function sizingTransform(e) {
  return e <= 1 && e !== 0 ? `${e * 100}%` : e;
}
const width = style$1({
  prop: "width",
  transform: sizingTransform
}), maxWidth = (e) => {
  if (e.maxWidth !== void 0 && e.maxWidth !== null) {
    const t = (o) => {
      const n = e.theme?.breakpoints?.values?.[o] || values$1[o];
      return n ? e.theme?.breakpoints?.unit !== "px" ? {
        maxWidth: `${n}${e.theme.breakpoints.unit}`
      } : {
        maxWidth: n
      } : {
        maxWidth: sizingTransform(o)
      };
    };
    return handleBreakpoints(e, e.maxWidth, t);
  }
  return null;
};
maxWidth.filterProps = ["maxWidth"];
const minWidth = style$1({
  prop: "minWidth",
  transform: sizingTransform
}), height = style$1({
  prop: "height",
  transform: sizingTransform
}), maxHeight = style$1({
  prop: "maxHeight",
  transform: sizingTransform
}), minHeight = style$1({
  prop: "minHeight",
  transform: sizingTransform
});
style$1({
  prop: "size",
  cssProperty: "width",
  transform: sizingTransform
});
style$1({
  prop: "size",
  cssProperty: "height",
  transform: sizingTransform
});
const boxSizing = style$1({
  prop: "boxSizing"
});
compose(width, maxWidth, minWidth, height, maxHeight, minHeight, boxSizing);
const defaultSxConfig = {
  // borders
  border: {
    themeKey: "borders",
    transform: borderTransform
  },
  borderTop: {
    themeKey: "borders",
    transform: borderTransform
  },
  borderRight: {
    themeKey: "borders",
    transform: borderTransform
  },
  borderBottom: {
    themeKey: "borders",
    transform: borderTransform
  },
  borderLeft: {
    themeKey: "borders",
    transform: borderTransform
  },
  borderColor: {
    themeKey: "palette"
  },
  borderTopColor: {
    themeKey: "palette"
  },
  borderRightColor: {
    themeKey: "palette"
  },
  borderBottomColor: {
    themeKey: "palette"
  },
  borderLeftColor: {
    themeKey: "palette"
  },
  outline: {
    themeKey: "borders",
    transform: borderTransform
  },
  outlineColor: {
    themeKey: "palette"
  },
  borderRadius: {
    themeKey: "shape.borderRadius",
    style: borderRadius
  },
  // palette
  color: {
    themeKey: "palette",
    transform: paletteTransform
  },
  bgcolor: {
    themeKey: "palette",
    cssProperty: "backgroundColor",
    transform: paletteTransform
  },
  backgroundColor: {
    themeKey: "palette",
    transform: paletteTransform
  },
  // spacing
  p: {
    style: padding
  },
  pt: {
    style: padding
  },
  pr: {
    style: padding
  },
  pb: {
    style: padding
  },
  pl: {
    style: padding
  },
  px: {
    style: padding
  },
  py: {
    style: padding
  },
  padding: {
    style: padding
  },
  paddingTop: {
    style: padding
  },
  paddingRight: {
    style: padding
  },
  paddingBottom: {
    style: padding
  },
  paddingLeft: {
    style: padding
  },
  paddingX: {
    style: padding
  },
  paddingY: {
    style: padding
  },
  paddingInline: {
    style: padding
  },
  paddingInlineStart: {
    style: padding
  },
  paddingInlineEnd: {
    style: padding
  },
  paddingBlock: {
    style: padding
  },
  paddingBlockStart: {
    style: padding
  },
  paddingBlockEnd: {
    style: padding
  },
  m: {
    style: margin
  },
  mt: {
    style: margin
  },
  mr: {
    style: margin
  },
  mb: {
    style: margin
  },
  ml: {
    style: margin
  },
  mx: {
    style: margin
  },
  my: {
    style: margin
  },
  margin: {
    style: margin
  },
  marginTop: {
    style: margin
  },
  marginRight: {
    style: margin
  },
  marginBottom: {
    style: margin
  },
  marginLeft: {
    style: margin
  },
  marginX: {
    style: margin
  },
  marginY: {
    style: margin
  },
  marginInline: {
    style: margin
  },
  marginInlineStart: {
    style: margin
  },
  marginInlineEnd: {
    style: margin
  },
  marginBlock: {
    style: margin
  },
  marginBlockStart: {
    style: margin
  },
  marginBlockEnd: {
    style: margin
  },
  // display
  displayPrint: {
    cssProperty: !1,
    transform: (e) => ({
      "@media print": {
        display: e
      }
    })
  },
  display: {},
  overflow: {},
  textOverflow: {},
  visibility: {},
  whiteSpace: {},
  // flexbox
  flexBasis: {},
  flexDirection: {},
  flexWrap: {},
  justifyContent: {},
  alignItems: {},
  alignContent: {},
  order: {},
  flex: {},
  flexGrow: {},
  flexShrink: {},
  alignSelf: {},
  justifyItems: {},
  justifySelf: {},
  // grid
  gap: {
    style: gap
  },
  rowGap: {
    style: rowGap
  },
  columnGap: {
    style: columnGap
  },
  gridColumn: {},
  gridRow: {},
  gridAutoFlow: {},
  gridAutoColumns: {},
  gridAutoRows: {},
  gridTemplateColumns: {},
  gridTemplateRows: {},
  gridTemplateAreas: {},
  gridArea: {},
  // positions
  position: {},
  zIndex: {
    themeKey: "zIndex"
  },
  top: {},
  right: {},
  bottom: {},
  left: {},
  // shadows
  boxShadow: {
    themeKey: "shadows"
  },
  // sizing
  width: {
    transform: sizingTransform
  },
  maxWidth: {
    style: maxWidth
  },
  minWidth: {
    transform: sizingTransform
  },
  height: {
    transform: sizingTransform
  },
  maxHeight: {
    transform: sizingTransform
  },
  minHeight: {
    transform: sizingTransform
  },
  boxSizing: {},
  // typography
  font: {
    themeKey: "font"
  },
  fontFamily: {
    themeKey: "typography"
  },
  fontSize: {
    themeKey: "typography"
  },
  fontStyle: {
    themeKey: "typography"
  },
  fontWeight: {
    themeKey: "typography"
  },
  letterSpacing: {},
  textTransform: {},
  lineHeight: {},
  textAlign: {},
  typography: {
    cssProperty: !1,
    themeKey: "typography"
  }
};
function objectsHaveSameKeys(...e) {
  const t = e.reduce((n, s) => n.concat(Object.keys(s)), []), o = new Set(t);
  return e.every((n) => o.size === Object.keys(n).length);
}
function callIfFn(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function unstable_createStyleFunctionSx() {
  function e(o, n, s, i) {
    const l = {
      [o]: n,
      theme: s
    }, d = i[o];
    if (!d)
      return {
        [o]: n
      };
    const {
      cssProperty: u = o,
      themeKey: c,
      transform: p,
      style: f
    } = d;
    if (n == null)
      return null;
    if (c === "typography" && n === "inherit")
      return {
        [o]: n
      };
    const g = getPath(s, c) || {};
    return f ? f(l) : handleBreakpoints(l, n, (h) => {
      let T = getStyleValue$1(g, p, h);
      return h === T && typeof h == "string" && (T = getStyleValue$1(g, p, `${o}${h === "default" ? "" : capitalize(h)}`, h)), u === !1 ? T : {
        [u]: T
      };
    });
  }
  function t(o) {
    const {
      sx: n,
      theme: s = {},
      nested: i
    } = o || {};
    if (!n)
      return null;
    const l = s.unstable_sxConfig ?? defaultSxConfig;
    function d(u) {
      let c = u;
      if (typeof u == "function")
        c = u(s);
      else if (typeof u != "object")
        return u;
      if (!c)
        return null;
      const p = createEmptyBreakpointObject(s.breakpoints), f = Object.keys(p);
      let g = p;
      return Object.keys(c).forEach((y) => {
        const h = callIfFn(c[y], s);
        if (h != null)
          if (typeof h == "object")
            if (l[y])
              g = merge$1(g, e(y, h, s, l));
            else {
              const T = handleBreakpoints({
                theme: s
              }, h, (P) => ({
                [y]: P
              }));
              objectsHaveSameKeys(T, h) ? g[y] = t({
                sx: h,
                theme: s,
                nested: !0
              }) : g = merge$1(g, T);
            }
          else
            g = merge$1(g, e(y, h, s, l));
      }), !i && s.modularCssLayers ? {
        "@layer sx": sortContainerQueries(s, removeUnusedBreakpoints(f, g))
      } : sortContainerQueries(s, removeUnusedBreakpoints(f, g));
    }
    return Array.isArray(n) ? n.map(d) : d(n);
  }
  return t;
}
const styleFunctionSx = unstable_createStyleFunctionSx();
styleFunctionSx.filterProps = ["sx"];
function applyStyles$2(e, t) {
  const o = this;
  if (o.vars) {
    if (!o.colorSchemes?.[e] || typeof o.getColorSchemeSelector != "function")
      return {};
    let n = o.getColorSchemeSelector(e);
    return n === "&" ? t : ((n.includes("data-") || n.includes(".")) && (n = `*:where(${n.replace(/\s*&$/, "")}) &`), {
      [n]: t
    });
  }
  return o.palette.mode === e ? t : {};
}
function createTheme$1(e = {}, ...t) {
  const {
    breakpoints: o = {},
    palette: n = {},
    spacing: s,
    shape: i = {},
    ...l
  } = e, d = createBreakpoints(o), u = createSpacing(s);
  let c = deepmerge({
    breakpoints: d,
    direction: "ltr",
    components: {},
    // Inject component definitions.
    palette: {
      mode: "light",
      ...n
    },
    spacing: u,
    shape: {
      ...shape,
      ...i
    }
  }, l);
  return c = cssContainerQueries(c), c.applyStyles = applyStyles$2, c = t.reduce((p, f) => deepmerge(p, f), c), c.unstable_sxConfig = {
    ...defaultSxConfig,
    ...l?.unstable_sxConfig
  }, c.unstable_sx = function(f) {
    return styleFunctionSx({
      sx: f,
      theme: this
    });
  }, c;
}
function isObjectEmpty$2(e) {
  return Object.keys(e).length === 0;
}
function useTheme$3(e = null) {
  const t = React.useContext(ThemeContext$1);
  return !t || isObjectEmpty$2(t) ? e : t;
}
const systemDefaultTheme$1 = createTheme$1();
function useTheme$2(e = systemDefaultTheme$1) {
  return useTheme$3(e);
}
var jsxRuntime = { exports: {} }, reactJsxRuntime_production = {};
var hasRequiredReactJsxRuntime_production;
function requireReactJsxRuntime_production() {
  if (hasRequiredReactJsxRuntime_production) return reactJsxRuntime_production;
  hasRequiredReactJsxRuntime_production = 1;
  var e = Symbol.for("react.transitional.element"), t = Symbol.for("react.fragment");
  function o(n, s, i) {
    var l = null;
    if (i !== void 0 && (l = "" + i), s.key !== void 0 && (l = "" + s.key), "key" in s) {
      i = {};
      for (var d in s)
        d !== "key" && (i[d] = s[d]);
    } else i = s;
    return s = i.ref, {
      $$typeof: e,
      type: n,
      key: l,
      ref: s !== void 0 ? s : null,
      props: i
    };
  }
  return reactJsxRuntime_production.Fragment = t, reactJsxRuntime_production.jsx = o, reactJsxRuntime_production.jsxs = o, reactJsxRuntime_production;
}
var reactJsxRuntime_development = {};
var hasRequiredReactJsxRuntime_development;
function requireReactJsxRuntime_development() {
  return hasRequiredReactJsxRuntime_development || (hasRequiredReactJsxRuntime_development = 1, process.env.NODE_ENV !== "production" && (function() {
    function e(A) {
      if (A == null) return null;
      if (typeof A == "function")
        return A.$$typeof === M ? null : A.displayName || A.name || null;
      if (typeof A == "string") return A;
      switch (A) {
        case P:
          return "Fragment";
        case $:
          return "Profiler";
        case E:
          return "StrictMode";
        case _:
          return "Suspense";
        case D:
          return "SuspenseList";
        case w:
          return "Activity";
      }
      if (typeof A == "object")
        switch (typeof A.tag == "number" && console.error(
          "Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."
        ), A.$$typeof) {
          case T:
            return "Portal";
          case C:
            return A.displayName || "Context";
          case R:
            return (A._context.displayName || "Context") + ".Consumer";
          case x:
            var U = A.render;
            return A = A.displayName, A || (A = U.displayName || U.name || "", A = A !== "" ? "ForwardRef(" + A + ")" : "ForwardRef"), A;
          case O:
            return U = A.displayName || null, U !== null ? U : e(A.type) || "Memo";
          case v:
            U = A._payload, A = A._init;
            try {
              return e(A(U));
            } catch {
            }
        }
      return null;
    }
    function t(A) {
      return "" + A;
    }
    function o(A) {
      try {
        t(A);
        var U = !1;
      } catch {
        U = !0;
      }
      if (U) {
        U = console;
        var G = U.error, Y = typeof Symbol == "function" && Symbol.toStringTag && A[Symbol.toStringTag] || A.constructor.name || "Object";
        return G.call(
          U,
          "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.",
          Y
        ), t(A);
      }
    }
    function n(A) {
      if (A === P) return "<>";
      if (typeof A == "object" && A !== null && A.$$typeof === v)
        return "<...>";
      try {
        var U = e(A);
        return U ? "<" + U + ">" : "<...>";
      } catch {
        return "<...>";
      }
    }
    function s() {
      var A = S.A;
      return A === null ? null : A.getOwner();
    }
    function i() {
      return Error("react-stack-top-frame");
    }
    function l(A) {
      if (I.call(A, "key")) {
        var U = Object.getOwnPropertyDescriptor(A, "key").get;
        if (U && U.isReactWarning) return !1;
      }
      return A.key !== void 0;
    }
    function d(A, U) {
      function G() {
        L || (L = !0, console.error(
          "%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)",
          U
        ));
      }
      G.isReactWarning = !0, Object.defineProperty(A, "key", {
        get: G,
        configurable: !0
      });
    }
    function u() {
      var A = e(this.type);
      return k[A] || (k[A] = !0, console.error(
        "Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release."
      )), A = this.props.ref, A !== void 0 ? A : null;
    }
    function c(A, U, G, Y, ee, J) {
      var Z = G.ref;
      return A = {
        $$typeof: h,
        type: A,
        key: U,
        props: G,
        _owner: Y
      }, (Z !== void 0 ? Z : null) !== null ? Object.defineProperty(A, "ref", {
        enumerable: !1,
        get: u
      }) : Object.defineProperty(A, "ref", { enumerable: !1, value: null }), A._store = {}, Object.defineProperty(A._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: 0
      }), Object.defineProperty(A, "_debugInfo", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: null
      }), Object.defineProperty(A, "_debugStack", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: ee
      }), Object.defineProperty(A, "_debugTask", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: J
      }), Object.freeze && (Object.freeze(A.props), Object.freeze(A)), A;
    }
    function p(A, U, G, Y, ee, J) {
      var Z = U.children;
      if (Z !== void 0)
        if (Y)
          if (N(Z)) {
            for (Y = 0; Y < Z.length; Y++)
              f(Z[Y]);
            Object.freeze && Object.freeze(Z);
          } else
            console.error(
              "React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead."
            );
        else f(Z);
      if (I.call(U, "key")) {
        Z = e(A);
        var le = Object.keys(U).filter(function(K) {
          return K !== "key";
        });
        Y = 0 < le.length ? "{key: someKey, " + le.join(": ..., ") + ": ...}" : "{key: someKey}", j[Z + Y] || (le = 0 < le.length ? "{" + le.join(": ..., ") + ": ...}" : "{}", console.error(
          `A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`,
          Y,
          Z,
          le,
          Z
        ), j[Z + Y] = !0);
      }
      if (Z = null, G !== void 0 && (o(G), Z = "" + G), l(U) && (o(U.key), Z = "" + U.key), "key" in U) {
        G = {};
        for (var se in U)
          se !== "key" && (G[se] = U[se]);
      } else G = U;
      return Z && d(
        G,
        typeof A == "function" ? A.displayName || A.name || "Unknown" : A
      ), c(
        A,
        Z,
        G,
        s(),
        ee,
        J
      );
    }
    function f(A) {
      g(A) ? A._store && (A._store.validated = 1) : typeof A == "object" && A !== null && A.$$typeof === v && (A._payload.status === "fulfilled" ? g(A._payload.value) && A._payload.value._store && (A._payload.value._store.validated = 1) : A._store && (A._store.validated = 1));
    }
    function g(A) {
      return typeof A == "object" && A !== null && A.$$typeof === h;
    }
    var y = React__default, h = Symbol.for("react.transitional.element"), T = Symbol.for("react.portal"), P = Symbol.for("react.fragment"), E = Symbol.for("react.strict_mode"), $ = Symbol.for("react.profiler"), R = Symbol.for("react.consumer"), C = Symbol.for("react.context"), x = Symbol.for("react.forward_ref"), _ = Symbol.for("react.suspense"), D = Symbol.for("react.suspense_list"), O = Symbol.for("react.memo"), v = Symbol.for("react.lazy"), w = Symbol.for("react.activity"), M = Symbol.for("react.client.reference"), S = y.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, I = Object.prototype.hasOwnProperty, N = Array.isArray, F = console.createTask ? console.createTask : function() {
      return null;
    };
    y = {
      react_stack_bottom_frame: function(A) {
        return A();
      }
    };
    var L, k = {}, W = y.react_stack_bottom_frame.bind(
      y,
      i
    )(), V = F(n(i)), j = {};
    reactJsxRuntime_development.Fragment = P, reactJsxRuntime_development.jsx = function(A, U, G) {
      var Y = 1e4 > S.recentlyCreatedOwnerStacks++;
      return p(
        A,
        U,
        G,
        !1,
        Y ? Error("react-stack-top-frame") : W,
        Y ? F(n(A)) : V
      );
    }, reactJsxRuntime_development.jsxs = function(A, U, G) {
      var Y = 1e4 > S.recentlyCreatedOwnerStacks++;
      return p(
        A,
        U,
        G,
        !0,
        Y ? Error("react-stack-top-frame") : W,
        Y ? F(n(A)) : V
      );
    };
  })()), reactJsxRuntime_development;
}
var hasRequiredJsxRuntime;
function requireJsxRuntime() {
  return hasRequiredJsxRuntime || (hasRequiredJsxRuntime = 1, process.env.NODE_ENV === "production" ? jsxRuntime.exports = requireReactJsxRuntime_production() : jsxRuntime.exports = requireReactJsxRuntime_development()), jsxRuntime.exports;
}
var jsxRuntimeExports = requireJsxRuntime();
function wrapGlobalLayer(e) {
  const t = internal_serializeStyles(e);
  return e !== t && t.styles ? (t.styles.match(/^@layer\s+[^{]*$/) || (t.styles = `@layer global{${t.styles}}`), t) : e;
}
function GlobalStyles$1({
  styles: e,
  themeId: t,
  defaultTheme: o = {}
}) {
  const n = useTheme$2(o), s = t && n[t] || n;
  let i = typeof e == "function" ? e(s) : e;
  return s.modularCssLayers && (Array.isArray(i) ? i = i.map((l) => wrapGlobalLayer(typeof l == "function" ? l(s) : l)) : i = wrapGlobalLayer(i)), /* @__PURE__ */ jsxRuntimeExports.jsx(GlobalStyles$2, {
    styles: i
  });
}
process.env.NODE_ENV !== "production" && (GlobalStyles$1.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  defaultTheme: PropTypes.object,
  /**
   * @ignore
   */
  styles: PropTypes.oneOfType([PropTypes.array, PropTypes.func, PropTypes.number, PropTypes.object, PropTypes.string, PropTypes.bool]),
  /**
   * @ignore
   */
  themeId: PropTypes.string
});
const splitProps = (e) => {
  const t = {
    systemProps: {},
    otherProps: {}
  }, o = e?.theme?.unstable_sxConfig ?? defaultSxConfig;
  return Object.keys(e).forEach((n) => {
    o[n] ? t.systemProps[n] = e[n] : t.otherProps[n] = e[n];
  }), t;
};
function extendSxProp$1(e) {
  const {
    sx: t,
    ...o
  } = e, {
    systemProps: n,
    otherProps: s
  } = splitProps(o);
  let i;
  return Array.isArray(t) ? i = [n, ...t] : typeof t == "function" ? i = (...l) => {
    const d = t(...l);
    return isPlainObject$1(d) ? {
      ...n,
      ...d
    } : n;
  } : i = {
    ...n,
    ...t
  }, {
    ...s,
    sx: i
  };
}
const defaultGenerator = (e) => e, createClassNameGenerator = () => {
  let e = defaultGenerator;
  return {
    configure(t) {
      e = t;
    },
    generate(t) {
      return e(t);
    },
    reset() {
      e = defaultGenerator;
    }
  };
}, ClassNameGenerator = createClassNameGenerator();
function r(e) {
  var t, o, n = "";
  if (typeof e == "string" || typeof e == "number") n += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var s = e.length;
    for (t = 0; t < s; t++) e[t] && (o = r(e[t])) && (n && (n += " "), n += o);
  } else for (o in e) e[o] && (n && (n += " "), n += o);
  return n;
}
function clsx() {
  for (var e, t, o = 0, n = "", s = arguments.length; o < s; o++) (e = arguments[o]) && (t = r(e)) && (n && (n += " "), n += t);
  return n;
}
const globalStateClasses = {
  active: "active",
  checked: "checked",
  completed: "completed",
  disabled: "disabled",
  error: "error",
  expanded: "expanded",
  focused: "focused",
  focusVisible: "focusVisible",
  open: "open",
  readOnly: "readOnly",
  required: "required",
  selected: "selected"
};
function generateUtilityClass(e, t, o = "Mui") {
  const n = globalStateClasses[t];
  return n ? `${o}-${n}` : `${ClassNameGenerator.generate(e)}-${t}`;
}
function generateUtilityClasses(e, t, o = "Mui") {
  const n = {};
  return t.forEach((s) => {
    n[s] = generateUtilityClass(e, s, o);
  }), n;
}
function getFunctionComponentName(e, t = "") {
  return e.displayName || e.name || t;
}
function getWrappedName(e, t, o) {
  const n = getFunctionComponentName(t);
  return e.displayName || (n !== "" ? `${o}(${n})` : o);
}
function getDisplayName(e) {
  if (e != null) {
    if (typeof e == "string")
      return e;
    if (typeof e == "function")
      return getFunctionComponentName(e, "Component");
    if (typeof e == "object")
      switch (e.$$typeof) {
        case reactIsExports.ForwardRef:
          return getWrappedName(e, e.render, "ForwardRef");
        case reactIsExports.Memo:
          return getWrappedName(e, e.type, "memo");
        default:
          return;
      }
  }
}
function preprocessStyles(e) {
  const {
    variants: t,
    ...o
  } = e, n = {
    variants: t,
    style: internal_serializeStyles(o),
    isProcessed: !0
  };
  return n.style === o || t && t.forEach((s) => {
    typeof s.style != "function" && (s.style = internal_serializeStyles(s.style));
  }), n;
}
const systemDefaultTheme = createTheme$1();
function shouldForwardProp(e) {
  return e !== "ownerState" && e !== "theme" && e !== "sx" && e !== "as";
}
function shallowLayer(e, t) {
  return t && e && typeof e == "object" && e.styles && !e.styles.startsWith("@layer") && (e.styles = `@layer ${t}{${String(e.styles)}}`), e;
}
function defaultOverridesResolver(e) {
  return e ? (t, o) => o[e] : null;
}
function attachTheme(e, t, o) {
  e.theme = isObjectEmpty$1(e.theme) ? o : e.theme[t] || e.theme;
}
function processStyle(e, t, o) {
  const n = typeof t == "function" ? t(e) : t;
  if (Array.isArray(n))
    return n.flatMap((s) => processStyle(e, s, o));
  if (Array.isArray(n?.variants)) {
    let s;
    if (n.isProcessed)
      s = o ? shallowLayer(n.style, o) : n.style;
    else {
      const {
        variants: i,
        ...l
      } = n;
      s = o ? shallowLayer(internal_serializeStyles(l), o) : l;
    }
    return processStyleVariants(e, n.variants, [s], o);
  }
  return n?.isProcessed ? o ? shallowLayer(internal_serializeStyles(n.style), o) : n.style : o ? shallowLayer(internal_serializeStyles(n), o) : n;
}
function processStyleVariants(e, t, o = [], n = void 0) {
  let s;
  e: for (let i = 0; i < t.length; i += 1) {
    const l = t[i];
    if (typeof l.props == "function") {
      if (s ??= {
        ...e,
        ...e.ownerState,
        ownerState: e.ownerState
      }, !l.props(s))
        continue;
    } else
      for (const d in l.props)
        if (e[d] !== l.props[d] && e.ownerState?.[d] !== l.props[d])
          continue e;
    typeof l.style == "function" ? (s ??= {
      ...e,
      ...e.ownerState,
      ownerState: e.ownerState
    }, o.push(n ? shallowLayer(internal_serializeStyles(l.style(s)), n) : l.style(s))) : o.push(n ? shallowLayer(internal_serializeStyles(l.style), n) : l.style);
  }
  return o;
}
function createStyled(e = {}) {
  const {
    themeId: t,
    defaultTheme: o = systemDefaultTheme,
    rootShouldForwardProp: n = shouldForwardProp,
    slotShouldForwardProp: s = shouldForwardProp
  } = e;
  function i(d) {
    attachTheme(d, t, o);
  }
  return (d, u = {}) => {
    internal_mutateStyles(d, (_) => _.filter((D) => D !== styleFunctionSx));
    const {
      name: c,
      slot: p,
      skipVariantsResolver: f,
      skipSx: g,
      // TODO v6: remove `lowercaseFirstLetter()` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      overridesResolver: y = defaultOverridesResolver(lowercaseFirstLetter(p)),
      ...h
    } = u, T = c && c.startsWith("Mui") || p ? "components" : "custom", P = f !== void 0 ? f : (
      // TODO v6: remove `Root` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      p && p !== "Root" && p !== "root" || !1
    ), E = g || !1;
    let $ = shouldForwardProp;
    p === "Root" || p === "root" ? $ = n : p ? $ = s : isStringTag(d) && ($ = void 0);
    const R = styled$1(d, {
      shouldForwardProp: $,
      label: generateStyledLabel(c, p),
      ...h
    }), C = (_) => {
      if (_.__emotion_real === _)
        return _;
      if (typeof _ == "function")
        return function(O) {
          return processStyle(O, _, O.theme.modularCssLayers ? T : void 0);
        };
      if (isPlainObject$1(_)) {
        const D = preprocessStyles(_);
        return function(v) {
          return D.variants ? processStyle(v, D, v.theme.modularCssLayers ? T : void 0) : v.theme.modularCssLayers ? shallowLayer(D.style, T) : D.style;
        };
      }
      return _;
    }, x = (..._) => {
      const D = [], O = _.map(C), v = [];
      if (D.push(i), c && y && v.push(function(I) {
        const F = I.theme.components?.[c]?.styleOverrides;
        if (!F)
          return null;
        const L = {};
        for (const k in F)
          L[k] = processStyle(I, F[k], I.theme.modularCssLayers ? "theme" : void 0);
        return y(I, L);
      }), c && !P && v.push(function(I) {
        const F = I.theme?.components?.[c]?.variants;
        return F ? processStyleVariants(I, F, [], I.theme.modularCssLayers ? "theme" : void 0) : null;
      }), E || v.push(styleFunctionSx), Array.isArray(O[0])) {
        const S = O.shift(), I = new Array(D.length).fill(""), N = new Array(v.length).fill("");
        let F;
        F = [...I, ...S, ...N], F.raw = [...I, ...S.raw, ...N], D.unshift(F);
      }
      const w = [...D, ...O, ...v], M = R(...w);
      return d.muiName && (M.muiName = d.muiName), process.env.NODE_ENV !== "production" && (M.displayName = generateDisplayName(c, p, d)), M;
    };
    return R.withConfig && (x.withConfig = R.withConfig), x;
  };
}
function generateDisplayName(e, t, o) {
  return e ? `${e}${capitalize(t || "")}` : `Styled(${getDisplayName(o)})`;
}
function generateStyledLabel(e, t) {
  let o;
  return process.env.NODE_ENV !== "production" && e && (o = `${e}-${lowercaseFirstLetter(t || "Root")}`), o;
}
function isObjectEmpty$1(e) {
  for (const t in e)
    return !1;
  return !0;
}
function isStringTag(e) {
  return typeof e == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  e.charCodeAt(0) > 96;
}
function lowercaseFirstLetter(e) {
  return e && e.charAt(0).toLowerCase() + e.slice(1);
}
function resolveProps(e, t, o = !1) {
  const n = {
    ...t
  };
  for (const s in e)
    if (Object.prototype.hasOwnProperty.call(e, s)) {
      const i = s;
      if (i === "components" || i === "slots")
        n[i] = {
          ...e[i],
          ...n[i]
        };
      else if (i === "componentsProps" || i === "slotProps") {
        const l = e[i], d = t[i];
        if (!d)
          n[i] = l || {};
        else if (!l)
          n[i] = d;
        else {
          n[i] = {
            ...d
          };
          for (const u in l)
            if (Object.prototype.hasOwnProperty.call(l, u)) {
              const c = u;
              n[i][c] = resolveProps(l[c], d[c], o);
            }
        }
      } else i === "className" && o && t.className ? n.className = clsx(e?.className, t?.className) : i === "style" && o && t.style ? n.style = {
        ...e?.style,
        ...t?.style
      } : n[i] === void 0 && (n[i] = e[i]);
    }
  return n;
}
function getThemeProps$1(e) {
  const {
    theme: t,
    name: o,
    props: n
  } = e;
  return !t || !t.components || !t.components[o] || !t.components[o].defaultProps ? n : resolveProps(t.components[o].defaultProps, n);
}
function useThemeProps$1({
  props: e,
  name: t,
  defaultTheme: o,
  themeId: n
}) {
  let s = useTheme$2(o);
  return s = s[n] || s, getThemeProps$1({
    theme: s,
    name: t,
    props: e
  });
}
const useEnhancedEffect = typeof window < "u" ? React.useLayoutEffect : React.useEffect;
function useMediaQueryOld(e, t, o, n, s) {
  const [i, l] = React.useState(() => s && o ? o(e).matches : n ? n(e).matches : t);
  return useEnhancedEffect(() => {
    if (!o)
      return;
    const d = o(e), u = () => {
      l(d.matches);
    };
    return u(), d.addEventListener("change", u), () => {
      d.removeEventListener("change", u);
    };
  }, [e, o]), i;
}
const safeReact$1 = {
  ...React
}, maybeReactUseSyncExternalStore = safeReact$1.useSyncExternalStore;
function useMediaQueryNew(e, t, o, n, s) {
  const i = React.useCallback(() => t, [t]), l = React.useMemo(() => {
    if (s && o)
      return () => o(e).matches;
    if (n !== null) {
      const {
        matches: p
      } = n(e);
      return () => p;
    }
    return i;
  }, [i, e, n, s, o]), [d, u] = React.useMemo(() => {
    if (o === null)
      return [i, () => () => {
      }];
    const p = o(e);
    return [() => p.matches, (f) => (p.addEventListener("change", f), () => {
      p.removeEventListener("change", f);
    })];
  }, [i, o, e]);
  return maybeReactUseSyncExternalStore(u, d, l);
}
function unstable_createUseMediaQuery(e = {}) {
  const {
    themeId: t
  } = e;
  return function(n, s = {}) {
    let i = useTheme$3();
    i && t && (i = i[t] || i);
    const l = typeof window < "u" && typeof window.matchMedia < "u", {
      defaultMatches: d = !1,
      matchMedia: u = l ? window.matchMedia : null,
      ssrMatchMedia: c = null,
      noSsr: p = !1
    } = getThemeProps$1({
      name: "MuiUseMediaQuery",
      props: s,
      theme: i
    });
    process.env.NODE_ENV !== "production" && typeof n == "function" && i === null && console.error(["MUI: The `query` argument provided is invalid.", "You are providing a function without a theme in the context.", "One of the parent elements needs to use a ThemeProvider."].join(`
`));
    let f = typeof n == "function" ? n(i) : n;
    f = f.replace(/^@media( ?)/m, ""), f.includes("print") && console.warn(["MUI: You have provided a `print` query to the `useMediaQuery` hook.", "Using the print media query to modify print styles can lead to unexpected results.", "Consider using the `displayPrint` field in the `sx` prop instead.", "More information about `displayPrint` on our docs: https://mui.com/system/display/#display-in-print."].join(`
`));
    const y = (maybeReactUseSyncExternalStore !== void 0 ? useMediaQueryNew : useMediaQueryOld)(f, d, u, c, p);
    return process.env.NODE_ENV !== "production" && React.useDebugValue({
      query: f,
      match: y
    }), y;
  };
}
unstable_createUseMediaQuery();
function clamp$1(e, t = Number.MIN_SAFE_INTEGER, o = Number.MAX_SAFE_INTEGER) {
  return Math.max(t, Math.min(e, o));
}
function clampWrapper(e, t = 0, o = 1) {
  return process.env.NODE_ENV !== "production" && (e < t || e > o) && console.error(`MUI: The value provided ${e} is out of range [${t}, ${o}].`), clamp$1(e, t, o);
}
function hexToRgb(e) {
  e = e.slice(1);
  const t = new RegExp(`.{1,${e.length >= 6 ? 2 : 1}}`, "g");
  let o = e.match(t);
  return o && o[0].length === 1 && (o = o.map((n) => n + n)), process.env.NODE_ENV !== "production" && e.length !== e.trim().length && console.error(`MUI: The color: "${e}" is invalid. Make sure the color input doesn't contain leading/trailing space.`), o ? `rgb${o.length === 4 ? "a" : ""}(${o.map((n, s) => s < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1e3) / 1e3).join(", ")})` : "";
}
function decomposeColor(e) {
  if (e.type)
    return e;
  if (e.charAt(0) === "#")
    return decomposeColor(hexToRgb(e));
  const t = e.indexOf("("), o = e.substring(0, t);
  if (!["rgb", "rgba", "hsl", "hsla", "color"].includes(o))
    throw new Error(process.env.NODE_ENV !== "production" ? `MUI: Unsupported \`${e}\` color.
The following formats are supported: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().` : formatMuiErrorMessage(9, e));
  let n = e.substring(t + 1, e.length - 1), s;
  if (o === "color") {
    if (n = n.split(" "), s = n.shift(), n.length === 4 && n[3].charAt(0) === "/" && (n[3] = n[3].slice(1)), !["srgb", "display-p3", "a98-rgb", "prophoto-rgb", "rec-2020"].includes(s))
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: unsupported \`${s}\` color space.
The following color spaces are supported: srgb, display-p3, a98-rgb, prophoto-rgb, rec-2020.` : formatMuiErrorMessage(10, s));
  } else
    n = n.split(",");
  return n = n.map((i) => parseFloat(i)), {
    type: o,
    values: n,
    colorSpace: s
  };
}
const colorChannel = (e) => {
  const t = decomposeColor(e);
  return t.values.slice(0, 3).map((o, n) => t.type.includes("hsl") && n !== 0 ? `${o}%` : o).join(" ");
}, private_safeColorChannel = (e, t) => {
  try {
    return colorChannel(e);
  } catch {
    return t && process.env.NODE_ENV !== "production" && console.warn(t), e;
  }
};
function recomposeColor(e) {
  const {
    type: t,
    colorSpace: o
  } = e;
  let {
    values: n
  } = e;
  return t.includes("rgb") ? n = n.map((s, i) => i < 3 ? parseInt(s, 10) : s) : t.includes("hsl") && (n[1] = `${n[1]}%`, n[2] = `${n[2]}%`), t.includes("color") ? n = `${o} ${n.join(" ")}` : n = `${n.join(", ")}`, `${t}(${n})`;
}
function hslToRgb(e) {
  e = decomposeColor(e);
  const {
    values: t
  } = e, o = t[0], n = t[1] / 100, s = t[2] / 100, i = n * Math.min(s, 1 - s), l = (c, p = (c + o / 30) % 12) => s - i * Math.max(Math.min(p - 3, 9 - p, 1), -1);
  let d = "rgb";
  const u = [Math.round(l(0) * 255), Math.round(l(8) * 255), Math.round(l(4) * 255)];
  return e.type === "hsla" && (d += "a", u.push(t[3])), recomposeColor({
    type: d,
    values: u
  });
}
function getLuminance(e) {
  e = decomposeColor(e);
  let t = e.type === "hsl" || e.type === "hsla" ? decomposeColor(hslToRgb(e)).values : e.values;
  return t = t.map((o) => (e.type !== "color" && (o /= 255), o <= 0.03928 ? o / 12.92 : ((o + 0.055) / 1.055) ** 2.4)), Number((0.2126 * t[0] + 0.7152 * t[1] + 0.0722 * t[2]).toFixed(3));
}
function getContrastRatio(e, t) {
  const o = getLuminance(e), n = getLuminance(t);
  return (Math.max(o, n) + 0.05) / (Math.min(o, n) + 0.05);
}
function alpha$1(e, t) {
  return e = decomposeColor(e), t = clampWrapper(t), (e.type === "rgb" || e.type === "hsl") && (e.type += "a"), e.type === "color" ? e.values[3] = `/${t}` : e.values[3] = t, recomposeColor(e);
}
function private_safeAlpha(e, t, o) {
  try {
    return alpha$1(e, t);
  } catch {
    return o && process.env.NODE_ENV !== "production" && console.warn(o), e;
  }
}
function darken(e, t) {
  if (e = decomposeColor(e), t = clampWrapper(t), e.type.includes("hsl"))
    e.values[2] *= 1 - t;
  else if (e.type.includes("rgb") || e.type.includes("color"))
    for (let o = 0; o < 3; o += 1)
      e.values[o] *= 1 - t;
  return recomposeColor(e);
}
function private_safeDarken(e, t, o) {
  try {
    return darken(e, t);
  } catch {
    return o && process.env.NODE_ENV !== "production" && console.warn(o), e;
  }
}
function lighten(e, t) {
  if (e = decomposeColor(e), t = clampWrapper(t), e.type.includes("hsl"))
    e.values[2] += (100 - e.values[2]) * t;
  else if (e.type.includes("rgb"))
    for (let o = 0; o < 3; o += 1)
      e.values[o] += (255 - e.values[o]) * t;
  else if (e.type.includes("color"))
    for (let o = 0; o < 3; o += 1)
      e.values[o] += (1 - e.values[o]) * t;
  return recomposeColor(e);
}
function private_safeLighten(e, t, o) {
  try {
    return lighten(e, t);
  } catch {
    return o && process.env.NODE_ENV !== "production" && console.warn(o), e;
  }
}
function emphasize(e, t = 0.15) {
  return getLuminance(e) > 0.5 ? darken(e, t) : lighten(e, t);
}
function private_safeEmphasize(e, t, o) {
  try {
    return emphasize(e, t);
  } catch {
    return e;
  }
}
const specialProperty = "exact-prop: ​";
function exactProp(e) {
  return process.env.NODE_ENV === "production" ? e : {
    ...e,
    [specialProperty]: (t) => {
      const o = Object.keys(t).filter((n) => !e.hasOwnProperty(n));
      return o.length > 0 ? new Error(`The following props are not supported: ${o.map((n) => `\`${n}\``).join(", ")}. Please remove them.`) : null;
    }
  };
}
const ThemeContext = /* @__PURE__ */ React.createContext(null);
process.env.NODE_ENV !== "production" && (ThemeContext.displayName = "ThemeContext");
function useTheme$1() {
  const e = React.useContext(ThemeContext);
  return process.env.NODE_ENV !== "production" && React.useDebugValue(e), e;
}
const hasSymbol = typeof Symbol == "function" && Symbol.for, nested = hasSymbol ? Symbol.for("mui.nested") : "__THEME_NESTED__";
function mergeOuterLocalTheme(e, t) {
  if (typeof t == "function") {
    const o = t(e);
    return process.env.NODE_ENV !== "production" && (o || console.error(["MUI: You should return an object from your theme function, i.e.", "<ThemeProvider theme={() => ({})} />"].join(`
`))), o;
  }
  return {
    ...e,
    ...t
  };
}
function ThemeProvider$3(e) {
  const {
    children: t,
    theme: o
  } = e, n = useTheme$1();
  process.env.NODE_ENV !== "production" && n === null && typeof o == "function" && console.error(["MUI: You are providing a theme function prop to the ThemeProvider component:", "<ThemeProvider theme={outerTheme => outerTheme} />", "", "However, no outer theme is present.", "Make sure a theme is already injected higher in the React tree or provide a theme object."].join(`
`));
  const s = React.useMemo(() => {
    const i = n === null ? {
      ...o
    } : mergeOuterLocalTheme(n, o);
    return i != null && (i[nested] = n !== null), i;
  }, [o, n]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ThemeContext.Provider, {
    value: s,
    children: t
  });
}
process.env.NODE_ENV !== "production" && (ThemeProvider$3.propTypes = {
  /**
   * Your component tree.
   */
  children: PropTypes.node,
  /**
   * A theme object. You can provide a function to extend the outer theme.
   */
  theme: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired
});
process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "production" && (ThemeProvider$3.propTypes = exactProp(ThemeProvider$3.propTypes));
const RtlContext = /* @__PURE__ */ React.createContext();
function RtlProvider({
  value: e,
  ...t
}) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(RtlContext.Provider, {
    value: e ?? !0,
    ...t
  });
}
process.env.NODE_ENV !== "production" && (RtlProvider.propTypes = {
  children: PropTypes.node,
  value: PropTypes.bool
});
const useRtl = () => React.useContext(RtlContext) ?? !1, PropsContext = /* @__PURE__ */ React.createContext(void 0);
function DefaultPropsProvider({
  value: e,
  children: t
}) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(PropsContext.Provider, {
    value: e,
    children: t
  });
}
process.env.NODE_ENV !== "production" && (DefaultPropsProvider.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  children: PropTypes.node,
  /**
   * @ignore
   */
  value: PropTypes.object
});
function getThemeProps(e) {
  const {
    theme: t,
    name: o,
    props: n
  } = e;
  if (!t || !t.components || !t.components[o])
    return n;
  const s = t.components[o];
  return s.defaultProps ? resolveProps(s.defaultProps, n, t.components.mergeClassNameAndStyle) : !s.styleOverrides && !s.variants ? resolveProps(s, n, t.components.mergeClassNameAndStyle) : n;
}
function useDefaultProps$1({
  props: e,
  name: t
}) {
  const o = React.useContext(PropsContext);
  return getThemeProps({
    props: e,
    name: t,
    theme: {
      components: o
    }
  });
}
let globalId = 0;
function useGlobalId(e) {
  const [t, o] = React.useState(e), n = e || t;
  return React.useEffect(() => {
    t == null && (globalId += 1, o(`mui-${globalId}`));
  }, [t]), n;
}
const safeReact = {
  ...React
}, maybeReactUseId = safeReact.useId;
function useId(e) {
  if (maybeReactUseId !== void 0) {
    const t = maybeReactUseId();
    return e ?? t;
  }
  return useGlobalId(e);
}
function useLayerOrder(e) {
  const t = useTheme$3(), o = useId() || "", {
    modularCssLayers: n
  } = e;
  let s = "mui.global, mui.components, mui.theme, mui.custom, mui.sx";
  return !n || t !== null ? s = "" : typeof n == "string" ? s = n.replace(/mui(?!\.)/g, s) : s = `@layer ${s};`, useEnhancedEffect(() => {
    const i = document.querySelector("head");
    if (!i)
      return;
    const l = i.firstChild;
    if (s) {
      if (l && l.hasAttribute?.("data-mui-layer-order") && l.getAttribute("data-mui-layer-order") === o)
        return;
      const d = document.createElement("style");
      d.setAttribute("data-mui-layer-order", o), d.textContent = s, i.prepend(d);
    } else
      i.querySelector(`style[data-mui-layer-order="${o}"]`)?.remove();
  }, [s, o]), s ? /* @__PURE__ */ jsxRuntimeExports.jsx(GlobalStyles$1, {
    styles: s
  }) : null;
}
const EMPTY_THEME = {};
function useThemeScoping(e, t, o, n = !1) {
  return React.useMemo(() => {
    const s = e && t[e] || t;
    if (typeof o == "function") {
      const i = o(s), l = e ? {
        ...t,
        [e]: i
      } : i;
      return n ? () => l : l;
    }
    return e ? {
      ...t,
      [e]: o
    } : {
      ...t,
      ...o
    };
  }, [e, t, o, n]);
}
function ThemeProvider$2(e) {
  const {
    children: t,
    theme: o,
    themeId: n
  } = e, s = useTheme$3(EMPTY_THEME), i = useTheme$1() || EMPTY_THEME;
  process.env.NODE_ENV !== "production" && (s === null && typeof o == "function" || n && s && !s[n] && typeof o == "function") && console.error(["MUI: You are providing a theme function prop to the ThemeProvider component:", "<ThemeProvider theme={outerTheme => outerTheme} />", "", "However, no outer theme is present.", "Make sure a theme is already injected higher in the React tree or provide a theme object."].join(`
`));
  const l = useThemeScoping(n, s, o), d = useThemeScoping(n, i, o, !0), u = (n ? l[n] : l).direction === "rtl", c = useLayerOrder(l);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ThemeProvider$3, {
    theme: d,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(ThemeContext$1.Provider, {
      value: l,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(RtlProvider, {
        value: u,
        children: /* @__PURE__ */ jsxRuntimeExports.jsxs(DefaultPropsProvider, {
          value: n ? l[n].components : l.components,
          children: [c, t]
        })
      })
    })
  });
}
process.env.NODE_ENV !== "production" && (ThemeProvider$2.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Your component tree.
   */
  children: PropTypes.node,
  /**
   * A theme object. You can provide a function to extend the outer theme.
   */
  theme: PropTypes.oneOfType([PropTypes.func, PropTypes.object]).isRequired,
  /**
   * The design system's unique id for getting the corresponded theme when there are multiple design systems.
   */
  themeId: PropTypes.string
});
process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "production" && (ThemeProvider$2.propTypes = exactProp(ThemeProvider$2.propTypes));
const arg = {
  theme: void 0
};
function unstable_memoTheme(e) {
  let t, o;
  return function(s) {
    let i = t;
    return (i === void 0 || s.theme !== o) && (arg.theme = s.theme, i = preprocessStyles(e(arg)), t = i, o = s.theme), i;
  };
}
const DEFAULT_MODE_STORAGE_KEY = "mode", DEFAULT_COLOR_SCHEME_STORAGE_KEY = "color-scheme", DEFAULT_ATTRIBUTE = "data-color-scheme";
function InitColorSchemeScript(e) {
  const {
    defaultMode: t = "system",
    defaultLightColorScheme: o = "light",
    defaultDarkColorScheme: n = "dark",
    modeStorageKey: s = DEFAULT_MODE_STORAGE_KEY,
    colorSchemeStorageKey: i = DEFAULT_COLOR_SCHEME_STORAGE_KEY,
    attribute: l = DEFAULT_ATTRIBUTE,
    colorSchemeNode: d = "document.documentElement",
    nonce: u
  } = e || {};
  let c = "", p = l;
  if (l === "class" && (p = ".%s"), l === "data" && (p = "[data-%s]"), p.startsWith(".")) {
    const g = p.substring(1);
    c += `${d}.classList.remove('${g}'.replace('%s', light), '${g}'.replace('%s', dark));
      ${d}.classList.add('${g}'.replace('%s', colorScheme));`;
  }
  const f = p.match(/\[([^[\]]+)\]/);
  if (f) {
    const [g, y] = f[1].split("=");
    y || (c += `${d}.removeAttribute('${g}'.replace('%s', light));
      ${d}.removeAttribute('${g}'.replace('%s', dark));`), c += `
      ${d}.setAttribute('${g}'.replace('%s', colorScheme), ${y ? `${y}.replace('%s', colorScheme)` : '""'});`;
  } else
    c += `${d}.setAttribute('${p}', colorScheme);`;
  return /* @__PURE__ */ jsxRuntimeExports.jsx("script", {
    suppressHydrationWarning: !0,
    nonce: typeof window > "u" ? u : "",
    dangerouslySetInnerHTML: {
      __html: `(function() {
try {
  let colorScheme = '';
  const mode = localStorage.getItem('${s}') || '${t}';
  const dark = localStorage.getItem('${i}-dark') || '${n}';
  const light = localStorage.getItem('${i}-light') || '${o}';
  if (mode === 'system') {
    // handle system mode
    const mql = window.matchMedia('(prefers-color-scheme: dark)');
    if (mql.matches) {
      colorScheme = dark
    } else {
      colorScheme = light
    }
  }
  if (mode === 'light') {
    colorScheme = light;
  }
  if (mode === 'dark') {
    colorScheme = dark;
  }
  if (colorScheme) {
    ${c}
  }
} catch(e){}})();`
    }
  }, "mui-color-scheme-init");
}
function noop$7() {
}
const localStorageManager = ({
  key: e,
  storageWindow: t
}) => (!t && typeof window < "u" && (t = window), {
  get(o) {
    if (typeof window > "u")
      return;
    if (!t)
      return o;
    let n;
    try {
      n = t.localStorage.getItem(e);
    } catch {
    }
    return n || o;
  },
  set: (o) => {
    if (t)
      try {
        t.localStorage.setItem(e, o);
      } catch {
      }
  },
  subscribe: (o) => {
    if (!t)
      return noop$7;
    const n = (s) => {
      const i = s.newValue;
      s.key === e && o(i);
    };
    return t.addEventListener("storage", n), () => {
      t.removeEventListener("storage", n);
    };
  }
});
function noop$6() {
}
function getSystemMode(e) {
  if (typeof window < "u" && typeof window.matchMedia == "function" && e === "system")
    return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
}
function processState(e, t) {
  if (e.mode === "light" || e.mode === "system" && e.systemMode === "light")
    return t("light");
  if (e.mode === "dark" || e.mode === "system" && e.systemMode === "dark")
    return t("dark");
}
function getColorScheme(e) {
  return processState(e, (t) => {
    if (t === "light")
      return e.lightColorScheme;
    if (t === "dark")
      return e.darkColorScheme;
  });
}
function useCurrentColorScheme(e) {
  const {
    defaultMode: t = "light",
    defaultLightColorScheme: o,
    defaultDarkColorScheme: n,
    supportedColorSchemes: s = [],
    modeStorageKey: i = DEFAULT_MODE_STORAGE_KEY,
    colorSchemeStorageKey: l = DEFAULT_COLOR_SCHEME_STORAGE_KEY,
    storageWindow: d = typeof window > "u" ? void 0 : window,
    storageManager: u = localStorageManager,
    noSsr: c = !1
  } = e, p = s.join(","), f = s.length > 1, g = React.useMemo(() => u?.({
    key: i,
    storageWindow: d
  }), [u, i, d]), y = React.useMemo(() => u?.({
    key: `${l}-light`,
    storageWindow: d
  }), [u, l, d]), h = React.useMemo(() => u?.({
    key: `${l}-dark`,
    storageWindow: d
  }), [u, l, d]), [T, P] = React.useState(() => {
    const O = g?.get(t) || t, v = y?.get(o) || o, w = h?.get(n) || n;
    return {
      mode: O,
      systemMode: getSystemMode(O),
      lightColorScheme: v,
      darkColorScheme: w
    };
  }), [E, $] = React.useState(c || !f);
  React.useEffect(() => {
    $(!0);
  }, []);
  const R = getColorScheme(T), C = React.useCallback((O) => {
    P((v) => {
      if (O === v.mode)
        return v;
      const w = O ?? t;
      return g?.set(w), {
        ...v,
        mode: w,
        systemMode: getSystemMode(w)
      };
    });
  }, [g, t]), x = React.useCallback((O) => {
    O ? typeof O == "string" ? O && !p.includes(O) ? console.error(`\`${O}\` does not exist in \`theme.colorSchemes\`.`) : P((v) => {
      const w = {
        ...v
      };
      return processState(v, (M) => {
        M === "light" && (y?.set(O), w.lightColorScheme = O), M === "dark" && (h?.set(O), w.darkColorScheme = O);
      }), w;
    }) : P((v) => {
      const w = {
        ...v
      }, M = O.light === null ? o : O.light, S = O.dark === null ? n : O.dark;
      return M && (p.includes(M) ? (w.lightColorScheme = M, y?.set(M)) : console.error(`\`${M}\` does not exist in \`theme.colorSchemes\`.`)), S && (p.includes(S) ? (w.darkColorScheme = S, h?.set(S)) : console.error(`\`${S}\` does not exist in \`theme.colorSchemes\`.`)), w;
    }) : P((v) => (y?.set(o), h?.set(n), {
      ...v,
      lightColorScheme: o,
      darkColorScheme: n
    }));
  }, [p, y, h, o, n]), _ = React.useCallback((O) => {
    T.mode === "system" && P((v) => {
      const w = O?.matches ? "dark" : "light";
      return v.systemMode === w ? v : {
        ...v,
        systemMode: w
      };
    });
  }, [T.mode]), D = React.useRef(_);
  return D.current = _, React.useEffect(() => {
    if (typeof window.matchMedia != "function" || !f)
      return;
    const O = (...w) => D.current(...w), v = window.matchMedia("(prefers-color-scheme: dark)");
    return v.addListener(O), O(v), () => {
      v.removeListener(O);
    };
  }, [f]), React.useEffect(() => {
    if (f) {
      const O = g?.subscribe((M) => {
        (!M || ["light", "dark", "system"].includes(M)) && C(M || t);
      }) || noop$6, v = y?.subscribe((M) => {
        (!M || p.match(M)) && x({
          light: M
        });
      }) || noop$6, w = h?.subscribe((M) => {
        (!M || p.match(M)) && x({
          dark: M
        });
      }) || noop$6;
      return () => {
        O(), v(), w();
      };
    }
  }, [x, C, p, t, d, f, g, y, h]), {
    ...T,
    mode: E ? T.mode : void 0,
    systemMode: E ? T.systemMode : void 0,
    colorScheme: E ? R : void 0,
    setMode: C,
    setColorScheme: x
  };
}
const DISABLE_CSS_TRANSITION = "*{-webkit-transition:none!important;-moz-transition:none!important;-o-transition:none!important;-ms-transition:none!important;transition:none!important}";
function createCssVarsProvider(e) {
  const {
    themeId: t,
    /**
     * This `theme` object needs to follow a certain structure to
     * be used correctly by the finel `CssVarsProvider`. It should have a
     * `colorSchemes` key with the light and dark (and any other) palette.
     * It should also ideally have a vars object created using `prepareCssVars`.
     */
    theme: o = {},
    modeStorageKey: n = DEFAULT_MODE_STORAGE_KEY,
    colorSchemeStorageKey: s = DEFAULT_COLOR_SCHEME_STORAGE_KEY,
    disableTransitionOnChange: i = !1,
    defaultColorScheme: l,
    resolveTheme: d
  } = e, u = {
    allColorSchemes: [],
    colorScheme: void 0,
    darkColorScheme: void 0,
    lightColorScheme: void 0,
    mode: void 0,
    setColorScheme: () => {
    },
    setMode: () => {
    },
    systemMode: void 0
  }, c = /* @__PURE__ */ React.createContext(void 0);
  process.env.NODE_ENV !== "production" && (c.displayName = "ColorSchemeContext");
  const p = () => React.useContext(c) || u, f = {}, g = {};
  function y(E) {
    const {
      children: $,
      theme: R,
      modeStorageKey: C = n,
      colorSchemeStorageKey: x = s,
      disableTransitionOnChange: _ = i,
      storageManager: D,
      storageWindow: O = typeof window > "u" ? void 0 : window,
      documentNode: v = typeof document > "u" ? void 0 : document,
      colorSchemeNode: w = typeof document > "u" ? void 0 : document.documentElement,
      disableNestedContext: M = !1,
      disableStyleSheetGeneration: S = !1,
      defaultMode: I = "system",
      forceThemeRerender: N = !1,
      noSsr: F
    } = E, L = React.useRef(!1), k = useTheme$1(), W = React.useContext(c), V = !!W && !M, j = React.useMemo(() => R || (typeof o == "function" ? o() : o), [R]), A = j[t], U = A || j, {
      colorSchemes: G = f,
      components: Y = g,
      cssVarPrefix: ee
    } = U, J = Object.keys(G).filter((H) => !!G[H]).join(","), Z = React.useMemo(() => J.split(","), [J]), le = typeof l == "string" ? l : l.light, se = typeof l == "string" ? l : l.dark, K = G[le] && G[se] ? I : G[U.defaultColorScheme]?.palette?.mode || U.palette?.mode, {
      mode: q,
      setMode: B,
      systemMode: ue,
      lightColorScheme: re,
      darkColorScheme: be,
      colorScheme: X,
      setColorScheme: ge
    } = useCurrentColorScheme({
      supportedColorSchemes: Z,
      defaultLightColorScheme: le,
      defaultDarkColorScheme: se,
      modeStorageKey: C,
      colorSchemeStorageKey: x,
      defaultMode: K,
      storageManager: D,
      storageWindow: O,
      noSsr: F
    });
    let Ee = q, xe = X;
    V && (Ee = W.mode, xe = W.colorScheme), process.env.NODE_ENV !== "production" && N && !U.vars && console.warn(["MUI: The `forceThemeRerender` prop should only be used with CSS theme variables.", "Note that it will slow down the app when changing between modes, so only do this when you cannot find a better solution."].join(`
`));
    let he = xe || U.defaultColorScheme;
    U.vars && !N && (he = U.defaultColorScheme);
    const Pe = React.useMemo(() => {
      const H = U.generateThemeVars?.() || U.vars, te = {
        ...U,
        components: Y,
        colorSchemes: G,
        cssVarPrefix: ee,
        vars: H
      };
      if (typeof te.generateSpacing == "function" && (te.spacing = te.generateSpacing()), he) {
        const ie = G[he];
        ie && typeof ie == "object" && Object.keys(ie).forEach((ce) => {
          ie[ce] && typeof ie[ce] == "object" ? te[ce] = {
            ...te[ce],
            ...ie[ce]
          } : te[ce] = ie[ce];
        });
      }
      return d ? d(te) : te;
    }, [U, he, Y, G, ee]), ye = U.colorSchemeSelector;
    useEnhancedEffect(() => {
      if (xe && w && ye && ye !== "media") {
        const H = ye;
        let te = ye;
        if (H === "class" && (te = ".%s"), H === "data" && (te = "[data-%s]"), H?.startsWith("data-") && !H.includes("%s") && (te = `[${H}="%s"]`), te.startsWith("."))
          w.classList.remove(...Z.map((ie) => te.substring(1).replace("%s", ie))), w.classList.add(te.substring(1).replace("%s", xe));
        else {
          const ie = te.replace("%s", xe).match(/\[([^\]]+)\]/);
          if (ie) {
            const [ce, me] = ie[1].split("=");
            me || Z.forEach((pe) => {
              w.removeAttribute(ce.replace(xe, pe));
            }), w.setAttribute(ce, me ? me.replace(/"|'/g, "") : "");
          } else
            w.setAttribute(te, xe);
        }
      }
    }, [xe, ye, w, Z]), React.useEffect(() => {
      let H;
      if (_ && L.current && v) {
        const te = v.createElement("style");
        te.appendChild(v.createTextNode(DISABLE_CSS_TRANSITION)), v.head.appendChild(te), window.getComputedStyle(v.body), H = setTimeout(() => {
          v.head.removeChild(te);
        }, 1);
      }
      return () => {
        clearTimeout(H);
      };
    }, [xe, _, v]), React.useEffect(() => (L.current = !0, () => {
      L.current = !1;
    }), []);
    const _e = React.useMemo(() => ({
      allColorSchemes: Z,
      colorScheme: xe,
      darkColorScheme: be,
      lightColorScheme: re,
      mode: Ee,
      setColorScheme: ge,
      setMode: process.env.NODE_ENV === "production" ? B : (H) => {
        Pe.colorSchemeSelector === "media" && console.error(["MUI: The `setMode` function has no effect if `colorSchemeSelector` is `media` (`media` is the default value).", "To toggle the mode manually, please configure `colorSchemeSelector` to use a class or data attribute.", "To learn more, visit https://mui.com/material-ui/customization/css-theme-variables/configuration/#toggling-dark-mode-manually"].join(`
`)), B(H);
      },
      systemMode: ue
    }), [Z, xe, be, re, Ee, ge, B, ue, Pe.colorSchemeSelector]);
    let Ce = !0;
    (S || U.cssVariables === !1 || V && k?.cssVarPrefix === ee) && (Ce = !1);
    const ne = /* @__PURE__ */ jsxRuntimeExports.jsxs(React.Fragment, {
      children: [/* @__PURE__ */ jsxRuntimeExports.jsx(ThemeProvider$2, {
        themeId: A ? t : void 0,
        theme: Pe,
        children: $
      }), Ce && /* @__PURE__ */ jsxRuntimeExports.jsx(GlobalStyles$2, {
        styles: Pe.generateStyleSheets?.() || []
      })]
    });
    return V ? ne : /* @__PURE__ */ jsxRuntimeExports.jsx(c.Provider, {
      value: _e,
      children: ne
    });
  }
  process.env.NODE_ENV !== "production" && (y.propTypes = {
    /**
     * The component tree.
     */
    children: PropTypes.node,
    /**
     * The node used to attach the color-scheme attribute
     */
    colorSchemeNode: PropTypes.any,
    /**
     * localStorage key used to store `colorScheme`
     */
    colorSchemeStorageKey: PropTypes.string,
    /**
     * The default mode when the storage is empty,
     * require the theme to have `colorSchemes` with light and dark.
     */
    defaultMode: PropTypes.string,
    /**
     * If `true`, the provider creates its own context and generate stylesheet as if it is a root `CssVarsProvider`.
     */
    disableNestedContext: PropTypes.bool,
    /**
     * If `true`, the style sheet won't be generated.
     *
     * This is useful for controlling nested CssVarsProvider behavior.
     */
    disableStyleSheetGeneration: PropTypes.bool,
    /**
     * Disable CSS transitions when switching between modes or color schemes.
     */
    disableTransitionOnChange: PropTypes.bool,
    /**
     * The document to attach the attribute to.
     */
    documentNode: PropTypes.any,
    /**
     * If `true`, theme values are recalculated when the mode changes.
     */
    forceThemeRerender: PropTypes.bool,
    /**
     * The key in the local storage used to store current color scheme.
     */
    modeStorageKey: PropTypes.string,
    /**
     * If `true`, the mode will be the same value as the storage without an extra rerendering after the hydration.
     * You should use this option in conjunction with `InitColorSchemeScript` component.
     */
    noSsr: PropTypes.bool,
    /**
     * The storage manager to be used for storing the mode and color scheme
     * @default using `window.localStorage`
     */
    storageManager: PropTypes.func,
    /**
     * The window that attaches the 'storage' event listener.
     * @default window
     */
    storageWindow: PropTypes.any,
    /**
     * The calculated theme object that will be passed through context.
     */
    theme: PropTypes.object
  });
  const h = typeof l == "string" ? l : l.light, T = typeof l == "string" ? l : l.dark;
  return {
    CssVarsProvider: y,
    useColorScheme: p,
    getInitColorSchemeScript: (E) => InitColorSchemeScript({
      colorSchemeStorageKey: s,
      defaultLightColorScheme: h,
      defaultDarkColorScheme: T,
      modeStorageKey: n,
      ...E
    })
  };
}
function createGetCssVar$1(e = "") {
  function t(...n) {
    if (!n.length)
      return "";
    const s = n[0];
    return typeof s == "string" && !s.match(/(#|\(|\)|(-?(\d*\.)?\d+)(px|em|%|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc))|^(-?(\d*\.)?\d+)$|(\d+ \d+ \d+)/) ? `, var(--${e ? `${e}-` : ""}${s}${t(...n.slice(1))})` : `, ${s}`;
  }
  return (n, ...s) => `var(--${e ? `${e}-` : ""}${n}${t(...s)})`;
}
const assignNestedKeys = (e, t, o, n = []) => {
  let s = e;
  t.forEach((i, l) => {
    l === t.length - 1 ? Array.isArray(s) ? s[Number(i)] = o : s && typeof s == "object" && (s[i] = o) : s && typeof s == "object" && (s[i] || (s[i] = n.includes(i) ? [] : {}), s = s[i]);
  });
}, walkObjectDeep = (e, t, o) => {
  function n(s, i = [], l = []) {
    Object.entries(s).forEach(([d, u]) => {
      (!o || o && !o([...i, d])) && u != null && (typeof u == "object" && Object.keys(u).length > 0 ? n(u, [...i, d], Array.isArray(u) ? [...l, d] : l) : t([...i, d], u, l));
    });
  }
  n(e);
}, getCssValue = (e, t) => typeof t == "number" ? ["lineHeight", "fontWeight", "opacity", "zIndex"].some((n) => e.includes(n)) || e[e.length - 1].toLowerCase().includes("opacity") ? t : `${t}px` : t;
function cssVarsParser(e, t) {
  const {
    prefix: o,
    shouldSkipGeneratingVar: n
  } = t || {}, s = {}, i = {}, l = {};
  return walkObjectDeep(
    e,
    (d, u, c) => {
      if ((typeof u == "string" || typeof u == "number") && (!n || !n(d, u))) {
        const p = `--${o ? `${o}-` : ""}${d.join("-")}`, f = getCssValue(d, u);
        Object.assign(s, {
          [p]: f
        }), assignNestedKeys(i, d, `var(${p})`, c), assignNestedKeys(l, d, `var(${p}, ${f})`, c);
      }
    },
    (d) => d[0] === "vars"
    // skip 'vars/*' paths
  ), {
    css: s,
    vars: i,
    varsWithDefaults: l
  };
}
function prepareCssVars(e, t = {}) {
  const {
    getSelector: o = E,
    disableCssColorScheme: n,
    colorSchemeSelector: s,
    enableContrastVars: i
  } = t, {
    colorSchemes: l = {},
    components: d,
    defaultColorScheme: u = "light",
    ...c
  } = e, {
    vars: p,
    css: f,
    varsWithDefaults: g
  } = cssVarsParser(c, t);
  let y = g;
  const h = {}, {
    [u]: T,
    ...P
  } = l;
  if (Object.entries(P || {}).forEach(([C, x]) => {
    const {
      vars: _,
      css: D,
      varsWithDefaults: O
    } = cssVarsParser(x, t);
    y = deepmerge(y, O), h[C] = {
      css: D,
      vars: _
    };
  }), T) {
    const {
      css: C,
      vars: x,
      varsWithDefaults: _
    } = cssVarsParser(T, t);
    y = deepmerge(y, _), h[u] = {
      css: C,
      vars: x
    };
  }
  function E(C, x) {
    let _ = s;
    if (s === "class" && (_ = ".%s"), s === "data" && (_ = "[data-%s]"), s?.startsWith("data-") && !s.includes("%s") && (_ = `[${s}="%s"]`), C) {
      if (_ === "media")
        return e.defaultColorScheme === C ? ":root" : {
          [`@media (prefers-color-scheme: ${l[C]?.palette?.mode || C})`]: {
            ":root": x
          }
        };
      if (_)
        return e.defaultColorScheme === C ? `:root, ${_.replace("%s", String(C))}` : _.replace("%s", String(C));
    }
    return ":root";
  }
  return {
    vars: y,
    generateThemeVars: () => {
      let C = {
        ...p
      };
      return Object.entries(h).forEach(([, {
        vars: x
      }]) => {
        C = deepmerge(C, x);
      }), C;
    },
    generateStyleSheets: () => {
      const C = [], x = e.defaultColorScheme || "light";
      function _(v, w) {
        Object.keys(w).length && C.push(typeof v == "string" ? {
          [v]: {
            ...w
          }
        } : v);
      }
      _(o(void 0, {
        ...f
      }), f);
      const {
        [x]: D,
        ...O
      } = h;
      if (D) {
        const {
          css: v
        } = D, w = l[x]?.palette?.mode, M = !n && w ? {
          colorScheme: w,
          ...v
        } : {
          ...v
        };
        _(o(x, {
          ...M
        }), M);
      }
      return Object.entries(O).forEach(([v, {
        css: w
      }]) => {
        const M = l[v]?.palette?.mode, S = !n && M ? {
          colorScheme: M,
          ...w
        } : {
          ...w
        };
        _(o(v, {
          ...S
        }), S);
      }), i && C.push({
        ":root": {
          // use double underscore to indicate that these are private variables
          "--__l-threshold": "0.7",
          "--__l": "clamp(0, (l / var(--__l-threshold) - 1) * -infinity, 1)",
          "--__a": "clamp(0.87, (l / var(--__l-threshold) - 1) * -infinity, 1)"
          // 0.87 is the default alpha value for black text.
        }
      }), C;
    }
  };
}
function createGetColorSchemeSelector(e) {
  return function(o) {
    return e === "media" ? (process.env.NODE_ENV !== "production" && o !== "light" && o !== "dark" && console.error(`MUI: @media (prefers-color-scheme) supports only 'light' or 'dark', but receive '${o}'.`), `@media (prefers-color-scheme: ${o})`) : e ? e.startsWith("data-") && !e.includes("%s") ? `[${e}="${o}"] &` : e === "class" ? `.${o} &` : e === "data" ? `[data-${o}] &` : `${e.replace("%s", o)} &` : "&";
  };
}
function composeClasses(e, t, o = void 0) {
  const n = {};
  for (const s in e) {
    const i = e[s];
    let l = "", d = !0;
    for (let u = 0; u < i.length; u += 1) {
      const c = i[u];
      c && (l += (d === !0 ? "" : " ") + t(c), d = !1, o && o[c] && (l += " " + o[c]));
    }
    n[s] = l;
  }
  return n;
}
function isMuiElement(e, t) {
  return /* @__PURE__ */ React.isValidElement(e) && t.indexOf(
    // For server components `muiName` is available in element.type._payload.value.muiName
    // relevant info - https://github.com/facebook/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
    // eslint-disable-next-line no-underscore-dangle
    e.type.muiName ?? e.type?._payload?.value?.muiName
  ) !== -1;
}
const common = {
  black: "#000",
  white: "#fff"
}, grey = {
  50: "#fafafa",
  100: "#f5f5f5",
  200: "#eeeeee",
  300: "#e0e0e0",
  400: "#bdbdbd",
  500: "#9e9e9e",
  600: "#757575",
  700: "#616161",
  800: "#424242",
  900: "#212121",
  A100: "#f5f5f5",
  A200: "#eeeeee",
  A400: "#bdbdbd",
  A700: "#616161"
}, purple = {
  50: "#f3e5f5",
  200: "#ce93d8",
  300: "#ba68c8",
  400: "#ab47bc",
  500: "#9c27b0",
  700: "#7b1fa2"
}, red = {
  300: "#e57373",
  400: "#ef5350",
  500: "#f44336",
  700: "#d32f2f",
  800: "#c62828"
}, orange = {
  300: "#ffb74d",
  400: "#ffa726",
  500: "#ff9800",
  700: "#f57c00",
  900: "#e65100"
}, blue = {
  50: "#e3f2fd",
  200: "#90caf9",
  400: "#42a5f5",
  700: "#1976d2",
  800: "#1565c0"
}, lightBlue = {
  300: "#4fc3f7",
  400: "#29b6f6",
  500: "#03a9f4",
  700: "#0288d1",
  900: "#01579b"
}, green = {
  300: "#81c784",
  400: "#66bb6a",
  500: "#4caf50",
  700: "#388e3c",
  800: "#2e7d32",
  900: "#1b5e20"
};
function getLight() {
  return {
    // The colors used to style the text.
    text: {
      // The most important text.
      primary: "rgba(0, 0, 0, 0.87)",
      // Secondary text.
      secondary: "rgba(0, 0, 0, 0.6)",
      // Disabled text have even lower visual prominence.
      disabled: "rgba(0, 0, 0, 0.38)"
    },
    // The color used to divide different elements.
    divider: "rgba(0, 0, 0, 0.12)",
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
      paper: common.white,
      default: common.white
    },
    // The colors used to style the action elements.
    action: {
      // The color of an active action like an icon button.
      active: "rgba(0, 0, 0, 0.54)",
      // The color of an hovered action.
      hover: "rgba(0, 0, 0, 0.04)",
      hoverOpacity: 0.04,
      // The color of a selected action.
      selected: "rgba(0, 0, 0, 0.08)",
      selectedOpacity: 0.08,
      // The color of a disabled action.
      disabled: "rgba(0, 0, 0, 0.26)",
      // The background color of a disabled action.
      disabledBackground: "rgba(0, 0, 0, 0.12)",
      disabledOpacity: 0.38,
      focus: "rgba(0, 0, 0, 0.12)",
      focusOpacity: 0.12,
      activatedOpacity: 0.12
    }
  };
}
const light = getLight();
function getDark() {
  return {
    text: {
      primary: common.white,
      secondary: "rgba(255, 255, 255, 0.7)",
      disabled: "rgba(255, 255, 255, 0.5)",
      icon: "rgba(255, 255, 255, 0.5)"
    },
    divider: "rgba(255, 255, 255, 0.12)",
    background: {
      paper: "#121212",
      default: "#121212"
    },
    action: {
      active: common.white,
      hover: "rgba(255, 255, 255, 0.08)",
      hoverOpacity: 0.08,
      selected: "rgba(255, 255, 255, 0.16)",
      selectedOpacity: 0.16,
      disabled: "rgba(255, 255, 255, 0.3)",
      disabledBackground: "rgba(255, 255, 255, 0.12)",
      disabledOpacity: 0.38,
      focus: "rgba(255, 255, 255, 0.12)",
      focusOpacity: 0.12,
      activatedOpacity: 0.24
    }
  };
}
const dark = getDark();
function addLightOrDark(e, t, o, n) {
  const s = n.light || n, i = n.dark || n * 1.5;
  e[t] || (e.hasOwnProperty(o) ? e[t] = e[o] : t === "light" ? e.light = lighten(e.main, s) : t === "dark" && (e.dark = darken(e.main, i)));
}
function mixLightOrDark(e, t, o, n, s) {
  const i = s.light || s, l = s.dark || s * 1.5;
  t[o] || (t.hasOwnProperty(n) ? t[o] = t[n] : o === "light" ? t.light = `color-mix(in ${e}, ${t.main}, #fff ${(i * 100).toFixed(0)}%)` : o === "dark" && (t.dark = `color-mix(in ${e}, ${t.main}, #000 ${(l * 100).toFixed(0)}%)`));
}
function getDefaultPrimary(e = "light") {
  return e === "dark" ? {
    main: blue[200],
    light: blue[50],
    dark: blue[400]
  } : {
    main: blue[700],
    light: blue[400],
    dark: blue[800]
  };
}
function getDefaultSecondary(e = "light") {
  return e === "dark" ? {
    main: purple[200],
    light: purple[50],
    dark: purple[400]
  } : {
    main: purple[500],
    light: purple[300],
    dark: purple[700]
  };
}
function getDefaultError(e = "light") {
  return e === "dark" ? {
    main: red[500],
    light: red[300],
    dark: red[700]
  } : {
    main: red[700],
    light: red[400],
    dark: red[800]
  };
}
function getDefaultInfo(e = "light") {
  return e === "dark" ? {
    main: lightBlue[400],
    light: lightBlue[300],
    dark: lightBlue[700]
  } : {
    main: lightBlue[700],
    light: lightBlue[500],
    dark: lightBlue[900]
  };
}
function getDefaultSuccess(e = "light") {
  return e === "dark" ? {
    main: green[400],
    light: green[300],
    dark: green[700]
  } : {
    main: green[800],
    light: green[500],
    dark: green[900]
  };
}
function getDefaultWarning(e = "light") {
  return e === "dark" ? {
    main: orange[400],
    light: orange[300],
    dark: orange[700]
  } : {
    main: "#ed6c02",
    // closest to orange[800] that pass 3:1.
    light: orange[500],
    dark: orange[900]
  };
}
function contrastColor(e) {
  return `oklch(from ${e} var(--__l) 0 h / var(--__a))`;
}
function createPalette(e) {
  const {
    mode: t = "light",
    contrastThreshold: o = 3,
    tonalOffset: n = 0.2,
    colorSpace: s,
    ...i
  } = e, l = e.primary || getDefaultPrimary(t), d = e.secondary || getDefaultSecondary(t), u = e.error || getDefaultError(t), c = e.info || getDefaultInfo(t), p = e.success || getDefaultSuccess(t), f = e.warning || getDefaultWarning(t);
  function g(P) {
    if (s)
      return contrastColor(P);
    const E = getContrastRatio(P, dark.text.primary) >= o ? dark.text.primary : light.text.primary;
    if (process.env.NODE_ENV !== "production") {
      const $ = getContrastRatio(P, E);
      $ < 3 && console.error([`MUI: The contrast ratio of ${$}:1 for ${E} on ${P}`, "falls below the WCAG recommended absolute minimum contrast ratio of 3:1.", "https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast"].join(`
`));
    }
    return E;
  }
  const y = ({
    color: P,
    name: E,
    mainShade: $ = 500,
    lightShade: R = 300,
    darkShade: C = 700
  }) => {
    if (P = {
      ...P
    }, !P.main && P[$] && (P.main = P[$]), !P.hasOwnProperty("main"))
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The color${E ? ` (${E})` : ""} provided to augmentColor(color) is invalid.
The color object needs to have a \`main\` property or a \`${$}\` property.` : formatMuiErrorMessage(11, E ? ` (${E})` : "", $));
    if (typeof P.main != "string")
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The color${E ? ` (${E})` : ""} provided to augmentColor(color) is invalid.
\`color.main\` should be a string, but \`${JSON.stringify(P.main)}\` was provided instead.

Did you intend to use one of the following approaches?

import { green } from "@mui/material/colors";

const theme1 = createTheme({ palette: {
  primary: green,
} });

const theme2 = createTheme({ palette: {
  primary: { main: green[500] },
} });` : formatMuiErrorMessage(12, E ? ` (${E})` : "", JSON.stringify(P.main)));
    return s ? (mixLightOrDark(s, P, "light", R, n), mixLightOrDark(s, P, "dark", C, n)) : (addLightOrDark(P, "light", R, n), addLightOrDark(P, "dark", C, n)), P.contrastText || (P.contrastText = g(P.main)), P;
  };
  let h;
  return t === "light" ? h = getLight() : t === "dark" && (h = getDark()), process.env.NODE_ENV !== "production" && (h || console.error(`MUI: The palette mode \`${t}\` is not supported.`)), deepmerge({
    // A collection of common colors.
    common: {
      ...common
    },
    // prevent mutable object.
    // The palette mode, can be light or dark.
    mode: t,
    // The colors used to represent primary interface elements for a user.
    primary: y({
      color: l,
      name: "primary"
    }),
    // The colors used to represent secondary interface elements for a user.
    secondary: y({
      color: d,
      name: "secondary",
      mainShade: "A400",
      lightShade: "A200",
      darkShade: "A700"
    }),
    // The colors used to represent interface elements that the user should be made aware of.
    error: y({
      color: u,
      name: "error"
    }),
    // The colors used to represent potentially dangerous actions or important messages.
    warning: y({
      color: f,
      name: "warning"
    }),
    // The colors used to present information to the user that is neutral and not necessarily important.
    info: y({
      color: c,
      name: "info"
    }),
    // The colors used to indicate the successful completion of an action that user triggered.
    success: y({
      color: p,
      name: "success"
    }),
    // The grey colors.
    grey,
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: o,
    // Takes a background color and returns the text color that maximizes the contrast.
    getContrastText: g,
    // Generate a rich color object.
    augmentColor: y,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: n,
    // The light and dark mode object.
    ...h
  }, i);
}
function prepareTypographyVars(e) {
  const t = {};
  return Object.entries(e).forEach((n) => {
    const [s, i] = n;
    typeof i == "object" && (t[s] = `${i.fontStyle ? `${i.fontStyle} ` : ""}${i.fontVariant ? `${i.fontVariant} ` : ""}${i.fontWeight ? `${i.fontWeight} ` : ""}${i.fontStretch ? `${i.fontStretch} ` : ""}${i.fontSize || ""}${i.lineHeight ? `/${i.lineHeight} ` : ""}${i.fontFamily || ""}`);
  }), t;
}
function createMixins(e, t) {
  return {
    toolbar: {
      minHeight: 56,
      [e.up("xs")]: {
        "@media (orientation: landscape)": {
          minHeight: 48
        }
      },
      [e.up("sm")]: {
        minHeight: 64
      }
    },
    ...t
  };
}
function round$2(e) {
  return Math.round(e * 1e5) / 1e5;
}
const caseAllCaps = {
  textTransform: "uppercase"
}, defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function createTypography(e, t) {
  const {
    fontFamily: o = defaultFontFamily,
    // The default font size of the Material Specification.
    fontSize: n = 14,
    // px
    fontWeightLight: s = 300,
    fontWeightRegular: i = 400,
    fontWeightMedium: l = 500,
    fontWeightBold: d = 700,
    // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize: u = 16,
    // Apply the CSS properties to all the variants.
    allVariants: c,
    pxToRem: p,
    ...f
  } = typeof t == "function" ? t(e) : t;
  process.env.NODE_ENV !== "production" && (typeof n != "number" && console.error("MUI: `fontSize` is required to be a number."), typeof u != "number" && console.error("MUI: `htmlFontSize` is required to be a number."));
  const g = n / 14, y = p || ((P) => `${P / u * g}rem`), h = (P, E, $, R, C) => ({
    fontFamily: o,
    fontWeight: P,
    fontSize: y(E),
    // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
    lineHeight: $,
    // The letter spacing was designed for the Roboto font-family. Using the same letter-spacing
    // across font-families can cause issues with the kerning.
    ...o === defaultFontFamily ? {
      letterSpacing: `${round$2(R / E)}em`
    } : {},
    ...C,
    ...c
  }), T = {
    h1: h(s, 96, 1.167, -1.5),
    h2: h(s, 60, 1.2, -0.5),
    h3: h(i, 48, 1.167, 0),
    h4: h(i, 34, 1.235, 0.25),
    h5: h(i, 24, 1.334, 0),
    h6: h(l, 20, 1.6, 0.15),
    subtitle1: h(i, 16, 1.75, 0.15),
    subtitle2: h(l, 14, 1.57, 0.1),
    body1: h(i, 16, 1.5, 0.15),
    body2: h(i, 14, 1.43, 0.15),
    button: h(l, 14, 1.75, 0.4, caseAllCaps),
    caption: h(i, 12, 1.66, 0.4),
    overline: h(i, 12, 2.66, 1, caseAllCaps),
    // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
    inherit: {
      fontFamily: "inherit",
      fontWeight: "inherit",
      fontSize: "inherit",
      lineHeight: "inherit",
      letterSpacing: "inherit"
    }
  };
  return deepmerge({
    htmlFontSize: u,
    pxToRem: y,
    fontFamily: o,
    fontSize: n,
    fontWeightLight: s,
    fontWeightRegular: i,
    fontWeightMedium: l,
    fontWeightBold: d,
    ...T
  }, f, {
    clone: !1
    // No need to clone deep
  });
}
const shadowKeyUmbraOpacity = 0.2, shadowKeyPenumbraOpacity = 0.14, shadowAmbientShadowOpacity = 0.12;
function createShadow$1(...e) {
  return [`${e[0]}px ${e[1]}px ${e[2]}px ${e[3]}px rgba(0,0,0,${shadowKeyUmbraOpacity})`, `${e[4]}px ${e[5]}px ${e[6]}px ${e[7]}px rgba(0,0,0,${shadowKeyPenumbraOpacity})`, `${e[8]}px ${e[9]}px ${e[10]}px ${e[11]}px rgba(0,0,0,${shadowAmbientShadowOpacity})`].join(",");
}
const shadows$1 = ["none", createShadow$1(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), createShadow$1(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), createShadow$1(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), createShadow$1(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), createShadow$1(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), createShadow$1(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), createShadow$1(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), createShadow$1(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), createShadow$1(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), createShadow$1(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), createShadow$1(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), createShadow$1(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), createShadow$1(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), createShadow$1(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), createShadow$1(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), createShadow$1(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), createShadow$1(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), createShadow$1(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), createShadow$1(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), createShadow$1(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), createShadow$1(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), createShadow$1(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), createShadow$1(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), createShadow$1(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)], easing = {
  // This is the most common easing curve.
  easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: "cubic-bezier(0.4, 0, 1, 1)",
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
}, duration = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};
function formatMs(e) {
  return `${Math.round(e)}ms`;
}
function getAutoHeightDuration(e) {
  if (!e)
    return 0;
  const t = e / 36;
  return Math.min(Math.round((4 + 15 * t ** 0.25 + t / 5) * 10), 3e3);
}
function createTransitions(e) {
  const t = {
    ...easing,
    ...e.easing
  }, o = {
    ...duration,
    ...e.duration
  };
  return {
    getAutoHeightDuration,
    create: (s = ["all"], i = {}) => {
      const {
        duration: l = o.standard,
        easing: d = t.easeInOut,
        delay: u = 0,
        ...c
      } = i;
      if (process.env.NODE_ENV !== "production") {
        const p = (g) => typeof g == "string", f = (g) => !Number.isNaN(parseFloat(g));
        !p(s) && !Array.isArray(s) && console.error('MUI: Argument "props" must be a string or Array.'), !f(l) && !p(l) && console.error(`MUI: Argument "duration" must be a number or a string but found ${l}.`), p(d) || console.error('MUI: Argument "easing" must be a string.'), !f(u) && !p(u) && console.error('MUI: Argument "delay" must be a number or a string.'), typeof i != "object" && console.error(["MUI: Secong argument of transition.create must be an object.", "Arguments should be either `create('prop1', options)` or `create(['prop1', 'prop2'], options)`"].join(`
`)), Object.keys(c).length !== 0 && console.error(`MUI: Unrecognized argument(s) [${Object.keys(c).join(",")}].`);
      }
      return (Array.isArray(s) ? s : [s]).map((p) => `${p} ${typeof l == "string" ? l : formatMs(l)} ${d} ${typeof u == "string" ? u : formatMs(u)}`).join(",");
    },
    ...e,
    easing: t,
    duration: o
  };
}
const zIndex = {
  mobileStepper: 1e3,
  fab: 1050,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
};
function isSerializable(e) {
  return isPlainObject$1(e) || typeof e > "u" || typeof e == "string" || typeof e == "boolean" || typeof e == "number" || Array.isArray(e);
}
function stringifyTheme(e = {}) {
  const t = {
    ...e
  };
  function o(n) {
    const s = Object.entries(n);
    for (let i = 0; i < s.length; i++) {
      const [l, d] = s[i];
      !isSerializable(d) || l.startsWith("unstable_") ? delete n[l] : isPlainObject$1(d) && (n[l] = {
        ...d
      }, o(n[l]));
    }
  }
  return o(t), `import { unstable_createBreakpoints as createBreakpoints, createTransitions } from '@mui/material/styles';

const theme = ${JSON.stringify(t, null, 2)};

theme.breakpoints = createBreakpoints(theme.breakpoints || {});
theme.transitions = createTransitions(theme.transitions || {});

export default theme;`;
}
function coefficientToPercentage(e) {
  return typeof e == "number" ? `${(e * 100).toFixed(0)}%` : `calc((${e}) * 100%)`;
}
const parseAddition = (e) => {
  if (!Number.isNaN(+e))
    return +e;
  const t = e.match(/\d*\.?\d+/g);
  if (!t)
    return 0;
  let o = 0;
  for (let n = 0; n < t.length; n += 1)
    o += +t[n];
  return o;
};
function attachColorManipulators(e) {
  Object.assign(e, {
    alpha(t, o) {
      const n = this || e;
      return n.colorSpace ? `oklch(from ${t} l c h / ${typeof o == "string" ? `calc(${o})` : o})` : n.vars ? `rgba(${t.replace(/var\(--([^,\s)]+)(?:,[^)]+)?\)+/g, "var(--$1Channel)")} / ${typeof o == "string" ? `calc(${o})` : o})` : alpha$1(t, parseAddition(o));
    },
    lighten(t, o) {
      const n = this || e;
      return n.colorSpace ? `color-mix(in ${n.colorSpace}, ${t}, #fff ${coefficientToPercentage(o)})` : lighten(t, o);
    },
    darken(t, o) {
      const n = this || e;
      return n.colorSpace ? `color-mix(in ${n.colorSpace}, ${t}, #000 ${coefficientToPercentage(o)})` : darken(t, o);
    }
  });
}
function createThemeNoVars(e = {}, ...t) {
  const {
    breakpoints: o,
    mixins: n = {},
    spacing: s,
    palette: i = {},
    transitions: l = {},
    typography: d = {},
    shape: u,
    colorSpace: c,
    ...p
  } = e;
  if (e.vars && // The error should throw only for the root theme creation because user is not allowed to use a custom node `vars`.
  // `generateThemeVars` is the closest identifier for checking that the `options` is a result of `createTheme` with CSS variables so that user can create new theme for nested ThemeProvider.
  e.generateThemeVars === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "MUI: `vars` is a private field used for CSS variables support.\nPlease use another name or follow the [docs](https://mui.com/material-ui/customization/css-theme-variables/usage/) to enable the feature." : formatMuiErrorMessage(20));
  const f = createPalette({
    ...i,
    colorSpace: c
  }), g = createTheme$1(e);
  let y = deepmerge(g, {
    mixins: createMixins(g.breakpoints, n),
    palette: f,
    // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
    shadows: shadows$1.slice(),
    typography: createTypography(f, d),
    transitions: createTransitions(l),
    zIndex: {
      ...zIndex
    }
  });
  if (y = deepmerge(y, p), y = t.reduce((h, T) => deepmerge(h, T), y), process.env.NODE_ENV !== "production") {
    const h = ["active", "checked", "completed", "disabled", "error", "expanded", "focused", "focusVisible", "required", "selected"], T = (P, E) => {
      let $;
      for ($ in P) {
        const R = P[$];
        if (h.includes($) && Object.keys(R).length > 0) {
          if (process.env.NODE_ENV !== "production") {
            const C = generateUtilityClass("", $);
            console.error([`MUI: The \`${E}\` component increases the CSS specificity of the \`${$}\` internal state.`, "You can not override it like this: ", JSON.stringify(P, null, 2), "", `Instead, you need to use the '&.${C}' syntax:`, JSON.stringify({
              root: {
                [`&.${C}`]: R
              }
            }, null, 2), "", "https://mui.com/r/state-classes-guide"].join(`
`));
          }
          P[$] = {};
        }
      }
    };
    Object.keys(y.components).forEach((P) => {
      const E = y.components[P].styleOverrides;
      E && P.startsWith("Mui") && T(E, P);
    });
  }
  return y.unstable_sxConfig = {
    ...defaultSxConfig,
    ...p?.unstable_sxConfig
  }, y.unstable_sx = function(T) {
    return styleFunctionSx({
      sx: T,
      theme: this
    });
  }, y.toRuntimeSource = stringifyTheme, attachColorManipulators(y), y;
}
function getOverlayAlpha(e) {
  let t;
  return e < 1 ? t = 5.11916 * e ** 2 : t = 4.5 * Math.log(e + 1) + 2, Math.round(t * 10) / 1e3;
}
const defaultDarkOverlays = [...Array(25)].map((e, t) => {
  if (t === 0)
    return "none";
  const o = getOverlayAlpha(t);
  return `linear-gradient(rgba(255 255 255 / ${o}), rgba(255 255 255 / ${o}))`;
});
function getOpacity(e) {
  return {
    inputPlaceholder: e === "dark" ? 0.5 : 0.42,
    inputUnderline: e === "dark" ? 0.7 : 0.42,
    switchTrackDisabled: e === "dark" ? 0.2 : 0.12,
    switchTrack: e === "dark" ? 0.3 : 0.38
  };
}
function getOverlays(e) {
  return e === "dark" ? defaultDarkOverlays : [];
}
function createColorScheme(e) {
  const {
    palette: t = {
      mode: "light"
    },
    // need to cast to avoid module augmentation test
    opacity: o,
    overlays: n,
    colorSpace: s,
    ...i
  } = e, l = createPalette({
    ...t,
    colorSpace: s
  });
  return {
    palette: l,
    opacity: {
      ...getOpacity(l.mode),
      ...o
    },
    overlays: n || getOverlays(l.mode),
    ...i
  };
}
function shouldSkipGeneratingVar(e) {
  return !!e[0].match(/(cssVarPrefix|colorSchemeSelector|modularCssLayers|rootSelector|typography|mixins|breakpoints|direction|transitions)/) || !!e[0].match(/sxConfig$/) || // ends with sxConfig
  e[0] === "palette" && !!e[1]?.match(/(mode|contrastThreshold|tonalOffset)/);
}
const excludeVariablesFromRoot = (e) => [...[...Array(25)].map((t, o) => `--${e ? `${e}-` : ""}overlays-${o}`), `--${e ? `${e}-` : ""}palette-AppBar-darkBg`, `--${e ? `${e}-` : ""}palette-AppBar-darkColor`], defaultGetSelector = (e) => (t, o) => {
  const n = e.rootSelector || ":root", s = e.colorSchemeSelector;
  let i = s;
  if (s === "class" && (i = ".%s"), s === "data" && (i = "[data-%s]"), s?.startsWith("data-") && !s.includes("%s") && (i = `[${s}="%s"]`), e.defaultColorScheme === t) {
    if (t === "dark") {
      const l = {};
      return excludeVariablesFromRoot(e.cssVarPrefix).forEach((d) => {
        l[d] = o[d], delete o[d];
      }), i === "media" ? {
        [n]: o,
        "@media (prefers-color-scheme: dark)": {
          [n]: l
        }
      } : i ? {
        [i.replace("%s", t)]: l,
        [`${n}, ${i.replace("%s", t)}`]: o
      } : {
        [n]: {
          ...o,
          ...l
        }
      };
    }
    if (i && i !== "media")
      return `${n}, ${i.replace("%s", String(t))}`;
  } else if (t) {
    if (i === "media")
      return {
        [`@media (prefers-color-scheme: ${String(t)})`]: {
          [n]: o
        }
      };
    if (i)
      return i.replace("%s", String(t));
  }
  return n;
};
function assignNode(e, t) {
  t.forEach((o) => {
    e[o] || (e[o] = {});
  });
}
function setColor(e, t, o) {
  !e[t] && o && (e[t] = o);
}
function toRgb(e) {
  return typeof e != "string" || !e.startsWith("hsl") ? e : hslToRgb(e);
}
function setColorChannel(e, t) {
  `${t}Channel` in e || (e[`${t}Channel`] = private_safeColorChannel(toRgb(e[t]), `MUI: Can't create \`palette.${t}Channel\` because \`palette.${t}\` is not one of these formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().
To suppress this warning, you need to explicitly provide the \`palette.${t}Channel\` as a string (in rgb format, for example "12 12 12") or undefined if you want to remove the channel token.`));
}
function getSpacingVal(e) {
  return typeof e == "number" ? `${e}px` : typeof e == "string" || typeof e == "function" || Array.isArray(e) ? e : "8px";
}
const silent = (e) => {
  try {
    return e();
  } catch {
  }
}, createGetCssVar = (e = "mui") => createGetCssVar$1(e);
function attachColorScheme$1(e, t, o, n, s) {
  if (!o)
    return;
  o = o === !0 ? {} : o;
  const i = s === "dark" ? "dark" : "light";
  if (!n) {
    t[s] = createColorScheme({
      ...o,
      palette: {
        mode: i,
        ...o?.palette
      },
      colorSpace: e
    });
    return;
  }
  const {
    palette: l,
    ...d
  } = createThemeNoVars({
    ...n,
    palette: {
      mode: i,
      ...o?.palette
    },
    colorSpace: e
  });
  return t[s] = {
    ...o,
    palette: l,
    opacity: {
      ...getOpacity(i),
      ...o?.opacity
    },
    overlays: o?.overlays || getOverlays(i)
  }, d;
}
function createThemeWithVars(e = {}, ...t) {
  const {
    colorSchemes: o = {
      light: !0
    },
    defaultColorScheme: n,
    disableCssColorScheme: s = !1,
    cssVarPrefix: i = "mui",
    nativeColor: l = !1,
    shouldSkipGeneratingVar: d = shouldSkipGeneratingVar,
    colorSchemeSelector: u = o.light && o.dark ? "media" : void 0,
    rootSelector: c = ":root",
    ...p
  } = e, f = Object.keys(o)[0], g = n || (o.light && f !== "light" ? "light" : f), y = createGetCssVar(i), {
    [g]: h,
    light: T,
    dark: P,
    ...E
  } = o, $ = {
    ...E
  };
  let R = h;
  if ((g === "dark" && !("dark" in o) || g === "light" && !("light" in o)) && (R = !0), !R)
    throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The \`colorSchemes.${g}\` option is either missing or invalid.` : formatMuiErrorMessage(21, g));
  let C;
  l && (C = "oklch");
  const x = attachColorScheme$1(C, $, R, p, g);
  T && !$.light && attachColorScheme$1(C, $, T, void 0, "light"), P && !$.dark && attachColorScheme$1(C, $, P, void 0, "dark");
  let _ = {
    defaultColorScheme: g,
    ...x,
    cssVarPrefix: i,
    colorSchemeSelector: u,
    rootSelector: c,
    getCssVar: y,
    colorSchemes: $,
    font: {
      ...prepareTypographyVars(x.typography),
      ...x.font
    },
    spacing: getSpacingVal(p.spacing)
  };
  Object.keys(_.colorSchemes).forEach((M) => {
    const S = _.colorSchemes[M].palette, I = (F) => {
      const L = F.split("-"), k = L[1], W = L[2];
      return y(F, S[k][W]);
    };
    S.mode === "light" && (setColor(S.common, "background", "#fff"), setColor(S.common, "onBackground", "#000")), S.mode === "dark" && (setColor(S.common, "background", "#000"), setColor(S.common, "onBackground", "#fff"));
    function N(F, L, k) {
      if (C) {
        let W;
        return F === private_safeAlpha && (W = `transparent ${((1 - k) * 100).toFixed(0)}%`), F === private_safeDarken && (W = `#000 ${(k * 100).toFixed(0)}%`), F === private_safeLighten && (W = `#fff ${(k * 100).toFixed(0)}%`), `color-mix(in ${C}, ${L}, ${W})`;
      }
      return F(L, k);
    }
    if (assignNode(S, ["Alert", "AppBar", "Avatar", "Button", "Chip", "FilledInput", "LinearProgress", "Skeleton", "Slider", "SnackbarContent", "SpeedDialAction", "StepConnector", "StepContent", "Switch", "TableCell", "Tooltip"]), S.mode === "light") {
      setColor(S.Alert, "errorColor", N(private_safeDarken, S.error.light, 0.6)), setColor(S.Alert, "infoColor", N(private_safeDarken, S.info.light, 0.6)), setColor(S.Alert, "successColor", N(private_safeDarken, S.success.light, 0.6)), setColor(S.Alert, "warningColor", N(private_safeDarken, S.warning.light, 0.6)), setColor(S.Alert, "errorFilledBg", I("palette-error-main")), setColor(S.Alert, "infoFilledBg", I("palette-info-main")), setColor(S.Alert, "successFilledBg", I("palette-success-main")), setColor(S.Alert, "warningFilledBg", I("palette-warning-main")), setColor(S.Alert, "errorFilledColor", silent(() => S.getContrastText(S.error.main))), setColor(S.Alert, "infoFilledColor", silent(() => S.getContrastText(S.info.main))), setColor(S.Alert, "successFilledColor", silent(() => S.getContrastText(S.success.main))), setColor(S.Alert, "warningFilledColor", silent(() => S.getContrastText(S.warning.main))), setColor(S.Alert, "errorStandardBg", N(private_safeLighten, S.error.light, 0.9)), setColor(S.Alert, "infoStandardBg", N(private_safeLighten, S.info.light, 0.9)), setColor(S.Alert, "successStandardBg", N(private_safeLighten, S.success.light, 0.9)), setColor(S.Alert, "warningStandardBg", N(private_safeLighten, S.warning.light, 0.9)), setColor(S.Alert, "errorIconColor", I("palette-error-main")), setColor(S.Alert, "infoIconColor", I("palette-info-main")), setColor(S.Alert, "successIconColor", I("palette-success-main")), setColor(S.Alert, "warningIconColor", I("palette-warning-main")), setColor(S.AppBar, "defaultBg", I("palette-grey-100")), setColor(S.Avatar, "defaultBg", I("palette-grey-400")), setColor(S.Button, "inheritContainedBg", I("palette-grey-300")), setColor(S.Button, "inheritContainedHoverBg", I("palette-grey-A100")), setColor(S.Chip, "defaultBorder", I("palette-grey-400")), setColor(S.Chip, "defaultAvatarColor", I("palette-grey-700")), setColor(S.Chip, "defaultIconColor", I("palette-grey-700")), setColor(S.FilledInput, "bg", "rgba(0, 0, 0, 0.06)"), setColor(S.FilledInput, "hoverBg", "rgba(0, 0, 0, 0.09)"), setColor(S.FilledInput, "disabledBg", "rgba(0, 0, 0, 0.12)"), setColor(S.LinearProgress, "primaryBg", N(private_safeLighten, S.primary.main, 0.62)), setColor(S.LinearProgress, "secondaryBg", N(private_safeLighten, S.secondary.main, 0.62)), setColor(S.LinearProgress, "errorBg", N(private_safeLighten, S.error.main, 0.62)), setColor(S.LinearProgress, "infoBg", N(private_safeLighten, S.info.main, 0.62)), setColor(S.LinearProgress, "successBg", N(private_safeLighten, S.success.main, 0.62)), setColor(S.LinearProgress, "warningBg", N(private_safeLighten, S.warning.main, 0.62)), setColor(S.Skeleton, "bg", C ? N(private_safeAlpha, S.text.primary, 0.11) : `rgba(${I("palette-text-primaryChannel")} / 0.11)`), setColor(S.Slider, "primaryTrack", N(private_safeLighten, S.primary.main, 0.62)), setColor(S.Slider, "secondaryTrack", N(private_safeLighten, S.secondary.main, 0.62)), setColor(S.Slider, "errorTrack", N(private_safeLighten, S.error.main, 0.62)), setColor(S.Slider, "infoTrack", N(private_safeLighten, S.info.main, 0.62)), setColor(S.Slider, "successTrack", N(private_safeLighten, S.success.main, 0.62)), setColor(S.Slider, "warningTrack", N(private_safeLighten, S.warning.main, 0.62));
      const F = C ? N(private_safeDarken, S.background.default, 0.6825) : private_safeEmphasize(S.background.default, 0.8);
      setColor(S.SnackbarContent, "bg", F), setColor(S.SnackbarContent, "color", silent(() => C ? dark.text.primary : S.getContrastText(F))), setColor(S.SpeedDialAction, "fabHoverBg", private_safeEmphasize(S.background.paper, 0.15)), setColor(S.StepConnector, "border", I("palette-grey-400")), setColor(S.StepContent, "border", I("palette-grey-400")), setColor(S.Switch, "defaultColor", I("palette-common-white")), setColor(S.Switch, "defaultDisabledColor", I("palette-grey-100")), setColor(S.Switch, "primaryDisabledColor", N(private_safeLighten, S.primary.main, 0.62)), setColor(S.Switch, "secondaryDisabledColor", N(private_safeLighten, S.secondary.main, 0.62)), setColor(S.Switch, "errorDisabledColor", N(private_safeLighten, S.error.main, 0.62)), setColor(S.Switch, "infoDisabledColor", N(private_safeLighten, S.info.main, 0.62)), setColor(S.Switch, "successDisabledColor", N(private_safeLighten, S.success.main, 0.62)), setColor(S.Switch, "warningDisabledColor", N(private_safeLighten, S.warning.main, 0.62)), setColor(S.TableCell, "border", N(private_safeLighten, N(private_safeAlpha, S.divider, 1), 0.88)), setColor(S.Tooltip, "bg", N(private_safeAlpha, S.grey[700], 0.92));
    }
    if (S.mode === "dark") {
      setColor(S.Alert, "errorColor", N(private_safeLighten, S.error.light, 0.6)), setColor(S.Alert, "infoColor", N(private_safeLighten, S.info.light, 0.6)), setColor(S.Alert, "successColor", N(private_safeLighten, S.success.light, 0.6)), setColor(S.Alert, "warningColor", N(private_safeLighten, S.warning.light, 0.6)), setColor(S.Alert, "errorFilledBg", I("palette-error-dark")), setColor(S.Alert, "infoFilledBg", I("palette-info-dark")), setColor(S.Alert, "successFilledBg", I("palette-success-dark")), setColor(S.Alert, "warningFilledBg", I("palette-warning-dark")), setColor(S.Alert, "errorFilledColor", silent(() => S.getContrastText(S.error.dark))), setColor(S.Alert, "infoFilledColor", silent(() => S.getContrastText(S.info.dark))), setColor(S.Alert, "successFilledColor", silent(() => S.getContrastText(S.success.dark))), setColor(S.Alert, "warningFilledColor", silent(() => S.getContrastText(S.warning.dark))), setColor(S.Alert, "errorStandardBg", N(private_safeDarken, S.error.light, 0.9)), setColor(S.Alert, "infoStandardBg", N(private_safeDarken, S.info.light, 0.9)), setColor(S.Alert, "successStandardBg", N(private_safeDarken, S.success.light, 0.9)), setColor(S.Alert, "warningStandardBg", N(private_safeDarken, S.warning.light, 0.9)), setColor(S.Alert, "errorIconColor", I("palette-error-main")), setColor(S.Alert, "infoIconColor", I("palette-info-main")), setColor(S.Alert, "successIconColor", I("palette-success-main")), setColor(S.Alert, "warningIconColor", I("palette-warning-main")), setColor(S.AppBar, "defaultBg", I("palette-grey-900")), setColor(S.AppBar, "darkBg", I("palette-background-paper")), setColor(S.AppBar, "darkColor", I("palette-text-primary")), setColor(S.Avatar, "defaultBg", I("palette-grey-600")), setColor(S.Button, "inheritContainedBg", I("palette-grey-800")), setColor(S.Button, "inheritContainedHoverBg", I("palette-grey-700")), setColor(S.Chip, "defaultBorder", I("palette-grey-700")), setColor(S.Chip, "defaultAvatarColor", I("palette-grey-300")), setColor(S.Chip, "defaultIconColor", I("palette-grey-300")), setColor(S.FilledInput, "bg", "rgba(255, 255, 255, 0.09)"), setColor(S.FilledInput, "hoverBg", "rgba(255, 255, 255, 0.13)"), setColor(S.FilledInput, "disabledBg", "rgba(255, 255, 255, 0.12)"), setColor(S.LinearProgress, "primaryBg", N(private_safeDarken, S.primary.main, 0.5)), setColor(S.LinearProgress, "secondaryBg", N(private_safeDarken, S.secondary.main, 0.5)), setColor(S.LinearProgress, "errorBg", N(private_safeDarken, S.error.main, 0.5)), setColor(S.LinearProgress, "infoBg", N(private_safeDarken, S.info.main, 0.5)), setColor(S.LinearProgress, "successBg", N(private_safeDarken, S.success.main, 0.5)), setColor(S.LinearProgress, "warningBg", N(private_safeDarken, S.warning.main, 0.5)), setColor(S.Skeleton, "bg", C ? N(private_safeAlpha, S.text.primary, 0.13) : `rgba(${I("palette-text-primaryChannel")} / 0.13)`), setColor(S.Slider, "primaryTrack", N(private_safeDarken, S.primary.main, 0.5)), setColor(S.Slider, "secondaryTrack", N(private_safeDarken, S.secondary.main, 0.5)), setColor(S.Slider, "errorTrack", N(private_safeDarken, S.error.main, 0.5)), setColor(S.Slider, "infoTrack", N(private_safeDarken, S.info.main, 0.5)), setColor(S.Slider, "successTrack", N(private_safeDarken, S.success.main, 0.5)), setColor(S.Slider, "warningTrack", N(private_safeDarken, S.warning.main, 0.5));
      const F = C ? N(private_safeLighten, S.background.default, 0.985) : private_safeEmphasize(S.background.default, 0.98);
      setColor(S.SnackbarContent, "bg", F), setColor(S.SnackbarContent, "color", silent(() => C ? light.text.primary : S.getContrastText(F))), setColor(S.SpeedDialAction, "fabHoverBg", private_safeEmphasize(S.background.paper, 0.15)), setColor(S.StepConnector, "border", I("palette-grey-600")), setColor(S.StepContent, "border", I("palette-grey-600")), setColor(S.Switch, "defaultColor", I("palette-grey-300")), setColor(S.Switch, "defaultDisabledColor", I("palette-grey-600")), setColor(S.Switch, "primaryDisabledColor", N(private_safeDarken, S.primary.main, 0.55)), setColor(S.Switch, "secondaryDisabledColor", N(private_safeDarken, S.secondary.main, 0.55)), setColor(S.Switch, "errorDisabledColor", N(private_safeDarken, S.error.main, 0.55)), setColor(S.Switch, "infoDisabledColor", N(private_safeDarken, S.info.main, 0.55)), setColor(S.Switch, "successDisabledColor", N(private_safeDarken, S.success.main, 0.55)), setColor(S.Switch, "warningDisabledColor", N(private_safeDarken, S.warning.main, 0.55)), setColor(S.TableCell, "border", N(private_safeDarken, N(private_safeAlpha, S.divider, 1), 0.68)), setColor(S.Tooltip, "bg", N(private_safeAlpha, S.grey[700], 0.92));
    }
    setColorChannel(S.background, "default"), setColorChannel(S.background, "paper"), setColorChannel(S.common, "background"), setColorChannel(S.common, "onBackground"), setColorChannel(S, "divider"), Object.keys(S).forEach((F) => {
      const L = S[F];
      F !== "tonalOffset" && L && typeof L == "object" && (L.main && setColor(S[F], "mainChannel", private_safeColorChannel(toRgb(L.main))), L.light && setColor(S[F], "lightChannel", private_safeColorChannel(toRgb(L.light))), L.dark && setColor(S[F], "darkChannel", private_safeColorChannel(toRgb(L.dark))), L.contrastText && setColor(S[F], "contrastTextChannel", private_safeColorChannel(toRgb(L.contrastText))), F === "text" && (setColorChannel(S[F], "primary"), setColorChannel(S[F], "secondary")), F === "action" && (L.active && setColorChannel(S[F], "active"), L.selected && setColorChannel(S[F], "selected")));
    });
  }), _ = t.reduce((M, S) => deepmerge(M, S), _);
  const D = {
    prefix: i,
    disableCssColorScheme: s,
    shouldSkipGeneratingVar: d,
    getSelector: defaultGetSelector(_),
    enableContrastVars: l
  }, {
    vars: O,
    generateThemeVars: v,
    generateStyleSheets: w
  } = prepareCssVars(_, D);
  return _.vars = O, Object.entries(_.colorSchemes[_.defaultColorScheme]).forEach(([M, S]) => {
    _[M] = S;
  }), _.generateThemeVars = v, _.generateStyleSheets = w, _.generateSpacing = function() {
    return createSpacing(p.spacing, createUnarySpacing(this));
  }, _.getColorSchemeSelector = createGetColorSchemeSelector(u), _.spacing = _.generateSpacing(), _.shouldSkipGeneratingVar = d, _.unstable_sxConfig = {
    ...defaultSxConfig,
    ...p?.unstable_sxConfig
  }, _.unstable_sx = function(S) {
    return styleFunctionSx({
      sx: S,
      theme: this
    });
  }, _.toRuntimeSource = stringifyTheme, _;
}
function attachColorScheme(e, t, o) {
  e.colorSchemes && o && (e.colorSchemes[t] = {
    ...o !== !0 && o,
    palette: createPalette({
      ...o === !0 ? {} : o.palette,
      mode: t
    })
    // cast type to skip module augmentation test
  });
}
function createTheme(e = {}, ...t) {
  const {
    palette: o,
    cssVariables: n = !1,
    colorSchemes: s = o ? void 0 : {
      light: !0
    },
    defaultColorScheme: i = o?.mode,
    ...l
  } = e, d = i || "light", u = s?.[d], c = {
    ...s,
    ...o ? {
      [d]: {
        ...typeof u != "boolean" && u,
        palette: o
      }
    } : void 0
  };
  if (n === !1) {
    if (!("colorSchemes" in e))
      return createThemeNoVars(e, ...t);
    let p = o;
    "palette" in e || c[d] && (c[d] !== !0 ? p = c[d].palette : d === "dark" && (p = {
      mode: "dark"
    }));
    const f = createThemeNoVars({
      ...e,
      palette: p
    }, ...t);
    return f.defaultColorScheme = d, f.colorSchemes = c, f.palette.mode === "light" && (f.colorSchemes.light = {
      ...c.light !== !0 && c.light,
      palette: f.palette
    }, attachColorScheme(f, "dark", c.dark)), f.palette.mode === "dark" && (f.colorSchemes.dark = {
      ...c.dark !== !0 && c.dark,
      palette: f.palette
    }, attachColorScheme(f, "light", c.light)), f;
  }
  return !o && !("light" in c) && d === "light" && (c.light = !0), createThemeWithVars({
    ...l,
    colorSchemes: c,
    defaultColorScheme: d,
    ...typeof n != "boolean" && n
  }, ...t);
}
const defaultTheme = createTheme();
function useTheme() {
  const e = useTheme$2(defaultTheme);
  return process.env.NODE_ENV !== "production" && React.useDebugValue(e), e[THEME_ID] || e;
}
function useThemeProps({
  props: e,
  name: t
}) {
  return useThemeProps$1({
    props: e,
    name: t,
    defaultTheme,
    themeId: THEME_ID
  });
}
function slotShouldForwardProp(e) {
  return e !== "ownerState" && e !== "theme" && e !== "sx" && e !== "as";
}
const rootShouldForwardProp = (e) => slotShouldForwardProp(e) && e !== "classes", styled = createStyled({
  themeId: THEME_ID,
  defaultTheme,
  rootShouldForwardProp
});
function ThemeProviderNoVars({
  theme: e,
  ...t
}) {
  const o = THEME_ID in e ? e[THEME_ID] : void 0;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ThemeProvider$2, {
    ...t,
    themeId: o ? THEME_ID : void 0,
    theme: o || e
  });
}
const defaultConfig = {
  colorSchemeStorageKey: "mui-color-scheme",
  defaultLightColorScheme: "light",
  defaultDarkColorScheme: "dark",
  modeStorageKey: "mui-mode"
};
process.env.NODE_ENV !== "production" && (PropTypes.string, PropTypes.string, PropTypes.string, PropTypes.string, PropTypes.string, PropTypes.oneOf(["dark", "light", "system"]), PropTypes.string, PropTypes.string);
const {
  CssVarsProvider: InternalCssVarsProvider
} = createCssVarsProvider({
  themeId: THEME_ID,
  // @ts-ignore ignore module augmentation tests
  theme: () => createTheme({
    cssVariables: !0
  }),
  colorSchemeStorageKey: defaultConfig.colorSchemeStorageKey,
  modeStorageKey: defaultConfig.modeStorageKey,
  defaultColorScheme: {
    light: defaultConfig.defaultLightColorScheme,
    dark: defaultConfig.defaultDarkColorScheme
  },
  resolveTheme: (e) => {
    const t = {
      ...e,
      typography: createTypography(e.palette, e.typography)
    };
    return t.unstable_sx = function(n) {
      return styleFunctionSx({
        sx: n,
        theme: this
      });
    }, t;
  }
}), CssVarsProvider = InternalCssVarsProvider;
function ThemeProvider$1({
  theme: e,
  ...t
}) {
  const o = React.useMemo(() => {
    if (typeof e == "function")
      return e;
    const n = THEME_ID in e ? e[THEME_ID] : e;
    return "colorSchemes" in n ? null : "vars" in n ? e : {
      ...e,
      vars: null
    };
  }, [e]);
  return o ? /* @__PURE__ */ jsxRuntimeExports.jsx(ThemeProviderNoVars, {
    theme: o,
    ...t
  }) : /* @__PURE__ */ jsxRuntimeExports.jsx(CssVarsProvider, {
    theme: e,
    ...t
  });
}
function createGradient(e, t) {
  return `linear-gradient(to bottom, ${e}, ${t})`;
}
const PRIMARY = {
  main: "#0086cf",
  // In theory should be hsl(201, 100%, 41%) but it's not exactly the same so we go with hex
  light: "hsl(201, 72%, 65%)",
  dark: "hsl(201, 98%, 34%)",
  lighter: "hsl(201, 100%, 92%)",
  darker: "hsl(201, 99%, 19%)"
}, SECONDARY = {
  lighter: "hsl(126, 83%, 88%)",
  light: "hsl(138, 73%, 63%)",
  main: "hsl(150, 100%, 34%)",
  dark: "hsl(161, 100%, 24%)",
  darker: "hsl(173, 100%, 16%)"
}, INFO = {
  lighter: "hsl(197, 100%, 91%)",
  light: "hsl(203, 100%, 73%)",
  main: "hsl(209, 100%, 55%)",
  dark: "hsl(215, 88%, 38%)",
  darker: "hsl(221, 94%, 25%)"
}, SUCCESS = {
  lighter: "hsl(89, 87%, 91%)",
  light: "hsl(98, 82%, 72%)",
  main: "hsl(106, 67%, 51%)",
  dark: "hsl(115, 75%, 35%)",
  darker: "hsl(123, 85%, 22%)"
}, WARNING = {
  lighter: "hsl(50, 100%, 90%)",
  light: "hsl(48, 100%, 71%)",
  main: "hsl(45, 100%, 51%)",
  dark: "hsl(42, 97%, 36%)",
  darker: "hsl(39, 98%, 24%)"
}, ERROR = {
  lighter: "hsl(22, 100%, 93%)",
  light: "hsl(12, 100%, 78%)",
  main: "hsl(2, 100%, 63%)",
  dark: "hsl(352, 69%, 42%)",
  darker: "hsl(341, 82%, 26%)"
}, BASE_WHITE = "hsl(0, 0%, 100%)", BASE_BLACK = "hsl(0, 0%, 0%)", INTERACTION_BACKGROUND = "hsl(219, 34%, 75%)", GREY = {
  0: BASE_WHITE,
  100: "hsl(210, 20%, 98%)",
  200: "hsl(210, 22%, 96%)",
  300: "hsl(213, 16%, 89%)",
  400: "hsl(208, 17%, 80%)",
  500: "hsl(210, 13%, 62%)",
  600: "hsl(208, 13%, 45%)",
  700: "hsl(213, 14%, 31%)",
  800: "hsl(211, 24%, 17%)",
  900: "hsl(214, 24%, 11%)",
  5008: alpha$1("hsl(210, 13%, 62%)", 0.08),
  50012: alpha$1("hsl(210, 13%, 62%)", 0.12),
  50016: alpha$1("hsl(210, 13%, 62%)", 0.16),
  50024: alpha$1("hsl(210, 13%, 62%)", 0.24),
  50032: alpha$1("hsl(210, 13%, 62%)", 0.32),
  50048: alpha$1("hsl(210, 13%, 62%)", 0.48),
  50056: alpha$1("hsl(210, 13%, 62%)", 0.56),
  50080: alpha$1("hsl(210, 13%, 62%)", 0.8)
}, TRANSPARENT_WHITE = {
  0: BASE_WHITE,
  8: alpha$1(BASE_WHITE, 0.08),
  16: alpha$1(BASE_WHITE, 0.16)
}, GRADIENTS = {
  primary: createGradient(PRIMARY.light, PRIMARY.main),
  info: createGradient(INFO.light, INFO.main),
  success: createGradient(SUCCESS.light, SUCCESS.main),
  warning: createGradient(WARNING.light, WARNING.main),
  error: createGradient(ERROR.light, ERROR.main)
}, CHART_COLORS = {
  violet: [
    "hsl(250, 92%, 70%)",
    "hsl(252, 100%, 76%)",
    "hsl(265, 100%, 84%)",
    "hsl(289, 100%, 91%)"
  ],
  blue: [
    "hsl(209, 100%, 59%)",
    "hsl(203, 100%, 76%)",
    "hsl(188, 100%, 82%)",
    "hsl(186, 100%, 90%)"
  ],
  green: [
    "hsl(173, 69%, 51%)",
    "hsl(163, 84%, 66%)",
    "hsl(149, 84%, 81%)",
    "hsl(154, 66%, 85%)"
  ],
  yellow: [
    "hsl(54, 100%, 50%)",
    "hsl(54, 100%, 68%)",
    "hsl(54, 100%, 84%)",
    "hsl(42, 100%, 92%)"
  ],
  red: [
    "hsl(14, 100%, 63%)",
    "hsl(14, 100%, 71%)",
    "hsl(22, 100%, 80%)",
    "hsl(42, 100%, 92%)"
  ]
}, COMMON = {
  common: {
    black: BASE_BLACK,
    white: BASE_WHITE
  },
  primary: { ...PRIMARY, contrastText: GREY[0] },
  secondary: { ...SECONDARY, contrastText: GREY[0] },
  info: { ...INFO, contrastText: GREY[0] },
  success: { ...SUCCESS, contrastText: GREY[0] },
  warning: { ...WARNING, contrastText: GREY[0] },
  error: { ...ERROR, contrastText: GREY[0] },
  grey: GREY,
  gradients: GRADIENTS,
  chart: CHART_COLORS,
  transparentWhite: TRANSPARENT_WHITE,
  divider: GREY[50024],
  action: {
    hover: GREY[5008],
    selected: GREY[50016],
    disabled: GREY[50080],
    disabledBackground: GREY[50024],
    focus: GREY[50024],
    hoverOpacity: 0.08,
    disabledOpacity: 0.48
  }
}, palette = {
  light: {
    ...COMMON,
    mode: "light",
    text: { primary: GREY[800], secondary: GREY[600], disabled: GREY[500] },
    background: {
      paper: BASE_WHITE,
      default: BASE_WHITE,
      neutral: GREY[200],
      interaction: INTERACTION_BACKGROUND
    },
    action: { active: GREY[600], ...COMMON.action }
  },
  dark: {
    ...COMMON,
    mode: "dark",
    text: {
      primary: BASE_WHITE,
      secondary: GREY[500],
      disabled: GREY[600]
    },
    background: {
      paper: GREY[800],
      default: GREY[900],
      neutral: GREY[50016],
      interaction: INTERACTION_BACKGROUND
    },
    action: { active: GREY[500], ...COMMON.action }
  }
}, LIGHT_MODE = palette.light.grey[500], DARK_MODE = "#000000", createShadow = (e) => {
  const t = alpha$1(e, 0.2), o = alpha$1(e, 0.14), n = alpha$1(e, 0.12);
  return [
    "none",
    `0px 2px 1px -1px ${t},0px 1px 1px 0px ${o},0px 1px 3px 0px ${n}`,
    `0px 3px 1px -2px ${t},0px 2px 2px 0px ${o},0px 1px 5px 0px ${n}`,
    `0px 3px 3px -2px ${t},0px 3px 4px 0px ${o},0px 1px 8px 0px ${n}`,
    `0px 2px 4px -1px ${t},0px 4px 5px 0px ${o},0px 1px 10px 0px ${n}`,
    `0px 3px 5px -1px ${t},0px 5px 8px 0px ${o},0px 1px 14px 0px ${n}`,
    `0px 3px 5px -1px ${t},0px 6px 10px 0px ${o},0px 1px 18px 0px ${n}`,
    `0px 4px 5px -2px ${t},0px 7px 10px 1px ${o},0px 2px 16px 1px ${n}`,
    `0px 5px 5px -3px ${t},0px 8px 10px 1px ${o},0px 3px 14px 2px ${n}`,
    `0px 5px 6px -3px ${t},0px 9px 12px 1px ${o},0px 3px 16px 2px ${n}`,
    `0px 6px 6px -3px ${t},0px 10px 14px 1px ${o},0px 4px 18px 3px ${n}`,
    `0px 6px 7px -4px ${t},0px 11px 15px 1px ${o},0px 4px 20px 3px ${n}`,
    `0px 7px 8px -4px ${t},0px 12px 17px 2px ${o},0px 5px 22px 4px ${n}`,
    `0px 7px 8px -4px ${t},0px 13px 19px 2px ${o},0px 5px 24px 4px ${n}`,
    `0px 7px 9px -4px ${t},0px 14px 21px 2px ${o},0px 5px 26px 4px ${n}`,
    `0px 8px 9px -5px ${t},0px 15px 22px 2px ${o},0px 6px 28px 5px ${n}`,
    `0px 8px 10px -5px ${t},0px 16px 24px 2px ${o},0px 6px 30px 5px ${n}`,
    `0px 8px 11px -5px ${t},0px 17px 26px 2px ${o},0px 6px 32px 5px ${n}`,
    `0px 9px 11px -5px ${t},0px 18px 28px 2px ${o},0px 7px 34px 6px ${n}`,
    `0px 9px 12px -6px ${t},0px 19px 29px 2px ${o},0px 7px 36px 6px ${n}`,
    `0px 10px 13px -6px ${t},0px 20px 31px 3px ${o},0px 8px 38px 7px ${n}`,
    `0px 10px 13px -6px ${t},0px 21px 33px 3px ${o},0px 8px 40px 7px ${n}`,
    `0px 10px 14px -6px ${t},0px 22px 35px 3px ${o},0px 8px 42px 7px ${n}`,
    `0px 11px 14px -7px ${t},0px 23px 36px 3px ${o},0px 9px 44px 8px ${n}`,
    `0px 11px 15px -7px ${t},0px 24px 38px 3px ${o},0px 9px 46px 8px ${n}`
  ];
}, createCustomShadow = (e) => {
  const t = alpha$1(e, 0.16);
  return {
    z1: `0 1px 2px 0 ${t}`,
    z8: `0 8px 16px 0 ${t}`,
    z12: `0 12px 24px -4px ${t}`,
    z16: `0 16px 32px -4px ${t}`,
    z20: `0 20px 40px -4px ${t}`,
    z24: `0 24px 48px 0 ${t}`,
    //
    primary: `0 8px 16px 0 ${alpha$1(palette.light.primary.main, 0.24)}`,
    info: `0 8px 16px 0 ${alpha$1(palette.light.info.main, 0.24)}`,
    secondary: `0 8px 16px 0 ${alpha$1(palette.light.secondary.main, 0.24)}`,
    success: `0 8px 16px 0 ${alpha$1(palette.light.success.main, 0.24)}`,
    warning: `0 8px 16px 0 ${alpha$1(palette.light.warning.main, 0.24)}`,
    error: `0 8px 16px 0 ${alpha$1(palette.light.error.main, 0.24)}`,
    //
    card: `0 0 2px 0 ${alpha$1(e, 0.2)}, 0 12px 24px -4px ${alpha$1(
      e,
      0.12
    )}`,
    dialog: `-40px 40px 80px -8px ${alpha$1(palette.light.common.black, 0.24)}`,
    dropdown: `0 0 2px 0 ${alpha$1(e, 0.24)}, -20px 20px 40px -4px ${alpha$1(
      e,
      0.24
    )}`
  };
}, customShadows = {
  light: createCustomShadow(LIGHT_MODE),
  dark: createCustomShadow(DARK_MODE)
}, shadows = {
  light: createShadow(LIGHT_MODE),
  dark: createShadow(DARK_MODE)
};
function Accordion(e) {
  return {
    MuiAccordion: {
      styleOverrides: {
        root: {
          "&.Mui-expanded": {
            boxShadow: e.customShadows.z8,
            borderRadius: e.shape.borderRadius
          },
          "&.Mui-disabled": {
            backgroundColor: "transparent"
          }
        }
      }
    },
    MuiAccordionSummary: {
      styleOverrides: {
        root: {
          paddingLeft: e.spacing(2),
          paddingRight: e.spacing(1),
          "&.Mui-disabled": {
            opacity: 1,
            color: e.palette.action.disabled,
            "& .MuiTypography-root": {
              color: "inherit"
            }
          }
        },
        expandIconWrapper: {
          color: "inherit"
        }
      }
    }
  };
}
function CloseIcon(e) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(SvgIcon$2, { ...e, children: /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M12,2 C6.4771525,2 2,6.4771525 2,12 C2,17.5228475 6.4771525,22 12,22 C17.5228475,22 22,17.5228475 22,12 C22,9.3478351 20.9464316,6.80429597 19.0710678,4.92893219 C17.195704,3.0535684 14.6521649,2 12,2 Z M14.71,13.29 C14.8993127,13.4777666 15.0057983,13.7333625 15.0057983,14 C15.0057983,14.2666375 14.8993127,14.5222334 14.71,14.71 C14.5222334,14.8993127 14.2666375,15.0057983 14,15.0057983 C13.7333625,15.0057983 13.4777666,14.8993127 13.29,14.71 L12,13.41 L10.71,14.71 C10.5222334,14.8993127 10.2666375,15.0057983 10,15.0057983 C9.73336246,15.0057983 9.4777666,14.8993127 9.29,14.71 C9.10068735,14.5222334 8.99420168,14.2666375 8.99420168,14 C8.99420168,13.7333625 9.10068735,13.4777666 9.29,13.29 L10.59,12 L9.29,10.71 C8.89787783,10.3178778 8.89787783,9.68212217 9.29,9.29 C9.68212217,8.89787783 10.3178778,8.89787783 10.71,9.29 L12,10.59 L13.29,9.29 C13.6821222,8.89787783 14.3178778,8.89787783 14.71,9.29 C15.1021222,9.68212217 15.1021222,10.3178778 14.71,10.71 L13.41,12 L14.71,13.29 Z" }) });
}
function StarIcon(e) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(SvgIcon$2, { ...e, children: /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M17.56,21 C17.4000767,21.0006435 17.2423316,20.9629218 17.1,20.89 L12,18.22 L6.9,20.89 C6.56213339,21.067663 6.15259539,21.0374771 5.8444287,20.8121966 C5.53626201,20.5869161 5.38323252,20.2058459 5.45,19.83 L6.45,14.2 L2.33,10.2 C2.06805623,9.93860108 1.9718844,9.55391377 2.08,9.2 C2.19824414,8.83742187 2.51242293,8.57366684 2.89,8.52 L8.59,7.69 L11.1,2.56 C11.2670864,2.21500967 11.6166774,1.99588989 12,1.99588989 C12.3833226,1.99588989 12.7329136,2.21500967 12.9,2.56 L15.44,7.68 L21.14,8.51 C21.5175771,8.56366684 21.8317559,8.82742187 21.95,9.19 C22.0581156,9.54391377 21.9619438,9.92860108 21.7,10.19 L17.58,14.19 L18.58,19.82 C18.652893,20.2027971 18.4967826,20.5930731 18.18,20.82 C17.9989179,20.9468967 17.7808835,21.010197 17.56,21 L17.56,21 Z" }) });
}
function InfoIcon(e) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(SvgIcon$2, { ...e, children: /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M12,2 C6.4771525,2 2,6.4771525 2,12 C2,17.5228475 6.4771525,22 12,22 C17.5228475,22 22,17.5228475 22,12 C22,9.3478351 20.9464316,6.80429597 19.0710678,4.92893219 C17.195704,3.0535684 14.6521649,2 12,2 Z M13,16 C13,16.5522847 12.5522847,17 12,17 C11.4477153,17 11,16.5522847 11,16 L11,11 C11,10.4477153 11.4477153,10 12,10 C12.5522847,10 13,10.4477153 13,11 L13,16 Z M12,9 C11.4477153,9 11,8.55228475 11,8 C11,7.44771525 11.4477153,7 12,7 C12.5522847,7 13,7.44771525 13,8 C13,8.55228475 12.5522847,9 12,9 Z" }) });
}
function WarningIcon(e) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(SvgIcon$2, { ...e, children: /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M22.56,16.3 L14.89,3.58 C14.2597186,2.59400001 13.1702353,1.99737652 12,1.99737652 C10.8297647,1.99737652 9.74028139,2.59400001 9.11,3.58 L1.44,16.3 C0.888546003,17.2192471 0.869485343,18.3628867 1.39,19.3 C1.99197363,20.3551378 3.11522982,21.0046397 4.33,21 L19.67,21 C20.8765042,21.0128744 21.9978314,20.3797441 22.61,19.34 C23.146086,18.3926382 23.1269508,17.2292197 22.56,16.3 L22.56,16.3 Z M12,17 C11.4477153,17 11,16.5522847 11,16 C11,15.4477153 11.4477153,15 12,15 C12.5522847,15 13,15.4477153 13,16 C13,16.5522847 12.5522847,17 12,17 Z M13,13 C13,13.5522847 12.5522847,14 12,14 C11.4477153,14 11,13.5522847 11,13 L11,9 C11,8.44771525 11.4477153,8 12,8 C12.5522847,8 13,8.44771525 13,9 L13,13 Z" }) });
}
function SuccessIcon(e) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(SvgIcon$2, { ...e, children: /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M12,2 C6.4771525,2 2,6.4771525 2,12 C2,17.5228475 6.4771525,22 12,22 C17.5228475,22 22,17.5228475 22,12 C22,9.3478351 20.9464316,6.80429597 19.0710678,4.92893219 C17.195704,3.0535684 14.6521649,2 12,2 Z M16.3,9.61 L11.73,15.61 C11.5412074,15.855247 11.2494966,15.9992561 10.94,16.0000145 C10.6322197,16.001658 10.3408221,15.861492 10.15,15.62 L7.71,12.51 C7.49028166,12.2277602 7.43782669,11.8497415 7.57239438,11.5183399 C7.70696206,11.1869384 8.00810836,10.9525017 8.36239438,10.9033399 C8.7166804,10.8541782 9.07028166,10.9977602 9.29,11.28 L10.92,13.36 L14.7,8.36 C14.917932,8.07418751 15.2717886,7.92635122 15.6282755,7.97217964 C15.9847624,8.01800806 16.2897207,8.25053875 16.4282755,8.58217966 C16.5668304,8.91382056 16.517932,9.29418753 16.3,9.58 L16.3,9.61 Z" }) });
}
function ErrorIcon(e) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(SvgIcon$2, { ...e, children: /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M12,2 C6.4771525,2 2,6.4771525 2,12 C2,17.5228475 6.4771525,22 12,22 C17.5228475,22 22,17.5228475 22,12 C22,9.3478351 20.9464316,6.80429597 19.0710678,4.92893219 C17.195704,3.0535684 14.6521649,2 12,2 Z M12,17 C11.4477153,17 11,16.5522847 11,16 C11,15.4477153 11.4477153,15 12,15 C12.5522847,15 13,15.4477153 13,16 C13,16.5522847 12.5522847,17 12,17 Z M13,13 C13,13.5522847 12.5522847,14 12,14 C11.4477153,14 11,13.5522847 11,13 L11,8 C11,7.44771525 11.4477153,7 12,7 C12.5522847,7 13,7.44771525 13,8 L13,13 Z" }) });
}
function CheckboxIcon(e) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(SvgIcon$2, { ...e, children: /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M17 3a4 4 0 014 4v10a4 4 0 01-4 4H7a4 4 0 01-4-4V7a4 4 0 014-4h10zm0 2H7a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2z" }) });
}
function CheckboxCheckedIcon(e) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(SvgIcon$2, { ...e, children: /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M17 3a4 4 0 014 4v10a4 4 0 01-4 4H7a4 4 0 01-4-4V7a4 4 0 014-4h10zm-1.372 4.972a1.006 1.006 0 00-.928.388l-3.78 5-1.63-2.08a1.001 1.001 0 00-1.58 1.23l2.44 3.11a1 1 0 001.58-.01l4.57-6v-.03a1.006 1.006 0 00-.672-1.608z" }) });
}
function CheckboxIndeterminateIcon(e) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(SvgIcon$2, { ...e, children: /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M17 3a4 4 0 014 4v10a4 4 0 01-4 4H7a4 4 0 01-4-4V7a4 4 0 014-4h10zm-1.75 8h-6.5a.75.75 0 00-.75.75v.5c0 .414.336.75.75.75h6.5a.75.75 0 00.75-.75v-.5a.75.75 0 00-.75-.75z" }) });
}
function InputSelectIcon(e) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    SvgIcon$2,
    {
      ...e,
      sx: {
        right: 12,
        fontSize: 16,
        position: "absolute",
        pointerEvents: "none"
      },
      children: /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M12,16 C11.7663478,16.0004565 11.5399121,15.9190812 11.36,15.77 L5.36,10.77 C4.93474074,10.4165378 4.87653776,9.78525926 5.23,9.36 C5.58346224,8.93474074 6.21474074,8.87653776 6.64,9.23 L12,13.71 L17.36,9.39 C17.5665934,9.2222295 17.8315409,9.14373108 18.0961825,9.17188444 C18.3608241,9.2000378 18.6033268,9.33252029 18.77,9.54 C18.9551341,9.74785947 19.0452548,10.0234772 19.0186853,10.3005589 C18.9921158,10.5776405 18.8512608,10.8311099 18.63,11 L12.63,15.83 C12.444916,15.955516 12.2231011,16.0153708 12,16 Z" })
    }
  );
}
function TreeViewCollapseIcon(e) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(SvgIcon$2, { ...e, children: /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M18,3 C19.6568542,3 21,4.34314575 21,6 L21,6 L21,18 C21,19.6568542 19.6568542,21 18,21 L18,21 L6,21 C4.34314575,21 3,19.6568542 3,18 L3,18 L3,6 C3,4.34314575 4.34314575,3 6,3 L6,3 Z M18,5 L6,5 C5.44771525,5 5,5.44771525 5,6 L5,6 L5,18 C5,18.5522847 5.44771525,19 6,19 L6,19 L18,19 C18.5522847,19 19,18.5522847 19,18 L19,18 L19,6 C19,5.44771525 18.5522847,5 18,5 L18,5 Z M12,8 C12.5522847,8 13,8.44771525 13,9 L13,9 L13,11 L15,11 C15.5522847,11 16,11.4477153 16,12 C16,12.5522847 15.5522847,13 15,13 L15,13 L13,13 L13,15 C13,15.5522847 12.5522847,16 12,16 C11.4477153,16 11,15.5522847 11,15 L11,15 L11,13 L9,13 C8.44771525,13 8,12.5522847 8,12 C8,11.4477153 8.44771525,11 9,11 L9,11 L11,11 L11,9 C11,8.44771525 11.4477153,8 12,8 Z" }) });
}
function TreeViewExpandIcon(e) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(SvgIcon$2, { ...e, children: /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M18,3 C19.6568542,3 21,4.34314575 21,6 L21,6 L21,18 C21,19.6568542 19.6568542,21 18,21 L18,21 L6,21 C4.34314575,21 3,19.6568542 3,18 L3,18 L3,6 C3,4.34314575 4.34314575,3 6,3 L6,3 Z M18,5 L6,5 C5.44771525,5 5,5.44771525 5,6 L5,6 L5,18 C5,18.5522847 5.44771525,19 6,19 L6,19 L18,19 C18.5522847,19 19,18.5522847 19,18 L19,18 L19,6 C19,5.44771525 18.5522847,5 18,5 L18,5 Z M15,11 C15.5522847,11 16,11.4477153 16,12 C16,12.5522847 15.5522847,13 15,13 L15,13 L9,13 C8.44771525,13 8,12.5522847 8,12 C8,11.4477153 8.44771525,11 9,11 L9,11 Z" }) });
}
function TreeViewEndIcon(e) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(SvgIcon$2, { ...e, children: /* @__PURE__ */ jsxRuntimeExports.jsx("path", { d: "M18,3 C19.6568542,3 21,4.34314575 21,6 L21,6 L21,18 C21,19.6568542 19.6568542,21 18,21 L18,21 L6,21 C4.34314575,21 3,19.6568542 3,18 L3,18 L3,6 C3,4.34314575 4.34314575,3 6,3 L6,3 Z M18,5 L6,5 C5.44771525,5 5,5.44771525 5,6 L5,6 L5,18 C5,18.5522847 5.44771525,19 6,19 L6,19 L18,19 C18.5522847,19 19,18.5522847 19,18 L19,18 L19,6 C19,5.44771525 18.5522847,5 18,5 L18,5 Z M14,8.99420168 C14.2666375,8.99420168 14.5222334,9.10068735 14.71,9.29 C14.8993127,9.4777666 15.0057983,9.73336246 15.0057983,10 C15.0057983,10.2666375 14.8993127,10.5222334 14.71,10.71 L14.71,10.71 L13.41,12 L14.71,13.29 C14.8993127,13.4777666 15.0057983,13.7333625 15.0057983,14 C15.0057983,14.2666375 14.8993127,14.5222334 14.71,14.71 C14.5222334,14.8993127 14.2666375,15.0057983 14,15.0057983 C13.7333625,15.0057983 13.4777666,14.8993127 13.29,14.71 L13.29,14.71 L12,13.41 L10.71,14.71 C10.5222334,14.8993127 10.2666375,15.0057983 10,15.0057983 C9.73336246,15.0057983 9.4777666,14.8993127 9.29,14.71 C9.10068735,14.5222334 8.99420168,14.2666375 8.99420168,14 C8.99420168,13.7333625 9.10068735,13.4777666 9.29,13.29 L9.29,13.29 L10.59,12 L9.29,10.71 C8.89787783,10.3178778 8.89787783,9.68212217 9.29,9.29 C9.68212217,8.89787783 10.3178778,8.89787783 10.71,9.29 L10.71,9.29 L12,10.59 L13.29,9.29 C13.4777666,9.10068735 13.7333625,8.99420168 14,8.99420168 Z" }) });
}
function Alert(e) {
  const t = e.palette.mode === "light", o = (i) => ({
    color: e.palette[i][t ? "darker" : "lighter"],
    backgroundColor: e.palette[i][t ? "lighter" : "darker"],
    "& .MuiAlert-icon": {
      color: e.palette[i][t ? "main" : "light"]
    }
  }), n = (i) => ({
    color: e.palette[i].contrastText
  }), s = (i) => ({
    color: e.palette[i][t ? "darker" : "lighter"],
    border: `solid 1px ${e.palette[i][t ? "light" : "dark"]}`,
    backgroundColor: e.palette[i][t ? "lighter" : "darker"],
    "& .MuiAlert-icon": {
      color: e.palette[i][t ? "main" : "light"]
    }
  });
  return {
    MuiAlert: {
      defaultProps: {
        iconMapping: {
          info: /* @__PURE__ */ jsxRuntimeExports.jsx(InfoIcon, {}),
          success: /* @__PURE__ */ jsxRuntimeExports.jsx(SuccessIcon, {}),
          warning: /* @__PURE__ */ jsxRuntimeExports.jsx(WarningIcon, {}),
          error: /* @__PURE__ */ jsxRuntimeExports.jsx(ErrorIcon, {})
        }
      },
      styleOverrides: {
        message: {
          "& .MuiAlertTitle-root": {
            marginBottom: e.spacing(0.5)
          }
        },
        action: {
          "& button:not(:first-of-type)": {
            marginLeft: e.spacing(1)
          }
        },
        standardInfo: o("info"),
        standardSuccess: o("success"),
        standardWarning: o("warning"),
        standardError: o("error"),
        filledInfo: n("info"),
        filledSuccess: n("success"),
        filledWarning: n("warning"),
        filledError: n("error"),
        outlinedInfo: s("info"),
        outlinedSuccess: s("success"),
        outlinedWarning: s("warning"),
        outlinedError: s("error")
      }
    }
  };
}
function Autocomplete(e) {
  return {
    MuiAutocomplete: {
      styleOverrides: {
        paper: {
          boxShadow: e.customShadows.dropdown
        },
        listbox: {
          padding: e.spacing(0, 1),
          "& .MuiAutocomplete-option": {
            padding: e.spacing(1),
            margin: e.spacing(1, 0),
            borderRadius: e.shape.borderRadius
          }
        }
      }
    }
  };
}
function Avatar(e) {
  return {
    MuiAvatar: {
      styleOverrides: {
        colorDefault: {
          color: e.palette.text.secondary,
          backgroundColor: e.palette.grey[400]
        }
      }
    },
    MuiAvatarGroup: {
      styleOverrides: {
        avatar: {
          fontSize: 16,
          fontWeight: e.typography.fontWeightMedium,
          "&:first-of-type": {
            fontSize: 14,
            color: e.palette.primary.main,
            backgroundColor: e.palette.primary.lighter
          }
        }
      }
    }
  };
}
function Backdrop$1(e) {
  const t = alpha$1(e.palette.grey[900], 0.48), o = alpha$1(e.palette.grey[900], 1);
  return {
    MuiBackdrop: {
      styleOverrides: {
        root: {
          background: [
            "rgb(22,28,36)",
            `-moz-linear-gradient(75deg, ${t} 0%, ${o} 100%)`,
            `-webkit-linear-gradient(75deg, ${t} 0%, ${o} 100%)`,
            `linear-gradient(75deg, ${t} 0%, ${o} 100%)`
          ],
          "&.MuiBackdrop-invisible": {
            background: "transparent"
          }
        }
      }
    }
  };
}
function Badge(e) {
  return {
    MuiBadge: {
      styleOverrides: {
        dot: {
          width: 10,
          height: 10,
          borderRadius: "50%"
        }
      }
    }
  };
}
function Breadcrumbs(e) {
  return {
    MuiBreadcrumbs: {
      styleOverrides: {
        separator: {
          marginLeft: e.spacing(2),
          marginRight: e.spacing(2)
        }
      }
    }
  };
}
function Button$4(e) {
  return {
    MuiButton: {
      styleOverrides: {
        root: {
          "&:hover": {
            boxShadow: "none"
          }
        },
        sizeLarge: {
          height: 48
        },
        // contained
        containedInherit: {
          color: e.palette.grey[800],
          boxShadow: e.customShadows.z8,
          "&:hover": {
            backgroundColor: e.palette.grey[400]
          }
        },
        containedPrimary: {
          boxShadow: e.customShadows.primary
        },
        containedSecondary: {
          boxShadow: e.customShadows.secondary
        },
        containedInfo: {
          boxShadow: e.customShadows.info
        },
        containedSuccess: {
          boxShadow: e.customShadows.success
        },
        containedWarning: {
          boxShadow: e.customShadows.warning
        },
        containedError: {
          boxShadow: e.customShadows.error
        },
        // outlined
        outlinedInherit: {
          border: `1px solid ${e.palette.grey[50032]}`,
          "&:hover": {
            backgroundColor: e.palette.action.hover
          }
        },
        textInherit: {
          "&:hover": {
            backgroundColor: e.palette.action.hover
          }
        }
      }
    }
  };
}
function ButtonGroup(e) {
  const t = (o) => ({
    props: { variant: "contained", color: o },
    style: { boxShadow: e.customShadows[o] }
  });
  return {
    MuiButtonGroup: {
      variants: [
        {
          props: { variant: "contained", color: "inherit" },
          style: { boxShadow: e.customShadows.z8 }
        },
        t("primary"),
        t("secondary"),
        t("info"),
        t("success"),
        t("warning"),
        t("error"),
        {
          props: { disabled: !0 },
          style: {
            boxShadow: "none",
            "& .MuiButtonGroup-grouped.Mui-disabled": {
              color: e.palette.action.disabled,
              borderColor: `${e.palette.action.disabledBackground} !important`,
              "&.MuiButton-contained": {
                backgroundColor: e.palette.action.disabledBackground
              }
            }
          }
        }
      ],
      styleOverrides: {
        root: {
          "&:hover": {
            boxShadow: "none"
          }
        }
      }
    }
  };
}
function Card(e) {
  return {
    MuiCard: {
      styleOverrides: {
        root: {
          position: "relative",
          boxShadow: e.customShadows.card,
          borderRadius: Number(e.shape.borderRadius) * 2,
          zIndex: 0
          // Fix Safari overflow: hidden with border radius
        }
      }
    },
    MuiCardHeader: {
      defaultProps: {
        titleTypographyProps: { variant: "h6" },
        subheaderTypographyProps: {
          variant: "body2",
          marginTop: e.spacing(0.5)
        }
      },
      styleOverrides: {
        root: {
          padding: e.spacing(3, 3, 0)
        }
      }
    }
  };
}
function Checkbox(e) {
  return {
    MuiCheckbox: {
      defaultProps: {
        icon: /* @__PURE__ */ jsxRuntimeExports.jsx(CheckboxIcon, {}),
        checkedIcon: /* @__PURE__ */ jsxRuntimeExports.jsx(CheckboxCheckedIcon, {}),
        indeterminateIcon: /* @__PURE__ */ jsxRuntimeExports.jsx(CheckboxIndeterminateIcon, {})
      },
      styleOverrides: {
        root: {
          padding: e.spacing(1),
          "&.Mui-checked.Mui-disabled, &.Mui-disabled": {
            color: e.palette.action.disabled
          },
          "& .MuiSvgIcon-fontSizeMedium": {
            width: 24,
            height: 24
          },
          "& .MuiSvgIcon-fontSizeSmall": {
            width: 20,
            height: 20
          },
          svg: {
            fontSize: 24,
            "&[font-size=small]": {
              fontSize: 20
            }
          }
        }
      }
    }
  };
}
function Chip$1(e) {
  return {
    MuiChip: {
      defaultProps: {
        deleteIcon: /* @__PURE__ */ jsxRuntimeExports.jsx(CloseIcon, {})
      },
      styleOverrides: {
        colorDefault: {
          "& .MuiChip-avatarMedium, .MuiChip-avatarSmall": {
            color: e.palette.text.secondary
          }
        },
        outlined: {
          borderColor: e.palette.grey[50032],
          "&.MuiChip-colorPrimary": {
            borderColor: e.palette.primary.main
          },
          "&.MuiChip-colorSecondary": {
            borderColor: e.palette.secondary.main
          }
        },
        //
        avatarColorInfo: {
          color: e.palette.info.contrastText,
          backgroundColor: e.palette.info.dark
        },
        avatarColorSuccess: {
          color: e.palette.success.contrastText,
          backgroundColor: e.palette.success.dark
        },
        avatarColorWarning: {
          color: e.palette.warning.contrastText,
          backgroundColor: e.palette.warning.dark
        },
        avatarColorError: {
          color: e.palette.error.contrastText,
          backgroundColor: e.palette.error.dark
        }
      }
    }
  };
}
function ControlLabel(e) {
  return {
    MuiFormControlLabel: {
      styleOverrides: {
        label: {
          ...e.typography.body2
        }
      }
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          marginTop: e.spacing(1)
        }
      }
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          color: e.palette.text.disabled
        }
      }
    }
  };
}
function CssBaseline(e) {
  return {
    MuiCssBaseline: {
      styleOverrides: {
        "*": {
          margin: 0,
          padding: 0,
          boxSizing: "border-box"
        },
        html: {
          width: "100%",
          height: "100%",
          WebkitOverflowScrolling: "touch"
        },
        body: {
          width: "100%",
          height: "100%"
        },
        "#root": {
          width: "100%",
          height: "100%"
        },
        input: {
          "&[type=number]": {
            MozAppearance: "textfield",
            "&::-webkit-outer-spin-button": {
              margin: 0,
              WebkitAppearance: "none"
            },
            "&::-webkit-inner-spin-button": {
              margin: 0,
              WebkitAppearance: "none"
            }
          }
        },
        img: {
          display: "block",
          maxWidth: "100%"
        }
      }
    }
  };
}
function DataGrid(e) {
  return {
    MuiDataGrid: {
      styleOverrides: {
        root: {
          borderRadius: 0,
          border: "1px solid transparent",
          "& .MuiTablePagination-root": {
            borderTop: 0
          },
          "& .MuiDataGrid-toolbarContainer": {
            padding: e.spacing(2),
            backgroundColor: e.palette.background.neutral,
            "& .MuiButton-root": {
              marginRight: e.spacing(1.5),
              color: e.palette.text.primary,
              "&:hover": {
                backgroundColor: e.palette.action.hover
              }
            }
          },
          "& .MuiDataGrid-cell, .MuiDataGrid-columnsContainer": {
            borderBottom: `1px solid ${e.palette.divider}`
          },
          "& .MuiDataGrid-columnSeparator": {
            color: e.palette.divider
          },
          '& .MuiDataGrid-columnHeader[data-field="__check__"]': {
            padding: 0
          }
        }
      }
    },
    MuiGridMenu: {
      styleOverrides: {
        root: {
          "& .MuiDataGrid-gridMenuList": {
            boxShadow: e.customShadows.z20,
            borderRadius: e.shape.borderRadius
          },
          "& .MuiMenuItem-root": {
            ...e.typography.body2
          }
        }
      }
    },
    MuiGridFilterForm: {
      styleOverrides: {
        root: {
          padding: e.spacing(1.5, 0),
          "& .MuiFormControl-root": {
            margin: e.spacing(0, 0.5)
          },
          "& .MuiInput-root": {
            marginTop: e.spacing(3),
            "&::before, &::after": {
              display: "none"
            },
            "& .MuiNativeSelect-select, .MuiInput-input": {
              ...e.typography.body2,
              padding: e.spacing(0.75, 1),
              borderRadius: e.shape.borderRadius,
              backgroundColor: e.palette.background.neutral
            },
            "& .MuiSvgIcon-root": {
              right: 4
            }
          }
        }
      }
    },
    MuiGridPanelFooter: {
      styleOverrides: {
        root: {
          padding: e.spacing(2),
          justifyContent: "flex-end",
          "& .MuiButton-root": {
            "&:first-of-type": {
              marginRight: e.spacing(1.5),
              color: e.palette.text.primary,
              "&:hover": {
                backgroundColor: e.palette.action.hover
              }
            },
            "&:last-of-type": {
              color: e.palette.common.white,
              backgroundColor: e.palette.primary.main,
              "&:hover": {
                backgroundColor: e.palette.primary.dark
              }
            }
          }
        }
      }
    }
  };
}
function Dialog$1(e) {
  return {
    MuiDialog: {
      styleOverrides: {
        paper: {
          boxShadow: e.customShadows.dialog,
          "&.MuiPaper-rounded": {
            borderRadius: Number(e.shape.borderRadius) * 2
          },
          "&.MuiDialog-paperFullScreen": {
            borderRadius: 0
          },
          "&.MuiDialog-paper .MuiDialogActions-root": {
            padding: e.spacing(3)
          },
          "@media (max-width: 600px)": {
            margin: e.spacing(2)
          },
          "@media (max-width: 663.95px)": {
            "&.MuiDialog-paperWidthSm.MuiDialog-paperScrollBody": {
              maxWidth: "100%"
            }
          }
        },
        paperFullWidth: {
          width: "100%"
        }
      }
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          padding: e.spacing(3, 3, 0)
        }
      }
    },
    MuiDialogContent: {
      styleOverrides: {
        root: {
          borderTop: 0,
          borderBottom: 0,
          padding: e.spacing(3)
        }
      }
    },
    MuiDialogActions: {
      styleOverrides: {
        root: {
          "& > :not(:first-of-type)": {
            marginLeft: e.spacing(1.5)
          }
        }
      }
    }
  };
}
function Drawer(e) {
  const t = e.palette.mode === "light";
  return {
    MuiDrawer: {
      styleOverrides: {
        modal: {
          '&[role="presentation"]': {
            "& .MuiDrawer-paperAnchorLeft": {
              boxShadow: `8px 24px 24px 12px ${alpha$2(
                e.palette.grey[900],
                t ? 0.16 : 0.48
              )}`
            },
            "& .MuiDrawer-paperAnchorRight": {
              boxShadow: `-8px 24px 24px 12px ${alpha$2(
                e.palette.grey[900],
                t ? 0.16 : 0.48
              )}`
            }
          }
        }
      }
    }
  };
}
function Fab(e) {
  return {
    MuiFab: {
      defaultProps: {
        color: "primary"
      },
      styleOverrides: {
        root: {
          boxShadow: e.customShadows.z8,
          "&:hover": {
            boxShadow: "none",
            backgroundColor: e.palette.grey[400]
          }
        },
        primary: {
          boxShadow: e.customShadows.primary,
          "&:hover": {
            backgroundColor: e.palette.primary.dark
          }
        },
        secondary: {
          boxShadow: e.customShadows.secondary,
          "&:hover": {
            backgroundColor: e.palette.secondary.dark
          }
        },
        extended: {
          "& svg": {
            marginRight: e.spacing(1)
          }
        }
      }
    }
  };
}
function Input$1(e) {
  return {
    MuiInputBase: {
      styleOverrides: {
        root: {
          "&.Mui-disabled": {
            "& svg": { color: e.palette.text.disabled }
          }
        },
        input: {
          "&::placeholder": {
            opacity: 1,
            color: e.palette.text.disabled
          }
        }
      }
    },
    MuiInput: {
      styleOverrides: {
        underline: {
          "&:before": {
            borderBottomColor: e.palette.grey[50056]
          }
        }
      }
    },
    MuiFilledInput: {
      styleOverrides: {
        root: {
          backgroundColor: e.palette.grey[50012],
          "&:hover": {
            backgroundColor: e.palette.grey[50016]
          },
          "&.Mui-focused": {
            backgroundColor: e.palette.action.focus
          },
          "&.Mui-disabled": {
            backgroundColor: e.palette.action.disabledBackground
          }
        },
        underline: {
          "&:before": {
            borderBottomColor: e.palette.grey[50056]
          }
        }
      }
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: e.palette.grey[50032]
          },
          "&.Mui-disabled": {
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: e.palette.action.disabledBackground
            }
          }
        }
      }
    }
  };
}
function Link(e) {
  return {
    MuiLink: {
      defaultProps: {
        underline: "hover"
      }
    }
  };
}
function List$1(e) {
  return {
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          color: "inherit",
          minWidth: "auto",
          marginRight: e.spacing(2)
        }
      }
    },
    MuiListItemAvatar: {
      styleOverrides: {
        root: {
          minWidth: "auto",
          marginRight: e.spacing(2)
        }
      }
    },
    MuiListItemText: {
      styleOverrides: {
        root: {
          marginTop: 0,
          marginBottom: 0
        },
        multiline: {
          marginTop: 0,
          marginBottom: 0
        }
      }
    }
  };
}
function LoadingButton(e) {
  return {
    MuiLoadingButton: {
      styleOverrides: {
        root: {
          textTransform: "uppercase",
          "&.MuiButton-text": {
            "& .MuiLoadingButton-startIconPendingStart": {
              marginLeft: 0
            },
            "& .MuiLoadingButton-endIconPendingEnd": {
              marginRight: 0
            }
          }
        }
      }
    }
  };
}
function Menu$1(e) {
  return {
    MuiMenuItem: {
      styleOverrides: {
        root: {
          "&.Mui-selected": {
            backgroundColor: e.palette.action.selected,
            "&:hover": {
              backgroundColor: e.palette.action.hover
            }
          }
        }
      }
    }
  };
}
function Pagination(e) {
  return {
    MuiPaginationItem: {
      styleOverrides: {
        root: {
          "&.Mui-selected": {
            fontWeight: e.typography.fontWeightBold
          }
        },
        textPrimary: {
          "&.Mui-selected": {
            color: e.palette.primary.main,
            backgroundColor: alpha$1(e.palette.primary.main, 0.08),
            "&:hover, &.Mui-focusVisible": {
              backgroundColor: `${alpha$1(
                e.palette.primary.main,
                0.24
              )} !important`
            }
          }
        },
        outlined: {
          border: `1px solid ${e.palette.grey[50032]}`
        },
        outlinedPrimary: {
          "&.Mui-selected": {
            backgroundColor: alpha$1(e.palette.primary.main, 0.08),
            border: `1px solid ${alpha$1(e.palette.primary.main, 0.24)}`
          }
        }
      }
    }
  };
}
function Paper$1(e) {
  return {
    MuiPaper: {
      defaultProps: {
        elevation: 0
      },
      variants: [
        {
          props: { variant: "outlined" },
          style: { borderColor: e.palette.grey[50012] }
        }
      ],
      styleOverrides: {
        root: {
          backgroundImage: "none"
        }
      }
    }
  };
}
function Popover$1(e) {
  return {
    MuiPopover: {
      styleOverrides: {
        paper: {
          boxShadow: e.customShadows.dropdown,
          borderRadius: Number(e.shape.borderRadius) * 1.5
        }
      }
    }
  };
}
function Progress(e) {
  const t = e.palette.mode === "light";
  return {
    MuiLinearProgress: {
      styleOverrides: {
        root: {
          borderRadius: 4,
          overflow: "hidden"
        },
        bar: {
          borderRadius: 4
        },
        colorPrimary: {
          backgroundColor: e.palette.primary[t ? "lighter" : "darker"]
        },
        buffer: {
          backgroundColor: "transparent"
        }
      }
    }
  };
}
function Radio(e) {
  return {
    MuiRadio: {
      styleOverrides: {
        root: {
          padding: e.spacing(1),
          svg: {
            fontSize: 24,
            "&[font-size=small]": {
              fontSize: 20
            }
          }
        }
      }
    }
  };
}
const ICON_SMALL = { width: 20, height: 20 }, ICON_LARGE = { width: 28, height: 28 };
function Rating(e) {
  return {
    MuiRating: {
      defaultProps: {
        emptyIcon: /* @__PURE__ */ jsxRuntimeExports.jsx(StarIcon, {}),
        icon: /* @__PURE__ */ jsxRuntimeExports.jsx(StarIcon, {})
      },
      styleOverrides: {
        root: {
          "&.Mui-disabled": {
            opacity: 0.48
          }
        },
        iconEmpty: { color: e.palette.grey[50048] },
        sizeSmall: { "& svg": { ...ICON_SMALL } },
        sizeLarge: { "& svg": { ...ICON_LARGE } }
      }
    }
  };
}
function Select$1(e) {
  return {
    MuiSelect: {
      defaultProps: {
        IconComponent: InputSelectIcon
      }
    }
  };
}
function Skeleton(e) {
  return {
    MuiSkeleton: {
      defaultProps: {
        animation: "wave",
        variant: "rounded"
      },
      styleOverrides: {
        root: {
          backgroundColor: e.palette.grey[300],
          "&.MuiSkeleton-rounded": {
            borderRadius: Number(e.shape.borderRadius) / 2
          }
        }
      }
    }
  };
}
function Slider(e) {
  const t = e.palette.mode === "light";
  return {
    MuiSlider: {
      defaultProps: {
        size: "small"
      },
      styleOverrides: {
        root: {
          "&.Mui-disabled": {
            color: e.palette.action.disabled
          }
        },
        markLabel: {
          fontSize: 13,
          color: e.palette.text.disabled
        },
        valueLabel: {
          borderRadius: 8,
          backgroundColor: e.palette.grey[t ? 800 : 700]
        }
      }
    }
  };
}
function Stepper(e) {
  return {
    MuiStepConnector: {
      styleOverrides: {
        line: {
          borderColor: e.palette.divider
        }
      }
    }
  };
}
function SvgIcon$1(e) {
  return {
    MuiSvgIcon: {
      styleOverrides: {
        fontSizeSmall: {
          width: 20,
          height: 20,
          fontSize: "inherit"
        },
        fontSizeLarge: {
          width: 32,
          height: 32,
          fontSize: "inherit"
        }
      }
    }
  };
}
function Switch(e) {
  const t = e.palette.mode === "light";
  return {
    MuiSwitch: {
      styleOverrides: {
        thumb: {
          boxShadow: e.customShadows.z1
        },
        track: {
          opacity: 1,
          backgroundColor: e.palette.grey[500]
        },
        switchBase: {
          left: 0,
          right: "auto",
          "&:not(:.Mui-checked)": {
            color: e.palette.grey[t ? 100 : 300]
          },
          "&.Mui-checked.Mui-disabled, &.Mui-disabled": {
            color: e.palette.grey[t ? 400 : 600]
          },
          "&.Mui-disabled+.MuiSwitch-track": {
            opacity: 1,
            backgroundColor: `${e.palette.action.disabledBackground} !important`
          }
        }
      }
    }
  };
}
function Table(e) {
  return {
    MuiTableRow: {
      styleOverrides: {
        root: {
          "&.Mui-selected": {
            backgroundColor: e.palette.action.selected,
            "&:hover": {
              backgroundColor: e.palette.action.hover
            }
          }
        }
      }
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          borderBottom: "none"
        },
        head: {
          color: e.palette.text.secondary,
          backgroundColor: e.palette.background.neutral,
          "&:first-of-type": {
            paddingLeft: e.spacing(3),
            borderTopLeftRadius: e.shape.borderRadius,
            borderBottomLeftRadius: e.shape.borderRadius,
            boxShadow: `inset 8px 0 0 ${e.palette.background.paper}`
          },
          "&:last-of-type": {
            paddingRight: e.spacing(3),
            borderTopRightRadius: e.shape.borderRadius,
            borderBottomRightRadius: e.shape.borderRadius,
            boxShadow: `inset -8px 0 0 ${e.palette.background.paper}`
          }
        },
        stickyHeader: {
          backgroundColor: e.palette.background.paper,
          backgroundImage: `linear-gradient(to bottom, ${e.palette.background.neutral} 0%, ${e.palette.background.neutral} 100%)`
        },
        body: {
          "&:first-of-type": {
            paddingLeft: e.spacing(3)
          },
          "&:last-of-type": {
            paddingRight: e.spacing(3)
          }
        }
      }
    },
    MuiTablePagination: {
      styleOverrides: {
        root: {
          borderTop: `solid 1px ${e.palette.divider}`
        },
        toolbar: {
          height: 64
        },
        select: {
          "&:focus": {
            borderRadius: e.shape.borderRadius
          }
        },
        selectIcon: {
          width: 20,
          height: 20,
          marginTop: -4
        }
      }
    }
  };
}
function Tabs(e) {
  return {
    MuiTab: {
      styleOverrides: {
        root: {
          padding: 0,
          fontWeight: e.typography.fontWeightMedium,
          borderTopLeftRadius: e.shape.borderRadius,
          borderTopRightRadius: e.shape.borderRadius,
          "&.Mui-selected": {
            color: e.palette.text.primary
          },
          "&:not(:last-of-type)": {
            marginRight: e.spacing(5)
          },
          "@media (min-width: 600px)": {
            minWidth: 48
          }
        },
        labelIcon: {
          minHeight: 48,
          flexDirection: "row",
          "& > *:first-of-type": {
            marginBottom: 0,
            marginRight: e.spacing(1)
          }
        },
        wrapper: {
          flexDirection: "row",
          whiteSpace: "nowrap"
        },
        textColorInherit: {
          opacity: 1,
          color: e.palette.text.secondary
        }
      }
    },
    MuiTabPanel: {
      styleOverrides: {
        root: {
          padding: 0
        }
      }
    },
    MuiTabScrollButton: {
      styleOverrides: {
        root: {
          width: 48,
          borderRadius: "50%"
        }
      }
    }
  };
}
function Timeline(e) {
  return {
    MuiTimelineDot: {
      styleOverrides: {
        root: {
          boxShadow: "none"
        }
      }
    },
    MuiTimelineConnector: {
      styleOverrides: {
        root: {
          backgroundColor: e.palette.divider
        }
      }
    }
  };
}
function ToggleButton(e) {
  const t = (o) => ({
    props: { color: o },
    style: {
      "&:hover": {
        borderColor: alpha$1(e.palette[o].main, 0.48),
        backgroundColor: alpha$1(
          e.palette[o].main,
          e.palette.action.hoverOpacity
        )
      },
      "&.Mui-selected": {
        borderColor: alpha$1(e.palette[o].main, 0.48)
      }
    }
  });
  return {
    MuiToggleButton: {
      variants: [
        {
          props: { color: "standard" },
          style: {
            "&.Mui-selected": {
              backgroundColor: e.palette.action.selected
            }
          }
        },
        t("primary"),
        t("secondary"),
        t("info"),
        t("success"),
        t("warning"),
        t("error")
      ]
    },
    MuiToggleButtonGroup: {
      styleOverrides: {
        root: {
          borderRadius: e.shape.borderRadius,
          backgroundColor: e.palette.background.paper,
          border: `solid 1px ${e.palette.grey[50012]}`,
          "& .MuiToggleButton-root": {
            margin: 4,
            borderColor: "transparent !important",
            borderRadius: `${e.shape.borderRadius}px !important`
          }
        }
      }
    }
  };
}
function Tooltip(e) {
  const t = e.palette.mode === "light";
  return {
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: e.palette.grey[t ? 800 : 700]
        },
        arrow: {
          color: e.palette.grey[t ? 800 : 700]
        }
      }
    }
  };
}
function TreeView(e) {
  return {
    MuiTreeView: {
      defaultProps: {
        defaultCollapseIcon: /* @__PURE__ */ jsxRuntimeExports.jsx(TreeViewCollapseIcon, { sx: { width: 20, height: 20 } }),
        defaultExpandIcon: /* @__PURE__ */ jsxRuntimeExports.jsx(TreeViewExpandIcon, { sx: { width: 20, height: 20 } }),
        defaultEndIcon: /* @__PURE__ */ jsxRuntimeExports.jsx(
          TreeViewEndIcon,
          {
            sx: { color: "text.secondary", width: 20, height: 20 }
          }
        )
      }
    },
    MuiTreeItem: {
      styleOverrides: {
        label: { ...e.typography.body2 },
        iconContainer: { width: "auto" }
      }
    }
  };
}
function Typography$1(e) {
  return {
    MuiTypography: {
      styleOverrides: {
        paragraph: {
          marginBottom: e.spacing(2)
        },
        gutterBottom: {
          marginBottom: e.spacing(1)
        }
      }
    }
  };
}
const componentsOverrides = (e) => Object.assign(
  Fab(e),
  Tabs(e),
  Chip$1(e),
  Card(e),
  Menu$1(e),
  Link(),
  Input$1(e),
  Radio(e),
  Badge(),
  List$1(e),
  Table(e),
  Paper$1(e),
  Alert(e),
  Switch(e),
  Select$1(),
  Button$4(e),
  Rating(e),
  Dialog$1(e),
  Avatar(e),
  Slider(e),
  Drawer(e),
  Stepper(e),
  Tooltip(e),
  Popover$1(e),
  SvgIcon$1(),
  Checkbox(e),
  DataGrid(e),
  Skeleton(e),
  Timeline(e),
  TreeView(e),
  Backdrop$1(e),
  Progress(e),
  Accordion(e),
  Typography$1(e),
  Pagination(e),
  ButtonGroup(e),
  Breadcrumbs(e),
  CssBaseline(),
  Autocomplete(e),
  ControlLabel(e),
  ToggleButton(e),
  LoadingButton()
), pxToRem = (e) => `${e / 16}rem`, responsiveFontSizes = ({
  sm: e,
  md: t,
  lg: o
}) => ({
  "@media (min-width:600px)": {
    fontSize: pxToRem(e)
  },
  "@media (min-width:900px)": {
    fontSize: pxToRem(t)
  },
  "@media (min-width:1200px)": {
    fontSize: pxToRem(o)
  }
}), FONT_PRIMARY = "Inter, sans-serif", typography = {
  fontFamily: FONT_PRIMARY,
  fontWeightRegular: 400,
  fontWeightMedium: 600,
  fontWeightBold: 700,
  h1: {
    fontWeight: 700,
    lineHeight: 80 / 64,
    fontSize: pxToRem(40),
    letterSpacing: 2,
    ...responsiveFontSizes({ sm: 52, md: 58, lg: 64 })
  },
  h2: {
    fontWeight: 700,
    lineHeight: 64 / 48,
    fontSize: pxToRem(32),
    ...responsiveFontSizes({ sm: 40, md: 44, lg: 48 })
  },
  h3: {
    fontWeight: 700,
    lineHeight: 1.5,
    fontSize: pxToRem(24),
    ...responsiveFontSizes({ sm: 26, md: 30, lg: 32 })
  },
  h4: {
    fontWeight: 700,
    lineHeight: 1.5,
    fontSize: pxToRem(20),
    ...responsiveFontSizes({ sm: 20, md: 24, lg: 24 })
  },
  h5: {
    fontWeight: 700,
    lineHeight: 1.5,
    fontSize: pxToRem(18),
    ...responsiveFontSizes({ sm: 19, md: 20, lg: 20 })
  },
  h6: {
    fontWeight: 700,
    lineHeight: 28 / 18,
    fontSize: pxToRem(17),
    ...responsiveFontSizes({ sm: 18, md: 18, lg: 18 })
  },
  subtitle1: {
    fontWeight: 600,
    lineHeight: 1.5,
    fontSize: pxToRem(16)
  },
  subtitle2: {
    fontWeight: 600,
    lineHeight: 22 / 14,
    fontSize: pxToRem(14)
  },
  body1: {
    lineHeight: 1.5,
    fontSize: pxToRem(16)
  },
  body2: {
    lineHeight: 22 / 14,
    fontSize: pxToRem(14)
  },
  caption: {
    lineHeight: 1.5,
    fontSize: pxToRem(12)
  },
  overline: {
    fontWeight: 700,
    lineHeight: 1.5,
    fontSize: pxToRem(12),
    textTransform: "uppercase"
  },
  button: {
    fontWeight: 700,
    lineHeight: 24 / 14,
    fontSize: pxToRem(14),
    textTransform: "uppercase"
  }
}, ThemeProvider = ({ children: e }) => {
  const t = useMemo(
    () => ({
      palette: palette.light,
      typography,
      breakpoints,
      shape: { borderRadius: 8 },
      shadows: shadows.light,
      customShadows: customShadows.light
    }),
    []
  ), o = createTheme$2(t);
  return o.components = componentsOverrides(o), /* @__PURE__ */ jsxRuntimeExports.jsx(StyledEngineProvider, { injectFirst: !0, children: /* @__PURE__ */ jsxRuntimeExports.jsx(ThemeProvider$1, { theme: o, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(ThemeProvider$4, { theme: o, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(CssBaseline$1, {}),
    e
  ] }) }) });
}, CustomizeInternalAspectCard = styled(Card$1)(({ theme: e }) => ({
  display: "flex",
  gap: e.spacing(0.5),
  justifyContent: "space-between",
  width: "100%",
  padding: e.spacing(2),
  cursor: "pointer"
})), SkeletonCard = styled(Card$1)(({ theme: e }) => ({
  display: "flex",
  flexDirection: "column",
  gap: e.spacing(1),
  justifyContent: "space-between",
  width: "100%",
  padding: e.spacing(2),
  cursor: "pointer"
})), TextWithEllipsis = styled(Typography$2, {
  shouldForwardProp: (e) => e !== "widthSizeInPixel"
})(({ widthSizeInPixel: e }) => ({
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  overflow: "hidden",
  width: e ?? "80%"
})), BaseCard = ({ children: e, onClick: t }) => /* @__PURE__ */ jsxRuntimeExports.jsx(CustomizeInternalAspectCard, { "data-testid": "base-card", onClick: t, children: /* @__PURE__ */ jsxRuntimeExports.jsx(CustomizeContent$1, { children: e }) }), CustomizeContent$1 = styled(Box)(({ theme: e }) => ({
  display: "flex",
  flex: 1,
  flexDirection: "column",
  gap: e.spacing(1),
  width: "100%"
})), DEFAULT_ICON_SIZE = 36, FIRST_LINE_ICON_SIZE = 20, SECOND_LINE_ICON_SIZE = 12, ADDRESS_ICON_SIZE = 12, ADD_ICON_SIZE = 36, REMOVE_ICON_SIZE = 36, SELECTED_ICON_SIZE = 36, DEFAULT_VARIANT_FIRST_LINE = "subtitle2", DEFAULT_VARIANT_SECOND_LINE = "caption", DEFAULT_VARIANT_THIRD_LINE = "caption", FONT_WEIGHT_FIRST_LINE = 700, FONT_WEIGHT_SECOND_LINE = 400, LINE_HEIGHT_FIRST_LINE = "22px", LINE_HEIGHT_SECOND_LINE = "18px", LINE_HEIGHT_THIRD_LINE = "18px", FirstLine = ({
  content: e,
  icon: t,
  showIcon: o = !0,
  backgroundColor: n = "",
  variant: s = DEFAULT_VARIANT_FIRST_LINE,
  sizeIcon: i = DEFAULT_ICON_SIZE,
  textColor: l = ""
}) => {
  const d = useTheme$4(), u = l ?? d.palette.text.primary;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Row$4, { "data-testid": "first-line", children: [
    o ? /* @__PURE__ */ jsxRuntimeExports.jsx(
      IconWrapper,
      {
        backgroundColor: n,
        size: i,
        testId: "first-line-icon",
        children: t
      }
    ) : "",
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Typography$2,
      {
        variant: s,
        color: u,
        "data-testid": "first-line-text",
        fontWeight: FONT_WEIGHT_FIRST_LINE,
        lineHeight: LINE_HEIGHT_FIRST_LINE,
        children: e
      }
    )
  ] });
}, Row$4 = styled(Box)(({ theme: e }) => ({
  display: "flex",
  alignItems: "center",
  gap: e.spacing(1)
})), SecondLine = ({
  content: e,
  icon: t,
  showIcon: o = !0,
  backgroundColor: n = "",
  variant: s = DEFAULT_VARIANT_SECOND_LINE,
  sizeIcon: i = DEFAULT_ICON_SIZE,
  textColor: l = ""
}) => {
  const d = e;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Row$3, { "data-testid": "second-line", title: d, children: [
    o ? /* @__PURE__ */ jsxRuntimeExports.jsx(
      IconWrapper,
      {
        backgroundColor: n,
        size: i,
        testId: "second-line-icon",
        children: t
      }
    ) : "",
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      TextWithEllipsis,
      {
        variant: s,
        color: l,
        fontWeight: FONT_WEIGHT_SECOND_LINE,
        lineHeight: LINE_HEIGHT_SECOND_LINE,
        "data-testid": "second-line-text",
        children: e
      }
    )
  ] });
}, Row$3 = styled(Box)(({ theme: e }) => ({
  display: "flex",
  alignItems: "center",
  gap: e.spacing(0.8)
})), ThirdLine = ({
  content: e,
  icon: t,
  showIcon: o = !0,
  backgroundColor: n = "",
  variant: s = DEFAULT_VARIANT_THIRD_LINE,
  sizeIcon: i = DEFAULT_ICON_SIZE,
  textColor: l = ""
}) => {
  const d = e;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Row$2, { "data-testid": "third-line", title: d, children: [
    o ? /* @__PURE__ */ jsxRuntimeExports.jsx(
      IconWrapper,
      {
        backgroundColor: n,
        size: i,
        testId: "third-line-icon",
        children: t
      }
    ) : "",
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      TextWithEllipsis,
      {
        variant: s,
        color: l,
        fontWeight: DEFAULT_VARIANT_THIRD_LINE,
        lineHeight: LINE_HEIGHT_THIRD_LINE,
        "data-testid": "third-line-text",
        children: e
      }
    )
  ] });
}, Row$2 = styled(Box)(({ theme: e }) => ({
  display: "flex",
  alignItems: "center",
  gap: e.spacing(0.8)
})), LayoutGroupContext = createContext({});
function useConstant(e) {
  const t = useRef(null);
  return t.current === null && (t.current = e()), t.current;
}
const isBrowser = typeof window < "u", useIsomorphicLayoutEffect = isBrowser ? useLayoutEffect : useEffect, PresenceContext = /* @__PURE__ */ createContext(null);
function addUniqueItem(e, t) {
  e.indexOf(t) === -1 && e.push(t);
}
function removeItem(e, t) {
  const o = e.indexOf(t);
  o > -1 && e.splice(o, 1);
}
const clamp = (e, t, o) => o > t ? t : o < e ? e : o;
function formatErrorMessage(e, t) {
  return t ? `${e}. For more information and steps for solving, visit https://motion.dev/troubleshooting/${t}` : e;
}
let warning = () => {
}, invariant = () => {
};
process.env.NODE_ENV !== "production" && (warning = (e, t, o) => {
  !e && typeof console < "u" && console.warn(formatErrorMessage(t, o));
}, invariant = (e, t, o) => {
  if (!e)
    throw new Error(formatErrorMessage(t, o));
});
const MotionGlobalConfig = {}, isNumericalString = (e) => /^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(e);
function isObject$1(e) {
  return typeof e == "object" && e !== null;
}
const isZeroValueString = (e) => /^0[^.\s]+$/u.test(e);
// @__NO_SIDE_EFFECTS__
function memo(e) {
  let t;
  return () => (t === void 0 && (t = e()), t);
}
const noop$5 = /* @__NO_SIDE_EFFECTS__ */ (e) => e, combineFunctions = (e, t) => (o) => t(e(o)), pipe = (...e) => e.reduce(combineFunctions), progress = /* @__NO_SIDE_EFFECTS__ */ (e, t, o) => {
  const n = t - e;
  return n === 0 ? 1 : (o - e) / n;
};
class SubscriptionManager {
  constructor() {
    this.subscriptions = [];
  }
  add(t) {
    return addUniqueItem(this.subscriptions, t), () => removeItem(this.subscriptions, t);
  }
  notify(t, o, n) {
    const s = this.subscriptions.length;
    if (s)
      if (s === 1)
        this.subscriptions[0](t, o, n);
      else
        for (let i = 0; i < s; i++) {
          const l = this.subscriptions[i];
          l && l(t, o, n);
        }
  }
  getSize() {
    return this.subscriptions.length;
  }
  clear() {
    this.subscriptions.length = 0;
  }
}
const secondsToMilliseconds = /* @__NO_SIDE_EFFECTS__ */ (e) => e * 1e3, millisecondsToSeconds = /* @__NO_SIDE_EFFECTS__ */ (e) => e / 1e3;
function velocityPerSecond(e, t) {
  return t ? e * (1e3 / t) : 0;
}
const warned = /* @__PURE__ */ new Set();
function warnOnce$1(e, t, o) {
  e || warned.has(t) || (console.warn(formatErrorMessage(t, o)), warned.add(t));
}
const calcBezier = (e, t, o) => (((1 - 3 * o + 3 * t) * e + (3 * o - 6 * t)) * e + 3 * t) * e, subdivisionPrecision = 1e-7, subdivisionMaxIterations = 12;
function binarySubdivide(e, t, o, n, s) {
  let i, l, d = 0;
  do
    l = t + (o - t) / 2, i = calcBezier(l, n, s) - e, i > 0 ? o = l : t = l;
  while (Math.abs(i) > subdivisionPrecision && ++d < subdivisionMaxIterations);
  return l;
}
function cubicBezier(e, t, o, n) {
  if (e === t && o === n)
    return noop$5;
  const s = (i) => binarySubdivide(i, 0, 1, e, o);
  return (i) => i === 0 || i === 1 ? i : calcBezier(s(i), t, n);
}
const mirrorEasing = (e) => (t) => t <= 0.5 ? e(2 * t) / 2 : (2 - e(2 * (1 - t))) / 2, reverseEasing = (e) => (t) => 1 - e(1 - t), backOut = /* @__PURE__ */ cubicBezier(0.33, 1.53, 0.69, 0.99), backIn = /* @__PURE__ */ reverseEasing(backOut), backInOut = /* @__PURE__ */ mirrorEasing(backIn), anticipate = (e) => (e *= 2) < 1 ? 0.5 * backIn(e) : 0.5 * (2 - Math.pow(2, -10 * (e - 1))), circIn = (e) => 1 - Math.sin(Math.acos(e)), circOut = reverseEasing(circIn), circInOut = mirrorEasing(circIn), easeIn = /* @__PURE__ */ cubicBezier(0.42, 0, 1, 1), easeOut = /* @__PURE__ */ cubicBezier(0, 0, 0.58, 1), easeInOut = /* @__PURE__ */ cubicBezier(0.42, 0, 0.58, 1), isEasingArray = (e) => Array.isArray(e) && typeof e[0] != "number", isBezierDefinition = (e) => Array.isArray(e) && typeof e[0] == "number", easingLookup = {
  linear: noop$5,
  easeIn,
  easeInOut,
  easeOut,
  circIn,
  circInOut,
  circOut,
  backIn,
  backInOut,
  backOut,
  anticipate
}, isValidEasing = (e) => typeof e == "string", easingDefinitionToFunction = (e) => {
  if (isBezierDefinition(e)) {
    invariant(e.length === 4, "Cubic bezier arrays must contain four numerical values.", "cubic-bezier-length");
    const [t, o, n, s] = e;
    return cubicBezier(t, o, n, s);
  } else if (isValidEasing(e))
    return invariant(easingLookup[e] !== void 0, `Invalid easing type '${e}'`, "invalid-easing-type"), easingLookup[e];
  return e;
}, stepsOrder = [
  "setup",
  // Compute
  "read",
  // Read
  "resolveKeyframes",
  // Write/Read/Write/Read
  "preUpdate",
  // Compute
  "update",
  // Compute
  "preRender",
  // Compute
  "render",
  // Write
  "postRender"
  // Compute
];
function createRenderStep(e, t) {
  let o = /* @__PURE__ */ new Set(), n = /* @__PURE__ */ new Set(), s = !1, i = !1;
  const l = /* @__PURE__ */ new WeakSet();
  let d = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  };
  function u(p) {
    l.has(p) && (c.schedule(p), e()), p(d);
  }
  const c = {
    /**
     * Schedule a process to run on the next frame.
     */
    schedule: (p, f = !1, g = !1) => {
      const h = g && s ? o : n;
      return f && l.add(p), h.has(p) || h.add(p), p;
    },
    /**
     * Cancel the provided callback from running on the next frame.
     */
    cancel: (p) => {
      n.delete(p), l.delete(p);
    },
    /**
     * Execute all schedule callbacks.
     */
    process: (p) => {
      if (d = p, s) {
        i = !0;
        return;
      }
      s = !0, [o, n] = [n, o], o.forEach(u), o.clear(), s = !1, i && (i = !1, c.process(p));
    }
  };
  return c;
}
const maxElapsed = 40;
function createRenderBatcher(e, t) {
  let o = !1, n = !0;
  const s = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  }, i = () => o = !0, l = stepsOrder.reduce((R, C) => (R[C] = createRenderStep(i), R), {}), { setup: d, read: u, resolveKeyframes: c, preUpdate: p, update: f, preRender: g, render: y, postRender: h } = l, T = () => {
    const R = MotionGlobalConfig.useManualTiming ? s.timestamp : performance.now();
    o = !1, MotionGlobalConfig.useManualTiming || (s.delta = n ? 1e3 / 60 : Math.max(Math.min(R - s.timestamp, maxElapsed), 1)), s.timestamp = R, s.isProcessing = !0, d.process(s), u.process(s), c.process(s), p.process(s), f.process(s), g.process(s), y.process(s), h.process(s), s.isProcessing = !1, o && t && (n = !1, e(T));
  }, P = () => {
    o = !0, n = !0, s.isProcessing || e(T);
  };
  return { schedule: stepsOrder.reduce((R, C) => {
    const x = l[C];
    return R[C] = (_, D = !1, O = !1) => (o || P(), x.schedule(_, D, O)), R;
  }, {}), cancel: (R) => {
    for (let C = 0; C < stepsOrder.length; C++)
      l[stepsOrder[C]].cancel(R);
  }, state: s, steps: l };
}
const { schedule: frame, cancel: cancelFrame, state: frameData, steps: frameSteps } = /* @__PURE__ */ createRenderBatcher(typeof requestAnimationFrame < "u" ? requestAnimationFrame : noop$5, !0);
let now;
function clearTime() {
  now = void 0;
}
const time = {
  now: () => (now === void 0 && time.set(frameData.isProcessing || MotionGlobalConfig.useManualTiming ? frameData.timestamp : performance.now()), now),
  set: (e) => {
    now = e, queueMicrotask(clearTime);
  }
}, checkStringStartsWith = (e) => (t) => typeof t == "string" && t.startsWith(e), isCSSVariableName = /* @__PURE__ */ checkStringStartsWith("--"), startsAsVariableToken = /* @__PURE__ */ checkStringStartsWith("var(--"), isCSSVariableToken = (e) => startsAsVariableToken(e) ? singleCssVariableRegex.test(e.split("/*")[0].trim()) : !1, singleCssVariableRegex = /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu, number$1 = {
  test: (e) => typeof e == "number",
  parse: parseFloat,
  transform: (e) => e
}, alpha = {
  ...number$1,
  transform: (e) => clamp(0, 1, e)
}, scale = {
  ...number$1,
  default: 1
}, sanitize = (e) => Math.round(e * 1e5) / 1e5, floatRegex = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu;
function isNullish(e) {
  return e == null;
}
const singleColorRegex = /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu, isColorString = (e, t) => (o) => !!(typeof o == "string" && singleColorRegex.test(o) && o.startsWith(e) || t && !isNullish(o) && Object.prototype.hasOwnProperty.call(o, t)), splitColor = (e, t, o) => (n) => {
  if (typeof n != "string")
    return n;
  const [s, i, l, d] = n.match(floatRegex);
  return {
    [e]: parseFloat(s),
    [t]: parseFloat(i),
    [o]: parseFloat(l),
    alpha: d !== void 0 ? parseFloat(d) : 1
  };
}, clampRgbUnit = (e) => clamp(0, 255, e), rgbUnit = {
  ...number$1,
  transform: (e) => Math.round(clampRgbUnit(e))
}, rgba = {
  test: /* @__PURE__ */ isColorString("rgb", "red"),
  parse: /* @__PURE__ */ splitColor("red", "green", "blue"),
  transform: ({ red: e, green: t, blue: o, alpha: n = 1 }) => "rgba(" + rgbUnit.transform(e) + ", " + rgbUnit.transform(t) + ", " + rgbUnit.transform(o) + ", " + sanitize(alpha.transform(n)) + ")"
};
function parseHex(e) {
  let t = "", o = "", n = "", s = "";
  return e.length > 5 ? (t = e.substring(1, 3), o = e.substring(3, 5), n = e.substring(5, 7), s = e.substring(7, 9)) : (t = e.substring(1, 2), o = e.substring(2, 3), n = e.substring(3, 4), s = e.substring(4, 5), t += t, o += o, n += n, s += s), {
    red: parseInt(t, 16),
    green: parseInt(o, 16),
    blue: parseInt(n, 16),
    alpha: s ? parseInt(s, 16) / 255 : 1
  };
}
const hex = {
  test: /* @__PURE__ */ isColorString("#"),
  parse: parseHex,
  transform: rgba.transform
}, createUnitType = /* @__NO_SIDE_EFFECTS__ */ (e) => ({
  test: (t) => typeof t == "string" && t.endsWith(e) && t.split(" ").length === 1,
  parse: parseFloat,
  transform: (t) => `${t}${e}`
}), degrees = /* @__PURE__ */ createUnitType("deg"), percent = /* @__PURE__ */ createUnitType("%"), px = /* @__PURE__ */ createUnitType("px"), vh = /* @__PURE__ */ createUnitType("vh"), vw = /* @__PURE__ */ createUnitType("vw"), progressPercentage = {
  ...percent,
  parse: (e) => percent.parse(e) / 100,
  transform: (e) => percent.transform(e * 100)
}, hsla = {
  test: /* @__PURE__ */ isColorString("hsl", "hue"),
  parse: /* @__PURE__ */ splitColor("hue", "saturation", "lightness"),
  transform: ({ hue: e, saturation: t, lightness: o, alpha: n = 1 }) => "hsla(" + Math.round(e) + ", " + percent.transform(sanitize(t)) + ", " + percent.transform(sanitize(o)) + ", " + sanitize(alpha.transform(n)) + ")"
}, color = {
  test: (e) => rgba.test(e) || hex.test(e) || hsla.test(e),
  parse: (e) => rgba.test(e) ? rgba.parse(e) : hsla.test(e) ? hsla.parse(e) : hex.parse(e),
  transform: (e) => typeof e == "string" ? e : e.hasOwnProperty("red") ? rgba.transform(e) : hsla.transform(e),
  getAnimatableNone: (e) => {
    const t = color.parse(e);
    return t.alpha = 0, color.transform(t);
  }
}, colorRegex = /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu;
function test$1(e) {
  return isNaN(e) && typeof e == "string" && (e.match(floatRegex)?.length || 0) + (e.match(colorRegex)?.length || 0) > 0;
}
const NUMBER_TOKEN = "number", COLOR_TOKEN = "color", VAR_TOKEN = "var", VAR_FUNCTION_TOKEN = "var(", SPLIT_TOKEN = "${}", complexRegex = /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;
function analyseComplexValue(e) {
  const t = e.toString(), o = [], n = {
    color: [],
    number: [],
    var: []
  }, s = [];
  let i = 0;
  const d = t.replace(complexRegex, (u) => (color.test(u) ? (n.color.push(i), s.push(COLOR_TOKEN), o.push(color.parse(u))) : u.startsWith(VAR_FUNCTION_TOKEN) ? (n.var.push(i), s.push(VAR_TOKEN), o.push(u)) : (n.number.push(i), s.push(NUMBER_TOKEN), o.push(parseFloat(u))), ++i, SPLIT_TOKEN)).split(SPLIT_TOKEN);
  return { values: o, split: d, indexes: n, types: s };
}
function parseComplexValue(e) {
  return analyseComplexValue(e).values;
}
function createTransformer(e) {
  const { split: t, types: o } = analyseComplexValue(e), n = t.length;
  return (s) => {
    let i = "";
    for (let l = 0; l < n; l++)
      if (i += t[l], s[l] !== void 0) {
        const d = o[l];
        d === NUMBER_TOKEN ? i += sanitize(s[l]) : d === COLOR_TOKEN ? i += color.transform(s[l]) : i += s[l];
      }
    return i;
  };
}
const convertNumbersToZero = (e) => typeof e == "number" ? 0 : color.test(e) ? color.getAnimatableNone(e) : e;
function getAnimatableNone$1(e) {
  const t = parseComplexValue(e);
  return createTransformer(e)(t.map(convertNumbersToZero));
}
const complex = {
  test: test$1,
  parse: parseComplexValue,
  createTransformer,
  getAnimatableNone: getAnimatableNone$1
};
function hueToRgb(e, t, o) {
  return o < 0 && (o += 1), o > 1 && (o -= 1), o < 1 / 6 ? e + (t - e) * 6 * o : o < 1 / 2 ? t : o < 2 / 3 ? e + (t - e) * (2 / 3 - o) * 6 : e;
}
function hslaToRgba({ hue: e, saturation: t, lightness: o, alpha: n }) {
  e /= 360, t /= 100, o /= 100;
  let s = 0, i = 0, l = 0;
  if (!t)
    s = i = l = o;
  else {
    const d = o < 0.5 ? o * (1 + t) : o + t - o * t, u = 2 * o - d;
    s = hueToRgb(u, d, e + 1 / 3), i = hueToRgb(u, d, e), l = hueToRgb(u, d, e - 1 / 3);
  }
  return {
    red: Math.round(s * 255),
    green: Math.round(i * 255),
    blue: Math.round(l * 255),
    alpha: n
  };
}
function mixImmediate(e, t) {
  return (o) => o > 0 ? t : e;
}
const mixNumber$1 = (e, t, o) => e + (t - e) * o, mixLinearColor = (e, t, o) => {
  const n = e * e, s = o * (t * t - n) + n;
  return s < 0 ? 0 : Math.sqrt(s);
}, colorTypes = [hex, rgba, hsla], getColorType = (e) => colorTypes.find((t) => t.test(e));
function asRGBA(e) {
  const t = getColorType(e);
  if (warning(!!t, `'${e}' is not an animatable color. Use the equivalent color code instead.`, "color-not-animatable"), !t)
    return !1;
  let o = t.parse(e);
  return t === hsla && (o = hslaToRgba(o)), o;
}
const mixColor = (e, t) => {
  const o = asRGBA(e), n = asRGBA(t);
  if (!o || !n)
    return mixImmediate(e, t);
  const s = { ...o };
  return (i) => (s.red = mixLinearColor(o.red, n.red, i), s.green = mixLinearColor(o.green, n.green, i), s.blue = mixLinearColor(o.blue, n.blue, i), s.alpha = mixNumber$1(o.alpha, n.alpha, i), rgba.transform(s));
}, invisibleValues = /* @__PURE__ */ new Set(["none", "hidden"]);
function mixVisibility(e, t) {
  return invisibleValues.has(e) ? (o) => o <= 0 ? e : t : (o) => o >= 1 ? t : e;
}
function mixNumber(e, t) {
  return (o) => mixNumber$1(e, t, o);
}
function getMixer(e) {
  return typeof e == "number" ? mixNumber : typeof e == "string" ? isCSSVariableToken(e) ? mixImmediate : color.test(e) ? mixColor : mixComplex : Array.isArray(e) ? mixArray : typeof e == "object" ? color.test(e) ? mixColor : mixObject : mixImmediate;
}
function mixArray(e, t) {
  const o = [...e], n = o.length, s = e.map((i, l) => getMixer(i)(i, t[l]));
  return (i) => {
    for (let l = 0; l < n; l++)
      o[l] = s[l](i);
    return o;
  };
}
function mixObject(e, t) {
  const o = { ...e, ...t }, n = {};
  for (const s in o)
    e[s] !== void 0 && t[s] !== void 0 && (n[s] = getMixer(e[s])(e[s], t[s]));
  return (s) => {
    for (const i in n)
      o[i] = n[i](s);
    return o;
  };
}
function matchOrder(e, t) {
  const o = [], n = { color: 0, var: 0, number: 0 };
  for (let s = 0; s < t.values.length; s++) {
    const i = t.types[s], l = e.indexes[i][n[i]], d = e.values[l] ?? 0;
    o[s] = d, n[i]++;
  }
  return o;
}
const mixComplex = (e, t) => {
  const o = complex.createTransformer(t), n = analyseComplexValue(e), s = analyseComplexValue(t);
  return n.indexes.var.length === s.indexes.var.length && n.indexes.color.length === s.indexes.color.length && n.indexes.number.length >= s.indexes.number.length ? invisibleValues.has(e) && !s.values.length || invisibleValues.has(t) && !n.values.length ? mixVisibility(e, t) : pipe(mixArray(matchOrder(n, s), s.values), o) : (warning(!0, `Complex values '${e}' and '${t}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`, "complex-values-different"), mixImmediate(e, t));
};
function mix(e, t, o) {
  return typeof e == "number" && typeof t == "number" && typeof o == "number" ? mixNumber$1(e, t, o) : getMixer(e)(e, t);
}
const frameloopDriver = (e) => {
  const t = ({ timestamp: o }) => e(o);
  return {
    start: (o = !0) => frame.update(t, o),
    stop: () => cancelFrame(t),
    /**
     * If we're processing this frame we can use the
     * framelocked timestamp to keep things in sync.
     */
    now: () => frameData.isProcessing ? frameData.timestamp : time.now()
  };
}, generateLinearEasing = (e, t, o = 10) => {
  let n = "";
  const s = Math.max(Math.round(t / o), 2);
  for (let i = 0; i < s; i++)
    n += Math.round(e(i / (s - 1)) * 1e4) / 1e4 + ", ";
  return `linear(${n.substring(0, n.length - 2)})`;
}, maxGeneratorDuration = 2e4;
function calcGeneratorDuration(e) {
  let t = 0;
  const o = 50;
  let n = e.next(t);
  for (; !n.done && t < maxGeneratorDuration; )
    t += o, n = e.next(t);
  return t >= maxGeneratorDuration ? 1 / 0 : t;
}
function createGeneratorEasing(e, t = 100, o) {
  const n = o({ ...e, keyframes: [0, t] }), s = Math.min(calcGeneratorDuration(n), maxGeneratorDuration);
  return {
    type: "keyframes",
    ease: (i) => n.next(s * i).value / t,
    duration: /* @__PURE__ */ millisecondsToSeconds(s)
  };
}
const velocitySampleDuration = 5;
function calcGeneratorVelocity(e, t, o) {
  const n = Math.max(t - velocitySampleDuration, 0);
  return velocityPerSecond(o - e(n), t - n);
}
const springDefaults = {
  // Default spring physics
  stiffness: 100,
  damping: 10,
  mass: 1,
  velocity: 0,
  // Default duration/bounce-based options
  duration: 800,
  // in ms
  bounce: 0.3,
  visualDuration: 0.3,
  // in seconds
  // Rest thresholds
  restSpeed: {
    granular: 0.01,
    default: 2
  },
  restDelta: {
    granular: 5e-3,
    default: 0.5
  },
  // Limits
  minDuration: 0.01,
  // in seconds
  maxDuration: 10,
  // in seconds
  minDamping: 0.05,
  maxDamping: 1
}, safeMin = 1e-3;
function findSpring({ duration: e = springDefaults.duration, bounce: t = springDefaults.bounce, velocity: o = springDefaults.velocity, mass: n = springDefaults.mass }) {
  let s, i;
  warning(e <= /* @__PURE__ */ secondsToMilliseconds(springDefaults.maxDuration), "Spring duration must be 10 seconds or less", "spring-duration-limit");
  let l = 1 - t;
  l = clamp(springDefaults.minDamping, springDefaults.maxDamping, l), e = clamp(springDefaults.minDuration, springDefaults.maxDuration, /* @__PURE__ */ millisecondsToSeconds(e)), l < 1 ? (s = (c) => {
    const p = c * l, f = p * e, g = p - o, y = calcAngularFreq(c, l), h = Math.exp(-f);
    return safeMin - g / y * h;
  }, i = (c) => {
    const f = c * l * e, g = f * o + o, y = Math.pow(l, 2) * Math.pow(c, 2) * e, h = Math.exp(-f), T = calcAngularFreq(Math.pow(c, 2), l);
    return (-s(c) + safeMin > 0 ? -1 : 1) * ((g - y) * h) / T;
  }) : (s = (c) => {
    const p = Math.exp(-c * e), f = (c - o) * e + 1;
    return -safeMin + p * f;
  }, i = (c) => {
    const p = Math.exp(-c * e), f = (o - c) * (e * e);
    return p * f;
  });
  const d = 5 / e, u = approximateRoot(s, i, d);
  if (e = /* @__PURE__ */ secondsToMilliseconds(e), isNaN(u))
    return {
      stiffness: springDefaults.stiffness,
      damping: springDefaults.damping,
      duration: e
    };
  {
    const c = Math.pow(u, 2) * n;
    return {
      stiffness: c,
      damping: l * 2 * Math.sqrt(n * c),
      duration: e
    };
  }
}
const rootIterations = 12;
function approximateRoot(e, t, o) {
  let n = o;
  for (let s = 1; s < rootIterations; s++)
    n = n - e(n) / t(n);
  return n;
}
function calcAngularFreq(e, t) {
  return e * Math.sqrt(1 - t * t);
}
const durationKeys = ["duration", "bounce"], physicsKeys = ["stiffness", "damping", "mass"];
function isSpringType(e, t) {
  return t.some((o) => e[o] !== void 0);
}
function getSpringOptions(e) {
  let t = {
    velocity: springDefaults.velocity,
    stiffness: springDefaults.stiffness,
    damping: springDefaults.damping,
    mass: springDefaults.mass,
    isResolvedFromDuration: !1,
    ...e
  };
  if (!isSpringType(e, physicsKeys) && isSpringType(e, durationKeys))
    if (e.visualDuration) {
      const o = e.visualDuration, n = 2 * Math.PI / (o * 1.2), s = n * n, i = 2 * clamp(0.05, 1, 1 - (e.bounce || 0)) * Math.sqrt(s);
      t = {
        ...t,
        mass: springDefaults.mass,
        stiffness: s,
        damping: i
      };
    } else {
      const o = findSpring(e);
      t = {
        ...t,
        ...o,
        mass: springDefaults.mass
      }, t.isResolvedFromDuration = !0;
    }
  return t;
}
function spring(e = springDefaults.visualDuration, t = springDefaults.bounce) {
  const o = typeof e != "object" ? {
    visualDuration: e,
    keyframes: [0, 1],
    bounce: t
  } : e;
  let { restSpeed: n, restDelta: s } = o;
  const i = o.keyframes[0], l = o.keyframes[o.keyframes.length - 1], d = { done: !1, value: i }, { stiffness: u, damping: c, mass: p, duration: f, velocity: g, isResolvedFromDuration: y } = getSpringOptions({
    ...o,
    velocity: -/* @__PURE__ */ millisecondsToSeconds(o.velocity || 0)
  }), h = g || 0, T = c / (2 * Math.sqrt(u * p)), P = l - i, E = /* @__PURE__ */ millisecondsToSeconds(Math.sqrt(u / p)), $ = Math.abs(P) < 5;
  n || (n = $ ? springDefaults.restSpeed.granular : springDefaults.restSpeed.default), s || (s = $ ? springDefaults.restDelta.granular : springDefaults.restDelta.default);
  let R;
  if (T < 1) {
    const x = calcAngularFreq(E, T);
    R = (_) => {
      const D = Math.exp(-T * E * _);
      return l - D * ((h + T * E * P) / x * Math.sin(x * _) + P * Math.cos(x * _));
    };
  } else if (T === 1)
    R = (x) => l - Math.exp(-E * x) * (P + (h + E * P) * x);
  else {
    const x = E * Math.sqrt(T * T - 1);
    R = (_) => {
      const D = Math.exp(-T * E * _), O = Math.min(x * _, 300);
      return l - D * ((h + T * E * P) * Math.sinh(O) + x * P * Math.cosh(O)) / x;
    };
  }
  const C = {
    calculatedDuration: y && f || null,
    next: (x) => {
      const _ = R(x);
      if (y)
        d.done = x >= f;
      else {
        let D = x === 0 ? h : 0;
        T < 1 && (D = x === 0 ? /* @__PURE__ */ secondsToMilliseconds(h) : calcGeneratorVelocity(R, x, _));
        const O = Math.abs(D) <= n, v = Math.abs(l - _) <= s;
        d.done = O && v;
      }
      return d.value = d.done ? l : _, d;
    },
    toString: () => {
      const x = Math.min(calcGeneratorDuration(C), maxGeneratorDuration), _ = generateLinearEasing((D) => C.next(x * D).value, x, 30);
      return x + "ms " + _;
    },
    toTransition: () => {
    }
  };
  return C;
}
spring.applyToOptions = (e) => {
  const t = createGeneratorEasing(e, 100, spring);
  return e.ease = t.ease, e.duration = /* @__PURE__ */ secondsToMilliseconds(t.duration), e.type = "keyframes", e;
};
function inertia({ keyframes: e, velocity: t = 0, power: o = 0.8, timeConstant: n = 325, bounceDamping: s = 10, bounceStiffness: i = 500, modifyTarget: l, min: d, max: u, restDelta: c = 0.5, restSpeed: p }) {
  const f = e[0], g = {
    done: !1,
    value: f
  }, y = (O) => d !== void 0 && O < d || u !== void 0 && O > u, h = (O) => d === void 0 ? u : u === void 0 || Math.abs(d - O) < Math.abs(u - O) ? d : u;
  let T = o * t;
  const P = f + T, E = l === void 0 ? P : l(P);
  E !== P && (T = E - f);
  const $ = (O) => -T * Math.exp(-O / n), R = (O) => E + $(O), C = (O) => {
    const v = $(O), w = R(O);
    g.done = Math.abs(v) <= c, g.value = g.done ? E : w;
  };
  let x, _;
  const D = (O) => {
    y(g.value) && (x = O, _ = spring({
      keyframes: [g.value, h(g.value)],
      velocity: calcGeneratorVelocity(R, O, g.value),
      // TODO: This should be passing * 1000
      damping: s,
      stiffness: i,
      restDelta: c,
      restSpeed: p
    }));
  };
  return D(0), {
    calculatedDuration: null,
    next: (O) => {
      let v = !1;
      return !_ && x === void 0 && (v = !0, C(O), D(O)), x !== void 0 && O >= x ? _.next(O - x) : (!v && C(O), g);
    }
  };
}
function createMixers(e, t, o) {
  const n = [], s = o || MotionGlobalConfig.mix || mix, i = e.length - 1;
  for (let l = 0; l < i; l++) {
    let d = s(e[l], e[l + 1]);
    if (t) {
      const u = Array.isArray(t) ? t[l] || noop$5 : t;
      d = pipe(u, d);
    }
    n.push(d);
  }
  return n;
}
function interpolate(e, t, { clamp: o = !0, ease: n, mixer: s } = {}) {
  const i = e.length;
  if (invariant(i === t.length, "Both input and output ranges must be the same length", "range-length"), i === 1)
    return () => t[0];
  if (i === 2 && t[0] === t[1])
    return () => t[1];
  const l = e[0] === e[1];
  e[0] > e[i - 1] && (e = [...e].reverse(), t = [...t].reverse());
  const d = createMixers(t, n, s), u = d.length, c = (p) => {
    if (l && p < e[0])
      return t[0];
    let f = 0;
    if (u > 1)
      for (; f < e.length - 2 && !(p < e[f + 1]); f++)
        ;
    const g = /* @__PURE__ */ progress(e[f], e[f + 1], p);
    return d[f](g);
  };
  return o ? (p) => c(clamp(e[0], e[i - 1], p)) : c;
}
function fillOffset(e, t) {
  const o = e[e.length - 1];
  for (let n = 1; n <= t; n++) {
    const s = /* @__PURE__ */ progress(0, t, n);
    e.push(mixNumber$1(o, 1, s));
  }
}
function defaultOffset(e) {
  const t = [0];
  return fillOffset(t, e.length - 1), t;
}
function convertOffsetToTimes(e, t) {
  return e.map((o) => o * t);
}
function defaultEasing(e, t) {
  return e.map(() => t || easeInOut).splice(0, e.length - 1);
}
function keyframes({ duration: e = 300, keyframes: t, times: o, ease: n = "easeInOut" }) {
  const s = isEasingArray(n) ? n.map(easingDefinitionToFunction) : easingDefinitionToFunction(n), i = {
    done: !1,
    value: t[0]
  }, l = convertOffsetToTimes(
    // Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    o && o.length === t.length ? o : defaultOffset(t),
    e
  ), d = interpolate(l, t, {
    ease: Array.isArray(s) ? s : defaultEasing(t, s)
  });
  return {
    calculatedDuration: e,
    next: (u) => (i.value = d(u), i.done = u >= e, i)
  };
}
const isNotNull$1 = (e) => e !== null;
function getFinalKeyframe$1(e, { repeat: t, repeatType: o = "loop" }, n, s = 1) {
  const i = e.filter(isNotNull$1), d = s < 0 || t && o !== "loop" && t % 2 === 1 ? 0 : i.length - 1;
  return !d || n === void 0 ? i[d] : n;
}
const transitionTypeMap = {
  decay: inertia,
  inertia,
  tween: keyframes,
  keyframes,
  spring
};
function replaceTransitionType(e) {
  typeof e.type == "string" && (e.type = transitionTypeMap[e.type]);
}
class WithPromise {
  constructor() {
    this.updateFinished();
  }
  get finished() {
    return this._finished;
  }
  updateFinished() {
    this._finished = new Promise((t) => {
      this.resolve = t;
    });
  }
  notifyFinished() {
    this.resolve();
  }
  /**
   * Allows the animation to be awaited.
   *
   * @deprecated Use `finished` instead.
   */
  then(t, o) {
    return this.finished.then(t, o);
  }
}
const percentToProgress = (e) => e / 100;
class JSAnimation extends WithPromise {
  constructor(t) {
    super(), this.state = "idle", this.startTime = null, this.isStopped = !1, this.currentTime = 0, this.holdTime = null, this.playbackSpeed = 1, this.stop = () => {
      const { motionValue: o } = this.options;
      o && o.updatedAt !== time.now() && this.tick(time.now()), this.isStopped = !0, this.state !== "idle" && (this.teardown(), this.options.onStop?.());
    }, this.options = t, this.initAnimation(), this.play(), t.autoplay === !1 && this.pause();
  }
  initAnimation() {
    const { options: t } = this;
    replaceTransitionType(t);
    const { type: o = keyframes, repeat: n = 0, repeatDelay: s = 0, repeatType: i, velocity: l = 0 } = t;
    let { keyframes: d } = t;
    const u = o || keyframes;
    process.env.NODE_ENV !== "production" && u !== keyframes && invariant(d.length <= 2, `Only two keyframes currently supported with spring and inertia animations. Trying to animate ${d}`, "spring-two-frames"), u !== keyframes && typeof d[0] != "number" && (this.mixKeyframes = pipe(percentToProgress, mix(d[0], d[1])), d = [0, 100]);
    const c = u({ ...t, keyframes: d });
    i === "mirror" && (this.mirroredGenerator = u({
      ...t,
      keyframes: [...d].reverse(),
      velocity: -l
    })), c.calculatedDuration === null && (c.calculatedDuration = calcGeneratorDuration(c));
    const { calculatedDuration: p } = c;
    this.calculatedDuration = p, this.resolvedDuration = p + s, this.totalDuration = this.resolvedDuration * (n + 1) - s, this.generator = c;
  }
  updateTime(t) {
    const o = Math.round(t - this.startTime) * this.playbackSpeed;
    this.holdTime !== null ? this.currentTime = this.holdTime : this.currentTime = o;
  }
  tick(t, o = !1) {
    const { generator: n, totalDuration: s, mixKeyframes: i, mirroredGenerator: l, resolvedDuration: d, calculatedDuration: u } = this;
    if (this.startTime === null)
      return n.next(0);
    const { delay: c = 0, keyframes: p, repeat: f, repeatType: g, repeatDelay: y, type: h, onUpdate: T, finalKeyframe: P } = this.options;
    this.speed > 0 ? this.startTime = Math.min(this.startTime, t) : this.speed < 0 && (this.startTime = Math.min(t - s / this.speed, this.startTime)), o ? this.currentTime = t : this.updateTime(t);
    const E = this.currentTime - c * (this.playbackSpeed >= 0 ? 1 : -1), $ = this.playbackSpeed >= 0 ? E < 0 : E > s;
    this.currentTime = Math.max(E, 0), this.state === "finished" && this.holdTime === null && (this.currentTime = s);
    let R = this.currentTime, C = n;
    if (f) {
      const O = Math.min(this.currentTime, s) / d;
      let v = Math.floor(O), w = O % 1;
      !w && O >= 1 && (w = 1), w === 1 && v--, v = Math.min(v, f + 1), !!(v % 2) && (g === "reverse" ? (w = 1 - w, y && (w -= y / d)) : g === "mirror" && (C = l)), R = clamp(0, 1, w) * d;
    }
    const x = $ ? { done: !1, value: p[0] } : C.next(R);
    i && (x.value = i(x.value));
    let { done: _ } = x;
    !$ && u !== null && (_ = this.playbackSpeed >= 0 ? this.currentTime >= s : this.currentTime <= 0);
    const D = this.holdTime === null && (this.state === "finished" || this.state === "running" && _);
    return D && h !== inertia && (x.value = getFinalKeyframe$1(p, this.options, P, this.speed)), T && T(x.value), D && this.finish(), x;
  }
  /**
   * Allows the returned animation to be awaited or promise-chained. Currently
   * resolves when the animation finishes at all but in a future update could/should
   * reject if its cancels.
   */
  then(t, o) {
    return this.finished.then(t, o);
  }
  get duration() {
    return /* @__PURE__ */ millisecondsToSeconds(this.calculatedDuration);
  }
  get iterationDuration() {
    const { delay: t = 0 } = this.options || {};
    return this.duration + /* @__PURE__ */ millisecondsToSeconds(t);
  }
  get time() {
    return /* @__PURE__ */ millisecondsToSeconds(this.currentTime);
  }
  set time(t) {
    t = /* @__PURE__ */ secondsToMilliseconds(t), this.currentTime = t, this.startTime === null || this.holdTime !== null || this.playbackSpeed === 0 ? this.holdTime = t : this.driver && (this.startTime = this.driver.now() - t / this.playbackSpeed), this.driver?.start(!1);
  }
  get speed() {
    return this.playbackSpeed;
  }
  set speed(t) {
    this.updateTime(time.now());
    const o = this.playbackSpeed !== t;
    this.playbackSpeed = t, o && (this.time = /* @__PURE__ */ millisecondsToSeconds(this.currentTime));
  }
  play() {
    if (this.isStopped)
      return;
    const { driver: t = frameloopDriver, startTime: o } = this.options;
    this.driver || (this.driver = t((s) => this.tick(s))), this.options.onPlay?.();
    const n = this.driver.now();
    this.state === "finished" ? (this.updateFinished(), this.startTime = n) : this.holdTime !== null ? this.startTime = n - this.holdTime : this.startTime || (this.startTime = o ?? n), this.state === "finished" && this.speed < 0 && (this.startTime += this.calculatedDuration), this.holdTime = null, this.state = "running", this.driver.start();
  }
  pause() {
    this.state = "paused", this.updateTime(time.now()), this.holdTime = this.currentTime;
  }
  complete() {
    this.state !== "running" && this.play(), this.state = "finished", this.holdTime = null;
  }
  finish() {
    this.notifyFinished(), this.teardown(), this.state = "finished", this.options.onComplete?.();
  }
  cancel() {
    this.holdTime = null, this.startTime = 0, this.tick(0), this.teardown(), this.options.onCancel?.();
  }
  teardown() {
    this.state = "idle", this.stopDriver(), this.startTime = this.holdTime = null;
  }
  stopDriver() {
    this.driver && (this.driver.stop(), this.driver = void 0);
  }
  sample(t) {
    return this.startTime = 0, this.tick(t, !0);
  }
  attachTimeline(t) {
    return this.options.allowFlatten && (this.options.type = "keyframes", this.options.ease = "linear", this.initAnimation()), this.driver?.stop(), t.observe(this);
  }
}
function fillWildcards(e) {
  for (let t = 1; t < e.length; t++)
    e[t] ?? (e[t] = e[t - 1]);
}
const radToDeg = (e) => e * 180 / Math.PI, rotate = (e) => {
  const t = radToDeg(Math.atan2(e[1], e[0]));
  return rebaseAngle(t);
}, matrix2dParsers = {
  x: 4,
  y: 5,
  translateX: 4,
  translateY: 5,
  scaleX: 0,
  scaleY: 3,
  scale: (e) => (Math.abs(e[0]) + Math.abs(e[3])) / 2,
  rotate,
  rotateZ: rotate,
  skewX: (e) => radToDeg(Math.atan(e[1])),
  skewY: (e) => radToDeg(Math.atan(e[2])),
  skew: (e) => (Math.abs(e[1]) + Math.abs(e[2])) / 2
}, rebaseAngle = (e) => (e = e % 360, e < 0 && (e += 360), e), rotateZ = rotate, scaleX = (e) => Math.sqrt(e[0] * e[0] + e[1] * e[1]), scaleY = (e) => Math.sqrt(e[4] * e[4] + e[5] * e[5]), matrix3dParsers = {
  x: 12,
  y: 13,
  z: 14,
  translateX: 12,
  translateY: 13,
  translateZ: 14,
  scaleX,
  scaleY,
  scale: (e) => (scaleX(e) + scaleY(e)) / 2,
  rotateX: (e) => rebaseAngle(radToDeg(Math.atan2(e[6], e[5]))),
  rotateY: (e) => rebaseAngle(radToDeg(Math.atan2(-e[2], e[0]))),
  rotateZ,
  rotate: rotateZ,
  skewX: (e) => radToDeg(Math.atan(e[4])),
  skewY: (e) => radToDeg(Math.atan(e[1])),
  skew: (e) => (Math.abs(e[1]) + Math.abs(e[4])) / 2
};
function defaultTransformValue(e) {
  return e.includes("scale") ? 1 : 0;
}
function parseValueFromTransform(e, t) {
  if (!e || e === "none")
    return defaultTransformValue(t);
  const o = e.match(/^matrix3d\(([-\d.e\s,]+)\)$/u);
  let n, s;
  if (o)
    n = matrix3dParsers, s = o;
  else {
    const d = e.match(/^matrix\(([-\d.e\s,]+)\)$/u);
    n = matrix2dParsers, s = d;
  }
  if (!s)
    return defaultTransformValue(t);
  const i = n[t], l = s[1].split(",").map(convertTransformToNumber);
  return typeof i == "function" ? i(l) : l[i];
}
const readTransformValue = (e, t) => {
  const { transform: o = "none" } = getComputedStyle(e);
  return parseValueFromTransform(o, t);
};
function convertTransformToNumber(e) {
  return parseFloat(e.trim());
}
const transformPropOrder = [
  "transformPerspective",
  "x",
  "y",
  "z",
  "translateX",
  "translateY",
  "translateZ",
  "scale",
  "scaleX",
  "scaleY",
  "rotate",
  "rotateX",
  "rotateY",
  "rotateZ",
  "skew",
  "skewX",
  "skewY"
], transformProps = new Set(transformPropOrder), isNumOrPxType = (e) => e === number$1 || e === px, transformKeys = /* @__PURE__ */ new Set(["x", "y", "z"]), nonTranslationalTransformKeys = transformPropOrder.filter((e) => !transformKeys.has(e));
function removeNonTranslationalTransform(e) {
  const t = [];
  return nonTranslationalTransformKeys.forEach((o) => {
    const n = e.getValue(o);
    n !== void 0 && (t.push([o, n.get()]), n.set(o.startsWith("scale") ? 1 : 0));
  }), t;
}
const positionalValues = {
  // Dimensions
  width: ({ x: e }, { paddingLeft: t = "0", paddingRight: o = "0" }) => e.max - e.min - parseFloat(t) - parseFloat(o),
  height: ({ y: e }, { paddingTop: t = "0", paddingBottom: o = "0" }) => e.max - e.min - parseFloat(t) - parseFloat(o),
  top: (e, { top: t }) => parseFloat(t),
  left: (e, { left: t }) => parseFloat(t),
  bottom: ({ y: e }, { top: t }) => parseFloat(t) + (e.max - e.min),
  right: ({ x: e }, { left: t }) => parseFloat(t) + (e.max - e.min),
  // Transform
  x: (e, { transform: t }) => parseValueFromTransform(t, "x"),
  y: (e, { transform: t }) => parseValueFromTransform(t, "y")
};
positionalValues.translateX = positionalValues.x;
positionalValues.translateY = positionalValues.y;
const toResolve = /* @__PURE__ */ new Set();
let isScheduled = !1, anyNeedsMeasurement = !1, isForced = !1;
function measureAllKeyframes() {
  if (anyNeedsMeasurement) {
    const e = Array.from(toResolve).filter((n) => n.needsMeasurement), t = new Set(e.map((n) => n.element)), o = /* @__PURE__ */ new Map();
    t.forEach((n) => {
      const s = removeNonTranslationalTransform(n);
      s.length && (o.set(n, s), n.render());
    }), e.forEach((n) => n.measureInitialState()), t.forEach((n) => {
      n.render();
      const s = o.get(n);
      s && s.forEach(([i, l]) => {
        n.getValue(i)?.set(l);
      });
    }), e.forEach((n) => n.measureEndState()), e.forEach((n) => {
      n.suspendedScrollY !== void 0 && window.scrollTo(0, n.suspendedScrollY);
    });
  }
  anyNeedsMeasurement = !1, isScheduled = !1, toResolve.forEach((e) => e.complete(isForced)), toResolve.clear();
}
function readAllKeyframes() {
  toResolve.forEach((e) => {
    e.readKeyframes(), e.needsMeasurement && (anyNeedsMeasurement = !0);
  });
}
function flushKeyframeResolvers() {
  isForced = !0, readAllKeyframes(), measureAllKeyframes(), isForced = !1;
}
class KeyframeResolver {
  constructor(t, o, n, s, i, l = !1) {
    this.state = "pending", this.isAsync = !1, this.needsMeasurement = !1, this.unresolvedKeyframes = [...t], this.onComplete = o, this.name = n, this.motionValue = s, this.element = i, this.isAsync = l;
  }
  scheduleResolve() {
    this.state = "scheduled", this.isAsync ? (toResolve.add(this), isScheduled || (isScheduled = !0, frame.read(readAllKeyframes), frame.resolveKeyframes(measureAllKeyframes))) : (this.readKeyframes(), this.complete());
  }
  readKeyframes() {
    const { unresolvedKeyframes: t, name: o, element: n, motionValue: s } = this;
    if (t[0] === null) {
      const i = s?.get(), l = t[t.length - 1];
      if (i !== void 0)
        t[0] = i;
      else if (n && o) {
        const d = n.readValue(o, l);
        d != null && (t[0] = d);
      }
      t[0] === void 0 && (t[0] = l), s && i === void 0 && s.set(t[0]);
    }
    fillWildcards(t);
  }
  setFinalKeyframe() {
  }
  measureInitialState() {
  }
  renderEndStyles() {
  }
  measureEndState() {
  }
  complete(t = !1) {
    this.state = "complete", this.onComplete(this.unresolvedKeyframes, this.finalKeyframe, t), toResolve.delete(this);
  }
  cancel() {
    this.state === "scheduled" && (toResolve.delete(this), this.state = "pending");
  }
  resume() {
    this.state === "pending" && this.scheduleResolve();
  }
}
const isCSSVar = (e) => e.startsWith("--");
function setStyle(e, t, o) {
  isCSSVar(t) ? e.style.setProperty(t, o) : e.style[t] = o;
}
const supportsScrollTimeline = /* @__PURE__ */ memo(() => window.ScrollTimeline !== void 0), supportsFlags = {};
function memoSupports(e, t) {
  const o = /* @__PURE__ */ memo(e);
  return () => supportsFlags[t] ?? o();
}
const supportsLinearEasing = /* @__PURE__ */ memoSupports(() => {
  try {
    document.createElement("div").animate({ opacity: 0 }, { easing: "linear(0, 1)" });
  } catch {
    return !1;
  }
  return !0;
}, "linearEasing"), cubicBezierAsString = ([e, t, o, n]) => `cubic-bezier(${e}, ${t}, ${o}, ${n})`, supportedWaapiEasing = {
  linear: "linear",
  ease: "ease",
  easeIn: "ease-in",
  easeOut: "ease-out",
  easeInOut: "ease-in-out",
  circIn: /* @__PURE__ */ cubicBezierAsString([0, 0.65, 0.55, 1]),
  circOut: /* @__PURE__ */ cubicBezierAsString([0.55, 0, 1, 0.45]),
  backIn: /* @__PURE__ */ cubicBezierAsString([0.31, 0.01, 0.66, -0.59]),
  backOut: /* @__PURE__ */ cubicBezierAsString([0.33, 1.53, 0.69, 0.99])
};
function mapEasingToNativeEasing(e, t) {
  if (e)
    return typeof e == "function" ? supportsLinearEasing() ? generateLinearEasing(e, t) : "ease-out" : isBezierDefinition(e) ? cubicBezierAsString(e) : Array.isArray(e) ? e.map((o) => mapEasingToNativeEasing(o, t) || supportedWaapiEasing.easeOut) : supportedWaapiEasing[e];
}
function startWaapiAnimation(e, t, o, { delay: n = 0, duration: s = 300, repeat: i = 0, repeatType: l = "loop", ease: d = "easeOut", times: u } = {}, c = void 0) {
  const p = {
    [t]: o
  };
  u && (p.offset = u);
  const f = mapEasingToNativeEasing(d, s);
  Array.isArray(f) && (p.easing = f);
  const g = {
    delay: n,
    duration: s,
    easing: Array.isArray(f) ? "linear" : f,
    fill: "both",
    iterations: i + 1,
    direction: l === "reverse" ? "alternate" : "normal"
  };
  return c && (g.pseudoElement = c), e.animate(p, g);
}
function isGenerator(e) {
  return typeof e == "function" && "applyToOptions" in e;
}
function applyGeneratorOptions({ type: e, ...t }) {
  return isGenerator(e) && supportsLinearEasing() ? e.applyToOptions(t) : (t.duration ?? (t.duration = 300), t.ease ?? (t.ease = "easeOut"), t);
}
class NativeAnimation extends WithPromise {
  constructor(t) {
    if (super(), this.finishedTime = null, this.isStopped = !1, !t)
      return;
    const { element: o, name: n, keyframes: s, pseudoElement: i, allowFlatten: l = !1, finalKeyframe: d, onComplete: u } = t;
    this.isPseudoElement = !!i, this.allowFlatten = l, this.options = t, invariant(typeof t.type != "string", `Mini animate() doesn't support "type" as a string.`, "mini-spring");
    const c = applyGeneratorOptions(t);
    this.animation = startWaapiAnimation(o, n, s, c, i), c.autoplay === !1 && this.animation.pause(), this.animation.onfinish = () => {
      if (this.finishedTime = this.time, !i) {
        const p = getFinalKeyframe$1(s, this.options, d, this.speed);
        this.updateMotionValue ? this.updateMotionValue(p) : setStyle(o, n, p), this.animation.cancel();
      }
      u?.(), this.notifyFinished();
    };
  }
  play() {
    this.isStopped || (this.animation.play(), this.state === "finished" && this.updateFinished());
  }
  pause() {
    this.animation.pause();
  }
  complete() {
    this.animation.finish?.();
  }
  cancel() {
    try {
      this.animation.cancel();
    } catch {
    }
  }
  stop() {
    if (this.isStopped)
      return;
    this.isStopped = !0;
    const { state: t } = this;
    t === "idle" || t === "finished" || (this.updateMotionValue ? this.updateMotionValue() : this.commitStyles(), this.isPseudoElement || this.cancel());
  }
  /**
   * WAAPI doesn't natively have any interruption capabilities.
   *
   * In this method, we commit styles back to the DOM before cancelling
   * the animation.
   *
   * This is designed to be overridden by NativeAnimationExtended, which
   * will create a renderless JS animation and sample it twice to calculate
   * its current value, "previous" value, and therefore allow
   * Motion to also correctly calculate velocity for any subsequent animation
   * while deferring the commit until the next animation frame.
   */
  commitStyles() {
    this.isPseudoElement || this.animation.commitStyles?.();
  }
  get duration() {
    const t = this.animation.effect?.getComputedTiming?.().duration || 0;
    return /* @__PURE__ */ millisecondsToSeconds(Number(t));
  }
  get iterationDuration() {
    const { delay: t = 0 } = this.options || {};
    return this.duration + /* @__PURE__ */ millisecondsToSeconds(t);
  }
  get time() {
    return /* @__PURE__ */ millisecondsToSeconds(Number(this.animation.currentTime) || 0);
  }
  set time(t) {
    this.finishedTime = null, this.animation.currentTime = /* @__PURE__ */ secondsToMilliseconds(t);
  }
  /**
   * The playback speed of the animation.
   * 1 = normal speed, 2 = double speed, 0.5 = half speed.
   */
  get speed() {
    return this.animation.playbackRate;
  }
  set speed(t) {
    t < 0 && (this.finishedTime = null), this.animation.playbackRate = t;
  }
  get state() {
    return this.finishedTime !== null ? "finished" : this.animation.playState;
  }
  get startTime() {
    return Number(this.animation.startTime);
  }
  set startTime(t) {
    this.animation.startTime = t;
  }
  /**
   * Attaches a timeline to the animation, for instance the `ScrollTimeline`.
   */
  attachTimeline({ timeline: t, observe: o }) {
    return this.allowFlatten && this.animation.effect?.updateTiming({ easing: "linear" }), this.animation.onfinish = null, t && supportsScrollTimeline() ? (this.animation.timeline = t, noop$5) : o(this);
  }
}
const unsupportedEasingFunctions = {
  anticipate,
  backInOut,
  circInOut
};
function isUnsupportedEase(e) {
  return e in unsupportedEasingFunctions;
}
function replaceStringEasing(e) {
  typeof e.ease == "string" && isUnsupportedEase(e.ease) && (e.ease = unsupportedEasingFunctions[e.ease]);
}
const sampleDelta = 10;
class NativeAnimationExtended extends NativeAnimation {
  constructor(t) {
    replaceStringEasing(t), replaceTransitionType(t), super(t), t.startTime && (this.startTime = t.startTime), this.options = t;
  }
  /**
   * WAAPI doesn't natively have any interruption capabilities.
   *
   * Rather than read commited styles back out of the DOM, we can
   * create a renderless JS animation and sample it twice to calculate
   * its current value, "previous" value, and therefore allow
   * Motion to calculate velocity for any subsequent animation.
   */
  updateMotionValue(t) {
    const { motionValue: o, onUpdate: n, onComplete: s, element: i, ...l } = this.options;
    if (!o)
      return;
    if (t !== void 0) {
      o.set(t);
      return;
    }
    const d = new JSAnimation({
      ...l,
      autoplay: !1
    }), u = /* @__PURE__ */ secondsToMilliseconds(this.finishedTime ?? this.time);
    o.setWithVelocity(d.sample(u - sampleDelta).value, d.sample(u).value, sampleDelta), d.stop();
  }
}
const isAnimatable = (e, t) => t === "zIndex" ? !1 : !!(typeof e == "number" || Array.isArray(e) || typeof e == "string" && // It's animatable if we have a string
(complex.test(e) || e === "0") && // And it contains numbers and/or colors
!e.startsWith("url("));
function hasKeyframesChanged(e) {
  const t = e[0];
  if (e.length === 1)
    return !0;
  for (let o = 0; o < e.length; o++)
    if (e[o] !== t)
      return !0;
}
function canAnimate(e, t, o, n) {
  const s = e[0];
  if (s === null)
    return !1;
  if (t === "display" || t === "visibility")
    return !0;
  const i = e[e.length - 1], l = isAnimatable(s, t), d = isAnimatable(i, t);
  return warning(l === d, `You are trying to animate ${t} from "${s}" to "${i}". "${l ? i : s}" is not an animatable value.`, "value-not-animatable"), !l || !d ? !1 : hasKeyframesChanged(e) || (o === "spring" || isGenerator(o)) && n;
}
function makeAnimationInstant(e) {
  e.duration = 0, e.type = "keyframes";
}
const acceleratedValues = /* @__PURE__ */ new Set([
  "opacity",
  "clipPath",
  "filter",
  "transform"
  // TODO: Could be re-enabled now we have support for linear() easing
  // "background-color"
]), supportsWaapi = /* @__PURE__ */ memo(() => Object.hasOwnProperty.call(Element.prototype, "animate"));
function supportsBrowserAnimation(e) {
  const { motionValue: t, name: o, repeatDelay: n, repeatType: s, damping: i, type: l } = e;
  if (!(t?.owner?.current instanceof HTMLElement))
    return !1;
  const { onUpdate: u, transformTemplate: c } = t.owner.getProps();
  return supportsWaapi() && o && acceleratedValues.has(o) && (o !== "transform" || !c) && /**
   * If we're outputting values to onUpdate then we can't use WAAPI as there's
   * no way to read the value from WAAPI every frame.
   */
  !u && !n && s !== "mirror" && i !== 0 && l !== "inertia";
}
const MAX_RESOLVE_DELAY = 40;
class AsyncMotionValueAnimation extends WithPromise {
  constructor({ autoplay: t = !0, delay: o = 0, type: n = "keyframes", repeat: s = 0, repeatDelay: i = 0, repeatType: l = "loop", keyframes: d, name: u, motionValue: c, element: p, ...f }) {
    super(), this.stop = () => {
      this._animation && (this._animation.stop(), this.stopTimeline?.()), this.keyframeResolver?.cancel();
    }, this.createdAt = time.now();
    const g = {
      autoplay: t,
      delay: o,
      type: n,
      repeat: s,
      repeatDelay: i,
      repeatType: l,
      name: u,
      motionValue: c,
      element: p,
      ...f
    }, y = p?.KeyframeResolver || KeyframeResolver;
    this.keyframeResolver = new y(d, (h, T, P) => this.onKeyframesResolved(h, T, g, !P), u, c, p), this.keyframeResolver?.scheduleResolve();
  }
  onKeyframesResolved(t, o, n, s) {
    this.keyframeResolver = void 0;
    const { name: i, type: l, velocity: d, delay: u, isHandoff: c, onUpdate: p } = n;
    this.resolvedAt = time.now(), canAnimate(t, i, l, d) || ((MotionGlobalConfig.instantAnimations || !u) && p?.(getFinalKeyframe$1(t, n, o)), t[0] = t[t.length - 1], makeAnimationInstant(n), n.repeat = 0);
    const g = {
      startTime: s ? this.resolvedAt ? this.resolvedAt - this.createdAt > MAX_RESOLVE_DELAY ? this.resolvedAt : this.createdAt : this.createdAt : void 0,
      finalKeyframe: o,
      ...n,
      keyframes: t
    }, y = !c && supportsBrowserAnimation(g) ? new NativeAnimationExtended({
      ...g,
      element: g.motionValue.owner.current
    }) : new JSAnimation(g);
    y.finished.then(() => this.notifyFinished()).catch(noop$5), this.pendingTimeline && (this.stopTimeline = y.attachTimeline(this.pendingTimeline), this.pendingTimeline = void 0), this._animation = y;
  }
  get finished() {
    return this._animation ? this.animation.finished : this._finished;
  }
  then(t, o) {
    return this.finished.finally(t).then(() => {
    });
  }
  get animation() {
    return this._animation || (this.keyframeResolver?.resume(), flushKeyframeResolvers()), this._animation;
  }
  get duration() {
    return this.animation.duration;
  }
  get iterationDuration() {
    return this.animation.iterationDuration;
  }
  get time() {
    return this.animation.time;
  }
  set time(t) {
    this.animation.time = t;
  }
  get speed() {
    return this.animation.speed;
  }
  get state() {
    return this.animation.state;
  }
  set speed(t) {
    this.animation.speed = t;
  }
  get startTime() {
    return this.animation.startTime;
  }
  attachTimeline(t) {
    return this._animation ? this.stopTimeline = this.animation.attachTimeline(t) : this.pendingTimeline = t, () => this.stop();
  }
  play() {
    this.animation.play();
  }
  pause() {
    this.animation.pause();
  }
  complete() {
    this.animation.complete();
  }
  cancel() {
    this._animation && this.animation.cancel(), this.keyframeResolver?.cancel();
  }
}
const splitCSSVariableRegex = (
  // eslint-disable-next-line redos-detector/no-unsafe-regex -- false positive, as it can match a lot of words
  /^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u
);
function parseCSSVariable(e) {
  const t = splitCSSVariableRegex.exec(e);
  if (!t)
    return [,];
  const [, o, n, s] = t;
  return [`--${o ?? n}`, s];
}
const maxDepth = 4;
function getVariableValue(e, t, o = 1) {
  invariant(o <= maxDepth, `Max CSS variable fallback depth detected in property "${e}". This may indicate a circular fallback dependency.`, "max-css-var-depth");
  const [n, s] = parseCSSVariable(e);
  if (!n)
    return;
  const i = window.getComputedStyle(t).getPropertyValue(n);
  if (i) {
    const l = i.trim();
    return isNumericalString(l) ? parseFloat(l) : l;
  }
  return isCSSVariableToken(s) ? getVariableValue(s, t, o + 1) : s;
}
function getValueTransition(e, t) {
  return e?.[t] ?? e?.default ?? e;
}
const positionalKeys = /* @__PURE__ */ new Set([
  "width",
  "height",
  "top",
  "left",
  "right",
  "bottom",
  ...transformPropOrder
]), auto$1 = {
  test: (e) => e === "auto",
  parse: (e) => e
}, testValueType = (e) => (t) => t.test(e), dimensionValueTypes = [number$1, px, percent, degrees, vw, vh, auto$1], findDimensionValueType = (e) => dimensionValueTypes.find(testValueType(e));
function isNone(e) {
  return typeof e == "number" ? e === 0 : e !== null ? e === "none" || e === "0" || isZeroValueString(e) : !0;
}
const maxDefaults = /* @__PURE__ */ new Set(["brightness", "contrast", "saturate", "opacity"]);
function applyDefaultFilter(e) {
  const [t, o] = e.slice(0, -1).split("(");
  if (t === "drop-shadow")
    return e;
  const [n] = o.match(floatRegex) || [];
  if (!n)
    return e;
  const s = o.replace(n, "");
  let i = maxDefaults.has(t) ? 1 : 0;
  return n !== o && (i *= 100), t + "(" + i + s + ")";
}
const functionRegex = /\b([a-z-]*)\(.*?\)/gu, filter = {
  ...complex,
  getAnimatableNone: (e) => {
    const t = e.match(functionRegex);
    return t ? t.map(applyDefaultFilter).join(" ") : e;
  }
}, int = {
  ...number$1,
  transform: Math.round
}, transformValueTypes = {
  rotate: degrees,
  rotateX: degrees,
  rotateY: degrees,
  rotateZ: degrees,
  scale,
  scaleX: scale,
  scaleY: scale,
  scaleZ: scale,
  skew: degrees,
  skewX: degrees,
  skewY: degrees,
  distance: px,
  translateX: px,
  translateY: px,
  translateZ: px,
  x: px,
  y: px,
  z: px,
  perspective: px,
  transformPerspective: px,
  opacity: alpha,
  originX: progressPercentage,
  originY: progressPercentage,
  originZ: px
}, numberValueTypes = {
  // Border props
  borderWidth: px,
  borderTopWidth: px,
  borderRightWidth: px,
  borderBottomWidth: px,
  borderLeftWidth: px,
  borderRadius: px,
  radius: px,
  borderTopLeftRadius: px,
  borderTopRightRadius: px,
  borderBottomRightRadius: px,
  borderBottomLeftRadius: px,
  // Positioning props
  width: px,
  maxWidth: px,
  height: px,
  maxHeight: px,
  top: px,
  right: px,
  bottom: px,
  left: px,
  // Spacing props
  padding: px,
  paddingTop: px,
  paddingRight: px,
  paddingBottom: px,
  paddingLeft: px,
  margin: px,
  marginTop: px,
  marginRight: px,
  marginBottom: px,
  marginLeft: px,
  // Misc
  backgroundPositionX: px,
  backgroundPositionY: px,
  ...transformValueTypes,
  zIndex: int,
  // SVG
  fillOpacity: alpha,
  strokeOpacity: alpha,
  numOctaves: int
}, defaultValueTypes = {
  ...numberValueTypes,
  // Color props
  color,
  backgroundColor: color,
  outlineColor: color,
  fill: color,
  stroke: color,
  // Border props
  borderColor: color,
  borderTopColor: color,
  borderRightColor: color,
  borderBottomColor: color,
  borderLeftColor: color,
  filter,
  WebkitFilter: filter
}, getDefaultValueType = (e) => defaultValueTypes[e];
function getAnimatableNone(e, t) {
  let o = getDefaultValueType(e);
  return o !== filter && (o = complex), o.getAnimatableNone ? o.getAnimatableNone(t) : void 0;
}
const invalidTemplates = /* @__PURE__ */ new Set(["auto", "none", "0"]);
function makeNoneKeyframesAnimatable(e, t, o) {
  let n = 0, s;
  for (; n < e.length && !s; ) {
    const i = e[n];
    typeof i == "string" && !invalidTemplates.has(i) && analyseComplexValue(i).values.length && (s = e[n]), n++;
  }
  if (s && o)
    for (const i of t)
      e[i] = getAnimatableNone(o, s);
}
class DOMKeyframesResolver extends KeyframeResolver {
  constructor(t, o, n, s, i) {
    super(t, o, n, s, i, !0);
  }
  readKeyframes() {
    const { unresolvedKeyframes: t, element: o, name: n } = this;
    if (!o || !o.current)
      return;
    super.readKeyframes();
    for (let u = 0; u < t.length; u++) {
      let c = t[u];
      if (typeof c == "string" && (c = c.trim(), isCSSVariableToken(c))) {
        const p = getVariableValue(c, o.current);
        p !== void 0 && (t[u] = p), u === t.length - 1 && (this.finalKeyframe = c);
      }
    }
    if (this.resolveNoneKeyframes(), !positionalKeys.has(n) || t.length !== 2)
      return;
    const [s, i] = t, l = findDimensionValueType(s), d = findDimensionValueType(i);
    if (l !== d)
      if (isNumOrPxType(l) && isNumOrPxType(d))
        for (let u = 0; u < t.length; u++) {
          const c = t[u];
          typeof c == "string" && (t[u] = parseFloat(c));
        }
      else positionalValues[n] && (this.needsMeasurement = !0);
  }
  resolveNoneKeyframes() {
    const { unresolvedKeyframes: t, name: o } = this, n = [];
    for (let s = 0; s < t.length; s++)
      (t[s] === null || isNone(t[s])) && n.push(s);
    n.length && makeNoneKeyframesAnimatable(t, n, o);
  }
  measureInitialState() {
    const { element: t, unresolvedKeyframes: o, name: n } = this;
    if (!t || !t.current)
      return;
    n === "height" && (this.suspendedScrollY = window.pageYOffset), this.measuredOrigin = positionalValues[n](t.measureViewportBox(), window.getComputedStyle(t.current)), o[0] = this.measuredOrigin;
    const s = o[o.length - 1];
    s !== void 0 && t.getValue(n, s).jump(s, !1);
  }
  measureEndState() {
    const { element: t, name: o, unresolvedKeyframes: n } = this;
    if (!t || !t.current)
      return;
    const s = t.getValue(o);
    s && s.jump(this.measuredOrigin, !1);
    const i = n.length - 1, l = n[i];
    n[i] = positionalValues[o](t.measureViewportBox(), window.getComputedStyle(t.current)), l !== null && this.finalKeyframe === void 0 && (this.finalKeyframe = l), this.removedTransforms?.length && this.removedTransforms.forEach(([d, u]) => {
      t.getValue(d).set(u);
    }), this.resolveNoneKeyframes();
  }
}
function resolveElements(e, t, o) {
  if (e instanceof EventTarget)
    return [e];
  if (typeof e == "string") {
    let n = document;
    const s = o?.[e] ?? n.querySelectorAll(e);
    return s ? Array.from(s) : [];
  }
  return Array.from(e);
}
const getValueAsType = (e, t) => t && typeof e == "number" ? t.transform(e) : e;
function isHTMLElement$2(e) {
  return isObject$1(e) && "offsetHeight" in e;
}
const MAX_VELOCITY_DELTA = 30, isFloat = (e) => !isNaN(parseFloat(e));
class MotionValue {
  /**
   * @param init - The initiating value
   * @param config - Optional configuration options
   *
   * -  `transformer`: A function to transform incoming values with.
   */
  constructor(t, o = {}) {
    this.canTrackVelocity = null, this.events = {}, this.updateAndNotify = (n) => {
      const s = time.now();
      if (this.updatedAt !== s && this.setPrevFrameValue(), this.prev = this.current, this.setCurrent(n), this.current !== this.prev && (this.events.change?.notify(this.current), this.dependents))
        for (const i of this.dependents)
          i.dirty();
    }, this.hasAnimated = !1, this.setCurrent(t), this.owner = o.owner;
  }
  setCurrent(t) {
    this.current = t, this.updatedAt = time.now(), this.canTrackVelocity === null && t !== void 0 && (this.canTrackVelocity = isFloat(this.current));
  }
  setPrevFrameValue(t = this.current) {
    this.prevFrameValue = t, this.prevUpdatedAt = this.updatedAt;
  }
  /**
   * Adds a function that will be notified when the `MotionValue` is updated.
   *
   * It returns a function that, when called, will cancel the subscription.
   *
   * When calling `onChange` inside a React component, it should be wrapped with the
   * `useEffect` hook. As it returns an unsubscribe function, this should be returned
   * from the `useEffect` function to ensure you don't add duplicate subscribers..
   *
   * ```jsx
   * export const MyComponent = () => {
   *   const x = useMotionValue(0)
   *   const y = useMotionValue(0)
   *   const opacity = useMotionValue(1)
   *
   *   useEffect(() => {
   *     function updateOpacity() {
   *       const maxXY = Math.max(x.get(), y.get())
   *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
   *       opacity.set(newOpacity)
   *     }
   *
   *     const unsubscribeX = x.on("change", updateOpacity)
   *     const unsubscribeY = y.on("change", updateOpacity)
   *
   *     return () => {
   *       unsubscribeX()
   *       unsubscribeY()
   *     }
   *   }, [])
   *
   *   return <motion.div style={{ x }} />
   * }
   * ```
   *
   * @param subscriber - A function that receives the latest value.
   * @returns A function that, when called, will cancel this subscription.
   *
   * @deprecated
   */
  onChange(t) {
    return process.env.NODE_ENV !== "production" && warnOnce$1(!1, 'value.onChange(callback) is deprecated. Switch to value.on("change", callback).'), this.on("change", t);
  }
  on(t, o) {
    this.events[t] || (this.events[t] = new SubscriptionManager());
    const n = this.events[t].add(o);
    return t === "change" ? () => {
      n(), frame.read(() => {
        this.events.change.getSize() || this.stop();
      });
    } : n;
  }
  clearListeners() {
    for (const t in this.events)
      this.events[t].clear();
  }
  /**
   * Attaches a passive effect to the `MotionValue`.
   */
  attach(t, o) {
    this.passiveEffect = t, this.stopPassiveEffect = o;
  }
  /**
   * Sets the state of the `MotionValue`.
   *
   * @remarks
   *
   * ```jsx
   * const x = useMotionValue(0)
   * x.set(10)
   * ```
   *
   * @param latest - Latest value to set.
   * @param render - Whether to notify render subscribers. Defaults to `true`
   *
   * @public
   */
  set(t) {
    this.passiveEffect ? this.passiveEffect(t, this.updateAndNotify) : this.updateAndNotify(t);
  }
  setWithVelocity(t, o, n) {
    this.set(o), this.prev = void 0, this.prevFrameValue = t, this.prevUpdatedAt = this.updatedAt - n;
  }
  /**
   * Set the state of the `MotionValue`, stopping any active animations,
   * effects, and resets velocity to `0`.
   */
  jump(t, o = !0) {
    this.updateAndNotify(t), this.prev = t, this.prevUpdatedAt = this.prevFrameValue = void 0, o && this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
  dirty() {
    this.events.change?.notify(this.current);
  }
  addDependent(t) {
    this.dependents || (this.dependents = /* @__PURE__ */ new Set()), this.dependents.add(t);
  }
  removeDependent(t) {
    this.dependents && this.dependents.delete(t);
  }
  /**
   * Returns the latest state of `MotionValue`
   *
   * @returns - The latest state of `MotionValue`
   *
   * @public
   */
  get() {
    return this.current;
  }
  /**
   * @public
   */
  getPrevious() {
    return this.prev;
  }
  /**
   * Returns the latest velocity of `MotionValue`
   *
   * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
   *
   * @public
   */
  getVelocity() {
    const t = time.now();
    if (!this.canTrackVelocity || this.prevFrameValue === void 0 || t - this.updatedAt > MAX_VELOCITY_DELTA)
      return 0;
    const o = Math.min(this.updatedAt - this.prevUpdatedAt, MAX_VELOCITY_DELTA);
    return velocityPerSecond(parseFloat(this.current) - parseFloat(this.prevFrameValue), o);
  }
  /**
   * Registers a new animation to control this `MotionValue`. Only one
   * animation can drive a `MotionValue` at one time.
   *
   * ```jsx
   * value.start()
   * ```
   *
   * @param animation - A function that starts the provided animation
   */
  start(t) {
    return this.stop(), new Promise((o) => {
      this.hasAnimated = !0, this.animation = t(o), this.events.animationStart && this.events.animationStart.notify();
    }).then(() => {
      this.events.animationComplete && this.events.animationComplete.notify(), this.clearAnimation();
    });
  }
  /**
   * Stop the currently active animation.
   *
   * @public
   */
  stop() {
    this.animation && (this.animation.stop(), this.events.animationCancel && this.events.animationCancel.notify()), this.clearAnimation();
  }
  /**
   * Returns `true` if this value is currently animating.
   *
   * @public
   */
  isAnimating() {
    return !!this.animation;
  }
  clearAnimation() {
    delete this.animation;
  }
  /**
   * Destroy and clean up subscribers to this `MotionValue`.
   *
   * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
   * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
   * created a `MotionValue` via the `motionValue` function.
   *
   * @public
   */
  destroy() {
    this.dependents?.clear(), this.events.destroy?.notify(), this.clearListeners(), this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
}
function motionValue(e, t) {
  return new MotionValue(e, t);
}
const { schedule: microtask } = /* @__PURE__ */ createRenderBatcher(queueMicrotask, !1), isDragging = {
  x: !1,
  y: !1
};
function isDragActive() {
  return isDragging.x || isDragging.y;
}
function setDragLock(e) {
  return e === "x" || e === "y" ? isDragging[e] ? null : (isDragging[e] = !0, () => {
    isDragging[e] = !1;
  }) : isDragging.x || isDragging.y ? null : (isDragging.x = isDragging.y = !0, () => {
    isDragging.x = isDragging.y = !1;
  });
}
function setupGesture(e, t) {
  const o = resolveElements(e), n = new AbortController(), s = {
    passive: !0,
    ...t,
    signal: n.signal
  };
  return [o, s, () => n.abort()];
}
function isValidHover(e) {
  return !(e.pointerType === "touch" || isDragActive());
}
function hover(e, t, o = {}) {
  const [n, s, i] = setupGesture(e, o), l = (d) => {
    if (!isValidHover(d))
      return;
    const { target: u } = d, c = t(u, d);
    if (typeof c != "function" || !u)
      return;
    const p = (f) => {
      isValidHover(f) && (c(f), u.removeEventListener("pointerleave", p));
    };
    u.addEventListener("pointerleave", p, s);
  };
  return n.forEach((d) => {
    d.addEventListener("pointerenter", l, s);
  }), i;
}
const isNodeOrChild = (e, t) => t ? e === t ? !0 : isNodeOrChild(e, t.parentElement) : !1, isPrimaryPointer = (e) => e.pointerType === "mouse" ? typeof e.button != "number" || e.button <= 0 : e.isPrimary !== !1, focusableElements = /* @__PURE__ */ new Set([
  "BUTTON",
  "INPUT",
  "SELECT",
  "TEXTAREA",
  "A"
]);
function isElementKeyboardAccessible(e) {
  return focusableElements.has(e.tagName) || e.tabIndex !== -1;
}
const isPressing = /* @__PURE__ */ new WeakSet();
function filterEvents(e) {
  return (t) => {
    t.key === "Enter" && e(t);
  };
}
function firePointerEvent(e, t) {
  e.dispatchEvent(new PointerEvent("pointer" + t, { isPrimary: !0, bubbles: !0 }));
}
const enableKeyboardPress = (e, t) => {
  const o = e.currentTarget;
  if (!o)
    return;
  const n = filterEvents(() => {
    if (isPressing.has(o))
      return;
    firePointerEvent(o, "down");
    const s = filterEvents(() => {
      firePointerEvent(o, "up");
    }), i = () => firePointerEvent(o, "cancel");
    o.addEventListener("keyup", s, t), o.addEventListener("blur", i, t);
  });
  o.addEventListener("keydown", n, t), o.addEventListener("blur", () => o.removeEventListener("keydown", n), t);
};
function isValidPressEvent(e) {
  return isPrimaryPointer(e) && !isDragActive();
}
function press(e, t, o = {}) {
  const [n, s, i] = setupGesture(e, o), l = (d) => {
    const u = d.currentTarget;
    if (!isValidPressEvent(d))
      return;
    isPressing.add(u);
    const c = t(u, d), p = (y, h) => {
      window.removeEventListener("pointerup", f), window.removeEventListener("pointercancel", g), isPressing.has(u) && isPressing.delete(u), isValidPressEvent(y) && typeof c == "function" && c(y, { success: h });
    }, f = (y) => {
      p(y, u === window || u === document || o.useGlobalTarget || isNodeOrChild(u, y.target));
    }, g = (y) => {
      p(y, !1);
    };
    window.addEventListener("pointerup", f, s), window.addEventListener("pointercancel", g, s);
  };
  return n.forEach((d) => {
    (o.useGlobalTarget ? window : d).addEventListener("pointerdown", l, s), isHTMLElement$2(d) && (d.addEventListener("focus", (c) => enableKeyboardPress(c, s)), !isElementKeyboardAccessible(d) && !d.hasAttribute("tabindex") && (d.tabIndex = 0));
  }), i;
}
function isSVGElement(e) {
  return isObject$1(e) && "ownerSVGElement" in e;
}
function isSVGSVGElement(e) {
  return isSVGElement(e) && e.tagName === "svg";
}
const isMotionValue = (e) => !!(e && e.getVelocity), valueTypes = [...dimensionValueTypes, color, complex], findValueType = (e) => valueTypes.find(testValueType(e)), MotionConfigContext = createContext({
  transformPagePoint: (e) => e,
  isStatic: !1,
  reducedMotion: "never"
});
function usePresence(e = !0) {
  const t = useContext(PresenceContext);
  if (t === null)
    return [!0, null];
  const { isPresent: o, onExitComplete: n, register: s } = t, i = useId$1();
  useEffect(() => {
    if (e)
      return s(i);
  }, [e]);
  const l = useCallback(() => e && n && n(i), [i, n, e]);
  return !o && n ? [!1, l] : [!0];
}
const LazyContext = createContext({ strict: !1 }), featureProps = {
  animation: [
    "animate",
    "variants",
    "whileHover",
    "whileTap",
    "exit",
    "whileInView",
    "whileFocus",
    "whileDrag"
  ],
  exit: ["exit"],
  drag: ["drag", "dragControls"],
  focus: ["whileFocus"],
  hover: ["whileHover", "onHoverStart", "onHoverEnd"],
  tap: ["whileTap", "onTap", "onTapStart", "onTapCancel"],
  pan: ["onPan", "onPanStart", "onPanSessionStart", "onPanEnd"],
  inView: ["whileInView", "onViewportEnter", "onViewportLeave"],
  layout: ["layout", "layoutId"]
}, featureDefinitions = {};
for (const e in featureProps)
  featureDefinitions[e] = {
    isEnabled: (t) => featureProps[e].some((o) => !!t[o])
  };
function loadFeatures(e) {
  for (const t in e)
    featureDefinitions[t] = {
      ...featureDefinitions[t],
      ...e[t]
    };
}
const validMotionProps = /* @__PURE__ */ new Set([
  "animate",
  "exit",
  "variants",
  "initial",
  "style",
  "values",
  "variants",
  "transition",
  "transformTemplate",
  "custom",
  "inherit",
  "onBeforeLayoutMeasure",
  "onAnimationStart",
  "onAnimationComplete",
  "onUpdate",
  "onDragStart",
  "onDrag",
  "onDragEnd",
  "onMeasureDragConstraints",
  "onDirectionLock",
  "onDragTransitionEnd",
  "_dragX",
  "_dragY",
  "onHoverStart",
  "onHoverEnd",
  "onViewportEnter",
  "onViewportLeave",
  "globalTapTarget",
  "ignoreStrict",
  "viewport"
]);
function isValidMotionProp(e) {
  return e.startsWith("while") || e.startsWith("drag") && e !== "draggable" || e.startsWith("layout") || e.startsWith("onTap") || e.startsWith("onPan") || e.startsWith("onLayout") || validMotionProps.has(e);
}
let shouldForward = (e) => !isValidMotionProp(e);
function loadExternalIsValidProp(e) {
  typeof e == "function" && (shouldForward = (t) => t.startsWith("on") ? !isValidMotionProp(t) : e(t));
}
try {
  loadExternalIsValidProp(require("@emotion/is-prop-valid").default);
} catch {
}
function filterProps(e, t, o) {
  const n = {};
  for (const s in e)
    s === "values" && typeof e.values == "object" || (shouldForward(s) || o === !0 && isValidMotionProp(s) || !t && !isValidMotionProp(s) || // If trying to use native HTML drag events, forward drag listeners
    e.draggable && s.startsWith("onDrag")) && (n[s] = e[s]);
  return n;
}
const MotionContext = /* @__PURE__ */ createContext({});
function isAnimationControls(e) {
  return e !== null && typeof e == "object" && typeof e.start == "function";
}
function isVariantLabel(e) {
  return typeof e == "string" || Array.isArray(e);
}
const variantPriorityOrder = [
  "animate",
  "whileInView",
  "whileFocus",
  "whileHover",
  "whileTap",
  "whileDrag",
  "exit"
], variantProps = ["initial", ...variantPriorityOrder];
function isControllingVariants(e) {
  return isAnimationControls(e.animate) || variantProps.some((t) => isVariantLabel(e[t]));
}
function isVariantNode(e) {
  return !!(isControllingVariants(e) || e.variants);
}
function getCurrentTreeVariants(e, t) {
  if (isControllingVariants(e)) {
    const { initial: o, animate: n } = e;
    return {
      initial: o === !1 || isVariantLabel(o) ? o : void 0,
      animate: isVariantLabel(n) ? n : void 0
    };
  }
  return e.inherit !== !1 ? t : {};
}
function useCreateMotionContext(e) {
  const { initial: t, animate: o } = getCurrentTreeVariants(e, useContext(MotionContext));
  return useMemo(() => ({ initial: t, animate: o }), [variantLabelsAsDependency(t), variantLabelsAsDependency(o)]);
}
function variantLabelsAsDependency(e) {
  return Array.isArray(e) ? e.join(" ") : e;
}
const scaleCorrectors = {};
function addScaleCorrector(e) {
  for (const t in e)
    scaleCorrectors[t] = e[t], isCSSVariableName(t) && (scaleCorrectors[t].isCSSVariable = !0);
}
function isForcedMotionValue(e, { layout: t, layoutId: o }) {
  return transformProps.has(e) || e.startsWith("origin") || (t || o !== void 0) && (!!scaleCorrectors[e] || e === "opacity");
}
const translateAlias = {
  x: "translateX",
  y: "translateY",
  z: "translateZ",
  transformPerspective: "perspective"
}, numTransforms = transformPropOrder.length;
function buildTransform(e, t, o) {
  let n = "", s = !0;
  for (let i = 0; i < numTransforms; i++) {
    const l = transformPropOrder[i], d = e[l];
    if (d === void 0)
      continue;
    let u = !0;
    if (typeof d == "number" ? u = d === (l.startsWith("scale") ? 1 : 0) : u = parseFloat(d) === 0, !u || o) {
      const c = getValueAsType(d, numberValueTypes[l]);
      if (!u) {
        s = !1;
        const p = translateAlias[l] || l;
        n += `${p}(${c}) `;
      }
      o && (t[l] = c);
    }
  }
  return n = n.trim(), o ? n = o(t, s ? "" : n) : s && (n = "none"), n;
}
function buildHTMLStyles(e, t, o) {
  const { style: n, vars: s, transformOrigin: i } = e;
  let l = !1, d = !1;
  for (const u in t) {
    const c = t[u];
    if (transformProps.has(u)) {
      l = !0;
      continue;
    } else if (isCSSVariableName(u)) {
      s[u] = c;
      continue;
    } else {
      const p = getValueAsType(c, numberValueTypes[u]);
      u.startsWith("origin") ? (d = !0, i[u] = p) : n[u] = p;
    }
  }
  if (t.transform || (l || o ? n.transform = buildTransform(t, e.transform, o) : n.transform && (n.transform = "none")), d) {
    const { originX: u = "50%", originY: c = "50%", originZ: p = 0 } = i;
    n.transformOrigin = `${u} ${c} ${p}`;
  }
}
const createHtmlRenderState = () => ({
  style: {},
  transform: {},
  transformOrigin: {},
  vars: {}
});
function copyRawValuesOnly(e, t, o) {
  for (const n in t)
    !isMotionValue(t[n]) && !isForcedMotionValue(n, o) && (e[n] = t[n]);
}
function useInitialMotionValues({ transformTemplate: e }, t) {
  return useMemo(() => {
    const o = createHtmlRenderState();
    return buildHTMLStyles(o, t, e), Object.assign({}, o.vars, o.style);
  }, [t]);
}
function useStyle(e, t) {
  const o = e.style || {}, n = {};
  return copyRawValuesOnly(n, o, e), Object.assign(n, useInitialMotionValues(e, t)), n;
}
function useHTMLProps(e, t) {
  const o = {}, n = useStyle(e, t);
  return e.drag && e.dragListener !== !1 && (o.draggable = !1, n.userSelect = n.WebkitUserSelect = n.WebkitTouchCallout = "none", n.touchAction = e.drag === !0 ? "none" : `pan-${e.drag === "x" ? "y" : "x"}`), e.tabIndex === void 0 && (e.onTap || e.onTapStart || e.whileTap) && (o.tabIndex = 0), o.style = n, o;
}
const dashKeys = {
  offset: "stroke-dashoffset",
  array: "stroke-dasharray"
}, camelKeys = {
  offset: "strokeDashoffset",
  array: "strokeDasharray"
};
function buildSVGPath(e, t, o = 1, n = 0, s = !0) {
  e.pathLength = 1;
  const i = s ? dashKeys : camelKeys;
  e[i.offset] = px.transform(-n);
  const l = px.transform(t), d = px.transform(o);
  e[i.array] = `${l} ${d}`;
}
function buildSVGAttrs(e, {
  attrX: t,
  attrY: o,
  attrScale: n,
  pathLength: s,
  pathSpacing: i = 1,
  pathOffset: l = 0,
  // This is object creation, which we try to avoid per-frame.
  ...d
}, u, c, p) {
  if (buildHTMLStyles(e, d, c), u) {
    e.style.viewBox && (e.attrs.viewBox = e.style.viewBox);
    return;
  }
  e.attrs = e.style, e.style = {};
  const { attrs: f, style: g } = e;
  f.transform && (g.transform = f.transform, delete f.transform), (g.transform || f.transformOrigin) && (g.transformOrigin = f.transformOrigin ?? "50% 50%", delete f.transformOrigin), g.transform && (g.transformBox = p?.transformBox ?? "fill-box", delete f.transformBox), t !== void 0 && (f.x = t), o !== void 0 && (f.y = o), n !== void 0 && (f.scale = n), s !== void 0 && buildSVGPath(f, s, i, l, !1);
}
const createSvgRenderState = () => ({
  ...createHtmlRenderState(),
  attrs: {}
}), isSVGTag = (e) => typeof e == "string" && e.toLowerCase() === "svg";
function useSVGProps(e, t, o, n) {
  const s = useMemo(() => {
    const i = createSvgRenderState();
    return buildSVGAttrs(i, t, isSVGTag(n), e.transformTemplate, e.style), {
      ...i.attrs,
      style: { ...i.style }
    };
  }, [t]);
  if (e.style) {
    const i = {};
    copyRawValuesOnly(i, e.style, e), s.style = { ...i, ...s.style };
  }
  return s;
}
const lowercaseSVGElements = [
  "animate",
  "circle",
  "defs",
  "desc",
  "ellipse",
  "g",
  "image",
  "line",
  "filter",
  "marker",
  "mask",
  "metadata",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "rect",
  "stop",
  "switch",
  "symbol",
  "svg",
  "text",
  "tspan",
  "use",
  "view"
];
function isSVGComponent(e) {
  return (
    /**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */
    typeof e != "string" || /**
     * If it contains a dash, the element is a custom HTML webcomponent.
     */
    e.includes("-") ? !1 : (
      /**
       * If it's in our list of lowercase SVG tags, it's an SVG component
       */
      !!(lowercaseSVGElements.indexOf(e) > -1 || /**
       * If it contains a capital letter, it's an SVG component
       */
      /[A-Z]/u.test(e))
    )
  );
}
function useRender(e, t, o, { latestValues: n }, s, i = !1) {
  const d = (isSVGComponent(e) ? useSVGProps : useHTMLProps)(t, n, s, e), u = filterProps(t, typeof e == "string", i), c = e !== Fragment ? { ...u, ...d, ref: o } : {}, { children: p } = t, f = useMemo(() => isMotionValue(p) ? p.get() : p, [p]);
  return createElement(e, {
    ...c,
    children: f
  });
}
function getValueState(e) {
  const t = [{}, {}];
  return e?.values.forEach((o, n) => {
    t[0][n] = o.get(), t[1][n] = o.getVelocity();
  }), t;
}
function resolveVariantFromProps(e, t, o, n) {
  if (typeof t == "function") {
    const [s, i] = getValueState(n);
    t = t(o !== void 0 ? o : e.custom, s, i);
  }
  if (typeof t == "string" && (t = e.variants && e.variants[t]), typeof t == "function") {
    const [s, i] = getValueState(n);
    t = t(o !== void 0 ? o : e.custom, s, i);
  }
  return t;
}
function resolveMotionValue(e) {
  return isMotionValue(e) ? e.get() : e;
}
function makeState({ scrapeMotionValuesFromProps: e, createRenderState: t }, o, n, s) {
  return {
    latestValues: makeLatestValues(o, n, s, e),
    renderState: t()
  };
}
function makeLatestValues(e, t, o, n) {
  const s = {}, i = n(e, {});
  for (const g in i)
    s[g] = resolveMotionValue(i[g]);
  let { initial: l, animate: d } = e;
  const u = isControllingVariants(e), c = isVariantNode(e);
  t && c && !u && e.inherit !== !1 && (l === void 0 && (l = t.initial), d === void 0 && (d = t.animate));
  let p = o ? o.initial === !1 : !1;
  p = p || l === !1;
  const f = p ? d : l;
  if (f && typeof f != "boolean" && !isAnimationControls(f)) {
    const g = Array.isArray(f) ? f : [f];
    for (let y = 0; y < g.length; y++) {
      const h = resolveVariantFromProps(e, g[y]);
      if (h) {
        const { transitionEnd: T, transition: P, ...E } = h;
        for (const $ in E) {
          let R = E[$];
          if (Array.isArray(R)) {
            const C = p ? R.length - 1 : 0;
            R = R[C];
          }
          R !== null && (s[$] = R);
        }
        for (const $ in T)
          s[$] = T[$];
      }
    }
  }
  return s;
}
const makeUseVisualState = (e) => (t, o) => {
  const n = useContext(MotionContext), s = useContext(PresenceContext), i = () => makeState(e, t, n, s);
  return o ? i() : useConstant(i);
};
function scrapeMotionValuesFromProps$1(e, t, o) {
  const { style: n } = e, s = {};
  for (const i in n)
    (isMotionValue(n[i]) || t.style && isMotionValue(t.style[i]) || isForcedMotionValue(i, e) || o?.getValue(i)?.liveStyle !== void 0) && (s[i] = n[i]);
  return s;
}
const useHTMLVisualState = /* @__PURE__ */ makeUseVisualState({
  scrapeMotionValuesFromProps: scrapeMotionValuesFromProps$1,
  createRenderState: createHtmlRenderState
});
function scrapeMotionValuesFromProps(e, t, o) {
  const n = scrapeMotionValuesFromProps$1(e, t, o);
  for (const s in e)
    if (isMotionValue(e[s]) || isMotionValue(t[s])) {
      const i = transformPropOrder.indexOf(s) !== -1 ? "attr" + s.charAt(0).toUpperCase() + s.substring(1) : s;
      n[i] = e[s];
    }
  return n;
}
const useSVGVisualState = /* @__PURE__ */ makeUseVisualState({
  scrapeMotionValuesFromProps,
  createRenderState: createSvgRenderState
}), motionComponentSymbol = Symbol.for("motionComponentSymbol");
function isRefObject(e) {
  return e && typeof e == "object" && Object.prototype.hasOwnProperty.call(e, "current");
}
function useMotionRef(e, t, o) {
  return useCallback(
    (n) => {
      n && e.onMount && e.onMount(n), t && (n ? t.mount(n) : t.unmount()), o && (typeof o == "function" ? o(n) : isRefObject(o) && (o.current = n));
    },
    /**
     * Include externalRef in dependencies to ensure the callback updates
     * when the ref changes, allowing proper ref forwarding.
     */
    [t]
  );
}
const camelToDash = (e) => e.replace(/([a-z])([A-Z])/gu, "$1-$2").toLowerCase(), optimizedAppearDataId = "framerAppearId", optimizedAppearDataAttribute = "data-" + camelToDash(optimizedAppearDataId), SwitchLayoutGroupContext = createContext({});
function useVisualElement(e, t, o, n, s) {
  const { visualElement: i } = useContext(MotionContext), l = useContext(LazyContext), d = useContext(PresenceContext), u = useContext(MotionConfigContext).reducedMotion, c = useRef(null);
  n = n || l.renderer, !c.current && n && (c.current = n(e, {
    visualState: t,
    parent: i,
    props: o,
    presenceContext: d,
    blockInitialAnimation: d ? d.initial === !1 : !1,
    reducedMotionConfig: u
  }));
  const p = c.current, f = useContext(SwitchLayoutGroupContext);
  p && !p.projection && s && (p.type === "html" || p.type === "svg") && createProjectionNode$1(c.current, o, s, f);
  const g = useRef(!1);
  useInsertionEffect(() => {
    p && g.current && p.update(o, d);
  });
  const y = o[optimizedAppearDataAttribute], h = useRef(!!y && !window.MotionHandoffIsComplete?.(y) && window.MotionHasOptimisedAnimation?.(y));
  return useIsomorphicLayoutEffect(() => {
    p && (g.current = !0, window.MotionIsMounted = !0, p.updateFeatures(), p.scheduleRenderMicrotask(), h.current && p.animationState && p.animationState.animateChanges());
  }), useEffect(() => {
    p && (!h.current && p.animationState && p.animationState.animateChanges(), h.current && (queueMicrotask(() => {
      window.MotionHandoffMarkAsComplete?.(y);
    }), h.current = !1), p.enteringChildren = void 0);
  }), p;
}
function createProjectionNode$1(e, t, o, n) {
  const { layoutId: s, layout: i, drag: l, dragConstraints: d, layoutScroll: u, layoutRoot: c, layoutCrossfade: p } = t;
  e.projection = new o(e.latestValues, t["data-framer-portal-id"] ? void 0 : getClosestProjectingNode(e.parent)), e.projection.setOptions({
    layoutId: s,
    layout: i,
    alwaysMeasureLayout: !!l || d && isRefObject(d),
    visualElement: e,
    /**
     * TODO: Update options in an effect. This could be tricky as it'll be too late
     * to update by the time layout animations run.
     * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
     * ensuring it gets called if there's no potential layout animations.
     *
     */
    animationType: typeof i == "string" ? i : "both",
    initialPromotionConfig: n,
    crossfade: p,
    layoutScroll: u,
    layoutRoot: c
  });
}
function getClosestProjectingNode(e) {
  if (e)
    return e.options.allowProjection !== !1 ? e.projection : getClosestProjectingNode(e.parent);
}
function createMotionComponent(e, { forwardMotionProps: t = !1 } = {}, o, n) {
  o && loadFeatures(o);
  const s = isSVGComponent(e) ? useSVGVisualState : useHTMLVisualState;
  function i(d, u) {
    let c;
    const p = {
      ...useContext(MotionConfigContext),
      ...d,
      layoutId: useLayoutId(d)
    }, { isStatic: f } = p, g = useCreateMotionContext(d), y = s(d, f);
    if (!f && isBrowser) {
      useStrictMode(p, o);
      const h = getProjectionFunctionality(p);
      c = h.MeasureLayout, g.visualElement = useVisualElement(e, y, p, n, h.ProjectionNode);
    }
    return jsxRuntimeExports.jsxs(MotionContext.Provider, { value: g, children: [c && g.visualElement ? jsxRuntimeExports.jsx(c, { visualElement: g.visualElement, ...p }) : null, useRender(e, d, useMotionRef(y, g.visualElement, u), y, f, t)] });
  }
  i.displayName = `motion.${typeof e == "string" ? e : `create(${e.displayName ?? e.name ?? ""})`}`;
  const l = forwardRef(i);
  return l[motionComponentSymbol] = e, l;
}
function useLayoutId({ layoutId: e }) {
  const t = useContext(LayoutGroupContext).id;
  return t && e !== void 0 ? t + "-" + e : e;
}
function useStrictMode(e, t) {
  const o = useContext(LazyContext).strict;
  if (process.env.NODE_ENV !== "production" && t && o) {
    const n = "You have rendered a `motion` component within a `LazyMotion` component. This will break tree shaking. Import and render a `m` component instead.";
    e.ignoreStrict ? warning(!1, n, "lazy-strict-mode") : invariant(!1, n, "lazy-strict-mode");
  }
}
function getProjectionFunctionality(e) {
  const { drag: t, layout: o } = featureDefinitions;
  if (!t && !o)
    return {};
  const n = { ...t, ...o };
  return {
    MeasureLayout: t?.isEnabled(e) || o?.isEnabled(e) ? n.MeasureLayout : void 0,
    ProjectionNode: n.ProjectionNode
  };
}
function createMotionProxy(e, t) {
  if (typeof Proxy > "u")
    return createMotionComponent;
  const o = /* @__PURE__ */ new Map(), n = (i, l) => createMotionComponent(i, l, e, t), s = (i, l) => (process.env.NODE_ENV !== "production" && warnOnce$1(!1, "motion() is deprecated. Use motion.create() instead."), n(i, l));
  return new Proxy(s, {
    /**
     * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
     * The prop name is passed through as `key` and we can use that to generate a `motion`
     * DOM component with that name.
     */
    get: (i, l) => l === "create" ? n : (o.has(l) || o.set(l, createMotionComponent(l, void 0, e, t)), o.get(l))
  });
}
const m = /* @__PURE__ */ createMotionProxy();
function convertBoundingBoxToBox({ top: e, left: t, right: o, bottom: n }) {
  return {
    x: { min: t, max: o },
    y: { min: e, max: n }
  };
}
function convertBoxToBoundingBox({ x: e, y: t }) {
  return { top: t.min, right: e.max, bottom: t.max, left: e.min };
}
function transformBoxPoints(e, t) {
  if (!t)
    return e;
  const o = t({ x: e.left, y: e.top }), n = t({ x: e.right, y: e.bottom });
  return {
    top: o.y,
    left: o.x,
    bottom: n.y,
    right: n.x
  };
}
function isIdentityScale(e) {
  return e === void 0 || e === 1;
}
function hasScale({ scale: e, scaleX: t, scaleY: o }) {
  return !isIdentityScale(e) || !isIdentityScale(t) || !isIdentityScale(o);
}
function hasTransform(e) {
  return hasScale(e) || has2DTranslate(e) || e.z || e.rotate || e.rotateX || e.rotateY || e.skewX || e.skewY;
}
function has2DTranslate(e) {
  return is2DTranslate(e.x) || is2DTranslate(e.y);
}
function is2DTranslate(e) {
  return e && e !== "0%";
}
function scalePoint(e, t, o) {
  const n = e - o, s = t * n;
  return o + s;
}
function applyPointDelta(e, t, o, n, s) {
  return s !== void 0 && (e = scalePoint(e, s, n)), scalePoint(e, o, n) + t;
}
function applyAxisDelta(e, t = 0, o = 1, n, s) {
  e.min = applyPointDelta(e.min, t, o, n, s), e.max = applyPointDelta(e.max, t, o, n, s);
}
function applyBoxDelta(e, { x: t, y: o }) {
  applyAxisDelta(e.x, t.translate, t.scale, t.originPoint), applyAxisDelta(e.y, o.translate, o.scale, o.originPoint);
}
const TREE_SCALE_SNAP_MIN = 0.999999999999, TREE_SCALE_SNAP_MAX = 1.0000000000001;
function applyTreeDeltas(e, t, o, n = !1) {
  const s = o.length;
  if (!s)
    return;
  t.x = t.y = 1;
  let i, l;
  for (let d = 0; d < s; d++) {
    i = o[d], l = i.projectionDelta;
    const { visualElement: u } = i.options;
    u && u.props.style && u.props.style.display === "contents" || (n && i.options.layoutScroll && i.scroll && i !== i.root && transformBox(e, {
      x: -i.scroll.offset.x,
      y: -i.scroll.offset.y
    }), l && (t.x *= l.x.scale, t.y *= l.y.scale, applyBoxDelta(e, l)), n && hasTransform(i.latestValues) && transformBox(e, i.latestValues));
  }
  t.x < TREE_SCALE_SNAP_MAX && t.x > TREE_SCALE_SNAP_MIN && (t.x = 1), t.y < TREE_SCALE_SNAP_MAX && t.y > TREE_SCALE_SNAP_MIN && (t.y = 1);
}
function translateAxis(e, t) {
  e.min = e.min + t, e.max = e.max + t;
}
function transformAxis(e, t, o, n, s = 0.5) {
  const i = mixNumber$1(e.min, e.max, s);
  applyAxisDelta(e, t, o, i, n);
}
function transformBox(e, t) {
  transformAxis(e.x, t.x, t.scaleX, t.scale, t.originX), transformAxis(e.y, t.y, t.scaleY, t.scale, t.originY);
}
function measureViewportBox(e, t) {
  return convertBoundingBoxToBox(transformBoxPoints(e.getBoundingClientRect(), t));
}
function measurePageBox(e, t, o) {
  const n = measureViewportBox(e, o), { scroll: s } = t;
  return s && (translateAxis(n.x, s.offset.x), translateAxis(n.y, s.offset.y)), n;
}
const createAxisDelta = () => ({
  translate: 0,
  scale: 1,
  origin: 0,
  originPoint: 0
}), createDelta = () => ({
  x: createAxisDelta(),
  y: createAxisDelta()
}), createAxis = () => ({ min: 0, max: 0 }), createBox = () => ({
  x: createAxis(),
  y: createAxis()
}), prefersReducedMotion = { current: null }, hasReducedMotionListener = { current: !1 };
function initPrefersReducedMotion() {
  if (hasReducedMotionListener.current = !0, !!isBrowser)
    if (window.matchMedia) {
      const e = window.matchMedia("(prefers-reduced-motion)"), t = () => prefersReducedMotion.current = e.matches;
      e.addEventListener("change", t), t();
    } else
      prefersReducedMotion.current = !1;
}
const visualElementStore = /* @__PURE__ */ new WeakMap();
function updateMotionValuesFromProps(e, t, o) {
  for (const n in t) {
    const s = t[n], i = o[n];
    if (isMotionValue(s))
      e.addValue(n, s);
    else if (isMotionValue(i))
      e.addValue(n, motionValue(s, { owner: e }));
    else if (i !== s)
      if (e.hasValue(n)) {
        const l = e.getValue(n);
        l.liveStyle === !0 ? l.jump(s) : l.hasAnimated || l.set(s);
      } else {
        const l = e.getStaticValue(n);
        e.addValue(n, motionValue(l !== void 0 ? l : s, { owner: e }));
      }
  }
  for (const n in o)
    t[n] === void 0 && e.removeValue(n);
  return t;
}
const propEventHandlers = [
  "AnimationStart",
  "AnimationComplete",
  "Update",
  "BeforeLayoutMeasure",
  "LayoutMeasure",
  "LayoutAnimationStart",
  "LayoutAnimationComplete"
];
class VisualElement {
  /**
   * This method takes React props and returns found MotionValues. For example, HTML
   * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
   *
   * This isn't an abstract method as it needs calling in the constructor, but it is
   * intended to be one.
   */
  scrapeMotionValuesFromProps(t, o, n) {
    return {};
  }
  constructor({ parent: t, props: o, presenceContext: n, reducedMotionConfig: s, blockInitialAnimation: i, visualState: l }, d = {}) {
    this.current = null, this.children = /* @__PURE__ */ new Set(), this.isVariantNode = !1, this.isControllingVariants = !1, this.shouldReduceMotion = null, this.values = /* @__PURE__ */ new Map(), this.KeyframeResolver = KeyframeResolver, this.features = {}, this.valueSubscriptions = /* @__PURE__ */ new Map(), this.prevMotionValues = {}, this.events = {}, this.propEventSubscriptions = {}, this.notifyUpdate = () => this.notify("Update", this.latestValues), this.render = () => {
      this.current && (this.triggerBuild(), this.renderInstance(this.current, this.renderState, this.props.style, this.projection));
    }, this.renderScheduledAt = 0, this.scheduleRender = () => {
      const g = time.now();
      this.renderScheduledAt < g && (this.renderScheduledAt = g, frame.render(this.render, !1, !0));
    };
    const { latestValues: u, renderState: c } = l;
    this.latestValues = u, this.baseTarget = { ...u }, this.initialValues = o.initial ? { ...u } : {}, this.renderState = c, this.parent = t, this.props = o, this.presenceContext = n, this.depth = t ? t.depth + 1 : 0, this.reducedMotionConfig = s, this.options = d, this.blockInitialAnimation = !!i, this.isControllingVariants = isControllingVariants(o), this.isVariantNode = isVariantNode(o), this.isVariantNode && (this.variantChildren = /* @__PURE__ */ new Set()), this.manuallyAnimateOnMount = !!(t && t.current);
    const { willChange: p, ...f } = this.scrapeMotionValuesFromProps(o, {}, this);
    for (const g in f) {
      const y = f[g];
      u[g] !== void 0 && isMotionValue(y) && y.set(u[g]);
    }
  }
  mount(t) {
    this.current = t, visualElementStore.set(t, this), this.projection && !this.projection.instance && this.projection.mount(t), this.parent && this.isVariantNode && !this.isControllingVariants && (this.removeFromVariantTree = this.parent.addVariantChild(this)), this.values.forEach((o, n) => this.bindToMotionValue(n, o)), hasReducedMotionListener.current || initPrefersReducedMotion(), this.shouldReduceMotion = this.reducedMotionConfig === "never" ? !1 : this.reducedMotionConfig === "always" ? !0 : prefersReducedMotion.current, process.env.NODE_ENV !== "production" && warnOnce$1(this.shouldReduceMotion !== !0, "You have Reduced Motion enabled on your device. Animations may not appear as expected.", "reduced-motion-disabled"), this.parent?.addChild(this), this.update(this.props, this.presenceContext);
  }
  unmount() {
    this.projection && this.projection.unmount(), cancelFrame(this.notifyUpdate), cancelFrame(this.render), this.valueSubscriptions.forEach((t) => t()), this.valueSubscriptions.clear(), this.removeFromVariantTree && this.removeFromVariantTree(), this.parent?.removeChild(this);
    for (const t in this.events)
      this.events[t].clear();
    for (const t in this.features) {
      const o = this.features[t];
      o && (o.unmount(), o.isMounted = !1);
    }
    this.current = null;
  }
  addChild(t) {
    this.children.add(t), this.enteringChildren ?? (this.enteringChildren = /* @__PURE__ */ new Set()), this.enteringChildren.add(t);
  }
  removeChild(t) {
    this.children.delete(t), this.enteringChildren && this.enteringChildren.delete(t);
  }
  bindToMotionValue(t, o) {
    this.valueSubscriptions.has(t) && this.valueSubscriptions.get(t)();
    const n = transformProps.has(t);
    n && this.onBindTransform && this.onBindTransform();
    const s = o.on("change", (l) => {
      this.latestValues[t] = l, this.props.onUpdate && frame.preRender(this.notifyUpdate), n && this.projection && (this.projection.isTransformDirty = !0), this.scheduleRender();
    });
    let i;
    window.MotionCheckAppearSync && (i = window.MotionCheckAppearSync(this, t, o)), this.valueSubscriptions.set(t, () => {
      s(), i && i(), o.owner && o.stop();
    });
  }
  sortNodePosition(t) {
    return !this.current || !this.sortInstanceNodePosition || this.type !== t.type ? 0 : this.sortInstanceNodePosition(this.current, t.current);
  }
  updateFeatures() {
    let t = "animation";
    for (t in featureDefinitions) {
      const o = featureDefinitions[t];
      if (!o)
        continue;
      const { isEnabled: n, Feature: s } = o;
      if (!this.features[t] && s && n(this.props) && (this.features[t] = new s(this)), this.features[t]) {
        const i = this.features[t];
        i.isMounted ? i.update() : (i.mount(), i.isMounted = !0);
      }
    }
  }
  triggerBuild() {
    this.build(this.renderState, this.latestValues, this.props);
  }
  /**
   * Measure the current viewport box with or without transforms.
   * Only measures axis-aligned boxes, rotate and skew must be manually
   * removed with a re-render to work.
   */
  measureViewportBox() {
    return this.current ? this.measureInstanceViewportBox(this.current, this.props) : createBox();
  }
  getStaticValue(t) {
    return this.latestValues[t];
  }
  setStaticValue(t, o) {
    this.latestValues[t] = o;
  }
  /**
   * Update the provided props. Ensure any newly-added motion values are
   * added to our map, old ones removed, and listeners updated.
   */
  update(t, o) {
    (t.transformTemplate || this.props.transformTemplate) && this.scheduleRender(), this.prevProps = this.props, this.props = t, this.prevPresenceContext = this.presenceContext, this.presenceContext = o;
    for (let n = 0; n < propEventHandlers.length; n++) {
      const s = propEventHandlers[n];
      this.propEventSubscriptions[s] && (this.propEventSubscriptions[s](), delete this.propEventSubscriptions[s]);
      const i = "on" + s, l = t[i];
      l && (this.propEventSubscriptions[s] = this.on(s, l));
    }
    this.prevMotionValues = updateMotionValuesFromProps(this, this.scrapeMotionValuesFromProps(t, this.prevProps, this), this.prevMotionValues), this.handleChildMotionValue && this.handleChildMotionValue();
  }
  getProps() {
    return this.props;
  }
  /**
   * Returns the variant definition with a given name.
   */
  getVariant(t) {
    return this.props.variants ? this.props.variants[t] : void 0;
  }
  /**
   * Returns the defined default transition on this component.
   */
  getDefaultTransition() {
    return this.props.transition;
  }
  getTransformPagePoint() {
    return this.props.transformPagePoint;
  }
  getClosestVariantNode() {
    return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : void 0;
  }
  /**
   * Add a child visual element to our set of children.
   */
  addVariantChild(t) {
    const o = this.getClosestVariantNode();
    if (o)
      return o.variantChildren && o.variantChildren.add(t), () => o.variantChildren.delete(t);
  }
  /**
   * Add a motion value and bind it to this visual element.
   */
  addValue(t, o) {
    const n = this.values.get(t);
    o !== n && (n && this.removeValue(t), this.bindToMotionValue(t, o), this.values.set(t, o), this.latestValues[t] = o.get());
  }
  /**
   * Remove a motion value and unbind any active subscriptions.
   */
  removeValue(t) {
    this.values.delete(t);
    const o = this.valueSubscriptions.get(t);
    o && (o(), this.valueSubscriptions.delete(t)), delete this.latestValues[t], this.removeValueFromRenderState(t, this.renderState);
  }
  /**
   * Check whether we have a motion value for this key
   */
  hasValue(t) {
    return this.values.has(t);
  }
  getValue(t, o) {
    if (this.props.values && this.props.values[t])
      return this.props.values[t];
    let n = this.values.get(t);
    return n === void 0 && o !== void 0 && (n = motionValue(o === null ? void 0 : o, { owner: this }), this.addValue(t, n)), n;
  }
  /**
   * If we're trying to animate to a previously unencountered value,
   * we need to check for it in our state and as a last resort read it
   * directly from the instance (which might have performance implications).
   */
  readValue(t, o) {
    let n = this.latestValues[t] !== void 0 || !this.current ? this.latestValues[t] : this.getBaseTargetFromProps(this.props, t) ?? this.readValueFromInstance(this.current, t, this.options);
    return n != null && (typeof n == "string" && (isNumericalString(n) || isZeroValueString(n)) ? n = parseFloat(n) : !findValueType(n) && complex.test(o) && (n = getAnimatableNone(t, o)), this.setBaseTarget(t, isMotionValue(n) ? n.get() : n)), isMotionValue(n) ? n.get() : n;
  }
  /**
   * Set the base target to later animate back to. This is currently
   * only hydrated on creation and when we first read a value.
   */
  setBaseTarget(t, o) {
    this.baseTarget[t] = o;
  }
  /**
   * Find the base target for a value thats been removed from all animation
   * props.
   */
  getBaseTarget(t) {
    const { initial: o } = this.props;
    let n;
    if (typeof o == "string" || typeof o == "object") {
      const i = resolveVariantFromProps(this.props, o, this.presenceContext?.custom);
      i && (n = i[t]);
    }
    if (o && n !== void 0)
      return n;
    const s = this.getBaseTargetFromProps(this.props, t);
    return s !== void 0 && !isMotionValue(s) ? s : this.initialValues[t] !== void 0 && n === void 0 ? void 0 : this.baseTarget[t];
  }
  on(t, o) {
    return this.events[t] || (this.events[t] = new SubscriptionManager()), this.events[t].add(o);
  }
  notify(t, ...o) {
    this.events[t] && this.events[t].notify(...o);
  }
  scheduleRenderMicrotask() {
    microtask.render(this.render);
  }
}
class DOMVisualElement extends VisualElement {
  constructor() {
    super(...arguments), this.KeyframeResolver = DOMKeyframesResolver;
  }
  sortInstanceNodePosition(t, o) {
    return t.compareDocumentPosition(o) & 2 ? 1 : -1;
  }
  getBaseTargetFromProps(t, o) {
    return t.style ? t.style[o] : void 0;
  }
  removeValueFromRenderState(t, { vars: o, style: n }) {
    delete o[t], delete n[t];
  }
  handleChildMotionValue() {
    this.childSubscription && (this.childSubscription(), delete this.childSubscription);
    const { children: t } = this.props;
    isMotionValue(t) && (this.childSubscription = t.on("change", (o) => {
      this.current && (this.current.textContent = `${o}`);
    }));
  }
}
function renderHTML(e, { style: t, vars: o }, n, s) {
  const i = e.style;
  let l;
  for (l in t)
    i[l] = t[l];
  s?.applyProjectionStyles(i, n);
  for (l in o)
    i.setProperty(l, o[l]);
}
function getComputedStyle$2(e) {
  return window.getComputedStyle(e);
}
class HTMLVisualElement extends DOMVisualElement {
  constructor() {
    super(...arguments), this.type = "html", this.renderInstance = renderHTML;
  }
  readValueFromInstance(t, o) {
    if (transformProps.has(o))
      return this.projection?.isProjecting ? defaultTransformValue(o) : readTransformValue(t, o);
    {
      const n = getComputedStyle$2(t), s = (isCSSVariableName(o) ? n.getPropertyValue(o) : n[o]) || 0;
      return typeof s == "string" ? s.trim() : s;
    }
  }
  measureInstanceViewportBox(t, { transformPagePoint: o }) {
    return measureViewportBox(t, o);
  }
  build(t, o, n) {
    buildHTMLStyles(t, o, n.transformTemplate);
  }
  scrapeMotionValuesFromProps(t, o, n) {
    return scrapeMotionValuesFromProps$1(t, o, n);
  }
}
const camelCaseAttributes = /* @__PURE__ */ new Set([
  "baseFrequency",
  "diffuseConstant",
  "kernelMatrix",
  "kernelUnitLength",
  "keySplines",
  "keyTimes",
  "limitingConeAngle",
  "markerHeight",
  "markerWidth",
  "numOctaves",
  "targetX",
  "targetY",
  "surfaceScale",
  "specularConstant",
  "specularExponent",
  "stdDeviation",
  "tableValues",
  "viewBox",
  "gradientTransform",
  "pathLength",
  "startOffset",
  "textLength",
  "lengthAdjust"
]);
function renderSVG(e, t, o, n) {
  renderHTML(e, t, void 0, n);
  for (const s in t.attrs)
    e.setAttribute(camelCaseAttributes.has(s) ? s : camelToDash(s), t.attrs[s]);
}
class SVGVisualElement extends DOMVisualElement {
  constructor() {
    super(...arguments), this.type = "svg", this.isSVGTag = !1, this.measureInstanceViewportBox = createBox;
  }
  getBaseTargetFromProps(t, o) {
    return t[o];
  }
  readValueFromInstance(t, o) {
    if (transformProps.has(o)) {
      const n = getDefaultValueType(o);
      return n && n.default || 0;
    }
    return o = camelCaseAttributes.has(o) ? o : camelToDash(o), t.getAttribute(o);
  }
  scrapeMotionValuesFromProps(t, o, n) {
    return scrapeMotionValuesFromProps(t, o, n);
  }
  build(t, o, n) {
    buildSVGAttrs(t, o, this.isSVGTag, n.transformTemplate, n.style);
  }
  renderInstance(t, o, n, s) {
    renderSVG(t, o, n, s);
  }
  mount(t) {
    this.isSVGTag = isSVGTag(t.tagName), super.mount(t);
  }
}
const createDomVisualElement = (e, t) => isSVGComponent(e) ? new SVGVisualElement(t) : new HTMLVisualElement(t, {
  allowProjection: e !== Fragment
});
function resolveVariant(e, t, o) {
  const n = e.getProps();
  return resolveVariantFromProps(n, t, o !== void 0 ? o : n.custom, e);
}
const isKeyframesTarget = (e) => Array.isArray(e);
function setMotionValue(e, t, o) {
  e.hasValue(t) ? e.getValue(t).set(o) : e.addValue(t, motionValue(o));
}
function resolveFinalValueInKeyframes(e) {
  return isKeyframesTarget(e) ? e[e.length - 1] || 0 : e;
}
function setTarget(e, t) {
  const o = resolveVariant(e, t);
  let { transitionEnd: n = {}, transition: s = {}, ...i } = o || {};
  i = { ...i, ...n };
  for (const l in i) {
    const d = resolveFinalValueInKeyframes(i[l]);
    setMotionValue(e, l, d);
  }
}
function isWillChangeMotionValue(e) {
  return !!(isMotionValue(e) && e.add);
}
function addValueToWillChange(e, t) {
  const o = e.getValue("willChange");
  if (isWillChangeMotionValue(o))
    return o.add(t);
  if (!o && MotionGlobalConfig.WillChange) {
    const n = new MotionGlobalConfig.WillChange("auto");
    e.addValue("willChange", n), n.add(t);
  }
}
function getOptimisedAppearId(e) {
  return e.props[optimizedAppearDataAttribute];
}
const isNotNull = (e) => e !== null;
function getFinalKeyframe(e, { repeat: t, repeatType: o = "loop" }, n) {
  const s = e.filter(isNotNull), i = t && o !== "loop" && t % 2 === 1 ? 0 : s.length - 1;
  return s[i];
}
const underDampedSpring = {
  type: "spring",
  stiffness: 500,
  damping: 25,
  restSpeed: 10
}, criticallyDampedSpring = (e) => ({
  type: "spring",
  stiffness: 550,
  damping: e === 0 ? 2 * Math.sqrt(550) : 30,
  restSpeed: 10
}), keyframesTransition = {
  type: "keyframes",
  duration: 0.8
}, ease = {
  type: "keyframes",
  ease: [0.25, 0.1, 0.35, 1],
  duration: 0.3
}, getDefaultTransition = (e, { keyframes: t }) => t.length > 2 ? keyframesTransition : transformProps.has(e) ? e.startsWith("scale") ? criticallyDampedSpring(t[1]) : underDampedSpring : ease;
function isTransitionDefined({ when: e, delay: t, delayChildren: o, staggerChildren: n, staggerDirection: s, repeat: i, repeatType: l, repeatDelay: d, from: u, elapsed: c, ...p }) {
  return !!Object.keys(p).length;
}
const animateMotionValue = (e, t, o, n = {}, s, i) => (l) => {
  const d = getValueTransition(n, e) || {}, u = d.delay || n.delay || 0;
  let { elapsed: c = 0 } = n;
  c = c - /* @__PURE__ */ secondsToMilliseconds(u);
  const p = {
    keyframes: Array.isArray(o) ? o : [null, o],
    ease: "easeOut",
    velocity: t.getVelocity(),
    ...d,
    delay: -c,
    onUpdate: (g) => {
      t.set(g), d.onUpdate && d.onUpdate(g);
    },
    onComplete: () => {
      l(), d.onComplete && d.onComplete();
    },
    name: e,
    motionValue: t,
    element: i ? void 0 : s
  };
  isTransitionDefined(d) || Object.assign(p, getDefaultTransition(e, p)), p.duration && (p.duration = /* @__PURE__ */ secondsToMilliseconds(p.duration)), p.repeatDelay && (p.repeatDelay = /* @__PURE__ */ secondsToMilliseconds(p.repeatDelay)), p.from !== void 0 && (p.keyframes[0] = p.from);
  let f = !1;
  if ((p.type === !1 || p.duration === 0 && !p.repeatDelay) && (makeAnimationInstant(p), p.delay === 0 && (f = !0)), (MotionGlobalConfig.instantAnimations || MotionGlobalConfig.skipAnimations) && (f = !0, makeAnimationInstant(p), p.delay = 0), p.allowFlatten = !d.type && !d.ease, f && !i && t.get() !== void 0) {
    const g = getFinalKeyframe(p.keyframes, d);
    if (g !== void 0) {
      frame.update(() => {
        p.onUpdate(g), p.onComplete();
      });
      return;
    }
  }
  return d.isSync ? new JSAnimation(p) : new AsyncMotionValueAnimation(p);
};
function shouldBlockAnimation({ protectedKeys: e, needsAnimating: t }, o) {
  const n = e.hasOwnProperty(o) && t[o] !== !0;
  return t[o] = !1, n;
}
function animateTarget(e, t, { delay: o = 0, transitionOverride: n, type: s } = {}) {
  let { transition: i = e.getDefaultTransition(), transitionEnd: l, ...d } = t;
  n && (i = n);
  const u = [], c = s && e.animationState && e.animationState.getState()[s];
  for (const p in d) {
    const f = e.getValue(p, e.latestValues[p] ?? null), g = d[p];
    if (g === void 0 || c && shouldBlockAnimation(c, p))
      continue;
    const y = {
      delay: o,
      ...getValueTransition(i || {}, p)
    }, h = f.get();
    if (h !== void 0 && !f.isAnimating && !Array.isArray(g) && g === h && !y.velocity)
      continue;
    let T = !1;
    if (window.MotionHandoffAnimation) {
      const E = getOptimisedAppearId(e);
      if (E) {
        const $ = window.MotionHandoffAnimation(E, p, frame);
        $ !== null && (y.startTime = $, T = !0);
      }
    }
    addValueToWillChange(e, p), f.start(animateMotionValue(p, f, g, e.shouldReduceMotion && positionalKeys.has(p) ? { type: !1 } : y, e, T));
    const P = f.animation;
    P && u.push(P);
  }
  return l && Promise.all(u).then(() => {
    frame.update(() => {
      l && setTarget(e, l);
    });
  }), u;
}
function calcChildStagger(e, t, o, n = 0, s = 1) {
  const i = Array.from(e).sort((c, p) => c.sortNodePosition(p)).indexOf(t), l = e.size, d = (l - 1) * n;
  return typeof o == "function" ? o(i, l) : s === 1 ? i * n : d - i * n;
}
function animateVariant(e, t, o = {}) {
  const n = resolveVariant(e, t, o.type === "exit" ? e.presenceContext?.custom : void 0);
  let { transition: s = e.getDefaultTransition() || {} } = n || {};
  o.transitionOverride && (s = o.transitionOverride);
  const i = n ? () => Promise.all(animateTarget(e, n, o)) : () => Promise.resolve(), l = e.variantChildren && e.variantChildren.size ? (u = 0) => {
    const { delayChildren: c = 0, staggerChildren: p, staggerDirection: f } = s;
    return animateChildren(e, t, u, c, p, f, o);
  } : () => Promise.resolve(), { when: d } = s;
  if (d) {
    const [u, c] = d === "beforeChildren" ? [i, l] : [l, i];
    return u().then(() => c());
  } else
    return Promise.all([i(), l(o.delay)]);
}
function animateChildren(e, t, o = 0, n = 0, s = 0, i = 1, l) {
  const d = [];
  for (const u of e.variantChildren)
    u.notify("AnimationStart", t), d.push(animateVariant(u, t, {
      ...l,
      delay: o + (typeof n == "function" ? 0 : n) + calcChildStagger(e.variantChildren, u, n, s, i)
    }).then(() => u.notify("AnimationComplete", t)));
  return Promise.all(d);
}
function animateVisualElement(e, t, o = {}) {
  e.notify("AnimationStart", t);
  let n;
  if (Array.isArray(t)) {
    const s = t.map((i) => animateVariant(e, i, o));
    n = Promise.all(s);
  } else if (typeof t == "string")
    n = animateVariant(e, t, o);
  else {
    const s = typeof t == "function" ? resolveVariant(e, t, o.custom) : t;
    n = Promise.all(animateTarget(e, s, o));
  }
  return n.then(() => {
    e.notify("AnimationComplete", t);
  });
}
function shallowCompare(e, t) {
  if (!Array.isArray(t))
    return !1;
  const o = t.length;
  if (o !== e.length)
    return !1;
  for (let n = 0; n < o; n++)
    if (t[n] !== e[n])
      return !1;
  return !0;
}
const numVariantProps = variantProps.length;
function getVariantContext(e) {
  if (!e)
    return;
  if (!e.isControllingVariants) {
    const o = e.parent ? getVariantContext(e.parent) || {} : {};
    return e.props.initial !== void 0 && (o.initial = e.props.initial), o;
  }
  const t = {};
  for (let o = 0; o < numVariantProps; o++) {
    const n = variantProps[o], s = e.props[n];
    (isVariantLabel(s) || s === !1) && (t[n] = s);
  }
  return t;
}
const reversePriorityOrder = [...variantPriorityOrder].reverse(), numAnimationTypes = variantPriorityOrder.length;
function animateList(e) {
  return (t) => Promise.all(t.map(({ animation: o, options: n }) => animateVisualElement(e, o, n)));
}
function createAnimationState(e) {
  let t = animateList(e), o = createState(), n = !0;
  const s = (u) => (c, p) => {
    const f = resolveVariant(e, p, u === "exit" ? e.presenceContext?.custom : void 0);
    if (f) {
      const { transition: g, transitionEnd: y, ...h } = f;
      c = { ...c, ...h, ...y };
    }
    return c;
  };
  function i(u) {
    t = u(e);
  }
  function l(u) {
    const { props: c } = e, p = getVariantContext(e.parent) || {}, f = [], g = /* @__PURE__ */ new Set();
    let y = {}, h = 1 / 0;
    for (let P = 0; P < numAnimationTypes; P++) {
      const E = reversePriorityOrder[P], $ = o[E], R = c[E] !== void 0 ? c[E] : p[E], C = isVariantLabel(R), x = E === u ? $.isActive : null;
      x === !1 && (h = P);
      let _ = R === p[E] && R !== c[E] && C;
      if (_ && n && e.manuallyAnimateOnMount && (_ = !1), $.protectedKeys = { ...y }, // If it isn't active and hasn't *just* been set as inactive
      !$.isActive && x === null || // If we didn't and don't have any defined prop for this animation type
      !R && !$.prevProp || // Or if the prop doesn't define an animation
      isAnimationControls(R) || typeof R == "boolean")
        continue;
      const D = checkVariantsDidChange($.prevProp, R);
      let O = D || // If we're making this variant active, we want to always make it active
      E === u && $.isActive && !_ && C || // If we removed a higher-priority variant (i is in reverse order)
      P > h && C, v = !1;
      const w = Array.isArray(R) ? R : [R];
      let M = w.reduce(s(E), {});
      x === !1 && (M = {});
      const { prevResolvedValues: S = {} } = $, I = {
        ...S,
        ...M
      }, N = (k) => {
        O = !0, g.has(k) && (v = !0, g.delete(k)), $.needsAnimating[k] = !0;
        const W = e.getValue(k);
        W && (W.liveStyle = !1);
      };
      for (const k in I) {
        const W = M[k], V = S[k];
        if (y.hasOwnProperty(k))
          continue;
        let j = !1;
        isKeyframesTarget(W) && isKeyframesTarget(V) ? j = !shallowCompare(W, V) : j = W !== V, j ? W != null ? N(k) : g.add(k) : W !== void 0 && g.has(k) ? N(k) : $.protectedKeys[k] = !0;
      }
      $.prevProp = R, $.prevResolvedValues = M, $.isActive && (y = { ...y, ...M }), n && e.blockInitialAnimation && (O = !1);
      const F = _ && D;
      O && (!F || v) && f.push(...w.map((k) => {
        const W = { type: E };
        if (typeof k == "string" && n && !F && e.manuallyAnimateOnMount && e.parent) {
          const { parent: V } = e, j = resolveVariant(V, k);
          if (V.enteringChildren && j) {
            const { delayChildren: A } = j.transition || {};
            W.delay = calcChildStagger(V.enteringChildren, e, A);
          }
        }
        return {
          animation: k,
          options: W
        };
      }));
    }
    if (g.size) {
      const P = {};
      if (typeof c.initial != "boolean") {
        const E = resolveVariant(e, Array.isArray(c.initial) ? c.initial[0] : c.initial);
        E && E.transition && (P.transition = E.transition);
      }
      g.forEach((E) => {
        const $ = e.getBaseTarget(E), R = e.getValue(E);
        R && (R.liveStyle = !0), P[E] = $ ?? null;
      }), f.push({ animation: P });
    }
    let T = !!f.length;
    return n && (c.initial === !1 || c.initial === c.animate) && !e.manuallyAnimateOnMount && (T = !1), n = !1, T ? t(f) : Promise.resolve();
  }
  function d(u, c) {
    if (o[u].isActive === c)
      return Promise.resolve();
    e.variantChildren?.forEach((f) => f.animationState?.setActive(u, c)), o[u].isActive = c;
    const p = l(u);
    for (const f in o)
      o[f].protectedKeys = {};
    return p;
  }
  return {
    animateChanges: l,
    setActive: d,
    setAnimateFunction: i,
    getState: () => o,
    reset: () => {
      o = createState();
    }
  };
}
function checkVariantsDidChange(e, t) {
  return typeof t == "string" ? t !== e : Array.isArray(t) ? !shallowCompare(t, e) : !1;
}
function createTypeState(e = !1) {
  return {
    isActive: e,
    protectedKeys: {},
    needsAnimating: {},
    prevResolvedValues: {}
  };
}
function createState() {
  return {
    animate: createTypeState(!0),
    whileInView: createTypeState(),
    whileHover: createTypeState(),
    whileTap: createTypeState(),
    whileDrag: createTypeState(),
    whileFocus: createTypeState(),
    exit: createTypeState()
  };
}
class Feature {
  constructor(t) {
    this.isMounted = !1, this.node = t;
  }
  update() {
  }
}
class AnimationFeature extends Feature {
  /**
   * We dynamically generate the AnimationState manager as it contains a reference
   * to the underlying animation library. We only want to load that if we load this,
   * so people can optionally code split it out using the `m` component.
   */
  constructor(t) {
    super(t), t.animationState || (t.animationState = createAnimationState(t));
  }
  updateAnimationControlsSubscription() {
    const { animate: t } = this.node.getProps();
    isAnimationControls(t) && (this.unmountControls = t.subscribe(this.node));
  }
  /**
   * Subscribe any provided AnimationControls to the component's VisualElement
   */
  mount() {
    this.updateAnimationControlsSubscription();
  }
  update() {
    const { animate: t } = this.node.getProps(), { animate: o } = this.node.prevProps || {};
    t !== o && this.updateAnimationControlsSubscription();
  }
  unmount() {
    this.node.animationState.reset(), this.unmountControls?.();
  }
}
let id$1 = 0;
class ExitAnimationFeature extends Feature {
  constructor() {
    super(...arguments), this.id = id$1++;
  }
  update() {
    if (!this.node.presenceContext)
      return;
    const { isPresent: t, onExitComplete: o } = this.node.presenceContext, { isPresent: n } = this.node.prevPresenceContext || {};
    if (!this.node.animationState || t === n)
      return;
    const s = this.node.animationState.setActive("exit", !t);
    o && !t && s.then(() => {
      o(this.id);
    });
  }
  mount() {
    const { register: t, onExitComplete: o } = this.node.presenceContext || {};
    o && o(this.id), t && (this.unmount = t(this.id));
  }
  unmount() {
  }
}
const animations = {
  animation: {
    Feature: AnimationFeature
  },
  exit: {
    Feature: ExitAnimationFeature
  }
};
function addDomEvent(e, t, o, n = { passive: !0 }) {
  return e.addEventListener(t, o, n), () => e.removeEventListener(t, o);
}
function extractEventInfo(e) {
  return {
    point: {
      x: e.pageX,
      y: e.pageY
    }
  };
}
const addPointerInfo = (e) => (t) => isPrimaryPointer(t) && e(t, extractEventInfo(t));
function addPointerEvent(e, t, o, n) {
  return addDomEvent(e, t, addPointerInfo(o), n);
}
const SCALE_PRECISION = 1e-4, SCALE_MIN = 1 - SCALE_PRECISION, SCALE_MAX = 1 + SCALE_PRECISION, TRANSLATE_PRECISION = 0.01, TRANSLATE_MIN = 0 - TRANSLATE_PRECISION, TRANSLATE_MAX = 0 + TRANSLATE_PRECISION;
function calcLength(e) {
  return e.max - e.min;
}
function isNear(e, t, o) {
  return Math.abs(e - t) <= o;
}
function calcAxisDelta(e, t, o, n = 0.5) {
  e.origin = n, e.originPoint = mixNumber$1(t.min, t.max, e.origin), e.scale = calcLength(o) / calcLength(t), e.translate = mixNumber$1(o.min, o.max, e.origin) - e.originPoint, (e.scale >= SCALE_MIN && e.scale <= SCALE_MAX || isNaN(e.scale)) && (e.scale = 1), (e.translate >= TRANSLATE_MIN && e.translate <= TRANSLATE_MAX || isNaN(e.translate)) && (e.translate = 0);
}
function calcBoxDelta(e, t, o, n) {
  calcAxisDelta(e.x, t.x, o.x, n ? n.originX : void 0), calcAxisDelta(e.y, t.y, o.y, n ? n.originY : void 0);
}
function calcRelativeAxis(e, t, o) {
  e.min = o.min + t.min, e.max = e.min + calcLength(t);
}
function calcRelativeBox(e, t, o) {
  calcRelativeAxis(e.x, t.x, o.x), calcRelativeAxis(e.y, t.y, o.y);
}
function calcRelativeAxisPosition(e, t, o) {
  e.min = t.min - o.min, e.max = e.min + calcLength(t);
}
function calcRelativePosition(e, t, o) {
  calcRelativeAxisPosition(e.x, t.x, o.x), calcRelativeAxisPosition(e.y, t.y, o.y);
}
function eachAxis(e) {
  return [e("x"), e("y")];
}
const getContextWindow = ({ current: e }) => e ? e.ownerDocument.defaultView : null, distance = (e, t) => Math.abs(e - t);
function distance2D(e, t) {
  const o = distance(e.x, t.x), n = distance(e.y, t.y);
  return Math.sqrt(o ** 2 + n ** 2);
}
class PanSession {
  constructor(t, o, { transformPagePoint: n, contextWindow: s = window, dragSnapToOrigin: i = !1, distanceThreshold: l = 3 } = {}) {
    if (this.startEvent = null, this.lastMoveEvent = null, this.lastMoveEventInfo = null, this.handlers = {}, this.contextWindow = window, this.updatePoint = () => {
      if (!(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const g = getPanInfo(this.lastMoveEventInfo, this.history), y = this.startEvent !== null, h = distance2D(g.offset, { x: 0, y: 0 }) >= this.distanceThreshold;
      if (!y && !h)
        return;
      const { point: T } = g, { timestamp: P } = frameData;
      this.history.push({ ...T, timestamp: P });
      const { onStart: E, onMove: $ } = this.handlers;
      y || (E && E(this.lastMoveEvent, g), this.startEvent = this.lastMoveEvent), $ && $(this.lastMoveEvent, g);
    }, this.handlePointerMove = (g, y) => {
      this.lastMoveEvent = g, this.lastMoveEventInfo = transformPoint(y, this.transformPagePoint), frame.update(this.updatePoint, !0);
    }, this.handlePointerUp = (g, y) => {
      this.end();
      const { onEnd: h, onSessionEnd: T, resumeAnimation: P } = this.handlers;
      if (this.dragSnapToOrigin && P && P(), !(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const E = getPanInfo(g.type === "pointercancel" ? this.lastMoveEventInfo : transformPoint(y, this.transformPagePoint), this.history);
      this.startEvent && h && h(g, E), T && T(g, E);
    }, !isPrimaryPointer(t))
      return;
    this.dragSnapToOrigin = i, this.handlers = o, this.transformPagePoint = n, this.distanceThreshold = l, this.contextWindow = s || window;
    const d = extractEventInfo(t), u = transformPoint(d, this.transformPagePoint), { point: c } = u, { timestamp: p } = frameData;
    this.history = [{ ...c, timestamp: p }];
    const { onSessionStart: f } = o;
    f && f(t, getPanInfo(u, this.history)), this.removeListeners = pipe(addPointerEvent(this.contextWindow, "pointermove", this.handlePointerMove), addPointerEvent(this.contextWindow, "pointerup", this.handlePointerUp), addPointerEvent(this.contextWindow, "pointercancel", this.handlePointerUp));
  }
  updateHandlers(t) {
    this.handlers = t;
  }
  end() {
    this.removeListeners && this.removeListeners(), cancelFrame(this.updatePoint);
  }
}
function transformPoint(e, t) {
  return t ? { point: t(e.point) } : e;
}
function subtractPoint(e, t) {
  return { x: e.x - t.x, y: e.y - t.y };
}
function getPanInfo({ point: e }, t) {
  return {
    point: e,
    delta: subtractPoint(e, lastDevicePoint(t)),
    offset: subtractPoint(e, startDevicePoint(t)),
    velocity: getVelocity(t, 0.1)
  };
}
function startDevicePoint(e) {
  return e[0];
}
function lastDevicePoint(e) {
  return e[e.length - 1];
}
function getVelocity(e, t) {
  if (e.length < 2)
    return { x: 0, y: 0 };
  let o = e.length - 1, n = null;
  const s = lastDevicePoint(e);
  for (; o >= 0 && (n = e[o], !(s.timestamp - n.timestamp > /* @__PURE__ */ secondsToMilliseconds(t))); )
    o--;
  if (!n)
    return { x: 0, y: 0 };
  const i = /* @__PURE__ */ millisecondsToSeconds(s.timestamp - n.timestamp);
  if (i === 0)
    return { x: 0, y: 0 };
  const l = {
    x: (s.x - n.x) / i,
    y: (s.y - n.y) / i
  };
  return l.x === 1 / 0 && (l.x = 0), l.y === 1 / 0 && (l.y = 0), l;
}
function applyConstraints(e, { min: t, max: o }, n) {
  return t !== void 0 && e < t ? e = n ? mixNumber$1(t, e, n.min) : Math.max(e, t) : o !== void 0 && e > o && (e = n ? mixNumber$1(o, e, n.max) : Math.min(e, o)), e;
}
function calcRelativeAxisConstraints(e, t, o) {
  return {
    min: t !== void 0 ? e.min + t : void 0,
    max: o !== void 0 ? e.max + o - (e.max - e.min) : void 0
  };
}
function calcRelativeConstraints(e, { top: t, left: o, bottom: n, right: s }) {
  return {
    x: calcRelativeAxisConstraints(e.x, o, s),
    y: calcRelativeAxisConstraints(e.y, t, n)
  };
}
function calcViewportAxisConstraints(e, t) {
  let o = t.min - e.min, n = t.max - e.max;
  return t.max - t.min < e.max - e.min && ([o, n] = [n, o]), { min: o, max: n };
}
function calcViewportConstraints(e, t) {
  return {
    x: calcViewportAxisConstraints(e.x, t.x),
    y: calcViewportAxisConstraints(e.y, t.y)
  };
}
function calcOrigin(e, t) {
  let o = 0.5;
  const n = calcLength(e), s = calcLength(t);
  return s > n ? o = /* @__PURE__ */ progress(t.min, t.max - n, e.min) : n > s && (o = /* @__PURE__ */ progress(e.min, e.max - s, t.min)), clamp(0, 1, o);
}
function rebaseAxisConstraints(e, t) {
  const o = {};
  return t.min !== void 0 && (o.min = t.min - e.min), t.max !== void 0 && (o.max = t.max - e.min), o;
}
const defaultElastic = 0.35;
function resolveDragElastic(e = defaultElastic) {
  return e === !1 ? e = 0 : e === !0 && (e = defaultElastic), {
    x: resolveAxisElastic(e, "left", "right"),
    y: resolveAxisElastic(e, "top", "bottom")
  };
}
function resolveAxisElastic(e, t, o) {
  return {
    min: resolvePointElastic(e, t),
    max: resolvePointElastic(e, o)
  };
}
function resolvePointElastic(e, t) {
  return typeof e == "number" ? e : e[t] || 0;
}
const elementDragControls = /* @__PURE__ */ new WeakMap();
class VisualElementDragControls {
  constructor(t) {
    this.openDragLock = null, this.isDragging = !1, this.currentDirection = null, this.originPoint = { x: 0, y: 0 }, this.constraints = !1, this.hasMutatedConstraints = !1, this.elastic = createBox(), this.latestPointerEvent = null, this.latestPanInfo = null, this.visualElement = t;
  }
  start(t, { snapToCursor: o = !1, distanceThreshold: n } = {}) {
    const { presenceContext: s } = this.visualElement;
    if (s && s.isPresent === !1)
      return;
    const i = (f) => {
      const { dragSnapToOrigin: g } = this.getProps();
      g ? this.pauseAnimation() : this.stopAnimation(), o && this.snapToCursor(extractEventInfo(f).point);
    }, l = (f, g) => {
      const { drag: y, dragPropagation: h, onDragStart: T } = this.getProps();
      if (y && !h && (this.openDragLock && this.openDragLock(), this.openDragLock = setDragLock(y), !this.openDragLock))
        return;
      this.latestPointerEvent = f, this.latestPanInfo = g, this.isDragging = !0, this.currentDirection = null, this.resolveConstraints(), this.visualElement.projection && (this.visualElement.projection.isAnimationBlocked = !0, this.visualElement.projection.target = void 0), eachAxis((E) => {
        let $ = this.getAxisMotionValue(E).get() || 0;
        if (percent.test($)) {
          const { projection: R } = this.visualElement;
          if (R && R.layout) {
            const C = R.layout.layoutBox[E];
            C && ($ = calcLength(C) * (parseFloat($) / 100));
          }
        }
        this.originPoint[E] = $;
      }), T && frame.postRender(() => T(f, g)), addValueToWillChange(this.visualElement, "transform");
      const { animationState: P } = this.visualElement;
      P && P.setActive("whileDrag", !0);
    }, d = (f, g) => {
      this.latestPointerEvent = f, this.latestPanInfo = g;
      const { dragPropagation: y, dragDirectionLock: h, onDirectionLock: T, onDrag: P } = this.getProps();
      if (!y && !this.openDragLock)
        return;
      const { offset: E } = g;
      if (h && this.currentDirection === null) {
        this.currentDirection = getCurrentDirection(E), this.currentDirection !== null && T && T(this.currentDirection);
        return;
      }
      this.updateAxis("x", g.point, E), this.updateAxis("y", g.point, E), this.visualElement.render(), P && P(f, g);
    }, u = (f, g) => {
      this.latestPointerEvent = f, this.latestPanInfo = g, this.stop(f, g), this.latestPointerEvent = null, this.latestPanInfo = null;
    }, c = () => eachAxis((f) => this.getAnimationState(f) === "paused" && this.getAxisMotionValue(f).animation?.play()), { dragSnapToOrigin: p } = this.getProps();
    this.panSession = new PanSession(t, {
      onSessionStart: i,
      onStart: l,
      onMove: d,
      onSessionEnd: u,
      resumeAnimation: c
    }, {
      transformPagePoint: this.visualElement.getTransformPagePoint(),
      dragSnapToOrigin: p,
      distanceThreshold: n,
      contextWindow: getContextWindow(this.visualElement)
    });
  }
  /**
   * @internal
   */
  stop(t, o) {
    const n = t || this.latestPointerEvent, s = o || this.latestPanInfo, i = this.isDragging;
    if (this.cancel(), !i || !s || !n)
      return;
    const { velocity: l } = s;
    this.startAnimation(l);
    const { onDragEnd: d } = this.getProps();
    d && frame.postRender(() => d(n, s));
  }
  /**
   * @internal
   */
  cancel() {
    this.isDragging = !1;
    const { projection: t, animationState: o } = this.visualElement;
    t && (t.isAnimationBlocked = !1), this.panSession && this.panSession.end(), this.panSession = void 0;
    const { dragPropagation: n } = this.getProps();
    !n && this.openDragLock && (this.openDragLock(), this.openDragLock = null), o && o.setActive("whileDrag", !1);
  }
  updateAxis(t, o, n) {
    const { drag: s } = this.getProps();
    if (!n || !shouldDrag(t, s, this.currentDirection))
      return;
    const i = this.getAxisMotionValue(t);
    let l = this.originPoint[t] + n[t];
    this.constraints && this.constraints[t] && (l = applyConstraints(l, this.constraints[t], this.elastic[t])), i.set(l);
  }
  resolveConstraints() {
    const { dragConstraints: t, dragElastic: o } = this.getProps(), n = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(!1) : this.visualElement.projection?.layout, s = this.constraints;
    t && isRefObject(t) ? this.constraints || (this.constraints = this.resolveRefConstraints()) : t && n ? this.constraints = calcRelativeConstraints(n.layoutBox, t) : this.constraints = !1, this.elastic = resolveDragElastic(o), s !== this.constraints && n && this.constraints && !this.hasMutatedConstraints && eachAxis((i) => {
      this.constraints !== !1 && this.getAxisMotionValue(i) && (this.constraints[i] = rebaseAxisConstraints(n.layoutBox[i], this.constraints[i]));
    });
  }
  resolveRefConstraints() {
    const { dragConstraints: t, onMeasureDragConstraints: o } = this.getProps();
    if (!t || !isRefObject(t))
      return !1;
    const n = t.current;
    invariant(n !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.", "drag-constraints-ref");
    const { projection: s } = this.visualElement;
    if (!s || !s.layout)
      return !1;
    const i = measurePageBox(n, s.root, this.visualElement.getTransformPagePoint());
    let l = calcViewportConstraints(s.layout.layoutBox, i);
    if (o) {
      const d = o(convertBoxToBoundingBox(l));
      this.hasMutatedConstraints = !!d, d && (l = convertBoundingBoxToBox(d));
    }
    return l;
  }
  startAnimation(t) {
    const { drag: o, dragMomentum: n, dragElastic: s, dragTransition: i, dragSnapToOrigin: l, onDragTransitionEnd: d } = this.getProps(), u = this.constraints || {}, c = eachAxis((p) => {
      if (!shouldDrag(p, o, this.currentDirection))
        return;
      let f = u && u[p] || {};
      l && (f = { min: 0, max: 0 });
      const g = s ? 200 : 1e6, y = s ? 40 : 1e7, h = {
        type: "inertia",
        velocity: n ? t[p] : 0,
        bounceStiffness: g,
        bounceDamping: y,
        timeConstant: 750,
        restDelta: 1,
        restSpeed: 10,
        ...i,
        ...f
      };
      return this.startAxisValueAnimation(p, h);
    });
    return Promise.all(c).then(d);
  }
  startAxisValueAnimation(t, o) {
    const n = this.getAxisMotionValue(t);
    return addValueToWillChange(this.visualElement, t), n.start(animateMotionValue(t, n, 0, o, this.visualElement, !1));
  }
  stopAnimation() {
    eachAxis((t) => this.getAxisMotionValue(t).stop());
  }
  pauseAnimation() {
    eachAxis((t) => this.getAxisMotionValue(t).animation?.pause());
  }
  getAnimationState(t) {
    return this.getAxisMotionValue(t).animation?.state;
  }
  /**
   * Drag works differently depending on which props are provided.
   *
   * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
   * - Otherwise, we apply the delta to the x/y motion values.
   */
  getAxisMotionValue(t) {
    const o = `_drag${t.toUpperCase()}`, n = this.visualElement.getProps(), s = n[o];
    return s || this.visualElement.getValue(t, (n.initial ? n.initial[t] : void 0) || 0);
  }
  snapToCursor(t) {
    eachAxis((o) => {
      const { drag: n } = this.getProps();
      if (!shouldDrag(o, n, this.currentDirection))
        return;
      const { projection: s } = this.visualElement, i = this.getAxisMotionValue(o);
      if (s && s.layout) {
        const { min: l, max: d } = s.layout.layoutBox[o];
        i.set(t[o] - mixNumber$1(l, d, 0.5));
      }
    });
  }
  /**
   * When the viewport resizes we want to check if the measured constraints
   * have changed and, if so, reposition the element within those new constraints
   * relative to where it was before the resize.
   */
  scalePositionWithinConstraints() {
    if (!this.visualElement.current)
      return;
    const { drag: t, dragConstraints: o } = this.getProps(), { projection: n } = this.visualElement;
    if (!isRefObject(o) || !n || !this.constraints)
      return;
    this.stopAnimation();
    const s = { x: 0, y: 0 };
    eachAxis((l) => {
      const d = this.getAxisMotionValue(l);
      if (d && this.constraints !== !1) {
        const u = d.get();
        s[l] = calcOrigin({ min: u, max: u }, this.constraints[l]);
      }
    });
    const { transformTemplate: i } = this.visualElement.getProps();
    this.visualElement.current.style.transform = i ? i({}, "") : "none", n.root && n.root.updateScroll(), n.updateLayout(), this.resolveConstraints(), eachAxis((l) => {
      if (!shouldDrag(l, t, null))
        return;
      const d = this.getAxisMotionValue(l), { min: u, max: c } = this.constraints[l];
      d.set(mixNumber$1(u, c, s[l]));
    });
  }
  addListeners() {
    if (!this.visualElement.current)
      return;
    elementDragControls.set(this.visualElement, this);
    const t = this.visualElement.current, o = addPointerEvent(t, "pointerdown", (u) => {
      const { drag: c, dragListener: p = !0 } = this.getProps();
      c && p && this.start(u);
    }), n = () => {
      const { dragConstraints: u } = this.getProps();
      isRefObject(u) && u.current && (this.constraints = this.resolveRefConstraints());
    }, { projection: s } = this.visualElement, i = s.addEventListener("measure", n);
    s && !s.layout && (s.root && s.root.updateScroll(), s.updateLayout()), frame.read(n);
    const l = addDomEvent(window, "resize", () => this.scalePositionWithinConstraints()), d = s.addEventListener("didUpdate", (({ delta: u, hasLayoutChanged: c }) => {
      this.isDragging && c && (eachAxis((p) => {
        const f = this.getAxisMotionValue(p);
        f && (this.originPoint[p] += u[p].translate, f.set(f.get() + u[p].translate));
      }), this.visualElement.render());
    }));
    return () => {
      l(), o(), i(), d && d();
    };
  }
  getProps() {
    const t = this.visualElement.getProps(), { drag: o = !1, dragDirectionLock: n = !1, dragPropagation: s = !1, dragConstraints: i = !1, dragElastic: l = defaultElastic, dragMomentum: d = !0 } = t;
    return {
      ...t,
      drag: o,
      dragDirectionLock: n,
      dragPropagation: s,
      dragConstraints: i,
      dragElastic: l,
      dragMomentum: d
    };
  }
}
function shouldDrag(e, t, o) {
  return (t === !0 || t === e) && (o === null || o === e);
}
function getCurrentDirection(e, t = 10) {
  let o = null;
  return Math.abs(e.y) > t ? o = "y" : Math.abs(e.x) > t && (o = "x"), o;
}
class DragGesture extends Feature {
  constructor(t) {
    super(t), this.removeGroupControls = noop$5, this.removeListeners = noop$5, this.controls = new VisualElementDragControls(t);
  }
  mount() {
    const { dragControls: t } = this.node.getProps();
    t && (this.removeGroupControls = t.subscribe(this.controls)), this.removeListeners = this.controls.addListeners() || noop$5;
  }
  unmount() {
    this.removeGroupControls(), this.removeListeners();
  }
}
const asyncHandler = (e) => (t, o) => {
  e && frame.postRender(() => e(t, o));
};
class PanGesture extends Feature {
  constructor() {
    super(...arguments), this.removePointerDownListener = noop$5;
  }
  onPointerDown(t) {
    this.session = new PanSession(t, this.createPanHandlers(), {
      transformPagePoint: this.node.getTransformPagePoint(),
      contextWindow: getContextWindow(this.node)
    });
  }
  createPanHandlers() {
    const { onPanSessionStart: t, onPanStart: o, onPan: n, onPanEnd: s } = this.node.getProps();
    return {
      onSessionStart: asyncHandler(t),
      onStart: asyncHandler(o),
      onMove: n,
      onEnd: (i, l) => {
        delete this.session, s && frame.postRender(() => s(i, l));
      }
    };
  }
  mount() {
    this.removePointerDownListener = addPointerEvent(this.node.current, "pointerdown", (t) => this.onPointerDown(t));
  }
  update() {
    this.session && this.session.updateHandlers(this.createPanHandlers());
  }
  unmount() {
    this.removePointerDownListener(), this.session && this.session.end();
  }
}
const globalProjectionState = {
  /**
   * Global flag as to whether the tree has animated since the last time
   * we resized the window
   */
  hasAnimatedSinceResize: !0,
  /**
   * We set this to true once, on the first update. Any nodes added to the tree beyond that
   * update will be given a `data-projection-id` attribute.
   */
  hasEverUpdated: !1
};
function pixelsToPercent(e, t) {
  return t.max === t.min ? 0 : e / (t.max - t.min) * 100;
}
const correctBorderRadius = {
  correct: (e, t) => {
    if (!t.target)
      return e;
    if (typeof e == "string")
      if (px.test(e))
        e = parseFloat(e);
      else
        return e;
    const o = pixelsToPercent(e, t.target.x), n = pixelsToPercent(e, t.target.y);
    return `${o}% ${n}%`;
  }
}, correctBoxShadow = {
  correct: (e, { treeScale: t, projectionDelta: o }) => {
    const n = e, s = complex.parse(e);
    if (s.length > 5)
      return n;
    const i = complex.createTransformer(e), l = typeof s[0] != "number" ? 1 : 0, d = o.x.scale * t.x, u = o.y.scale * t.y;
    s[0 + l] /= d, s[1 + l] /= u;
    const c = mixNumber$1(d, u, 0.5);
    return typeof s[2 + l] == "number" && (s[2 + l] /= c), typeof s[3 + l] == "number" && (s[3 + l] /= c), i(s);
  }
};
let hasTakenAnySnapshot = !1;
class MeasureLayoutWithContext extends Component {
  /**
   * This only mounts projection nodes for components that
   * need measuring, we might want to do it for all components
   * in order to incorporate transforms
   */
  componentDidMount() {
    const { visualElement: t, layoutGroup: o, switchLayoutGroup: n, layoutId: s } = this.props, { projection: i } = t;
    addScaleCorrector(defaultScaleCorrectors), i && (o.group && o.group.add(i), n && n.register && s && n.register(i), hasTakenAnySnapshot && i.root.didUpdate(), i.addEventListener("animationComplete", () => {
      this.safeToRemove();
    }), i.setOptions({
      ...i.options,
      onExitComplete: () => this.safeToRemove()
    })), globalProjectionState.hasEverUpdated = !0;
  }
  getSnapshotBeforeUpdate(t) {
    const { layoutDependency: o, visualElement: n, drag: s, isPresent: i } = this.props, { projection: l } = n;
    return l && (l.isPresent = i, hasTakenAnySnapshot = !0, s || t.layoutDependency !== o || o === void 0 || t.isPresent !== i ? l.willUpdate() : this.safeToRemove(), t.isPresent !== i && (i ? l.promote() : l.relegate() || frame.postRender(() => {
      const d = l.getStack();
      (!d || !d.members.length) && this.safeToRemove();
    }))), null;
  }
  componentDidUpdate() {
    const { projection: t } = this.props.visualElement;
    t && (t.root.didUpdate(), microtask.postRender(() => {
      !t.currentAnimation && t.isLead() && this.safeToRemove();
    }));
  }
  componentWillUnmount() {
    const { visualElement: t, layoutGroup: o, switchLayoutGroup: n } = this.props, { projection: s } = t;
    hasTakenAnySnapshot = !0, s && (s.scheduleCheckAfterUnmount(), o && o.group && o.group.remove(s), n && n.deregister && n.deregister(s));
  }
  safeToRemove() {
    const { safeToRemove: t } = this.props;
    t && t();
  }
  render() {
    return null;
  }
}
function MeasureLayout(e) {
  const [t, o] = usePresence(), n = useContext(LayoutGroupContext);
  return jsxRuntimeExports.jsx(MeasureLayoutWithContext, { ...e, layoutGroup: n, switchLayoutGroup: useContext(SwitchLayoutGroupContext), isPresent: t, safeToRemove: o });
}
const defaultScaleCorrectors = {
  borderRadius: {
    ...correctBorderRadius,
    applyTo: [
      "borderTopLeftRadius",
      "borderTopRightRadius",
      "borderBottomLeftRadius",
      "borderBottomRightRadius"
    ]
  },
  borderTopLeftRadius: correctBorderRadius,
  borderTopRightRadius: correctBorderRadius,
  borderBottomLeftRadius: correctBorderRadius,
  borderBottomRightRadius: correctBorderRadius,
  boxShadow: correctBoxShadow
};
function animateSingleValue(e, t, o) {
  const n = isMotionValue(e) ? e : motionValue(e);
  return n.start(animateMotionValue("", n, t, o)), n.animation;
}
const compareByDepth = (e, t) => e.depth - t.depth;
class FlatTree {
  constructor() {
    this.children = [], this.isDirty = !1;
  }
  add(t) {
    addUniqueItem(this.children, t), this.isDirty = !0;
  }
  remove(t) {
    removeItem(this.children, t), this.isDirty = !0;
  }
  forEach(t) {
    this.isDirty && this.children.sort(compareByDepth), this.isDirty = !1, this.children.forEach(t);
  }
}
function delay(e, t) {
  const o = time.now(), n = ({ timestamp: s }) => {
    const i = s - o;
    i >= t && (cancelFrame(n), e(i - t));
  };
  return frame.setup(n, !0), () => cancelFrame(n);
}
const borders = ["TopLeft", "TopRight", "BottomLeft", "BottomRight"], numBorders = borders.length, asNumber = (e) => typeof e == "string" ? parseFloat(e) : e, isPx = (e) => typeof e == "number" || px.test(e);
function mixValues(e, t, o, n, s, i) {
  s ? (e.opacity = mixNumber$1(0, o.opacity ?? 1, easeCrossfadeIn(n)), e.opacityExit = mixNumber$1(t.opacity ?? 1, 0, easeCrossfadeOut(n))) : i && (e.opacity = mixNumber$1(t.opacity ?? 1, o.opacity ?? 1, n));
  for (let l = 0; l < numBorders; l++) {
    const d = `border${borders[l]}Radius`;
    let u = getRadius(t, d), c = getRadius(o, d);
    if (u === void 0 && c === void 0)
      continue;
    u || (u = 0), c || (c = 0), u === 0 || c === 0 || isPx(u) === isPx(c) ? (e[d] = Math.max(mixNumber$1(asNumber(u), asNumber(c), n), 0), (percent.test(c) || percent.test(u)) && (e[d] += "%")) : e[d] = c;
  }
  (t.rotate || o.rotate) && (e.rotate = mixNumber$1(t.rotate || 0, o.rotate || 0, n));
}
function getRadius(e, t) {
  return e[t] !== void 0 ? e[t] : e.borderRadius;
}
const easeCrossfadeIn = /* @__PURE__ */ compress(0, 0.5, circOut), easeCrossfadeOut = /* @__PURE__ */ compress(0.5, 0.95, noop$5);
function compress(e, t, o) {
  return (n) => n < e ? 0 : n > t ? 1 : o(/* @__PURE__ */ progress(e, t, n));
}
function copyAxisInto(e, t) {
  e.min = t.min, e.max = t.max;
}
function copyBoxInto(e, t) {
  copyAxisInto(e.x, t.x), copyAxisInto(e.y, t.y);
}
function copyAxisDeltaInto(e, t) {
  e.translate = t.translate, e.scale = t.scale, e.originPoint = t.originPoint, e.origin = t.origin;
}
function removePointDelta(e, t, o, n, s) {
  return e -= t, e = scalePoint(e, 1 / o, n), s !== void 0 && (e = scalePoint(e, 1 / s, n)), e;
}
function removeAxisDelta(e, t = 0, o = 1, n = 0.5, s, i = e, l = e) {
  if (percent.test(t) && (t = parseFloat(t), t = mixNumber$1(l.min, l.max, t / 100) - l.min), typeof t != "number")
    return;
  let d = mixNumber$1(i.min, i.max, n);
  e === i && (d -= t), e.min = removePointDelta(e.min, t, o, d, s), e.max = removePointDelta(e.max, t, o, d, s);
}
function removeAxisTransforms(e, t, [o, n, s], i, l) {
  removeAxisDelta(e, t[o], t[n], t[s], t.scale, i, l);
}
const xKeys = ["x", "scaleX", "originX"], yKeys = ["y", "scaleY", "originY"];
function removeBoxTransforms(e, t, o, n) {
  removeAxisTransforms(e.x, t, xKeys, o ? o.x : void 0, n ? n.x : void 0), removeAxisTransforms(e.y, t, yKeys, o ? o.y : void 0, n ? n.y : void 0);
}
function isAxisDeltaZero(e) {
  return e.translate === 0 && e.scale === 1;
}
function isDeltaZero(e) {
  return isAxisDeltaZero(e.x) && isAxisDeltaZero(e.y);
}
function axisEquals(e, t) {
  return e.min === t.min && e.max === t.max;
}
function boxEquals(e, t) {
  return axisEquals(e.x, t.x) && axisEquals(e.y, t.y);
}
function axisEqualsRounded(e, t) {
  return Math.round(e.min) === Math.round(t.min) && Math.round(e.max) === Math.round(t.max);
}
function boxEqualsRounded(e, t) {
  return axisEqualsRounded(e.x, t.x) && axisEqualsRounded(e.y, t.y);
}
function aspectRatio(e) {
  return calcLength(e.x) / calcLength(e.y);
}
function axisDeltaEquals(e, t) {
  return e.translate === t.translate && e.scale === t.scale && e.originPoint === t.originPoint;
}
class NodeStack {
  constructor() {
    this.members = [];
  }
  add(t) {
    addUniqueItem(this.members, t), t.scheduleRender();
  }
  remove(t) {
    if (removeItem(this.members, t), t === this.prevLead && (this.prevLead = void 0), t === this.lead) {
      const o = this.members[this.members.length - 1];
      o && this.promote(o);
    }
  }
  relegate(t) {
    const o = this.members.findIndex((s) => t === s);
    if (o === 0)
      return !1;
    let n;
    for (let s = o; s >= 0; s--) {
      const i = this.members[s];
      if (i.isPresent !== !1) {
        n = i;
        break;
      }
    }
    return n ? (this.promote(n), !0) : !1;
  }
  promote(t, o) {
    const n = this.lead;
    if (t !== n && (this.prevLead = n, this.lead = t, t.show(), n)) {
      n.instance && n.scheduleRender(), t.scheduleRender(), t.resumeFrom = n, o && (t.resumeFrom.preserveOpacity = !0), n.snapshot && (t.snapshot = n.snapshot, t.snapshot.latestValues = n.animationValues || n.latestValues), t.root && t.root.isUpdating && (t.isLayoutDirty = !0);
      const { crossfade: s } = t.options;
      s === !1 && n.hide();
    }
  }
  exitAnimationComplete() {
    this.members.forEach((t) => {
      const { options: o, resumingFrom: n } = t;
      o.onExitComplete && o.onExitComplete(), n && n.options.onExitComplete && n.options.onExitComplete();
    });
  }
  scheduleRender() {
    this.members.forEach((t) => {
      t.instance && t.scheduleRender(!1);
    });
  }
  /**
   * Clear any leads that have been removed this render to prevent them from being
   * used in future animations and to prevent memory leaks
   */
  removeLeadSnapshot() {
    this.lead && this.lead.snapshot && (this.lead.snapshot = void 0);
  }
}
function buildProjectionTransform(e, t, o) {
  let n = "";
  const s = e.x.translate / t.x, i = e.y.translate / t.y, l = o?.z || 0;
  if ((s || i || l) && (n = `translate3d(${s}px, ${i}px, ${l}px) `), (t.x !== 1 || t.y !== 1) && (n += `scale(${1 / t.x}, ${1 / t.y}) `), o) {
    const { transformPerspective: c, rotate: p, rotateX: f, rotateY: g, skewX: y, skewY: h } = o;
    c && (n = `perspective(${c}px) ${n}`), p && (n += `rotate(${p}deg) `), f && (n += `rotateX(${f}deg) `), g && (n += `rotateY(${g}deg) `), y && (n += `skewX(${y}deg) `), h && (n += `skewY(${h}deg) `);
  }
  const d = e.x.scale * t.x, u = e.y.scale * t.y;
  return (d !== 1 || u !== 1) && (n += `scale(${d}, ${u})`), n || "none";
}
const transformAxes = ["", "X", "Y", "Z"], animationTarget = 1e3;
let id = 0;
function resetDistortingTransform(e, t, o, n) {
  const { latestValues: s } = t;
  s[e] && (o[e] = s[e], t.setStaticValue(e, 0), n && (n[e] = 0));
}
function cancelTreeOptimisedTransformAnimations(e) {
  if (e.hasCheckedOptimisedAppear = !0, e.root === e)
    return;
  const { visualElement: t } = e.options;
  if (!t)
    return;
  const o = getOptimisedAppearId(t);
  if (window.MotionHasOptimisedAnimation(o, "transform")) {
    const { layout: s, layoutId: i } = e.options;
    window.MotionCancelOptimisedAnimation(o, "transform", frame, !(s || i));
  }
  const { parent: n } = e;
  n && !n.hasCheckedOptimisedAppear && cancelTreeOptimisedTransformAnimations(n);
}
function createProjectionNode({ attachResizeListener: e, defaultParent: t, measureScroll: o, checkIsScrollRoot: n, resetTransform: s }) {
  return class {
    constructor(l = {}, d = t?.()) {
      this.id = id++, this.animationId = 0, this.animationCommitId = 0, this.children = /* @__PURE__ */ new Set(), this.options = {}, this.isTreeAnimating = !1, this.isAnimationBlocked = !1, this.isLayoutDirty = !1, this.isProjectionDirty = !1, this.isSharedProjectionDirty = !1, this.isTransformDirty = !1, this.updateManuallyBlocked = !1, this.updateBlockedByResize = !1, this.isUpdating = !1, this.isSVG = !1, this.needsReset = !1, this.shouldResetTransform = !1, this.hasCheckedOptimisedAppear = !1, this.treeScale = { x: 1, y: 1 }, this.eventHandlers = /* @__PURE__ */ new Map(), this.hasTreeAnimated = !1, this.updateScheduled = !1, this.scheduleUpdate = () => this.update(), this.projectionUpdateScheduled = !1, this.checkUpdateFailed = () => {
        this.isUpdating && (this.isUpdating = !1, this.clearAllSnapshots());
      }, this.updateProjection = () => {
        this.projectionUpdateScheduled = !1, this.nodes.forEach(propagateDirtyNodes), this.nodes.forEach(resolveTargetDelta), this.nodes.forEach(calcProjection), this.nodes.forEach(cleanDirtyNodes);
      }, this.resolvedRelativeTargetAt = 0, this.hasProjected = !1, this.isVisible = !0, this.animationProgress = 0, this.sharedNodes = /* @__PURE__ */ new Map(), this.latestValues = l, this.root = d ? d.root || d : this, this.path = d ? [...d.path, d] : [], this.parent = d, this.depth = d ? d.depth + 1 : 0;
      for (let u = 0; u < this.path.length; u++)
        this.path[u].shouldResetTransform = !0;
      this.root === this && (this.nodes = new FlatTree());
    }
    addEventListener(l, d) {
      return this.eventHandlers.has(l) || this.eventHandlers.set(l, new SubscriptionManager()), this.eventHandlers.get(l).add(d);
    }
    notifyListeners(l, ...d) {
      const u = this.eventHandlers.get(l);
      u && u.notify(...d);
    }
    hasListeners(l) {
      return this.eventHandlers.has(l);
    }
    /**
     * Lifecycles
     */
    mount(l) {
      if (this.instance)
        return;
      this.isSVG = isSVGElement(l) && !isSVGSVGElement(l), this.instance = l;
      const { layoutId: d, layout: u, visualElement: c } = this.options;
      if (c && !c.current && c.mount(l), this.root.nodes.add(this), this.parent && this.parent.children.add(this), this.root.hasTreeAnimated && (u || d) && (this.isLayoutDirty = !0), e) {
        let p, f = 0;
        const g = () => this.root.updateBlockedByResize = !1;
        frame.read(() => {
          f = window.innerWidth;
        }), e(l, () => {
          const y = window.innerWidth;
          y !== f && (f = y, this.root.updateBlockedByResize = !0, p && p(), p = delay(g, 250), globalProjectionState.hasAnimatedSinceResize && (globalProjectionState.hasAnimatedSinceResize = !1, this.nodes.forEach(finishAnimation)));
        });
      }
      d && this.root.registerSharedNode(d, this), this.options.animate !== !1 && c && (d || u) && this.addEventListener("didUpdate", ({ delta: p, hasLayoutChanged: f, hasRelativeLayoutChanged: g, layout: y }) => {
        if (this.isTreeAnimationBlocked()) {
          this.target = void 0, this.relativeTarget = void 0;
          return;
        }
        const h = this.options.transition || c.getDefaultTransition() || defaultLayoutTransition, { onLayoutAnimationStart: T, onLayoutAnimationComplete: P } = c.getProps(), E = !this.targetLayout || !boxEqualsRounded(this.targetLayout, y), $ = !f && g;
        if (this.options.layoutRoot || this.resumeFrom || $ || f && (E || !this.currentAnimation)) {
          this.resumeFrom && (this.resumingFrom = this.resumeFrom, this.resumingFrom.resumingFrom = void 0);
          const R = {
            ...getValueTransition(h, "layout"),
            onPlay: T,
            onComplete: P
          };
          (c.shouldReduceMotion || this.options.layoutRoot) && (R.delay = 0, R.type = !1), this.startAnimation(R), this.setAnimationOrigin(p, $);
        } else
          f || finishAnimation(this), this.isLead() && this.options.onExitComplete && this.options.onExitComplete();
        this.targetLayout = y;
      });
    }
    unmount() {
      this.options.layoutId && this.willUpdate(), this.root.nodes.remove(this);
      const l = this.getStack();
      l && l.remove(this), this.parent && this.parent.children.delete(this), this.instance = void 0, this.eventHandlers.clear(), cancelFrame(this.updateProjection);
    }
    // only on the root
    blockUpdate() {
      this.updateManuallyBlocked = !0;
    }
    unblockUpdate() {
      this.updateManuallyBlocked = !1;
    }
    isUpdateBlocked() {
      return this.updateManuallyBlocked || this.updateBlockedByResize;
    }
    isTreeAnimationBlocked() {
      return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || !1;
    }
    // Note: currently only running on root node
    startUpdate() {
      this.isUpdateBlocked() || (this.isUpdating = !0, this.nodes && this.nodes.forEach(resetSkewAndRotation), this.animationId++);
    }
    getTransformTemplate() {
      const { visualElement: l } = this.options;
      return l && l.getProps().transformTemplate;
    }
    willUpdate(l = !0) {
      if (this.root.hasTreeAnimated = !0, this.root.isUpdateBlocked()) {
        this.options.onExitComplete && this.options.onExitComplete();
        return;
      }
      if (window.MotionCancelOptimisedAnimation && !this.hasCheckedOptimisedAppear && cancelTreeOptimisedTransformAnimations(this), !this.root.isUpdating && this.root.startUpdate(), this.isLayoutDirty)
        return;
      this.isLayoutDirty = !0;
      for (let p = 0; p < this.path.length; p++) {
        const f = this.path[p];
        f.shouldResetTransform = !0, f.updateScroll("snapshot"), f.options.layoutRoot && f.willUpdate(!1);
      }
      const { layoutId: d, layout: u } = this.options;
      if (d === void 0 && !u)
        return;
      const c = this.getTransformTemplate();
      this.prevTransformTemplateValue = c ? c(this.latestValues, "") : void 0, this.updateSnapshot(), l && this.notifyListeners("willUpdate");
    }
    update() {
      if (this.updateScheduled = !1, this.isUpdateBlocked()) {
        this.unblockUpdate(), this.clearAllSnapshots(), this.nodes.forEach(clearMeasurements);
        return;
      }
      if (this.animationId <= this.animationCommitId) {
        this.nodes.forEach(clearIsLayoutDirty);
        return;
      }
      this.animationCommitId = this.animationId, this.isUpdating ? (this.isUpdating = !1, this.nodes.forEach(resetTransformStyle), this.nodes.forEach(updateLayout), this.nodes.forEach(notifyLayoutUpdate)) : this.nodes.forEach(clearIsLayoutDirty), this.clearAllSnapshots();
      const d = time.now();
      frameData.delta = clamp(0, 1e3 / 60, d - frameData.timestamp), frameData.timestamp = d, frameData.isProcessing = !0, frameSteps.update.process(frameData), frameSteps.preRender.process(frameData), frameSteps.render.process(frameData), frameData.isProcessing = !1;
    }
    didUpdate() {
      this.updateScheduled || (this.updateScheduled = !0, microtask.read(this.scheduleUpdate));
    }
    clearAllSnapshots() {
      this.nodes.forEach(clearSnapshot), this.sharedNodes.forEach(removeLeadSnapshots);
    }
    scheduleUpdateProjection() {
      this.projectionUpdateScheduled || (this.projectionUpdateScheduled = !0, frame.preRender(this.updateProjection, !1, !0));
    }
    scheduleCheckAfterUnmount() {
      frame.postRender(() => {
        this.isLayoutDirty ? this.root.didUpdate() : this.root.checkUpdateFailed();
      });
    }
    /**
     * Update measurements
     */
    updateSnapshot() {
      this.snapshot || !this.instance || (this.snapshot = this.measure(), this.snapshot && !calcLength(this.snapshot.measuredBox.x) && !calcLength(this.snapshot.measuredBox.y) && (this.snapshot = void 0));
    }
    updateLayout() {
      if (!this.instance || (this.updateScroll(), !(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty))
        return;
      if (this.resumeFrom && !this.resumeFrom.instance)
        for (let u = 0; u < this.path.length; u++)
          this.path[u].updateScroll();
      const l = this.layout;
      this.layout = this.measure(!1), this.layoutCorrected = createBox(), this.isLayoutDirty = !1, this.projectionDelta = void 0, this.notifyListeners("measure", this.layout.layoutBox);
      const { visualElement: d } = this.options;
      d && d.notify("LayoutMeasure", this.layout.layoutBox, l ? l.layoutBox : void 0);
    }
    updateScroll(l = "measure") {
      let d = !!(this.options.layoutScroll && this.instance);
      if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === l && (d = !1), d && this.instance) {
        const u = n(this.instance);
        this.scroll = {
          animationId: this.root.animationId,
          phase: l,
          isRoot: u,
          offset: o(this.instance),
          wasRoot: this.scroll ? this.scroll.isRoot : u
        };
      }
    }
    resetTransform() {
      if (!s)
        return;
      const l = this.isLayoutDirty || this.shouldResetTransform || this.options.alwaysMeasureLayout, d = this.projectionDelta && !isDeltaZero(this.projectionDelta), u = this.getTransformTemplate(), c = u ? u(this.latestValues, "") : void 0, p = c !== this.prevTransformTemplateValue;
      l && this.instance && (d || hasTransform(this.latestValues) || p) && (s(this.instance, c), this.shouldResetTransform = !1, this.scheduleRender());
    }
    measure(l = !0) {
      const d = this.measurePageBox();
      let u = this.removeElementScroll(d);
      return l && (u = this.removeTransform(u)), roundBox(u), {
        animationId: this.root.animationId,
        measuredBox: d,
        layoutBox: u,
        latestValues: {},
        source: this.id
      };
    }
    measurePageBox() {
      const { visualElement: l } = this.options;
      if (!l)
        return createBox();
      const d = l.measureViewportBox();
      if (!(this.scroll?.wasRoot || this.path.some(checkNodeWasScrollRoot))) {
        const { scroll: c } = this.root;
        c && (translateAxis(d.x, c.offset.x), translateAxis(d.y, c.offset.y));
      }
      return d;
    }
    removeElementScroll(l) {
      const d = createBox();
      if (copyBoxInto(d, l), this.scroll?.wasRoot)
        return d;
      for (let u = 0; u < this.path.length; u++) {
        const c = this.path[u], { scroll: p, options: f } = c;
        c !== this.root && p && f.layoutScroll && (p.wasRoot && copyBoxInto(d, l), translateAxis(d.x, p.offset.x), translateAxis(d.y, p.offset.y));
      }
      return d;
    }
    applyTransform(l, d = !1) {
      const u = createBox();
      copyBoxInto(u, l);
      for (let c = 0; c < this.path.length; c++) {
        const p = this.path[c];
        !d && p.options.layoutScroll && p.scroll && p !== p.root && transformBox(u, {
          x: -p.scroll.offset.x,
          y: -p.scroll.offset.y
        }), hasTransform(p.latestValues) && transformBox(u, p.latestValues);
      }
      return hasTransform(this.latestValues) && transformBox(u, this.latestValues), u;
    }
    removeTransform(l) {
      const d = createBox();
      copyBoxInto(d, l);
      for (let u = 0; u < this.path.length; u++) {
        const c = this.path[u];
        if (!c.instance || !hasTransform(c.latestValues))
          continue;
        hasScale(c.latestValues) && c.updateSnapshot();
        const p = createBox(), f = c.measurePageBox();
        copyBoxInto(p, f), removeBoxTransforms(d, c.latestValues, c.snapshot ? c.snapshot.layoutBox : void 0, p);
      }
      return hasTransform(this.latestValues) && removeBoxTransforms(d, this.latestValues), d;
    }
    setTargetDelta(l) {
      this.targetDelta = l, this.root.scheduleUpdateProjection(), this.isProjectionDirty = !0;
    }
    setOptions(l) {
      this.options = {
        ...this.options,
        ...l,
        crossfade: l.crossfade !== void 0 ? l.crossfade : !0
      };
    }
    clearMeasurements() {
      this.scroll = void 0, this.layout = void 0, this.snapshot = void 0, this.prevTransformTemplateValue = void 0, this.targetDelta = void 0, this.target = void 0, this.isLayoutDirty = !1;
    }
    forceRelativeParentToResolveTarget() {
      this.relativeParent && this.relativeParent.resolvedRelativeTargetAt !== frameData.timestamp && this.relativeParent.resolveTargetDelta(!0);
    }
    resolveTargetDelta(l = !1) {
      const d = this.getLead();
      this.isProjectionDirty || (this.isProjectionDirty = d.isProjectionDirty), this.isTransformDirty || (this.isTransformDirty = d.isTransformDirty), this.isSharedProjectionDirty || (this.isSharedProjectionDirty = d.isSharedProjectionDirty);
      const u = !!this.resumingFrom || this !== d;
      if (!(l || u && this.isSharedProjectionDirty || this.isProjectionDirty || this.parent?.isProjectionDirty || this.attemptToResolveRelativeTarget || this.root.updateBlockedByResize))
        return;
      const { layout: p, layoutId: f } = this.options;
      if (!(!this.layout || !(p || f))) {
        if (this.resolvedRelativeTargetAt = frameData.timestamp, !this.targetDelta && !this.relativeTarget) {
          const g = this.getClosestProjectingParent();
          g && g.layout && this.animationProgress !== 1 ? (this.relativeParent = g, this.forceRelativeParentToResolveTarget(), this.relativeTarget = createBox(), this.relativeTargetOrigin = createBox(), calcRelativePosition(this.relativeTargetOrigin, this.layout.layoutBox, g.layout.layoutBox), copyBoxInto(this.relativeTarget, this.relativeTargetOrigin)) : this.relativeParent = this.relativeTarget = void 0;
        }
        if (!(!this.relativeTarget && !this.targetDelta) && (this.target || (this.target = createBox(), this.targetWithTransforms = createBox()), this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target ? (this.forceRelativeParentToResolveTarget(), calcRelativeBox(this.target, this.relativeTarget, this.relativeParent.target)) : this.targetDelta ? (this.resumingFrom ? this.target = this.applyTransform(this.layout.layoutBox) : copyBoxInto(this.target, this.layout.layoutBox), applyBoxDelta(this.target, this.targetDelta)) : copyBoxInto(this.target, this.layout.layoutBox), this.attemptToResolveRelativeTarget)) {
          this.attemptToResolveRelativeTarget = !1;
          const g = this.getClosestProjectingParent();
          g && !!g.resumingFrom == !!this.resumingFrom && !g.options.layoutScroll && g.target && this.animationProgress !== 1 ? (this.relativeParent = g, this.forceRelativeParentToResolveTarget(), this.relativeTarget = createBox(), this.relativeTargetOrigin = createBox(), calcRelativePosition(this.relativeTargetOrigin, this.target, g.target), copyBoxInto(this.relativeTarget, this.relativeTargetOrigin)) : this.relativeParent = this.relativeTarget = void 0;
        }
      }
    }
    getClosestProjectingParent() {
      if (!(!this.parent || hasScale(this.parent.latestValues) || has2DTranslate(this.parent.latestValues)))
        return this.parent.isProjecting() ? this.parent : this.parent.getClosestProjectingParent();
    }
    isProjecting() {
      return !!((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
    }
    calcProjection() {
      const l = this.getLead(), d = !!this.resumingFrom || this !== l;
      let u = !0;
      if ((this.isProjectionDirty || this.parent?.isProjectionDirty) && (u = !1), d && (this.isSharedProjectionDirty || this.isTransformDirty) && (u = !1), this.resolvedRelativeTargetAt === frameData.timestamp && (u = !1), u)
        return;
      const { layout: c, layoutId: p } = this.options;
      if (this.isTreeAnimating = !!(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation), this.isTreeAnimating || (this.targetDelta = this.relativeTarget = void 0), !this.layout || !(c || p))
        return;
      copyBoxInto(this.layoutCorrected, this.layout.layoutBox);
      const f = this.treeScale.x, g = this.treeScale.y;
      applyTreeDeltas(this.layoutCorrected, this.treeScale, this.path, d), l.layout && !l.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1) && (l.target = l.layout.layoutBox, l.targetWithTransforms = createBox());
      const { target: y } = l;
      if (!y) {
        this.prevProjectionDelta && (this.createProjectionDeltas(), this.scheduleRender());
        return;
      }
      !this.projectionDelta || !this.prevProjectionDelta ? this.createProjectionDeltas() : (copyAxisDeltaInto(this.prevProjectionDelta.x, this.projectionDelta.x), copyAxisDeltaInto(this.prevProjectionDelta.y, this.projectionDelta.y)), calcBoxDelta(this.projectionDelta, this.layoutCorrected, y, this.latestValues), (this.treeScale.x !== f || this.treeScale.y !== g || !axisDeltaEquals(this.projectionDelta.x, this.prevProjectionDelta.x) || !axisDeltaEquals(this.projectionDelta.y, this.prevProjectionDelta.y)) && (this.hasProjected = !0, this.scheduleRender(), this.notifyListeners("projectionUpdate", y));
    }
    hide() {
      this.isVisible = !1;
    }
    show() {
      this.isVisible = !0;
    }
    scheduleRender(l = !0) {
      if (this.options.visualElement?.scheduleRender(), l) {
        const d = this.getStack();
        d && d.scheduleRender();
      }
      this.resumingFrom && !this.resumingFrom.instance && (this.resumingFrom = void 0);
    }
    createProjectionDeltas() {
      this.prevProjectionDelta = createDelta(), this.projectionDelta = createDelta(), this.projectionDeltaWithTransform = createDelta();
    }
    setAnimationOrigin(l, d = !1) {
      const u = this.snapshot, c = u ? u.latestValues : {}, p = { ...this.latestValues }, f = createDelta();
      (!this.relativeParent || !this.relativeParent.options.layoutRoot) && (this.relativeTarget = this.relativeTargetOrigin = void 0), this.attemptToResolveRelativeTarget = !d;
      const g = createBox(), y = u ? u.source : void 0, h = this.layout ? this.layout.source : void 0, T = y !== h, P = this.getStack(), E = !P || P.members.length <= 1, $ = !!(T && !E && this.options.crossfade === !0 && !this.path.some(hasOpacityCrossfade));
      this.animationProgress = 0;
      let R;
      this.mixTargetDelta = (C) => {
        const x = C / 1e3;
        mixAxisDelta(f.x, l.x, x), mixAxisDelta(f.y, l.y, x), this.setTargetDelta(f), this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout && (calcRelativePosition(g, this.layout.layoutBox, this.relativeParent.layout.layoutBox), mixBox(this.relativeTarget, this.relativeTargetOrigin, g, x), R && boxEquals(this.relativeTarget, R) && (this.isProjectionDirty = !1), R || (R = createBox()), copyBoxInto(R, this.relativeTarget)), T && (this.animationValues = p, mixValues(p, c, this.latestValues, x, $, E)), this.root.scheduleUpdateProjection(), this.scheduleRender(), this.animationProgress = x;
      }, this.mixTargetDelta(this.options.layoutRoot ? 1e3 : 0);
    }
    startAnimation(l) {
      this.notifyListeners("animationStart"), this.currentAnimation?.stop(), this.resumingFrom?.currentAnimation?.stop(), this.pendingAnimation && (cancelFrame(this.pendingAnimation), this.pendingAnimation = void 0), this.pendingAnimation = frame.update(() => {
        globalProjectionState.hasAnimatedSinceResize = !0, this.motionValue || (this.motionValue = motionValue(0)), this.currentAnimation = animateSingleValue(this.motionValue, [0, 1e3], {
          ...l,
          velocity: 0,
          isSync: !0,
          onUpdate: (d) => {
            this.mixTargetDelta(d), l.onUpdate && l.onUpdate(d);
          },
          onStop: () => {
          },
          onComplete: () => {
            l.onComplete && l.onComplete(), this.completeAnimation();
          }
        }), this.resumingFrom && (this.resumingFrom.currentAnimation = this.currentAnimation), this.pendingAnimation = void 0;
      });
    }
    completeAnimation() {
      this.resumingFrom && (this.resumingFrom.currentAnimation = void 0, this.resumingFrom.preserveOpacity = void 0);
      const l = this.getStack();
      l && l.exitAnimationComplete(), this.resumingFrom = this.currentAnimation = this.animationValues = void 0, this.notifyListeners("animationComplete");
    }
    finishAnimation() {
      this.currentAnimation && (this.mixTargetDelta && this.mixTargetDelta(animationTarget), this.currentAnimation.stop()), this.completeAnimation();
    }
    applyTransformsToTarget() {
      const l = this.getLead();
      let { targetWithTransforms: d, target: u, layout: c, latestValues: p } = l;
      if (!(!d || !u || !c)) {
        if (this !== l && this.layout && c && shouldAnimatePositionOnly(this.options.animationType, this.layout.layoutBox, c.layoutBox)) {
          u = this.target || createBox();
          const f = calcLength(this.layout.layoutBox.x);
          u.x.min = l.target.x.min, u.x.max = u.x.min + f;
          const g = calcLength(this.layout.layoutBox.y);
          u.y.min = l.target.y.min, u.y.max = u.y.min + g;
        }
        copyBoxInto(d, u), transformBox(d, p), calcBoxDelta(this.projectionDeltaWithTransform, this.layoutCorrected, d, p);
      }
    }
    registerSharedNode(l, d) {
      this.sharedNodes.has(l) || this.sharedNodes.set(l, new NodeStack()), this.sharedNodes.get(l).add(d);
      const c = d.options.initialPromotionConfig;
      d.promote({
        transition: c ? c.transition : void 0,
        preserveFollowOpacity: c && c.shouldPreserveFollowOpacity ? c.shouldPreserveFollowOpacity(d) : void 0
      });
    }
    isLead() {
      const l = this.getStack();
      return l ? l.lead === this : !0;
    }
    getLead() {
      const { layoutId: l } = this.options;
      return l ? this.getStack()?.lead || this : this;
    }
    getPrevLead() {
      const { layoutId: l } = this.options;
      return l ? this.getStack()?.prevLead : void 0;
    }
    getStack() {
      const { layoutId: l } = this.options;
      if (l)
        return this.root.sharedNodes.get(l);
    }
    promote({ needsReset: l, transition: d, preserveFollowOpacity: u } = {}) {
      const c = this.getStack();
      c && c.promote(this, u), l && (this.projectionDelta = void 0, this.needsReset = !0), d && this.setOptions({ transition: d });
    }
    relegate() {
      const l = this.getStack();
      return l ? l.relegate(this) : !1;
    }
    resetSkewAndRotation() {
      const { visualElement: l } = this.options;
      if (!l)
        return;
      let d = !1;
      const { latestValues: u } = l;
      if ((u.z || u.rotate || u.rotateX || u.rotateY || u.rotateZ || u.skewX || u.skewY) && (d = !0), !d)
        return;
      const c = {};
      u.z && resetDistortingTransform("z", l, c, this.animationValues);
      for (let p = 0; p < transformAxes.length; p++)
        resetDistortingTransform(`rotate${transformAxes[p]}`, l, c, this.animationValues), resetDistortingTransform(`skew${transformAxes[p]}`, l, c, this.animationValues);
      l.render();
      for (const p in c)
        l.setStaticValue(p, c[p]), this.animationValues && (this.animationValues[p] = c[p]);
      l.scheduleRender();
    }
    applyProjectionStyles(l, d) {
      if (!this.instance || this.isSVG)
        return;
      if (!this.isVisible) {
        l.visibility = "hidden";
        return;
      }
      const u = this.getTransformTemplate();
      if (this.needsReset) {
        this.needsReset = !1, l.visibility = "", l.opacity = "", l.pointerEvents = resolveMotionValue(d?.pointerEvents) || "", l.transform = u ? u(this.latestValues, "") : "none";
        return;
      }
      const c = this.getLead();
      if (!this.projectionDelta || !this.layout || !c.target) {
        this.options.layoutId && (l.opacity = this.latestValues.opacity !== void 0 ? this.latestValues.opacity : 1, l.pointerEvents = resolveMotionValue(d?.pointerEvents) || ""), this.hasProjected && !hasTransform(this.latestValues) && (l.transform = u ? u({}, "") : "none", this.hasProjected = !1);
        return;
      }
      l.visibility = "";
      const p = c.animationValues || c.latestValues;
      this.applyTransformsToTarget();
      let f = buildProjectionTransform(this.projectionDeltaWithTransform, this.treeScale, p);
      u && (f = u(p, f)), l.transform = f;
      const { x: g, y } = this.projectionDelta;
      l.transformOrigin = `${g.origin * 100}% ${y.origin * 100}% 0`, c.animationValues ? l.opacity = c === this ? p.opacity ?? this.latestValues.opacity ?? 1 : this.preserveOpacity ? this.latestValues.opacity : p.opacityExit : l.opacity = c === this ? p.opacity !== void 0 ? p.opacity : "" : p.opacityExit !== void 0 ? p.opacityExit : 0;
      for (const h in scaleCorrectors) {
        if (p[h] === void 0)
          continue;
        const { correct: T, applyTo: P, isCSSVariable: E } = scaleCorrectors[h], $ = f === "none" ? p[h] : T(p[h], c);
        if (P) {
          const R = P.length;
          for (let C = 0; C < R; C++)
            l[P[C]] = $;
        } else
          E ? this.options.visualElement.renderState.vars[h] = $ : l[h] = $;
      }
      this.options.layoutId && (l.pointerEvents = c === this ? resolveMotionValue(d?.pointerEvents) || "" : "none");
    }
    clearSnapshot() {
      this.resumeFrom = this.snapshot = void 0;
    }
    // Only run on root
    resetTree() {
      this.root.nodes.forEach((l) => l.currentAnimation?.stop()), this.root.nodes.forEach(clearMeasurements), this.root.sharedNodes.clear();
    }
  };
}
function updateLayout(e) {
  e.updateLayout();
}
function notifyLayoutUpdate(e) {
  const t = e.resumeFrom?.snapshot || e.snapshot;
  if (e.isLead() && e.layout && t && e.hasListeners("didUpdate")) {
    const { layoutBox: o, measuredBox: n } = e.layout, { animationType: s } = e.options, i = t.source !== e.layout.source;
    s === "size" ? eachAxis((p) => {
      const f = i ? t.measuredBox[p] : t.layoutBox[p], g = calcLength(f);
      f.min = o[p].min, f.max = f.min + g;
    }) : shouldAnimatePositionOnly(s, t.layoutBox, o) && eachAxis((p) => {
      const f = i ? t.measuredBox[p] : t.layoutBox[p], g = calcLength(o[p]);
      f.max = f.min + g, e.relativeTarget && !e.currentAnimation && (e.isProjectionDirty = !0, e.relativeTarget[p].max = e.relativeTarget[p].min + g);
    });
    const l = createDelta();
    calcBoxDelta(l, o, t.layoutBox);
    const d = createDelta();
    i ? calcBoxDelta(d, e.applyTransform(n, !0), t.measuredBox) : calcBoxDelta(d, o, t.layoutBox);
    const u = !isDeltaZero(l);
    let c = !1;
    if (!e.resumeFrom) {
      const p = e.getClosestProjectingParent();
      if (p && !p.resumeFrom) {
        const { snapshot: f, layout: g } = p;
        if (f && g) {
          const y = createBox();
          calcRelativePosition(y, t.layoutBox, f.layoutBox);
          const h = createBox();
          calcRelativePosition(h, o, g.layoutBox), boxEqualsRounded(y, h) || (c = !0), p.options.layoutRoot && (e.relativeTarget = h, e.relativeTargetOrigin = y, e.relativeParent = p);
        }
      }
    }
    e.notifyListeners("didUpdate", {
      layout: o,
      snapshot: t,
      delta: d,
      layoutDelta: l,
      hasLayoutChanged: u,
      hasRelativeLayoutChanged: c
    });
  } else if (e.isLead()) {
    const { onExitComplete: o } = e.options;
    o && o();
  }
  e.options.transition = void 0;
}
function propagateDirtyNodes(e) {
  e.parent && (e.isProjecting() || (e.isProjectionDirty = e.parent.isProjectionDirty), e.isSharedProjectionDirty || (e.isSharedProjectionDirty = !!(e.isProjectionDirty || e.parent.isProjectionDirty || e.parent.isSharedProjectionDirty)), e.isTransformDirty || (e.isTransformDirty = e.parent.isTransformDirty));
}
function cleanDirtyNodes(e) {
  e.isProjectionDirty = e.isSharedProjectionDirty = e.isTransformDirty = !1;
}
function clearSnapshot(e) {
  e.clearSnapshot();
}
function clearMeasurements(e) {
  e.clearMeasurements();
}
function clearIsLayoutDirty(e) {
  e.isLayoutDirty = !1;
}
function resetTransformStyle(e) {
  const { visualElement: t } = e.options;
  t && t.getProps().onBeforeLayoutMeasure && t.notify("BeforeLayoutMeasure"), e.resetTransform();
}
function finishAnimation(e) {
  e.finishAnimation(), e.targetDelta = e.relativeTarget = e.target = void 0, e.isProjectionDirty = !0;
}
function resolveTargetDelta(e) {
  e.resolveTargetDelta();
}
function calcProjection(e) {
  e.calcProjection();
}
function resetSkewAndRotation(e) {
  e.resetSkewAndRotation();
}
function removeLeadSnapshots(e) {
  e.removeLeadSnapshot();
}
function mixAxisDelta(e, t, o) {
  e.translate = mixNumber$1(t.translate, 0, o), e.scale = mixNumber$1(t.scale, 1, o), e.origin = t.origin, e.originPoint = t.originPoint;
}
function mixAxis(e, t, o, n) {
  e.min = mixNumber$1(t.min, o.min, n), e.max = mixNumber$1(t.max, o.max, n);
}
function mixBox(e, t, o, n) {
  mixAxis(e.x, t.x, o.x, n), mixAxis(e.y, t.y, o.y, n);
}
function hasOpacityCrossfade(e) {
  return e.animationValues && e.animationValues.opacityExit !== void 0;
}
const defaultLayoutTransition = {
  duration: 0.45,
  ease: [0.4, 0, 0.1, 1]
}, userAgentContains = (e) => typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().includes(e), roundPoint = userAgentContains("applewebkit/") && !userAgentContains("chrome/") ? Math.round : noop$5;
function roundAxis(e) {
  e.min = roundPoint(e.min), e.max = roundPoint(e.max);
}
function roundBox(e) {
  roundAxis(e.x), roundAxis(e.y);
}
function shouldAnimatePositionOnly(e, t, o) {
  return e === "position" || e === "preserve-aspect" && !isNear(aspectRatio(t), aspectRatio(o), 0.2);
}
function checkNodeWasScrollRoot(e) {
  return e !== e.root && e.scroll?.wasRoot;
}
const DocumentProjectionNode = createProjectionNode({
  attachResizeListener: (e, t) => addDomEvent(e, "resize", t),
  measureScroll: () => ({
    x: document.documentElement.scrollLeft || document.body.scrollLeft,
    y: document.documentElement.scrollTop || document.body.scrollTop
  }),
  checkIsScrollRoot: () => !0
}), rootProjectionNode = {
  current: void 0
}, HTMLProjectionNode = createProjectionNode({
  measureScroll: (e) => ({
    x: e.scrollLeft,
    y: e.scrollTop
  }),
  defaultParent: () => {
    if (!rootProjectionNode.current) {
      const e = new DocumentProjectionNode({});
      e.mount(window), e.setOptions({ layoutScroll: !0 }), rootProjectionNode.current = e;
    }
    return rootProjectionNode.current;
  },
  resetTransform: (e, t) => {
    e.style.transform = t !== void 0 ? t : "none";
  },
  checkIsScrollRoot: (e) => window.getComputedStyle(e).position === "fixed"
}), drag = {
  pan: {
    Feature: PanGesture
  },
  drag: {
    Feature: DragGesture,
    ProjectionNode: HTMLProjectionNode,
    MeasureLayout
  }
};
function handleHoverEvent(e, t, o) {
  const { props: n } = e;
  e.animationState && n.whileHover && e.animationState.setActive("whileHover", o === "Start");
  const s = "onHover" + o, i = n[s];
  i && frame.postRender(() => i(t, extractEventInfo(t)));
}
class HoverGesture extends Feature {
  mount() {
    const { current: t } = this.node;
    t && (this.unmount = hover(t, (o, n) => (handleHoverEvent(this.node, n, "Start"), (s) => handleHoverEvent(this.node, s, "End"))));
  }
  unmount() {
  }
}
class FocusGesture extends Feature {
  constructor() {
    super(...arguments), this.isActive = !1;
  }
  onFocus() {
    let t = !1;
    try {
      t = this.node.current.matches(":focus-visible");
    } catch {
      t = !0;
    }
    !t || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !0), this.isActive = !0);
  }
  onBlur() {
    !this.isActive || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !1), this.isActive = !1);
  }
  mount() {
    this.unmount = pipe(addDomEvent(this.node.current, "focus", () => this.onFocus()), addDomEvent(this.node.current, "blur", () => this.onBlur()));
  }
  unmount() {
  }
}
function handlePressEvent(e, t, o) {
  const { props: n } = e;
  if (e.current instanceof HTMLButtonElement && e.current.disabled)
    return;
  e.animationState && n.whileTap && e.animationState.setActive("whileTap", o === "Start");
  const s = "onTap" + (o === "End" ? "" : o), i = n[s];
  i && frame.postRender(() => i(t, extractEventInfo(t)));
}
class PressGesture extends Feature {
  mount() {
    const { current: t } = this.node;
    t && (this.unmount = press(t, (o, n) => (handlePressEvent(this.node, n, "Start"), (s, { success: i }) => handlePressEvent(this.node, s, i ? "End" : "Cancel")), { useGlobalTarget: this.node.props.globalTapTarget }));
  }
  unmount() {
  }
}
const observerCallbacks = /* @__PURE__ */ new WeakMap(), observers = /* @__PURE__ */ new WeakMap(), fireObserverCallback = (e) => {
  const t = observerCallbacks.get(e.target);
  t && t(e);
}, fireAllObserverCallbacks = (e) => {
  e.forEach(fireObserverCallback);
};
function initIntersectionObserver({ root: e, ...t }) {
  const o = e || document;
  observers.has(o) || observers.set(o, {});
  const n = observers.get(o), s = JSON.stringify(t);
  return n[s] || (n[s] = new IntersectionObserver(fireAllObserverCallbacks, { root: e, ...t })), n[s];
}
function observeIntersection(e, t, o) {
  const n = initIntersectionObserver(t);
  return observerCallbacks.set(e, o), n.observe(e), () => {
    observerCallbacks.delete(e), n.unobserve(e);
  };
}
const thresholdNames = {
  some: 0,
  all: 1
};
class InViewFeature extends Feature {
  constructor() {
    super(...arguments), this.hasEnteredView = !1, this.isInView = !1;
  }
  startObserver() {
    this.unmount();
    const { viewport: t = {} } = this.node.getProps(), { root: o, margin: n, amount: s = "some", once: i } = t, l = {
      root: o ? o.current : void 0,
      rootMargin: n,
      threshold: typeof s == "number" ? s : thresholdNames[s]
    }, d = (u) => {
      const { isIntersecting: c } = u;
      if (this.isInView === c || (this.isInView = c, i && !c && this.hasEnteredView))
        return;
      c && (this.hasEnteredView = !0), this.node.animationState && this.node.animationState.setActive("whileInView", c);
      const { onViewportEnter: p, onViewportLeave: f } = this.node.getProps(), g = c ? p : f;
      g && g(u);
    };
    return observeIntersection(this.node.current, l, d);
  }
  mount() {
    this.startObserver();
  }
  update() {
    if (typeof IntersectionObserver > "u")
      return;
    const { props: t, prevProps: o } = this.node;
    ["amount", "margin", "root"].some(hasViewportOptionChanged(t, o)) && this.startObserver();
  }
  unmount() {
  }
}
function hasViewportOptionChanged({ viewport: e = {} }, { viewport: t = {} } = {}) {
  return (o) => e[o] !== t[o];
}
const gestureAnimations = {
  inView: {
    Feature: InViewFeature
  },
  tap: {
    Feature: PressGesture
  },
  focus: {
    Feature: FocusGesture
  },
  hover: {
    Feature: HoverGesture
  }
}, layout = {
  layout: {
    ProjectionNode: HTMLProjectionNode,
    MeasureLayout
  }
}, featureBundle = {
  ...animations,
  ...gestureAnimations,
  ...drag,
  ...layout
}, motion = /* @__PURE__ */ createMotionProxy(featureBundle, createDomVisualElement), IconButtonAnimate = forwardRef(
  ({ children: e, size: t = "medium", ...o }, n) => /* @__PURE__ */ jsxRuntimeExports.jsx(AnimateWrap, { size: t, children: /* @__PURE__ */ jsxRuntimeExports.jsx(IconButton$1, { ref: n, size: t, ...o, children: e }) })
), varSmall = {
  hover: { scale: 1.1 },
  tap: { scale: 0.95 }
}, varMedium = {
  hover: { scale: 1.09 },
  tap: { scale: 0.97 }
}, varLarge = {
  hover: { scale: 1.08 },
  tap: { scale: 0.99 }
}, AnimateWrap = ({ size: e, children: t }) => {
  const o = e === "small", n = e === "large";
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Box,
    {
      component: m.div,
      whileTap: "tap",
      whileHover: "hover",
      variants: o && varSmall || n && varLarge || varMedium,
      sx: {
        display: "inline-flex"
      },
      children: t
    }
  );
}, varTranHover = (e) => {
  const t = e?.duration || 0.32, o = e?.ease || [0.43, 0.13, 0.23, 0.96];
  return { duration: t, ease: o };
}, varTranEnter = (e) => {
  const t = e?.durationIn || 0.64, o = e?.easeIn || [0.43, 0.13, 0.23, 0.96], n = e?.delay || 0;
  return { duration: t, ease: o, delay: n };
}, varTranExit = (e) => {
  const t = e?.durationOut || 0.48, o = e?.easeOut || [0.43, 0.13, 0.23, 0.96], n = e?.delay || 0;
  return { duration: t, ease: o, delay: n };
}, varFade = (e) => {
  const t = e?.distance || 120, o = e?.durationIn, n = e?.durationOut, s = e?.easeIn, i = e?.easeOut, l = e?.delay;
  return {
    // IN
    in: {
      initial: { opacity: 0 },
      animate: {
        opacity: 1,
        transition: varTranEnter({ durationIn: o, delay: l, easeIn: s })
      },
      exit: {
        opacity: 0,
        transition: varTranExit({ durationOut: n, delay: l, easeOut: i })
      }
    },
    inUp: {
      initial: { y: t, opacity: 0 },
      animate: {
        y: 0,
        opacity: 1,
        transition: varTranEnter({ durationIn: o, easeIn: s })
      },
      exit: {
        y: t,
        opacity: 0,
        transition: varTranExit({ durationOut: n, easeOut: i })
      }
    },
    inDown: {
      initial: { y: -t, opacity: 0 },
      animate: {
        y: 0,
        opacity: 1,
        transition: varTranEnter({ durationIn: o, easeIn: s })
      },
      exit: {
        y: -t,
        opacity: 0,
        transition: varTranExit({ durationOut: n, easeOut: i })
      }
    },
    inLeft: {
      initial: { x: -t, opacity: 0 },
      animate: {
        x: 0,
        opacity: 1,
        transition: varTranEnter({ durationIn: o, easeIn: s })
      },
      exit: {
        x: -t,
        opacity: 0,
        transition: varTranExit({ durationOut: n, easeOut: i })
      }
    },
    inRight: {
      initial: { x: t, opacity: 0 },
      animate: {
        x: 0,
        opacity: 1,
        transition: varTranEnter({ durationIn: o, easeIn: s })
      },
      exit: {
        x: t,
        opacity: 0,
        transition: varTranExit({ durationOut: n, easeOut: i })
      }
    },
    inRightFullscreen: {
      initial: { x: "calc(100% + 50vw)" },
      animate: {
        x: 0,
        transition: varTranEnter({ durationIn: o, easeIn: s })
      }
    },
    // OUT
    out: {
      initial: { opacity: 1 },
      animate: { opacity: 0, transition: varTranEnter({ durationIn: o, easeIn: s }) },
      exit: { opacity: 1, transition: varTranExit({ durationOut: n, easeOut: i }) }
    },
    outUp: {
      initial: { y: 0, opacity: 1 },
      animate: {
        y: -t,
        opacity: 0,
        transition: varTranEnter({ durationIn: o, easeIn: s })
      },
      exit: {
        y: 0,
        opacity: 1,
        transition: varTranExit({ durationOut: n, easeOut: i })
      }
    },
    outDown: {
      initial: { y: 0, opacity: 1 },
      animate: {
        y: t,
        opacity: 0,
        transition: varTranEnter({ durationIn: o, easeIn: s })
      },
      exit: {
        y: 0,
        opacity: 1,
        transition: varTranExit({ durationOut: n, easeOut: i })
      }
    },
    outLeft: {
      initial: { x: 0, opacity: 1 },
      animate: {
        x: -t,
        opacity: 0,
        transition: varTranEnter({ durationIn: o, easeIn: s })
      },
      exit: {
        x: 0,
        opacity: 1,
        transition: varTranExit({ durationOut: n, easeOut: i })
      }
    },
    outLeftFullscreen: {
      initial: { x: 0 },
      exit: {
        x: "calc(0px - 50vw - 100%)",
        transition: varTranExit({ durationOut: n, easeOut: i })
      }
    },
    outRight: {
      initial: { x: 0, opacity: 1 },
      animate: {
        x: t,
        opacity: 0,
        transition: varTranEnter({ durationIn: o, easeIn: s })
      },
      exit: {
        x: 0,
        opacity: 1,
        transition: varTranExit({ durationOut: n, easeOut: i })
      }
    }
  };
};
function createChainedFunction(...e) {
  return e.reduce((t, o) => o == null ? t : function(...s) {
    t.apply(this, s), o.apply(this, s);
  }, () => {
  });
}
function GlobalStyles(e) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(GlobalStyles$1, {
    ...e,
    defaultTheme,
    themeId: THEME_ID
  });
}
process.env.NODE_ENV !== "production" && (GlobalStyles.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The styles you want to apply globally.
   */
  styles: PropTypes.oneOfType([PropTypes.array, PropTypes.func, PropTypes.number, PropTypes.object, PropTypes.string, PropTypes.bool])
});
function globalCss(e) {
  return function(o) {
    return (
      // Pigment CSS `globalCss` support callback with theme inside an object but `GlobalStyles` support theme as a callback value.
      /* @__PURE__ */ jsxRuntimeExports.jsx(GlobalStyles, {
        styles: typeof e == "function" ? (n) => e({
          theme: n,
          ...o
        }) : e
      })
    );
  };
}
function internal_createExtendSxProp() {
  return extendSxProp$1;
}
const memoTheme = unstable_memoTheme;
process.env.NODE_ENV !== "production" && (PropTypes.node, PropTypes.object.isRequired);
function useDefaultProps(e) {
  return useDefaultProps$1(e);
}
function getSvgIconUtilityClass(e) {
  return generateUtilityClass("MuiSvgIcon", e);
}
generateUtilityClasses("MuiSvgIcon", ["root", "colorPrimary", "colorSecondary", "colorAction", "colorError", "colorDisabled", "fontSizeInherit", "fontSizeSmall", "fontSizeMedium", "fontSizeLarge"]);
const useUtilityClasses$R = (e) => {
  const {
    color: t,
    fontSize: o,
    classes: n
  } = e, s = {
    root: ["root", t !== "inherit" && `color${capitalize(t)}`, `fontSize${capitalize(o)}`]
  };
  return composeClasses(s, getSvgIconUtilityClass, n);
}, SvgIconRoot = styled("svg", {
  name: "MuiSvgIcon",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.root, o.color !== "inherit" && t[`color${capitalize(o.color)}`], t[`fontSize${capitalize(o.fontSize)}`]];
  }
})(memoTheme(({
  theme: e
}) => ({
  userSelect: "none",
  width: "1em",
  height: "1em",
  display: "inline-block",
  flexShrink: 0,
  transition: e.transitions?.create?.("fill", {
    duration: (e.vars ?? e).transitions?.duration?.shorter
  }),
  variants: [
    {
      props: (t) => !t.hasSvgAsChild,
      style: {
        // the <svg> will define the property that has `currentColor`
        // for example heroicons uses fill="none" and stroke="currentColor"
        fill: "currentColor"
      }
    },
    {
      props: {
        fontSize: "inherit"
      },
      style: {
        fontSize: "inherit"
      }
    },
    {
      props: {
        fontSize: "small"
      },
      style: {
        fontSize: e.typography?.pxToRem?.(20) || "1.25rem"
      }
    },
    {
      props: {
        fontSize: "medium"
      },
      style: {
        fontSize: e.typography?.pxToRem?.(24) || "1.5rem"
      }
    },
    {
      props: {
        fontSize: "large"
      },
      style: {
        fontSize: e.typography?.pxToRem?.(35) || "2.1875rem"
      }
    },
    // TODO v5 deprecate color prop, v6 remove for sx
    ...Object.entries((e.vars ?? e).palette).filter(([, t]) => t && t.main).map(([t]) => ({
      props: {
        color: t
      },
      style: {
        color: (e.vars ?? e).palette?.[t]?.main
      }
    })),
    {
      props: {
        color: "action"
      },
      style: {
        color: (e.vars ?? e).palette?.action?.active
      }
    },
    {
      props: {
        color: "disabled"
      },
      style: {
        color: (e.vars ?? e).palette?.action?.disabled
      }
    },
    {
      props: {
        color: "inherit"
      },
      style: {
        color: void 0
      }
    }
  ]
}))), SvgIcon = /* @__PURE__ */ React.forwardRef(function(t, o) {
  const n = useDefaultProps({
    props: t,
    name: "MuiSvgIcon"
  }), {
    children: s,
    className: i,
    color: l = "inherit",
    component: d = "svg",
    fontSize: u = "medium",
    htmlColor: c,
    inheritViewBox: p = !1,
    titleAccess: f,
    viewBox: g = "0 0 24 24",
    ...y
  } = n, h = /* @__PURE__ */ React.isValidElement(s) && s.type === "svg", T = {
    ...n,
    color: l,
    component: d,
    fontSize: u,
    instanceFontSize: t.fontSize,
    inheritViewBox: p,
    viewBox: g,
    hasSvgAsChild: h
  }, P = {};
  p || (P.viewBox = g);
  const E = useUtilityClasses$R(T);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(SvgIconRoot, {
    as: d,
    className: clsx(E.root, i),
    focusable: "false",
    color: c,
    "aria-hidden": f ? void 0 : !0,
    role: f ? "img" : void 0,
    ref: o,
    ...P,
    ...y,
    ...h && s.props,
    ownerState: T,
    children: [h ? s.props.children : s, f ? /* @__PURE__ */ jsxRuntimeExports.jsx("title", {
      children: f
    }) : null]
  });
});
process.env.NODE_ENV !== "production" && (SvgIcon.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Node passed into the SVG element.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * You can use the `htmlColor` prop to apply a color attribute to the SVG element.
   * @default 'inherit'
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["inherit", "action", "disabled", "primary", "secondary", "error", "info", "success", "warning"]), PropTypes.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * The fontSize applied to the icon. Defaults to 24px, but can be configure to inherit font size.
   * @default 'medium'
   */
  fontSize: PropTypes.oneOfType([PropTypes.oneOf(["inherit", "large", "medium", "small"]), PropTypes.string]),
  /**
   * Applies a color attribute to the SVG element.
   */
  htmlColor: PropTypes.string,
  /**
   * If `true`, the root node will inherit the custom `component`'s viewBox and the `viewBox`
   * prop will be ignored.
   * Useful when you want to reference a custom `component` and have `SvgIcon` pass that
   * `component`'s viewBox to the root node.
   * @default false
   */
  inheritViewBox: PropTypes.bool,
  /**
   * The shape-rendering attribute. The behavior of the different options is described on the
   * [MDN Web Docs](https://developer.mozilla.org/en-US/docs/Web/SVG/Reference/Attribute/shape-rendering).
   * If you are having issues with blurry icons you should investigate this prop.
   */
  shapeRendering: PropTypes.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Provides a human-readable title for the element that contains it.
   * https://www.w3.org/TR/SVG-access/#Equivalent
   */
  titleAccess: PropTypes.string,
  /**
   * Allows you to redefine what the coordinates without units mean inside an SVG element.
   * For example, if the SVG element is 500 (width) by 200 (height),
   * and you pass viewBox="0 0 50 20",
   * this means that the coordinates inside the SVG will go from the top left corner (0,0)
   * to bottom right (50,20) and each unit will be worth 10px.
   * @default '0 0 24 24'
   */
  viewBox: PropTypes.string
});
SvgIcon.muiName = "SvgIcon";
function createSvgIcon(e, t) {
  function o(n, s) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(SvgIcon, {
      "data-testid": process.env.NODE_ENV !== "production" ? `${t}Icon` : void 0,
      ref: s,
      ...n,
      children: e
    });
  }
  return process.env.NODE_ENV !== "production" && (o.displayName = `${t}Icon`), o.muiName = SvgIcon.muiName, /* @__PURE__ */ React.memo(/* @__PURE__ */ React.forwardRef(o));
}
function debounce$1(e, t = 166) {
  let o;
  function n(...s) {
    const i = () => {
      e.apply(this, s);
    };
    clearTimeout(o), o = setTimeout(i, t);
  }
  return n.clear = () => {
    clearTimeout(o);
  }, n;
}
function ownerDocument(e) {
  return e && e.ownerDocument || document;
}
function ownerWindow(e) {
  return ownerDocument(e).defaultView || window;
}
function setRef(e, t) {
  typeof e == "function" ? e(t) : e && (e.current = t);
}
function unsupportedProp(e, t, o, n, s) {
  if (process.env.NODE_ENV === "production")
    return null;
  const i = s || t;
  return typeof e[t] < "u" ? new Error(`The prop \`${i}\` is not supported. Please remove it.`) : null;
}
function useControlled(e) {
  const {
    controlled: t,
    default: o,
    name: n,
    state: s = "value"
  } = e, {
    current: i
  } = React.useRef(t !== void 0), [l, d] = React.useState(o), u = i ? t : l;
  if (process.env.NODE_ENV !== "production") {
    React.useEffect(() => {
      i !== (t !== void 0) && console.error([`MUI: A component is changing the ${i ? "" : "un"}controlled ${s} state of ${n} to be ${i ? "un" : ""}controlled.`, "Elements should not switch from uncontrolled to controlled (or vice versa).", `Decide between using a controlled or uncontrolled ${n} element for the lifetime of the component.`, "The nature of the state is determined during the first render. It's considered controlled if the value is not `undefined`.", "More info: https://fb.me/react-controlled-components"].join(`
`));
    }, [s, n, t]);
    const {
      current: p
    } = React.useRef(o);
    React.useEffect(() => {
      !i && JSON.stringify(o) !== JSON.stringify(p) && console.error([`MUI: A component is changing the default ${s} state of an uncontrolled ${n} after being initialized. To suppress this warning opt to use a controlled ${n}.`].join(`
`));
    }, [JSON.stringify(o)]);
  }
  const c = React.useCallback((p) => {
    i || d(p);
  }, []);
  return [u, c];
}
function useEventCallback(e) {
  const t = React.useRef(e);
  return useEnhancedEffect(() => {
    t.current = e;
  }), React.useRef((...o) => (
    // @ts-expect-error hide `this`
    (0, t.current)(...o)
  )).current;
}
function useForkRef(...e) {
  const t = React.useRef(void 0), o = React.useCallback((n) => {
    const s = e.map((i) => {
      if (i == null)
        return null;
      if (typeof i == "function") {
        const l = i, d = l(n);
        return typeof d == "function" ? d : () => {
          l(null);
        };
      }
      return i.current = n, () => {
        i.current = null;
      };
    });
    return () => {
      s.forEach((i) => i?.());
    };
  }, e);
  return React.useMemo(() => e.every((n) => n == null) ? null : (n) => {
    t.current && (t.current(), t.current = void 0), n != null && (t.current = o(n));
  }, e);
}
function isEventHandler(e, t) {
  const o = e.charCodeAt(2);
  return e[0] === "o" && e[1] === "n" && o >= 65 && o <= 90 && typeof t == "function";
}
function mergeSlotProps$2(e, t) {
  if (!e)
    return t;
  function o(l, d) {
    const u = {};
    return Object.keys(d).forEach((c) => {
      isEventHandler(c, d[c]) && typeof l[c] == "function" && (u[c] = (...p) => {
        l[c](...p), d[c](...p);
      });
    }), u;
  }
  if (typeof e == "function" || typeof t == "function")
    return (l) => {
      const d = typeof t == "function" ? t(l) : t, u = typeof e == "function" ? e({
        ...l,
        ...d
      }) : e, c = clsx(l?.className, d?.className, u?.className), p = o(u, d);
      return {
        ...d,
        ...u,
        ...p,
        ...!!c && {
          className: c
        },
        ...d?.style && u?.style && {
          style: {
            ...d.style,
            ...u.style
          }
        },
        ...d?.sx && u?.sx && {
          sx: [...Array.isArray(d.sx) ? d.sx : [d.sx], ...Array.isArray(u.sx) ? u.sx : [u.sx]]
        }
      };
    };
  const n = t, s = o(e, n), i = clsx(n?.className, e?.className);
  return {
    ...t,
    ...e,
    ...s,
    ...!!i && {
      className: i
    },
    ...n?.style && e?.style && {
      style: {
        ...n.style,
        ...e.style
      }
    },
    ...n?.sx && e?.sx && {
      sx: [...Array.isArray(n.sx) ? n.sx : [n.sx], ...Array.isArray(e.sx) ? e.sx : [e.sx]]
    }
  };
}
const AddCircle = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m5 11h-4v4h-2v-4H7v-2h4V7h2v4h4z"
}), "AddCircle"), CheckCircle = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m-2 15-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8z"
}), "CheckCircle"), CheckCircleRounded = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2M9.29 16.29 5.7 12.7a.996.996 0 0 1 0-1.41c.39-.39 1.02-.39 1.41 0L10 14.17l6.88-6.88c.39-.39 1.02-.39 1.41 0s.39 1.02 0 1.41l-7.59 7.59c-.38.39-1.02.39-1.41 0"
}), "CheckCircleRounded"), Close = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Close"), Delete = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6zM19 4h-3.5l-1-1h-5l-1 1H5v2h14z"
}), "Delete"), Error$1 = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m1 15h-2v-2h2zm0-4h-2V7h2z"
}), "Error"), Info = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m1 15h-2v-6h2zm0-8h-2V7h2z"
}), "Info"), LibraryBooksIcon = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M4 6H2v14c0 1.1.9 2 2 2h14v-2H4zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2m-1 9H9V9h10zm-4 4H9v-2h6zm4-8H9V5h10z"
}), "LibraryBooks"), LocalHospital = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M19 3H5c-1.1 0-1.99.9-1.99 2L3 19c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m-1 11h-4v4h-4v-4H6v-4h4V6h4v4h4z"
}), "LocalHospital"), LocationOn = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7m0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5"
}), "LocationOn"), ManageAccountsRoundedIcon = createSvgIcon([/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M10.67 13.02c-.22-.01-.44-.02-.67-.02-2.42 0-4.68.67-6.61 1.82-.88.52-1.39 1.5-1.39 2.53V19c0 .55.45 1 1 1h8.26c-.79-1.13-1.26-2.51-1.26-4 0-1.07.25-2.07.67-2.98"
}, "0"), /* @__PURE__ */ jsxRuntimeExports.jsx("circle", {
  cx: "10",
  cy: "8",
  r: "4"
}, "1"), /* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M20.75 16c0-.22-.03-.42-.06-.63l.84-.73c.18-.16.22-.42.1-.63l-.59-1.02c-.12-.21-.37-.3-.59-.22l-1.06.36q-.48-.405-1.08-.63l-.22-1.09c-.05-.23-.25-.4-.49-.4h-1.18c-.24 0-.44.17-.49.4l-.22 1.09q-.6.225-1.08.63l-1.06-.36c-.23-.08-.47.02-.59.22l-.59 1.02c-.12.21-.08.47.1.63l.84.73c-.03.21-.06.41-.06.63s.03.42.06.63l-.84.73c-.18.16-.22.42-.1.63l.59 1.02c.12.21.37.3.59.22l1.06-.36q.48.405 1.08.63l.22 1.09c.05.23.25.4.49.4h1.18c.24 0 .44-.17.49-.4l.22-1.09q.6-.225 1.08-.63l1.06.36c.23.08.47-.02.59-.22l.59-1.02c.12-.21.08-.47-.1-.63l-.84-.73c.03-.21.06-.41.06-.63M17 18c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2"
}, "2")], "ManageAccountsRounded"), MedicalServices = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M20 6h-4V4c0-1.1-.9-2-2-2h-4c-1.1 0-2 .9-2 2v2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2M10 4h4v2h-4zm6 11h-3v3h-2v-3H8v-2h3v-3h2v3h3z"
}), "MedicalServices"), MedicationIcon = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M6 3h12v2H6zm11 3H7c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2m-1 9h-2.5v2.5h-3V15H8v-3h2.5V9.5h3V12H16z"
}), "Medication"), MicOffIcon = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M19 11h-1.7c0 .74-.16 1.43-.43 2.05l1.23 1.23c.56-.98.9-2.09.9-3.28m-4.02.17c0-.06.02-.11.02-.17V5c0-1.66-1.34-3-3-3S9 3.34 9 5v.18zM4.27 3 3 4.27l6.01 6.01V11c0 1.66 1.33 3 2.99 3 .22 0 .44-.03.65-.08l1.66 1.66c-.71.33-1.5.52-2.31.52-2.76 0-5.3-2.1-5.3-5.1H5c0 3.41 2.72 6.23 6 6.72V21h2v-3.28c.91-.13 1.77-.45 2.54-.9L19.73 21 21 19.73z"
}), "MicOff"), Person = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4m0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4"
}), "Person"), PersonOffRoundedIcon = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M8.65 5.82C9.36 4.72 10.6 4 12 4c2.21 0 4 1.79 4 4 0 1.4-.72 2.64-1.82 3.35zM20 17.17c-.02-1.1-.63-2.11-1.61-2.62-.54-.28-1.13-.54-1.77-.76zm.49 3.32L3.51 3.51a.996.996 0 0 0-1.41 0c-.39.39-.39 1.02 0 1.41l8.18 8.18c-1.82.23-3.41.8-4.7 1.46C4.6 15.08 4 16.11 4 17.22V20h13.17l1.9 1.9c.39.39 1.02.39 1.41 0 .4-.39.4-1.02.01-1.41"
}), "PersonOffRounded"), ReportProblemRounded = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M2.73 21h18.53c.77 0 1.25-.83.87-1.5l-9.27-16c-.39-.67-1.35-.67-1.73 0l-9.27 16c-.38.67.1 1.5.87 1.5M13 18h-2v-2h2zm-1-4c-.55 0-1-.45-1-1v-2c0-.55.45-1 1-1s1 .45 1 1v2c0 .55-.45 1-1 1"
}), "ReportProblemRounded"), RestartAltIcon = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M12 5V2L8 6l4 4V7c3.31 0 6 2.69 6 6 0 2.97-2.17 5.43-5 5.91v2.02c3.95-.49 7-3.85 7-7.93 0-4.42-3.58-8-8-8m-6 8c0-1.65.67-3.15 1.76-4.24L6.34 7.34C4.9 8.79 4 10.79 4 13c0 4.08 3.05 7.44 7 7.93v-2.02c-2.83-.48-5-2.94-5-5.91"
}), "RestartAlt"), Search = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14"
}), "Search"), SettingsIcon = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M19.14 12.94c.04-.3.06-.61.06-.94 0-.32-.02-.64-.07-.94l2.03-1.58c.18-.14.23-.41.12-.61l-1.92-3.32c-.12-.22-.37-.29-.59-.22l-2.39.96c-.5-.38-1.03-.7-1.62-.94l-.36-2.54c-.04-.24-.24-.41-.48-.41h-3.84c-.24 0-.43.17-.47.41l-.36 2.54c-.59.24-1.13.57-1.62.94l-2.39-.96c-.22-.08-.47 0-.59.22L2.74 8.87c-.12.21-.08.47.12.61l2.03 1.58c-.05.3-.09.63-.09.94s.02.64.07.94l-2.03 1.58c-.18.14-.23.41-.12.61l1.92 3.32c.12.22.37.29.59.22l2.39-.96c.5.38 1.03.7 1.62.94l.36 2.54c.05.24.24.41.48.41h3.84c.24 0 .44-.17.47-.41l.36-2.54c.59-.24 1.13-.56 1.62-.94l2.39.96c.22.08.47 0 .59-.22l1.92-3.32c.12-.22.07-.47-.12-.61zM12 15.6c-1.98 0-3.6-1.62-3.6-3.6s1.62-3.6 3.6-3.6 3.6 1.62 3.6 3.6-1.62 3.6-3.6 3.6"
}), "Settings"), ButtonIcon = ({
  children: e,
  size: t,
  backgroundColor: o,
  testId: n,
  onClick: s
}) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  IconWrapper,
  {
    size: t,
    backgroundColor: o,
    testId: n,
    onClick: s,
    children: e
  }
), AddItemIcon = ({
  iconSize: e = ADD_ICON_SIZE,
  backgroundColor: t,
  onClick: o
}) => {
  const n = useTheme$4(), s = t ?? n.palette.primary.lighter, i = e ?? ADD_ICON_SIZE;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    ButtonIcon,
    {
      size: i,
      backgroundColor: s,
      testId: "add-button-icon",
      onClick: o,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(AddCircle, { fontSize: "small", color: "primary" })
    }
  );
}, RemoveItemIcon = ({
  iconSize: e = REMOVE_ICON_SIZE,
  backgroundColor: t,
  onClick: o
}) => {
  const n = useTheme$4(), s = t ?? n.palette.error.lighter, i = e ?? REMOVE_ICON_SIZE;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    ButtonIcon,
    {
      size: i,
      backgroundColor: s,
      testId: "remove-button-icon",
      onClick: o,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(Delete, { fontSize: "small", color: "error" })
    }
  );
}, SelectedItemIcon = ({
  iconSize: e = SELECTED_ICON_SIZE,
  backgroundColor: t = "",
  color: o = "success"
}) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  IconWrapper,
  {
    size: e,
    backgroundColor: t,
    testId: "selected-button-icon",
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(CheckCircle, { fontSize: "small", color: o })
  }
), ConsentCollectionColumn = ({
  children: e
}) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  InteractionItemsColumn,
  {
    isSharing: !0,
    flex: 2,
    testId: "consent-collection-column",
    children: e
  }
), ConsentFormPreview = ({ state: e }) => {
  const t = useRef(null);
  return useEffect(() => {
    const n = t.current?.contentWindow?.document;
    n && e?.step === "preview" && (n.open(), n.write(e.content ?? ""), n.close());
  }, [e]), /* @__PURE__ */ jsxRuntimeExports.jsx(Content$2, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(FormFrame$1, { ref: t, "data-testid": "ConsentFormPreview", id: "form-frame" }) });
}, Content$2 = styled(Box)({
  flexGrow: 1,
  height: "100%"
}), FormFrame$1 = styled("iframe")(({ theme: e }) => ({
  backgroundColor: e.palette.common.white,
  border: "none",
  height: "100%",
  width: "100%"
})), SimpleDialog = ({
  isOpen: e,
  title: t,
  description: o,
  testId: n,
  closeDialog: s,
  closeDialogText: i,
  cancelDialog: l,
  cancelDialogText: d
}) => /* @__PURE__ */ jsxRuntimeExports.jsxs(Dialog$2, { open: e, "data-testid": n, children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx(DialogTitle, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Typography$2, { variant: "h6", children: t }) }),
  o && /* @__PURE__ */ jsxRuntimeExports.jsx(DialogTitle, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Typography$2, { variant: "body1", children: o }) }),
  /* @__PURE__ */ jsxRuntimeExports.jsxs(DialogContent$2, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Button$3, { variant: "contained", onClick: s, children: i }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Button$3, { variant: "outlined", onClick: l, children: d })
  ] })
] }), DialogTitle = styled(Box)(({ theme: e }) => ({
  display: "flex",
  flexDirection: "column",
  gap: e.spacing(2),
  padding: e.spacing(2)
})), DialogContent$2 = styled(DialogContent$3)(({ theme: e }) => ({
  display: "flex",
  flexDirection: "column",
  gap: e.spacing(1),
  padding: e.spacing(2),
  paddingTop: 0,
  height: "100%"
})), Button$3 = styled(Button$5)({
  textTransform: "uppercase"
}), DoubleListItem = ({
  renderItem: e,
  operation: t,
  onClick: o
}) => /* @__PURE__ */ jsxRuntimeExports.jsxs(Row$1, { "data-testid": "double-list-item", children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx(Wrapper$k, { children: e }),
  t === "add" && /* @__PURE__ */ jsxRuntimeExports.jsx(AddItemIcon, { iconSize: ADD_ICON_SIZE, onClick: o }),
  t === "remove" && /* @__PURE__ */ jsxRuntimeExports.jsx(RemoveItemIcon, { iconSize: REMOVE_ICON_SIZE, onClick: o }),
  t === "selected" && /* @__PURE__ */ jsxRuntimeExports.jsx(SelectedItemIcon, { iconSize: SELECTED_ICON_SIZE, color: "disabled" })
] }), Row$1 = styled(Card$1)(({ theme: e }) => ({
  display: "flex",
  gap: e.spacing(1),
  padding: e.spacing(2),
  alignItems: "center"
})), Wrapper$k = styled(Box)(({ theme: e }) => ({
  gap: e.spacing(1),
  flex: 4,
  overflowWrap: "anywhere"
})), DoubleListItemSkeleton = () => /* @__PURE__ */ jsxRuntimeExports.jsx(Row, { "data-testid": "double-list-item-skeleton", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Wrapper$j, { children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx(Typography$2, { variant: "subtitle2", children: /* @__PURE__ */ jsxRuntimeExports.jsx(Skeleton$1, { width: 200, height: 22 }) }),
  /* @__PURE__ */ jsxRuntimeExports.jsx(Skeleton$1, { width: 160 })
] }) }), Row = styled(Card$1)(({ theme: e }) => ({
  display: "flex",
  gap: e.spacing(1),
  padding: e.spacing(2),
  alignItems: "center"
})), Wrapper$j = styled(Stack)(({ theme: e }) => ({
  gap: e.spacing(1)
})), ErrorPage = ({
  title: e,
  subtitleLine1: t,
  subtitleLine2: o,
  actionButton: n,
  imageFile: s,
  imageAlt: i
}) => /* @__PURE__ */ jsxRuntimeExports.jsxs(Wrapper$i, { "data-testid": "error-page-wrapper", children: [
  /* @__PURE__ */ jsxRuntimeExports.jsxs(TypographyWrapper, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Title$3, { variant: "h3", children: e }),
    t || o ? /* @__PURE__ */ jsxRuntimeExports.jsxs(SubtitleWrapper, { children: [
      t && /* @__PURE__ */ jsxRuntimeExports.jsx(Subtitle, { variant: "body1", children: t }),
      o && /* @__PURE__ */ jsxRuntimeExports.jsx(Subtitle, { variant: "body1", children: o })
    ] }) : null,
    n
  ] }),
  s && /* @__PURE__ */ jsxRuntimeExports.jsx(ImageWrapper, { children: /* @__PURE__ */ jsxRuntimeExports.jsx("img", { alt: i, src: s }) })
] }), Wrapper$i = styled(Box)(({ theme: e }) => ({
  display: "flex",
  flexDirection: "column",
  width: ERROR_PAGE.DESKTOP.WIDTH,
  alignSelf: "center",
  alignItems: "center",
  justifyContent: "center",
  gap: e.spacing(5),
  margin: `${e.spacing(5)} auto`,
  [`@media only screen and (max-height: ${CUSTOM_BREAKPOINTS.MOBILE_LANDSCAPE_MAX_HEIGHT})`]: {
    flexDirection: "row-reverse",
    gap: e.spacing(2),
    width: ERROR_PAGE.MOBILE.LANDSCAPE.WIDTH
  },
  [e.breakpoints.down("sm")]: {
    width: "100%"
  }
})), TypographyWrapper = styled(Stack)(({ theme: e }) => ({
  alignItems: "center",
  gap: e.spacing(2),
  [`@media only screen and (max-height: ${CUSTOM_BREAKPOINTS.MOBILE_LANDSCAPE_MAX_HEIGHT})`]: {
    alignItems: "center"
  }
})), Title$3 = styled(Typography$2)({
  textAlign: "center",
  [`@media only screen and (max-height: ${CUSTOM_BREAKPOINTS.MOBILE_LANDSCAPE_MAX_HEIGHT})`]: {
    textAlign: "left"
  }
}), SubtitleWrapper = styled(Box)({
  textAlign: "center"
}), Subtitle = styled(Typography$2)(({ theme: e }) => ({
  ...e.typography.body1,
  color: e.palette.text.secondary,
  [e.breakpoints.down("md")]: {
    ...e.typography.caption
  }
})), ImageWrapper = styled(Stack)(({ theme: e }) => ({
  width: "66%",
  [e.breakpoints.down("md")]: {
    width: "100%"
  },
  [`@media only screen and (max-height: ${CUSTOM_BREAKPOINTS.MOBILE_LANDSCAPE_MAX_HEIGHT})`]: {
    img: {
      width: 240
    }
  }
})), Icon = ({ icon: e, ...t }) => {
  switch (e) {
    case "info":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(Info, { ...t });
    case "error":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(Error$1, { ...t });
    case "warning":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(ReportProblemRounded, { ...t });
    case "success":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(CheckCircleRounded, { ...t });
    default:
      return null;
  }
}, SnackbarIcon = ({
  icon: e,
  color: t,
  backgroundColor: o
}) => /* @__PURE__ */ jsxRuntimeExports.jsx(StyleBox, { style: { color: t, backgroundColor: o }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Icon, { icon: e, width: 24, height: 24 }) }), StyleBox = styled$2("span")(({ theme: e }) => ({
  minWidth: 40,
  height: 40,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  margin: e.spacing(1),
  borderRadius: Number(e.shape.borderRadius) * 1.5
})), IconWrapper = ({
  backgroundColor: e = "none",
  isDisabled: t = !1,
  size: o = 24,
  testId: n,
  children: s,
  className: i,
  onClick: l
}) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  Wrapper$h,
  {
    backgroundColor: e,
    isDisabled: t,
    size: o,
    "data-testid": n,
    className: i,
    onClick: l,
    children: s
  }
), Wrapper$h = styled(Box, {
  shouldForwardProp: (e) => typeof e == "string" && ["isDisabled", "size", "backgroundColor"].indexOf(e) === -1
})(
  ({ theme: e, backgroundColor: t, isDisabled: o, size: n, onClick: s }) => ({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "100%",
    backgroundColor: o ? e.palette.text.disabled : t,
    width: n,
    height: n,
    flexShrink: 0,
    cursor: s ? "pointer" : "unset"
  })
);
var build$4 = { exports: {} }, hasRequiredBuild$2;
function requireBuild$2() {
  return hasRequiredBuild$2 || (hasRequiredBuild$2 = 1, (() => {
    var e = { 296: (s, i, l) => {
      var d = /^\s+|\s+$/g, u = /^[-+]0x[0-9a-f]+$/i, c = /^0b[01]+$/i, p = /^0o[0-7]+$/i, f = parseInt, g = typeof l.g == "object" && l.g && l.g.Object === Object && l.g, y = typeof self == "object" && self && self.Object === Object && self, h = g || y || Function("return this")(), T = Object.prototype.toString, P = Math.max, E = Math.min, $ = function() {
        return h.Date.now();
      };
      function R(x) {
        var _ = typeof x;
        return !!x && (_ == "object" || _ == "function");
      }
      function C(x) {
        if (typeof x == "number") return x;
        if ((function(O) {
          return typeof O == "symbol" || /* @__PURE__ */ (function(v) {
            return !!v && typeof v == "object";
          })(O) && T.call(O) == "[object Symbol]";
        })(x)) return NaN;
        if (R(x)) {
          var _ = typeof x.valueOf == "function" ? x.valueOf() : x;
          x = R(_) ? _ + "" : _;
        }
        if (typeof x != "string") return x === 0 ? x : +x;
        x = x.replace(d, "");
        var D = c.test(x);
        return D || p.test(x) ? f(x.slice(2), D ? 2 : 8) : u.test(x) ? NaN : +x;
      }
      s.exports = function(x, _, D) {
        var O, v, w, M, S, I, N = 0, F = !1, L = !1, k = !0;
        if (typeof x != "function") throw new TypeError("Expected a function");
        function W(G) {
          var Y = O, ee = v;
          return O = v = void 0, N = G, M = x.apply(ee, Y);
        }
        function V(G) {
          var Y = G - I;
          return I === void 0 || Y >= _ || Y < 0 || L && G - N >= w;
        }
        function j() {
          var G = $();
          if (V(G)) return A(G);
          S = setTimeout(j, (function(Y) {
            var ee = _ - (Y - I);
            return L ? E(ee, w - (Y - N)) : ee;
          })(G));
        }
        function A(G) {
          return S = void 0, k && O ? W(G) : (O = v = void 0, M);
        }
        function U() {
          var G = $(), Y = V(G);
          if (O = arguments, v = this, I = G, Y) {
            if (S === void 0) return (function(ee) {
              return N = ee, S = setTimeout(j, _), F ? W(ee) : M;
            })(I);
            if (L) return S = setTimeout(j, _), W(I);
          }
          return S === void 0 && (S = setTimeout(j, _)), M;
        }
        return _ = C(_) || 0, R(D) && (F = !!D.leading, w = (L = "maxWait" in D) ? P(C(D.maxWait) || 0, _) : w, k = "trailing" in D ? !!D.trailing : k), U.cancel = function() {
          S !== void 0 && clearTimeout(S), N = 0, O = I = v = S = void 0;
        }, U.flush = function() {
          return S === void 0 ? M : A($());
        }, U;
      };
    }, 96: (s, i, l) => {
      var d = "Expected a function", u = NaN, c = "[object Symbol]", p = /^\s+|\s+$/g, f = /^[-+]0x[0-9a-f]+$/i, g = /^0b[01]+$/i, y = /^0o[0-7]+$/i, h = parseInt, T = typeof l.g == "object" && l.g && l.g.Object === Object && l.g, P = typeof self == "object" && self && self.Object === Object && self, E = T || P || Function("return this")(), $ = Object.prototype.toString, R = Math.max, C = Math.min, x = function() {
        return E.Date.now();
      };
      function _(O) {
        var v = typeof O;
        return !!O && (v == "object" || v == "function");
      }
      function D(O) {
        if (typeof O == "number") return O;
        if ((function(M) {
          return typeof M == "symbol" || /* @__PURE__ */ (function(S) {
            return !!S && typeof S == "object";
          })(M) && $.call(M) == c;
        })(O)) return u;
        if (_(O)) {
          var v = typeof O.valueOf == "function" ? O.valueOf() : O;
          O = _(v) ? v + "" : v;
        }
        if (typeof O != "string") return O === 0 ? O : +O;
        O = O.replace(p, "");
        var w = g.test(O);
        return w || y.test(O) ? h(O.slice(2), w ? 2 : 8) : f.test(O) ? u : +O;
      }
      s.exports = function(O, v, w) {
        var M = !0, S = !0;
        if (typeof O != "function") throw new TypeError(d);
        return _(w) && (M = "leading" in w ? !!w.leading : M, S = "trailing" in w ? !!w.trailing : S), (function(I, N, F) {
          var L, k, W, V, j, A, U = 0, G = !1, Y = !1, ee = !0;
          if (typeof I != "function") throw new TypeError(d);
          function J(q) {
            var B = L, ue = k;
            return L = k = void 0, U = q, V = I.apply(ue, B);
          }
          function Z(q) {
            var B = q - A;
            return A === void 0 || B >= N || B < 0 || Y && q - U >= W;
          }
          function le() {
            var q = x();
            if (Z(q)) return se(q);
            j = setTimeout(le, (function(B) {
              var ue = N - (B - A);
              return Y ? C(ue, W - (B - U)) : ue;
            })(q));
          }
          function se(q) {
            return j = void 0, ee && L ? J(q) : (L = k = void 0, V);
          }
          function K() {
            var q = x(), B = Z(q);
            if (L = arguments, k = this, A = q, B) {
              if (j === void 0) return (function(ue) {
                return U = ue, j = setTimeout(le, N), G ? J(ue) : V;
              })(A);
              if (Y) return j = setTimeout(le, N), J(A);
            }
            return j === void 0 && (j = setTimeout(le, N)), V;
          }
          return N = D(N) || 0, _(F) && (G = !!F.leading, W = (Y = "maxWait" in F) ? R(D(F.maxWait) || 0, N) : W, ee = "trailing" in F ? !!F.trailing : ee), K.cancel = function() {
            j !== void 0 && clearTimeout(j), U = 0, L = A = k = j = void 0;
          }, K.flush = function() {
            return j === void 0 ? V : se(x());
          }, K;
        })(O, v, { leading: M, maxWait: v, trailing: S });
      };
    }, 703: (s, i, l) => {
      var d = l(414);
      function u() {
      }
      function c() {
      }
      c.resetWarningCache = u, s.exports = function() {
        function p(y, h, T, P, E, $) {
          if ($ !== d) {
            var R = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
            throw R.name = "Invariant Violation", R;
          }
        }
        function f() {
          return p;
        }
        p.isRequired = p;
        var g = { array: p, bigint: p, bool: p, func: p, number: p, object: p, string: p, symbol: p, any: p, arrayOf: f, element: p, elementType: p, instanceOf: f, node: p, objectOf: f, oneOf: f, oneOfType: f, shape: f, exact: f, checkPropTypes: c, resetWarningCache: u };
        return g.PropTypes = g, g;
      };
    }, 697: (s, i, l) => {
      s.exports = l(703)();
    }, 414: (s) => {
      s.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
    } }, t = {};
    function o(s) {
      var i = t[s];
      if (i !== void 0) return i.exports;
      var l = t[s] = { exports: {} };
      return e[s](l, l.exports, o), l.exports;
    }
    o.n = (s) => {
      var i = s && s.__esModule ? () => s.default : () => s;
      return o.d(i, { a: i }), i;
    }, o.d = (s, i) => {
      for (var l in i) o.o(i, l) && !o.o(s, l) && Object.defineProperty(s, l, { enumerable: !0, get: i[l] });
    }, o.g = (function() {
      if (typeof globalThis == "object") return globalThis;
      try {
        return this || new Function("return this")();
      } catch {
        if (typeof window == "object") return window;
      }
    })(), o.o = (s, i) => Object.prototype.hasOwnProperty.call(s, i), o.r = (s) => {
      typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(s, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(s, "__esModule", { value: !0 });
    };
    var n = {};
    (() => {
      o.r(n), o.d(n, { LazyLoadComponent: () => B, LazyLoadImage: () => Ce, trackWindowScroll: () => V });
      const s = React__default;
      var i = o.n(s), l = o(697);
      function d() {
        return typeof window < "u" && "IntersectionObserver" in window && "isIntersecting" in window.IntersectionObserverEntry.prototype;
      }
      function u(ne) {
        return u = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(H) {
          return typeof H;
        } : function(H) {
          return H && typeof Symbol == "function" && H.constructor === Symbol && H !== Symbol.prototype ? "symbol" : typeof H;
        }, u(ne);
      }
      function c(ne, H) {
        var te = Object.keys(ne);
        if (Object.getOwnPropertySymbols) {
          var ie = Object.getOwnPropertySymbols(ne);
          H && (ie = ie.filter((function(ce) {
            return Object.getOwnPropertyDescriptor(ne, ce).enumerable;
          }))), te.push.apply(te, ie);
        }
        return te;
      }
      function p(ne, H, te) {
        return (H = g(H)) in ne ? Object.defineProperty(ne, H, { value: te, enumerable: !0, configurable: !0, writable: !0 }) : ne[H] = te, ne;
      }
      function f(ne, H) {
        for (var te = 0; te < H.length; te++) {
          var ie = H[te];
          ie.enumerable = ie.enumerable || !1, ie.configurable = !0, "value" in ie && (ie.writable = !0), Object.defineProperty(ne, g(ie.key), ie);
        }
      }
      function g(ne) {
        var H = (function(te, ie) {
          if (u(te) !== "object" || te === null) return te;
          var ce = te[Symbol.toPrimitive];
          if (ce !== void 0) {
            var me = ce.call(te, "string");
            if (u(me) !== "object") return me;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }
          return String(te);
        })(ne);
        return u(H) === "symbol" ? H : String(H);
      }
      function y(ne, H) {
        return y = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(te, ie) {
          return te.__proto__ = ie, te;
        }, y(ne, H);
      }
      function h(ne) {
        return h = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(H) {
          return H.__proto__ || Object.getPrototypeOf(H);
        }, h(ne);
      }
      var T = function(ne) {
        ne.forEach((function(H) {
          H.isIntersecting && H.target.onVisible();
        }));
      }, P = {}, E = (function(ne) {
        (function(z, Q) {
          if (typeof Q != "function" && Q !== null) throw new TypeError("Super expression must either be null or a function");
          z.prototype = Object.create(Q && Q.prototype, { constructor: { value: z, writable: !0, configurable: !0 } }), Object.defineProperty(z, "prototype", { writable: !1 }), Q && y(z, Q);
        })(pe, ne);
        var H, te, ie, ce, me = (ie = pe, ce = (function() {
          if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
          if (typeof Proxy == "function") return !0;
          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], (function() {
            }))), !0;
          } catch {
            return !1;
          }
        })(), function() {
          var z, Q = h(ie);
          if (ce) {
            var Te = h(this).constructor;
            z = Reflect.construct(Q, arguments, Te);
          } else z = Q.apply(this, arguments);
          return (function(fe, oe) {
            if (oe && (u(oe) === "object" || typeof oe == "function")) return oe;
            if (oe !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
            return (function(ae) {
              if (ae === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return ae;
            })(fe);
          })(this, z);
        });
        function pe(z) {
          var Q;
          if ((function(fe, oe) {
            if (!(fe instanceof oe)) throw new TypeError("Cannot call a class as a function");
          })(this, pe), (Q = me.call(this, z)).supportsObserver = !z.scrollPosition && z.useIntersectionObserver && d(), Q.supportsObserver) {
            var Te = z.threshold;
            Q.observer = (function(fe) {
              return P[fe] = P[fe] || new IntersectionObserver(T, { rootMargin: fe + "px" }), P[fe];
            })(Te);
          }
          return Q;
        }
        return H = pe, te = [{ key: "componentDidMount", value: function() {
          this.placeholder && this.observer && (this.placeholder.onVisible = this.props.onVisible, this.observer.observe(this.placeholder)), this.supportsObserver || this.updateVisibility();
        } }, { key: "componentWillUnmount", value: function() {
          this.observer && this.placeholder && this.observer.unobserve(this.placeholder);
        } }, { key: "componentDidUpdate", value: function() {
          this.supportsObserver || this.updateVisibility();
        } }, { key: "getPlaceholderBoundingBox", value: function() {
          var z = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.props.scrollPosition, Q = this.placeholder.getBoundingClientRect(), Te = this.placeholder.style, fe = parseInt(Te.getPropertyValue("margin-left"), 10) || 0, oe = parseInt(Te.getPropertyValue("margin-top"), 10) || 0;
          return { bottom: z.y + Q.bottom + oe, left: z.x + Q.left + fe, right: z.x + Q.right + fe, top: z.y + Q.top + oe };
        } }, { key: "isPlaceholderInViewport", value: function() {
          if (typeof window > "u" || !this.placeholder) return !1;
          var z = this.props, Q = z.scrollPosition, Te = z.threshold, fe = this.getPlaceholderBoundingBox(Q), oe = Q.y + window.innerHeight, ae = Q.x, Se = Q.x + window.innerWidth, $e = Q.y;
          return $e - Te <= fe.bottom && oe + Te >= fe.top && ae - Te <= fe.right && Se + Te >= fe.left;
        } }, { key: "updateVisibility", value: function() {
          this.isPlaceholderInViewport() && this.props.onVisible();
        } }, { key: "render", value: function() {
          var z = this, Q = this.props, Te = Q.className, fe = Q.height, oe = Q.placeholder, ae = Q.style, Se = Q.width;
          if (oe && typeof oe.type != "function") return i().cloneElement(oe, { ref: function(Re) {
            return z.placeholder = Re;
          } });
          var $e = (function(Re) {
            for (var Oe = 1; Oe < arguments.length; Oe++) {
              var ve = arguments[Oe] != null ? arguments[Oe] : {};
              Oe % 2 ? c(Object(ve), !0).forEach((function(Ie) {
                p(Re, Ie, ve[Ie]);
              })) : Object.getOwnPropertyDescriptors ? Object.defineProperties(Re, Object.getOwnPropertyDescriptors(ve)) : c(Object(ve)).forEach((function(Ie) {
                Object.defineProperty(Re, Ie, Object.getOwnPropertyDescriptor(ve, Ie));
              }));
            }
            return Re;
          })({ display: "inline-block" }, ae);
          return Se !== void 0 && ($e.width = Se), fe !== void 0 && ($e.height = fe), i().createElement("span", { className: Te, ref: function(Re) {
            return z.placeholder = Re;
          }, style: $e }, oe);
        } }], te && f(H.prototype, te), Object.defineProperty(H, "prototype", { writable: !1 }), pe;
      })(i().Component);
      E.propTypes = { onVisible: l.PropTypes.func.isRequired, className: l.PropTypes.string, height: l.PropTypes.oneOfType([l.PropTypes.number, l.PropTypes.string]), placeholder: l.PropTypes.element, threshold: l.PropTypes.number, useIntersectionObserver: l.PropTypes.bool, scrollPosition: l.PropTypes.shape({ x: l.PropTypes.number.isRequired, y: l.PropTypes.number.isRequired }), width: l.PropTypes.oneOfType([l.PropTypes.number, l.PropTypes.string]) }, E.defaultProps = { className: "", placeholder: null, threshold: 100, useIntersectionObserver: !0 };
      const $ = E;
      var R = o(296), C = o.n(R), x = o(96), _ = o.n(x), D = function(ne) {
        var H = getComputedStyle(ne, null);
        return H.getPropertyValue("overflow") + H.getPropertyValue("overflow-y") + H.getPropertyValue("overflow-x");
      };
      const O = function(ne) {
        if (!(ne instanceof HTMLElement)) return window;
        for (var H = ne; H && H instanceof HTMLElement; ) {
          if (/(scroll|auto)/.test(D(H))) return H;
          H = H.parentNode;
        }
        return window;
      };
      function v(ne) {
        return v = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(H) {
          return typeof H;
        } : function(H) {
          return H && typeof Symbol == "function" && H.constructor === Symbol && H !== Symbol.prototype ? "symbol" : typeof H;
        }, v(ne);
      }
      var w = ["delayMethod", "delayTime"];
      function M() {
        return M = Object.assign ? Object.assign.bind() : function(ne) {
          for (var H = 1; H < arguments.length; H++) {
            var te = arguments[H];
            for (var ie in te) Object.prototype.hasOwnProperty.call(te, ie) && (ne[ie] = te[ie]);
          }
          return ne;
        }, M.apply(this, arguments);
      }
      function S(ne, H) {
        for (var te = 0; te < H.length; te++) {
          var ie = H[te];
          ie.enumerable = ie.enumerable || !1, ie.configurable = !0, "value" in ie && (ie.writable = !0), Object.defineProperty(ne, (ce = (function(me, pe) {
            if (v(me) !== "object" || me === null) return me;
            var z = me[Symbol.toPrimitive];
            if (z !== void 0) {
              var Q = z.call(me, "string");
              if (v(Q) !== "object") return Q;
              throw new TypeError("@@toPrimitive must return a primitive value.");
            }
            return String(me);
          })(ie.key), v(ce) === "symbol" ? ce : String(ce)), ie);
        }
        var ce;
      }
      function I(ne, H) {
        return I = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(te, ie) {
          return te.__proto__ = ie, te;
        }, I(ne, H);
      }
      function N(ne, H) {
        if (H && (v(H) === "object" || typeof H == "function")) return H;
        if (H !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
        return F(ne);
      }
      function F(ne) {
        if (ne === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return ne;
      }
      function L(ne) {
        return L = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(H) {
          return H.__proto__ || Object.getPrototypeOf(H);
        }, L(ne);
      }
      var k = function() {
        return typeof window > "u" ? 0 : window.scrollX || window.pageXOffset;
      }, W = function() {
        return typeof window > "u" ? 0 : window.scrollY || window.pageYOffset;
      };
      const V = function(ne) {
        var H = (function(te) {
          (function(Te, fe) {
            if (typeof fe != "function" && fe !== null) throw new TypeError("Super expression must either be null or a function");
            Te.prototype = Object.create(fe && fe.prototype, { constructor: { value: Te, writable: !0, configurable: !0 } }), Object.defineProperty(Te, "prototype", { writable: !1 }), fe && I(Te, fe);
          })(Q, te);
          var ie, ce, me, pe, z = (me = Q, pe = (function() {
            if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
            if (typeof Proxy == "function") return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], (function() {
              }))), !0;
            } catch {
              return !1;
            }
          })(), function() {
            var Te, fe = L(me);
            if (pe) {
              var oe = L(this).constructor;
              Te = Reflect.construct(fe, arguments, oe);
            } else Te = fe.apply(this, arguments);
            return N(this, Te);
          });
          function Q(Te) {
            var fe;
            if ((function(ae, Se) {
              if (!(ae instanceof Se)) throw new TypeError("Cannot call a class as a function");
            })(this, Q), (fe = z.call(this, Te)).useIntersectionObserver = Te.useIntersectionObserver && d(), fe.useIntersectionObserver) return N(fe);
            var oe = fe.onChangeScroll.bind(F(fe));
            return Te.delayMethod === "debounce" ? fe.delayedScroll = C()(oe, Te.delayTime) : Te.delayMethod === "throttle" && (fe.delayedScroll = _()(oe, Te.delayTime)), fe.state = { scrollPosition: { x: k(), y: W() } }, fe.baseComponentRef = i().createRef(), fe;
          }
          return ie = Q, (ce = [{ key: "componentDidMount", value: function() {
            this.addListeners();
          } }, { key: "componentWillUnmount", value: function() {
            this.removeListeners();
          } }, { key: "componentDidUpdate", value: function() {
            typeof window > "u" || this.useIntersectionObserver || O(this.baseComponentRef.current) !== this.scrollElement && (this.removeListeners(), this.addListeners());
          } }, { key: "addListeners", value: function() {
            typeof window > "u" || this.useIntersectionObserver || (this.scrollElement = O(this.baseComponentRef.current), this.scrollElement.addEventListener("scroll", this.delayedScroll, { passive: !0 }), window.addEventListener("resize", this.delayedScroll, { passive: !0 }), this.scrollElement !== window && window.addEventListener("scroll", this.delayedScroll, { passive: !0 }));
          } }, { key: "removeListeners", value: function() {
            typeof window > "u" || this.useIntersectionObserver || (this.scrollElement.removeEventListener("scroll", this.delayedScroll), window.removeEventListener("resize", this.delayedScroll), this.scrollElement !== window && window.removeEventListener("scroll", this.delayedScroll));
          } }, { key: "onChangeScroll", value: function() {
            this.useIntersectionObserver || this.setState({ scrollPosition: { x: k(), y: W() } });
          } }, { key: "render", value: function() {
            var Te = this.props, fe = (Te.delayMethod, Te.delayTime, (function(ae, Se) {
              if (ae == null) return {};
              var $e, Re, Oe = (function(Ie, we) {
                if (Ie == null) return {};
                var De, Me, Ne = {}, Ae = Object.keys(Ie);
                for (Me = 0; Me < Ae.length; Me++) De = Ae[Me], we.indexOf(De) >= 0 || (Ne[De] = Ie[De]);
                return Ne;
              })(ae, Se);
              if (Object.getOwnPropertySymbols) {
                var ve = Object.getOwnPropertySymbols(ae);
                for (Re = 0; Re < ve.length; Re++) $e = ve[Re], Se.indexOf($e) >= 0 || Object.prototype.propertyIsEnumerable.call(ae, $e) && (Oe[$e] = ae[$e]);
              }
              return Oe;
            })(Te, w)), oe = this.useIntersectionObserver ? null : this.state.scrollPosition;
            return i().createElement(ne, M({ forwardRef: this.baseComponentRef, scrollPosition: oe }, fe));
          } }]) && S(ie.prototype, ce), Object.defineProperty(ie, "prototype", { writable: !1 }), Q;
        })(i().Component);
        return H.propTypes = { delayMethod: l.PropTypes.oneOf(["debounce", "throttle"]), delayTime: l.PropTypes.number, useIntersectionObserver: l.PropTypes.bool }, H.defaultProps = { delayMethod: "throttle", delayTime: 300, useIntersectionObserver: !0 }, H;
      };
      function j(ne) {
        return j = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(H) {
          return typeof H;
        } : function(H) {
          return H && typeof Symbol == "function" && H.constructor === Symbol && H !== Symbol.prototype ? "symbol" : typeof H;
        }, j(ne);
      }
      function A(ne, H) {
        for (var te = 0; te < H.length; te++) {
          var ie = H[te];
          ie.enumerable = ie.enumerable || !1, ie.configurable = !0, "value" in ie && (ie.writable = !0), Object.defineProperty(ne, (ce = (function(me, pe) {
            if (j(me) !== "object" || me === null) return me;
            var z = me[Symbol.toPrimitive];
            if (z !== void 0) {
              var Q = z.call(me, "string");
              if (j(Q) !== "object") return Q;
              throw new TypeError("@@toPrimitive must return a primitive value.");
            }
            return String(me);
          })(ie.key), j(ce) === "symbol" ? ce : String(ce)), ie);
        }
        var ce;
      }
      function U(ne, H) {
        return U = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(te, ie) {
          return te.__proto__ = ie, te;
        }, U(ne, H);
      }
      function G(ne) {
        return G = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(H) {
          return H.__proto__ || Object.getPrototypeOf(H);
        }, G(ne);
      }
      var Y = (function(ne) {
        (function(z, Q) {
          if (typeof Q != "function" && Q !== null) throw new TypeError("Super expression must either be null or a function");
          z.prototype = Object.create(Q && Q.prototype, { constructor: { value: z, writable: !0, configurable: !0 } }), Object.defineProperty(z, "prototype", { writable: !1 }), Q && U(z, Q);
        })(pe, ne);
        var H, te, ie, ce, me = (ie = pe, ce = (function() {
          if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
          if (typeof Proxy == "function") return !0;
          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], (function() {
            }))), !0;
          } catch {
            return !1;
          }
        })(), function() {
          var z, Q = G(ie);
          if (ce) {
            var Te = G(this).constructor;
            z = Reflect.construct(Q, arguments, Te);
          } else z = Q.apply(this, arguments);
          return (function(fe, oe) {
            if (oe && (j(oe) === "object" || typeof oe == "function")) return oe;
            if (oe !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
            return (function(ae) {
              if (ae === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return ae;
            })(fe);
          })(this, z);
        });
        function pe(z) {
          return (function(Q, Te) {
            if (!(Q instanceof Te)) throw new TypeError("Cannot call a class as a function");
          })(this, pe), me.call(this, z);
        }
        return H = pe, (te = [{ key: "render", value: function() {
          return i().createElement($, this.props);
        } }]) && A(H.prototype, te), Object.defineProperty(H, "prototype", { writable: !1 }), pe;
      })(i().Component);
      const ee = V(Y);
      function J(ne) {
        return J = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(H) {
          return typeof H;
        } : function(H) {
          return H && typeof Symbol == "function" && H.constructor === Symbol && H !== Symbol.prototype ? "symbol" : typeof H;
        }, J(ne);
      }
      function Z(ne, H) {
        for (var te = 0; te < H.length; te++) {
          var ie = H[te];
          ie.enumerable = ie.enumerable || !1, ie.configurable = !0, "value" in ie && (ie.writable = !0), Object.defineProperty(ne, (ce = (function(me, pe) {
            if (J(me) !== "object" || me === null) return me;
            var z = me[Symbol.toPrimitive];
            if (z !== void 0) {
              var Q = z.call(me, "string");
              if (J(Q) !== "object") return Q;
              throw new TypeError("@@toPrimitive must return a primitive value.");
            }
            return String(me);
          })(ie.key), J(ce) === "symbol" ? ce : String(ce)), ie);
        }
        var ce;
      }
      function le(ne, H) {
        return le = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(te, ie) {
          return te.__proto__ = ie, te;
        }, le(ne, H);
      }
      function se(ne) {
        if (ne === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return ne;
      }
      function K(ne) {
        return K = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(H) {
          return H.__proto__ || Object.getPrototypeOf(H);
        }, K(ne);
      }
      var q = (function(ne) {
        (function(z, Q) {
          if (typeof Q != "function" && Q !== null) throw new TypeError("Super expression must either be null or a function");
          z.prototype = Object.create(Q && Q.prototype, { constructor: { value: z, writable: !0, configurable: !0 } }), Object.defineProperty(z, "prototype", { writable: !1 }), Q && le(z, Q);
        })(pe, ne);
        var H, te, ie, ce, me = (ie = pe, ce = (function() {
          if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
          if (typeof Proxy == "function") return !0;
          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], (function() {
            }))), !0;
          } catch {
            return !1;
          }
        })(), function() {
          var z, Q = K(ie);
          if (ce) {
            var Te = K(this).constructor;
            z = Reflect.construct(Q, arguments, Te);
          } else z = Q.apply(this, arguments);
          return (function(fe, oe) {
            if (oe && (J(oe) === "object" || typeof oe == "function")) return oe;
            if (oe !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
            return se(fe);
          })(this, z);
        });
        function pe(z) {
          var Q;
          (function(Se, $e) {
            if (!(Se instanceof $e)) throw new TypeError("Cannot call a class as a function");
          })(this, pe), Q = me.call(this, z);
          var Te = z.afterLoad, fe = z.beforeLoad, oe = z.scrollPosition, ae = z.visibleByDefault;
          return Q.state = { visible: ae }, ae && (fe(), Te()), Q.onVisible = Q.onVisible.bind(se(Q)), Q.isScrollTracked = !!(oe && Number.isFinite(oe.x) && oe.x >= 0 && Number.isFinite(oe.y) && oe.y >= 0), Q;
        }
        return H = pe, (te = [{ key: "componentDidUpdate", value: function(z, Q) {
          Q.visible !== this.state.visible && this.props.afterLoad();
        } }, { key: "onVisible", value: function() {
          this.props.beforeLoad(), this.setState({ visible: !0 });
        } }, { key: "render", value: function() {
          if (this.state.visible) return this.props.children;
          var z = this.props, Q = z.className, Te = z.delayMethod, fe = z.delayTime, oe = z.height, ae = z.placeholder, Se = z.scrollPosition, $e = z.style, Re = z.threshold, Oe = z.useIntersectionObserver, ve = z.width;
          return this.isScrollTracked || Oe && d() ? i().createElement($, { className: Q, height: oe, onVisible: this.onVisible, placeholder: ae, scrollPosition: Se, style: $e, threshold: Re, useIntersectionObserver: Oe, width: ve }) : i().createElement(ee, { className: Q, delayMethod: Te, delayTime: fe, height: oe, onVisible: this.onVisible, placeholder: ae, style: $e, threshold: Re, width: ve });
        } }]) && Z(H.prototype, te), Object.defineProperty(H, "prototype", { writable: !1 }), pe;
      })(i().Component);
      q.propTypes = { afterLoad: l.PropTypes.func, beforeLoad: l.PropTypes.func, useIntersectionObserver: l.PropTypes.bool, visibleByDefault: l.PropTypes.bool }, q.defaultProps = { afterLoad: function() {
        return {};
      }, beforeLoad: function() {
        return {};
      }, useIntersectionObserver: !0, visibleByDefault: !1 };
      const B = q;
      function ue(ne) {
        return ue = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(H) {
          return typeof H;
        } : function(H) {
          return H && typeof Symbol == "function" && H.constructor === Symbol && H !== Symbol.prototype ? "symbol" : typeof H;
        }, ue(ne);
      }
      var re = ["afterLoad", "beforeLoad", "delayMethod", "delayTime", "effect", "placeholder", "placeholderSrc", "scrollPosition", "threshold", "useIntersectionObserver", "visibleByDefault", "wrapperClassName", "wrapperProps"];
      function be(ne, H) {
        var te = Object.keys(ne);
        if (Object.getOwnPropertySymbols) {
          var ie = Object.getOwnPropertySymbols(ne);
          H && (ie = ie.filter((function(ce) {
            return Object.getOwnPropertyDescriptor(ne, ce).enumerable;
          }))), te.push.apply(te, ie);
        }
        return te;
      }
      function X(ne) {
        for (var H = 1; H < arguments.length; H++) {
          var te = arguments[H] != null ? arguments[H] : {};
          H % 2 ? be(Object(te), !0).forEach((function(ie) {
            ge(ne, ie, te[ie]);
          })) : Object.getOwnPropertyDescriptors ? Object.defineProperties(ne, Object.getOwnPropertyDescriptors(te)) : be(Object(te)).forEach((function(ie) {
            Object.defineProperty(ne, ie, Object.getOwnPropertyDescriptor(te, ie));
          }));
        }
        return ne;
      }
      function ge(ne, H, te) {
        return (H = he(H)) in ne ? Object.defineProperty(ne, H, { value: te, enumerable: !0, configurable: !0, writable: !0 }) : ne[H] = te, ne;
      }
      function Ee() {
        return Ee = Object.assign ? Object.assign.bind() : function(ne) {
          for (var H = 1; H < arguments.length; H++) {
            var te = arguments[H];
            for (var ie in te) Object.prototype.hasOwnProperty.call(te, ie) && (ne[ie] = te[ie]);
          }
          return ne;
        }, Ee.apply(this, arguments);
      }
      function xe(ne, H) {
        for (var te = 0; te < H.length; te++) {
          var ie = H[te];
          ie.enumerable = ie.enumerable || !1, ie.configurable = !0, "value" in ie && (ie.writable = !0), Object.defineProperty(ne, he(ie.key), ie);
        }
      }
      function he(ne) {
        var H = (function(te, ie) {
          if (ue(te) !== "object" || te === null) return te;
          var ce = te[Symbol.toPrimitive];
          if (ce !== void 0) {
            var me = ce.call(te, "string");
            if (ue(me) !== "object") return me;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }
          return String(te);
        })(ne);
        return ue(H) === "symbol" ? H : String(H);
      }
      function Pe(ne, H) {
        return Pe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(te, ie) {
          return te.__proto__ = ie, te;
        }, Pe(ne, H);
      }
      function ye(ne) {
        return ye = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(H) {
          return H.__proto__ || Object.getPrototypeOf(H);
        }, ye(ne);
      }
      var _e = (function(ne) {
        (function(z, Q) {
          if (typeof Q != "function" && Q !== null) throw new TypeError("Super expression must either be null or a function");
          z.prototype = Object.create(Q && Q.prototype, { constructor: { value: z, writable: !0, configurable: !0 } }), Object.defineProperty(z, "prototype", { writable: !1 }), Q && Pe(z, Q);
        })(pe, ne);
        var H, te, ie, ce, me = (ie = pe, ce = (function() {
          if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
          if (typeof Proxy == "function") return !0;
          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], (function() {
            }))), !0;
          } catch {
            return !1;
          }
        })(), function() {
          var z, Q = ye(ie);
          if (ce) {
            var Te = ye(this).constructor;
            z = Reflect.construct(Q, arguments, Te);
          } else z = Q.apply(this, arguments);
          return (function(fe, oe) {
            if (oe && (ue(oe) === "object" || typeof oe == "function")) return oe;
            if (oe !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
            return (function(ae) {
              if (ae === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return ae;
            })(fe);
          })(this, z);
        });
        function pe(z) {
          var Q;
          return (function(Te, fe) {
            if (!(Te instanceof fe)) throw new TypeError("Cannot call a class as a function");
          })(this, pe), (Q = me.call(this, z)).state = { loaded: !1 }, Q;
        }
        return H = pe, (te = [{ key: "onImageLoad", value: function() {
          var z = this;
          return this.state.loaded ? null : function(Q) {
            z.props.onLoad(Q), z.props.afterLoad(), z.setState({ loaded: !0 });
          };
        } }, { key: "getImg", value: function() {
          var z = this.props, Q = (z.afterLoad, z.beforeLoad, z.delayMethod, z.delayTime, z.effect, z.placeholder, z.placeholderSrc, z.scrollPosition, z.threshold, z.useIntersectionObserver, z.visibleByDefault, z.wrapperClassName, z.wrapperProps, (function(Te, fe) {
            if (Te == null) return {};
            var oe, ae, Se = (function(Re, Oe) {
              if (Re == null) return {};
              var ve, Ie, we = {}, De = Object.keys(Re);
              for (Ie = 0; Ie < De.length; Ie++) ve = De[Ie], Oe.indexOf(ve) >= 0 || (we[ve] = Re[ve]);
              return we;
            })(Te, fe);
            if (Object.getOwnPropertySymbols) {
              var $e = Object.getOwnPropertySymbols(Te);
              for (ae = 0; ae < $e.length; ae++) oe = $e[ae], fe.indexOf(oe) >= 0 || Object.prototype.propertyIsEnumerable.call(Te, oe) && (Se[oe] = Te[oe]);
            }
            return Se;
          })(z, re));
          return i().createElement("img", Ee({}, Q, { onLoad: this.onImageLoad() }));
        } }, { key: "getLazyLoadImage", value: function() {
          var z = this.props, Q = z.beforeLoad, Te = z.className, fe = z.delayMethod, oe = z.delayTime, ae = z.height, Se = z.placeholder, $e = z.scrollPosition, Re = z.style, Oe = z.threshold, ve = z.useIntersectionObserver, Ie = z.visibleByDefault, we = z.width;
          return i().createElement(B, { beforeLoad: Q, className: Te, delayMethod: fe, delayTime: oe, height: ae, placeholder: Se, scrollPosition: $e, style: Re, threshold: Oe, useIntersectionObserver: ve, visibleByDefault: Ie, width: we }, this.getImg());
        } }, { key: "getWrappedLazyLoadImage", value: function(z) {
          var Q = this.props, Te = Q.effect, fe = Q.height, oe = Q.placeholderSrc, ae = Q.width, Se = Q.wrapperClassName, $e = Q.wrapperProps, Re = this.state.loaded, Oe = Re ? " lazy-load-image-loaded" : "", ve = Re || !oe ? {} : { backgroundImage: "url(".concat(oe, ")"), backgroundSize: "100% 100%" };
          return i().createElement("span", Ee({ className: Se + " lazy-load-image-background " + Te + Oe, style: X(X({}, ve), {}, { color: "transparent", display: "inline-block", height: fe, width: ae }) }, $e), z);
        } }, { key: "render", value: function() {
          var z = this.props, Q = z.effect, Te = z.placeholderSrc, fe = z.visibleByDefault, oe = z.wrapperClassName, ae = z.wrapperProps, Se = this.getLazyLoadImage();
          return (Q || Te) && !fe || oe || ae ? this.getWrappedLazyLoadImage(Se) : Se;
        } }]) && xe(H.prototype, te), Object.defineProperty(H, "prototype", { writable: !1 }), pe;
      })(i().Component);
      _e.propTypes = { onLoad: l.PropTypes.func, afterLoad: l.PropTypes.func, beforeLoad: l.PropTypes.func, delayMethod: l.PropTypes.string, delayTime: l.PropTypes.number, effect: l.PropTypes.string, placeholderSrc: l.PropTypes.string, threshold: l.PropTypes.number, useIntersectionObserver: l.PropTypes.bool, visibleByDefault: l.PropTypes.bool, wrapperClassName: l.PropTypes.string, wrapperProps: l.PropTypes.object }, _e.defaultProps = { onLoad: function() {
      }, afterLoad: function() {
        return {};
      }, beforeLoad: function() {
        return {};
      }, delayMethod: "throttle", delayTime: 300, effect: "", placeholderSrc: null, threshold: 100, useIntersectionObserver: !0, visibleByDefault: !1, wrapperClassName: "" };
      const Ce = _e;
    })(), build$4.exports = n;
  })()), build$4.exports;
}
var buildExports$1 = requireBuild$2();
const Placeholder = "data:image/svg+xml,%3csvg%20height='512'%20viewBox='0%200%20512%20512'%20width='512'%20xmlns='http://www.w3.org/2000/svg'%3e%3cradialGradient%20id='a'%20cx='50%25'%20cy='46.801102%25'%20r='95.497112%25'%3e%3cstop%20offset='0'%20stop-color='%23fff'%20stop-opacity='0'/%3e%3cstop%20offset='1'%20stop-color='%23919eab'%20stop-opacity='.48'/%3e%3c/radialGradient%3e%3cpath%20d='m88%2086h512v512h-512z'%20fill='url(%23a)'%20fill-rule='evenodd'%20transform='translate(-88%20-86)'/%3e%3c/svg%3e", Image$1 = ({
  ratio: e,
  disabledEffect: t = !1,
  effect: o = "blur",
  objectFit: n = "cover",
  sx: s,
  ...i
}) => e ? /* @__PURE__ */ jsxRuntimeExports.jsx(
  Box,
  {
    component: "span",
    sx: {
      width: 1,
      lineHeight: 0,
      display: "block",
      overflow: "hidden",
      position: "relative",
      borderRadius: "8px",
      pt: getRatio(e),
      "& .wrapper": {
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        lineHeight: 0,
        position: "absolute",
        backgroundSize: "cover !important"
      },
      ...s
    },
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      Box,
      {
        component: buildExports$1.LazyLoadImage,
        wrapperClassName: "wrapper",
        effect: t ? void 0 : o,
        placeholderSrc: Placeholder,
        sx: { width: 1, height: 1, objectFit: n },
        ...i
      }
    )
  }
) : /* @__PURE__ */ jsxRuntimeExports.jsx(
  Box,
  {
    component: "span",
    sx: {
      lineHeight: 0,
      display: "block",
      overflow: "hidden",
      borderRadius: "8px",
      "& .wrapper": {
        width: 1,
        height: 1,
        backgroundSize: "cover !important"
      },
      ...s
    },
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      Box,
      {
        component: buildExports$1.LazyLoadImage,
        wrapperClassName: "wrapper",
        effect: t ? void 0 : o,
        placeholderSrc: Placeholder,
        sx: { width: 1, height: 1, objectFit: n },
        ...i
      }
    )
  }
);
function getRatio(e = "1/1") {
  return {
    "4/3": "calc(100% / 4 * 3)",
    "3/4": "calc(100% / 3 * 4)",
    "6/4": "calc(100% / 6 * 4)",
    "4/6": "calc(100% / 4 * 6)",
    "16/9": "calc(100% / 16 * 9)",
    "9/16": "calc(100% / 9 * 16)",
    "21/9": "calc(100% / 21 * 9)",
    "9/21": "calc(100% / 9 * 21)",
    "1/1": "100%"
  }[e];
}
const Label = ({
  color: e = "default",
  variant: t = "ghost",
  hasAvatar: o = !1,
  children: n,
  sx: s
}) => {
  const i = useTheme$4();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Wrapper$g,
    {
      palette: i.palette,
      spacing: i.spacing,
      typography: i.typography,
      ownerState: { color: e, variant: t, hasAvatar: o },
      sx: s,
      children: n
    }
  );
}, Wrapper$g = styled$2("span", {
  shouldForwardProp: (e) => e !== "ownerState" && e !== "spacing"
})(({ palette: e, typography: t, spacing: o, ownerState: n }) => {
  const s = e.mode === "light", { color: i, variant: l } = n, d = (g) => ({
    color: e[g].contrastText,
    backgroundColor: e[g].main
  }), u = (g) => ({
    color: e[g].main,
    backgroundColor: "transparent",
    border: `1px solid ${e[g].main}`
  }), c = (g) => ({
    color: e[g][s ? "dark" : "light"],
    backgroundColor: alpha$2(e[g].main, 0.16)
  }), p = {
    height: n.hasAvatar ? 30 : 22,
    minWidth: 22,
    lineHeight: 0,
    borderRadius: 6,
    cursor: "default",
    alignItems: "center",
    whiteSpace: "nowrap",
    display: "inline-flex",
    justifyContent: "center",
    color: e.grey[800],
    padding: o(0, 1),
    fontSize: t.pxToRem(12),
    fontFamily: t.fontFamily,
    backgroundColor: e.grey[300],
    fontWeight: t.fontWeightBold
  }, f = (() => {
    if (i !== "default") {
      if (l === "filled") return d(i);
      if (l === "outlined") return u(i);
      if (l === "ghost") return c(i);
    } else {
      if (l === "outlined")
        return {
          backgroundColor: "transparent",
          color: e.text.primary,
          border: `1px solid ${e.grey[50032]}`
        };
      if (l === "ghost")
        return {
          color: s ? e.text.secondary : e.common.white,
          backgroundColor: e.grey[50016]
        };
    }
    return {};
  })();
  return {
    ...p,
    ...f
  };
}), Loader = ({ size: e = 40 }) => /* @__PURE__ */ jsxRuntimeExports.jsx(Wrapper$f, { "data-testid": "loader", children: /* @__PURE__ */ jsxRuntimeExports.jsx(CircularProgress$1, { size: e }) }), Wrapper$f = styled(Box)({
  display: "grid",
  placeContent: "center"
}), isMobileDevice = () => {
  const e = navigator.userAgent;
  let t = !1;
  if ("maxTouchPoints" in navigator)
    t = navigator.maxTouchPoints > 0;
  else {
    const o = matchMedia?.("(pointer:coarse)");
    o && o.media === "(pointer:coarse)" ? t = !!o.matches : "orientation" in window ? t = !0 : t = /\b(BlackBerry|webOS|iPhone|IEMobile)\b/i.test(e) || /\b(Android|Windows Phone|iPad|iPod)\b/i.test(e);
  }
  return t;
};
function commonjsRequire(e) {
  throw new Error('Could not dynamically require "' + e + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var libphonenumber$1 = { exports: {} }, hasRequiredLibphonenumber;
function requireLibphonenumber() {
  return hasRequiredLibphonenumber || (hasRequiredLibphonenumber = 1, (function(module, exports$1) {
    (function(e) {
      module.exports = e();
    })(function() {
      return (/* @__PURE__ */ (function() {
        function e(t, o, n) {
          function s(d, u) {
            if (!o[d]) {
              if (!t[d]) {
                var c = typeof commonjsRequire == "function" && commonjsRequire;
                if (!u && c) return c(d, !0);
                if (i) return i(d, !0);
                var p = new Error("Cannot find module '" + d + "'");
                throw p.code = "MODULE_NOT_FOUND", p;
              }
              var f = o[d] = { exports: {} };
              t[d][0].call(f.exports, function(g) {
                var y = t[d][1][g];
                return s(y || g);
              }, f, f.exports, e, t, o, n);
            }
            return o[d].exports;
          }
          for (var i = typeof commonjsRequire == "function" && commonjsRequire, l = 0; l < n.length; l++) s(n[l]);
          return s;
        }
        return e;
      })())({ 1: [function(require, module, exports$1) {
        (function(global) {
          (function() {
            var $jscomp = $jscomp || {};
            $jscomp.scope = {}, $jscomp.createTemplateTagFirstArg = function(e) {
              return e.raw = e;
            }, $jscomp.createTemplateTagFirstArgWithRaw = function(e, t) {
              return e.raw = t, e;
            }, $jscomp.arrayIteratorImpl = function(e) {
              var t = 0;
              return function() {
                return t < e.length ? { done: !1, value: e[t++] } : { done: !0 };
              };
            }, $jscomp.arrayIterator = function(e) {
              return { next: $jscomp.arrayIteratorImpl(e) };
            }, $jscomp.makeIterator = function(e) {
              var t = typeof Symbol < "u" && Symbol.iterator && e[Symbol.iterator];
              return t ? t.call(e) : $jscomp.arrayIterator(e);
            }, $jscomp.arrayFromIterator = function(e) {
              for (var t, o = []; !(t = e.next()).done; ) o.push(t.value);
              return o;
            }, $jscomp.arrayFromIterable = function(e) {
              return e instanceof Array ? e : $jscomp.arrayFromIterator($jscomp.makeIterator(e));
            }, $jscomp.checkStringArgs = function(e, t, o) {
              if (e == null) throw new TypeError("The 'this' value for String.prototype." + o + " must not be null or undefined");
              if (t instanceof RegExp) throw new TypeError("First argument to String.prototype." + o + " must not be a regular expression");
              return e + "";
            }, $jscomp.ASSUME_ES5 = !1, $jscomp.ASSUME_NO_NATIVE_MAP = !1, $jscomp.ASSUME_NO_NATIVE_SET = !1, $jscomp.SIMPLE_FROUND_POLYFILL = !1, $jscomp.ISOLATE_POLYFILLS = !1, $jscomp.FORCE_POLYFILL_PROMISE = !1, $jscomp.FORCE_POLYFILL_PROMISE_WHEN_NO_UNHANDLED_REJECTION = !1, $jscomp.defineProperty = $jscomp.ASSUME_ES5 || typeof Object.defineProperties == "function" ? Object.defineProperty : function(e, t, o) {
              return e == Array.prototype || e == Object.prototype || (e[t] = o.value), e;
            }, $jscomp.getGlobal = function(e) {
              e = [typeof globalThis == "object" && globalThis, e, typeof window == "object" && window, typeof self == "object" && self, typeof global == "object" && global];
              for (var t = 0; t < e.length; ++t) {
                var o = e[t];
                if (o && o.Math == Math) return o;
              }
              throw Error("Cannot find global object");
            }, $jscomp.global = $jscomp.getGlobal(this), $jscomp.IS_SYMBOL_NATIVE = typeof Symbol == "function" && typeof Symbol("x") == "symbol", $jscomp.TRUST_ES6_POLYFILLS = !$jscomp.ISOLATE_POLYFILLS || $jscomp.IS_SYMBOL_NATIVE, $jscomp.polyfills = {}, $jscomp.propertyToPolyfillSymbol = {}, $jscomp.POLYFILL_PREFIX = "$jscp$", $jscomp.polyfill = function(e, t, o, n) {
              t && ($jscomp.ISOLATE_POLYFILLS ? $jscomp.polyfillIsolated(e, t, o, n) : $jscomp.polyfillUnisolated(e, t, o, n));
            }, $jscomp.polyfillUnisolated = function(e, t, o, n) {
              for (o = $jscomp.global, e = e.split("."), n = 0; n < e.length - 1; n++) {
                var s = e[n];
                if (!(s in o)) return;
                o = o[s];
              }
              e = e[e.length - 1], n = o[e], t = t(n), t != n && t != null && $jscomp.defineProperty(o, e, { configurable: !0, writable: !0, value: t });
            }, $jscomp.polyfillIsolated = function(e, t, o, n) {
              var s = e.split(".");
              e = s.length === 1, n = s[0], n = !e && n in $jscomp.polyfills ? $jscomp.polyfills : $jscomp.global;
              for (var i = 0; i < s.length - 1; i++) {
                var l = s[i];
                if (!(l in n)) return;
                n = n[l];
              }
              s = s[s.length - 1], o = $jscomp.IS_SYMBOL_NATIVE && o === "es6" ? n[s] : null, t = t(o), t != null && (e ? $jscomp.defineProperty($jscomp.polyfills, s, { configurable: !0, writable: !0, value: t }) : t !== o && ($jscomp.propertyToPolyfillSymbol[s] = $jscomp.IS_SYMBOL_NATIVE ? $jscomp.global.Symbol(s) : $jscomp.POLYFILL_PREFIX + s, s = $jscomp.propertyToPolyfillSymbol[s], $jscomp.defineProperty(n, s, { configurable: !0, writable: !0, value: t })));
            }, $jscomp.polyfill("String.prototype.endsWith", function(e) {
              return e || function(t, o) {
                var n = $jscomp.checkStringArgs(this, t, "endsWith");
                t += "", o === void 0 && (o = n.length), o = Math.max(0, Math.min(o | 0, n.length));
                for (var s = t.length; 0 < s && 0 < o; ) if (n[--o] != t[--s]) return !1;
                return 0 >= s;
              };
            }, "es6", "es3"), $jscomp.findInternal = function(e, t, o) {
              e instanceof String && (e = String(e));
              for (var n = e.length, s = 0; s < n; s++) {
                var i = e[s];
                if (t.call(o, i, s, e)) return { i: s, v: i };
              }
              return { i: -1, v: void 0 };
            }, $jscomp.polyfill("Array.prototype.find", function(e) {
              return e || function(t, o) {
                return $jscomp.findInternal(this, t, o).v;
              };
            }, "es6", "es3"), $jscomp.polyfill("String.prototype.startsWith", function(e) {
              return e || function(t, o) {
                var n = $jscomp.checkStringArgs(this, t, "startsWith");
                t += "";
                var s = n.length, i = t.length;
                o = Math.max(0, Math.min(o | 0, n.length));
                for (var l = 0; l < i && o < s; ) if (n[o++] != t[l++]) return !1;
                return l >= i;
              };
            }, "es6", "es3"), $jscomp.polyfill("String.prototype.repeat", function(e) {
              return e || function(t) {
                var o = $jscomp.checkStringArgs(this, null, "repeat");
                if (0 > t || 1342177279 < t) throw new RangeError("Invalid count value");
                t |= 0;
                for (var n = ""; t; ) t & 1 && (n += o), (t >>>= 1) && (o += o);
                return n;
              };
            }, "es6", "es3"), $jscomp.initSymbol = function() {
            }, $jscomp.polyfill("Symbol", function(e) {
              if (e) return e;
              var t = function(s, i) {
                this.$jscomp$symbol$id_ = s, $jscomp.defineProperty(this, "description", { configurable: !0, writable: !0, value: i });
              };
              t.prototype.toString = function() {
                return this.$jscomp$symbol$id_;
              };
              var o = 0, n = function(s) {
                if (this instanceof n) throw new TypeError("Symbol is not a constructor");
                return new t("jscomp_symbol_" + (s || "") + "_" + o++, s);
              };
              return n;
            }, "es6", "es3"), $jscomp.polyfill(
              "Symbol.iterator",
              function(e) {
                if (e) return e;
                e = Symbol("Symbol.iterator");
                for (var t = "Array Int8Array Uint8Array Uint8ClampedArray Int16Array Uint16Array Int32Array Uint32Array Float32Array Float64Array".split(" "), o = 0; o < t.length; o++) {
                  var n = $jscomp.global[t[o]];
                  typeof n == "function" && typeof n.prototype[e] != "function" && $jscomp.defineProperty(n.prototype, e, { configurable: !0, writable: !0, value: function() {
                    return $jscomp.iteratorPrototype($jscomp.arrayIteratorImpl(this));
                  } });
                }
                return e;
              },
              "es6",
              "es3"
            ), $jscomp.iteratorPrototype = function(e) {
              return e = { next: e }, e[Symbol.iterator] = function() {
                return this;
              }, e;
            }, $jscomp.iteratorFromArray = function(e, t) {
              e instanceof String && (e += "");
              var o = 0, n = !1, s = { next: function() {
                if (!n && o < e.length) {
                  var i = o++;
                  return { value: t(i, e[i]), done: !1 };
                }
                return n = !0, { done: !0, value: void 0 };
              } };
              return s[Symbol.iterator] = function() {
                return s;
              }, s;
            }, $jscomp.polyfill("Array.prototype.keys", function(e) {
              return e || function() {
                return $jscomp.iteratorFromArray(this, function(t) {
                  return t;
                });
              };
            }, "es6", "es3"), $jscomp.polyfill("Object.is", function(e) {
              return e || function(t, o) {
                return t === o ? t !== 0 || 1 / t === 1 / o : t !== t && o !== o;
              };
            }, "es6", "es3"), $jscomp.polyfill("Array.prototype.includes", function(e) {
              return e || function(t, o) {
                var n = this;
                n instanceof String && (n = String(n));
                var s = n.length;
                for (o = o || 0, 0 > o && (o = Math.max(o + s, 0)); o < s; o++) {
                  var i = n[o];
                  if (i === t || Object.is(i, t)) return !0;
                }
                return !1;
              };
            }, "es7", "es3"), $jscomp.polyfill("String.prototype.includes", function(e) {
              return e || function(t, o) {
                return $jscomp.checkStringArgs(this, t, "includes").indexOf(t, o || 0) !== -1;
              };
            }, "es6", "es3");
            var goog = goog || {};
            goog.global = this || self, goog.exportPath_ = function(e, t, o, n) {
              e = e.split("."), n = n || goog.global, e[0] in n || typeof n.execScript > "u" || n.execScript("var " + e[0]);
              for (var s; e.length && (s = e.shift()); ) if (e.length || t === void 0) n = n[s] && n[s] !== Object.prototype[s] ? n[s] : n[s] = {};
              else if (!o && goog.isObject(t) && goog.isObject(n[s])) for (var i in t) t.hasOwnProperty(i) && (n[s][i] = t[i]);
              else n[s] = t;
            }, goog.define = function(e, t) {
              return t;
            }, goog.FEATURESET_YEAR = 2012, goog.DEBUG = !0, goog.LOCALE = "en", goog.TRUSTED_SITE = !0, goog.DISALLOW_TEST_ONLY_CODE = !goog.DEBUG, goog.ENABLE_CHROME_APP_SAFE_SCRIPT_LOADING = !1, goog.provide = function(e) {
              if (goog.isInModuleLoader_()) throw Error("goog.provide cannot be used within a module.");
              goog.constructNamespace_(e);
            }, goog.constructNamespace_ = function(e, t, o) {
              goog.exportPath_(e, t, o);
            }, goog.getScriptNonce = function(e) {
              return e && e != goog.global ? goog.getScriptNonce_(e.document) : (goog.cspNonce_ === null && (goog.cspNonce_ = goog.getScriptNonce_(goog.global.document)), goog.cspNonce_);
            }, goog.NONCE_PATTERN_ = /^[\w+/_-]+[=]{0,2}$/, goog.cspNonce_ = null, goog.getScriptNonce_ = function(e) {
              return (e = e.querySelector && e.querySelector("script[nonce]")) && (e = e.nonce || e.getAttribute("nonce")) && goog.NONCE_PATTERN_.test(e) ? e : "";
            }, goog.VALID_MODULE_RE_ = /^[a-zA-Z_$][a-zA-Z0-9._$]*$/, goog.module = function(e) {
              if (typeof e != "string" || !e || e.search(goog.VALID_MODULE_RE_) == -1) throw Error("Invalid module identifier");
              if (!goog.isInGoogModuleLoader_()) throw Error("Module " + e + " has been loaded incorrectly. Note, modules cannot be loaded as normal scripts. They require some kind of pre-processing step. You're likely trying to load a module via a script tag or as a part of a concatenated bundle without rewriting the module. For more info see: https://github.com/google/closure-library/wiki/goog.module:-an-ES6-module-like-alternative-to-goog.provide.");
              if (goog.moduleLoaderState_.moduleName) throw Error("goog.module may only be called once per module.");
              goog.moduleLoaderState_.moduleName = e;
            }, goog.module.get = function(e) {
              return goog.module.getInternal_(e);
            }, goog.module.getInternal_ = function(e) {
              return null;
            }, goog.ModuleType = { ES6: "es6", GOOG: "goog" }, goog.moduleLoaderState_ = null, goog.isInModuleLoader_ = function() {
              return goog.isInGoogModuleLoader_() || goog.isInEs6ModuleLoader_();
            }, goog.isInGoogModuleLoader_ = function() {
              return !!goog.moduleLoaderState_ && goog.moduleLoaderState_.type == goog.ModuleType.GOOG;
            }, goog.isInEs6ModuleLoader_ = function() {
              if (goog.moduleLoaderState_ && goog.moduleLoaderState_.type == goog.ModuleType.ES6) return !0;
              var e = goog.global.$jscomp;
              return e ? typeof e.getCurrentModulePath != "function" ? !1 : !!e.getCurrentModulePath() : !1;
            }, goog.module.declareLegacyNamespace = function() {
              goog.moduleLoaderState_.declareLegacyNamespace = !0;
            }, goog.declareModuleId = function(e) {
              if (goog.moduleLoaderState_) goog.moduleLoaderState_.moduleName = e;
              else {
                var t = goog.global.$jscomp;
                if (!t || typeof t.getCurrentModulePath != "function") throw Error('Module with namespace "' + e + '" has been loaded incorrectly.');
                t = t.require(t.getCurrentModulePath()), goog.loadedModules_[e] = { exports: t, type: goog.ModuleType.ES6, moduleId: e };
              }
            }, goog.setTestOnly = function(e) {
              if (goog.DISALLOW_TEST_ONLY_CODE) throw e = e || "", Error("Importing test-only code into non-debug environment" + (e ? ": " + e : "."));
            }, goog.forwardDeclare = function(e) {
            }, goog.getObjectByName = function(e, t) {
              e = e.split("."), t = t || goog.global;
              for (var o = 0; o < e.length; o++) if (t = t[e[o]], t == null) return null;
              return t;
            }, goog.addDependency = function(e, t, o, n) {
            }, goog.ENABLE_DEBUG_LOADER = !0, goog.logToConsole_ = function(e) {
              goog.global.console && goog.global.console.error(e);
            }, goog.require = function(e) {
            }, goog.requireType = function(e) {
              return {};
            }, goog.basePath = "", goog.nullFunction = function() {
            }, goog.abstractMethod = function() {
              throw Error("unimplemented abstract method");
            }, goog.addSingletonGetter = function(e) {
              e.instance_ = void 0, e.getInstance = function() {
                return e.instance_ ? e.instance_ : (goog.DEBUG && (goog.instantiatedSingletons_[goog.instantiatedSingletons_.length] = e), e.instance_ = new e());
              };
            }, goog.instantiatedSingletons_ = [], goog.LOAD_MODULE_USING_EVAL = !0, goog.SEAL_MODULE_EXPORTS = goog.DEBUG, goog.loadedModules_ = {}, goog.DEPENDENCIES_ENABLED = !1, goog.TRANSPILE = "detect", goog.ASSUME_ES_MODULES_TRANSPILED = !1, goog.TRANSPILE_TO_LANGUAGE = "", goog.TRANSPILER = "transpile.js", goog.hasBadLetScoping = null, goog.useSafari10Workaround = function() {
              if (goog.hasBadLetScoping == null) {
                try {
                  var a = !eval('"use strict";let x = 1; function f() { return typeof x; };f() == "number";');
                } catch (e) {
                  a = !1;
                }
                goog.hasBadLetScoping = a;
              }
              return goog.hasBadLetScoping;
            }, goog.workaroundSafari10EvalBug = function(e) {
              return "(function(){" + e + `
;})();
`;
            }, goog.loadModule = function(e) {
              var t = goog.moduleLoaderState_;
              try {
                goog.moduleLoaderState_ = { moduleName: "", declareLegacyNamespace: !1, type: goog.ModuleType.GOOG };
                var o = {}, n = o;
                if (typeof e == "function") n = e.call(void 0, n);
                else if (typeof e == "string") goog.useSafari10Workaround() && (e = goog.workaroundSafari10EvalBug(e)), n = goog.loadModuleFromSource_.call(void 0, n, e);
                else throw Error("Invalid module definition");
                var s = goog.moduleLoaderState_.moduleName;
                if (typeof s == "string" && s) goog.moduleLoaderState_.declareLegacyNamespace ? goog.constructNamespace_(s, n, o !== n) : goog.SEAL_MODULE_EXPORTS && Object.seal && typeof n == "object" && n != null && Object.seal(n), goog.loadedModules_[s] = { exports: n, type: goog.ModuleType.GOOG, moduleId: goog.moduleLoaderState_.moduleName };
                else throw Error('Invalid module name "' + s + '"');
              } finally {
                goog.moduleLoaderState_ = t;
              }
            }, goog.loadModuleFromSource_ = function(a, b) {
              return eval(b), a;
            }, goog.normalizePath_ = function(e) {
              e = e.split("/");
              for (var t = 0; t < e.length; ) e[t] == "." ? e.splice(t, 1) : t && e[t] == ".." && e[t - 1] && e[t - 1] != ".." ? e.splice(--t, 2) : t++;
              return e.join("/");
            }, goog.loadFileSync_ = function(e) {
              if (goog.global.CLOSURE_LOAD_FILE_SYNC) return goog.global.CLOSURE_LOAD_FILE_SYNC(e);
              try {
                var t = new goog.global.XMLHttpRequest();
                return t.open("get", e, !1), t.send(), t.status == 0 || t.status == 200 ? t.responseText : null;
              } catch {
                return null;
              }
            }, goog.transpile_ = function(e, t, o) {
              var n = goog.global.$jscomp;
              n || (goog.global.$jscomp = n = {});
              var s = n.transpile;
              if (!s) {
                var i = goog.basePath + goog.TRANSPILER, l = goog.loadFileSync_(i);
                if (l) {
                  if ((function() {
                    (0, eval)(l + `
//# sourceURL=` + i);
                  }).call(goog.global), goog.global.$gwtExport && goog.global.$gwtExport.$jscomp && !goog.global.$gwtExport.$jscomp.transpile) throw Error('The transpiler did not properly export the "transpile" method. $gwtExport: ' + JSON.stringify(goog.global.$gwtExport));
                  goog.global.$jscomp.transpile = goog.global.$gwtExport.$jscomp.transpile, n = goog.global.$jscomp, s = n.transpile;
                }
              }
              return s || (s = n.transpile = function(d, u) {
                return goog.logToConsole_(u + " requires transpilation but no transpiler was found."), d;
              }), s(e, t, o);
            }, goog.typeOf = function(e) {
              var t = typeof e;
              return t != "object" ? t : e ? Array.isArray(e) ? "array" : t : "null";
            }, goog.isArrayLike = function(e) {
              var t = goog.typeOf(e);
              return t == "array" || t == "object" && typeof e.length == "number";
            }, goog.isDateLike = function(e) {
              return goog.isObject(e) && typeof e.getFullYear == "function";
            }, goog.isObject = function(e) {
              var t = typeof e;
              return t == "object" && e != null || t == "function";
            }, goog.getUid = function(e) {
              return Object.prototype.hasOwnProperty.call(e, goog.UID_PROPERTY_) && e[goog.UID_PROPERTY_] || (e[goog.UID_PROPERTY_] = ++goog.uidCounter_);
            }, goog.hasUid = function(e) {
              return !!e[goog.UID_PROPERTY_];
            }, goog.removeUid = function(e) {
              e !== null && "removeAttribute" in e && e.removeAttribute(goog.UID_PROPERTY_);
              try {
                delete e[goog.UID_PROPERTY_];
              } catch {
              }
            }, goog.UID_PROPERTY_ = "closure_uid_" + (1e9 * Math.random() >>> 0), goog.uidCounter_ = 0, goog.cloneObject = function(e) {
              var t = goog.typeOf(e);
              if (t == "object" || t == "array") {
                if (typeof e.clone == "function") return e.clone();
                t = t == "array" ? [] : {};
                for (var o in e) t[o] = goog.cloneObject(e[o]);
                return t;
              }
              return e;
            }, goog.bindNative_ = function(e, t, o) {
              return e.call.apply(e.bind, arguments);
            }, goog.bindJs_ = function(e, t, o) {
              if (!e) throw Error();
              if (2 < arguments.length) {
                var n = Array.prototype.slice.call(arguments, 2);
                return function() {
                  var s = Array.prototype.slice.call(arguments);
                  return Array.prototype.unshift.apply(s, n), e.apply(t, s);
                };
              }
              return function() {
                return e.apply(t, arguments);
              };
            }, goog.bind = function(e, t, o) {
              return Function.prototype.bind && Function.prototype.bind.toString().indexOf("native code") != -1 ? goog.bind = goog.bindNative_ : goog.bind = goog.bindJs_, goog.bind.apply(null, arguments);
            }, goog.partial = function(e, t) {
              var o = Array.prototype.slice.call(arguments, 1);
              return function() {
                var n = o.slice();
                return n.push.apply(n, arguments), e.apply(this, n);
              };
            }, goog.mixin = function(e, t) {
              for (var o in t) e[o] = t[o];
            }, goog.now = function() {
              return Date.now();
            }, goog.globalEval = function(e) {
              (0, eval)(e);
            }, goog.getCssName = function(e, t) {
              if (String(e).charAt(0) == ".") throw Error('className passed in goog.getCssName must not start with ".". You passed: ' + e);
              var o = function(s) {
                return goog.cssNameMapping_[s] || s;
              }, n = function(s) {
                s = s.split("-");
                for (var i = [], l = 0; l < s.length; l++) i.push(o(s[l]));
                return i.join("-");
              };
              return n = goog.cssNameMapping_ ? goog.cssNameMappingStyle_ == "BY_WHOLE" ? o : n : function(s) {
                return s;
              }, e = t ? e + "-" + n(t) : n(e), goog.global.CLOSURE_CSS_NAME_MAP_FN ? goog.global.CLOSURE_CSS_NAME_MAP_FN(e) : e;
            }, goog.setCssNameMapping = function(e, t) {
              goog.cssNameMapping_ = e, goog.cssNameMappingStyle_ = t;
            }, goog.getMsg = function(e, t, o) {
              return o && o.html && (e = e.replace(/</g, "&lt;")), o && o.unescapeHtmlEntities && (e = e.replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&apos;/g, "'").replace(/&quot;/g, '"').replace(/&amp;/g, "&")), t && (e = e.replace(/\{\$([^}]+)}/g, function(n, s) {
                return t != null && s in t ? t[s] : n;
              })), e;
            }, goog.getMsgWithFallback = function(e, t) {
              return e;
            }, goog.exportSymbol = function(e, t, o) {
              goog.exportPath_(e, t, !0, o);
            }, goog.exportProperty = function(e, t, o) {
              e[t] = o;
            }, goog.inherits = function(e, t) {
              function o() {
              }
              o.prototype = t.prototype, e.superClass_ = t.prototype, e.prototype = new o(), e.prototype.constructor = e, e.base = function(n, s, i) {
                for (var l = Array(arguments.length - 2), d = 2; d < arguments.length; d++) l[d - 2] = arguments[d];
                return t.prototype[s].apply(n, l);
              };
            }, goog.scope = function(e) {
              if (goog.isInModuleLoader_()) throw Error("goog.scope is not supported within a module.");
              e.call(goog.global);
            }, goog.defineClass = function(e, t) {
              var o = t.constructor, n = t.statics;
              return o && o != Object.prototype.constructor || (o = function() {
                throw Error("cannot instantiate an interface (no constructor defined).");
              }), o = goog.defineClass.createSealingConstructor_(o, e), e && goog.inherits(o, e), delete t.constructor, delete t.statics, goog.defineClass.applyProperties_(o.prototype, t), n != null && (n instanceof Function ? n(o) : goog.defineClass.applyProperties_(o, n)), o;
            }, goog.defineClass.SEAL_CLASS_INSTANCES = goog.DEBUG, goog.defineClass.createSealingConstructor_ = function(e, t) {
              return goog.defineClass.SEAL_CLASS_INSTANCES ? function() {
                var o = e.apply(this, arguments) || this;
                return o[goog.UID_PROPERTY_] = o[goog.UID_PROPERTY_], o;
              } : e;
            }, goog.defineClass.OBJECT_PROTOTYPE_FIELDS_ = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" "), goog.defineClass.applyProperties_ = function(e, t) {
              for (var o in t) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
              for (var n = 0; n < goog.defineClass.OBJECT_PROTOTYPE_FIELDS_.length; n++) o = goog.defineClass.OBJECT_PROTOTYPE_FIELDS_[n], Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
            }, goog.TRUSTED_TYPES_POLICY_NAME = "goog", goog.identity_ = function(e) {
              return e;
            }, goog.createTrustedTypesPolicy = function(e) {
              var t = null, o = goog.global.trustedTypes;
              if (!o || !o.createPolicy) return t;
              try {
                t = o.createPolicy(e, { createHTML: goog.identity_, createScript: goog.identity_, createScriptURL: goog.identity_ });
              } catch (n) {
                goog.logToConsole_(n.message);
              }
              return t;
            }, goog.debug = {};
            function module$contents$goog$debug$Error_DebugError(e) {
              if (Error.captureStackTrace) Error.captureStackTrace(this, module$contents$goog$debug$Error_DebugError);
              else {
                var t = Error().stack;
                t && (this.stack = t);
              }
              e && (this.message = String(e)), this.reportErrorToServer = !0;
            }
            goog.inherits(module$contents$goog$debug$Error_DebugError, Error), module$contents$goog$debug$Error_DebugError.prototype.name = "CustomError", goog.debug.Error = module$contents$goog$debug$Error_DebugError, goog.dom = {}, goog.dom.NodeType = { ELEMENT: 1, ATTRIBUTE: 2, TEXT: 3, CDATA_SECTION: 4, ENTITY_REFERENCE: 5, ENTITY: 6, PROCESSING_INSTRUCTION: 7, COMMENT: 8, DOCUMENT: 9, DOCUMENT_TYPE: 10, DOCUMENT_FRAGMENT: 11, NOTATION: 12 }, goog.asserts = {}, goog.asserts.ENABLE_ASSERTS = goog.DEBUG, goog.asserts.AssertionError = function(e, t) {
              module$contents$goog$debug$Error_DebugError.call(this, goog.asserts.subs_(e, t)), this.messagePattern = e;
            }, goog.inherits(goog.asserts.AssertionError, module$contents$goog$debug$Error_DebugError), goog.asserts.AssertionError.prototype.name = "AssertionError", goog.asserts.DEFAULT_ERROR_HANDLER = function(e) {
              throw e;
            }, goog.asserts.errorHandler_ = goog.asserts.DEFAULT_ERROR_HANDLER, goog.asserts.subs_ = function(e, t) {
              e = e.split("%s");
              for (var o = "", n = e.length - 1, s = 0; s < n; s++) o += e[s] + (s < t.length ? t[s] : "%s");
              return o + e[n];
            }, goog.asserts.doAssertFailure_ = function(e, t, o, n) {
              var s = "Assertion failed";
              if (o) {
                s += ": " + o;
                var i = n;
              } else e && (s += ": " + e, i = t);
              e = new goog.asserts.AssertionError("" + s, i || []), goog.asserts.errorHandler_(e);
            }, goog.asserts.setErrorHandler = function(e) {
              goog.asserts.ENABLE_ASSERTS && (goog.asserts.errorHandler_ = e);
            }, goog.asserts.assert = function(e, t, o) {
              return goog.asserts.ENABLE_ASSERTS && !e && goog.asserts.doAssertFailure_("", null, t, Array.prototype.slice.call(arguments, 2)), e;
            }, goog.asserts.assertExists = function(e, t, o) {
              return goog.asserts.ENABLE_ASSERTS && e == null && goog.asserts.doAssertFailure_("Expected to exist: %s.", [e], t, Array.prototype.slice.call(arguments, 2)), e;
            }, goog.asserts.fail = function(e, t) {
              goog.asserts.ENABLE_ASSERTS && goog.asserts.errorHandler_(new goog.asserts.AssertionError("Failure" + (e ? ": " + e : ""), Array.prototype.slice.call(arguments, 1)));
            }, goog.asserts.assertNumber = function(e, t, o) {
              return goog.asserts.ENABLE_ASSERTS && typeof e != "number" && goog.asserts.doAssertFailure_("Expected number but got %s: %s.", [goog.typeOf(e), e], t, Array.prototype.slice.call(arguments, 2)), e;
            }, goog.asserts.assertString = function(e, t, o) {
              return goog.asserts.ENABLE_ASSERTS && typeof e != "string" && goog.asserts.doAssertFailure_("Expected string but got %s: %s.", [goog.typeOf(e), e], t, Array.prototype.slice.call(arguments, 2)), e;
            }, goog.asserts.assertFunction = function(e, t, o) {
              return goog.asserts.ENABLE_ASSERTS && typeof e != "function" && goog.asserts.doAssertFailure_("Expected function but got %s: %s.", [goog.typeOf(e), e], t, Array.prototype.slice.call(arguments, 2)), e;
            }, goog.asserts.assertObject = function(e, t, o) {
              return goog.asserts.ENABLE_ASSERTS && !goog.isObject(e) && goog.asserts.doAssertFailure_("Expected object but got %s: %s.", [goog.typeOf(e), e], t, Array.prototype.slice.call(arguments, 2)), e;
            }, goog.asserts.assertArray = function(e, t, o) {
              return goog.asserts.ENABLE_ASSERTS && !Array.isArray(e) && goog.asserts.doAssertFailure_("Expected array but got %s: %s.", [goog.typeOf(e), e], t, Array.prototype.slice.call(arguments, 2)), e;
            }, goog.asserts.assertBoolean = function(e, t, o) {
              return goog.asserts.ENABLE_ASSERTS && typeof e != "boolean" && goog.asserts.doAssertFailure_("Expected boolean but got %s: %s.", [goog.typeOf(e), e], t, Array.prototype.slice.call(arguments, 2)), e;
            }, goog.asserts.assertElement = function(e, t, o) {
              return !goog.asserts.ENABLE_ASSERTS || goog.isObject(e) && e.nodeType == goog.dom.NodeType.ELEMENT || goog.asserts.doAssertFailure_("Expected Element but got %s: %s.", [goog.typeOf(e), e], t, Array.prototype.slice.call(arguments, 2)), e;
            }, goog.asserts.assertInstanceof = function(e, t, o, n) {
              return !goog.asserts.ENABLE_ASSERTS || e instanceof t || goog.asserts.doAssertFailure_("Expected instanceof %s but got %s.", [goog.asserts.getType_(t), goog.asserts.getType_(e)], o, Array.prototype.slice.call(arguments, 3)), e;
            }, goog.asserts.assertFinite = function(e, t, o) {
              return !goog.asserts.ENABLE_ASSERTS || typeof e == "number" && isFinite(e) || goog.asserts.doAssertFailure_("Expected %s to be a finite number but it is not.", [e], t, Array.prototype.slice.call(arguments, 2)), e;
            }, goog.asserts.assertObjectPrototypeIsIntact = function() {
              for (var e in Object.prototype) goog.asserts.fail(e + " should not be enumerable in Object.prototype.");
            }, goog.asserts.getType_ = function(e) {
              return e instanceof Function ? e.displayName || e.name || "unknown type name" : e instanceof Object ? e.constructor.displayName || e.constructor.name || Object.prototype.toString.call(e) : e === null ? "null" : typeof e;
            }, goog.array = {}, goog.NATIVE_ARRAY_PROTOTYPES = goog.TRUSTED_SITE;
            var module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS = 2012 < goog.FEATURESET_YEAR;
            goog.array.ASSUME_NATIVE_FUNCTIONS = module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS;
            function module$contents$goog$array_peek(e) {
              return e[e.length - 1];
            }
            goog.array.peek = module$contents$goog$array_peek, goog.array.last = module$contents$goog$array_peek;
            var module$contents$goog$array_indexOf = goog.NATIVE_ARRAY_PROTOTYPES && (module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS || Array.prototype.indexOf) ? function(e, t, o) {
              return goog.asserts.assert(e.length != null), Array.prototype.indexOf.call(e, t, o);
            } : function(e, t, o) {
              if (o = o == null ? 0 : 0 > o ? Math.max(0, e.length + o) : o, typeof e == "string") return typeof t != "string" || t.length != 1 ? -1 : e.indexOf(t, o);
              for (; o < e.length; o++) if (o in e && e[o] === t) return o;
              return -1;
            };
            goog.array.indexOf = module$contents$goog$array_indexOf;
            var module$contents$goog$array_lastIndexOf = goog.NATIVE_ARRAY_PROTOTYPES && (module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS || Array.prototype.lastIndexOf) ? function(e, t, o) {
              return goog.asserts.assert(e.length != null), Array.prototype.lastIndexOf.call(e, t, o ?? e.length - 1);
            } : function(e, t, o) {
              if (o = o ?? e.length - 1, 0 > o && (o = Math.max(0, e.length + o)), typeof e == "string") return typeof t != "string" || t.length != 1 ? -1 : e.lastIndexOf(t, o);
              for (; 0 <= o; o--) if (o in e && e[o] === t) return o;
              return -1;
            };
            goog.array.lastIndexOf = module$contents$goog$array_lastIndexOf;
            var module$contents$goog$array_forEach = goog.NATIVE_ARRAY_PROTOTYPES && (module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS || Array.prototype.forEach) ? function(e, t, o) {
              goog.asserts.assert(e.length != null), Array.prototype.forEach.call(e, t, o);
            } : function(e, t, o) {
              for (var n = e.length, s = typeof e == "string" ? e.split("") : e, i = 0; i < n; i++) i in s && t.call(o, s[i], i, e);
            };
            goog.array.forEach = module$contents$goog$array_forEach;
            function module$contents$goog$array_forEachRight(e, t, o) {
              var n = e.length, s = typeof e == "string" ? e.split("") : e;
              for (--n; 0 <= n; --n) n in s && t.call(o, s[n], n, e);
            }
            goog.array.forEachRight = module$contents$goog$array_forEachRight;
            var module$contents$goog$array_filter = goog.NATIVE_ARRAY_PROTOTYPES && (module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS || Array.prototype.filter) ? function(e, t, o) {
              return goog.asserts.assert(e.length != null), Array.prototype.filter.call(e, t, o);
            } : function(e, t, o) {
              for (var n = e.length, s = [], i = 0, l = typeof e == "string" ? e.split("") : e, d = 0; d < n; d++) if (d in l) {
                var u = l[d];
                t.call(o, u, d, e) && (s[i++] = u);
              }
              return s;
            };
            goog.array.filter = module$contents$goog$array_filter;
            var module$contents$goog$array_map = goog.NATIVE_ARRAY_PROTOTYPES && (module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS || Array.prototype.map) ? function(e, t, o) {
              return goog.asserts.assert(e.length != null), Array.prototype.map.call(e, t, o);
            } : function(e, t, o) {
              for (var n = e.length, s = Array(n), i = typeof e == "string" ? e.split("") : e, l = 0; l < n; l++) l in i && (s[l] = t.call(o, i[l], l, e));
              return s;
            };
            goog.array.map = module$contents$goog$array_map;
            var module$contents$goog$array_reduce = goog.NATIVE_ARRAY_PROTOTYPES && (module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS || Array.prototype.reduce) ? function(e, t, o, n) {
              return goog.asserts.assert(e.length != null), n && (t = goog.bind(t, n)), Array.prototype.reduce.call(e, t, o);
            } : function(e, t, o, n) {
              var s = o;
              return module$contents$goog$array_forEach(e, function(i, l) {
                s = t.call(n, s, i, l, e);
              }), s;
            };
            goog.array.reduce = module$contents$goog$array_reduce;
            var module$contents$goog$array_reduceRight = goog.NATIVE_ARRAY_PROTOTYPES && (module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS || Array.prototype.reduceRight) ? function(e, t, o, n) {
              return goog.asserts.assert(e.length != null), goog.asserts.assert(t != null), n && (t = goog.bind(t, n)), Array.prototype.reduceRight.call(e, t, o);
            } : function(e, t, o, n) {
              var s = o;
              return module$contents$goog$array_forEachRight(e, function(i, l) {
                s = t.call(n, s, i, l, e);
              }), s;
            };
            goog.array.reduceRight = module$contents$goog$array_reduceRight;
            var module$contents$goog$array_some = goog.NATIVE_ARRAY_PROTOTYPES && (module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS || Array.prototype.some) ? function(e, t, o) {
              return goog.asserts.assert(e.length != null), Array.prototype.some.call(e, t, o);
            } : function(e, t, o) {
              for (var n = e.length, s = typeof e == "string" ? e.split("") : e, i = 0; i < n; i++) if (i in s && t.call(o, s[i], i, e)) return !0;
              return !1;
            };
            goog.array.some = module$contents$goog$array_some;
            var module$contents$goog$array_every = goog.NATIVE_ARRAY_PROTOTYPES && (module$contents$goog$array_ASSUME_NATIVE_FUNCTIONS || Array.prototype.every) ? function(e, t, o) {
              return goog.asserts.assert(e.length != null), Array.prototype.every.call(e, t, o);
            } : function(e, t, o) {
              for (var n = e.length, s = typeof e == "string" ? e.split("") : e, i = 0; i < n; i++) if (i in s && !t.call(o, s[i], i, e)) return !1;
              return !0;
            };
            goog.array.every = module$contents$goog$array_every;
            function module$contents$goog$array_count(e, t, o) {
              var n = 0;
              return module$contents$goog$array_forEach(e, function(s, i, l) {
                t.call(o, s, i, l) && ++n;
              }, o), n;
            }
            goog.array.count = module$contents$goog$array_count;
            function module$contents$goog$array_find(e, t, o) {
              return t = module$contents$goog$array_findIndex(e, t, o), 0 > t ? null : typeof e == "string" ? e.charAt(t) : e[t];
            }
            goog.array.find = module$contents$goog$array_find;
            function module$contents$goog$array_findIndex(e, t, o) {
              for (var n = e.length, s = typeof e == "string" ? e.split("") : e, i = 0; i < n; i++) if (i in s && t.call(o, s[i], i, e)) return i;
              return -1;
            }
            goog.array.findIndex = module$contents$goog$array_findIndex;
            function module$contents$goog$array_findRight(e, t, o) {
              return t = module$contents$goog$array_findIndexRight(e, t, o), 0 > t ? null : typeof e == "string" ? e.charAt(t) : e[t];
            }
            goog.array.findRight = module$contents$goog$array_findRight;
            function module$contents$goog$array_findIndexRight(e, t, o) {
              var n = e.length, s = typeof e == "string" ? e.split("") : e;
              for (--n; 0 <= n; n--) if (n in s && t.call(o, s[n], n, e)) return n;
              return -1;
            }
            goog.array.findIndexRight = module$contents$goog$array_findIndexRight;
            function module$contents$goog$array_contains(e, t) {
              return 0 <= module$contents$goog$array_indexOf(e, t);
            }
            goog.array.contains = module$contents$goog$array_contains;
            function module$contents$goog$array_isEmpty(e) {
              return e.length == 0;
            }
            goog.array.isEmpty = module$contents$goog$array_isEmpty;
            function module$contents$goog$array_clear(e) {
              if (!Array.isArray(e)) for (var t = e.length - 1; 0 <= t; t--) delete e[t];
              e.length = 0;
            }
            goog.array.clear = module$contents$goog$array_clear;
            function module$contents$goog$array_insert(e, t) {
              module$contents$goog$array_contains(e, t) || e.push(t);
            }
            goog.array.insert = module$contents$goog$array_insert;
            function module$contents$goog$array_insertAt(e, t, o) {
              module$contents$goog$array_splice(e, o, 0, t);
            }
            goog.array.insertAt = module$contents$goog$array_insertAt;
            function module$contents$goog$array_insertArrayAt(e, t, o) {
              goog.partial(module$contents$goog$array_splice, e, o, 0).apply(null, t);
            }
            goog.array.insertArrayAt = module$contents$goog$array_insertArrayAt;
            function module$contents$goog$array_insertBefore(e, t, o) {
              var n;
              arguments.length == 2 || 0 > (n = module$contents$goog$array_indexOf(e, o)) ? e.push(t) : module$contents$goog$array_insertAt(e, t, n);
            }
            goog.array.insertBefore = module$contents$goog$array_insertBefore;
            function module$contents$goog$array_remove(e, t) {
              t = module$contents$goog$array_indexOf(e, t);
              var o;
              return (o = 0 <= t) && module$contents$goog$array_removeAt(e, t), o;
            }
            goog.array.remove = module$contents$goog$array_remove;
            function module$contents$goog$array_removeLast(e, t) {
              return t = module$contents$goog$array_lastIndexOf(e, t), 0 <= t ? (module$contents$goog$array_removeAt(e, t), !0) : !1;
            }
            goog.array.removeLast = module$contents$goog$array_removeLast;
            function module$contents$goog$array_removeAt(e, t) {
              return goog.asserts.assert(e.length != null), Array.prototype.splice.call(e, t, 1).length == 1;
            }
            goog.array.removeAt = module$contents$goog$array_removeAt;
            function module$contents$goog$array_removeIf(e, t, o) {
              return t = module$contents$goog$array_findIndex(e, t, o), 0 <= t ? (module$contents$goog$array_removeAt(e, t), !0) : !1;
            }
            goog.array.removeIf = module$contents$goog$array_removeIf;
            function module$contents$goog$array_removeAllIf(e, t, o) {
              var n = 0;
              return module$contents$goog$array_forEachRight(e, function(s, i) {
                t.call(o, s, i, e) && module$contents$goog$array_removeAt(e, i) && n++;
              }), n;
            }
            goog.array.removeAllIf = module$contents$goog$array_removeAllIf;
            function module$contents$goog$array_concat(e) {
              return Array.prototype.concat.apply([], arguments);
            }
            goog.array.concat = module$contents$goog$array_concat;
            function module$contents$goog$array_join(e) {
              return Array.prototype.concat.apply([], arguments);
            }
            goog.array.join = module$contents$goog$array_join;
            function module$contents$goog$array_toArray(e) {
              var t = e.length;
              if (0 < t) {
                for (var o = Array(t), n = 0; n < t; n++) o[n] = e[n];
                return o;
              }
              return [];
            }
            var module$contents$goog$array_clone = goog.array.toArray = module$contents$goog$array_toArray;
            goog.array.clone = module$contents$goog$array_clone;
            function module$contents$goog$array_extend(e, t) {
              for (var o = 1; o < arguments.length; o++) {
                var n = arguments[o];
                if (goog.isArrayLike(n)) {
                  var s = e.length || 0, i = n.length || 0;
                  e.length = s + i;
                  for (var l = 0; l < i; l++) e[s + l] = n[l];
                } else e.push(n);
              }
            }
            goog.array.extend = module$contents$goog$array_extend;
            function module$contents$goog$array_splice(e, t, o, n) {
              return goog.asserts.assert(e.length != null), Array.prototype.splice.apply(e, module$contents$goog$array_slice(arguments, 1));
            }
            goog.array.splice = module$contents$goog$array_splice;
            function module$contents$goog$array_slice(e, t, o) {
              return goog.asserts.assert(e.length != null), 2 >= arguments.length ? Array.prototype.slice.call(e, t) : Array.prototype.slice.call(e, t, o);
            }
            goog.array.slice = module$contents$goog$array_slice;
            function module$contents$goog$array_removeDuplicates(e, t, o) {
              t = t || e;
              var n = function(u) {
                return goog.isObject(u) ? "o" + goog.getUid(u) : (typeof u).charAt(0) + u;
              };
              o = o || n, n = {};
              for (var s = 0, i = 0; i < e.length; ) {
                var l = e[i++], d = o(l);
                Object.prototype.hasOwnProperty.call(n, d) || (n[d] = !0, t[s++] = l);
              }
              t.length = s;
            }
            goog.array.removeDuplicates = module$contents$goog$array_removeDuplicates;
            function module$contents$goog$array_binarySearch(e, t, o) {
              return module$contents$goog$array_binarySearch_(e, o || module$contents$goog$array_defaultCompare, !1, t);
            }
            goog.array.binarySearch = module$contents$goog$array_binarySearch;
            function module$contents$goog$array_binarySelect(e, t, o) {
              return module$contents$goog$array_binarySearch_(e, t, !0, void 0, o);
            }
            goog.array.binarySelect = module$contents$goog$array_binarySelect;
            function module$contents$goog$array_binarySearch_(e, t, o, n, s) {
              for (var i = 0, l = e.length, d; i < l; ) {
                var u = i + (l - i >>> 1), c = o ? t.call(s, e[u], u, e) : t(n, e[u]);
                0 < c ? i = u + 1 : (l = u, d = !c);
              }
              return d ? i : -i - 1;
            }
            function module$contents$goog$array_sort(e, t) {
              e.sort(t || module$contents$goog$array_defaultCompare);
            }
            goog.array.sort = module$contents$goog$array_sort;
            function module$contents$goog$array_stableSort(e, t) {
              for (var o = Array(e.length), n = 0; n < e.length; n++) o[n] = { index: n, value: e[n] };
              var s = t || module$contents$goog$array_defaultCompare;
              for (module$contents$goog$array_sort(o, function(i, l) {
                return s(i.value, l.value) || i.index - l.index;
              }), n = 0; n < e.length; n++) e[n] = o[n].value;
            }
            goog.array.stableSort = module$contents$goog$array_stableSort;
            function module$contents$goog$array_sortByKey(e, t, o) {
              var n = o || module$contents$goog$array_defaultCompare;
              module$contents$goog$array_sort(e, function(s, i) {
                return n(t(s), t(i));
              });
            }
            goog.array.sortByKey = module$contents$goog$array_sortByKey;
            function module$contents$goog$array_sortObjectsByKey(e, t, o) {
              module$contents$goog$array_sortByKey(e, function(n) {
                return n[t];
              }, o);
            }
            goog.array.sortObjectsByKey = module$contents$goog$array_sortObjectsByKey;
            function module$contents$goog$array_isSorted(e, t, o) {
              t = t || module$contents$goog$array_defaultCompare;
              for (var n = 1; n < e.length; n++) {
                var s = t(e[n - 1], e[n]);
                if (0 < s || s == 0 && o) return !1;
              }
              return !0;
            }
            goog.array.isSorted = module$contents$goog$array_isSorted;
            function module$contents$goog$array_equals(e, t, o) {
              if (!goog.isArrayLike(e) || !goog.isArrayLike(t) || e.length != t.length) return !1;
              var n = e.length;
              o = o || module$contents$goog$array_defaultCompareEquality;
              for (var s = 0; s < n; s++) if (!o(e[s], t[s])) return !1;
              return !0;
            }
            goog.array.equals = module$contents$goog$array_equals;
            function module$contents$goog$array_compare3(e, t, o) {
              o = o || module$contents$goog$array_defaultCompare;
              for (var n = Math.min(e.length, t.length), s = 0; s < n; s++) {
                var i = o(e[s], t[s]);
                if (i != 0) return i;
              }
              return module$contents$goog$array_defaultCompare(e.length, t.length);
            }
            goog.array.compare3 = module$contents$goog$array_compare3;
            function module$contents$goog$array_defaultCompare(e, t) {
              return e > t ? 1 : e < t ? -1 : 0;
            }
            goog.array.defaultCompare = module$contents$goog$array_defaultCompare;
            function module$contents$goog$array_inverseDefaultCompare(e, t) {
              return -module$contents$goog$array_defaultCompare(e, t);
            }
            goog.array.inverseDefaultCompare = module$contents$goog$array_inverseDefaultCompare;
            function module$contents$goog$array_defaultCompareEquality(e, t) {
              return e === t;
            }
            goog.array.defaultCompareEquality = module$contents$goog$array_defaultCompareEquality;
            function module$contents$goog$array_binaryInsert(e, t, o) {
              return o = module$contents$goog$array_binarySearch(e, t, o), 0 > o ? (module$contents$goog$array_insertAt(e, t, -(o + 1)), !0) : !1;
            }
            goog.array.binaryInsert = module$contents$goog$array_binaryInsert;
            function module$contents$goog$array_binaryRemove(e, t, o) {
              return t = module$contents$goog$array_binarySearch(e, t, o), 0 <= t ? module$contents$goog$array_removeAt(e, t) : !1;
            }
            goog.array.binaryRemove = module$contents$goog$array_binaryRemove;
            function module$contents$goog$array_bucket(e, t, o) {
              for (var n = {}, s = 0; s < e.length; s++) {
                var i = e[s], l = t.call(o, i, s, e);
                l !== void 0 && (n[l] || (n[l] = [])).push(i);
              }
              return n;
            }
            goog.array.bucket = module$contents$goog$array_bucket;
            function module$contents$goog$array_toObject(e, t, o) {
              var n = {};
              return module$contents$goog$array_forEach(e, function(s, i) {
                n[t.call(o, s, i, e)] = s;
              }), n;
            }
            goog.array.toObject = module$contents$goog$array_toObject;
            function module$contents$goog$array_range(e, t, o) {
              var n = [], s = 0, i = e;
              if (o = o || 1, t !== void 0 && (s = e, i = t), 0 > o * (i - s)) return [];
              if (0 < o) for (e = s; e < i; e += o) n.push(e);
              else for (e = s; e > i; e += o) n.push(e);
              return n;
            }
            goog.array.range = module$contents$goog$array_range;
            function module$contents$goog$array_repeat(e, t) {
              for (var o = [], n = 0; n < t; n++) o[n] = e;
              return o;
            }
            goog.array.repeat = module$contents$goog$array_repeat;
            function module$contents$goog$array_flatten(e) {
              for (var t = [], o = 0; o < arguments.length; o++) {
                var n = arguments[o];
                if (Array.isArray(n)) for (var s = 0; s < n.length; s += 8192) {
                  var i = module$contents$goog$array_slice(n, s, s + 8192);
                  i = module$contents$goog$array_flatten.apply(null, i);
                  for (var l = 0; l < i.length; l++) t.push(i[l]);
                }
                else t.push(n);
              }
              return t;
            }
            goog.array.flatten = module$contents$goog$array_flatten;
            function module$contents$goog$array_rotate(e, t) {
              return goog.asserts.assert(e.length != null), e.length && (t %= e.length, 0 < t ? Array.prototype.unshift.apply(e, e.splice(-t, t)) : 0 > t && Array.prototype.push.apply(e, e.splice(0, -t))), e;
            }
            goog.array.rotate = module$contents$goog$array_rotate;
            function module$contents$goog$array_moveItem(e, t, o) {
              goog.asserts.assert(0 <= t && t < e.length), goog.asserts.assert(0 <= o && o < e.length), t = Array.prototype.splice.call(e, t, 1), Array.prototype.splice.call(e, o, 0, t[0]);
            }
            goog.array.moveItem = module$contents$goog$array_moveItem;
            function module$contents$goog$array_zip(e) {
              if (!arguments.length) return [];
              for (var t = [], o = arguments[0].length, n = 1; n < arguments.length; n++) arguments[n].length < o && (o = arguments[n].length);
              for (n = 0; n < o; n++) {
                for (var s = [], i = 0; i < arguments.length; i++) s.push(arguments[i][n]);
                t.push(s);
              }
              return t;
            }
            goog.array.zip = module$contents$goog$array_zip;
            function module$contents$goog$array_shuffle(e, t) {
              t = t || Math.random;
              for (var o = e.length - 1; 0 < o; o--) {
                var n = Math.floor(t() * (o + 1)), s = e[o];
                e[o] = e[n], e[n] = s;
              }
            }
            goog.array.shuffle = module$contents$goog$array_shuffle;
            function module$contents$goog$array_copyByIndex(e, t) {
              var o = [];
              return module$contents$goog$array_forEach(t, function(n) {
                o.push(e[n]);
              }), o;
            }
            goog.array.copyByIndex = module$contents$goog$array_copyByIndex;
            function module$contents$goog$array_concatMap(e, t, o) {
              return module$contents$goog$array_concat.apply([], module$contents$goog$array_map(e, t, o));
            }
            goog.array.concatMap = module$contents$goog$array_concatMap, goog.dom.asserts = {}, goog.dom.asserts.assertIsLocation = function(e) {
              if (goog.asserts.ENABLE_ASSERTS) {
                var t = goog.dom.asserts.getWindow_(e);
                t && (!e || !(e instanceof t.Location) && e instanceof t.Element) && goog.asserts.fail("Argument is not a Location (or a non-Element mock); got: %s", goog.dom.asserts.debugStringForType_(e));
              }
              return e;
            }, goog.dom.asserts.assertIsElementType_ = function(e, t) {
              if (goog.asserts.ENABLE_ASSERTS) {
                var o = goog.dom.asserts.getWindow_(e);
                o && typeof o[t] < "u" && (e && (e instanceof o[t] || !(e instanceof o.Location || e instanceof o.Element)) || goog.asserts.fail("Argument is not a %s (or a non-Element, non-Location mock); got: %s", t, goog.dom.asserts.debugStringForType_(e)));
              }
              return e;
            }, goog.dom.asserts.assertIsHTMLAnchorElement = function(e) {
              return goog.dom.asserts.assertIsElementType_(e, "HTMLAnchorElement");
            }, goog.dom.asserts.assertIsHTMLButtonElement = function(e) {
              return goog.dom.asserts.assertIsElementType_(e, "HTMLButtonElement");
            }, goog.dom.asserts.assertIsHTMLLinkElement = function(e) {
              return goog.dom.asserts.assertIsElementType_(e, "HTMLLinkElement");
            }, goog.dom.asserts.assertIsHTMLImageElement = function(e) {
              return goog.dom.asserts.assertIsElementType_(e, "HTMLImageElement");
            }, goog.dom.asserts.assertIsHTMLAudioElement = function(e) {
              return goog.dom.asserts.assertIsElementType_(e, "HTMLAudioElement");
            }, goog.dom.asserts.assertIsHTMLVideoElement = function(e) {
              return goog.dom.asserts.assertIsElementType_(e, "HTMLVideoElement");
            }, goog.dom.asserts.assertIsHTMLInputElement = function(e) {
              return goog.dom.asserts.assertIsElementType_(e, "HTMLInputElement");
            }, goog.dom.asserts.assertIsHTMLTextAreaElement = function(e) {
              return goog.dom.asserts.assertIsElementType_(e, "HTMLTextAreaElement");
            }, goog.dom.asserts.assertIsHTMLCanvasElement = function(e) {
              return goog.dom.asserts.assertIsElementType_(e, "HTMLCanvasElement");
            }, goog.dom.asserts.assertIsHTMLEmbedElement = function(e) {
              return goog.dom.asserts.assertIsElementType_(e, "HTMLEmbedElement");
            }, goog.dom.asserts.assertIsHTMLFormElement = function(e) {
              return goog.dom.asserts.assertIsElementType_(e, "HTMLFormElement");
            }, goog.dom.asserts.assertIsHTMLFrameElement = function(e) {
              return goog.dom.asserts.assertIsElementType_(e, "HTMLFrameElement");
            }, goog.dom.asserts.assertIsHTMLIFrameElement = function(e) {
              return goog.dom.asserts.assertIsElementType_(e, "HTMLIFrameElement");
            }, goog.dom.asserts.assertIsHTMLObjectElement = function(e) {
              return goog.dom.asserts.assertIsElementType_(e, "HTMLObjectElement");
            }, goog.dom.asserts.assertIsHTMLScriptElement = function(e) {
              return goog.dom.asserts.assertIsElementType_(e, "HTMLScriptElement");
            }, goog.dom.asserts.debugStringForType_ = function(e) {
              if (goog.isObject(e)) try {
                return e.constructor.displayName || e.constructor.name || Object.prototype.toString.call(e);
              } catch {
                return "<object could not be stringified>";
              }
              else return e === void 0 ? "undefined" : e === null ? "null" : typeof e;
            }, goog.dom.asserts.getWindow_ = function(e) {
              try {
                var t = e && e.ownerDocument, o = t && (t.defaultView || t.parentWindow);
                if (o = o || goog.global, o.Element && o.Location) return o;
              } catch {
              }
              return null;
            }, goog.dom.HtmlElement = function() {
            }, goog.functions = {}, goog.functions.constant = function(e) {
              return function() {
                return e;
              };
            }, goog.functions.FALSE = function() {
              return !1;
            }, goog.functions.TRUE = function() {
              return !0;
            }, goog.functions.NULL = function() {
              return null;
            }, goog.functions.identity = function(e, t) {
              return e;
            }, goog.functions.error = function(e) {
              return function() {
                throw Error(e);
              };
            }, goog.functions.fail = function(e) {
              return function() {
                throw e;
              };
            }, goog.functions.lock = function(e, t) {
              return t = t || 0, function() {
                return e.apply(this, Array.prototype.slice.call(arguments, 0, t));
              };
            }, goog.functions.nth = function(e) {
              return function() {
                return arguments[e];
              };
            }, goog.functions.partialRight = function(e, t) {
              var o = Array.prototype.slice.call(arguments, 1);
              return function() {
                var n = this;
                n === goog.global && (n = void 0);
                var s = Array.prototype.slice.call(arguments);
                return s.push.apply(s, o), e.apply(n, s);
              };
            }, goog.functions.withReturnValue = function(e, t) {
              return goog.functions.sequence(e, goog.functions.constant(t));
            }, goog.functions.equalTo = function(e, t) {
              return function(o) {
                return t ? e == o : e === o;
              };
            }, goog.functions.compose = function(e, t) {
              var o = arguments, n = o.length;
              return function() {
                var s;
                n && (s = o[n - 1].apply(this, arguments));
                for (var i = n - 2; 0 <= i; i--) s = o[i].call(this, s);
                return s;
              };
            }, goog.functions.sequence = function(e) {
              var t = arguments, o = t.length;
              return function() {
                for (var n, s = 0; s < o; s++) n = t[s].apply(this, arguments);
                return n;
              };
            }, goog.functions.and = function(e) {
              var t = arguments, o = t.length;
              return function() {
                for (var n = 0; n < o; n++) if (!t[n].apply(this, arguments)) return !1;
                return !0;
              };
            }, goog.functions.or = function(e) {
              var t = arguments, o = t.length;
              return function() {
                for (var n = 0; n < o; n++) if (t[n].apply(this, arguments)) return !0;
                return !1;
              };
            }, goog.functions.not = function(e) {
              return function() {
                return !e.apply(this, arguments);
              };
            }, goog.functions.create = function(e, t) {
              var o = function() {
              };
              return o.prototype = e.prototype, o = new o(), e.apply(o, Array.prototype.slice.call(arguments, 1)), o;
            }, goog.functions.CACHE_RETURN_VALUE = !0, goog.functions.cacheReturnValue = function(e) {
              var t = !1, o;
              return function() {
                return goog.functions.CACHE_RETURN_VALUE ? (t || (o = e(), t = !0), o) : e();
              };
            }, goog.functions.once = function(e) {
              var t = e;
              return function() {
                if (t) {
                  var o = t;
                  t = null, o();
                }
              };
            }, goog.functions.debounce = function(e, t, o) {
              var n = 0;
              return function(s) {
                goog.global.clearTimeout(n);
                var i = arguments;
                n = goog.global.setTimeout(function() {
                  e.apply(o, i);
                }, t);
              };
            }, goog.functions.throttle = function(e, t, o) {
              var n = 0, s = !1, i = [], l = function() {
                n = 0, s && (s = !1, d());
              }, d = function() {
                n = goog.global.setTimeout(l, t), e.apply(o, i);
              };
              return function(u) {
                i = arguments, n ? s = !0 : d();
              };
            }, goog.functions.rateLimit = function(e, t, o) {
              var n = 0, s = function() {
                n = 0;
              };
              return function(i) {
                n || (n = goog.global.setTimeout(s, t), e.apply(o, arguments));
              };
            }, goog.functions.isFunction = function(e) {
              return typeof e == "function";
            }, goog.dom.TagName = function() {
            }, goog.dom.TagName.cast = function(e, t) {
              return e;
            }, goog.dom.TagName.prototype.toString = function() {
            }, goog.dom.TagName.A = "A", goog.dom.TagName.ABBR = "ABBR", goog.dom.TagName.ACRONYM = "ACRONYM", goog.dom.TagName.ADDRESS = "ADDRESS", goog.dom.TagName.APPLET = "APPLET", goog.dom.TagName.AREA = "AREA", goog.dom.TagName.ARTICLE = "ARTICLE", goog.dom.TagName.ASIDE = "ASIDE", goog.dom.TagName.AUDIO = "AUDIO", goog.dom.TagName.B = "B", goog.dom.TagName.BASE = "BASE", goog.dom.TagName.BASEFONT = "BASEFONT", goog.dom.TagName.BDI = "BDI", goog.dom.TagName.BDO = "BDO", goog.dom.TagName.BIG = "BIG", goog.dom.TagName.BLOCKQUOTE = "BLOCKQUOTE", goog.dom.TagName.BODY = "BODY", goog.dom.TagName.BR = "BR", goog.dom.TagName.BUTTON = "BUTTON", goog.dom.TagName.CANVAS = "CANVAS", goog.dom.TagName.CAPTION = "CAPTION", goog.dom.TagName.CENTER = "CENTER", goog.dom.TagName.CITE = "CITE", goog.dom.TagName.CODE = "CODE", goog.dom.TagName.COL = "COL", goog.dom.TagName.COLGROUP = "COLGROUP", goog.dom.TagName.COMMAND = "COMMAND", goog.dom.TagName.DATA = "DATA", goog.dom.TagName.DATALIST = "DATALIST", goog.dom.TagName.DD = "DD", goog.dom.TagName.DEL = "DEL", goog.dom.TagName.DETAILS = "DETAILS", goog.dom.TagName.DFN = "DFN", goog.dom.TagName.DIALOG = "DIALOG", goog.dom.TagName.DIR = "DIR", goog.dom.TagName.DIV = "DIV", goog.dom.TagName.DL = "DL", goog.dom.TagName.DT = "DT", goog.dom.TagName.EM = "EM", goog.dom.TagName.EMBED = "EMBED", goog.dom.TagName.FIELDSET = "FIELDSET", goog.dom.TagName.FIGCAPTION = "FIGCAPTION", goog.dom.TagName.FIGURE = "FIGURE", goog.dom.TagName.FONT = "FONT", goog.dom.TagName.FOOTER = "FOOTER", goog.dom.TagName.FORM = "FORM", goog.dom.TagName.FRAME = "FRAME", goog.dom.TagName.FRAMESET = "FRAMESET", goog.dom.TagName.H1 = "H1", goog.dom.TagName.H2 = "H2", goog.dom.TagName.H3 = "H3", goog.dom.TagName.H4 = "H4", goog.dom.TagName.H5 = "H5", goog.dom.TagName.H6 = "H6", goog.dom.TagName.HEAD = "HEAD", goog.dom.TagName.HEADER = "HEADER", goog.dom.TagName.HGROUP = "HGROUP", goog.dom.TagName.HR = "HR", goog.dom.TagName.HTML = "HTML", goog.dom.TagName.I = "I", goog.dom.TagName.IFRAME = "IFRAME", goog.dom.TagName.IMG = "IMG", goog.dom.TagName.INPUT = "INPUT", goog.dom.TagName.INS = "INS", goog.dom.TagName.ISINDEX = "ISINDEX", goog.dom.TagName.KBD = "KBD", goog.dom.TagName.KEYGEN = "KEYGEN", goog.dom.TagName.LABEL = "LABEL", goog.dom.TagName.LEGEND = "LEGEND", goog.dom.TagName.LI = "LI", goog.dom.TagName.LINK = "LINK", goog.dom.TagName.MAIN = "MAIN", goog.dom.TagName.MAP = "MAP", goog.dom.TagName.MARK = "MARK", goog.dom.TagName.MATH = "MATH", goog.dom.TagName.MENU = "MENU", goog.dom.TagName.MENUITEM = "MENUITEM", goog.dom.TagName.META = "META", goog.dom.TagName.METER = "METER", goog.dom.TagName.NAV = "NAV", goog.dom.TagName.NOFRAMES = "NOFRAMES", goog.dom.TagName.NOSCRIPT = "NOSCRIPT", goog.dom.TagName.OBJECT = "OBJECT", goog.dom.TagName.OL = "OL", goog.dom.TagName.OPTGROUP = "OPTGROUP", goog.dom.TagName.OPTION = "OPTION", goog.dom.TagName.OUTPUT = "OUTPUT", goog.dom.TagName.P = "P", goog.dom.TagName.PARAM = "PARAM", goog.dom.TagName.PICTURE = "PICTURE", goog.dom.TagName.PRE = "PRE", goog.dom.TagName.PROGRESS = "PROGRESS", goog.dom.TagName.Q = "Q", goog.dom.TagName.RP = "RP", goog.dom.TagName.RT = "RT", goog.dom.TagName.RTC = "RTC", goog.dom.TagName.RUBY = "RUBY", goog.dom.TagName.S = "S", goog.dom.TagName.SAMP = "SAMP", goog.dom.TagName.SCRIPT = "SCRIPT", goog.dom.TagName.SECTION = "SECTION", goog.dom.TagName.SELECT = "SELECT", goog.dom.TagName.SMALL = "SMALL", goog.dom.TagName.SOURCE = "SOURCE", goog.dom.TagName.SPAN = "SPAN", goog.dom.TagName.STRIKE = "STRIKE", goog.dom.TagName.STRONG = "STRONG", goog.dom.TagName.STYLE = "STYLE", goog.dom.TagName.SUB = "SUB", goog.dom.TagName.SUMMARY = "SUMMARY", goog.dom.TagName.SUP = "SUP", goog.dom.TagName.SVG = "SVG", goog.dom.TagName.TABLE = "TABLE", goog.dom.TagName.TBODY = "TBODY", goog.dom.TagName.TD = "TD", goog.dom.TagName.TEMPLATE = "TEMPLATE", goog.dom.TagName.TEXTAREA = "TEXTAREA", goog.dom.TagName.TFOOT = "TFOOT", goog.dom.TagName.TH = "TH", goog.dom.TagName.THEAD = "THEAD", goog.dom.TagName.TIME = "TIME", goog.dom.TagName.TITLE = "TITLE", goog.dom.TagName.TR = "TR", goog.dom.TagName.TRACK = "TRACK", goog.dom.TagName.TT = "TT", goog.dom.TagName.U = "U", goog.dom.TagName.UL = "UL", goog.dom.TagName.VAR = "VAR", goog.dom.TagName.VIDEO = "VIDEO", goog.dom.TagName.WBR = "WBR", goog.object = {}, goog.object.forEach = function(e, t, o) {
              for (var n in e) t.call(o, e[n], n, e);
            }, goog.object.filter = function(e, t, o) {
              var n = {}, s;
              for (s in e) t.call(o, e[s], s, e) && (n[s] = e[s]);
              return n;
            }, goog.object.map = function(e, t, o) {
              var n = {}, s;
              for (s in e) n[s] = t.call(o, e[s], s, e);
              return n;
            }, goog.object.some = function(e, t, o) {
              for (var n in e) if (t.call(o, e[n], n, e)) return !0;
              return !1;
            }, goog.object.every = function(e, t, o) {
              for (var n in e) if (!t.call(o, e[n], n, e)) return !1;
              return !0;
            }, goog.object.getCount = function(e) {
              var t = 0, o;
              for (o in e) t++;
              return t;
            }, goog.object.getAnyKey = function(e) {
              for (var t in e) return t;
            }, goog.object.getAnyValue = function(e) {
              for (var t in e) return e[t];
            }, goog.object.contains = function(e, t) {
              return goog.object.containsValue(e, t);
            }, goog.object.getValues = function(e) {
              var t = [], o = 0, n;
              for (n in e) t[o++] = e[n];
              return t;
            }, goog.object.getKeys = function(e) {
              var t = [], o = 0, n;
              for (n in e) t[o++] = n;
              return t;
            }, goog.object.getValueByKeys = function(e, t) {
              var o = goog.isArrayLike(t), n = o ? t : arguments;
              for (o = o ? 0 : 1; o < n.length; o++) {
                if (e == null) return;
                e = e[n[o]];
              }
              return e;
            }, goog.object.containsKey = function(e, t) {
              return e !== null && t in e;
            }, goog.object.containsValue = function(e, t) {
              for (var o in e) if (e[o] == t) return !0;
              return !1;
            }, goog.object.findKey = function(e, t, o) {
              for (var n in e) if (t.call(o, e[n], n, e)) return n;
            }, goog.object.findValue = function(e, t, o) {
              return (t = goog.object.findKey(e, t, o)) && e[t];
            }, goog.object.isEmpty = function(e) {
              for (var t in e) return !1;
              return !0;
            }, goog.object.clear = function(e) {
              for (var t in e) delete e[t];
            }, goog.object.remove = function(e, t) {
              var o;
              return (o = t in e) && delete e[t], o;
            }, goog.object.add = function(e, t, o) {
              if (e !== null && t in e) throw Error('The object already contains the key "' + t + '"');
              goog.object.set(e, t, o);
            }, goog.object.get = function(e, t, o) {
              return e !== null && t in e ? e[t] : o;
            }, goog.object.set = function(e, t, o) {
              e[t] = o;
            }, goog.object.setIfUndefined = function(e, t, o) {
              return t in e ? e[t] : e[t] = o;
            }, goog.object.setWithReturnValueIfNotSet = function(e, t, o) {
              return t in e ? e[t] : (o = o(), e[t] = o);
            }, goog.object.equals = function(e, t) {
              for (var o in e) if (!(o in t) || e[o] !== t[o]) return !1;
              for (var n in t) if (!(n in e)) return !1;
              return !0;
            }, goog.object.clone = function(e) {
              var t = {}, o;
              for (o in e) t[o] = e[o];
              return t;
            }, goog.object.unsafeClone = function(e) {
              if (!e || typeof e != "object") return e;
              if (typeof e.clone == "function") return e.clone();
              var t = Array.isArray(e) ? [] : typeof ArrayBuffer != "function" || typeof ArrayBuffer.isView != "function" || !ArrayBuffer.isView(e) || e instanceof DataView ? {} : new e.constructor(e.length), o;
              for (o in e) t[o] = goog.object.unsafeClone(e[o]);
              return t;
            }, goog.object.transpose = function(e) {
              var t = {}, o;
              for (o in e) t[e[o]] = o;
              return t;
            }, goog.object.PROTOTYPE_FIELDS_ = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" "), goog.object.extend = function(e, t) {
              for (var o, n, s = 1; s < arguments.length; s++) {
                n = arguments[s];
                for (o in n) e[o] = n[o];
                for (var i = 0; i < goog.object.PROTOTYPE_FIELDS_.length; i++) o = goog.object.PROTOTYPE_FIELDS_[i], Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
              }
            }, goog.object.create = function(e) {
              var t = arguments.length;
              if (t == 1 && Array.isArray(arguments[0])) return goog.object.create.apply(null, arguments[0]);
              if (t % 2) throw Error("Uneven number of arguments");
              for (var o = {}, n = 0; n < t; n += 2) o[arguments[n]] = arguments[n + 1];
              return o;
            }, goog.object.createSet = function(e) {
              var t = arguments.length;
              if (t == 1 && Array.isArray(arguments[0])) return goog.object.createSet.apply(null, arguments[0]);
              for (var o = {}, n = 0; n < t; n++) o[arguments[n]] = !0;
              return o;
            }, goog.object.createImmutableView = function(e) {
              var t = e;
              return Object.isFrozen && !Object.isFrozen(e) && (t = Object.create(e), Object.freeze(t)), t;
            }, goog.object.isImmutableView = function(e) {
              return !!Object.isFrozen && Object.isFrozen(e);
            }, goog.object.getAllPropertyNames = function(e, t, o) {
              if (!e) return [];
              if (!Object.getOwnPropertyNames || !Object.getPrototypeOf) return goog.object.getKeys(e);
              for (var n = {}; e && (e !== Object.prototype || t) && (e !== Function.prototype || o); ) {
                for (var s = Object.getOwnPropertyNames(e), i = 0; i < s.length; i++) n[s[i]] = !0;
                e = Object.getPrototypeOf(e);
              }
              return goog.object.getKeys(n);
            }, goog.object.getSuperClass = function(e) {
              return (e = Object.getPrototypeOf(e.prototype)) && e.constructor;
            }, goog.dom.tags = {}, goog.dom.tags.VOID_TAGS_ = { area: !0, base: !0, br: !0, col: !0, command: !0, embed: !0, hr: !0, img: !0, input: !0, keygen: !0, link: !0, meta: !0, param: !0, source: !0, track: !0, wbr: !0 }, goog.dom.tags.isVoidTag = function(e) {
              return goog.dom.tags.VOID_TAGS_[e] === !0;
            }, goog.string = {}, goog.string.TypedString = function() {
            }, goog.string.Const = function(e, t) {
              this.stringConstValueWithSecurityContract__googStringSecurityPrivate_ = e === goog.string.Const.GOOG_STRING_CONSTRUCTOR_TOKEN_PRIVATE_ && t || "", this.STRING_CONST_TYPE_MARKER__GOOG_STRING_SECURITY_PRIVATE_ = goog.string.Const.TYPE_MARKER_;
            }, goog.string.Const.prototype.implementsGoogStringTypedString = !0, goog.string.Const.prototype.getTypedStringValue = function() {
              return this.stringConstValueWithSecurityContract__googStringSecurityPrivate_;
            }, goog.DEBUG && (goog.string.Const.prototype.toString = function() {
              return "Const{" + this.stringConstValueWithSecurityContract__googStringSecurityPrivate_ + "}";
            }), goog.string.Const.unwrap = function(e) {
              return e instanceof goog.string.Const && e.constructor === goog.string.Const && e.STRING_CONST_TYPE_MARKER__GOOG_STRING_SECURITY_PRIVATE_ === goog.string.Const.TYPE_MARKER_ ? e.stringConstValueWithSecurityContract__googStringSecurityPrivate_ : (goog.asserts.fail("expected object of type Const, got '" + e + "'"), "type_error:Const");
            }, goog.string.Const.from = function(e) {
              return new goog.string.Const(goog.string.Const.GOOG_STRING_CONSTRUCTOR_TOKEN_PRIVATE_, e);
            }, goog.string.Const.TYPE_MARKER_ = {}, goog.string.Const.GOOG_STRING_CONSTRUCTOR_TOKEN_PRIVATE_ = {}, goog.string.Const.EMPTY = goog.string.Const.from(""), goog.html = {}, goog.html.trustedtypes = {}, goog.html.trustedtypes.getPolicyPrivateDoNotAccessOrElse = function() {
              return goog.TRUSTED_TYPES_POLICY_NAME ? (goog.html.trustedtypes.cachedPolicy_ === void 0 && (goog.html.trustedtypes.cachedPolicy_ = goog.createTrustedTypesPolicy(goog.TRUSTED_TYPES_POLICY_NAME + "#html")), goog.html.trustedtypes.cachedPolicy_) : null;
            };
            var module$contents$goog$html$SafeScript_CONSTRUCTOR_TOKEN_PRIVATE = {}, module$contents$goog$html$SafeScript_SafeScript = function(e, t) {
              this.privateDoNotAccessOrElseSafeScriptWrappedValue_ = t === module$contents$goog$html$SafeScript_CONSTRUCTOR_TOKEN_PRIVATE ? e : "", this.implementsGoogStringTypedString = !0;
            };
            module$contents$goog$html$SafeScript_SafeScript.fromConstant = function(e) {
              return e = goog.string.Const.unwrap(e), e.length === 0 ? module$contents$goog$html$SafeScript_SafeScript.EMPTY : module$contents$goog$html$SafeScript_SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse(e);
            }, module$contents$goog$html$SafeScript_SafeScript.fromConstantAndArgs = function(e, t) {
              for (var o = [], n = 1; n < arguments.length; n++) o.push(module$contents$goog$html$SafeScript_SafeScript.stringify_(arguments[n]));
              return module$contents$goog$html$SafeScript_SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse("(" + goog.string.Const.unwrap(e) + ")(" + o.join(", ") + ");");
            }, module$contents$goog$html$SafeScript_SafeScript.fromJson = function(e) {
              return module$contents$goog$html$SafeScript_SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse(module$contents$goog$html$SafeScript_SafeScript.stringify_(e));
            }, module$contents$goog$html$SafeScript_SafeScript.prototype.getTypedStringValue = function() {
              return this.privateDoNotAccessOrElseSafeScriptWrappedValue_.toString();
            }, module$contents$goog$html$SafeScript_SafeScript.unwrap = function(e) {
              return module$contents$goog$html$SafeScript_SafeScript.unwrapTrustedScript(e).toString();
            }, module$contents$goog$html$SafeScript_SafeScript.unwrapTrustedScript = function(e) {
              return e instanceof module$contents$goog$html$SafeScript_SafeScript && e.constructor === module$contents$goog$html$SafeScript_SafeScript ? e.privateDoNotAccessOrElseSafeScriptWrappedValue_ : ((0, goog.asserts.fail)("expected object of type SafeScript, got '" + e + "' of type " + goog.typeOf(e)), "type_error:SafeScript");
            }, module$contents$goog$html$SafeScript_SafeScript.stringify_ = function(e) {
              return JSON.stringify(e).replace(/</g, "\\x3c");
            }, module$contents$goog$html$SafeScript_SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse = function(e) {
              var t = goog.html.trustedtypes.getPolicyPrivateDoNotAccessOrElse();
              return e = t ? t.createScript(e) : e, new module$contents$goog$html$SafeScript_SafeScript(e, module$contents$goog$html$SafeScript_CONSTRUCTOR_TOKEN_PRIVATE);
            }, goog.DEBUG && (module$contents$goog$html$SafeScript_SafeScript.prototype.toString = function() {
              return "SafeScript{" + this.privateDoNotAccessOrElseSafeScriptWrappedValue_ + "}";
            }), module$contents$goog$html$SafeScript_SafeScript.EMPTY = (function() {
              return module$contents$goog$html$SafeScript_SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse("");
            })(), goog.html.SafeScript = module$contents$goog$html$SafeScript_SafeScript, goog.fs = {}, goog.fs.url = {}, goog.fs.url.createObjectUrl = function(e) {
              return goog.fs.url.getUrlObject_().createObjectURL(e);
            }, goog.fs.url.revokeObjectUrl = function(e) {
              goog.fs.url.getUrlObject_().revokeObjectURL(e);
            }, goog.fs.url.UrlObject_ = function() {
            }, goog.fs.url.UrlObject_.prototype.createObjectURL = function(e) {
            }, goog.fs.url.UrlObject_.prototype.revokeObjectURL = function(e) {
            }, goog.fs.url.getUrlObject_ = function() {
              var e = goog.fs.url.findUrlObject_();
              if (e != null) return e;
              throw Error("This browser doesn't seem to support blob URLs");
            }, goog.fs.url.findUrlObject_ = function() {
              return goog.global.URL !== void 0 && goog.global.URL.createObjectURL !== void 0 ? goog.global.URL : goog.global.webkitURL !== void 0 && goog.global.webkitURL.createObjectURL !== void 0 ? goog.global.webkitURL : goog.global.createObjectURL !== void 0 ? goog.global : null;
            }, goog.fs.url.browserSupportsObjectUrls = function() {
              return goog.fs.url.findUrlObject_() != null;
            }, goog.fs.blob = {}, goog.fs.blob.getBlob = function(e) {
              var t = goog.global.BlobBuilder || goog.global.WebKitBlobBuilder;
              if (t !== void 0) {
                t = new t();
                for (var o = 0; o < arguments.length; o++) t.append(arguments[o]);
                return t.getBlob();
              }
              return goog.fs.blob.getBlobWithProperties(module$contents$goog$array_toArray(arguments));
            }, goog.fs.blob.getBlobWithProperties = function(e, t, o) {
              var n = goog.global.BlobBuilder || goog.global.WebKitBlobBuilder;
              if (n !== void 0) {
                n = new n();
                for (var s = 0; s < e.length; s++) n.append(e[s], o);
                return n.getBlob(t);
              }
              if (goog.global.Blob !== void 0) return n = {}, t && (n.type = t), o && (n.endings = o), new Blob(e, n);
              throw Error("This browser doesn't seem to support creating Blobs");
            }, goog.i18n = {}, goog.i18n.bidi = {}, goog.i18n.bidi.FORCE_RTL = !1, goog.i18n.bidi.IS_RTL = goog.i18n.bidi.FORCE_RTL || (goog.LOCALE.substring(0, 2).toLowerCase() == "ar" || goog.LOCALE.substring(0, 2).toLowerCase() == "fa" || goog.LOCALE.substring(0, 2).toLowerCase() == "he" || goog.LOCALE.substring(0, 2).toLowerCase() == "iw" || goog.LOCALE.substring(0, 2).toLowerCase() == "ps" || goog.LOCALE.substring(0, 2).toLowerCase() == "sd" || goog.LOCALE.substring(0, 2).toLowerCase() == "ug" || goog.LOCALE.substring(0, 2).toLowerCase() == "ur" || goog.LOCALE.substring(0, 2).toLowerCase() == "yi") && (goog.LOCALE.length == 2 || goog.LOCALE.substring(2, 3) == "-" || goog.LOCALE.substring(2, 3) == "_") || 3 <= goog.LOCALE.length && goog.LOCALE.substring(0, 3).toLowerCase() == "ckb" && (goog.LOCALE.length == 3 || goog.LOCALE.substring(3, 4) == "-" || goog.LOCALE.substring(3, 4) == "_") || 7 <= goog.LOCALE.length && (goog.LOCALE.substring(2, 3) == "-" || goog.LOCALE.substring(2, 3) == "_") && (goog.LOCALE.substring(3, 7).toLowerCase() == "adlm" || goog.LOCALE.substring(3, 7).toLowerCase() == "arab" || goog.LOCALE.substring(3, 7).toLowerCase() == "hebr" || goog.LOCALE.substring(
              3,
              7
            ).toLowerCase() == "nkoo" || goog.LOCALE.substring(3, 7).toLowerCase() == "rohg" || goog.LOCALE.substring(3, 7).toLowerCase() == "thaa") || 8 <= goog.LOCALE.length && (goog.LOCALE.substring(3, 4) == "-" || goog.LOCALE.substring(3, 4) == "_") && (goog.LOCALE.substring(4, 8).toLowerCase() == "adlm" || goog.LOCALE.substring(4, 8).toLowerCase() == "arab" || goog.LOCALE.substring(4, 8).toLowerCase() == "hebr" || goog.LOCALE.substring(4, 8).toLowerCase() == "nkoo" || goog.LOCALE.substring(4, 8).toLowerCase() == "rohg" || goog.LOCALE.substring(4, 8).toLowerCase() == "thaa"), goog.i18n.bidi.Format = { LRE: "‪", RLE: "‫", PDF: "‬", LRM: "‎", RLM: "‏" }, goog.i18n.bidi.Dir = { LTR: 1, RTL: -1, NEUTRAL: 0 }, goog.i18n.bidi.RIGHT = "right", goog.i18n.bidi.LEFT = "left", goog.i18n.bidi.I18N_RIGHT = goog.i18n.bidi.IS_RTL ? goog.i18n.bidi.LEFT : goog.i18n.bidi.RIGHT, goog.i18n.bidi.I18N_LEFT = goog.i18n.bidi.IS_RTL ? goog.i18n.bidi.RIGHT : goog.i18n.bidi.LEFT, goog.i18n.bidi.toDir = function(e, t) {
              return typeof e == "number" ? 0 < e ? goog.i18n.bidi.Dir.LTR : 0 > e ? goog.i18n.bidi.Dir.RTL : t ? null : goog.i18n.bidi.Dir.NEUTRAL : e == null ? null : e ? goog.i18n.bidi.Dir.RTL : goog.i18n.bidi.Dir.LTR;
            }, goog.i18n.bidi.ltrChars_ = "A-Za-zÀ-ÖØ-öø-ʸ̀-֐ऀ-῿‎Ⰰ-\uD801\uD804-\uD839\uD83C-\uDBFF豈-﬜︀-﹯﻽-￿", goog.i18n.bidi.rtlChars_ = "֑-ۯۺ-ࣿ‏\uD802-\uD803\uD83A-\uD83Bיִ-﷿ﹰ-ﻼ", goog.i18n.bidi.htmlSkipReg_ = /<[^>]*>|&[^;]+;/g, goog.i18n.bidi.stripHtmlIfNeeded_ = function(e, t) {
              return t ? e.replace(goog.i18n.bidi.htmlSkipReg_, "") : e;
            }, goog.i18n.bidi.rtlCharReg_ = new RegExp("[" + goog.i18n.bidi.rtlChars_ + "]"), goog.i18n.bidi.ltrCharReg_ = new RegExp("[" + goog.i18n.bidi.ltrChars_ + "]"), goog.i18n.bidi.hasAnyRtl = function(e, t) {
              return goog.i18n.bidi.rtlCharReg_.test(goog.i18n.bidi.stripHtmlIfNeeded_(e, t));
            }, goog.i18n.bidi.hasRtlChar = goog.i18n.bidi.hasAnyRtl, goog.i18n.bidi.hasAnyLtr = function(e, t) {
              return goog.i18n.bidi.ltrCharReg_.test(goog.i18n.bidi.stripHtmlIfNeeded_(e, t));
            }, goog.i18n.bidi.ltrRe_ = new RegExp("^[" + goog.i18n.bidi.ltrChars_ + "]"), goog.i18n.bidi.rtlRe_ = new RegExp("^[" + goog.i18n.bidi.rtlChars_ + "]"), goog.i18n.bidi.isRtlChar = function(e) {
              return goog.i18n.bidi.rtlRe_.test(e);
            }, goog.i18n.bidi.isLtrChar = function(e) {
              return goog.i18n.bidi.ltrRe_.test(e);
            }, goog.i18n.bidi.isNeutralChar = function(e) {
              return !goog.i18n.bidi.isLtrChar(e) && !goog.i18n.bidi.isRtlChar(e);
            }, goog.i18n.bidi.ltrDirCheckRe_ = new RegExp("^[^" + goog.i18n.bidi.rtlChars_ + "]*[" + goog.i18n.bidi.ltrChars_ + "]"), goog.i18n.bidi.rtlDirCheckRe_ = new RegExp("^[^" + goog.i18n.bidi.ltrChars_ + "]*[" + goog.i18n.bidi.rtlChars_ + "]"), goog.i18n.bidi.startsWithRtl = function(e, t) {
              return goog.i18n.bidi.rtlDirCheckRe_.test(goog.i18n.bidi.stripHtmlIfNeeded_(e, t));
            }, goog.i18n.bidi.isRtlText = goog.i18n.bidi.startsWithRtl, goog.i18n.bidi.startsWithLtr = function(e, t) {
              return goog.i18n.bidi.ltrDirCheckRe_.test(goog.i18n.bidi.stripHtmlIfNeeded_(e, t));
            }, goog.i18n.bidi.isLtrText = goog.i18n.bidi.startsWithLtr, goog.i18n.bidi.isRequiredLtrRe_ = /^http:\/\/.*/, goog.i18n.bidi.isNeutralText = function(e, t) {
              return e = goog.i18n.bidi.stripHtmlIfNeeded_(e, t), goog.i18n.bidi.isRequiredLtrRe_.test(e) || !goog.i18n.bidi.hasAnyLtr(e) && !goog.i18n.bidi.hasAnyRtl(e);
            }, goog.i18n.bidi.ltrExitDirCheckRe_ = new RegExp("[" + goog.i18n.bidi.ltrChars_ + "][^" + goog.i18n.bidi.rtlChars_ + "]*$"), goog.i18n.bidi.rtlExitDirCheckRe_ = new RegExp("[" + goog.i18n.bidi.rtlChars_ + "][^" + goog.i18n.bidi.ltrChars_ + "]*$"), goog.i18n.bidi.endsWithLtr = function(e, t) {
              return goog.i18n.bidi.ltrExitDirCheckRe_.test(goog.i18n.bidi.stripHtmlIfNeeded_(e, t));
            }, goog.i18n.bidi.isLtrExitText = goog.i18n.bidi.endsWithLtr, goog.i18n.bidi.endsWithRtl = function(e, t) {
              return goog.i18n.bidi.rtlExitDirCheckRe_.test(goog.i18n.bidi.stripHtmlIfNeeded_(e, t));
            }, goog.i18n.bidi.isRtlExitText = goog.i18n.bidi.endsWithRtl, goog.i18n.bidi.rtlLocalesRe_ = /^(ar|ckb|dv|he|iw|fa|nqo|ps|sd|ug|ur|yi|.*[-_](Adlm|Arab|Hebr|Nkoo|Rohg|Thaa))(?!.*[-_](Latn|Cyrl)($|-|_))($|-|_)/i, goog.i18n.bidi.isRtlLanguage = function(e) {
              return goog.i18n.bidi.rtlLocalesRe_.test(e);
            }, goog.i18n.bidi.bracketGuardTextRe_ = /(\(.*?\)+)|(\[.*?\]+)|(\{.*?\}+)|(<.*?>+)/g, goog.i18n.bidi.guardBracketInText = function(e, t) {
              return t = (t === void 0 ? goog.i18n.bidi.hasAnyRtl(e) : t) ? goog.i18n.bidi.Format.RLM : goog.i18n.bidi.Format.LRM, e.replace(goog.i18n.bidi.bracketGuardTextRe_, t + "$&" + t);
            }, goog.i18n.bidi.enforceRtlInHtml = function(e) {
              return e.charAt(0) == "<" ? e.replace(/<\w+/, "$& dir=rtl") : `
<span dir=rtl>` + e + "</span>";
            }, goog.i18n.bidi.enforceRtlInText = function(e) {
              return goog.i18n.bidi.Format.RLE + e + goog.i18n.bidi.Format.PDF;
            }, goog.i18n.bidi.enforceLtrInHtml = function(e) {
              return e.charAt(0) == "<" ? e.replace(/<\w+/, "$& dir=ltr") : `
<span dir=ltr>` + e + "</span>";
            }, goog.i18n.bidi.enforceLtrInText = function(e) {
              return goog.i18n.bidi.Format.LRE + e + goog.i18n.bidi.Format.PDF;
            }, goog.i18n.bidi.dimensionsRe_ = /:\s*([.\d][.\w]*)\s+([.\d][.\w]*)\s+([.\d][.\w]*)\s+([.\d][.\w]*)/g, goog.i18n.bidi.leftRe_ = /left/gi, goog.i18n.bidi.rightRe_ = /right/gi, goog.i18n.bidi.tempRe_ = /%%%%/g, goog.i18n.bidi.mirrorCSS = function(e) {
              return e.replace(goog.i18n.bidi.dimensionsRe_, ":$1 $4 $3 $2").replace(goog.i18n.bidi.leftRe_, "%%%%").replace(goog.i18n.bidi.rightRe_, goog.i18n.bidi.LEFT).replace(goog.i18n.bidi.tempRe_, goog.i18n.bidi.RIGHT);
            }, goog.i18n.bidi.doubleQuoteSubstituteRe_ = /([\u0591-\u05f2])"/g, goog.i18n.bidi.singleQuoteSubstituteRe_ = /([\u0591-\u05f2])'/g, goog.i18n.bidi.normalizeHebrewQuote = function(e) {
              return e.replace(goog.i18n.bidi.doubleQuoteSubstituteRe_, "$1״").replace(goog.i18n.bidi.singleQuoteSubstituteRe_, "$1׳");
            }, goog.i18n.bidi.wordSeparatorRe_ = /\s+/, goog.i18n.bidi.hasNumeralsRe_ = /[\d\u06f0-\u06f9]/, goog.i18n.bidi.rtlDetectionThreshold_ = 0.4, goog.i18n.bidi.estimateDirection = function(e, t) {
              var o = 0, n = 0, s = !1;
              for (e = goog.i18n.bidi.stripHtmlIfNeeded_(e, t).split(goog.i18n.bidi.wordSeparatorRe_), t = 0; t < e.length; t++) {
                var i = e[t];
                goog.i18n.bidi.startsWithRtl(i) ? (o++, n++) : goog.i18n.bidi.isRequiredLtrRe_.test(i) ? s = !0 : goog.i18n.bidi.hasAnyLtr(i) ? n++ : goog.i18n.bidi.hasNumeralsRe_.test(i) && (s = !0);
              }
              return n == 0 ? s ? goog.i18n.bidi.Dir.LTR : goog.i18n.bidi.Dir.NEUTRAL : o / n > goog.i18n.bidi.rtlDetectionThreshold_ ? goog.i18n.bidi.Dir.RTL : goog.i18n.bidi.Dir.LTR;
            }, goog.i18n.bidi.detectRtlDirectionality = function(e, t) {
              return goog.i18n.bidi.estimateDirection(e, t) == goog.i18n.bidi.Dir.RTL;
            }, goog.i18n.bidi.setElementDirAndAlign = function(e, t) {
              e && (t = goog.i18n.bidi.toDir(t)) && (e.style.textAlign = t == goog.i18n.bidi.Dir.RTL ? goog.i18n.bidi.RIGHT : goog.i18n.bidi.LEFT, e.dir = t == goog.i18n.bidi.Dir.RTL ? "rtl" : "ltr");
            }, goog.i18n.bidi.setElementDirByTextDirectionality = function(e, t) {
              switch (goog.i18n.bidi.estimateDirection(t)) {
                case goog.i18n.bidi.Dir.LTR:
                  e.dir !== "ltr" && (e.dir = "ltr");
                  break;
                case goog.i18n.bidi.Dir.RTL:
                  e.dir !== "rtl" && (e.dir = "rtl");
                  break;
                default:
                  e.removeAttribute("dir");
              }
            }, goog.i18n.bidi.DirectionalString = function() {
            }, goog.html.TrustedResourceUrl = function(e, t) {
              this.privateDoNotAccessOrElseTrustedResourceUrlWrappedValue_ = t === goog.html.TrustedResourceUrl.CONSTRUCTOR_TOKEN_PRIVATE_ ? e : "";
            }, goog.html.TrustedResourceUrl.prototype.implementsGoogStringTypedString = !0, goog.html.TrustedResourceUrl.prototype.getTypedStringValue = function() {
              return this.privateDoNotAccessOrElseTrustedResourceUrlWrappedValue_.toString();
            }, goog.html.TrustedResourceUrl.prototype.implementsGoogI18nBidiDirectionalString = !0, goog.html.TrustedResourceUrl.prototype.getDirection = function() {
              return goog.i18n.bidi.Dir.LTR;
            }, goog.html.TrustedResourceUrl.prototype.cloneWithParams = function(e, t) {
              var o = goog.html.TrustedResourceUrl.unwrap(this);
              o = goog.html.TrustedResourceUrl.URL_PARAM_PARSER_.exec(o);
              var n = o[3] || "";
              return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(o[1] + goog.html.TrustedResourceUrl.stringifyParams_("?", o[2] || "", e) + goog.html.TrustedResourceUrl.stringifyParams_("#", n, t));
            }, goog.DEBUG && (goog.html.TrustedResourceUrl.prototype.toString = function() {
              return "TrustedResourceUrl{" + this.privateDoNotAccessOrElseTrustedResourceUrlWrappedValue_ + "}";
            }), goog.html.TrustedResourceUrl.unwrap = function(e) {
              return goog.html.TrustedResourceUrl.unwrapTrustedScriptURL(e).toString();
            }, goog.html.TrustedResourceUrl.unwrapTrustedScriptURL = function(e) {
              return e instanceof goog.html.TrustedResourceUrl && e.constructor === goog.html.TrustedResourceUrl ? e.privateDoNotAccessOrElseTrustedResourceUrlWrappedValue_ : (goog.asserts.fail("expected object of type TrustedResourceUrl, got '" + e + "' of type " + goog.typeOf(e)), "type_error:TrustedResourceUrl");
            }, goog.html.TrustedResourceUrl.format = function(e, t) {
              var o = goog.string.Const.unwrap(e);
              if (!goog.html.TrustedResourceUrl.BASE_URL_.test(o)) throw Error("Invalid TrustedResourceUrl format: " + o);
              return e = o.replace(goog.html.TrustedResourceUrl.FORMAT_MARKER_, function(n, s) {
                if (!Object.prototype.hasOwnProperty.call(t, s)) throw Error('Found marker, "' + s + '", in format string, "' + o + '", but no valid label mapping found in args: ' + JSON.stringify(t));
                return n = t[s], n instanceof goog.string.Const ? goog.string.Const.unwrap(n) : encodeURIComponent(String(n));
              }), goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(e);
            }, goog.html.TrustedResourceUrl.FORMAT_MARKER_ = /%{(\w+)}/g, goog.html.TrustedResourceUrl.BASE_URL_ = /^((https:)?\/\/[0-9a-z.:[\]-]+\/|\/[^/\\]|[^:/\\%]+\/|[^:/\\%]*[?#]|about:blank#)/i, goog.html.TrustedResourceUrl.URL_PARAM_PARSER_ = /^([^?#]*)(\?[^#]*)?(#[\s\S]*)?/, goog.html.TrustedResourceUrl.formatWithParams = function(e, t, o, n) {
              return goog.html.TrustedResourceUrl.format(e, t).cloneWithParams(o, n);
            }, goog.html.TrustedResourceUrl.fromConstant = function(e) {
              return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(goog.string.Const.unwrap(e));
            }, goog.html.TrustedResourceUrl.fromConstants = function(e) {
              for (var t = "", o = 0; o < e.length; o++) t += goog.string.Const.unwrap(e[o]);
              return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(t);
            }, goog.html.TrustedResourceUrl.fromSafeScript = function(e) {
              return e = goog.fs.blob.getBlobWithProperties([module$contents$goog$html$SafeScript_SafeScript.unwrap(e)], "text/javascript"), e = goog.fs.url.createObjectUrl(e), goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(e);
            }, goog.html.TrustedResourceUrl.CONSTRUCTOR_TOKEN_PRIVATE_ = {}, goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse = function(e) {
              var t = goog.html.trustedtypes.getPolicyPrivateDoNotAccessOrElse();
              return e = t ? t.createScriptURL(e) : e, new goog.html.TrustedResourceUrl(e, goog.html.TrustedResourceUrl.CONSTRUCTOR_TOKEN_PRIVATE_);
            }, goog.html.TrustedResourceUrl.stringifyParams_ = function(e, t, o) {
              if (o == null) return t;
              if (typeof o == "string") return o ? e + encodeURIComponent(o) : "";
              for (var n in o) if (Object.prototype.hasOwnProperty.call(o, n)) {
                var s = o[n];
                s = Array.isArray(s) ? s : [s];
                for (var i = 0; i < s.length; i++) {
                  var l = s[i];
                  l != null && (t || (t = e), t += (t.length > e.length ? "&" : "") + encodeURIComponent(n) + "=" + encodeURIComponent(String(l)));
                }
              }
              return t;
            }, goog.string.internal = {}, goog.string.internal.startsWith = function(e, t) {
              return e.lastIndexOf(t, 0) == 0;
            }, goog.string.internal.endsWith = function(e, t) {
              var o = e.length - t.length;
              return 0 <= o && e.indexOf(t, o) == o;
            }, goog.string.internal.caseInsensitiveStartsWith = function(e, t) {
              return goog.string.internal.caseInsensitiveCompare(t, e.substr(0, t.length)) == 0;
            }, goog.string.internal.caseInsensitiveEndsWith = function(e, t) {
              return goog.string.internal.caseInsensitiveCompare(t, e.substr(e.length - t.length, t.length)) == 0;
            }, goog.string.internal.caseInsensitiveEquals = function(e, t) {
              return e.toLowerCase() == t.toLowerCase();
            }, goog.string.internal.isEmptyOrWhitespace = function(e) {
              return /^[\s\xa0]*$/.test(e);
            }, goog.string.internal.trim = goog.TRUSTED_SITE && String.prototype.trim ? function(e) {
              return e.trim();
            } : function(e) {
              return /^[\s\xa0]*([\s\S]*?)[\s\xa0]*$/.exec(e)[1];
            }, goog.string.internal.caseInsensitiveCompare = function(e, t) {
              return e = String(e).toLowerCase(), t = String(t).toLowerCase(), e < t ? -1 : e == t ? 0 : 1;
            }, goog.string.internal.newLineToBr = function(e, t) {
              return e.replace(/(\r\n|\r|\n)/g, t ? "<br />" : "<br>");
            }, goog.string.internal.htmlEscape = function(e, t) {
              if (t) e = e.replace(goog.string.internal.AMP_RE_, "&amp;").replace(goog.string.internal.LT_RE_, "&lt;").replace(goog.string.internal.GT_RE_, "&gt;").replace(goog.string.internal.QUOT_RE_, "&quot;").replace(goog.string.internal.SINGLE_QUOTE_RE_, "&#39;").replace(goog.string.internal.NULL_RE_, "&#0;");
              else {
                if (!goog.string.internal.ALL_RE_.test(e)) return e;
                e.indexOf("&") != -1 && (e = e.replace(goog.string.internal.AMP_RE_, "&amp;")), e.indexOf("<") != -1 && (e = e.replace(
                  goog.string.internal.LT_RE_,
                  "&lt;"
                )), e.indexOf(">") != -1 && (e = e.replace(goog.string.internal.GT_RE_, "&gt;")), e.indexOf('"') != -1 && (e = e.replace(goog.string.internal.QUOT_RE_, "&quot;")), e.indexOf("'") != -1 && (e = e.replace(goog.string.internal.SINGLE_QUOTE_RE_, "&#39;")), e.indexOf("\0") != -1 && (e = e.replace(goog.string.internal.NULL_RE_, "&#0;"));
              }
              return e;
            }, goog.string.internal.AMP_RE_ = /&/g, goog.string.internal.LT_RE_ = /</g, goog.string.internal.GT_RE_ = />/g, goog.string.internal.QUOT_RE_ = /"/g, goog.string.internal.SINGLE_QUOTE_RE_ = /'/g, goog.string.internal.NULL_RE_ = /\x00/g, goog.string.internal.ALL_RE_ = /[\x00&<>"']/, goog.string.internal.whitespaceEscape = function(e, t) {
              return goog.string.internal.newLineToBr(e.replace(/  /g, " &#160;"), t);
            }, goog.string.internal.contains = function(e, t) {
              return e.indexOf(t) != -1;
            }, goog.string.internal.caseInsensitiveContains = function(e, t) {
              return goog.string.internal.contains(e.toLowerCase(), t.toLowerCase());
            }, goog.string.internal.compareVersions = function(e, t) {
              var o = 0;
              e = goog.string.internal.trim(String(e)).split("."), t = goog.string.internal.trim(String(t)).split(".");
              for (var n = Math.max(e.length, t.length), s = 0; o == 0 && s < n; s++) {
                var i = e[s] || "", l = t[s] || "";
                do {
                  if (i = /(\d*)(\D*)(.*)/.exec(i) || ["", "", "", ""], l = /(\d*)(\D*)(.*)/.exec(l) || ["", "", "", ""], i[0].length == 0 && l[0].length == 0) break;
                  o = i[1].length == 0 ? 0 : parseInt(i[1], 10);
                  var d = l[1].length == 0 ? 0 : parseInt(l[1], 10);
                  o = goog.string.internal.compareElements_(o, d) || goog.string.internal.compareElements_(i[2].length == 0, l[2].length == 0) || goog.string.internal.compareElements_(i[2], l[2]), i = i[3], l = l[3];
                } while (o == 0);
              }
              return o;
            }, goog.string.internal.compareElements_ = function(e, t) {
              return e < t ? -1 : e > t ? 1 : 0;
            }, goog.html.SafeUrl = function(e, t) {
              this.privateDoNotAccessOrElseSafeUrlWrappedValue_ = t === goog.html.SafeUrl.CONSTRUCTOR_TOKEN_PRIVATE_ ? e : "";
            }, goog.html.SafeUrl.INNOCUOUS_STRING = "about:invalid#zClosurez", goog.html.SafeUrl.prototype.implementsGoogStringTypedString = !0, goog.html.SafeUrl.prototype.getTypedStringValue = function() {
              return this.privateDoNotAccessOrElseSafeUrlWrappedValue_.toString();
            }, goog.html.SafeUrl.prototype.implementsGoogI18nBidiDirectionalString = !0, goog.html.SafeUrl.prototype.getDirection = function() {
              return goog.i18n.bidi.Dir.LTR;
            }, goog.DEBUG && (goog.html.SafeUrl.prototype.toString = function() {
              return "SafeUrl{" + this.privateDoNotAccessOrElseSafeUrlWrappedValue_ + "}";
            }), goog.html.SafeUrl.unwrap = function(e) {
              return e instanceof goog.html.SafeUrl && e.constructor === goog.html.SafeUrl ? e.privateDoNotAccessOrElseSafeUrlWrappedValue_ : (goog.asserts.fail("expected object of type SafeUrl, got '" + e + "' of type " + goog.typeOf(e)), "type_error:SafeUrl");
            }, goog.html.SafeUrl.fromConstant = function(e) {
              return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(goog.string.Const.unwrap(e));
            }, goog.html.SAFE_MIME_TYPE_PATTERN_ = /^(?:audio\/(?:3gpp2|3gpp|aac|L16|midi|mp3|mp4|mpeg|oga|ogg|opus|x-m4a|x-matroska|x-wav|wav|webm)|font\/\w+|image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp|x-icon)|video\/(?:mpeg|mp4|ogg|webm|quicktime|x-matroska))(?:;\w+=(?:\w+|"[\w;,= ]+"))*$/i, goog.html.SafeUrl.isSafeMimeType = function(e) {
              return goog.html.SAFE_MIME_TYPE_PATTERN_.test(e);
            }, goog.html.SafeUrl.fromBlob = function(e) {
              return e = goog.html.SafeUrl.isSafeMimeType(e.type) ? goog.fs.url.createObjectUrl(e) : goog.html.SafeUrl.INNOCUOUS_STRING, goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(e);
            }, goog.html.SafeUrl.revokeObjectUrl = function(e) {
              e = e.getTypedStringValue(), e !== goog.html.SafeUrl.INNOCUOUS_STRING && goog.fs.url.revokeObjectUrl(e);
            }, goog.html.SafeUrl.fromMediaSource = function(e) {
              return goog.asserts.assert("MediaSource" in goog.global, "No support for MediaSource"), e = e instanceof MediaSource ? goog.fs.url.createObjectUrl(e) : goog.html.SafeUrl.INNOCUOUS_STRING, goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(e);
            }, goog.html.DATA_URL_PATTERN_ = /^data:(.*);base64,[a-z0-9+\/]+=*$/i, goog.html.SafeUrl.tryFromDataUrl = function(e) {
              e = String(e), e = e.replace(/(%0A|%0D)/g, "");
              var t = e.match(goog.html.DATA_URL_PATTERN_);
              return t && goog.html.SafeUrl.isSafeMimeType(t[1]) ? goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(e) : null;
            }, goog.html.SafeUrl.fromDataUrl = function(e) {
              return goog.html.SafeUrl.tryFromDataUrl(e) || goog.html.SafeUrl.INNOCUOUS_URL;
            }, goog.html.SafeUrl.fromTelUrl = function(e) {
              return goog.string.internal.caseInsensitiveStartsWith(e, "tel:") || (e = goog.html.SafeUrl.INNOCUOUS_STRING), goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(e);
            }, goog.html.SIP_URL_PATTERN_ = /^sip[s]?:[+a-z0-9_.!$%&'*\/=^`{|}~-]+@([a-z0-9-]+\.)+[a-z0-9]{2,63}$/i, goog.html.SafeUrl.fromSipUrl = function(e) {
              return goog.html.SIP_URL_PATTERN_.test(decodeURIComponent(e)) || (e = goog.html.SafeUrl.INNOCUOUS_STRING), goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(e);
            }, goog.html.SafeUrl.fromFacebookMessengerUrl = function(e) {
              return goog.string.internal.caseInsensitiveStartsWith(e, "fb-messenger://share") || (e = goog.html.SafeUrl.INNOCUOUS_STRING), goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(e);
            }, goog.html.SafeUrl.fromWhatsAppUrl = function(e) {
              return goog.string.internal.caseInsensitiveStartsWith(e, "whatsapp://send") || (e = goog.html.SafeUrl.INNOCUOUS_STRING), goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(e);
            }, goog.html.SafeUrl.fromSmsUrl = function(e) {
              return goog.string.internal.caseInsensitiveStartsWith(e, "sms:") && goog.html.SafeUrl.isSmsUrlBodyValid_(e) || (e = goog.html.SafeUrl.INNOCUOUS_STRING), goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(e);
            }, goog.html.SafeUrl.isSmsUrlBodyValid_ = function(e) {
              var t = e.indexOf("#");
              if (0 < t && (e = e.substring(0, t)), t = e.match(/[?&]body=/gi), !t) return !0;
              if (1 < t.length) return !1;
              if (e = e.match(/[?&]body=([^&]*)/)[1], !e) return !0;
              try {
                decodeURIComponent(e);
              } catch {
                return !1;
              }
              return /^(?:[a-z0-9\-_.~]|%[0-9a-f]{2})+$/i.test(e);
            }, goog.html.SafeUrl.fromSshUrl = function(e) {
              return goog.string.internal.caseInsensitiveStartsWith(e, "ssh://") || (e = goog.html.SafeUrl.INNOCUOUS_STRING), goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(e);
            }, goog.html.SafeUrl.sanitizeChromeExtensionUrl = function(e, t) {
              return goog.html.SafeUrl.sanitizeExtensionUrl_(/^chrome-extension:\/\/([^\/]+)\//, e, t);
            }, goog.html.SafeUrl.sanitizeFirefoxExtensionUrl = function(e, t) {
              return goog.html.SafeUrl.sanitizeExtensionUrl_(/^moz-extension:\/\/([^\/]+)\//, e, t);
            }, goog.html.SafeUrl.sanitizeEdgeExtensionUrl = function(e, t) {
              return goog.html.SafeUrl.sanitizeExtensionUrl_(/^ms-browser-extension:\/\/([^\/]+)\//, e, t);
            }, goog.html.SafeUrl.sanitizeExtensionUrl_ = function(e, t, o) {
              return (e = e.exec(t)) ? (e = e[1], (o instanceof goog.string.Const ? [goog.string.Const.unwrap(o)] : o.map(function(n) {
                return goog.string.Const.unwrap(n);
              })).indexOf(e) == -1 && (t = goog.html.SafeUrl.INNOCUOUS_STRING)) : t = goog.html.SafeUrl.INNOCUOUS_STRING, goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(t);
            }, goog.html.SafeUrl.fromTrustedResourceUrl = function(e) {
              return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(goog.html.TrustedResourceUrl.unwrap(e));
            }, goog.html.SAFE_URL_PATTERN_ = /^(?:(?:https?|mailto|ftp):|[^:/?#]*(?:[/?#]|$))/i, goog.html.SafeUrl.SAFE_URL_PATTERN = goog.html.SAFE_URL_PATTERN_, goog.html.SafeUrl.trySanitize = function(e) {
              return e instanceof goog.html.SafeUrl ? e : (e = typeof e == "object" && e.implementsGoogStringTypedString ? e.getTypedStringValue() : String(e), goog.html.SAFE_URL_PATTERN_.test(e) ? goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(e) : goog.html.SafeUrl.tryFromDataUrl(e));
            }, goog.html.SafeUrl.sanitize = function(e) {
              return goog.html.SafeUrl.trySanitize(e) || goog.html.SafeUrl.INNOCUOUS_URL;
            }, goog.html.SafeUrl.sanitizeAssertUnchanged = function(e, t) {
              return e instanceof goog.html.SafeUrl ? e : (e = typeof e == "object" && e.implementsGoogStringTypedString ? e.getTypedStringValue() : String(e), t && /^data:/i.test(e) && (t = goog.html.SafeUrl.fromDataUrl(e), t.getTypedStringValue() == e) ? t : (goog.asserts.assert(goog.html.SAFE_URL_PATTERN_.test(e), "%s does not match the safe URL pattern", e) || (e = goog.html.SafeUrl.INNOCUOUS_STRING), goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(e)));
            }, goog.html.SafeUrl.CONSTRUCTOR_TOKEN_PRIVATE_ = {}, goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse = function(e) {
              return new goog.html.SafeUrl(e, goog.html.SafeUrl.CONSTRUCTOR_TOKEN_PRIVATE_);
            }, goog.html.SafeUrl.INNOCUOUS_URL = goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(goog.html.SafeUrl.INNOCUOUS_STRING), goog.html.SafeUrl.ABOUT_BLANK = goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse("about:blank"), goog.html.SafeStyle = function(e, t) {
              this.privateDoNotAccessOrElseSafeStyleWrappedValue_ = t === goog.html.SafeStyle.CONSTRUCTOR_TOKEN_PRIVATE_ ? e : "";
            }, goog.html.SafeStyle.prototype.implementsGoogStringTypedString = !0, goog.html.SafeStyle.fromConstant = function(e) {
              return e = goog.string.Const.unwrap(e), e.length === 0 ? goog.html.SafeStyle.EMPTY : (goog.asserts.assert(goog.string.internal.endsWith(e, ";"), "Last character of style string is not ';': " + e), goog.asserts.assert(goog.string.internal.contains(e, ":"), `Style string must contain at least one ':', to specify a "name: value" pair: ` + e), goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(e));
            }, goog.html.SafeStyle.prototype.getTypedStringValue = function() {
              return this.privateDoNotAccessOrElseSafeStyleWrappedValue_;
            }, goog.DEBUG && (goog.html.SafeStyle.prototype.toString = function() {
              return "SafeStyle{" + this.privateDoNotAccessOrElseSafeStyleWrappedValue_ + "}";
            }), goog.html.SafeStyle.unwrap = function(e) {
              return e instanceof goog.html.SafeStyle && e.constructor === goog.html.SafeStyle ? e.privateDoNotAccessOrElseSafeStyleWrappedValue_ : (goog.asserts.fail("expected object of type SafeStyle, got '" + e + "' of type " + goog.typeOf(e)), "type_error:SafeStyle");
            }, goog.html.SafeStyle.CONSTRUCTOR_TOKEN_PRIVATE_ = {}, goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse = function(e) {
              return new goog.html.SafeStyle(e, goog.html.SafeStyle.CONSTRUCTOR_TOKEN_PRIVATE_);
            }, goog.html.SafeStyle.EMPTY = goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(""), goog.html.SafeStyle.INNOCUOUS_STRING = "zClosurez", goog.html.SafeStyle.create = function(e) {
              var t = "", o;
              for (o in e) if (Object.prototype.hasOwnProperty.call(e, o)) {
                if (!/^[-_a-zA-Z0-9]+$/.test(o)) throw Error("Name allows only [-_a-zA-Z0-9], got: " + o);
                var n = e[o];
                n != null && (n = Array.isArray(n) ? module$contents$goog$array_map(n, goog.html.SafeStyle.sanitizePropertyValue_).join(" ") : goog.html.SafeStyle.sanitizePropertyValue_(n), t += o + ":" + n + ";");
              }
              return t ? goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(t) : goog.html.SafeStyle.EMPTY;
            }, goog.html.SafeStyle.sanitizePropertyValue_ = function(e) {
              if (e instanceof goog.html.SafeUrl) return 'url("' + goog.html.SafeUrl.unwrap(e).replace(/</g, "%3c").replace(/[\\"]/g, "\\$&") + '")';
              if (e = e instanceof goog.string.Const ? goog.string.Const.unwrap(e) : goog.html.SafeStyle.sanitizePropertyValueString_(String(e)), /[{;}]/.test(e)) throw new goog.asserts.AssertionError("Value does not allow [{;}], got: %s.", [e]);
              return e;
            }, goog.html.SafeStyle.sanitizePropertyValueString_ = function(e) {
              var t = e.replace(goog.html.SafeStyle.FUNCTIONS_RE_, "$1").replace(goog.html.SafeStyle.FUNCTIONS_RE_, "$1").replace(goog.html.SafeStyle.URL_RE_, "url");
              if (goog.html.SafeStyle.VALUE_RE_.test(t)) {
                if (goog.html.SafeStyle.COMMENT_RE_.test(e)) return goog.asserts.fail("String value disallows comments, got: " + e), goog.html.SafeStyle.INNOCUOUS_STRING;
                if (!goog.html.SafeStyle.hasBalancedQuotes_(e)) return goog.asserts.fail("String value requires balanced quotes, got: " + e), goog.html.SafeStyle.INNOCUOUS_STRING;
                if (!goog.html.SafeStyle.hasBalancedSquareBrackets_(e)) return goog.asserts.fail("String value requires balanced square brackets and one identifier per pair of brackets, got: " + e), goog.html.SafeStyle.INNOCUOUS_STRING;
              } else return goog.asserts.fail("String value allows only " + goog.html.SafeStyle.VALUE_ALLOWED_CHARS_ + " and simple functions, got: " + e), goog.html.SafeStyle.INNOCUOUS_STRING;
              return goog.html.SafeStyle.sanitizeUrl_(e);
            }, goog.html.SafeStyle.hasBalancedQuotes_ = function(e) {
              for (var t = !0, o = !0, n = 0; n < e.length; n++) {
                var s = e.charAt(n);
                s == "'" && o ? t = !t : s == '"' && t && (o = !o);
              }
              return t && o;
            }, goog.html.SafeStyle.hasBalancedSquareBrackets_ = function(e) {
              for (var t = !0, o = /^[-_a-zA-Z0-9]$/, n = 0; n < e.length; n++) {
                var s = e.charAt(n);
                if (s == "]") {
                  if (t) return !1;
                  t = !0;
                } else if (s == "[") {
                  if (!t) return !1;
                  t = !1;
                } else if (!t && !o.test(s)) return !1;
              }
              return t;
            }, goog.html.SafeStyle.VALUE_ALLOWED_CHARS_ = `[-,."'%_!# a-zA-Z0-9\\[\\]]`, goog.html.SafeStyle.VALUE_RE_ = new RegExp("^" + goog.html.SafeStyle.VALUE_ALLOWED_CHARS_ + "+$"), goog.html.SafeStyle.URL_RE_ = /\b(url\([ \t\n]*)('[ -&(-\[\]-~]*'|"[ !#-\[\]-~]*"|[!#-&*-\[\]-~]*)([ \t\n]*\))/g, goog.html.SafeStyle.ALLOWED_FUNCTIONS_ = "calc cubic-bezier fit-content hsl hsla linear-gradient matrix minmax repeat rgb rgba (rotate|scale|translate)(X|Y|Z|3d)?".split(" "), goog.html.SafeStyle.FUNCTIONS_RE_ = new RegExp("\\b(" + goog.html.SafeStyle.ALLOWED_FUNCTIONS_.join("|") + ")\\([-+*/0-9a-z.%\\[\\], ]+\\)", "g"), goog.html.SafeStyle.COMMENT_RE_ = /\/\*/, goog.html.SafeStyle.sanitizeUrl_ = function(e) {
              return e.replace(goog.html.SafeStyle.URL_RE_, function(t, o, n, s) {
                var i = "";
                return n = n.replace(/^(['"])(.*)\1$/, function(l, d, u) {
                  return i = d, u;
                }), t = goog.html.SafeUrl.sanitize(n).getTypedStringValue(), o + i + t + i + s;
              });
            }, goog.html.SafeStyle.concat = function(e) {
              var t = "", o = function(n) {
                Array.isArray(n) ? module$contents$goog$array_forEach(n, o) : t += goog.html.SafeStyle.unwrap(n);
              };
              return module$contents$goog$array_forEach(arguments, o), t ? goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(t) : goog.html.SafeStyle.EMPTY;
            };
            var module$contents$goog$html$SafeStyleSheet_CONSTRUCTOR_TOKEN_PRIVATE = {}, module$contents$goog$html$SafeStyleSheet_SafeStyleSheet = function(e, t) {
              this.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_ = t === module$contents$goog$html$SafeStyleSheet_CONSTRUCTOR_TOKEN_PRIVATE ? e : "", this.implementsGoogStringTypedString = !0;
            };
            module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.createRule = function(e, t) {
              if ((0, goog.string.internal.contains)(e, "<")) throw Error("Selector does not allow '<', got: " + e);
              var o = e.replace(/('|")((?!\1)[^\r\n\f\\]|\\[\s\S])*\1/g, "");
              if (!/^[-_a-zA-Z0-9#.:* ,>+~[\]()=^$|]+$/.test(o)) throw Error("Selector allows only [-_a-zA-Z0-9#.:* ,>+~[\\]()=^$|] and strings, got: " + e);
              if (!module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.hasBalancedBrackets_(o)) throw Error("() and [] in selector must be balanced, got: " + e);
              return t instanceof goog.html.SafeStyle || (t = goog.html.SafeStyle.create(t)), e = e + "{" + goog.html.SafeStyle.unwrap(t).replace(/</g, "\\3C ") + "}", module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse(e);
            }, module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.hasBalancedBrackets_ = function(e) {
              for (var t = { "(": ")", "[": "]" }, o = [], n = 0; n < e.length; n++) {
                var s = e[n];
                if (t[s]) o.push(t[s]);
                else if (goog.object.contains(t, s) && o.pop() != s) return !1;
              }
              return o.length == 0;
            }, module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.concat = function(e) {
              var t = "", o = function(n) {
                Array.isArray(n) ? module$contents$goog$array_forEach(n, o) : t += module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.unwrap(n);
              };
              return module$contents$goog$array_forEach(arguments, o), module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse(t);
            }, module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.fromConstant = function(e) {
              return e = goog.string.Const.unwrap(e), e.length === 0 ? module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.EMPTY : ((0, goog.asserts.assert)(!(0, goog.string.internal.contains)(e, "<"), "Forbidden '<' character in style sheet string: " + e), module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse(e));
            }, module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.prototype.getTypedStringValue = function() {
              return this.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_;
            }, module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.unwrap = function(e) {
              return e instanceof module$contents$goog$html$SafeStyleSheet_SafeStyleSheet && e.constructor === module$contents$goog$html$SafeStyleSheet_SafeStyleSheet ? e.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_ : ((0, goog.asserts.fail)("expected object of type SafeStyleSheet, got '" + e + "' of type " + goog.typeOf(e)), "type_error:SafeStyleSheet");
            }, module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse = function(e) {
              return new module$contents$goog$html$SafeStyleSheet_SafeStyleSheet(e, module$contents$goog$html$SafeStyleSheet_CONSTRUCTOR_TOKEN_PRIVATE);
            }, goog.DEBUG && (module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.prototype.toString = function() {
              return "SafeStyleSheet{" + this.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_ + "}";
            }), module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.EMPTY = module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse(""), goog.html.SafeStyleSheet = module$contents$goog$html$SafeStyleSheet_SafeStyleSheet, goog.labs = {}, goog.labs.userAgent = {}, goog.labs.userAgent.util = {}, goog.labs.userAgent.util.getNativeUserAgentString_ = function() {
              var e = goog.labs.userAgent.util.getNavigator_();
              return e && (e = e.userAgent) ? e : "";
            }, goog.labs.userAgent.util.getNavigator_ = function() {
              return goog.global.navigator;
            }, goog.labs.userAgent.util.userAgent_ = goog.labs.userAgent.util.getNativeUserAgentString_(), goog.labs.userAgent.util.setUserAgent = function(e) {
              goog.labs.userAgent.util.userAgent_ = e || goog.labs.userAgent.util.getNativeUserAgentString_();
            }, goog.labs.userAgent.util.getUserAgent = function() {
              return goog.labs.userAgent.util.userAgent_;
            }, goog.labs.userAgent.util.matchUserAgent = function(e) {
              var t = goog.labs.userAgent.util.getUserAgent();
              return goog.string.internal.contains(t, e);
            }, goog.labs.userAgent.util.matchUserAgentIgnoreCase = function(e) {
              var t = goog.labs.userAgent.util.getUserAgent();
              return goog.string.internal.caseInsensitiveContains(t, e);
            }, goog.labs.userAgent.util.extractVersionTuples = function(e) {
              for (var t = /(\w[\w ]+)\/([^\s]+)\s*(?:\((.*?)\))?/g, o = [], n; n = t.exec(e); ) o.push([n[1], n[2], n[3] || void 0]);
              return o;
            }, goog.labs.userAgent.browser = {}, goog.labs.userAgent.browser.matchOpera_ = function() {
              return goog.labs.userAgent.util.matchUserAgent("Opera");
            }, goog.labs.userAgent.browser.matchIE_ = function() {
              return goog.labs.userAgent.util.matchUserAgent("Trident") || goog.labs.userAgent.util.matchUserAgent("MSIE");
            }, goog.labs.userAgent.browser.matchEdgeHtml_ = function() {
              return goog.labs.userAgent.util.matchUserAgent("Edge");
            }, goog.labs.userAgent.browser.matchEdgeChromium_ = function() {
              return goog.labs.userAgent.util.matchUserAgent("Edg/");
            }, goog.labs.userAgent.browser.matchOperaChromium_ = function() {
              return goog.labs.userAgent.util.matchUserAgent("OPR");
            }, goog.labs.userAgent.browser.matchFirefox_ = function() {
              return goog.labs.userAgent.util.matchUserAgent("Firefox") || goog.labs.userAgent.util.matchUserAgent("FxiOS");
            }, goog.labs.userAgent.browser.matchSafari_ = function() {
              return goog.labs.userAgent.util.matchUserAgent("Safari") && !(goog.labs.userAgent.browser.matchChrome_() || goog.labs.userAgent.browser.matchCoast_() || goog.labs.userAgent.browser.matchOpera_() || goog.labs.userAgent.browser.matchEdgeHtml_() || goog.labs.userAgent.browser.matchEdgeChromium_() || goog.labs.userAgent.browser.matchOperaChromium_() || goog.labs.userAgent.browser.matchFirefox_() || goog.labs.userAgent.browser.isSilk() || goog.labs.userAgent.util.matchUserAgent("Android"));
            }, goog.labs.userAgent.browser.matchCoast_ = function() {
              return goog.labs.userAgent.util.matchUserAgent("Coast");
            }, goog.labs.userAgent.browser.matchIosWebview_ = function() {
              return (goog.labs.userAgent.util.matchUserAgent("iPad") || goog.labs.userAgent.util.matchUserAgent("iPhone")) && !goog.labs.userAgent.browser.matchSafari_() && !goog.labs.userAgent.browser.matchChrome_() && !goog.labs.userAgent.browser.matchCoast_() && !goog.labs.userAgent.browser.matchFirefox_() && goog.labs.userAgent.util.matchUserAgent("AppleWebKit");
            }, goog.labs.userAgent.browser.matchChrome_ = function() {
              return (goog.labs.userAgent.util.matchUserAgent("Chrome") || goog.labs.userAgent.util.matchUserAgent("CriOS")) && !goog.labs.userAgent.browser.matchEdgeHtml_();
            }, goog.labs.userAgent.browser.matchAndroidBrowser_ = function() {
              return goog.labs.userAgent.util.matchUserAgent("Android") && !(goog.labs.userAgent.browser.isChrome() || goog.labs.userAgent.browser.isFirefox() || goog.labs.userAgent.browser.isOpera() || goog.labs.userAgent.browser.isSilk());
            }, goog.labs.userAgent.browser.isOpera = goog.labs.userAgent.browser.matchOpera_, goog.labs.userAgent.browser.isIE = goog.labs.userAgent.browser.matchIE_, goog.labs.userAgent.browser.isEdge = goog.labs.userAgent.browser.matchEdgeHtml_, goog.labs.userAgent.browser.isEdgeChromium = goog.labs.userAgent.browser.matchEdgeChromium_, goog.labs.userAgent.browser.isOperaChromium = goog.labs.userAgent.browser.matchOperaChromium_, goog.labs.userAgent.browser.isFirefox = goog.labs.userAgent.browser.matchFirefox_, goog.labs.userAgent.browser.isSafari = goog.labs.userAgent.browser.matchSafari_, goog.labs.userAgent.browser.isCoast = goog.labs.userAgent.browser.matchCoast_, goog.labs.userAgent.browser.isIosWebview = goog.labs.userAgent.browser.matchIosWebview_, goog.labs.userAgent.browser.isChrome = goog.labs.userAgent.browser.matchChrome_, goog.labs.userAgent.browser.isAndroidBrowser = goog.labs.userAgent.browser.matchAndroidBrowser_, goog.labs.userAgent.browser.isSilk = function() {
              return goog.labs.userAgent.util.matchUserAgent("Silk");
            }, goog.labs.userAgent.browser.getVersion = function() {
              function e(s) {
                return s = module$contents$goog$array_find(s, n), o[s] || "";
              }
              var t = goog.labs.userAgent.util.getUserAgent();
              if (goog.labs.userAgent.browser.isIE()) return goog.labs.userAgent.browser.getIEVersion_(t);
              t = goog.labs.userAgent.util.extractVersionTuples(t);
              var o = {};
              module$contents$goog$array_forEach(t, function(s) {
                o[s[0]] = s[1];
              });
              var n = goog.partial(goog.object.containsKey, o);
              return goog.labs.userAgent.browser.isOpera() ? e(["Version", "Opera"]) : goog.labs.userAgent.browser.isEdge() ? e(["Edge"]) : goog.labs.userAgent.browser.isEdgeChromium() ? e(["Edg"]) : goog.labs.userAgent.browser.isChrome() ? e(["Chrome", "CriOS", "HeadlessChrome"]) : (t = t[2]) && t[1] || "";
            }, goog.labs.userAgent.browser.isVersionOrHigher = function(e) {
              return 0 <= goog.string.internal.compareVersions(goog.labs.userAgent.browser.getVersion(), e);
            }, goog.labs.userAgent.browser.getIEVersion_ = function(e) {
              var t = /rv: *([\d\.]*)/.exec(e);
              if (t && t[1]) return t[1];
              t = "";
              var o = /MSIE +([\d\.]+)/.exec(e);
              if (o && o[1]) if (e = /Trident\/(\d.\d)/.exec(e), o[1] == "7.0") if (e && e[1]) switch (e[1]) {
                case "4.0":
                  t = "8.0";
                  break;
                case "5.0":
                  t = "9.0";
                  break;
                case "6.0":
                  t = "10.0";
                  break;
                case "7.0":
                  t = "11.0";
              }
              else t = "7.0";
              else t = o[1];
              return t;
            }, goog.html.SafeHtml = function(e, t, o) {
              this.privateDoNotAccessOrElseSafeHtmlWrappedValue_ = o === goog.html.SafeHtml.CONSTRUCTOR_TOKEN_PRIVATE_ ? e : "", this.dir_ = t;
            }, goog.html.SafeHtml.ENABLE_ERROR_MESSAGES = goog.DEBUG, goog.html.SafeHtml.SUPPORT_STYLE_ATTRIBUTE = !0, goog.html.SafeHtml.prototype.implementsGoogI18nBidiDirectionalString = !0, goog.html.SafeHtml.prototype.getDirection = function() {
              return this.dir_;
            }, goog.html.SafeHtml.prototype.implementsGoogStringTypedString = !0, goog.html.SafeHtml.prototype.getTypedStringValue = function() {
              return this.privateDoNotAccessOrElseSafeHtmlWrappedValue_.toString();
            }, goog.DEBUG && (goog.html.SafeHtml.prototype.toString = function() {
              return "SafeHtml{" + this.privateDoNotAccessOrElseSafeHtmlWrappedValue_ + "}";
            }), goog.html.SafeHtml.unwrap = function(e) {
              return goog.html.SafeHtml.unwrapTrustedHTML(e).toString();
            }, goog.html.SafeHtml.unwrapTrustedHTML = function(e) {
              return e instanceof goog.html.SafeHtml && e.constructor === goog.html.SafeHtml ? e.privateDoNotAccessOrElseSafeHtmlWrappedValue_ : (goog.asserts.fail("expected object of type SafeHtml, got '" + e + "' of type " + goog.typeOf(e)), "type_error:SafeHtml");
            }, goog.html.SafeHtml.htmlEscape = function(e) {
              if (e instanceof goog.html.SafeHtml) return e;
              var t = typeof e == "object", o = null;
              return t && e.implementsGoogI18nBidiDirectionalString && (o = e.getDirection()), e = t && e.implementsGoogStringTypedString ? e.getTypedStringValue() : String(e), goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(goog.string.internal.htmlEscape(e), o);
            }, goog.html.SafeHtml.htmlEscapePreservingNewlines = function(e) {
              return e instanceof goog.html.SafeHtml ? e : (e = goog.html.SafeHtml.htmlEscape(e), goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(goog.string.internal.newLineToBr(goog.html.SafeHtml.unwrap(e)), e.getDirection()));
            }, goog.html.SafeHtml.htmlEscapePreservingNewlinesAndSpaces = function(e) {
              return e instanceof goog.html.SafeHtml ? e : (e = goog.html.SafeHtml.htmlEscape(e), goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(goog.string.internal.whitespaceEscape(goog.html.SafeHtml.unwrap(e)), e.getDirection()));
            }, goog.html.SafeHtml.from = goog.html.SafeHtml.htmlEscape, goog.html.SafeHtml.comment = function(e) {
              return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse("<!--" + goog.string.internal.htmlEscape(e) + "-->", null);
            }, goog.html.SafeHtml.VALID_NAMES_IN_TAG_ = /^[a-zA-Z0-9-]+$/, goog.html.SafeHtml.URL_ATTRIBUTES_ = { action: !0, cite: !0, data: !0, formaction: !0, href: !0, manifest: !0, poster: !0, src: !0 }, goog.html.SafeHtml.NOT_ALLOWED_TAG_NAMES_ = goog.object.createSet(goog.dom.TagName.APPLET, goog.dom.TagName.BASE, goog.dom.TagName.EMBED, goog.dom.TagName.IFRAME, goog.dom.TagName.LINK, goog.dom.TagName.MATH, goog.dom.TagName.META, goog.dom.TagName.OBJECT, goog.dom.TagName.SCRIPT, goog.dom.TagName.STYLE, goog.dom.TagName.SVG, goog.dom.TagName.TEMPLATE), goog.html.SafeHtml.create = function(e, t, o) {
              return goog.html.SafeHtml.verifyTagName(String(e)), goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse(String(e), t, o);
            }, goog.html.SafeHtml.verifyTagName = function(e) {
              if (!goog.html.SafeHtml.VALID_NAMES_IN_TAG_.test(e)) throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? "Invalid tag name <" + e + ">." : "");
              if (e.toUpperCase() in goog.html.SafeHtml.NOT_ALLOWED_TAG_NAMES_) throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? "Tag name <" + e + "> is not allowed for SafeHtml." : "");
            }, goog.html.SafeHtml.createIframe = function(e, t, o, n) {
              e && goog.html.TrustedResourceUrl.unwrap(e);
              var s = {};
              return s.src = e || null, s.srcdoc = t && goog.html.SafeHtml.unwrap(t), e = goog.html.SafeHtml.combineAttributes(s, { sandbox: "" }, o), goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("iframe", e, n);
            }, goog.html.SafeHtml.createSandboxIframe = function(e, t, o, n) {
              if (!goog.html.SafeHtml.canUseSandboxIframe()) throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? "The browser does not support sandboxed iframes." : "");
              var s = {};
              return s.src = e ? goog.html.SafeUrl.unwrap(goog.html.SafeUrl.sanitize(e)) : null, s.srcdoc = t || null, s.sandbox = "", e = goog.html.SafeHtml.combineAttributes(s, {}, o), goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("iframe", e, n);
            }, goog.html.SafeHtml.canUseSandboxIframe = function() {
              return goog.global.HTMLIFrameElement && "sandbox" in goog.global.HTMLIFrameElement.prototype;
            }, goog.html.SafeHtml.createScriptSrc = function(e, t) {
              return goog.html.TrustedResourceUrl.unwrap(e), e = goog.html.SafeHtml.combineAttributes({ src: e }, {}, t), goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("script", e);
            }, goog.html.SafeHtml.createScript = function(e, t) {
              for (var o in t) if (Object.prototype.hasOwnProperty.call(t, o)) {
                var n = o.toLowerCase();
                if (n == "language" || n == "src" || n == "text" || n == "type") throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? 'Cannot set "' + n + '" attribute' : "");
              }
              for (o = "", e = module$contents$goog$array_concat(e), n = 0; n < e.length; n++) o += module$contents$goog$html$SafeScript_SafeScript.unwrap(e[n]);
              return e = goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(o, goog.i18n.bidi.Dir.NEUTRAL), goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse(
                "script",
                t,
                e
              );
            }, goog.html.SafeHtml.createStyle = function(e, t) {
              t = goog.html.SafeHtml.combineAttributes({ type: "text/css" }, {}, t);
              var o = "";
              e = module$contents$goog$array_concat(e);
              for (var n = 0; n < e.length; n++) o += module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.unwrap(e[n]);
              return e = goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(o, goog.i18n.bidi.Dir.NEUTRAL), goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("style", t, e);
            }, goog.html.SafeHtml.createMetaRefresh = function(e, t) {
              return e = goog.html.SafeUrl.unwrap(goog.html.SafeUrl.sanitize(e)), (goog.labs.userAgent.browser.isIE() || goog.labs.userAgent.browser.isEdge()) && goog.string.internal.contains(e, ";") && (e = "'" + e.replace(/'/g, "%27") + "'"), goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("meta", { "http-equiv": "refresh", content: (t || 0) + "; url=" + e });
            }, goog.html.SafeHtml.getAttrNameAndValue_ = function(e, t, o) {
              if (o instanceof goog.string.Const) o = goog.string.Const.unwrap(o);
              else if (t.toLowerCase() == "style") if (goog.html.SafeHtml.SUPPORT_STYLE_ATTRIBUTE) o = goog.html.SafeHtml.getStyleValue_(o);
              else throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? 'Attribute "style" not supported.' : "");
              else {
                if (/^on/i.test(t)) throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? 'Attribute "' + t + '" requires goog.string.Const value, "' + o + '" given.' : "");
                if (t.toLowerCase() in goog.html.SafeHtml.URL_ATTRIBUTES_) if (o instanceof goog.html.TrustedResourceUrl) o = goog.html.TrustedResourceUrl.unwrap(o);
                else if (o instanceof goog.html.SafeUrl) o = goog.html.SafeUrl.unwrap(o);
                else if (typeof o == "string") o = goog.html.SafeUrl.sanitize(o).getTypedStringValue();
                else throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? 'Attribute "' + t + '" on tag "' + e + '" requires goog.html.SafeUrl, goog.string.Const, or string, value "' + o + '" given.' : "");
              }
              return o.implementsGoogStringTypedString && (o = o.getTypedStringValue()), goog.asserts.assert(typeof o == "string" || typeof o == "number", "String or number value expected, got " + typeof o + " with value: " + o), t + '="' + goog.string.internal.htmlEscape(String(o)) + '"';
            }, goog.html.SafeHtml.getStyleValue_ = function(e) {
              if (!goog.isObject(e)) throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? 'The "style" attribute requires goog.html.SafeStyle or map of style properties, ' + typeof e + " given: " + e : "");
              return e instanceof goog.html.SafeStyle || (e = goog.html.SafeStyle.create(e)), goog.html.SafeStyle.unwrap(e);
            }, goog.html.SafeHtml.createWithDir = function(e, t, o, n) {
              return t = goog.html.SafeHtml.create(t, o, n), t.dir_ = e, t;
            }, goog.html.SafeHtml.join = function(e, t) {
              e = goog.html.SafeHtml.htmlEscape(e);
              var o = e.getDirection(), n = [], s = function(i) {
                Array.isArray(i) ? module$contents$goog$array_forEach(i, s) : (i = goog.html.SafeHtml.htmlEscape(i), n.push(goog.html.SafeHtml.unwrap(i)), i = i.getDirection(), o == goog.i18n.bidi.Dir.NEUTRAL ? o = i : i != goog.i18n.bidi.Dir.NEUTRAL && o != i && (o = null));
              };
              return module$contents$goog$array_forEach(t, s), goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(n.join(goog.html.SafeHtml.unwrap(e)), o);
            }, goog.html.SafeHtml.concat = function(e) {
              return goog.html.SafeHtml.join(goog.html.SafeHtml.EMPTY, Array.prototype.slice.call(arguments));
            }, goog.html.SafeHtml.concatWithDir = function(e, t) {
              var o = goog.html.SafeHtml.concat(module$contents$goog$array_slice(arguments, 1));
              return o.dir_ = e, o;
            }, goog.html.SafeHtml.CONSTRUCTOR_TOKEN_PRIVATE_ = {}, goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse = function(e, t) {
              var o = goog.html.trustedtypes.getPolicyPrivateDoNotAccessOrElse();
              return e = o ? o.createHTML(e) : e, new goog.html.SafeHtml(e, t, goog.html.SafeHtml.CONSTRUCTOR_TOKEN_PRIVATE_);
            }, goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse = function(e, t, o) {
              var n = null, s = "<" + e + goog.html.SafeHtml.stringifyAttributes(e, t);
              return o == null ? o = [] : Array.isArray(o) || (o = [o]), goog.dom.tags.isVoidTag(e.toLowerCase()) ? (goog.asserts.assert(!o.length, "Void tag <" + e + "> does not allow content."), s += ">") : (n = goog.html.SafeHtml.concat(o), s += ">" + goog.html.SafeHtml.unwrap(n) + "</" + e + ">", n = n.getDirection()), (e = t && t.dir) && (n = /^(ltr|rtl|auto)$/i.test(e) ? goog.i18n.bidi.Dir.NEUTRAL : null), goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(
                s,
                n
              );
            }, goog.html.SafeHtml.stringifyAttributes = function(e, t) {
              var o = "";
              if (t) {
                for (var n in t) if (Object.prototype.hasOwnProperty.call(t, n)) {
                  if (!goog.html.SafeHtml.VALID_NAMES_IN_TAG_.test(n)) throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? 'Invalid attribute name "' + n + '".' : "");
                  var s = t[n];
                  s != null && (o += " " + goog.html.SafeHtml.getAttrNameAndValue_(e, n, s));
                }
              }
              return o;
            }, goog.html.SafeHtml.combineAttributes = function(e, t, o) {
              var n = {}, s;
              for (s in e) Object.prototype.hasOwnProperty.call(e, s) && (goog.asserts.assert(s.toLowerCase() == s, "Must be lower case"), n[s] = e[s]);
              for (s in t) Object.prototype.hasOwnProperty.call(t, s) && (goog.asserts.assert(s.toLowerCase() == s, "Must be lower case"), n[s] = t[s]);
              if (o) {
                for (s in o) if (Object.prototype.hasOwnProperty.call(o, s)) {
                  var i = s.toLowerCase();
                  if (i in e) throw Error(goog.html.SafeHtml.ENABLE_ERROR_MESSAGES ? 'Cannot override "' + i + '" attribute, got "' + s + '" with value "' + o[s] + '"' : "");
                  i in t && delete n[i], n[s] = o[s];
                }
              }
              return n;
            }, goog.html.SafeHtml.DOCTYPE_HTML = (function() {
              return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse("<!DOCTYPE html>", goog.i18n.bidi.Dir.NEUTRAL);
            })(), goog.html.SafeHtml.EMPTY = new goog.html.SafeHtml(goog.global.trustedTypes && goog.global.trustedTypes.emptyHTML || "", goog.i18n.bidi.Dir.NEUTRAL, goog.html.SafeHtml.CONSTRUCTOR_TOKEN_PRIVATE_), goog.html.SafeHtml.BR = (function() {
              return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse("<br>", goog.i18n.bidi.Dir.NEUTRAL);
            })(), goog.html.uncheckedconversions = {}, goog.html.uncheckedconversions.safeHtmlFromStringKnownToSatisfyTypeContract = function(e, t, o) {
              return goog.asserts.assertString(goog.string.Const.unwrap(e), "must provide justification"), goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(e)), "must provide non-empty justification"), goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(t, o || null);
            }, goog.html.uncheckedconversions.safeScriptFromStringKnownToSatisfyTypeContract = function(e, t) {
              return goog.asserts.assertString(goog.string.Const.unwrap(e), "must provide justification"), goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(e)), "must provide non-empty justification"), module$contents$goog$html$SafeScript_SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse(t);
            }, goog.html.uncheckedconversions.safeStyleFromStringKnownToSatisfyTypeContract = function(e, t) {
              return goog.asserts.assertString(goog.string.Const.unwrap(e), "must provide justification"), goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(e)), "must provide non-empty justification"), goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(t);
            }, goog.html.uncheckedconversions.safeStyleSheetFromStringKnownToSatisfyTypeContract = function(e, t) {
              return goog.asserts.assertString(goog.string.Const.unwrap(e), "must provide justification"), goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(e)), "must provide non-empty justification"), module$contents$goog$html$SafeStyleSheet_SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse(t);
            }, goog.html.uncheckedconversions.safeUrlFromStringKnownToSatisfyTypeContract = function(e, t) {
              return goog.asserts.assertString(goog.string.Const.unwrap(e), "must provide justification"), goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(e)), "must provide non-empty justification"), goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(t);
            }, goog.html.uncheckedconversions.trustedResourceUrlFromStringKnownToSatisfyTypeContract = function(e, t) {
              return goog.asserts.assertString(goog.string.Const.unwrap(e), "must provide justification"), goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(e)), "must provide non-empty justification"), goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(t);
            }, goog.dom.safe = {}, goog.dom.safe.InsertAdjacentHtmlPosition = { AFTERBEGIN: "afterbegin", AFTEREND: "afterend", BEFOREBEGIN: "beforebegin", BEFOREEND: "beforeend" }, goog.dom.safe.insertAdjacentHtml = function(e, t, o) {
              e.insertAdjacentHTML(t, goog.html.SafeHtml.unwrapTrustedHTML(o));
            }, goog.dom.safe.SET_INNER_HTML_DISALLOWED_TAGS_ = { MATH: !0, SCRIPT: !0, STYLE: !0, SVG: !0, TEMPLATE: !0 }, goog.dom.safe.isInnerHtmlCleanupRecursive_ = goog.functions.cacheReturnValue(function() {
              if (goog.DEBUG && typeof document > "u") return !1;
              var e = document.createElement("div"), t = document.createElement("div");
              return t.appendChild(document.createElement("div")), e.appendChild(t), goog.DEBUG && !e.firstChild ? !1 : (t = e.firstChild.firstChild, e.innerHTML = goog.html.SafeHtml.unwrapTrustedHTML(goog.html.SafeHtml.EMPTY), !t.parentElement);
            }), goog.dom.safe.unsafeSetInnerHtmlDoNotUseOrElse = function(e, t) {
              if (goog.dom.safe.isInnerHtmlCleanupRecursive_()) for (; e.lastChild; ) e.removeChild(e.lastChild);
              e.innerHTML = goog.html.SafeHtml.unwrapTrustedHTML(t);
            }, goog.dom.safe.setInnerHtml = function(e, t) {
              if (goog.asserts.ENABLE_ASSERTS && e.tagName) {
                var o = e.tagName.toUpperCase();
                if (goog.dom.safe.SET_INNER_HTML_DISALLOWED_TAGS_[o]) throw Error("goog.dom.safe.setInnerHtml cannot be used to set content of " + e.tagName + ".");
              }
              goog.dom.safe.unsafeSetInnerHtmlDoNotUseOrElse(e, t);
            }, goog.dom.safe.setInnerHtmlFromConstant = function(e, t) {
              goog.dom.safe.setInnerHtml(e, goog.html.uncheckedconversions.safeHtmlFromStringKnownToSatisfyTypeContract(goog.string.Const.from("Constant HTML to be immediatelly used."), goog.string.Const.unwrap(t)));
            }, goog.dom.safe.setOuterHtml = function(e, t) {
              e.outerHTML = goog.html.SafeHtml.unwrapTrustedHTML(t);
            }, goog.dom.safe.setFormElementAction = function(e, t) {
              t = t instanceof goog.html.SafeUrl ? t : goog.html.SafeUrl.sanitizeAssertUnchanged(t), goog.dom.asserts.assertIsHTMLFormElement(e).action = goog.html.SafeUrl.unwrap(t);
            }, goog.dom.safe.setButtonFormAction = function(e, t) {
              t = t instanceof goog.html.SafeUrl ? t : goog.html.SafeUrl.sanitizeAssertUnchanged(t), goog.dom.asserts.assertIsHTMLButtonElement(e).formAction = goog.html.SafeUrl.unwrap(t);
            }, goog.dom.safe.setInputFormAction = function(e, t) {
              t = t instanceof goog.html.SafeUrl ? t : goog.html.SafeUrl.sanitizeAssertUnchanged(t), goog.dom.asserts.assertIsHTMLInputElement(e).formAction = goog.html.SafeUrl.unwrap(t);
            }, goog.dom.safe.setStyle = function(e, t) {
              e.style.cssText = goog.html.SafeStyle.unwrap(t);
            }, goog.dom.safe.documentWrite = function(e, t) {
              e.write(goog.html.SafeHtml.unwrapTrustedHTML(t));
            }, goog.dom.safe.setAnchorHref = function(e, t) {
              goog.dom.asserts.assertIsHTMLAnchorElement(e), t = t instanceof goog.html.SafeUrl ? t : goog.html.SafeUrl.sanitizeAssertUnchanged(t), e.href = goog.html.SafeUrl.unwrap(t);
            }, goog.dom.safe.setImageSrc = function(e, t) {
              if (goog.dom.asserts.assertIsHTMLImageElement(e), !(t instanceof goog.html.SafeUrl)) {
                var o = /^data:image\//i.test(t);
                t = goog.html.SafeUrl.sanitizeAssertUnchanged(t, o);
              }
              e.src = goog.html.SafeUrl.unwrap(t);
            }, goog.dom.safe.setAudioSrc = function(e, t) {
              if (goog.dom.asserts.assertIsHTMLAudioElement(e), !(t instanceof goog.html.SafeUrl)) {
                var o = /^data:audio\//i.test(t);
                t = goog.html.SafeUrl.sanitizeAssertUnchanged(t, o);
              }
              e.src = goog.html.SafeUrl.unwrap(t);
            }, goog.dom.safe.setVideoSrc = function(e, t) {
              if (goog.dom.asserts.assertIsHTMLVideoElement(e), !(t instanceof goog.html.SafeUrl)) {
                var o = /^data:video\//i.test(t);
                t = goog.html.SafeUrl.sanitizeAssertUnchanged(t, o);
              }
              e.src = goog.html.SafeUrl.unwrap(t);
            }, goog.dom.safe.setEmbedSrc = function(e, t) {
              goog.dom.asserts.assertIsHTMLEmbedElement(e), e.src = goog.html.TrustedResourceUrl.unwrapTrustedScriptURL(t);
            }, goog.dom.safe.setFrameSrc = function(e, t) {
              goog.dom.asserts.assertIsHTMLFrameElement(e), e.src = goog.html.TrustedResourceUrl.unwrap(t);
            }, goog.dom.safe.setIframeSrc = function(e, t) {
              goog.dom.asserts.assertIsHTMLIFrameElement(e), e.src = goog.html.TrustedResourceUrl.unwrap(t);
            }, goog.dom.safe.setIframeSrcdoc = function(e, t) {
              goog.dom.asserts.assertIsHTMLIFrameElement(e), e.srcdoc = goog.html.SafeHtml.unwrapTrustedHTML(t);
            }, goog.dom.safe.setLinkHrefAndRel = function(e, t, o) {
              goog.dom.asserts.assertIsHTMLLinkElement(e), e.rel = o, goog.string.internal.caseInsensitiveContains(o, "stylesheet") ? (goog.asserts.assert(t instanceof goog.html.TrustedResourceUrl, 'URL must be TrustedResourceUrl because "rel" contains "stylesheet"'), e.href = goog.html.TrustedResourceUrl.unwrap(t)) : e.href = t instanceof goog.html.TrustedResourceUrl ? goog.html.TrustedResourceUrl.unwrap(t) : t instanceof goog.html.SafeUrl ? goog.html.SafeUrl.unwrap(t) : goog.html.SafeUrl.unwrap(goog.html.SafeUrl.sanitizeAssertUnchanged(t));
            }, goog.dom.safe.setObjectData = function(e, t) {
              goog.dom.asserts.assertIsHTMLObjectElement(e), e.data = goog.html.TrustedResourceUrl.unwrapTrustedScriptURL(t);
            }, goog.dom.safe.setScriptSrc = function(e, t) {
              goog.dom.asserts.assertIsHTMLScriptElement(e), e.src = goog.html.TrustedResourceUrl.unwrapTrustedScriptURL(t), goog.dom.safe.setNonceForScriptElement_(e);
            }, goog.dom.safe.setScriptContent = function(e, t) {
              goog.dom.asserts.assertIsHTMLScriptElement(e), e.textContent = module$contents$goog$html$SafeScript_SafeScript.unwrapTrustedScript(t), goog.dom.safe.setNonceForScriptElement_(e);
            }, goog.dom.safe.setNonceForScriptElement_ = function(e) {
              var t = goog.getScriptNonce(e.ownerDocument && e.ownerDocument.defaultView);
              t && e.setAttribute("nonce", t);
            }, goog.dom.safe.setLocationHref = function(e, t) {
              goog.dom.asserts.assertIsLocation(e), t = t instanceof goog.html.SafeUrl ? t : goog.html.SafeUrl.sanitizeAssertUnchanged(t), e.href = goog.html.SafeUrl.unwrap(t);
            }, goog.dom.safe.assignLocation = function(e, t) {
              goog.dom.asserts.assertIsLocation(e), t = t instanceof goog.html.SafeUrl ? t : goog.html.SafeUrl.sanitizeAssertUnchanged(t), e.assign(goog.html.SafeUrl.unwrap(t));
            }, goog.dom.safe.replaceLocation = function(e, t) {
              t = t instanceof goog.html.SafeUrl ? t : goog.html.SafeUrl.sanitizeAssertUnchanged(t), e.replace(goog.html.SafeUrl.unwrap(t));
            }, goog.dom.safe.openInWindow = function(e, t, o, n, s) {
              return e = e instanceof goog.html.SafeUrl ? e : goog.html.SafeUrl.sanitizeAssertUnchanged(e), t = t || goog.global, o = o instanceof goog.string.Const ? goog.string.Const.unwrap(o) : o || "", t.open(goog.html.SafeUrl.unwrap(e), o, n, s);
            }, goog.dom.safe.parseFromStringHtml = function(e, t) {
              return goog.dom.safe.parseFromString(e, t, "text/html");
            }, goog.dom.safe.parseFromString = function(e, t, o) {
              return e.parseFromString(goog.html.SafeHtml.unwrapTrustedHTML(t), o);
            }, goog.dom.safe.createImageFromBlob = function(e) {
              if (!/^image\/.*/g.test(e.type)) throw Error("goog.dom.safe.createImageFromBlob only accepts MIME type image/.*.");
              var t = goog.global.URL.createObjectURL(e);
              return e = new goog.global.Image(), e.onload = function() {
                goog.global.URL.revokeObjectURL(t);
              }, goog.dom.safe.setImageSrc(e, goog.html.uncheckedconversions.safeUrlFromStringKnownToSatisfyTypeContract(goog.string.Const.from("Image blob URL."), t)), e;
            }, goog.string.DETECT_DOUBLE_ESCAPING = !1, goog.string.FORCE_NON_DOM_HTML_UNESCAPING = !1, goog.string.Unicode = { NBSP: " " }, goog.string.startsWith = goog.string.internal.startsWith, goog.string.endsWith = goog.string.internal.endsWith, goog.string.caseInsensitiveStartsWith = goog.string.internal.caseInsensitiveStartsWith, goog.string.caseInsensitiveEndsWith = goog.string.internal.caseInsensitiveEndsWith, goog.string.caseInsensitiveEquals = goog.string.internal.caseInsensitiveEquals, goog.string.subs = function(e, t) {
              for (var o = e.split("%s"), n = "", s = Array.prototype.slice.call(arguments, 1); s.length && 1 < o.length; ) n += o.shift() + s.shift();
              return n + o.join("%s");
            }, goog.string.collapseWhitespace = function(e) {
              return e.replace(/[\s\xa0]+/g, " ").replace(/^\s+|\s+$/g, "");
            }, goog.string.isEmptyOrWhitespace = goog.string.internal.isEmptyOrWhitespace, goog.string.isEmptyString = function(e) {
              return e.length == 0;
            }, goog.string.isEmpty = goog.string.isEmptyOrWhitespace, goog.string.isEmptyOrWhitespaceSafe = function(e) {
              return goog.string.isEmptyOrWhitespace(goog.string.makeSafe(e));
            }, goog.string.isEmptySafe = goog.string.isEmptyOrWhitespaceSafe, goog.string.isBreakingWhitespace = function(e) {
              return !/[^\t\n\r ]/.test(e);
            }, goog.string.isAlpha = function(e) {
              return !/[^a-zA-Z]/.test(e);
            }, goog.string.isNumeric = function(e) {
              return !/[^0-9]/.test(e);
            }, goog.string.isAlphaNumeric = function(e) {
              return !/[^a-zA-Z0-9]/.test(e);
            }, goog.string.isSpace = function(e) {
              return e == " ";
            }, goog.string.isUnicodeChar = function(e) {
              return e.length == 1 && " " <= e && "~" >= e || "" <= e && "�" >= e;
            }, goog.string.stripNewlines = function(e) {
              return e.replace(/(\r\n|\r|\n)+/g, " ");
            }, goog.string.canonicalizeNewlines = function(e) {
              return e.replace(/(\r\n|\r|\n)/g, `
`);
            }, goog.string.normalizeWhitespace = function(e) {
              return e.replace(/\xa0|\s/g, " ");
            }, goog.string.normalizeSpaces = function(e) {
              return e.replace(/\xa0|[ \t]+/g, " ");
            }, goog.string.collapseBreakingSpaces = function(e) {
              return e.replace(/[\t\r\n ]+/g, " ").replace(/^[\t\r\n ]+|[\t\r\n ]+$/g, "");
            }, goog.string.trim = goog.string.internal.trim, goog.string.trimLeft = function(e) {
              return e.replace(/^[\s\xa0]+/, "");
            }, goog.string.trimRight = function(e) {
              return e.replace(/[\s\xa0]+$/, "");
            }, goog.string.caseInsensitiveCompare = goog.string.internal.caseInsensitiveCompare, goog.string.numberAwareCompare_ = function(e, t, o) {
              if (e == t) return 0;
              if (!e) return -1;
              if (!t) return 1;
              for (var n = e.toLowerCase().match(o), s = t.toLowerCase().match(o), i = Math.min(n.length, s.length), l = 0; l < i; l++) {
                o = n[l];
                var d = s[l];
                if (o != d) return e = parseInt(o, 10), !isNaN(e) && (t = parseInt(d, 10), !isNaN(t) && e - t) ? e - t : o < d ? -1 : 1;
              }
              return n.length != s.length ? n.length - s.length : e < t ? -1 : 1;
            }, goog.string.intAwareCompare = function(e, t) {
              return goog.string.numberAwareCompare_(e, t, /\d+|\D+/g);
            }, goog.string.floatAwareCompare = function(e, t) {
              return goog.string.numberAwareCompare_(e, t, /\d+|\.\d+|\D+/g);
            }, goog.string.numerateCompare = goog.string.floatAwareCompare, goog.string.urlEncode = function(e) {
              return encodeURIComponent(String(e));
            }, goog.string.urlDecode = function(e) {
              return decodeURIComponent(e.replace(/\+/g, " "));
            }, goog.string.newLineToBr = goog.string.internal.newLineToBr, goog.string.htmlEscape = function(e, t) {
              return e = goog.string.internal.htmlEscape(e, t), goog.string.DETECT_DOUBLE_ESCAPING && (e = e.replace(goog.string.E_RE_, "&#101;")), e;
            }, goog.string.E_RE_ = /e/g, goog.string.unescapeEntities = function(e) {
              return goog.string.contains(e, "&") ? !goog.string.FORCE_NON_DOM_HTML_UNESCAPING && "document" in goog.global ? goog.string.unescapeEntitiesUsingDom_(e) : goog.string.unescapePureXmlEntities_(e) : e;
            }, goog.string.unescapeEntitiesWithDocument = function(e, t) {
              return goog.string.contains(e, "&") ? goog.string.unescapeEntitiesUsingDom_(e, t) : e;
            }, goog.string.unescapeEntitiesUsingDom_ = function(e, t) {
              var o = { "&amp;": "&", "&lt;": "<", "&gt;": ">", "&quot;": '"' }, n = t ? t.createElement("div") : goog.global.document.createElement("div");
              return e.replace(goog.string.HTML_ENTITY_PATTERN_, function(s, i) {
                var l = o[s];
                return l || (i.charAt(0) == "#" && (i = +("0" + i.substr(1)), isNaN(i) || (l = String.fromCharCode(i))), l || (goog.dom.safe.setInnerHtml(n, goog.html.uncheckedconversions.safeHtmlFromStringKnownToSatisfyTypeContract(
                  goog.string.Const.from("Single HTML entity."),
                  s + " "
                )), l = n.firstChild.nodeValue.slice(0, -1)), o[s] = l);
              });
            }, goog.string.unescapePureXmlEntities_ = function(e) {
              return e.replace(/&([^;]+);/g, function(t, o) {
                switch (o) {
                  case "amp":
                    return "&";
                  case "lt":
                    return "<";
                  case "gt":
                    return ">";
                  case "quot":
                    return '"';
                  default:
                    return o.charAt(0) != "#" || (o = +("0" + o.substr(1)), isNaN(o)) ? t : String.fromCharCode(o);
                }
              });
            }, goog.string.HTML_ENTITY_PATTERN_ = /&([^;\s<&]+);?/g, goog.string.whitespaceEscape = function(e, t) {
              return goog.string.newLineToBr(e.replace(/  /g, " &#160;"), t);
            }, goog.string.preserveSpaces = function(e) {
              return e.replace(/(^|[\n ]) /g, "$1" + goog.string.Unicode.NBSP);
            }, goog.string.stripQuotes = function(e, t) {
              for (var o = t.length, n = 0; n < o; n++) {
                var s = o == 1 ? t : t.charAt(n);
                if (e.charAt(0) == s && e.charAt(e.length - 1) == s) return e.substring(1, e.length - 1);
              }
              return e;
            }, goog.string.truncate = function(e, t, o) {
              return o && (e = goog.string.unescapeEntities(e)), e.length > t && (e = e.substring(0, t - 3) + "..."), o && (e = goog.string.htmlEscape(e)), e;
            }, goog.string.truncateMiddle = function(e, t, o, n) {
              if (o && (e = goog.string.unescapeEntities(e)), n && e.length > t) {
                n > t && (n = t);
                var s = e.length - n;
                e = e.substring(0, t - n) + "..." + e.substring(s);
              } else e.length > t && (n = Math.floor(t / 2), s = e.length - n, e = e.substring(0, n + t % 2) + "..." + e.substring(s));
              return o && (e = goog.string.htmlEscape(e)), e;
            }, goog.string.specialEscapeChars_ = { "\0": "\\0", "\b": "\\b", "\f": "\\f", "\n": "\\n", "\r": "\\r", "	": "\\t", "\v": "\\x0B", '"': '\\"', "\\": "\\\\", "<": "\\u003C" }, goog.string.jsEscapeCache_ = { "'": "\\'" }, goog.string.quote = function(e) {
              e = String(e);
              for (var t = ['"'], o = 0; o < e.length; o++) {
                var n = e.charAt(o), s = n.charCodeAt(0);
                t[o + 1] = goog.string.specialEscapeChars_[n] || (31 < s && 127 > s ? n : goog.string.escapeChar(n));
              }
              return t.push('"'), t.join("");
            }, goog.string.escapeString = function(e) {
              for (var t = [], o = 0; o < e.length; o++) t[o] = goog.string.escapeChar(e.charAt(o));
              return t.join("");
            }, goog.string.escapeChar = function(e) {
              if (e in goog.string.jsEscapeCache_) return goog.string.jsEscapeCache_[e];
              if (e in goog.string.specialEscapeChars_) return goog.string.jsEscapeCache_[e] = goog.string.specialEscapeChars_[e];
              var t = e.charCodeAt(0);
              if (31 < t && 127 > t) var o = e;
              else
                256 > t ? (o = "\\x", (16 > t || 256 < t) && (o += "0")) : (o = "\\u", 4096 > t && (o += "0")), o += t.toString(16).toUpperCase();
              return goog.string.jsEscapeCache_[e] = o;
            }, goog.string.contains = goog.string.internal.contains, goog.string.caseInsensitiveContains = goog.string.internal.caseInsensitiveContains, goog.string.countOf = function(e, t) {
              return e && t ? e.split(t).length - 1 : 0;
            }, goog.string.removeAt = function(e, t, o) {
              var n = e;
              return 0 <= t && t < e.length && 0 < o && (n = e.substr(0, t) + e.substr(t + o, e.length - t - o)), n;
            }, goog.string.remove = function(e, t) {
              return e.replace(t, "");
            }, goog.string.removeAll = function(e, t) {
              return t = new RegExp(goog.string.regExpEscape(t), "g"), e.replace(t, "");
            }, goog.string.replaceAll = function(e, t, o) {
              return t = new RegExp(goog.string.regExpEscape(t), "g"), e.replace(t, o.replace(/\$/g, "$$$$"));
            }, goog.string.regExpEscape = function(e) {
              return String(e).replace(/([-()\[\]{}+?*.$\^|,:#<!\\])/g, "\\$1").replace(/\x08/g, "\\x08");
            }, goog.string.repeat = String.prototype.repeat ? function(e, t) {
              return e.repeat(t);
            } : function(e, t) {
              return Array(t + 1).join(e);
            }, goog.string.padNumber = function(e, t, o) {
              return e = o !== void 0 ? e.toFixed(o) : String(e), o = e.indexOf("."), o == -1 && (o = e.length), goog.string.repeat("0", Math.max(0, t - o)) + e;
            }, goog.string.makeSafe = function(e) {
              return e == null ? "" : String(e);
            }, goog.string.buildString = function(e) {
              return Array.prototype.join.call(arguments, "");
            }, goog.string.getRandomString = function() {
              return Math.floor(2147483648 * Math.random()).toString(36) + Math.abs(Math.floor(2147483648 * Math.random()) ^ goog.now()).toString(36);
            }, goog.string.compareVersions = goog.string.internal.compareVersions, goog.string.hashCode = function(e) {
              for (var t = 0, o = 0; o < e.length; ++o) t = 31 * t + e.charCodeAt(o) >>> 0;
              return t;
            }, goog.string.uniqueStringCounter_ = 2147483648 * Math.random() | 0, goog.string.createUniqueString = function() {
              return "goog_" + goog.string.uniqueStringCounter_++;
            }, goog.string.toNumber = function(e) {
              var t = Number(e);
              return t == 0 && goog.string.isEmptyOrWhitespace(e) ? NaN : t;
            }, goog.string.isLowerCamelCase = function(e) {
              return /^[a-z]+([A-Z][a-z]*)*$/.test(e);
            }, goog.string.isUpperCamelCase = function(e) {
              return /^([A-Z][a-z]*)+$/.test(e);
            }, goog.string.toCamelCase = function(e) {
              return String(e).replace(/\-([a-z])/g, function(t, o) {
                return o.toUpperCase();
              });
            }, goog.string.toSelectorCase = function(e) {
              return String(e).replace(/([A-Z])/g, "-$1").toLowerCase();
            }, goog.string.toTitleCase = function(e, t) {
              return t = typeof t == "string" ? goog.string.regExpEscape(t) : "\\s", e.replace(new RegExp("(^" + (t ? "|[" + t + "]+" : "") + ")([a-z])", "g"), function(o, n, s) {
                return n + s.toUpperCase();
              });
            }, goog.string.capitalize = function(e) {
              return String(e.charAt(0)).toUpperCase() + String(e.substr(1)).toLowerCase();
            }, goog.string.parseInt = function(e) {
              return isFinite(e) && (e = String(e)), typeof e == "string" ? /^\s*-?0x/i.test(e) ? parseInt(e, 16) : parseInt(e, 10) : NaN;
            }, goog.string.splitLimit = function(e, t, o) {
              e = e.split(t);
              for (var n = []; 0 < o && e.length; ) n.push(e.shift()), o--;
              return e.length && n.push(e.join(t)), n;
            }, goog.string.lastComponent = function(e, t) {
              if (t) typeof t == "string" && (t = [t]);
              else return e;
              for (var o = -1, n = 0; n < t.length; n++) if (t[n] != "") {
                var s = e.lastIndexOf(t[n]);
                s > o && (o = s);
              }
              return o == -1 ? e : e.slice(o + 1);
            }, goog.string.editDistance = function(e, t) {
              var o = [], n = [];
              if (e == t) return 0;
              if (!e.length || !t.length) return Math.max(e.length, t.length);
              for (var s = 0; s < t.length + 1; s++) o[s] = s;
              for (s = 0; s < e.length; s++) {
                n[0] = s + 1;
                for (var i = 0; i < t.length; i++) n[i + 1] = Math.min(n[i] + 1, o[i + 1] + 1, o[i] + +(e[s] != t[i]));
                for (i = 0; i < o.length; i++) o[i] = n[i];
              }
              return n[t.length];
            }, goog.proto2 = {}, goog.proto2.Descriptor = function(e, t, o) {
              for (this.messageType_ = e, this.name_ = t.name || null, this.fullName_ = t.fullName || null, this.containingType_ = t.containingType, this.fields_ = {}, e = 0; e < o.length; e++) t = o[e], this.fields_[t.getTag()] = t;
            }, goog.proto2.Descriptor.prototype.getName = function() {
              return this.name_;
            }, goog.proto2.Descriptor.prototype.getFullName = function() {
              return this.fullName_;
            }, goog.proto2.Descriptor.prototype.getContainingType = function() {
              return this.containingType_ ? this.containingType_.getDescriptor() : null;
            }, goog.proto2.Descriptor.prototype.getFields = function() {
              var e = goog.object.getValues(this.fields_);
              return module$contents$goog$array_sort(e, function(t, o) {
                return t.getTag() - o.getTag();
              }), e;
            }, goog.proto2.Descriptor.prototype.getFieldsMap = function() {
              return this.fields_;
            }, goog.proto2.Descriptor.prototype.findFieldByName = function(e) {
              return goog.object.findValue(this.fields_, function(t, o, n) {
                return t.getName() == e;
              }) || null;
            }, goog.proto2.Descriptor.prototype.findFieldByTag = function(e) {
              return goog.asserts.assert(goog.string.isNumeric(e)), this.fields_[parseInt(e, 10)] || null;
            }, goog.proto2.Descriptor.prototype.createMessageInstance = function() {
              return new this.messageType_();
            }, goog.proto2.FieldDescriptor = function(e, t, o) {
              switch (this.parent_ = e, goog.asserts.assert(goog.string.isNumeric(t)), this.tag_ = t, this.name_ = o.name, this.isPacked_ = !!o.packed, this.isRepeated_ = !!o.repeated, this.isRequired_ = !!o.required, this.fieldType_ = o.fieldType, this.nativeType_ = o.type, this.deserializationConversionPermitted_ = !1, this.fieldType_) {
                case goog.proto2.FieldDescriptor.FieldType.INT64:
                case goog.proto2.FieldDescriptor.FieldType.UINT64:
                case goog.proto2.FieldDescriptor.FieldType.FIXED64:
                case goog.proto2.FieldDescriptor.FieldType.SFIXED64:
                case goog.proto2.FieldDescriptor.FieldType.SINT64:
                case goog.proto2.FieldDescriptor.FieldType.FLOAT:
                case goog.proto2.FieldDescriptor.FieldType.DOUBLE:
                  this.deserializationConversionPermitted_ = !0;
              }
              this.defaultValue_ = o.defaultValue;
            }, goog.proto2.FieldDescriptor.FieldType = { DOUBLE: 1, FLOAT: 2, INT64: 3, UINT64: 4, INT32: 5, FIXED64: 6, FIXED32: 7, BOOL: 8, STRING: 9, GROUP: 10, MESSAGE: 11, BYTES: 12, UINT32: 13, ENUM: 14, SFIXED32: 15, SFIXED64: 16, SINT32: 17, SINT64: 18 }, goog.proto2.FieldDescriptor.prototype.getTag = function() {
              return this.tag_;
            }, goog.proto2.FieldDescriptor.prototype.getContainingType = function() {
              return this.parent_.prototype.getDescriptor();
            }, goog.proto2.FieldDescriptor.prototype.getName = function() {
              return this.name_;
            }, goog.proto2.FieldDescriptor.prototype.getDefaultValue = function() {
              if (this.defaultValue_ === void 0) {
                var e = this.nativeType_;
                if (e === Boolean) this.defaultValue_ = !1;
                else if (e === Number) this.defaultValue_ = 0;
                else if (e === String) this.defaultValue_ = this.deserializationConversionPermitted_ ? "0" : "";
                else return new e();
              }
              return this.defaultValue_;
            }, goog.proto2.FieldDescriptor.prototype.getFieldType = function() {
              return this.fieldType_;
            }, goog.proto2.FieldDescriptor.prototype.getNativeType = function() {
              return this.nativeType_;
            }, goog.proto2.FieldDescriptor.prototype.deserializationConversionPermitted = function() {
              return this.deserializationConversionPermitted_;
            }, goog.proto2.FieldDescriptor.prototype.getFieldMessageType = function() {
              return this.nativeType_.prototype.getDescriptor();
            }, goog.proto2.FieldDescriptor.prototype.isCompositeType = function() {
              return this.fieldType_ == goog.proto2.FieldDescriptor.FieldType.MESSAGE || this.fieldType_ == goog.proto2.FieldDescriptor.FieldType.GROUP;
            }, goog.proto2.FieldDescriptor.prototype.isPacked = function() {
              return this.isPacked_;
            }, goog.proto2.FieldDescriptor.prototype.isRepeated = function() {
              return this.isRepeated_;
            }, goog.proto2.FieldDescriptor.prototype.isRequired = function() {
              return this.isRequired_;
            }, goog.proto2.FieldDescriptor.prototype.isOptional = function() {
              return !this.isRepeated_ && !this.isRequired_;
            }, goog.proto2.Message = function() {
              this.values_ = {}, this.fields_ = this.getDescriptor().getFieldsMap(), this.deserializedFields_ = this.lazyDeserializer_ = null;
            }, goog.proto2.Message.FieldType = { DOUBLE: 1, FLOAT: 2, INT64: 3, UINT64: 4, INT32: 5, FIXED64: 6, FIXED32: 7, BOOL: 8, STRING: 9, GROUP: 10, MESSAGE: 11, BYTES: 12, UINT32: 13, ENUM: 14, SFIXED32: 15, SFIXED64: 16, SINT32: 17, SINT64: 18 }, goog.proto2.Message.prototype.initializeForLazyDeserializer = function(e, t) {
              this.lazyDeserializer_ = e, this.values_ = t, this.deserializedFields_ = {};
            }, goog.proto2.Message.prototype.setUnknown = function(e, t) {
              goog.asserts.assert(!this.fields_[e], "Field is not unknown in this message"), goog.asserts.assert(1 <= e, "Tag " + e + ' has value "' + t + '" in descriptor ' + this.getDescriptor().getName()), goog.asserts.assert(t !== null, "Value cannot be null"), this.values_[e] = t, this.deserializedFields_ && delete this.deserializedFields_[e];
            }, goog.proto2.Message.prototype.forEachUnknown = function(e, t) {
              t = t || this;
              for (var o in this.values_) {
                var n = Number(o);
                this.fields_[n] || e.call(t, n, this.values_[o]);
              }
            }, goog.proto2.Message.prototype.getDescriptor = goog.abstractMethod, goog.proto2.Message.prototype.has = function(e) {
              return goog.asserts.assert(e.getContainingType() == this.getDescriptor(), "The current message does not contain the given field"), this.has$Value(e.getTag());
            }, goog.proto2.Message.prototype.arrayOf = function(e) {
              return goog.asserts.assert(e.getContainingType() == this.getDescriptor(), "The current message does not contain the given field"), this.array$Values(e.getTag());
            }, goog.proto2.Message.prototype.countOf = function(e) {
              return goog.asserts.assert(e.getContainingType() == this.getDescriptor(), "The current message does not contain the given field"), this.count$Values(e.getTag());
            }, goog.proto2.Message.prototype.get = function(e, t) {
              return goog.asserts.assert(e.getContainingType() == this.getDescriptor(), "The current message does not contain the given field"), this.get$Value(e.getTag(), t);
            }, goog.proto2.Message.prototype.getOrDefault = function(e, t) {
              return goog.asserts.assert(e.getContainingType() == this.getDescriptor(), "The current message does not contain the given field"), this.get$ValueOrDefault(e.getTag(), t);
            }, goog.proto2.Message.prototype.set = function(e, t) {
              goog.asserts.assert(e.getContainingType() == this.getDescriptor(), "The current message does not contain the given field"), this.set$Value(e.getTag(), t);
            }, goog.proto2.Message.prototype.add = function(e, t) {
              goog.asserts.assert(e.getContainingType() == this.getDescriptor(), "The current message does not contain the given field"), this.add$Value(e.getTag(), t);
            }, goog.proto2.Message.prototype.clear = function(e) {
              goog.asserts.assert(e.getContainingType() == this.getDescriptor(), "The current message does not contain the given field"), this.clear$Field(e.getTag());
            }, goog.proto2.Message.prototype.equals = function(e) {
              if (!e || this.constructor != e.constructor) return !1;
              for (var t = this.getDescriptor().getFields(), o = 0; o < t.length; o++) {
                var n = t[o], s = n.getTag();
                if (this.has$Value(s) != e.has$Value(s)) return !1;
                if (this.has$Value(s)) {
                  var i = n.isCompositeType(), l = this.getValueForTag_(s);
                  if (s = e.getValueForTag_(s), n.isRepeated()) {
                    if (l.length != s.length) return !1;
                    for (n = 0; n < l.length; n++) {
                      var d = l[n], u = s[n];
                      if (i ? !d.equals(u) : d != u) return !1;
                    }
                  } else if (i ? !l.equals(s) : l != s) return !1;
                }
              }
              return !0;
            }, goog.proto2.Message.prototype.copyFrom = function(e) {
              goog.asserts.assert(this.constructor == e.constructor, "The source message must have the same type."), this != e && (this.values_ = {}, this.deserializedFields_ && (this.deserializedFields_ = {}), this.mergeFrom(e));
            }, goog.proto2.Message.prototype.mergeFrom = function(e) {
              goog.asserts.assert(this.constructor == e.constructor, "The source message must have the same type.");
              for (var t = this.getDescriptor().getFields(), o = 0; o < t.length; o++) {
                var n = t[o], s = n.getTag();
                if (e.has$Value(s)) {
                  this.deserializedFields_ && delete this.deserializedFields_[n.getTag()];
                  var i = n.isCompositeType();
                  if (n.isRepeated()) {
                    n = e.array$Values(s);
                    for (var l = 0; l < n.length; l++) this.add$Value(s, i ? n[l].clone() : n[l]);
                  } else n = e.getValueForTag_(s), i ? (i = this.getValueForTag_(s)) ? i.mergeFrom(n) : this.set$Value(s, n.clone()) : this.set$Value(s, n);
                }
              }
            }, goog.proto2.Message.prototype.clone = function() {
              var e = new this.constructor();
              return e.copyFrom(this), e;
            }, goog.proto2.Message.prototype.initDefaults = function(e) {
              for (var t = this.getDescriptor().getFields(), o = 0; o < t.length; o++) {
                var n = t[o], s = n.getTag(), i = n.isCompositeType();
                if (this.has$Value(s) || n.isRepeated() || (i ? this.values_[s] = new (n.getNativeType())() : e && (this.values_[s] = n.getDefaultValue())), i) if (n.isRepeated()) for (n = this.array$Values(s), s = 0; s < n.length; s++) n[s].initDefaults(e);
                else this.get$Value(s).initDefaults(e);
              }
            }, goog.proto2.Message.prototype.has$Value = function(e) {
              return this.values_[e] != null;
            }, goog.proto2.Message.prototype.getValueForTag_ = function(e) {
              var t = this.values_[e];
              return t == null ? null : this.lazyDeserializer_ ? e in this.deserializedFields_ ? this.deserializedFields_[e] : (t = this.lazyDeserializer_.deserializeField(this, this.fields_[e], t), this.deserializedFields_[e] = t) : t;
            }, goog.proto2.Message.prototype.get$Value = function(e, t) {
              var o = this.getValueForTag_(e);
              return this.fields_[e].isRepeated() ? (e = t || 0, goog.asserts.assert(0 <= e && e < o.length, "Given index %s is out of bounds.  Repeated field length: %s", e, o.length), o[e]) : o;
            }, goog.proto2.Message.prototype.get$ValueOrDefault = function(e, t) {
              return this.has$Value(e) ? this.get$Value(e, t) : this.fields_[e].getDefaultValue();
            }, goog.proto2.Message.prototype.array$Values = function(e) {
              return this.getValueForTag_(e) || [];
            }, goog.proto2.Message.prototype.count$Values = function(e) {
              return this.fields_[e].isRepeated() ? this.has$Value(e) ? this.values_[e].length : 0 : this.has$Value(e) ? 1 : 0;
            }, goog.proto2.Message.prototype.set$Value = function(e, t) {
              goog.asserts.ENABLE_ASSERTS && this.checkFieldType_(this.fields_[e], t), this.values_[e] = t, this.deserializedFields_ && (this.deserializedFields_[e] = t);
            }, goog.proto2.Message.prototype.add$Value = function(e, t) {
              goog.asserts.ENABLE_ASSERTS && this.checkFieldType_(this.fields_[e], t), this.values_[e] || (this.values_[e] = []), this.values_[e].push(t), this.deserializedFields_ && delete this.deserializedFields_[e];
            }, goog.proto2.Message.prototype.checkFieldType_ = function(e, t) {
              e.getFieldType() == goog.proto2.FieldDescriptor.FieldType.ENUM ? goog.asserts.assertNumber(t) : goog.asserts.assert(Object(t).constructor == e.getNativeType());
            }, goog.proto2.Message.prototype.clear$Field = function(e) {
              delete this.values_[e], this.deserializedFields_ && delete this.deserializedFields_[e];
            }, goog.proto2.Message.createDescriptor = function(e, t) {
              var o = [], n = t[0], s;
              for (s in t) s != 0 && o.push(new goog.proto2.FieldDescriptor(e, s, t[s]));
              return new goog.proto2.Descriptor(e, n, o);
            }, goog.proto2.Serializer = function() {
            }, goog.proto2.Serializer.DECODE_SYMBOLIC_ENUMS = !1, goog.proto2.Serializer.prototype.serialize = goog.abstractMethod, goog.proto2.Serializer.prototype.getSerializedValue = function(e, t) {
              return e.isCompositeType() ? this.serialize(t) : typeof t != "number" || isFinite(t) ? t : t.toString();
            }, goog.proto2.Serializer.prototype.deserialize = function(e, t) {
              return e = e.createMessageInstance(), this.deserializeTo(e, t), goog.asserts.assert(e instanceof goog.proto2.Message), e;
            }, goog.proto2.Serializer.prototype.deserializeTo = goog.abstractMethod, goog.proto2.Serializer.prototype.getDeserializedValue = function(e, t) {
              if (e.isCompositeType()) return t instanceof goog.proto2.Message ? t : this.deserialize(e.getFieldMessageType(), t);
              if (e.getFieldType() == goog.proto2.FieldDescriptor.FieldType.ENUM) return goog.proto2.Serializer.DECODE_SYMBOLIC_ENUMS && typeof t == "string" && (e = e.getNativeType(), e.hasOwnProperty(t)) ? e[t] : typeof t == "string" && goog.proto2.Serializer.INTEGER_REGEX.test(t) && (e = Number(t), 0 < e) ? e : t;
              if (!e.deserializationConversionPermitted()) return t;
              if (e = e.getNativeType(), e === String) {
                if (typeof t == "number") return String(t);
              } else if (e === Number && typeof t == "string" && (t === "Infinity" || t === "-Infinity" || t === "NaN" || goog.proto2.Serializer.INTEGER_REGEX.test(t))) return Number(t);
              return t;
            }, goog.proto2.Serializer.INTEGER_REGEX = /^-?[0-9]+$/, goog.proto2.LazyDeserializer = function() {
            }, goog.inherits(goog.proto2.LazyDeserializer, goog.proto2.Serializer), goog.proto2.LazyDeserializer.prototype.deserialize = function(e, t) {
              return e = e.createMessageInstance(), e.initializeForLazyDeserializer(this, t), goog.asserts.assert(e instanceof goog.proto2.Message), e;
            }, goog.proto2.LazyDeserializer.prototype.deserializeTo = function(e, t) {
              throw Error("Unimplemented");
            }, goog.proto2.LazyDeserializer.prototype.deserializeField = goog.abstractMethod, goog.proto2.PbLiteSerializer = function() {
            }, goog.inherits(goog.proto2.PbLiteSerializer, goog.proto2.LazyDeserializer), goog.proto2.PbLiteSerializer.prototype.zeroIndexing_ = !1, goog.proto2.PbLiteSerializer.prototype.setZeroIndexed = function(e) {
              this.zeroIndexing_ = e;
            }, goog.proto2.PbLiteSerializer.prototype.serialize = function(e) {
              for (var t = e.getDescriptor().getFields(), o = [], n = this.zeroIndexing_, s = 0; s < t.length; s++) {
                var i = t[s];
                if (e.has(i)) {
                  var l = i.getTag();
                  if (l = n ? l - 1 : l, i.isRepeated()) {
                    o[l] = [];
                    for (var d = 0; d < e.countOf(i); d++) o[l][d] = this.getSerializedValue(i, e.get(i, d));
                  } else o[l] = this.getSerializedValue(i, e.get(i));
                }
              }
              return e.forEachUnknown(function(u, c) {
                o[n ? u - 1 : u] = c;
              }), o;
            }, goog.proto2.PbLiteSerializer.prototype.deserializeField = function(e, t, o) {
              if (o == null) return o;
              if (t.isRepeated()) {
                e = [], goog.asserts.assert(Array.isArray(o), "Value must be array: %s", o);
                for (var n = 0; n < o.length; n++) e[n] = this.getDeserializedValue(t, o[n]);
                return e;
              }
              return this.getDeserializedValue(t, o);
            }, goog.proto2.PbLiteSerializer.prototype.getSerializedValue = function(e, t) {
              return e.getFieldType() == goog.proto2.FieldDescriptor.FieldType.BOOL ? t ? 1 : 0 : goog.proto2.Serializer.prototype.getSerializedValue.apply(this, arguments);
            }, goog.proto2.PbLiteSerializer.prototype.getDeserializedValue = function(e, t) {
              return e.getFieldType() == goog.proto2.FieldDescriptor.FieldType.BOOL ? (goog.asserts.assert(typeof t == "number" || typeof t == "boolean", "Value is expected to be a number or boolean"), !!t) : goog.proto2.Serializer.prototype.getDeserializedValue.apply(this, arguments);
            }, goog.proto2.PbLiteSerializer.prototype.deserialize = function(e, t) {
              var o = t;
              if (this.zeroIndexing_) {
                o = [];
                for (var n in t) o[parseInt(n, 10) + 1] = t[n];
              }
              return goog.proto2.PbLiteSerializer.superClass_.deserialize.call(this, e, o);
            }, goog.string.StringBuffer = function(e, t) {
              e != null && this.append.apply(this, arguments);
            }, goog.string.StringBuffer.prototype.buffer_ = "", goog.string.StringBuffer.prototype.set = function(e) {
              this.buffer_ = "" + e;
            }, goog.string.StringBuffer.prototype.append = function(e, t, o) {
              if (this.buffer_ += String(e), t != null) for (var n = 1; n < arguments.length; n++) this.buffer_ += arguments[n];
              return this;
            }, goog.string.StringBuffer.prototype.clear = function() {
              this.buffer_ = "";
            }, goog.string.StringBuffer.prototype.getLength = function() {
              return this.buffer_.length;
            }, goog.string.StringBuffer.prototype.toString = function() {
              return this.buffer_;
            };
            var i18n = { phonenumbers: {} };
            i18n.phonenumbers.NumberFormat = function() {
              goog.proto2.Message.call(this);
            }, goog.inherits(i18n.phonenumbers.NumberFormat, goog.proto2.Message), i18n.phonenumbers.NumberFormat.descriptor_ = null, i18n.phonenumbers.NumberFormat.prototype.getPattern = function() {
              return this.get$Value(1);
            }, i18n.phonenumbers.NumberFormat.prototype.getPatternOrDefault = function() {
              return this.get$ValueOrDefault(1);
            }, i18n.phonenumbers.NumberFormat.prototype.setPattern = function(e) {
              this.set$Value(1, e);
            }, i18n.phonenumbers.NumberFormat.prototype.hasPattern = function() {
              return this.has$Value(1);
            }, i18n.phonenumbers.NumberFormat.prototype.patternCount = function() {
              return this.count$Values(1);
            }, i18n.phonenumbers.NumberFormat.prototype.clearPattern = function() {
              this.clear$Field(1);
            }, i18n.phonenumbers.NumberFormat.prototype.getFormat = function() {
              return this.get$Value(2);
            }, i18n.phonenumbers.NumberFormat.prototype.getFormatOrDefault = function() {
              return this.get$ValueOrDefault(2);
            }, i18n.phonenumbers.NumberFormat.prototype.setFormat = function(e) {
              this.set$Value(2, e);
            }, i18n.phonenumbers.NumberFormat.prototype.hasFormat = function() {
              return this.has$Value(2);
            }, i18n.phonenumbers.NumberFormat.prototype.formatCount = function() {
              return this.count$Values(2);
            }, i18n.phonenumbers.NumberFormat.prototype.clearFormat = function() {
              this.clear$Field(2);
            }, i18n.phonenumbers.NumberFormat.prototype.getLeadingDigitsPattern = function(e) {
              return this.get$Value(3, e);
            }, i18n.phonenumbers.NumberFormat.prototype.getLeadingDigitsPatternOrDefault = function(e) {
              return this.get$ValueOrDefault(3, e);
            }, i18n.phonenumbers.NumberFormat.prototype.addLeadingDigitsPattern = function(e) {
              this.add$Value(3, e);
            }, i18n.phonenumbers.NumberFormat.prototype.leadingDigitsPatternArray = function() {
              return this.array$Values(3);
            }, i18n.phonenumbers.NumberFormat.prototype.hasLeadingDigitsPattern = function() {
              return this.has$Value(3);
            }, i18n.phonenumbers.NumberFormat.prototype.leadingDigitsPatternCount = function() {
              return this.count$Values(3);
            }, i18n.phonenumbers.NumberFormat.prototype.clearLeadingDigitsPattern = function() {
              this.clear$Field(3);
            }, i18n.phonenumbers.NumberFormat.prototype.getNationalPrefixFormattingRule = function() {
              return this.get$Value(4);
            }, i18n.phonenumbers.NumberFormat.prototype.getNationalPrefixFormattingRuleOrDefault = function() {
              return this.get$ValueOrDefault(4);
            }, i18n.phonenumbers.NumberFormat.prototype.setNationalPrefixFormattingRule = function(e) {
              this.set$Value(4, e);
            }, i18n.phonenumbers.NumberFormat.prototype.hasNationalPrefixFormattingRule = function() {
              return this.has$Value(4);
            }, i18n.phonenumbers.NumberFormat.prototype.nationalPrefixFormattingRuleCount = function() {
              return this.count$Values(4);
            }, i18n.phonenumbers.NumberFormat.prototype.clearNationalPrefixFormattingRule = function() {
              this.clear$Field(4);
            }, i18n.phonenumbers.NumberFormat.prototype.getNationalPrefixOptionalWhenFormatting = function() {
              return this.get$Value(6);
            }, i18n.phonenumbers.NumberFormat.prototype.getNationalPrefixOptionalWhenFormattingOrDefault = function() {
              return this.get$ValueOrDefault(6);
            }, i18n.phonenumbers.NumberFormat.prototype.setNationalPrefixOptionalWhenFormatting = function(e) {
              this.set$Value(6, e);
            }, i18n.phonenumbers.NumberFormat.prototype.hasNationalPrefixOptionalWhenFormatting = function() {
              return this.has$Value(6);
            }, i18n.phonenumbers.NumberFormat.prototype.nationalPrefixOptionalWhenFormattingCount = function() {
              return this.count$Values(6);
            }, i18n.phonenumbers.NumberFormat.prototype.clearNationalPrefixOptionalWhenFormatting = function() {
              this.clear$Field(6);
            }, i18n.phonenumbers.NumberFormat.prototype.getDomesticCarrierCodeFormattingRule = function() {
              return this.get$Value(5);
            }, i18n.phonenumbers.NumberFormat.prototype.getDomesticCarrierCodeFormattingRuleOrDefault = function() {
              return this.get$ValueOrDefault(5);
            }, i18n.phonenumbers.NumberFormat.prototype.setDomesticCarrierCodeFormattingRule = function(e) {
              this.set$Value(5, e);
            }, i18n.phonenumbers.NumberFormat.prototype.hasDomesticCarrierCodeFormattingRule = function() {
              return this.has$Value(5);
            }, i18n.phonenumbers.NumberFormat.prototype.domesticCarrierCodeFormattingRuleCount = function() {
              return this.count$Values(5);
            }, i18n.phonenumbers.NumberFormat.prototype.clearDomesticCarrierCodeFormattingRule = function() {
              this.clear$Field(5);
            }, i18n.phonenumbers.PhoneNumberDesc = function() {
              goog.proto2.Message.call(this);
            }, goog.inherits(i18n.phonenumbers.PhoneNumberDesc, goog.proto2.Message), i18n.phonenumbers.PhoneNumberDesc.descriptor_ = null, i18n.phonenumbers.PhoneNumberDesc.prototype.getNationalNumberPattern = function() {
              return this.get$Value(2);
            }, i18n.phonenumbers.PhoneNumberDesc.prototype.getNationalNumberPatternOrDefault = function() {
              return this.get$ValueOrDefault(2);
            }, i18n.phonenumbers.PhoneNumberDesc.prototype.setNationalNumberPattern = function(e) {
              this.set$Value(2, e);
            }, i18n.phonenumbers.PhoneNumberDesc.prototype.hasNationalNumberPattern = function() {
              return this.has$Value(2);
            }, i18n.phonenumbers.PhoneNumberDesc.prototype.nationalNumberPatternCount = function() {
              return this.count$Values(2);
            }, i18n.phonenumbers.PhoneNumberDesc.prototype.clearNationalNumberPattern = function() {
              this.clear$Field(2);
            }, i18n.phonenumbers.PhoneNumberDesc.prototype.getPossibleLength = function(e) {
              return this.get$Value(9, e);
            }, i18n.phonenumbers.PhoneNumberDesc.prototype.getPossibleLengthOrDefault = function(e) {
              return this.get$ValueOrDefault(9, e);
            }, i18n.phonenumbers.PhoneNumberDesc.prototype.addPossibleLength = function(e) {
              this.add$Value(9, e);
            }, i18n.phonenumbers.PhoneNumberDesc.prototype.possibleLengthArray = function() {
              return this.array$Values(9);
            }, i18n.phonenumbers.PhoneNumberDesc.prototype.hasPossibleLength = function() {
              return this.has$Value(9);
            }, i18n.phonenumbers.PhoneNumberDesc.prototype.possibleLengthCount = function() {
              return this.count$Values(9);
            }, i18n.phonenumbers.PhoneNumberDesc.prototype.clearPossibleLength = function() {
              this.clear$Field(9);
            }, i18n.phonenumbers.PhoneNumberDesc.prototype.getPossibleLengthLocalOnly = function(e) {
              return this.get$Value(10, e);
            }, i18n.phonenumbers.PhoneNumberDesc.prototype.getPossibleLengthLocalOnlyOrDefault = function(e) {
              return this.get$ValueOrDefault(10, e);
            }, i18n.phonenumbers.PhoneNumberDesc.prototype.addPossibleLengthLocalOnly = function(e) {
              this.add$Value(10, e);
            }, i18n.phonenumbers.PhoneNumberDesc.prototype.possibleLengthLocalOnlyArray = function() {
              return this.array$Values(10);
            }, i18n.phonenumbers.PhoneNumberDesc.prototype.hasPossibleLengthLocalOnly = function() {
              return this.has$Value(10);
            }, i18n.phonenumbers.PhoneNumberDesc.prototype.possibleLengthLocalOnlyCount = function() {
              return this.count$Values(10);
            }, i18n.phonenumbers.PhoneNumberDesc.prototype.clearPossibleLengthLocalOnly = function() {
              this.clear$Field(10);
            }, i18n.phonenumbers.PhoneNumberDesc.prototype.getExampleNumber = function() {
              return this.get$Value(6);
            }, i18n.phonenumbers.PhoneNumberDesc.prototype.getExampleNumberOrDefault = function() {
              return this.get$ValueOrDefault(6);
            }, i18n.phonenumbers.PhoneNumberDesc.prototype.setExampleNumber = function(e) {
              this.set$Value(6, e);
            }, i18n.phonenumbers.PhoneNumberDesc.prototype.hasExampleNumber = function() {
              return this.has$Value(6);
            }, i18n.phonenumbers.PhoneNumberDesc.prototype.exampleNumberCount = function() {
              return this.count$Values(6);
            }, i18n.phonenumbers.PhoneNumberDesc.prototype.clearExampleNumber = function() {
              this.clear$Field(6);
            }, i18n.phonenumbers.PhoneMetadata = function() {
              goog.proto2.Message.call(this);
            }, goog.inherits(i18n.phonenumbers.PhoneMetadata, goog.proto2.Message), i18n.phonenumbers.PhoneMetadata.descriptor_ = null, i18n.phonenumbers.PhoneMetadata.prototype.getGeneralDesc = function() {
              return this.get$Value(1);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getGeneralDescOrDefault = function() {
              return this.get$ValueOrDefault(1);
            }, i18n.phonenumbers.PhoneMetadata.prototype.setGeneralDesc = function(e) {
              this.set$Value(1, e);
            }, i18n.phonenumbers.PhoneMetadata.prototype.hasGeneralDesc = function() {
              return this.has$Value(1);
            }, i18n.phonenumbers.PhoneMetadata.prototype.generalDescCount = function() {
              return this.count$Values(1);
            }, i18n.phonenumbers.PhoneMetadata.prototype.clearGeneralDesc = function() {
              this.clear$Field(1);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getFixedLine = function() {
              return this.get$Value(2);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getFixedLineOrDefault = function() {
              return this.get$ValueOrDefault(2);
            }, i18n.phonenumbers.PhoneMetadata.prototype.setFixedLine = function(e) {
              this.set$Value(2, e);
            }, i18n.phonenumbers.PhoneMetadata.prototype.hasFixedLine = function() {
              return this.has$Value(2);
            }, i18n.phonenumbers.PhoneMetadata.prototype.fixedLineCount = function() {
              return this.count$Values(2);
            }, i18n.phonenumbers.PhoneMetadata.prototype.clearFixedLine = function() {
              this.clear$Field(2);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getMobile = function() {
              return this.get$Value(3);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getMobileOrDefault = function() {
              return this.get$ValueOrDefault(3);
            }, i18n.phonenumbers.PhoneMetadata.prototype.setMobile = function(e) {
              this.set$Value(3, e);
            }, i18n.phonenumbers.PhoneMetadata.prototype.hasMobile = function() {
              return this.has$Value(3);
            }, i18n.phonenumbers.PhoneMetadata.prototype.mobileCount = function() {
              return this.count$Values(3);
            }, i18n.phonenumbers.PhoneMetadata.prototype.clearMobile = function() {
              this.clear$Field(3);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getTollFree = function() {
              return this.get$Value(4);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getTollFreeOrDefault = function() {
              return this.get$ValueOrDefault(4);
            }, i18n.phonenumbers.PhoneMetadata.prototype.setTollFree = function(e) {
              this.set$Value(4, e);
            }, i18n.phonenumbers.PhoneMetadata.prototype.hasTollFree = function() {
              return this.has$Value(4);
            }, i18n.phonenumbers.PhoneMetadata.prototype.tollFreeCount = function() {
              return this.count$Values(4);
            }, i18n.phonenumbers.PhoneMetadata.prototype.clearTollFree = function() {
              this.clear$Field(4);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getPremiumRate = function() {
              return this.get$Value(5);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getPremiumRateOrDefault = function() {
              return this.get$ValueOrDefault(5);
            }, i18n.phonenumbers.PhoneMetadata.prototype.setPremiumRate = function(e) {
              this.set$Value(5, e);
            }, i18n.phonenumbers.PhoneMetadata.prototype.hasPremiumRate = function() {
              return this.has$Value(5);
            }, i18n.phonenumbers.PhoneMetadata.prototype.premiumRateCount = function() {
              return this.count$Values(5);
            }, i18n.phonenumbers.PhoneMetadata.prototype.clearPremiumRate = function() {
              this.clear$Field(5);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getSharedCost = function() {
              return this.get$Value(6);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getSharedCostOrDefault = function() {
              return this.get$ValueOrDefault(6);
            }, i18n.phonenumbers.PhoneMetadata.prototype.setSharedCost = function(e) {
              this.set$Value(6, e);
            }, i18n.phonenumbers.PhoneMetadata.prototype.hasSharedCost = function() {
              return this.has$Value(6);
            }, i18n.phonenumbers.PhoneMetadata.prototype.sharedCostCount = function() {
              return this.count$Values(6);
            }, i18n.phonenumbers.PhoneMetadata.prototype.clearSharedCost = function() {
              this.clear$Field(6);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getPersonalNumber = function() {
              return this.get$Value(7);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getPersonalNumberOrDefault = function() {
              return this.get$ValueOrDefault(7);
            }, i18n.phonenumbers.PhoneMetadata.prototype.setPersonalNumber = function(e) {
              this.set$Value(7, e);
            }, i18n.phonenumbers.PhoneMetadata.prototype.hasPersonalNumber = function() {
              return this.has$Value(7);
            }, i18n.phonenumbers.PhoneMetadata.prototype.personalNumberCount = function() {
              return this.count$Values(7);
            }, i18n.phonenumbers.PhoneMetadata.prototype.clearPersonalNumber = function() {
              this.clear$Field(7);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getVoip = function() {
              return this.get$Value(8);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getVoipOrDefault = function() {
              return this.get$ValueOrDefault(8);
            }, i18n.phonenumbers.PhoneMetadata.prototype.setVoip = function(e) {
              this.set$Value(8, e);
            }, i18n.phonenumbers.PhoneMetadata.prototype.hasVoip = function() {
              return this.has$Value(8);
            }, i18n.phonenumbers.PhoneMetadata.prototype.voipCount = function() {
              return this.count$Values(8);
            }, i18n.phonenumbers.PhoneMetadata.prototype.clearVoip = function() {
              this.clear$Field(8);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getPager = function() {
              return this.get$Value(21);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getPagerOrDefault = function() {
              return this.get$ValueOrDefault(21);
            }, i18n.phonenumbers.PhoneMetadata.prototype.setPager = function(e) {
              this.set$Value(21, e);
            }, i18n.phonenumbers.PhoneMetadata.prototype.hasPager = function() {
              return this.has$Value(21);
            }, i18n.phonenumbers.PhoneMetadata.prototype.pagerCount = function() {
              return this.count$Values(21);
            }, i18n.phonenumbers.PhoneMetadata.prototype.clearPager = function() {
              this.clear$Field(21);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getUan = function() {
              return this.get$Value(25);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getUanOrDefault = function() {
              return this.get$ValueOrDefault(25);
            }, i18n.phonenumbers.PhoneMetadata.prototype.setUan = function(e) {
              this.set$Value(25, e);
            }, i18n.phonenumbers.PhoneMetadata.prototype.hasUan = function() {
              return this.has$Value(25);
            }, i18n.phonenumbers.PhoneMetadata.prototype.uanCount = function() {
              return this.count$Values(25);
            }, i18n.phonenumbers.PhoneMetadata.prototype.clearUan = function() {
              this.clear$Field(25);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getEmergency = function() {
              return this.get$Value(27);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getEmergencyOrDefault = function() {
              return this.get$ValueOrDefault(27);
            }, i18n.phonenumbers.PhoneMetadata.prototype.setEmergency = function(e) {
              this.set$Value(27, e);
            }, i18n.phonenumbers.PhoneMetadata.prototype.hasEmergency = function() {
              return this.has$Value(27);
            }, i18n.phonenumbers.PhoneMetadata.prototype.emergencyCount = function() {
              return this.count$Values(27);
            }, i18n.phonenumbers.PhoneMetadata.prototype.clearEmergency = function() {
              this.clear$Field(27);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getVoicemail = function() {
              return this.get$Value(28);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getVoicemailOrDefault = function() {
              return this.get$ValueOrDefault(28);
            }, i18n.phonenumbers.PhoneMetadata.prototype.setVoicemail = function(e) {
              this.set$Value(28, e);
            }, i18n.phonenumbers.PhoneMetadata.prototype.hasVoicemail = function() {
              return this.has$Value(28);
            }, i18n.phonenumbers.PhoneMetadata.prototype.voicemailCount = function() {
              return this.count$Values(28);
            }, i18n.phonenumbers.PhoneMetadata.prototype.clearVoicemail = function() {
              this.clear$Field(28);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getShortCode = function() {
              return this.get$Value(29);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getShortCodeOrDefault = function() {
              return this.get$ValueOrDefault(29);
            }, i18n.phonenumbers.PhoneMetadata.prototype.setShortCode = function(e) {
              this.set$Value(29, e);
            }, i18n.phonenumbers.PhoneMetadata.prototype.hasShortCode = function() {
              return this.has$Value(29);
            }, i18n.phonenumbers.PhoneMetadata.prototype.shortCodeCount = function() {
              return this.count$Values(29);
            }, i18n.phonenumbers.PhoneMetadata.prototype.clearShortCode = function() {
              this.clear$Field(29);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getStandardRate = function() {
              return this.get$Value(30);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getStandardRateOrDefault = function() {
              return this.get$ValueOrDefault(30);
            }, i18n.phonenumbers.PhoneMetadata.prototype.setStandardRate = function(e) {
              this.set$Value(30, e);
            }, i18n.phonenumbers.PhoneMetadata.prototype.hasStandardRate = function() {
              return this.has$Value(30);
            }, i18n.phonenumbers.PhoneMetadata.prototype.standardRateCount = function() {
              return this.count$Values(30);
            }, i18n.phonenumbers.PhoneMetadata.prototype.clearStandardRate = function() {
              this.clear$Field(30);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getCarrierSpecific = function() {
              return this.get$Value(31);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getCarrierSpecificOrDefault = function() {
              return this.get$ValueOrDefault(31);
            }, i18n.phonenumbers.PhoneMetadata.prototype.setCarrierSpecific = function(e) {
              this.set$Value(31, e);
            }, i18n.phonenumbers.PhoneMetadata.prototype.hasCarrierSpecific = function() {
              return this.has$Value(31);
            }, i18n.phonenumbers.PhoneMetadata.prototype.carrierSpecificCount = function() {
              return this.count$Values(31);
            }, i18n.phonenumbers.PhoneMetadata.prototype.clearCarrierSpecific = function() {
              this.clear$Field(31);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getSmsServices = function() {
              return this.get$Value(33);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getSmsServicesOrDefault = function() {
              return this.get$ValueOrDefault(33);
            }, i18n.phonenumbers.PhoneMetadata.prototype.setSmsServices = function(e) {
              this.set$Value(33, e);
            }, i18n.phonenumbers.PhoneMetadata.prototype.hasSmsServices = function() {
              return this.has$Value(33);
            }, i18n.phonenumbers.PhoneMetadata.prototype.smsServicesCount = function() {
              return this.count$Values(33);
            }, i18n.phonenumbers.PhoneMetadata.prototype.clearSmsServices = function() {
              this.clear$Field(33);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getNoInternationalDialling = function() {
              return this.get$Value(24);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getNoInternationalDiallingOrDefault = function() {
              return this.get$ValueOrDefault(24);
            }, i18n.phonenumbers.PhoneMetadata.prototype.setNoInternationalDialling = function(e) {
              this.set$Value(24, e);
            }, i18n.phonenumbers.PhoneMetadata.prototype.hasNoInternationalDialling = function() {
              return this.has$Value(24);
            }, i18n.phonenumbers.PhoneMetadata.prototype.noInternationalDiallingCount = function() {
              return this.count$Values(24);
            }, i18n.phonenumbers.PhoneMetadata.prototype.clearNoInternationalDialling = function() {
              this.clear$Field(24);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getId = function() {
              return this.get$Value(9);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getIdOrDefault = function() {
              return this.get$ValueOrDefault(9);
            }, i18n.phonenumbers.PhoneMetadata.prototype.setId = function(e) {
              this.set$Value(9, e);
            }, i18n.phonenumbers.PhoneMetadata.prototype.hasId = function() {
              return this.has$Value(9);
            }, i18n.phonenumbers.PhoneMetadata.prototype.idCount = function() {
              return this.count$Values(9);
            }, i18n.phonenumbers.PhoneMetadata.prototype.clearId = function() {
              this.clear$Field(9);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getCountryCode = function() {
              return this.get$Value(10);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getCountryCodeOrDefault = function() {
              return this.get$ValueOrDefault(10);
            }, i18n.phonenumbers.PhoneMetadata.prototype.setCountryCode = function(e) {
              this.set$Value(10, e);
            }, i18n.phonenumbers.PhoneMetadata.prototype.hasCountryCode = function() {
              return this.has$Value(10);
            }, i18n.phonenumbers.PhoneMetadata.prototype.countryCodeCount = function() {
              return this.count$Values(10);
            }, i18n.phonenumbers.PhoneMetadata.prototype.clearCountryCode = function() {
              this.clear$Field(10);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getInternationalPrefix = function() {
              return this.get$Value(11);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getInternationalPrefixOrDefault = function() {
              return this.get$ValueOrDefault(11);
            }, i18n.phonenumbers.PhoneMetadata.prototype.setInternationalPrefix = function(e) {
              this.set$Value(11, e);
            }, i18n.phonenumbers.PhoneMetadata.prototype.hasInternationalPrefix = function() {
              return this.has$Value(11);
            }, i18n.phonenumbers.PhoneMetadata.prototype.internationalPrefixCount = function() {
              return this.count$Values(11);
            }, i18n.phonenumbers.PhoneMetadata.prototype.clearInternationalPrefix = function() {
              this.clear$Field(11);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getPreferredInternationalPrefix = function() {
              return this.get$Value(17);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getPreferredInternationalPrefixOrDefault = function() {
              return this.get$ValueOrDefault(17);
            }, i18n.phonenumbers.PhoneMetadata.prototype.setPreferredInternationalPrefix = function(e) {
              this.set$Value(17, e);
            }, i18n.phonenumbers.PhoneMetadata.prototype.hasPreferredInternationalPrefix = function() {
              return this.has$Value(17);
            }, i18n.phonenumbers.PhoneMetadata.prototype.preferredInternationalPrefixCount = function() {
              return this.count$Values(17);
            }, i18n.phonenumbers.PhoneMetadata.prototype.clearPreferredInternationalPrefix = function() {
              this.clear$Field(17);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getNationalPrefix = function() {
              return this.get$Value(12);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getNationalPrefixOrDefault = function() {
              return this.get$ValueOrDefault(12);
            }, i18n.phonenumbers.PhoneMetadata.prototype.setNationalPrefix = function(e) {
              this.set$Value(12, e);
            }, i18n.phonenumbers.PhoneMetadata.prototype.hasNationalPrefix = function() {
              return this.has$Value(12);
            }, i18n.phonenumbers.PhoneMetadata.prototype.nationalPrefixCount = function() {
              return this.count$Values(12);
            }, i18n.phonenumbers.PhoneMetadata.prototype.clearNationalPrefix = function() {
              this.clear$Field(12);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getPreferredExtnPrefix = function() {
              return this.get$Value(13);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getPreferredExtnPrefixOrDefault = function() {
              return this.get$ValueOrDefault(13);
            }, i18n.phonenumbers.PhoneMetadata.prototype.setPreferredExtnPrefix = function(e) {
              this.set$Value(13, e);
            }, i18n.phonenumbers.PhoneMetadata.prototype.hasPreferredExtnPrefix = function() {
              return this.has$Value(13);
            }, i18n.phonenumbers.PhoneMetadata.prototype.preferredExtnPrefixCount = function() {
              return this.count$Values(13);
            }, i18n.phonenumbers.PhoneMetadata.prototype.clearPreferredExtnPrefix = function() {
              this.clear$Field(13);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getNationalPrefixForParsing = function() {
              return this.get$Value(15);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getNationalPrefixForParsingOrDefault = function() {
              return this.get$ValueOrDefault(15);
            }, i18n.phonenumbers.PhoneMetadata.prototype.setNationalPrefixForParsing = function(e) {
              this.set$Value(15, e);
            }, i18n.phonenumbers.PhoneMetadata.prototype.hasNationalPrefixForParsing = function() {
              return this.has$Value(15);
            }, i18n.phonenumbers.PhoneMetadata.prototype.nationalPrefixForParsingCount = function() {
              return this.count$Values(15);
            }, i18n.phonenumbers.PhoneMetadata.prototype.clearNationalPrefixForParsing = function() {
              this.clear$Field(15);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getNationalPrefixTransformRule = function() {
              return this.get$Value(16);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getNationalPrefixTransformRuleOrDefault = function() {
              return this.get$ValueOrDefault(16);
            }, i18n.phonenumbers.PhoneMetadata.prototype.setNationalPrefixTransformRule = function(e) {
              this.set$Value(16, e);
            }, i18n.phonenumbers.PhoneMetadata.prototype.hasNationalPrefixTransformRule = function() {
              return this.has$Value(16);
            }, i18n.phonenumbers.PhoneMetadata.prototype.nationalPrefixTransformRuleCount = function() {
              return this.count$Values(16);
            }, i18n.phonenumbers.PhoneMetadata.prototype.clearNationalPrefixTransformRule = function() {
              this.clear$Field(16);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getSameMobileAndFixedLinePattern = function() {
              return this.get$Value(18);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getSameMobileAndFixedLinePatternOrDefault = function() {
              return this.get$ValueOrDefault(18);
            }, i18n.phonenumbers.PhoneMetadata.prototype.setSameMobileAndFixedLinePattern = function(e) {
              this.set$Value(18, e);
            }, i18n.phonenumbers.PhoneMetadata.prototype.hasSameMobileAndFixedLinePattern = function() {
              return this.has$Value(18);
            }, i18n.phonenumbers.PhoneMetadata.prototype.sameMobileAndFixedLinePatternCount = function() {
              return this.count$Values(18);
            }, i18n.phonenumbers.PhoneMetadata.prototype.clearSameMobileAndFixedLinePattern = function() {
              this.clear$Field(18);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getNumberFormat = function(e) {
              return this.get$Value(19, e);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getNumberFormatOrDefault = function(e) {
              return this.get$ValueOrDefault(19, e);
            }, i18n.phonenumbers.PhoneMetadata.prototype.addNumberFormat = function(e) {
              this.add$Value(19, e);
            }, i18n.phonenumbers.PhoneMetadata.prototype.numberFormatArray = function() {
              return this.array$Values(19);
            }, i18n.phonenumbers.PhoneMetadata.prototype.hasNumberFormat = function() {
              return this.has$Value(19);
            }, i18n.phonenumbers.PhoneMetadata.prototype.numberFormatCount = function() {
              return this.count$Values(19);
            }, i18n.phonenumbers.PhoneMetadata.prototype.clearNumberFormat = function() {
              this.clear$Field(19);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getIntlNumberFormat = function(e) {
              return this.get$Value(20, e);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getIntlNumberFormatOrDefault = function(e) {
              return this.get$ValueOrDefault(20, e);
            }, i18n.phonenumbers.PhoneMetadata.prototype.addIntlNumberFormat = function(e) {
              this.add$Value(20, e);
            }, i18n.phonenumbers.PhoneMetadata.prototype.intlNumberFormatArray = function() {
              return this.array$Values(20);
            }, i18n.phonenumbers.PhoneMetadata.prototype.hasIntlNumberFormat = function() {
              return this.has$Value(20);
            }, i18n.phonenumbers.PhoneMetadata.prototype.intlNumberFormatCount = function() {
              return this.count$Values(20);
            }, i18n.phonenumbers.PhoneMetadata.prototype.clearIntlNumberFormat = function() {
              this.clear$Field(20);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getMainCountryForCode = function() {
              return this.get$Value(22);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getMainCountryForCodeOrDefault = function() {
              return this.get$ValueOrDefault(22);
            }, i18n.phonenumbers.PhoneMetadata.prototype.setMainCountryForCode = function(e) {
              this.set$Value(22, e);
            }, i18n.phonenumbers.PhoneMetadata.prototype.hasMainCountryForCode = function() {
              return this.has$Value(22);
            }, i18n.phonenumbers.PhoneMetadata.prototype.mainCountryForCodeCount = function() {
              return this.count$Values(22);
            }, i18n.phonenumbers.PhoneMetadata.prototype.clearMainCountryForCode = function() {
              this.clear$Field(22);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getLeadingDigits = function() {
              return this.get$Value(23);
            }, i18n.phonenumbers.PhoneMetadata.prototype.getLeadingDigitsOrDefault = function() {
              return this.get$ValueOrDefault(23);
            }, i18n.phonenumbers.PhoneMetadata.prototype.setLeadingDigits = function(e) {
              this.set$Value(23, e);
            }, i18n.phonenumbers.PhoneMetadata.prototype.hasLeadingDigits = function() {
              return this.has$Value(23);
            }, i18n.phonenumbers.PhoneMetadata.prototype.leadingDigitsCount = function() {
              return this.count$Values(23);
            }, i18n.phonenumbers.PhoneMetadata.prototype.clearLeadingDigits = function() {
              this.clear$Field(23);
            }, i18n.phonenumbers.PhoneMetadataCollection = function() {
              goog.proto2.Message.call(this);
            }, goog.inherits(i18n.phonenumbers.PhoneMetadataCollection, goog.proto2.Message), i18n.phonenumbers.PhoneMetadataCollection.descriptor_ = null, i18n.phonenumbers.PhoneMetadataCollection.prototype.getMetadata = function(e) {
              return this.get$Value(1, e);
            }, i18n.phonenumbers.PhoneMetadataCollection.prototype.getMetadataOrDefault = function(e) {
              return this.get$ValueOrDefault(1, e);
            }, i18n.phonenumbers.PhoneMetadataCollection.prototype.addMetadata = function(e) {
              this.add$Value(1, e);
            }, i18n.phonenumbers.PhoneMetadataCollection.prototype.metadataArray = function() {
              return this.array$Values(1);
            }, i18n.phonenumbers.PhoneMetadataCollection.prototype.hasMetadata = function() {
              return this.has$Value(1);
            }, i18n.phonenumbers.PhoneMetadataCollection.prototype.metadataCount = function() {
              return this.count$Values(1);
            }, i18n.phonenumbers.PhoneMetadataCollection.prototype.clearMetadata = function() {
              this.clear$Field(1);
            }, i18n.phonenumbers.NumberFormat.prototype.getDescriptor = function() {
              var e = i18n.phonenumbers.NumberFormat.descriptor_;
              return e || (i18n.phonenumbers.NumberFormat.descriptor_ = e = goog.proto2.Message.createDescriptor(i18n.phonenumbers.NumberFormat, { 0: { name: "NumberFormat", fullName: "i18n.phonenumbers.NumberFormat" }, 1: { name: "pattern", required: !0, fieldType: goog.proto2.Message.FieldType.STRING, type: String }, 2: { name: "format", required: !0, fieldType: goog.proto2.Message.FieldType.STRING, type: String }, 3: {
                name: "leading_digits_pattern",
                repeated: !0,
                fieldType: goog.proto2.Message.FieldType.STRING,
                type: String
              }, 4: { name: "national_prefix_formatting_rule", fieldType: goog.proto2.Message.FieldType.STRING, type: String }, 6: { name: "national_prefix_optional_when_formatting", fieldType: goog.proto2.Message.FieldType.BOOL, defaultValue: !1, type: Boolean }, 5: { name: "domestic_carrier_code_formatting_rule", fieldType: goog.proto2.Message.FieldType.STRING, type: String } })), e;
            }, i18n.phonenumbers.NumberFormat.getDescriptor = i18n.phonenumbers.NumberFormat.prototype.getDescriptor, i18n.phonenumbers.PhoneNumberDesc.prototype.getDescriptor = function() {
              var e = i18n.phonenumbers.PhoneNumberDesc.descriptor_;
              return e || (i18n.phonenumbers.PhoneNumberDesc.descriptor_ = e = goog.proto2.Message.createDescriptor(i18n.phonenumbers.PhoneNumberDesc, {
                0: { name: "PhoneNumberDesc", fullName: "i18n.phonenumbers.PhoneNumberDesc" },
                2: { name: "national_number_pattern", fieldType: goog.proto2.Message.FieldType.STRING, type: String },
                9: { name: "possible_length", repeated: !0, fieldType: goog.proto2.Message.FieldType.INT32, type: Number },
                10: { name: "possible_length_local_only", repeated: !0, fieldType: goog.proto2.Message.FieldType.INT32, type: Number },
                6: { name: "example_number", fieldType: goog.proto2.Message.FieldType.STRING, type: String }
              })), e;
            }, i18n.phonenumbers.PhoneNumberDesc.getDescriptor = i18n.phonenumbers.PhoneNumberDesc.prototype.getDescriptor, i18n.phonenumbers.PhoneMetadata.prototype.getDescriptor = function() {
              var e = i18n.phonenumbers.PhoneMetadata.descriptor_;
              return e || (i18n.phonenumbers.PhoneMetadata.descriptor_ = e = goog.proto2.Message.createDescriptor(i18n.phonenumbers.PhoneMetadata, {
                0: { name: "PhoneMetadata", fullName: "i18n.phonenumbers.PhoneMetadata" },
                1: { name: "general_desc", fieldType: goog.proto2.Message.FieldType.MESSAGE, type: i18n.phonenumbers.PhoneNumberDesc },
                2: { name: "fixed_line", fieldType: goog.proto2.Message.FieldType.MESSAGE, type: i18n.phonenumbers.PhoneNumberDesc },
                3: { name: "mobile", fieldType: goog.proto2.Message.FieldType.MESSAGE, type: i18n.phonenumbers.PhoneNumberDesc },
                4: { name: "toll_free", fieldType: goog.proto2.Message.FieldType.MESSAGE, type: i18n.phonenumbers.PhoneNumberDesc },
                5: { name: "premium_rate", fieldType: goog.proto2.Message.FieldType.MESSAGE, type: i18n.phonenumbers.PhoneNumberDesc },
                6: { name: "shared_cost", fieldType: goog.proto2.Message.FieldType.MESSAGE, type: i18n.phonenumbers.PhoneNumberDesc },
                7: {
                  name: "personal_number",
                  fieldType: goog.proto2.Message.FieldType.MESSAGE,
                  type: i18n.phonenumbers.PhoneNumberDesc
                },
                8: { name: "voip", fieldType: goog.proto2.Message.FieldType.MESSAGE, type: i18n.phonenumbers.PhoneNumberDesc },
                21: { name: "pager", fieldType: goog.proto2.Message.FieldType.MESSAGE, type: i18n.phonenumbers.PhoneNumberDesc },
                25: { name: "uan", fieldType: goog.proto2.Message.FieldType.MESSAGE, type: i18n.phonenumbers.PhoneNumberDesc },
                27: { name: "emergency", fieldType: goog.proto2.Message.FieldType.MESSAGE, type: i18n.phonenumbers.PhoneNumberDesc },
                28: {
                  name: "voicemail",
                  fieldType: goog.proto2.Message.FieldType.MESSAGE,
                  type: i18n.phonenumbers.PhoneNumberDesc
                },
                29: { name: "short_code", fieldType: goog.proto2.Message.FieldType.MESSAGE, type: i18n.phonenumbers.PhoneNumberDesc },
                30: { name: "standard_rate", fieldType: goog.proto2.Message.FieldType.MESSAGE, type: i18n.phonenumbers.PhoneNumberDesc },
                31: { name: "carrier_specific", fieldType: goog.proto2.Message.FieldType.MESSAGE, type: i18n.phonenumbers.PhoneNumberDesc },
                33: { name: "sms_services", fieldType: goog.proto2.Message.FieldType.MESSAGE, type: i18n.phonenumbers.PhoneNumberDesc },
                24: {
                  name: "no_international_dialling",
                  fieldType: goog.proto2.Message.FieldType.MESSAGE,
                  type: i18n.phonenumbers.PhoneNumberDesc
                },
                9: { name: "id", required: !0, fieldType: goog.proto2.Message.FieldType.STRING, type: String },
                10: { name: "country_code", fieldType: goog.proto2.Message.FieldType.INT32, type: Number },
                11: { name: "international_prefix", fieldType: goog.proto2.Message.FieldType.STRING, type: String },
                17: { name: "preferred_international_prefix", fieldType: goog.proto2.Message.FieldType.STRING, type: String },
                12: {
                  name: "national_prefix",
                  fieldType: goog.proto2.Message.FieldType.STRING,
                  type: String
                },
                13: { name: "preferred_extn_prefix", fieldType: goog.proto2.Message.FieldType.STRING, type: String },
                15: { name: "national_prefix_for_parsing", fieldType: goog.proto2.Message.FieldType.STRING, type: String },
                16: { name: "national_prefix_transform_rule", fieldType: goog.proto2.Message.FieldType.STRING, type: String },
                18: { name: "same_mobile_and_fixed_line_pattern", fieldType: goog.proto2.Message.FieldType.BOOL, defaultValue: !1, type: Boolean },
                19: {
                  name: "number_format",
                  repeated: !0,
                  fieldType: goog.proto2.Message.FieldType.MESSAGE,
                  type: i18n.phonenumbers.NumberFormat
                },
                20: { name: "intl_number_format", repeated: !0, fieldType: goog.proto2.Message.FieldType.MESSAGE, type: i18n.phonenumbers.NumberFormat },
                22: { name: "main_country_for_code", fieldType: goog.proto2.Message.FieldType.BOOL, defaultValue: !1, type: Boolean },
                23: { name: "leading_digits", fieldType: goog.proto2.Message.FieldType.STRING, type: String }
              })), e;
            }, i18n.phonenumbers.PhoneMetadata.getDescriptor = i18n.phonenumbers.PhoneMetadata.prototype.getDescriptor, i18n.phonenumbers.PhoneMetadataCollection.prototype.getDescriptor = function() {
              var e = i18n.phonenumbers.PhoneMetadataCollection.descriptor_;
              return e || (i18n.phonenumbers.PhoneMetadataCollection.descriptor_ = e = goog.proto2.Message.createDescriptor(i18n.phonenumbers.PhoneMetadataCollection, { 0: { name: "PhoneMetadataCollection", fullName: "i18n.phonenumbers.PhoneMetadataCollection" }, 1: { name: "metadata", repeated: !0, fieldType: goog.proto2.Message.FieldType.MESSAGE, type: i18n.phonenumbers.PhoneMetadata } })), e;
            }, i18n.phonenumbers.PhoneMetadataCollection.getDescriptor = i18n.phonenumbers.PhoneMetadataCollection.prototype.getDescriptor, i18n.phonenumbers.PhoneNumber = function() {
              goog.proto2.Message.call(this);
            }, goog.inherits(i18n.phonenumbers.PhoneNumber, goog.proto2.Message), i18n.phonenumbers.PhoneNumber.descriptor_ = null, i18n.phonenumbers.PhoneNumber.prototype.getCountryCode = function() {
              return this.get$Value(1);
            }, i18n.phonenumbers.PhoneNumber.prototype.getCountryCodeOrDefault = function() {
              return this.get$ValueOrDefault(1);
            }, i18n.phonenumbers.PhoneNumber.prototype.setCountryCode = function(e) {
              this.set$Value(1, e);
            }, i18n.phonenumbers.PhoneNumber.prototype.hasCountryCode = function() {
              return this.has$Value(1);
            }, i18n.phonenumbers.PhoneNumber.prototype.countryCodeCount = function() {
              return this.count$Values(1);
            }, i18n.phonenumbers.PhoneNumber.prototype.clearCountryCode = function() {
              this.clear$Field(1);
            }, i18n.phonenumbers.PhoneNumber.prototype.getNationalNumber = function() {
              return this.get$Value(2);
            }, i18n.phonenumbers.PhoneNumber.prototype.getNationalNumberOrDefault = function() {
              return this.get$ValueOrDefault(2);
            }, i18n.phonenumbers.PhoneNumber.prototype.setNationalNumber = function(e) {
              this.set$Value(2, e);
            }, i18n.phonenumbers.PhoneNumber.prototype.hasNationalNumber = function() {
              return this.has$Value(2);
            }, i18n.phonenumbers.PhoneNumber.prototype.nationalNumberCount = function() {
              return this.count$Values(2);
            }, i18n.phonenumbers.PhoneNumber.prototype.clearNationalNumber = function() {
              this.clear$Field(2);
            }, i18n.phonenumbers.PhoneNumber.prototype.getExtension = function() {
              return this.get$Value(3);
            }, i18n.phonenumbers.PhoneNumber.prototype.getExtensionOrDefault = function() {
              return this.get$ValueOrDefault(3);
            }, i18n.phonenumbers.PhoneNumber.prototype.setExtension = function(e) {
              this.set$Value(3, e);
            }, i18n.phonenumbers.PhoneNumber.prototype.hasExtension = function() {
              return this.has$Value(3);
            }, i18n.phonenumbers.PhoneNumber.prototype.extensionCount = function() {
              return this.count$Values(3);
            }, i18n.phonenumbers.PhoneNumber.prototype.clearExtension = function() {
              this.clear$Field(3);
            }, i18n.phonenumbers.PhoneNumber.prototype.getItalianLeadingZero = function() {
              return this.get$Value(4);
            }, i18n.phonenumbers.PhoneNumber.prototype.getItalianLeadingZeroOrDefault = function() {
              return this.get$ValueOrDefault(4);
            }, i18n.phonenumbers.PhoneNumber.prototype.setItalianLeadingZero = function(e) {
              this.set$Value(4, e);
            }, i18n.phonenumbers.PhoneNumber.prototype.hasItalianLeadingZero = function() {
              return this.has$Value(4);
            }, i18n.phonenumbers.PhoneNumber.prototype.italianLeadingZeroCount = function() {
              return this.count$Values(4);
            }, i18n.phonenumbers.PhoneNumber.prototype.clearItalianLeadingZero = function() {
              this.clear$Field(4);
            }, i18n.phonenumbers.PhoneNumber.prototype.getNumberOfLeadingZeros = function() {
              return this.get$Value(8);
            }, i18n.phonenumbers.PhoneNumber.prototype.getNumberOfLeadingZerosOrDefault = function() {
              return this.get$ValueOrDefault(8);
            }, i18n.phonenumbers.PhoneNumber.prototype.setNumberOfLeadingZeros = function(e) {
              this.set$Value(8, e);
            }, i18n.phonenumbers.PhoneNumber.prototype.hasNumberOfLeadingZeros = function() {
              return this.has$Value(8);
            }, i18n.phonenumbers.PhoneNumber.prototype.numberOfLeadingZerosCount = function() {
              return this.count$Values(8);
            }, i18n.phonenumbers.PhoneNumber.prototype.clearNumberOfLeadingZeros = function() {
              this.clear$Field(8);
            }, i18n.phonenumbers.PhoneNumber.prototype.getRawInput = function() {
              return this.get$Value(5);
            }, i18n.phonenumbers.PhoneNumber.prototype.getRawInputOrDefault = function() {
              return this.get$ValueOrDefault(5);
            }, i18n.phonenumbers.PhoneNumber.prototype.setRawInput = function(e) {
              this.set$Value(5, e);
            }, i18n.phonenumbers.PhoneNumber.prototype.hasRawInput = function() {
              return this.has$Value(5);
            }, i18n.phonenumbers.PhoneNumber.prototype.rawInputCount = function() {
              return this.count$Values(5);
            }, i18n.phonenumbers.PhoneNumber.prototype.clearRawInput = function() {
              this.clear$Field(5);
            }, i18n.phonenumbers.PhoneNumber.prototype.getCountryCodeSource = function() {
              return this.get$Value(6);
            }, i18n.phonenumbers.PhoneNumber.prototype.getCountryCodeSourceOrDefault = function() {
              return this.get$ValueOrDefault(6);
            }, i18n.phonenumbers.PhoneNumber.prototype.setCountryCodeSource = function(e) {
              this.set$Value(6, e);
            }, i18n.phonenumbers.PhoneNumber.prototype.hasCountryCodeSource = function() {
              return this.has$Value(6);
            }, i18n.phonenumbers.PhoneNumber.prototype.countryCodeSourceCount = function() {
              return this.count$Values(6);
            }, i18n.phonenumbers.PhoneNumber.prototype.clearCountryCodeSource = function() {
              this.clear$Field(6);
            }, i18n.phonenumbers.PhoneNumber.prototype.getPreferredDomesticCarrierCode = function() {
              return this.get$Value(7);
            }, i18n.phonenumbers.PhoneNumber.prototype.getPreferredDomesticCarrierCodeOrDefault = function() {
              return this.get$ValueOrDefault(7);
            }, i18n.phonenumbers.PhoneNumber.prototype.setPreferredDomesticCarrierCode = function(e) {
              this.set$Value(7, e);
            }, i18n.phonenumbers.PhoneNumber.prototype.hasPreferredDomesticCarrierCode = function() {
              return this.has$Value(7);
            }, i18n.phonenumbers.PhoneNumber.prototype.preferredDomesticCarrierCodeCount = function() {
              return this.count$Values(7);
            }, i18n.phonenumbers.PhoneNumber.prototype.clearPreferredDomesticCarrierCode = function() {
              this.clear$Field(7);
            }, i18n.phonenumbers.PhoneNumber.CountryCodeSource = { UNSPECIFIED: 0, FROM_NUMBER_WITH_PLUS_SIGN: 1, FROM_NUMBER_WITH_IDD: 5, FROM_NUMBER_WITHOUT_PLUS_SIGN: 10, FROM_DEFAULT_COUNTRY: 20 }, i18n.phonenumbers.PhoneNumber.prototype.getDescriptor = function() {
              var e = i18n.phonenumbers.PhoneNumber.descriptor_;
              return e || (i18n.phonenumbers.PhoneNumber.descriptor_ = e = goog.proto2.Message.createDescriptor(i18n.phonenumbers.PhoneNumber, {
                0: { name: "PhoneNumber", fullName: "i18n.phonenumbers.PhoneNumber" },
                1: { name: "country_code", required: !0, fieldType: goog.proto2.Message.FieldType.INT32, type: Number },
                2: { name: "national_number", required: !0, fieldType: goog.proto2.Message.FieldType.UINT64, type: Number },
                3: {
                  name: "extension",
                  fieldType: goog.proto2.Message.FieldType.STRING,
                  type: String
                },
                4: { name: "italian_leading_zero", fieldType: goog.proto2.Message.FieldType.BOOL, type: Boolean },
                8: { name: "number_of_leading_zeros", fieldType: goog.proto2.Message.FieldType.INT32, defaultValue: 1, type: Number },
                5: { name: "raw_input", fieldType: goog.proto2.Message.FieldType.STRING, type: String },
                6: { name: "country_code_source", fieldType: goog.proto2.Message.FieldType.ENUM, defaultValue: i18n.phonenumbers.PhoneNumber.CountryCodeSource.UNSPECIFIED, type: i18n.phonenumbers.PhoneNumber.CountryCodeSource },
                7: { name: "preferred_domestic_carrier_code", fieldType: goog.proto2.Message.FieldType.STRING, type: String }
              })), e;
            }, i18n.phonenumbers.PhoneNumber.ctor = i18n.phonenumbers.PhoneNumber, i18n.phonenumbers.PhoneNumber.ctor.getDescriptor = i18n.phonenumbers.PhoneNumber.prototype.getDescriptor, i18n.phonenumbers.metadata = {}, i18n.phonenumbers.metadata.countryCodeToRegionCodeMap = {
              1: "US AG AI AS BB BM BS CA DM DO GD GU JM KN KY LC MP MS PR SX TC TT VC VG VI".split(" "),
              7: ["RU", "KZ"],
              20: ["EG"],
              27: ["ZA"],
              30: ["GR"],
              31: ["NL"],
              32: ["BE"],
              33: ["FR"],
              34: ["ES"],
              36: ["HU"],
              39: ["IT", "VA"],
              40: ["RO"],
              41: ["CH"],
              43: ["AT"],
              44: ["GB", "GG", "IM", "JE"],
              45: ["DK"],
              46: ["SE"],
              47: ["NO", "SJ"],
              48: ["PL"],
              49: ["DE"],
              51: ["PE"],
              52: ["MX"],
              53: ["CU"],
              54: ["AR"],
              55: ["BR"],
              56: ["CL"],
              57: ["CO"],
              58: ["VE"],
              60: ["MY"],
              61: ["AU", "CC", "CX"],
              62: ["ID"],
              63: ["PH"],
              64: ["NZ"],
              65: ["SG"],
              66: ["TH"],
              81: ["JP"],
              82: ["KR"],
              84: ["VN"],
              86: ["CN"],
              90: ["TR"],
              91: ["IN"],
              92: ["PK"],
              93: ["AF"],
              94: ["LK"],
              95: ["MM"],
              98: ["IR"],
              211: ["SS"],
              212: ["MA", "EH"],
              213: ["DZ"],
              216: ["TN"],
              218: ["LY"],
              220: ["GM"],
              221: ["SN"],
              222: ["MR"],
              223: ["ML"],
              224: ["GN"],
              225: ["CI"],
              226: ["BF"],
              227: ["NE"],
              228: ["TG"],
              229: ["BJ"],
              230: ["MU"],
              231: ["LR"],
              232: ["SL"],
              233: ["GH"],
              234: ["NG"],
              235: ["TD"],
              236: ["CF"],
              237: ["CM"],
              238: ["CV"],
              239: ["ST"],
              240: ["GQ"],
              241: ["GA"],
              242: ["CG"],
              243: ["CD"],
              244: ["AO"],
              245: ["GW"],
              246: ["IO"],
              247: ["AC"],
              248: ["SC"],
              249: ["SD"],
              250: ["RW"],
              251: ["ET"],
              252: ["SO"],
              253: ["DJ"],
              254: ["KE"],
              255: ["TZ"],
              256: ["UG"],
              257: ["BI"],
              258: ["MZ"],
              260: ["ZM"],
              261: ["MG"],
              262: ["RE", "YT"],
              263: ["ZW"],
              264: ["NA"],
              265: ["MW"],
              266: ["LS"],
              267: ["BW"],
              268: ["SZ"],
              269: ["KM"],
              290: ["SH", "TA"],
              291: ["ER"],
              297: ["AW"],
              298: ["FO"],
              299: ["GL"],
              350: ["GI"],
              351: ["PT"],
              352: ["LU"],
              353: ["IE"],
              354: ["IS"],
              355: ["AL"],
              356: ["MT"],
              357: ["CY"],
              358: ["FI", "AX"],
              359: ["BG"],
              370: ["LT"],
              371: ["LV"],
              372: ["EE"],
              373: ["MD"],
              374: ["AM"],
              375: ["BY"],
              376: ["AD"],
              377: ["MC"],
              378: ["SM"],
              380: ["UA"],
              381: ["RS"],
              382: ["ME"],
              383: ["XK"],
              385: ["HR"],
              386: ["SI"],
              387: ["BA"],
              389: ["MK"],
              420: ["CZ"],
              421: ["SK"],
              423: ["LI"],
              500: ["FK"],
              501: ["BZ"],
              502: ["GT"],
              503: ["SV"],
              504: ["HN"],
              505: ["NI"],
              506: ["CR"],
              507: ["PA"],
              508: ["PM"],
              509: ["HT"],
              590: ["GP", "BL", "MF"],
              591: ["BO"],
              592: ["GY"],
              593: ["EC"],
              594: ["GF"],
              595: ["PY"],
              596: ["MQ"],
              597: ["SR"],
              598: ["UY"],
              599: ["CW", "BQ"],
              670: ["TL"],
              672: ["NF"],
              673: ["BN"],
              674: ["NR"],
              675: ["PG"],
              676: ["TO"],
              677: ["SB"],
              678: ["VU"],
              679: ["FJ"],
              680: ["PW"],
              681: ["WF"],
              682: ["CK"],
              683: ["NU"],
              685: ["WS"],
              686: ["KI"],
              687: ["NC"],
              688: ["TV"],
              689: ["PF"],
              690: ["TK"],
              691: ["FM"],
              692: ["MH"],
              800: ["001"],
              808: ["001"],
              850: ["KP"],
              852: ["HK"],
              853: ["MO"],
              855: ["KH"],
              856: ["LA"],
              870: ["001"],
              878: ["001"],
              880: ["BD"],
              881: ["001"],
              882: ["001"],
              883: ["001"],
              886: ["TW"],
              888: ["001"],
              960: ["MV"],
              961: ["LB"],
              962: ["JO"],
              963: ["SY"],
              964: ["IQ"],
              965: ["KW"],
              966: ["SA"],
              967: ["YE"],
              968: ["OM"],
              970: ["PS"],
              971: ["AE"],
              972: ["IL"],
              973: ["BH"],
              974: ["QA"],
              975: ["BT"],
              976: ["MN"],
              977: ["NP"],
              979: ["001"],
              992: ["TJ"],
              993: ["TM"],
              994: ["AZ"],
              995: ["GE"],
              996: ["KG"],
              998: ["UZ"]
            }, i18n.phonenumbers.metadata.countryToMetadata = {
              AC: [, [, , "(?:[01589]\\d|[46])\\d{4}", , , , , , , [5, 6]], [, , "6[2-467]\\d{3}", , , , "62889", , , [5]], [, , "4\\d{4}", , , , "40123", , , [5]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "AC", 247, "00", , , , , , , , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "(?:0[1-9]|[1589]\\d)\\d{4}", , , , "542011", , , [6]], , , [, , , , , , , , , [-1]]],
              AD: [, [, , "(?:1|6\\d)\\d{7}|[135-9]\\d{5}", , , , , , , [6, 8, 9]], [, , "[78]\\d{5}", , , , "712345", , , [6]], [
                ,
                ,
                "690\\d{6}|[356]\\d{5}",
                ,
                ,
                ,
                "312345",
                ,
                ,
                [6, 9]
              ], [, , "180[02]\\d{4}", , , , "18001234", , , [8]], [, , "[19]\\d{5}", , , , "912345", , , [6]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "AD", 376, "00", , , , , , , , [[, "(\\d{3})(\\d{3})", "$1 $2", ["[135-9]"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["1"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]], , [, , , , , , , , , [-1]], , , [, , "1800\\d{4}", , , , , , , [8]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              AE: [
                ,
                [, , "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}", , , , , , , [5, 6, 7, 8, 9, 10, 11, 12]],
                [, , "[2-4679][2-8]\\d{6}", , , , "22345678", , , [8], [7]],
                [, , "5[024-68]\\d{7}", , , , "501234567", , , [9]],
                [, , "400\\d{6}|800\\d{2,9}", , , , "800123456"],
                [, , "900[02]\\d{5}", , , , "900234567", , , [9]],
                [, , "700[05]\\d{5}", , , , "700012345", , , [9]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                "AE",
                971,
                "00",
                "0",
                ,
                ,
                "0",
                ,
                ,
                ,
                [[, "(\\d{3})(\\d{2,9})", "$1 $2", ["60|8"]], [, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[236]|[479][2-8]"], "0$1"], [, "(\\d{3})(\\d)(\\d{5})", "$1 $2 $3", ["[479]"]], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"]],
                ,
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]],
                [
                  ,
                  ,
                  "600[25]\\d{5}",
                  ,
                  ,
                  ,
                  "600212345",
                  ,
                  ,
                  [9]
                ],
                ,
                ,
                [, , , , , , , , , [-1]]
              ],
              AF: [, [, , "[2-7]\\d{8}", , , , , , , [9], [7]], [, , "(?:[25][0-8]|[34][0-4]|6[0-5])[2-9]\\d{6}", , , , "234567890", , , , [7]], [, , "7\\d{8}", , , , "701234567", , , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "AF", 93, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[1-9]"]], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"]], [[, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              AG: [, [, , "(?:268|[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]], [, , "268(?:4(?:6[0-38]|84)|56[0-2])\\d{4}", , , , "2684601234", , , , [7]], [, , "268(?:464|7(?:1[3-9]|[28]\\d|3[0246]|64|7[0-689]))\\d{4}", , , , "2684641234", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [
                ,
                ,
                "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "5002345678"
              ], [, , "26848[01]\\d{4}", , , , "2684801234", , , , [7]], "AG", 1, "011", "1", , , "([457]\\d{6})$|1", "268$1", , , , , [, , "26840[69]\\d{4}", , , , "2684061234", , , , [7]], , "268", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              AI: [, [, , "(?:264|[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]], [, , "264(?:292|4(?:6[12]|9[78]))\\d{4}", , , , "2644612345", , , , [7]], [, , "264(?:235|4(?:69|76)|5(?:3[6-9]|8[1-4])|7(?:29|72))\\d{4}", , , , "2642351234", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [
                ,
                ,
                "900[2-9]\\d{6}",
                ,
                ,
                ,
                "9002123456"
              ], [, , , , , , , , , [-1]], [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "AI", 1, "011", "1", , , "([2457]\\d{6})$|1", "264$1", , , , , [, , "264724\\d{4}", , , , "2647241234", , , , [7]], , "264", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              AL: [, [
                ,
                ,
                "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [6, 7, 8, 9],
                [5]
              ], [, , "4505[0-2]\\d{3}|(?:[2358][16-9]\\d[2-9]|4410)\\d{4}|(?:[2358][2-5][2-9]|4(?:[2-57-9][2-9]|6\\d))\\d{5}", , , , "22345678", , , [8], [5, 6, 7]], [, , "6(?:[78][2-9]|9\\d)\\d{6}", , , , "672123456", , , [9]], [, , "800\\d{4}", , , , "8001234", , , [7]], [, , "900[1-9]\\d\\d", , , , "900123", , , [6]], [, , "808[1-9]\\d\\d", , , , "808123", , , [6]], [, , "700[2-9]\\d{4}", , , , "70021234", , , [8]], [, , , , , , , , , [-1]], "AL", 355, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{3,4})", "$1 $2", ["80|9"], "0$1"], [
                ,
                "(\\d)(\\d{3})(\\d{4})",
                "$1 $2 $3",
                ["4[2-6]"],
                "0$1"
              ], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2358][2-5]|4"], "0$1"], [, "(\\d{3})(\\d{5})", "$1 $2", ["[23578]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["6"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              AM: [
                ,
                [, , "(?:[1-489]\\d|55|60|77)\\d{6}", , , , , , , [8], [5, 6]],
                [, , "(?:(?:1[0-25]|47)\\d|2(?:2[2-46]|3[1-8]|4[2-69]|5[2-7]|6[1-9]|8[1-7])|3[12]2)\\d{5}", , , , "10123456", , , , [5, 6]],
                [, , "(?:33|4[1349]|55|77|88|9[13-9])\\d{6}", , , , "77123456"],
                [, , "800\\d{5}", , , , "80012345"],
                [, , "90[016]\\d{5}", , , , "90012345"],
                [, , "80[1-4]\\d{5}", , , , "80112345"],
                [, , , , , , , , , [-1]],
                [, , "60(?:2[78]|3[5-9]|4[02-9]|5[0-46-9]|[6-8]\\d|9[0-2])\\d{4}", , , , "60271234"],
                "AM",
                374,
                "00",
                "0",
                ,
                ,
                "0",
                ,
                ,
                ,
                [[, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[89]0"], "0 $1"], [, "(\\d{3})(\\d{5})", "$1 $2", ["2|3[12]"], "(0$1)"], [, "(\\d{2})(\\d{6})", "$1 $2", ["1|47"], "(0$1)"], [, "(\\d{2})(\\d{6})", "$1 $2", ["[3-9]"], "0$1"]],
                ,
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]]
              ],
              AO: [, [, , "[29]\\d{8}", , , , , , , [9]], [
                ,
                ,
                "2\\d(?:[0134][25-9]|[25-9]\\d)\\d{5}",
                ,
                ,
                ,
                "222123456"
              ], [, , "9[1-79]\\d{7}", , , , "923123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "AO", 244, "00", , , , , , , , [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[29]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              AR: [
                ,
                [, , "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}", , , , , , , [10, 11], [6, 7, 8]],
                [
                  ,
                  ,
                  "3(?:7(?:1[15]|81)|8(?:21|4[16]|69|9[12]))[46]\\d{5}|(?:2(?:2(?:2[59]|44|52)|3(?:26|44)|47[35]|9(?:[07]2|2[26]|34|46))|3327)[45]\\d{5}|(?:2(?:657|9(?:54|66))|3(?:48[27]|7(?:55|77)|8(?:65|78)))[2-8]\\d{5}|(?:2(?:284|3(?:02|23)|477|622|920)|3(?:4(?:46|89|92)|541))[2-7]\\d{5}|(?:(?:11[1-8]|670)\\d|2(?:2(?:0[45]|1[2-6]|3[3-6])|3(?:[06]4|7[45])|494|6(?:04|1[2-8]|[36][45]|4[3-6])|80[45]|9(?:[17][4-6]|[48][45]|9[3-6]))|3(?:364|4(?:1[2-8]|[25][4-6]|3[3-6]|84)|5(?:1[2-9]|[38][4-6])|6(?:2[45]|44)|7[069][45]|8(?:0[45]|1[2-7]|3[4-6]|5[3-6]|7[2-6]|8[3-68])))\\d{6}|(?:2(?:2(?:62|81)|320|9(?:42|83))|3(?:329|4(?:62|7[16])|5(?:43|64)|7(?:18|5[17])))[2-6]\\d{5}|2(?:2(?:21|4[23]|6[145]|7[1-4]|8[356]|9[267])|3(?:16|3[13-8]|43|5[346-8]|9[3-5])|6(?:2[46]|4[78]|5[1568])|9(?:03|2[1457-9]|3[1356]|4[08]|[56][23]|82))4\\d{5}|(?:2(?:257|3(?:24|46|92)|9(?:01|23|64))|3(?:4(?:42|64)|5(?:25|37|4[47]|71)|7(?:35|72)|825))[3-6]\\d{5}|(?:2(?:2(?:02|2[3467]|4[156]|5[45]|6[6-8]|91)|3(?:1[47]|25|[45][25]|96)|47[48]|625|932)|3(?:38[2578]|4(?:0[0-24-9]|3[78]|4[457]|58|6[035-9]|72|83|9[136-8])|5(?:2[124]|[368][23]|4[2689]|7[2-6])|7(?:16|2[15]|3[14]|4[13]|5[468]|7[3-5]|8[26])|8(?:2[67]|3[278]|4[3-5]|5[78]|6[1-378]|[78]7|94)))[4-6]\\d{5}",
                  ,
                  ,
                  ,
                  "1123456789",
                  ,
                  ,
                  [10],
                  [6, 7, 8]
                ],
                [
                  ,
                  ,
                  "93(?:7(?:1[15]|81)|8(?:21|4[16]|69|9[12]))[46]\\d{5}|9(?:2(?:2(?:2[59]|44|52)|3(?:26|44)|47[35]|9(?:[07]2|2[26]|34|46))|3327)[45]\\d{5}|9(?:2(?:657|9(?:54|66))|3(?:48[27]|7(?:55|77)|8(?:65|78)))[2-8]\\d{5}|9(?:2(?:284|3(?:02|23)|477|622|920)|3(?:4(?:46|89|92)|541))[2-7]\\d{5}|(?:675\\d|9(?:11[1-8]\\d|2(?:2(?:0[45]|1[2-6]|3[3-6])|3(?:[06]4|7[45])|494|6(?:04|1[2-8]|[36][45]|4[3-6])|80[45]|9(?:[17][4-6]|[48][45]|9[3-6]))|3(?:364|4(?:1[2-8]|[25][4-6]|3[3-6]|84)|5(?:1[2-9]|[38][4-6])|6(?:2[45]|44)|7[069][45]|8(?:0[45]|1[2-7]|3[4-6]|5[3-6]|7[2-6]|8[3-68]))))\\d{6}|9(?:2(?:2(?:62|81)|320|9(?:42|83))|3(?:329|4(?:62|7[16])|5(?:43|64)|7(?:18|5[17])))[2-6]\\d{5}|92(?:2(?:21|4[23]|6[145]|7[1-4]|8[356]|9[267])|3(?:16|3[13-8]|43|5[346-8]|9[3-5])|6(?:2[46]|4[78]|5[1568])|9(?:03|2[1457-9]|3[1356]|4[08]|[56][23]|82))4\\d{5}|9(?:2(?:257|3(?:24|46|92)|9(?:01|23|64))|3(?:4(?:42|64)|5(?:25|37|4[47]|71)|7(?:35|72)|825))[3-6]\\d{5}|9(?:2(?:2(?:02|2[3467]|4[156]|5[45]|6[6-8]|91)|3(?:1[47]|25|[45][25]|96)|47[48]|625|932)|3(?:38[2578]|4(?:0[0-24-9]|3[78]|4[457]|58|6[035-9]|72|83|9[136-8])|5(?:2[124]|[368][23]|4[2689]|7[2-6])|7(?:16|2[15]|3[14]|4[13]|5[468]|7[3-5]|8[26])|8(?:2[67]|3[278]|4[3-5]|5[78]|6[1-378]|[78]7|94)))[4-6]\\d{5}",
                  ,
                  ,
                  ,
                  "91123456789",
                  ,
                  ,
                  ,
                  [6, 7, 8]
                ],
                [, , "800\\d{7,8}", , , , "8001234567"],
                [, , "60[04579]\\d{7}", , , , "6001234567", , , [10]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                "AR",
                54,
                "00",
                "0",
                ,
                ,
                "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?",
                "9$1",
                ,
                ,
                [[, "(\\d{3})", "$1", ["0|1(?:0[0-35-7]|1[02-5]|2[015]|3[47]|4[478])|911"]], [, "(\\d{2})(\\d{4})", "$1-$2", ["[1-9]"]], [, "(\\d{3})(\\d{4})", "$1-$2", ["[2-9]"]], [, "(\\d{4})(\\d{4})", "$1-$2", ["[1-8]"]], [
                  ,
                  "(\\d{4})(\\d{2})(\\d{4})",
                  "$1 $2-$3",
                  [
                    "2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])",
                    "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)",
                    "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
                    "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
                  ],
                  "0$1",
                  ,
                  1
                ], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["1"], "0$1", , 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[68]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2-$3", ["[23]"], "0$1", , 1], [
                  ,
                  "(\\d)(\\d{4})(\\d{2})(\\d{4})",
                  "$2 15-$3-$4",
                  [
                    "9(?:2[2-469]|3[3-578])",
                    "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))",
                    "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)",
                    "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
                    "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
                  ],
                  "0$1"
                ], [, "(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 15-$3-$4", ["91"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{5})", "$1-$2-$3", ["8"], "0$1"], [, "(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 15-$3-$4", ["9"], "0$1"]],
                [
                  [
                    ,
                    "(\\d{4})(\\d{2})(\\d{4})",
                    "$1 $2-$3",
                    [
                      "2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])",
                      "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)",
                      "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
                      "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
                    ],
                    "0$1",
                    ,
                    1
                  ],
                  [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["1"], "0$1", , 1],
                  [, "(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[68]"], "0$1"],
                  [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2-$3", ["[23]"], "0$1", , 1],
                  [, "(\\d)(\\d{4})(\\d{2})(\\d{4})", "$1 $2 $3-$4", [
                    "9(?:2[2-469]|3[3-578])",
                    "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))",
                    "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)",
                    "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
                    "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
                  ]],
                  [, "(\\d)(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3-$4", ["91"]],
                  [, "(\\d{3})(\\d{3})(\\d{5})", "$1-$2-$3", ["8"], "0$1"],
                  [, "(\\d)(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3-$4", ["9"]]
                ],
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , "810\\d{7}", , , , , , , [10]],
                [, , "810\\d{7}", , , , "8101234567", , , [10]],
                ,
                ,
                [, , , , , , , , , [-1]]
              ],
              AS: [, [, , "(?:[58]\\d\\d|684|900)\\d{7}", , , , , , , [10], [7]], [, , "6846(?:22|33|44|55|77|88|9[19])\\d{4}", , , , "6846221234", , , , [7]], [, , "684(?:2(?:48|5[2468]|7[26])|7(?:3[13]|70|82))\\d{4}", , , , "6847331234", , , , [7]], [
                ,
                ,
                "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "8002123456"
              ], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "AS", 1, "011", "1", , , "([267]\\d{6})$|1", "684$1", , , , , [, , , , , , , , , [-1]], , "684", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              AT: [, [
                ,
                ,
                "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}",
                ,
                ,
                ,
                ,
                ,
                ,
                [4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
                [3]
              ], [, , "1(?:11\\d|[2-9]\\d{3,11})|(?:316|463)\\d{3,10}|648[34]\\d{3,9}|(?:51|66|73)2\\d{3,10}|(?:2(?:1[467]|2[13-8]|5[2357]|6[1-46-8]|7[1-8]|8[124-7]|9[1458])|3(?:1[1-578]|3[23568]|4[5-7]|5[1378]|6[1-38]|8[3-68])|4(?:2[1-8]|35|7[1368]|8[2457])|5(?:2[1-8]|3[357]|4[147]|5[12578]|6[37])|6(?:13|2[1-47]|4[135-7]|5[468])|7(?:2[1-8]|35|4[13478]|5[68]|6[16-8]|7[1-6]|9[45]))\\d{4,10}", , , , "1234567890", , , , [3]], [
                ,
                ,
                "6(?:485|(?:5[0-3579]|6[013-9]|[7-9]\\d)\\d)\\d{3,9}",
                ,
                ,
                ,
                "664123456",
                ,
                ,
                [7, 8, 9, 10, 11, 12, 13]
              ], [, , "800\\d{6,10}", , , , "800123456", , , [9, 10, 11, 12, 13]], [, , "(?:8[69][2-68]|9(?:0[01]|3[019]))\\d{6,10}", , , , "900123456", , , [9, 10, 11, 12, 13]], [, , "8(?:10|2[018])\\d{6,10}|828\\d{5}", , , , "810123456", , , [8, 9, 10, 11, 12, 13]], [, , , , , , , , , [-1]], [, , "5(?:0[1-9]|17|[79]\\d)\\d{2,10}|7[28]0\\d{6,10}", , , , "780123456", , , [5, 6, 7, 8, 9, 10, 11, 12, 13]], "AT", 43, "00", "0", , , "0", , , , [[, "(\\d{4})", "$1", ["14"]], [, "(\\d)(\\d{3,12})", "$1 $2", ["1(?:11|[2-9])"], "0$1"], [, "(\\d{3})(\\d{2})", "$1 $2", ["517"], "0$1"], [
                ,
                "(\\d{2})(\\d{3,5})",
                "$1 $2",
                ["5[079]"],
                "0$1"
              ], [, "(\\d{6})", "$1", ["[18]"]], [, "(\\d{3})(\\d{3,10})", "$1 $2", ["(?:31|4)6|51|6(?:48|5[0-3579]|[6-9])|7(?:20|32|8)|[89]", "(?:31|4)6|51|6(?:485|5[0-3579]|[6-9])|7(?:20|32|8)|[89]"], "0$1"], [, "(\\d{4})(\\d{3,9})", "$1 $2", ["[2-467]|5[2-6]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["5"], "0$1"], [, "(\\d{2})(\\d{4})(\\d{4,7})", "$1 $2 $3", ["5"], "0$1"]], [[, "(\\d)(\\d{3,12})", "$1 $2", ["1(?:11|[2-9])"], "0$1"], [, "(\\d{3})(\\d{2})", "$1 $2", ["517"], "0$1"], [
                ,
                "(\\d{2})(\\d{3,5})",
                "$1 $2",
                ["5[079]"],
                "0$1"
              ], [, "(\\d{3})(\\d{3,10})", "$1 $2", ["(?:31|4)6|51|6(?:48|5[0-3579]|[6-9])|7(?:20|32|8)|[89]", "(?:31|4)6|51|6(?:485|5[0-3579]|[6-9])|7(?:20|32|8)|[89]"], "0$1"], [, "(\\d{4})(\\d{3,9})", "$1 $2", ["[2-467]|5[2-6]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["5"], "0$1"], [, "(\\d{2})(\\d{4})(\\d{4,7})", "$1 $2 $3", ["5"], "0$1"]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              AU: [
                ,
                [
                  ,
                  ,
                  "1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}",
                  ,
                  ,
                  ,
                  ,
                  ,
                  ,
                  [5, 6, 7, 8, 9, 10, 12]
                ],
                [
                  ,
                  ,
                  "(?:(?:2(?:(?:[0-26-9]\\d|3[0-8]|5[0135-9])\\d|4(?:[02-9]\\d|10))|3(?:(?:[0-3589]\\d|6[1-9]|7[0-35-9])\\d|4(?:[0-578]\\d|90))|7(?:[013-57-9]\\d|2[0-8])\\d)\\d\\d|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4])|[34]\\d\\d)|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}",
                  ,
                  ,
                  ,
                  "212345678",
                  ,
                  ,
                  [9],
                  [8]
                ],
                [, , "4(?:79[01]|83[0-389]|94[0-478])\\d{5}|4(?:[0-36]\\d|4[047-9]|[58][0-24-9]|7[02-8]|9[0-37-9])\\d{6}", , , , "412345678", , , [9]],
                [, , "180(?:0\\d{3}|2)\\d{3}", , , , "1800123456", , , [7, 10]],
                [, , "190[0-26]\\d{6}", , , , "1900123456", , , [10]],
                [, , "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", , , , "1300123456", , , [6, 8, 10, 12]],
                [, , , , , , , , , [-1]],
                [, , "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", , , , "147101234", , , [9]],
                "AU",
                61,
                "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
                "0",
                ,
                ,
                "(183[12])|0",
                ,
                "0011",
                ,
                [[, "(\\d{2})(\\d{3,4})", "$1 $2", ["16"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["13"]], [, "(\\d{3})(\\d{3})", "$1 $2", ["19"]], [, "(\\d{3})(\\d{4})", "$1 $2", ["180", "1802"]], [, "(\\d{4})(\\d{3,4})", "$1 $2", ["19"]], [, "(\\d{2})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["16"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["14|4"], "0$1"], [, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[2378]"], "(0$1)", "$CC ($1)"], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:30|[89])"]], [
                  ,
                  "(\\d{4})(\\d{4})(\\d{4})",
                  "$1 $2 $3",
                  ["130"]
                ]],
                [[, "(\\d{2})(\\d{3,4})", "$1 $2", ["16"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["16"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["14|4"], "0$1"], [, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[2378]"], "(0$1)", "$CC ($1)"], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:30|[89])"]]],
                [, , "163\\d{2,6}", , , , "1631234", , , [5, 6, 7, 8, 9]],
                1,
                ,
                [, , "1(?:3(?:00\\d{5}|45[0-4])|802)\\d{3}|1[38]00\\d{6}|13\\d{4}", , , , , , , [6, 7, 8, 10, 12]],
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]]
              ],
              AW: [, [
                ,
                ,
                "(?:[25-79]\\d\\d|800)\\d{4}",
                ,
                ,
                ,
                ,
                ,
                ,
                [7]
              ], [, , "5(?:2\\d|8[1-9])\\d{4}", , , , "5212345"], [, , "(?:290|5[69]\\d|6(?:[03]0|22|4[0-2]|[69]\\d)|7(?:[34]\\d|7[07])|9(?:6[45]|9[4-8]))\\d{4}", , , , "5601234"], [, , "800\\d{4}", , , , "8001234"], [, , "900\\d{4}", , , , "9001234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "(?:28\\d|501)\\d{4}", , , , "5011234"], "AW", 297, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[25-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              AX: [, [
                ,
                ,
                "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}",
                ,
                ,
                ,
                ,
                ,
                ,
                [5, 6, 7, 8, 9, 10, 11, 12]
              ], [, , "18[1-8]\\d{3,6}", , , , "181234567", , , [6, 7, 8, 9]], [, , "4946\\d{2,6}|(?:4[0-8]|50)\\d{4,8}", , , , "412345678", , , [6, 7, 8, 9, 10]], [, , "800\\d{4,6}", , , , "800123456", , , [7, 8, 9]], [, , "[67]00\\d{5,6}", , , , "600123456", , , [8, 9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "AX", 358, "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "0", , , "0", , "00", , , , [, , , , , , , , , [-1]], , "18", [, , , , , , , , , [-1]], [
                ,
                ,
                "20\\d{4,8}|60[12]\\d{5,6}|7(?:099\\d{4,5}|5[03-9]\\d{3,7})|20[2-59]\\d\\d|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:10|29|3[09]|70[1-5]\\d)\\d{4,8}",
                ,
                ,
                ,
                "10112345"
              ], , , [, , , , , , , , , [-1]]],
              AZ: [, [, , "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}", , , , , , , [9], [7]], [, , "(?:2[12]428|3655[02])\\d{4}|(?:2(?:22[0-79]|63[0-28])|3654)\\d{5}|(?:(?:1[28]|46)\\d|2(?:[014-6]2|[23]3))\\d{6}", , , , "123123456", , , , [7]], [, , "36554\\d{4}|(?:[16]0|4[04]|5[015]|7[07]|99)\\d{7}", , , , "401234567"], [, , "88\\d{7}", , , , "881234567"], [, , "900200\\d{3}", , , , "900200123"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "AZ", 994, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[1-9]"]], [
                ,
                "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                "$1 $2 $3 $4",
                ["90"],
                "0$1"
              ], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[28]|2|365|46", "1[28]|2|365[45]|46", "1[28]|2|365(?:4|5[02])|46"], "(0$1)"], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[13-9]"], "0$1"]], [[, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["90"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[28]|2|365|46", "1[28]|2|365[45]|46", "1[28]|2|365(?:4|5[02])|46"], "(0$1)"], [
                ,
                "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                "$1 $2 $3 $4",
                ["[13-9]"],
                "0$1"
              ]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              BA: [
                ,
                [, , "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}", , , , , , , [8, 9], [6]],
                [, , "(?:3(?:[05-79][2-9]|1[4579]|[23][24-9]|4[2-4689]|8[2457-9])|49[2-579]|5(?:0[2-49]|[13][2-9]|[268][2-4679]|4[4689]|5[2-79]|7[2-69]|9[2-4689]))\\d{5}", , , , "30212345", , , [8], [6]],
                [, , "6040\\d{5}|6(?:03|[1-356]|44|7\\d)\\d{6}", , , , "61123456"],
                [, , "8[08]\\d{6}", , , , "80123456", , , [8]],
                [, , "9[0246]\\d{6}", , , , "90123456", , , [8]],
                [, , "8[12]\\d{6}", , , , "82123456", , , [8]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                "BA",
                387,
                "00",
                "0",
                ,
                ,
                "0",
                ,
                ,
                ,
                [[, "(\\d{3})(\\d{3})", "$1-$2", ["[2-9]"]], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[1-3]|[7-9]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2-$3", ["[3-5]|6[56]"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["6"], "0$1"]],
                [[, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[1-3]|[7-9]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2-$3", ["[3-5]|6[56]"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["6"], "0$1"]],
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]],
                [, , "703[235]0\\d{3}|70(?:2[0-5]|3[0146]|[56]0)\\d{4}", , , , "70341234", , , [8]],
                ,
                ,
                [, , , , , , , , , [-1]]
              ],
              BB: [, [, , "(?:246|[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]], [, , "246521[0369]\\d{3}|246(?:2(?:2[78]|7[0-4])|4(?:1[024-6]|2\\d|3[2-9])|5(?:20|[34]\\d|54|7[1-3])|6(?:2\\d|38)|7[35]7|9(?:1[89]|63))\\d{4}", , , , "2464123456", , , , [7]], [, , "246(?:(?:2(?:[3568]\\d|4[0-57-9])|3(?:5[2-9]|6[0-6])|4(?:46|5\\d)|69[5-7]|8(?:[2-5]\\d|83))\\d|52(?:1[147]|20))\\d{3}", , , , "2462501234", , , , [7]], [
                ,
                ,
                "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "8002123456"
              ], [, , "(?:246976|900[2-9]\\d\\d)\\d{4}", , , , "9002123456", , , , [7]], [, , , , , , , , , [-1]], [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , "24631\\d{5}", , , , "2463101234", , , , [7]], "BB", 1, "011", "1", , , "([2-9]\\d{6})$|1", "246$1", , , , , [, , , , , , , , , [-1]], , "246", [, , , , , , , , , [-1]], [
                ,
                ,
                "246(?:292|367|4(?:1[7-9]|3[01]|4[47-9]|67)|7(?:1[2-9]|2\\d|3[016]|53))\\d{4}",
                ,
                ,
                ,
                "2464301234",
                ,
                ,
                ,
                [7]
              ], , , [, , , , , , , , , [-1]]],
              BD: [, [, , "[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}", , , , , , , [6, 7, 8, 9, 10]], [
                ,
                ,
                "(?:4(?:31\\d\\d|423)|5222)\\d{3}(?:\\d{2})?|8332[6-9]\\d\\d|(?:3(?:03[56]|224)|4(?:22[25]|653))\\d{3,4}|(?:3(?:42[47]|529|823)|4(?:027|525|65(?:28|8))|562|6257|7(?:1(?:5[3-5]|6[12]|7[156]|89)|22[589]56|32|42675|52(?:[25689](?:56|8)|[347]8)|71(?:6[1267]|75|89)|92374)|82(?:2[59]|32)56|9(?:03[23]56|23(?:256|373)|31|5(?:1|2[4589]56)))\\d{3}|(?:3(?:02[348]|22[35]|324|422)|4(?:22[67]|32[236-9]|6(?:2[46]|5[57])|953)|5526|6(?:024|6655)|81)\\d{4,5}|(?:2(?:7(?:1[0-267]|2[0-289]|3[0-29]|4[01]|5[1-3]|6[013]|7[0178]|91)|8(?:0[125]|1[1-6]|2[0157-9]|3[1-69]|41|6[1-35]|7[1-5]|8[1-8]|9[0-6])|9(?:0[0-2]|1[0-4]|2[568]|3[3-6]|5[5-7]|6[0136-9]|7[0-7]|8[014-9]))|3(?:0(?:2[025-79]|3[2-4])|181|22[12]|32[2356]|824)|4(?:02[09]|22[348]|32[045]|523|6(?:27|54))|666(?:22|53)|7(?:22[57-9]|42[56]|82[35])8|8(?:0[124-9]|2(?:181|2[02-4679]8)|4[12]|[5-7]2)|9(?:[04]2|2(?:2|328)|81))\\d{4}|(?:2(?:[23]\\d|[45])\\d\\d|3(?:1(?:2[5-7]|[5-7])|425|822)|4(?:033|1\\d|[257]1|332|4(?:2[246]|5[25])|6(?:2[35]|56|62)|8(?:23|54)|92[2-5])|5(?:02[03489]|22[457]|32[35-79]|42[46]|6(?:[18]|53)|724|826)|6(?:023|2(?:2[2-5]|5[3-5]|8)|32[3478]|42[34]|52[47]|6(?:[18]|6(?:2[34]|5[24]))|[78]2[2-5]|92[2-6])|7(?:02|21\\d|[3-589]1|6[12]|72[24])|8(?:217|3[12]|[5-7]1)|9[24]1)\\d{5}|(?:(?:3[2-8]|5[2-57-9]|6[03-589])1|4[4689][18])\\d{5}|[59]1\\d{5}",
                ,
                ,
                ,
                "27111234"
              ], [, , "(?:1[13-9]\\d|644)\\d{7}|(?:3[78]|44|66)[02-9]\\d{7}", , , , "1812345678", , , [10]], [, , "80[03]\\d{7}", , , , "8001234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "96(?:0[469]|1[0-47]|3[389]|43|6[69]|7[78])\\d{6}", , , , "9604123456", , , [10]], "BD", 880, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{4,6})", "$1-$2", ["31[5-8]|[459]1"], "0$1"], [
                ,
                "(\\d{3})(\\d{3,7})",
                "$1-$2",
                ["3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28|4[14])|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"],
                "0$1"
              ], [, "(\\d{4})(\\d{3,6})", "$1-$2", ["[13-9]|2[23]"], "0$1"], [, "(\\d)(\\d{7,8})", "$1-$2", ["2"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              BE: [, [, , "4\\d{8}|[1-9]\\d{7}", , , , , , , [8, 9]], [, , "80[2-8]\\d{5}|(?:1[0-69]|[23][2-8]|4[23]|5\\d|6[013-57-9]|71|8[1-79]|9[2-4])\\d{6}", , , , "12345678", , , [8]], [, , "4[5-9]\\d{7}", , , , "470123456", , , [9]], [, , "800[1-9]\\d{4}", , , , "80012345", , , [8]], [, , "(?:70(?:2[0-57]|3[04-7]|44|6[04-69]|7[0579])|90\\d\\d)\\d{4}", , , , "90012345", , , [8]], [
                ,
                ,
                "7879\\d{4}",
                ,
                ,
                ,
                "78791234",
                ,
                ,
                [8]
              ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BE", 32, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:80|9)0"], "0$1"], [, "(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[239]|4[23]"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[15-8]"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "78(?:0[578]|1[014-8]|2[25]|3[15-8]|48|5[05]|60|7[06-8]|9\\d)\\d{4}", , , , "78102345", , , [8]], , , [, , , , , , , , , [-1]]],
              BF: [, [
                ,
                ,
                "(?:[025-7]\\d|44)\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [8]
              ], [, , "2(?:0(?:49|5[23]|6[5-7]|9[016-9])|4(?:4[569]|5[4-6]|6[5-7]|7[0179])|5(?:[34]\\d|50|6[5-7]))\\d{4}", , , , "20491234"], [, , "(?:0[1-7]|44|5[0-8]|[67]\\d)\\d{6}", , , , "70123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BF", 226, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[024-7]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              BG: [, [
                ,
                ,
                "00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [6, 7, 8, 9, 12],
                [4, 5]
              ], [, , "2\\d{5,7}|(?:43[1-6]|70[1-9])\\d{4,5}|(?:[36]\\d|4[124-7]|[57][1-9]|8[1-6]|9[1-7])\\d{5,6}", , , , "2123456", , , [6, 7, 8], [4, 5]], [, , "(?:43[07-9]|99[69]\\d)\\d{5}|(?:8[7-9]|98)\\d{7}", , , , "43012345", , , [8, 9]], [, , "(?:00800\\d\\d|800)\\d{5}", , , , "80012345", , , [8, 12]], [, , "90\\d{6}", , , , "90123456", , , [8]], [, , "700\\d{5}", , , , "70012345", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BG", 359, "00", "0", , , "0", , , , [[, "(\\d{6})", "$1", ["1"]], [, "(\\d)(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["2"], "0$1"], [
                ,
                "(\\d{3})(\\d{4})",
                "$1 $2",
                ["43[1-6]|70[1-9]"],
                "0$1"
              ], [, "(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:70|8)0"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["43[1-7]|7"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[48]|9[08]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"]], [[, "(\\d)(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["2"], "0$1"], [
                ,
                "(\\d{3})(\\d{4})",
                "$1 $2",
                ["43[1-6]|70[1-9]"],
                "0$1"
              ], [, "(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:70|8)0"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["43[1-7]|7"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[48]|9[08]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              BH: [
                ,
                [
                  ,
                  ,
                  "[136-9]\\d{7}",
                  ,
                  ,
                  ,
                  ,
                  ,
                  ,
                  [8]
                ],
                [, , "(?:1(?:3[1356]|6[0156]|7\\d)\\d|6(?:1[16]\\d|500|6(?:0\\d|3[12]|44|55|7[7-9]|88)|9[69][69])|7(?:[07]\\d\\d|1(?:11|78)))\\d{4}", , , , "17001234"],
                [, , "(?:3(?:[0-79]\\d|8[0-57-9])\\d|6(?:3(?:00|33|6[16])|441|6(?:3[03-9]|[69]\\d|7[0-689])))\\d{4}", , , , "36001234"],
                [, , "8[02369]\\d{6}", , , , "80123456"],
                [, , "(?:87|9[0-8])\\d{6}", , , , "90123456"],
                [, , "84\\d{6}", , , , "84123456"],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                "BH",
                973,
                "00",
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [[, "(\\d{4})(\\d{4})", "$1 $2", ["[13679]|8[02-4679]"]]],
                ,
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]]
              ],
              BI: [, [, , "(?:[267]\\d|31)\\d{6}", , , , , , , [8]], [, , "(?:22|31)\\d{6}", , , , "22201234"], [, , "(?:29|6[124-9]|7[125-9])\\d{6}", , , , "79561234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BI", 257, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2367]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              BJ: [, [, , "(?:01\\d|[24-689])\\d{7}", , , , , , , [8, 10]], [
                ,
                ,
                "2090\\d{4}|(?:012\\d\\d|2(?:02|1[037]|2[45]|3[68]|4\\d))\\d{5}",
                ,
                ,
                ,
                "0120211234"
              ], [, , "(?:01(?:2[5-9]|[4-69]\\d)|4[0-8]|[56]\\d|9[013-9])\\d{6}", , , , "0195123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "857[58]\\d{4}", , , , "85751234", , , [8]], "BJ", 229, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-689]"]], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["0"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "81\\d{6}", , , , "81123456", , , [8]], , , [, , , , , , , , , [-1]]],
              BL: [, [
                ,
                ,
                "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [9]
              ], [, , "590(?:2[7-9]|3[3-7]|5[12]|87)\\d{4}", , , , "590271234"], [, , "(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}", , , , "690001234"], [, , "80[0-5]\\d{6}", , , , "800012345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}", , , , "976012345"], "BL", 590, "00", "0", , , "0", , , , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              BM: [
                ,
                [, , "(?:441|[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]],
                [
                  ,
                  ,
                  "441(?:[46]\\d\\d|5(?:4\\d|60|89))\\d{4}",
                  ,
                  ,
                  ,
                  "4414123456",
                  ,
                  ,
                  ,
                  [7]
                ],
                [, , "441(?:[2378]\\d|5[0-39]|9[02])\\d{5}", , , , "4413701234", , , , [7]],
                [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"],
                [, , "900[2-9]\\d{6}", , , , "9002123456"],
                [, , , , , , , , , [-1]],
                [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"],
                [, , , , , , , , , [-1]],
                "BM",
                1,
                "011",
                "1",
                ,
                ,
                "([2-9]\\d{6})$|1",
                "441$1",
                ,
                ,
                ,
                ,
                [, , , , , , , , , [-1]],
                ,
                "441",
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]]
              ],
              BN: [, [, , "[2-578]\\d{6}", , , , , , , [7]], [, , "22[0-7]\\d{4}|(?:2[013-9]|[34]\\d|5[0-25-9])\\d{5}", , , , "2345678"], [, , "(?:22[89]|[78]\\d\\d)\\d{4}", , , , "7123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "5[34]\\d{5}", , , , "5345678"], "BN", 673, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[2-578]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              BO: [, [
                ,
                ,
                "8001\\d{5}|(?:[2-467]\\d|50)\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [8, 9],
                [7]
              ], [, , "(?:2(?:2\\d\\d|5(?:11|[258]\\d|9[67])|6(?:12|2\\d|9[34])|8(?:2[34]|39|62))|3(?:3\\d\\d|4(?:6\\d|8[24])|8(?:25|42|5[257]|86|9[25])|9(?:[27]\\d|3[2-4]|4[248]|5[24]|6[2-6]))|4(?:4\\d\\d|6(?:11|[24689]\\d|72)))\\d{4}", , , , "22123456", , , [8], [7]], [, , "[67]\\d{7}", , , , "71234567", , , [8]], [, , "8001[07]\\d{4}", , , , "800171234", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "50\\d{6}", , , , "50123456", , , [8], [7]], "BO", 591, "00(?:1\\d)?", "0", , , "0(1\\d)?", , , , [[
                ,
                "(\\d)(\\d{7})",
                "$1 $2",
                ["[235]|4[46]"],
                ,
                "0$CC $1"
              ], [, "(\\d{8})", "$1", ["[67]"], , "0$CC $1"], [, "(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["8"], , "0$CC $1"]], , [, , , , , , , , , [-1]], , , [, , "8001[07]\\d{4}", , , , , , , [9]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              BQ: [
                ,
                [, , "(?:[34]1|7\\d)\\d{5}", , , , , , , [7]],
                [, , "(?:318[023]|41(?:6[023]|70)|7(?:1[578]|2[05]|50)\\d)\\d{3}", , , , "7151234"],
                [, , "(?:31(?:8[14-8]|9[14578])|416[14-9]|7(?:0[01]|7[07]|8\\d|9[056])\\d)\\d{3}", , , , "3181234"],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                "BQ",
                599,
                "00",
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [, , , , , , , , , [-1]],
                ,
                "[347]",
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]]
              ],
              BR: [, [, , "[1-467]\\d{9,10}|55[0-46-9]\\d{8}|[34]\\d{7}|55\\d{7,8}|(?:5[0-46-9]|[89]\\d)\\d{7,9}", , , , , , , [8, 9, 10, 11]], [, , "(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-5]\\d{7}", , , , "1123456789", , , [10], [8]], [, , "(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])(?:7|9\\d)\\d{7}", , , , "11961234567", , , [10, 11], [8, 9]], [, , "800\\d{6,7}", , , , "800123456", , , [9, 10]], [, , "[59]00\\d{6,7}", , , , "500123456", , , [9, 10]], [
                ,
                ,
                "(?:30[03]\\d{3}|4(?:0(?:0\\d|20)|370|864))\\d{4}|300\\d{5}",
                ,
                ,
                ,
                "40041234",
                ,
                ,
                [8, 10]
              ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BR", 55, "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)", "0", , , "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?", "$2", , , [[, "(\\d{3,6})", "$1", ["1(?:1[25-8]|2[357-9]|3[02-68]|4[12568]|5|6[0-8]|8[015]|9[0-47-9])|321|610"]], [, "(\\d{4})(\\d{4})", "$1-$2", ["300|4(?:0[02]|37|86)", "300|4(?:0(?:0|20)|370|864)"]], [, "(\\d{4})(\\d{4})", "$1-$2", ["[2-57]", "[2357]|4(?:[0-24-9]|3(?:[0-689]|7[1-9]))"]], [
                ,
                "(\\d{3})(\\d{2,3})(\\d{4})",
                "$1 $2 $3",
                ["(?:[358]|90)0"],
                "0$1"
              ], [, "(\\d{5})(\\d{4})", "$1-$2", ["9"]], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"], "($1)", "0 $CC ($1)"], [, "(\\d{2})(\\d{5})(\\d{4})", "$1 $2-$3", ["[16][1-9]|[2-57-9]"], "($1)", "0 $CC ($1)"]], [[, "(\\d{4})(\\d{4})", "$1-$2", ["300|4(?:0[02]|37|86)", "300|4(?:0(?:0|20)|370|864)"]], [, "(\\d{3})(\\d{2,3})(\\d{4})", "$1 $2 $3", ["(?:[358]|90)0"], "0$1"], [
                ,
                "(\\d{2})(\\d{4})(\\d{4})",
                "$1 $2-$3",
                ["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"],
                "($1)",
                "0 $CC ($1)"
              ], [, "(\\d{2})(\\d{5})(\\d{4})", "$1 $2-$3", ["[16][1-9]|[2-57-9]"], "($1)", "0 $CC ($1)"]], [, , , , , , , , , [-1]], , , [, , "(?:30[03]\\d{3}|4(?:0(?:0\\d|20)|864))\\d{4}|800\\d{6,7}|300\\d{5}", , , , , , , [8, 9, 10]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              BS: [, [, , "(?:242|[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]], [, , "242(?:3(?:02|[236][1-9]|4[0-24-9]|5[0-68]|7[347]|8[0-4]|9[2-467])|461|502|6(?:0[1-5]|12|2[013]|[45]0|7[67]|8[78]|9[89])|7(?:02|88))\\d{4}", , , , "2423456789", , , , [7]], [
                ,
                ,
                "242(?:3(?:5[79]|7[56]|95)|4(?:[23][1-9]|4[1-35-9]|5[1-8]|6[2-8]|7\\d|81)|5(?:2[45]|3[35]|44|5[1-46-9]|65|77)|6[34]6|7(?:27|38)|8(?:0[1-9]|1[02-9]|2\\d|3[0-4]|[89]9))\\d{4}",
                ,
                ,
                ,
                "2423591234",
                ,
                ,
                ,
                [7]
              ], [, , "242300\\d{4}|8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456", , , , [7]], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "BS", 1, "011", "1", , , "([3-8]\\d{6})$|1", "242$1", , , , , [, , , , , , , , , [-1]], , "242", [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ], [, , "242225\\d{4}", , , , "2422250123"], , , [, , , , , , , , , [-1]]],
              BT: [, [, , "[178]\\d{7}|[2-8]\\d{6}", , , , , , , [7, 8], [6]], [, , "(?:2[3-6]|[34][5-7]|5[236]|6[2-46]|7[246]|8[2-4])\\d{5}", , , , "2345678", , , [7], [6]], [, , "(?:1[67]|[78]7)\\d{6}", , , , "17123456", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BT", 975, "00", , , , , , , , [[, "(\\d{3})(\\d{3})", "$1 $2", ["[2-7]"]], [, "(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-6]|7[246]|8[2-4]"]], [
                ,
                "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                "$1 $2 $3 $4",
                ["1[67]|[78]"]
              ]], [[, "(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-6]|7[246]|8[2-4]"]], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[67]|[78]"]]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              BW: [, [, , "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}", , , , , , , [7, 8, 10]], [, , "(?:2(?:4[0-48]|6[0-24]|9[0578])|3(?:1[0-35-9]|55|[69]\\d|7[013]|81)|4(?:6[03]|7[1267]|9[0-5])|5(?:3[03489]|4[0489]|7[1-47]|88|9[0-49])|6(?:2[1-35]|5[149]|8[013467]))\\d{4}", , , , "2401234", , , [7]], [
                ,
                ,
                "(?:321|7[1-8]\\d)\\d{5}",
                ,
                ,
                ,
                "71123456",
                ,
                ,
                [8]
              ], [, , "(?:0800|800\\d)\\d{6}", , , , "0800012345", , , [10]], [, , "90\\d{5}", , , , "9012345", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "79(?:1(?:[0-2]\\d|3[0-8])|2[0-7]\\d)\\d{3}", , , , "79101234", , , [8]], "BW", 267, "00", , , , , , , , [[, "(\\d{2})(\\d{5})", "$1 $2", ["90"]], [, "(\\d{3})(\\d{4})", "$1 $2", ["[24-6]|3[15-9]"]], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37]"]], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["0"]], [, "(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["8"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ], , , [, , , , , , , , , [-1]]],
              BY: [, [, , "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}", , , , , , , [6, 7, 8, 9, 10, 11], [5]], [, , "(?:1(?:5(?:1[1-5]|[24]\\d|6[2-4]|9[1-7])|6(?:[235]\\d|4[1-7])|7\\d\\d)|2(?:1(?:[246]\\d|3[0-35-9]|5[1-9])|2(?:[235]\\d|4[0-8])|3(?:[26]\\d|3[02-79]|4[024-7]|5[03-7])))\\d{5}", , , , "152450911", , , [9], [5, 6, 7]], [, , "(?:2(?:5[5-79]|9[1-9])|(?:33|44)\\d)\\d{6}", , , , "294911911", , , [9]], [
                ,
                ,
                "800\\d{3,7}|8(?:0[13]|20\\d)\\d{7}",
                ,
                ,
                ,
                "8011234567"
              ], [, , "(?:810|902)\\d{7}", , , , "9021234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "249\\d{6}", , , , "249123456", , , [9]], "BY", 375, "810", "8", , , "0|80?", , "8~10", , [[, "(\\d{3})(\\d{3})", "$1 $2", ["800"], "8 $1"], [, "(\\d{3})(\\d{2})(\\d{2,4})", "$1 $2 $3", ["800"], "8 $1"], [, "(\\d{4})(\\d{2})(\\d{3})", "$1 $2-$3", ["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])", "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"], "8 0$1"], [
                ,
                "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                "$1 $2-$3-$4",
                ["1(?:[56]|7[467])|2[1-3]"],
                "8 0$1"
              ], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-4]"], "8 0$1"], [, "(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[89]"], "8 $1"]], , [, , , , , , , , , [-1]], , , [, , "800\\d{3,7}|(?:8(?:0[13]|10|20\\d)|902)\\d{7}"], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              BZ: [, [, , "(?:0800\\d|[2-8])\\d{6}", , , , , , , [7, 11]], [, , "(?:2(?:[02]\\d|36|[68]0)|[3-58](?:[02]\\d|[68]0)|7(?:[02]\\d|32|[68]0))\\d{4}", , , , "2221234", , , [7]], [, , "6[0-35-7]\\d{5}", , , , "6221234", , , [7]], [
                ,
                ,
                "0800\\d{7}",
                ,
                ,
                ,
                "08001234123",
                ,
                ,
                [11]
              ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "BZ", 501, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1-$2", ["[2-8]"]], [, "(\\d)(\\d{3})(\\d{4})(\\d{3})", "$1-$2-$3-$4", ["0"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              CA: [, [, , "[2-9]\\d{9}|3\\d{6}", , , , , , , [7, 10]], [
                ,
                ,
                "(?:2(?:04|[23]6|[48]9|5[07]|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|7[39])|9(?:0[25]|42))[2-9]\\d{6}",
                ,
                ,
                ,
                "5062345678",
                ,
                ,
                [10],
                [7]
              ], [, , "(?:2(?:04|[23]6|[48]9|5[07]|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|7[39])|9(?:0[25]|42))[2-9]\\d{6}", , , , "5062345678", , , [10], [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456", , , [10]], [, , "900[2-9]\\d{6}", , , , "9002123456", , , [10]], [, , , , , , , , , [-1]], [
                ,
                ,
                "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:2[125-9]|33|44|66|77|88)|6(?:22|33))[2-9]\\d{6}",
                ,
                ,
                ,
                "5219023456",
                ,
                ,
                [10]
              ], [, , "600[2-9]\\d{6}", , , , "6002012345", , , [10]], "CA", 1, "011", "1", , , "1", , , 1, , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "310\\d{4}", , , , "3101234", , , [7]], , , [, , , , , , , , , [-1]]],
              CC: [, [, , "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", , , , , , , [6, 7, 8, 9, 10, 12]], [, , "8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}", , , , "891621234", , , [9], [8]], [
                ,
                ,
                "4(?:79[01]|83[0-389]|94[0-478])\\d{5}|4(?:[0-36]\\d|4[047-9]|[58][0-24-9]|7[02-8]|9[0-37-9])\\d{6}",
                ,
                ,
                ,
                "412345678",
                ,
                ,
                [9]
              ], [, , "180(?:0\\d{3}|2)\\d{3}", , , , "1800123456", , , [7, 10]], [, , "190[0-26]\\d{6}", , , , "1900123456", , , [10]], [, , "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", , , , "1300123456", , , [6, 8, 10, 12]], [, , , , , , , , , [-1]], [, , "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", , , , "147101234", , , [9]], "CC", 61, "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "0", , , "([59]\\d{7})$|0", "8$1", "0011", , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              CD: [, [
                ,
                ,
                "(?:(?:[189]|5\\d)\\d|2)\\d{7}|[1-68]\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [7, 8, 9, 10]
              ], [, , "(?:(?:12|573)\\d\\d|276)\\d{5}|[1-6]\\d{6}", , , , "1234567"], [, , "88\\d{5}|(?:8[0-69]|9[017-9])\\d{7}", , , , "991234567", , , [7, 9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CD", 243, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], [, "(\\d{2})(\\d{5})", "$1 $2", ["[1-6]"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], [
                ,
                "(\\d{3})(\\d{3})(\\d{3})",
                "$1 $2 $3",
                ["[89]"],
                "0$1"
              ], [, "(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["5"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              CF: [, [, , "(?:[27]\\d{3}|8776)\\d{4}", , , , , , , [8]], [, , "2[12]\\d{6}", , , , "21612345"], [, , "7[024-7]\\d{6}", , , , "70012345"], [, , , , , , , , , [-1]], [, , "8776\\d{4}", , , , "87761234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CF", 236, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[278]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              CG: [, [, , "222\\d{6}|(?:0\\d|80)\\d{7}", , , , , , , [9]], [, , "222[1-589]\\d{5}", , , , "222123456"], [, , "026(?:1[0-5]|6[6-9])\\d{4}|0(?:[14-6]\\d\\d|2(?:40|5[5-8]|6[07-9]))\\d{5}", , , , "061234567"], [, , , , , , , , , [-1]], [, , "80[0-2]\\d{6}", , , , "800123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CG", 242, "00", , , , , , , , [[, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["8"]], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[02]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              CH: [, [
                ,
                ,
                "8\\d{11}|[2-9]\\d{8}",
                ,
                ,
                ,
                ,
                ,
                ,
                [9, 12]
              ], [, , "(?:2[12467]|3[1-4]|4[134]|5[256]|6[12]|[7-9]1)\\d{7}", , , , "212345678", , , [9]], [, , "(?:6[89]|7[235-9])\\d{7}", , , , "781234567", , , [9]], [, , "800\\d{6}", , , , "800123456", , , [9]], [, , "90[016]\\d{6}", , , , "900123456", , , [9]], [, , "84[0248]\\d{6}", , , , "840123456", , , [9]], [, , "878\\d{6}", , , , "878123456", , , [9]], [, , , , , , , , , [-1]], "CH", 41, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8[047]|90"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]|81"], "0$1"], [
                ,
                "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                "$1 $2 $3 $4 $5",
                ["8"],
                "0$1"
              ]], , [, , "74[0248]\\d{6}", , , , "740123456", , , [9]], , , [, , , , , , , , , [-1]], [, , "5[18]\\d{7}", , , , "581234567", , , [9]], , , [, , "860\\d{9}", , , , "860123456789", , , [12]]],
              CI: [, [, , "[02]\\d{9}", , , , , , , [10]], [, , "2(?:[15]\\d{3}|7(?:2(?:0[23]|1[2357]|2[245]|3[45]|4[3-5])|3(?:06|1[69]|[2-6]7)))\\d{5}", , , , "2123456789"], [, , "0[157]\\d{8}", , , , "0123456789"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CI", 225, "00", , , , , , , , [[
                ,
                "(\\d{2})(\\d{2})(\\d)(\\d{5})",
                "$1 $2 $3 $4",
                ["2"]
              ], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3 $4", ["0"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              CK: [, [, , "[2-578]\\d{4}", , , , , , , [5]], [, , "(?:2\\d|3[13-7]|4[1-5])\\d{3}", , , , "21234"], [, , "[578]\\d{4}", , , , "71234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CK", 682, "00", , , , , , , , [[, "(\\d{2})(\\d{3})", "$1 $2", ["[2-578]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              CL: [, [
                ,
                ,
                "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}",
                ,
                ,
                ,
                ,
                ,
                ,
                [9, 10, 11]
              ], [, , "2(?:1982[0-6]|3314[05-9])\\d{3}|(?:2(?:1(?:160|962)|2\\d{3}|3(?:(?:2\\d|50)\\d|3(?:[03467]\\d|1[0-35-9]|2[1-9]|5[0-24-9]|8[0-389]|9[0-8])|600)|646[59])|(?:(?:3[2-5]|[47][1-35]|5[1-3578])\\d|6(?:00|[13-57]\\d)|8(?:0[1-9]|[1-9]\\d))\\d\\d|9(?:(?:10[01]|(?:[2458]\\d|7[1-9])\\d)\\d|3(?:[0-57-9]\\d\\d|6(?:0[02-9]|[1-9]\\d))|6(?:[0-8]\\d\\d|9(?:[02-79]\\d|1[05-9]))|9(?:[03-9]\\d\\d|1(?:[0235-9]\\d|4[0-24-9])|2(?:[0-79]\\d|8[0-46-9]))))\\d{4}", , , , "600123456", , , [9]], [
                ,
                ,
                "2(?:1982[0-6]|3314[05-9])\\d{3}|(?:2(?:1(?:160|962)|2\\d{3}|3(?:(?:2\\d|50)\\d|3(?:[03467]\\d|1[0-35-9]|2[1-9]|5[0-24-9]|8[0-389]|9[0-8])|600)|646[59])|(?:(?:3[2-5]|[47][1-35]|5[1-3578]|6[13-57])\\d|8(?:0[1-8]|[1-9]\\d))\\d\\d|9(?:(?:10[01]|(?:[2458]\\d|7[1-9])\\d)\\d|3(?:[0-57-9]\\d\\d|6(?:0[02-9]|[1-9]\\d))|6(?:[0-8]\\d\\d|9(?:[02-79]\\d|1[05-9]))|9(?:[03-9]\\d\\d|1(?:[0235-9]\\d|4[0-24-9])|2(?:[0-79]\\d|8[0-46-9]))))\\d{4}",
                ,
                ,
                ,
                "221234567",
                ,
                ,
                [9]
              ], [, , "(?:123|8)00\\d{6}", , , , "800123456", , , [9, 11]], [, , , , , , , , , [-1]], [, , "600\\d{7,8}", , , , "6001234567", , , [10, 11]], [, , , , , , , , , [-1]], [, , "44\\d{7}", , , , "441234567", , , [9]], "CL", 56, "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0", , , , , , , , [[, "(\\d{4})", "$1", ["1(?:[03-589]|21)|[29]0|78"]], [, "(\\d{5})(\\d{4})", "$1 $2", ["219", "2196"], "($1)"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["60|809"]], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["44"]], [
                ,
                "(\\d)(\\d{4})(\\d{4})",
                "$1 $2 $3",
                ["2[1-36]"],
                "($1)"
              ], [, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["9(?:10|[2-9])"]], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-8]|[1-9])"], "($1)"], [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["60|8"]], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], [, "(\\d{3})(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["60"]]], [[, "(\\d{5})(\\d{4})", "$1 $2", ["219", "2196"], "($1)"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["60|809"]], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["44"]], [
                ,
                "(\\d)(\\d{4})(\\d{4})",
                "$1 $2 $3",
                ["2[1-36]"],
                "($1)"
              ], [, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["9(?:10|[2-9])"]], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-8]|[1-9])"], "($1)"], [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["60|8"]], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], [, "(\\d{3})(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["60"]]], [, , , , , , , , , [-1]], , , [, , "600\\d{7,8}", , , , , , , [10, 11]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              CM: [, [, , "[26]\\d{8}|88\\d{6,7}", , , , , , , [8, 9]], [
                ,
                ,
                "2(?:22|33)\\d{6}",
                ,
                ,
                ,
                "222123456",
                ,
                ,
                [9]
              ], [, , "(?:24[23]|6(?:[25-9]\\d|40))\\d{6}", , , , "671234567", , , [9]], [, , "88\\d{6,7}", , , , "88012345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CM", 237, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["88"]], [, "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[26]|88"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              CN: [, [
                ,
                ,
                "(?:(?:1[03-689]|2\\d)\\d\\d|6)\\d{8}|1\\d{10}|[126]\\d{6}(?:\\d(?:\\d{2})?)?|86\\d{5,6}|(?:[3-579]\\d|8[0-57-9])\\d{5,9}",
                ,
                ,
                ,
                ,
                ,
                ,
                [7, 8, 9, 10, 11, 12],
                [5, 6]
              ], [
                ,
                ,
                "(?:10(?:[02-79]\\d\\d|[18](?:0[1-9]|[1-9]\\d))|2(?:[02-57-9]\\d{3}|1(?:[18](?:0[1-9]|[1-9]\\d)|[2-79]\\d\\d))|(?:41[03]|8078|9(?:78|94))\\d\\d)\\d{5}|(?:10|2[0-57-9])(?:1(?:00|23)\\d\\d|95\\d{3,4})|(?:41[03]|9(?:78|94))(?:100\\d\\d|95\\d{3,4})|8078123|(?:43[35]|754|851)\\d{7,8}|(?:43[35]|754|851)(?:1(?:00\\d|23)\\d|95\\d{3,4})|(?:3(?:11|7[179])|4(?:[15]1|3[12])|5(?:1\\d|2[37]|3[12]|51|7[13-79]|9[15])|7(?:[39]1|5[57]|6[09])|8(?:71|98))(?:[02-8]\\d{7}|1(?:0(?:0\\d\\d(?:\\d{3})?|[1-9]\\d{5})|[13-9]\\d{6}|2(?:[0-24-9]\\d{5}|3\\d(?:\\d{4})?))|9(?:[0-46-9]\\d{6}|5\\d{3}(?:\\d(?:\\d{2})?)?))|(?:3(?:1[02-9]|35|49|5\\d|7[02-68]|9[1-68])|4(?:1[24-9]|2[179]|3[46-9]|5[2-9]|6[47-9]|7\\d|8[23])|5(?:3[03-9]|4[36]|5[02-9]|6[1-46]|7[028]|80|9[2-46-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[17]\\d|2[248]|3[04-9]|4[3-6]|5[0-3689]|6[2368]|9[02-9])|8(?:1[236-8]|2[5-7]|3\\d|5[2-9]|7[02-9]|8[36-8]|9[1-7])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))(?:[02-8]\\d{6}|1(?:0(?:0\\d\\d(?:\\d{2})?|[1-9]\\d{4})|[13-9]\\d{5}|2(?:[0-24-9]\\d{4}|3\\d(?:\\d{3})?))|9(?:[0-46-9]\\d{5}|5\\d{3,5}))",
                ,
                ,
                ,
                "1012345678",
                ,
                ,
                [7, 8, 9, 10, 11],
                [5, 6]
              ], [, , "1740[0-5]\\d{6}|1(?:[38]\\d|4[57]|[59][0-35-9]|6[25-7]|7[0-35-8])\\d{8}", , , , "13123456789", , , [11]], [, , "(?:(?:10|21)8|8)00\\d{7}", , , , "8001234567", , , [10, 12]], [, , "16[08]\\d{5}", , , , "16812345", , , [8]], [
                ,
                ,
                "10(?:10\\d{4}|96\\d{3,4})|400\\d{7}|950\\d{7,8}|(?:2[0-57-9]|3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))96\\d{3,4}",
                ,
                ,
                ,
                "4001234567",
                ,
                ,
                [7, 8, 9, 10, 11],
                [5, 6]
              ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CN", 86, "00|1(?:[12]\\d|79)\\d\\d00", "0", , , "(1(?:[12]\\d|79)\\d\\d)|0", , "00", , [
                [, "(\\d{5,6})", "$1", ["1(?:00|2[13])|9[56]", "1(?:00|2(?:1|39))|9[56]", "1(?:00|2(?:1|395))|9[56]"]],
                [, "(\\d{5,6})", "$1", ["1(?:0|23)|781|[1-9]12", "1(?:0|23)|7812|[1-9]123", "1(?:0|23(?:[0-8]|9[0-46-9]))|78123|[1-9]123"]],
                [
                  ,
                  "(\\d{2})(\\d{5,6})",
                  "$1 $2",
                  [
                    "(?:10|2[0-57-9])[19]|3(?:[157]|35|49|9[1-68])|4(?:1[124-9]|2[179]|6[47-9]|7|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:07|1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3|4[13]|5[1-5]|7[0-79]|9[0-35-9])|(?:4[35]|59|85)[1-9]",
                    "(?:10|2[0-57-9])(?:1[02]|9[56])|8078|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))1",
                    "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|80781|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))12",
                    "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|807812|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123",
                    "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:078|1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123"
                  ],
                  "0$1",
                  "$CC $1"
                ],
                [, "(\\d{3})(\\d{4})", "$1 $2", [
                  "[1-9]",
                  "1[1-9]|26|[3-9]|(?:10|2[0-57-9])(?:[0-8]|9[0-47-9])",
                  "1(?:0(?:[02-8]|1(?:[013-9]|2[0-24-9])|9[0-47-9])|[1-9])|2(?:[0-57-9](?:[02-8]|1(?:0[1-9]|[13-9]|2[0-24-9])|9[0-47-9])|6)|[3-9]",
                  "1(?:0(?:[02-8]|1(?:[013-9]|2[0-24-9])|9[0-47-9])|[1-9])|2(?:[0-57-9](?:[02-8]|1(?:0[1-9]|[13-9]|2[0-24-9])|9[0-47-9])|6)|3(?:[0268]|3[0-46-9]|4[0-8]|9[079])|4(?:[049]|1[03]|2[02-68]|[35]0|6[0-356]|8[014-9])|5(?:0|2[0-24-689]|4[0-2457-9]|6[057-9]|8[1-9]|90)|6(?:[0-24578]|3[06-9]|6[14-79]|9[03-9])|7(?:0[02-9]|2[0135-79]|3[23]|4[0-27-9]|6[1457]|8)|8(?:[046]|1[01459]|2[0-489]|50|8[0-2459]|9[09])|9(?:0[0457]|1[08]|[268]|4[024-9]|5[06-9]|78|94)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))(?:[02-9]|1(?:[013-9]|2[0-24-9]))",
                  "1(?:0(?:[02-8]|1(?:[013-9]|2[0-24-9])|9[0-47-9])|[1-9])|2(?:[0-57-9](?:[02-8]|1(?:0[1-9]|[13-9]|2[0-24-9])|9[0-47-9])|6)|3(?:[0268]|3[0-46-9]|4[0-8]|9[079])|4(?:[049]|1[03]|2[02-68]|[35]0|6[0-356]|8[014-9])|5(?:0|2[0-24-689]|4[0-2457-9]|6[057-9]|8[1-9]|90)|6(?:[0-24578]|3[06-9]|6[14-79]|9[03-9])|7(?:0[02-9]|2[0135-79]|3[23]|4[0-27-9]|6[1457]|8)|8(?:0(?:[0-689]|7[0-79])|1[01459]|2[0-489]|[46]|50|8[0-2459]|9[09])|9(?:0[0457]|1[08]|[268]|4[024-9]|5[06-9]|78|94)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:078|1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))(?:[02-9]|1(?:[013-9]|2[0-24-9]))"
                ]],
                [, "(\\d{4})(\\d{4})", "$1 $2", ["16[08]"]],
                [
                  ,
                  "(\\d{3})(\\d{5,6})",
                  "$1 $2",
                  [
                    "3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]",
                    "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]",
                    "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])",
                    "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"
                  ],
                  "0$1",
                  "$CC $1"
                ],
                [, "(\\d{4})(\\d{4})", "$1 $2", [
                  "[1-9]",
                  "1(?:0(?:[02-8]|1[1-9]|9[0-47-9])|[1-9])|2(?:[0-57-9](?:[0-8]|9[0-47-9])|6)|[3-9]",
                  "1(?:0(?:[02-8]|1[1-9]|9[0-47-9])|[1-9])|26|3(?:[0268]|4[0-8]|9[079])|4(?:[049]|2[02-68]|[35]0|6[0-356]|8[014-9])|5(?:0|2[0-24-689]|4[0-2457-9]|6[057-9]|8[1-9]|90)|6(?:[0-24578]|3[06-9]|6[14-79]|9[03-9])|7(?:0[02-9]|2[0135-79]|3[23]|4[0-27-9]|6[1457]|8)|8(?:[046]|1[01459]|2[0-489]|5(?:0|[23][0-8])|8[0-2459]|9[09])|9(?:0[0457]|1[08]|[268]|4[024-9]|5[06-9])|(?:33|85[23]9)[0-46-9]|(?:2[0-57-9]|3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:[0-8]|9[0-47-9])",
                  "1(?:0[02-8]|[1-9])|2(?:[0-57-9][0-8]|6)|3(?:[0268]|3[0-46-9]|4[0-8]|9[079])|4(?:[049]|2[02-68]|[35]0|6[0-356]|8[014-9])|5(?:0|2[0-24-689]|4[0-2457-9]|6[057-9]|90)|6(?:[0-24578]|3[06-9]|6[14-79]|9[03-9])|7(?:0[02-9]|2[0135-79]|3[23]|4[0-27-9]|6[1457]|8)|8(?:[046]|1[01459]|2[0-489]|5(?:0|[23](?:[02-8]|1[1-9]|9[0-46-9]))|8[0-2459]|9[09])|9(?:0[0457]|1[08]|[268]|4[024-9]|5[06-9])|(?:10|2[0-57-9])9[0-47-9]|(?:101|58|85[23]10)[1-9]|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:[02-8]|1(?:0[1-9]|[1-9])|9[0-47-9])"
                ]],
                [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["(?:4|80)0"]],
                [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|2(?:[02-57-9]|1[1-9])", "10|2(?:[02-57-9]|1[1-9])", "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"], "0$1", "$CC $1", 1],
                [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"], "0$1", "$CC $1", 1],
                [
                  ,
                  "(\\d{3})(\\d{7,8})",
                  "$1 $2",
                  ["9"]
                ],
                [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["80"], "0$1", "$CC $1", 1],
                [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[3-578]"], "0$1", "$CC $1", 1],
                [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["1[3-9]"], , "$CC $1"],
                [, "(\\d{2})(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["[12]"], "0$1", , 1]
              ], [[
                ,
                "(\\d{2})(\\d{5,6})",
                "$1 $2",
                [
                  "(?:10|2[0-57-9])[19]|3(?:[157]|35|49|9[1-68])|4(?:1[124-9]|2[179]|6[47-9]|7|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:07|1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3|4[13]|5[1-5]|7[0-79]|9[0-35-9])|(?:4[35]|59|85)[1-9]",
                  "(?:10|2[0-57-9])(?:1[02]|9[56])|8078|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))1",
                  "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|80781|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))12",
                  "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|807812|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123",
                  "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:078|1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123"
                ],
                "0$1",
                "$CC $1"
              ], [
                ,
                "(\\d{3})(\\d{5,6})",
                "$1 $2",
                [
                  "3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]",
                  "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]",
                  "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])",
                  "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"
                ],
                "0$1",
                "$CC $1"
              ], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["(?:4|80)0"]], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|2(?:[02-57-9]|1[1-9])", "10|2(?:[02-57-9]|1[1-9])", "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"], "0$1", "$CC $1", 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"], "0$1", "$CC $1", 1], [
                ,
                "(\\d{3})(\\d{7,8})",
                "$1 $2",
                ["9"]
              ], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["80"], "0$1", "$CC $1", 1], [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[3-578]"], "0$1", "$CC $1", 1], [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["1[3-9]"], , "$CC $1"], [, "(\\d{2})(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["[12]"], "0$1", , 1]], [, , , , , , , , , [-1]], , , [, , "(?:(?:10|21)8|[48])00\\d{7}|950\\d{7,8}", , , , , , , [10, 11, 12]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              CO: [, [, , "(?:46|60\\d\\d)\\d{6}|(?:1\\d|[39])\\d{9}", , , , , , , [8, 10, 11], [4, 7]], [
                ,
                ,
                "601055(?:[0-4]\\d|50)\\d\\d|6010(?:[0-4]\\d|5[0-4])\\d{4}|(?:46|60(?:[18][1-9]|[24-7][2-9]))\\d{6}",
                ,
                ,
                ,
                "6012345678",
                ,
                ,
                [8, 10],
                [4, 7]
              ], [, , "333301[0-5]\\d{3}|3333(?:00|2[5-9]|[3-9]\\d)\\d{4}|(?:3(?:(?:0[0-5]|1\\d|5[01]|70)\\d|2(?:[0-3]\\d|4[1-9])|3(?:00|3[0-24-9]))|9(?:101|408))\\d{6}", , , , "3211234567", , , [10]], [, , "1800\\d{7}", , , , "18001234567", , , [11]], [, , "(?:19(?:0[01]|4[78])|901)\\d{7}", , , , "19001234567", , , [10, 11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CO", 57, "00(?:4(?:[14]4|56)|[579])", "0", , , "0([3579]|4(?:[14]4|56))?", , , , [[, "(\\d{4})(\\d{4})", "$1 $2", ["46"]], [
                ,
                "(\\d{3})(\\d{7})",
                "$1 $2",
                ["6|90"],
                "($1)",
                "0$CC $1"
              ], [, "(\\d{3})(\\d{7})", "$1 $2", ["3[0-357]|9[14]"], , "0$CC $1"], [, "(\\d)(\\d{3})(\\d{7})", "$1-$2-$3", ["1"], "0$1"]], [[, "(\\d{4})(\\d{4})", "$1 $2", ["46"]], [, "(\\d{3})(\\d{7})", "$1 $2", ["6|90"], "($1)", "0$CC $1"], [, "(\\d{3})(\\d{7})", "$1 $2", ["3[0-357]|9[14]"], , "0$CC $1"], [, "(\\d)(\\d{3})(\\d{7})", "$1 $2 $3", ["1"]]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              CR: [, [, , "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}", , , , , , , [8, 10]], [
                ,
                ,
                "210[7-9]\\d{4}|2(?:[024-7]\\d|1[1-9])\\d{5}",
                ,
                ,
                ,
                "22123456",
                ,
                ,
                [8]
              ], [, , "(?:3005\\d|6500[01])\\d{3}|(?:5[07]|6[0-4]|7[0-3]|8[3-9])\\d{6}", , , , "83123456", , , [8]], [, , "800\\d{7}", , , , "8001234567", , , [10]], [, , "90[059]\\d{7}", , , , "9001234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "(?:210[0-6]|4\\d{3}|5100)\\d{4}", , , , "40001234", , , [8]], "CR", 506, "00", , , , "(19(?:0[0-2468]|1[09]|20|66|77|99))", , , , [[, "(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[3-9]"], , "$CC $1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[89]"], , "$CC $1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ], , , [, , , , , , , , , [-1]]],
              CU: [, [, , "(?:[2-7]|8\\d\\d)\\d{7}|[2-47]\\d{6}|[34]\\d{5}", , , , , , , [6, 7, 8, 10], [4, 5]], [, , "(?:3[23]|4[89])\\d{4,6}|(?:31|4[36]|8(?:0[25]|78)\\d)\\d{6}|(?:2[1-4]|4[1257]|7\\d)\\d{5,6}", , , , "71234567", , , , [4, 5]], [, , "(?:5\\d|6[2-4])\\d{6}", , , , "51234567", , , [8]], [, , "800\\d{7}", , , , "8001234567", , , [10]], [, , , , , , , , , [-1]], [, , "807\\d{7}", , , , "8071234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CU", 53, "119", "0", , , "0", , , , [[, "(\\d{2})(\\d{4,6})", "$1 $2", ["2[1-4]|[34]"], "(0$1)"], [
                ,
                "(\\d)(\\d{6,7})",
                "$1 $2",
                ["7"],
                "(0$1)"
              ], [, "(\\d)(\\d{7})", "$1 $2", ["[56]"], "0$1"], [, "(\\d{3})(\\d{7})", "$1 $2", ["8"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              CV: [, [, , "(?:[2-59]\\d\\d|800)\\d{4}", , , , , , , [7]], [, , "2(?:2[1-7]|3[0-8]|4[12]|5[1256]|6\\d|7[1-3]|8[1-5])\\d{4}", , , , "2211234"], [, , "(?:36|5[1-389]|9\\d)\\d{5}", , , , "9911234"], [, , "800\\d{4}", , , , "8001234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "(?:3[3-5]|4[356])\\d{5}", , , , "3401234"], "CV", 238, "0", , , , , , , , [[
                ,
                "(\\d{3})(\\d{2})(\\d{2})",
                "$1 $2 $3",
                ["[2-589]"]
              ]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              CW: [, [, , "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}", , , , , , , [7, 8]], [, , "9(?:4(?:3[0-5]|4[14]|6\\d)|50\\d|7(?:2[014]|3[02-9]|4[4-9]|6[357]|77|8[7-9])|8(?:3[39]|[46]\\d|7[01]|8[57-9]))\\d{4}", , , , "94351234"], [, , "953[01]\\d{4}|9(?:5[12467]|6[5-9])\\d{5}", , , , "95181234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "60[0-2]\\d{4}", , , , "6001234", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "CW", 599, "00", , , , , , , , [[
                ,
                "(\\d{3})(\\d{4})",
                "$1 $2",
                ["[3467]"]
              ], [, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["9[4-8]"]]], , [, , "955\\d{5}", , , , "95581234", , , [8]], 1, "[69]", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              CX: [, [, , "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", , , , , , , [6, 7, 8, 9, 10, 12]], [, , "8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}", , , , "891641234", , , [9], [8]], [
                ,
                ,
                "4(?:79[01]|83[0-389]|94[0-478])\\d{5}|4(?:[0-36]\\d|4[047-9]|[58][0-24-9]|7[02-8]|9[0-37-9])\\d{6}",
                ,
                ,
                ,
                "412345678",
                ,
                ,
                [9]
              ], [, , "180(?:0\\d{3}|2)\\d{3}", , , , "1800123456", , , [7, 10]], [, , "190[0-26]\\d{6}", , , , "1900123456", , , [10]], [, , "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", , , , "1300123456", , , [6, 8, 10, 12]], [, , , , , , , , , [-1]], [, , "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", , , , "147101234", , , [9]], "CX", 61, "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "0", , , "([59]\\d{7})$|0", "8$1", "0011", , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              CY: [, [
                ,
                ,
                "(?:[279]\\d|[58]0)\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [8]
              ], [, , "2[2-6]\\d{6}", , , , "22345678"], [, , "9(?:10|[4-79]\\d)\\d{5}", , , , "96123456"], [, , "800\\d{5}", , , , "80001234"], [, , "90[09]\\d{5}", , , , "90012345"], [, , "80[1-9]\\d{5}", , , , "80112345"], [, , "700\\d{5}", , , , "70012345"], [, , , , , , , , , [-1]], "CY", 357, "00", , , , , , , , [[, "(\\d{2})(\\d{6})", "$1 $2", ["[257-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "(?:50|77)\\d{6}", , , , "77123456"], , , [, , , , , , , , , [-1]]],
              CZ: [, [, , "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}", , , , , , , [9, 10, 11, 12]], [
                ,
                ,
                "(?:2\\d|3[1257-9]|4[16-9]|5[13-9])\\d{7}",
                ,
                ,
                ,
                "212345678",
                ,
                ,
                [9]
              ], [, , "7(?:060\\d|19(?:[0-4]\\d|50))\\d{4}|(?:60[1-8]|7(?:0[2-5]|[2379]\\d))\\d{6}", , , , "601123456", , , [9]], [, , "800\\d{6}", , , , "800123456", , , [9]], [, , "9(?:0[05689]|76)\\d{6}", , , , "900123456", , , [9]], [, , "8[134]\\d{7}", , , , "811234567", , , [9]], [, , "70[01]\\d{6}", , , , "700123456", , , [9]], [, , "9[17]0\\d{6}", , , , "910123456", , , [9]], "CZ", 420, "00", , , , , , , , [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]|9[015-7]"]], [, "(\\d{2})(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["96"]], [
                ,
                "(\\d{2})(\\d{3})(\\d{3})(\\d{3})",
                "$1 $2 $3 $4",
                ["9"]
              ], [, "(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "9(?:5\\d|7[2-4])\\d{6}", , , , "972123456", , , [9]], , , [, , "9(?:3\\d{9}|6\\d{7,10})", , , , "93123456789"]],
              DE: [, [, , "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}", , , , , , , [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15], [2, 3]], [
                ,
                ,
                "32\\d{9,11}|49[1-6]\\d{10}|322\\d{6}|49[0-7]\\d{3,9}|(?:[34]0|[68]9)\\d{3,13}|(?:2(?:0[1-689]|[1-3569]\\d|4[0-8]|7[1-7]|8[0-7])|3(?:[3569]\\d|4[0-79]|7[1-7]|8[1-8])|4(?:1[02-9]|[2-48]\\d|5[0-6]|6[0-8]|7[0-79])|5(?:0[2-8]|[124-6]\\d|[38][0-8]|[79][0-7])|6(?:0[02-9]|[1-358]\\d|[47][0-8]|6[1-9])|7(?:0[2-8]|1[1-9]|[27][0-7]|3\\d|[4-6][0-8]|8[0-5]|9[013-7])|8(?:0[2-9]|1[0-79]|2\\d|3[0-46-9]|4[0-6]|5[013-9]|6[1-8]|7[0-8]|8[0-24-6])|9(?:0[6-9]|[1-4]\\d|[589][0-7]|6[0-8]|7[0-467]))\\d{3,12}",
                ,
                ,
                ,
                "30123456",
                ,
                ,
                [5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
                [2, 3, 4]
              ], [, , "1(?:(?:5(?:[0-25-9]\\d\\d|3(?:10|33))|7[26-9]\\d\\d)\\d{6}|6[023]\\d{7,8})|17\\d{8}", , , , "15123456789", , , [10, 11]], [, , "800\\d{7,12}", , , , "8001234567890", , , [10, 11, 12, 13, 14, 15]], [, , "(?:137[7-9]|900(?:[135]|9\\d))\\d{6}", , , , "9001234567", , , [10, 11]], [, , "180\\d{5,11}|13(?:7[1-6]\\d\\d|8)\\d{4}", , , , "18012345", , , [7, 8, 9, 10, 11, 12, 13, 14]], [, , "700\\d{8}", , , , "70012345678", , , [11]], [, , , , , , , , , [-1]], "DE", 49, "00", "0", , , "0", , , , [
                [
                  ,
                  "(\\d{2})(\\d{3,13})",
                  "$1 $2",
                  ["3[02]|40|[68]9"],
                  "0$1"
                ],
                [, "(\\d{6})", "$1", ["227", "2277"]],
                [, "(\\d{3})(\\d{3,12})", "$1 $2", ["2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1", "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"], "0$1"],
                [
                  ,
                  "(\\d{4})(\\d{2,11})",
                  "$1 $2",
                  ["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]", "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"],
                  "0$1"
                ],
                [, "(\\d{3})(\\d{4})", "$1 $2", ["138"], "0$1"],
                [, "(\\d{5})(\\d{2,10})", "$1 $2", ["3"], "0$1"],
                [, "(\\d{3})(\\d{5,11})", "$1 $2", ["181"], "0$1"],
                [, "(\\d{3})(\\d)(\\d{4,10})", "$1 $2 $3", ["1(?:3|80)|9"], "0$1"],
                [, "(\\d{3})(\\d{7,8})", "$1 $2", ["1[67]"], "0$1"],
                [, "(\\d{3})(\\d{7,12})", "$1 $2", ["8"], "0$1"],
                [, "(\\d{5})(\\d{6})", "$1 $2", ["185", "1850", "18500"], "0$1"],
                [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"],
                [, "(\\d{4})(\\d{7})", "$1 $2", ["18[68]"], "0$1"],
                [, "(\\d{4})(\\d{7})", "$1 $2", ["15[1279]"], "0$1"],
                [, "(\\d{5})(\\d{6})", "$1 $2", ["15[03568]", "15(?:[0568]|3[13])"], "0$1"],
                [, "(\\d{3})(\\d{8})", "$1 $2", ["18"], "0$1"],
                [, "(\\d{3})(\\d{2})(\\d{7,8})", "$1 $2 $3", ["1(?:6[023]|7)"], "0$1"],
                [, "(\\d{4})(\\d{2})(\\d{7})", "$1 $2 $3", ["15[279]"], "0$1"],
                [, "(\\d{3})(\\d{2})(\\d{8})", "$1 $2 $3", ["15"], "0$1"]
              ], [
                [, "(\\d{2})(\\d{3,13})", "$1 $2", ["3[02]|40|[68]9"], "0$1"],
                [
                  ,
                  "(\\d{3})(\\d{3,12})",
                  "$1 $2",
                  ["2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1", "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"],
                  "0$1"
                ],
                [
                  ,
                  "(\\d{4})(\\d{2,11})",
                  "$1 $2",
                  ["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]", "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"],
                  "0$1"
                ],
                [, "(\\d{3})(\\d{4})", "$1 $2", ["138"], "0$1"],
                [, "(\\d{5})(\\d{2,10})", "$1 $2", ["3"], "0$1"],
                [, "(\\d{3})(\\d{5,11})", "$1 $2", ["181"], "0$1"],
                [, "(\\d{3})(\\d)(\\d{4,10})", "$1 $2 $3", ["1(?:3|80)|9"], "0$1"],
                [, "(\\d{3})(\\d{7,8})", "$1 $2", ["1[67]"], "0$1"],
                [, "(\\d{3})(\\d{7,12})", "$1 $2", ["8"], "0$1"],
                [, "(\\d{5})(\\d{6})", "$1 $2", ["185", "1850", "18500"], "0$1"],
                [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"],
                [, "(\\d{4})(\\d{7})", "$1 $2", ["18[68]"], "0$1"],
                [, "(\\d{4})(\\d{7})", "$1 $2", ["15[1279]"], "0$1"],
                [, "(\\d{5})(\\d{6})", "$1 $2", ["15[03568]", "15(?:[0568]|3[13])"], "0$1"],
                [, "(\\d{3})(\\d{8})", "$1 $2", ["18"], "0$1"],
                [, "(\\d{3})(\\d{2})(\\d{7,8})", "$1 $2 $3", ["1(?:6[023]|7)"], "0$1"],
                [, "(\\d{4})(\\d{2})(\\d{7})", "$1 $2 $3", ["15[279]"], "0$1"],
                [, "(\\d{3})(\\d{2})(\\d{8})", "$1 $2 $3", ["15"], "0$1"]
              ], [, , "16(?:4\\d{1,10}|[89]\\d{1,11})", , , , "16412345", , , [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14]], , , [, , , , , , , , , [-1]], [, , "18(?:1\\d{5,11}|[2-9]\\d{8})", , , , "18500123456", , , [8, 9, 10, 11, 12, 13, 14]], , , [
                ,
                ,
                "1(?:6(?:013|255|399)|7(?:(?:[015]1|[69]3)3|[2-4]55|[78]99))\\d{7,8}|15(?:(?:[03-68]00|113)\\d|2\\d55|7\\d99|9\\d33)\\d{7}",
                ,
                ,
                ,
                "177991234567",
                ,
                ,
                [12, 13]
              ]],
              DJ: [, [, , "(?:2\\d|77)\\d{6}", , , , , , , [8]], [, , "2(?:1[2-5]|7[45])\\d{5}", , , , "21360003"], [, , "77\\d{6}", , , , "77831001"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "DJ", 253, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[27]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              DK: [, [, , "[2-9]\\d{7}", , , , , , , [8]], [
                ,
                ,
                "(?:2(?:[0-59][1-9]|[6-8]\\d)|3(?:[0-3][1-9]|4[13]|5[1-58]|6[1347-9]|7\\d|8[1-8]|9[1-79])|4(?:[0-25][1-9]|[34][2-9]|6[13-579]|7[13579]|8[1-47]|9[127])|5(?:[0-36][1-9]|4[146-9]|5[3-57-9]|7[568]|8[1-358]|9[1-69])|6(?:[0135][1-9]|2[1-68]|4[2-8]|6[1689]|[78]\\d|9[15689])|7(?:[0-69][1-9]|7[3-9]|8[147])|8(?:[16-9][1-9]|2[1-58])|9(?:[1-47-9][1-9]|6\\d))\\d{5}",
                ,
                ,
                ,
                "32123456"
              ], [, , "(?:2[6-8]|37|6[78]|96)\\d{6}|(?:2[0-59]|3[0-689]|[457]\\d|6[0-69]|8[126-9]|9[1-47-9])[1-9]\\d{5}", , , , "34412345"], [, , "80\\d{6}", , , , "80123456"], [, , "90\\d{6}", , , , "90123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "DK", 45, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              DM: [
                ,
                [, , "(?:[58]\\d\\d|767|900)\\d{7}", , , , , , , [10], [7]],
                [
                  ,
                  ,
                  "767(?:2(?:55|66)|4(?:2[01]|4[0-25-9])|50[0-4])\\d{4}",
                  ,
                  ,
                  ,
                  "7674201234",
                  ,
                  ,
                  ,
                  [7]
                ],
                [, , "767(?:2(?:[2-4689]5|7[5-7])|31[5-7]|61[1-8]|70[1-6])\\d{4}", , , , "7672251234", , , , [7]],
                [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"],
                [, , "900[2-9]\\d{6}", , , , "9002123456"],
                [, , , , , , , , , [-1]],
                [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"],
                [, , , , , , , , , [-1]],
                "DM",
                1,
                "011",
                "1",
                ,
                ,
                "([2-7]\\d{6})$|1",
                "767$1",
                ,
                ,
                ,
                ,
                [, , , , , , , , , [-1]],
                ,
                "767",
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]]
              ],
              DO: [
                ,
                [, , "(?:[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]],
                [
                  ,
                  ,
                  "8(?:[04]9[2-9]\\d\\d|29(?:2(?:[0-59]\\d|6[04-9]|7[0-27]|8[0237-9])|3(?:[0-35-9]\\d|4[7-9])|[45]\\d\\d|6(?:[0-27-9]\\d|[3-5][1-9]|6[0135-8])|7(?:0[013-9]|[1-37]\\d|4[1-35689]|5[1-4689]|6[1-57-9]|8[1-79]|9[1-8])|8(?:0[146-9]|1[0-48]|[248]\\d|3[1-79]|5[01589]|6[013-68]|7[124-8]|9[0-8])|9(?:[0-24]\\d|3[02-46-9]|5[0-79]|60|7[0169]|8[57-9]|9[02-9])))\\d{4}",
                  ,
                  ,
                  ,
                  "8092345678",
                  ,
                  ,
                  ,
                  [7]
                ],
                [, , "8[024]9[2-9]\\d{6}", , , , "8092345678", , , , [7]],
                [, , "800(?:14|[2-9]\\d)\\d{5}|8[024]9[01]\\d{6}|8(?:33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"],
                [, , "900[2-9]\\d{6}", , , , "9002123456"],
                [, , , , , , , , , [-1]],
                [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"],
                [, , , , , , , , , [-1]],
                "DO",
                1,
                "011",
                "1",
                ,
                ,
                "1",
                ,
                ,
                ,
                ,
                ,
                [, , , , , , , , , [-1]],
                ,
                "8001|8[024]9",
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]]
              ],
              DZ: [
                ,
                [, , "(?:[1-4]|[5-79]\\d|80)\\d{7}", , , , , , , [8, 9]],
                [, , "9619\\d{5}|(?:1\\d|2[013-79]|3[0-8]|4[013-689])\\d{6}", , , , "12345678"],
                [, , "(?:5(?:4[0-29]|5\\d|6[0-3])|6(?:[569]\\d|7[0-6])|7[7-9]\\d)\\d{6}", , , , "551234567", , , [9]],
                [, , "800\\d{6}", , , , "800123456", , , [9]],
                [, , "80[3-689]1\\d{5}", , , , "808123456", , , [9]],
                [, , "80[12]1\\d{5}", , , , "801123456", , , [9]],
                [, , , , , , , , , [-1]],
                [, , "98[23]\\d{6}", , , , "983123456", , , [9]],
                "DZ",
                213,
                "00",
                "0",
                ,
                ,
                "0",
                ,
                ,
                ,
                [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-4]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["9"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-8]"], "0$1"]],
                ,
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]]
              ],
              EC: [, [, , "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}", , , , , , , [8, 9, 10, 11], [7]], [, , "[2-7][2-7]\\d{6}", , , , "22123456", , , [8], [7]], [, , "964[0-2]\\d{5}|9(?:39|[57][89]|6[0-36-9]|[89]\\d)\\d{6}", , , , "991234567", , , [9]], [
                ,
                ,
                "1800\\d{7}|1[78]00\\d{6}",
                ,
                ,
                ,
                "18001234567",
                ,
                ,
                [10, 11]
              ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "[2-7]890\\d{4}", , , , "28901234", , , [8]], "EC", 593, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{4})", "$1-$2", ["[2-7]"]], [, "(\\d)(\\d{3})(\\d{4})", "$1 $2-$3", ["[2-7]"], "(0$1)"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1"]]], [[, "(\\d)(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-7]"]], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1"]]], [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              EE: [, [, , "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}", , , , , , , [7, 8, 10]], [, , "(?:3[23589]|4[3-8]|6\\d|7[1-9]|88)\\d{5}", , , , "3212345", , , [7]], [
                ,
                ,
                "(?:5\\d{5}|8(?:1(?:0(?:0(?:00|[178]\\d)|[3-9]\\d\\d)|(?:1(?:0[2-6]|1\\d)|(?:2[0-59]|[3-79]\\d)\\d)\\d)|2(?:0(?:0(?:00|4\\d)|(?:19|[2-7]\\d)\\d)|(?:(?:[124-69]\\d|3[5-9])\\d|7(?:[0-79]\\d|8[13-9])|8(?:[2-6]\\d|7[01]))\\d)|[349]\\d{4}))\\d\\d|5(?:(?:[02]\\d|5[0-478])\\d|1(?:[0-8]\\d|95)|6(?:4[0-4]|5[1-589]))\\d{3}",
                ,
                ,
                ,
                "51234567",
                ,
                ,
                [7, 8]
              ], [, , "800(?:(?:0\\d\\d|1)\\d|[2-9])\\d{3}", , , , "80012345"], [, , "(?:40\\d\\d|900)\\d{4}", , , , "9001234", , , [7, 8]], [, , , , , , , , , [-1]], [, , "70[0-2]\\d{5}", , , , "70012345", , , [8]], [, , , , , , , , , [-1]], "EE", 372, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88", "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"]], [, "(\\d{4})(\\d{3,4})", "$1 $2", ["[45]|8(?:00|[1-49])", "[45]|8(?:00[1-9]|[1-49])"]], [
                ,
                "(\\d{2})(\\d{2})(\\d{4})",
                "$1 $2 $3",
                ["7"]
              ], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]], , [, , , , , , , , , [-1]], , , [, , "800[2-9]\\d{3}", , , , , , , [7]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              EG: [
                ,
                [, , "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}", , , , , , , [8, 9, 10], [6, 7]],
                [, , "13[23]\\d{6}|(?:15|57)\\d{6,7}|(?:2\\d|3|4[05-8]|5[05]|6[24-689]|8[2468]|9[235-7])\\d{7}", , , , "234567890", , , [8, 9], [6, 7]],
                [, , "1[0-25]\\d{8}", , , , "1001234567", , , [10]],
                [, , "800\\d{7}", , , , "8001234567", , , [10]],
                [, , "900\\d{7}", , , , "9001234567", , , [10]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                "EG",
                20,
                "00",
                "0",
                ,
                ,
                "0",
                ,
                ,
                ,
                [[, "(\\d)(\\d{7,8})", "$1 $2", ["[23]"], "0$1"], [, "(\\d{2})(\\d{6,7})", "$1 $2", ["1[35]|[4-6]|8[2468]|9[235-7]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], [, "(\\d{2})(\\d{8})", "$1 $2", ["1"], "0$1"]],
                ,
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]]
              ],
              EH: [
                ,
                [, , "[5-8]\\d{8}", , , , , , , [9]],
                [, , "528[89]\\d{5}", , , , "528812345"],
                [, , "(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-8]|5[0-5]|8[0-7]))\\d{6}", , , , "650123456"],
                [, , "80[0-7]\\d{6}", , , , "801234567"],
                [, , "89\\d{7}", , , , "891234567"],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , "(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}", , , , "592401234"],
                "EH",
                212,
                "00",
                "0",
                ,
                ,
                "0",
                ,
                ,
                ,
                ,
                ,
                [, , , , , , , , , [-1]],
                ,
                "528[89]",
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]]
              ],
              ER: [, [, , "[178]\\d{6}", , , , , , , [7], [6]], [, , "(?:1(?:1[12568]|[24]0|55|6[146])|8\\d\\d)\\d{4}", , , , "8370362", , , , [6]], [, , "(?:17[1-3]|7\\d\\d)\\d{4}", , , , "7123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "ER", 291, "00", "0", , , "0", , , , [[
                ,
                "(\\d)(\\d{3})(\\d{3})",
                "$1 $2 $3",
                ["[178]"],
                "0$1"
              ]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              ES: [
                ,
                [, , "[5-9]\\d{8}", , , , , , , [9]],
                [, , "96906(?:0[0-8]|1[1-9]|[2-9]\\d)\\d\\d|9(?:69(?:0[0-57-9]|[1-9]\\d)|73(?:[0-8]\\d|9[1-9]))\\d{4}|(?:8(?:[1356]\\d|[28][0-8]|[47][1-9])|9(?:[135]\\d|[268][0-8]|4[1-9]|7[124-9]))\\d{6}", , , , "810123456"],
                [, , "(?:590[16]00\\d|9(?:6906(?:09|10)|7390\\d\\d))\\d\\d|(?:6\\d|7[1-48])\\d{7}", , , , "612345678"],
                [, , "[89]00\\d{6}", , , , "800123456"],
                [, , "80[367]\\d{6}", , , , "803123456"],
                [, , "90[12]\\d{6}", , , , "901123456"],
                [, , "70\\d{7}", , , , "701234567"],
                [, , , , , , , , , [-1]],
                "ES",
                34,
                "00",
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [[, "(\\d{4})", "$1", ["905"]], [, "(\\d{6})", "$1", ["[79]9"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]00"]], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-9]"]]],
                [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]00"]], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-9]"]]],
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]],
                [, , "51\\d{7}", , , , "511234567"],
                ,
                ,
                [, , , , , , , , , [-1]]
              ],
              ET: [, [
                ,
                ,
                "(?:11|[2-579]\\d)\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [9],
                [7]
              ], [
                ,
                ,
                "11667[01]\\d{3}|(?:11(?:1(?:1[1-468]|2[2-7]|3[1-5]|5[5-8]|8[6-8])|2(?:13|3[6-8]|5[89]|7[05-9]|8[2-6])|3(?:2[01]|3[0-289]|4[1289]|7[1-4]|87)|4(?:1[69]|3[2-49]|4[0-3]|6[5-8]|7\\d)|5(?:1[578]|44|5[0-4])|6(?:1[578]|2[69]|39|4[5-7]|5[0-5]|6[0-59]|8[015-8]))|2(?:2(?:11[1-9]|22[0-7]|33\\d|44[1467]|66[1-68])|5(?:11[124-6]|33[2-8]|44[1467]|55[14]|66[1-3679]|77[124-79]|880))|3(?:3(?:11[0-46-8]|(?:22|55)[0-6]|33[0134689]|44[04]|66[01467])|4(?:44[0-8]|55[0-69]|66[0-3]|77[1-5]))|4(?:6(?:119|22[0-24-7]|33[1-5]|44[13-69]|55[14-689]|660|88[1-4])|7(?:(?:11|22)[1-9]|33[13-7]|44[13-6]|55[1-689]))|5(?:7(?:227|55[05]|(?:66|77)[14-8])|8(?:11[149]|22[013-79]|33[0-68]|44[013-8]|550|66[1-5]|77\\d)))\\d{4}",
                ,
                ,
                ,
                "111112345",
                ,
                ,
                ,
                [7]
              ], [, , "700[1-9]\\d{5}|(?:7(?:0[1-9]|1[0-8]|22|77|86|99)|9\\d\\d)\\d{6}", , , , "911234567"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "ET", 251, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-579]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              FI: [
                ,
                [, , "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}", , , , , , , [5, 6, 7, 8, 9, 10, 11, 12]],
                [
                  ,
                  ,
                  "1[3-7][1-8]\\d{3,6}|(?:19[1-8]|[23568][1-8]\\d|9(?:00|[1-8]\\d))\\d{2,6}",
                  ,
                  ,
                  ,
                  "131234567",
                  ,
                  ,
                  [5, 6, 7, 8, 9]
                ],
                [, , "4946\\d{2,6}|(?:4[0-8]|50)\\d{4,8}", , , , "412345678", , , [6, 7, 8, 9, 10]],
                [, , "800\\d{4,6}", , , , "800123456", , , [7, 8, 9]],
                [, , "[67]00\\d{5,6}", , , , "600123456", , , [8, 9]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                "FI",
                358,
                "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))",
                "0",
                ,
                ,
                "0",
                ,
                "00",
                ,
                [[, "(\\d{5})", "$1", ["75[12]"], "0$1"], [, "(\\d{5})", "$1", ["20[2-59]"], "0$1"], [, "(\\d{6})", "$1", ["11"]], [, "(\\d{3})(\\d{3,7})", "$1 $2", ["(?:[1-3]0|[68])0|70[07-9]"], "0$1"], [
                  ,
                  "(\\d{2})(\\d{4,8})",
                  "$1 $2",
                  ["[14]|2[09]|50|7[135]"],
                  "0$1"
                ], [, "(\\d{2})(\\d{6,10})", "$1 $2", ["7"], "0$1"], [, "(\\d)(\\d{4,9})", "$1 $2", ["(?:19|[2568])[1-8]|3(?:0[1-9]|[1-9])|9"], "0$1"]],
                [[, "(\\d{5})", "$1", ["20[2-59]"], "0$1"], [, "(\\d{3})(\\d{3,7})", "$1 $2", ["(?:[1-3]0|[68])0|70[07-9]"], "0$1"], [, "(\\d{2})(\\d{4,8})", "$1 $2", ["[14]|2[09]|50|7[135]"], "0$1"], [, "(\\d{2})(\\d{6,10})", "$1 $2", ["7"], "0$1"], [, "(\\d)(\\d{4,9})", "$1 $2", ["(?:19|[2568])[1-8]|3(?:0[1-9]|[1-9])|9"], "0$1"]],
                [, , , , , , , , , [-1]],
                1,
                "1[03-79]|[2-9]",
                [, , "20(?:2[023]|9[89])\\d{1,6}|(?:60[12]\\d|7099)\\d{4,5}|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:[1-3]00|7(?:0[1-5]\\d\\d|5[03-9]))\\d{3,7}"],
                [, , "20\\d{4,8}|60[12]\\d{5,6}|7(?:099\\d{4,5}|5[03-9]\\d{3,7})|20[2-59]\\d\\d|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:10|29|3[09]|70[1-5]\\d)\\d{4,8}", , , , "10112345"],
                ,
                ,
                [, , , , , , , , , [-1]]
              ],
              FJ: [
                ,
                [, , "45\\d{5}|(?:0800\\d|[235-9])\\d{6}", , , , , , , [7, 11]],
                [, , "603\\d{4}|(?:3[0-5]|6[25-7]|8[58])\\d{5}", , , , "3212345", , , [7]],
                [, , "(?:[279]\\d|45|5[01568]|8[034679])\\d{5}", , , , "7012345", , , [7]],
                [, , "0800\\d{7}", , , , "08001234567", , , [11]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                "FJ",
                679,
                "0(?:0|52)",
                ,
                ,
                ,
                ,
                ,
                "00",
                ,
                [[, "(\\d{3})(\\d{4})", "$1 $2", ["[235-9]|45"]], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]]],
                ,
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]]
              ],
              FK: [, [, , "[2-7]\\d{4}", , , , , , , [5]], [, , "[2-47]\\d{4}", , , , "31234"], [, , "[56]\\d{4}", , , , "51234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "FK", 500, "00", , , , , , , , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              FM: [, [, , "(?:[39]\\d\\d|820)\\d{4}", , , , , , , [7]], [
                ,
                ,
                "31(?:00[67]|208|309)\\d\\d|(?:3(?:[2357]0[1-9]|602|804|905)|(?:820|9[2-6]\\d)\\d)\\d{3}",
                ,
                ,
                ,
                "3201234"
              ], [, , "31(?:00[67]|208|309)\\d\\d|(?:3(?:[2357]0[1-9]|602|804|905)|(?:820|9[2-7]\\d)\\d)\\d{3}", , , , "3501234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "FM", 691, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[389]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              FO: [, [, , "[2-9]\\d{5}", , , , , , , [6]], [, , "(?:20|[34]\\d|8[19])\\d{4}", , , , "201234"], [, , "(?:[27][1-9]|5\\d|9[16])\\d{4}", , , , "211234"], [, , "80[257-9]\\d{3}", , , , "802123"], [
                ,
                ,
                "90(?:[13-5][15-7]|2[125-7]|9\\d)\\d\\d",
                ,
                ,
                ,
                "901123"
              ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "(?:6[0-36]|88)\\d{4}", , , , "601234"], "FO", 298, "00", , , , "(10(?:01|[12]0|88))", , , , [[, "(\\d{6})", "$1", ["[2-9]"], , "$CC $1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              FR: [, [, , "[1-9]\\d{8}", , , , , , , [9]], [, , "(?:26[013-9]|59[1-35-9])\\d{6}|(?:[13]\\d|2[0-57-9]|4[1-9]|5[0-8])\\d{7}", , , , "123456789"], [, , "(?:6(?:[0-24-8]\\d|3[0-8]|9[589])|7[3-9]\\d)\\d{6}", , , , "612345678"], [, , "80[0-5]\\d{6}", , , , "801234567"], [
                ,
                ,
                "836(?:0[0-36-9]|[1-9]\\d)\\d{4}|8(?:1[2-9]|2[2-47-9]|3[0-57-9]|[569]\\d|8[0-35-9])\\d{6}",
                ,
                ,
                ,
                "891123456"
              ], [, , "8(?:1[01]|2[0156]|4[024]|84)\\d{6}", , , , "884012345"], [, , , , , , , , , [-1]], [, , "9\\d{8}", , , , "912345678"], "FR", 33, "00", "0", , , "0", , , , [[, "(\\d{4})", "$1", ["10"]], [, "(\\d{3})(\\d{3})", "$1 $2", ["1"]], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0 $1"], [, "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[1-79]"], "0$1"]], [[, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0 $1"], [, "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[1-79]"], "0$1"]], [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ], , , [, , , , , , , , , [-1]], [, , "80[6-9]\\d{6}", , , , "806123456"], , , [, , , , , , , , , [-1]]],
              GA: [, [, , "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}", , , , , , , [7, 8]], [, , "[01]1\\d{6}", , , , "01441234", , , [8]], [, , "(?:(?:0[2-7]|7[467])\\d|6(?:0[0-4]|10|[256]\\d))\\d{5}|[2-7]\\d{6}", , , , "06031234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "GA", 241, "00", , , , "0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})", "$1", , , [[, "(\\d)(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-7]"], "0$1"], [
                ,
                "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                "$1 $2 $3 $4",
                ["0"]
              ], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["11|[67]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              GB: [, [, , "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}", , , , , , , [7, 9, 10], [4, 5, 6, 8]], [
                ,
                ,
                "(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0-35])|4(?:(?:[0-5]\\d|70)\\d|69[7-9])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|50))\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[0-3]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}",
                ,
                ,
                ,
                "1212345678",
                ,
                ,
                [9, 10],
                [4, 5, 6, 7, 8]
              ], [, , "7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}", , , , "7400123456", , , [10]], [, , "80[08]\\d{7}|800\\d{6}|8001111", , , , "8001234567"], [, , "(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d", , , , "9012345678", , , [7, 10]], [, , , , , , , , , [-1]], [, , "70\\d{8}", , , , "7012345678", , , [10]], [
                ,
                ,
                "56\\d{8}",
                ,
                ,
                ,
                "5612345678",
                ,
                ,
                [10]
              ], "GB", 44, "00", "0", " x", , "0|180020", , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["800", "8001", "80011", "800111", "8001111"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["845", "8454", "84546", "845464"], "0$1"], [, "(\\d{3})(\\d{6})", "$1 $2", ["800"], "0$1"], [, "(\\d{5})(\\d{4,5})", "$1 $2", ["1(?:38|5[23]|69|76|94)", "1(?:(?:38|69)7|5(?:24|39)|768|946)", "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"], "0$1"], [, "(\\d{4})(\\d{5,6})", "$1 $2", ["1(?:[2-69][02-9]|[78])"], "0$1"], [
                ,
                "(\\d{2})(\\d{4})(\\d{4})",
                "$1 $2 $3",
                ["[25]|7(?:0|6[02-9])", "[25]|7(?:0|6(?:[03-9]|2[356]))"],
                "0$1"
              ], [, "(\\d{4})(\\d{6})", "$1 $2", ["7"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1389]"], "0$1"]], , [, , "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", , , , "7640123456", , , [10]], 1, , [, , , , , , , , , [-1]], [, , "(?:3[0347]|55)\\d{8}", , , , "5512345678", , , [10]], , , [, , , , , , , , , [-1]]],
              GD: [, [, , "(?:473|[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]], [
                ,
                ,
                "473(?:2(?:3[0-2]|69)|3(?:2[89]|86)|4(?:[06]8|3[5-9]|4[0-4]|5[59]|73|90)|63[68]|7(?:58|84)|800|938)\\d{4}",
                ,
                ,
                ,
                "4732691234",
                ,
                ,
                ,
                [7]
              ], [, , "473(?:4(?:0[2-79]|1[04-9]|2[0-5]|49|5[6-8])|5(?:2[01]|3[3-8])|901)\\d{4}", , , , "4734031234", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ], "GD", 1, "011", "1", , , "([2-9]\\d{6})$|1", "473$1", , , , , [, , , , , , , , , [-1]], , "473", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              GE: [, [, , "(?:[3-57]\\d\\d|800)\\d{6}", , , , , , , [9], [6, 7]], [, , "(?:3(?:[256]\\d|4[124-9]|7[0-4])|4(?:1\\d|2[2-7]|3[1-79]|4[2-8]|7[239]|9[1-7]))\\d{6}", , , , "322123456", , , , [6, 7]], [
                ,
                ,
                "5(?:(?:(?:0555|1(?:[17]77|555))[5-9]|757(?:7[7-9]|8[01]))\\d|22252[0-4])\\d\\d|5(?:0(?:0[17]0|505)|1(?:0[01]0|1(?:07|33|51))|2(?:0[02]0|2[25]2)|3(?:0[03]0|3[35]3)|(?:40[04]|900)0|5222)[0-4]\\d{3}|(?:5(?:0(?:0(?:0\\d|11|22|3[0-6]|44|5[05]|77|88|9[09])|(?:[14]\\d|77)\\d|22[02])|1(?:1(?:[03][01]|[124]\\d|5[2-6]|7[0-4])|4\\d\\d)|[23]555|4(?:4\\d\\d|555)|5(?:[0157-9]\\d\\d|200|333|444)|6[89]\\d\\d|7(?:[0147-9]\\d\\d|5(?:00|[57]5))|8(?:0(?:[018]\\d|2[0-4])|5(?:55|8[89])|8(?:55|88))|9(?:090|[1-35-9]\\d\\d))|790\\d\\d)\\d{4}",
                ,
                ,
                ,
                "555123456"
              ], [, , "800\\d{6}", , , , "800123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "70[67]\\d{6}", , , , "706123456"], "GE", 995, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["32"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[57]"]], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[348]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , "70[67]\\d{6}"], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              GF: [, [
                ,
                ,
                "(?:[56]94\\d|7093)\\d{5}|(?:80|9\\d)\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [9]
              ], [, , "594(?:[02-49]\\d|1[0-5]|5[6-9]|6[0-3]|80)\\d{4}", , , , "594101234"], [, , "(?:694(?:[0-249]\\d|3[0-8])|7093[0-3])\\d{4}", , , , "694201234"], [, , "80[0-5]\\d{6}", , , , "800012345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "9(?:(?:396|76\\d)\\d|476[0-6])\\d{4}", , , , "976012345"], "GF", 594, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]|9[47]"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[89]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ], , , [, , , , , , , , , [-1]]],
              GG: [
                ,
                [, , "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?", , , , , , , [7, 9, 10], [6]],
                [, , "1481[25-9]\\d{5}", , , , "1481256789", , , [10], [6]],
                [, , "7(?:(?:781|839)\\d|911[17])\\d{5}", , , , "7781123456", , , [10]],
                [, , "80[08]\\d{7}|800\\d{6}|8001111", , , , "8001234567"],
                [, , "(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d", , , , "9012345678", , , [7, 10]],
                [, , , , , , , , , [-1]],
                [, , "70\\d{8}", , , , "7012345678", , , [10]],
                [, , "56\\d{8}", , , , "5612345678", , , [10]],
                "GG",
                44,
                "00",
                "0",
                ,
                ,
                "([25-9]\\d{5})$|0|180020",
                "1481$1",
                ,
                ,
                ,
                ,
                [, , "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", , , , "7640123456", , , [10]],
                ,
                ,
                [, , , , , , , , , [-1]],
                [, , "(?:3[0347]|55)\\d{8}", , , , "5512345678", , , [10]],
                ,
                ,
                [, , , , , , , , , [-1]]
              ],
              GH: [, [, , "(?:[235]\\d{3}|800)\\d{5}", , , , , , , [8, 9], [7]], [, , "3082[0-5]\\d{4}|3(?:0(?:[237]\\d|8[01])|[167](?:2[0-6]|7\\d|80)|2(?:2[0-5]|7\\d|80)|3(?:2[0-3]|7\\d|80)|4(?:2[013-9]|3[01]|7\\d|80)|5(?:2[0-7]|7\\d|80)|8(?:2[0-2]|7\\d|80)|9(?:[28]0|7\\d))\\d{5}", , , , "302345678", , , [9], [7]], [
                ,
                ,
                "(?:2(?:[0346-9]\\d|5[67])|5(?:[03-7]\\d|9[1-9]))\\d{6}",
                ,
                ,
                ,
                "231234567",
                ,
                ,
                [9]
              ], [, , "800\\d{5}", , , , "80012345", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "GH", 233, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[237]|8[0-2]"]], [, "(\\d{3})(\\d{5})", "$1 $2", ["8"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[235]"], "0$1"]], [[, "(\\d{3})(\\d{5})", "$1 $2", ["8"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[235]"], "0$1"]], [, , , , , , , , , [-1]], , , [, , "800\\d{5}", , , , , , , [8]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              GI: [, [
                ,
                ,
                "(?:[25]\\d|60)\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [8]
              ], [, , "2190[0-2]\\d{3}|2(?:0(?:[02]\\d|3[01])|16[24-9]|2[2-5]\\d)\\d{4}", , , , "20012345"], [, , "5251[0-4]\\d{3}|(?:5(?:[146-8]\\d\\d|250)|60(?:1[01]|6\\d))\\d{4}", , , , "57123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "GI", 350, "00", , , , , , , , [[, "(\\d{3})(\\d{5})", "$1 $2", ["2"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              GL: [, [, , "(?:19|[2-689]\\d|70)\\d{4}", , , , , , , [6]], [, , "(?:19|3[1-7]|[68][1-9]|70|9\\d)\\d{4}", , , , "321000"], [
                ,
                ,
                "[245]\\d{5}",
                ,
                ,
                ,
                "221234"
              ], [, , "80\\d{4}", , , , "801234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "3[89]\\d{4}", , , , "381234"], "GL", 299, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["19|[2-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              GM: [, [, , "[2-9]\\d{6}", , , , , , , [7]], [, , "(?:4(?:[23]\\d\\d|4(?:1[024679]|[6-9]\\d))|5(?:5(?:3\\d|4[0-7])|6[67]\\d|7(?:1[04]|2[035]|3[58]|48))|8[0-589]\\d\\d)\\d{3}", , , , "5661234"], [
                ,
                ,
                "556\\d{4}|(?:[23679]\\d|4[015]|5[0-489]|8[67])\\d{5}",
                ,
                ,
                ,
                "3012345"
              ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "GM", 220, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              GN: [, [, , "722\\d{6}|(?:3|6\\d)\\d{7}", , , , , , , [8, 9]], [, , "3(?:0(?:24|3[12]|4[1-35-7]|5[13]|6[189]|[78]1|9[1478])|1\\d\\d)\\d{4}", , , , "30241234", , , [8]], [, , "6[0-356]\\d{7}", , , , "601123456", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
                ,
                ,
                "722\\d{6}",
                ,
                ,
                ,
                "722123456",
                ,
                ,
                [9]
              ], "GN", 224, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["3"]], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[67]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              GP: [
                ,
                [, , "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}", , , , , , , [9]],
                [, , "590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1-9]|5[3-579]|[68][0-689]|7[08]|9\\d)\\d{4}", , , , "590201234"],
                [, , "(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}", , , , "690001234"],
                [, , "80[0-5]\\d{6}", , , , "800012345"],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , "9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}", , , , "976012345"],
                "GP",
                590,
                "00",
                "0",
                ,
                ,
                "0",
                ,
                ,
                ,
                [[, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-79]"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]],
                ,
                [, , , , , , , , , [-1]],
                1,
                ,
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]]
              ],
              GQ: [
                ,
                [, , "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}", , , , , , , [9]],
                [, , "33[0-24-9]\\d[46]\\d{4}|3(?:33|5\\d)\\d[7-9]\\d{4}", , , , "333091234"],
                [, , "(?:222|55\\d)\\d{6}", , , , "222123456"],
                [, , "80\\d[1-9]\\d{5}", , , , "800123456"],
                [, , "90\\d[1-9]\\d{5}", , , , "900123456"],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                "GQ",
                240,
                "00",
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235]"]], [, "(\\d{3})(\\d{6})", "$1 $2", ["[89]"]]],
                ,
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]]
              ],
              GR: [, [, , "5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}", , , , , , , [10, 11, 12]], [
                ,
                ,
                "2(?:1\\d\\d|2(?:2[1-46-9]|[36][1-8]|4[1-7]|5[1-4]|7[1-5]|[89][1-9])|3(?:1\\d|2[1-57]|[35][1-3]|4[13]|7[1-7]|8[124-6]|9[1-79])|4(?:1\\d|2[1-8]|3[1-4]|4[13-5]|6[1-578]|9[1-5])|5(?:1\\d|[29][1-4]|3[1-5]|4[124]|5[1-6])|6(?:1\\d|[269][1-6]|3[1245]|4[1-7]|5[13-9]|7[14]|8[1-5])|7(?:1\\d|2[1-5]|3[1-6]|4[1-7]|5[1-57]|6[135]|9[125-7])|8(?:1\\d|2[1-5]|[34][1-4]|9[1-57]))\\d{6}",
                ,
                ,
                ,
                "2123456789",
                ,
                ,
                [10]
              ], [, , "68[57-9]\\d{7}|(?:69|94)\\d{8}", , , , "6912345678", , , [10]], [, , "800\\d{7,9}", , , , "8001234567"], [, , "90[19]\\d{7}", , , , "9091234567", , , [10]], [, , "8(?:0[16]|12|[27]5|50)\\d{7}", , , , "8011234567", , , [10]], [, , "70\\d{8}", , , , "7012345678", , , [10]], [, , , , , , , , , [-1]], "GR", 30, "00", , , , , , , , [[, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["21|7"]], [, "(\\d{4})(\\d{6})", "$1 $2", ["2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2689]"]], [
                ,
                "(\\d{3})(\\d{3,4})(\\d{5})",
                "$1 $2 $3",
                ["8"]
              ]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "5005000\\d{3}", , , , "5005000123", , , [10]], , , [, , , , , , , , , [-1]]],
              GT: [, [, , "80\\d{6}|(?:1\\d{3}|[2-7])\\d{7}", , , , , , , [8, 11]], [, , "[267][2-9]\\d{6}", , , , "22456789", , , [8]], [, , "(?:[3-5]\\d\\d|80[0-4])\\d{5}", , , , "51234567", , , [8]], [, , "18[01]\\d{8}", , , , "18001112222", , , [11]], [, , "19\\d{9}", , , , "19001112222", , , [11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "GT", 502, "00", , , , , , , , [[, "(\\d{4})(\\d{4})", "$1 $2", ["[2-8]"]], [
                ,
                "(\\d{4})(\\d{3})(\\d{4})",
                "$1 $2 $3",
                ["1"]
              ]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              GU: [, [, , "(?:[58]\\d\\d|671|900)\\d{7}", , , , , , , [10], [7]], [, , "671(?:2\\d\\d|3(?:00|3[39]|4[349]|55|6[26])|4(?:00|56|7[1-9]|8[02-9])|5(?:55|6[2-5]|88)|6(?:3[2-578]|4[24-9]|5[34]|78|8[235-9])|7(?:[0479]7|2[0167]|3[45]|8[7-9])|8(?:[2-57-9]8|6[478])|9(?:2[29]|6[79]|7[1279]|8[7-9]|9[78]))\\d{4}", , , , "6713001234", , , , [7]], [
                ,
                ,
                "671(?:2\\d\\d|3(?:00|3[39]|4[349]|55|6[26])|4(?:00|56|7[1-9]|8[02-9])|5(?:55|6[2-5]|88)|6(?:3[2-578]|4[24-9]|5[34]|78|8[235-9])|7(?:[0479]7|2[0167]|3[45]|8[7-9])|8(?:[2-57-9]8|6[478])|9(?:2[29]|6[79]|7[1279]|8[7-9]|9[78]))\\d{4}",
                ,
                ,
                ,
                "6713001234",
                ,
                ,
                ,
                [7]
              ], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "GU", 1, "011", "1", , , "([2-9]\\d{6})$|1", "671$1", , 1, , , [, , , , , , , , , [-1]], , "671", [, , , , , , , , , [-1]], [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ], , , [, , , , , , , , , [-1]]],
              GW: [, [, , "[49]\\d{8}|4\\d{6}", , , , , , , [7, 9]], [, , "443\\d{6}", , , , "443201234", , , [9]], [, , "9(?:5\\d|6[569]|77)\\d{6}", , , , "955012345", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "40\\d{5}", , , , "4012345", , , [7]], "GW", 245, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["40"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              GY: [, [, , "(?:[2-8]\\d{3}|9008)\\d{3}", , , , , , , [7]], [
                ,
                ,
                "(?:2(?:1[6-9]|2[0-35-9]|3[1-4]|5[3-9]|6\\d|7[0-79])|3(?:2[25-9]|3\\d)|4(?:4[0-24]|5[56])|50[0-6]|77[1-57])\\d{4}",
                ,
                ,
                ,
                "2201234"
              ], [, , "(?:51[01]|6\\d\\d|7(?:[0-5]\\d|6[0-39]|70))\\d{4}", , , , "6091234"], [, , "(?:289|8(?:00|6[28]|88|99))\\d{4}", , , , "2891234"], [, , "9008\\d{3}", , , , "9008123"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "515\\d{4}", , , , "5151234"], "GY", 592, "001", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              HK: [, [, , "8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}", , , , , , , [5, 6, 7, 8, 9, 11]], [
                ,
                ,
                "(?:2(?:[13-9]\\d|2[013-9])\\d|3(?:(?:[1569][0-24-9]|4[0-246-9]|7[0-24-69])\\d|8(?:4[0-8]|[579]\\d|6[0-5]))|58(?:0[1-9]|1[2-9]))\\d{4}",
                ,
                ,
                ,
                "21234567",
                ,
                ,
                [8]
              ], [, , "(?:4(?:44[0-35-9]|6(?:4[0-57-9]|6[0-4])|7(?:3[0-4]|4[0-48]|6[0-5]))|5(?:35[4-8]|73[0-6]|95[0-8])|6(?:26[013-8]|(?:66|78)[0-5])|70(?:7[1-8]|8[0-8])|84(?:4[0-2]|8[0-35-9])|9(?:29[013-9]|39[014-9]|59[0-4]|899))\\d{4}|(?:4(?:4[0-35-9]|6[0-357-9]|7[0-25])|5(?:[1-59][0-46-9]|6[0-4689]|7[0-246-9])|6(?:0[1-9]|[13-59]\\d|[268][0-57-9]|7[0-79])|70[1-59]|84[0-39]|9(?:0[1-9]|1[02-9]|[2358][0-8]|[467]\\d))\\d{5}", , , , "51234567", , , [8]], [, , "800\\d{6}", , , , "800123456", , , [9]], [
                ,
                ,
                "900(?:[0-24-9]\\d{7}|3\\d{1,4})",
                ,
                ,
                ,
                "90012345678",
                ,
                ,
                [5, 6, 7, 8, 11]
              ], [, , , , , , , , , [-1]], [, , "8(?:1[0-4679]\\d|2(?:[0-36]\\d|7[0-4])|3(?:[034]\\d|2[09]|70))\\d{4}", , , , "81123456", , , [8]], [, , , , , , , , , [-1]], "HK", 852, "00(?:30|5[09]|[126-9]?)", , , , , , "00", , [[, "(\\d{3})(\\d{2,5})", "$1 $2", ["900", "9003"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], [, "(\\d{3})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]], , [
                ,
                ,
                "7(?:1(?:0[0-38]|1[0-3679]|3[013]|69|9[0136])|2(?:[02389]\\d|1[18]|7[27-9])|3(?:[0-38]\\d|7[0-369]|9[2357-9])|47\\d|5(?:[178]\\d|5[0-5])|6(?:0[0-7]|2[236-9]|[35]\\d)|7(?:[27]\\d|8[7-9])|8(?:[23689]\\d|7[1-9])|9(?:[025]\\d|6[0-246-8]|7[0-36-9]|8[238]))\\d{4}",
                ,
                ,
                ,
                "71123456",
                ,
                ,
                [8]
              ], , , [, , , , , , , , , [-1]], [, , "30(?:0[1-9]|[15-7]\\d|2[047]|89)\\d{4}", , , , "30161234", , , [8]], , , [, , , , , , , , , [-1]]],
              HN: [, [, , "8\\d{10}|[237-9]\\d{7}", , , , , , , [8, 11]], [
                ,
                ,
                "2(?:2(?:0[0-59]|1[1-9]|[23]\\d|4[02-7]|5[57]|6[245]|7[0135689]|8[01346-9]|9[0-2])|4(?:0[578]|2[3-59]|3[13-9]|4[0-68]|5[1-3589])|5(?:0[2357-9]|1[1-356]|4[03-5]|5\\d|6[014-69]|7[04]|80)|6(?:[056]\\d|17|2[067]|3[047]|4[0-378]|[78][0-8]|9[01])|7(?:0[5-79]|6[46-9]|7[02-9]|8[034]|91)|8(?:79|8[0-357-9]|9[1-57-9]))\\d{4}",
                ,
                ,
                ,
                "22123456",
                ,
                ,
                [8]
              ], [, , "[37-9]\\d{7}", , , , "91234567", , , [8]], [, , "8002\\d{7}", , , , "80021234567", , , [11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "HN", 504, "00", , , , , , , , [[, "(\\d{4})(\\d{4})", "$1-$2", ["[237-9]"]], [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["8"]]], [[, "(\\d{4})(\\d{4})", "$1-$2", ["[237-9]"]]], [, , , , , , , , , [-1]], , , [, , "8002\\d{7}", , , , , , , [11]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              HR: [, [, , "[2-69]\\d{8}|80\\d{5,7}|[1-79]\\d{7}|6\\d{6}", , , , , , , [7, 8, 9], [6]], [
                ,
                ,
                "1\\d{7}|(?:2[0-3]|3[1-5]|4[02-47-9]|5[1-3])\\d{6,7}",
                ,
                ,
                ,
                "12345678",
                ,
                ,
                [8, 9],
                [6, 7]
              ], [, , "9(?:(?:0[1-9]|[12589]\\d)\\d\\d|7(?:[0679]\\d\\d|5(?:[01]\\d|44|55|77|9[5-79])))\\d{4}|98\\d{6}", , , , "921234567", , , [8, 9]], [, , "80\\d{5,7}", , , , "800123456"], [, , "6[01459]\\d{6}|6[01]\\d{5}", , , , "6001234", , , [7, 8]], [, , , , , , , , , [-1]], [, , "7[45]\\d{6}", , , , "74123456", , , [8]], [, , , , , , , , , [-1]], "HR", 385, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["6[01]"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["8"], "0$1"], [, "(\\d)(\\d{4})(\\d{3})", "$1 $2 $3", ["1"], "0$1"], [
                ,
                "(\\d{2})(\\d{3})(\\d{3,4})",
                "$1 $2 $3",
                ["6|7[245]"],
                "0$1"
              ], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-57]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "62\\d{6,7}|72\\d{6}", , , , "62123456", , , [8, 9]], , , [, , , , , , , , , [-1]]],
              HT: [, [, , "[2-589]\\d{7}", , , , , , , [8]], [, , "2(?:2\\d|5[1-5]|81|9[149])\\d{5}", , , , "22453300"], [, , "(?:[34]\\d|5[56])\\d{6}", , , , "34101234"], [, , "8\\d{7}", , , , "80012345"], [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "9(?:[67][0-4]|8[0-3589]|9\\d)\\d{5}", , , , "98901234"], "HT", 509, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[2-589]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              HU: [, [, , "[235-7]\\d{8}|[1-9]\\d{7}", , , , , , , [8, 9], [6, 7]], [, , "(?:1\\d|[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6[23689]|8[2-57-9]|9[2-69])\\d{6}", , , , "12345678", , , [8], [6, 7]], [, , "(?:[257]0|3[01])\\d{7}", , , , "201234567", , , [9]], [, , "(?:[48]0\\d|680[29])\\d{5}", , , , "80123456"], [
                ,
                ,
                "9[01]\\d{6}",
                ,
                ,
                ,
                "90123456",
                ,
                ,
                [8]
              ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "21\\d{7}", , , , "211234567", , , [9]], "HU", 36, "00", "06", , , "06", , , , [[, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "(06 $1)"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"], "(06 $1)"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "06 $1"]], , [, , , , , , , , , [-1]], , , [, , "(?:[48]0\\d|680[29])\\d{5}"], [, , "38\\d{7}", , , , "381234567", , , [9]], , , [, , , , , , , , , [-1]]],
              ID: [, [
                ,
                ,
                "00[1-9]\\d{9,14}|(?:[1-36]|8\\d{5})\\d{6}|00\\d{9}|[1-9]\\d{8,10}|[2-9]\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17],
                [5, 6]
              ], [
                ,
                ,
                "2[124]\\d{7,8}|619\\d{8}|2(?:1(?:14|500)|2\\d{3})\\d{3}|61\\d{5,8}|(?:2(?:[35][1-4]|6[0-8]|7[1-6]|8\\d|9[1-8])|3(?:1|[25][1-8]|3[1-68]|4[1-3]|6[1-3568]|7[0-469]|8\\d)|4(?:0[1-589]|1[01347-9]|2[0-36-8]|3[0-24-68]|43|5[1-378]|6[1-5]|7[134]|8[1245])|5(?:1[1-35-9]|2[25-8]|3[124-9]|4[1-3589]|5[1-46]|6[1-8])|6(?:[25]\\d|3[1-69]|4[1-6])|7(?:02|[125][1-9]|[36]\\d|4[1-8]|7[0-36-9])|9(?:0[12]|1[013-8]|2[0-479]|5[125-8]|6[23679]|7[159]|8[01346]))\\d{5,8}",
                ,
                ,
                ,
                "218350123",
                ,
                ,
                [7, 8, 9, 10, 11],
                [5, 6]
              ], [, , "8[1-35-9]\\d{7,10}", , , , "812345678", , , [9, 10, 11, 12]], [, , "00(?:1803\\d{5,11}|7803\\d{7})|(?:177\\d|800)\\d{5,7}", , , , "8001234567", , , [8, 9, 10, 11, 12, 13, 14, 15, 16, 17]], [, , "809\\d{7}", , , , "8091234567", , , [10]], [, , "804\\d{7}", , , , "8041234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "ID", 62, "00[89]", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["15"]], [, "(\\d{2})(\\d{5,9})", "$1 $2", ["2[124]|[36]1"], "(0$1)"], [, "(\\d{3})(\\d{5,7})", "$1 $2", ["800"], "0$1"], [
                ,
                "(\\d{3})(\\d{5,8})",
                "$1 $2",
                ["[2-79]"],
                "(0$1)"
              ], [, "(\\d{3})(\\d{3,4})(\\d{3})", "$1-$2-$3", ["8[1-35-9]"], "0$1"], [, "(\\d{3})(\\d{6,8})", "$1 $2", ["1"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["804"], "0$1"], [, "(\\d{3})(\\d)(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["80"], "0$1"], [, "(\\d{3})(\\d{4})(\\d{4,5})", "$1-$2-$3", ["8"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})(\\d{2,8})", "$1 $2 $3 $4", ["001"]], [, "(\\d{2})(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["0"]]], [[, "(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["15"]], [
                ,
                "(\\d{2})(\\d{5,9})",
                "$1 $2",
                ["2[124]|[36]1"],
                "(0$1)"
              ], [, "(\\d{3})(\\d{5,7})", "$1 $2", ["800"], "0$1"], [, "(\\d{3})(\\d{5,8})", "$1 $2", ["[2-79]"], "(0$1)"], [, "(\\d{3})(\\d{3,4})(\\d{3})", "$1-$2-$3", ["8[1-35-9]"], "0$1"], [, "(\\d{3})(\\d{6,8})", "$1 $2", ["1"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["804"], "0$1"], [, "(\\d{3})(\\d)(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["80"], "0$1"], [, "(\\d{3})(\\d{4})(\\d{4,5})", "$1-$2-$3", ["8"], "0$1"]], [, , , , , , , , , [-1]], , , [, , "001803\\d{5,11}|(?:007803\\d|8071)\\d{6}", , , , , , , [10, 11, 12, 13, 14, 15, 16, 17]], [
                ,
                ,
                "(?:1500|8071\\d{3})\\d{3}",
                ,
                ,
                ,
                "8071123456",
                ,
                ,
                [7, 10]
              ], , , [, , , , , , , , , [-1]]],
              IE: [, [, , "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}", , , , , , , [7, 8, 9, 10], [5, 6]], [, , "(?:1\\d|21)\\d{6,7}|(?:2[24-9]|4(?:0[24]|5\\d|7)|5(?:0[45]|1\\d|8)|6(?:1\\d|[237-9])|9(?:1\\d|[35-9]))\\d{5}|(?:23|4(?:[1-469]|8\\d)|5[23679]|6[4-6]|7[14]|9[04])\\d{7}", , , , "2212345", , , , [5, 6]], [, , "8(?:22|[35-9]\\d)\\d{6}", , , , "850123456", , , [9]], [, , "1800\\d{6}", , , , "1800123456", , , [10]], [
                ,
                ,
                "15(?:1[2-8]|[2-8]0|9[089])\\d{6}",
                ,
                ,
                ,
                "1520123456",
                ,
                ,
                [10]
              ], [, , "18[59]0\\d{6}", , , , "1850123456", , , [10]], [, , "700\\d{6}", , , , "700123456", , , [9]], [, , "76\\d{7}", , , , "761234567", , , [9]], "IE", 353, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{5})", "$1 $2", ["2[24-9]|47|58|6[237-9]|9[35-9]"], "(0$1)"], [, "(\\d{3})(\\d{5})", "$1 $2", ["[45]0"], "(0$1)"], [, "(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1"], "(0$1)"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2569]|4[1-69]|7[14]"], "(0$1)"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], [
                ,
                "(\\d{3})(\\d{3})(\\d{3})",
                "$1 $2 $3",
                ["81"],
                "(0$1)"
              ], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[78]"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["4"], "(0$1)"], [, "(\\d{2})(\\d)(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["8"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , "18[59]0\\d{6}", , , , , , , [10]], [, , "818\\d{6}", , , , "818123456", , , [9]], , , [, , "88210[1-9]\\d{4}|8(?:[35-79]5\\d\\d|8(?:[013-9]\\d\\d|2(?:[01][1-9]|[2-9]\\d)))\\d{5}", , , , "8551234567", , , [10]]],
              IL: [, [, , "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}", , , , , , , [
                7,
                8,
                9,
                10,
                11,
                12
              ]], [, , "153\\d{8,9}|29[1-9]\\d{5}|(?:2[0-8]|[3489]\\d)\\d{6}", , , , "21234567", , , [8, 11, 12], [7]], [, , "55(?:4(?:0[01]|10|5[0-7])|57[0-289])\\d{4}|5(?:(?:[0-2][02-9]|[36]\\d|[49][2-9]|8[3-7])\\d|5(?:01|2\\d|3[0-3]|4[34]|5[0-25689]|6[6-8]|7[0-267]|8[7-9]|9[1-9]))\\d{5}", , , , "502345678", , , [9]], [, , "1(?:255|80[019]\\d{3})\\d{3}", , , , "1800123456", , , [7, 10]], [, , "1212\\d{4}|1(?:200|9(?:0[0-2]|19))\\d{6}", , , , "1919123456", , , [8, 10]], [, , "1700\\d{6}", , , , "1700123456", , , [10]], [, , , , , , , , , [-1]], [
                ,
                ,
                "7(?:38(?:[05]\\d|8[018])|8(?:33|55|77|81)\\d)\\d{4}|7(?:18|2[23]|3[237]|47|6[258]|7\\d|82|9[2-9])\\d{6}",
                ,
                ,
                ,
                "771234567",
                ,
                ,
                [9]
              ], "IL", 972, "0(?:0|1[2-9])", "0", , , "0", , , , [[, "(\\d{4})(\\d{3})", "$1-$2", ["125"]], [, "(\\d{4})(\\d{2})(\\d{2})", "$1-$2-$3", ["121"]], [, "(\\d)(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-489]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{3})", "$1-$2-$3", ["12"]], [, "(\\d{4})(\\d{6})", "$1-$2", ["159"]], [, "(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3-$4", ["1[7-9]"]], [, "(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})", "$1-$2 $3-$4", ["15"]]], , [, , , , , , , , , [-1]], , , [
                ,
                ,
                "1700\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [10]
              ], [, , "1599\\d{6}", , , , "1599123456", , , [10]], , , [, , "151\\d{8,9}", , , , "15112340000", , , [11, 12]]],
              IM: [
                ,
                [, , "1624\\d{6}|(?:[3578]\\d|90)\\d{8}", , , , , , , [10], [6]],
                [, , "1624(?:230|[5-8]\\d\\d)\\d{3}", , , , "1624756789", , , , [6]],
                [, , "76245[06]\\d{4}|7(?:4576|[59]24\\d|624[0-4689])\\d{5}", , , , "7924123456"],
                [, , "808162\\d{4}", , , , "8081624567"],
                [, , "8(?:440[49]06|72299\\d)\\d{3}|(?:8(?:45|70)|90[0167])624\\d{4}", , , , "9016247890"],
                [, , , , , , , , , [-1]],
                [, , "70\\d{8}", , , , "7012345678"],
                [, , "56\\d{8}", , , , "5612345678"],
                "IM",
                44,
                "00",
                "0",
                ,
                ,
                "([25-8]\\d{5})$|0|180020",
                "1624$1",
                ,
                ,
                ,
                ,
                [, , , , , , , , , [-1]],
                ,
                "74576|(?:16|7[56])24",
                [, , , , , , , , , [-1]],
                [, , "3440[49]06\\d{3}|(?:3(?:08162|3\\d{4}|45624|7(?:0624|2299))|55\\d{4})\\d{4}", , , , "5512345678"],
                ,
                ,
                [, , , , , , , , , [-1]]
              ],
              IN: [, [, , "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}", , , , , , , [8, 9, 10, 11, 12, 13], [6, 7]], [
                ,
                ,
                "2717(?:[2-7]\\d|95)\\d{4}|(?:271[0-689]|782[0-6])[2-7]\\d{5}|(?:170[24]|2(?:(?:[02][2-79]|90)\\d|80[13468])|(?:3(?:23|80)|683|79[1-7])\\d|4(?:20[24]|72[2-8])|552[1-7])\\d{6}|(?:11|33|4[04]|80)[2-7]\\d{7}|(?:342|674|788)(?:[0189][2-7]|[2-7]\\d)\\d{5}|(?:1(?:2[0-249]|3[0-25]|4[145]|[59][14]|6[014]|7[1257]|8[01346])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568]|9[14])|3(?:26|4[13]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[014-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|2[14]|3[134]|4[47]|5[15]|[67]1)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91))[2-7]\\d{6}|(?:1(?:2[35-8]|3[346-9]|4[236-9]|[59][0235-9]|6[235-9]|7[34689]|8[257-9])|2(?:1[134689]|3[24-8]|4[2-8]|5[25689]|6[2-4679]|7[3-79]|8[2-479]|9[235-9])|3(?:01|1[79]|2[1245]|4[5-8]|5[125689]|6[235-7]|7[157-9]|8[2-46-8])|4(?:1[14578]|2[5689]|3[2-467]|5[4-7]|6[35]|73|8[2689]|9[2389])|5(?:[16][146-9]|2[14-8]|3[1346]|4[14-69]|5[46]|7[2-4]|8[2-8]|9[246])|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])|7(?:1[013-9]|2[0235-9]|3[2679]|4[1-35689]|5[2-46-9]|[67][02-9]|8[013-7]|9[089])|8(?:1[1357-9]|2[235-8]|3[03-57-9]|4[0-24-9]|5\\d|6[2457-9]|7[1-6]|8[1256]|9[2-4]))\\d[2-7]\\d{5}",
                ,
                ,
                ,
                "7410410123",
                ,
                ,
                [10],
                [6, 7, 8]
              ], [
                ,
                ,
                "(?:61279|7(?:887[02-9]|9(?:313|79[07-9]))|8(?:079[04-9]|(?:84|91)7[02-8]))\\d{5}|(?:6(?:12|[2-47]1|5[17]|6[13]|80)[0189]|7(?:1(?:2[0189]|9[0-5])|2(?:[14][017-9]|8[0-59])|3(?:2[5-8]|[34][017-9]|9[016-9])|4(?:1[015-9]|[29][89]|39|8[389])|5(?:[15][017-9]|2[04-9]|9[7-9])|6(?:0[0-47]|1[0-257-9]|2[0-4]|3[19]|5[4589])|70[0289]|88[089]|97[02-8])|8(?:0(?:6[67]|7[02-8])|70[017-9]|84[01489]|91[0-289]))\\d{6}|(?:7(?:31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[0189]\\d|7[02-8])\\d{5}|(?:6(?:[09]\\d|1[04679]|2[03689]|3[05-9]|4[0489]|50|6[069]|7[07]|8[7-9])|7(?:0\\d|2[0235-79]|3[05-8]|40|5[0346-8]|6[6-9]|7[1-9]|8[0-79]|9[089])|8(?:0[01589]|1[0-57-9]|2[235-9]|3[03-57-9]|[45]\\d|6[02457-9]|7[1-69]|8[0-25-9]|9[02-9])|9\\d\\d)\\d{7}|(?:6(?:(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|8[124-6])\\d|7(?:[235689]\\d|4[0189]))|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-5])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]|881))[0189]\\d{5}",
                ,
                ,
                ,
                "8123456789",
                ,
                ,
                [10]
              ], [, , "000800\\d{7}|1(?:600\\d{6}|80(?:0\\d{4,9}|3\\d{9}))", , , , "1800123456"], [, , "186[12]\\d{9}", , , , "1861123456789", , , [13]], [, , "1860\\d{7}", , , , "18603451234", , , [11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "IN", 91, "00", "0", , , "0", , , , [[, "(\\d{7})", "$1", ["575"]], [, "(\\d{8})", "$1", ["5(?:0|2[23]|3[03]|[67]1|88)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"], , , 1], [, "(\\d{4})(\\d{4,5})", "$1 $2", ["180", "1800"], , , 1], [
                ,
                "(\\d{3})(\\d{3})(\\d{4})",
                "$1 $2 $3",
                ["140"],
                ,
                ,
                1
              ], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["11|2[02]|33|4[04]|79[1-7]|80[2-46]", "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])", "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"], "0$1", , 1], [
                ,
                "(\\d{3})(\\d{3})(\\d{4})",
                "$1 $2 $3",
                [
                  "1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]",
                  "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]",
                  "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"
                ],
                "0$1",
                ,
                1
              ], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", [
                "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807",
                "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]",
                "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"
              ], "0$1", , 1], [, "(\\d{5})(\\d{5})", "$1 $2", ["[6-9]"], "0$1", , 1], [, "(\\d{4})(\\d{2,4})(\\d{4})", "$1 $2 $3", ["1(?:6|8[06])", "1(?:6|8[06]0)"], , , 1], [
                ,
                "(\\d{3})(\\d{3})(\\d{3})(\\d{4})",
                "$1 $2 $3 $4",
                ["0"]
              ], [, "(\\d{4})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["18"], , , 1]], [[, "(\\d{8})", "$1", ["5(?:0|2[23]|3[03]|[67]1|88)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"], , , 1], [, "(\\d{4})(\\d{4,5})", "$1 $2", ["180", "1800"], , , 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["140"], , , 1], [
                ,
                "(\\d{2})(\\d{4})(\\d{4})",
                "$1 $2 $3",
                ["11|2[02]|33|4[04]|79[1-7]|80[2-46]", "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])", "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"],
                "0$1",
                ,
                1
              ], [
                ,
                "(\\d{3})(\\d{3})(\\d{4})",
                "$1 $2 $3",
                [
                  "1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]",
                  "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]",
                  "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"
                ],
                "0$1",
                ,
                1
              ], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", [
                "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807",
                "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]",
                "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"
              ], "0$1", , 1], [, "(\\d{5})(\\d{5})", "$1 $2", ["[6-9]"], "0$1", , 1], [, "(\\d{4})(\\d{2,4})(\\d{4})", "$1 $2 $3", ["1(?:6|8[06])", "1(?:6|8[06]0)"], , , 1], [
                ,
                "(\\d{4})(\\d{3})(\\d{3})(\\d{3})",
                "$1 $2 $3 $4",
                ["18"],
                ,
                ,
                1
              ]], [, , , , , , , , , [-1]], , , [, , "1(?:600\\d{6}|800\\d{4,9})|(?:000800|18(?:03\\d\\d|6(?:0|[12]\\d\\d)))\\d{7}"], [, , "140\\d{7}", , , , "1409305260", , , [10]], , , [, , , , , , , , , [-1]]],
              IO: [, [, , "3\\d{6}", , , , , , , [7]], [, , "37\\d{5}", , , , "3709100"], [, , "38\\d{5}", , , , "3801234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "IO", 246, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["3"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              IQ: [, [
                ,
                ,
                "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}",
                ,
                ,
                ,
                ,
                ,
                ,
                [8, 9, 10],
                [6, 7]
              ], [, , "1\\d{7}|(?:2[13-5]|3[02367]|4[023]|5[03]|6[026])\\d{6,7}", , , , "12345678", , , [8, 9], [6, 7]], [, , "7[3-9]\\d{8}", , , , "7912345678", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "IQ", 964, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-6]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              IR: [
                ,
                [, , "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}", , , , , , , [4, 5, 6, 7, 10], [8]],
                [, , "(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])(?:[03-57]\\d{7}|[16]\\d{3}(?:\\d{4})?|[289]\\d{3}(?:\\d(?:\\d{3})?)?)|94(?:000[09]|(?:12\\d|30[0-2])\\d|2(?:121|[2689]0\\d)|4(?:111|40\\d))\\d{4}", , , , "2123456789", , , [6, 7, 10], [4, 5, 8]],
                [, , "9(?:(?:0[0-5]|[13]\\d|2[0-3])\\d\\d|9(?:[0-46]\\d\\d|5(?:10|5\\d)|8(?:[12]\\d|88)|9(?:0[0-3]|[19]\\d|21|69|77|8[7-9])))\\d{5}", , , , "9123456789", , , [10]],
                [, , , , , , , , , [-1]],
                [
                  ,
                  ,
                  ,
                  ,
                  ,
                  ,
                  ,
                  ,
                  ,
                  [-1]
                ],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                "IR",
                98,
                "00",
                "0",
                ,
                ,
                "0",
                ,
                ,
                ,
                [[, "(\\d{4,5})", "$1", ["96"], "0$1"], [, "(\\d{2})(\\d{4,5})", "$1 $2", ["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[1-8]"], "0$1"]],
                ,
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , "9(?:4440\\d{5}|6(?:0[12]|2[16-8]|3(?:08|[14]5|[23]|66)|4(?:0|80)|5[01]|6[89]|86|9[19]))", , , , , , , [4, 5, 10]],
                [
                  ,
                  ,
                  "96(?:0[12]|2[16-8]|3(?:08|[14]5|[23]|66)|4(?:0|80)|5[01]|6[89]|86|9[19])",
                  ,
                  ,
                  ,
                  "9601",
                  ,
                  ,
                  [4, 5]
                ],
                ,
                ,
                [, , , , , , , , , [-1]]
              ],
              IS: [, [, , "(?:38\\d|[4-9])\\d{6}", , , , , , , [7, 9]], [, , "(?:4(?:1[0-24-69]|2[0-7]|[37][0-8]|4[0-24589]|5[0-68]|6\\d|8[0-36-8])|5(?:05|[156]\\d|2[02578]|3[0-579]|4[03-7]|7[0-2578]|8[0-35-9]|9[013-689])|872)\\d{4}", , , , "4101234", , , [7]], [, , "(?:38[589]\\d\\d|6(?:1[1-8]|2[0-6]|3[026-9]|4[014679]|5[0159]|6[0-69]|70|8[06-8]|9\\d)|7(?:5[057]|[6-9]\\d)|8(?:2[0-59]|[3-69]\\d|8[238]))\\d{4}", , , , "6111234"], [, , "80[0-8]\\d{4}", , , , "8001234", , , [7]], [
                ,
                ,
                "90(?:0\\d|1[5-79]|2[015-79]|3[135-79]|4[125-7]|5[25-79]|7[1-37]|8[0-35-7])\\d{3}",
                ,
                ,
                ,
                "9001234",
                ,
                ,
                [7]
              ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "49[0-24-79]\\d{4}", , , , "4921234", , , [7]], "IS", 354, "00|1(?:0(?:01|[12]0)|100)", , , , , , "00", , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[4-9]"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["3"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "809\\d{4}", , , , "8091234", , , [7]], , , [, , "(?:689|8(?:7[18]|80)|95[48])\\d{4}", , , , "6891234", , , [7]]],
              IT: [, [, , "0\\d{5,11}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:43|55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?", , , , , , , [6, 7, 8, 9, 10, 11, 12]], [
                ,
                ,
                "0(?:669[0-79]\\d{1,6}|831\\d{2,8})|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[2356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}",
                ,
                ,
                ,
                "0212345678"
              ], [, , "3[2-9]\\d{7,8}|(?:31|43)\\d{8}", , , , "3123456789", , , [9, 10]], [, , "80(?:0\\d{3}|3)\\d{3}", , , , "800123456", , , [6, 9]], [, , "(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}", , , , "899123456", , , [6, 8, 9, 10]], [, , "84(?:[08]\\d{3}|[17])\\d{3}", , , , "848123456", , , [6, 9]], [, , "1(?:78\\d|99)\\d{6}", , , , "1781234567", , , [9, 10]], [, , "55\\d{8}", , , , "5512345678", , , [10]], "IT", 39, "00", , , , , , , , [
                [, "(\\d{4,5})", "$1", ["1(?:0|9[246])", "1(?:0|9(?:2[2-9]|[46]))"]],
                [, "(\\d{6})", "$1", ["1(?:1|92)"]],
                [, "(\\d{2})(\\d{4,6})", "$1 $2", ["0[26]"]],
                [, "(\\d{3})(\\d{3,6})", "$1 $2", ["0[13-57-9][0159]|8(?:03|4[17]|9[2-5])", "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"]],
                [, "(\\d{4})(\\d{2,6})", "$1 $2", ["0(?:[13-579][2-46-8]|8[236-8])"]],
                [, "(\\d{4})(\\d{4})", "$1 $2", ["894"]],
                [, "(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[26]|5"]],
                [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1(?:44|[679])|[378]|43"]],
                [, "(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[13-57-9][0159]|14"]],
                [, "(\\d{2})(\\d{4})(\\d{5})", "$1 $2 $3", ["0[26]"]],
                [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]],
                [, "(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["[03]"]]
              ], [[, "(\\d{2})(\\d{4,6})", "$1 $2", ["0[26]"]], [, "(\\d{3})(\\d{3,6})", "$1 $2", ["0[13-57-9][0159]|8(?:03|4[17]|9[2-5])", "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"]], [, "(\\d{4})(\\d{2,6})", "$1 $2", ["0(?:[13-579][2-46-8]|8[236-8])"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["894"]], [, "(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[26]|5"]], [
                ,
                "(\\d{3})(\\d{3})(\\d{3,4})",
                "$1 $2 $3",
                ["1(?:44|[679])|[378]|43"]
              ], [, "(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[13-57-9][0159]|14"]], [, "(\\d{2})(\\d{4})(\\d{5})", "$1 $2 $3", ["0[26]"]], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]], [, "(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["[03]"]]], [, , , , , , , , , [-1]], 1, , [, , "848\\d{6}", , , , , , , [9]], [, , , , , , , , , [-1]], , , [, , "3[2-8]\\d{9,10}", , , , "33101234501", , , [11, 12]]],
              JE: [, [, , "1534\\d{6}|(?:[3578]\\d|90)\\d{8}", , , , , , , [10], [6]], [, , "1534[0-24-8]\\d{5}", , , , "1534456789", , , , [6]], [
                ,
                ,
                "7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97\\d))\\d{5}",
                ,
                ,
                ,
                "7797712345"
              ], [, , "80(?:07(?:35|81)|8901)\\d{4}", , , , "8007354567"], [, , "(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}", , , , "9018105678"], [, , , , , , , , , [-1]], [, , "701511\\d{4}", , , , "7015115678"], [, , "56\\d{8}", , , , "5612345678"], "JE", 44, "00", "0", , , "([0-24-8]\\d{5})$|0|180020", "1534$1", , , , , [, , "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", , , , "7640123456"], , , [, , , , , , , , , [-1]], [
                ,
                ,
                "(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}",
                ,
                ,
                ,
                "5512345678"
              ], , , [, , , , , , , , , [-1]]],
              JM: [, [, , "(?:[58]\\d\\d|658|900)\\d{7}", , , , , , , [10], [7]], [, , "8766060\\d{3}|(?:658(?:2(?:[0-8]\\d|9[0-46-9])|[3-9]\\d\\d)|876(?:52[35]|6(?:0[1-3579]|1[0235-9]|[23]\\d|40|5[06]|6[2-589]|7[0-25-9]|8[04]|9[4-9])|7(?:0[2-689]|[1-6]\\d|8[056]|9[45])|9(?:0[1-8]|1[02378]|[2-8]\\d|9[2-468])))\\d{4}", , , , "8765230123", , , , [7]], [
                ,
                ,
                "(?:658295|876(?:2(?:0[1-9]|[13-9]\\d|2[013-9])|[348]\\d\\d|5(?:0[1-9]|[1-9]\\d)|6(?:4[89]|6[67])|7(?:0[07]|7\\d|8[1-47-9]|9[0-36-9])|9(?:[01]9|9[0579])))\\d{4}",
                ,
                ,
                ,
                "8762101234",
                ,
                ,
                ,
                [7]
              ], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "JM", 1, "011", "1", , , "1", , , , , , [, , , , , , , , , [-1]], , "658|876", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]],
              JO: [, [, , "(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}", , , , , , , [8, 9]], [
                ,
                ,
                "87(?:000|90[01])\\d{3}|(?:2(?:6(?:2[0-35-9]|3[0-578]|4[24-7]|5[0-24-8]|[6-8][023]|9[0-3])|7(?:0[1-79]|10|2[014-7]|3[0-689]|4[019]|5[0-3578]))|32(?:0[1-69]|1[1-35-7]|2[024-7]|3\\d|4[0-3]|[5-7][023])|53(?:0[0-3]|[13][023]|2[0-59]|49|5[0-35-9]|6[15]|7[45]|8[1-6]|9[0-36-9])|6(?:2(?:[05]0|22)|3(?:00|33)|4(?:0[0-25]|1[2-7]|2[0569]|[38][07-9]|4[025689]|6[0-589]|7\\d|9[0-2])|5(?:[01][056]|2[034]|3[0-57-9]|4[178]|5[0-69]|6[0-35-9]|7[1-379]|8[0-68]|9[0239]))|87(?:20|7[078]|99))\\d{4}",
                ,
                ,
                ,
                "62001234",
                ,
                ,
                [8]
              ], [, , "7(?:[78][0-25-9]|9\\d)\\d{6}", , , , "790123456", , , [9]], [, , "80\\d{6}", , , , "80012345", , , [8]], [, , "9\\d{7}", , , , "90012345", , , [8]], [, , "85\\d{6}", , , , "85012345", , , [8]], [, , "70\\d{7}", , , , "700123456", , , [9]], [, , , , , , , , , [-1]], "JO", 962, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2356]|87"], "(0$1)"], [, "(\\d{3})(\\d{5,6})", "$1 $2", ["[89]"], "0$1"], [, "(\\d{2})(\\d{7})", "$1 $2", ["70"], "0$1"], [, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], , [
                ,
                ,
                "74(?:66|77)\\d{5}",
                ,
                ,
                ,
                "746612345",
                ,
                ,
                [9]
              ], , , [, , , , , , , , , [-1]], [, , "8(?:10|8\\d)\\d{5}", , , , "88101234", , , [8]], , , [, , , , , , , , , [-1]]],
              JP: [
                ,
                [, , "00[1-9]\\d{6,14}|[25-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}", , , , , , , [8, 9, 10, 11, 12, 13, 14, 15, 16, 17]],
                [, , "(?:1(?:1[235-8]|2[3-6]|3[3-9]|4[2-6]|[58][2-8]|6[2-7]|7[2-9]|9[1-9])|(?:2[2-9]|[36][1-9])\\d|4(?:[2-578]\\d|6[02-8]|9[2-59])|5(?:[2-589]\\d|6[1-9]|7[2-8])|7(?:[25-9]\\d|3[4-9]|4[02-9])|8(?:[2679]\\d|3[2-9]|4[5-9]|5[1-9]|8[03-9])|9(?:[2-58]\\d|[679][1-9]))\\d{6}", , , , "312345678", , , [9]],
                [
                  ,
                  ,
                  "(?:601[0-4]0|[7-9]0[1-9]\\d\\d)\\d{5}",
                  ,
                  ,
                  ,
                  "9012345678",
                  ,
                  ,
                  [10]
                ],
                [, , "00777(?:[01]|5\\d)\\d\\d|(?:00(?:7778|882[1245])|(?:120|800\\d)\\d\\d)\\d{4}|00(?:37|66|78)\\d{6,13}", , , , "120123456"],
                [, , "990\\d{6}", , , , "990123456", , , [9]],
                [, , , , , , , , , [-1]],
                [, , "60\\d{7}", , , , "601234567", , , [9]],
                [, , "50[1-9]\\d{7}", , , , "5012345678", , , [10]],
                "JP",
                81,
                "010",
                "0",
                ,
                ,
                "(000[2569]\\d{4,6})$|(?:(?:003768)0?)|0",
                "$1",
                ,
                ,
                [[, "(\\d{4})(\\d{4})", "$1-$2", ["007", "0077", "00777", "00777[01]"]], [, "(\\d{8,10})", "$1", ["000"]], [
                  ,
                  "(\\d{3})(\\d{3})(\\d{3})",
                  "$1-$2-$3",
                  ["(?:12|57|99)0"],
                  "0$1"
                ], [, "(\\d{4})(\\d)(\\d{4})", "$1-$2-$3", ["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"], "0$1"], [
                  ,
                  "(\\d{2})(\\d{3})(\\d{4})",
                  "$1-$2-$3",
                  ["60"],
                  "0$1"
                ], [, "(\\d)(\\d{4})(\\d{4})", "$1-$2-$3", ["3|4(?:2[09]|7[01])|6[1-9]", "3|4(?:2(?:0|9[02-69])|7(?:0[019]|1))|6[1-9]"], "0$1"], [
                  ,
                  "(\\d{2})(\\d{3})(\\d{4})",
                  "$1-$2-$3",
                  [
                    "1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])",
                    "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]",
                    "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"
                  ],
                  "0$1"
                ], [, "(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3", ["[14]|[289][2-9]|5[3-9]|7[2-4679]"], "0$1"], [, "(\\d{4})(\\d{2})(\\d{3,4})", "$1-$2-$3", ["007", "0077"]], [, "(\\d{4})(\\d{2})(\\d{4})", "$1-$2-$3", ["008"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["800"], "0$1"], [, "(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[25-9]"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{3,4})", "$1-$2-$3", ["0"]], [, "(\\d{4})(\\d{4})(\\d{4,5})", "$1-$2-$3", ["0"]], [, "(\\d{4})(\\d{5})(\\d{5,6})", "$1-$2-$3", ["0"]], [, "(\\d{4})(\\d{6})(\\d{6,7})", "$1-$2-$3", ["0"]]],
                [[, "(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3", ["(?:12|57|99)0"], "0$1"], [
                  ,
                  "(\\d{4})(\\d)(\\d{4})",
                  "$1-$2-$3",
                  ["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"],
                  "0$1"
                ], [, "(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60"], "0$1"], [, "(\\d)(\\d{4})(\\d{4})", "$1-$2-$3", ["3|4(?:2[09]|7[01])|6[1-9]", "3|4(?:2(?:0|9[02-69])|7(?:0[019]|1))|6[1-9]"], "0$1"], [
                  ,
                  "(\\d{2})(\\d{3})(\\d{4})",
                  "$1-$2-$3",
                  [
                    "1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])",
                    "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]",
                    "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"
                  ],
                  "0$1"
                ], [, "(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3", ["[14]|[289][2-9]|5[3-9]|7[2-4679]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["800"], "0$1"], [, "(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[25-9]"], "0$1"]],
                [, , "20\\d{8}", , , , "2012345678", , , [10]],
                ,
                ,
                [, , "00(?:777(?:[01]|(?:5|8\\d)\\d)|882[1245]\\d\\d)\\d\\d|00(?:37|66|78)\\d{6,13}"],
                [, , "570\\d{6}", , , , "570123456", , , [9]],
                ,
                ,
                [, , , , , , , , , [-1]]
              ],
              KE: [, [, , "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}", , , , , , , [7, 8, 9, 10]], [
                ,
                ,
                "(?:4[245]|5[1-79]|6[01457-9])\\d{5,7}|(?:4[136]|5[08]|62)\\d{7}|(?:[24]0|66)\\d{6,7}",
                ,
                ,
                ,
                "202012345",
                ,
                ,
                [7, 8, 9]
              ], [, , "(?:1(?:0[0-8]|1[0-7]|2[014]|30)|7\\d\\d)\\d{6}", , , , "712123456", , , [9]], [, , "800[02-8]\\d{5,6}", , , , "800223456", , , [9, 10]], [, , "900[02-9]\\d{5}", , , , "900223456", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "KE", 254, "000", "0", , , "0", , , , [[, "(\\d{2})(\\d{5,7})", "$1 $2", ["[24-6]"], "0$1"], [, "(\\d{3})(\\d{6})", "$1 $2", ["[17]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              KG: [, [
                ,
                ,
                "8\\d{9}|[235-9]\\d{8}",
                ,
                ,
                ,
                ,
                ,
                ,
                [9, 10],
                [5, 6]
              ], [, , "312(?:5[0-79]\\d|9(?:[0-689]\\d|7[0-24-9]))\\d{3}|(?:3(?:1(?:2[0-46-8]|3[1-9]|47|[56]\\d)|2(?:22|3[0-479]|6[0-7])|4(?:22|5[6-9]|6\\d)|5(?:22|3[4-7]|59|6\\d)|6(?:22|5[35-7]|6\\d)|7(?:22|3[468]|4[1-9]|59|[67]\\d)|9(?:22|4[1-8]|6\\d))|6(?:09|12|2[2-4])\\d)\\d{5}", , , , "312123456", , , [9], [5, 6]], [, , "312(?:58\\d|973)\\d{3}|(?:2(?:0[0-35]|2\\d)|5[0-24-7]\\d|600|7(?:[07]\\d|55)|88[08]|9(?:12|9[05-9]))\\d{6}", , , , "700123456", , , [9]], [, , "800\\d{6,7}", , , , "800123456"], [, , , , , , , , , [-1]], [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "KG", 996, "00", "0", , , "0", , , , [[, "(\\d{4})(\\d{5})", "$1 $2", ["3(?:1[346]|[24-79])"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-79]|88"], "0$1"], [, "(\\d{3})(\\d{3})(\\d)(\\d{2,3})", "$1 $2 $3 $4", ["8"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              KH: [
                ,
                [, , "1\\d{9}|[1-9]\\d{7,8}", , , , , , , [8, 9, 10], [6, 7]],
                [
                  ,
                  ,
                  "23(?:4(?:[2-4]|[56]\\d)|[568]\\d\\d)\\d{4}|23[236-9]\\d{5}|(?:2[4-6]|3[2-6]|4[2-4]|[5-7][2-5])(?:(?:[237-9]|4[56]|5\\d)\\d{5}|6\\d{5,6})",
                  ,
                  ,
                  ,
                  "23756789",
                  ,
                  ,
                  [8, 9],
                  [6, 7]
                ],
                [, , "(?:(?:1[28]|3[18]|9[67])\\d|6[016-9]|7(?:[07-9]|[16]\\d)|8(?:[013-79]|8\\d))\\d{6}|(?:1\\d|9[0-57-9])\\d{6}|(?:2[3-6]|3[2-6]|4[2-4]|[5-7][2-5])48\\d{5}", , , , "91234567", , , [8, 9]],
                [, , "1800(?:1\\d|2[019])\\d{4}", , , , "1800123456", , , [10]],
                [, , "1900(?:1\\d|2[09])\\d{4}", , , , "1900123456", , , [10]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                "KH",
                855,
                "00[14-9]",
                "0",
                ,
                ,
                "0",
                ,
                ,
                ,
                [[, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-9]"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]],
                ,
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]]
              ],
              KI: [, [, , "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}", , , , , , , [5, 8]], [, , "(?:[24]\\d|3[1-9]|50|65(?:02[12]|12[56]|22[89]|[3-5]00)|7(?:27\\d\\d|3100|5(?:02[12]|12[56]|22[89]|[34](?:00|81)|500))|8[0-5])\\d{3}", , , , "31234"], [
                ,
                ,
                "(?:6200[01]|7(?:310[1-9]|5(?:02[03-9]|12[0-47-9]|22[0-7]|[34](?:0[1-9]|8[02-9])|50[1-9])))\\d{3}|(?:63\\d\\d|7(?:(?:[0146-9]\\d|2[0-689])\\d|3(?:[02-9]\\d|1[1-9])|5(?:[0-2][013-9]|[34][1-79]|5[1-9]|[6-9]\\d)))\\d{4}",
                ,
                ,
                ,
                "72001234",
                ,
                ,
                [8]
              ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "30(?:0[01]\\d\\d|12(?:11|20))\\d\\d", , , , "30010000", , , [8]], "KI", 686, "00", "0", , , "0", , , , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              KM: [, [, , "[3478]\\d{6}", , , , , , , [7], [4]], [, , "7[4-7]\\d{5}", , , , "7712345", , , , [4]], [, , "[34]\\d{6}", , , , "3212345"], [, , , , , , , , , [-1]], [, , "8\\d{6}", , , , "8001234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "KM", 269, "00", , , , , , , , [[
                ,
                "(\\d{3})(\\d{2})(\\d{2})",
                "$1 $2 $3",
                ["[3478]"]
              ]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              KN: [, [, , "(?:[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]], [, , "869(?:2(?:29|36)|302|4(?:6[015-9]|70)|56[5-7])\\d{4}", , , , "8692361234", , , , [7]], [, , "869(?:48[89]|55[6-8]|66\\d|76[02-7])\\d{4}", , , , "8697652917", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [
                ,
                ,
                "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "5002345678"
              ], [, , , , , , , , , [-1]], "KN", 1, "011", "1", , , "([2-7]\\d{6})$|1", "869$1", , , , , [, , , , , , , , , [-1]], , "869", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              KP: [, [, , "85\\d{6}|(?:19\\d|[2-7])\\d{7}", , , , , , , [8, 10], [6, 7]], [, , "(?:(?:195|2)\\d|3[19]|4[159]|5[37]|6[17]|7[39]|85)\\d{6}", , , , "21234567", , , , [6, 7]], [, , "19[1-3]\\d{7}", , , , "1921234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "KP", 850, "00|99", "0", , , "0", , , , [[
                ,
                "(\\d{2})(\\d{3})(\\d{3})",
                "$1 $2 $3",
                ["8"],
                "0$1"
              ], [, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , "238[02-9]\\d{4}|2(?:[0-24-9]\\d|3[0-79])\\d{5}", , , , , , , [8]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              KR: [, [, , "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}", , , , , , , [5, 6, 8, 9, 10, 11, 12, 13, 14], [3, 4, 7]], [
                ,
                ,
                "(?:2|3[1-3]|[46][1-4]|5[1-5])[1-9]\\d{6,7}|(?:3[1-3]|[46][1-4]|5[1-5])1\\d{2,3}",
                ,
                ,
                ,
                "22123456",
                ,
                ,
                [5, 6, 8, 9, 10],
                [3, 4, 7]
              ], [, , "1(?:05(?:[0-8]\\d|9[0-6])|22[13]\\d)\\d{4,5}|1(?:0[0-46-9]|[16-9]\\d|2[013-9])\\d{6,7}", , , , "1020000000", , , [9, 10]], [, , "00(?:308\\d{6,7}|798\\d{7,9})|(?:00368|[38]0)\\d{7}", , , , "801234567", , , [9, 11, 12, 13, 14]], [, , "60[2-9]\\d{6}", , , , "602345678", , , [9]], [, , , , , , , , , [-1]], [, , "50\\d{8,9}", , , , "5012345678", , , [10, 11]], [, , "70\\d{8}", , , , "7012345678", , , [10]], "KR", 82, "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))", "0", , , "0(8(?:[1-46-8]|5\\d\\d))?", , , , [[
                ,
                "(\\d{5})",
                "$1",
                ["1[016-9]1", "1[016-9]11", "1[016-9]114"],
                "0$1"
              ], [, "(\\d{2})(\\d{3,4})", "$1-$2", ["(?:3[1-3]|[46][1-4]|5[1-5])1"], "0$1", "0$CC-$1"], [, "(\\d{4})(\\d{4})", "$1-$2", ["1"]], [, "(\\d)(\\d{3,4})(\\d{4})", "$1-$2-$3", ["2"], "0$1", "0$CC-$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[36]0|8"], "0$1", "0$CC-$1"], [, "(\\d{2})(\\d{3,4})(\\d{4})", "$1-$2-$3", ["[1346]|5[1-5]"], "0$1", "0$CC-$1"], [, "(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1", "0$CC-$1"], [, "(\\d{5})(\\d{3})(\\d{3})", "$1 $2 $3", ["003", "0030"]], [
                ,
                "(\\d{2})(\\d{5})(\\d{4})",
                "$1-$2-$3",
                ["5"],
                "0$1",
                "0$CC-$1"
              ], [, "(\\d{5})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0"]], [, "(\\d{5})(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["0"]]], [
                [, "(\\d{2})(\\d{3,4})", "$1-$2", ["(?:3[1-3]|[46][1-4]|5[1-5])1"], "0$1", "0$CC-$1"],
                [, "(\\d{4})(\\d{4})", "$1-$2", ["1"]],
                [, "(\\d)(\\d{3,4})(\\d{4})", "$1-$2-$3", ["2"], "0$1", "0$CC-$1"],
                [, "(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[36]0|8"], "0$1", "0$CC-$1"],
                [, "(\\d{2})(\\d{3,4})(\\d{4})", "$1-$2-$3", ["[1346]|5[1-5]"], "0$1", "0$CC-$1"],
                [, "(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1", "0$CC-$1"],
                [, "(\\d{2})(\\d{5})(\\d{4})", "$1-$2-$3", ["5"], "0$1", "0$CC-$1"]
              ], [, , "15\\d{7,8}", , , , "1523456789", , , [9, 10]], , , [, , "00(?:3(?:08\\d{6,7}|68\\d{7})|798\\d{7,9})", , , , , , , [11, 12, 13, 14]], [, , "1(?:5(?:22|33|44|66|77|88|99)|6(?:[07]0|44|6[0168]|88)|8(?:00|33|55|77|99))\\d{4}", , , , "15441234", , , [8]], , , [, , , , , , , , , [-1]]],
              KW: [, [, , "18\\d{5}|(?:[2569]\\d|41)\\d{6}", , , , , , , [7, 8]], [, , "2(?:[23]\\d\\d|4(?:[1-35-9]\\d|44)|5(?:0[034]|[2-46]\\d|5[1-3]|7[1-7]))\\d{4}", , , , "22345678", , , [8]], [
                ,
                ,
                "(?:41\\d\\d|5(?:(?:[05]\\d|1[0-7]|6[56])\\d|2(?:22|5[25])|7(?:55|77)|88[58])|6(?:(?:0[034679]|5[015-9]|6\\d)\\d|1(?:00|11|6[16])|2[26]2|3[36]3|4[46]4|7(?:0[013-9]|[67]\\d)|8[68]8|9(?:[069]\\d|3[039]))|9(?:(?:[04679]\\d|8[057-9])\\d|1(?:00|1[01]|99)|2(?:00|2\\d)|3(?:00|3[03])|5(?:00|5\\d)))\\d{4}",
                ,
                ,
                ,
                "50012345",
                ,
                ,
                [8]
              ], [, , "18\\d{5}", , , , "1801234", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "KW", 965, "00", , , , , , , , [[, "(\\d{4})(\\d{3,4})", "$1 $2", ["[169]|2(?:[235]|4[1-35-9])|52"]], [, "(\\d{3})(\\d{5})", "$1 $2", ["[245]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              KY: [, [, , "(?:345|[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]], [
                ,
                ,
                "345(?:2(?:22|3[23]|44|66)|333|444|6(?:23|38|40)|7(?:30|4[35-79]|6[6-9]|77)|8(?:00|1[45]|4[89]|88)|9(?:14|4[035-9]))\\d{4}",
                ,
                ,
                ,
                "3452221234",
                ,
                ,
                ,
                [7]
              ], [, , "345(?:32[1-9]|42[0-4]|5(?:1[67]|2[5-79]|4[6-9]|50|76)|649|82[56]|9(?:1[679]|2[2-9]|3[06-9]|90))\\d{4}", , , , "3453231234", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002345678"], [, , "(?:345976|900[2-9]\\d\\d)\\d{4}", , , , "9002345678"], [, , , , , , , , , [-1]], [
                ,
                ,
                "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "5002345678"
              ], [, , , , , , , , , [-1]], "KY", 1, "011", "1", , , "([2-9]\\d{6})$|1", "345$1", , , , , [, , , , , , , , , [-1]], , "345", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              KZ: [, [, , "(?:33622|8\\d{8})\\d{5}|[78]\\d{9}", , , , , , , [10, 14], [5, 6, 7]], [
                ,
                ,
                "(?:33622|7(?:1(?:0(?:[23]\\d|4[0-3]|59|63)|1(?:[23]\\d|4[0-79]|59)|2(?:[23]\\d|59)|3(?:2\\d|3[0-79]|4[0-35-9]|59)|4(?:[24]\\d|3[013-9]|5[1-9]|97)|5(?:2\\d|3[1-9]|4[0-7]|59)|6(?:[2-4]\\d|5[19]|61)|72\\d|8(?:[27]\\d|3[1-46-9]|4[0-5]|59))|2(?:1(?:[23]\\d|4[46-9]|5[3469])|2(?:2\\d|3[0679]|46|5[12679])|3(?:[2-4]\\d|5[139])|4(?:2\\d|3[1-35-9]|59)|5(?:[23]\\d|4[0-8]|59|61)|6(?:2\\d|3[1-9]|4[0-4]|59)|7(?:[2379]\\d|40|5[279])|8(?:[23]\\d|4[0-3]|59)|9(?:2\\d|3[124578]|59))))\\d{5}",
                ,
                ,
                ,
                "7123456789",
                ,
                ,
                [10],
                [5, 6, 7]
              ], [, , "7(?:0[0-25-8]|47|6[0-4]|7[15-8]|85)\\d{7}", , , , "7710009998", , , [10]], [, , "8(?:00|108\\d{3})\\d{7}", , , , "8001234567"], [, , "809\\d{7}", , , , "8091234567", , , [10]], [, , , , , , , , , [-1]], [, , "808\\d{7}", , , , "8081234567", , , [10]], [, , "751\\d{7}", , , , "7511234567", , , [10]], "KZ", 7, "810", "8", , , "8", , "8~10", , , , [, , , , , , , , , [-1]], , "33622|7", [, , "751\\d{7}", , , , , , , [10]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              LA: [, [, , "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}", , , , , , , [8, 9, 10], [6]], [
                ,
                ,
                "(?:2[13]|[35-7][14]|41|8[1468])\\d{6}",
                ,
                ,
                ,
                "21212862",
                ,
                ,
                [8],
                [6]
              ], [, , "(?:20(?:[23579]\\d|8[78])|30[24]\\d)\\d{6}|30\\d{7}", , , , "2023123456", , , [9, 10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "LA", 856, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2[13]|3[14]|[4-8]"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["3"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[23]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              LB: [, [
                ,
                ,
                "[27-9]\\d{7}|[13-9]\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [7, 8]
              ], [, , "7(?:62|8[0-6]|9[04-9])\\d{4}|(?:[14-69]\\d|2(?:[14-69]\\d|[78][1-9])|7[2-57]|8[02-9])\\d{5}", , , , "1123456"], [, , "(?:(?:3|81)\\d|7(?:[01]\\d|6[013-9]|8[7-9]|9[1-3]))\\d{5}", , , , "71123456"], [, , , , , , , , , [-1]], [, , "9[01]\\d{6}", , , , "90123456", , , [8]], [, , "80\\d{6}", , , , "80123456", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "LB", 961, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[13-69]|7(?:[2-57]|62|8[0-6]|9[04-9])|8[02-9]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27-9]"]]], , [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              LC: [, [, , "(?:[58]\\d\\d|758|900)\\d{7}", , , , , , , [10], [7]], [, , "758(?:234|4(?:30|5\\d|6[2-9]|8[0-2])|57[0-2]|(?:63|75)8)\\d{4}", , , , "7584305678", , , , [7]], [, , "758(?:28[4-7]|384|4(?:6[01]|8[4-9])|5(?:1[89]|20|84)|7(?:1[2-9]|2\\d|3[0-3])|812)\\d{4}", , , , "7582845678", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [
                ,
                ,
                "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "5002345678"
              ], [, , , , , , , , , [-1]], "LC", 1, "011", "1", , , "([2-8]\\d{6})$|1", "758$1", , , , , [, , , , , , , , , [-1]], , "758", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              LI: [, [, , "[68]\\d{8}|(?:[2378]\\d|90)\\d{5}", , , , , , , [7, 9]], [, , "(?:2(?:01|1[27]|2[024]|3\\d|6[02-578]|96)|3(?:[24]0|33|7[0135-7]|8[048]|9[0269]))\\d{4}", , , , "2345678", , , [7]], [, , "(?:6(?:(?:4[5-9]|5\\d)\\d|6(?:[024-6]\\d|[17]0|3[7-9]))\\d|7(?:[37-9]\\d|42|56))\\d{4}", , , , "660234567"], [, , "8002[28]\\d\\d|80(?:05\\d|9)\\d{4}", , , , "8002222"], [
                ,
                ,
                "90(?:02[258]|1(?:23|3[14])|66[136])\\d\\d",
                ,
                ,
                ,
                "9002222",
                ,
                ,
                [7]
              ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "LI", 423, "00", "0", , , "(1001)|0", , , , [[, "(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2379]|8(?:0[09]|7)", "[2379]|8(?:0(?:02|9)|7)"], , "$CC $1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["69"], , "$CC $1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"], , "$CC $1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "870(?:28|87)\\d\\d", , , , "8702812", , , [7]], , , [, , "697(?:42|56|[78]\\d)\\d{4}", , , , "697861234", , , [9]]],
              LK: [
                ,
                [, , "[1-9]\\d{8}", , , , , , , [9], [7]],
                [, , "(?:12[2-9]|602|8[12]\\d|9(?:1\\d|22|9[245]))\\d{6}|(?:11|2[13-7]|3[1-8]|4[157]|5[12457]|6[35-7])[2-57]\\d{6}", , , , "112345678", , , , [7]],
                [, , "7(?:[0-25-8]\\d|4[0-4])\\d{6}", , , , "712345678"],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                "LK",
                94,
                "00",
                "0",
                ,
                ,
                "0",
                ,
                ,
                ,
                [[, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[1-689]"], "0$1"]],
                ,
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]],
                [, , "1973\\d{5}", , , , "197312345"],
                ,
                ,
                [, , , , , , , , , [-1]]
              ],
              LR: [, [, , "(?:[2457]\\d|33|88)\\d{7}|(?:2\\d|[4-6])\\d{6}", , , , , , , [7, 8, 9]], [, , "2\\d{7}", , , , "21234567", , , [8]], [, , "(?:(?:(?:22|33)0|555|7(?:6[01]|7\\d)|88\\d)\\d|4(?:240|[67]))\\d{5}|[56]\\d{6}", , , , "770123456", , , [7, 9]], [, , , , , , , , , [-1]], [, , "332(?:02|[34]\\d)\\d{4}", , , , "332021234", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "LR", 231, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["4[67]|[56]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], [
                ,
                "(\\d{2})(\\d{3})(\\d{4})",
                "$1 $2 $3",
                ["[2-578]"],
                "0$1"
              ]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              LS: [, [, , "(?:[256]\\d\\d|800)\\d{5}", , , , , , , [8]], [, , "2\\d{7}", , , , "22123456"], [, , "[56]\\d{7}", , , , "50123456"], [, , "800[1256]\\d{4}", , , , "80021234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "LS", 266, "00", , , , , , , , [[, "(\\d{4})(\\d{4})", "$1 $2", ["[2568]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              LT: [
                ,
                [, , "(?:[3469]\\d|52|[78]0)\\d{6}", , , , , , , [8]],
                [
                  ,
                  ,
                  "(?:3[1478]|4[124-6]|52)\\d{6}",
                  ,
                  ,
                  ,
                  "31234567"
                ],
                [, , "6\\d{7}", , , , "61234567"],
                [, , "80[02]\\d{5}", , , , "80012345"],
                [, , "9(?:0[0239]|10)\\d{5}", , , , "90012345"],
                [, , "808\\d{5}", , , , "80812345"],
                [, , "70[05]\\d{5}", , , , "70012345"],
                [, , "[89]01\\d{5}", , , , "80123456"],
                "LT",
                370,
                "00",
                "0",
                ,
                ,
                "[08]",
                ,
                ,
                ,
                [[, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["52[0-7]"], "(0-$1)", , 1], [, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0 $1", , 1], [, "(\\d{2})(\\d{6})", "$1 $2", ["37|4(?:[15]|6[1-8])"], "(0-$1)", , 1], [, "(\\d{3})(\\d{5})", "$1 $2", ["[3-6]"], "(0-$1)", , 1]],
                ,
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]],
                [, , "70[67]\\d{5}", , , , "70712345"],
                ,
                ,
                [, , , , , , , , , [-1]]
              ],
              LU: [, [, , "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}", , , , , , , [4, 5, 6, 7, 8, 9, 10, 11]], [, , "(?:35[013-9]|80[2-9]|90[89])\\d{1,8}|(?:2[2-9]|3[0-46-9]|[457]\\d|8[13-9]|9[2-579])\\d{2,9}", , , , "27123456"], [, , "6(?:[269][18]|5[1568]|7[189]|81)\\d{6}", , , , "628123456", , , [9]], [, , "800\\d{5}", , , , "80012345", , , [8]], [, , "90[015]\\d{5}", , , , "90012345", , , [8]], [, , "801\\d{5}", , , , "80112345", , , [8]], [, , , , , , , , , [-1]], [
                ,
                ,
                "20(?:1\\d{5}|[2-689]\\d{1,7})",
                ,
                ,
                ,
                "20201234",
                ,
                ,
                [4, 5, 6, 7, 8, 9, 10]
              ], "LU", 352, "00", , , , "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)", , , , [[, "(\\d{2})(\\d{3})", "$1 $2", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"], , "$CC $1"], [, "(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"], , "$CC $1"], [, "(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["20[2-689]"], , "$CC $1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4", ["2(?:[0367]|4[3-8])"], , "$CC $1"], [
                ,
                "(\\d{3})(\\d{2})(\\d{3})",
                "$1 $2 $3",
                ["80[01]|90[015]"],
                ,
                "$CC $1"
              ], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["20"], , "$CC $1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"], , "$CC $1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4 $5", ["2(?:[0367]|4[3-8])"], , "$CC $1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})", "$1 $2 $3 $4", ["[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"], , "$CC $1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              LV: [, [, , "(?:[268]\\d|78|90)\\d{6}", , , , , , , [8]], [
                ,
                ,
                "6\\d{7}",
                ,
                ,
                ,
                "63123456"
              ], [, , "2333[0-8]\\d{3}|2(?:[0-24-9]\\d\\d|3(?:0[07]|[14-9]\\d|2[02-9]|3[0-24-9]))\\d{4}", , , , "21234567"], [, , "80\\d{6}", , , , "80123456"], [, , "90\\d{6}", , , , "90123456"], [, , "81\\d{6}", , , , "81123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "LV", 371, "00", , , , , , , , [[, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2679]|8[01]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              LY: [, [, , "[2-9]\\d{8}", , , , , , , [9], [7]], [
                ,
                ,
                "(?:2(?:0[56]|[1-6]\\d|7[124579]|8[124])|3(?:1\\d|2[2356])|4(?:[17]\\d|2[1-357]|5[2-4]|8[124])|5(?:[1347]\\d|2[1-469]|5[13-5]|8[1-4])|6(?:[1-479]\\d|5[2-57]|8[1-5])|7(?:[13]\\d|2[13-79])|8(?:[124]\\d|5[124]|84))\\d{6}",
                ,
                ,
                ,
                "212345678",
                ,
                ,
                ,
                [7]
              ], [, , "9[1-6]\\d{7}", , , , "912345678"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "LY", 218, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{7})", "$1-$2", ["[2-9]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              MA: [, [, , "[5-8]\\d{8}", , , , , , , [9]], [, , "5(?:2(?:[0-25-79]\\d|3[1-578]|4[02-46-8]|8[0235-7])|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[014-9]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}", , , , "520123456"], [
                ,
                ,
                "(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-8]|5[0-5]|8[0-7]))\\d{6}",
                ,
                ,
                ,
                "650123456"
              ], [, , "80[0-7]\\d{6}", , , , "801234567"], [, , "89\\d{7}", , , , "891234567"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}", , , , "592401234"], "MA", 212, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5[45]"], "0$1"], [, "(\\d{4})(\\d{5})", "$1-$2", ["5(?:2[2-46-9]|3[3-9]|9)|8(?:0[89]|92)"], "0$1"], [, "(\\d{2})(\\d{7})", "$1-$2", ["8"], "0$1"], [, "(\\d{3})(\\d{6})", "$1-$2", ["[5-7]"], "0$1"]], , [, , , , , , , , , [-1]], 1, , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]],
              MC: [, [, , "(?:[3489]|6\\d)\\d{7}", , , , , , , [8, 9]], [, , "(?:870|9[2-47-9]\\d)\\d{5}", , , , "99123456", , , [8]], [, , "4(?:[469]\\d|5[1-9])\\d{5}|(?:3|6\\d)\\d{7}", , , , "612345678"], [, , "(?:800|90\\d)\\d{5}", , , , "90123456", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "MC", 377, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["87"]], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["4"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[389]"]], [
                ,
                "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                "$1 $2 $3 $4 $5",
                ["6"],
                "0$1"
              ]], [[, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["4"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[389]"]], [, "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["6"], "0$1"]], [, , , , , , , , , [-1]], , , [, , "8[07]0\\d{5}", , , , , , , [8]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              MD: [, [, , "(?:[235-7]\\d|[89]0)\\d{6}", , , , , , , [8]], [, , "(?:(?:2[1-9]|3[1-79])\\d|5(?:33|5[257]))\\d{5}", , , , "22212345"], [, , "562\\d{5}|(?:6\\d|7[16-9])\\d{6}", , , , "62112345"], [, , "800\\d{5}", , , , "80012345"], [
                ,
                ,
                "90[056]\\d{5}",
                ,
                ,
                ,
                "90012345"
              ], [, , "808\\d{5}", , , , "80812345"], [, , , , , , , , , [-1]], [, , "3[08]\\d{6}", , , , "30123456"], "MD", 373, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["22|3"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[25-7]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "803\\d{5}", , , , "80312345"], , , [, , , , , , , , , [-1]]],
              ME: [, [, , "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}", , , , , , , [8, 9], [6]], [
                ,
                ,
                "(?:20[2-8]|3(?:[0-2][2-7]|3[24-7])|4(?:0[2-467]|1[2467])|5(?:0[2467]|1[24-7]|2[2-467]))\\d{5}",
                ,
                ,
                ,
                "30234567",
                ,
                ,
                [8],
                [6]
              ], [, , "6(?:[07-9]\\d|3[024]|6[0-25])\\d{5}", , , , "60123456", , , [8]], [, , "80(?:[0-2578]|9\\d)\\d{5}", , , , "80080002"], [, , "9(?:4[1568]|5[178])\\d{5}", , , , "94515151", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "78[1-49]\\d{5}", , , , "78108780", , , [8]], "ME", 382, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "77[1-9]\\d{5}", , , , "77273012", , , [8]], , , [, , , , , , , , , [-1]]],
              MF: [
                ,
                [, , "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}", , , , , , , [9]],
                [, , "590(?:0[079]|[14]3|[27][79]|3[03-7]|5[0-268]|87)\\d{4}", , , , "590271234"],
                [, , "(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}", , , , "690001234"],
                [, , "80[0-5]\\d{6}", , , , "800012345"],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , "9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}", , , , "976012345"],
                "MF",
                590,
                "00",
                "0",
                ,
                ,
                "0",
                ,
                ,
                ,
                ,
                ,
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]]
              ],
              MG: [, [, , "[23]\\d{8}", , , , , , , [9], [7]], [
                ,
                ,
                "2072[29]\\d{4}|20(?:2\\d|4[47]|5[3467]|6[279]|7[356]|8[268]|9[2457])\\d{5}",
                ,
                ,
                ,
                "202123456",
                ,
                ,
                ,
                [7]
              ], [, , "3[2-47-9]\\d{7}", , , , "321234567"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "22\\d{7}", , , , "221234567"], "MG", 261, "00", "0", , , "([24-9]\\d{6})$|0", "20$1", , , [[, "(\\d{2})(\\d{2})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["[23]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              MH: [
                ,
                [, , "329\\d{4}|(?:[256]\\d|45)\\d{5}", , , , , , , [7]],
                [, , "(?:247|528|625)\\d{4}", , , , "2471234"],
                [, , "(?:(?:23|54)5|329|45[35-8])\\d{4}", , , , "2351234"],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , "635\\d{4}", , , , "6351234"],
                "MH",
                692,
                "011",
                "1",
                ,
                ,
                "1",
                ,
                ,
                ,
                [[, "(\\d{3})(\\d{4})", "$1-$2", ["[2-6]"]]],
                ,
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]]
              ],
              MK: [, [, , "[2-578]\\d{7}", , , , , , , [8], [6, 7]], [, , "(?:(?:2(?:62|77)0|3444)\\d|4[56]440)\\d{3}|(?:34|4[357])700\\d{3}|(?:2(?:[0-3]\\d|5[0-578]|6[01]|82)|3(?:1[3-68]|[23][2-68]|4[23568])|4(?:[23][2-68]|4[3-68]|5[2568]|6[25-8]|7[24-68]|8[4-68]))\\d{5}", , , , "22012345", , , , [6, 7]], [
                ,
                ,
                "7(?:3555|(?:474|9[019]7)7)\\d{3}|7(?:[0-25-8]\\d\\d|3(?:[1-478]\\d|6[01])|4(?:2\\d|60|7[01578])|9(?:[2-4]\\d|5[01]|7[015]))\\d{4}",
                ,
                ,
                ,
                "72345678"
              ], [, , "800\\d{5}", , , , "80012345"], [, , "5\\d{7}", , , , "50012345"], [, , "8(?:0[1-9]|[1-9]\\d)\\d{5}", , , , "80123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "MK", 389, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2|34[47]|4(?:[37]7|5[47]|64)"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[347]"], "0$1"], [, "(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[58]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              ML: [, [, , "[24-9]\\d{7}", , , , , , , [8]], [
                ,
                ,
                "2(?:07[0-8]|12[67])\\d{4}|(?:2(?:02|1[4-689])|4(?:0[0-4]|4[1-59]))\\d{5}",
                ,
                ,
                ,
                "20212345"
              ], [, , "2(?:0(?:01|79)|17\\d)\\d{4}|(?:5[0-3]|[679]\\d|8[2-59])\\d{6}", , , , "65012345"], [, , "80\\d{6}", , , , "80012345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "ML", 223, "00", , , , , , , , [[, "(\\d{4})", "$1", ["67[057-9]|74[045]", "67(?:0[09]|[59]9|77|8[89])|74(?:0[02]|44|55)"]], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-9]"]]], [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-9]"]]], [, , , , , , , , , [-1]], , , [, , "80\\d{6}"], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              MM: [
                ,
                [, , "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}", , , , , , , [6, 7, 8, 9, 10], [5]],
                [
                  ,
                  ,
                  "(?:1(?:(?:12|[28]\\d|3[56]|7[3-6]|9[0-6])\\d|4(?:2[29]|7[0-2]|83)|6)|2(?:2(?:00|8[34])|4(?:0\\d|22|7[0-2]|83)|51\\d\\d)|4(?:2(?:2\\d\\d|48[013])|3(?:20\\d|4(?:70|83)|56)|420\\d|5(?:2\\d|470))|6(?:0(?:[23]|88\\d)|(?:124|[56]2\\d)\\d|2472|3(?:20\\d|470)|4(?:2[04]\\d|472)|7(?:3\\d\\d|4[67]0|8(?:[01459]\\d|8))))\\d{4}|5(?:2(?:2\\d{5,6}|47[02]\\d{4})|(?:3472|4(?:2(?:1|86)|470)|522\\d|6(?:20\\d|483)|7(?:20\\d|48[01])|8(?:20\\d|47[02])|9(?:20\\d|470))\\d{4})|7(?:(?:0470|4(?:25\\d|470)|5(?:202|470|96\\d))\\d{4}|1(?:20\\d{4,5}|4(?:70|83)\\d{4}))|8(?:1(?:2\\d{5,6}|4(?:10|7[01]\\d)\\d{3})|2(?:2\\d{5,6}|(?:320|490\\d)\\d{3})|(?:3(?:2\\d\\d|470)|4[24-7]|5(?:(?:2\\d|51)\\d|4(?:[1-35-9]\\d|4[0-57-9]))|6[23])\\d{4})|(?:1[2-6]\\d|4(?:2[24-8]|3[2-7]|[46][2-6]|5[3-5])|5(?:[27][2-8]|3[2-68]|4[24-8]|5[23]|6[2-4]|8[24-7]|9[2-7])|6(?:[19]20|42[03-6]|(?:52|7[45])\\d)|7(?:[04][24-8]|[15][2-7]|22|3[2-4])|8(?:1[2-689]|2[2-8]|(?:[35]2|64)\\d))\\d{4}|25\\d{5,6}|(?:2[2-9]|6(?:1[2356]|[24][2-6]|3[24-6]|5[2-4]|6[2-8]|7[235-7]|8[245]|9[24])|8(?:3[24]|5[245]))\\d{4}",
                  ,
                  ,
                  ,
                  "1234567",
                  ,
                  ,
                  [6, 7, 8, 9],
                  [5]
                ],
                [, , "(?:17[01]|9(?:2(?:[0-4]|[56]\\d\\d)|(?:3(?:[0-36]|4\\d)|(?:6\\d|8[89]|9[4-8])\\d|7(?:3|40|[5-9]\\d))\\d|4(?:(?:[0245]\\d|[1379])\\d|88)|5[0-6])\\d)\\d{4}|9[69]1\\d{6}|9(?:[68]\\d|9[089])\\d{5}", , , , "92123456", , , [7, 8, 9, 10]],
                [, , "80080(?:0[1-9]|2\\d)\\d{3}", , , , "8008001234", , , [10]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , "1333\\d{4}", , , , "13331234", , , [8]],
                "MM",
                95,
                "00",
                "0",
                ,
                ,
                "0",
                ,
                ,
                ,
                [[, "(\\d)(\\d{2})(\\d{3})", "$1 $2 $3", ["16|2"], "0$1"], [
                  ,
                  "(\\d{2})(\\d{2})(\\d{3})",
                  "$1 $2 $3",
                  ["4(?:[2-46]|5[3-5])|5|6(?:[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-5]|(?:60|86)[23]"],
                  "0$1"
                ], [, "(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]|452|678|86", "[12]|452|6788|86"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[4-7]|8[1-35]"], "0$1"], [, "(\\d)(\\d{3})(\\d{4,6})", "$1 $2 $3", ["9(?:2[0-4]|[35-9]|4[137-9])"], "0$1"], [, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"], [, "(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["92"], "0$1"], [
                  ,
                  "(\\d)(\\d{5})(\\d{4})",
                  "$1 $2 $3",
                  ["9"],
                  "0$1"
                ]],
                ,
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]]
              ],
              MN: [, [, , "[12]\\d{7,9}|[5-9]\\d{7}", , , , , , , [8, 9, 10], [4, 5, 6]], [, , "[12]2[1-3]\\d{5,6}|(?:(?:[12](?:1|27)|5[368])\\d\\d|7(?:0(?:[0-5]\\d|7[078]|80)|128))\\d{4}|[12](?:3[2-8]|4[2-68]|5[1-4689])\\d{6,7}", , , , "53123456", , , , [4, 5, 6]], [, , "92[0139]\\d{5}|(?:5[05]|6[069]|7[28]|8[0135689]|9[013-9])\\d{6}", , , , "88123456", , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
                ,
                ,
                "712[0-79]\\d{4}|7(?:1[013-9]|[5-79]\\d)\\d{5}",
                ,
                ,
                ,
                "75123456",
                ,
                ,
                [8]
              ], "MN", 976, "001", "0", , , "0", , , , [[, "(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[12]1"], "0$1"], [, "(\\d{4})(\\d{4})", "$1 $2", ["[5-9]"]], [, "(\\d{3})(\\d{5,6})", "$1 $2", ["[12]2[1-3]"], "0$1"], [, "(\\d{4})(\\d{5,6})", "$1 $2", ["[12](?:27|3[2-8]|4[2-68]|5[1-4689])", "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"], "0$1"], [, "(\\d{5})(\\d{4,5})", "$1 $2", ["[12]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              MO: [, [, , "0800\\d{3}|(?:28|[68]\\d)\\d{6}", , , , , , , [7, 8]], [
                ,
                ,
                "(?:28[2-9]|8(?:11|[2-57-9]\\d))\\d{5}",
                ,
                ,
                ,
                "28212345",
                ,
                ,
                [8]
              ], [, , "6800[0-79]\\d{3}|6(?:[235]\\d\\d|6(?:0[0-5]|[1-9]\\d)|8(?:0[1-9]|[14-8]\\d|2[5-9]|[39][0-4]))\\d{4}", , , , "66123456", , , [8]], [, , "0800\\d{3}", , , , "0800501", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "MO", 853, "00", , , , , , , , [[, "(\\d{4})(\\d{3})", "$1 $2", ["0"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["[268]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              MP: [, [, , "[58]\\d{9}|(?:67|90)0\\d{7}", , , , , , , [10], [7]], [
                ,
                ,
                "670(?:2(?:3[3-7]|56|8[4-8])|32[1-38]|4(?:33|8[348])|5(?:32|55|88)|6(?:64|70|82)|78[3589]|8[3-9]8|989)\\d{4}",
                ,
                ,
                ,
                "6702345678",
                ,
                ,
                ,
                [7]
              ], [, , "670(?:2(?:3[3-7]|56|8[4-8])|32[1-38]|4(?:33|8[348])|5(?:32|55|88)|6(?:64|70|82)|78[3589]|8[3-9]8|989)\\d{4}", , , , "6702345678", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [
                ,
                ,
                "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "5002345678"
              ], [, , , , , , , , , [-1]], "MP", 1, "011", "1", , , "([2-9]\\d{6})$|1", "670$1", , 1, , , [, , , , , , , , , [-1]], , "670", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              MQ: [, [, , "(?:596\\d|7091)\\d{5}|(?:69|[89]\\d)\\d{7}", , , , , , , [9]], [, , "(?:596(?:[03-7]\\d|1[05]|2[7-9]|8[0-39]|9[04-9])|80[6-9]\\d\\d|9(?:477[6-9]|767[4589]))\\d{4}", , , , "596301234"], [, , "(?:69[67]\\d\\d|7091[0-3])\\d{4}", , , , "696201234"], [, , "80[0-5]\\d{6}", , , , "800012345"], [, , "8[129]\\d{7}", , , , "810123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
                ,
                ,
                "9(?:397[0-3]|477[0-5]|76(?:6\\d|7[0-367]))\\d{4}",
                ,
                ,
                ,
                "976612345"
              ], "MQ", 596, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-79]|8(?:0[6-9]|[36])"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              MR: [
                ,
                [, , "(?:[2-4]\\d\\d|800)\\d{5}", , , , , , , [8]],
                [, , "(?:25[08]|35\\d|45[1-7])\\d{5}", , , , "35123456"],
                [, , "[2-4][0-46-9]\\d{6}", , , , "22123456"],
                [, , "800\\d{5}", , , , "80012345"],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                "MR",
                222,
                "00",
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-48]"]]],
                ,
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]]
              ],
              MS: [, [, , "(?:[58]\\d\\d|664|900)\\d{7}", , , , , , , [10], [7]], [, , "6644(?:1[0-3]|91)\\d{4}", , , , "6644912345", , , , [7]], [, , "664(?:3(?:49|9[1-6])|49[2-6])\\d{4}", , , , "6644923456", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"], [, , "900[2-9]\\d{6}", , , , "9002123456"], [, , , , , , , , , [-1]], [
                ,
                ,
                "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "5002345678"
              ], [, , , , , , , , , [-1]], "MS", 1, "011", "1", , , "([34]\\d{6})$|1", "664$1", , , , , [, , , , , , , , , [-1]], , "664", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              MT: [, [, , "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}", , , , , , , [8]], [, , "20(?:3[1-4]|6[059])\\d{4}|2(?:0[19]|[1-357]\\d|60)\\d{5}", , , , "21001234"], [, , "(?:7(?:210|[79]\\d\\d)|9(?:[29]\\d\\d|69[67]|8(?:1[1-3]|89|97)))\\d{4}", , , , "96961234"], [, , "800(?:02|[3467]\\d)\\d{3}", , , , "80071234"], [
                ,
                ,
                "5(?:0(?:0(?:37|43)|(?:6\\d|70|9[0168])\\d)|[12]\\d0[1-5])\\d{3}",
                ,
                ,
                ,
                "50037123"
              ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "3550\\d{4}", , , , "35501234"], "MT", 356, "00", , , , , , , , [[, "(\\d{4})(\\d{4})", "$1 $2", ["[2357-9]"]]], , [, , "7117\\d{4}", , , , "71171234"], , , [, , , , , , , , , [-1]], [, , "501\\d{5}", , , , "50112345"], , , [, , , , , , , , , [-1]]],
              MU: [, [, , "(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}", , , , , , , [7, 8, 10]], [, , "(?:2(?:[0346-8]\\d|1[0-8])|4(?:[013568]\\d|2[4-8]|71|90)|54(?:[3-5]\\d|71)|6\\d\\d|8(?:14|3[129]))\\d{4}", , , , "54480123", , , [7, 8]], [
                ,
                ,
                "5(?:4(?:2[1-389]|7[1-9])|87[15-8])\\d{4}|(?:5(?:2[5-9]|4[3-689]|[57]\\d|8[0-689]|9[0-8])|7(?:0[0-6]|3[013]))\\d{5}",
                ,
                ,
                ,
                "52512345",
                ,
                ,
                [8]
              ], [, , "802\\d{7}|80[0-2]\\d{4}", , , , "8001234", , , [7, 10]], [, , "30\\d{5}", , , , "3012345", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "3(?:20|9\\d)\\d{4}", , , , "3201234", , , [7]], "MU", 230, "0(?:0|[24-7]0|3[03])", , , , , , "020", , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[2-46]|8[013]"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["[57]"]], [, "(\\d{5})(\\d{5})", "$1 $2", ["8"]]], , [, , "219\\d{4}", , , , "2190123", , , [7]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              MV: [, [, , "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}", , , , , , , [
                7,
                10
              ]], [, , "(?:3(?:0[0-4]|3[0-59])|6(?:[58][024689]|6[024-68]|7[02468]))\\d{4}", , , , "6701234", , , [7]], [, , "(?:46[46]|[79]\\d\\d)\\d{4}", , , , "7712345", , , [7]], [, , "800\\d{7}", , , , "8001234567", , , [10]], [, , "900\\d{7}", , , , "9001234567", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "MV", 960, "0(?:0|19)", , , , , , "00", , [[, "(\\d{3})(\\d{4})", "$1-$2", ["[34679]"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "4(?:0[01]|50)\\d{4}", , , , "4001234", , , [7]], , , [, , , , , , , , , [-1]]],
              MW: [
                ,
                [, , "(?:[1289]\\d|31|77)\\d{7}|1\\d{6}", , , , , , , [7, 9]],
                [, , "(?:1[2-9]|2[12]\\d\\d)\\d{5}", , , , "1234567"],
                [, , "111\\d{6}|(?:31|77|[89][89])\\d{7}", , , , "991234567", , , [9]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                "MW",
                265,
                "00",
                "0",
                ,
                ,
                "0",
                ,
                ,
                ,
                [[, "(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["1[2-9]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[137-9]"], "0$1"]],
                ,
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]]
              ],
              MX: [
                ,
                [, , "[2-9]\\d{9}", , , , , , , [10], [7, 8]],
                [
                  ,
                  ,
                  "(?:2(?:0[01]|2\\d|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[267][1-9]|3[1-8]|[45]\\d|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-36-9]|6[0-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[1346][1-9]|[27]\\d|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[0-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|[69]\\d|7[12]|8[1-8]))\\d{7}",
                  ,
                  ,
                  ,
                  "2001234567",
                  ,
                  ,
                  ,
                  [7, 8]
                ],
                [, , "(?:2(?:2\\d|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[267][1-9]|3[1-8]|[45]\\d|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-36-9]|6[0-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[1346][1-9]|[27]\\d|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[0-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|[69]\\d|7[12]|8[1-8]))\\d{7}", , , , "2221234567", , , , [7, 8]],
                [, , "8(?:00|88)\\d{7}", , , , "8001234567"],
                [, , "900\\d{7}", , , , "9001234567"],
                [, , "300\\d{7}", , , , "3001234567"],
                [, , "500\\d{7}", , , , "5001234567"],
                [, , , , , , , , , [-1]],
                "MX",
                52,
                "0[09]",
                ,
                ,
                ,
                ,
                ,
                "00",
                ,
                [[, "(\\d{5})", "$1", ["53"]], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["33|5[56]|81"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-9]"]]],
                [[, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["33|5[56]|81"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-9]"]]],
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]]
              ],
              MY: [, [
                ,
                ,
                "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [8, 9, 10],
                [6, 7]
              ], [, , "427[01]\\d{4}|(?:3(?:2[0-36-9]|3[0-368]|4[0-278]|5[0-24-8]|6[0-467]|7[1246-9]|8\\d|9[0-57])\\d|4(?:2[0-689]|[3-79]\\d|8[1-35689])|5(?:2[0-589]|[3468]\\d|5[0-489]|7[1-9]|9[23])|6(?:2[2-9]|3[1357-9]|[46]\\d|5[0-6]|7[0-35-9]|85|9[015-8])|7(?:[2579]\\d|3[03-68]|4[0-8]|6[5-9]|8[0-35-9])|8(?:[24][2-8]|3[2-5]|5[2-7]|6[2-589]|7[2-578]|[89][2-9])|9(?:0[57]|13|[25-7]\\d|[3489][0-8]))\\d{5}", , , , "323856789", , , [8, 9], [6, 7]], [
                ,
                ,
                "1(?:1888[689]|4400|8(?:47|8[27])[0-4])\\d{4}|1(?:0(?:[23568]\\d|4[0-6]|7[016-9]|9[0-8])|1(?:[1-5]\\d\\d|6(?:0[5-9]|[1-9]\\d)|7(?:[0-4]\\d|5[0-7]))|(?:[269]\\d|[37][1-9]|4[235-9])\\d|5(?:31|9\\d\\d)|8(?:1[23]|[236]\\d|4[06]|5(?:46|[7-9])|7[016-9]|8[01]|9[0-8]))\\d{5}",
                ,
                ,
                ,
                "123456789",
                ,
                ,
                [9, 10]
              ], [, , "1[378]00\\d{6}", , , , "1300123456", , , [10]], [, , "1600\\d{6}", , , , "1600123456", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "15(?:4(?:6[0-4]\\d|8(?:0[125]|[17]\\d|21|3[01]|4[01589]|5[014]|6[02]))|6(?:32[0-6]|78\\d))\\d{4}", , , , "1546012345", , , [10]], "MY", 60, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{4})", "$1-$2 $3", ["[4-79]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1-$2 $3", ["1(?:[02469]|[378][1-9]|53)|8", "1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"], "0$1"], [
                ,
                "(\\d)(\\d{4})(\\d{4})",
                "$1-$2 $3",
                ["3"],
                "0$1"
              ], [, "(\\d)(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3-$4", ["1(?:[367]|80)"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1-$2 $3", ["15"], "0$1"], [, "(\\d{2})(\\d{4})(\\d{4})", "$1-$2 $3", ["1"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              MZ: [
                ,
                [, , "(?:2|8\\d)\\d{7}", , , , , , , [8, 9]],
                [, , "2(?:[1346]\\d|5[0-2]|[78][12]|93)\\d{5}", , , , "21123456", , , [8]],
                [, , "8[2-79]\\d{7}", , , , "821234567", , , [9]],
                [, , "800\\d{6}", , , , "800123456", , , [9]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                "MZ",
                258,
                "00",
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [[, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2|8[2-79]"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]],
                ,
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]]
              ],
              NA: [, [, , "[68]\\d{7,8}", , , , , , , [8, 9]], [
                ,
                ,
                "64426\\d{3}|6(?:1(?:2[2-7]|3[01378]|4[0-4])|254|32[0237]|4(?:27|41|5[25])|52[236-8]|626|7(?:2[2-4]|30))\\d{4,5}|6(?:1(?:(?:0\\d|2[0189]|3[24-69]|4[5-9])\\d|17|69|7[014])|2(?:17|5[0-36-8]|69|70)|3(?:17|2[14-689]|34|6[289]|7[01]|81)|4(?:17|2[0-2]|4[06]|5[0137]|69|7[01])|5(?:17|2[0459]|69|7[01])|6(?:17|25|38|42|69|7[01])|7(?:17|2[569]|3[13]|6[89]|7[01]))\\d{4}",
                ,
                ,
                ,
                "61221234"
              ], [, , "(?:60|8[1245])\\d{7}", , , , "811234567", , , [9]], [, , "80\\d{7}", , , , "800123456", , , [9]], [, , "8701\\d{5}", , , , "870123456", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "8(?:3\\d\\d|86)\\d{5}", , , , "88612345"], "NA", 264, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["87"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ], , , [, , , , , , , , , [-1]]],
              NC: [, [, , "(?:050|[2-57-9]\\d\\d)\\d{3}", , , , , , , [6]], [, , "(?:2[03-9]|3[0-5]|4[1-7]|88)\\d{4}", , , , "201234"], [, , "(?:[579]\\d|8[0-79])\\d{4}", , , , "751234"], [, , "050\\d{3}", , , , "050012"], [, , "36\\d{4}", , , , "366711"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "NC", 687, "00", , , , , , , , [[, "(\\d{3})", "$1", ["5[6-8]"]], [, "(\\d{2})(\\d{2})(\\d{2})", "$1.$2.$3", ["[02-57-9]"]]], [[, "(\\d{2})(\\d{2})(\\d{2})", "$1.$2.$3", ["[02-57-9]"]]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]],
              NE: [, [, , "[027-9]\\d{7}", , , , , , , [8]], [, , "2(?:0(?:20|3[1-8]|4[13-5]|5[14]|6[14578]|7[1-578])|1(?:4[145]|5[14]|6[14-68]|7[169]|88))\\d{4}", , , , "20201234"], [, , "(?:23|7[0467]|[89]\\d)\\d{6}", , , , "93123456"], [, , "08\\d{6}", , , , "08123456"], [, , "09\\d{6}", , , , "09123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "NE", 227, "00", , , , , , , , [[, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["08"]], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[089]|2[013]|7[0467]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ], , , [, , , , , , , , , [-1]]],
              NF: [, [, , "[13]\\d{5}", , , , , , , [6], [5]], [, , "(?:1(?:06|17|28|39)|3[0-2]\\d)\\d{3}", , , , "106609", , , , [5]], [, , "(?:14|3[58])\\d{4}", , , , "381234", , , , [5]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "NF", 672, "00", , , , "([0-258]\\d{4})$", "3$1", , , [[, "(\\d{2})(\\d{4})", "$1 $2", ["1[0-3]"]], [, "(\\d)(\\d{5})", "$1 $2", ["[13]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              NG: [, [, , "(?:20|9\\d)\\d{8}|[78]\\d{9,13}", , , , , , , [
                10,
                11,
                12,
                13,
                14
              ], [6, 7]], [, , "20(?:[1259]\\d|3[013-9]|4[1-8]|6[024-689]|7[1-79]|8[2-9])\\d{6}", , , , "2033123456", , , [10], [6, 7]], [, , "(?:702[0-24-9]|819[01])\\d{6}|(?:7(?:0[13-9]|[12]\\d)|8(?:0[1-9]|1[0-8])|9(?:0[1-9]|1[1-6]))\\d{7}", , , , "8021234567", , , [10]], [, , "800\\d{7,11}", , , , "80017591759"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "NG", 234, "009", "0", , , "0", , , , [[, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[7-9]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["20[129]"], "0$1"], [
                ,
                "(\\d{4})(\\d{2})(\\d{4})",
                "$1 $2 $3",
                ["2"],
                "0$1"
              ], [, "(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["[78]"], "0$1"], [, "(\\d{3})(\\d{5})(\\d{5,6})", "$1 $2 $3", ["[78]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "700\\d{7,11}", , , , "7001234567"], , , [, , , , , , , , , [-1]]],
              NI: [, [, , "(?:1800|[25-8]\\d{3})\\d{4}", , , , , , , [8]], [, , "2\\d{7}", , , , "21234567"], [, , "(?:5(?:5[0-7]|[78]\\d)|6(?:20|3[035]|4[045]|5[05]|77|8[1-9]|9[059])|(?:7[5-8]|8\\d)\\d)\\d{5}", , , , "81234567"], [, , "1800\\d{4}", , , , "18001234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ], "NI", 505, "00", , , , , , , , [[, "(\\d{4})(\\d{4})", "$1 $2", ["[125-8]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              NL: [, [, , "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}", , , , , , , [5, 6, 7, 8, 9, 10, 11]], [
                ,
                ,
                "(?:1(?:[035]\\d|1[13-578]|6[124-8]|7[24]|8[0-467])|2(?:[0346]\\d|2[2-46-9]|5[125]|9[479])|3(?:[03568]\\d|1[3-8]|2[01]|4[1-8])|4(?:[0356]\\d|1[1-368]|7[58]|8[15-8]|9[23579])|5(?:[0358]\\d|[19][1-9]|2[1-57-9]|4[13-8]|6[126]|7[0-3578])|7\\d\\d)\\d{6}",
                ,
                ,
                ,
                "101234567",
                ,
                ,
                [9]
              ], [, , "(?:6[1-58]|970\\d)\\d{7}", , , , "612345678", , , [9, 11]], [, , "800\\d{4,7}", , , , "8001234", , , [7, 8, 9, 10]], [, , "90[069]\\d{4,7}", , , , "9061234", , , [7, 8, 9, 10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "(?:85|91)\\d{7}", , , , "851234567", , , [9]], "NL", 31, "00", "0", , , "0", , , , [[, "(\\d{4})", "$1", ["1[238]|[34]"]], [, "(\\d{2})(\\d{3,4})", "$1 $2", ["14"]], [, "(\\d{6})", "$1", ["1"]], [, "(\\d{3})(\\d{4,7})", "$1 $2", ["[89]0"], "0$1"], [, "(\\d{2})(\\d{7})", "$1 $2", ["66"], "0$1"], [, "(\\d)(\\d{8})", "$1 $2", ["6"], "0$1"], [
                ,
                "(\\d{3})(\\d{3})(\\d{3})",
                "$1 $2 $3",
                ["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"],
                "0$1"
              ], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-578]|91"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3", ["9"], "0$1"]], [[, "(\\d{3})(\\d{4,7})", "$1 $2", ["[89]0"], "0$1"], [, "(\\d{2})(\\d{7})", "$1 $2", ["66"], "0$1"], [, "(\\d)(\\d{8})", "$1 $2", ["6"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-578]|91"], "0$1"], [
                ,
                "(\\d{3})(\\d{3})(\\d{5})",
                "$1 $2 $3",
                ["9"],
                "0$1"
              ]], [, , "66\\d{7}", , , , "662345678", , , [9]], , , [, , "140(?:1[035]|2[0346]|3[03568]|4[0356]|5[0358]|8[458])|140(?:1[16-8]|2[259]|3[124]|4[17-9]|5[124679]|7)\\d", , , , , , , [5, 6]], [, , "140(?:1[035]|2[0346]|3[03568]|4[0356]|5[0358]|8[458])|(?:140(?:1[16-8]|2[259]|3[124]|4[17-9]|5[124679]|7)|8[478]\\d{6})\\d", , , , "14020", , , [5, 6, 9]], , , [, , , , , , , , , [-1]]],
              NO: [, [, , "(?:0|[2-9]\\d{3})\\d{4}", , , , , , , [5, 8]], [, , "(?:2[1-4]|3[1-3578]|5[1-35-7]|6[1-4679]|7[0-8])\\d{6}", , , , "21234567", , , [8]], [
                ,
                ,
                "(?:4[015-8]|9\\d)\\d{6}",
                ,
                ,
                ,
                "40612345",
                ,
                ,
                [8]
              ], [, , "80[01]\\d{5}", , , , "80012345", , , [8]], [, , "82[09]\\d{5}", , , , "82012345", , , [8]], [, , "810(?:0[0-6]|[2-8]\\d)\\d{3}", , , , "81021234", , , [8]], [, , "880\\d{5}", , , , "88012345", , , [8]], [, , "85[0-5]\\d{5}", , , , "85012345", , , [8]], "NO", 47, "00", , , , , , , , [[, "(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["8"]], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]"]]], , [, , , , , , , , , [-1]], 1, "[02-689]|7[0-8]", [, , , , , , , , , [-1]], [, , "(?:0[235-9]|81(?:0(?:0[7-9]|1\\d)|5\\d\\d))\\d{3}", , , , "02000"], , , [
                ,
                ,
                "81[23]\\d{5}",
                ,
                ,
                ,
                "81212345",
                ,
                ,
                [8]
              ]],
              NP: [, [, , "(?:1\\d|9)\\d{9}|[1-9]\\d{7}", , , , , , , [8, 10, 11], [6, 7]], [, , "(?:1[0-6]\\d|99[02-6])\\d{5}|(?:2[13-79]|3[135-8]|4[146-9]|5[135-7]|6[13-9]|7[15-9]|8[1-46-9]|9[1-7])[2-6]\\d{5}", , , , "14567890", , , [8], [6, 7]], [, , "9(?:00|6[0-3]|7[0-24-6]|8[0-24-68])\\d{7}", , , , "9841234567", , , [10]], [, , "1(?:66001|800\\d\\d)\\d{5}", , , , "16600101234", , , [11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "NP", 977, "00", "0", , , "0", , , , [[, "(\\d)(\\d{7})", "$1-$2", ["1[2-6]"], "0$1"], [
                ,
                "(\\d{2})(\\d{6})",
                "$1-$2",
                ["1[01]|[2-8]|9(?:[1-59]|[67][2-6])"],
                "0$1"
              ], [, "(\\d{3})(\\d{7})", "$1-$2", ["9"]], [, "(\\d{4})(\\d{2})(\\d{5})", "$1-$2-$3", ["1"]]], [[, "(\\d)(\\d{7})", "$1-$2", ["1[2-6]"], "0$1"], [, "(\\d{2})(\\d{6})", "$1-$2", ["1[01]|[2-8]|9(?:[1-59]|[67][2-6])"], "0$1"], [, "(\\d{3})(\\d{7})", "$1-$2", ["9"]]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              NR: [, [, , "(?:222|444|(?:55|8\\d)\\d|666|777|999)\\d{4}", , , , , , , [7]], [, , "444\\d{4}", , , , "4441234"], [
                ,
                ,
                "(?:222|55[3-9]|666|777|8\\d\\d|999)\\d{4}",
                ,
                ,
                ,
                "5551234"
              ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "NR", 674, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[24-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              NU: [
                ,
                [, , "(?:[4-7]|888\\d)\\d{3}", , , , , , , [4, 7]],
                [, , "[47]\\d{3}", , , , "7012", , , [4]],
                [, , "(?:[56]|888[1-9])\\d{3}", , , , "8884012"],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                "NU",
                683,
                "00",
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [[, "(\\d{3})(\\d{4})", "$1 $2", ["8"]]],
                ,
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]]
              ],
              NZ: [
                ,
                [, , "[1289]\\d{9}|50\\d{5}(?:\\d{2,3})?|[27-9]\\d{7,8}|(?:[34]\\d|6[0-35-9])\\d{6}|8\\d{4,6}", , , , , , , [5, 6, 7, 8, 9, 10]],
                [, , "240\\d{5}|(?:3[2-79]|[49][2-9]|6[235-9]|7[2-57-9])\\d{6}", , , , "32345678", , , [8], [7]],
                [, , "2(?:[0-27-9]\\d|6)\\d{6,7}|2(?:1\\d|75)\\d{5}", , , , "211234567", , , [8, 9, 10]],
                [, , "508\\d{6,7}|80\\d{6,8}", , , , "800123456", , , [8, 9, 10]],
                [, , "(?:1[13-57-9]\\d{5}|50(?:0[08]|30|66|77|88))\\d{3}|90\\d{6,8}", , , , "900123456", , , [7, 8, 9, 10]],
                [, , , , , , , , , [-1]],
                [, , "70\\d{7}", , , , "701234567", , , [9]],
                [, , , , , , , , , [-1]],
                "NZ",
                64,
                "0(?:0|161)",
                "0",
                ,
                ,
                "0",
                ,
                "00",
                ,
                [[, "(\\d{2})(\\d{3,8})", "$1 $2", ["8[1-79]"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["50[036-8]|8|90", "50(?:[0367]|88)|8|90"], "0$1"], [, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["24|[346]|7[2-57-9]|9[2-9]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:10|74)|[589]"], "0$1"], [, "(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1|2[028]"], "0$1"], [
                  ,
                  "(\\d{2})(\\d{3})(\\d{3,5})",
                  "$1 $2 $3",
                  ["2(?:[169]|7[0-35-9])|7"],
                  "0$1"
                ]],
                ,
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]],
                [, , "8(?:1[16-9]|22|3\\d|4[045]|5[459]|6[235-9]|7[0-3579]|90)\\d{2,7}", , , , "83012378"],
                ,
                ,
                [, , , , , , , , , [-1]]
              ],
              OM: [
                ,
                [, , "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}", , , , , , , [7, 8, 9]],
                [, , "2[1-6]\\d{6}", , , , "23123456", , , [8]],
                [, , "1505\\d{4}|(?:7(?:[125-9]\\d|41)|9(?:0[1-9]|[1-9]\\d))\\d{5}", , , , "92123456", , , [8]],
                [, , "8007\\d{4,5}|(?:500|800[05])\\d{4}", , , , "80071234"],
                [, , "900\\d{5}", , , , "90012345", , , [8]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                "OM",
                968,
                "00",
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [[, "(\\d{3})(\\d{4,6})", "$1 $2", ["[58]"]], [, "(\\d{2})(\\d{6})", "$1 $2", ["2"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["[179]"]]],
                ,
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]]
              ],
              PA: [, [, , "(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}", , , , , , , [7, 8, 10, 11]], [
                ,
                ,
                "(?:1(?:0\\d|1[0479]|2[37]|3[0137]|4[17]|5[05]|6[058]|7[0167]|8[2358]|9[1389])|2(?:[0235-79]\\d|1[0-7]|4[013-9]|8[02-9])|3(?:[047-9]\\d|1[0-8]|2[0-5]|33|5[0-35]|6[068])|4(?:00|3[0-579]|4\\d|7[0-57-9])|5(?:[01]\\d|2[0-7]|[56]0|79)|7(?:0[09]|2[0-26-8]|3[03]|4[04]|5[05-9]|6[0156]|7[0-24-9]|8[4-9]|90)|8(?:09|2[89]|3\\d|4[0-24-689]|5[014]|8[02])|9(?:0[5-9]|1[0135-8]|2[036-9]|3[35-79]|40|5[0457-9]|6[05-9]|7[04-9]|8[35-8]|9\\d))\\d{4}",
                ,
                ,
                ,
                "2001234",
                ,
                ,
                [7]
              ], [, , "(?:1[16]1|21[89]|6\\d{3}|8(?:1[01]|7[23]))\\d{4}", , , , "61234567", , , [7, 8]], [, , "800\\d{4,5}|(?:00800|800\\d)\\d{6}", , , , "8001234"], [, , "(?:8(?:22|55|60|7[78]|86)|9(?:00|81))\\d{4}", , , , "8601234", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "PA", 507, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1-$2", ["[1-57-9]"]], [, "(\\d{4})(\\d{4})", "$1-$2", ["[68]"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              PE: [, [
                ,
                ,
                "(?:[14-8]|9\\d)\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [8, 9],
                [6, 7]
              ], [, , "(?:(?:(?:4[34]|5[14])[0-8]|687)\\d|7(?:173|(?:3[0-8]|55)\\d)|8(?:10[05689]|6(?:0[06-9]|1[6-9]|29)|7(?:0[0569]|[56]0)))\\d{4}|(?:1[0-8]|4[12]|5[236]|6[1-7]|7[246]|8[2-4])\\d{6}", , , , "11234567", , , [8], [6, 7]], [, , "9\\d{8}", , , , "912345678", , , [9]], [, , "800\\d{5}", , , , "80012345", , , [8]], [, , "805\\d{5}", , , , "80512345", , , [8]], [, , "801\\d{5}", , , , "80112345", , , [8]], [, , "80[24]\\d{5}", , , , "80212345", , , [8]], [, , , , , , , , , [-1]], "PE", 51, "00|19(?:1[124]|77|90)00", "0", " Anexo ", , "0", , "00", , [[
                ,
                "(\\d{3})(\\d{5})",
                "$1 $2",
                ["80"],
                "(0$1)"
              ], [, "(\\d)(\\d{7})", "$1 $2", ["1"], "(0$1)"], [, "(\\d{2})(\\d{6})", "$1 $2", ["[4-8]"], "(0$1)"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              PF: [
                ,
                [, , "4\\d{5}(?:\\d{2})?|8\\d{7,8}", , , , , , , [6, 8, 9]],
                [, , "4(?:0[4-689]|9[4-68])\\d{5}", , , , "40412345", , , [8]],
                [, , "8[7-9]\\d{6}", , , , "87123456", , , [8]],
                [, , "80[0-5]\\d{6}", , , , "800012345", , , [9]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , "499\\d{5}", , , , "49901234", , , [8]],
                "PF",
                689,
                "00",
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [[, "(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["44"]], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4|8[7-9]"]], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]],
                ,
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , "44\\d{4}", , , , , , , [6]],
                [, , "44\\d{4}", , , , "440123", , , [6]],
                ,
                ,
                [, , , , , , , , , [-1]]
              ],
              PG: [, [, , "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}", , , , , , , [7, 8]], [, , "(?:(?:3[0-2]|4[257]|5[34]|9[78])\\d|64[1-9]|85[02-46-9])\\d{4}", , , , "3123456", , , [7]], [, , "(?:7\\d|8[1-48])\\d{6}", , , , "70123456", , , [8]], [
                ,
                ,
                "180\\d{4}",
                ,
                ,
                ,
                "1801234",
                ,
                ,
                [7]
              ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "2(?:0[0-57]|7[568])\\d{4}", , , , "2751234", , , [7]], "PG", 675, "00|140[1-3]", , , , , , "00", , [[, "(\\d{3})(\\d{4})", "$1 $2", ["18|[2-69]|85"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["[78]"]]], , [, , "27[01]\\d{4}", , , , "2700123", , , [7]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              PH: [, [, , "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}", , , , , , , [6, 8, 9, 10, 11, 12, 13], [4, 5, 7]], [
                ,
                ,
                "(?:(?:2[3-8]|3[2-68]|4[2-9]|5[2-6]|6[2-58]|7[24578])\\d{3}|88(?:22\\d\\d|42))\\d{4}|(?:2|8[2-8]\\d\\d)\\d{5}",
                ,
                ,
                ,
                "232345678",
                ,
                ,
                [6, 8, 9, 10],
                [4, 5, 7]
              ], [, , "(?:8(?:1[37]|9[5-8])|9(?:0[5-9]|1[0-24-9]|[235-7]\\d|4[2-9]|8[135-9]|9[1-9]))\\d{7}", , , , "9051234567", , , [10]], [, , "1800\\d{7,9}", , , , "180012345678", , , [11, 12, 13]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "PH", 63, "00", "0", , , "0", , , , [[, "(\\d)(\\d{5})", "$1 $2", ["2"], "(0$1)"], [
                ,
                "(\\d{4})(\\d{4,6})",
                "$1 $2",
                ["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2", "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"],
                "(0$1)"
              ], [, "(\\d{5})(\\d{4})", "$1 $2", ["346|4(?:27|9[35])|883", "3469|4(?:279|9(?:30|56))|8834"], "(0$1)"], [, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "(0$1)"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|8[2-8]"], "(0$1)"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], [, "(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["1"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              PK: [, [
                ,
                ,
                "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}",
                ,
                ,
                ,
                ,
                ,
                ,
                [8, 9, 10, 11, 12],
                [5, 6, 7]
              ], [, , "(?:(?:21|42)[2-9]|58[126])\\d{7}|(?:2[25]|4[0146-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]\\d{6,7}|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8]))[2-9]\\d{5,6}", , , , "2123456789", , , [9, 10], [5, 6, 7, 8]], [, , "3(?:[0-247]\\d|3[0-79]|55|64)\\d{7}", , , , "3012345678", , , [10]], [, , "800\\d{5}(?:\\d{3})?", , , , "80012345", , , [8, 11]], [, , "900\\d{5}", , , , "90012345", , , [8]], [, , , , , , , , , [-1]], [
                ,
                ,
                "122\\d{6}",
                ,
                ,
                ,
                "122044444",
                ,
                ,
                [9]
              ], [, , , , , , , , , [-1]], "PK", 92, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{3})(\\d{2,7})", "$1 $2 $3", ["[89]0"], "0$1"], [, "(\\d{4})(\\d{5})", "$1 $2", ["1"]], [
                ,
                "(\\d{3})(\\d{6,7})",
                "$1 $2",
                ["2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])", "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"],
                "(0$1)"
              ], [, "(\\d{2})(\\d{7,8})", "$1 $2", ["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"], "(0$1)"], [, "(\\d{5})(\\d{5})", "$1 $2", ["58"], "(0$1)"], [, "(\\d{3})(\\d{7})", "$1 $2", ["3"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"], "(0$1)"], [, "(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[24-9]"], "(0$1)"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [
                ,
                ,
                "(?:2(?:[125]|3[2358]|4[2-4]|9[2-8])|4(?:[0-246-9]|5[3479])|5(?:[1-35-7]|4[2-467])|6(?:0[468]|[1-8])|7(?:[14]|2[236])|8(?:[16]|2[2-689]|3[23578]|4[3478]|5[2356])|9(?:1|22|3[27-9]|4[2-6]|6[3569]|9[2-7]))111\\d{6}",
                ,
                ,
                ,
                "21111825888",
                ,
                ,
                [11, 12]
              ], , , [, , , , , , , , , [-1]]],
              PL: [, [, , "(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}", , , , , , , [6, 7, 8, 9, 10]], [, , "47\\d{7}|(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])(?:[02-9]\\d{6}|1(?:[0-8]\\d{5}|9\\d{3}(?:\\d{2})?))", , , , "123456789", , , [7, 9]], [, , "2131[89]\\d{4}|21(?:1[013-5]|2\\d|3[2-9])\\d{5}|(?:45|5[0137]|6[069]|7[2389]|88)\\d{7}", , , , "512345678", , , [9]], [, , "800\\d{6,7}", , , , "800123456", , , [9, 10]], [, , "70[01346-8]\\d{6}", , , , "701234567", , , [9]], [
                ,
                ,
                "801\\d{6}",
                ,
                ,
                ,
                "801234567",
                ,
                ,
                [9]
              ], [, , , , , , , , , [-1]], [, , "39\\d{7}", , , , "391234567", , , [9]], "PL", 48, "00", , , , , , , , [
                [, "(\\d{5})", "$1", ["19"]],
                [, "(\\d{3})(\\d{3})", "$1 $2", ["11|20|64"]],
                [, "(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1", "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"]],
                [, "(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["64"]],
                [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"]],
                [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[2-8]|[2-7]|8[1-79]|9[145]"]],
                [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["8"]]
              ], , [, , "64\\d{4,7}", , , , "641234567", , , [6, 7, 8, 9]], , , [, , , , , , , , , [-1]], [, , "804\\d{6}", , , , "804123456", , , [9]], , , [, , , , , , , , , [-1]]],
              PM: [, [, , "[45]\\d{5}|(?:708|8\\d\\d)\\d{6}", , , , , , , [6, 9]], [, , "(?:4[1-35-9]|5[0-47-9]|80[6-9]\\d\\d)\\d{4}", , , , "430123"], [, , "(?:4[02-489]|5[02-9]|708(?:4[0-5]|5[0-6]))\\d{4}", , , , "551234"], [, , "80[0-5]\\d{6}", , , , "800012345", , , [9]], [
                ,
                ,
                "8[129]\\d{7}",
                ,
                ,
                ,
                "810123456",
                ,
                ,
                [9]
              ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "PM", 508, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[45]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"]], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              PR: [, [, , "(?:[589]\\d\\d|787)\\d{7}", , , , , , , [10], [7]], [, , "(?:787|939)[2-9]\\d{6}", , , , "7872345678", , , , [7]], [, , "(?:787|939)[2-9]\\d{6}", , , , "7872345678", , , , [7]], [
                ,
                ,
                "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "8002345678"
              ], [, , "900[2-9]\\d{6}", , , , "9002345678"], [, , , , , , , , , [-1]], [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "PR", 1, "011", "1", , , "1", , , 1, , , [, , , , , , , , , [-1]], , "787|939", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              PS: [, [
                ,
                ,
                "[2489]2\\d{6}|(?:1\\d|5)\\d{8}",
                ,
                ,
                ,
                ,
                ,
                ,
                [8, 9, 10],
                [7]
              ], [, , "(?:22[2-47-9]|42[45]|82[014-68]|92[3569])\\d{5}", , , , "22234567", , , [8], [7]], [, , "5[69]\\d{7}", , , , "599123456", , , [9]], [, , "1800\\d{6}", , , , "1800123456", , , [10]], [, , , , , , , , , [-1]], [, , "1700\\d{6}", , , , "1700123456", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "PS", 970, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2489]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["5"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              PT: [
                ,
                [, , "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}", , , , , , , [9]],
                [, , "2(?:[12]\\d|3[1-689]|4[1-59]|[57][1-9]|6[1-35689]|8[1-69]|9[1256])\\d{6}", , , , "212345678"],
                [, , "6(?:[06]92(?:30|9\\d)|[35]92(?:[049]\\d|3[034]))\\d{3}|(?:(?:16|6[0356])93|9(?:[1-36]\\d\\d|480))\\d{5}", , , , "912345678"],
                [, , "80[02]\\d{6}", , , , "800123456"],
                [, , "(?:6(?:0[178]|4[68])\\d|76(?:0[1-57]|1[2-47]|2[237]))\\d{5}", , , , "760123456"],
                [, , "80(?:8\\d|9[1579])\\d{5}", , , , "808123456"],
                [, , "884[0-4689]\\d{5}", , , , "884123456"],
                [, , "30\\d{7}", , , , "301234567"],
                "PT",
                351,
                "00",
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [[, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["2[12]"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["16|[236-9]"]]],
                ,
                [, , "6(?:222\\d|89(?:00|88|99))\\d{4}", , , , "622212345"],
                ,
                ,
                [, , , , , , , , , [-1]],
                [, , "70(?:38[01]|596|(?:7\\d|8[17])\\d)\\d{4}", , , , "707123456"],
                ,
                ,
                [, , "600\\d{6}|6[06]92(?:0\\d|3[349]|49)\\d{3}", , , , "600110000"]
              ],
              PW: [, [, , "(?:[24-8]\\d\\d|345|900)\\d{4}", , , , , , , [7]], [, , "(?:2(?:55|77)|345|488|5(?:35|44|87)|6(?:22|54|79)|7(?:33|47)|8(?:24|55|76)|900)\\d{4}", , , , "2771234"], [
                ,
                ,
                "(?:(?:46|83)[0-5]|(?:6[2-4689]|78)0)\\d{4}|(?:45|77|88)\\d{5}",
                ,
                ,
                ,
                "6201234"
              ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "PW", 680, "01[12]", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              PY: [, [, , "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}", , , , , , , [6, 7, 8, 9, 10, 11], [5]], [
                ,
                ,
                "(?:[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36])\\d{5,7}|(?:2(?:2[4-68]|[4-68]\\d|7[15]|9[1-5])|3(?:18|3[167]|4[2357]|51|[67]\\d)|4(?:3[12]|5[13]|9[1-47])|5(?:[1-4]\\d|5[02-4])|6(?:3[1-3]|44|7[1-8])|7(?:4[0-4]|5\\d|6[1-578]|75|8[0-8])|858)\\d{5,6}",
                ,
                ,
                ,
                "212345678",
                ,
                ,
                [7, 8, 9],
                [5, 6]
              ], [, , "9(?:51|6[129]|7[1-6]|8[1-7]|9[1-5])\\d{6}", , , , "961456789", , , [9]], [, , "9800\\d{5,7}", , , , "98000123456", , , [9, 10, 11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "8700[0-4]\\d{4}", , , , "870012345", , , [9]], "PY", 595, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{3,6})", "$1 $2", ["[2-9]0"], "0$1"], [, "(\\d{2})(\\d{5})", "$1 $2", ["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"], "(0$1)"], [, "(\\d{3})(\\d{4,5})", "$1 $2", ["2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"], "(0$1)"], [
                ,
                "(\\d{2})(\\d{3})(\\d{3,4})",
                "$1 $2 $3",
                ["2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"],
                "(0$1)"
              ], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["87"]], [, "(\\d{3})(\\d{6})", "$1 $2", ["9(?:[5-79]|8[1-7])"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "[2-9]0\\d{4,7}", , , , "201234567", , , [6, 7, 8, 9]], , , [, , , , , , , , , [-1]]],
              QA: [, [, , "800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}", , , , , , , [7, 8, 9, 11]], [
                ,
                ,
                "4(?:1111|2022)\\d{3}|4(?:[04]\\d\\d|14[0-6]|999)\\d{4}",
                ,
                ,
                ,
                "44123456",
                ,
                ,
                [8]
              ], [, , "[35-7]\\d{7}", , , , "33123456", , , [8]], [, , "800\\d{4}|(?:0080[01]|800)\\d{6}", , , , "8001234", , , [7, 9, 11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "QA", 974, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["2[136]|8"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["[3-7]"]]], , [, , "2[136]\\d{5}", , , , "2123456", , , [7]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              RE: [, [, , "709\\d{6}|(?:26|[689]\\d)\\d{7}", , , , , , , [9]], [, , "26(?:2\\d\\d|3(?:0\\d|1[0-6]))\\d{4}", , , , "262161234"], [
                ,
                ,
                "(?:69(?:2\\d\\d|3(?:[06][0-6]|1[0-3]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-37]|8[0-8]|9[0-479]))|7092[0-3])\\d{4}",
                ,
                ,
                ,
                "692123456"
              ], [, , "80\\d{7}", , , , "801234567"], [, , "89[1-37-9]\\d{6}", , , , "891123456"], [, , "8(?:1[019]|2[0156]|84|90)\\d{6}", , , , "810123456"], [, , , , , , , , , [-1]], [, , "9(?:399[0-3]|479[0-6]|76(?:2[278]|3[0-37]))\\d{4}", , , , "939901234"], "RE", 262, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[26-9]"], "0$1"]], , [, , , , , , , , , [-1]], 1, , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              RO: [, [, , "(?:[236-8]\\d|90)\\d{7}|[23]\\d{5}", , , , , , , [6, 9]], [
                ,
                ,
                "[23][13-6]\\d{7}|(?:2(?:19\\d|[3-6]\\d9)|31\\d\\d)\\d\\d",
                ,
                ,
                ,
                "211234567"
              ], [, , "(?:630|702)0\\d{5}|(?:6(?:00|2\\d)|7(?:0[013-9]|1[0-3]|[2-7]\\d|8[03-8]|9[0-39]))\\d{6}", , , , "712034567", , , [9]], [, , "800\\d{6}", , , , "800123456", , , [9]], [, , "90[0136]\\d{6}", , , , "900123456", , , [9]], [, , "801\\d{6}", , , , "801123456", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "RO", 40, "00", "0", " int ", , "0", , , , [[, "(\\d{3})(\\d{3})", "$1 $2", ["2[3-6]", "2[3-6]\\d9"], "0$1"], [, "(\\d{2})(\\d{4})", "$1 $2", ["219|31"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[23]1"], "0$1"], [
                ,
                "(\\d{3})(\\d{3})(\\d{3})",
                "$1 $2 $3",
                ["[236-9]"],
                "0$1"
              ]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "(?:37\\d|80[578])\\d{6}", , , , "372123456", , , [9]], , , [, , , , , , , , , [-1]]],
              RS: [, [, , "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}", , , , , , , [6, 7, 8, 9, 10, 11, 12], [4, 5]], [, , "(?:11[1-9]\\d|(?:2[389]|39)(?:0[2-9]|[2-9]\\d))\\d{3,8}|(?:1[02-9]|2[0-24-7]|3[0-8])[2-9]\\d{4,9}", , , , "10234567", , , [7, 8, 9, 10, 11, 12], [4, 5, 6]], [, , "6(?:[0-689]|7\\d)\\d{6,7}", , , , "601234567", , , [8, 9, 10]], [
                ,
                ,
                "800\\d{3,9}",
                ,
                ,
                ,
                "80012345"
              ], [, , "(?:78\\d|90[0169])\\d{3,7}", , , , "90012345", , , [6, 7, 8, 9, 10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "RS", 381, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{3,9})", "$1 $2", ["(?:2[389]|39)0|[7-9]"], "0$1"], [, "(\\d{2})(\\d{5,10})", "$1 $2", ["[1-36]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "7[06]\\d{4,10}", , , , "700123456"], , , [, , , , , , , , , [-1]]],
              RU: [, [, , "8\\d{13}|[347-9]\\d{9}", , , , , , , [10, 14], [7]], [
                ,
                ,
                "336(?:[013-9]\\d|2[013-9])\\d{5}|(?:3(?:0[12]|4[1-35-79]|5[1-3]|65|8[1-58]|9[0145])|4(?:01|1[1356]|2[13467]|7[1-5]|8[1-7]|9[1-689])|8(?:1[1-8]|2[01]|3[13-6]|4[0-8]|5[15-7]|6[0-35-79]|7[1-37-9]))\\d{7}",
                ,
                ,
                ,
                "3011234567",
                ,
                ,
                [10],
                [7]
              ], [, , "9\\d{9}", , , , "9123456789", , , [10]], [, , "8(?:0[04]|108\\d{3})\\d{7}", , , , "8001234567"], [, , "80[39]\\d{7}", , , , "8091234567", , , [10]], [, , , , , , , , , [-1]], [, , "808\\d{7}", , , , "8081234567", , , [10]], [, , , , , , , , , [-1]], "RU", 7, "810", "8", , , "8", , "8~10", , [[, "(\\d{3})(\\d{2})(\\d{2})", "$1-$2-$3", ["[0-79]"]], [
                ,
                "(\\d{4})(\\d{2})(\\d{2})(\\d{2})",
                "$1 $2 $3 $4",
                ["7(?:1[0-8]|2[1-9])", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"],
                "8 ($1)",
                ,
                1
              ], [, "(\\d{5})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-68]|2[1-9])", "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))", "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"], "8 ($1)", , 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "8 ($1)", , 1], [
                ,
                "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                "$1 $2-$3-$4",
                ["[349]|8(?:[02-7]|1[1-8])"],
                "8 ($1)",
                ,
                1
              ], [, "(\\d{4})(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["8"], "8 ($1)"]], [[, "(\\d{4})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-8]|2[1-9])", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"], "8 ($1)", , 1], [
                ,
                "(\\d{5})(\\d)(\\d{2})(\\d{2})",
                "$1 $2 $3 $4",
                ["7(?:1[0-68]|2[1-9])", "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))", "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"],
                "8 ($1)",
                ,
                1
              ], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "8 ($1)", , 1], [, "(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[349]|8(?:[02-7]|1[1-8])"], "8 ($1)", , 1], [, "(\\d{4})(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["8"], "8 ($1)"]], [, , , , , , , , , [-1]], 1, , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              RW: [, [, , "(?:06|[27]\\d\\d|[89]00)\\d{6}", , , , , , , [8, 9]], [, , "(?:06|2[23568]\\d)\\d{6}", , , , "250123456"], [, , "7[237-9]\\d{7}", , , , "720123456", , , [9]], [, , "800\\d{6}", , , , "800123456", , , [9]], [
                ,
                ,
                "900\\d{6}",
                ,
                ,
                ,
                "900123456",
                ,
                ,
                [9]
              ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "RW", 250, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              SA: [, [, , "(?:[15]\\d|800|92)\\d{7}", , , , , , , [9, 10], [7]], [, , "1(?:1\\d|2[24-8]|3[35-8]|4[3-68]|6[2-5]|7[235-7])\\d{6}", , , , "112345678", , , [9], [7]], [
                ,
                ,
                "579[01]\\d{5}|5(?:[013-689]\\d|7[0-8])\\d{6}",
                ,
                ,
                ,
                "512345678",
                ,
                ,
                [9]
              ], [, , "800\\d{7}", , , , "8001234567", , , [10]], [, , "925\\d{6}", , , , "925012345", , , [9]], [, , "920\\d{6}", , , , "920012345", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "SA", 966, "00", "0", , , "0", , , , [[, "(\\d{4})(\\d{5})", "$1 $2", ["9"]], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              SB: [
                ,
                [, , "[6-9]\\d{6}|[1-6]\\d{4}", , , , , , , [5, 7]],
                [, , "(?:1[4-79]|[23]\\d|4[0-2]|5[03]|6[0-37])\\d{3}", , , , "40123", , , [5]],
                [, , "48\\d{3}|(?:(?:6[89]|7[1-9]|8[4-9])\\d|9(?:1[2-9]|2[013-9]|3[0-2]|[46]\\d|5[0-46-9]|7[0-689]|8[0-79]|9[0-8]))\\d{4}", , , , "7421234"],
                [, , "1[38]\\d{3}", , , , "18123", , , [5]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , "5[12]\\d{3}", , , , "51123", , , [5]],
                "SB",
                677,
                "0[01]",
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [[, "(\\d{2})(\\d{5})", "$1 $2", ["6[89]|7|8[4-9]|9(?:[1-8]|9[0-8])"]]],
                ,
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]]
              ],
              SC: [, [
                ,
                ,
                "(?:[2489]\\d|64)\\d{5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [7]
              ], [, , "4[2-46]\\d{5}", , , , "4217123"], [, , "2[125-8]\\d{5}", , , , "2510123"], [, , "800[08]\\d{3}", , , , "8000000"], [, , "85\\d{5}", , , , "8512345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "971\\d{4}|(?:64|95)\\d{5}", , , , "6412345"], "SC", 248, "010|0[0-2]", , , , , , "00", , [[, "(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[246]|9[57]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              SD: [, [, , "[19]\\d{8}", , , , , , , [9]], [, , "1(?:5\\d|8[35-7])\\d{6}", , , , "153123456"], [, , "(?:1[0-2]|9[0-3569])\\d{7}", , , , "911231234"], [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "SD", 249, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[19]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              SE: [, [, , "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}", , , , , , , [6, 7, 8, 9, 10, 12]], [
                ,
                ,
                "(?:(?:[12][136]|3[356]|4[0246]|6[03]|8\\d)\\d|90[1-9])\\d{4,6}|(?:1(?:2[0-35]|4[0-4]|5[0-25-9]|7[13-6]|[89]\\d)|2(?:2[0-7]|4[0136-8]|5[0138]|7[018]|8[01]|9[0-57])|3(?:0[0-4]|1\\d|2[0-25]|4[056]|7[0-2]|8[0-3]|9[023])|4(?:1[013-8]|3[0135]|5[14-79]|7[0-246-9]|8[0156]|9[0-689])|5(?:0[0-6]|[15][0-5]|2[0-68]|3[0-4]|4\\d|6[03-5]|7[013]|8[0-79]|9[01])|6(?:1[1-3]|2[0-4]|4[02-57]|5[0-37]|6[0-3]|7[0-2]|8[0247]|9[0-356])|9(?:1[0-68]|2\\d|3[02-5]|4[0-3]|5[0-4]|[68][01]|7[0135-8]))\\d{5,6}",
                ,
                ,
                ,
                "8123456",
                ,
                ,
                [7, 8, 9]
              ], [, , "7[02369]\\d{7}", , , , "701234567", , , [9]], [, , "20\\d{4,7}", , , , "20123456", , , [6, 7, 8, 9]], [, , "649\\d{6}|99[1-59]\\d{4}(?:\\d{3})?|9(?:00|39|44)[1-8]\\d{3,6}", , , , "9001234567", , , [7, 8, 9, 10]], [, , "77[0-7]\\d{6}", , , , "771234567", , , [9]], [, , "75[1-8]\\d{6}", , , , "751234567", , , [9]], [, , , , , , , , , [-1]], "SE", 46, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["20"], "0$1"], [, "(\\d{3})(\\d{4})", "$1-$2", ["9(?:00|39|44|9)"], "0$1"], [
                ,
                "(\\d{2})(\\d{3})(\\d{2})",
                "$1-$2 $3",
                ["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"],
                "0$1"
              ], [, "(\\d)(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1"], [, "(\\d{3})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1"], [, "(\\d{3})(\\d{2,3})(\\d{3})", "$1-$2 $3", ["9(?:00|39|44)"], "0$1"], [, "(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["10|7"], "0$1"], [
                ,
                "(\\d)(\\d{3})(\\d{3})(\\d{2})",
                "$1-$2 $3 $4",
                ["8"],
                "0$1"
              ], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{3})", "$1-$2 $3 $4", ["9"], "0$1"], [, "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4 $5", ["[26]"], "0$1"]], [[, "(\\d{2})(\\d{2,3})(\\d{2})", "$1 $2 $3", ["20"]], [, "(\\d{3})(\\d{4})", "$1 $2", ["9(?:00|39|44|9)"]], [, "(\\d{2})(\\d{3})(\\d{2})", "$1 $2 $3", ["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"]], [
                ,
                "(\\d)(\\d{2,3})(\\d{2})(\\d{2})",
                "$1 $2 $3 $4",
                ["8"]
              ], [, "(\\d{3})(\\d{2,3})(\\d{2})", "$1 $2 $3", ["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"]], [, "(\\d{3})(\\d{2,3})(\\d{3})", "$1 $2 $3", ["9(?:00|39|44)"]], [, "(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"]], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["10|7"]], [, "(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["8"]], [
                ,
                "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                "$1 $2 $3 $4",
                ["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"]
              ], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["9"]], [, "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[26]"]]], [, , "74[02-9]\\d{6}", , , , "740123456", , , [9]], , , [, , , , , , , , , [-1]], [, , "10[1-8]\\d{6}", , , , "102345678", , , [9]], , , [, , "(?:25[245]|67[3-68])\\d{9}", , , , "254123456789", , , [12]]],
              SG: [, [, , "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}", , , , , , , [8, 10, 11]], [
                ,
                ,
                "662[0-24-9]\\d{4}|6(?:[0-578]\\d|6[013-57-9]|9[0-35-9])\\d{5}",
                ,
                ,
                ,
                "61234567",
                ,
                ,
                [8]
              ], [, , "898[02-8]\\d{4}|(?:8(?:0[1-9]|[1-8]\\d|9[0-7])|9[0-8]\\d)\\d{5}", , , , "81234567", , , [8]], [, , "(?:18|8)00\\d{7}", , , , "18001234567", , , [10, 11]], [, , "1900\\d{7}", , , , "19001234567", , , [11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "(?:3[12]\\d|666)\\d{5}", , , , "31234567", , , [8]], "SG", 65, "0[0-3]\\d", , , , , , , , [[, "(\\d{4,5})", "$1", ["1[013-9]|77", "1(?:[013-8]|9(?:0[1-9]|[1-9]))|77"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["[369]|8(?:0[1-9]|[1-9])"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]], [
                ,
                "(\\d{4})(\\d{4})(\\d{3})",
                "$1 $2 $3",
                ["7"]
              ], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]], [[, "(\\d{4})(\\d{4})", "$1 $2", ["[369]|8(?:0[1-9]|[1-9])"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]], [, "(\\d{4})(\\d{4})(\\d{3})", "$1 $2 $3", ["7"]], [, "(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "7000\\d{7}", , , , "70001234567", , , [11]], , , [, , , , , , , , , [-1]]],
              SH: [
                ,
                [, , "(?:[256]\\d|8)\\d{3}", , , , , , , [4, 5]],
                [, , "2(?:[0-57-9]\\d|6[4-9])\\d\\d", , , , "22158"],
                [, , "[56]\\d{4}", , , , "51234", , , [5]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , "262\\d\\d", , , , "26212", , , [5]],
                "SH",
                290,
                "00",
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [, , , , , , , , , [-1]],
                1,
                "[256]",
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]]
              ],
              SI: [
                ,
                [, , "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}", , , , , , , [5, 6, 7, 8]],
                [, , "(?:[1-357][2-8]|4[24-8])\\d{6}", , , , "12345678", , , [8], [7]],
                [, , "65(?:[178]\\d|5[56]|6[01])\\d{4}|(?:[37][01]|4[0139]|51|6[489])\\d{6}", , , , "31234567", , , [8]],
                [, , "80\\d{4,6}", , , , "80123456", , , [6, 7, 8]],
                [, , "89[1-3]\\d{2,5}|90\\d{4,6}", , , , "90123456"],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , "(?:59\\d\\d|8(?:1(?:[67]\\d|8[0-589])|2(?:0\\d|2[0-37-9]|8[0-2489])|3[389]\\d))\\d{4}", , , , "59012345", , , [8]],
                "SI",
                386,
                "00|10(?:22|66|88|99)",
                "0",
                ,
                ,
                "0",
                ,
                "00",
                ,
                [[, "(\\d{2})(\\d{3,6})", "$1 $2", ["8[09]|9"], "0$1"], [, "(\\d{3})(\\d{5})", "$1 $2", ["59|8"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37][01]|4[0139]|51|6"], "0$1"], [, "(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-57]"], "(0$1)"]],
                ,
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]]
              ],
              SJ: [, [
                ,
                ,
                "0\\d{4}|(?:[489]\\d|79)\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [5, 8]
              ], [, , "79\\d{6}", , , , "79123456", , , [8]], [, , "(?:4[015-8]|9\\d)\\d{6}", , , , "41234567", , , [8]], [, , "80[01]\\d{5}", , , , "80012345", , , [8]], [, , "82[09]\\d{5}", , , , "82012345", , , [8]], [, , "810(?:0[0-6]|[2-8]\\d)\\d{3}", , , , "81021234", , , [8]], [, , "880\\d{5}", , , , "88012345", , , [8]], [, , "85[0-5]\\d{5}", , , , "85012345", , , [8]], "SJ", 47, "00", , , , , , , , , , [, , , , , , , , , [-1]], , "79", [, , , , , , , , , [-1]], [, , "(?:0[235-9]|81(?:0(?:0[7-9]|1\\d)|5\\d\\d))\\d{3}", , , , "02000"], , , [, , "81[23]\\d{5}", , , , "81212345", , , [8]]],
              SK: [, [
                ,
                ,
                "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [6, 7, 9]
              ], [, , "(?:2(?:16|[2-9]\\d{3})|(?:(?:[3-5][1-8]\\d|819)\\d|601[1-5])\\d)\\d{4}|(?:2|[3-5][1-8])1[67]\\d{3}|[3-5][1-8]16\\d\\d", , , , "221234567"], [, , "909[1-9]\\d{5}|9(?:0[1-8]|1[0-24-9]|4[03-57-9]|5\\d)\\d{6}", , , , "912123456", , , [9]], [, , "800\\d{6}", , , , "800123456", , , [9]], [, , "9(?:00|[78]\\d)\\d{6}", , , , "900123456", , , [9]], [, , "8[5-9]\\d{7}", , , , "850123456", , , [9]], [, , , , , , , , , [-1]], [, , "6(?:02|5[0-4]|9[0-6])\\d{6}", , , , "690123456", , , [9]], "SK", 421, "00", "0", , , "0", , , , [[
                ,
                "(\\d)(\\d{2})(\\d{3,4})",
                "$1 $2 $3",
                ["21"],
                "0$1"
              ], [, "(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["[3-5][1-8]1", "[3-5][1-8]1[67]"], "0$1"], [, "(\\d{4})(\\d{3})", "$1 $2", ["909", "9090"], "0$1"], [, "(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1/$2 $3 $4", ["2"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[689]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1/$2 $3 $4", ["[3-5]"], "0$1"]], [[, "(\\d)(\\d{2})(\\d{3,4})", "$1 $2 $3", ["21"], "0$1"], [, "(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["[3-5][1-8]1", "[3-5][1-8]1[67]"], "0$1"], [
                ,
                "(\\d)(\\d{3})(\\d{3})(\\d{2})",
                "$1/$2 $3 $4",
                ["2"],
                "0$1"
              ], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[689]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1/$2 $3 $4", ["[3-5]"], "0$1"]], [, , "9090\\d{3}", , , , "9090123", , , [7]], , , [, , "9090\\d{3}|(?:602|8(?:00|[5-9]\\d)|9(?:00|[78]\\d))\\d{6}", , , , , , , [7, 9]], [, , "96\\d{7}", , , , "961234567", , , [9]], , , [, , , , , , , , , [-1]]],
              SL: [, [, , "(?:[237-9]\\d|66)\\d{6}", , , , , , , [8], [6]], [, , "22[2-4][2-9]\\d{4}", , , , "22221234", , , , [6]], [, , "(?:25|3[0-5]|66|7[1-9]|8[08]|9[09])\\d{6}", , , , "25123456"], [, , , , , , , , , [-1]], [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "SL", 232, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{6})", "$1 $2", ["[236-9]"], "(0$1)"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              SM: [
                ,
                [, , "(?:0549|[5-7]\\d)\\d{6}", , , , , , , [8, 10], [6]],
                [, , "0549(?:8[0157-9]|9\\d)\\d{4}", , , , "0549886377", , , [10], [6]],
                [, , "6[16]\\d{6}", , , , "66661212", , , [8]],
                [, , , , , , , , , [-1]],
                [, , "7[178]\\d{6}", , , , "71123456", , , [8]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , "5[158]\\d{6}", , , , "58001110", , , [8]],
                "SM",
                378,
                "00",
                ,
                ,
                ,
                "([89]\\d{5})$",
                "0549$1",
                ,
                ,
                [[, "(\\d{6})", "$1", ["[89]"]], [, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]"]], [, "(\\d{4})(\\d{6})", "$1 $2", ["0"]]],
                [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]"]], [, "(\\d{4})(\\d{6})", "$1 $2", ["0"]]],
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]]
              ],
              SN: [, [, , "(?:[378]\\d|93)\\d{7}", , , , , , , [9]], [, , "3(?:0(?:1[0-2]|80)|282|3(?:8[1-9]|9[3-9])|611)\\d{5}", , , , "301012345"], [
                ,
                ,
                "7(?:(?:[06-8]\\d|[19]0|21)\\d|5(?:0[01]|[19]0|2[25]|3[356]|[4-7]\\d|8[35]))\\d{5}",
                ,
                ,
                ,
                "701234567"
              ], [, , "800\\d{6}", , , , "800123456"], [, , "88[4689]\\d{6}", , , , "884123456"], [, , "81[02468]\\d{6}", , , , "810123456"], [, , , , , , , , , [-1]], [, , "(?:3(?:392|9[01]\\d)\\d|93(?:3[13]0|929))\\d{4}", , , , "933301234"], "SN", 221, "00", , , , , , , , [[, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[379]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              SO: [, [, , "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}", , , , , , , [6, 7, 8, 9]], [
                ,
                ,
                "(?:1\\d|2[0-79]|3[0-46-8]|4[0-7]|5[57-9])\\d{5}|(?:[134]\\d|8[125])\\d{4}",
                ,
                ,
                ,
                "4012345",
                ,
                ,
                [6, 7]
              ], [, , "(?:(?:15|(?:3[59]|4[89]|6\\d|7[679]|8[08])\\d|9(?:0\\d|[2-9]))\\d|2(?:4\\d|8))\\d{5}|(?:[67]\\d\\d|904)\\d{5}", , , , "71123456", , , [7, 8, 9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "SO", 252, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{4})", "$1 $2", ["8[125]"]], [, "(\\d{6})", "$1", ["[134]"]], [, "(\\d)(\\d{6})", "$1 $2", ["[15]|2[0-79]|3[0-46-8]|4[0-7]"]], [
                ,
                "(\\d)(\\d{7})",
                "$1 $2",
                ["(?:2|90)4|[67]"]
              ], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[348]|64|79|90"]], [, "(\\d{2})(\\d{5,7})", "$1 $2", ["1|28|6[0-35-9]|7[67]|9[2-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              SR: [, [, , "(?:[2-5]|[6-8]\\d|90)\\d{5}", , , , , , , [6, 7]], [, , "(?:2[1-3]|3[0-7]|4\\d|5[2-58])\\d{4}", , , , "211234", , , [6]], [, , "(?:6[08]|7[124-7]|8[1-9])\\d{5}", , , , "7412345", , , [7]], [, , "80\\d{5}", , , , "8012345", , , [7]], [, , "90\\d{5}", , , , "9012345", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
                ,
                ,
                "56\\d{4}",
                ,
                ,
                ,
                "561234",
                ,
                ,
                [6]
              ], "SR", 597, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})", "$1-$2-$3", ["56"]], [, "(\\d{3})(\\d{3})", "$1-$2", ["[2-5]"]], [, "(\\d{3})(\\d{4})", "$1-$2", ["[6-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              SS: [, [, , "[19]\\d{8}", , , , , , , [9]], [, , "1[89]\\d{7}", , , , "181234567"], [, , "(?:12|9[1257-9])\\d{7}", , , , "977123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "SS", 211, "00", "0", , , "0", , , , [[
                ,
                "(\\d{3})(\\d{3})(\\d{3})",
                "$1 $2 $3",
                ["[19]"],
                "0$1"
              ]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              ST: [, [, , "(?:22|9\\d)\\d{5}", , , , , , , [7]], [, , "22\\d{5}", , , , "2221234"], [, , "900[5-9]\\d{3}|9(?:0[1-9]|[89]\\d)\\d{4}", , , , "9812345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "ST", 239, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[29]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              SV: [, [, , "[267]\\d{7}|(?:80\\d|900)\\d{4}(?:\\d{4})?", , , , , , , [7, 8, 11]], [
                ,
                ,
                "2(?:79(?:0[0347-9]|[1-9]\\d)|89(?:0[024589]|[1-9]\\d))\\d{3}|2(?:[1-69]\\d|[78][0-8])\\d{5}",
                ,
                ,
                ,
                "21234567",
                ,
                ,
                [8]
              ], [, , "[67]\\d{7}", , , , "70123456", , , [8]], [, , "800\\d{8}|80[01]\\d{4}", , , , "8001234", , , [7, 11]], [, , "900\\d{4}(?:\\d{4})?", , , , "9001234", , , [7, 11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "SV", 503, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[89]"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["[267]"]], [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[89]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              SX: [
                ,
                [, , "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]],
                [
                  ,
                  ,
                  "7215(?:4[2-8]|8[239]|9[056])\\d{4}",
                  ,
                  ,
                  ,
                  "7215425678",
                  ,
                  ,
                  ,
                  [7]
                ],
                [, , "7215(?:1[02]|2\\d|5[034679]|8[014-8])\\d{4}", , , , "7215205678", , , , [7]],
                [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002123456"],
                [, , "900[2-9]\\d{6}", , , , "9002123456"],
                [, , , , , , , , , [-1]],
                [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"],
                [, , , , , , , , , [-1]],
                "SX",
                1,
                "011",
                "1",
                ,
                ,
                "(5\\d{6})$|1",
                "721$1",
                ,
                ,
                ,
                ,
                [, , , , , , , , , [-1]],
                ,
                "721",
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]]
              ],
              SY: [, [, , "[1-359]\\d{8}|[1-5]\\d{7}", , , , , , , [8, 9], [6, 7]], [, , "21\\d{6,7}|(?:1(?:[14]\\d|[2356])|2[235]|3(?:[13]\\d|4)|4[134]|5[1-3])\\d{6}", , , , "112345678", , , , [6, 7]], [, , "(?:50|9[1-9])\\d{7}", , , , "944567890", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "SY", 963, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-4]|5[1-3]"], "0$1", , 1], [
                ,
                "(\\d{3})(\\d{3})(\\d{3})",
                "$1 $2 $3",
                ["[59]"],
                "0$1",
                ,
                1
              ]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              SZ: [, [, , "0800\\d{4}|(?:[237]\\d|900)\\d{6}", , , , , , , [8, 9]], [, , "[23][2-5]\\d{6}", , , , "22171234", , , [8]], [, , "7[5-9]\\d{6}", , , , "76123456", , , [8]], [, , "0800\\d{4}", , , , "08001234", , , [8]], [, , "900\\d{6}", , , , "900012345", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "70\\d{6}", , , , "70012345", , , [8]], "SZ", 268, "00", , , , , , , , [[, "(\\d{4})(\\d{4})", "$1 $2", ["[0237]"]], [, "(\\d{5})(\\d{4})", "$1 $2", ["9"]]], , [, , , , , , , , , [-1]], , , [
                ,
                ,
                "0800\\d{4}",
                ,
                ,
                ,
                ,
                ,
                ,
                [8]
              ], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              TA: [, [, , "8\\d{3}", , , , , , , [4]], [, , "8\\d{3}", , , , "8999"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "TA", 290, "00", , , , , , , , , , [, , , , , , , , , [-1]], , "8", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              TC: [
                ,
                [, , "(?:[58]\\d\\d|649|900)\\d{7}", , , , , , , [10], [7]],
                [, , "649(?:266|712|9(?:4\\d|50))\\d{4}", , , , "6497121234", , , , [7]],
                [, , "649(?:2(?:3[129]|4[1-79])|3\\d\\d|4[34][1-3])\\d{4}", , , , "6492311234", , , , [7]],
                [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002345678"],
                [, , "900[2-9]\\d{6}", , , , "9002345678"],
                [, , , , , , , , , [-1]],
                [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"],
                [, , "649(?:71[01]|966)\\d{4}", , , , "6497101234", , , , [7]],
                "TC",
                1,
                "011",
                "1",
                ,
                ,
                "([2-479]\\d{6})$|1",
                "649$1",
                ,
                ,
                ,
                ,
                [, , , , , , , , , [-1]],
                ,
                "649",
                [
                  ,
                  ,
                  ,
                  ,
                  ,
                  ,
                  ,
                  ,
                  ,
                  [-1]
                ],
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]]
              ],
              TD: [, [, , "(?:22|30|[689]\\d|77)\\d{6}", , , , , , , [8]], [, , "22(?:[37-9]0|5[0-5]|6[89])\\d{4}", , , , "22501234"], [, , "(?:30|[69]\\d|77|8[56])\\d{6}", , , , "63012345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "TD", 235, "00|16", , , , , , "00", , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[236-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              TG: [, [, , "[279]\\d{7}", , , , , , , [8]], [
                ,
                ,
                "2(?:2[2-7]|3[23]|4[45]|55|6[67]|77)\\d{5}",
                ,
                ,
                ,
                "22212345"
              ], [, , "(?:7[0-29]|9[0-36-9])\\d{6}", , , , "90112345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "TG", 228, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[279]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              TH: [, [, , "(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}", , , , , , , [8, 9, 10, 13]], [, , "(?:1[0689]|2\\d|3[2-9]|4[2-5]|5[2-6]|7[3-7])\\d{6}", , , , "21234567", , , [8]], [
                ,
                ,
                "67(?:1[0-8]|2[4-7])\\d{5}|(?:14|6[1-6]|[89]\\d)\\d{7}",
                ,
                ,
                ,
                "812345678",
                ,
                ,
                [9]
              ], [, , "(?:001800\\d|1800)\\d{6}", , , , "1800123456", , , [10, 13]], [, , "1900\\d{6}", , , , "1900123456", , , [10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "6[08]\\d{7}", , , , "601234567", , , [9]], "TH", 66, "00[1-9]", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[13-9]"], "0$1"], [, "(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              TJ: [
                ,
                [, , "[0-57-9]\\d{8}", , , , , , , [9], [3, 5, 6, 7]],
                [
                  ,
                  ,
                  "(?:3(?:1[3-5]|2[245]|3[12]|4[24-7]|5[25]|72)|4(?:46|74|87))\\d{6}",
                  ,
                  ,
                  ,
                  "372123456",
                  ,
                  ,
                  ,
                  [3, 5, 6, 7]
                ],
                [, , "(?:33[03-9]|4(?:1[18]|4[02-479])|81[1-9])\\d{6}|(?:[09]\\d|1[0-27-9]|2[0-27]|[34]0|5[05]|7[01578]|8[078])\\d{7}", , , , "917123456"],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                "TJ",
                992,
                "810",
                ,
                ,
                ,
                ,
                ,
                "8~10",
                ,
                [[, "(\\d{6})(\\d)(\\d{2})", "$1 $2 $3", ["331", "3317"]], [, "(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["44[02-479]|[34]7"]], [, "(\\d{4})(\\d)(\\d{4})", "$1 $2 $3", ["3(?:[1245]|3[12])"]], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[0-57-9]"]]],
                ,
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]]
              ],
              TK: [, [, , "[2-47]\\d{3,6}", , , , , , , [4, 5, 6, 7]], [, , "(?:2[2-4]|[34]\\d)\\d{2,5}", , , , "3101"], [, , "7[2-4]\\d{2,5}", , , , "7290"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "TK", 690, "00", , , , , , , , , , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              TL: [, [, , "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}", , , , , , , [7, 8]], [, , "(?:2[1-5]|3[1-9]|4[1-4])\\d{5}", , , , "2112345", , , [7]], [
                ,
                ,
                "7[2-8]\\d{6}",
                ,
                ,
                ,
                "77212345",
                ,
                ,
                [8]
              ], [, , "80\\d{5}", , , , "8012345", , , [7]], [, , "90\\d{5}", , , , "9012345", , , [7]], [, , , , , , , , , [-1]], [, , "70\\d{5}", , , , "7012345", , , [7]], [, , , , , , , , , [-1]], "TL", 670, "00", , , , , , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[2-489]|70"]], [, "(\\d{4})(\\d{4})", "$1 $2", ["7"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              TM: [, [, , "(?:[1-6]\\d|71)\\d{6}", , , , , , , [8]], [, , "(?:1(?:2\\d|3[1-9])|2(?:22|4[0-35-8])|3(?:22|4[03-9])|4(?:22|3[128]|4\\d|6[15])|5(?:22|5[7-9]|6[014-689]))\\d{5}", , , , "12345678"], [
                ,
                ,
                "(?:6\\d|71)\\d{6}",
                ,
                ,
                ,
                "66123456"
              ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "TM", 993, "810", "8", , , "8", , "8~10", , [[, "(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["12"], "(8 $1)"], [, "(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-5]"], "(8 $1)"], [, "(\\d{2})(\\d{6})", "$1 $2", ["[67]"], "8 $1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              TN: [, [, , "[2-57-9]\\d{7}", , , , , , , [8]], [, , "81200\\d{3}|(?:3[0-2]|7\\d)\\d{6}", , , , "30010123"], [
                ,
                ,
                "3(?:001|[12]40)\\d{4}|(?:(?:[259]\\d|4[0-8])\\d|3(?:1[1-35]|6[0-4]|91))\\d{5}",
                ,
                ,
                ,
                "20123456"
              ], [, , "8010\\d{4}", , , , "80101234"], [, , "88\\d{6}", , , , "88123456"], [, , "8[12]10\\d{4}", , , , "81101234"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "TN", 216, "00", , , , , , , , [[, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-57-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              TO: [, [, , "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}", , , , , , , [5, 7]], [, , "(?:2\\d|3[0-8]|4[0-4]|50|6[09]|7[0-24-69]|8[05])\\d{3}", , , , "20123", , , [5]], [
                ,
                ,
                "(?:5(?:4[0-5]|5[4-6])|6(?:[09]\\d|3[02]|8[15-9])|(?:7\\d|8[46-9])\\d|999)\\d{4}",
                ,
                ,
                ,
                "7715123",
                ,
                ,
                [7]
              ], [, , "0800\\d{3}", , , , "0800222", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "55[0-37-9]\\d{4}", , , , "5510123", , , [7]], "TO", 676, "00", , , , , , , , [[, "(\\d{2})(\\d{3})", "$1-$2", ["[2-4]|50|6[09]|7[0-24-69]|8[05]"]], [, "(\\d{4})(\\d{3})", "$1 $2", ["0"]], [, "(\\d{3})(\\d{4})", "$1 $2", ["[5-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              TR: [, [, , "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}", , , , , , , [7, 10, 12, 13]], [
                ,
                ,
                "(?:2(?:[13][26]|[28][2468]|[45][268]|[67][246])|3(?:[13][28]|[24-6][2468]|[78][02468]|92)|4(?:[16][246]|[23578][2468]|4[26]))\\d{7}",
                ,
                ,
                ,
                "2123456789",
                ,
                ,
                [10]
              ], [, , "561(?:011|61\\d)\\d{4}|5(?:0[15-7]|1[06]|24|[34]\\d|5[1-59]|9[46])\\d{7}", , , , "5012345678", , , [10]], [, , "8(?:00\\d{7}(?:\\d{2,3})?|11\\d{7})", , , , "8001234567", , , [10, 12, 13]], [, , "(?:8[89]8|900)\\d{7}", , , , "9001234567", , , [10]], [, , , , , , , , , [-1]], [, , "592(?:21[12]|461)\\d{4}", , , , "5922121234", , , [10]], [, , "850\\d{7}", , , , "8500123456", , , [10]], "TR", 90, "00", "0", , , "0", , , , [
                [, "(\\d{3})(\\d)(\\d{3})", "$1 $2 $3", ["444"], , , 1],
                [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["512|8[01589]|90"], "0$1", , 1],
                [, "(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5(?:[0-59]|61)", "5(?:[0-59]|61[06])", "5(?:[0-59]|61[06]1)"], "0$1", , 1],
                [, "(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24][1-8]|3[1-9]"], "(0$1)", , 1],
                [, "(\\d{3})(\\d{3})(\\d{6,7})", "$1 $2 $3", ["80"], "0$1", , 1]
              ], [[, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["512|8[01589]|90"], "0$1", , 1], [, "(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5(?:[0-59]|61)", "5(?:[0-59]|61[06])", "5(?:[0-59]|61[06]1)"], "0$1", , 1], [
                ,
                "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                "$1 $2 $3 $4",
                ["[24][1-8]|3[1-9]"],
                "(0$1)",
                ,
                1
              ], [, "(\\d{3})(\\d{3})(\\d{6,7})", "$1 $2 $3", ["80"], "0$1", , 1]], [, , "512\\d{7}", , , , "5123456789", , , [10]], , , [, , "(?:444|811\\d{3})\\d{4}", , , , , , , [7, 10]], [, , "444\\d{4}", , , , "4441444", , , [7]], , , [, , , , , , , , , [-1]]],
              TT: [, [, , "(?:[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]], [, , "868(?:2(?:01|1[5-9]|[23]\\d|4[0-2])|6(?:0[7-9]|1[02-8]|2[1-9]|[3-69]\\d|7[0-79])|82[124])\\d{4}", , , , "8682211234", , , , [7]], [
                ,
                ,
                "868(?:(?:2[5-9]|3\\d)\\d|4(?:3[0-6]|[6-9]\\d)|6(?:20|78|8\\d)|7(?:0[1-9]|1[02-9]|[2-9]\\d))\\d{4}",
                ,
                ,
                ,
                "8682911234",
                ,
                ,
                ,
                [7]
              ], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002345678"], [, , "900[2-9]\\d{6}", , , , "9002345678"], [, , , , , , , , , [-1]], [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "TT", 1, "011", "1", , , "([2-46-8]\\d{6})$|1", "868$1", , , , , [, , , , , , , , , [-1]], , "868", [, , , , , , , , , [-1]], [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ], , , [, , "868619\\d{4}", , , , "8686191234", , , , [7]]],
              TV: [, [, , "(?:2|7\\d\\d|90)\\d{4}", , , , , , , [5, 6, 7]], [, , "2[02-9]\\d{3}", , , , "20123", , , [5]], [, , "(?:7[01]\\d|90)\\d{4}", , , , "901234", , , [6, 7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "TV", 688, "00", , , , , , , , [[, "(\\d{2})(\\d{3})", "$1 $2", ["2"]], [, "(\\d{2})(\\d{4})", "$1 $2", ["90"]], [, "(\\d{2})(\\d{5})", "$1 $2", ["7"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              TW: [, [
                ,
                ,
                "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [7, 8, 9, 10, 11]
              ], [
                ,
                ,
                "(?:2[2-8]\\d|370|55[01]|7[1-9])\\d{6}|4(?:(?:0(?:0[1-9]|[2-48]\\d)|1[023]\\d)\\d{4,5}|(?:[239]\\d\\d|4(?:0[56]|12|49))\\d{5})|6(?:[01]\\d{7}|4(?:0[56]|12|24|4[09])\\d{4,5})|8(?:(?:2(?:3\\d|4[0-269]|[578]0|66)|36[24-9]|90\\d\\d)\\d{4}|4(?:0[56]|12|24|4[09])\\d{4,5})|(?:2(?:2(?:0\\d\\d|4(?:0[68]|[249]0|3[0-467]|5[0-25-9]|6[0235689]))|(?:3(?:[09]\\d|1[0-4])|(?:4\\d|5[0-49]|6[0-29]|7[0-5])\\d)\\d)|(?:(?:3[2-9]|5[2-8]|6[0-35-79]|8[7-9])\\d\\d|4(?:2(?:[089]\\d|7[1-9])|(?:3[0-4]|[78]\\d|9[01])\\d))\\d)\\d{3}",
                ,
                ,
                ,
                "221234567",
                ,
                ,
                [8, 9]
              ], [, , "(?:40001[0-2]|9[0-8]\\d{4})\\d{3}", , , , "912345678", , , [9]], [, , "80[0-79]\\d{6}|800\\d{5}", , , , "800123456", , , [8, 9]], [, , "20(?:[013-9]\\d\\d|2)\\d{4}", , , , "203123456", , , [7, 9]], [, , , , , , , , , [-1]], [, , "99\\d{7}", , , , "990123456", , , [9]], [, , "7010(?:[0-2679]\\d|3[0-7]|8[0-5])\\d{5}|70\\d{8}", , , , "7012345678", , , [10, 11]], "TW", 886, "0(?:0[25-79]|19)", "0", "#", , "0", , , , [[, "(\\d{2})(\\d)(\\d{4})", "$1 $2 $3", ["202"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[258]0"], "0$1"], [
                ,
                "(\\d)(\\d{3,4})(\\d{4})",
                "$1 $2 $3",
                ["[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]", "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"],
                "0$1"
              ], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"], "0$1"], [, "(\\d{2})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["7"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "50[0-46-9]\\d{6}", , , , "500123456", , , [9]], , , [, , , , , , , , , [-1]]],
              TZ: [
                ,
                [, , "(?:[25-8]\\d|41|90)\\d{7}", , , , , , , [9]],
                [, , "2[2-8]\\d{7}", , , , "222345678"],
                [, , "(?:6[125-9]|7[13-9])\\d{7}", , , , "621234567"],
                [, , "80[08]\\d{6}", , , , "800123456"],
                [, , "90\\d{7}", , , , "900123456"],
                [, , "8(?:40|6[01])\\d{6}", , , , "840123456"],
                [, , , , , , , , , [-1]],
                [, , "41\\d{7}", , , , "412345678"],
                "TZ",
                255,
                "00[056]",
                "0",
                ,
                ,
                "0",
                ,
                ,
                ,
                [[, "(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[24]"], "0$1"], [, "(\\d{2})(\\d{7})", "$1 $2", ["5"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[67]"], "0$1"]],
                ,
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , "(?:8(?:[04]0|6[01])|90\\d)\\d{6}"],
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]]
              ],
              UA: [, [, , "[89]\\d{9}|[3-9]\\d{8}", , , , , , , [9, 10], [5, 6, 7]], [
                ,
                ,
                "(?:3[1-8]|4[13-8]|5[1-7]|6[12459])\\d{7}",
                ,
                ,
                ,
                "311234567",
                ,
                ,
                [9],
                [5, 6, 7]
              ], [, , "790\\d{6}|(?:39|50|6[36-8]|7[1-357]|9[1-9])\\d{7}", , , , "501234567", , , [9]], [, , "800[1-8]\\d{5,6}", , , , "800123456"], [, , "900[239]\\d{5,6}", , , , "900212345"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "89[1-579]\\d{6}", , , , "891234567", , , [9]], "UA", 380, "00", "0", , , "0", , "0~0", , [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]", "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"], "0$1"], [
                ,
                "(\\d{4})(\\d{5})",
                "$1 $2",
                ["3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])", "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"],
                "0$1"
              ], [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|89|9[1-9]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              UG: [, [, , "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}", , , , , , , [9], [5, 6, 7]], [
                ,
                ,
                "20(?:(?:240|30[67])\\d|6(?:00[0-2]|30[0-4]))\\d{3}|(?:20(?:[017]\\d|2[5-9]|3[1-4]|5[0-4]|6[15-9])|[34]\\d{3})\\d{5}",
                ,
                ,
                ,
                "312345678",
                ,
                ,
                ,
                [5, 6, 7]
              ], [, , "72[48]0\\d{5}|7(?:[014-8]\\d|2[067]|36|9[0189])\\d{6}", , , , "712345678"], [, , "800[1-3]\\d{5}", , , , "800123456"], [, , "90[1-3]\\d{6}", , , , "901123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "UG", 256, "00[057]", "0", , , "0", , , , [[, "(\\d{4})(\\d{5})", "$1 $2", ["202", "2024"], "0$1"], [, "(\\d{3})(\\d{6})", "$1 $2", ["[27-9]|4(?:6[45]|[7-9])"], "0$1"], [, "(\\d{2})(\\d{7})", "$1 $2", ["[34]"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              US: [, [
                ,
                ,
                "[2-9]\\d{9}|3\\d{6}",
                ,
                ,
                ,
                ,
                ,
                ,
                [10],
                [7]
              ], [
                ,
                ,
                "(?:3052(?:0[0-8]|[1-9]\\d)|5056(?:[0-35-9]\\d|4[0-68]))\\d{4}|(?:2742|305[3-9]|(?:472|983)[2-47-9]|505[2-57-9])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[1459]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-47-9]|1[02-9]|2[0135-79]|3[0-24679]|4[167]|5[0-2]|6[01349]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[0156]|5[01679]|6[0-279]|78|8[0-269])|7(?:0[1-46-8]|1[2-9]|2[04-8]|3[0-247]|4[0378]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[0168]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-3589]|8[04-69]))[2-9]\\d{6}",
                ,
                ,
                ,
                "2015550123",
                ,
                ,
                ,
                [7]
              ], [
                ,
                ,
                "(?:3052(?:0[0-8]|[1-9]\\d)|5056(?:[0-35-9]\\d|4[0-68]))\\d{4}|(?:2742|305[3-9]|(?:472|983)[2-47-9]|505[2-57-9])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[1459]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-47-9]|1[02-9]|2[0135-79]|3[0-24679]|4[167]|5[0-2]|6[01349]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[0156]|5[01679]|6[0-279]|78|8[0-269])|7(?:0[1-46-8]|1[2-9]|2[04-8]|3[0-247]|4[0378]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[0168]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-3589]|8[04-69]))[2-9]\\d{6}",
                ,
                ,
                ,
                "2015550123",
                ,
                ,
                ,
                [7]
              ], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002345678"], [, , "900[2-9]\\d{6}", , , , "9002345678"], [, , , , , , , , , [-1]], [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , "305209\\d{4}", , , , "3052090123", , , , [7]], "US", 1, "011", "1", , , "1", , , 1, [
                [, "(\\d{3})(\\d{4})", "$1-$2", ["310"], , , 1],
                [, "(\\d{3})(\\d{4})", "$1-$2", ["[24-9]|3(?:[02-9]|1[1-9])"]],
                [, "(\\d{3})(\\d{3})(\\d{4})", "($1) $2-$3", ["[2-9]"], , , 1]
              ], [[, "(\\d{3})(\\d{4})", "$1-$2", ["310"], , , 1], [, "(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-9]"]]], [, , , , , , , , , [-1]], 1, , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              UY: [, [, , "0004\\d{2,9}|[1249]\\d{7}|2\\d{3,4}|(?:[49]\\d|80)\\d{5}", , , , , , , [4, 5, 6, 7, 8, 9, 10, 11, 12, 13]], [, , "(?:1(?:770|9(?:20|[89]7))|(?:2\\d|4[2-7])\\d\\d)\\d{4}", , , , "21231234", , , [8], [7]], [
                ,
                ,
                "9[1-9]\\d{6}",
                ,
                ,
                ,
                "94231234",
                ,
                ,
                [8]
              ], [, , "0004\\d{2,9}|(?:405|80[05])\\d{4}", , , , "8001234", , , [6, 7, 8, 9, 10, 11, 12, 13]], [, , "90[0-8]\\d{4}", , , , "9001234", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "UY", 598, "0(?:0|1[3-9]\\d)", "0", " int. ", , "0", , "00", , [[, "(\\d{4,5})", "$1", ["21"]], [, "(\\d{3})(\\d{3,4})", "$1 $2", ["0"]], [, "(\\d{3})(\\d{4})", "$1 $2", ["[49]0|8"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"], [, "(\\d{4})(\\d{4})", "$1 $2", ["[124]"]], [, "(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["0"]], [
                ,
                "(\\d{3})(\\d{3})(\\d{3})(\\d{2,4})",
                "$1 $2 $3 $4",
                ["0"]
              ]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "21\\d{2,3}", , , , "21123", , , [4, 5]], , , [, , , , , , , , , [-1]]],
              UZ: [
                ,
                [, , "(?:20|33|[5-9]\\d)\\d{7}", , , , , , , [9]],
                [, , "(?:55\\d\\d|6(?:1(?:22|3[124]|4[1-4]|5[1-3578]|64)|2(?:22|3[0-57-9]|41)|5(?:22|3[3-7]|5[024-8])|[69]\\d\\d|7(?:[23]\\d|7[69]))|7(?:0(?:5[4-9]|6[0146]|7[124-6]|9[135-8])|[168]\\d\\d|2(?:22|3[13-57-9]|4[1-3579]|5[14])|3(?:2\\d|3[1578]|4[1-35-7]|5[1-57]|61)|4(?:2\\d|3[1-579]|7[1-79])|5(?:22|5[1-9]|6[1457])|9(?:22|5[1-9])))\\d{5}", , , , "669050123"],
                [
                  ,
                  ,
                  "(?:(?:[25]0|33|8[78]|9[0-57-9])\\d{3}|6(?:1(?:2(?:2[01]|98)|35[0-4]|50\\d|61[23]|7(?:[01][017]|4\\d|55|9[5-9]))|2(?:(?:11|7\\d)\\d|2(?:[12]1|9[01379])|5(?:[126]\\d|3[0-4]))|5(?:19[01]|2(?:27|9[26])|(?:30|59|7\\d)\\d)|6(?:2(?:1[5-9]|2[0367]|38|41|52|60)|(?:3[79]|9[0-3])\\d|4(?:56|83)|7(?:[07]\\d|1[017]|3[07]|4[047]|5[057]|67|8[0178]|9[79]))|7(?:2(?:24|3[237]|4[5-9]|7[15-8])|5(?:7[12]|8[0589])|7(?:0\\d|[39][07])|9(?:0\\d|7[079])))|7(?:[07]\\d{3}|2(?:2(?:2[79]|95)|3(?:2[5-9]|6[0-6])|57\\d|7(?:0\\d|1[17]|2[27]|3[37]|44|5[057]|66|88))|3(?:2(?:1[0-6]|21|3[469]|7[159])|(?:33|9[4-6])\\d|5(?:0[0-4]|5[579]|9\\d)|7(?:[0-3579]\\d|4[0467]|6[67]|8[078]))|4(?:2(?:29|5[0257]|6[0-7]|7[1-57])|5(?:1[0-4]|8\\d|9[5-9])|7(?:0\\d|1[024589]|2[0-27]|3[0137]|[46][07]|5[01]|7[5-9]|9[079])|9(?:7[015-9]|[89]\\d))|5(?:112|2(?:0\\d|2[29]|[49]4)|3[1568]\\d|52[6-9]|7(?:0[01578]|1[017]|[23]7|4[047]|[5-7]\\d|8[78]|9[079]))|9(?:22[128]|3(?:2[0-4]|7\\d)|57[02569]|7(?:2[05-9]|3[37]|4\\d|60|7[2579]|87|9[07]))))\\d{4}",
                  ,
                  ,
                  ,
                  "912345678"
                ],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                "UZ",
                998,
                "00",
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [[, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[235-9]"]]],
                ,
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]]
              ],
              VA: [, [, , "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}", , , , , , , [6, 7, 8, 9, 10, 11, 12]], [, , "06698\\d{1,6}", , , , "0669812345", , , [6, 7, 8, 9, 10, 11]], [, , "3[1-9]\\d{8}|3[2-9]\\d{7}", , , , "3123456789", , , [9, 10]], [
                ,
                ,
                "80(?:0\\d{3}|3)\\d{3}",
                ,
                ,
                ,
                "800123456",
                ,
                ,
                [6, 9]
              ], [, , "(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}", , , , "899123456", , , [6, 8, 9, 10]], [, , "84(?:[08]\\d{3}|[17])\\d{3}", , , , "848123456", , , [6, 9]], [, , "1(?:78\\d|99)\\d{6}", , , , "1781234567", , , [9, 10]], [, , "55\\d{8}", , , , "5512345678", , , [10]], "VA", 39, "00", , , , , , , , , , [, , , , , , , , , [-1]], , "06698", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , "3[2-8]\\d{9,10}", , , , "33101234501", , , [11, 12]]],
              VC: [
                ,
                [, , "(?:[58]\\d\\d|784|900)\\d{7}", , , , , , , [10], [7]],
                [, , "784(?:266|3(?:6[6-9]|7\\d|8[0-6])|4(?:38|5[0-36-8]|8[0-8])|5(?:55|7[0-2]|93)|638|784)\\d{4}", , , , "7842661234", , , , [7]],
                [, , "784(?:4(?:3[0-5]|5[45]|89|9[0-8])|5(?:2[6-9]|3[0-4])|720)\\d{4}", , , , "7844301234", , , , [7]],
                [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002345678"],
                [, , "900[2-9]\\d{6}", , , , "9002345678"],
                [, , , , , , , , , [-1]],
                [
                  ,
                  ,
                  "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
                  ,
                  ,
                  ,
                  "5002345678"
                ],
                [, , "78451[0-2]\\d{4}", , , , "7845101234", , , , [7]],
                "VC",
                1,
                "011",
                "1",
                ,
                ,
                "([2-7]\\d{6})$|1",
                "784$1",
                ,
                ,
                ,
                ,
                [, , , , , , , , , [-1]],
                ,
                "784",
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]]
              ],
              VE: [
                ,
                [, , "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}", , , , , , , [10], [7]],
                [, , "(?:2(?:12|3[457-9]|[467]\\d|[58][1-9]|9[1-6])|[4-6]00)\\d{7}", , , , "2121234567", , , , [7]],
                [, , "4(?:1[24-8]|2[246])\\d{7}", , , , "4121234567"],
                [, , "800\\d{7}", , , , "8001234567"],
                [, , "90[01]\\d{7}", , , , "9001234567"],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                "VE",
                58,
                "00",
                "0",
                ,
                ,
                "0",
                ,
                ,
                ,
                [[, "(\\d{3})(\\d{7})", "$1-$2", ["[24-689]"], "0$1", "$CC $1"]],
                ,
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]],
                [, , "501\\d{7}", , , , "5010123456", , , , [7]],
                ,
                ,
                [, , , , , , , , , [-1]]
              ],
              VG: [, [, , "(?:284|[58]\\d\\d|900)\\d{7}", , , , , , , [10], [7]], [, , "284(?:229|4(?:22|9[45])|774|8(?:52|6[459]))\\d{4}", , , , "2842291234", , , , [7]], [, , "284(?:245|3(?:0[0-3]|4[0-7]|68|9[34])|4(?:4[0-6]|68|9[69])|5(?:4[0-7]|68|9[69]))\\d{4}", , , , "2843001234", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002345678"], [
                ,
                ,
                "900[2-9]\\d{6}",
                ,
                ,
                ,
                "9002345678"
              ], [, , , , , , , , , [-1]], [, , "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}", , , , "5002345678"], [, , , , , , , , , [-1]], "VG", 1, "011", "1", , , "([2-578]\\d{6})$|1", "284$1", , , , , [, , , , , , , , , [-1]], , "284", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              VI: [, [, , "[58]\\d{9}|(?:34|90)0\\d{7}", , , , , , , [10], [7]], [
                ,
                ,
                "340(?:2(?:0\\d|10|2[06-8]|4[49]|77)|3(?:32|44)|4(?:2[23]|44|7[34]|89)|5(?:1[34]|55)|6(?:2[56]|4[23]|77|9[023])|7(?:1[2-57-9]|2[57]|7\\d)|884|998)\\d{4}",
                ,
                ,
                ,
                "3406421234",
                ,
                ,
                ,
                [7]
              ], [, , "340(?:2(?:0\\d|10|2[06-8]|4[49]|77)|3(?:32|44)|4(?:2[23]|44|7[34]|89)|5(?:1[34]|55)|6(?:2[56]|4[23]|77|9[023])|7(?:1[2-57-9]|2[57]|7\\d)|884|998)\\d{4}", , , , "3406421234", , , , [7]], [, , "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", , , , "8002345678"], [, , "900[2-9]\\d{6}", , , , "9002345678"], [, , , , , , , , , [-1]], [
                ,
                ,
                "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}",
                ,
                ,
                ,
                "5002345678"
              ], [, , , , , , , , , [-1]], "VI", 1, "011", "1", , , "([2-9]\\d{6})$|1", "340$1", , 1, , , [, , , , , , , , , [-1]], , "340", [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              VN: [, [, , "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}", , , , , , , [7, 8, 9, 10]], [, , "2(?:0[3-9]|1[0-689]|2[0-25-9]|[38][2-9]|4[2-8]|5[124-9]|6[0-39]|7[0-7]|9[0-4679])\\d{7}", , , , "2101234567", , , [10]], [, , "(?:5(?:2[238]|59)|89[6-9]|99[013-9])\\d{6}|(?:3\\d|5[1689]|7[06-9]|8[1-8]|9[0-8])\\d{7}", , , , "912345678", , , [9]], [
                ,
                ,
                "1800\\d{4,6}|12(?:0[13]|28)\\d{4}",
                ,
                ,
                ,
                "1800123456",
                ,
                ,
                [8, 9, 10]
              ], [, , "1900\\d{4,6}", , , , "1900123456", , , [8, 9, 10]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "672\\d{6}", , , , "672012345", , , [9]], "VN", 84, "00", "0", , , "0", , , , [[, "(\\d{3})(\\d{4})", "$1 $2", ["[17]99"], "0$1", , 1], [, "(\\d{2})(\\d{5})", "$1 $2", ["80"], "0$1", , 1], [, "(\\d{3})(\\d{4,5})", "$1 $2", ["69"], "0$1", , 1], [, "(\\d{4})(\\d{4,6})", "$1 $2", ["1"], , , 1], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["6"], "0$1", , 1], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[357-9]"], "0$1", , 1], [
                ,
                "(\\d{2})(\\d{4})(\\d{4})",
                "$1 $2 $3",
                ["2[48]"],
                "0$1",
                ,
                1
              ], [, "(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["2"], "0$1", , 1]], [[, "(\\d{2})(\\d{5})", "$1 $2", ["80"], "0$1", , 1], [, "(\\d{4})(\\d{4,6})", "$1 $2", ["1"], , , 1], [, "(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["6"], "0$1", , 1], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[357-9]"], "0$1", , 1], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["2[48]"], "0$1", , 1], [, "(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["2"], "0$1", , 1]], [, , , , , , , , , [-1]], , , [, , "[17]99\\d{4}|69\\d{5,6}", , , , , , , [7, 8]], [
                ,
                ,
                "(?:[17]99|80\\d)\\d{4}|69\\d{5,6}",
                ,
                ,
                ,
                "1992000",
                ,
                ,
                [7, 8]
              ], , , [, , , , , , , , , [-1]]],
              VU: [
                ,
                [, , "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}", , , , , , , [5, 7]],
                [, , "(?:38[0-8]|48[4-9])\\d\\d|(?:2[02-9]|3[4-7]|88)\\d{3}", , , , "22123", , , [5]],
                [, , "(?:[58]\\d|7[013-7])\\d{5}", , , , "5912345", , , [7]],
                [, , "81[18]\\d\\d", , , , "81123", , , [5]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , "9(?:0[1-9]|1[01])\\d{4}", , , , "9010123", , , [7]],
                "VU",
                678,
                "00",
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [[, "(\\d{3})(\\d{4})", "$1 $2", ["[57-9]"]]],
                ,
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]],
                [, , "(?:3[03]|900\\d)\\d{3}", , , , "30123"],
                ,
                ,
                [, , , , , , , , , [-1]]
              ],
              WF: [, [, , "(?:40|72|8\\d{4})\\d{4}|[89]\\d{5}", , , , , , , [6, 9]], [, , "72\\d{4}", , , , "721234", , , [6]], [, , "(?:72|8[23])\\d{4}", , , , "821234", , , [6]], [, , "80[0-5]\\d{6}", , , , "800012345", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "9[23]\\d{4}", , , , "921234", , , [6]], "WF", 681, "00", , , , , , , , [[, "(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[47-9]"]], [, "(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , "[48]0\\d{4}", , , , "401234", , , [6]]],
              WS: [
                ,
                [, , "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}", , , , , , , [5, 6, 7, 10]],
                [, , "6[1-9]\\d{3}|(?:[2-5]|60)\\d{4}", , , , "22123", , , [5, 6]],
                [, , "(?:7[1-35-8]|8(?:[3-7]|9\\d{3}))\\d{5}", , , , "7212345", , , [7, 10]],
                [, , "800\\d{3}", , , , "800123", , , [6]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                "WS",
                685,
                "0",
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [[, "(\\d{5})", "$1", ["[2-5]|6[1-9]"]], [, "(\\d{3})(\\d{3,7})", "$1 $2", ["[68]"]], [, "(\\d{2})(\\d{5})", "$1 $2", ["7"]]],
                ,
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]]
              ],
              XK: [
                ,
                [, , "2\\d{7,8}|3\\d{7,11}|(?:4\\d\\d|[89]00)\\d{5}", , , , , , , [8, 9, 10, 11, 12]],
                [, , "38\\d{6,10}|(?:2[89]|39)(?:0\\d{5,6}|[1-9]\\d{5})", , , , "28012345"],
                [, , "4[3-9]\\d{6}", , , , "43201234", , , [8]],
                [, , "800\\d{5}", , , , "80001234", , , [8]],
                [, , "900\\d{5}", , , , "90001234", , , [8]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                "XK",
                383,
                "00",
                "0",
                ,
                ,
                "0",
                ,
                ,
                ,
                [[, "(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-4]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2|39"], "0$1"], [
                  ,
                  "(\\d{2})(\\d{7,10})",
                  "$1 $2",
                  ["3"],
                  "0$1"
                ]],
                ,
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]]
              ],
              YE: [, [, , "(?:1|7\\d)\\d{7}|[1-7]\\d{6}", , , , , , , [7, 8, 9], [6]], [, , "78[0-7]\\d{4}|17\\d{6}|(?:[12][2-68]|3[2358]|4[2-58]|5[2-6]|6[3-58]|7[24-6])\\d{5}", , , , "1234567", , , [7, 8], [6]], [, , "7[01378]\\d{7}", , , , "712345678", , , [9]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "YE", 967, "00", "0", , , "0", , , , [[, "(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-6]|7(?:[24-6]|8[0-7])"], "0$1"], [
                ,
                "(\\d{3})(\\d{3})(\\d{3})",
                "$1 $2 $3",
                ["7"],
                "0$1"
              ]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              YT: [
                ,
                [, , "7093\\d{5}|(?:80|9\\d)\\d{7}|(?:26|63)9\\d{6}", , , , , , , [9]],
                [, , "269(?:0[0-467]|15|5[0-4]|6\\d|[78]0)\\d{4}", , , , "269601234"],
                [, , "(?:639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])|7093[5-7])\\d{4}", , , , "639012345"],
                [, , "80\\d{7}", , , , "801234567"],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , "9(?:(?:39|47)8[01]|769\\d)\\d{4}", , , , "939801234"],
                "YT",
                262,
                "00",
                "0",
                ,
                ,
                "0",
                ,
                ,
                ,
                ,
                ,
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]]
              ],
              ZA: [, [, , "[1-79]\\d{8}|8\\d{4,9}", , , , , , , [5, 6, 7, 8, 9, 10]], [, , "(?:2(?:0330|4302)|52087)0\\d{3}|(?:1[0-8]|2[1-378]|3[1-69]|4\\d|5[1346-8])\\d{7}", , , , "101234567", , , [9]], [
                ,
                ,
                "(?:1(?:3492[0-25]|4495[0235]|549(?:20|5[01]))|4[34]492[01])\\d{3}|8[1-4]\\d{3,7}|(?:2[27]|47|54)4950\\d{3}|(?:1(?:049[2-4]|9[12]\\d\\d)|(?:50[0-2]|6\\d\\d|7(?:[0-46-9]\\d|5[0-4]))\\d\\d|8(?:5\\d{3}|7(?:08[67]|158|28[5-9]|310)))\\d{4}|(?:1[6-8]|28|3[2-69]|4[025689]|5[36-8])4920\\d{3}|(?:12|[2-5]1)492\\d{4}",
                ,
                ,
                ,
                "711234567",
                ,
                ,
                [5, 6, 7, 8, 9]
              ], [, , "80\\d{7}", , , , "801234567", , , [9]], [, , "(?:86[2-9]|9[0-2]\\d)\\d{6}", , , , "862345678", , , [9]], [, , "860\\d{6}", , , , "860123456", , , [9]], [, , , , , , , , , [-1]], [, , "87(?:08[0-589]|15[0-79]|28[0-4]|31[1-9])\\d{4}|87(?:[02][0-79]|1[0-46-9]|3[02-9]|[4-9]\\d)\\d{5}", , , , "871234567", , , [9]], "ZA", 27, "00", "0", , , "0", , , , [[, "(\\d{2})(\\d{3,4})", "$1 $2", ["8[1-4]"], "0$1"], [, "(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["8[1-4]"], "0$1"], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["860"], "0$1"], [
                ,
                "(\\d{2})(\\d{3})(\\d{4})",
                "$1 $2 $3",
                ["[1-9]"],
                "0$1"
              ], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "861\\d{6,7}", , , , "861123456", , , [9, 10]], , , [, , , , , , , , , [-1]]],
              ZM: [, [, , "800\\d{6}|(?:21|[579]\\d|63)\\d{7}", , , , , , , [9], [6]], [, , "21[1-8]\\d{6}", , , , "211234567", , , , [6]], [, , "(?:[59][5-8]|7[5-9])\\d{7}", , , , "955123456"], [, , "800\\d{6}", , , , "800123456"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "63\\d{7}", , , , "630123456"], "ZM", 260, "00", "0", , , "0", , , , [
                [, "(\\d{3})(\\d{3})", "$1 $2", ["[1-9]"]],
                [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[28]"], "0$1"],
                [, "(\\d{2})(\\d{7})", "$1 $2", ["[579]"], "0$1"]
              ], [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[28]"], "0$1"], [, "(\\d{2})(\\d{7})", "$1 $2", ["[579]"], "0$1"]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              ZW: [, [, , "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}", , , , , , , [5, 6, 7, 8, 9, 10], [3, 4]], [
                ,
                ,
                "(?:1(?:(?:3\\d|9)\\d|[4-8])|2(?:(?:(?:0(?:2[014]|5)|(?:2[0157]|31|84|9)\\d\\d|[56](?:[14]\\d\\d|20)|7(?:[089]|2[03]|[35]\\d\\d))\\d|4(?:2\\d\\d|8))\\d|1(?:2|[39]\\d{4}))|3(?:(?:123|(?:29\\d|92)\\d)\\d\\d|7(?:[19]|[56]\\d))|5(?:0|1[2-478]|26|[37]2|4(?:2\\d{3}|83)|5(?:25\\d\\d|[78])|[689]\\d)|6(?:(?:[16-8]21|28|52[013])\\d\\d|[39])|8(?:[1349]28|523)\\d\\d)\\d{3}|(?:4\\d\\d|9[2-9])\\d{4,5}|(?:(?:2(?:(?:(?:0|8[146])\\d|7[1-7])\\d|2(?:[278]\\d|92)|58(?:2\\d|3))|3(?:[26]|9\\d{3})|5(?:4\\d|5)\\d\\d)\\d|6(?:(?:(?:[0-246]|[78]\\d)\\d|37)\\d|5[2-8]))\\d\\d|(?:2(?:[569]\\d|8[2-57-9])|3(?:[013-59]\\d|8[37])|6[89]8)\\d{3}",
                ,
                ,
                ,
                "1312345",
                ,
                ,
                ,
                [3, 4]
              ], [, , "7(?:[1278]\\d|3[1-9])\\d{6}", , , , "712345678", , , [9]], [, , "80(?:[01]\\d|20|8[0-8])\\d{3}", , , , "8001234", , , [7]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "86(?:1[12]|22|30|44|55|77|8[368])\\d{6}", , , , "8686123456", , , [10]], "ZW", 263, "00", "0", , , "0", , , , [
                [, "(\\d{3})(\\d{3,5})", "$1 $2", ["2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"], "0$1"],
                [, "(\\d)(\\d{3})(\\d{2,4})", "$1 $2 $3", ["[49]"], "0$1"],
                [, "(\\d{3})(\\d{4})", "$1 $2", ["80"], "0$1"],
                [, "(\\d{2})(\\d{7})", "$1 $2", ["24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2", "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"], "(0$1)"],
                [, "(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"],
                [, "(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)", "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"], "0$1"],
                [, "(\\d{4})(\\d{6})", "$1 $2", ["8"], "0$1"],
                [
                  ,
                  "(\\d{2})(\\d{3,5})",
                  "$1 $2",
                  ["1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"],
                  "0$1"
                ],
                [, "(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["29[013-9]|39|54"], "0$1"],
                [, "(\\d{4})(\\d{3,5})", "$1 $2", ["(?:25|54)8", "258|5483"], "0$1"]
              ], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              800: [
                ,
                [, , "(?:00|[1-9]\\d)\\d{6}", , , , , , , [8]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , "(?:00|[1-9]\\d)\\d{6}", , , , "12345678"],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                "001",
                800,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                1,
                [[, "(\\d{4})(\\d{4})", "$1 $2", ["\\d"]]],
                ,
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                ,
                [, , , , , , , , , [-1]]
              ],
              808: [, [, , "[1-9]\\d{7}", , , , , , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "[1-9]\\d{7}", , , , "12345678"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "001", 808, , , , , , , , 1, [[, "(\\d{4})(\\d{4})", "$1 $2", ["[1-9]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              870: [, [, , "7\\d{11}|[235-7]\\d{8}", , , , , , , [9, 12]], [, , , , , , , , , [-1]], [, , "(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}", , , , "301234567"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
                ,
                ,
                "2\\d{8}",
                ,
                ,
                ,
                "201234567",
                ,
                ,
                [9]
              ], "001", 870, , , , , , , , , [[, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-7]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              878: [, [, , "10\\d{10}", , , , , , , [12]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "10\\d{10}", , , , "101234567890"], "001", 878, , , , , , , , 1, [[, "(\\d{2})(\\d{5})(\\d{5})", "$1 $2 $3", ["1"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              881: [, [
                ,
                ,
                "6\\d{9}|[0-36-9]\\d{8}",
                ,
                ,
                ,
                ,
                ,
                ,
                [9, 10]
              ], [, , , , , , , , , [-1]], [, , "6\\d{9}|[0-36-9]\\d{8}", , , , "612345678"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "001", 881, , , , , , , , , [[, "(\\d)(\\d{3})(\\d{5})", "$1 $2 $3", ["[0-37-9]"]], [, "(\\d)(\\d{3})(\\d{5,6})", "$1 $2 $3", ["6"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              882: [, [, , "[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?", , , , , , , [7, 8, 9, 10, 11, 12]], [, , , , , , , , , [-1]], [
                ,
                ,
                "342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}",
                ,
                ,
                ,
                "3421234",
                ,
                ,
                [7, 8, 9, 10, 12]
              ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}", , , , "390123456789"], "001", 882, , , , , , , , , [[, "(\\d{2})(\\d{5})", "$1 $2", ["16|342"]], [, "(\\d{2})(\\d{6})", "$1 $2", ["49"]], [, "(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["1[36]|9"]], [, "(\\d{2})(\\d{4})(\\d{3})", "$1 $2 $3", ["3[23]"]], [
                ,
                "(\\d{2})(\\d{3,4})(\\d{4})",
                "$1 $2 $3",
                ["16"]
              ], [, "(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|23|3(?:[15]|4[57])|4|51"]], [, "(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["34"]], [, "(\\d{2})(\\d{4,5})(\\d{5})", "$1 $2 $3", ["[1-35]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , "348[57]\\d{7}", , , , "34851234567", , , [11]]],
              883: [, [, , "(?:[1-4]\\d|51)\\d{6,10}", , , , , , , [8, 9, 10, 11, 12]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
                ,
                ,
                "(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[0-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}",
                ,
                ,
                ,
                "510012345"
              ], "001", 883, , , , , , , , 1, [[, "(\\d{3})(\\d{3})(\\d{2,8})", "$1 $2 $3", ["[14]|2[24-689]|3[02-689]|51[24-9]"]], [, "(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["510"]], [, "(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["21"]], [, "(\\d{4})(\\d{4})(\\d{4})", "$1 $2 $3", ["51[13]"]], [, "(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[235]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]],
              888: [, [, , "\\d{11}", , , , , , , [11]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "001", 888, , , , , , , , 1, [[, "(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3"]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , "\\d{11}", , , , "12345678901"], , , [, , , , , , , , , [-1]]],
              979: [, [, , "[1359]\\d{8}", , , , , , , [9], [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , "[1359]\\d{8}", , , , "123456789", , , , [8]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], "001", 979, , , , , , , , 1, [[, "(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[1359]"]]], , [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , [, , , , , , , , , [-1]]]
            }, i18n.phonenumbers.PhoneNumberUtil = function() {
              this.regionToMetadataMap = {};
            }, goog.addSingletonGetter(i18n.phonenumbers.PhoneNumberUtil), i18n.phonenumbers.Error = { INVALID_COUNTRY_CODE: "Invalid country calling code", NOT_A_NUMBER: "The string supplied did not seem to be a phone number", TOO_SHORT_AFTER_IDD: "Phone number too short after IDD", TOO_SHORT_NSN: "The string supplied is too short to be a phone number", TOO_LONG: "The string supplied is too long to be a phone number" }, i18n.phonenumbers.PhoneNumberUtil.NANPA_COUNTRY_CODE_ = 1, i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_FOR_NSN_ = 2, i18n.phonenumbers.PhoneNumberUtil.MAX_LENGTH_FOR_NSN_ = 17, i18n.phonenumbers.PhoneNumberUtil.MAX_LENGTH_COUNTRY_CODE_ = 3, i18n.phonenumbers.PhoneNumberUtil.MAX_INPUT_STRING_LENGTH_ = 250, i18n.phonenumbers.PhoneNumberUtil.UNKNOWN_REGION_ = "ZZ", i18n.phonenumbers.PhoneNumberUtil.MOBILE_TOKEN_MAPPINGS_ = { 54: "9" }, i18n.phonenumbers.PhoneNumberUtil.GEO_MOBILE_COUNTRIES_ = [52, 54, 55], i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN = "+", i18n.phonenumbers.PhoneNumberUtil.STAR_SIGN_ = "*", i18n.phonenumbers.PhoneNumberUtil.RFC3966_EXTN_PREFIX_ = ";ext=", i18n.phonenumbers.PhoneNumberUtil.RFC3966_PREFIX_ = "tel:", i18n.phonenumbers.PhoneNumberUtil.RFC3966_PHONE_CONTEXT_ = ";phone-context=", i18n.phonenumbers.PhoneNumberUtil.RFC3966_ISDN_SUBADDRESS_ = ";isub=", i18n.phonenumbers.PhoneNumberUtil.DIGIT_MAPPINGS = { 0: "0", 1: "1", 2: "2", 3: "3", 4: "4", 5: "5", 6: "6", 7: "7", 8: "8", 9: "9", "０": "0", "１": "1", "２": "2", "３": "3", "４": "4", "５": "5", "６": "6", "７": "7", "８": "8", "９": "9", "٠": "0", "١": "1", "٢": "2", "٣": "3", "٤": "4", "٥": "5", "٦": "6", "٧": "7", "٨": "8", "٩": "9", "۰": "0", "۱": "1", "۲": "2", "۳": "3", "۴": "4", "۵": "5", "۶": "6", "۷": "7", "۸": "8", "۹": "9" }, i18n.phonenumbers.PhoneNumberUtil.DIALLABLE_CHAR_MAPPINGS_ = { 0: "0", 1: "1", 2: "2", 3: "3", 4: "4", 5: "5", 6: "6", 7: "7", 8: "8", 9: "9", "+": i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN, "*": "*", "#": "#" }, i18n.phonenumbers.PhoneNumberUtil.ALPHA_MAPPINGS_ = { A: "2", B: "2", C: "2", D: "3", E: "3", F: "3", G: "4", H: "4", I: "4", J: "5", K: "5", L: "5", M: "6", N: "6", O: "6", P: "7", Q: "7", R: "7", S: "7", T: "8", U: "8", V: "8", W: "9", X: "9", Y: "9", Z: "9" }, i18n.phonenumbers.PhoneNumberUtil.ALL_NORMALIZATION_MAPPINGS_ = {
              0: "0",
              1: "1",
              2: "2",
              3: "3",
              4: "4",
              5: "5",
              6: "6",
              7: "7",
              8: "8",
              9: "9",
              "０": "0",
              "１": "1",
              "２": "2",
              "３": "3",
              "４": "4",
              "５": "5",
              "６": "6",
              "７": "7",
              "８": "8",
              "９": "9",
              "٠": "0",
              "١": "1",
              "٢": "2",
              "٣": "3",
              "٤": "4",
              "٥": "5",
              "٦": "6",
              "٧": "7",
              "٨": "8",
              "٩": "9",
              "۰": "0",
              "۱": "1",
              "۲": "2",
              "۳": "3",
              "۴": "4",
              "۵": "5",
              "۶": "6",
              "۷": "7",
              "۸": "8",
              "۹": "9",
              A: "2",
              B: "2",
              C: "2",
              D: "3",
              E: "3",
              F: "3",
              G: "4",
              H: "4",
              I: "4",
              J: "5",
              K: "5",
              L: "5",
              M: "6",
              N: "6",
              O: "6",
              P: "7",
              Q: "7",
              R: "7",
              S: "7",
              T: "8",
              U: "8",
              V: "8",
              W: "9",
              X: "9",
              Y: "9",
              Z: "9"
            }, i18n.phonenumbers.PhoneNumberUtil.ALL_PLUS_NUMBER_GROUPING_SYMBOLS_ = {
              0: "0",
              1: "1",
              2: "2",
              3: "3",
              4: "4",
              5: "5",
              6: "6",
              7: "7",
              8: "8",
              9: "9",
              A: "A",
              B: "B",
              C: "C",
              D: "D",
              E: "E",
              F: "F",
              G: "G",
              H: "H",
              I: "I",
              J: "J",
              K: "K",
              L: "L",
              M: "M",
              N: "N",
              O: "O",
              P: "P",
              Q: "Q",
              R: "R",
              S: "S",
              T: "T",
              U: "U",
              V: "V",
              W: "W",
              X: "X",
              Y: "Y",
              Z: "Z",
              a: "A",
              b: "B",
              c: "C",
              d: "D",
              e: "E",
              f: "F",
              g: "G",
              h: "H",
              i: "I",
              j: "J",
              k: "K",
              l: "L",
              m: "M",
              n: "N",
              o: "O",
              p: "P",
              q: "Q",
              r: "R",
              s: "S",
              t: "T",
              u: "U",
              v: "V",
              w: "W",
              x: "X",
              y: "Y",
              z: "Z",
              "-": "-",
              "－": "-",
              "‐": "-",
              "‑": "-",
              "‒": "-",
              "–": "-",
              "—": "-",
              "―": "-",
              "−": "-",
              "/": "/",
              "／": "/",
              " ": " ",
              "　": " ",
              "⁠": " ",
              ".": ".",
              "．": "."
            }, i18n.phonenumbers.PhoneNumberUtil.SINGLE_INTERNATIONAL_PREFIX_ = /[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?/, i18n.phonenumbers.PhoneNumberUtil.VALID_PUNCTUATION = "-x‐-―−ー－-／  ­​⁠　()（）［］.\\[\\]/~⁓∼～", i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ = "0-9０-９٠-٩۰-۹", i18n.phonenumbers.PhoneNumberUtil.VALID_ALPHA_ = "A-Za-z", i18n.phonenumbers.PhoneNumberUtil.PLUS_CHARS_ = "+＋", i18n.phonenumbers.PhoneNumberUtil.PLUS_CHARS_PATTERN = new RegExp("[" + i18n.phonenumbers.PhoneNumberUtil.PLUS_CHARS_ + "]+"), i18n.phonenumbers.PhoneNumberUtil.LEADING_PLUS_CHARS_PATTERN = new RegExp("^[" + i18n.phonenumbers.PhoneNumberUtil.PLUS_CHARS_ + "]+"), i18n.phonenumbers.PhoneNumberUtil.SEPARATOR_PATTERN_ = "[" + i18n.phonenumbers.PhoneNumberUtil.VALID_PUNCTUATION + "]+", i18n.phonenumbers.PhoneNumberUtil.CAPTURING_DIGIT_PATTERN = new RegExp("([" + i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ + "])"), i18n.phonenumbers.PhoneNumberUtil.VALID_START_CHAR_PATTERN_ = new RegExp("[" + i18n.phonenumbers.PhoneNumberUtil.PLUS_CHARS_ + i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ + "]"), i18n.phonenumbers.PhoneNumberUtil.SECOND_NUMBER_START_PATTERN_ = /[\\\/] *x/, i18n.phonenumbers.PhoneNumberUtil.UNWANTED_END_CHAR_PATTERN_ = new RegExp("[^" + i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ + i18n.phonenumbers.PhoneNumberUtil.VALID_ALPHA_ + "#]+$"), i18n.phonenumbers.PhoneNumberUtil.VALID_ALPHA_PHONE_PATTERN_ = /(?:.*?[A-Za-z]){3}.*/, i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_PHONE_NUMBER_PATTERN_ = "[" + i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ + "]{" + i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_FOR_NSN_ + "}", i18n.phonenumbers.PhoneNumberUtil.VALID_PHONE_NUMBER_ = "[" + i18n.phonenumbers.PhoneNumberUtil.PLUS_CHARS_ + "]*(?:[" + i18n.phonenumbers.PhoneNumberUtil.VALID_PUNCTUATION + i18n.phonenumbers.PhoneNumberUtil.STAR_SIGN_ + "]*[" + i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ + "]){3,}[" + i18n.phonenumbers.PhoneNumberUtil.VALID_PUNCTUATION + i18n.phonenumbers.PhoneNumberUtil.STAR_SIGN_ + i18n.phonenumbers.PhoneNumberUtil.VALID_ALPHA_ + i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ + "]*", i18n.phonenumbers.PhoneNumberUtil.DEFAULT_EXTN_PREFIX_ = " ext. ", i18n.phonenumbers.PhoneNumberUtil.RFC3966_VISUAL_SEPARATOR_ = "[\\-\\.\\(\\)]?", i18n.phonenumbers.PhoneNumberUtil.RFC3966_PHONE_DIGIT_ = "([" + i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ + "]|" + i18n.phonenumbers.PhoneNumberUtil.RFC3966_VISUAL_SEPARATOR_ + ")", i18n.phonenumbers.PhoneNumberUtil.RFC3966_GLOBAL_NUMBER_DIGITS_ = "^\\" + i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN + i18n.phonenumbers.PhoneNumberUtil.RFC3966_PHONE_DIGIT_ + "*[" + i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ + "]" + i18n.phonenumbers.PhoneNumberUtil.RFC3966_PHONE_DIGIT_ + "*$", i18n.phonenumbers.PhoneNumberUtil.RFC3966_GLOBAL_NUMBER_DIGITS_PATTERN_ = new RegExp(i18n.phonenumbers.PhoneNumberUtil.RFC3966_GLOBAL_NUMBER_DIGITS_), i18n.phonenumbers.PhoneNumberUtil.ALPHANUM_ = i18n.phonenumbers.PhoneNumberUtil.VALID_ALPHA_ + i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_, i18n.phonenumbers.PhoneNumberUtil.RFC3966_DOMAINLABEL_ = "[" + i18n.phonenumbers.PhoneNumberUtil.ALPHANUM_ + "]+((\\-)*[" + i18n.phonenumbers.PhoneNumberUtil.ALPHANUM_ + "])*", i18n.phonenumbers.PhoneNumberUtil.RFC3966_TOPLABEL_ = "[" + i18n.phonenumbers.PhoneNumberUtil.VALID_ALPHA_ + "]+((\\-)*[" + i18n.phonenumbers.PhoneNumberUtil.ALPHANUM_ + "])*", i18n.phonenumbers.PhoneNumberUtil.RFC3966_DOMAINNAME_ = "^(" + i18n.phonenumbers.PhoneNumberUtil.RFC3966_DOMAINLABEL_ + "\\.)*" + i18n.phonenumbers.PhoneNumberUtil.RFC3966_TOPLABEL_ + "\\.?$", i18n.phonenumbers.PhoneNumberUtil.RFC3966_DOMAINNAME_PATTERN_ = new RegExp(i18n.phonenumbers.PhoneNumberUtil.RFC3966_DOMAINNAME_), i18n.phonenumbers.PhoneNumberUtil.extnDigits_ = function(e) {
              return "([" + i18n.phonenumbers.PhoneNumberUtil.VALID_DIGITS_ + "]{1," + e + "})";
            }, i18n.phonenumbers.PhoneNumberUtil.createExtnPattern_ = function() {
              var e = i18n.phonenumbers.PhoneNumberUtil.RFC3966_EXTN_PREFIX_ + i18n.phonenumbers.PhoneNumberUtil.extnDigits_("20"), t = "[  \\t,]*(?:e?xt(?:ensi(?:ó?|ó))?n?|ｅ?ｘｔｎ?|доб|anexo)[:\\.．]?[  \\t,-]*" + i18n.phonenumbers.PhoneNumberUtil.extnDigits_("20") + "#?", o = "[  \\t,]*(?:[xｘ#＃~～]|int|ｉｎｔ)[:\\.．]?[  \\t,-]*" + i18n.phonenumbers.PhoneNumberUtil.extnDigits_("9") + "#?", n = "[- ]+" + i18n.phonenumbers.PhoneNumberUtil.extnDigits_("6") + "#", s = "[  \\t]*(?:,{2}|;)[:\\.．]?[  \\t,-]*" + i18n.phonenumbers.PhoneNumberUtil.extnDigits_("15") + "#?", i = "[  \\t]*(?:,)+[:\\.．]?[  \\t,-]*" + i18n.phonenumbers.PhoneNumberUtil.extnDigits_("9") + "#?";
              return e + "|" + t + "|" + o + "|" + n + "|" + s + "|" + i;
            }, i18n.phonenumbers.PhoneNumberUtil.EXTN_PATTERN_ = new RegExp("(?:" + i18n.phonenumbers.PhoneNumberUtil.createExtnPattern_() + ")$", "i"), i18n.phonenumbers.PhoneNumberUtil.VALID_PHONE_NUMBER_PATTERN_ = new RegExp("^" + i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_PHONE_NUMBER_PATTERN_ + "$|^" + i18n.phonenumbers.PhoneNumberUtil.VALID_PHONE_NUMBER_ + "(?:" + i18n.phonenumbers.PhoneNumberUtil.createExtnPattern_() + ")?$", "i"), i18n.phonenumbers.PhoneNumberUtil.NON_DIGITS_PATTERN_ = /\D+/, i18n.phonenumbers.PhoneNumberUtil.FIRST_GROUP_PATTERN_ = /(\$\d)/, i18n.phonenumbers.PhoneNumberUtil.NP_PATTERN_ = /\$NP/, i18n.phonenumbers.PhoneNumberUtil.FG_PATTERN_ = /\$FG/, i18n.phonenumbers.PhoneNumberUtil.CC_PATTERN_ = /\$CC/, i18n.phonenumbers.PhoneNumberUtil.FIRST_GROUP_ONLY_PREFIX_PATTERN_ = /^\(?\$1\)?$/, i18n.phonenumbers.PhoneNumberUtil.REGION_CODE_FOR_NON_GEO_ENTITY = "001", i18n.phonenumbers.PhoneNumberFormat = { E164: 0, INTERNATIONAL: 1, NATIONAL: 2, RFC3966: 3 }, i18n.phonenumbers.PhoneNumberType = { FIXED_LINE: 0, MOBILE: 1, FIXED_LINE_OR_MOBILE: 2, TOLL_FREE: 3, PREMIUM_RATE: 4, SHARED_COST: 5, VOIP: 6, PERSONAL_NUMBER: 7, PAGER: 8, UAN: 9, VOICEMAIL: 10, UNKNOWN: -1 }, i18n.phonenumbers.PhoneNumberUtil.MatchType = { NOT_A_NUMBER: 0, NO_MATCH: 1, SHORT_NSN_MATCH: 2, NSN_MATCH: 3, EXACT_MATCH: 4 }, i18n.phonenumbers.PhoneNumberUtil.ValidationResult = { IS_POSSIBLE: 0, IS_POSSIBLE_LOCAL_ONLY: 4, INVALID_COUNTRY_CODE: 1, TOO_SHORT: 2, INVALID_LENGTH: 5, TOO_LONG: 3 }, i18n.phonenumbers.PhoneNumberUtil.extractPossibleNumber = function(e) {
              var t = e.search(i18n.phonenumbers.PhoneNumberUtil.VALID_START_CHAR_PATTERN_);
              return 0 <= t ? (e = e.substring(t), e = e.replace(i18n.phonenumbers.PhoneNumberUtil.UNWANTED_END_CHAR_PATTERN_, ""), t = e.search(i18n.phonenumbers.PhoneNumberUtil.SECOND_NUMBER_START_PATTERN_), 0 <= t && (e = e.substring(0, t))) : e = "", e;
            }, i18n.phonenumbers.PhoneNumberUtil.isViablePhoneNumber = function(e) {
              return e.length < i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_FOR_NSN_ ? !1 : i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(i18n.phonenumbers.PhoneNumberUtil.VALID_PHONE_NUMBER_PATTERN_, e);
            }, i18n.phonenumbers.PhoneNumberUtil.normalize = function(e) {
              return i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(i18n.phonenumbers.PhoneNumberUtil.VALID_ALPHA_PHONE_PATTERN_, e) ? i18n.phonenumbers.PhoneNumberUtil.normalizeHelper_(e, i18n.phonenumbers.PhoneNumberUtil.ALL_NORMALIZATION_MAPPINGS_, !0) : i18n.phonenumbers.PhoneNumberUtil.normalizeDigitsOnly(e);
            }, i18n.phonenumbers.PhoneNumberUtil.normalizeSB_ = function(e) {
              var t = i18n.phonenumbers.PhoneNumberUtil.normalize(e.toString());
              e.clear(), e.append(t);
            }, i18n.phonenumbers.PhoneNumberUtil.normalizeDigitsOnly = function(e) {
              return i18n.phonenumbers.PhoneNumberUtil.normalizeHelper_(e, i18n.phonenumbers.PhoneNumberUtil.DIGIT_MAPPINGS, !0);
            }, i18n.phonenumbers.PhoneNumberUtil.normalizeDiallableCharsOnly = function(e) {
              return i18n.phonenumbers.PhoneNumberUtil.normalizeHelper_(e, i18n.phonenumbers.PhoneNumberUtil.DIALLABLE_CHAR_MAPPINGS_, !0);
            }, i18n.phonenumbers.PhoneNumberUtil.convertAlphaCharactersInNumber = function(e) {
              return i18n.phonenumbers.PhoneNumberUtil.normalizeHelper_(e, i18n.phonenumbers.PhoneNumberUtil.ALL_NORMALIZATION_MAPPINGS_, !1);
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.getLengthOfGeographicalAreaCode = function(e) {
              var t = this.getMetadataForRegion(this.getRegionCodeForNumber(e));
              return t != null && (t.hasNationalPrefix() || e.hasItalianLeadingZero()) && this.isNumberGeographical(e) ? this.getLengthOfNationalDestinationCode(e) : 0;
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.getLengthOfNationalDestinationCode = function(e) {
              if (e.hasExtension()) {
                var t = e.clone();
                t.clearExtension();
              } else t = e;
              return t = this.format(t, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL).split(i18n.phonenumbers.PhoneNumberUtil.NON_DIGITS_PATTERN_), t[0].length == 0 && t.shift(), 2 >= t.length ? 0 : this.getNumberType(e) == i18n.phonenumbers.PhoneNumberType.MOBILE && (e = i18n.phonenumbers.PhoneNumberUtil.getCountryMobileToken(e.getCountryCodeOrDefault()), e != "") ? t[2].length + e.length : t[1].length;
            }, i18n.phonenumbers.PhoneNumberUtil.getCountryMobileToken = function(e) {
              return i18n.phonenumbers.PhoneNumberUtil.MOBILE_TOKEN_MAPPINGS_[e] || "";
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.getSupportedRegions = function() {
              return Object.keys(i18n.phonenumbers.metadata.countryToMetadata).filter(function(e) {
                return isNaN(e);
              });
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.getSupportedGlobalNetworkCallingCodes = function() {
              return Object.keys(i18n.phonenumbers.metadata.countryToMetadata).filter(function(e) {
                return !isNaN(e);
              }).map(function(e) {
                return parseInt(e, 10);
              });
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.getSupportedCallingCodes = function() {
              var e = Object.keys(i18n.phonenumbers.metadata.countryCodeToRegionCodeMap);
              return [].concat($jscomp.arrayFromIterable(this.getSupportedGlobalNetworkCallingCodes()), $jscomp.arrayFromIterable(e.map(function(t) {
                return parseInt(t, 10);
              })));
            }, i18n.phonenumbers.PhoneNumberUtil.descHasPossibleNumberData_ = function(e) {
              return e != null && (e.possibleLengthCount() != 1 || e.possibleLengthArray()[0] != -1);
            }, i18n.phonenumbers.PhoneNumberUtil.descHasData_ = function(e) {
              return e != null && (e.hasExampleNumber() || i18n.phonenumbers.PhoneNumberUtil.descHasPossibleNumberData_(e) || e.hasNationalNumberPattern());
            }, i18n.phonenumbers.PhoneNumberUtil.getSupportedTypesForMetadata_ = function(e) {
              var t = [];
              return goog.object.forEach(i18n.phonenumbers.PhoneNumberType, function(o) {
                if (o != i18n.phonenumbers.PhoneNumberType.FIXED_LINE_OR_MOBILE && o != i18n.phonenumbers.PhoneNumberType.UNKNOWN) {
                  var n = i18n.phonenumbers.PhoneNumberUtil.getNumberDescByType_(e, o);
                  i18n.phonenumbers.PhoneNumberUtil.descHasData_(n) && t.push(o);
                }
              }), t;
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.getSupportedTypesForRegion = function(e) {
              return this.isValidRegionCode_(e) ? i18n.phonenumbers.PhoneNumberUtil.getSupportedTypesForMetadata_(this.getMetadataForRegion(e)) : [];
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.getSupportedTypesForNonGeoEntity = function(e) {
              return e = this.getMetadataForNonGeographicalRegion(e), e == null ? [] : i18n.phonenumbers.PhoneNumberUtil.getSupportedTypesForMetadata_(e);
            }, i18n.phonenumbers.PhoneNumberUtil.normalizeHelper_ = function(e, t, o) {
              for (var n = new goog.string.StringBuffer(), s, i, l = e.length, d = 0; d < l; ++d) s = e.charAt(d), i = t[s.toUpperCase()], i != null ? n.append(i) : o || n.append(s);
              return n.toString();
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.formattingRuleHasFirstGroupOnly = function(e) {
              return e.length == 0 || i18n.phonenumbers.PhoneNumberUtil.FIRST_GROUP_ONLY_PREFIX_PATTERN_.test(e);
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.isNumberGeographical = function(e) {
              var t = this.getNumberType(e);
              return t == i18n.phonenumbers.PhoneNumberType.FIXED_LINE || t == i18n.phonenumbers.PhoneNumberType.FIXED_LINE_OR_MOBILE || i18n.phonenumbers.PhoneNumberUtil.GEO_MOBILE_COUNTRIES_.includes(e.getCountryCodeOrDefault()) && t == i18n.phonenumbers.PhoneNumberType.MOBILE;
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.isValidRegionCode_ = function(e) {
              return e != null && isNaN(e) && e.toUpperCase() in i18n.phonenumbers.metadata.countryToMetadata;
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.hasValidCountryCallingCode_ = function(e) {
              return e in i18n.phonenumbers.metadata.countryCodeToRegionCodeMap;
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.format = function(e, t) {
              if (e.getNationalNumber() == 0 && e.hasRawInput()) {
                var o = e.getRawInputOrDefault();
                if (0 < o.length) return o;
              }
              o = e.getCountryCodeOrDefault();
              var n = this.getNationalSignificantNumber(e);
              if (t == i18n.phonenumbers.PhoneNumberFormat.E164) return this.prefixNumberWithCountryCallingCode_(o, i18n.phonenumbers.PhoneNumberFormat.E164, n, "");
              if (!this.hasValidCountryCallingCode_(o)) return n;
              var s = this.getRegionCodeForCountryCode(o);
              return s = this.getMetadataForRegionOrCallingCode_(
                o,
                s
              ), e = this.maybeGetFormattedExtension_(e, s, t), n = this.formatNsn_(n, s, t), this.prefixNumberWithCountryCallingCode_(o, t, n, e);
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.formatByPattern = function(e, t, o) {
              var n = e.getCountryCodeOrDefault(), s = this.getNationalSignificantNumber(e);
              if (!this.hasValidCountryCallingCode_(n)) return s;
              var i = this.getRegionCodeForCountryCode(n);
              i = this.getMetadataForRegionOrCallingCode_(n, i);
              var l = this.chooseFormattingPatternForNumber_(o, s);
              if (l != null) {
                if (o = l.clone(), l = l.getNationalPrefixFormattingRuleOrDefault(), 0 < l.length) {
                  var d = i.getNationalPrefixOrDefault();
                  0 < d.length ? (l = l.replace(
                    i18n.phonenumbers.PhoneNumberUtil.NP_PATTERN_,
                    d
                  ).replace(i18n.phonenumbers.PhoneNumberUtil.FG_PATTERN_, "$1"), o.setNationalPrefixFormattingRule(l)) : o.clearNationalPrefixFormattingRule();
                }
                s = this.formatNsnUsingPattern_(s, o, t);
              }
              return e = this.maybeGetFormattedExtension_(e, i, t), this.prefixNumberWithCountryCallingCode_(n, t, s, e);
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.formatNationalNumberWithCarrierCode = function(e, t) {
              var o = e.getCountryCodeOrDefault(), n = this.getNationalSignificantNumber(e);
              if (!this.hasValidCountryCallingCode_(o)) return n;
              var s = this.getRegionCodeForCountryCode(o);
              return s = this.getMetadataForRegionOrCallingCode_(o, s), e = this.maybeGetFormattedExtension_(e, s, i18n.phonenumbers.PhoneNumberFormat.NATIONAL), t = this.formatNsn_(n, s, i18n.phonenumbers.PhoneNumberFormat.NATIONAL, t), this.prefixNumberWithCountryCallingCode_(
                o,
                i18n.phonenumbers.PhoneNumberFormat.NATIONAL,
                t,
                e
              );
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.getMetadataForRegionOrCallingCode_ = function(e, t) {
              return i18n.phonenumbers.PhoneNumberUtil.REGION_CODE_FOR_NON_GEO_ENTITY == t ? this.getMetadataForNonGeographicalRegion(e) : this.getMetadataForRegion(t);
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.formatNationalNumberWithPreferredCarrierCode = function(e, t) {
              return this.formatNationalNumberWithCarrierCode(e, 0 < e.getPreferredDomesticCarrierCodeOrDefault().length ? e.getPreferredDomesticCarrierCodeOrDefault() : t);
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.formatNumberForMobileDialing = function(e, t, o) {
              var n = e.getCountryCodeOrDefault();
              if (!this.hasValidCountryCallingCode_(n)) return e.hasRawInput() ? e.getRawInputOrDefault() : "";
              var s = "";
              e = e.clone(), e.clearExtension();
              var i = this.getRegionCodeForCountryCode(n), l = this.getNumberType(e), d = l != i18n.phonenumbers.PhoneNumberType.UNKNOWN;
              if (t == i) s = l == i18n.phonenumbers.PhoneNumberType.FIXED_LINE || l == i18n.phonenumbers.PhoneNumberType.MOBILE || l == i18n.phonenumbers.PhoneNumberType.FIXED_LINE_OR_MOBILE, i == "BR" && s ? s = 0 < e.getPreferredDomesticCarrierCodeOrDefault().length ? this.formatNationalNumberWithPreferredCarrierCode(e, "") : "" : n == i18n.phonenumbers.PhoneNumberUtil.NANPA_COUNTRY_CODE_ ? (t = this.getMetadataForRegion(t), s = this.canBeInternationallyDialled(e) && this.testNumberLength_(this.getNationalSignificantNumber(e), t) != i18n.phonenumbers.PhoneNumberUtil.ValidationResult.TOO_SHORT ? this.format(e, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL) : this.format(e, i18n.phonenumbers.PhoneNumberFormat.NATIONAL)) : s = (i == i18n.phonenumbers.PhoneNumberUtil.REGION_CODE_FOR_NON_GEO_ENTITY || (i == "MX" || i == "CL" || i == "UZ") && s) && this.canBeInternationallyDialled(e) ? this.format(e, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL) : this.format(e, i18n.phonenumbers.PhoneNumberFormat.NATIONAL);
              else if (d && this.canBeInternationallyDialled(e)) return o ? this.format(e, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL) : this.format(e, i18n.phonenumbers.PhoneNumberFormat.E164);
              return o ? s : i18n.phonenumbers.PhoneNumberUtil.normalizeDiallableCharsOnly(s);
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.formatOutOfCountryCallingNumber = function(e, t) {
              if (!this.isValidRegionCode_(t)) return this.format(e, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL);
              var o = e.getCountryCodeOrDefault(), n = this.getNationalSignificantNumber(e);
              if (!this.hasValidCountryCallingCode_(o)) return n;
              if (o == i18n.phonenumbers.PhoneNumberUtil.NANPA_COUNTRY_CODE_) {
                if (this.isNANPACountry(t)) return o + " " + this.format(e, i18n.phonenumbers.PhoneNumberFormat.NATIONAL);
              } else if (o == this.getCountryCodeForValidRegion_(t)) return this.format(
                e,
                i18n.phonenumbers.PhoneNumberFormat.NATIONAL
              );
              var s = this.getMetadataForRegion(t), i = s.getInternationalPrefixOrDefault();
              return t = "", s.hasPreferredInternationalPrefix() ? t = s.getPreferredInternationalPrefixOrDefault() : i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(i18n.phonenumbers.PhoneNumberUtil.SINGLE_INTERNATIONAL_PREFIX_, i) && (t = i), s = this.getRegionCodeForCountryCode(o), s = this.getMetadataForRegionOrCallingCode_(o, s), n = this.formatNsn_(n, s, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL), e = this.maybeGetFormattedExtension_(
                e,
                s,
                i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL
              ), 0 < t.length ? t + " " + o + " " + n + e : this.prefixNumberWithCountryCallingCode_(o, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL, n, e);
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.formatInOriginalFormat = function(e, t) {
              if (e.hasRawInput() && !this.hasFormattingPatternForNumber_(e)) return e.getRawInputOrDefault();
              if (!e.hasCountryCodeSource()) return this.format(e, i18n.phonenumbers.PhoneNumberFormat.NATIONAL);
              switch (e.getCountryCodeSource()) {
                case i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_NUMBER_WITH_PLUS_SIGN:
                  t = this.format(e, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL);
                  break;
                case i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_NUMBER_WITH_IDD:
                  t = this.formatOutOfCountryCallingNumber(e, t);
                  break;
                case i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_NUMBER_WITHOUT_PLUS_SIGN:
                  t = this.format(e, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL).substring(1);
                  break;
                default:
                  var o = this.getRegionCodeForCountryCode(e.getCountryCodeOrDefault()), n = this.getNddPrefixForRegion(o, !0);
                  if (t = this.format(e, i18n.phonenumbers.PhoneNumberFormat.NATIONAL), n != null && n.length != 0 && !this.rawInputContainsNationalPrefix_(e.getRawInputOrDefault(), n, o) && (o = this.getMetadataForRegion(o), n = this.getNationalSignificantNumber(e), o = this.chooseFormattingPatternForNumber_(o.numberFormatArray(), n), o != null)) {
                    n = o.getNationalPrefixFormattingRuleOrDefault();
                    var s = n.indexOf("$1");
                    0 >= s || (n = n.substring(0, s), n = i18n.phonenumbers.PhoneNumberUtil.normalizeDigitsOnly(n), n.length != 0 && (t = o.clone(), t.clearNationalPrefixFormattingRule(), t = this.formatByPattern(e, i18n.phonenumbers.PhoneNumberFormat.NATIONAL, [t])));
                  }
              }
              return e = e.getRawInputOrDefault(), t != null && 0 < e.length && (o = i18n.phonenumbers.PhoneNumberUtil.normalizeDiallableCharsOnly(t), n = i18n.phonenumbers.PhoneNumberUtil.normalizeDiallableCharsOnly(e), o != n && (t = e)), t;
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.rawInputContainsNationalPrefix_ = function(e, t, o) {
              if (e = i18n.phonenumbers.PhoneNumberUtil.normalizeDigitsOnly(e), goog.string.startsWith(e, t)) try {
                return this.isValidNumber(this.parse(e.substring(t.length), o));
              } catch {
              }
              return !1;
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.hasFormattingPatternForNumber_ = function(e) {
              var t = e.getCountryCodeOrDefault(), o = this.getRegionCodeForCountryCode(t);
              return t = this.getMetadataForRegionOrCallingCode_(t, o), t == null ? !1 : (e = this.getNationalSignificantNumber(e), this.chooseFormattingPatternForNumber_(t.numberFormatArray(), e) != null);
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.formatOutOfCountryKeepingAlphaChars = function(e, t) {
              var o = e.getRawInputOrDefault();
              if (o.length == 0) return this.formatOutOfCountryCallingNumber(e, t);
              var n = e.getCountryCodeOrDefault();
              if (!this.hasValidCountryCallingCode_(n)) return o;
              o = i18n.phonenumbers.PhoneNumberUtil.normalizeHelper_(o, i18n.phonenumbers.PhoneNumberUtil.ALL_PLUS_NUMBER_GROUPING_SYMBOLS_, !0);
              var s = this.getNationalSignificantNumber(e);
              if (3 < s.length) {
                var i = o.indexOf(s.substring(0, 3));
                i != -1 && (o = o.substring(i));
              }
              if (i = this.getMetadataForRegion(t), n == i18n.phonenumbers.PhoneNumberUtil.NANPA_COUNTRY_CODE_) {
                if (this.isNANPACountry(t)) return n + " " + o;
              } else if (i != null && n == this.getCountryCodeForValidRegion_(t))
                return n = this.chooseFormattingPatternForNumber_(i.numberFormatArray(), s), n == null ? o : (n = n.clone(), n.setPattern("(\\d+)(.*)"), n.setFormat("$1$2"), this.formatNsnUsingPattern_(o, n, i18n.phonenumbers.PhoneNumberFormat.NATIONAL));
              return t = "", i != null && (t = i.getInternationalPrefixOrDefault(), t = i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(
                i18n.phonenumbers.PhoneNumberUtil.SINGLE_INTERNATIONAL_PREFIX_,
                t
              ) ? t : i.getPreferredInternationalPrefixOrDefault()), i = this.getRegionCodeForCountryCode(n), i = this.getMetadataForRegionOrCallingCode_(n, i), e = this.maybeGetFormattedExtension_(e, i, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL), 0 < t.length ? t + " " + n + " " + o + e : this.prefixNumberWithCountryCallingCode_(n, i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL, o, e);
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.getNationalSignificantNumber = function(e) {
              if (!e.hasNationalNumber()) return "";
              var t = "" + e.getNationalNumber();
              return e.hasItalianLeadingZero() && e.getItalianLeadingZero() && 0 < e.getNumberOfLeadingZerosOrDefault() ? Array(e.getNumberOfLeadingZerosOrDefault() + 1).join("0") + t : t;
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.prefixNumberWithCountryCallingCode_ = function(e, t, o, n) {
              switch (t) {
                case i18n.phonenumbers.PhoneNumberFormat.E164:
                  return i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN + e + o + n;
                case i18n.phonenumbers.PhoneNumberFormat.INTERNATIONAL:
                  return i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN + e + " " + o + n;
                case i18n.phonenumbers.PhoneNumberFormat.RFC3966:
                  return i18n.phonenumbers.PhoneNumberUtil.RFC3966_PREFIX_ + i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN + e + "-" + o + n;
                default:
                  return o + n;
              }
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.formatNsn_ = function(e, t, o, n) {
              return t = t.intlNumberFormatArray().length == 0 || o == i18n.phonenumbers.PhoneNumberFormat.NATIONAL ? t.numberFormatArray() : t.intlNumberFormatArray(), t = this.chooseFormattingPatternForNumber_(t, e), t == null ? e : this.formatNsnUsingPattern_(e, t, o, n);
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.chooseFormattingPatternForNumber_ = function(e, t) {
              for (var o, n = e.length, s = 0; s < n; ++s) {
                o = e[s];
                var i = o.leadingDigitsPatternCount();
                if ((i == 0 || t.search(o.getLeadingDigitsPattern(i - 1)) == 0) && (i = new RegExp(o.getPattern()), i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(i, t))) return o;
              }
              return null;
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.formatNsnUsingPattern_ = function(e, t, o, n) {
              var s = t.getFormatOrDefault(), i = new RegExp(t.getPattern()), l = t.getDomesticCarrierCodeFormattingRuleOrDefault();
              return o == i18n.phonenumbers.PhoneNumberFormat.NATIONAL && n != null && 0 < n.length && 0 < l.length ? (t = l.replace(i18n.phonenumbers.PhoneNumberUtil.CC_PATTERN_, n), s = s.replace(i18n.phonenumbers.PhoneNumberUtil.FIRST_GROUP_PATTERN_, t), e = e.replace(i, s)) : (t = t.getNationalPrefixFormattingRuleOrDefault(), e = o == i18n.phonenumbers.PhoneNumberFormat.NATIONAL && t != null && 0 < t.length ? e.replace(i, s.replace(i18n.phonenumbers.PhoneNumberUtil.FIRST_GROUP_PATTERN_, t)) : e.replace(i, s)), o == i18n.phonenumbers.PhoneNumberFormat.RFC3966 && (e = e.replace(new RegExp("^" + i18n.phonenumbers.PhoneNumberUtil.SEPARATOR_PATTERN_), ""), e = e.replace(new RegExp(i18n.phonenumbers.PhoneNumberUtil.SEPARATOR_PATTERN_, "g"), "-")), e;
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.getExampleNumber = function(e) {
              return this.getExampleNumberForType(e, i18n.phonenumbers.PhoneNumberType.FIXED_LINE);
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.getExampleNumberForType = function(e, t) {
              if (!this.isValidRegionCode_(e)) return null;
              t = i18n.phonenumbers.PhoneNumberUtil.getNumberDescByType_(this.getMetadataForRegion(e), t);
              try {
                if (t.hasExampleNumber()) return this.parse(t.getExampleNumber(), e);
              } catch {
              }
              return null;
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.getExampleNumberForNonGeoEntity = function(e) {
              var t = this.getMetadataForNonGeographicalRegion(e);
              if (t != null && (t = [t.getMobile(), t.getTollFree(), t.getSharedCost(), t.getVoip(), t.getVoicemail(), t.getUan(), t.getPremiumRate()].find(function(o, n) {
                return o.hasExampleNumber();
              }), t !== void 0)) try {
                return this.parse("+" + e + t.getExampleNumber(), "ZZ");
              } catch {
              }
              return null;
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.maybeGetFormattedExtension_ = function(e, t, o) {
              return e.hasExtension() && e.getExtension().length != 0 ? o == i18n.phonenumbers.PhoneNumberFormat.RFC3966 ? i18n.phonenumbers.PhoneNumberUtil.RFC3966_EXTN_PREFIX_ + e.getExtension() : t.hasPreferredExtnPrefix() ? t.getPreferredExtnPrefix() + e.getExtensionOrDefault() : i18n.phonenumbers.PhoneNumberUtil.DEFAULT_EXTN_PREFIX_ + e.getExtensionOrDefault() : "";
            }, i18n.phonenumbers.PhoneNumberUtil.getNumberDescByType_ = function(e, t) {
              switch (t) {
                case i18n.phonenumbers.PhoneNumberType.PREMIUM_RATE:
                  return e.getPremiumRate();
                case i18n.phonenumbers.PhoneNumberType.TOLL_FREE:
                  return e.getTollFree();
                case i18n.phonenumbers.PhoneNumberType.MOBILE:
                  return e.getMobile();
                case i18n.phonenumbers.PhoneNumberType.FIXED_LINE:
                case i18n.phonenumbers.PhoneNumberType.FIXED_LINE_OR_MOBILE:
                  return e.getFixedLine();
                case i18n.phonenumbers.PhoneNumberType.SHARED_COST:
                  return e.getSharedCost();
                case i18n.phonenumbers.PhoneNumberType.VOIP:
                  return e.getVoip();
                case i18n.phonenumbers.PhoneNumberType.PERSONAL_NUMBER:
                  return e.getPersonalNumber();
                case i18n.phonenumbers.PhoneNumberType.PAGER:
                  return e.getPager();
                case i18n.phonenumbers.PhoneNumberType.UAN:
                  return e.getUan();
                case i18n.phonenumbers.PhoneNumberType.VOICEMAIL:
                  return e.getVoicemail();
                default:
                  return e.getGeneralDesc();
              }
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.getNumberType = function(e) {
              var t = this.getRegionCodeForNumber(e);
              return t = this.getMetadataForRegionOrCallingCode_(e.getCountryCodeOrDefault(), t), t == null ? i18n.phonenumbers.PhoneNumberType.UNKNOWN : (e = this.getNationalSignificantNumber(e), this.getNumberTypeHelper_(e, t));
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.getNumberTypeHelper_ = function(e, t) {
              return this.isNumberMatchingDesc_(e, t.getGeneralDesc()) ? this.isNumberMatchingDesc_(e, t.getPremiumRate()) ? i18n.phonenumbers.PhoneNumberType.PREMIUM_RATE : this.isNumberMatchingDesc_(e, t.getTollFree()) ? i18n.phonenumbers.PhoneNumberType.TOLL_FREE : this.isNumberMatchingDesc_(e, t.getSharedCost()) ? i18n.phonenumbers.PhoneNumberType.SHARED_COST : this.isNumberMatchingDesc_(e, t.getVoip()) ? i18n.phonenumbers.PhoneNumberType.VOIP : this.isNumberMatchingDesc_(
                e,
                t.getPersonalNumber()
              ) ? i18n.phonenumbers.PhoneNumberType.PERSONAL_NUMBER : this.isNumberMatchingDesc_(e, t.getPager()) ? i18n.phonenumbers.PhoneNumberType.PAGER : this.isNumberMatchingDesc_(e, t.getUan()) ? i18n.phonenumbers.PhoneNumberType.UAN : this.isNumberMatchingDesc_(e, t.getVoicemail()) ? i18n.phonenumbers.PhoneNumberType.VOICEMAIL : this.isNumberMatchingDesc_(e, t.getFixedLine()) ? t.getSameMobileAndFixedLinePattern() || this.isNumberMatchingDesc_(e, t.getMobile()) ? i18n.phonenumbers.PhoneNumberType.FIXED_LINE_OR_MOBILE : i18n.phonenumbers.PhoneNumberType.FIXED_LINE : !t.getSameMobileAndFixedLinePattern() && this.isNumberMatchingDesc_(e, t.getMobile()) ? i18n.phonenumbers.PhoneNumberType.MOBILE : i18n.phonenumbers.PhoneNumberType.UNKNOWN : i18n.phonenumbers.PhoneNumberType.UNKNOWN;
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.getMetadataForRegion = function(e) {
              if (e == null) return null;
              e = e.toUpperCase();
              var t = this.regionToMetadataMap[e];
              if (t == null) {
                t = new goog.proto2.PbLiteSerializer();
                var o = i18n.phonenumbers.metadata.countryToMetadata[e];
                if (o == null) return null;
                t = t.deserialize(i18n.phonenumbers.PhoneMetadata.getDescriptor(), o), this.regionToMetadataMap[e] = t;
              }
              return t;
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.getMetadataForNonGeographicalRegion = function(e) {
              return this.getMetadataForRegion("" + e);
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.isNumberMatchingDesc_ = function(e, t) {
              var o = e.length;
              return 0 < t.possibleLengthCount() && t.possibleLengthArray().indexOf(o) == -1 ? !1 : i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(t.getNationalNumberPatternOrDefault(), e);
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.isValidNumber = function(e) {
              var t = this.getRegionCodeForNumber(e);
              return this.isValidNumberForRegion(e, t);
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.isValidNumberForRegion = function(e, t) {
              var o = e.getCountryCodeOrDefault(), n = this.getMetadataForRegionOrCallingCode_(o, t);
              return n == null || i18n.phonenumbers.PhoneNumberUtil.REGION_CODE_FOR_NON_GEO_ENTITY != t && o != this.getCountryCodeForValidRegion_(t) ? !1 : (e = this.getNationalSignificantNumber(e), this.getNumberTypeHelper_(e, n) != i18n.phonenumbers.PhoneNumberType.UNKNOWN);
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.getRegionCodeForNumber = function(e) {
              if (e == null) return null;
              var t = e.getCountryCodeOrDefault();
              return t = i18n.phonenumbers.metadata.countryCodeToRegionCodeMap[t], t == null ? null : t.length == 1 ? t[0] : this.getRegionCodeForNumberFromRegionList_(e, t);
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.getRegionCodeForNumberFromRegionList_ = function(e, t) {
              e = this.getNationalSignificantNumber(e);
              for (var o, n = t.length, s = 0; s < n; s++) {
                o = t[s];
                var i = this.getMetadataForRegion(o);
                if (i.hasLeadingDigits()) {
                  if (e.search(i.getLeadingDigits()) == 0) return o;
                } else if (this.getNumberTypeHelper_(e, i) != i18n.phonenumbers.PhoneNumberType.UNKNOWN) return o;
              }
              return null;
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.getRegionCodeForCountryCode = function(e) {
              return e = i18n.phonenumbers.metadata.countryCodeToRegionCodeMap[e], e == null ? i18n.phonenumbers.PhoneNumberUtil.UNKNOWN_REGION_ : e[0];
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.getRegionCodesForCountryCode = function(e) {
              return e = i18n.phonenumbers.metadata.countryCodeToRegionCodeMap[e], e ?? [];
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.getCountryCodeForRegion = function(e) {
              return this.isValidRegionCode_(e) ? this.getCountryCodeForValidRegion_(e) : 0;
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.getCountryCodeForValidRegion_ = function(e) {
              var t = this.getMetadataForRegion(e);
              if (t == null) throw Error("Invalid region code: " + e);
              return t.getCountryCodeOrDefault();
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.getNddPrefixForRegion = function(e, t) {
              return e = this.getMetadataForRegion(e), e == null || (e = e.getNationalPrefixOrDefault(), e.length == 0) ? null : (t && (e = e.replace("~", "")), e);
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.isNANPACountry = function(e) {
              return e != null && i18n.phonenumbers.metadata.countryCodeToRegionCodeMap[i18n.phonenumbers.PhoneNumberUtil.NANPA_COUNTRY_CODE_].includes(e.toUpperCase());
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.isAlphaNumber = function(e) {
              return i18n.phonenumbers.PhoneNumberUtil.isViablePhoneNumber(e) ? (e = new goog.string.StringBuffer(e), this.maybeStripExtension(e), i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(i18n.phonenumbers.PhoneNumberUtil.VALID_ALPHA_PHONE_PATTERN_, e.toString())) : !1;
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.isPossibleNumber = function(e) {
              return e = this.isPossibleNumberWithReason(e), e == i18n.phonenumbers.PhoneNumberUtil.ValidationResult.IS_POSSIBLE || e == i18n.phonenumbers.PhoneNumberUtil.ValidationResult.IS_POSSIBLE_LOCAL_ONLY;
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.isPossibleNumberForType = function(e, t) {
              return e = this.isPossibleNumberForTypeWithReason(e, t), e == i18n.phonenumbers.PhoneNumberUtil.ValidationResult.IS_POSSIBLE || e == i18n.phonenumbers.PhoneNumberUtil.ValidationResult.IS_POSSIBLE_LOCAL_ONLY;
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.testNumberLength_ = function(e, t) {
              return this.testNumberLengthForType_(e, t, i18n.phonenumbers.PhoneNumberType.UNKNOWN);
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.testNumberLengthForType_ = function(e, t, o) {
              var n = i18n.phonenumbers.PhoneNumberUtil.getNumberDescByType_(t, o), s = n.possibleLengthCount() == 0 ? t.getGeneralDesc().possibleLengthArray() : n.possibleLengthArray();
              if (n = n.possibleLengthLocalOnlyArray(), o == i18n.phonenumbers.PhoneNumberType.FIXED_LINE_OR_MOBILE) if (i18n.phonenumbers.PhoneNumberUtil.descHasPossibleNumberData_(i18n.phonenumbers.PhoneNumberUtil.getNumberDescByType_(t, i18n.phonenumbers.PhoneNumberType.FIXED_LINE))) o = i18n.phonenumbers.PhoneNumberUtil.getNumberDescByType_(t, i18n.phonenumbers.PhoneNumberType.MOBILE), i18n.phonenumbers.PhoneNumberUtil.descHasPossibleNumberData_(o) && (s = s.concat(o.possibleLengthCount() == 0 ? t.getGeneralDesc().possibleLengthArray() : o.possibleLengthArray()), s.sort(), n.length == 0 ? n = o.possibleLengthLocalOnlyArray() : (n = n.concat(o.possibleLengthLocalOnlyArray()), n.sort()));
              else return this.testNumberLengthForType_(e, t, i18n.phonenumbers.PhoneNumberType.MOBILE);
              return s[0] == -1 ? i18n.phonenumbers.PhoneNumberUtil.ValidationResult.INVALID_LENGTH : (e = e.length, -1 < n.indexOf(e) ? i18n.phonenumbers.PhoneNumberUtil.ValidationResult.IS_POSSIBLE_LOCAL_ONLY : (t = s[0], t == e ? i18n.phonenumbers.PhoneNumberUtil.ValidationResult.IS_POSSIBLE : t > e ? i18n.phonenumbers.PhoneNumberUtil.ValidationResult.TOO_SHORT : s[s.length - 1] < e ? i18n.phonenumbers.PhoneNumberUtil.ValidationResult.TOO_LONG : -1 < s.indexOf(e, 1) ? i18n.phonenumbers.PhoneNumberUtil.ValidationResult.IS_POSSIBLE : i18n.phonenumbers.PhoneNumberUtil.ValidationResult.INVALID_LENGTH));
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.isPossibleNumberWithReason = function(e) {
              return this.isPossibleNumberForTypeWithReason(e, i18n.phonenumbers.PhoneNumberType.UNKNOWN);
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.isPossibleNumberForTypeWithReason = function(e, t) {
              var o = this.getNationalSignificantNumber(e);
              if (e = e.getCountryCodeOrDefault(), !this.hasValidCountryCallingCode_(e)) return i18n.phonenumbers.PhoneNumberUtil.ValidationResult.INVALID_COUNTRY_CODE;
              var n = this.getRegionCodeForCountryCode(e);
              return e = this.getMetadataForRegionOrCallingCode_(e, n), this.testNumberLengthForType_(o, e, t);
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.isPossibleNumberString = function(e, t) {
              try {
                return this.isPossibleNumber(this.parse(e, t));
              } catch {
                return !1;
              }
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.truncateTooLongNumber = function(e) {
              if (this.isValidNumber(e)) return !0;
              var t = e.clone(), o = e.getNationalNumberOrDefault();
              do
                if (o = Math.floor(o / 10), t.setNationalNumber(o), o == 0 || this.isPossibleNumberWithReason(t) == i18n.phonenumbers.PhoneNumberUtil.ValidationResult.TOO_SHORT) return !1;
              while (!this.isValidNumber(t));
              return e.setNationalNumber(o), !0;
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.extractCountryCode = function(e, t) {
              if (e = e.toString(), e.length == 0 || e.charAt(0) == "0") return 0;
              for (var o, n = e.length, s = 1; s <= i18n.phonenumbers.PhoneNumberUtil.MAX_LENGTH_COUNTRY_CODE_ && s <= n; ++s) if (o = parseInt(e.substring(0, s), 10), o in i18n.phonenumbers.metadata.countryCodeToRegionCodeMap) return t.append(e.substring(s)), o;
              return 0;
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.maybeExtractCountryCode = function(e, t, o, n, s) {
              if (e.length == 0) return 0;
              e = new goog.string.StringBuffer(e);
              var i;
              if (t != null && (i = t.getInternationalPrefix()), i == null && (i = "NonMatch"), i = this.maybeStripInternationalPrefixAndNormalize(e, i), n && s.setCountryCodeSource(i), i != i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_DEFAULT_COUNTRY) {
                if (e.getLength() <= i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_FOR_NSN_) throw Error(i18n.phonenumbers.Error.TOO_SHORT_AFTER_IDD);
                if (t = this.extractCountryCode(e, o), t != 0) return s.setCountryCode(t), t;
                throw Error(i18n.phonenumbers.Error.INVALID_COUNTRY_CODE);
              }
              if (t != null) {
                i = t.getCountryCodeOrDefault();
                var l = "" + i, d = e.toString();
                if (goog.string.startsWith(d, l) && (l = new goog.string.StringBuffer(d.substring(l.length)), d = t.getGeneralDesc(), d = new RegExp(d.getNationalNumberPatternOrDefault()), this.maybeStripNationalPrefixAndCarrierCode(l, t, null), l = l.toString(), !i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(d, e.toString()) && i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(
                  d,
                  l
                ) || this.testNumberLength_(e.toString(), t) == i18n.phonenumbers.PhoneNumberUtil.ValidationResult.TOO_LONG)) return o.append(l), n && s.setCountryCodeSource(i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_NUMBER_WITHOUT_PLUS_SIGN), s.setCountryCode(i), i;
              }
              return s.setCountryCode(0), 0;
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.parsePrefixAsIdd_ = function(e, t) {
              var o = t.toString();
              if (o.search(e) == 0) {
                e = o.match(e)[0].length;
                var n = o.substring(e).match(i18n.phonenumbers.PhoneNumberUtil.CAPTURING_DIGIT_PATTERN);
                return n && n[1] != null && 0 < n[1].length && i18n.phonenumbers.PhoneNumberUtil.normalizeDigitsOnly(n[1]) == "0" ? !1 : (t.clear(), t.append(o.substring(e)), !0);
              }
              return !1;
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.maybeStripInternationalPrefixAndNormalize = function(e, t) {
              var o = e.toString();
              return o.length == 0 ? i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_DEFAULT_COUNTRY : i18n.phonenumbers.PhoneNumberUtil.LEADING_PLUS_CHARS_PATTERN.test(o) ? (o = o.replace(i18n.phonenumbers.PhoneNumberUtil.LEADING_PLUS_CHARS_PATTERN, ""), e.clear(), e.append(i18n.phonenumbers.PhoneNumberUtil.normalize(o)), i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_NUMBER_WITH_PLUS_SIGN) : (t = new RegExp(t), i18n.phonenumbers.PhoneNumberUtil.normalizeSB_(e), this.parsePrefixAsIdd_(t, e) ? i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_NUMBER_WITH_IDD : i18n.phonenumbers.PhoneNumber.CountryCodeSource.FROM_DEFAULT_COUNTRY);
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.maybeStripNationalPrefixAndCarrierCode = function(e, t, o) {
              var n = e.toString(), s = n.length, i = t.getNationalPrefixForParsing();
              if (s == 0 || i == null || i.length == 0) return !1;
              var l = new RegExp("^(?:" + i + ")");
              if (s = l.exec(n)) {
                i = new RegExp(t.getGeneralDesc().getNationalNumberPatternOrDefault());
                var d = i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(i, n), u = s.length - 1;
                if (t = t.getNationalPrefixTransformRule(), t == null || t.length == 0 || s[u] == null || s[u].length == 0) {
                  if (d && !i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(
                    i,
                    n.substring(s[0].length)
                  )) return !1;
                  o != null && 0 < u && s[u] != null && o.append(s[1]), e.set(n.substring(s[0].length));
                } else {
                  if (n = n.replace(l, t), d && !i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(i, n)) return !1;
                  o != null && 0 < u && o.append(s[1]), e.set(n);
                }
                return !0;
              }
              return !1;
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.maybeStripExtension = function(e) {
              var t = e.toString(), o = t.search(i18n.phonenumbers.PhoneNumberUtil.EXTN_PATTERN_);
              if (0 <= o && i18n.phonenumbers.PhoneNumberUtil.isViablePhoneNumber(t.substring(0, o))) {
                for (var n = t.match(i18n.phonenumbers.PhoneNumberUtil.EXTN_PATTERN_), s = n.length, i = 1; i < s; ++i) if (n[i] != null && 0 < n[i].length) return e.clear(), e.append(t.substring(0, o)), n[i];
              }
              return "";
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.checkRegionForParsing_ = function(e, t) {
              return this.isValidRegionCode_(t) || e != null && 0 < e.length && i18n.phonenumbers.PhoneNumberUtil.LEADING_PLUS_CHARS_PATTERN.test(e);
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.parse = function(e, t) {
              return this.parseHelper_(e, t, !1, !0);
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.parseAndKeepRawInput = function(e, t) {
              if (!this.isValidRegionCode_(t) && 0 < e.length && e.charAt(0) != i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN) throw Error(i18n.phonenumbers.Error.INVALID_COUNTRY_CODE);
              return this.parseHelper_(e, t, !0, !0);
            }, i18n.phonenumbers.PhoneNumberUtil.setItalianLeadingZerosForPhoneNumber_ = function(e, t) {
              if (1 < e.length && e.charAt(0) == "0") {
                t.setItalianLeadingZero(!0);
                for (var o = 1; o < e.length - 1 && e.charAt(o) == "0"; ) o++;
                o != 1 && t.setNumberOfLeadingZeros(o);
              }
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.parseHelper_ = function(e, t, o, n) {
              if (e == null) throw Error(i18n.phonenumbers.Error.NOT_A_NUMBER);
              if (e.length > i18n.phonenumbers.PhoneNumberUtil.MAX_INPUT_STRING_LENGTH_) throw Error(i18n.phonenumbers.Error.TOO_LONG);
              var s = new goog.string.StringBuffer();
              if (this.buildNationalNumberForParsing_(e, s), !i18n.phonenumbers.PhoneNumberUtil.isViablePhoneNumber(s.toString())) throw Error(i18n.phonenumbers.Error.NOT_A_NUMBER);
              if (n && !this.checkRegionForParsing_(s.toString(), t)) throw Error(i18n.phonenumbers.Error.INVALID_COUNTRY_CODE);
              n = new i18n.phonenumbers.PhoneNumber(), o && n.setRawInput(e), e = this.maybeStripExtension(s), 0 < e.length && n.setExtension(e);
              var i = this.getMetadataForRegion(t);
              e = new goog.string.StringBuffer();
              var l = 0, d = s.toString();
              try {
                l = this.maybeExtractCountryCode(d, i, e, o, n);
              } catch (u) {
                if (u.message == i18n.phonenumbers.Error.INVALID_COUNTRY_CODE && i18n.phonenumbers.PhoneNumberUtil.LEADING_PLUS_CHARS_PATTERN.test(d)) {
                  if (d = d.replace(i18n.phonenumbers.PhoneNumberUtil.LEADING_PLUS_CHARS_PATTERN, ""), l = this.maybeExtractCountryCode(
                    d,
                    i,
                    e,
                    o,
                    n
                  ), l == 0) throw u;
                } else throw u;
              }
              if (l != 0 ? (s = this.getRegionCodeForCountryCode(l), s != t && (i = this.getMetadataForRegionOrCallingCode_(l, s))) : (i18n.phonenumbers.PhoneNumberUtil.normalizeSB_(s), e.append(s.toString()), t != null ? (l = i.getCountryCodeOrDefault(), n.setCountryCode(l)) : o && n.clearCountryCodeSource()), e.getLength() < i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_FOR_NSN_ || (i != null && (t = new goog.string.StringBuffer(), s = new goog.string.StringBuffer(e.toString()), this.maybeStripNationalPrefixAndCarrierCode(s, i, t), i = this.testNumberLength_(s.toString(), i), l = i18n.phonenumbers.PhoneNumberUtil.ValidationResult, i != l.TOO_SHORT && i != l.IS_POSSIBLE_LOCAL_ONLY && i != l.INVALID_LENGTH && (e = s, o && 0 < t.toString().length && n.setPreferredDomesticCarrierCode(t.toString()))), o = e.toString(), e = o.length, e < i18n.phonenumbers.PhoneNumberUtil.MIN_LENGTH_FOR_NSN_)) throw Error(i18n.phonenumbers.Error.TOO_SHORT_NSN);
              if (e > i18n.phonenumbers.PhoneNumberUtil.MAX_LENGTH_FOR_NSN_) throw Error(i18n.phonenumbers.Error.TOO_LONG);
              return i18n.phonenumbers.PhoneNumberUtil.setItalianLeadingZerosForPhoneNumber_(o, n), n.setNationalNumber(parseInt(o, 10)), n;
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.extractPhoneContext_ = function(e) {
              var t = e.indexOf(i18n.phonenumbers.PhoneNumberUtil.RFC3966_PHONE_CONTEXT_);
              if (t === -1) return null;
              if (t += i18n.phonenumbers.PhoneNumberUtil.RFC3966_PHONE_CONTEXT_.length, t >= e.length) return "";
              var o = e.indexOf(";", t);
              return o !== -1 ? e.substring(t, o) : e.substring(t);
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.isPhoneContextValid_ = function(e) {
              if (e == null) return !0;
              if (e.length === 0) return !1;
              var t = i18n.phonenumbers.PhoneNumberUtil.RFC3966_GLOBAL_NUMBER_DIGITS_PATTERN_.exec(e);
              return e = i18n.phonenumbers.PhoneNumberUtil.RFC3966_DOMAINNAME_PATTERN_.exec(e), t !== null || e !== null;
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.buildNationalNumberForParsing_ = function(e, t) {
              var o = i18n.phonenumbers.PhoneNumberUtil.prototype.extractPhoneContext_(e);
              if (!i18n.phonenumbers.PhoneNumberUtil.prototype.isPhoneContextValid_(o)) throw Error(i18n.phonenumbers.Error.NOT_A_NUMBER);
              if (o != null) {
                o.charAt(0) === i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN && t.append(o), o = e.indexOf(i18n.phonenumbers.PhoneNumberUtil.RFC3966_PREFIX_), o = 0 <= o ? o + i18n.phonenumbers.PhoneNumberUtil.RFC3966_PREFIX_.length : 0;
                var n = e.indexOf(i18n.phonenumbers.PhoneNumberUtil.RFC3966_PHONE_CONTEXT_);
                t.append(e.substring(o, n));
              } else t.append(i18n.phonenumbers.PhoneNumberUtil.extractPossibleNumber(e ?? ""));
              e = t.toString(), o = e.indexOf(i18n.phonenumbers.PhoneNumberUtil.RFC3966_ISDN_SUBADDRESS_), 0 < o && (t.clear(), t.append(e.substring(0, o)));
            }, i18n.phonenumbers.PhoneNumberUtil.copyCoreFieldsOnly_ = function(e) {
              var t = new i18n.phonenumbers.PhoneNumber();
              return t.setCountryCode(e.getCountryCodeOrDefault()), t.setNationalNumber(e.getNationalNumberOrDefault()), 0 < e.getExtensionOrDefault().length && t.setExtension(e.getExtensionOrDefault()), e.getItalianLeadingZero() && (t.setItalianLeadingZero(!0), t.setNumberOfLeadingZeros(e.getNumberOfLeadingZerosOrDefault())), t;
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.isNumberMatch = function(e, t) {
              if (typeof e == "string") try {
                var o = this.parse(e, i18n.phonenumbers.PhoneNumberUtil.UNKNOWN_REGION_);
              } catch (i) {
                if (i.message != i18n.phonenumbers.Error.INVALID_COUNTRY_CODE) return i18n.phonenumbers.PhoneNumberUtil.MatchType.NOT_A_NUMBER;
                if (typeof t != "string") {
                  var n = this.getRegionCodeForCountryCode(t.getCountryCodeOrDefault());
                  if (n != i18n.phonenumbers.PhoneNumberUtil.UNKNOWN_REGION_) {
                    try {
                      o = this.parse(e, n);
                    } catch {
                      return i18n.phonenumbers.PhoneNumberUtil.MatchType.NOT_A_NUMBER;
                    }
                    var s = this.isNumberMatch(o, t);
                    return s == i18n.phonenumbers.PhoneNumberUtil.MatchType.EXACT_MATCH ? i18n.phonenumbers.PhoneNumberUtil.MatchType.NSN_MATCH : s;
                  }
                }
                try {
                  o = this.parseHelper_(e, null, !1, !1);
                } catch {
                  return i18n.phonenumbers.PhoneNumberUtil.MatchType.NOT_A_NUMBER;
                }
              }
              else o = e.clone();
              if (typeof t == "string") try {
                return s = this.parse(t, i18n.phonenumbers.PhoneNumberUtil.UNKNOWN_REGION_), this.isNumberMatch(e, s);
              } catch (i) {
                return i.message != i18n.phonenumbers.Error.INVALID_COUNTRY_CODE ? i18n.phonenumbers.PhoneNumberUtil.MatchType.NOT_A_NUMBER : this.isNumberMatch(t, o);
              }
              else s = t.clone();
              return e = i18n.phonenumbers.PhoneNumberUtil.copyCoreFieldsOnly_(o), s = i18n.phonenumbers.PhoneNumberUtil.copyCoreFieldsOnly_(s), e.hasExtension() && s.hasExtension() && e.getExtension() != s.getExtension() ? i18n.phonenumbers.PhoneNumberUtil.MatchType.NO_MATCH : (t = e.getCountryCodeOrDefault(), o = s.getCountryCodeOrDefault(), t != 0 && o != 0 ? e.equals(s) ? i18n.phonenumbers.PhoneNumberUtil.MatchType.EXACT_MATCH : t == o && this.isNationalNumberSuffixOfTheOther_(e, s) ? i18n.phonenumbers.PhoneNumberUtil.MatchType.SHORT_NSN_MATCH : i18n.phonenumbers.PhoneNumberUtil.MatchType.NO_MATCH : (e.setCountryCode(0), s.setCountryCode(0), e.equals(s) ? i18n.phonenumbers.PhoneNumberUtil.MatchType.NSN_MATCH : this.isNationalNumberSuffixOfTheOther_(e, s) ? i18n.phonenumbers.PhoneNumberUtil.MatchType.SHORT_NSN_MATCH : i18n.phonenumbers.PhoneNumberUtil.MatchType.NO_MATCH));
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.isNationalNumberSuffixOfTheOther_ = function(e, t) {
              return e = "" + e.getNationalNumber(), t = "" + t.getNationalNumber(), goog.string.endsWith(e, t) || goog.string.endsWith(t, e);
            }, i18n.phonenumbers.PhoneNumberUtil.prototype.canBeInternationallyDialled = function(e) {
              var t = this.getMetadataForRegion(this.getRegionCodeForNumber(e));
              return t == null ? !0 : (e = this.getNationalSignificantNumber(e), !this.isNumberMatchingDesc_(e, t.getNoInternationalDialling()));
            }, i18n.phonenumbers.PhoneNumberUtil.matchesEntirely = function(e, t) {
              return !!((e = t.match(new RegExp("^(?:" + (typeof e == "string" ? e : e.source) + ")$", "i"))) && e[0].length == t.length);
            }, i18n.phonenumbers.PhoneNumberUtil.matchesPrefix = function(e, t) {
              return !!((e = typeof e == "string" ? t.match("^(?:" + e + ")") : t.match(e)) && goog.string.startsWith(t, e[0]));
            }, i18n.phonenumbers.shortnumbermetadata = {}, i18n.phonenumbers.shortnumbermetadata.countryCodeToRegionCodeMap = { 0: "AC AD AE AF AG AI AL AM AO AR AS AT AU AW AX AZ BA BB BD BE BF BG BH BI BJ BL BM BN BO BQ BR BS BT BW BY BZ CA CC CD CF CG CH CI CK CL CM CN CO CR CU CV CW CX CY CZ DE DJ DK DM DO DZ EC EE EG EH ER ES ET FI FJ FK FM FO FR GA GB GD GE GF GG GH GI GL GM GN GP GR GT GU GW GY HK HN HR HT HU ID IE IL IM IN IQ IR IS IT JE JM JO JP KE KG KH KI KM KN KP KR KW KY KZ LA LB LC LI LK LR LS LT LU LV LY MA MC MD ME MF MG MH MK ML MM MN MO MP MQ MR MS MT MU MV MW MX MY MZ NA NC NE NF NG NI NL NO NP NR NU NZ OM PA PE PF PG PH PK PL PM PR PS PT PW PY QA RE RO RS RU RW SA SB SC SD SE SG SH SI SJ SK SL SM SN SO SR SS ST SV SX SY SZ TC TD TG TH TJ TL TM TN TO TR TT TV TW TZ UA UG US UY UZ VA VC VE VG VI VN VU WF WS XK YE YT ZA ZM ZW".split(" ") }, i18n.phonenumbers.shortnumbermetadata.countryToMetadata = {
              AC: [, [, , "9\\d\\d", , , , , , , [3]], , , [, , "9(?:11|99)", , , , "911"], [, , , , , , , , , [-1]], , , , "AC", , , , , , , , , , , , , , , , , , [, , "9(?:11|99)", , , , "911"], , [, , "9(?:11|99)", , , , "911"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              AD: [, [, , "1\\d\\d", , , , , , , [3]], , , [, , "11[0268]", , , , "110"], [, , , , , , , , , [-1]], , , , "AD", , , , , , , , , , , , , , , , , , [, , "11[0268]", , , , "110"], , [, , "11[0268]", , , , "110"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              AE: [, [, , "[149]\\d{2,3}", , , , , , , [3, 4]], , , [
                ,
                ,
                "112|99[7-9]",
                ,
                ,
                ,
                "112",
                ,
                ,
                [3]
              ], [, , , , , , , , , [-1]], , , , "AE", , , , , , , , , , , , , , , , , , [, , "112|99[7-9]", , , , "112", , , [3]], , [, , "112|445[16]|99[7-9]", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , "445\\d", , , , "4450", , , [4]]],
              AF: [, [, , "[14]\\d\\d(?:\\d{2})?", , , , , , , [3, 5]], , , [, , "1(?:0[02]|19)", , , , "100", , , [3]], [, , , , , , , , , [-1]], , , , "AF", , , , , , , , , , , , , , , , , , [, , "1(?:0[02]|19)", , , , "100", , , [3]], , [, , "1(?:0[02]|19)|40404", , , , "100"], [, , , , , , , , , [-1]], [, , "404\\d\\d", , , , "40400", , , [5]], , [, , "404\\d\\d", , , , "40400", , , [5]]],
              AG: [
                ,
                [, , "[19]\\d\\d", , , , , , , [3]],
                ,
                ,
                [, , "9(?:11|88|99)", , , , "911"],
                [, , , , , , , , , [-1]],
                ,
                ,
                ,
                "AG",
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [, , "9(?:11|99)", , , , "911"],
                ,
                [, , "176|9(?:11|88|99)", , , , "176"],
                [, , , , , , , , , [-1]],
                [, , "176", , , , "176"],
                ,
                [, , "176", , , , "176"]
              ],
              AI: [, [, , "[19]\\d\\d", , , , , , , [3]], , , [, , "9(?:11|88)", , , , "911"], [, , , , , , , , , [-1]], , , , "AI", , , , , , , , , , , , , , , , , , [, , "911", , , , "911"], , [, , "176|9(?:11|88)", , , , "176"], [, , , , , , , , , [-1]], [, , "176", , , , "176"], , [, , "176", , , , "176"]],
              AL: [, [, , "[15]\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [, , "1(?:1(?:2|6[01]\\d\\d)|2[7-9]|3[15]|41)", , , , "112", , , [3, 6]], [
                ,
                ,
                "5\\d{4}",
                ,
                ,
                ,
                "50000",
                ,
                ,
                [5]
              ], , , , "AL", , , , , , , , , , , , , , , , , , [, , "1(?:12|2[7-9])", , , , "112", , , [3]], , [, , "1(?:1(?:6(?:000|1(?:06|11|23))|8\\d\\d)|65\\d|89[12])|5\\d{4}|1(?:[1349]\\d|2[2-9])", , , , "110"], [, , , , , , , , , [-1]], [, , "123", , , , "123", , , [3]], , [, , "131|5\\d{4}", , , , "131", , , [3, 5]]],
              AM: [, [, , "[148]\\d{2,4}", , , , , , , [3, 4, 5]], , , [, , "10[1-3]", , , , "101", , , [3]], [, , , , , , , , , [-1]], , , , "AM", , , , , , , , , , , , , , , , , , [, , "10[1-3]", , , , "101", , , [3]], , [, , "(?:1|8[1-7])\\d\\d|40404", , , , "100"], [, , , , , , , , , [-1]], [, , "404\\d\\d", , , , "40400", , , [5]], , [
                ,
                ,
                "404\\d\\d",
                ,
                ,
                ,
                "40400",
                ,
                ,
                [5]
              ]],
              AO: [, [, , "1\\d\\d", , , , , , , [3]], , , [, , "11[235]", , , , "112"], [, , , , , , , , , [-1]], , , , "AO", , , , , , , , , , , , , , , , , , [, , "11[235]", , , , "112"], , [, , "11[235]", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              AR: [, [, , "[01389]\\d{1,4}", , , , , , , [2, 3, 4, 5]], , , [, , "000|1(?:0[0-35-7]|1[0245]|2[015]|3[47]|4[478]|9)|911", , , , "19", , , [2, 3]], [, , , , , , , , , [-1]], , , , "AR", , , , , , , , , , , , , , , , , , [, , "10[017]|911", , , , "100", , , [3]], , [, , "000|1(?:0[0-35-7]|1[02-5]|2[015]|3[47]|4[478]|9)|3372|89338|911", , , , "19"], [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ], [, , "893\\d\\d", , , , "89300", , , [5]], , [, , "(?:337|893\\d)\\d", , , , "3370", , , [4, 5]]],
              AS: [, [, , "[49]\\d\\d(?:\\d{2})?", , , , , , , [3, 5]], , , [, , "9(?:11|88)", , , , "911", , , [3]], [, , , , , , , , , [-1]], , , , "AS", , , , , , , , , , , , , , , , , , [, , "911", , , , "911", , , [3]], , [, , "40404|9(?:11|88)", , , , "911"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , "404\\d\\d", , , , "40400", , , [5]]],
              AT: [, [, , "[1268]\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [, , "1(?:12|2[0238]|3[03]|4[0-247])|1(?:16\\d\\d|4[58])\\d", , , , "112", , , [3, 4, 6]], [, , , , , , , , , [-1]], , , , "AT", , , , , , , , , , , , , , , , , , [
                ,
                ,
                "1(?:[12]2|33|44)",
                ,
                ,
                ,
                "112",
                ,
                ,
                [3]
              ], , [, , "1(?:1(?:2|6(?:00[06]|1(?:17|23)))|2[0238]|3[03]|4(?:[0-247]|5[05]|84))|(?:2(?:066|20)|61|8108[1-3])0", , , , "112"], [, , , , , , , , , [-1]], [, , "220\\d|610|(?:206|810\\d)\\d\\d", , , , "610"], , [, , "206\\d\\d", , , , "20600", , , [5]]],
              AU: [, [, , "[0-27]\\d{2,7}", , , , , , , [3, 4, 5, 6, 7, 8]], , , [, , "000|1(?:06|12|258885|55\\d)|733", , , , "000", , , [3, 4, 7]], [, , "1(?:2(?:34|456)|9\\d{4,6})", , , , "1234", , , [4, 5, 6, 7, 8]], , , , "AU", , , , , , , , , , , , , , , , , , [, , "000|1(?:06|12)", , , , "000", , , [3]], , [
                ,
                ,
                "000|1(?:06|1(?:00|2|9[46])|2(?:014[1-3]|[23]\\d|(?:4|5\\d)\\d{2,3}|68[689]|72(?:20|3\\d\\d)|8(?:[013-9]\\d|2))|555|9\\d{4,6})|225|7(?:33|67)",
                ,
                ,
                ,
                "000"
              ], [, , "1(?:1[09]\\d|24733)|225|767", , , , "225", , , [3, 4, 6]], [, , "1(?:258885|55\\d)", , , , "1550", , , [4, 7]], , [, , "19\\d{4,6}", , , , "190000", , , [6, 7, 8]]],
              AW: [, [, , "[19]\\d\\d", , , , , , , [3]], , , [, , "100|911", , , , "100"], [, , , , , , , , , [-1]], , , , "AW", , , , , , , , , , , , , , , , , , [, , "100|911", , , , "100"], , [, , "1(?:00|18|76)|91[13]", , , , "100"], [, , , , , , , , , [-1]], [, , "176", , , , "176"], , [, , "176", , , , "176"]],
              AX: [, [, , "[17]\\d\\d(?:\\d{2})?", , , , , , , [3, 5]], , , [, , "112", , , , "112", , , [3]], [, , , , , , , , , [-1]], , , , "AX", , , , , , , , , , , , , , , , , , [, , "112", , , , "112", , , [3]], , [
                ,
                ,
                "112|75[12]\\d\\d",
                ,
                ,
                ,
                "112"
              ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              AZ: [, [, , "[148]\\d{2,3}", , , , , , , [3, 4]], , , [, , "1(?:0[1-3]|12)", , , , "101", , , [3]], [, , , , , , , , , [-1]], , , , "AZ", , , , , , , , , , , , , , , , , , [, , "1(?:0[1-3]|12)", , , , "101", , , [3]], , [, , "1(?:0[1-3]|12)|(?:404|880)0", , , , "101"], [, , , , , , , , , [-1]], [, , "(?:404|880)\\d", , , , "4040", , , [4]], , [, , "(?:404|880)\\d", , , , "4040", , , [4]]],
              BA: [, [, , "1\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [, , "1(?:16\\d{3}|2[2-4])", , , , "122", , , [3, 6]], [, , , , , , , , , [-1]], , , , "BA", , , , , , , , , , , , , , , , , , [
                ,
                ,
                "12[2-4]",
                ,
                ,
                ,
                "122",
                ,
                ,
                [3]
              ], , [, , "1(?:16(?:00[06]|1(?:1[17]|23))|2(?:0[0-7]|[2-5]|6[0-26])|(?:[3-5]|7\\d)\\d\\d)|1(?:18|2[78])\\d\\d?", , , , "122"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              BB: [, [, , "[2-689]\\d\\d", , , , , , , [3]], , , [, , "988|[2359]11", , , , "211"], [, , , , , , , , , [-1]], , , , "BB", , , , , , , , , , , , , , , , , , [, , "[2359]11", , , , "211"], , [, , "988|[2-689]11", , , , "211"], [, , , , , , , , , [-1]], [, , "[468]11", , , , "411"], , [, , , , , , , , , [-1]]],
              BD: [
                ,
                [, , "[1579]\\d{2,4}", , , , , , , [3, 4, 5]],
                ,
                ,
                [, , "10[0-26]|[19]99", , , , "100", , , [3]],
                [, , , , , , , , , [-1]],
                ,
                ,
                ,
                "BD",
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [, , "10[0-2]|[19]99", , , , "100", , , [3]],
                ,
                [, , "1(?:0(?:[0-369]|5[1-4]|7[0-4]|8[0-29])|1[16-9]|2(?:[134]|2[0-5])|3(?:1\\d?|6[3-6])|5[2-9])|5012|786|9594|[19]99|1(?:0(?:50|6\\d)|33|4(?:0|1\\d))\\d", , , , "100"],
                [, , , , , , , , , [-1]],
                [, , "1(?:11|2[13])|(?:501|959)\\d|786", , , , "111", , , [3, 4]],
                ,
                [, , "959\\d", , , , "9590", , , [4]]
              ],
              BE: [, [, , "[1-9]\\d\\d(?:\\d(?:\\d{2})?)?", , , , , , , [3, 4, 6]], , , [, , "1(?:0[0-35-8]|1[0269]|7(?:12|77)|813)|(?:116|8)\\d{3}", , , , "100"], [
                ,
                ,
                "1(?:2[03]|40)4|(?:1(?:[24]1|3[01])|[2-79]\\d\\d)\\d",
                ,
                ,
                ,
                "1204",
                ,
                ,
                [4]
              ], , , , "BE", , , , , , , , , , , , , , , , , , [, , "1(?:0[01]|12)", , , , "100", , , [3]], , [, , "1(?:0[0-8]|16117|2(?:12|3[0-24])|313|414|5(?:1[05]|5[15]|66|95)|6(?:1[167]|36|6[16])|7(?:[07][017]|1[27-9]|22|33|65)|81[39])|[2-9]\\d{3}|11[02679]|1(?:1600|45)0|1(?:[2-4]9|78)9|1[2-4]0[47]", , , , "100"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , "[2-9]\\d{3}", , , , "2000", , , [4]]],
              BF: [, [, , "1\\d", , , , , , , [2]], , , [, , "1[78]", , , , "17"], [, , , , , , , , , [-1]], , , , "BF", , , , , , , , , , , , , , , , , , [, , "1[78]", , , , "17"], , [, , "1[78]", , , , "17"], [, , , , , , , , , [-1]], [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ], , [, , , , , , , , , [-1]]],
              BG: [, [, , "1\\d\\d(?:\\d{3})?", , , , , , , [3, 6]], , , [, , "1(?:1(?:2|6\\d{3})|50|6[06])", , , , "112"], [, , , , , , , , , [-1]], , , , "BG", , , , , , , , , , , , , , , , , , [, , "1(?:12|50|6[06])", , , , "112", , , [3]], , [, , "1(?:1(?:2|6(?:000|111))|50|6[06])", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              BH: [, [, , "[0189]\\d\\d(?:\\d{2})?", , , , , , , [3, 5]], , , [, , "(?:0[167]|81)\\d{3}|[19]99", , , , "199"], [, , "9[148]\\d{3}", , , , "91000", , , [5]], , , , "BH", , , , , , , , , , , , , , , , , , [, , "[19]99", , , , "199", , , [3]], , [
                ,
                ,
                "1(?:[02]\\d|12|4[01]|51|8[18]|9[169])|99[02489]|(?:0[167]|8[158]|9[148])\\d{3}",
                ,
                ,
                ,
                "100"
              ], [, , , , , , , , , [-1]], [, , "0[67]\\d{3}|88000|98555", , , , "06000", , , [5]], , [, , "88000|98555", , , , "88000", , , [5]]],
              BI: [, [, , "[16-9]\\d{2,3}", , , , , , , [3, 4]], , , [, , "11[237]|611", , , , "112", , , [3]], [, , , , , , , , , [-1]], , , , "BI", , , , , , , , , , , , , , , , , , [, , "11[237]", , , , "112", , , [3]], , [, , "1(?:1\\d|5[2-9]|6[0-256])|611|7(?:10|77|979)|8[28]8|900", , , , "110"], [, , , , , , , , , [-1]], [, , "611|7(?:10|77)|888|900", , , , "611", , , [3]], , [, , "(?:71|90)0", , , , "710", , , [3]]],
              BJ: [, [, , "[17]\\d{2,3}", , , , , , , [3, 4]], , , [
                ,
                ,
                "1(?:1[246-8]|3[68]|6[06])|7[3-5]\\d\\d",
                ,
                ,
                ,
                "112"
              ], [, , , , , , , , , [-1]], , , , "BJ", , , , , , , , , , , , , , , , , , [, , "11[246-8]", , , , "112", , , [3]], , [, , "1(?:05|1[24-8]|2[02-5]|3[126-8]|5[05]|6[06]|89)|7[0-5]\\d\\d", , , , "105"], [, , , , , , , , , [-1]], [, , "12[02-5]", , , , "120", , , [3]], , [, , , , , , , , , [-1]]],
              BL: [, [, , "1\\d", , , , , , , [2]], , , [, , "18", , , , "18"], [, , , , , , , , , [-1]], , , , "BL", , , , , , , , , , , , , , , , , , [, , "18", , , , "18"], , [, , "18", , , , "18"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              BM: [, [, , "[19]\\d\\d", , , , , , , [3]], , , [, , "9(?:11|88)", , , , "911"], [, , , , , , , , , [-1]], , , , "BM", , , , , , , , , , , , , , , , , , [
                ,
                ,
                "911",
                ,
                ,
                ,
                "911"
              ], , [, , "176|9(?:11|88)", , , , "176"], [, , , , , , , , , [-1]], [, , "176", , , , "176"], , [, , "176", , , , "176"]],
              BN: [, [, , "9\\d\\d", , , , , , , [3]], , , [, , "99[135]", , , , "991"], [, , , , , , , , , [-1]], , , , "BN", , , , , , , , , , , , , , , , , , [, , "99[135]", , , , "991"], , [, , "99[135]", , , , "991"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              BO: [, [, , "[14]\\d\\d(?:\\d{2})?", , , , , , , [3, 5]], , , [, , "11[089]", , , , "110", , , [3]], [, , , , , , , , , [-1]], , , , "BO", , , , , , , , , , , , , , , , , , [, , "11[089]", , , , "110", , , [3]], , [, , "11[089]|40404", , , , "110"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [
                ,
                ,
                "404\\d\\d",
                ,
                ,
                ,
                "40400",
                ,
                ,
                [5]
              ]],
              BQ: [, [, , "[19]\\d\\d", , , , , , , [3]], , , [, , "112|911", , , , "112"], [, , , , , , , , , [-1]], , , , "BQ", , , , , , , , , , , , , , , , , , [, , "112|911", , , , "112"], , [, , "1(?:12|76)|911", , , , "112"], [, , , , , , , , , [-1]], [, , "176", , , , "176"], , [, , "176", , , , "176"]],
              BR: [, [, , "[1-69]\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [, , "1(?:00|12|28|8[015]|9[0-47-9])|4(?:57|82\\d)|911", , , , "100", , , [3, 4]], [, , , , , , , , , [-1]], , , , "BR", , , , , , , , , , , , , , , , , , [, , "1(?:12|28|9[023])|911", , , , "112", , , [3]], , [
                ,
                ,
                "1(?:0(?:[02]|3(?:1[2-579]|2[13-9]|3[124-9]|4[1-3578]|5[1-468]|6[139]|8[149]|9[168])|5[0-35-9]|6(?:0|1[0-35-8]?|2[0145]|3[0137]?|4[37-9]?|5[0-35]|6[016]?|7[137]?|8[5-8]|9[1359]))|1[25-8]|2[357-9]|3[024-68]|4[12568]|5\\d|6[0-8]|8[015]|9[0-47-9])|2(?:7(?:330|878)|85959?)|(?:32|91)1|4(?:0404?|57|828)|55555|6(?:0\\d{4}|10000)|(?:133|411)[12]",
                ,
                ,
                ,
                "100"
              ], [, , "102|273\\d\\d|321", , , , "102", , , [3, 5]], [, , "151|(?:278|555)\\d\\d|4(?:04\\d\\d?|11\\d|57)", , , , "151", , , [3, 4, 5]], , [, , "285\\d{2,3}|321|40404|(?:27[38]\\d|482)\\d|6(?:0\\d|10)\\d{3}", , , , "321"]],
              BS: [, [, , "9\\d\\d", , , , , , , [3]], , , [, , "9(?:1[19]|88)", , , , "911"], [, , , , , , , , , [-1]], , , , "BS", , , , , , , , , , , , , , , , , , [, , "91[19]", , , , "911"], , [, , "9(?:1[19]|88)", , , , "911"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              BT: [
                ,
                [, , "[14]\\d\\d(?:\\d{2})?", , , , , , , [3, 5]],
                ,
                ,
                [, , "11[023]", , , , "110", , , [3]],
                [, , , , , , , , , [-1]],
                ,
                ,
                ,
                "BT",
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [, , "11[023]", , , , "110", , , [3]],
                ,
                [, , "11[0-6]|40404", , , , "110"],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                [, , "404\\d\\d", , , , "40400", , , [5]]
              ],
              BW: [, [, , "[19]\\d\\d(?:\\d{2})?", , , , , , , [3, 5]], , , [, , "9(?:11|9[7-9])", , , , "911", , , [3]], [, , , , , , , , , [-1]], , , , "BW", , , , , , , , , , , , , , , , , , [, , "9(?:11|9[7-9])", , , , "911", , , [3]], , [, , "1(?:1[26]|3123)|9(?:1[14]|9[1-57-9])", , , , "112"], [, , , , , , , , , [-1]], [, , "131\\d\\d", , , , "13100", , , [5]], , [, , "131\\d\\d", , , , "13100", , , [5]]],
              BY: [
                ,
                [, , "1\\d\\d", , , , , , , [3]],
                ,
                ,
                [, , "1(?:0[1-3]|12)", , , , "101"],
                [, , , , , , , , , [-1]],
                ,
                ,
                ,
                "BY",
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [, , "1(?:0[1-3]|12)", , , , "101"],
                ,
                [, , "1(?:0[1-79]|1[246]|35|5[1-35]|6[89]|7[5-7]|8[58]|9[1-7])", , , , "101"],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                [, , , , , , , , , [-1]]
              ],
              BZ: [, [, , "9\\d\\d?", , , , , , , [2, 3]], , , [, , "9(?:0|11|22|66|77|9[09])", , , , "90"], [, , , , , , , , , [-1]], , , , "BZ", , , , , , , , , , , , , , , , , , [, , "9(?:0|11|90)", , , , "90"], , [, , "9(?:0|11|22|66|77|9[09])", , , , "90"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              CA: [, [, , "[1-9]\\d\\d(?:\\d{2,3})?", , , , , , , [3, 5, 6]], , , [
                ,
                ,
                "112|988|[29]11",
                ,
                ,
                ,
                "112",
                ,
                ,
                [3]
              ], [, , , , , , , , , [-1]], , , , "CA", , , , , , , , , , , , , , , , , , [, , "112|911", , , , "112", , , [3]], , [, , "[1-35-9]\\d{4,5}|112|[2-8]11|9(?:11|88)", , , , "112"], [, , , , , , , , , [-1]], [, , "[235-7]11", , , , "211", , , [3]], , [, , "[1-35-9]\\d{4,5}", , , , "10000", , , [5, 6]]],
              CC: [, [, , "[01]\\d\\d", , , , , , , [3]], , , [, , "000|112", , , , "000"], [, , , , , , , , , [-1]], , , , "CC", , , , , , , , , , , , , , , , , , [, , "000|112", , , , "000"], , [, , "000|112", , , , "000"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              CD: [
                ,
                [, , "[14]\\d\\d(?:\\d{2})?", , , , , , , [3, 5]],
                ,
                ,
                [, , "1(?:1[348]|77|88)", , , , "113", , , [3]],
                [, , , , , , , , , [-1]],
                ,
                ,
                ,
                "CD",
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [, , "1(?:1[348]|77|88)", , , , "113", , , [3]],
                ,
                [, , "1(?:1[348]|23|77|88)|40404", , , , "113"],
                [, , , , , , , , , [-1]],
                [, , "404\\d\\d", , , , "40400", , , [5]],
                ,
                [, , "404\\d\\d", , , , "40400", , , [5]]
              ],
              CF: [, [, , "1\\d{2,3}", , , , , , , [3, 4]], , , [, , "1(?:1[78]|22\\d)", , , , "117"], [, , , , , , , , , [-1]], , , , "CF", , , , , , , , , , , , , , , , , , [, , "1(?:1[78]|220)", , , , "117"], , [, , "1(?:1[478]|220)", , , , "114"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              CG: [
                ,
                [, , "1\\d\\d", , , , , , , [3]],
                ,
                ,
                [, , "11[178]", , , , "111"],
                [, , , , , , , , , [-1]],
                ,
                ,
                ,
                "CG",
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [, , "11[78]", , , , "117"],
                ,
                [, , "11[126-8]", , , , "111"],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                [, , , , , , , , , [-1]]
              ],
              CH: [, [, , "[1-9]\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [, , "1(?:1(?:[278]|6\\d{3})|4[47])|5200", , , , "112", , , [3, 4, 6]], [, , "1(?:14|8[0-2589])\\d|543|83111", , , , "543", , , [3, 4, 5]], , , , "CH", , , , , , , , , , , , , , , , , , [, , "1(?:1[278]|44)", , , , "112", , , [3]], , [, , "1(?:0[78]\\d\\d|1(?:[278]|45|6(?:000|111))|4(?:[03-57]|1[0145])|6(?:00|[1-46])|8(?:02|1[189]|[25]0|7|8[08]|99))|[2-9]\\d{2,4}", , , , "112"], [
                ,
                ,
                "1(?:4[035]|6[1-46])|1(?:41|60)\\d",
                ,
                ,
                ,
                "140",
                ,
                ,
                [3, 4]
              ], [, , "5(?:200|35)", , , , "535", , , [3, 4]], , [, , "[2-9]\\d{2,4}", , , , "200", , , [3, 4, 5]]],
              CI: [, [, , "[14]\\d{2,3}", , , , , , , [3, 4]], , , [, , "1(?:1[01]|[78]0)", , , , "110", , , [3]], [, , , , , , , , , [-1]], , , , "CI", , , , , , , , , , , , , , , , , , [, , "1(?:1[01]|[78]0)", , , , "110", , , [3]], , [, , "1(?:1[01]|[78]0)|4443", , , , "110"], [, , , , , , , , , [-1]], [, , "444\\d", , , , "4440", , , [4]], , [, , "444\\d", , , , "4440", , , [4]]],
              CK: [
                ,
                [, , "9\\d\\d", , , , , , , [3]],
                ,
                ,
                [, , "99[689]", , , , "996"],
                [, , , , , , , , , [-1]],
                ,
                ,
                ,
                "CK",
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [, , "99[689]", , , , "996"],
                ,
                [, , "99[689]", , , , "996"],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                [, , , , , , , , , [-1]]
              ],
              CL: [, [, , "[1-9]\\d{2,4}", , , , , , , [3, 4, 5]], , , [, , "1(?:213|3[1-3])|434\\d|911", , , , "131", , , [3, 4]], [, , "1(?:211|3(?:13|[348]0|5[01]))|(?:1(?:[05]6|[48]1|9[18])|2(?:01\\d|[23]2|77|88)|3(?:0[59]|13|3[279]|66)|4(?:[12]4|36\\d|4[017]|55)|5(?:00|41\\d|5[67]|99)|6(?:07\\d|13|22|3[06]|50|69)|787|8(?:[01]1|[48]8)|9(?:01|[12]0|33))\\d", , , , "1060", , , [4, 5]], , , , "CL", , , , , , , , , , , , , , , , , , [, , "13[1-3]|911", , , , "131", , , [3]], , [
                ,
                ,
                "1(?:00|21[13]|3(?:13|[348]0|5[01])|4(?:0[02-6]|17|[379])|818|919)|2(?:0(?:01|122)|22[47]|323|777|882)|3(?:0(?:51|99)|132|3(?:29|[37]7)|665)|43656|5(?:(?:00|415)4|5(?:66|77)|995)|6(?:131|222|366|699)|7878|8(?:011|11[28]|482|889)|9(?:01|1)1|13\\d|4(?:[13]42|243|4(?:02|15|77)|554)|(?:1(?:[05]6|98)|339|6(?:07|[35])0|9(?:[12]0|33))0",
                ,
                ,
                ,
                "100"
              ], [, , "(?:200|333)\\d", , , , "2000", , , [4]], [, , , , , , , , , [-1]], , [, , "13(?:13|[348]0|5[01])|(?:1(?:[05]6|[28]1|4[01]|9[18])|2(?:0(?:0|1\\d)|[23]2|77|88)|3(?:0[59]|13|3[2379]|66)|436\\d|5(?:00|41\\d|5[67]|99)|6(?:07\\d|13|22|3[06]|50|69)|787|8(?:[01]1|[48]8)|9(?:01|[12]0|33))\\d|4(?:[1-3]4|4[017]|55)\\d", , , , "1060", , , [4, 5]]],
              CM: [, [, , "[18]\\d{1,3}", , , , , , , [2, 3, 4]], , , [, , "1(?:1[37]|[37])", , , , "13", , , [2, 3]], [, , , , , , , , , [-1]], , , , "CM", , , , , , , , , , , , , , , , , , [, , "1(?:1[37]|[37])", , , , "13", , , [2, 3]], , [
                ,
                ,
                "1(?:1[37]|[37])|8711",
                ,
                ,
                ,
                "13"
              ], [, , , , , , , , , [-1]], [, , "871\\d", , , , "8710", , , [4]], , [, , "871\\d", , , , "8710", , , [4]]],
              CN: [, [, , "[19]\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [, , "1(?:1[09]|2(?:[02]|1\\d\\d|395))", , , , "110", , , [3, 5]], [, , , , , , , , , [-1]], , , , "CN", , , , , , , , , , , , , , , , , , [, , "1(?:1[09]|20)", , , , "110", , , [3]], , [, , "1(?:00|1[0249]|2395|6[08])|9[56]\\d{3,4}|12[023]|1(?:0(?:[0-26]\\d|8)|21\\d)\\d", , , , "100"], [, , "1(?:0(?:[0-26]\\d|8)\\d|1[24]|23|6[08])|9[56]\\d{3,4}|100", , , , "100"], [, , , , , , , , , [-1]], , [, , "12110", , , , "12110", , , [5]]],
              CO: [, [
                ,
                ,
                "[1-589]\\d\\d(?:\\d{2,3})?",
                ,
                ,
                ,
                ,
                ,
                ,
                [3, 5, 6]
              ], , , [, , "1(?:1[29]|23|32|56)", , , , "112", , , [3]], [, , , , , , , , , [-1]], , , , "CO", , , , , , , , , , , , , , , , , , [, , "1(?:1[29]|23|32|56)", , , , "112", , , [3]], , [, , "1(?:06|1[2-9]|2[35-7]|3[27]|4[467]|5[36]|6[4-7]|95)|(?:29002|39003)9|40404|5930\\d\\d|85432|(?:[2359][57]|8(?:7|9\\d))\\d{3}", , , , "106"], [, , , , , , , , , [-1]], [, , "(?:40|85)4\\d\\d", , , , "40400", , , [5]], , [, , "(?:40|85)4\\d\\d", , , , "40400", , , [5]]],
              CR: [, [, , "[1359]\\d{2,3}", , , , , , , [3, 4]], , , [, , "112|911", , , , "112", , , [3]], [, , , , , , , , , [-1]], , , , "CR", , , , , , , , , , , , , , , , , , [
                ,
                ,
                "112|911",
                ,
                ,
                ,
                "112",
                ,
                ,
                [3]
              ], , [, , "1(?:0(?:00|15|2[2-4679])|1(?:1[0-35-9]|2|37|[46]6|7[57]|8[79]|9[0-379])|2(?:00|[12]2|34|55)|3(?:21|33)|4(?:0[06]|1[4-6])|5(?:15|5[15])|693|7(?:00|1[7-9]|2[02]|[67]7)|975)|3855|5(?:0(?:30|49)|510)|911", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , "(?:385|5(?:0[34]|51))\\d", , , , "3850", , , [4]]],
              CU: [, [, , "[12]\\d\\d(?:\\d{3,4})?", , , , , , , [3, 6, 7]], , , [, , "10[4-7]|(?:116|204\\d)\\d{3}", , , , "104"], [, , , , , , , , , [-1]], , , , "CU", , , , , , , , , , , , , , , , , , [, , "10[4-6]", , , , "104", , , [3]], , [
                ,
                ,
                "1(?:0[4-7]|1(?:6111|8)|40)|2045252",
                ,
                ,
                ,
                "104"
              ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              CV: [, [, , "1\\d\\d", , , , , , , [3]], , , [, , "13[0-2]", , , , "130"], [, , , , , , , , , [-1]], , , , "CV", , , , , , , , , , , , , , , , , , [, , "13[0-2]", , , , "130"], , [, , "13[0-2]", , , , "130"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              CW: [, [, , "[19]\\d\\d", , , , , , , [3]], , , [, , "112|911", , , , "112"], [, , , , , , , , , [-1]], , , , "CW", , , , , , , , , , , , , , , , , , [, , "112|911", , , , "112"], , [, , "1(?:12|76)|911", , , , "112"], [, , , , , , , , , [-1]], [, , "176", , , , "176"], , [, , "176", , , , "176"]],
              CX: [, [, , "[01]\\d\\d", , , , , , , [3]], , , [
                ,
                ,
                "000|112",
                ,
                ,
                ,
                "000"
              ], [, , , , , , , , , [-1]], , , , "CX", , , , , , , , , , , , , , , , , , [, , "000|112", , , , "000"], , [, , "000|112", , , , "000"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              CY: [, [, , "1\\d\\d(?:\\d{3})?", , , , , , , [3, 6]], , , [, , "1(?:1(?:2|6\\d{3})|99)", , , , "112"], [, , , , , , , , , [-1]], , , , "CY", , , , , , , , , , , , , , , , , , [, , "1(?:12|99)", , , , "112", , , [3]], , [, , "1(?:1(?:2|6(?:000|111))|99)", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              CZ: [, [, , "1\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [, , "1(?:1(?:2|6(?:00[06]|1(?:11|23)))|5\\d)", , , , "112", , , [3, 6]], [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ], , , , "CZ", , , , , , , , , , , , , , , , , , [, , "1(?:12|5\\d)", , , , "112", , , [3]], , [, , "1(?:1(?:2|8\\d)|(?:2|3\\d)\\d{2,3}|5\\d|99)|1(?:16|4)\\d{3}", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              DE: [
                ,
                [, , "[1-478]\\d{2,5}", , , , , , , [3, 4, 5, 6]],
                ,
                ,
                [, , "11(?:[02]|6\\d{3})", , , , "110", , , [3, 6]],
                [, , , , , , , , , [-1]],
                ,
                ,
                ,
                "DE",
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [, , "11[02]", , , , "110", , , [3]],
                ,
                [, , "11(?:[025]|6(?:00[06]|1(?:1[167]|23))|800\\d)|22(?:044|5(?:43|80)|7700|922)|33(?:11|3[34])|44844|7(?:0\\d{3}|464)|80808|118\\d\\d", , , , "110"],
                [, , , , , , , , , [-1]],
                [, , "(?:33[13]|746)\\d|(?:22(?:[059]|7\\d)|(?:44|80)8|70\\d)\\d\\d", , , , "3310", , , [4, 5, 6]],
                ,
                [, , "(?:333|746)\\d|(?:22(?:[059]|7\\d)|(?:44|80)8|70\\d)\\d\\d", , , , "3330", , , [4, 5, 6]]
              ],
              DJ: [, [, , "1\\d", , , , , , , [2]], , , [, , "1[78]", , , , "17"], [, , , , , , , , , [-1]], , , , "DJ", , , , , , , , , , , , , , , , , , [, , "1[78]", , , , "17"], , [, , "1[78]", , , , "17"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              DK: [, [, , "1\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [, , "11(?:[24]|6\\d{3})", , , , "112", , , [3, 6]], [, , , , , , , , , [-1]], , , , "DK", , , , , , , , , , , , , , , , , , [
                ,
                ,
                "11[24]",
                ,
                ,
                ,
                "112",
                ,
                ,
                [3]
              ], , [, , "1(?:1(?:[248]|6(?:00[06]|111))|619[0-2]|8(?:01|1[0238]|28|30|5[13]|8[18]))", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              DM: [, [, , "[39]\\d\\d", , , , , , , [3]], , , [, , "333|9(?:11|88|99)", , , , "333"], [, , , , , , , , , [-1]], , , , "DM", , , , , , , , , , , , , , , , , , [, , "333|9(?:11|99)", , , , "333"], , [, , "333|9(?:11|88|99)", , , , "333"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              DO: [
                ,
                [, , "[19]\\d\\d", , , , , , , [3]],
                ,
                ,
                [, , "112|9(?:11|88)", , , , "112"],
                [, , , , , , , , , [-1]],
                ,
                ,
                ,
                "DO",
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [, , "112|911", , , , "112"],
                ,
                [, , "112|9(?:11|88)", , , , "112"],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                [, , , , , , , , , [-1]]
              ],
              DZ: [, [, , "[17]\\d{1,3}", , , , , , , [2, 3, 4]], , , [, , "1(?:12|[47]|54\\d)", , , , "14"], [, , , , , , , , , [-1]], , , , "DZ", , , , , , , , , , , , , , , , , , [, , "1(?:12|[47])", , , , "14", , , [2, 3]], , [, , "1(?:055|12|[47]|548)|730", , , , "14"], [, , , , , , , , , [-1]], [, , "730", , , , "730", , , [3]], , [, , "730", , , , "730", , , [3]]],
              EC: [, [, , "[19]\\d\\d", , , , , , , [3]], , , [, , "1(?:0[12]|12)|911", , , , "101"], [, , , , , , , , , [-1]], , , , "EC", , , , , , , , , , , , , , , , , , [, , "1(?:0[12]|12)|911", , , , "101"], , [
                ,
                ,
                "1(?:0[12]|12)|911",
                ,
                ,
                ,
                "101"
              ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              EE: [, [, , "1\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [, , "1(?:1(?:[02]|6\\d{3})|2(?:05|28)|3(?:014|3(?:21|5\\d?)|660)|492|5(?:1[03]|410|501)|6(?:112|333|644)|7(?:012|127|89)|8(?:10|8[57])|9(?:0[134]|14))", , , , "110"], [
                ,
                ,
                "1(?:18(?:00|[12458]\\d?)|2(?:0(?:[02-46-8]\\d?|1[0-36])|1(?:[0-4]\\d?|6[06])|2(?:[0-4]\\d?|5[25])|[367]|4(?:0[04]|[12]\\d?|4[24]|54)|55[12457])|3(?:0(?:[02]\\d?|1[13578]|3[356])|1[1347]|2[02-5]|3(?:[01347]\\d?|2[023]|88)|4(?:[35]\\d?|4[34])|5(?:3[134]|5[035])|666)|4(?:2(?:00|4\\d?)|4(?:0[01358]|1[024]|50|7\\d?)|900)|5(?:0[0-35]|1(?:[1267]\\d?|5[0-7]|82)|2(?:[014-6]\\d?|22)|330|4(?:[35]\\d?|44)|5(?:00|[1-69]\\d?)|9(?:[159]\\d?|[38]0|77))|6(?:1(?:00|1[19]|[35-9]\\d?)|2(?:2[26]|[68]\\d?)|3(?:22|36|6[36])|5|6(?:[0-359]\\d?|6[0-26])|7(?:00|55|7\\d?|8[89])|9(?:00|1\\d?|69))|7(?:0(?:[023]\\d?|1[0578])|1(?:00|2[034]|[4-9]\\d?)|2(?:[07]\\d?|20|44)|7(?:[0-57]\\d?|9[79])|8(?:0[08]|2\\d?|8[0178])|9(?:00|97))|8(?:1[127]|8[1268]|9[269])|9(?:0(?:[02]\\d?|69|9[0269])|1[1-3689]|21))",
                ,
                ,
                ,
                "123",
                ,
                ,
                [3, 4, 5]
              ], , , , "EE", , , , , , , , , , , , , , , , , , [, , "11[02]", , , , "110", , , [3]], , [, , "1(?:1(?:[02-579]|6(?:000|111)|8(?:[09]\\d|[1-8]))|2[36-9]|3[7-9]|4[05-7]|5[6-8]|6[05]|7[3-6]|8[02-7]|9[3-9])|1(?:2[0-245]|3[0-6]|4[1-489]|5[0-59]|6[1-46-9]|7[0-27-9]|8[189]|9[0-2])\\d\\d?", , , , "110"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [
                ,
                ,
                "1(?:18[1258]|2(?:0(?:1[036]|[46]\\d?)|166|21|4(?:0[04]|1\\d?|5[47])|[67])|3(?:0(?:1[13-578]|2\\d?|3[56])|1[15]|2[045]|3(?:[13]\\d?|2[13])|43|5(?:00|3[34]|53))|44(?:0[0135]|14|50|7\\d?)|5(?:05|1(?:[12]\\d?|5[1246]|8[12])|2(?:[01]\\d?|22)|3(?:00|3[03])|4(?:15|5\\d?)|500|9(?:5\\d?|77|80))|6(?:1[35-8]|226|3(?:22|3[36]|66)|644|7(?:00|7\\d?|89)|9(?:00|69))|7(?:01[258]|1(?:00|[15]\\d?)|2(?:44|7\\d?)|8(?:00|87|9\\d?))|8(?:1[128]|8[56]|9(?:[26]\\d?|77))|90(?:2\\d?|69|92))",
                ,
                ,
                ,
                "126",
                ,
                ,
                [3, 4, 5]
              ]],
              EG: [, [, , "[13]\\d\\d(?:\\d{2})?", , , , , , , [3, 5]], , , [, , "1(?:2[23]|80)", , , , "122", , , [3]], [, , , , , , , , , [-1]], , , , "EG", , , , , , , , , , , , , , , , , , [, , "1(?:2[23]|80)", , , , "122", , , [3]], , [, , "1(?:2[23]|[679]\\d{3}|80)|34400", , , , "122"], [, , , , , , , , , [-1]], [, , "344\\d\\d", , , , "34400", , , [5]], , [, , "344\\d\\d", , , , "34400", , , [5]]],
              EH: [
                ,
                [, , "1\\d\\d?", , , , , , , [2, 3]],
                ,
                ,
                [, , "1(?:[59]|77)", , , , "15"],
                [, , , , , , , , , [-1]],
                ,
                ,
                ,
                "EH",
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [, , "1(?:[59]|77)", , , , "15"],
                ,
                [, , "1(?:[59]|77)", , , , "15"],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                [, , , , , , , , , [-1]]
              ],
              ER: [, [, , "[12]\\d\\d(?:\\d{3})?", , , , , , , [3, 6]], , , [, , "11[2-46]|(?:12[47]|20[12])\\d{3}", , , , "112"], [, , , , , , , , , [-1]], , , , "ER", , , , , , , , , , , , , , , , , , [, , "1(?:1[2-46]|24422)|20(?:1(?:606|917)|2914)|(?:1277|2020)99", , , , "112"], , [, , "1(?:1[2-6]|24422)|20(?:1(?:606|917)|2914)|(?:1277|2020)99", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              ES: [, [, , "[0-379]\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [, , "0(?:16|6[57]|8[58])|1(?:006|12|[3-7]\\d\\d)|(?:116|20\\d)\\d{3}", , , , "016", , , [3, 4, 6]], [
                ,
                ,
                "[12]2\\d{1,4}|90(?:5\\d|7)|(?:118|2(?:[357]\\d|80)|3[357]\\d)\\d\\d|[79]9[57]\\d{3}",
                ,
                ,
                ,
                "120"
              ], , , , "ES", , , , , , , , , , , , , , , , , , [, , "08[58]|112", , , , "085", , , [3]], , [, , "0(?:1[0-26]|6[0-257]|8[058]|9[12])|1(?:0[03-57]\\d{1,3}|1(?:2|6(?:000|111)|8\\d\\d)|2\\d{1,4}|[3-9]\\d\\d)|2(?:2\\d{1,4}|80\\d\\d)|90(?:5[124578]|7)|1(?:3[34]|77)|(?:2[01]\\d|[79]9[57])\\d{3}|[23][357]\\d{3}", , , , "010"], [, , "0(?:[16][0-2]|80|9[12])|21\\d{4}", , , , "010", , , [3, 6]], [, , "1(?:3[34]|77)|[12]2\\d{1,4}", , , , "120"], , [, , "(?:2[0-2]\\d|3[357]|[79]9[57])\\d{3}|2(?:[2357]\\d|80)\\d\\d", , , , "22000", , , [5, 6]]],
              ET: [, [
                ,
                ,
                "9\\d\\d?",
                ,
                ,
                ,
                ,
                ,
                ,
                [2, 3]
              ], , , [, , "9(?:07|11?|2|39?|9[17])", , , , "91"], [, , , , , , , , , [-1]], , , , "ET", , , , , , , , , , , , , , , , , , [, , "9(?:11?|2|39?|9[17])", , , , "91"], , [, , "9(?:07|11?|2|39?|45|9[17])", , , , "91"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              FI: [
                ,
                [, , "[17]\\d\\d(?:\\d{2,3})?", , , , , , , [3, 5, 6]],
                ,
                ,
                [, , "11(?:2|6\\d{3})", , , , "112", , , [3, 6]],
                [, , , , , , , , , [-1]],
                ,
                ,
                ,
                "FI",
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [, , "112", , , , "112", , , [3]],
                ,
                [, , "11(?:2|6(?:00[06]|1(?:1[17]|23)))|(?:1[2-8]\\d|75[12])\\d\\d", , , , "112"],
                [, , "1[2-8]\\d{3}", , , , "12000", , , [5]],
                [, , , , , , , , , [-1]],
                ,
                [, , , , , , , , , [-1]]
              ],
              FJ: [, [, , "[0-579]\\d(?:\\d(?:\\d{2})?)?", , , , , , , [2, 3, 5]], , , [, , "91[17]", , , , "911", , , [3]], [, , , , , , , , , [-1]], , , , "FJ", , , , , , , , , , , , , , , , , , [, , "91[17]", , , , "911", , , [3]], , [, , "0(?:1[34]|8[1-4])|1(?:0[1-3]|[25]9)|2[289]|30|40404|91[137]|[45]4|75", , , , "22"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , "404\\d\\d", , , , "40400", , , [5]]],
              FK: [, [, , "[19]\\d\\d", , , , , , , [3]], , , [, , "999", , , , "999"], [, , , , , , , , , [-1]], , , , "FK", , , , , , , , , , , , , , , , , , [, , "999", , , , "999"], , [, , "1\\d\\d|999", , , , "100"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]],
              FM: [, [, , "[39]\\d\\d(?:\\d{3})?", , , , , , , [3, 6]], , , [, , "320\\d{3}|911", , , , "911"], [, , , , , , , , , [-1]], , , , "FM", , , , , , , , , , , , , , , , , , [, , "(?:32022|91)1", , , , "911"], , [, , "(?:32022|91)1", , , , "911"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              FO: [, [, , "1\\d{2,3}", , , , , , , [3, 4]], , , [, , "1(?:1[24]|81\\d)", , , , "112"], [, , , , , , , , , [-1]], , , , "FO", , , , , , , , , , , , , , , , , , [, , "11[24]", , , , "112", , , [3]], , [, , "1(?:1[248]|819)|1(?:4[124]|71|8[7-9])\\d", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              FR: [, [
                ,
                ,
                "[1-8]\\d{1,5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [2, 3, 4, 5, 6]
              ], , , [, , "1(?:1[02459]|[578]|9[167])|224|(?:3370|74)0|(?:116\\d|3[01])\\d\\d", , , , "15"], [, , "(?:1(?:0|18\\d)|366|[4-8]\\d\\d)\\d\\d|3[2-9]\\d\\d", , , , "1000", , , [4, 5, 6]], , , , "FR", , , , , , , , , , , , , , , , , , [, , "1(?:12|[578])", , , , "15", , , [2, 3]], , [, , "1(?:0\\d\\d|1(?:[02459]|6(?:000|111)|8\\d{3})|[578]|9[167])|2(?:0(?:00|2)0|24)|[3-8]\\d{4}|3\\d{3}|6(?:1[14]|34)|7(?:0[06]|22|40)", , , , "15"], [, , "202\\d|6(?:1[14]|34)|70[06]", , , , "611", , , [3, 4]], [
                ,
                ,
                "118777|224|6(?:1[14]|34)|7(?:0[06]|22|40)|20(?:0\\d|2)\\d",
                ,
                ,
                ,
                "224",
                ,
                ,
                [3, 4, 5, 6]
              ], , [, , "114|[3-8]\\d{4}", , , , "114", , , [3, 5]]],
              GA: [, [, , "1\\d(?:\\d{2})?", , , , , , , [2, 4]], , , [, , "18|1(?:3\\d|73)\\d", , , , "18"], [, , , , , , , , , [-1]], , , , "GA", , , , , , , , , , , , , , , , , , [, , "1(?:3\\d\\d|730|8)", , , , "18"], , [, , "1(?:3\\d\\d|730|8)", , , , "18"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              GB: [, [, , "[1-46-9]\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [, , "1(?:05|1(?:[29]|6\\d{3})|7[56]\\d|8000)|2(?:20\\d|48)|4444|999", , , , "105"], [, , , , , , , , , [-1]], , , , "GB", , , , , , , , , , , , , , , , , , [, , "112|999", , , , "112", , , [3]], , [
                ,
                ,
                "1(?:0[015]|1(?:[129]|6(?:000|1(?:11|23))|8\\d{3})|2(?:[1-3]|50)|33|4(?:1|7\\d)|571|7(?:0\\d|[56]0)|800\\d|9[15])|2(?:0202|1300|2(?:02|11)|3(?:02|336|45)|4(?:25|8))|3[13]3|4(?:0[02]|35[01]|44[45]|5\\d)|(?:[68]\\d|7[089])\\d{3}|15\\d|2[02]2|650|789|9(?:01|99)",
                ,
                ,
                ,
                "100"
              ], [, , , , , , , , , [-1]], [, , "1(?:(?:25|7[56])\\d|571)|2(?:02(?:\\d{2})?|[13]3\\d\\d|48)|4444|901", , , , "202", , , [3, 4, 5]], , [, , "(?:125|2(?:020|13\\d)|(?:7[089]|8[01])\\d\\d)\\d", , , , "1250", , , [4, 5]]],
              GD: [, [, , "[19]\\d\\d", , , , , , , [3]], , , [, , "9(?:11|88)", , , , "911"], [, , , , , , , , , [-1]], , , , "GD", , , , , , , , , , , , , , , , , , [, , "911", , , , "911"], , [, , "176|9(?:11|88)", , , , "176"], [, , , , , , , , , [-1]], [, , "176", , , , "176"], , [, , "176", , , , "176"]],
              GE: [, [, , "[014]\\d\\d(?:\\d{2})?", , , , , , , [3, 5]], , , [, , "0(?:11|33)|11[1-3]|[01]22", , , , "011", , , [3]], [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ], , , , "GE", , , , , , , , , , , , , , , , , , [, , "0(?:11|33)|11[1-3]|[01]22", , , , "011", , , [3]], , [, , "0(?:11|33)|11[1-3]|40404|[01]22", , , , "011"], [, , , , , , , , , [-1]], [, , "404\\d\\d", , , , "40400", , , [5]], , [, , "404\\d\\d", , , , "40400", , , [5]]],
              GF: [, [, , "1\\d", , , , , , , [2]], , , [, , "1[578]", , , , "15"], [, , , , , , , , , [-1]], , , , "GF", , , , , , , , , , , , , , , , , , [, , "1[578]", , , , "15"], , [, , "1[578]", , , , "15"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              GG: [
                ,
                [, , "[19]\\d{2,5}", , , , , , , [3, 4, 5, 6]],
                ,
                ,
                [, , "112|999", , , , "112", , , [3]],
                [, , , , , , , , , [-1]],
                ,
                ,
                ,
                "GG",
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [, , "112|999", , , , "112", , , [3]],
                ,
                [, , "1(?:0[01]|1[12]|23|41|55|9[05])|999|1(?:1[68]\\d\\d|47|800)\\d", , , , "100"],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                [, , , , , , , , , [-1]]
              ],
              GH: [, [, , "[14589]\\d{2,4}", , , , , , , [3, 4, 5]], , , [, , "19[1-3]|999", , , , "191", , , [3]], [, , , , , , , , , [-1]], , , , "GH", , , , , , , , , , , , , , , , , , [, , "19[1-3]|999", , , , "191", , , [3]], , [, , "19[1-3]|40404|(?:54|83)00|999", , , , "191"], [, , , , , , , , , [-1]], [, , "404\\d\\d|(?:54|83)0\\d", , , , "5400", , , [4, 5]], , [, , "404\\d\\d|(?:54|83)0\\d", , , , "5400", , , [4, 5]]],
              GI: [, [
                ,
                ,
                "[158]\\d{2,5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [3, 4, 5, 6]
              ], , , [, , "1(?:00|1[25]|23|4(?:1|7\\d)|5[15]|9[02-49])|555|(?:116\\d|80)\\d\\d", , , , "100", , , [3, 4, 6]], [, , "8[1-69]\\d\\d", , , , "8100", , , [4]], , , , "GI", , , , , , , , , , , , , , , , , , [, , "1(?:12|9[09])", , , , "112", , , [3]], , [, , "1(?:00|1(?:[25]|6(?:00[06]|1(?:1[17]|23))|8\\d\\d)|23|4(?:1|7[014])|5[015]|9[02-49])|555|8[0-79]\\d\\d|8(?:00|4[0-2]|8[0-589])", , , , "100"], [, , "150|87\\d\\d", , , , "150", , , [3, 4]], [, , "1(?:00|1(?:5|8\\d\\d)|23|51|9[2-4])|555|8(?:00|4[0-2]|8[0-589])", , , , "100", , , [3, 5]], , [, , , , , , , , , [-1]]],
              GL: [, [
                ,
                ,
                "1\\d\\d",
                ,
                ,
                ,
                ,
                ,
                ,
                [3]
              ], , , [, , "112", , , , "112"], [, , , , , , , , , [-1]], , , , "GL", , , , , , , , , , , , , , , , , , [, , "112", , , , "112"], , [, , "1[1-8]\\d", , , , "110"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              GM: [, [, , "1\\d\\d?", , , , , , , [2, 3]], , , [, , "1(?:1[6-8]|[6-8])", , , , "16"], [, , , , , , , , , [-1]], , , , "GM", , , , , , , , , , , , , , , , , , [, , "1(?:1[6-8]|[6-8])", , , , "16"], , [, , "1(?:1[6-8]|[6-8])", , , , "16"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              GN: [, [, , "[14]\\d\\d(?:\\d{2})?", , , , , , , [3, 5]], , , [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , , , "GN", , , , , , , , , , , , , , , , , , [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ], , [, , "12\\d|40404", , , , "120"], [, , , , , , , , , [-1]], [, , "404\\d\\d", , , , "40400", , , [5]], , [, , "404\\d\\d", , , , "40400", , , [5]]],
              GP: [, [, , "1\\d", , , , , , , [2]], , , [, , "1[578]", , , , "15"], [, , , , , , , , , [-1]], , , , "GP", , , , , , , , , , , , , , , , , , [, , "1[578]", , , , "15"], , [, , "1[578]", , , , "15"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              GR: [, [, , "1\\d\\d(?:\\d{2,3})?", , , , , , , [3, 5, 6]], , , [, , "1(?:0[089]|1(?:2|6\\d{3})|66|99)", , , , "100", , , [3, 6]], [, , , , , , , , , [-1]], , , , "GR", , , , , , , , , , , , , , , , , , [, , "1(?:00|12|66|99)", , , , "100", , , [3]], , [
                ,
                ,
                "1(?:0[089]|1(?:2|320|6(?:000|1(?:1[17]|23)))|(?:389|9)9|66)",
                ,
                ,
                ,
                "100"
              ], [, , "113\\d\\d", , , , "11300", , , [5]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              GT: [, [, , "[14]\\d{2,4}", , , , , , , [3, 4, 5]], , , [, , "1(?:10|2[03])", , , , "110", , , [3]], [, , , , , , , , , [-1]], , , , "GT", , , , , , , , , , , , , , , , , , [, , "1(?:10|2[03])", , , , "110", , , [3]], , [, , "110|40404|1(?:2|[57]\\d)\\d", , , , "110"], [, , , , , , , , , [-1]], [, , "404\\d\\d", , , , "40400", , , [5]], , [, , "404\\d\\d", , , , "40400", , , [5]]],
              GU: [, [, , "9\\d\\d", , , , , , , [3]], , , [, , "9(?:11|88)", , , , "911"], [, , , , , , , , , [-1]], , , , "GU", , , , , , , , , , , , , , , , , , [, , "911", , , , "911"], , [, , "9(?:11|88)", , , , "911"], [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              GW: [, [, , "1\\d\\d", , , , , , , [3]], , , [, , "11[378]", , , , "113"], [, , , , , , , , , [-1]], , , , "GW", , , , , , , , , , , , , , , , , , [, , "11[378]", , , , "113"], , [, , "11[378]", , , , "113"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              GY: [, [, , "[019]\\d{2,3}", , , , , , , [3, 4]], , , [, , "91[1-3]", , , , "911", , , [3]], [, , , , , , , , , [-1]], , , , "GY", , , , , , , , , , , , , , , , , , [, , "91[1-3]", , , , "911", , , [3]], , [, , "0(?:02|(?:17|80)1|444|7(?:[67]7|9)|9(?:0[78]|[2-47]))|1(?:443|5[568])|91[1-3]", , , , "002"], [, , , , , , , , , [-1]], [
                ,
                ,
                "144\\d",
                ,
                ,
                ,
                "1440",
                ,
                ,
                [4]
              ], , [, , "144\\d", , , , "1440", , , [4]]],
              HK: [
                ,
                [, , "[19]\\d{2,6}", , , , , , , [3, 4, 5, 6, 7]],
                ,
                ,
                [, , "112|99[29]", , , , "112", , , [3]],
                [, , , , , , , , , [-1]],
                ,
                ,
                ,
                "HK",
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [, , "112|99[29]", , , , "112", , , [3]],
                ,
                [, , "1(?:0(?:(?:[0136]\\d|2[14])\\d{0,3}|8[138])|12|2(?:[0-3]\\d{0,4}|(?:58|8[13])\\d{0,3})|7(?:[135-9]\\d{0,4}|219\\d{0,2})|8(?:0(?:(?:[13]|60\\d)\\d|8)|1(?:0\\d|[2-8])|2(?:0[5-9]|(?:18|2)2|3|8[128])|(?:(?:3[0-689]\\d|7(?:2[1-389]|8[0235-9]|93))\\d|8)\\d|50[138]|6(?:1(?:11|86)|8)))|99[29]|10[0139]", , , , "100"],
                [, , , , , , , , , [-1]],
                [, , "109|1(?:08|85\\d)\\d", , , , "109", , , [3, 4, 5]],
                ,
                [, , "992", , , , "992", , , [3]]
              ],
              HN: [, [, , "[14]\\d\\d(?:\\d{2})?", , , , , , , [3, 5]], , , [, , "199", , , , "199", , , [3]], [, , , , , , , , , [-1]], , , , "HN", , , , , , , , , , , , , , , , , , [, , "199", , , , "199", , , [3]], , [, , "199|40404", , , , "199"], [, , , , , , , , , [-1]], [, , "404\\d\\d", , , , "40400", , , [5]], , [, , "404\\d\\d", , , , "40400", , , [5]]],
              HR: [, [, , "[016-9]\\d{1,5}", , , , , , , [2, 3, 4, 5, 6]], , , [, , "1(?:12|9[2-4])|9[34]|1(?:16\\d|39)\\d\\d", , , , "93", , , [2, 3, 5, 6]], [, , "06\\d|(?:118|[6-8]\\d{3})\\d\\d", , , , "060", , , [
                3,
                5,
                6
              ]], , , , "HR", , , , , , , , , , , , , , , , , , [, , "1(?:12|9[2-4])|9[34]", , , , "93", , , [2, 3]], , [, , "(?:06|[6-8]\\d{4})\\d|1(?:1(?:2|6(?:00[06]|1(?:1[17]|23))|8\\d\\d)|3977|9(?:[2-5]|87))|9[34]", , , , "93"], [, , , , , , , , , [-1]], [, , "139\\d\\d", , , , "13900", , , [5]], , [, , "139\\d\\d", , , , "13900", , , [5]]],
              HT: [, [, , "[14]\\d\\d(?:\\d{2})?", , , , , , , [3, 5]], , , [, , "11[48]", , , , "114", , , [3]], [, , , , , , , , , [-1]], , , , "HT", , , , , , , , , , , , , , , , , , [, , "11[48]", , , , "114", , , [3]], , [, , "11[48]|40404", , , , "114"], [, , , , , , , , , [-1]], [, , "404\\d\\d", , , , "40400", , , [5]], , [
                ,
                ,
                "404\\d\\d",
                ,
                ,
                ,
                "40400",
                ,
                ,
                [5]
              ]],
              HU: [, [, , "1\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [, , "1(?:0[457]|12|4[0-4]\\d)|1(?:16\\d|37|45)\\d\\d", , , , "104"], [, , , , , , , , , [-1]], , , , "HU", , , , , , , , , , , , , , , , , , [, , "1(?:0[457]|12)", , , , "104", , , [3]], , [, , "1(?:0[457]|1(?:2|6(?:000|1(?:11|23))|800)|2(?:0[0-4]|1[013489]|2[0-5]|3[0-46]|4[0-24-68]|5[0-2568]|6[06]|7[0-25-7]|8[028]|9[08])|37(?:00|37|7[07])|4(?:0[0-5]|1[013-8]|2[034]|3[23]|4[02-9]|5(?:00|41|67))|777|8(?:1[27-9]|2[04]|40|[589]))", , , , "104"], [, , , , , , , , , [-1]], [
                ,
                ,
                "1(?:4[0-4]|77)\\d|1(?:18|2|45)\\d\\d",
                ,
                ,
                ,
                "1200",
                ,
                ,
                [4, 5]
              ], , [, , "184\\d", , , , "1840", , , [4]]],
              ID: [, [, , "[178]\\d\\d(?:\\d{2,3})?", , , , , , , [3, 5, 6]], , , [, , "11[02389]", , , , "110", , , [3]], [, , , , , , , , , [-1]], , , , "ID", , , , , , , , , , , , , , , , , , [, , "11[02389]", , , , "110", , , [3]], , [, , "1(?:1[02389]|40\\d\\d|50264)|71400|89887", , , , "110"], [, , , , , , , , , [-1]], [, , "(?:714|898)\\d\\d", , , , "71400", , , [5]], , [, , "714\\d\\d", , , , "71400", , , [5]]],
              IE: [, [, , "[159]\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [, , "11(?:2|6\\d{3})|999", , , , "112", , , [3, 6]], [, , "5[37]\\d{3}", , , , "53000", , , [5]], , , , "IE", , , , , , , , , , , , , , , , , , [
                ,
                ,
                "112|999",
                ,
                ,
                ,
                "112",
                ,
                ,
                [3]
              ], , [, , "11(?:2|6(?:00[06]|1(?:1[17]|23)))|999|(?:1(?:18|9)|5[0137]\\d)\\d\\d", , , , "112"], [, , "51\\d{3}", , , , "51000", , , [5]], [, , "51210", , , , "51210", , , [5]], , [, , "51210|(?:118|5[037]\\d)\\d\\d", , , , "11800", , , [5]]],
              IL: [, [, , "[12]\\d{2,4}", , , , , , , [3, 4, 5]], , , [, , "1(?:0[0-2]|12)", , , , "100", , , [3]], [, , , , , , , , , [-1]], , , , "IL", , , , , , , , , , , , , , , , , , [, , "1(?:0[0-2]|12)", , , , "100", , , [3]], , [, , "1(?:0[0-2]|1(?:[013-9]\\d|2)|[2-9]\\d\\d)|2407|(?:104|27)00", , , , "100"], [, , , , , , , , , [-1]], [
                ,
                ,
                "104\\d\\d",
                ,
                ,
                ,
                "10400",
                ,
                ,
                [5]
              ], , [, , "104\\d\\d", , , , "10400", , , [5]]],
              IM: [, [, , "[189]\\d\\d(?:\\d{2,3})?", , , , , , , [3, 5, 6]], , , [, , "999", , , , "999", , , [3]], [, , , , , , , , , [-1]], , , , "IM", , , , , , , , , , , , , , , , , , [, , "999", , , , "999", , , [3]], , [, , "1\\d\\d(?:\\d{3})?|8(?:6444|9887)|999", , , , "100"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , "8(?:64|98)\\d\\d", , , , "86400", , , [5]]],
              IN: [, [, , "[12578]\\d{2,8}", , , , , , , [3, 4, 5, 6, 7, 8, 9]], , , [
                ,
                ,
                "1(?:0[0-248]|1[289]|21|[39][89]|4[01]|6(?:1|6\\d?)|8[12])|777|800|1[05]5\\d|1(?:07|51|94)\\d\\d?|(?:1(?:[05]5\\d|70)\\d|261)\\d|1(?:0[369]|10|29|3[126]|9[0-256])\\d",
                ,
                ,
                ,
                "100",
                ,
                ,
                [3, 4, 5, 6]
              ], [, , "11[67]\\d{4}|56161561", , , , "1160000", , , [7, 8]], , , , "IN", , , , , , , , , , , , , , , , , , [, , "1(?:0[0-28]|12|298)|2611", , , , "100", , , [3, 4]], , [
                ,
                ,
                "1(?:0(?:[0-248]|3[39]|5(?:010|6)|6[3468]|7(?:[01357]|[28]0?|4[01])|9[0135-9])|1(?:00|[289])|2(?:1|98)|3(?:11|2[0-2]|63|[89])|4[01]|5(?:1(?:0[0-36]|[127])|54)|6(?:1|6[01]?)|7000|8[12]|9(?:0[013-59]|12|25|4[4-9]\\d?|50|6[1347]|[89]))|2611|5(?:0(?:0(?:0\\d|1|20?)|325|5[2-79]\\d{3,5})|1(?:234|555|717|818|96[49])|2(?:0(?:0[01]|[14]0)|151|555|666|888|9(?:06|99\\d?))|3(?:0[01]0|131|553|(?:66|77)6)|(?:464|55[05])\\d{1,3}|6(?:070|3[68]|43)|717\\d)|777|800|5(?:05(?:0|1\\d)|221|3(?:03|3[23]))\\d{1,4}|5(?:(?:04|88)0|2(?:2[0267]|3[16])|4(?:1[04]|20|3[02])|5(?:3[16]|67)|6(?:06|[67]\\d)|787|9(?:64|90))\\d\\d?|(?:1(?:05[79]|(?:1[67][0-2]|802)\\d|55[23])\\d|5(?:(?:00(?:0\\d|1)|(?:304|616)\\d\\d)\\d|1(?:0[12]|4[2-4])|2(?:2[3589]|3(?:1\\d{3}|2)|4[04]|7[78])|4(?:[02]4|32\\d{4}|4[04]|99)|5(?:1[25]|[36]5|4[45]|93)|7(?:(?:17\\d|57)\\d\\d|[27]7|88)|8(?:3[4-69]|4[01]|5[58]|88(?:8\\d\\d|9)|99)|9(?:0(?:0|2\\d{3})|55|6[67]|77|88)))\\d",
                ,
                ,
                ,
                "100"
              ], [, , "5(?:14(?:2[5-9]|[34]\\d)|757555)", , , , "51425", , , [5, 7]], [, , "1(?:(?:1[67]\\d\\d|70)\\d\\d|55330|909)|5(?:300\\d|6161(?:17[89]|561))|1(?:[19][89]|21|4[01])", , , , "118", , , [3, 4, 5, 6, 7, 8]], , [, , "1(?:39|90[019])|5(?:14(?:2[5-9]|[34]\\d)|6161(?:17[89]|561)|757555)", , , , "139", , , [3, 4, 5, 7, 8]]],
              IQ: [, [, , "[1479]\\d{2,4}", , , , , , , [3, 4, 5]], , , [, , "1(?:0[04]|15|22)", , , , "100", , , [3]], [, , , , , , , , , [-1]], , , , "IQ", , , , , , , , , , , , , , , , , , [, , "1(?:0[04]|15|22)", , , , "100", , , [3]], , [, , "1(?:0[04]|15|22)|4432|71117|9988", , , , "100"], [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ], [, , "(?:443|711\\d|998)\\d", , , , "4430", , , [4, 5]], , [, , "(?:443|711\\d|998)\\d", , , , "4430", , , [4, 5]]],
              IR: [, [, , "[129]\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [, , "1(?:1[0-68]|2[0-59]|9[0-579])|911", , , , "110", , , [3]], [, , , , , , , , , [-1]], , , , "IR", , , , , , , , , , , , , , , , , , [, , "1(?:1[025]|25)|911", , , , "110", , , [3]], , [
                ,
                ,
                "1(?:1[0-68]|2[0-59]|3[346-8]|4(?:[0147]|[289]0)|5(?:0[14]|1[02479]|2[0-3]|39|[49]0|65)|6(?:[16]6|[27]|90)|8(?:03|1[18]|22|3[37]|4[28]|88|99)|9[0-579])|20(?:[09]0|1(?:[038]|1[079]|26|9[69])|2[01])|9(?:11|9(?:0009|90))",
                ,
                ,
                ,
                "110"
              ], [, , "1(?:5[0-469]|8[0-489])\\d", , , , "1500", , , [4]], [, , "(?:1(?:5[0-469]|8[0-489])|99(?:0\\d\\d|9))\\d", , , , "1500", , , [4, 6]], , [, , "990\\d{3}", , , , "990000", , , [6]]],
              IS: [, [, , "1\\d\\d(?:\\d(?:\\d{2})?)?", , , , , , , [3, 4, 6]], , , [, , "1(?:12|71\\d)", , , , "112", , , [3, 4]], [, , , , , , , , , [-1]], , , , "IS", , , , , , , , , , , , , , , , , , [, , "112", , , , "112", , , [3]], , [, , "1(?:1(?:[28]|61(?:16|23))|4(?:00|1[145]|4[0146])|55|7(?:00|17|7[07-9])|8(?:[02]0|1[16-9]|88)|900)", , , , "112"], [, , , , , , , , , [-1]], [, , "14(?:0\\d|41)", , , , "1400", , , [4]], , [
                ,
                ,
                "1(?:415|90\\d)",
                ,
                ,
                ,
                "1415",
                ,
                ,
                [4]
              ]],
              IT: [
                ,
                [, , "[14]\\d{2,6}", , , , , , , [3, 4, 5, 6, 7]],
                ,
                ,
                [, , "1(?:1(?:[2358]|6\\d{3})|87)", , , , "112", , , [3, 6]],
                [, , "(?:12|4(?:[478](?:[0-4]|[5-9]\\d\\d)|55))\\d\\d", , , , "1200", , , [4, 5, 7]],
                ,
                ,
                ,
                "IT",
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [, , "11[2358]", , , , "112", , , [3]],
                ,
                [, , "1(?:0\\d{2,3}|1(?:[2-57-9]|6(?:000|111))|3[39]|4(?:82|9\\d{1,3})|5(?:00|1[58]|2[25]|3[03]|44|[59])|60|8[67]|9(?:[01]|2[2-9]|4\\d|696))|4(?:2323|5045)|(?:1(?:2|92[01])|4(?:3(?:[01]|[45]\\d\\d)|[478](?:[0-4]|[5-9]\\d\\d)|55))\\d\\d", , , , "112"],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                [, , "4(?:3(?:[01]|[45]\\d\\d)|[478](?:[0-4]|[5-9]\\d\\d)|5[05])\\d\\d", , , , "43000", , , [5, 7]]
              ],
              JE: [, [, , "[129]\\d\\d(?:\\d(?:\\d{2})?)?", , , , , , , [3, 4, 6]], , , [, , "112|999", , , , "112", , , [3]], [, , , , , , , , , [-1]], , , , "JE", , , , , , , , , , , , , , , , , , [, , "112|999", , , , "112", , , [3]], , [, , "1(?:00|1(?:2|8\\d{3})|23|4(?:[14]|28|7\\d)|5\\d|7(?:0[12]|[128]|35?)|808|9[0135])|23[2-4]|999", , , , "100"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              JM: [, [, , "[19]\\d\\d", , , , , , , [3]], , , [, , "11[029]|9(?:11|88)", , , , "110"], [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ], , , , "JM", , , , , , , , , , , , , , , , , , [, , "11[029]|911", , , , "110"], , [, , "1(?:1[029]|76)|9(?:11|88)", , , , "110"], [, , , , , , , , , [-1]], [, , "176", , , , "176"], , [, , "176", , , , "176"]],
              JO: [, [, , "[19]\\d\\d(?:\\d{2})?", , , , , , , [3, 5]], , , [, , "1(?:0[235]|1[2-6]|9[127])|911", , , , "102", , , [3]], [, , "9[0-4689]\\d{3}", , , , "90000", , , [5]], , , , "JO", , , , , , , , , , , , , , , , , , [, , "1(?:12|9[127])|911", , , , "112", , , [3]], , [, , "1(?:0[2359]|1[0-68]|9[0-24-79])|9[0-4689]\\d{3}|911", , , , "102"], [, , , , , , , , , [-1]], [, , "9[0-4689]\\d{3}", , , , "90000", , , [5]], , [
                ,
                ,
                "9[0-4689]\\d{3}",
                ,
                ,
                ,
                "90000",
                ,
                ,
                [5]
              ]],
              JP: [, [, , "[01]\\d\\d(?:\\d{5,7})?", , , , , , , [3, 8, 9, 10]], , , [, , "11[089]", , , , "110", , , [3]], [, , , , , , , , , [-1]], , , , "JP", , , , , , , , , , , , , , , , , , [, , "11[09]", , , , "110", , , [3]], , [, , "000[2569]\\d{4,6}|1(?:0[24]|1[089]|44|89)", , , , "102"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , "000[2569]\\d{4,6}", , , , "00020000", , , [8, 9, 10]]],
              KE: [, [, , "[1-9]\\d{2,4}", , , , , , , [3, 4, 5]], , , [, , "1(?:1(?:[246]|9\\d)|5(?:01|2[127]|6[26]\\d))|999", , , , "112"], [, , "909\\d\\d", , , , "90900", , , [5]], , , , "KE", , , , , , , , , , , , , , , , , , [
                ,
                ,
                "11[24]|999",
                ,
                ,
                ,
                "112",
                ,
                ,
                [3]
              ], , [, , "1(?:0(?:[07-9]|1[0-25]|400)|1(?:[024-6]|9[0-579])|2[1-3]|3[01]|4[14]|5(?:[01][01]|2[0-24-79]|33|4[05]|5[59]|6(?:00|29|6[67]))|(?:6[035]\\d|[78])\\d|9(?:[02-9]\\d\\d|19))|(?:(?:2[0-79]|[37][0-29]|4[0-4]|6[2357]|8\\d)\\d|5(?:[0-7]\\d|99))\\d\\d|9(?:09\\d\\d|99)|8988", , , , "100"], [, , , , , , , , , [-1]], [, , "1(?:(?:04|6[35])\\d\\d|3[01]|4[14]|5(?:1\\d|2[25]))|(?:(?:2[0-79]|[37][0-29]|4[0-4]|6[2357]|8\\d)\\d|5(?:[0-7]\\d|99)|909)\\d\\d|898\\d", , , , "130"], , [
                ,
                ,
                "1(?:(?:04|6[035])\\d\\d|4[14]|5(?:01|55|6[26]\\d))|40404|8988|909\\d\\d",
                ,
                ,
                ,
                "141"
              ]],
              KG: [, [, , "[14]\\d{2,3}", , , , , , , [3, 4]], , , [, , "10[1-3]", , , , "101", , , [3]], [, , , , , , , , , [-1]], , , , "KG", , , , , , , , , , , , , , , , , , [, , "10[1-3]", , , , "101", , , [3]], , [, , "10[1-3]|4040", , , , "101"], [, , , , , , , , , [-1]], [, , "404\\d", , , , "4040", , , [4]], , [, , "404\\d", , , , "4040", , , [4]]],
              KH: [, [, , "[146]\\d\\d(?:\\d{2})?", , , , , , , [3, 5]], , , [, , "11[7-9]|666", , , , "117", , , [3]], [, , , , , , , , , [-1]], , , , "KH", , , , , , , , , , , , , , , , , , [, , "11[7-9]|666", , , , "117", , , [3]], , [, , "11[7-9]|40404|666", , , , "117"], [, , , , , , , , , [-1]], [, , "404\\d\\d", , , , "40400", , , [5]], , [
                ,
                ,
                "404\\d\\d",
                ,
                ,
                ,
                "40400",
                ,
                ,
                [5]
              ]],
              KI: [, [, , "[179]\\d{2,3}", , , , , , , [3, 4]], , , [, , "19[2-5]|99[2-4]", , , , "192", , , [3]], [, , , , , , , , , [-1]], , , , "KI", , , , , , , , , , , , , , , , , , [, , "19[2-5]|99[2-4]", , , , "192", , , [3]], , [, , "1(?:05[0-259]|88|9[2-5])|777|99[2-4]|10[0-8]", , , , "100"], [, , "103", , , , "103", , , [3]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              KM: [, [, , "1\\d", , , , , , , [2]], , , [, , "1[78]", , , , "17"], [, , , , , , , , , [-1]], , , , "KM", , , , , , , , , , , , , , , , , , [, , "1[78]", , , , "17"], , [, , "1[78]", , , , "17"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              KN: [
                ,
                [, , "[39]\\d\\d", , , , , , , [3]],
                ,
                ,
                [, , "333|9(?:11|88|99)", , , , "333"],
                [, , , , , , , , , [-1]],
                ,
                ,
                ,
                "KN",
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [, , "333|9(?:11|99)", , , , "333"],
                ,
                [, , "333|9(?:11|88|99)", , , , "333"],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                [, , , , , , , , , [-1]]
              ],
              KP: [, [, , "[18]\\d\\d", , , , , , , [3]], , , [, , "11[29]|819", , , , "112"], [, , , , , , , , , [-1]], , , , "KP", , , , , , , , , , , , , , , , , , [, , "11[29]|819", , , , "112"], , [, , "11[29]|819", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              KR: [
                ,
                [, , "1\\d{2,4}", , , , , , , [3, 4, 5]],
                ,
                ,
                [, , "1(?:1[27-9]|28|330|82)", , , , "112", , , [3, 4]],
                [, , , , , , , , , [-1]],
                ,
                ,
                ,
                "KR",
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [, , "11[29]", , , , "112", , , [3]],
                ,
                [, , "1(?:[016-9]114|3(?:0[01]|2|3[0-35-9]|45?|5[057]|6[569]|7[79]|8[2589]|9[0189]))|1(?:0[015]|1\\d|2[01357-9]|41|8[28])", , , , "100"],
                [, , , , , , , , , [-1]],
                [, , "1(?:0[01]|1[4-6]|41)|1(?:[06-9]1\\d|111)\\d", , , , "100", , , [3, 5]],
                ,
                [, , , , , , , , , [-1]]
              ],
              KW: [, [, , "[18]\\d\\d(?:\\d{2})?", , , , , , , [3, 5]], , , [, , "112", , , , "112", , , [3]], [, , , , , , , , , [-1]], , , , "KW", , , , , , , , , , , , , , , , , , [, , "112", , , , "112", , , [3]], , [, , "1[0-7]\\d|89887", , , , "100"], [, , , , , , , , , [-1]], [, , "898\\d\\d", , , , "89800", , , [5]], , [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]],
              KY: [, [, , "9\\d\\d", , , , , , , [3]], , , [, , "9(?:11|88)", , , , "911"], [, , , , , , , , , [-1]], , , , "KY", , , , , , , , , , , , , , , , , , [, , "911", , , , "911"], , [, , "9(?:11|88)", , , , "911"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              KZ: [, [, , "[1-4]\\d{2,4}", , , , , , , [3, 4, 5]], , , [, , "1(?:0[1-3]|12)|212\\d", , , , "101", , , [3, 4]], [, , , , , , , , , [-1]], , , , "KZ", , , , , , , , , , , , , , , , , , [, , "1(?:0[1-3]|12)", , , , "101", , , [3]], , [, , "1(?:0[1-4]|12)|2121|(?:3040|404)0", , , , "101"], [, , , , , , , , , [-1]], [, , "(?:304\\d|404)\\d", , , , "4040", , , [4, 5]], , [
                ,
                ,
                "(?:304\\d|404)\\d",
                ,
                ,
                ,
                "4040",
                ,
                ,
                [4, 5]
              ]],
              LA: [, [, , "1\\d\\d", , , , , , , [3]], , , [, , "19[015]", , , , "190"], [, , , , , , , , , [-1]], , , , "LA", , , , , , , , , , , , , , , , , , [, , "19[015]", , , , "190"], , [, , "19[015]", , , , "190"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              LB: [, [, , "[19]\\d\\d", , , , , , , [3]], , , [, , "1(?:12|40|75)|999", , , , "112"], [, , , , , , , , , [-1]], , , , "LB", , , , , , , , , , , , , , , , , , [, , "1(?:12|40|75)|999", , , , "112"], , [, , "1(?:12|40|75)|999", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              LC: [, [, , "9\\d\\d", , , , , , , [3]], , , [, , "9(?:11|88|99)", , , , "911"], [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ], , , , "LC", , , , , , , , , , , , , , , , , , [, , "9(?:11|99)", , , , "911"], , [, , "9(?:11|88|99)", , , , "911"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              LI: [, [, , "1\\d{2,3}", , , , , , , [3, 4]], , , [, , "1(?:1[278]|44)", , , , "112", , , [3]], [, , , , , , , , , [-1]], , , , "LI", , , , , , , , , , , , , , , , , , [, , "1(?:1[278]|44)", , , , "112", , , [3]], , [, , "1(?:1(?:[278]|45)|4[3-57]|50|75|81[18])", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              LK: [
                ,
                [, , "1\\d{2,3}", , , , , , , [3, 4]],
                ,
                ,
                [, , "11[02689]", , , , "110", , , [3]],
                [, , , , , , , , , [-1]],
                ,
                ,
                ,
                "LK",
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [, , "11[02689]", , , , "110", , , [3]],
                ,
                [, , "1(?:1[024-9]|3(?:00|1[2-49]|2[23]|3[1-3]|44|5[07]|[67]9|88|9[039])|9(?:0[0-2589]|1[0-357-9]|2[0-25689]|3[0389]|4[0489]|5[014-69]|6[0-2689]|7[03579]|8[02457-9]|9[0-2569]))", , , , "110"],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                [, , , , , , , , , [-1]]
              ],
              LR: [, [, , "[3489]\\d{2,3}", , , , , , , [3, 4]], , , [, , "355|911", , , , "355", , , [3]], [, , , , , , , , , [-1]], , , , "LR", , , , , , , , , , , , , , , , , , [, , "355|911", , , , "355", , , [3]], , [, , "355|4040|8(?:400|933)|911", , , , "355"], [, , , , , , , , , [-1]], [
                ,
                ,
                "(?:404|8(?:40|93))\\d",
                ,
                ,
                ,
                "4040",
                ,
                ,
                [4]
              ], , [, , "(?:404|8(?:40|93))\\d", , , , "4040", , , [4]]],
              LS: [, [, , "1\\d\\d", , , , , , , [3]], , , [, , "11[257]", , , , "112"], [, , , , , , , , , [-1]], , , , "LS", , , , , , , , , , , , , , , , , , [, , "11[257]", , , , "112"], , [, , "11[257]", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              LT: [, [, , "[01]\\d(?:\\d(?:\\d{3})?)?", , , , , , , [2, 3, 6]], , , [, , "0(?:11?|22?|33?)|1(?:0[1-3]|1(?:2|6111))|116(?:0\\d|12)\\d", , , , "01"], [, , , , , , , , , [-1]], , , , "LT", , , , , , , , , , , , , , , , , , [, , "0(?:11?|22?|33?)|1(?:0[1-3]|12)", , , , "01", , , [2, 3]], , [
                ,
                ,
                "0(?:11?|22?|33?)|1(?:0[1-3]|1(?:[27-9]|6(?:000|1(?:1[17]|23))))",
                ,
                ,
                ,
                "01"
              ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              LU: [, [, , "1\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [, , "11(?:[23]|6\\d{3})", , , , "112", , , [3, 6]], [, , , , , , , , , [-1]], , , , "LU", , , , , , , , , , , , , , , , , , [, , "11[23]", , , , "112", , , [3]], , [, , "11(?:[23]|6(?:000|111))|1(?:18|[25]\\d|3)\\d\\d", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              LV: [, [, , "[018]\\d{1,5}", , , , , , , [2, 3, 4, 5, 6]], , , [, , "0[1-3]|11(?:[023]|6\\d{3})", , , , "01", , , [2, 3, 6]], [, , "1180|821\\d\\d", , , , "1180", , , [4, 5]], , , , "LV", , , , , , , , , , , , , , , , , , [
                ,
                ,
                "0[1-3]|11[023]",
                ,
                ,
                ,
                "01",
                ,
                ,
                [2, 3]
              ], , [, , "0[1-4]|1(?:1(?:[02-4]|6(?:000|111)|8[0189])|(?:5|65)5|77)|821[57]4", , , , "01"], [, , "1181", , , , "1181", , , [4]], [, , "165\\d", , , , "1650", , , [4]], , [, , , , , , , , , [-1]]],
              LY: [, [, , "1\\d\\d", , , , , , , [3]], , , [, , "19[013]", , , , "190"], [, , , , , , , , , [-1]], , , , "LY", , , , , , , , , , , , , , , , , , [, , "19[013]", , , , "190"], , [, , "19[013]", , , , "190"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              MA: [, [, , "1\\d\\d?", , , , , , , [2, 3]], , , [, , "1(?:[59]|77)", , , , "15"], [, , , , , , , , , [-1]], , , , "MA", , , , , , , , , , , , , , , , , , [, , "1(?:[59]|77)", , , , "15"], , [
                ,
                ,
                "1(?:[59]|77)",
                ,
                ,
                ,
                "15"
              ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              MC: [, [, , "1\\d\\d?", , , , , , , [2, 3]], , , [, , "1(?:12|[578])", , , , "15"], [, , , , , , , , , [-1]], , , , "MC", , , , , , , , , , , , , , , , , , [, , "1(?:12|[578])", , , , "15"], , [, , "1(?:12|41|[578])", , , , "15"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              MD: [, [, , "[19]\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [, , "11(?:2|6(?:000|1(?:11|2\\d)))|90[1-3]", , , , "112", , , [3, 6]], [, , , , , , , , , [-1]], , , , "MD", , , , , , , , , , , , , , , , , , [, , "112|90[1-3]", , , , "112", , , [3]], , [
                ,
                ,
                "1(?:1(?:2|6(?:00[06]|1(?:1[17]|23))|8\\d\\d?|99)|90[04-9])|90[1-3]|1(?:4\\d\\d|6[0-389]|9[1-4])\\d",
                ,
                ,
                ,
                "112"
              ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              ME: [, [, , "1\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [, , "1(?:12|2[2-4])", , , , "112", , , [3]], [, , , , , , , , , [-1]], , , , "ME", , , , , , , , , , , , , , , , , , [, , "1(?:12|2[2-4])", , , , "112", , , [3]], , [, , "1(?:1(?:(?:[013-57-9]|6\\d\\d)\\d|2)|[249]\\d{3}|5999|8(?:0[089]|1[0-8]|888))|1(?:[02-5]\\d\\d|60[06]|700)|12\\d", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              MF: [
                ,
                [, , "1\\d", , , , , , , [2]],
                ,
                ,
                [, , "1[578]", , , , "15"],
                [, , , , , , , , , [-1]],
                ,
                ,
                ,
                "MF",
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [, , "1[578]", , , , "15"],
                ,
                [, , "1[578]", , , , "15"],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                [, , , , , , , , , [-1]]
              ],
              MG: [, [, , "1\\d\\d?", , , , , , , [2, 3]], , , [, , "1(?:1[78]|[78])", , , , "17"], [, , , , , , , , , [-1]], , , , "MG", , , , , , , , , , , , , , , , , , [, , "1(?:1[78]|[78])", , , , "17"], , [, , "1(?:1[78]|[78])", , , , "17"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              MH: [, [, , "9\\d\\d", , , , , , , [3]], , , [, , "911", , , , "911"], [, , , , , , , , , [-1]], , , , "MH", , , , , , , , , , , , , , , , , , [, , "911", , , , "911"], , [, , "911", , , , "911"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              MK: [, [
                ,
                ,
                "1\\d\\d(?:\\d(?:\\d{2})?)?",
                ,
                ,
                ,
                ,
                ,
                ,
                [3, 4, 6]
              ], , , [, , "1(?:1(?:2|6\\d{3})|9[2-4])", , , , "112", , , [3, 6]], [, , , , , , , , , [-1]], , , , "MK", , , , , , , , , , , , , , , , , , [, , "1(?:12|9[2-4])", , , , "112", , , [3]], , [, , "1(?:1(?:2|8\\d)|3\\d|9[2-4])|1(?:16|2\\d)\\d{3}", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              ML: [, [, , "[136-8]\\d{1,4}", , , , , , , [2, 3, 4, 5]], , , [, , "1[578]|(?:352|67)00|7402|(?:677|744|8000)\\d", , , , "15", , , [2, 4, 5]], [, , "(?:12|800)2\\d|3(?:52(?:11|2[02]|3[04-6]|99)|7574)", , , , "1220", , , [4, 5]], , , , "ML", , , , , , , , , , , , , , , , , , [, , "1[578]", , , , "15", , , [2]], , [
                ,
                ,
                "1(?:1(?:[013-9]\\d|2)|2(?:1[02-469]|2[13])|[578])|350(?:35|57)|67(?:0[09]|[59]9|77|8[89])|74(?:0[02]|44|55)|800[0-2][12]|3(?:52|[67]\\d)\\d\\d",
                ,
                ,
                ,
                "15"
              ], [, , "37(?:433|575)|7400|8001\\d", , , , "7400", , , [4, 5]], [, , "3503\\d|(?:3[67]\\d|800)\\d\\d", , , , "35030", , , [5]], , [, , "374(?:0[24-9]|[1-9]\\d)|7400|3(?:6\\d|75)\\d\\d", , , , "7400", , , [4, 5]]],
              MM: [, [, , "1\\d\\d", , , , , , , [3]], , , [, , "199", , , , "199"], [, , , , , , , , , [-1]], , , , "MM", , , , , , , , , , , , , , , , , , [, , "199", , , , "199"], , [, , "199", , , , "199"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]],
              MN: [, [, , "1\\d\\d", , , , , , , [3]], , , [, , "10[0-35]", , , , "100"], [, , , , , , , , , [-1]], , , , "MN", , , , , , , , , , , , , , , , , , [, , "10[0-35]", , , , "100"], , [, , "10[0-35]", , , , "100"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              MO: [, [, , "9\\d\\d", , , , , , , [3]], , , [, , "999", , , , "999"], [, , , , , , , , , [-1]], , , , "MO", , , , , , , , , , , , , , , , , , [, , "999", , , , "999"], , [, , "999", , , , "999"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              MP: [
                ,
                [, , "9\\d\\d", , , , , , , [3]],
                ,
                ,
                [, , "9(?:11|88)", , , , "911"],
                [, , , , , , , , , [-1]],
                ,
                ,
                ,
                "MP",
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [, , "911", , , , "911"],
                ,
                [, , "9(?:11|88)", , , , "911"],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                [, , , , , , , , , [-1]]
              ],
              MQ: [, [, , "[13]\\d(?:\\d(?:\\d(?:\\d{2})?)?)?", , , , , , , [2, 3, 4, 6]], , , [, , "1(?:12|[578])|3[01]\\d\\d", , , , "15", , , [2, 3, 4]], [, , "3[2469]\\d\\d", , , , "3200", , , [4]], , , , "MQ", , , , , , , , , , , , , , , , , , [, , "1(?:12|[578])", , , , "15", , , [2, 3]], , [, , "1(?:12|[578])|(?:118[02-9]|3[0-2469])\\d\\d", , , , "15"], [, , "118\\d{3}", , , , "118000", , , [6]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              MR: [
                ,
                [, , "1\\d", , , , , , , [2]],
                ,
                ,
                [, , "1[78]", , , , "17"],
                [, , , , , , , , , [-1]],
                ,
                ,
                ,
                "MR",
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [, , "1[78]", , , , "17"],
                ,
                [, , "1[78]", , , , "17"],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                [, , , , , , , , , [-1]]
              ],
              MS: [, [, , "[29]\\d\\d", , , , , , , [3]], , , [, , "9(?:11|88|99)", , , , "911"], [, , , , , , , , , [-1]], , , , "MS", , , , , , , , , , , , , , , , , , [, , "9(?:11|99)", , , , "911"], , [, , "211|9(?:11|88|99)", , , , "211"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              MT: [, [, , "1\\d\\d(?:\\d{3})?", , , , , , , [3, 6]], , , [, , "11(?:2|6\\d{3})", , , , "112"], [, , , , , , , , , [-1]], , , , "MT", , , , , , , , , , , , , , , , , , [, , "112", , , , "112", , , [3]], , [, , "11(?:2|6(?:000|1(?:11|23)))", , , , "112"], [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              MU: [, [, , "[189]\\d{2,4}", , , , , , , [3, 4, 5]], , , [, , "11[45]|99[59]", , , , "114", , , [3]], [, , , , , , , , , [-1]], , , , "MU", , , , , , , , , , , , , , , , , , [, , "11[45]|99[59]", , , , "114", , , [3]], , [, , "1\\d{2,4}|(?:8\\d\\d|99)\\d", , , , "100"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              MV: [, [, , "[14]\\d{2,3}", , , , , , , [3, 4]], , , [, , "1(?:02|1[89])", , , , "102", , , [3]], [, , , , , , , , , [-1]], , , , "MV", , , , , , , , , , , , , , , , , , [, , "1(?:02|1[89])", , , , "102", , , [3]], , [, , "1(?:[0-37-9]|[4-6]\\d)\\d|4040|1[45]1", , , , "100"], [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ], [, , "1[45]1", , , , "141", , , [3]], , [, , , , , , , , , [-1]]],
              MW: [, [, , "[189]\\d\\d(?:\\d{2})?", , , , , , , [3, 5]], , , [, , "199|99[7-9]", , , , "199", , , [3]], [, , , , , , , , , [-1]], , , , "MW", , , , , , , , , , , , , , , , , , [, , "199|99[7-9]", , , , "199", , , [3]], , [, , "199|80400|99[7-9]", , , , "199"], [, , , , , , , , , [-1]], [, , "804\\d\\d", , , , "80400", , , [5]], , [, , "804\\d\\d", , , , "80400", , , [5]]],
              MX: [, [, , "[0579]\\d{2,4}", , , , , , , [3, 4, 5]], , , [, , "0(?:6[0568]|80)|911", , , , "060", , , [3]], [, , "(?:530\\d|776)\\d", , , , "7760", , , [4, 5]], , , , "MX", , , , , , , , , , , , , , , , , , [
                ,
                ,
                "0(?:6[0568]|80)|911",
                ,
                ,
                ,
                "060",
                ,
                ,
                [3]
              ], , [, , "0[1-9]\\d|53053|7766|911", , , , "010"], [, , , , , , , , , [-1]], [, , "0(?:[249]0|[35][01])", , , , "020", , , [3]], , [, , , , , , , , , [-1]]],
              MY: [, [, , "[1369]\\d{2,4}", , , , , , , [3, 4, 5]], , , [, , "112|999", , , , "112", , , [3]], [, , , , , , , , , [-1]], , , , "MY", , , , , , , , , , , , , , , , , , [, , "112|999", , , , "112", , , [3]], , [
                ,
                ,
                "1(?:0[01348]|1(?:[02]|1[128]|311)|2(?:0[125]|[13-6]|2\\d{0,2})|(?:3[1-35-79]|7[45])\\d\\d?|5(?:454|5\\d\\d?|77|888|999?)|8(?:18?|2|8[18])|9(?:[124]\\d?|68|71|9[0679]))|66628|99[1-469]|13[5-7]|(?:1(?:0[569]|309|5[12]|7[136-9]|9[03])|3[23679]\\d\\d)\\d",
                ,
                ,
                ,
                "100"
              ], [, , "666\\d\\d", , , , "66600", , , [5]], [, , , , , , , , , [-1]], , [, , "(?:3[23679]\\d|666)\\d\\d", , , , "32000", , , [5]]],
              MZ: [, [, , "1\\d{2,3}", , , , , , , [3, 4]], , , [, , "1(?:1[79]|9[78])", , , , "117", , , [3]], [, , , , , , , , , [-1]], , , , "MZ", , , , , , , , , , , , , , , , , , [, , "1(?:1[79]|9[78])", , , , "117", , , [3]], , [, , "1(?:[02-5]\\d\\d|1[79]|9[78])", , , , "117"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              NA: [, [, , "[19]\\d{2,4}", , , , , , , [3, 4, 5]], , , [, , "10111", , , , "10111", , , [5]], [, , , , , , , , , [-1]], , , , "NA", , , , , , , , , , , , , , , , , , [, , "10111", , , , "10111", , , [5]], , [
                ,
                ,
                "(?:10|93)111|(?:1\\d|9)\\d\\d",
                ,
                ,
                ,
                "900"
              ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              NC: [, [, , "[135]\\d{1,3}", , , , , , , [2, 3, 4]], , , [, , "1(?:0(?:00|1[23]|3[0-2]|8\\d)|[5-8])|363\\d|577", , , , "15"], [, , , , , , , , , [-1]], , , , "NC", , , , , , , , , , , , , , , , , , [, , "1[5-8]", , , , "15", , , [2]], , [, , "1(?:0(?:0[06]|1[02-46]|20|3[0-25]|42|5[058]|77|88)|[5-8])|3631|5[6-8]\\d", , , , "15"], [, , "5(?:67|88)", , , , "567", , , [3]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              NE: [, [, , "[1-3578]\\d(?:\\d(?:\\d{3})?)?", , , , , , , [2, 3, 6]], , , [
                ,
                ,
                "1(?:18|[578])|723\\d{3}",
                ,
                ,
                ,
                "15"
              ], [, , , , , , , , , [-1]], , , , "NE", , , , , , , , , , , , , , , , , , [, , "1(?:18|[578])|723141", , , , "15"], , [, , "1(?:0[01]|1[128]|2[034]|3[013]|[46]0|55?|[78])|222|333|555|723141|888", , , , "15"], [, , , , , , , , , [-1]], [, , "1(?:0[01]|1[12]|2[034]|3[013]|[46]0|55)|222|333|555|888", , , , "100", , , [3]], , [, , , , , , , , , [-1]]],
              NF: [, [, , "9\\d\\d", , , , , , , [3]], , , [, , "9(?:11|55|77)", , , , "911"], [, , , , , , , , , [-1]], , , , "NF", , , , , , , , , , , , , , , , , , [, , "9(?:11|55|77)", , , , "911"], , [, , "9(?:11|55|77)", , , , "911"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              NG: [, [
                ,
                ,
                "[14]\\d\\d(?:\\d{2})?",
                ,
                ,
                ,
                ,
                ,
                ,
                [3, 5]
              ], , , [, , "199", , , , "199", , , [3]], [, , , , , , , , , [-1]], , , , "NG", , , , , , , , , , , , , , , , , , [, , "199", , , , "199", , , [3]], , [, , "199|40700", , , , "199"], [, , , , , , , , , [-1]], [, , "407\\d\\d", , , , "40700", , , [5]], , [, , "407\\d\\d", , , , "40700", , , [5]]],
              NI: [, [, , "[12467]\\d{2,3}", , , , , , , [3, 4]], , , [, , "1(?:1[58]|2[08])|737\\d", , , , "115"], [, , , , , , , , , [-1]], , , , "NI", , , , , , , , , , , , , , , , , , [, , "1(?:1[58]|2[08])", , , , "115", , , [3]], , [, , "1(?:1[58]|200)|4878|7(?:010|373)|12[0158]|(?:19|[267]1)00", , , , "115"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              NL: [
                ,
                [, , "[1349]\\d\\d(?:\\d(?:\\d{2})?)?", , , , , , , [3, 4, 6]],
                ,
                ,
                [, , "11(?:2|6\\d{3})|911", , , , "112", , , [3, 6]],
                [, , , , , , , , , [-1]],
                ,
                ,
                ,
                "NL",
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [, , "112|911", , , , "112", , , [3]],
                ,
                [, , "1(?:1(?:2|6(?:00[06]|1(?:11|23)))|2(?:0[0-4]|3[34]|44)|3[03-9]\\d|400|8(?:[02-9]\\d|1[0-79]))|[34]000|911", , , , "112"],
                [, , , , , , , , , [-1]],
                [, , "120\\d", , , , "1200", , , [4]],
                ,
                [, , "[34]00\\d", , , , "3000", , , [4]]
              ],
              NO: [, [, , "[01]\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [, , "11(?:[023]|6\\d{3})", , , , "110", , , [3, 6]], [, , , , , , , , , [-1]], , , , "NO", , , , , , , , , , , , , , , , , , [
                ,
                ,
                "11[023]",
                ,
                ,
                ,
                "110",
                ,
                ,
                [3]
              ], , [, , "04\\d{3}|1(?:1(?:[0239]|61(?:1[17]|23))|2[048]|4(?:12|[59])|7[57]|8\\d\\d|90)", , , , "110"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , "04\\d{3}", , , , "04000", , , [5]]],
              NP: [, [, , "1\\d{2,3}", , , , , , , [3, 4]], , , [, , "1(?:0[0-36]|12)|1(?:09|11)\\d", , , , "100"], [, , , , , , , , , [-1]], , , , "NP", , , , , , , , , , , , , , , , , , [, , "1(?:0[0-3]|12)", , , , "100", , , [3]], , [, , "1(?:0(?:[0-36]|98)|1(?:1[1-4]|2))", , , , "100"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              NR: [
                ,
                [, , "1\\d\\d", , , , , , , [3]],
                ,
                ,
                [, , "11[0-2]", , , , "110"],
                [, , , , , , , , , [-1]],
                ,
                ,
                ,
                "NR",
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [, , "11[0-2]", , , , "110"],
                ,
                [, , "1(?:1[0-2]|23|92)", , , , "110"],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                [, , , , , , , , , [-1]]
              ],
              NU: [, [, , "[019]\\d\\d", , , , , , , [3]], , , [, , "999", , , , "999"], [, , , , , , , , , [-1]], , , , "NU", , , , , , , , , , , , , , , , , , [, , "999", , , , "999"], , [, , "01[05]|101|999", , , , "010"], [, , , , , , , , , [-1]], [, , "010", , , , "010"], , [, , , , , , , , , [-1]]],
              NZ: [, [, , "\\d{3,4}", , , , , , , [3, 4]], , , [, , "111", , , , "111", , , [3]], [, , "018", , , , "018", , , [3]], , , , "NZ", , , , , , , , , , , , , , , , , , [, , "111", , , , "111", , , [3]], , [
                ,
                ,
                "018|1(?:(?:1|37)1|(?:23|94)4|7[03]7)|[2-57-9]\\d{2,3}|6(?:161|26[0-3]|742)",
                ,
                ,
                ,
                "018"
              ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , "018|(?:1(?:23|37|7[03]|94)|6(?:[12]6|74))\\d|[2-57-9]\\d{2,3}", , , , "018"]],
              OM: [, [, , "[19]\\d{3}", , , , , , , [4]], , , [, , "1444|999\\d", , , , "1444"], [, , , , , , , , , [-1]], , , , "OM", , , , , , , , , , , , , , , , , , [, , "1444|9999", , , , "1444"], , [, , "1(?:111|222|4(?:4[0-5]|50|66|7[7-9])|51[0-8])|9999|1(?:2[3-5]|3[0-2]|50)\\d", , , , "1111"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              PA: [
                ,
                [, , "[19]\\d\\d", , , , , , , [3]],
                ,
                ,
                [, , "911", , , , "911"],
                [, , , , , , , , , [-1]],
                ,
                ,
                ,
                "PA",
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [, , "911", , , , "911"],
                ,
                [, , "10[2-4]|911", , , , "102"],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                [, , , , , , , , , [-1]]
              ],
              PE: [, [, , "1\\d\\d", , , , , , , [3]], , , [, , "1(?:05|1[67])", , , , "105"], [, , , , , , , , , [-1]], , , , "PE", , , , , , , , , , , , , , , , , , [, , "1(?:05|1[67])", , , , "105"], , [, , "1(?:05|1[67])", , , , "105"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              PF: [, [, , "1\\d", , , , , , , [2]], , , [, , "1[578]", , , , "15"], [, , , , , , , , , [-1]], , , , "PF", , , , , , , , , , , , , , , , , , [, , "1[578]", , , , "15"], , [, , "1[578]", , , , "15"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              PG: [, [, , "[01]\\d{2,6}", , , , , , , [
                3,
                4,
                5,
                6,
                7
              ]], , , [, , "000|11[01]", , , , "000", , , [3]], [, , , , , , , , , [-1]], , , , "PG", , , , , , , , , , , , , , , , , , [, , "000|11[01]", , , , "000", , , [3]], , [, , "000|1(?:1[01]|5\\d\\d|6\\d{2,5})", , , , "000"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , "16\\d{2,5}", , , , "1600", , , [4, 5, 6, 7]]],
              PH: [, [, , "[19]\\d\\d", , , , , , , [3]], , , [, , "11[27]|911", , , , "112"], [, , , , , , , , , [-1]], , , , "PH", , , , , , , , , , , , , , , , , , [, , "11[27]|911", , , , "112"], , [, , "11[27]|911", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              PK: [, [, , "1\\d{1,3}", , , , , , , [2, 3, 4]], , , [
                ,
                ,
                "1(?:1(?:2\\d?|5)|[56])",
                ,
                ,
                ,
                "15"
              ], [, , , , , , , , , [-1]], , , , "PK", , , , , , , , , , , , , , , , , , [, , "1(?:1(?:22?|5)|[56])", , , , "15"], , [, , "1(?:122|3[014]|[56])|11[2457-9]", , , , "15"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              PL: [, [, , "[19]\\d\\d(?:\\d{2,3})?", , , , , , , [3, 5, 6]], , , [, , "11(?:2|6\\d{3})|99[7-9]", , , , "112", , , [3, 6]], [, , , , , , , , , [-1]], , , , "PL", , , , , , , , , , , , , , , , , , [, , "112|99[7-9]", , , , "112", , , [3]], , [, , "1(?:1(?:2|61(?:11|23)|891[23])|9\\d{3})|9(?:8[4-7]|9[1-9])|11[68]000", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              PM: [, [
                ,
                ,
                "[13]\\d(?:\\d\\d(?:\\d{2})?)?",
                ,
                ,
                ,
                ,
                ,
                ,
                [2, 4, 6]
              ], , , [, , "1[578]|3(?:0\\d|1[689])\\d", , , , "15", , , [2, 4]], [, , "3[2469]\\d\\d", , , , "3200", , , [4]], , , , "PM", , , , , , , , , , , , , , , , , , [, , "1[578]", , , , "15", , , [2]], , [, , "1[578]|31(?:03|[689]\\d)|(?:118[02-9]|3[02469])\\d\\d", , , , "15"], [, , "118\\d{3}", , , , "118000", , , [6]], [, , "310\\d", , , , "3100", , , [4]], , [, , , , , , , , , [-1]]],
              PR: [, [, , "9\\d\\d", , , , , , , [3]], , , [, , "9(?:11|88)", , , , "911"], [, , , , , , , , , [-1]], , , , "PR", , , , , , , , , , , , , , , , , , [, , "911", , , , "911"], , [, , "9(?:11|88)", , , , "911"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              PS: [
                ,
                [, , "1\\d{2,3}", , , , , , , [3, 4]],
                ,
                ,
                [, , "1(?:0[0-2]|66)", , , , "100", , , [3]],
                [, , , , , , , , , [-1]],
                ,
                ,
                ,
                "PS",
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [, , "10[0-2]", , , , "100", , , [3]],
                ,
                [, , "1(?:0[0-2]|122|44|66|99)", , , , "100"],
                [, , , , , , , , , [-1]],
                [, , "112\\d", , , , "1120", , , [4]],
                ,
                [, , , , , , , , , [-1]]
              ],
              PT: [, [, , "1\\d\\d(?:\\d(?:\\d{2})?)?", , , , , , , [3, 4, 6]], , , [, , "11[257]|1(?:16\\d\\d|5[1589]|8[279])\\d", , , , "112"], [, , , , , , , , , [-1]], , , , "PT", , , , , , , , , , , , , , , , , , [, , "11[25]", , , , "112", , , [3]], , [
                ,
                ,
                "1(?:0(?:45|5[01])|1(?:[2578]|600[06])|4(?:1[45]|4)|583|6(?:1[0236]|3[02]|9[169]))|1(?:1611|59)1|1[068]78|1[08]9[16]|1(?:0[1-38]|40|5[15]|6[258]|82)0",
                ,
                ,
                ,
                "112"
              ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              PW: [, [, , "9\\d\\d", , , , , , , [3]], , , [, , "911", , , , "911"], [, , , , , , , , , [-1]], , , , "PW", , , , , , , , , , , , , , , , , , [, , "911", , , , "911"], , [, , "911", , , , "911"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              PY: [, [, , "[19]\\d\\d", , , , , , , [3]], , , [, , "128|911", , , , "128"], [, , , , , , , , , [-1]], , , , "PY", , , , , , , , , , , , , , , , , , [, , "128|911", , , , "128"], , [, , "1[1-9]\\d|911", , , , "110"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              QA: [, [, , "[129]\\d{2,4}", , , , , , , [3, 4, 5]], , , [
                ,
                ,
                "99\\d",
                ,
                ,
                ,
                "990",
                ,
                ,
                [3]
              ], [, , "900", , , , "900", , , [3]], , , , "QA", , , , , , , , , , , , , , , , , , [, , "999", , , , "999", , , [3]], , [, , "9(?:00|[19]\\d)|(?:1|20|9[27]\\d)\\d\\d", , , , "100"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              RE: [, [, , "1\\d\\d?", , , , , , , [2, 3]], , , [, , "1(?:12|[578])", , , , "15"], [, , , , , , , , , [-1]], , , , "RE", , , , , , , , , , , , , , , , , , [, , "1(?:12|[578])", , , , "15"], , [, , "1(?:12|[578])", , , , "15"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              RO: [, [, , "[18]\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [, , "11(?:2|6\\d{3})", , , , "112", , , [3, 6]], [
                ,
                ,
                "(?:1(?:18[39]|[24])|8[48])\\d\\d",
                ,
                ,
                ,
                "1200",
                ,
                ,
                [4, 6]
              ], , , , "RO", , , , , , , , , , , , , , , , , , [, , "112", , , , "112", , , [3]], , [, , "1(?:1(?:2|6(?:000|1(?:11|23))|8(?:(?:01|8[18])1|119|[23]00|932))|[24]\\d\\d|9(?:0(?:00|19)|1[19]|21|3[02]|5[178]))|8[48]\\d\\d", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , "(?:1[24]|8[48])\\d\\d", , , , "1200", , , [4]]],
              RS: [, [, , "[19]\\d{1,5}", , , , , , , [2, 3, 4, 5, 6]], , , [, , "112|9[2-4]", , , , "92", , , [2, 3]], [, , , , , , , , , [-1]], , , , "RS", , , , , , , , , , , , , , , , , , [, , "112|9[2-4]", , , , "92", , , [2, 3]], , [, , "1[189]\\d{1,4}|9[2-4]", , , , "92"], [, , , , , , , , , [-1]], [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ], , [, , , , , , , , , [-1]]],
              RU: [, [, , "[01]\\d\\d?", , , , , , , [2, 3]], , , [, , "112|(?:0|10)[1-3]", , , , "01"], [, , , , , , , , , [-1]], , , , "RU", , , , , , , , , , , , , , , , , , [, , "112|(?:0|10)[1-3]", , , , "01"], , [, , "112|(?:0|10)[1-4]", , , , "01"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              RW: [, [, , "[14]\\d\\d", , , , , , , [3]], , , [, , "11[1245]", , , , "111"], [, , , , , , , , , [-1]], , , , "RW", , , , , , , , , , , , , , , , , , [, , "11[12]", , , , "111"], , [, , "1(?:0[0-2]|1[0-24-6]|2[13]|70|99)|456", , , , "100"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              SA: [, [
                ,
                ,
                "[19]\\d{2,5}",
                ,
                ,
                ,
                ,
                ,
                ,
                [3, 4, 5, 6]
              ], , , [, , "11(?:2|6\\d{3})|9(?:11|37|9[7-9])", , , , "112", , , [3, 6]], [, , , , , , , , , [-1]], , , , "SA", , , , , , , , , , , , , , , , , , [, , "112|9(?:11|9[79])", , , , "112", , , [3]], , [, , "1(?:1(?:00|2|6111)|410|9(?:00|1[89]|9(?:099|22|9[0-3])))|9(?:0[24-79]|11|3[379]|40|66|8[5-9]|9[02-9])", , , , "112"], [, , "141\\d", , , , "1410", , , [4]], [, , "1(?:10|41)\\d|90[24679]", , , , "902", , , [3, 4]], , [, , , , , , , , , [-1]]],
              SB: [, [, , "[127-9]\\d\\d", , , , , , , [3]], , , [, , "999", , , , "999"], [, , , , , , , , , [-1]], , , , "SB", , , , , , , , , , , , , , , , , , [, , "999", , , , "999"], , [
                ,
                ,
                "1(?:[02]\\d|1[12]|[35][01]|[49][1-9]|6[2-9]|7[7-9]|8[0-8])|269|777|835|9(?:[01]1|22|33|55|77|88|99)",
                ,
                ,
                ,
                "100"
              ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              SC: [, [, , "[19]\\d{2,3}", , , , , , , [3, 4]], , , [, , "1(?:1[1468]|60)|999", , , , "111", , , [3]], [, , , , , , , , , [-1]], , , , "SC", , , , , , , , , , , , , , , , , , [, , "999", , , , "999", , , [3]], , [, , "1(?:[06]\\d|1[0-246-8]|2[0-8]|3[13]|4[0-2]|5[15]|7[124-6]|8[158]|9[015])|9(?:6\\d\\d|99)", , , , "100"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              SD: [
                ,
                [, , "9\\d\\d", , , , , , , [3]],
                ,
                ,
                [, , "999", , , , "999"],
                [, , , , , , , , , [-1]],
                ,
                ,
                ,
                "SD",
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [, , "999", , , , "999"],
                ,
                [, , "999", , , , "999"],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                [, , , , , , , , , [-1]]
              ],
              SE: [, [, , "[1-37-9]\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [, , "11(?:2|(?:3|6\\d)\\d\\d|414|77)|900\\d\\d", , , , "112"], [, , "11811[89]|72\\d{3}", , , , "72000", , , [5, 6]], , , , "SE", , , , , , , , , , , , , , , , , , [, , "112|90000", , , , "112", , , [3, 5]], , [, , "11(?:[25]|313|6(?:00[06]|1(?:1[17]|23))|7[0-8])|2(?:2[02358]|33|4[01]|50|6[1-4])|32[13]|8(?:22|88)|9(?:0(?:00|51)0|12)|(?:11(?:4|8[02-46-9])|7\\d\\d|90[2-4])\\d\\d|(?:118|90)1(?:[02-9]\\d|1[013-9])", , , , "112"], [, , , , , , , , , [-1]], [
                ,
                ,
                "2(?:2[02358]|33|4[01]|50|6[1-4])|32[13]|8(?:22|88)|912",
                ,
                ,
                ,
                "220",
                ,
                ,
                [3]
              ], , [, , "7\\d{4}", , , , "70000", , , [5]]],
              SG: [, [, , "[179]\\d{2,4}", , , , , , , [3, 4, 5]], , , [, , "99[359]", , , , "993", , , [3]], [, , , , , , , , , [-1]], , , , "SG", , , , , , , , , , , , , , , , , , [, , "99[359]", , , , "993", , , [3]], , [, , "1(?:(?:[01368]\\d|44)\\d|[57]\\d{2,3}|9(?:0[1-9]|[1-9]\\d))|77222|99[02-9]|100", , , , "100"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , "772\\d\\d", , , , "77200", , , [5]]],
              SH: [, [, , "[129]\\d{2,4}", , , , , , , [3, 4, 5]], , , [, , "9(?:11|99)", , , , "911", , , [3]], [, , , , , , , , , [-1]], , , , "SH", , , , , , , , , , , , , , , , , , [, , "9(?:11|99)", , , , "911", , , [3]], , [
                ,
                ,
                "1\\d{2,3}|26[01]\\d\\d|9(?:11|99)",
                ,
                ,
                ,
                "100"
              ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              SI: [, [, , "1\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [, , "11(?:(?:0|6\\d)\\d\\d|[23]|8\\d\\d?)", , , , "112"], [, , , , , , , , , [-1]], , , , "SI", , , , , , , , , , , , , , , , , , [, , "11[23]", , , , "112", , , [3]], , [, , "1(?:1(?:00[146]|[23]|6(?:000|1(?:11|23))|8(?:[08]|99))|9(?:059|1(?:0[12]|16)|5|70|87|9(?:00|[149])))|19(?:08|81)[09]", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              SJ: [, [, , "[01]\\d\\d(?:\\d{2})?", , , , , , , [3, 5]], , , [
                ,
                ,
                "11[023]",
                ,
                ,
                ,
                "110",
                ,
                ,
                [3]
              ], [, , , , , , , , , [-1]], , , , "SJ", , , , , , , , , , , , , , , , , , [, , "11[023]", , , , "110", , , [3]], , [, , "04\\d{3}|11[023]", , , , "110"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , "04\\d{3}", , , , "04000", , , [5]]],
              SK: [, [, , "1\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [, , "1(?:1(?:2|6\\d{3})|5[058])", , , , "112", , , [3, 6]], [, , , , , , , , , [-1]], , , , "SK", , , , , , , , , , , , , , , , , , [, , "1(?:12|5[058])", , , , "112", , , [3]], , [, , "1(?:1(?:2|6(?:000|111)|8[0-8])|[248]\\d{3}|5[0589])", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              SL: [, [
                ,
                ,
                "[069]\\d\\d(?:\\d{2})?",
                ,
                ,
                ,
                ,
                ,
                ,
                [3, 5]
              ], , , [, , "(?:01|99)9", , , , "019", , , [3]], [, , , , , , , , , [-1]], , , , "SL", , , , , , , , , , , , , , , , , , [, , "(?:01|99)9", , , , "019", , , [3]], , [, , "(?:01|99)9|60400", , , , "019"], [, , , , , , , , , [-1]], [, , "604\\d\\d", , , , "60400", , , [5]], , [, , "604\\d\\d", , , , "60400", , , [5]]],
              SM: [, [, , "1\\d\\d", , , , , , , [3]], , , [, , "11[358]", , , , "113"], [, , , , , , , , , [-1]], , , , "SM", , , , , , , , , , , , , , , , , , [, , "11[358]", , , , "113"], , [, , "11[358]", , , , "113"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              SN: [, [, , "[12]\\d{1,5}", , , , , , , [2, 3, 4, 5, 6]], , , [
                ,
                ,
                "1(?:515|[78])|2(?:00|1)\\d{3}",
                ,
                ,
                ,
                "17",
                ,
                ,
                [2, 4, 5, 6]
              ], [, , "2(?:0[246]|[468])\\d{3}", , , , "24000", , , [5, 6]], , , , "SN", , , , , , , , , , , , , , , , , , [, , "1[78]", , , , "17", , , [2]], , [, , "1(?:1[69]|(?:[246]\\d|51)\\d)|2(?:0[0-246]|[12468])\\d{3}|1[278]", , , , "12"], [, , "2(?:01|2)\\d{3}", , , , "22000", , , [5, 6]], [, , "1[46]\\d\\d", , , , "1400", , , [4]], , [, , "2[468]\\d{3}", , , , "24000", , , [5]]],
              SO: [, [, , "[57-9]\\d\\d", , , , , , , [3]], , , [, , "555|888|999", , , , "555"], [, , , , , , , , , [-1]], , , , "SO", , , , , , , , , , , , , , , , , , [, , "555|888|999", , , , "555"], , [, , "555|777|888|999", , , , "555"], [, , , , , , , , , [-1]], [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ], , [, , , , , , , , , [-1]]],
              SR: [, [, , "1\\d{2,3}", , , , , , , [3, 4]], , , [, , "115", , , , "115", , , [3]], [, , , , , , , , , [-1]], , , , "SR", , , , , , , , , , , , , , , , , , [, , "115", , , , "115", , , [3]], , [, , "1\\d{2,3}", , , , "100"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              SS: [, [, , "9\\d\\d", , , , , , , [3]], , , [, , "999", , , , "999"], [, , , , , , , , , [-1]], , , , "SS", , , , , , , , , , , , , , , , , , [, , "999", , , , "999"], , [, , "999", , , , "999"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              ST: [, [, , "1\\d\\d", , , , , , , [3]], , , [, , "112", , , , "112"], [, , , , , , , , , [-1]], , , , "ST", , , , , , , , , , , , , , , , , , [
                ,
                ,
                "112",
                ,
                ,
                ,
                "112"
              ], , [, , "112", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              SV: [, [, , "[149]\\d\\d(?:\\d{2,3})?", , , , , , , [3, 5, 6]], , , [, , "116\\d{3}|911", , , , "911", , , [3, 6]], [, , , , , , , , , [-1]], , , , "SV", , , , , , , , , , , , , , , , , , [, , "91[13]", , , , "911", , , [3]], , [, , "1(?:1(?:2|6111)|2[136-8]|3[0-6]|9[05])|40404|9(?:1\\d|29)", , , , "112"], [, , , , , , , , , [-1]], [, , "404\\d\\d", , , , "40400", , , [5]], , [, , "404\\d\\d", , , , "40400", , , [5]]],
              SX: [
                ,
                [, , "9\\d\\d", , , , , , , [3]],
                ,
                ,
                [, , "9(?:19|88)", , , , "919"],
                [, , , , , , , , , [-1]],
                ,
                ,
                ,
                "SX",
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [, , "919", , , , "919"],
                ,
                [, , "9(?:19|88)", , , , "919"],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                [, , , , , , , , , [-1]]
              ],
              SY: [, [, , "1\\d\\d", , , , , , , [3]], , , [, , "11[023]", , , , "110"], [, , , , , , , , , [-1]], , , , "SY", , , , , , , , , , , , , , , , , , [, , "11[023]", , , , "110"], , [, , "11[023]", , , , "110"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              SZ: [, [, , "9\\d\\d", , , , , , , [3]], , , [, , "999", , , , "999"], [, , , , , , , , , [-1]], , , , "SZ", , , , , , , , , , , , , , , , , , [, , "999", , , , "999"], , [, , "999", , , , "999"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              TC: [, [, , "9\\d\\d", , , , , , , [3]], , , [
                ,
                ,
                "9(?:11|88|99)",
                ,
                ,
                ,
                "911"
              ], [, , , , , , , , , [-1]], , , , "TC", , , , , , , , , , , , , , , , , , [, , "9(?:11|99)", , , , "911"], , [, , "9(?:11|88|99)", , , , "911"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              TD: [, [, , "1\\d", , , , , , , [2]], , , [, , "1[78]", , , , "17"], [, , , , , , , , , [-1]], , , , "TD", , , , , , , , , , , , , , , , , , [, , "1[78]", , , , "17"], , [, , "1[78]", , , , "17"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              TG: [, [, , "1\\d{2,3}", , , , , , , [3, 4]], , , [, , "1(?:1[78]|7[127])", , , , "117", , , [3]], [, , , , , , , , , [-1]], , , , "TG", , , , , , , , , , , , , , , , , , [
                ,
                ,
                "1(?:1[78]|7[127])",
                ,
                ,
                ,
                "117",
                ,
                ,
                [3]
              ], , [, , "1(?:011|1[078]|7[127])", , , , "110"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              TH: [, [, , "1\\d{2,3}", , , , , , , [3, 4]], , , [, , "1(?:1(?:00|2[03]|3[3479]|7[67]|9[0246])|578|6(?:44|6[79]|88|9[16])|88\\d|9[19])|1[15]55", , , , "191"], [, , "1(?:113|2[23]\\d|5(?:09|56))", , , , "1113", , , [4]], , , , "TH", , , , , , , , , , , , , , , , , , [, , "1(?:669|9[19])", , , , "191"], , [
                ,
                ,
                "1(?:0[0-2]|1(?:0[03]|1[1-35]|2[0358]|3[03-79]|4[02-489]|5[04-9]|6[04-79]|7[03-9]|8[027-9]|9[02-9])|2(?:22|3[89]|66)|3(?:18|2[23]|3[013]|5[56]|6[45]|73)|477|5(?:0\\d|4[0-37-9]|5[1-8]|6[01679]|7[12568]|8[0-24589]|9[013589])|6(?:0[0-29]|2[03]|4[3-6]|6[1-9]|7[0257-9]|8[0158]|9[014-9])|7(?:[14]9|7[27]|90)|888|9[19])",
                ,
                ,
                ,
                "100"
              ], [, , "1(?:1(?:03|1[15]|2[58]|3[056]|4[02-49]|5[046-9]|7[03-589]|9[57-9])|5(?:0[0-8]|4[0-378]|5[1-478]|7[156])|6(?:20|4[356]|6[1-68]|7[057-9]|8[015]|9[0457-9]))|1(?:1[68]|26|3[1-35]|5[689]|60|7[17])\\d", , , , "1103", , , [4]], [, , "114[89]", , , , "1148", , , [4]], , [, , , , , , , , , [-1]]],
              TJ: [, [, , "1\\d\\d", , , , , , , [3]], , , [, , "1(?:0[1-3]|12)", , , , "101"], [, , , , , , , , , [-1]], , , , "TJ", , , , , , , , , , , , , , , , , , [, , "1(?:0[1-3]|12)", , , , "101"], , [, , "1(?:0[1-3]|12)", , , , "101"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              TL: [, [
                ,
                ,
                "1\\d\\d",
                ,
                ,
                ,
                ,
                ,
                ,
                [3]
              ], , , [, , "11[25]", , , , "112"], [, , , , , , , , , [-1]], , , , "TL", , , , , , , , , , , , , , , , , , [, , "11[25]", , , , "112"], , [, , "1(?:0[02]|1[25]|2[0138]|72|9[07])", , , , "100"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              TM: [, [, , "0\\d", , , , , , , [2]], , , [, , "0[1-49]", , , , "01"], [, , , , , , , , , [-1]], , , , "TM", , , , , , , , , , , , , , , , , , [, , "0[1-3]", , , , "01"], , [, , "0[1-49]", , , , "01"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              TN: [
                ,
                [, , "1\\d\\d", , , , , , , [3]],
                ,
                ,
                [, , "19[078]", , , , "190"],
                [, , , , , , , , , [-1]],
                ,
                ,
                ,
                "TN",
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [, , "19[078]", , , , "190"],
                ,
                [, , "19[078]", , , , "190"],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                [, , , , , , , , , [-1]]
              ],
              TO: [, [, , "9\\d\\d", , , , , , , [3]], , , [, , "9(?:11|22|33|99)", , , , "911"], [, , , , , , , , , [-1]], , , , "TO", , , , , , , , , , , , , , , , , , [, , "9(?:11|22|33|99)", , , , "911"], , [, , "9(?:11|22|33|99)", , , , "911"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              TR: [, [, , "[1-9]\\d{2,4}", , , , , , , [3, 4, 5]], , , [, , "1(?:1[02]|22|3[126]|4[04]|5[15-9]|6[18]|77|83)", , , , "110", , , [3]], [, , , , , , , , , [-1]], , , , "TR", , , , , , , , , , , , , , , , , , [, , "1(?:1[02]|55)", , , , "110", , , [3]], , [
                ,
                ,
                "1(?:1(?:[02-79]|8(?:1[018]|2[0245]|3[2-4]|42|5[058]|6[06]|7[07]|8[01389]|9[089]))|3(?:37|[58]6|65)|471|5(?:07|78)|6(?:[02]6|99)|8(?:63|95))|2(?:077|268|4(?:17|23)|5(?:7[26]|82)|6[14]4|8\\d\\d|9(?:30|89))|3(?:0(?:05|72)|353|4(?:06|30|64)|502|674|747|851|9(?:1[29]|60))|4(?:0(?:25|3[12]|[47]2)|3(?:3[13]|[89]1)|439|5(?:43|55)|717|832)|5(?:145|290|[4-6]\\d\\d|772|833|9(?:[06]1|92))|6(?:236|6(?:12|39|8[59])|769)|7890|8(?:688|7(?:28|65)|85[06])|9(?:159|290)|1[2-9]\\d",
                ,
                ,
                ,
                "110"
              ], [, , "(?:285|542)0", , , , "2850", , , [4]], [, , , , , , , , , [-1]], , [, , "1(?:3(?:37|[58]6|65)|4(?:4|71)|5(?:07|78)|6(?:[02]6|99)|8(?:3|63|95))|(?:2(?:07|26|4[12]|5[78]|6[14]|8\\d|9[38])|3(?:0[07]|[38]5|4[036]|50|67|74|9[16])|4(?:0[2-47]|3[389]|[48]3|5[45]|71)|5(?:14|29|[4-6]\\d|77|83|9[069])|6(?:23|6[138]|76)|789|8(?:68|7[26]|85)|9(?:15|29))\\d", , , , "144", , , [3, 4]]],
              TT: [, [, , "9\\d\\d", , , , , , , [3]], , , [, , "9(?:88|9[09])", , , , "988"], [, , , , , , , , , [-1]], , , , "TT", , , , , , , , , , , , , , , , , , [, , "99[09]", , , , "990"], , [
                ,
                ,
                "9(?:88|9[09])",
                ,
                ,
                ,
                "988"
              ], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              TV: [, [, , "[19]\\d\\d", , , , , , , [3]], , , [, , "911", , , , "911"], [, , , , , , , , , [-1]], , , , "TV", , , , , , , , , , , , , , , , , , [, , "911", , , , "911"], , [, , "1\\d\\d|911", , , , "100"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              TW: [, [, , "1\\d{2,3}", , , , , , , [3, 4]], , , [, , "11[0289]|1(?:81|92)\\d", , , , "110"], [, , "10[56]", , , , "105", , , [3]], , , , "TW", , , , , , , , , , , , , , , , , , [, , "11[029]", , , , "110", , , [3]], , [
                ,
                ,
                "1(?:0[04-6]|1[0237-9]|3[389]|6[05-8]|7[07]|8(?:0|11)|9(?:19|22|5[057]|68|8[05]|9[15689]))",
                ,
                ,
                ,
                "100"
              ], [, , "1(?:65|9(?:1\\d|50|85|98))", , , , "165"], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              TZ: [, [, , "[149]\\d\\d(?:\\d{2})?", , , , , , , [3, 5]], , , [, , "1(?:1[0-79]|9[09])|999", , , , "110", , , [3]], [, , , , , , , , , [-1]], , , , "TZ", , , , , , , , , , , , , , , , , , [, , "11[0-245]|999", , , , "110", , , [3]], , [, , "1(?:1\\d|9[09])|46400|999", , , , "110"], [, , , , , , , , , [-1]], [, , "464\\d\\d", , , , "46400", , , [5]], , [, , "464\\d\\d", , , , "46400", , , [5]]],
              UA: [
                ,
                [, , "[189]\\d{2,5}", , , , , , , [3, 4, 5, 6]],
                ,
                ,
                [, , "1(?:0[1-3]|1(?:2|6\\d{3}))", , , , "101", , , [3, 6]],
                [, , , , , , , , , [-1]],
                ,
                ,
                ,
                "UA",
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [, , "1(?:0[1-3]|12)", , , , "101", , , [3]],
                ,
                [, , "1(?:0[1-49]|1(?:2|6(?:000|1(?:11|23))|8\\d\\d?)|(?:[278]|5\\d)\\d)|[89]00\\d\\d?|151|1(?:06|4\\d|6)\\d\\d", , , , "101"],
                [, , , , , , , , , [-1]],
                [, , "(?:118|[89]00)\\d\\d?", , , , "1180", , , [4, 5]],
                ,
                [, , , , , , , , , [-1]]
              ],
              UG: [, [, , "9\\d\\d", , , , , , , [3]], , , [, , "999", , , , "999"], [, , , , , , , , , [-1]], , , , "UG", , , , , , , , , , , , , , , , , , [, , "999", , , , "999"], , [, , "999", , , , "999"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              US: [, [, , "[1-9]\\d{2,5}", , , , , , , [3, 4, 5, 6]], , , [
                ,
                ,
                "112|611|9(?:11|33|88)",
                ,
                ,
                ,
                "112",
                ,
                ,
                [3]
              ], [, , "24280|(?:381|968)35|4(?:3355|7553|8221)|5(?:(?:489|934)2|5928)|72078|(?:323|960)40|(?:276|414)63|(?:2(?:520|744)|7390|9968)9|(?:693|732|976)88|(?:3(?:556|825)|5294|8623|9729)4|(?:3378|4136|7642|8961|9979)6|(?:4(?:6(?:15|32)|827)|(?:591|720)8|9529)7", , , , "24280", , , [5]], , , , "US", , , , , , , , , , , , , , , , , , [, , "112|911", , , , "112", , , [3]], , [, , "11(?:2|5[1-47]|[68]\\d|7[0-57]|98)|[2-9]\\d{3,5}|[2-8]11|9(?:11|33|88)", , , , "112"], [
                ,
                ,
                "2(?:3333|(?:4224|7562|900)2|56447|6688)|3(?:1010|2665|7404)|40404|560560|6(?:0060|22639|5246|7622)|7(?:0701|3822|4666)|8(?:(?:3825|7226)5|4816)|99099",
                ,
                ,
                ,
                "23333",
                ,
                ,
                [5, 6]
              ], [, , "336\\d\\d|[2-9]\\d{3}|[2356]11", , , , "211", , , [3, 4, 5]], , [, , "[2-9]\\d{4,5}", , , , "20000", , , [5, 6]]],
              UY: [, [, , "[19]\\d{2,4}", , , , , , , [3, 4, 5]], , , [, , "128|911", , , , "128", , , [3]], [, , , , , , , , , [-1]], , , , "UY", , , , , , , , , , , , , , , , , , [, , "128|911", , , , "128", , , [3]], , [, , "1(?:0[4-9]|1[2368]|2[0-3568]|787|997\\d?)|911", , , , "104"], [, , "178\\d", , , , "1780", , , [4]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              UZ: [
                ,
                [, , "[04]\\d(?:\\d(?:\\d{2})?)?", , , , , , , [2, 3, 5]],
                ,
                ,
                [, , "0(?:0[1-3]|[1-3]|50)", , , , "01", , , [2, 3]],
                [, , , , , , , , , [-1]],
                ,
                ,
                ,
                "UZ",
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [, , "0(?:0[1-3]|[1-3]|50)", , , , "01", , , [2, 3]],
                ,
                [, , "0(?:0[1-3]|[1-3]|50)|45400", , , , "01"],
                [, , , , , , , , , [-1]],
                [, , "454\\d\\d", , , , "45400", , , [5]],
                ,
                [, , "454\\d\\d", , , , "45400", , , [5]]
              ],
              VA: [, [, , "1\\d\\d", , , , , , , [3]], , , [, , "11[2358]", , , , "112"], [, , , , , , , , , [-1]], , , , "VA", , , , , , , , , , , , , , , , , , [, , "11[2358]", , , , "112"], , [, , "11[2358]", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              VC: [, [, , "9\\d\\d", , , , , , , [3]], , , [, , "9(?:11|88|99)", , , , "911"], [, , , , , , , , , [-1]], , , , "VC", , , , , , , , , , , , , , , , , , [
                ,
                ,
                "9(?:11|99)",
                ,
                ,
                ,
                "911"
              ], , [, , "9(?:11|88|99)", , , , "911"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              VE: [, [, , "[19]\\d\\d", , , , , , , [3]], , , [, , "1(?:12|71)|911", , , , "112"], [, , , , , , , , , [-1]], , , , "VE", , , , , , , , , , , , , , , , , , [, , "1(?:12|71)|911", , , , "112"], , [, , "1(?:12|71)|911", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              VG: [, [, , "9\\d\\d", , , , , , , [3]], , , [, , "9(?:11|88|99)", , , , "911"], [, , , , , , , , , [-1]], , , , "VG", , , , , , , , , , , , , , , , , , [, , "9(?:11|99)", , , , "911"], , [, , "9(?:11|88|99)", , , , "911"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ]],
              VI: [, [, , "9\\d\\d", , , , , , , [3]], , , [, , "9(?:11|88)", , , , "911"], [, , , , , , , , , [-1]], , , , "VI", , , , , , , , , , , , , , , , , , [, , "911", , , , "911"], , [, , "9(?:11|88)", , , , "911"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              VN: [, [, , "1\\d\\d", , , , , , , [3]], , , [, , "11[3-5]", , , , "113"], [, , , , , , , , , [-1]], , , , "VN", , , , , , , , , , , , , , , , , , [, , "11[3-5]", , , , "113"], , [, , "11[3-5]", , , , "113"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              VU: [
                ,
                [, , "1\\d\\d", , , , , , , [3]],
                ,
                ,
                [, , "112", , , , "112"],
                [, , , , , , , , , [-1]],
                ,
                ,
                ,
                "VU",
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [, , "112", , , , "112"],
                ,
                [, , "112", , , , "112"],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                [, , , , , , , , , [-1]]
              ],
              WF: [, [, , "1\\d", , , , , , , [2]], , , [, , "1[578]", , , , "15"], [, , , , , , , , , [-1]], , , , "WF", , , , , , , , , , , , , , , , , , [, , "1[578]", , , , "15"], , [, , "1[578]", , , , "15"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              WS: [, [, , "[19]\\d\\d", , , , , , , [3]], , , [, , "9(?:11|9[4-69])", , , , "911"], [, , , , , , , , , [-1]], , , , "WS", , , , , , , , , , , , , , , , , , [, , "9(?:11|9[4-69])", , , , "911"], , [, , "1(?:1[12]|2[0-6]|[39]0)|9(?:11|9[4-79])", , , , "111"], [, , , , , , , , , [-1]], [, , "12[0-6]", , , , "120"], , [, , , , , , , , , [-1]]],
              XK: [, [, , "1\\d\\d", , , , , , , [3]], , , [, , "1(?:12|9[2-4])", , , , "112"], [, , , , , , , , , [-1]], , , , "XK", , , , , , , , , , , , , , , , , , [, , "1(?:12|9[2-4])", , , , "112"], , [, , "1(?:12|9[2-4])", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              YE: [, [, , "1\\d\\d", , , , , , , [3]], , , [, , "19[1459]", , , , "191"], [, , , , , , , , , [-1]], , , , "YE", , , , , , , , , , , , , , , , , , [, , "19[1459]", , , , "191"], , [, , "19[1459]", , , , "191"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              YT: [
                ,
                [, , "1\\d\\d?", , , , , , , [2, 3]],
                ,
                ,
                [, , "1(?:12|5)", , , , "15"],
                [, , , , , , , , , [-1]],
                ,
                ,
                ,
                "YT",
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [, , "1(?:12|5)", , , , "15"],
                ,
                [, , "1(?:12|5)", , , , "15"],
                [, , , , , , , , , [-1]],
                [, , , , , , , , , [-1]],
                ,
                [, , , , , , , , , [-1]]
              ],
              ZA: [, [, , "[134]\\d{2,4}", , , , , , , [3, 4, 5]], , , [, , "1(?:01\\d\\d|12)", , , , "112", , , [3, 5]], [, , "41(?:348|851)", , , , "41348", , , [5]], , , , "ZA", , , , , , , , , , , , , , , , , , [, , "1(?:01(?:11|77)|12)", , , , "112", , , [3, 5]], , [, , "1(?:0(?:1(?:11|77)|20|7)|1[12]|77(?:3[237]|[45]7|6[279]|9[26]))|[34]\\d{4}", , , , "107"], [, , "3(?:078[23]|7(?:064|567)|8126)|4(?:394[16]|7751|8837)|4[23]699", , , , "30782", , , [5]], [, , "111", , , , "111", , , [3]], , [
                ,
                ,
                "[34]\\d{4}",
                ,
                ,
                ,
                "30000",
                ,
                ,
                [5]
              ]],
              ZM: [, [, , "[19]\\d\\d", , , , , , , [3]], , , [, , "112|99[139]", , , , "112"], [, , , , , , , , , [-1]], , , , "ZM", , , , , , , , , , , , , , , , , , [, , "112|99[139]", , , , "112"], , [, , "112|99[139]", , , , "112"], [, , , , , , , , , [-1]], [, , , , , , , , , [-1]], , [, , , , , , , , , [-1]]],
              ZW: [, [, , "[139]\\d\\d(?:\\d{2})?", , , , , , , [3, 5]], , , [, , "112|9(?:5[023]|61|9[3-59])", , , , "112", , , [3]], [, , "3[013-57-9]\\d{3}", , , , "30000", , , [5]], , , , "ZW", , , , , , , , , , , , , , , , , , [, , "112|99[3-59]", , , , "112", , , [3]], , [, , "11[2469]|3[013-57-9]\\d{3}|9(?:5[023]|6[0-25]|9[3-59])", , , , "112"], [
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                ,
                [-1]
              ], [, , "114|9(?:5[023]|6[0-25])", , , , "114", , , [3]], , [, , , , , , , , , [-1]]]
            }, i18n.phonenumbers.ShortNumberInfo = function() {
              this.regionToMetadataMap = {};
            }, goog.addSingletonGetter(i18n.phonenumbers.ShortNumberInfo), i18n.phonenumbers.ShortNumberInfo.REGIONS_WHERE_EMERGENCY_NUMBERS_MUST_BE_EXACT_ = ["BR", "CL", "NI"], i18n.phonenumbers.ShortNumberInfo.ShortNumberCost = { TOLL_FREE: 0, STANDARD_RATE: 1, PREMIUM_RATE: 2, UNKNOWN_COST: 3 }, i18n.phonenumbers.ShortNumberInfo.prototype.getRegionCodesForCountryCode_ = function(e) {
              return (e = i18n.phonenumbers.metadata.countryCodeToRegionCodeMap[e]) ? e : [];
            }, i18n.phonenumbers.ShortNumberInfo.prototype.regionDialingFromMatchesNumber_ = function(e, t) {
              return e = this.getRegionCodesForCountryCode_(e.getCountryCodeOrDefault()), t != null && e.includes(t);
            }, i18n.phonenumbers.ShortNumberInfo.prototype.isPossibleShortNumberForRegion = function(e, t) {
              return !this.regionDialingFromMatchesNumber_(e, t) || (t = this.getMetadataForRegion_(t), !t) ? !1 : (e = this.getNationalSignificantNumber_(e).length, t.getGeneralDesc().possibleLengthArray().includes(e));
            }, i18n.phonenumbers.ShortNumberInfo.prototype.isPossibleShortNumber = function(e) {
              var t = this.getRegionCodesForCountryCode_(e.getCountryCodeOrDefault());
              e = this.getNationalSignificantNumber_(e).length;
              for (var o = 0; o < t.length; o++) {
                var n = this.getMetadataForRegion_(t[o]);
                if (n && n.getGeneralDesc().possibleLengthArray().includes(e)) return !0;
              }
              return !1;
            }, i18n.phonenumbers.ShortNumberInfo.prototype.isValidShortNumberForRegion = function(e, t) {
              if (!this.regionDialingFromMatchesNumber_(e, t) || (t = this.getMetadataForRegion_(t), !t)) return !1;
              e = this.getNationalSignificantNumber_(e);
              var o = t.getGeneralDesc();
              return this.matchesPossibleNumberAndNationalNumber_(e, o) ? (t = t.getShortCode(), this.matchesPossibleNumberAndNationalNumber_(e, t)) : !1;
            }, i18n.phonenumbers.ShortNumberInfo.prototype.isValidShortNumber = function(e) {
              var t = this.getRegionCodesForCountryCode_(e.getCountryCodeOrDefault()), o = this.getRegionCodeForShortNumberFromRegionList_(e, t);
              return 1 < t.length && o != null ? !0 : this.isValidShortNumberForRegion(e, o);
            }, i18n.phonenumbers.ShortNumberInfo.prototype.getExpectedCostForRegion = function(e, t) {
              var o = i18n.phonenumbers.ShortNumberInfo.ShortNumberCost;
              if (!this.regionDialingFromMatchesNumber_(e, t)) return o.UNKNOWN_COST;
              var n = this.getMetadataForRegion_(t);
              return n ? (e = this.getNationalSignificantNumber_(e), n.getGeneralDesc().possibleLengthArray().includes(e.length) ? this.matchesPossibleNumberAndNationalNumber_(e, n.getPremiumRate()) ? o.PREMIUM_RATE : this.matchesPossibleNumberAndNationalNumber_(
                e,
                n.getStandardRate()
              ) ? o.STANDARD_RATE : this.matchesPossibleNumberAndNationalNumber_(e, n.getTollFree()) || this.isEmergencyNumber(e, t) ? o.TOLL_FREE : o.UNKNOWN_COST : o.UNKNOWN_COST) : o.UNKNOWN_COST;
            }, i18n.phonenumbers.ShortNumberInfo.prototype.getExpectedCost = function(e) {
              var t = i18n.phonenumbers.ShortNumberInfo.ShortNumberCost, o = this.getRegionCodesForCountryCode_(e.getCountryCodeOrDefault());
              if (o.length === 0) return t.UNKNOWN_COST;
              if (o.length === 1) return this.getExpectedCostForRegion(e, o[0]);
              for (var n = t.TOLL_FREE, s = 0; s < o.length; s++) {
                var i = this.getExpectedCostForRegion(e, o[s]);
                switch (i) {
                  case t.PREMIUM_RATE:
                    return t.PREMIUM_RATE;
                  case t.UNKNOWN_COST:
                    n = t.UNKNOWN_COST;
                    break;
                  case t.STANDARD_RATE:
                    n !== t.UNKNOWN_COST && (n = t.STANDARD_RATE);
                    break;
                  case t.TOLL_FREE:
                    break;
                  default:
                    throw Error("Unrecognized cost for region: " + i);
                }
              }
              return n;
            }, i18n.phonenumbers.ShortNumberInfo.prototype.getRegionCodeForShortNumberFromRegionList_ = function(e, t) {
              if (t.length === 0) return null;
              if (t.length === 1) return t[0];
              e = this.getNationalSignificantNumber_(e);
              for (var o = 0; o < t.length; o++) {
                var n = t[o], s = this.getMetadataForRegion_(n);
                if (s && this.matchesPossibleNumberAndNationalNumber_(e, s.getShortCode())) return n;
              }
              return null;
            }, i18n.phonenumbers.ShortNumberInfo.prototype.getSupportedRegions = function() {
              return Object.keys(i18n.phonenumbers.shortnumbermetadata.countryToMetadata).filter(function(e) {
                return isNaN(e);
              });
            }, i18n.phonenumbers.ShortNumberInfo.prototype.getExampleShortNumber = function(e) {
              return e = this.getMetadataForRegion_(e), e ? (e = e.getShortCode(), e.hasExampleNumber() && e.getExampleNumber() || "") : "";
            }, i18n.phonenumbers.ShortNumberInfo.prototype.getExampleShortNumberForCost = function(e, t) {
              if (e = this.getMetadataForRegion_(e), !e) return "";
              var o = i18n.phonenumbers.ShortNumberInfo.ShortNumberCost, n = null;
              switch (t) {
                case o.TOLL_FREE:
                  n = e.getTollFree();
                  break;
                case o.STANDARD_RATE:
                  n = e.getStandardRate();
                  break;
                case o.PREMIUM_RATE:
                  n = e.getPremiumRate();
              }
              return n && n.hasExampleNumber() && n.getExampleNumber() || "";
            }, i18n.phonenumbers.ShortNumberInfo.prototype.connectsToEmergencyNumber = function(e, t) {
              return this.matchesEmergencyNumberHelper_(e, t, !0);
            }, i18n.phonenumbers.ShortNumberInfo.prototype.isEmergencyNumber = function(e, t) {
              return this.matchesEmergencyNumberHelper_(e, t, !1);
            }, i18n.phonenumbers.ShortNumberInfo.prototype.getMetadataForRegion_ = function(e) {
              if (!e) return null;
              e = e.toUpperCase();
              var t = this.regionToMetadataMap[e];
              if (t == null) {
                t = new goog.proto2.PbLiteSerializer();
                var o = i18n.phonenumbers.shortnumbermetadata.countryToMetadata[e];
                if (o == null) return null;
                t = t.deserialize(i18n.phonenumbers.PhoneMetadata.getDescriptor(), o), this.regionToMetadataMap[e] = t;
              }
              return t;
            }, i18n.phonenumbers.ShortNumberInfo.prototype.matchesEmergencyNumberHelper_ = function(e, t, o) {
              var n = i18n.phonenumbers.PhoneNumberUtil.extractPossibleNumber(e);
              return i18n.phonenumbers.PhoneNumberUtil.LEADING_PLUS_CHARS_PATTERN.test(n) || (e = this.getMetadataForRegion_(t), e == null || !e.hasEmergency()) ? !1 : (n = i18n.phonenumbers.PhoneNumberUtil.normalizeDigitsOnly(n), t = o && !i18n.phonenumbers.ShortNumberInfo.REGIONS_WHERE_EMERGENCY_NUMBERS_MUST_BE_EXACT_.includes(t), o = e.getEmergency().getNationalNumberPatternOrDefault(), i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(o, n) || t && i18n.phonenumbers.PhoneNumberUtil.matchesPrefix(o, n));
            }, i18n.phonenumbers.ShortNumberInfo.prototype.isCarrierSpecific = function(e) {
              var t = this.getRegionCodesForCountryCode_(e.getCountryCodeOrDefault());
              return t = this.getRegionCodeForShortNumberFromRegionList_(e, t), e = this.getNationalSignificantNumber_(e), t = this.getMetadataForRegion_(t), !!t && this.matchesPossibleNumberAndNationalNumber_(e, t.getCarrierSpecific());
            }, i18n.phonenumbers.ShortNumberInfo.prototype.isCarrierSpecificForRegion = function(e, t) {
              return this.regionDialingFromMatchesNumber_(e, t) ? (e = this.getNationalSignificantNumber_(e), t = this.getMetadataForRegion_(t), !!t && this.matchesPossibleNumberAndNationalNumber_(e, t.getCarrierSpecific())) : !1;
            }, i18n.phonenumbers.ShortNumberInfo.prototype.isSmsServiceForRegion = function(e, t) {
              return this.regionDialingFromMatchesNumber_(e, t) ? (t = this.getMetadataForRegion_(t), e = this.getNationalSignificantNumber_(e), !!t && this.matchesPossibleNumberAndNationalNumber_(e, t.getSmsServices())) : !1;
            }, i18n.phonenumbers.ShortNumberInfo.prototype.getNationalSignificantNumber_ = function(e) {
              if (!e.hasNationalNumber()) return "";
              var t = "" + e.getNationalNumber();
              return e.hasItalianLeadingZero() && e.getItalianLeadingZero() && 0 < e.getNumberOfLeadingZerosOrDefault() ? Array(e.getNumberOfLeadingZerosOrDefault() + 1).join("0") + t : t;
            }, i18n.phonenumbers.ShortNumberInfo.prototype.matchesPossibleNumberAndNationalNumber_ = function(e, t) {
              return 0 < t.possibleLengthArray().length && !t.possibleLengthArray().includes(e.length) ? !1 : i18n.phonenumbers.PhoneNumberUtil.matchesEntirely(t.getNationalNumberPatternOrDefault(), e.toString());
            }, i18n.phonenumbers.AsYouTypeFormatter = function(e) {
              this.DIGIT_PLACEHOLDER_ = " ", this.DIGIT_PATTERN_ = new RegExp(this.DIGIT_PLACEHOLDER_), this.currentOutput_ = "", this.formattingTemplate_ = new goog.string.StringBuffer(), this.currentFormattingPattern_ = "", this.accruedInput_ = new goog.string.StringBuffer(), this.accruedInputWithoutFormatting_ = new goog.string.StringBuffer(), this.ableToFormat_ = !0, this.isExpectingCountryCallingCode_ = this.isCompleteNumber_ = this.inputHasFormatting_ = !1, this.phoneUtil_ = i18n.phonenumbers.PhoneNumberUtil.getInstance(), this.positionToRemember_ = this.originalPosition_ = this.lastMatchPosition_ = 0, this.prefixBeforeNationalNumber_ = new goog.string.StringBuffer(), this.shouldAddSpaceAfterNationalPrefix_ = !1, this.extractedNationalPrefix_ = "", this.nationalNumber_ = new goog.string.StringBuffer(), this.possibleFormats_ = [], this.defaultCountry_ = e, this.defaultMetadata_ = this.currentMetadata_ = this.getMetadataForRegion_(this.defaultCountry_);
            }, i18n.phonenumbers.AsYouTypeFormatter.SEPARATOR_BEFORE_NATIONAL_NUMBER_ = " ", i18n.phonenumbers.AsYouTypeFormatter.EMPTY_METADATA_ = new i18n.phonenumbers.PhoneMetadata(), i18n.phonenumbers.AsYouTypeFormatter.EMPTY_METADATA_.setInternationalPrefix("NA"), i18n.phonenumbers.AsYouTypeFormatter.ELIGIBLE_FORMAT_PATTERN_ = new RegExp("^[" + i18n.phonenumbers.PhoneNumberUtil.VALID_PUNCTUATION + "]*\\$1[" + i18n.phonenumbers.PhoneNumberUtil.VALID_PUNCTUATION + "]*(\\$\\d[" + i18n.phonenumbers.PhoneNumberUtil.VALID_PUNCTUATION + "]*)*$"), i18n.phonenumbers.AsYouTypeFormatter.NATIONAL_PREFIX_SEPARATORS_PATTERN_ = /[- ]/, i18n.phonenumbers.AsYouTypeFormatter.MIN_LEADING_DIGITS_LENGTH_ = 3, i18n.phonenumbers.AsYouTypeFormatter.prototype.getMetadataForRegion_ = function(e) {
              return e = this.phoneUtil_.getCountryCodeForRegion(e), e = this.phoneUtil_.getRegionCodeForCountryCode(e), e = this.phoneUtil_.getMetadataForRegion(e), e ?? i18n.phonenumbers.AsYouTypeFormatter.EMPTY_METADATA_;
            }, i18n.phonenumbers.AsYouTypeFormatter.prototype.maybeCreateNewTemplate_ = function() {
              for (var e = this.possibleFormats_.length, t = 0; t < e; ++t) {
                var o = this.possibleFormats_[t], n = o.getPatternOrDefault();
                if (this.currentFormattingPattern_ == n) return !1;
                if (this.createFormattingTemplate_(o)) return this.currentFormattingPattern_ = n, this.shouldAddSpaceAfterNationalPrefix_ = i18n.phonenumbers.AsYouTypeFormatter.NATIONAL_PREFIX_SEPARATORS_PATTERN_.test(o.getNationalPrefixFormattingRule()), this.lastMatchPosition_ = 0, !0;
              }
              return this.ableToFormat_ = !1;
            }, i18n.phonenumbers.AsYouTypeFormatter.prototype.getAvailableFormats_ = function(e) {
              for (var t = this.isCompleteNumber_ && this.extractedNationalPrefix_.length == 0 && 0 < this.currentMetadata_.intlNumberFormatCount() ? this.currentMetadata_.intlNumberFormatArray() : this.currentMetadata_.numberFormatArray(), o = t.length, n = 0; n < o; ++n) {
                var s = t[n];
                0 < this.extractedNationalPrefix_.length && this.phoneUtil_.formattingRuleHasFirstGroupOnly(s.getNationalPrefixFormattingRuleOrDefault()) && !s.getNationalPrefixOptionalWhenFormatting() && !s.hasDomesticCarrierCodeFormattingRule() || (this.extractedNationalPrefix_.length != 0 || this.isCompleteNumber_ || this.phoneUtil_.formattingRuleHasFirstGroupOnly(s.getNationalPrefixFormattingRuleOrDefault()) || s.getNationalPrefixOptionalWhenFormatting()) && i18n.phonenumbers.AsYouTypeFormatter.ELIGIBLE_FORMAT_PATTERN_.test(s.getFormatOrDefault()) && this.possibleFormats_.push(s);
              }
              this.narrowDownPossibleFormats_(e);
            }, i18n.phonenumbers.AsYouTypeFormatter.prototype.narrowDownPossibleFormats_ = function(e) {
              for (var t = [], o = e.length - i18n.phonenumbers.AsYouTypeFormatter.MIN_LEADING_DIGITS_LENGTH_, n = this.possibleFormats_.length, s = 0; s < n; ++s) {
                var i = this.possibleFormats_[s];
                if (i.leadingDigitsPatternCount() == 0) t.push(this.possibleFormats_[s]);
                else {
                  var l = Math.min(o, i.leadingDigitsPatternCount() - 1);
                  i = i.getLeadingDigitsPattern(l), e.search(i) == 0 && t.push(this.possibleFormats_[s]);
                }
              }
              this.possibleFormats_ = t;
            }, i18n.phonenumbers.AsYouTypeFormatter.prototype.createFormattingTemplate_ = function(e) {
              var t = e.getPatternOrDefault();
              return this.formattingTemplate_.clear(), e = this.getFormattingTemplate_(t, e.getFormatOrDefault()), 0 < e.length ? (this.formattingTemplate_.append(e), !0) : !1;
            }, i18n.phonenumbers.AsYouTypeFormatter.prototype.getFormattingTemplate_ = function(e, t) {
              var o = "999999999999999".match(e)[0];
              return o.length < this.nationalNumber_.getLength() ? "" : (e = o.replace(new RegExp(e, "g"), t), e = e.replace(/9/g, this.DIGIT_PLACEHOLDER_));
            }, i18n.phonenumbers.AsYouTypeFormatter.prototype.clear = function() {
              this.currentOutput_ = "", this.accruedInput_.clear(), this.accruedInputWithoutFormatting_.clear(), this.formattingTemplate_.clear(), this.lastMatchPosition_ = 0, this.currentFormattingPattern_ = "", this.prefixBeforeNationalNumber_.clear(), this.extractedNationalPrefix_ = "", this.nationalNumber_.clear(), this.ableToFormat_ = !0, this.inputHasFormatting_ = !1, this.originalPosition_ = this.positionToRemember_ = 0, this.isExpectingCountryCallingCode_ = this.isCompleteNumber_ = !1, this.possibleFormats_ = [], this.shouldAddSpaceAfterNationalPrefix_ = !1, this.currentMetadata_ != this.defaultMetadata_ && (this.currentMetadata_ = this.getMetadataForRegion_(this.defaultCountry_));
            }, i18n.phonenumbers.AsYouTypeFormatter.prototype.inputDigit = function(e) {
              return this.currentOutput_ = this.inputDigitWithOptionToRememberPosition_(e, !1);
            }, i18n.phonenumbers.AsYouTypeFormatter.prototype.inputDigitAndRememberPosition = function(e) {
              return this.currentOutput_ = this.inputDigitWithOptionToRememberPosition_(e, !0);
            }, i18n.phonenumbers.AsYouTypeFormatter.prototype.inputDigitWithOptionToRememberPosition_ = function(e, t) {
              if (this.accruedInput_.append(e), t && (this.originalPosition_ = this.accruedInput_.getLength()), this.isDigitOrLeadingPlusSign_(e) ? e = this.normalizeAndAccrueDigitsAndPlusSign_(e, t) : (this.ableToFormat_ = !1, this.inputHasFormatting_ = !0), !this.ableToFormat_) {
                if (!this.inputHasFormatting_) {
                  if (this.attemptToExtractIdd_()) {
                    if (this.attemptToExtractCountryCallingCode_()) return this.attemptToChoosePatternWithPrefixExtracted_();
                  } else if (this.ableToExtractLongerNdd_()) return this.prefixBeforeNationalNumber_.append(i18n.phonenumbers.AsYouTypeFormatter.SEPARATOR_BEFORE_NATIONAL_NUMBER_), this.attemptToChoosePatternWithPrefixExtracted_();
                }
                return this.accruedInput_.toString();
              }
              switch (this.accruedInputWithoutFormatting_.getLength()) {
                case 0:
                case 1:
                case 2:
                  return this.accruedInput_.toString();
                case 3:
                  if (this.attemptToExtractIdd_()) this.isExpectingCountryCallingCode_ = !0;
                  else return this.extractedNationalPrefix_ = this.removeNationalPrefixFromNationalNumber_(), this.attemptToChooseFormattingPattern_();
                default:
                  return this.isExpectingCountryCallingCode_ ? (this.attemptToExtractCountryCallingCode_() && (this.isExpectingCountryCallingCode_ = !1), this.prefixBeforeNationalNumber_.toString() + this.nationalNumber_.toString()) : 0 < this.possibleFormats_.length ? (e = this.inputDigitHelper_(e), t = this.attemptToFormatAccruedDigits_(), 0 < t.length ? t : (this.narrowDownPossibleFormats_(this.nationalNumber_.toString()), this.maybeCreateNewTemplate_() ? this.inputAccruedNationalNumber_() : this.ableToFormat_ ? this.appendNationalNumber_(e) : this.accruedInput_.toString())) : this.attemptToChooseFormattingPattern_();
              }
            }, i18n.phonenumbers.AsYouTypeFormatter.prototype.attemptToChoosePatternWithPrefixExtracted_ = function() {
              return this.ableToFormat_ = !0, this.isExpectingCountryCallingCode_ = !1, this.possibleFormats_ = [], this.lastMatchPosition_ = 0, this.formattingTemplate_.clear(), this.currentFormattingPattern_ = "", this.attemptToChooseFormattingPattern_();
            }, i18n.phonenumbers.AsYouTypeFormatter.prototype.getExtractedNationalPrefix_ = function() {
              return this.extractedNationalPrefix_;
            }, i18n.phonenumbers.AsYouTypeFormatter.prototype.ableToExtractLongerNdd_ = function() {
              if (0 < this.extractedNationalPrefix_.length) {
                var e = this.nationalNumber_.toString();
                this.nationalNumber_.clear(), this.nationalNumber_.append(this.extractedNationalPrefix_), this.nationalNumber_.append(e), e = this.prefixBeforeNationalNumber_.toString();
                var t = e.lastIndexOf(this.extractedNationalPrefix_);
                this.prefixBeforeNationalNumber_.clear(), this.prefixBeforeNationalNumber_.append(e.substring(0, t));
              }
              return this.extractedNationalPrefix_ != this.removeNationalPrefixFromNationalNumber_();
            }, i18n.phonenumbers.AsYouTypeFormatter.prototype.isDigitOrLeadingPlusSign_ = function(e) {
              return i18n.phonenumbers.PhoneNumberUtil.CAPTURING_DIGIT_PATTERN.test(e) || this.accruedInput_.getLength() == 1 && i18n.phonenumbers.PhoneNumberUtil.PLUS_CHARS_PATTERN.test(e);
            }, i18n.phonenumbers.AsYouTypeFormatter.prototype.attemptToFormatAccruedDigits_ = function() {
              for (var e = this.nationalNumber_.toString(), t = this.possibleFormats_.length, o = 0; o < t; ++o) {
                var n = this.possibleFormats_[o], s = n.getPatternOrDefault();
                if (new RegExp("^(?:" + s + ")$").test(e) && (this.shouldAddSpaceAfterNationalPrefix_ = i18n.phonenumbers.AsYouTypeFormatter.NATIONAL_PREFIX_SEPARATORS_PATTERN_.test(n.getNationalPrefixFormattingRule()), n = e.replace(new RegExp(s, "g"), n.getFormat()), n = this.appendNationalNumber_(n), i18n.phonenumbers.PhoneNumberUtil.normalizeDiallableCharsOnly(n) == this.accruedInputWithoutFormatting_)) return n;
              }
              return "";
            }, i18n.phonenumbers.AsYouTypeFormatter.prototype.appendNationalNumber_ = function(e) {
              var t = this.prefixBeforeNationalNumber_.getLength();
              return this.shouldAddSpaceAfterNationalPrefix_ && 0 < t && this.prefixBeforeNationalNumber_.toString().charAt(t - 1) != i18n.phonenumbers.AsYouTypeFormatter.SEPARATOR_BEFORE_NATIONAL_NUMBER_ ? this.prefixBeforeNationalNumber_ + i18n.phonenumbers.AsYouTypeFormatter.SEPARATOR_BEFORE_NATIONAL_NUMBER_ + e : this.prefixBeforeNationalNumber_ + e;
            }, i18n.phonenumbers.AsYouTypeFormatter.prototype.getRememberedPosition = function() {
              if (!this.ableToFormat_) return this.originalPosition_;
              for (var e = 0, t = 0, o = this.accruedInputWithoutFormatting_.toString(), n = this.currentOutput_.toString(); e < this.positionToRemember_ && t < n.length; ) o.charAt(e) == n.charAt(t) && e++, t++;
              return t;
            }, i18n.phonenumbers.AsYouTypeFormatter.prototype.attemptToChooseFormattingPattern_ = function() {
              var e = this.nationalNumber_.toString();
              return e.length >= i18n.phonenumbers.AsYouTypeFormatter.MIN_LEADING_DIGITS_LENGTH_ ? (this.getAvailableFormats_(e), e = this.attemptToFormatAccruedDigits_(), 0 < e.length ? e : this.maybeCreateNewTemplate_() ? this.inputAccruedNationalNumber_() : this.accruedInput_.toString()) : this.appendNationalNumber_(e);
            }, i18n.phonenumbers.AsYouTypeFormatter.prototype.inputAccruedNationalNumber_ = function() {
              var e = this.nationalNumber_.toString(), t = e.length;
              if (0 < t) {
                for (var o = "", n = 0; n < t; n++) o = this.inputDigitHelper_(e.charAt(n));
                return this.ableToFormat_ ? this.appendNationalNumber_(o) : this.accruedInput_.toString();
              }
              return this.prefixBeforeNationalNumber_.toString();
            }, i18n.phonenumbers.AsYouTypeFormatter.prototype.isNanpaNumberWithNationalPrefix_ = function() {
              if (this.currentMetadata_.getCountryCode() != 1) return !1;
              var e = this.nationalNumber_.toString();
              return e.charAt(0) == "1" && e.charAt(1) != "0" && e.charAt(1) != "1";
            }, i18n.phonenumbers.AsYouTypeFormatter.prototype.removeNationalPrefixFromNationalNumber_ = function() {
              var e = this.nationalNumber_.toString(), t = 0;
              if (this.isNanpaNumberWithNationalPrefix_()) t = 1, this.prefixBeforeNationalNumber_.append("1").append(i18n.phonenumbers.AsYouTypeFormatter.SEPARATOR_BEFORE_NATIONAL_NUMBER_), this.isCompleteNumber_ = !0;
              else if (this.currentMetadata_.hasNationalPrefixForParsing()) {
                var o = new RegExp("^(?:" + this.currentMetadata_.getNationalPrefixForParsing() + ")");
                o = e.match(o), o != null && o[0] != null && 0 < o[0].length && (this.isCompleteNumber_ = !0, t = o[0].length, this.prefixBeforeNationalNumber_.append(e.substring(0, t)));
              }
              return this.nationalNumber_.clear(), this.nationalNumber_.append(e.substring(t)), e.substring(0, t);
            }, i18n.phonenumbers.AsYouTypeFormatter.prototype.attemptToExtractIdd_ = function() {
              var e = this.accruedInputWithoutFormatting_.toString(), t = new RegExp("^(?:\\" + i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN + "|" + this.currentMetadata_.getInternationalPrefix() + ")");
              return t = e.match(t), t != null && t[0] != null && 0 < t[0].length ? (this.isCompleteNumber_ = !0, t = t[0].length, this.nationalNumber_.clear(), this.nationalNumber_.append(e.substring(t)), this.prefixBeforeNationalNumber_.clear(), this.prefixBeforeNationalNumber_.append(e.substring(
                0,
                t
              )), e.charAt(0) != i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN && this.prefixBeforeNationalNumber_.append(i18n.phonenumbers.AsYouTypeFormatter.SEPARATOR_BEFORE_NATIONAL_NUMBER_), !0) : !1;
            }, i18n.phonenumbers.AsYouTypeFormatter.prototype.attemptToExtractCountryCallingCode_ = function() {
              if (this.nationalNumber_.getLength() == 0) return !1;
              var e = new goog.string.StringBuffer(), t = this.phoneUtil_.extractCountryCode(this.nationalNumber_, e);
              return t == 0 ? !1 : (this.nationalNumber_.clear(), this.nationalNumber_.append(e.toString()), e = this.phoneUtil_.getRegionCodeForCountryCode(t), i18n.phonenumbers.PhoneNumberUtil.REGION_CODE_FOR_NON_GEO_ENTITY == e ? this.currentMetadata_ = this.phoneUtil_.getMetadataForNonGeographicalRegion(t) : e != this.defaultCountry_ && (this.currentMetadata_ = this.getMetadataForRegion_(e)), this.prefixBeforeNationalNumber_.append("" + t).append(i18n.phonenumbers.AsYouTypeFormatter.SEPARATOR_BEFORE_NATIONAL_NUMBER_), this.extractedNationalPrefix_ = "", !0);
            }, i18n.phonenumbers.AsYouTypeFormatter.prototype.normalizeAndAccrueDigitsAndPlusSign_ = function(e, t) {
              if (e == i18n.phonenumbers.PhoneNumberUtil.PLUS_SIGN) {
                var o = e;
                this.accruedInputWithoutFormatting_.append(e);
              } else o = i18n.phonenumbers.PhoneNumberUtil.DIGIT_MAPPINGS[e], this.accruedInputWithoutFormatting_.append(o), this.nationalNumber_.append(o);
              return t && (this.positionToRemember_ = this.accruedInputWithoutFormatting_.getLength()), o;
            }, i18n.phonenumbers.AsYouTypeFormatter.prototype.inputDigitHelper_ = function(e) {
              var t = this.formattingTemplate_.toString();
              if (0 <= t.substring(this.lastMatchPosition_).search(this.DIGIT_PATTERN_)) {
                var o = t.search(this.DIGIT_PATTERN_);
                return e = t.replace(this.DIGIT_PATTERN_, e), this.formattingTemplate_.clear(), this.formattingTemplate_.append(e), this.lastMatchPosition_ = o, e.substring(0, this.lastMatchPosition_ + 1);
              }
              return this.possibleFormats_.length == 1 && (this.ableToFormat_ = !1), this.currentFormattingPattern_ = "", this.accruedInput_.toString();
            }, Object.defineProperty(exports$1, "__esModule", { value: !0 }), exports$1.default = i18n.phonenumbers, module.exports = exports$1.default;
          }).call(this);
        }).call(this, typeof commonjsGlobal < "u" ? commonjsGlobal : typeof self < "u" ? self : typeof window < "u" ? window : {});
      }, {}] }, {}, [1])(1);
    });
  })(libphonenumber$1)), libphonenumber$1.exports;
}
var libphonenumberExports = /* @__PURE__ */ requireLibphonenumber();
const libphonenumber = /* @__PURE__ */ getDefaultExportFromCjs(libphonenumberExports);
var propertyExpr, hasRequiredPropertyExpr;
function requirePropertyExpr() {
  if (hasRequiredPropertyExpr) return propertyExpr;
  hasRequiredPropertyExpr = 1;
  function e(E) {
    this._maxSize = E, this.clear();
  }
  e.prototype.clear = function() {
    this._size = 0, this._values = /* @__PURE__ */ Object.create(null);
  }, e.prototype.get = function(E) {
    return this._values[E];
  }, e.prototype.set = function(E, $) {
    return this._size >= this._maxSize && this.clear(), E in this._values || this._size++, this._values[E] = $;
  };
  var t = /[^.^\]^[]+|(?=\[\]|\.\.)/g, o = /^\d+$/, n = /^\d/, s = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g, i = /^\s*(['"]?)(.*?)(\1)\s*$/, l = 512, d = new e(l), u = new e(l), c = new e(l);
  propertyExpr = {
    Cache: e,
    split: f,
    normalizePath: p,
    setter: function(E) {
      var $ = p(E);
      return u.get(E) || u.set(E, function(C, x) {
        for (var _ = 0, D = $.length, O = C; _ < D - 1; ) {
          var v = $[_];
          if (v === "__proto__" || v === "constructor" || v === "prototype")
            return C;
          O = O[$[_++]];
        }
        O[$[_]] = x;
      });
    },
    getter: function(E, $) {
      var R = p(E);
      return c.get(E) || c.set(E, function(x) {
        for (var _ = 0, D = R.length; _ < D; )
          if (x != null || !$) x = x[R[_++]];
          else return;
        return x;
      });
    },
    join: function(E) {
      return E.reduce(function($, R) {
        return $ + (y(R) || o.test(R) ? "[" + R + "]" : ($ ? "." : "") + R);
      }, "");
    },
    forEach: function(E, $, R) {
      g(Array.isArray(E) ? E : f(E), $, R);
    }
  };
  function p(E) {
    return d.get(E) || d.set(
      E,
      f(E).map(function($) {
        return $.replace(i, "$2");
      })
    );
  }
  function f(E) {
    return E.match(t) || [""];
  }
  function g(E, $, R) {
    var C = E.length, x, _, D, O;
    for (_ = 0; _ < C; _++)
      x = E[_], x && (P(x) && (x = '"' + x + '"'), O = y(x), D = !O && /^\d+$/.test(x), $.call(R, x, O, D, _, E));
  }
  function y(E) {
    return typeof E == "string" && E && ["'", '"'].indexOf(E.charAt(0)) !== -1;
  }
  function h(E) {
    return E.match(n) && !E.match(o);
  }
  function T(E) {
    return s.test(E);
  }
  function P(E) {
    return !y(E) && (h(E) || T(E));
  }
  return propertyExpr;
}
var propertyExprExports = requirePropertyExpr(), toposort = { exports: {} }, hasRequiredToposort;
function requireToposort() {
  if (hasRequiredToposort) return toposort.exports;
  hasRequiredToposort = 1, toposort.exports = function(s) {
    return e(t(s), s);
  }, toposort.exports.array = e;
  function e(s, i) {
    var l = s.length, d = new Array(l), u = {}, c = l, p = o(i), f = n(s);
    for (i.forEach(function(y) {
      if (!f.has(y[0]) || !f.has(y[1]))
        throw new Error("Unknown node. There is an unknown node in the supplied edges.");
    }); c--; )
      u[c] || g(s[c], c, /* @__PURE__ */ new Set());
    return d;
    function g(y, h, T) {
      if (T.has(y)) {
        var P;
        try {
          P = ", node was:" + JSON.stringify(y);
        } catch {
          P = "";
        }
        throw new Error("Cyclic dependency" + P);
      }
      if (!f.has(y))
        throw new Error("Found unknown node. Make sure to provided all involved nodes. Unknown node: " + JSON.stringify(y));
      if (!u[h]) {
        u[h] = !0;
        var E = p.get(y) || /* @__PURE__ */ new Set();
        if (E = Array.from(E), h = E.length) {
          T.add(y);
          do {
            var $ = E[--h];
            g($, f.get($), T);
          } while (h);
          T.delete(y);
        }
        d[--l] = y;
      }
    }
  }
  function t(s) {
    for (var i = /* @__PURE__ */ new Set(), l = 0, d = s.length; l < d; l++) {
      var u = s[l];
      i.add(u[0]), i.add(u[1]);
    }
    return Array.from(i);
  }
  function o(s) {
    for (var i = /* @__PURE__ */ new Map(), l = 0, d = s.length; l < d; l++) {
      var u = s[l];
      i.has(u[0]) || i.set(u[0], /* @__PURE__ */ new Set()), i.has(u[1]) || i.set(u[1], /* @__PURE__ */ new Set()), i.get(u[0]).add(u[1]);
    }
    return i;
  }
  function n(s) {
    for (var i = /* @__PURE__ */ new Map(), l = 0, d = s.length; l < d; l++)
      i.set(s[l], l);
    return i;
  }
  return toposort.exports;
}
requireToposort();
const toString$1 = Object.prototype.toString, errorToString = Error.prototype.toString, regExpToString = RegExp.prototype.toString, symbolToString = typeof Symbol < "u" ? Symbol.prototype.toString : () => "", SYMBOL_REGEXP = /^Symbol\((.*)\)(.*)$/;
function printNumber(e) {
  return e != +e ? "NaN" : e === 0 && 1 / e < 0 ? "-0" : "" + e;
}
function printSimpleValue(e, t = !1) {
  if (e == null || e === !0 || e === !1) return "" + e;
  const o = typeof e;
  if (o === "number") return printNumber(e);
  if (o === "string") return t ? `"${e}"` : e;
  if (o === "function") return "[Function " + (e.name || "anonymous") + "]";
  if (o === "symbol") return symbolToString.call(e).replace(SYMBOL_REGEXP, "Symbol($1)");
  const n = toString$1.call(e).slice(8, -1);
  return n === "Date" ? isNaN(e.getTime()) ? "" + e : e.toISOString(e) : n === "Error" || e instanceof Error ? "[" + errorToString.call(e) + "]" : n === "RegExp" ? regExpToString.call(e) : null;
}
function printValue(e, t) {
  let o = printSimpleValue(e, t);
  return o !== null ? o : JSON.stringify(e, function(n, s) {
    let i = printSimpleValue(this[n], t);
    return i !== null ? i : s;
  }, 2);
}
function toArray$1(e) {
  return e == null ? [] : [].concat(e);
}
let _Symbol$toStringTag, _Symbol$hasInstance, _Symbol$toStringTag2, strReg = /\$\{\s*(\w+)\s*\}/g;
_Symbol$toStringTag = Symbol.toStringTag;
class ValidationErrorNoStack {
  constructor(t, o, n, s) {
    this.name = void 0, this.message = void 0, this.value = void 0, this.path = void 0, this.type = void 0, this.params = void 0, this.errors = void 0, this.inner = void 0, this[_Symbol$toStringTag] = "Error", this.name = "ValidationError", this.value = o, this.path = n, this.type = s, this.errors = [], this.inner = [], toArray$1(t).forEach((i) => {
      if (ValidationError.isError(i)) {
        this.errors.push(...i.errors);
        const l = i.inner.length ? i.inner : [i];
        this.inner.push(...l);
      } else
        this.errors.push(i);
    }), this.message = this.errors.length > 1 ? `${this.errors.length} errors occurred` : this.errors[0];
  }
}
_Symbol$hasInstance = Symbol.hasInstance;
_Symbol$toStringTag2 = Symbol.toStringTag;
class ValidationError extends Error {
  static formatError(t, o) {
    const n = o.label || o.path || "this";
    return o = Object.assign({}, o, {
      path: n,
      originalPath: o.path
    }), typeof t == "string" ? t.replace(strReg, (s, i) => printValue(o[i])) : typeof t == "function" ? t(o) : t;
  }
  static isError(t) {
    return t && t.name === "ValidationError";
  }
  constructor(t, o, n, s, i) {
    const l = new ValidationErrorNoStack(t, o, n, s);
    if (i)
      return l;
    super(), this.value = void 0, this.path = void 0, this.type = void 0, this.params = void 0, this.errors = [], this.inner = [], this[_Symbol$toStringTag2] = "Error", this.name = l.name, this.message = l.message, this.type = l.type, this.value = l.value, this.path = l.path, this.errors = l.errors, this.inner = l.inner, Error.captureStackTrace && Error.captureStackTrace(this, ValidationError);
  }
  static [_Symbol$hasInstance](t) {
    return ValidationErrorNoStack[Symbol.hasInstance](t) || super[Symbol.hasInstance](t);
  }
}
let mixed = {
  default: "${path} is invalid",
  required: "${path} is a required field",
  defined: "${path} must be defined",
  notNull: "${path} cannot be null",
  oneOf: "${path} must be one of the following values: ${values}",
  notOneOf: "${path} must not be one of the following values: ${values}",
  notType: ({
    path: e,
    type: t,
    value: o,
    originalValue: n
  }) => {
    const s = n != null && n !== o ? ` (cast from the value \`${printValue(n, !0)}\`).` : ".";
    return t !== "mixed" ? `${e} must be a \`${t}\` type, but the final value was: \`${printValue(o, !0)}\`` + s : `${e} must match the configured type. The validated value was: \`${printValue(o, !0)}\`` + s;
  }
}, string = {
  length: "${path} must be exactly ${length} characters",
  min: "${path} must be at least ${min} characters",
  max: "${path} must be at most ${max} characters",
  matches: '${path} must match the following: "${regex}"',
  email: "${path} must be a valid email",
  url: "${path} must be a valid URL",
  uuid: "${path} must be a valid UUID",
  datetime: "${path} must be a valid ISO date-time",
  datetime_precision: "${path} must be a valid ISO date-time with a sub-second precision of exactly ${precision} digits",
  datetime_offset: '${path} must be a valid ISO date-time with UTC "Z" timezone',
  trim: "${path} must be a trimmed string",
  lowercase: "${path} must be a lowercase string",
  uppercase: "${path} must be a upper case string"
}, number = {
  min: "${path} must be greater than or equal to ${min}",
  max: "${path} must be less than or equal to ${max}",
  lessThan: "${path} must be less than ${less}",
  moreThan: "${path} must be greater than ${more}",
  positive: "${path} must be a positive number",
  negative: "${path} must be a negative number",
  integer: "${path} must be an integer"
}, date = {
  min: "${path} field must be later than ${min}",
  max: "${path} field must be at earlier than ${max}"
}, boolean = {
  isValue: "${path} field must be ${value}"
}, object = {
  noUnknown: "${path} field has unspecified keys: ${unknown}",
  exact: "${path} object contains unknown properties: ${properties}"
}, array = {
  min: "${path} field must have at least ${min} items",
  max: "${path} field must have less than or equal to ${max} items",
  length: "${path} must have ${length} items"
}, tuple = {
  notType: (e) => {
    const {
      path: t,
      value: o,
      spec: n
    } = e, s = n.types.length;
    if (Array.isArray(o)) {
      if (o.length < s) return `${t} tuple value has too few items, expected a length of ${s} but got ${o.length} for value: \`${printValue(o, !0)}\``;
      if (o.length > s) return `${t} tuple value has too many items, expected a length of ${s} but got ${o.length} for value: \`${printValue(o, !0)}\``;
    }
    return ValidationError.formatError(mixed.notType, e);
  }
};
Object.assign(/* @__PURE__ */ Object.create(null), {
  mixed,
  string,
  number,
  date,
  object,
  array,
  boolean,
  tuple
});
const isSchema = (e) => e && e.__isYupSchema__;
class Condition {
  static fromOptions(t, o) {
    if (!o.then && !o.otherwise) throw new TypeError("either `then:` or `otherwise:` is required for `when()` conditions");
    let {
      is: n,
      then: s,
      otherwise: i
    } = o, l = typeof n == "function" ? n : (...d) => d.every((u) => u === n);
    return new Condition(t, (d, u) => {
      var c;
      let p = l(...d) ? s : i;
      return (c = p?.(u)) != null ? c : u;
    });
  }
  constructor(t, o) {
    this.fn = void 0, this.refs = t, this.refs = t, this.fn = o;
  }
  resolve(t, o) {
    let n = this.refs.map((i) => (
      // TODO: ? operator here?
      i.getValue(o?.value, o?.parent, o?.context)
    )), s = this.fn(n, t, o);
    if (s === void 0 || // @ts-ignore this can be base
    s === t)
      return t;
    if (!isSchema(s)) throw new TypeError("conditions must return a schema object");
    return s.resolve(o);
  }
}
const prefixes = {
  context: "$",
  value: "."
};
class Reference {
  constructor(t, o = {}) {
    if (this.key = void 0, this.isContext = void 0, this.isValue = void 0, this.isSibling = void 0, this.path = void 0, this.getter = void 0, this.map = void 0, typeof t != "string") throw new TypeError("ref must be a string, got: " + t);
    if (this.key = t.trim(), t === "") throw new TypeError("ref must be a non-empty string");
    this.isContext = this.key[0] === prefixes.context, this.isValue = this.key[0] === prefixes.value, this.isSibling = !this.isContext && !this.isValue;
    let n = this.isContext ? prefixes.context : this.isValue ? prefixes.value : "";
    this.path = this.key.slice(n.length), this.getter = this.path && propertyExprExports.getter(this.path, !0), this.map = o.map;
  }
  getValue(t, o, n) {
    let s = this.isContext ? n : this.isValue ? t : o;
    return this.getter && (s = this.getter(s || {})), this.map && (s = this.map(s)), s;
  }
  /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {Object=} options.context
   * @param {Object=} options.parent
   */
  cast(t, o) {
    return this.getValue(t, o?.parent, o?.context);
  }
  resolve() {
    return this;
  }
  describe() {
    return {
      type: "ref",
      key: this.key
    };
  }
  toString() {
    return `Ref(${this.key})`;
  }
  static isRef(t) {
    return t && t.__isYupRef;
  }
}
Reference.prototype.__isYupRef = !0;
const isAbsent = (e) => e == null;
function createValidation(e) {
  function t({
    value: o,
    path: n = "",
    options: s,
    originalValue: i,
    schema: l
  }, d, u) {
    const {
      name: c,
      test: p,
      params: f,
      message: g,
      skipAbsent: y
    } = e;
    let {
      parent: h,
      context: T,
      abortEarly: P = l.spec.abortEarly,
      disableStackTrace: E = l.spec.disableStackTrace
    } = s;
    const $ = {
      value: o,
      parent: h,
      context: T
    };
    function R(M = {}) {
      const S = resolveParams(Object.assign({
        value: o,
        originalValue: i,
        label: l.spec.label,
        path: M.path || n,
        spec: l.spec,
        disableStackTrace: M.disableStackTrace || E
      }, f, M.params), $), I = new ValidationError(ValidationError.formatError(M.message || g, S), o, S.path, M.type || c, S.disableStackTrace);
      return I.params = S, I;
    }
    const C = P ? d : u;
    let x = {
      path: n,
      parent: h,
      type: c,
      from: s.from,
      createError: R,
      resolve(M) {
        return resolveMaybeRef(M, $);
      },
      options: s,
      originalValue: i,
      schema: l
    };
    const _ = (M) => {
      ValidationError.isError(M) ? C(M) : M ? u(null) : C(R());
    }, D = (M) => {
      ValidationError.isError(M) ? C(M) : d(M);
    };
    if (y && isAbsent(o))
      return _(!0);
    let v;
    try {
      var w;
      if (v = p.call(x, o, x), typeof ((w = v) == null ? void 0 : w.then) == "function") {
        if (s.sync)
          throw new Error(`Validation test of type: "${x.type}" returned a Promise during a synchronous validate. This test will finish after the validate call has returned`);
        return Promise.resolve(v).then(_, D);
      }
    } catch (M) {
      D(M);
      return;
    }
    _(v);
  }
  return t.OPTIONS = e, t;
}
function resolveParams(e, t) {
  if (!e) return e;
  for (const o of Object.keys(e))
    e[o] = resolveMaybeRef(e[o], t);
  return e;
}
function resolveMaybeRef(e, t) {
  return Reference.isRef(e) ? e.getValue(t.value, t.parent, t.context) : e;
}
function getIn(e, t, o, n = o) {
  let s, i, l;
  return t ? (propertyExprExports.forEach(t, (d, u, c) => {
    let p = u ? d.slice(1, d.length - 1) : d;
    e = e.resolve({
      context: n,
      parent: s,
      value: o
    });
    let f = e.type === "tuple", g = c ? parseInt(p, 10) : 0;
    if (e.innerType || f) {
      if (f && !c) throw new Error(`Yup.reach cannot implicitly index into a tuple type. the path part "${l}" must contain an index to the tuple element, e.g. "${l}[0]"`);
      if (o && g >= o.length)
        throw new Error(`Yup.reach cannot resolve an array item at index: ${d}, in the path: ${t}. because there is no value at that index. `);
      s = o, o = o && o[g], e = f ? e.spec.types[g] : e.innerType;
    }
    if (!c) {
      if (!e.fields || !e.fields[p]) throw new Error(`The schema does not contain the path: ${t}. (failed at: ${l} which is a type: "${e.type}")`);
      s = o, o = o && o[p], e = e.fields[p];
    }
    i = p, l = u ? "[" + d + "]" : "." + d;
  }), {
    schema: e,
    parent: s,
    parentPath: i
  }) : {
    parent: s,
    parentPath: t,
    schema: e
  };
}
class ReferenceSet extends Set {
  describe() {
    const t = [];
    for (const o of this.values())
      t.push(Reference.isRef(o) ? o.describe() : o);
    return t;
  }
  resolveAll(t) {
    let o = [];
    for (const n of this.values())
      o.push(t(n));
    return o;
  }
  clone() {
    return new ReferenceSet(this.values());
  }
  merge(t, o) {
    const n = this.clone();
    return t.forEach((s) => n.add(s)), o.forEach((s) => n.delete(s)), n;
  }
}
function clone(e, t = /* @__PURE__ */ new Map()) {
  if (isSchema(e) || !e || typeof e != "object") return e;
  if (t.has(e)) return t.get(e);
  let o;
  if (e instanceof Date)
    o = new Date(e.getTime()), t.set(e, o);
  else if (e instanceof RegExp)
    o = new RegExp(e), t.set(e, o);
  else if (Array.isArray(e)) {
    o = new Array(e.length), t.set(e, o);
    for (let n = 0; n < e.length; n++) o[n] = clone(e[n], t);
  } else if (e instanceof Map) {
    o = /* @__PURE__ */ new Map(), t.set(e, o);
    for (const [n, s] of e.entries()) o.set(n, clone(s, t));
  } else if (e instanceof Set) {
    o = /* @__PURE__ */ new Set(), t.set(e, o);
    for (const n of e) o.add(clone(n, t));
  } else if (e instanceof Object) {
    o = {}, t.set(e, o);
    for (const [n, s] of Object.entries(e)) o[n] = clone(s, t);
  } else
    throw Error(`Unable to clone ${e}`);
  return o;
}
function createStandardPath(e) {
  if (!(e != null && e.length))
    return;
  const t = [];
  let o = "", n = !1, s = !1;
  for (let i = 0; i < e.length; i++) {
    const l = e[i];
    if (l === "[" && !s) {
      o && (t.push(...o.split(".").filter(Boolean)), o = ""), n = !0;
      continue;
    }
    if (l === "]" && !s) {
      o && (/^\d+$/.test(o) ? t.push(o) : t.push(o.replace(/^"|"$/g, "")), o = ""), n = !1;
      continue;
    }
    if (l === '"') {
      s = !s;
      continue;
    }
    if (l === "." && !n && !s) {
      o && (t.push(o), o = "");
      continue;
    }
    o += l;
  }
  return o && t.push(...o.split(".").filter(Boolean)), t;
}
function createStandardIssues(e, t) {
  const o = t ? `${t}.${e.path}` : e.path;
  return e.errors.map((n) => ({
    message: n,
    path: createStandardPath(o)
  }));
}
function issuesFromValidationError(e, t) {
  var o;
  if (!((o = e.inner) != null && o.length) && e.errors.length)
    return createStandardIssues(e, t);
  const n = t ? `${t}.${e.path}` : e.path;
  return e.inner.flatMap((s) => issuesFromValidationError(s, n));
}
class Schema {
  constructor(t) {
    this.type = void 0, this.deps = [], this.tests = void 0, this.transforms = void 0, this.conditions = [], this._mutate = void 0, this.internalTests = {}, this._whitelist = new ReferenceSet(), this._blacklist = new ReferenceSet(), this.exclusiveTests = /* @__PURE__ */ Object.create(null), this._typeCheck = void 0, this.spec = void 0, this.tests = [], this.transforms = [], this.withMutation(() => {
      this.typeError(mixed.notType);
    }), this.type = t.type, this._typeCheck = t.check, this.spec = Object.assign({
      strip: !1,
      strict: !1,
      abortEarly: !0,
      recursive: !0,
      disableStackTrace: !1,
      nullable: !1,
      optional: !0,
      coerce: !0
    }, t?.spec), this.withMutation((o) => {
      o.nonNullable();
    });
  }
  // TODO: remove
  get _type() {
    return this.type;
  }
  clone(t) {
    if (this._mutate)
      return t && Object.assign(this.spec, t), this;
    const o = Object.create(Object.getPrototypeOf(this));
    return o.type = this.type, o._typeCheck = this._typeCheck, o._whitelist = this._whitelist.clone(), o._blacklist = this._blacklist.clone(), o.internalTests = Object.assign({}, this.internalTests), o.exclusiveTests = Object.assign({}, this.exclusiveTests), o.deps = [...this.deps], o.conditions = [...this.conditions], o.tests = [...this.tests], o.transforms = [...this.transforms], o.spec = clone(Object.assign({}, this.spec, t)), o;
  }
  label(t) {
    let o = this.clone();
    return o.spec.label = t, o;
  }
  meta(...t) {
    if (t.length === 0) return this.spec.meta;
    let o = this.clone();
    return o.spec.meta = Object.assign(o.spec.meta || {}, t[0]), o;
  }
  withMutation(t) {
    let o = this._mutate;
    this._mutate = !0;
    let n = t(this);
    return this._mutate = o, n;
  }
  concat(t) {
    if (!t || t === this) return this;
    if (t.type !== this.type && this.type !== "mixed") throw new TypeError(`You cannot \`concat()\` schema's of different types: ${this.type} and ${t.type}`);
    let o = this, n = t.clone();
    const s = Object.assign({}, o.spec, n.spec);
    return n.spec = s, n.internalTests = Object.assign({}, o.internalTests, n.internalTests), n._whitelist = o._whitelist.merge(t._whitelist, t._blacklist), n._blacklist = o._blacklist.merge(t._blacklist, t._whitelist), n.tests = o.tests, n.exclusiveTests = o.exclusiveTests, n.withMutation((i) => {
      t.tests.forEach((l) => {
        i.test(l.OPTIONS);
      });
    }), n.transforms = [...o.transforms, ...n.transforms], n;
  }
  isType(t) {
    return t == null ? !!(this.spec.nullable && t === null || this.spec.optional && t === void 0) : this._typeCheck(t);
  }
  resolve(t) {
    let o = this;
    if (o.conditions.length) {
      let n = o.conditions;
      o = o.clone(), o.conditions = [], o = n.reduce((s, i) => i.resolve(s, t), o), o = o.resolve(t);
    }
    return o;
  }
  resolveOptions(t) {
    var o, n, s, i;
    return Object.assign({}, t, {
      from: t.from || [],
      strict: (o = t.strict) != null ? o : this.spec.strict,
      abortEarly: (n = t.abortEarly) != null ? n : this.spec.abortEarly,
      recursive: (s = t.recursive) != null ? s : this.spec.recursive,
      disableStackTrace: (i = t.disableStackTrace) != null ? i : this.spec.disableStackTrace
    });
  }
  /**
   * Run the configured transform pipeline over an input value.
   */
  cast(t, o = {}) {
    let n = this.resolve(Object.assign({}, o, {
      value: t
      // parent: options.parent,
      // context: options.context,
    })), s = o.assert === "ignore-optionality", i = n._cast(t, o);
    if (o.assert !== !1 && !n.isType(i)) {
      if (s && isAbsent(i))
        return i;
      let l = printValue(t), d = printValue(i);
      throw new TypeError(`The value of ${o.path || "field"} could not be cast to a value that satisfies the schema type: "${n.type}". 

attempted value: ${l} 
` + (d !== l ? `result of cast: ${d}` : ""));
    }
    return i;
  }
  _cast(t, o) {
    let n = t === void 0 ? t : this.transforms.reduce((s, i) => i.call(this, s, t, this, o), t);
    return n === void 0 && (n = this.getDefault(o)), n;
  }
  _validate(t, o = {}, n, s) {
    let {
      path: i,
      originalValue: l = t,
      strict: d = this.spec.strict
    } = o, u = t;
    d || (u = this._cast(u, Object.assign({
      assert: !1
    }, o)));
    let c = [];
    for (let p of Object.values(this.internalTests))
      p && c.push(p);
    this.runTests({
      path: i,
      value: u,
      originalValue: l,
      options: o,
      tests: c
    }, n, (p) => {
      if (p.length)
        return s(p, u);
      this.runTests({
        path: i,
        value: u,
        originalValue: l,
        options: o,
        tests: this.tests
      }, n, s);
    });
  }
  /**
   * Executes a set of validations, either schema, produced Tests or a nested
   * schema validate result.
   */
  runTests(t, o, n) {
    let s = !1, {
      tests: i,
      value: l,
      originalValue: d,
      path: u,
      options: c
    } = t, p = (T) => {
      s || (s = !0, o(T, l));
    }, f = (T) => {
      s || (s = !0, n(T, l));
    }, g = i.length, y = [];
    if (!g) return f([]);
    let h = {
      value: l,
      originalValue: d,
      path: u,
      options: c,
      schema: this
    };
    for (let T = 0; T < i.length; T++) {
      const P = i[T];
      P(h, p, function($) {
        $ && (Array.isArray($) ? y.push(...$) : y.push($)), --g <= 0 && f(y);
      });
    }
  }
  asNestedTest({
    key: t,
    index: o,
    parent: n,
    parentPath: s,
    originalParent: i,
    options: l
  }) {
    const d = t ?? o;
    if (d == null)
      throw TypeError("Must include `key` or `index` for nested validations");
    const u = typeof d == "number";
    let c = n[d];
    const p = Object.assign({}, l, {
      // Nested validations fields are always strict:
      //    1. parent isn't strict so the casting will also have cast inner values
      //    2. parent is strict in which case the nested values weren't cast either
      strict: !0,
      parent: n,
      value: c,
      originalValue: i[d],
      // FIXME: tests depend on `index` being passed around deeply,
      //   we should not let the options.key/index bleed through
      key: void 0,
      // index: undefined,
      [u ? "index" : "key"]: d,
      path: u || d.includes(".") ? `${s || ""}[${u ? d : `"${d}"`}]` : (s ? `${s}.` : "") + t
    });
    return (f, g, y) => this.resolve(p)._validate(c, p, g, y);
  }
  validate(t, o) {
    var n;
    let s = this.resolve(Object.assign({}, o, {
      value: t
    })), i = (n = o?.disableStackTrace) != null ? n : s.spec.disableStackTrace;
    return new Promise((l, d) => s._validate(t, o, (u, c) => {
      ValidationError.isError(u) && (u.value = c), d(u);
    }, (u, c) => {
      u.length ? d(new ValidationError(u, c, void 0, void 0, i)) : l(c);
    }));
  }
  validateSync(t, o) {
    var n;
    let s = this.resolve(Object.assign({}, o, {
      value: t
    })), i, l = (n = o?.disableStackTrace) != null ? n : s.spec.disableStackTrace;
    return s._validate(t, Object.assign({}, o, {
      sync: !0
    }), (d, u) => {
      throw ValidationError.isError(d) && (d.value = u), d;
    }, (d, u) => {
      if (d.length) throw new ValidationError(d, t, void 0, void 0, l);
      i = u;
    }), i;
  }
  isValid(t, o) {
    return this.validate(t, o).then(() => !0, (n) => {
      if (ValidationError.isError(n)) return !1;
      throw n;
    });
  }
  isValidSync(t, o) {
    try {
      return this.validateSync(t, o), !0;
    } catch (n) {
      if (ValidationError.isError(n)) return !1;
      throw n;
    }
  }
  _getDefault(t) {
    let o = this.spec.default;
    return o == null ? o : typeof o == "function" ? o.call(this, t) : clone(o);
  }
  getDefault(t) {
    return this.resolve(t || {})._getDefault(t);
  }
  default(t) {
    return arguments.length === 0 ? this._getDefault() : this.clone({
      default: t
    });
  }
  strict(t = !0) {
    return this.clone({
      strict: t
    });
  }
  nullability(t, o) {
    const n = this.clone({
      nullable: t
    });
    return n.internalTests.nullable = createValidation({
      message: o,
      name: "nullable",
      test(s) {
        return s === null ? this.schema.spec.nullable : !0;
      }
    }), n;
  }
  optionality(t, o) {
    const n = this.clone({
      optional: t
    });
    return n.internalTests.optionality = createValidation({
      message: o,
      name: "optionality",
      test(s) {
        return s === void 0 ? this.schema.spec.optional : !0;
      }
    }), n;
  }
  optional() {
    return this.optionality(!0);
  }
  defined(t = mixed.defined) {
    return this.optionality(!1, t);
  }
  nullable() {
    return this.nullability(!0);
  }
  nonNullable(t = mixed.notNull) {
    return this.nullability(!1, t);
  }
  required(t = mixed.required) {
    return this.clone().withMutation((o) => o.nonNullable(t).defined(t));
  }
  notRequired() {
    return this.clone().withMutation((t) => t.nullable().optional());
  }
  transform(t) {
    let o = this.clone();
    return o.transforms.push(t), o;
  }
  /**
   * Adds a test function to the schema's queue of tests.
   * tests can be exclusive or non-exclusive.
   *
   * - exclusive tests, will replace any existing tests of the same name.
   * - non-exclusive: can be stacked
   *
   * If a non-exclusive test is added to a schema with an exclusive test of the same name
   * the exclusive test is removed and further tests of the same name will be stacked.
   *
   * If an exclusive test is added to a schema with non-exclusive tests of the same name
   * the previous tests are removed and further tests of the same name will replace each other.
   */
  test(...t) {
    let o;
    if (t.length === 1 ? typeof t[0] == "function" ? o = {
      test: t[0]
    } : o = t[0] : t.length === 2 ? o = {
      name: t[0],
      test: t[1]
    } : o = {
      name: t[0],
      message: t[1],
      test: t[2]
    }, o.message === void 0 && (o.message = mixed.default), typeof o.test != "function") throw new TypeError("`test` is a required parameters");
    let n = this.clone(), s = createValidation(o), i = o.exclusive || o.name && n.exclusiveTests[o.name] === !0;
    if (o.exclusive && !o.name)
      throw new TypeError("Exclusive tests must provide a unique `name` identifying the test");
    return o.name && (n.exclusiveTests[o.name] = !!o.exclusive), n.tests = n.tests.filter((l) => !(l.OPTIONS.name === o.name && (i || l.OPTIONS.test === s.OPTIONS.test))), n.tests.push(s), n;
  }
  when(t, o) {
    !Array.isArray(t) && typeof t != "string" && (o = t, t = ".");
    let n = this.clone(), s = toArray$1(t).map((i) => new Reference(i));
    return s.forEach((i) => {
      i.isSibling && n.deps.push(i.key);
    }), n.conditions.push(typeof o == "function" ? new Condition(s, o) : Condition.fromOptions(s, o)), n;
  }
  typeError(t) {
    let o = this.clone();
    return o.internalTests.typeError = createValidation({
      message: t,
      name: "typeError",
      skipAbsent: !0,
      test(n) {
        return this.schema._typeCheck(n) ? !0 : this.createError({
          params: {
            type: this.schema.type
          }
        });
      }
    }), o;
  }
  oneOf(t, o = mixed.oneOf) {
    let n = this.clone();
    return t.forEach((s) => {
      n._whitelist.add(s), n._blacklist.delete(s);
    }), n.internalTests.whiteList = createValidation({
      message: o,
      name: "oneOf",
      skipAbsent: !0,
      test(s) {
        let i = this.schema._whitelist, l = i.resolveAll(this.resolve);
        return l.includes(s) ? !0 : this.createError({
          params: {
            values: Array.from(i).join(", "),
            resolved: l
          }
        });
      }
    }), n;
  }
  notOneOf(t, o = mixed.notOneOf) {
    let n = this.clone();
    return t.forEach((s) => {
      n._blacklist.add(s), n._whitelist.delete(s);
    }), n.internalTests.blacklist = createValidation({
      message: o,
      name: "notOneOf",
      test(s) {
        let i = this.schema._blacklist, l = i.resolveAll(this.resolve);
        return l.includes(s) ? this.createError({
          params: {
            values: Array.from(i).join(", "),
            resolved: l
          }
        }) : !0;
      }
    }), n;
  }
  strip(t = !0) {
    let o = this.clone();
    return o.spec.strip = t, o;
  }
  /**
   * Return a serialized description of the schema including validations, flags, types etc.
   *
   * @param options Provide any needed context for resolving runtime schema alterations (lazy, when conditions, etc).
   */
  describe(t) {
    const o = (t ? this.resolve(t) : this).clone(), {
      label: n,
      meta: s,
      optional: i,
      nullable: l
    } = o.spec;
    return {
      meta: s,
      label: n,
      optional: i,
      nullable: l,
      default: o.getDefault(t),
      type: o.type,
      oneOf: o._whitelist.describe(),
      notOneOf: o._blacklist.describe(),
      tests: o.tests.filter((u, c, p) => p.findIndex((f) => f.OPTIONS.name === u.OPTIONS.name) === c).map((u) => {
        const c = u.OPTIONS.params && t ? resolveParams(Object.assign({}, u.OPTIONS.params), t) : u.OPTIONS.params;
        return {
          name: u.OPTIONS.name,
          params: c
        };
      })
    };
  }
  get "~standard"() {
    const t = this;
    return {
      version: 1,
      vendor: "yup",
      async validate(n) {
        try {
          return {
            value: await t.validate(n, {
              abortEarly: !1
            })
          };
        } catch (s) {
          if (s instanceof ValidationError)
            return {
              issues: issuesFromValidationError(s)
            };
          throw s;
        }
      }
    };
  }
}
Schema.prototype.__isYupSchema__ = !0;
for (const e of ["validate", "validateSync"]) Schema.prototype[`${e}At`] = function(t, o, n = {}) {
  const {
    parent: s,
    parentPath: i,
    schema: l
  } = getIn(this, t, o, n.context);
  return l[e](s && s[i], Object.assign({}, n, {
    parent: s,
    path: t
  }));
};
for (const e of ["equals", "is"]) Schema.prototype[e] = Schema.prototype.oneOf;
for (const e of ["not", "nope"]) Schema.prototype[e] = Schema.prototype.notOneOf;
function create$7() {
  return new BooleanSchema();
}
class BooleanSchema extends Schema {
  constructor() {
    super({
      type: "boolean",
      check(t) {
        return t instanceof Boolean && (t = t.valueOf()), typeof t == "boolean";
      }
    }), this.withMutation(() => {
      this.transform((t, o) => {
        if (this.spec.coerce && !this.isType(t)) {
          if (/^(true|1)$/i.test(String(t))) return !0;
          if (/^(false|0)$/i.test(String(t))) return !1;
        }
        return t;
      });
    });
  }
  isTrue(t = boolean.isValue) {
    return this.test({
      message: t,
      name: "is-value",
      exclusive: !0,
      params: {
        value: "true"
      },
      test(o) {
        return isAbsent(o) || o === !0;
      }
    });
  }
  isFalse(t = boolean.isValue) {
    return this.test({
      message: t,
      name: "is-value",
      exclusive: !0,
      params: {
        value: "false"
      },
      test(o) {
        return isAbsent(o) || o === !1;
      }
    });
  }
  default(t) {
    return super.default(t);
  }
  defined(t) {
    return super.defined(t);
  }
  optional() {
    return super.optional();
  }
  required(t) {
    return super.required(t);
  }
  notRequired() {
    return super.notRequired();
  }
  nullable() {
    return super.nullable();
  }
  nonNullable(t) {
    return super.nonNullable(t);
  }
  strip(t) {
    return super.strip(t);
  }
}
create$7.prototype = BooleanSchema.prototype;
const isoReg = /^(\d{4}|[+-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,.](\d{1,}))?)?(?:(Z)|([+-])(\d{2})(?::?(\d{2}))?)?)?$/;
function parseIsoDate(e) {
  const t = parseDateStruct(e);
  if (!t) return Date.parse ? Date.parse(e) : Number.NaN;
  if (t.z === void 0 && t.plusMinus === void 0)
    return new Date(t.year, t.month, t.day, t.hour, t.minute, t.second, t.millisecond).valueOf();
  let o = 0;
  return t.z !== "Z" && t.plusMinus !== void 0 && (o = t.hourOffset * 60 + t.minuteOffset, t.plusMinus === "+" && (o = 0 - o)), Date.UTC(t.year, t.month, t.day, t.hour, t.minute + o, t.second, t.millisecond);
}
function parseDateStruct(e) {
  var t, o;
  const n = isoReg.exec(e);
  return n ? {
    year: toNumber(n[1]),
    month: toNumber(n[2], 1) - 1,
    day: toNumber(n[3], 1),
    hour: toNumber(n[4]),
    minute: toNumber(n[5]),
    second: toNumber(n[6]),
    millisecond: n[7] ? (
      // allow arbitrary sub-second precision beyond milliseconds
      toNumber(n[7].substring(0, 3))
    ) : 0,
    precision: (t = (o = n[7]) == null ? void 0 : o.length) != null ? t : void 0,
    z: n[8] || void 0,
    plusMinus: n[9] || void 0,
    hourOffset: toNumber(n[10]),
    minuteOffset: toNumber(n[11])
  } : null;
}
function toNumber(e, t = 0) {
  return Number(e) || t;
}
let rEmail = (
  // eslint-disable-next-line
  /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/
), rUrl = (
  // eslint-disable-next-line
  /^((https?|ftp):)?\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i
), rUUID = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i, yearMonthDay = "^\\d{4}-\\d{2}-\\d{2}", hourMinuteSecond = "\\d{2}:\\d{2}:\\d{2}", zOrOffset = "(([+-]\\d{2}(:?\\d{2})?)|Z)", rIsoDateTime = new RegExp(`${yearMonthDay}T${hourMinuteSecond}(\\.\\d+)?${zOrOffset}$`), isTrimmed = (e) => isAbsent(e) || e === e.trim(), objStringTag = {}.toString();
function create$6() {
  return new StringSchema();
}
class StringSchema extends Schema {
  constructor() {
    super({
      type: "string",
      check(t) {
        return t instanceof String && (t = t.valueOf()), typeof t == "string";
      }
    }), this.withMutation(() => {
      this.transform((t, o) => {
        if (!this.spec.coerce || this.isType(t) || Array.isArray(t)) return t;
        const n = t != null && t.toString ? t.toString() : t;
        return n === objStringTag ? t : n;
      });
    });
  }
  required(t) {
    return super.required(t).withMutation((o) => o.test({
      message: t || mixed.required,
      name: "required",
      skipAbsent: !0,
      test: (n) => !!n.length
    }));
  }
  notRequired() {
    return super.notRequired().withMutation((t) => (t.tests = t.tests.filter((o) => o.OPTIONS.name !== "required"), t));
  }
  length(t, o = string.length) {
    return this.test({
      message: o,
      name: "length",
      exclusive: !0,
      params: {
        length: t
      },
      skipAbsent: !0,
      test(n) {
        return n.length === this.resolve(t);
      }
    });
  }
  min(t, o = string.min) {
    return this.test({
      message: o,
      name: "min",
      exclusive: !0,
      params: {
        min: t
      },
      skipAbsent: !0,
      test(n) {
        return n.length >= this.resolve(t);
      }
    });
  }
  max(t, o = string.max) {
    return this.test({
      name: "max",
      exclusive: !0,
      message: o,
      params: {
        max: t
      },
      skipAbsent: !0,
      test(n) {
        return n.length <= this.resolve(t);
      }
    });
  }
  matches(t, o) {
    let n = !1, s, i;
    return o && (typeof o == "object" ? {
      excludeEmptyString: n = !1,
      message: s,
      name: i
    } = o : s = o), this.test({
      name: i || "matches",
      message: s || string.matches,
      params: {
        regex: t
      },
      skipAbsent: !0,
      test: (l) => l === "" && n || l.search(t) !== -1
    });
  }
  email(t = string.email) {
    return this.matches(rEmail, {
      name: "email",
      message: t,
      excludeEmptyString: !0
    });
  }
  url(t = string.url) {
    return this.matches(rUrl, {
      name: "url",
      message: t,
      excludeEmptyString: !0
    });
  }
  uuid(t = string.uuid) {
    return this.matches(rUUID, {
      name: "uuid",
      message: t,
      excludeEmptyString: !1
    });
  }
  datetime(t) {
    let o = "", n, s;
    return t && (typeof t == "object" ? {
      message: o = "",
      allowOffset: n = !1,
      precision: s = void 0
    } = t : o = t), this.matches(rIsoDateTime, {
      name: "datetime",
      message: o || string.datetime,
      excludeEmptyString: !0
    }).test({
      name: "datetime_offset",
      message: o || string.datetime_offset,
      params: {
        allowOffset: n
      },
      skipAbsent: !0,
      test: (i) => {
        if (!i || n) return !0;
        const l = parseDateStruct(i);
        return l ? !!l.z : !1;
      }
    }).test({
      name: "datetime_precision",
      message: o || string.datetime_precision,
      params: {
        precision: s
      },
      skipAbsent: !0,
      test: (i) => {
        if (!i || s == null) return !0;
        const l = parseDateStruct(i);
        return l ? l.precision === s : !1;
      }
    });
  }
  //-- transforms --
  ensure() {
    return this.default("").transform((t) => t === null ? "" : t);
  }
  trim(t = string.trim) {
    return this.transform((o) => o != null ? o.trim() : o).test({
      message: t,
      name: "trim",
      test: isTrimmed
    });
  }
  lowercase(t = string.lowercase) {
    return this.transform((o) => isAbsent(o) ? o : o.toLowerCase()).test({
      message: t,
      name: "string_case",
      exclusive: !0,
      skipAbsent: !0,
      test: (o) => isAbsent(o) || o === o.toLowerCase()
    });
  }
  uppercase(t = string.uppercase) {
    return this.transform((o) => isAbsent(o) ? o : o.toUpperCase()).test({
      message: t,
      name: "string_case",
      exclusive: !0,
      skipAbsent: !0,
      test: (o) => isAbsent(o) || o === o.toUpperCase()
    });
  }
}
create$6.prototype = StringSchema.prototype;
let invalidDate = /* @__PURE__ */ new Date(""), isDate$1 = (e) => Object.prototype.toString.call(e) === "[object Date]";
class DateSchema extends Schema {
  constructor() {
    super({
      type: "date",
      check(t) {
        return isDate$1(t) && !isNaN(t.getTime());
      }
    }), this.withMutation(() => {
      this.transform((t, o) => !this.spec.coerce || this.isType(t) || t === null ? t : (t = parseIsoDate(t), isNaN(t) ? DateSchema.INVALID_DATE : new Date(t)));
    });
  }
  prepareParam(t, o) {
    let n;
    if (Reference.isRef(t))
      n = t;
    else {
      let s = this.cast(t);
      if (!this._typeCheck(s)) throw new TypeError(`\`${o}\` must be a Date or a value that can be \`cast()\` to a Date`);
      n = s;
    }
    return n;
  }
  min(t, o = date.min) {
    let n = this.prepareParam(t, "min");
    return this.test({
      message: o,
      name: "min",
      exclusive: !0,
      params: {
        min: t
      },
      skipAbsent: !0,
      test(s) {
        return s >= this.resolve(n);
      }
    });
  }
  max(t, o = date.max) {
    let n = this.prepareParam(t, "max");
    return this.test({
      message: o,
      name: "max",
      exclusive: !0,
      params: {
        max: t
      },
      skipAbsent: !0,
      test(s) {
        return s <= this.resolve(n);
      }
    });
  }
}
DateSchema.INVALID_DATE = invalidDate;
const getFormikInitialValues = (e, t) => !e || !e?.length ? {} : e.reduce((o, n) => {
  let s = {};
  const i = n?.inputId;
  return i && (s = {
    ...s,
    [i]: t?.[i] ?? !1
  }), n?.consentInputFields?.forEach(
    (l) => {
      const d = getConsentInputName(n, l);
      d && (s = {
        ...s,
        [d]: t?.[d] ?? ""
      });
    }
  ), { ...o, ...s };
}, {}), getInitialValues = (e, t) => !t || !t?.length ? {} : t.reduce((o, n) => {
  let s = {};
  const i = n?.inputId, l = e.find(
    (d) => d.consentItem?.oid === n.oid
  );
  return i && (s = {
    ...s,
    [i]: l?.consentItemState === ConsentItemStateChangeDataEnum.TURN_ON
  }), n?.consentInputFields?.forEach(
    (d) => {
      const u = getConsentInputName(n, d);
      if (u) {
        const c = l?.communicationDataValues?.find(
          (p) => p.oid === d.consentCommunicationDataTypeId
        );
        s = {
          ...s,
          [u]: c?.value ?? ""
        };
      }
    }
  ), { ...o, ...s };
}, {}), getConsentInputName = (e, t) => {
  const o = e?.name?.split(" ").join("-").replace(".", ""), n = t?.label?.split(" ").join("-").replace(".", ""), s = `${o}-${n}`;
  return t?.inputId ?? s;
}, isEmailBaseType = (e) => e === CommunicationDataBaseTypeDataEnum.EMAIL, isPhonelikeBaseType = (e) => e === CommunicationDataBaseTypeDataEnum.PHONE || e === CommunicationDataBaseTypeDataEnum.FAX, getValidationSchema = (e, t, o) => !e || !e?.length ? {} : filterNonNull(
  e?.map((s) => {
    if (t.includes(s?.inputId ?? "")) {
      const i = {
        name: s?.inputId ?? "",
        baseType: "item",
        isMandatory: !0
      }, l = s?.consentInputFields?.map(
        (d) => ({
          name: getConsentInputName(s, d),
          baseType: d?.baseType,
          isMandatory: d?.isMandatory
        })
      ) ?? [];
      return [i, ...l];
    }
  }).flat()
)?.reduce((s, i) => {
  if (!i)
    return s;
  if (isEmailBaseType(i?.baseType) && !isMobileDevice()) {
    const l = create$6().matches(
      emailRegex,
      "components.consentCollection.invalidEmail"
    );
    return {
      ...s,
      [i.name]: i?.isMandatory ? l.required(
        "components.consentCollection.invalidEmail"
      ) : l
    };
  } else if (isPhonelikeBaseType(i?.baseType)) {
    const l = libphonenumber.PhoneNumberUtil.getInstance(), d = create$6().test({
      message: "components.consentCollection.invalidPhone",
      test: (u) => {
        if (!u)
          return !0;
        try {
          const c = l.parse(
            u,
            o?.alpha2Code ?? "DE"
          );
          return l.isValidNumber(c);
        } catch {
          return !1;
        }
      }
    });
    return {
      ...s,
      [i.name]: i?.isMandatory ? d.required(
        "components.consentCollection.invalidPhone"
      ) : d
    };
  } else if (i?.baseType === "item") {
    const l = create$7().oneOf([!0]).required();
    return { ...s, [i.name]: l };
  } else
    return s;
}, {}), filterNonNull = (e) => !e || !Array.isArray(e) ? [] : e.filter((t) => !!t), getMediaTypeFromMimeType = (e) => {
  if (e === "text/html")
    return SupportedMediaTypeDataEnum.HTML;
  if (e === "application/pdf")
    return SupportedMediaTypeDataEnum.PDF;
}, convertMediaDataToMediaEvent = (e) => ({
  id: e.id ?? "",
  oid: e.oid ?? "",
  name: e.name ?? "",
  contentDocument: {
    downloadUrl: e.latestVersion?.document?.contentLink ?? "",
    id: e.latestVersion?.document?.id ?? "",
    oid: e.latestVersion?.oid ?? "",
    mediaType: e.latestVersion?.document?.mediaType ?? "",
    name: e.latestVersion?.document?.name ?? ""
  },
  thumbnailDocument: {
    downloadUrl: e.thumbnailDocument?.contentLink ?? "",
    id: e.thumbnailDocument?.id ?? "",
    mediaType: e.thumbnailDocument?.mediaType ?? "",
    name: e.thumbnailDocument?.name ?? ""
  }
}), convertMediaPayloadToMediaData = (e) => ({
  id: e.id,
  oid: e.oid,
  name: e.name,
  fileName: e?.contentDocument?.name ?? e.name,
  mediaType: getMediaTypeFromMimeType(e.contentDocument.mediaType),
  latestVersion: {
    oid: e.contentDocument.oid,
    document: {
      id: e.contentDocument.id,
      contentLink: e.contentDocument.downloadUrl,
      mediaType: e.contentDocument.mediaType,
      name: e.contentDocument.name
    }
  },
  thumbnailDocument: {
    id: e.thumbnailDocument.id,
    contentLink: e.thumbnailDocument.downloadUrl,
    name: e.thumbnailDocument.name,
    mediaType: e.thumbnailDocument.mediaType
  }
}), getOneLineAddress = (e) => (e?.addressLines?.filter(Boolean).join(", ") ?? "").concat(
  `, ${e?.postalCode} ${e?.city}`
), getPersonFullNameWithTitle = (e) => {
  let t = "";
  if (!e)
    return t;
  const { prefixAcademicTitle: o, firstName: n, lastName: s, postfixAcademicTitle: i } = e;
  return o && (t = o), n && (t = `${t} ${n}`), s && (t = `${t} ${s}`), i && (t = `${t} ${i}`), t.trim();
}, sortPromotionalMaterialGroup = (e) => {
  const t = (i, l) => (i.promotionalMaterial?.name || "").localeCompare(
    l.promotionalMaterial?.name || ""
  ), o = e.filter(
    (i) => i.promotionalMaterial?.type === PromotionalMaterialTypeDataEnum.PRODUCT && i.promotionalMaterial?.signatureRequired
  ).sort(t), n = e.filter(
    (i) => i.promotionalMaterial?.type === PromotionalMaterialTypeDataEnum.PRODUCT && !i.promotionalMaterial?.signatureRequired
  ).sort(t), s = e.filter(
    (i) => i.promotionalMaterial?.type === PromotionalMaterialTypeDataEnum.MARKETING_MATERIAL
  ).sort(t);
  return [
    ...o,
    ...n,
    ...s
  ];
}, emailRegex = /^(?:[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:\\[\x00-\x7F]|[^\r\n"\\])*")@(?:[a-zA-Z0-9\u00C0-\u024F\u1E00-\u1EFF](?:[a-zA-Z0-9\u00C0-\u024F\u1E00-\u1EFF-]{0,61}[a-zA-Z0-9\u00C0-\u024F\u1E00-\u1EFF])?\.)+[a-zA-Z]{2,}$/;
function bind(e, t) {
  return function() {
    return e.apply(t, arguments);
  };
}
const { toString } = Object.prototype, { getPrototypeOf } = Object, { iterator, toStringTag } = Symbol, kindOf = /* @__PURE__ */ ((e) => (t) => {
  const o = toString.call(t);
  return e[o] || (e[o] = o.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), kindOfTest = (e) => (e = e.toLowerCase(), (t) => kindOf(t) === e), typeOfTest = (e) => (t) => typeof t === e, { isArray } = Array, isUndefined = typeOfTest("undefined");
function isBuffer(e) {
  return e !== null && !isUndefined(e) && e.constructor !== null && !isUndefined(e.constructor) && isFunction$1(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const isArrayBuffer = kindOfTest("ArrayBuffer");
function isArrayBufferView(e) {
  let t;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && isArrayBuffer(e.buffer), t;
}
const isString = typeOfTest("string"), isFunction$1 = typeOfTest("function"), isNumber = typeOfTest("number"), isObject = (e) => e !== null && typeof e == "object", isBoolean = (e) => e === !0 || e === !1, isPlainObject = (e) => {
  if (kindOf(e) !== "object")
    return !1;
  const t = getPrototypeOf(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(toStringTag in e) && !(iterator in e);
}, isEmptyObject = (e) => {
  if (!isObject(e) || isBuffer(e))
    return !1;
  try {
    return Object.keys(e).length === 0 && Object.getPrototypeOf(e) === Object.prototype;
  } catch {
    return !1;
  }
}, isDate = kindOfTest("Date"), isFile = kindOfTest("File"), isBlob = kindOfTest("Blob"), isFileList = kindOfTest("FileList"), isStream = (e) => isObject(e) && isFunction$1(e.pipe), isFormData = (e) => {
  let t;
  return e && (typeof FormData == "function" && e instanceof FormData || isFunction$1(e.append) && ((t = kindOf(e)) === "formdata" || // detect form-data instance
  t === "object" && isFunction$1(e.toString) && e.toString() === "[object FormData]"));
}, isURLSearchParams = kindOfTest("URLSearchParams"), [isReadableStream, isRequest, isResponse, isHeaders] = ["ReadableStream", "Request", "Response", "Headers"].map(kindOfTest), trim = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function forEach(e, t, { allOwnKeys: o = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let n, s;
  if (typeof e != "object" && (e = [e]), isArray(e))
    for (n = 0, s = e.length; n < s; n++)
      t.call(null, e[n], n, e);
  else {
    if (isBuffer(e))
      return;
    const i = o ? Object.getOwnPropertyNames(e) : Object.keys(e), l = i.length;
    let d;
    for (n = 0; n < l; n++)
      d = i[n], t.call(null, e[d], d, e);
  }
}
function findKey(e, t) {
  if (isBuffer(e))
    return null;
  t = t.toLowerCase();
  const o = Object.keys(e);
  let n = o.length, s;
  for (; n-- > 0; )
    if (s = o[n], t === s.toLowerCase())
      return s;
  return null;
}
const _global = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, isContextDefined = (e) => !isUndefined(e) && e !== _global;
function merge() {
  const { caseless: e, skipUndefined: t } = isContextDefined(this) && this || {}, o = {}, n = (s, i) => {
    const l = e && findKey(o, i) || i;
    isPlainObject(o[l]) && isPlainObject(s) ? o[l] = merge(o[l], s) : isPlainObject(s) ? o[l] = merge({}, s) : isArray(s) ? o[l] = s.slice() : (!t || !isUndefined(s)) && (o[l] = s);
  };
  for (let s = 0, i = arguments.length; s < i; s++)
    arguments[s] && forEach(arguments[s], n);
  return o;
}
const extend = (e, t, o, { allOwnKeys: n } = {}) => (forEach(t, (s, i) => {
  o && isFunction$1(s) ? e[i] = bind(s, o) : e[i] = s;
}, { allOwnKeys: n }), e), stripBOM = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), inherits = (e, t, o, n) => {
  e.prototype = Object.create(t.prototype, n), e.prototype.constructor = e, Object.defineProperty(e, "super", {
    value: t.prototype
  }), o && Object.assign(e.prototype, o);
}, toFlatObject = (e, t, o, n) => {
  let s, i, l;
  const d = {};
  if (t = t || {}, e == null) return t;
  do {
    for (s = Object.getOwnPropertyNames(e), i = s.length; i-- > 0; )
      l = s[i], (!n || n(l, e, t)) && !d[l] && (t[l] = e[l], d[l] = !0);
    e = o !== !1 && getPrototypeOf(e);
  } while (e && (!o || o(e, t)) && e !== Object.prototype);
  return t;
}, endsWith = (e, t, o) => {
  e = String(e), (o === void 0 || o > e.length) && (o = e.length), o -= t.length;
  const n = e.indexOf(t, o);
  return n !== -1 && n === o;
}, toArray = (e) => {
  if (!e) return null;
  if (isArray(e)) return e;
  let t = e.length;
  if (!isNumber(t)) return null;
  const o = new Array(t);
  for (; t-- > 0; )
    o[t] = e[t];
  return o;
}, isTypedArray = /* @__PURE__ */ ((e) => (t) => e && t instanceof e)(typeof Uint8Array < "u" && getPrototypeOf(Uint8Array)), forEachEntry = (e, t) => {
  const n = (e && e[iterator]).call(e);
  let s;
  for (; (s = n.next()) && !s.done; ) {
    const i = s.value;
    t.call(e, i[0], i[1]);
  }
}, matchAll = (e, t) => {
  let o;
  const n = [];
  for (; (o = e.exec(t)) !== null; )
    n.push(o);
  return n;
}, isHTMLForm = kindOfTest("HTMLFormElement"), toCamelCase = (e) => e.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(o, n, s) {
    return n.toUpperCase() + s;
  }
), hasOwnProperty = (({ hasOwnProperty: e }) => (t, o) => e.call(t, o))(Object.prototype), isRegExp = kindOfTest("RegExp"), reduceDescriptors = (e, t) => {
  const o = Object.getOwnPropertyDescriptors(e), n = {};
  forEach(o, (s, i) => {
    let l;
    (l = t(s, i, e)) !== !1 && (n[i] = l || s);
  }), Object.defineProperties(e, n);
}, freezeMethods = (e) => {
  reduceDescriptors(e, (t, o) => {
    if (isFunction$1(e) && ["arguments", "caller", "callee"].indexOf(o) !== -1)
      return !1;
    const n = e[o];
    if (isFunction$1(n)) {
      if (t.enumerable = !1, "writable" in t) {
        t.writable = !1;
        return;
      }
      t.set || (t.set = () => {
        throw Error("Can not rewrite read-only method '" + o + "'");
      });
    }
  });
}, toObjectSet = (e, t) => {
  const o = {}, n = (s) => {
    s.forEach((i) => {
      o[i] = !0;
    });
  };
  return isArray(e) ? n(e) : n(String(e).split(t)), o;
}, noop$4 = () => {
}, toFiniteNumber = (e, t) => e != null && Number.isFinite(e = +e) ? e : t;
function isSpecCompliantForm(e) {
  return !!(e && isFunction$1(e.append) && e[toStringTag] === "FormData" && e[iterator]);
}
const toJSONObject = (e) => {
  const t = new Array(10), o = (n, s) => {
    if (isObject(n)) {
      if (t.indexOf(n) >= 0)
        return;
      if (isBuffer(n))
        return n;
      if (!("toJSON" in n)) {
        t[s] = n;
        const i = isArray(n) ? [] : {};
        return forEach(n, (l, d) => {
          const u = o(l, s + 1);
          !isUndefined(u) && (i[d] = u);
        }), t[s] = void 0, i;
      }
    }
    return n;
  };
  return o(e, 0);
}, isAsyncFn = kindOfTest("AsyncFunction"), isThenable = (e) => e && (isObject(e) || isFunction$1(e)) && isFunction$1(e.then) && isFunction$1(e.catch), _setImmediate = ((e, t) => e ? setImmediate : t ? ((o, n) => (_global.addEventListener("message", ({ source: s, data: i }) => {
  s === _global && i === o && n.length && n.shift()();
}, !1), (s) => {
  n.push(s), _global.postMessage(o, "*");
}))(`axios@${Math.random()}`, []) : (o) => setTimeout(o))(
  typeof setImmediate == "function",
  isFunction$1(_global.postMessage)
), asap = typeof queueMicrotask < "u" ? queueMicrotask.bind(_global) : typeof process < "u" && process.nextTick || _setImmediate, isIterable = (e) => e != null && isFunction$1(e[iterator]), utils$1 = {
  isArray,
  isArrayBuffer,
  isBuffer,
  isFormData,
  isArrayBufferView,
  isString,
  isNumber,
  isBoolean,
  isObject,
  isPlainObject,
  isEmptyObject,
  isReadableStream,
  isRequest,
  isResponse,
  isHeaders,
  isUndefined,
  isDate,
  isFile,
  isBlob,
  isRegExp,
  isFunction: isFunction$1,
  isStream,
  isURLSearchParams,
  isTypedArray,
  isFileList,
  forEach,
  merge,
  extend,
  trim,
  stripBOM,
  inherits,
  toFlatObject,
  kindOf,
  kindOfTest,
  endsWith,
  toArray,
  forEachEntry,
  matchAll,
  isHTMLForm,
  hasOwnProperty,
  hasOwnProp: hasOwnProperty,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors,
  freezeMethods,
  toObjectSet,
  toCamelCase,
  noop: noop$4,
  toFiniteNumber,
  findKey,
  global: _global,
  isContextDefined,
  isSpecCompliantForm,
  toJSONObject,
  isAsyncFn,
  isThenable,
  setImmediate: _setImmediate,
  asap,
  isIterable
};
function AxiosError$1(e, t, o, n, s) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", t && (this.code = t), o && (this.config = o), n && (this.request = n), s && (this.response = s, this.status = s.status ? s.status : null);
}
utils$1.inherits(AxiosError$1, Error, {
  toJSON: function e() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: utils$1.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
});
const prototype$1 = AxiosError$1.prototype, descriptors = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((e) => {
  descriptors[e] = { value: e };
});
Object.defineProperties(AxiosError$1, descriptors);
Object.defineProperty(prototype$1, "isAxiosError", { value: !0 });
AxiosError$1.from = (e, t, o, n, s, i) => {
  const l = Object.create(prototype$1);
  utils$1.toFlatObject(e, l, function(p) {
    return p !== Error.prototype;
  }, (c) => c !== "isAxiosError");
  const d = e && e.message ? e.message : "Error", u = t == null && e ? e.code : t;
  return AxiosError$1.call(l, d, u, o, n, s), e && l.cause == null && Object.defineProperty(l, "cause", { value: e, configurable: !0 }), l.name = e && e.name || "Error", i && Object.assign(l, i), l;
};
const httpAdapter = null;
function isVisitable(e) {
  return utils$1.isPlainObject(e) || utils$1.isArray(e);
}
function removeBrackets(e) {
  return utils$1.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function renderKey(e, t, o) {
  return e ? e.concat(t).map(function(s, i) {
    return s = removeBrackets(s), !o && i ? "[" + s + "]" : s;
  }).join(o ? "." : "") : t;
}
function isFlatArray(e) {
  return utils$1.isArray(e) && !e.some(isVisitable);
}
const predicates = utils$1.toFlatObject(utils$1, {}, null, function e(t) {
  return /^is[A-Z]/.test(t);
});
function toFormData$1(e, t, o) {
  if (!utils$1.isObject(e))
    throw new TypeError("target must be an object");
  t = t || new FormData(), o = utils$1.toFlatObject(o, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(T, P) {
    return !utils$1.isUndefined(P[T]);
  });
  const n = o.metaTokens, s = o.visitor || p, i = o.dots, l = o.indexes, u = (o.Blob || typeof Blob < "u" && Blob) && utils$1.isSpecCompliantForm(t);
  if (!utils$1.isFunction(s))
    throw new TypeError("visitor must be a function");
  function c(h) {
    if (h === null) return "";
    if (utils$1.isDate(h))
      return h.toISOString();
    if (utils$1.isBoolean(h))
      return h.toString();
    if (!u && utils$1.isBlob(h))
      throw new AxiosError$1("Blob is not supported. Use a Buffer instead.");
    return utils$1.isArrayBuffer(h) || utils$1.isTypedArray(h) ? u && typeof Blob == "function" ? new Blob([h]) : Buffer.from(h) : h;
  }
  function p(h, T, P) {
    let E = h;
    if (h && !P && typeof h == "object") {
      if (utils$1.endsWith(T, "{}"))
        T = n ? T : T.slice(0, -2), h = JSON.stringify(h);
      else if (utils$1.isArray(h) && isFlatArray(h) || (utils$1.isFileList(h) || utils$1.endsWith(T, "[]")) && (E = utils$1.toArray(h)))
        return T = removeBrackets(T), E.forEach(function(R, C) {
          !(utils$1.isUndefined(R) || R === null) && t.append(
            // eslint-disable-next-line no-nested-ternary
            l === !0 ? renderKey([T], C, i) : l === null ? T : T + "[]",
            c(R)
          );
        }), !1;
    }
    return isVisitable(h) ? !0 : (t.append(renderKey(P, T, i), c(h)), !1);
  }
  const f = [], g = Object.assign(predicates, {
    defaultVisitor: p,
    convertValue: c,
    isVisitable
  });
  function y(h, T) {
    if (!utils$1.isUndefined(h)) {
      if (f.indexOf(h) !== -1)
        throw Error("Circular reference detected in " + T.join("."));
      f.push(h), utils$1.forEach(h, function(E, $) {
        (!(utils$1.isUndefined(E) || E === null) && s.call(
          t,
          E,
          utils$1.isString($) ? $.trim() : $,
          T,
          g
        )) === !0 && y(E, T ? T.concat($) : [$]);
      }), f.pop();
    }
  }
  if (!utils$1.isObject(e))
    throw new TypeError("data must be an object");
  return y(e), t;
}
function encode$1(e) {
  const t = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(n) {
    return t[n];
  });
}
function AxiosURLSearchParams(e, t) {
  this._pairs = [], e && toFormData$1(e, this, t);
}
const prototype = AxiosURLSearchParams.prototype;
prototype.append = function e(t, o) {
  this._pairs.push([t, o]);
};
prototype.toString = function e(t) {
  const o = t ? function(n) {
    return t.call(this, n, encode$1);
  } : encode$1;
  return this._pairs.map(function(s) {
    return o(s[0]) + "=" + o(s[1]);
  }, "").join("&");
};
function encode(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+");
}
function buildURL(e, t, o) {
  if (!t)
    return e;
  const n = o && o.encode || encode;
  utils$1.isFunction(o) && (o = {
    serialize: o
  });
  const s = o && o.serialize;
  let i;
  if (s ? i = s(t, o) : i = utils$1.isURLSearchParams(t) ? t.toString() : new AxiosURLSearchParams(t, o).toString(n), i) {
    const l = e.indexOf("#");
    l !== -1 && (e = e.slice(0, l)), e += (e.indexOf("?") === -1 ? "?" : "&") + i;
  }
  return e;
}
class InterceptorManager {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(t, o, n) {
    return this.handlers.push({
      fulfilled: t,
      rejected: o,
      synchronous: n ? n.synchronous : !1,
      runWhen: n ? n.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {void}
   */
  eject(t) {
    this.handlers[t] && (this.handlers[t] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(t) {
    utils$1.forEach(this.handlers, function(n) {
      n !== null && t(n);
    });
  }
}
const transitionalDefaults = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, URLSearchParams$1 = typeof URLSearchParams < "u" ? URLSearchParams : AxiosURLSearchParams, FormData$1 = typeof FormData < "u" ? FormData : null, Blob$1 = typeof Blob < "u" ? Blob : null, platform$1 = {
  isBrowser: !0,
  classes: {
    URLSearchParams: URLSearchParams$1,
    FormData: FormData$1,
    Blob: Blob$1
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, hasBrowserEnv = typeof window < "u" && typeof document < "u", _navigator = typeof navigator == "object" && navigator || void 0, hasStandardBrowserEnv = hasBrowserEnv && (!_navigator || ["ReactNative", "NativeScript", "NS"].indexOf(_navigator.product) < 0), hasStandardBrowserWebWorkerEnv = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", origin = hasBrowserEnv && window.location.href || "http://localhost", utils = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv,
  hasStandardBrowserEnv,
  hasStandardBrowserWebWorkerEnv,
  navigator: _navigator,
  origin
}, Symbol.toStringTag, { value: "Module" })), platform = {
  ...utils,
  ...platform$1
};
function toURLEncodedForm(e, t) {
  return toFormData$1(e, new platform.classes.URLSearchParams(), {
    visitor: function(o, n, s, i) {
      return platform.isNode && utils$1.isBuffer(o) ? (this.append(n, o.toString("base64")), !1) : i.defaultVisitor.apply(this, arguments);
    },
    ...t
  });
}
function parsePropPath(e) {
  return utils$1.matchAll(/\w+|\[(\w*)]/g, e).map((t) => t[0] === "[]" ? "" : t[1] || t[0]);
}
function arrayToObject(e) {
  const t = {}, o = Object.keys(e);
  let n;
  const s = o.length;
  let i;
  for (n = 0; n < s; n++)
    i = o[n], t[i] = e[i];
  return t;
}
function formDataToJSON(e) {
  function t(o, n, s, i) {
    let l = o[i++];
    if (l === "__proto__") return !0;
    const d = Number.isFinite(+l), u = i >= o.length;
    return l = !l && utils$1.isArray(s) ? s.length : l, u ? (utils$1.hasOwnProp(s, l) ? s[l] = [s[l], n] : s[l] = n, !d) : ((!s[l] || !utils$1.isObject(s[l])) && (s[l] = []), t(o, n, s[l], i) && utils$1.isArray(s[l]) && (s[l] = arrayToObject(s[l])), !d);
  }
  if (utils$1.isFormData(e) && utils$1.isFunction(e.entries)) {
    const o = {};
    return utils$1.forEachEntry(e, (n, s) => {
      t(parsePropPath(n), s, o, 0);
    }), o;
  }
  return null;
}
function stringifySafely(e, t, o) {
  if (utils$1.isString(e))
    try {
      return (t || JSON.parse)(e), utils$1.trim(e);
    } catch (n) {
      if (n.name !== "SyntaxError")
        throw n;
    }
  return (o || JSON.stringify)(e);
}
const defaults = {
  transitional: transitionalDefaults,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function e(t, o) {
    const n = o.getContentType() || "", s = n.indexOf("application/json") > -1, i = utils$1.isObject(t);
    if (i && utils$1.isHTMLForm(t) && (t = new FormData(t)), utils$1.isFormData(t))
      return s ? JSON.stringify(formDataToJSON(t)) : t;
    if (utils$1.isArrayBuffer(t) || utils$1.isBuffer(t) || utils$1.isStream(t) || utils$1.isFile(t) || utils$1.isBlob(t) || utils$1.isReadableStream(t))
      return t;
    if (utils$1.isArrayBufferView(t))
      return t.buffer;
    if (utils$1.isURLSearchParams(t))
      return o.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), t.toString();
    let d;
    if (i) {
      if (n.indexOf("application/x-www-form-urlencoded") > -1)
        return toURLEncodedForm(t, this.formSerializer).toString();
      if ((d = utils$1.isFileList(t)) || n.indexOf("multipart/form-data") > -1) {
        const u = this.env && this.env.FormData;
        return toFormData$1(
          d ? { "files[]": t } : t,
          u && new u(),
          this.formSerializer
        );
      }
    }
    return i || s ? (o.setContentType("application/json", !1), stringifySafely(t)) : t;
  }],
  transformResponse: [function e(t) {
    const o = this.transitional || defaults.transitional, n = o && o.forcedJSONParsing, s = this.responseType === "json";
    if (utils$1.isResponse(t) || utils$1.isReadableStream(t))
      return t;
    if (t && utils$1.isString(t) && (n && !this.responseType || s)) {
      const l = !(o && o.silentJSONParsing) && s;
      try {
        return JSON.parse(t, this.parseReviver);
      } catch (d) {
        if (l)
          throw d.name === "SyntaxError" ? AxiosError$1.from(d, AxiosError$1.ERR_BAD_RESPONSE, this, null, this.response) : d;
      }
    }
    return t;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: platform.classes.FormData,
    Blob: platform.classes.Blob
  },
  validateStatus: function e(t) {
    return t >= 200 && t < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
utils$1.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  defaults.headers[e] = {};
});
const ignoreDuplicateOf = utils$1.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), parseHeaders = (e) => {
  const t = {};
  let o, n, s;
  return e && e.split(`
`).forEach(function(l) {
    s = l.indexOf(":"), o = l.substring(0, s).trim().toLowerCase(), n = l.substring(s + 1).trim(), !(!o || t[o] && ignoreDuplicateOf[o]) && (o === "set-cookie" ? t[o] ? t[o].push(n) : t[o] = [n] : t[o] = t[o] ? t[o] + ", " + n : n);
  }), t;
}, $internals = Symbol("internals");
function normalizeHeader(e) {
  return e && String(e).trim().toLowerCase();
}
function normalizeValue(e) {
  return e === !1 || e == null ? e : utils$1.isArray(e) ? e.map(normalizeValue) : String(e);
}
function parseTokens(e) {
  const t = /* @__PURE__ */ Object.create(null), o = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let n;
  for (; n = o.exec(e); )
    t[n[1]] = n[2];
  return t;
}
const isValidHeaderName = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function matchHeaderValue(e, t, o, n, s) {
  if (utils$1.isFunction(n))
    return n.call(this, t, o);
  if (s && (t = o), !!utils$1.isString(t)) {
    if (utils$1.isString(n))
      return t.indexOf(n) !== -1;
    if (utils$1.isRegExp(n))
      return n.test(t);
  }
}
function formatHeader(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (t, o, n) => o.toUpperCase() + n);
}
function buildAccessors(e, t) {
  const o = utils$1.toCamelCase(" " + t);
  ["get", "set", "has"].forEach((n) => {
    Object.defineProperty(e, n + o, {
      value: function(s, i, l) {
        return this[n].call(this, t, s, i, l);
      },
      configurable: !0
    });
  });
}
let AxiosHeaders$1 = class {
  constructor(t) {
    t && this.set(t);
  }
  set(t, o, n) {
    const s = this;
    function i(d, u, c) {
      const p = normalizeHeader(u);
      if (!p)
        throw new Error("header name must be a non-empty string");
      const f = utils$1.findKey(s, p);
      (!f || s[f] === void 0 || c === !0 || c === void 0 && s[f] !== !1) && (s[f || u] = normalizeValue(d));
    }
    const l = (d, u) => utils$1.forEach(d, (c, p) => i(c, p, u));
    if (utils$1.isPlainObject(t) || t instanceof this.constructor)
      l(t, o);
    else if (utils$1.isString(t) && (t = t.trim()) && !isValidHeaderName(t))
      l(parseHeaders(t), o);
    else if (utils$1.isObject(t) && utils$1.isIterable(t)) {
      let d = {}, u, c;
      for (const p of t) {
        if (!utils$1.isArray(p))
          throw TypeError("Object iterator must return a key-value pair");
        d[c = p[0]] = (u = d[c]) ? utils$1.isArray(u) ? [...u, p[1]] : [u, p[1]] : p[1];
      }
      l(d, o);
    } else
      t != null && i(o, t, n);
    return this;
  }
  get(t, o) {
    if (t = normalizeHeader(t), t) {
      const n = utils$1.findKey(this, t);
      if (n) {
        const s = this[n];
        if (!o)
          return s;
        if (o === !0)
          return parseTokens(s);
        if (utils$1.isFunction(o))
          return o.call(this, s, n);
        if (utils$1.isRegExp(o))
          return o.exec(s);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(t, o) {
    if (t = normalizeHeader(t), t) {
      const n = utils$1.findKey(this, t);
      return !!(n && this[n] !== void 0 && (!o || matchHeaderValue(this, this[n], n, o)));
    }
    return !1;
  }
  delete(t, o) {
    const n = this;
    let s = !1;
    function i(l) {
      if (l = normalizeHeader(l), l) {
        const d = utils$1.findKey(n, l);
        d && (!o || matchHeaderValue(n, n[d], d, o)) && (delete n[d], s = !0);
      }
    }
    return utils$1.isArray(t) ? t.forEach(i) : i(t), s;
  }
  clear(t) {
    const o = Object.keys(this);
    let n = o.length, s = !1;
    for (; n--; ) {
      const i = o[n];
      (!t || matchHeaderValue(this, this[i], i, t, !0)) && (delete this[i], s = !0);
    }
    return s;
  }
  normalize(t) {
    const o = this, n = {};
    return utils$1.forEach(this, (s, i) => {
      const l = utils$1.findKey(n, i);
      if (l) {
        o[l] = normalizeValue(s), delete o[i];
        return;
      }
      const d = t ? formatHeader(i) : String(i).trim();
      d !== i && delete o[i], o[d] = normalizeValue(s), n[d] = !0;
    }), this;
  }
  concat(...t) {
    return this.constructor.concat(this, ...t);
  }
  toJSON(t) {
    const o = /* @__PURE__ */ Object.create(null);
    return utils$1.forEach(this, (n, s) => {
      n != null && n !== !1 && (o[s] = t && utils$1.isArray(n) ? n.join(", ") : n);
    }), o;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([t, o]) => t + ": " + o).join(`
`);
  }
  getSetCookie() {
    return this.get("set-cookie") || [];
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(t) {
    return t instanceof this ? t : new this(t);
  }
  static concat(t, ...o) {
    const n = new this(t);
    return o.forEach((s) => n.set(s)), n;
  }
  static accessor(t) {
    const n = (this[$internals] = this[$internals] = {
      accessors: {}
    }).accessors, s = this.prototype;
    function i(l) {
      const d = normalizeHeader(l);
      n[d] || (buildAccessors(s, l), n[d] = !0);
    }
    return utils$1.isArray(t) ? t.forEach(i) : i(t), this;
  }
};
AxiosHeaders$1.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
utils$1.reduceDescriptors(AxiosHeaders$1.prototype, ({ value: e }, t) => {
  let o = t[0].toUpperCase() + t.slice(1);
  return {
    get: () => e,
    set(n) {
      this[o] = n;
    }
  };
});
utils$1.freezeMethods(AxiosHeaders$1);
function transformData(e, t) {
  const o = this || defaults, n = t || o, s = AxiosHeaders$1.from(n.headers);
  let i = n.data;
  return utils$1.forEach(e, function(d) {
    i = d.call(o, i, s.normalize(), t ? t.status : void 0);
  }), s.normalize(), i;
}
function isCancel$1(e) {
  return !!(e && e.__CANCEL__);
}
function CanceledError$1(e, t, o) {
  AxiosError$1.call(this, e ?? "canceled", AxiosError$1.ERR_CANCELED, t, o), this.name = "CanceledError";
}
utils$1.inherits(CanceledError$1, AxiosError$1, {
  __CANCEL__: !0
});
function settle(e, t, o) {
  const n = o.config.validateStatus;
  !o.status || !n || n(o.status) ? e(o) : t(new AxiosError$1(
    "Request failed with status code " + o.status,
    [AxiosError$1.ERR_BAD_REQUEST, AxiosError$1.ERR_BAD_RESPONSE][Math.floor(o.status / 100) - 4],
    o.config,
    o.request,
    o
  ));
}
function parseProtocol(e) {
  const t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return t && t[1] || "";
}
function speedometer(e, t) {
  e = e || 10;
  const o = new Array(e), n = new Array(e);
  let s = 0, i = 0, l;
  return t = t !== void 0 ? t : 1e3, function(u) {
    const c = Date.now(), p = n[i];
    l || (l = c), o[s] = u, n[s] = c;
    let f = i, g = 0;
    for (; f !== s; )
      g += o[f++], f = f % e;
    if (s = (s + 1) % e, s === i && (i = (i + 1) % e), c - l < t)
      return;
    const y = p && c - p;
    return y ? Math.round(g * 1e3 / y) : void 0;
  };
}
function throttle$1(e, t) {
  let o = 0, n = 1e3 / t, s, i;
  const l = (c, p = Date.now()) => {
    o = p, s = null, i && (clearTimeout(i), i = null), e(...c);
  };
  return [(...c) => {
    const p = Date.now(), f = p - o;
    f >= n ? l(c, p) : (s = c, i || (i = setTimeout(() => {
      i = null, l(s);
    }, n - f)));
  }, () => s && l(s)];
}
const progressEventReducer = (e, t, o = 3) => {
  let n = 0;
  const s = speedometer(50, 250);
  return throttle$1((i) => {
    const l = i.loaded, d = i.lengthComputable ? i.total : void 0, u = l - n, c = s(u), p = l <= d;
    n = l;
    const f = {
      loaded: l,
      total: d,
      progress: d ? l / d : void 0,
      bytes: u,
      rate: c || void 0,
      estimated: c && d && p ? (d - l) / c : void 0,
      event: i,
      lengthComputable: d != null,
      [t ? "download" : "upload"]: !0
    };
    e(f);
  }, o);
}, progressEventDecorator = (e, t) => {
  const o = e != null;
  return [(n) => t[0]({
    lengthComputable: o,
    total: e,
    loaded: n
  }), t[1]];
}, asyncDecorator = (e) => (...t) => utils$1.asap(() => e(...t)), isURLSameOrigin = platform.hasStandardBrowserEnv ? /* @__PURE__ */ ((e, t) => (o) => (o = new URL(o, platform.origin), e.protocol === o.protocol && e.host === o.host && (t || e.port === o.port)))(
  new URL(platform.origin),
  platform.navigator && /(msie|trident)/i.test(platform.navigator.userAgent)
) : () => !0, cookies = platform.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, t, o, n, s, i, l) {
      if (typeof document > "u") return;
      const d = [`${e}=${encodeURIComponent(t)}`];
      utils$1.isNumber(o) && d.push(`expires=${new Date(o).toUTCString()}`), utils$1.isString(n) && d.push(`path=${n}`), utils$1.isString(s) && d.push(`domain=${s}`), i === !0 && d.push("secure"), utils$1.isString(l) && d.push(`SameSite=${l}`), document.cookie = d.join("; ");
    },
    read(e) {
      if (typeof document > "u") return null;
      const t = document.cookie.match(new RegExp("(?:^|; )" + e + "=([^;]*)"));
      return t ? decodeURIComponent(t[1]) : null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5, "/");
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function isAbsoluteURL(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function combineURLs(e, t) {
  return t ? e.replace(/\/?\/$/, "") + "/" + t.replace(/^\/+/, "") : e;
}
function buildFullPath(e, t, o) {
  let n = !isAbsoluteURL(t);
  return e && (n || o == !1) ? combineURLs(e, t) : t;
}
const headersToObject = (e) => e instanceof AxiosHeaders$1 ? { ...e } : e;
function mergeConfig$1(e, t) {
  t = t || {};
  const o = {};
  function n(c, p, f, g) {
    return utils$1.isPlainObject(c) && utils$1.isPlainObject(p) ? utils$1.merge.call({ caseless: g }, c, p) : utils$1.isPlainObject(p) ? utils$1.merge({}, p) : utils$1.isArray(p) ? p.slice() : p;
  }
  function s(c, p, f, g) {
    if (utils$1.isUndefined(p)) {
      if (!utils$1.isUndefined(c))
        return n(void 0, c, f, g);
    } else return n(c, p, f, g);
  }
  function i(c, p) {
    if (!utils$1.isUndefined(p))
      return n(void 0, p);
  }
  function l(c, p) {
    if (utils$1.isUndefined(p)) {
      if (!utils$1.isUndefined(c))
        return n(void 0, c);
    } else return n(void 0, p);
  }
  function d(c, p, f) {
    if (f in t)
      return n(c, p);
    if (f in e)
      return n(void 0, c);
  }
  const u = {
    url: i,
    method: i,
    data: i,
    baseURL: l,
    transformRequest: l,
    transformResponse: l,
    paramsSerializer: l,
    timeout: l,
    timeoutMessage: l,
    withCredentials: l,
    withXSRFToken: l,
    adapter: l,
    responseType: l,
    xsrfCookieName: l,
    xsrfHeaderName: l,
    onUploadProgress: l,
    onDownloadProgress: l,
    decompress: l,
    maxContentLength: l,
    maxBodyLength: l,
    beforeRedirect: l,
    transport: l,
    httpAgent: l,
    httpsAgent: l,
    cancelToken: l,
    socketPath: l,
    responseEncoding: l,
    validateStatus: d,
    headers: (c, p, f) => s(headersToObject(c), headersToObject(p), f, !0)
  };
  return utils$1.forEach(Object.keys({ ...e, ...t }), function(p) {
    const f = u[p] || s, g = f(e[p], t[p], p);
    utils$1.isUndefined(g) && f !== d || (o[p] = g);
  }), o;
}
const resolveConfig = (e) => {
  const t = mergeConfig$1({}, e);
  let { data: o, withXSRFToken: n, xsrfHeaderName: s, xsrfCookieName: i, headers: l, auth: d } = t;
  if (t.headers = l = AxiosHeaders$1.from(l), t.url = buildURL(buildFullPath(t.baseURL, t.url, t.allowAbsoluteUrls), e.params, e.paramsSerializer), d && l.set(
    "Authorization",
    "Basic " + btoa((d.username || "") + ":" + (d.password ? unescape(encodeURIComponent(d.password)) : ""))
  ), utils$1.isFormData(o)) {
    if (platform.hasStandardBrowserEnv || platform.hasStandardBrowserWebWorkerEnv)
      l.setContentType(void 0);
    else if (utils$1.isFunction(o.getHeaders)) {
      const u = o.getHeaders(), c = ["content-type", "content-length"];
      Object.entries(u).forEach(([p, f]) => {
        c.includes(p.toLowerCase()) && l.set(p, f);
      });
    }
  }
  if (platform.hasStandardBrowserEnv && (n && utils$1.isFunction(n) && (n = n(t)), n || n !== !1 && isURLSameOrigin(t.url))) {
    const u = s && i && cookies.read(i);
    u && l.set(s, u);
  }
  return t;
}, isXHRAdapterSupported = typeof XMLHttpRequest < "u", xhrAdapter = isXHRAdapterSupported && function(e) {
  return new Promise(function(o, n) {
    const s = resolveConfig(e);
    let i = s.data;
    const l = AxiosHeaders$1.from(s.headers).normalize();
    let { responseType: d, onUploadProgress: u, onDownloadProgress: c } = s, p, f, g, y, h;
    function T() {
      y && y(), h && h(), s.cancelToken && s.cancelToken.unsubscribe(p), s.signal && s.signal.removeEventListener("abort", p);
    }
    let P = new XMLHttpRequest();
    P.open(s.method.toUpperCase(), s.url, !0), P.timeout = s.timeout;
    function E() {
      if (!P)
        return;
      const R = AxiosHeaders$1.from(
        "getAllResponseHeaders" in P && P.getAllResponseHeaders()
      ), x = {
        data: !d || d === "text" || d === "json" ? P.responseText : P.response,
        status: P.status,
        statusText: P.statusText,
        headers: R,
        config: e,
        request: P
      };
      settle(function(D) {
        o(D), T();
      }, function(D) {
        n(D), T();
      }, x), P = null;
    }
    "onloadend" in P ? P.onloadend = E : P.onreadystatechange = function() {
      !P || P.readyState !== 4 || P.status === 0 && !(P.responseURL && P.responseURL.indexOf("file:") === 0) || setTimeout(E);
    }, P.onabort = function() {
      P && (n(new AxiosError$1("Request aborted", AxiosError$1.ECONNABORTED, e, P)), P = null);
    }, P.onerror = function(C) {
      const x = C && C.message ? C.message : "Network Error", _ = new AxiosError$1(x, AxiosError$1.ERR_NETWORK, e, P);
      _.event = C || null, n(_), P = null;
    }, P.ontimeout = function() {
      let C = s.timeout ? "timeout of " + s.timeout + "ms exceeded" : "timeout exceeded";
      const x = s.transitional || transitionalDefaults;
      s.timeoutErrorMessage && (C = s.timeoutErrorMessage), n(new AxiosError$1(
        C,
        x.clarifyTimeoutError ? AxiosError$1.ETIMEDOUT : AxiosError$1.ECONNABORTED,
        e,
        P
      )), P = null;
    }, i === void 0 && l.setContentType(null), "setRequestHeader" in P && utils$1.forEach(l.toJSON(), function(C, x) {
      P.setRequestHeader(x, C);
    }), utils$1.isUndefined(s.withCredentials) || (P.withCredentials = !!s.withCredentials), d && d !== "json" && (P.responseType = s.responseType), c && ([g, h] = progressEventReducer(c, !0), P.addEventListener("progress", g)), u && P.upload && ([f, y] = progressEventReducer(u), P.upload.addEventListener("progress", f), P.upload.addEventListener("loadend", y)), (s.cancelToken || s.signal) && (p = (R) => {
      P && (n(!R || R.type ? new CanceledError$1(null, e, P) : R), P.abort(), P = null);
    }, s.cancelToken && s.cancelToken.subscribe(p), s.signal && (s.signal.aborted ? p() : s.signal.addEventListener("abort", p)));
    const $ = parseProtocol(s.url);
    if ($ && platform.protocols.indexOf($) === -1) {
      n(new AxiosError$1("Unsupported protocol " + $ + ":", AxiosError$1.ERR_BAD_REQUEST, e));
      return;
    }
    P.send(i || null);
  });
}, composeSignals = (e, t) => {
  const { length: o } = e = e ? e.filter(Boolean) : [];
  if (t || o) {
    let n = new AbortController(), s;
    const i = function(c) {
      if (!s) {
        s = !0, d();
        const p = c instanceof Error ? c : this.reason;
        n.abort(p instanceof AxiosError$1 ? p : new CanceledError$1(p instanceof Error ? p.message : p));
      }
    };
    let l = t && setTimeout(() => {
      l = null, i(new AxiosError$1(`timeout ${t} of ms exceeded`, AxiosError$1.ETIMEDOUT));
    }, t);
    const d = () => {
      e && (l && clearTimeout(l), l = null, e.forEach((c) => {
        c.unsubscribe ? c.unsubscribe(i) : c.removeEventListener("abort", i);
      }), e = null);
    };
    e.forEach((c) => c.addEventListener("abort", i));
    const { signal: u } = n;
    return u.unsubscribe = () => utils$1.asap(d), u;
  }
}, streamChunk = function* (e, t) {
  let o = e.byteLength;
  if (o < t) {
    yield e;
    return;
  }
  let n = 0, s;
  for (; n < o; )
    s = n + t, yield e.slice(n, s), n = s;
}, readBytes = async function* (e, t) {
  for await (const o of readStream(e))
    yield* streamChunk(o, t);
}, readStream = async function* (e) {
  if (e[Symbol.asyncIterator]) {
    yield* e;
    return;
  }
  const t = e.getReader();
  try {
    for (; ; ) {
      const { done: o, value: n } = await t.read();
      if (o)
        break;
      yield n;
    }
  } finally {
    await t.cancel();
  }
}, trackStream = (e, t, o, n) => {
  const s = readBytes(e, t);
  let i = 0, l, d = (u) => {
    l || (l = !0, n && n(u));
  };
  return new ReadableStream({
    async pull(u) {
      try {
        const { done: c, value: p } = await s.next();
        if (c) {
          d(), u.close();
          return;
        }
        let f = p.byteLength;
        if (o) {
          let g = i += f;
          o(g);
        }
        u.enqueue(new Uint8Array(p));
      } catch (c) {
        throw d(c), c;
      }
    },
    cancel(u) {
      return d(u), s.return();
    }
  }, {
    highWaterMark: 2
  });
}, DEFAULT_CHUNK_SIZE = 64 * 1024, { isFunction } = utils$1, globalFetchAPI = (({ Request: e, Response: t }) => ({
  Request: e,
  Response: t
}))(utils$1.global), {
  ReadableStream: ReadableStream$1,
  TextEncoder
} = utils$1.global, test = (e, ...t) => {
  try {
    return !!e(...t);
  } catch {
    return !1;
  }
}, factory = (e) => {
  e = utils$1.merge.call({
    skipUndefined: !0
  }, globalFetchAPI, e);
  const { fetch: t, Request: o, Response: n } = e, s = t ? isFunction(t) : typeof fetch == "function", i = isFunction(o), l = isFunction(n);
  if (!s)
    return !1;
  const d = s && isFunction(ReadableStream$1), u = s && (typeof TextEncoder == "function" ? /* @__PURE__ */ ((h) => (T) => h.encode(T))(new TextEncoder()) : async (h) => new Uint8Array(await new o(h).arrayBuffer())), c = i && d && test(() => {
    let h = !1;
    const T = new o(platform.origin, {
      body: new ReadableStream$1(),
      method: "POST",
      get duplex() {
        return h = !0, "half";
      }
    }).headers.has("Content-Type");
    return h && !T;
  }), p = l && d && test(() => utils$1.isReadableStream(new n("").body)), f = {
    stream: p && ((h) => h.body)
  };
  s && ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((h) => {
    !f[h] && (f[h] = (T, P) => {
      let E = T && T[h];
      if (E)
        return E.call(T);
      throw new AxiosError$1(`Response type '${h}' is not supported`, AxiosError$1.ERR_NOT_SUPPORT, P);
    });
  });
  const g = async (h) => {
    if (h == null)
      return 0;
    if (utils$1.isBlob(h))
      return h.size;
    if (utils$1.isSpecCompliantForm(h))
      return (await new o(platform.origin, {
        method: "POST",
        body: h
      }).arrayBuffer()).byteLength;
    if (utils$1.isArrayBufferView(h) || utils$1.isArrayBuffer(h))
      return h.byteLength;
    if (utils$1.isURLSearchParams(h) && (h = h + ""), utils$1.isString(h))
      return (await u(h)).byteLength;
  }, y = async (h, T) => {
    const P = utils$1.toFiniteNumber(h.getContentLength());
    return P ?? g(T);
  };
  return async (h) => {
    let {
      url: T,
      method: P,
      data: E,
      signal: $,
      cancelToken: R,
      timeout: C,
      onDownloadProgress: x,
      onUploadProgress: _,
      responseType: D,
      headers: O,
      withCredentials: v = "same-origin",
      fetchOptions: w
    } = resolveConfig(h), M = t || fetch;
    D = D ? (D + "").toLowerCase() : "text";
    let S = composeSignals([$, R && R.toAbortSignal()], C), I = null;
    const N = S && S.unsubscribe && (() => {
      S.unsubscribe();
    });
    let F;
    try {
      if (_ && c && P !== "get" && P !== "head" && (F = await y(O, E)) !== 0) {
        let A = new o(T, {
          method: "POST",
          body: E,
          duplex: "half"
        }), U;
        if (utils$1.isFormData(E) && (U = A.headers.get("content-type")) && O.setContentType(U), A.body) {
          const [G, Y] = progressEventDecorator(
            F,
            progressEventReducer(asyncDecorator(_))
          );
          E = trackStream(A.body, DEFAULT_CHUNK_SIZE, G, Y);
        }
      }
      utils$1.isString(v) || (v = v ? "include" : "omit");
      const L = i && "credentials" in o.prototype, k = {
        ...w,
        signal: S,
        method: P.toUpperCase(),
        headers: O.normalize().toJSON(),
        body: E,
        duplex: "half",
        credentials: L ? v : void 0
      };
      I = i && new o(T, k);
      let W = await (i ? M(I, w) : M(T, k));
      const V = p && (D === "stream" || D === "response");
      if (p && (x || V && N)) {
        const A = {};
        ["status", "statusText", "headers"].forEach((ee) => {
          A[ee] = W[ee];
        });
        const U = utils$1.toFiniteNumber(W.headers.get("content-length")), [G, Y] = x && progressEventDecorator(
          U,
          progressEventReducer(asyncDecorator(x), !0)
        ) || [];
        W = new n(
          trackStream(W.body, DEFAULT_CHUNK_SIZE, G, () => {
            Y && Y(), N && N();
          }),
          A
        );
      }
      D = D || "text";
      let j = await f[utils$1.findKey(f, D) || "text"](W, h);
      return !V && N && N(), await new Promise((A, U) => {
        settle(A, U, {
          data: j,
          headers: AxiosHeaders$1.from(W.headers),
          status: W.status,
          statusText: W.statusText,
          config: h,
          request: I
        });
      });
    } catch (L) {
      throw N && N(), L && L.name === "TypeError" && /Load failed|fetch/i.test(L.message) ? Object.assign(
        new AxiosError$1("Network Error", AxiosError$1.ERR_NETWORK, h, I),
        {
          cause: L.cause || L
        }
      ) : AxiosError$1.from(L, L && L.code, h, I);
    }
  };
}, seedCache = /* @__PURE__ */ new Map(), getFetch = (e) => {
  let t = e && e.env || {};
  const { fetch: o, Request: n, Response: s } = t, i = [
    n,
    s,
    o
  ];
  let l = i.length, d = l, u, c, p = seedCache;
  for (; d--; )
    u = i[d], c = p.get(u), c === void 0 && p.set(u, c = d ? /* @__PURE__ */ new Map() : factory(t)), p = c;
  return c;
};
getFetch();
const knownAdapters = {
  http: httpAdapter,
  xhr: xhrAdapter,
  fetch: {
    get: getFetch
  }
};
utils$1.forEach(knownAdapters, (e, t) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: t });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: t });
  }
});
const renderReason = (e) => `- ${e}`, isResolvedHandle = (e) => utils$1.isFunction(e) || e === null || e === !1;
function getAdapter$1(e, t) {
  e = utils$1.isArray(e) ? e : [e];
  const { length: o } = e;
  let n, s;
  const i = {};
  for (let l = 0; l < o; l++) {
    n = e[l];
    let d;
    if (s = n, !isResolvedHandle(n) && (s = knownAdapters[(d = String(n)).toLowerCase()], s === void 0))
      throw new AxiosError$1(`Unknown adapter '${d}'`);
    if (s && (utils$1.isFunction(s) || (s = s.get(t))))
      break;
    i[d || "#" + l] = s;
  }
  if (!s) {
    const l = Object.entries(i).map(
      ([u, c]) => `adapter ${u} ` + (c === !1 ? "is not supported by the environment" : "is not available in the build")
    );
    let d = o ? l.length > 1 ? `since :
` + l.map(renderReason).join(`
`) : " " + renderReason(l[0]) : "as no adapter specified";
    throw new AxiosError$1(
      "There is no suitable adapter to dispatch the request " + d,
      "ERR_NOT_SUPPORT"
    );
  }
  return s;
}
const adapters = {
  /**
   * Resolve an adapter from a list of adapter names or functions.
   * @type {Function}
   */
  getAdapter: getAdapter$1,
  /**
   * Exposes all known adapters
   * @type {Object<string, Function|Object>}
   */
  adapters: knownAdapters
};
function throwIfCancellationRequested(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new CanceledError$1(null, e);
}
function dispatchRequest(e) {
  return throwIfCancellationRequested(e), e.headers = AxiosHeaders$1.from(e.headers), e.data = transformData.call(
    e,
    e.transformRequest
  ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), adapters.getAdapter(e.adapter || defaults.adapter, e)(e).then(function(n) {
    return throwIfCancellationRequested(e), n.data = transformData.call(
      e,
      e.transformResponse,
      n
    ), n.headers = AxiosHeaders$1.from(n.headers), n;
  }, function(n) {
    return isCancel$1(n) || (throwIfCancellationRequested(e), n && n.response && (n.response.data = transformData.call(
      e,
      e.transformResponse,
      n.response
    ), n.response.headers = AxiosHeaders$1.from(n.response.headers))), Promise.reject(n);
  });
}
const VERSION$1 = "1.13.2", validators$1 = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, t) => {
  validators$1[e] = function(n) {
    return typeof n === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
const deprecatedWarnings = {};
validators$1.transitional = function e(t, o, n) {
  function s(i, l) {
    return "[Axios v" + VERSION$1 + "] Transitional option '" + i + "'" + l + (n ? ". " + n : "");
  }
  return (i, l, d) => {
    if (t === !1)
      throw new AxiosError$1(
        s(l, " has been removed" + (o ? " in " + o : "")),
        AxiosError$1.ERR_DEPRECATED
      );
    return o && !deprecatedWarnings[l] && (deprecatedWarnings[l] = !0, console.warn(
      s(
        l,
        " has been deprecated since v" + o + " and will be removed in the near future"
      )
    )), t ? t(i, l, d) : !0;
  };
};
validators$1.spelling = function e(t) {
  return (o, n) => (console.warn(`${n} is likely a misspelling of ${t}`), !0);
};
function assertOptions(e, t, o) {
  if (typeof e != "object")
    throw new AxiosError$1("options must be an object", AxiosError$1.ERR_BAD_OPTION_VALUE);
  const n = Object.keys(e);
  let s = n.length;
  for (; s-- > 0; ) {
    const i = n[s], l = t[i];
    if (l) {
      const d = e[i], u = d === void 0 || l(d, i, e);
      if (u !== !0)
        throw new AxiosError$1("option " + i + " must be " + u, AxiosError$1.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (o !== !0)
      throw new AxiosError$1("Unknown option " + i, AxiosError$1.ERR_BAD_OPTION);
  }
}
const validator$1 = {
  assertOptions,
  validators: validators$1
}, validators = validator$1.validators;
let Axios$1 = class {
  constructor(t) {
    this.defaults = t || {}, this.interceptors = {
      request: new InterceptorManager(),
      response: new InterceptorManager()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(t, o) {
    try {
      return await this._request(t, o);
    } catch (n) {
      if (n instanceof Error) {
        let s = {};
        Error.captureStackTrace ? Error.captureStackTrace(s) : s = new Error();
        const i = s.stack ? s.stack.replace(/^.+\n/, "") : "";
        try {
          n.stack ? i && !String(n.stack).endsWith(i.replace(/^.+\n.+\n/, "")) && (n.stack += `
` + i) : n.stack = i;
        } catch {
        }
      }
      throw n;
    }
  }
  _request(t, o) {
    typeof t == "string" ? (o = o || {}, o.url = t) : o = t || {}, o = mergeConfig$1(this.defaults, o);
    const { transitional: n, paramsSerializer: s, headers: i } = o;
    n !== void 0 && validator$1.assertOptions(n, {
      silentJSONParsing: validators.transitional(validators.boolean),
      forcedJSONParsing: validators.transitional(validators.boolean),
      clarifyTimeoutError: validators.transitional(validators.boolean)
    }, !1), s != null && (utils$1.isFunction(s) ? o.paramsSerializer = {
      serialize: s
    } : validator$1.assertOptions(s, {
      encode: validators.function,
      serialize: validators.function
    }, !0)), o.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? o.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : o.allowAbsoluteUrls = !0), validator$1.assertOptions(o, {
      baseUrl: validators.spelling("baseURL"),
      withXsrfToken: validators.spelling("withXSRFToken")
    }, !0), o.method = (o.method || this.defaults.method || "get").toLowerCase();
    let l = i && utils$1.merge(
      i.common,
      i[o.method]
    );
    i && utils$1.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (h) => {
        delete i[h];
      }
    ), o.headers = AxiosHeaders$1.concat(l, i);
    const d = [];
    let u = !0;
    this.interceptors.request.forEach(function(T) {
      typeof T.runWhen == "function" && T.runWhen(o) === !1 || (u = u && T.synchronous, d.unshift(T.fulfilled, T.rejected));
    });
    const c = [];
    this.interceptors.response.forEach(function(T) {
      c.push(T.fulfilled, T.rejected);
    });
    let p, f = 0, g;
    if (!u) {
      const h = [dispatchRequest.bind(this), void 0];
      for (h.unshift(...d), h.push(...c), g = h.length, p = Promise.resolve(o); f < g; )
        p = p.then(h[f++], h[f++]);
      return p;
    }
    g = d.length;
    let y = o;
    for (; f < g; ) {
      const h = d[f++], T = d[f++];
      try {
        y = h(y);
      } catch (P) {
        T.call(this, P);
        break;
      }
    }
    try {
      p = dispatchRequest.call(this, y);
    } catch (h) {
      return Promise.reject(h);
    }
    for (f = 0, g = c.length; f < g; )
      p = p.then(c[f++], c[f++]);
    return p;
  }
  getUri(t) {
    t = mergeConfig$1(this.defaults, t);
    const o = buildFullPath(t.baseURL, t.url, t.allowAbsoluteUrls);
    return buildURL(o, t.params, t.paramsSerializer);
  }
};
utils$1.forEach(["delete", "get", "head", "options"], function e(t) {
  Axios$1.prototype[t] = function(o, n) {
    return this.request(mergeConfig$1(n || {}, {
      method: t,
      url: o,
      data: (n || {}).data
    }));
  };
});
utils$1.forEach(["post", "put", "patch"], function e(t) {
  function o(n) {
    return function(i, l, d) {
      return this.request(mergeConfig$1(d || {}, {
        method: t,
        headers: n ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: i,
        data: l
      }));
    };
  }
  Axios$1.prototype[t] = o(), Axios$1.prototype[t + "Form"] = o(!0);
});
let CancelToken$1 = class Fe {
  constructor(t) {
    if (typeof t != "function")
      throw new TypeError("executor must be a function.");
    let o;
    this.promise = new Promise(function(i) {
      o = i;
    });
    const n = this;
    this.promise.then((s) => {
      if (!n._listeners) return;
      let i = n._listeners.length;
      for (; i-- > 0; )
        n._listeners[i](s);
      n._listeners = null;
    }), this.promise.then = (s) => {
      let i;
      const l = new Promise((d) => {
        n.subscribe(d), i = d;
      }).then(s);
      return l.cancel = function() {
        n.unsubscribe(i);
      }, l;
    }, t(function(i, l, d) {
      n.reason || (n.reason = new CanceledError$1(i, l, d), o(n.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(t) {
    if (this.reason) {
      t(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(t) : this._listeners = [t];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(t) {
    if (!this._listeners)
      return;
    const o = this._listeners.indexOf(t);
    o !== -1 && this._listeners.splice(o, 1);
  }
  toAbortSignal() {
    const t = new AbortController(), o = (n) => {
      t.abort(n);
    };
    return this.subscribe(o), t.signal.unsubscribe = () => this.unsubscribe(o), t.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let t;
    return {
      token: new Fe(function(s) {
        t = s;
      }),
      cancel: t
    };
  }
};
function spread$1(e) {
  return function(o) {
    return e.apply(null, o);
  };
}
function isAxiosError$1(e) {
  return utils$1.isObject(e) && e.isAxiosError === !0;
}
const HttpStatusCode$1 = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511,
  WebServerIsDown: 521,
  ConnectionTimedOut: 522,
  OriginIsUnreachable: 523,
  TimeoutOccurred: 524,
  SslHandshakeFailed: 525,
  InvalidSslCertificate: 526
};
Object.entries(HttpStatusCode$1).forEach(([e, t]) => {
  HttpStatusCode$1[t] = e;
});
function createInstance(e) {
  const t = new Axios$1(e), o = bind(Axios$1.prototype.request, t);
  return utils$1.extend(o, Axios$1.prototype, t, { allOwnKeys: !0 }), utils$1.extend(o, t, null, { allOwnKeys: !0 }), o.create = function(s) {
    return createInstance(mergeConfig$1(e, s));
  }, o;
}
const axios = createInstance(defaults);
axios.Axios = Axios$1;
axios.CanceledError = CanceledError$1;
axios.CancelToken = CancelToken$1;
axios.isCancel = isCancel$1;
axios.VERSION = VERSION$1;
axios.toFormData = toFormData$1;
axios.AxiosError = AxiosError$1;
axios.Cancel = axios.CanceledError;
axios.all = function e(t) {
  return Promise.all(t);
};
axios.spread = spread$1;
axios.isAxiosError = isAxiosError$1;
axios.mergeConfig = mergeConfig$1;
axios.AxiosHeaders = AxiosHeaders$1;
axios.formToJSON = (e) => formDataToJSON(utils$1.isHTMLForm(e) ? new FormData(e) : e);
axios.getAdapter = adapters.getAdapter;
axios.HttpStatusCode = HttpStatusCode$1;
axios.default = axios;
const {
  Axios,
  AxiosError,
  CanceledError,
  isCancel,
  CancelToken,
  VERSION,
  all,
  Cancel,
  isAxiosError,
  spread,
  toFormData,
  AxiosHeaders,
  HttpStatusCode,
  formToJSON,
  getAdapter,
  mergeConfig
} = axios, getDocumentByUrl = async (e) => {
  const { data: t } = await axios.get(
    `${e?.contentDocument?.downloadUrl}`,
    {
      responseType: e?.contentDocument?.mediaType === "text/html" ? "text" : "arraybuffer"
    }
  );
  return t;
}, countNumberOfDataPoints = (e) => !e || !e?.length ? 0 : e.reduce((t, o) => t + o.length, 0), unpackNodeId = (e) => {
  if (!e)
    return "";
  try {
    const t = JSON.parse(atob(e));
    if (t.id)
      return t.id;
  } catch {
  }
  return e.split("=")[0];
}, handleRoomReplayEvents = (e, t) => {
  if (e && e.length > 0) {
    const { key: o, payload: n } = e[0], s = e?.[1];
    if (o === "organizer_media_opened") {
      const i = convertMediaPayloadToMediaData(n);
      let l;
      if (s) {
        const { key: d, payload: u } = s;
        if (d === "organizer_presentation_state_changed") {
          const { type: c, stateChange: p } = u;
          c === "reveal" && p?.namespace === "reveal" ? l = {
            indexh: p?.state?.indexh,
            indexv: p?.state?.indexv,
            indexf: p?.state?.indexf
          } : c === "pdf" && p?.namespace === "pdfViewer" && (l = { indexh: p?.state?.page, indexv: 0 });
        }
      }
      t.onMediaEventReplay?.({ media: i, initialPage: l });
    } else if (o === "organizer_consent_opened" && // the initial step is always 'collect'
    n.state.step === "collect")
      if (!s)
        t.onConsentEventReplay?.({
          state: n
        });
      else {
        const { key: i, payload: l } = s;
        if (i === "consent_viewer_state_changed") {
          const { step: d, state: u } = l;
          d === "collect" && u.step === "collect" ? t.onConsentEventReplay?.({
            state: {
              id: n?.id,
              step: "collect",
              consentType: n?.consentType,
              validation: n?.validation,
              state: {
                title: n.state.title,
                step: "collect",
                consentCommunicationData: n.state.consentCommunicationData,
                staticText: n.state.staticText,
                consentItems: u.consentItems,
                signature: u.signature
              }
            }
          }) : d === "preview" && u.step === "preview" && t.onConsentEventReplay?.({
            state: {
              id: n?.id,
              step: "preview",
              consentType: n?.consentType,
              validation: n?.validation,
              state: {
                title: n.state.title,
                step: "preview",
                content: u.content
              }
            }
          });
        }
      }
    else if (o === "organizer_sample_request_opened")
      if (!s)
        t.onSampleRequestEventReplay?.({ state: n });
      else {
        const { key: i, payload: l } = s;
        i === "sample_request_viewer_state_changed" && t.onSampleRequestEventReplay?.({ state: l });
      }
    else o === "screen_share_started" && t.onScreenSharingEventReplay?.({ state: n });
  }
}, getVideoElementStatus = (e) => ({
  isPlaying: e.currentTime > 0 && !e.paused && !e.ended && e.readyState > 2,
  isPaused: e.paused,
  isEnded: e.ended,
  currentTime: e.currentTime,
  readyState: e.readyState,
  isMuted: e.muted
}), byteToHex = [];
for (let e = 0; e < 256; ++e)
  byteToHex.push((e + 256).toString(16).slice(1));
function unsafeStringify(e, t = 0) {
  return (byteToHex[e[t + 0]] + byteToHex[e[t + 1]] + byteToHex[e[t + 2]] + byteToHex[e[t + 3]] + "-" + byteToHex[e[t + 4]] + byteToHex[e[t + 5]] + "-" + byteToHex[e[t + 6]] + byteToHex[e[t + 7]] + "-" + byteToHex[e[t + 8]] + byteToHex[e[t + 9]] + "-" + byteToHex[e[t + 10]] + byteToHex[e[t + 11]] + byteToHex[e[t + 12]] + byteToHex[e[t + 13]] + byteToHex[e[t + 14]] + byteToHex[e[t + 15]]).toLowerCase();
}
let getRandomValues;
const rnds8 = new Uint8Array(16);
function rng() {
  if (!getRandomValues) {
    if (typeof crypto > "u" || !crypto.getRandomValues)
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    getRandomValues = crypto.getRandomValues.bind(crypto);
  }
  return getRandomValues(rnds8);
}
const randomUUID = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), native = { randomUUID };
function _v4(e, t, o) {
  e = e || {};
  const n = e.random ?? e.rng?.() ?? rng();
  if (n.length < 16)
    throw new Error("Random bytes length must be >= 16");
  return n[6] = n[6] & 15 | 64, n[8] = n[8] & 63 | 128, unsafeStringify(n);
}
function v4(e, t, o) {
  return native.randomUUID && !e ? native.randomUUID() : _v4(e);
}
const isTouchEvent = (e) => e && "touches" in e, isMouseEvent = (e) => e && "screenX" in e, PointerContainer = ({
  children: e,
  iframeRef: t,
  onPointerShown: o,
  broadcastPointerShow: n
}) => {
  const s = useRef(null), [i, l] = useState(
    null
  ), [d, u] = useState([]), c = useCallback((T) => {
    u((P) => [...P, T]);
  }, []), p = (T) => {
    const P = s.current?.getBoundingClientRect();
    return {
      id: T.id,
      posX: P ? T.rx * P.width + P.left : 0,
      posY: P ? T.ry * P.height + P.top : 0,
      isOrganizer: T.isOrganizer,
      rx: 0,
      ry: 0,
      source: "overlay"
    };
  }, f = (T) => {
    if (isTouchEvent(T)) {
      if (T.touches || T.changedTouches) {
        const P = T.touches[0] || T.changedTouches[0];
        return { x: P.clientX, y: P.clientY };
      }
    } else if (isMouseEvent(T))
      return { x: T.clientX, y: T.clientY };
    return { x: 0, y: 0 };
  }, g = (T) => {
    const { x: P, y: E } = f(T), $ = s.current?.getBoundingClientRect();
    if ($) {
      const R = P - $.left, C = E - $.top, x = {
        id: v4(),
        posX: P,
        posY: E,
        rx: R / $.width,
        ry: C / $.height,
        isOrganizer: !1,
        source: "overlay"
      }, _ = setTimeout(() => {
        c(x), n?.(x);
      }, 200);
      l(_);
    }
  }, y = () => {
    i && clearTimeout(i);
  };
  useEffect(() => {
    const T = (P) => {
      try {
        const E = P.data && typeof P.data == "string" && P.data.indexOf("pointer") > 0 && JSON.parse(P.data);
        if (E) {
          const $ = s.current?.getBoundingClientRect();
          if ($) {
            if (E.eventName === "pointerRequested") {
              const R = {
                id: v4(),
                posX: E.pointerRequest.posX + $.left,
                posY: E.pointerRequest.posY + $.top,
                rx: E.pointerRequest.rx,
                ry: E.pointerRequest.ry,
                isOrganizer: !0,
                source: "iframe"
              };
              c(R), n?.(R);
            }
            if (E.eventName === "pointerCalculated") {
              const R = {
                id: E.pointerCalculation.id,
                posX: E.pointerCalculation.posX + $.left,
                posY: E.pointerCalculation.posY + $.top,
                rx: E.pointerCalculation.rx,
                ry: E.pointerCalculation.ry,
                isOrganizer: E.pointerCalculation.isOrganizer,
                source: "iframe"
              };
              c(R);
            }
          }
        }
      } catch (E) {
        console.error(E);
      }
    };
    return window.addEventListener("message", T), () => {
      window.removeEventListener("message", T);
    };
  }, [n, c]), useEffect(() => {
    const P = o?.((E) => {
      if (E.source) {
        if (E.source === "overlay") {
          const $ = p(E);
          c($);
        }
        if (E.source === "iframe") {
          const $ = {
            namespace: "reveal",
            eventName: "pointer",
            pointer: E
          };
          t?.current?.contentWindow?.postMessage($, "*");
        }
      }
    });
    return () => {
      P && P();
    };
  }, [c, t, o]);
  const h = (T) => {
    u((P) => P.filter((E) => E.id !== T));
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    d.map((T) => /* @__PURE__ */ jsxRuntimeExports.jsx(
      PointerAnimate,
      {
        pointer: T,
        onAnimationComplete: () => h(T.id)
      },
      T.id
    )),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Wrapper$e,
      {
        ref: s,
        "data-testid": "pointer-overlay",
        onMouseDown: g,
        onMouseUp: y,
        onTouchStart: g,
        onTouchEnd: y,
        children: e
      }
    )
  ] });
}, Wrapper$e = styled$2(Box)({
  display: "grid",
  height: "100%",
  width: "100%"
}), HTMLMedia = ({
  media: e,
  onMediaStateChanged: t,
  onPointerShown: o,
  broadcastPointerShow: n,
  initialPage: s = { indexh: 0, indexv: 0 }
}) => {
  const i = useRef(null);
  return useEffect(() => {
    const d = t?.(
      (u) => {
        if (u?.type === "reveal" && u?.stateChange?.namespace === "reveal")
          if (u.stateChange.eventName === "slidechanged" || u.stateChange.eventName === "fragmentshown") {
            const { indexh: c, indexv: p, indexf: f } = u.stateChange.state, g = JSON.stringify({
              method: "slide",
              args: [c, p, f]
            });
            i?.current?.contentWindow?.postMessage(g, "*");
          } else u.stateChange.eventName === "interaction" && i?.current?.contentWindow?.postMessage(u.stateChange, "*");
      }
    );
    return () => {
      d && d();
    };
  }, [t]), useEffect(() => {
    (async (d) => {
      const u = await getDocumentByUrl(d), c = i.current;
      if (u && c) {
        const p = c?.contentWindow?.document;
        p?.open(), p?.write(u), p?.close();
      }
    })(e);
  }, [e]), e && /* @__PURE__ */ jsxRuntimeExports.jsx(Wrapper$d, { "data-testid": "HTML_media_wrapper", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    PointerContainer,
    {
      iframeRef: i,
      broadcastPointerShow: n,
      onPointerShown: o,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        Iframe$1,
        {
          ref: i,
          title: "HTML",
          "data-testid": "HTML_iframe",
          onLoad: () => {
            i.current?.contentWindow?.postMessage(
              JSON.stringify({ method: "getTotalSlides" }),
              "*"
            );
            const { indexh: l, indexv: d, indexf: u } = s, c = JSON.stringify({
              method: "slide",
              args: [l, d, u]
            });
            i?.current?.contentWindow?.postMessage(c, "*"), i.current?.contentWindow?.addEventListener(
              "message",
              (p) => {
                const { data: f } = p;
                if (f && f.namespace === "reveal" && f.eventName === "interaction" && f.interaction) {
                  const { type: y, elementId: h, selector: T } = p.data.interaction;
                  y === "click" && (typeof h == "string" ? i.current?.contentDocument?.getElementById(h)?.click() : typeof T == "string" && i.current?.contentDocument?.querySelector(T)?.click());
                }
              }
            );
          }
        }
      )
    }
  ) });
}, Wrapper$d = styled(Box)`
  display: flex;
  height: 100%;
  width: 100%;
`, Iframe$1 = styled("iframe")(({ theme: e }) => ({
  borderRadius: Number(e.shape.borderRadius) * 2,
  height: "100%",
  width: "100%",
  pointerEvents: "none"
  // Stop attendee to interact with the iframe which is the HTML View
})), HTMLZIPFile = ({
  media: e,
  onMediaStateChanged: t,
  isInInteraction: o = !1,
  isReadOnlyMode: n = !1
}) => {
  const s = useRef(null);
  useEffect(() => {
    const d = t?.(
      (u) => {
        u?.namespace === "ysura" && s?.current?.contentWindow && s?.current?.contentWindow?.postMessage(u.stateChange);
      }
    );
    return () => {
      d && d();
    };
  }, [t]), useEffect(() => {
    (async (d) => {
      const u = await navigator.serviceWorker.ready, c = await getDocumentByUrl(d), p = new MessageChannel(), f = new Promise((h) => {
        p.port1.onmessage = (T) => {
          h(T.data);
        };
      }), g = { documentId: d?.id };
      if (u.active?.postMessage(
        {
          type: "CHECK_ZIP_CACHE",
          mediaInfo: g
        },
        [p.port2]
      ), (await f).cached)
        s.current && (s.current.src = "/zip/index.html");
      else
        try {
          const h = new MessageChannel();
          u.active?.postMessage(
            {
              type: "EXTRACT_ZIP_FROM_ARRAYBUFFER",
              mediaInfo: g,
              arrayBuffer: c
            },
            [c, h.port2]
          ), h.port1.onmessage = (T) => {
            if (T.data.success && s.current)
              s.current.src = "/zip/index.html";
            else
              throw new Error(T.data.error);
          };
        } catch (h) {
          throw console.error("Error downloading ZIP file:", h), h;
        }
    })(e);
  }, [e]);
  const i = () => /* @__PURE__ */ jsxRuntimeExports.jsx(
    Iframe,
    {
      ref: s,
      title: "HTML ZIP Presentation",
      isReadOnlyMode: n,
      "data-testid": "HTMLZIP_iframe"
    }
  );
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Wrapper$c, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(DialogContent$1, { children: o ? /* @__PURE__ */ jsxRuntimeExports.jsx(PointerContainer, { iframeRef: s, children: i() }) : i() }) });
}, Wrapper$c = styled(Box)({
  display: "flex",
  flexDirection: "column",
  height: "100%",
  width: "100%"
}), DialogContent$1 = styled(DialogContent$3)(({ theme: e }) => ({
  display: "flex",
  height: "100%",
  padding: e.spacing(2)
})), Iframe = styled("iframe", {
  shouldForwardProp: (e) => e !== "isReadOnlyMode"
})(({ theme: e, isReadOnlyMode: t }) => ({
  width: "100%",
  height: "100%",
  borderRadius: Number(e.shape.borderRadius) * 2,
  pointerEvents: t ? "none" : "auto"
})), MediaSharingColumn = ({
  media: e,
  initialPage: t = { indexh: 0, indexv: 0 },
  onMediaStateChanged: o,
  onPointerShown: n,
  broadcastPointerShow: s,
  PdfMediaComponent: i
}) => /* @__PURE__ */ jsxRuntimeExports.jsx(InteractionItemsColumn, { isSharing: !0, flex: 2, testId: "media-sharing-column", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Content$1, { children: [
  e?.contentDocument.mediaType === "text/html" && /* @__PURE__ */ jsxRuntimeExports.jsx(
    HTMLMedia,
    {
      media: e,
      initialPage: t,
      broadcastPointerShow: s,
      onMediaStateChanged: o,
      onPointerShown: n
    }
  ),
  e?.contentDocument.mediaType === "application/pdf" && /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: i }),
  e?.contentDocument.mediaType === "application/zip" && /* @__PURE__ */ jsxRuntimeExports.jsx(
    HTMLZIPFile,
    {
      isInInteraction: !0,
      isFullScreenShown: !0,
      media: e,
      isReadOnlyMode: !0,
      onMediaStateChanged: o,
      onClose: () => {
      }
    }
  )
] }) }), Content$1 = styled(Box)(({ theme: e }) => ({
  display: "flex",
  flexGrow: 1,
  overflow: "auto",
  flexDirection: "column",
  height: "100%",
  gap: e.spacing(2),
  [e.breakpoints.down("md")]: {
    gap: e.spacing(1)
  }
})), Arrow = styled("span")(({ arrow: e, theme: t }) => {
  const s = `solid 1px ${t.palette.grey[50012]}`, i = {
    borderRadius: "0 0 3px 0",
    top: -6,
    borderBottom: s,
    borderRight: s
  }, l = {
    borderRadius: "3px 0 0 0",
    bottom: -6,
    borderTop: s,
    borderLeft: s
  }, d = {
    borderRadius: "0 3px 0 0",
    left: -6,
    borderTop: s,
    borderRight: s
  }, u = {
    borderRadius: "0 0 0 3px",
    right: -6,
    borderBottom: s,
    borderLeft: s
  };
  return {
    display: "none",
    [t.breakpoints.up("sm")]: {
      zIndex: 1,
      width: 12,
      height: 12,
      content: "''",
      display: "block",
      position: "absolute",
      transform: "rotate(-135deg)",
      background: t.palette.background.paper
    },
    // Top
    ...e === "top-left" && { ...i, left: 20 },
    ...e === "top-center" && {
      ...i,
      left: 0,
      right: 0,
      margin: "auto"
    },
    ...e === "top-right" && { ...i, right: 20 },
    // Bottom
    ...e === "bottom-left" && { ...l, left: 20 },
    ...e === "bottom-center" && {
      ...l,
      left: 0,
      right: 0,
      margin: "auto"
    },
    ...e === "bottom-right" && { ...l, right: 20 },
    // Left
    ...e === "left-top" && { ...d, top: 20 },
    ...e === "left-center" && {
      ...d,
      top: 0,
      bottom: 0,
      margin: "auto"
    },
    ...e === "left-bottom" && { ...d, bottom: 20 },
    // Right
    ...e === "right-top" && { ...u, top: 20 },
    ...e === "right-center" && {
      ...u,
      top: 0,
      bottom: 0,
      margin: "auto"
    },
    ...e === "right-bottom" && { ...u, bottom: 20 }
  };
}), MenuPopover = ({
  children: e,
  arrow: t = "top-right",
  disabledArrow: o,
  ...n
}) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
  Popover$2,
  {
    anchorOrigin: { vertical: "bottom", horizontal: "right" },
    transformOrigin: { vertical: "top", horizontal: "right" },
    slotProps: {
      paper: {
        sx: {
          p: 1,
          width: 200,
          overflow: "inherit"
        }
      }
    },
    ...n,
    children: [
      !o && /* @__PURE__ */ jsxRuntimeExports.jsx(Arrow, { arrow: t }),
      e
    ]
  }
), NoItemPlaceholder = ({
  children: e,
  subMessage: t
}) => /* @__PURE__ */ jsxRuntimeExports.jsxs(Wrapper$b, { children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx(Message, { variant: "subtitle2", children: e }),
  t && /* @__PURE__ */ jsxRuntimeExports.jsx(Message, { variant: "caption", children: t })
] }), Wrapper$b = styled(Stack)(({ theme: e }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexGrow: 1,
  width: "100%",
  backgroundColor: e.palette.background.neutral,
  borderRadius: e.shape.borderRadius,
  padding: e.spacing(2),
  gap: e.spacing(1)
})), Message = styled(Typography$2)(({ theme: e }) => ({
  color: e.palette.text.disabled,
  textAlign: "center"
})), InfiniteScrollingOrganizationCardSkeleton = () => /* @__PURE__ */ jsxRuntimeExports.jsx(LoaderWrapper$1, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(OrganizationCardSkeleton, {}) }), LoaderWrapper$1 = styled(Box)({
  /**
   * This padding is needed so the loading component inside the InfiniteScroll
   * is positioned correctly.
   */
  padding: "4px 1px"
}), TwoLinesInBlock$1 = styled(Box)(({ theme: e }) => ({
  display: "flex",
  flexDirection: "column",
  gap: e.spacing(0.5)
})), OrganizationIcon = styled(LocalHospital)(({ theme: e }) => ({
  fontSize: 12,
  fill: e.palette.common.white
})), IconAddress$1 = styled(LocationOn)(({ theme: e }) => ({
  color: e.palette.text.secondary,
  fontSize: "medium",
  height: 12,
  width: 12
})), OrganizationCard = ({
  organizationName: e,
  organizationType: t,
  rootOrganizationName: o,
  addressName: n,
  onClick: s
}) => {
  const i = useTheme$4();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(BaseCard, { onClick: s, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      FirstLine,
      {
        content: e,
        textColor: i.palette.text.primary,
        sizeIcon: FIRST_LINE_ICON_SIZE,
        variant: DEFAULT_VARIANT_FIRST_LINE,
        backgroundColor: i.palette.info.main,
        icon: /* @__PURE__ */ jsxRuntimeExports.jsx(OrganizationIcon, {})
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(TwoLinesInBlock$1, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        SecondLine,
        {
          content: o === e ? t : o,
          textColor: i.palette.text.primary,
          variant: DEFAULT_VARIANT_SECOND_LINE,
          sizeIcon: SECOND_LINE_ICON_SIZE
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        ThirdLine,
        {
          content: n,
          textColor: i.palette.text.primary,
          sizeIcon: ADDRESS_ICON_SIZE,
          variant: DEFAULT_VARIANT_THIRD_LINE,
          icon: /* @__PURE__ */ jsxRuntimeExports.jsx(IconAddress$1, {})
        }
      )
    ] })
  ] });
}, OrganizationCardSkeleton = () => /* @__PURE__ */ jsxRuntimeExports.jsx(OverviewCard, { testId: "organization-card-skeleton", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Wrapper$a, { children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx(SmallStack$1, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Typography$2, { variant: "subtitle2", children: /* @__PURE__ */ jsxRuntimeExports.jsx(Skeleton$1, { width: "100%" }) }) }),
  /* @__PURE__ */ jsxRuntimeExports.jsx(SmallStack$1, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Typography$2, { variant: "caption", children: /* @__PURE__ */ jsxRuntimeExports.jsx(Skeleton$1, { width: 60, height: 22 }) }) }),
  /* @__PURE__ */ jsxRuntimeExports.jsx(SmallStack$1, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Typography$2, { variant: "caption", children: /* @__PURE__ */ jsxRuntimeExports.jsx(Skeleton$1, { width: "100%" }) }) })
] }) }), Wrapper$a = styled(Stack)(({ theme: e }) => ({
  gap: e.spacing(2)
})), SmallStack$1 = styled(Stack)(({ theme: e }) => ({
  gap: e.spacing(1)
})), Line = styled(Box)(({ theme: e }) => ({
  display: "flex",
  gap: e.spacing(1)
})), TwoLinesInBlock = styled(Box)(({ theme: e }) => ({
  display: "flex",
  flexDirection: "column",
  gap: e.spacing(0.5)
})), CustomizeInfoLayer = styled(Box)(({ theme: e }) => ({
  display: "flex",
  gap: e.spacing(0.5),
  justifyContent: "space-between",
  width: "100%",
  padding: e.spacing(1)
})), SkeletonInfoLayer = styled(Box)(({ theme: e }) => ({
  display: "grid",
  gap: e.spacing(0.5),
  justifyContent: "space-between",
  width: "100%",
  padding: e.spacing(1)
})), CustomizeContent = styled(Box)(({ theme: e }) => ({
  display: "flex",
  flex: 1,
  flexDirection: "column",
  gap: e.spacing(1),
  maxWidth: `calc(100% - ${DEFAULT_ICON_SIZE}px - ${e.spacing(1)})`
})), CenteredButton = styled(Box)(() => ({
  display: "flex",
  alignItems: "center"
})), PersonIcon$1 = styled(Person)(({ theme: e }) => ({
  fontSize: 12,
  fill: e.palette.common.white
})), IconCompany = styled(LocalHospital)(({ theme: e }) => ({
  color: e.palette.text.secondary,
  fontSize: "medium",
  height: 12,
  width: 12
})), IconAddress = styled(LocationOn)(({ theme: e }) => ({
  color: e.palette.text.secondary,
  fontSize: "medium",
  height: 12,
  width: 12
})), OrganizationInfo = ({
  organization: e,
  organizationTypes: t,
  address: o
}) => {
  const n = useTheme$4();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(CustomizeContent, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      FirstLine,
      {
        content: e.name,
        textColor: e.color,
        sizeIcon: 20,
        variant: DEFAULT_VARIANT_FIRST_LINE,
        icon: e.icon ? e.icon : /* @__PURE__ */ jsxRuntimeExports.jsx(IconCompany, {})
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(TwoLinesInBlock, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        SecondLine,
        {
          content: t,
          showIcon: !1,
          textColor: n.palette.text.primary
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        ThirdLine,
        {
          content: o.street,
          textColor: o.color,
          sizeIcon: ADDRESS_ICON_SIZE,
          variant: DEFAULT_VARIANT_THIRD_LINE,
          icon: o.icon ? o.icon : /* @__PURE__ */ jsxRuntimeExports.jsx(IconAddress, {})
        }
      )
    ] })
  ] });
}, OverviewCard = ({
  title: e,
  subtitle: t,
  children: o,
  testId: n,
  handleClickCard: s
}) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
  StyledCard$1,
  {
    "data-testid": n,
    isClickable: !!s,
    onClick: s,
    children: [
      e && /* @__PURE__ */ jsxRuntimeExports.jsx(
        StyledCardHeader,
        {
          title: /* @__PURE__ */ jsxRuntimeExports.jsxs(TitleWrapper, { children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(Title$2, { variant: "subtitle2", children: e }),
            t && /* @__PURE__ */ jsxRuntimeExports.jsx(SubTitle, { variant: "subtitle2", children: t })
          ] })
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(StyledCardContent$1, { children: o })
    ]
  }
), StyledCard$1 = styled(Card$1, {
  shouldForwardProp: (e) => e !== "isClickable"
})(({ theme: e, isClickable: t }) => ({
  borderRadius: e.shape.borderRadius,
  cursor: t ? "pointer" : "default"
})), StyledCardContent$1 = styled(CardContent)(({ theme: e }) => ({
  padding: e.spacing(2)
})), StyledCardHeader = styled(CardHeader)(() => ({
  paddingBottom: 0
})), TitleWrapper = styled(Box)`
  display: flex;
  justify-content: space-between;
`, Title$2 = styled(Typography$2)(({ theme: e }) => ({
  color: e.palette.text.secondary
})), SubTitle = styled(Typography$2)(({ theme: e }) => ({
  color: e.palette.text.disabled
})), variants = {
  exit: {
    initial: { display: "none", opacity: 0 },
    exit: {
      display: "flex",
      opacity: 1,
      transition: { duration: 0.4, ease: "easeOut" }
    }
  },
  enter: {
    initial: { opacity: 1 },
    animate: {
      opacity: 0,
      transition: { duration: 0.4, ease: "easeOut", delay: 0.8 },
      transitionEnd: {
        display: "none"
      }
    }
  },
  enterAndExit: {
    initial: { opacity: 0 },
    animate: {
      opacity: [1, 0],
      transition: { duration: 0.4, ease: "easeInOut" },
      transitionEnd: {
        display: "none"
      }
    }
  }
}, PageOverlay = ({ overlayText: e, animate: t }) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  Overlay,
  {
    "data-testid": "page-overlay",
    ...variants[t],
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledTypography, { variant: "h3", children: e })
  },
  "overlay"
), Overlay = styled(motion.div)(({ theme: e }) => ({
  position: "absolute",
  inset: 0,
  zIndex: 1e3,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  backgroundColor: alpha$1(e.palette.common.black, 0.8),
  width: "100%",
  height: "100%"
})), StyledTypography = styled(Typography$2)(({ theme: e }) => ({
  color: e.palette.common.white
})), getAttendeeInitials = (e) => {
  if (!e)
    return "N/A";
  const t = e.split(" ");
  let o;
  return t.length === 1 && (o = `${t[0][0]}${t[0]?.[1] ?? ""}`), t.length > 1 && (o = `${t[0][0]}${t[1][0]}`), o ?? "N/A";
}, getProportions = (e) => {
  switch (e) {
    case "small":
      return 48;
    case "medium":
      return 96;
    case "large":
      return 144;
  }
}, getFontVariant = (e) => {
  switch (e) {
    case "small":
      return "subtitle2";
    case "medium":
      return "subtitle1";
    case "large":
      return "h2";
  }
}, ParticipantBox = ({
  attendeeName: e,
  showAsThumbnail: t = !1,
  size: o = "small",
  dark: n = !1
}) => {
  const s = e ? getAttendeeInitials(e) : void 0;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Wrapper$9,
    {
      "data-testid": "participant-box",
      proportions: getProportions(o),
      showAsThumbnail: t,
      dark: n,
      children: t && s ? /* @__PURE__ */ jsxRuntimeExports.jsx(
        ParticipantInitials,
        {
          variant: getFontVariant(o),
          "data-testid": "participant-initials",
          children: s
        }
      ) : /* @__PURE__ */ jsxRuntimeExports.jsx(VideoOffIcon, {})
    }
  );
}, Wrapper$9 = styled(Box, {
  shouldForwardProp: (e) => e !== "proportions" && e !== "showAsThumbnail" && e !== "dark"
})(({ theme: e, proportions: t, showAsThumbnail: o, dark: n }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  height: t,
  width: t,
  borderRadius: e.shape.borderRadius,
  background: o ? n ? e.palette.primary.main : e.palette.primary.light : "none"
})), ParticipantInitials = styled(Typography$2)(({ theme: e }) => ({
  color: e.palette.common.white,
  textTransform: "uppercase"
})), VideoOffIcon = styled(Person)(({ theme: e }) => ({
  color: e.palette.common.white,
  width: "100%",
  height: "100%"
})), InfiniteScrollingPersonCardSkeleton = () => /* @__PURE__ */ jsxRuntimeExports.jsx(LoaderWrapper, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(PersonCardSkeleton, {}) }), LoaderWrapper = styled(Box)({
  /**
   * This padding is needed so the loading component inside the InfiniteScroll
   * is positioned correctly.
   */
  padding: "4px 1px"
}), PersonCard = ({
  personName: e,
  organizationName: t,
  addressName: o,
  onClick: n
}) => {
  const s = "caption", i = useTheme$4();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(BaseCard, { onClick: n, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      FirstLine,
      {
        content: e,
        textColor: i.palette.text.primary,
        sizeIcon: FIRST_LINE_ICON_SIZE,
        variant: DEFAULT_VARIANT_FIRST_LINE,
        backgroundColor: i.palette.info.main,
        icon: /* @__PURE__ */ jsxRuntimeExports.jsx(PersonIcon$1, {})
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(TwoLinesInBlock, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        SecondLine,
        {
          content: t,
          textColor: i.palette.text.primary,
          sizeIcon: SECOND_LINE_ICON_SIZE,
          variant: s,
          icon: /* @__PURE__ */ jsxRuntimeExports.jsx(IconCompany, {})
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        ThirdLine,
        {
          content: o,
          textColor: i.palette.text.primary,
          sizeIcon: ADDRESS_ICON_SIZE,
          variant: DEFAULT_VARIANT_THIRD_LINE,
          icon: /* @__PURE__ */ jsxRuntimeExports.jsx(IconAddress, {})
        }
      )
    ] })
  ] });
}, PersonCardSkeleton = () => /* @__PURE__ */ jsxRuntimeExports.jsxs(SkeletonCard, { "data-testid": "person-card-skeleton", children: [
  /* @__PURE__ */ jsxRuntimeExports.jsxs(Line, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Skeleton$1, { variant: "circular", width: 20, height: 20 }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Skeleton$1, { width: 200, height: 22 })
  ] }),
  /* @__PURE__ */ jsxRuntimeExports.jsx(Skeleton$1, { width: 160, height: 18 }),
  /* @__PURE__ */ jsxRuntimeExports.jsx(Skeleton$1, { width: 160, height: 18 })
] }), PersonInfo = ({
  person: e,
  organization: t,
  address: o,
  operation: n,
  onClick: s
}) => {
  const i = useTheme$4(), l = "caption", d = s;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(CustomizeInfoLayer, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(CustomizeContent, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        FirstLine,
        {
          content: e.title,
          showIcon: e.showIcon,
          textColor: i.palette.text.primary,
          sizeIcon: FIRST_LINE_ICON_SIZE,
          variant: DEFAULT_VARIANT_FIRST_LINE,
          backgroundColor: i.palette.info.main,
          icon: e.showBalloonIcon ? /* @__PURE__ */ jsxRuntimeExports.jsx(PersonIcon$1, {}) : /* @__PURE__ */ jsxRuntimeExports.jsx(Person, {})
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(TwoLinesInBlock, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          SecondLine,
          {
            content: t.title,
            showIcon: t.showIcon,
            textColor: i.palette.text.primary,
            sizeIcon: SECOND_LINE_ICON_SIZE,
            variant: l,
            icon: /* @__PURE__ */ jsxRuntimeExports.jsx(IconCompany, {})
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          ThirdLine,
          {
            content: o.street,
            showIcon: o.showIcon,
            textColor: i.palette.text.primary,
            sizeIcon: ADDRESS_ICON_SIZE,
            variant: DEFAULT_VARIANT_THIRD_LINE,
            icon: /* @__PURE__ */ jsxRuntimeExports.jsx(IconAddress, {})
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(CenteredButton, { children: [
      n === "add" && /* @__PURE__ */ jsxRuntimeExports.jsx(AddItemIcon, { iconSize: ADD_ICON_SIZE, onClick: d }),
      n === "remove" && /* @__PURE__ */ jsxRuntimeExports.jsx(
        RemoveItemIcon,
        {
          iconSize: REMOVE_ICON_SIZE,
          onClick: d
        }
      ),
      n === "selected" && /* @__PURE__ */ jsxRuntimeExports.jsx(SelectedItemIcon, { iconSize: SELECTED_ICON_SIZE })
    ] })
  ] });
}, PersonInfoSkeleton = () => /* @__PURE__ */ jsxRuntimeExports.jsxs(SkeletonInfoLayer, { "data-testid": "person-info-skeleton", children: [
  /* @__PURE__ */ jsxRuntimeExports.jsxs(Line, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Skeleton$1, { variant: "circular", width: 20, height: 20 }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Skeleton$1, { width: 200, height: 22 })
  ] }),
  /* @__PURE__ */ jsxRuntimeExports.jsx(Skeleton$1, { width: 160, height: 18 }),
  /* @__PURE__ */ jsxRuntimeExports.jsx(Skeleton$1, { width: 160, height: 18 })
] }), PersonSimpleInfo = ({ person: e, testId: t }) => {
  const o = useTheme$4();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(CustomizeInfoLayer, { "data-testid": t, children: /* @__PURE__ */ jsxRuntimeExports.jsx(CustomizeContent, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    FirstLine,
    {
      content: e.name,
      showIcon: e.showIcon,
      textColor: o.palette.text.primary,
      sizeIcon: FIRST_LINE_ICON_SIZE,
      variant: DEFAULT_VARIANT_FIRST_LINE,
      backgroundColor: e.greyBackground ? o.palette.text.disabled : o.palette.info.main,
      icon: e.showBalloonIcon ? /* @__PURE__ */ jsxRuntimeExports.jsx(PersonIcon, {}) : /* @__PURE__ */ jsxRuntimeExports.jsx(Person, {})
    }
  ) }) });
}, PersonIcon = styled(Person)(({ theme: e }) => ({
  fontSize: 12,
  fill: e.palette.common.white
})), PointerAnimate = ({
  pointer: e,
  onAnimationComplete: t
}) => {
  const { posX: o, posY: n, isOrganizer: s } = e, i = o - 24, l = n - 24;
  return setTimeout(() => t(), 1e3), /* @__PURE__ */ jsxRuntimeExports.jsx(
    Wrapper$8,
    {
      "data-testid": "pointer",
      realPosX: i,
      realPosY: l,
      isOrganizer: s,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", version: "1.1", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("circle", { cx: "24", cy: "24", r: "0", strokeWidth: "2", fill: "none", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "animate",
          {
            attributeName: "r",
            begin: "0s",
            dur: "0.8s",
            repeatCount: "once",
            from: "0",
            to: "24"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "animate",
          {
            attributeName: "opacity",
            begin: "0.4s",
            dur: "0.4s",
            repeatCount: "once",
            from: "1",
            to: "0"
          }
        )
      ] }) })
    }
  );
}, Wrapper$8 = styled(Box, {
  shouldForwardProp: (e) => typeof e == "string" && ["realPosX", "realPosY", "isOrganizer"].indexOf(e) === -1
})(
  ({ realPosX: e, realPosY: t, isOrganizer: o, theme: n }) => ({
    position: "fixed",
    left: `${e}px`,
    top: `${t}px`,
    width: "100px",
    height: "100px",
    zIndex: 1,
    svg: {
      stroke: o ? n.palette.error.main : n.palette.primary.main
    }
  })
);
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var o = arguments[t];
      for (var n in o) ({}).hasOwnProperty.call(o, n) && (e[n] = o[n]);
    }
    return e;
  }, _extends.apply(null, arguments);
}
function _objectWithoutPropertiesLoose(e, t) {
  if (e == null) return {};
  var o = {};
  for (var n in e) if ({}.hasOwnProperty.call(e, n)) {
    if (t.indexOf(n) !== -1) continue;
    o[n] = e[n];
  }
  return o;
}
const getPickersLocalization = (e) => ({
  components: {
    MuiLocalizationProvider: {
      defaultProps: {
        localeText: _extends({}, e)
      }
    }
  }
}), enUSPickers = {
  // Calendar navigation
  previousMonth: "Previous month",
  nextMonth: "Next month",
  // View navigation
  openPreviousView: "Open previous view",
  openNextView: "Open next view",
  calendarViewSwitchingButtonAriaLabel: (e) => e === "year" ? "year view is open, switch to calendar view" : "calendar view is open, switch to year view",
  // DateRange labels
  start: "Start",
  end: "End",
  startDate: "Start date",
  startTime: "Start time",
  endDate: "End date",
  endTime: "End time",
  // Action bar
  cancelButtonLabel: "Cancel",
  clearButtonLabel: "Clear",
  okButtonLabel: "OK",
  todayButtonLabel: "Today",
  nextStepButtonLabel: "Next",
  // Toolbar titles
  datePickerToolbarTitle: "Select date",
  dateTimePickerToolbarTitle: "Select date & time",
  timePickerToolbarTitle: "Select time",
  dateRangePickerToolbarTitle: "Select date range",
  timeRangePickerToolbarTitle: "Select time range",
  // Clock labels
  clockLabelText: (e, t) => `Select ${e}. ${t ? `Selected time is ${t}` : "No time selected"}`,
  hoursClockNumberText: (e) => `${e} hours`,
  minutesClockNumberText: (e) => `${e} minutes`,
  secondsClockNumberText: (e) => `${e} seconds`,
  // Digital clock labels
  selectViewText: (e) => `Select ${e}`,
  // Calendar labels
  calendarWeekNumberHeaderLabel: "Week number",
  calendarWeekNumberHeaderText: "#",
  calendarWeekNumberAriaLabelText: (e) => `Week ${e}`,
  calendarWeekNumberText: (e) => `${e}`,
  // Open Picker labels
  openDatePickerDialogue: (e) => e ? `Choose date, selected date is ${e}` : "Choose date",
  openTimePickerDialogue: (e) => e ? `Choose time, selected time is ${e}` : "Choose time",
  openRangePickerDialogue: (e) => e ? `Choose range, selected range is ${e}` : "Choose range",
  fieldClearLabel: "Clear",
  // Table labels
  timeTableLabel: "pick time",
  dateTableLabel: "pick date",
  // Field section placeholders
  fieldYearPlaceholder: (e) => "Y".repeat(e.digitAmount),
  fieldMonthPlaceholder: (e) => e.contentType === "letter" ? "MMMM" : "MM",
  fieldDayPlaceholder: () => "DD",
  fieldWeekDayPlaceholder: (e) => e.contentType === "letter" ? "EEEE" : "EE",
  fieldHoursPlaceholder: () => "hh",
  fieldMinutesPlaceholder: () => "mm",
  fieldSecondsPlaceholder: () => "ss",
  fieldMeridiemPlaceholder: () => "aa",
  // View names
  year: "Year",
  month: "Month",
  day: "Day",
  weekDay: "Week day",
  hours: "Hours",
  minutes: "Minutes",
  seconds: "Seconds",
  meridiem: "Meridiem",
  // Common
  empty: "Empty"
}, DEFAULT_LOCALE = enUSPickers;
getPickersLocalization(enUSPickers);
const _excluded$v = ["localeText"], PickerAdapterContext = /* @__PURE__ */ React.createContext(null);
process.env.NODE_ENV !== "production" && (PickerAdapterContext.displayName = "PickerAdapterContext");
const LocalizationProvider = function e(t) {
  const {
    localeText: o
  } = t, n = _objectWithoutPropertiesLoose(t, _excluded$v), {
    adapter: s,
    localeText: i
  } = React.useContext(PickerAdapterContext) ?? {
    adapter: void 0,
    localeText: void 0
  }, l = useThemeProps({
    // We don't want to pass the `localeText` prop to the theme, that way it will always return the theme value,
    // We will then merge this theme value with our value manually
    props: n,
    name: "MuiLocalizationProvider"
  }), {
    children: d,
    dateAdapter: u,
    dateFormats: c,
    dateLibInstance: p,
    adapterLocale: f,
    localeText: g
  } = l, y = React.useMemo(() => _extends({}, g, i, o), [g, i, o]), h = React.useMemo(() => {
    if (!u)
      return s || null;
    const E = new u({
      locale: f,
      formats: c,
      instance: p
    });
    if (!E.isMUIAdapter)
      throw new Error(["MUI X: The date adapter should be imported from `@mui/x-date-pickers` or `@mui/x-date-pickers-pro`, not from `@date-io`", "For example, `import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'` instead of `import AdapterDayjs from '@date-io/dayjs'`", "More information on the installation documentation: https://mui.com/x/react-date-pickers/quickstart/#installation"].join(`
`));
    return E;
  }, [u, f, c, p, s]), T = React.useMemo(() => h ? {
    minDate: h.date("1900-01-01T00:00:00.000"),
    maxDate: h.date("2099-12-31T00:00:00.000")
  } : null, [h]), P = React.useMemo(() => ({
    utils: h,
    adapter: h,
    defaultDates: T,
    localeText: y
  }), [T, h, y]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(PickerAdapterContext.Provider, {
    value: P,
    children: d
  });
};
process.env.NODE_ENV !== "production" && (LocalizationProvider.displayName = "LocalizationProvider");
process.env.NODE_ENV !== "production" && (LocalizationProvider.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Locale for the date library you are using
   */
  adapterLocale: PropTypes.any,
  children: PropTypes.node,
  /**
   * Date library adapter class function.
   * @see See the localization provider {@link https://mui.com/x/react-date-pickers/quickstart/#integrate-provider-and-adapter date adapter setup section} for more details.
   */
  dateAdapter: PropTypes.func,
  /**
   * Formats that are used for any child pickers
   */
  dateFormats: PropTypes.shape({
    dayOfMonth: PropTypes.string,
    dayOfMonthFull: PropTypes.string,
    fullDate: PropTypes.string,
    fullTime12h: PropTypes.string,
    fullTime24h: PropTypes.string,
    hours12h: PropTypes.string,
    hours24h: PropTypes.string,
    keyboardDate: PropTypes.string,
    keyboardDateTime12h: PropTypes.string,
    keyboardDateTime24h: PropTypes.string,
    meridiem: PropTypes.string,
    minutes: PropTypes.string,
    month: PropTypes.string,
    monthShort: PropTypes.string,
    normalDate: PropTypes.string,
    normalDateWithWeekday: PropTypes.string,
    seconds: PropTypes.string,
    shortDate: PropTypes.string,
    weekday: PropTypes.string,
    weekdayShort: PropTypes.string,
    year: PropTypes.string
  }),
  /**
   * Date library instance you are using, if it has some global overrides
   * ```jsx
   * dateLibInstance={momentTimeZone}
   * ```
   */
  dateLibInstance: PropTypes.any,
  /**
   * Locale for components texts
   */
  localeText: PropTypes.object
});
const useLocalizationContext = () => {
  const e = React.useContext(PickerAdapterContext);
  if (e === null)
    throw new Error(["MUI X: Can not find the date and time pickers localization context.", "It looks like you forgot to wrap your component in LocalizationProvider.", "This can also happen if you are bundling multiple versions of the `@mui/x-date-pickers` package"].join(`
`));
  if (e.adapter === null)
    throw new Error(["MUI X: Can not find the date and time pickers adapter from its localization context.", "It looks like you forgot to pass a `dateAdapter` to your LocalizationProvider."].join(`
`));
  const t = React.useMemo(() => _extends({}, DEFAULT_LOCALE, e.localeText), [e.localeText]);
  return React.useMemo(() => _extends({}, e, {
    localeText: t
  }), [e, t]);
}, usePickerAdapter = () => useLocalizationContext().adapter, usePickerTranslations = () => useLocalizationContext().localeText, DATE_VALIDATION_PROP_NAMES = ["disablePast", "disableFuture", "minDate", "maxDate", "shouldDisableDate", "shouldDisableMonth", "shouldDisableYear"], TIME_VALIDATION_PROP_NAMES = ["disablePast", "disableFuture", "minTime", "maxTime", "shouldDisableTime", "minutesStep", "ampm", "disableIgnoringDatePartForTimeValidation"], DATE_TIME_VALIDATION_PROP_NAMES = ["minDateTime", "maxDateTime"], VALIDATION_PROP_NAMES = [...DATE_VALIDATION_PROP_NAMES, ...TIME_VALIDATION_PROP_NAMES, ...DATE_TIME_VALIDATION_PROP_NAMES], extractValidationProps = (e) => VALIDATION_PROP_NAMES.reduce((t, o) => (e.hasOwnProperty(o) && (t[o] = e[o]), t), {}), SHARED_FIELD_INTERNAL_PROP_NAMES = ["value", "defaultValue", "referenceDate", "format", "formatDensity", "onChange", "timezone", "onError", "shouldRespectLeadingZeros", "selectedSections", "onSelectedSectionsChange", "unstableFieldRef", "unstableStartFieldRef", "unstableEndFieldRef", "enableAccessibleFieldDOMStructure", "disabled", "readOnly", "dateSeparator", "autoFocus", "focused"], useSplitFieldProps = (e, t) => React.useMemo(() => {
  const o = _extends({}, e), n = {}, s = (i) => {
    o.hasOwnProperty(i) && (n[i] = o[i], delete o[i]);
  };
  return SHARED_FIELD_INTERNAL_PROP_NAMES.forEach(s), t === "date" ? DATE_VALIDATION_PROP_NAMES.forEach(s) : t === "time" ? TIME_VALIDATION_PROP_NAMES.forEach(s) : t === "date-time" && (DATE_VALIDATION_PROP_NAMES.forEach(s), TIME_VALIDATION_PROP_NAMES.forEach(s), DATE_TIME_VALIDATION_PROP_NAMES.forEach(s)), {
    forwardedProps: o,
    internalProps: n
  };
}, [e, t]), areViewsEqual = (e, t) => e.length !== t.length ? !1 : t.every((o) => e.includes(o)), applyDefaultViewProps = ({
  openTo: e,
  defaultOpenTo: t,
  views: o,
  defaultViews: n
}) => {
  const s = o ?? n;
  let i;
  if (e != null)
    i = e;
  else if (s.includes(t))
    i = t;
  else if (s.length > 0)
    i = s[0];
  else
    throw new Error("MUI X: The `views` prop must contain at least one view.");
  return {
    views: s,
    openTo: i
  };
}, mergeDateAndTime = (e, t, o) => {
  let n = t;
  return n = e.setHours(n, e.getHours(o)), n = e.setMinutes(n, e.getMinutes(o)), n = e.setSeconds(n, e.getSeconds(o)), n = e.setMilliseconds(n, e.getMilliseconds(o)), n;
}, findClosestEnabledDate = ({
  date: e,
  disableFuture: t,
  disablePast: o,
  maxDate: n,
  minDate: s,
  isDateDisabled: i,
  adapter: l,
  timezone: d
}) => {
  const u = mergeDateAndTime(l, l.date(void 0, d), e);
  o && l.isBefore(s, u) && (s = u), t && l.isAfter(n, u) && (n = u);
  let c = e, p = e;
  for (l.isBefore(e, s) && (c = s, p = null), l.isAfter(e, n) && (p && (p = n), c = null); c || p; ) {
    if (c && l.isAfter(c, n) && (c = null), p && l.isBefore(p, s) && (p = null), c) {
      if (!i(c))
        return c;
      c = l.addDays(c, 1);
    }
    if (p) {
      if (!i(p))
        return p;
      p = l.addDays(p, -1);
    }
  }
  return null;
}, replaceInvalidDateByNull = (e, t) => e.isValid(t) ? t : null, applyDefaultDate = (e, t, o) => t == null || !e.isValid(t) ? o : t, areDatesEqual = (e, t, o) => !e.isValid(t) && t != null && !e.isValid(o) && o != null ? !0 : e.isEqual(t, o), getMonthsInYear = (e, t) => {
  const n = [e.startOfYear(t)];
  for (; n.length < 12; ) {
    const s = n[n.length - 1];
    n.push(e.addMonths(s, 1));
  }
  return n;
}, getTodayDate = (e, t, o) => o === "date" ? e.startOfDay(e.date(void 0, t)) : e.date(void 0, t), DATE_VIEWS = ["year", "month", "day"], isDatePickerView = (e) => DATE_VIEWS.includes(e), resolveDateFormat = (e, {
  format: t,
  views: o
}, n) => {
  if (t != null)
    return t;
  const s = e.formats;
  return areViewsEqual(o, ["year"]) ? s.year : areViewsEqual(o, ["month"]) ? s.month : areViewsEqual(o, ["day"]) ? s.dayOfMonth : areViewsEqual(o, ["month", "year"]) ? `${s.month} ${s.year}` : areViewsEqual(o, ["day", "month"]) ? `${s.month} ${s.dayOfMonth}` : n ? /en/.test(e.getCurrentLocaleCode()) ? s.normalDateWithWeekday : s.normalDate : s.keyboardDate;
}, getWeekdays = (e, t) => {
  const o = e.startOfWeek(t);
  return [0, 1, 2, 3, 4, 5, 6].map((n) => e.addDays(o, n));
}, getDateSectionConfigFromFormatToken = (e, t) => {
  const o = e.formatTokenMap[t];
  if (o == null)
    throw new Error([`MUI X: The token "${t}" is not supported by the Date and Time Pickers.`, "Please try using another token or open an issue on https://github.com/mui/mui-x/issues/new/choose if you think it should be supported."].join(`
`));
  return typeof o == "string" ? {
    type: o,
    contentType: o === "meridiem" ? "letter" : "digit",
    maxLength: void 0
  } : {
    type: o.sectionType,
    contentType: o.contentType,
    maxLength: o.maxLength
  };
}, getDaysInWeekStr = (e, t) => {
  const o = [], n = e.date(void 0, "default"), s = e.startOfWeek(n), i = e.endOfWeek(n);
  let l = s;
  for (; e.isBefore(l, i); )
    o.push(l), l = e.addDays(l, 1);
  return o.map((d) => e.formatByString(d, t));
}, getLetterEditingOptions = (e, t, o, n) => {
  switch (o) {
    case "month":
      return getMonthsInYear(e, e.date(void 0, t)).map((s) => e.formatByString(s, n));
    case "weekDay":
      return getDaysInWeekStr(e, n);
    case "meridiem": {
      const s = e.date(void 0, t);
      return [e.startOfDay(s), e.endOfDay(s)].map((i) => e.formatByString(i, n));
    }
    default:
      return [];
  }
}, FORMAT_SECONDS_NO_LEADING_ZEROS = "s", NON_LOCALIZED_DIGITS = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"], getLocalizedDigits = (e) => {
  const t = e.date(void 0);
  return e.formatByString(e.setSeconds(t, 0), FORMAT_SECONDS_NO_LEADING_ZEROS) === "0" ? NON_LOCALIZED_DIGITS : Array.from({
    length: 10
  }).map((n, s) => e.formatByString(e.setSeconds(t, s), FORMAT_SECONDS_NO_LEADING_ZEROS));
}, removeLocalizedDigits = (e, t) => {
  if (t[0] === "0")
    return e;
  const o = [];
  let n = "";
  for (let s = 0; s < e.length; s += 1) {
    n += e[s];
    const i = t.indexOf(n);
    i > -1 && (o.push(i.toString()), n = "");
  }
  return o.join("");
}, applyLocalizedDigits = (e, t) => t[0] === "0" ? e : e.split("").map((o) => t[Number(o)]).join(""), isStringNumber = (e, t) => {
  const o = removeLocalizedDigits(e, t);
  return o !== " " && !Number.isNaN(Number(o));
}, cleanLeadingZeros = (e, t) => Number(e).toString().padStart(t, "0"), cleanDigitSectionValue = (e, t, o, n, s) => {
  if (process.env.NODE_ENV !== "production" && s.type !== "day" && s.contentType === "digit-with-letter")
    throw new Error([`MUI X: The token "${s.format}" is a digit format with letter in it.'
             This type of format is only supported for 'day' sections`].join(`
`));
  if (s.type === "day" && s.contentType === "digit-with-letter") {
    const l = e.setDate(o.longestMonth, t);
    return e.formatByString(l, s.format);
  }
  let i = t.toString();
  return s.hasLeadingZerosInInput && (i = cleanLeadingZeros(i, s.maxLength)), applyLocalizedDigits(i, n);
}, getSectionVisibleValue = (e, t, o) => {
  let n = e.value || e.placeholder;
  const s = t === "non-input" ? e.hasLeadingZerosInFormat : e.hasLeadingZerosInInput;
  return t === "non-input" && e.hasLeadingZerosInInput && !e.hasLeadingZerosInFormat && (n = Number(removeLocalizedDigits(n, o)).toString()), ["input-rtl", "input-ltr"].includes(t) && e.contentType === "digit" && !s && n.length === 1 && (n = `${n}‎`), t === "input-rtl" && (n = `⁨${n}⁩`), n;
}, changeSectionValueFormat = (e, t, o, n) => {
  if (process.env.NODE_ENV !== "production" && getDateSectionConfigFromFormatToken(e, o).type === "weekDay")
    throw new Error("changeSectionValueFormat doesn't support week day formats");
  return e.formatByString(e.parse(t, o), n);
}, isFourDigitYearFormat = (e, t) => e.formatByString(e.date(void 0, "system"), t).length === 4, doesSectionFormatHaveLeadingZeros = (e, t, o, n) => {
  if (t !== "digit")
    return !1;
  const s = e.date(void 0, "default");
  switch (o) {
    // We can't use `changeSectionValueFormat`, because  `adapter.parse('1', 'YYYY')` returns `1971` instead of `1`.
    case "year":
      return e.lib === "dayjs" && n === "YY" ? !0 : e.formatByString(e.setYear(s, 1), n).startsWith("0");
    case "month":
      return e.formatByString(e.startOfYear(s), n).length > 1;
    case "day":
      return e.formatByString(e.startOfMonth(s), n).length > 1;
    case "weekDay":
      return e.formatByString(e.startOfWeek(s), n).length > 1;
    case "hours":
      return e.formatByString(e.setHours(s, 1), n).length > 1;
    case "minutes":
      return e.formatByString(e.setMinutes(s, 1), n).length > 1;
    case "seconds":
      return e.formatByString(e.setSeconds(s, 1), n).length > 1;
    default:
      throw new Error("Invalid section type");
  }
}, getDateFromDateSections = (e, t, o) => {
  const n = t.some((u) => u.type === "day"), s = [], i = [];
  for (let u = 0; u < t.length; u += 1) {
    const c = t[u];
    n && c.type === "weekDay" || (s.push(c.format), i.push(getSectionVisibleValue(c, "non-input", o)));
  }
  const l = s.join(" "), d = i.join(" ");
  return e.parse(d, l);
}, createDateStrForV7HiddenInputFromSections = (e) => e.map((t) => `${t.startSeparator}${t.value || t.placeholder}${t.endSeparator}`).join(""), createDateStrForV6InputFromSections = (e, t, o) => {
  const s = e.map((i) => {
    const l = getSectionVisibleValue(i, o ? "input-rtl" : "input-ltr", t);
    return `${i.startSeparator}${l}${i.endSeparator}`;
  }).join("");
  return o ? `⁦${s}⁩` : s;
}, getSectionsBoundaries = (e, t, o) => {
  const n = e.date(void 0, o), s = e.endOfYear(n), i = e.endOfDay(n), {
    maxDaysInMonth: l,
    longestMonth: d
  } = getMonthsInYear(e, n).reduce((u, c) => {
    const p = e.getDaysInMonth(c);
    return p > u.maxDaysInMonth ? {
      maxDaysInMonth: p,
      longestMonth: c
    } : u;
  }, {
    maxDaysInMonth: 0,
    longestMonth: null
  });
  return {
    year: ({
      format: u
    }) => ({
      minimum: 0,
      maximum: isFourDigitYearFormat(e, u) ? 9999 : 99
    }),
    month: () => ({
      minimum: 1,
      // Assumption: All years have the same amount of months
      maximum: e.getMonth(s) + 1
    }),
    day: ({
      currentDate: u
    }) => ({
      minimum: 1,
      maximum: e.isValid(u) ? e.getDaysInMonth(u) : l,
      longestMonth: d
    }),
    weekDay: ({
      format: u,
      contentType: c
    }) => {
      if (c === "digit") {
        const p = getDaysInWeekStr(e, u).map(Number);
        return {
          minimum: Math.min(...p),
          maximum: Math.max(...p)
        };
      }
      return {
        minimum: 1,
        maximum: 7
      };
    },
    hours: ({
      format: u
    }) => {
      const c = e.getHours(i);
      return removeLocalizedDigits(e.formatByString(e.endOfDay(n), u), t) !== c.toString() ? {
        minimum: 1,
        maximum: Number(removeLocalizedDigits(e.formatByString(e.startOfDay(n), u), t))
      } : {
        minimum: 0,
        maximum: c
      };
    },
    minutes: () => ({
      minimum: 0,
      // Assumption: All years have the same amount of minutes
      maximum: e.getMinutes(i)
    }),
    seconds: () => ({
      minimum: 0,
      // Assumption: All years have the same amount of seconds
      maximum: e.getSeconds(i)
    }),
    meridiem: () => ({
      minimum: 0,
      maximum: 1
    }),
    empty: () => ({
      minimum: 0,
      maximum: 0
    })
  };
};
let warnedOnceInvalidSection = !1;
const validateSections = (e, t) => {
  if (process.env.NODE_ENV !== "production" && !warnedOnceInvalidSection) {
    const o = ["empty"];
    ["date", "date-time"].includes(t) && o.push("weekDay", "day", "month", "year"), ["time", "date-time"].includes(t) && o.push("hours", "minutes", "seconds", "meridiem");
    const n = e.find((s) => !o.includes(s.type));
    n && (console.warn(`MUI X: The field component you are using is not compatible with the "${n.type}" date section.`, `The supported date sections are ["${o.join('", "')}"]\`.`), warnedOnceInvalidSection = !0);
  }
}, transferDateSectionValue = (e, t, o, n) => {
  switch (t.type) {
    case "year":
      return e.setYear(n, e.getYear(o));
    case "month":
      return e.setMonth(n, e.getMonth(o));
    case "weekDay": {
      let s = e.formatByString(o, t.format);
      t.hasLeadingZerosInInput && (s = cleanLeadingZeros(s, t.maxLength));
      const i = getDaysInWeekStr(e, t.format), l = i.indexOf(s), u = i.indexOf(t.value) - l;
      return e.addDays(o, u);
    }
    case "day":
      return e.setDate(n, e.getDate(o));
    case "meridiem": {
      const s = e.getHours(o) < 12, i = e.getHours(n);
      return s && i >= 12 ? e.addHours(n, -12) : !s && i < 12 ? e.addHours(n, 12) : n;
    }
    case "hours":
      return e.setHours(n, e.getHours(o));
    case "minutes":
      return e.setMinutes(n, e.getMinutes(o));
    case "seconds":
      return e.setSeconds(n, e.getSeconds(o));
    default:
      return n;
  }
}, reliableSectionModificationOrder = {
  year: 1,
  month: 2,
  day: 3,
  weekDay: 4,
  hours: 5,
  minutes: 6,
  seconds: 7,
  meridiem: 8,
  empty: 9
}, mergeDateIntoReferenceDate = (e, t, o, n, s) => (
  // cloning sections before sort to avoid mutating it
  [...o].sort((i, l) => reliableSectionModificationOrder[i.type] - reliableSectionModificationOrder[l.type]).reduce((i, l) => !s || l.modified ? transferDateSectionValue(e, l, t, i) : i, n)
), isAndroid = () => navigator.userAgent.toLowerCase().includes("android"), getSectionOrder = (e, t) => {
  const o = {};
  if (!t)
    return e.forEach((u, c) => {
      const p = c === 0 ? null : c - 1, f = c === e.length - 1 ? null : c + 1;
      o[c] = {
        leftIndex: p,
        rightIndex: f
      };
    }), {
      neighbors: o,
      startIndex: 0,
      endIndex: e.length - 1
    };
  const n = {}, s = {};
  let i = 0, l = 0, d = e.length - 1;
  for (; d >= 0; ) {
    l = e.findIndex(
      // eslint-disable-next-line @typescript-eslint/no-loop-func
      (u, c) => c >= i && u.endSeparator?.includes(" ") && // Special case where the spaces were not there in the initial input
      u.endSeparator !== " / "
    ), l === -1 && (l = e.length - 1);
    for (let u = l; u >= i; u -= 1)
      s[u] = d, n[d] = u, d -= 1;
    i = l + 1;
  }
  return e.forEach((u, c) => {
    const p = s[c], f = p === 0 ? null : n[p - 1], g = p === e.length - 1 ? null : n[p + 1];
    o[c] = {
      leftIndex: f,
      rightIndex: g
    };
  }), {
    neighbors: o,
    startIndex: n[0],
    endIndex: n[e.length - 1]
  };
}, parseSelectedSections = (e, t) => {
  if (e == null)
    return null;
  if (e === "all")
    return "all";
  if (typeof e == "string") {
    const o = t.findIndex((n) => n.type === e);
    return o === -1 ? null : o;
  }
  return e;
}, expandFormat = ({
  adapter: e,
  format: t
}) => {
  let o = 10, n = t, s = e.expandFormat(t);
  for (; s !== n; )
    if (n = s, s = e.expandFormat(n), o -= 1, o < 0)
      throw new Error("MUI X: The format expansion seems to be in an infinite loop. Please open an issue with the format passed to the component.");
  return s;
}, getEscapedPartsFromFormat = ({
  adapter: e,
  expandedFormat: t
}) => {
  const o = [], {
    start: n,
    end: s
  } = e.escapedCharacters, i = new RegExp(`(\\${n}[^\\${s}]*\\${s})+`, "g");
  let l = null;
  for (; l = i.exec(t); )
    o.push({
      start: l.index,
      end: i.lastIndex - 1
    });
  return o;
}, getSectionPlaceholder = (e, t, o, n) => {
  switch (o.type) {
    case "year":
      return t.fieldYearPlaceholder({
        digitAmount: e.formatByString(e.date(void 0, "default"), n).length,
        format: n
      });
    case "month":
      return t.fieldMonthPlaceholder({
        contentType: o.contentType,
        format: n
      });
    case "day":
      return t.fieldDayPlaceholder({
        format: n
      });
    case "weekDay":
      return t.fieldWeekDayPlaceholder({
        contentType: o.contentType,
        format: n
      });
    case "hours":
      return t.fieldHoursPlaceholder({
        format: n
      });
    case "minutes":
      return t.fieldMinutesPlaceholder({
        format: n
      });
    case "seconds":
      return t.fieldSecondsPlaceholder({
        format: n
      });
    case "meridiem":
      return t.fieldMeridiemPlaceholder({
        format: n
      });
    default:
      return n;
  }
}, createSection = ({
  adapter: e,
  date: t,
  shouldRespectLeadingZeros: o,
  localeText: n,
  localizedDigits: s,
  now: i,
  token: l,
  startSeparator: d
}) => {
  if (l === "")
    throw new Error("MUI X: Should not call `commitToken` with an empty token");
  const u = getDateSectionConfigFromFormatToken(e, l), c = doesSectionFormatHaveLeadingZeros(e, u.contentType, u.type, l), p = o ? c : u.contentType === "digit", f = e.isValid(t);
  let g = f ? e.formatByString(t, l) : "", y = null;
  if (p)
    if (c)
      y = g === "" ? e.formatByString(i, l).length : g.length;
    else {
      if (u.maxLength == null)
        throw new Error(`MUI X: The token ${l} should have a 'maxLength' property on it's adapter`);
      y = u.maxLength, f && (g = applyLocalizedDigits(cleanLeadingZeros(removeLocalizedDigits(g, s), y), s));
    }
  return _extends({}, u, {
    format: l,
    maxLength: y,
    value: g,
    placeholder: getSectionPlaceholder(e, n, u, l),
    hasLeadingZerosInFormat: c,
    hasLeadingZerosInInput: p,
    startSeparator: d,
    endSeparator: "",
    modified: !1
  });
}, buildSections = (e) => {
  const {
    adapter: t,
    expandedFormat: o,
    escapedParts: n
  } = e, s = t.date(void 0), i = [];
  let l = "";
  const d = Object.keys(t.formatTokenMap).sort((y, h) => h.length - y.length), u = /^([a-zA-Z]+)/, c = new RegExp(`^(${d.join("|")})*$`), p = new RegExp(`^(${d.join("|")})`), f = (y) => n.find((h) => h.start <= y && h.end >= y);
  let g = 0;
  for (; g < o.length; ) {
    const y = f(g), h = y != null, T = u.exec(o.slice(g))?.[1];
    if (!h && T != null && c.test(T)) {
      let P = T;
      for (; P.length > 0; ) {
        const E = p.exec(P)[1];
        P = P.slice(E.length), i.push(createSection(_extends({}, e, {
          now: s,
          token: E,
          startSeparator: l
        }))), l = "";
      }
      g += T.length;
    } else {
      const P = o[g];
      h && y?.start === g || y?.end === g || (i.length === 0 ? l += P : (i[i.length - 1].endSeparator += P, i[i.length - 1].isEndFormatSeparator = !0)), g += 1;
    }
  }
  return i.length === 0 && l.length > 0 && i.push({
    type: "empty",
    contentType: "letter",
    maxLength: null,
    format: "",
    value: "",
    placeholder: "",
    hasLeadingZerosInFormat: !1,
    hasLeadingZerosInInput: !1,
    startSeparator: l,
    endSeparator: "",
    modified: !1
  }), i;
}, postProcessSections = ({
  isRtl: e,
  formatDensity: t,
  sections: o
}) => o.map((n) => {
  const s = (i) => {
    let l = i;
    return e && l !== null && l.includes(" ") && (l = `⁩${l}⁦`), t === "spacious" && ["/", ".", "-"].includes(l) && (l = ` ${l} `), l;
  };
  return n.startSeparator = s(n.startSeparator), n.endSeparator = s(n.endSeparator), n;
}), buildSectionsFromFormat = (e) => {
  let t = expandFormat(e);
  e.isRtl && e.enableAccessibleFieldDOMStructure && (t = t.split(" ").reverse().join(" "));
  const o = getEscapedPartsFromFormat(_extends({}, e, {
    expandedFormat: t
  })), n = buildSections(_extends({}, e, {
    expandedFormat: t,
    escapedParts: o
  }));
  return postProcessSections(_extends({}, e, {
    sections: n
  }));
}, PickerContext = /* @__PURE__ */ React.createContext(null);
process.env.NODE_ENV !== "production" && (PickerContext.displayName = "PickerContext");
const usePickerContext = () => {
  const e = React.useContext(PickerContext);
  if (e == null)
    throw new Error("MUI X: The `usePickerContext` hook can only be called inside the context of a Picker component");
  return e;
}, useNullablePickerContext = () => React.useContext(PickerContext), IsValidValueContext = /* @__PURE__ */ React.createContext(() => !0);
process.env.NODE_ENV !== "production" && (IsValidValueContext.displayName = "IsValidValueContext");
function useIsValidValue() {
  return React.useContext(IsValidValueContext);
}
const PickerFieldPrivateContext = /* @__PURE__ */ React.createContext(null);
process.env.NODE_ENV !== "production" && (PickerFieldPrivateContext.displayName = "PickerFieldPrivateContext");
function useNullableFieldPrivateContext() {
  return React.useContext(PickerFieldPrivateContext);
}
const PickerActionsContext = /* @__PURE__ */ React.createContext(null);
process.env.NODE_ENV !== "production" && (PickerActionsContext.displayName = "PickerActionsContext");
const PickerPrivateContext = /* @__PURE__ */ React.createContext({
  ownerState: {
    isPickerDisabled: !1,
    isPickerReadOnly: !1,
    isPickerValueEmpty: !1,
    isPickerOpen: !1,
    pickerVariant: "desktop",
    pickerOrientation: "portrait"
  },
  rootRefObject: {
    current: null
  },
  labelId: void 0,
  dismissViews: () => {
  },
  hasUIView: !0,
  getCurrentViewMode: () => "UI",
  triggerElement: null,
  viewContainerRole: null,
  defaultActionBarActions: [],
  onPopperExited: void 0
});
process.env.NODE_ENV !== "production" && (PickerPrivateContext.displayName = "PickerPrivateContext");
function PickerProvider(e) {
  const {
    contextValue: t,
    actionsContextValue: o,
    privateContextValue: n,
    fieldPrivateContextValue: s,
    isValidContextValue: i,
    localeText: l,
    children: d
  } = e;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(PickerContext.Provider, {
    value: t,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(PickerActionsContext.Provider, {
      value: o,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(PickerPrivateContext.Provider, {
        value: n,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(PickerFieldPrivateContext.Provider, {
          value: s,
          children: /* @__PURE__ */ jsxRuntimeExports.jsx(IsValidValueContext.Provider, {
            value: i,
            children: /* @__PURE__ */ jsxRuntimeExports.jsx(LocalizationProvider, {
              localeText: l,
              children: d
            })
          })
        })
      })
    })
  });
}
const usePickerActionsContext = () => {
  const e = React.useContext(PickerActionsContext);
  if (e == null)
    throw new Error(["MUI X: The `usePickerActionsContext` can only be called in fields that are used as a slot of a Picker component"].join(`
`));
  return e;
}, useDefaultDates = () => useLocalizationContext().defaultDates, useNow = (e) => {
  const t = usePickerAdapter(), o = React.useRef(void 0);
  return o.current === void 0 && (o.current = t.date(void 0, e)), o.current;
};
function hasCorrectMainProperty(e) {
  return typeof e.main == "string";
}
function checkSimplePaletteColorValues(e, t = []) {
  if (!hasCorrectMainProperty(e))
    return !1;
  for (const o of t)
    if (!e.hasOwnProperty(o) || typeof e[o] != "string")
      return !1;
  return !0;
}
function createSimplePaletteValueFilter(e = []) {
  return ([, t]) => t && checkSimplePaletteColorValues(t, e);
}
function getTypographyUtilityClass(e) {
  return generateUtilityClass("MuiTypography", e);
}
generateUtilityClasses("MuiTypography", ["root", "h1", "h2", "h3", "h4", "h5", "h6", "subtitle1", "subtitle2", "body1", "body2", "inherit", "button", "caption", "overline", "alignLeft", "alignRight", "alignCenter", "alignJustify", "noWrap", "gutterBottom", "paragraph"]);
const v6Colors = {
  primary: !0,
  secondary: !0,
  error: !0,
  info: !0,
  success: !0,
  warning: !0,
  textPrimary: !0,
  textSecondary: !0,
  textDisabled: !0
}, extendSxProp = internal_createExtendSxProp(), useUtilityClasses$Q = (e) => {
  const {
    align: t,
    gutterBottom: o,
    noWrap: n,
    paragraph: s,
    variant: i,
    classes: l
  } = e, d = {
    root: ["root", i, e.align !== "inherit" && `align${capitalize(t)}`, o && "gutterBottom", n && "noWrap", s && "paragraph"]
  };
  return composeClasses(d, getTypographyUtilityClass, l);
}, TypographyRoot = styled("span", {
  name: "MuiTypography",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.root, o.variant && t[o.variant], o.align !== "inherit" && t[`align${capitalize(o.align)}`], o.noWrap && t.noWrap, o.gutterBottom && t.gutterBottom, o.paragraph && t.paragraph];
  }
})(memoTheme(({
  theme: e
}) => ({
  margin: 0,
  variants: [{
    props: {
      variant: "inherit"
    },
    style: {
      // Some elements, like <button> on Chrome have default font that doesn't inherit, reset this.
      font: "inherit",
      lineHeight: "inherit",
      letterSpacing: "inherit"
    }
  }, ...Object.entries(e.typography).filter(([t, o]) => t !== "inherit" && o && typeof o == "object").map(([t, o]) => ({
    props: {
      variant: t
    },
    style: o
  })), ...Object.entries(e.palette).filter(createSimplePaletteValueFilter()).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      color: (e.vars || e).palette[t].main
    }
  })), ...Object.entries(e.palette?.text || {}).filter(([, t]) => typeof t == "string").map(([t]) => ({
    props: {
      color: `text${capitalize(t)}`
    },
    style: {
      color: (e.vars || e).palette.text[t]
    }
  })), {
    props: ({
      ownerState: t
    }) => t.align !== "inherit",
    style: {
      textAlign: "var(--Typography-textAlign)"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.noWrap,
    style: {
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.gutterBottom,
    style: {
      marginBottom: "0.35em"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.paragraph,
    style: {
      marginBottom: 16
    }
  }]
}))), defaultVariantMapping = {
  h1: "h1",
  h2: "h2",
  h3: "h3",
  h4: "h4",
  h5: "h5",
  h6: "h6",
  subtitle1: "h6",
  subtitle2: "h6",
  body1: "p",
  body2: "p",
  inherit: "p"
}, Typography = /* @__PURE__ */ React.forwardRef(function e(t, o) {
  const {
    color: n,
    ...s
  } = useDefaultProps({
    props: t,
    name: "MuiTypography"
  }), i = !v6Colors[n], l = extendSxProp({
    ...s,
    ...i && {
      color: n
    }
  }), {
    align: d = "inherit",
    className: u,
    component: c,
    gutterBottom: p = !1,
    noWrap: f = !1,
    paragraph: g = !1,
    variant: y = "body1",
    variantMapping: h = defaultVariantMapping,
    ...T
  } = l, P = {
    ...l,
    align: d,
    color: n,
    className: u,
    component: c,
    gutterBottom: p,
    noWrap: f,
    paragraph: g,
    variant: y,
    variantMapping: h
  }, E = c || (g ? "p" : h[y] || defaultVariantMapping[y]) || "span", $ = useUtilityClasses$Q(P);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(TypographyRoot, {
    as: E,
    ref: o,
    className: clsx($.root, u),
    ...T,
    ownerState: P,
    style: {
      ...d !== "inherit" && {
        "--Typography-textAlign": d
      },
      ...T.style
    }
  });
});
process.env.NODE_ENV !== "production" && (Typography.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Set the text-align on the component.
   * @default 'inherit'
   */
  align: PropTypes.oneOf(["center", "inherit", "justify", "left", "right"]),
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["primary", "secondary", "success", "error", "info", "warning", "textPrimary", "textSecondary", "textDisabled"]), PropTypes.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * If `true`, the text will have a bottom margin.
   * @default false
   */
  gutterBottom: PropTypes.bool,
  /**
   * If `true`, the text will not wrap, but instead will truncate with a text overflow ellipsis.
   *
   * Note that text overflow can only happen with block or inline-block level elements
   * (the element needs to have a width in order to overflow).
   * @default false
   */
  noWrap: PropTypes.bool,
  /**
   * If `true`, the element will be a paragraph element.
   * @default false
   * @deprecated Use the `component` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  paragraph: PropTypes.bool,
  /**
   * @ignore
   */
  style: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Applies the theme typography styles.
   * @default 'body1'
   */
  variant: PropTypes.oneOfType([PropTypes.oneOf(["body1", "body2", "button", "caption", "h1", "h2", "h3", "h4", "h5", "h6", "inherit", "overline", "subtitle1", "subtitle2"]), PropTypes.string]),
  /**
   * The component maps the variant prop to a range of different HTML element types.
   * For instance, subtitle1 to `<h6>`.
   * If you wish to change that mapping, you can provide your own.
   * Alternatively, you can use the `component` prop.
   * @default {
   *   h1: 'h1',
   *   h2: 'h2',
   *   h3: 'h3',
   *   h4: 'h4',
   *   h5: 'h5',
   *   h6: 'h6',
   *   subtitle1: 'h6',
   *   subtitle2: 'h6',
   *   body1: 'p',
   *   body2: 'p',
   *   inherit: 'p',
   * }
   */
  variantMapping: PropTypes.object
});
function isHostComponent(e) {
  return typeof e == "string";
}
function appendOwnerState(e, t, o) {
  return e === void 0 || isHostComponent(e) ? t : {
    ...t,
    ownerState: {
      ...t.ownerState,
      ...o
    }
  };
}
function extractEventHandlers(e, t = []) {
  if (e === void 0)
    return {};
  const o = {};
  return Object.keys(e).filter((n) => n.match(/^on[A-Z]/) && typeof e[n] == "function" && !t.includes(n)).forEach((n) => {
    o[n] = e[n];
  }), o;
}
function omitEventHandlers(e) {
  if (e === void 0)
    return {};
  const t = {};
  return Object.keys(e).filter((o) => !(o.match(/^on[A-Z]/) && typeof e[o] == "function")).forEach((o) => {
    t[o] = e[o];
  }), t;
}
function mergeSlotProps$1(e) {
  const {
    getSlotProps: t,
    additionalProps: o,
    externalSlotProps: n,
    externalForwardedProps: s,
    className: i
  } = e;
  if (!t) {
    const y = clsx(o?.className, i, s?.className, n?.className), h = {
      ...o?.style,
      ...s?.style,
      ...n?.style
    }, T = {
      ...o,
      ...s,
      ...n
    };
    return y.length > 0 && (T.className = y), Object.keys(h).length > 0 && (T.style = h), {
      props: T,
      internalRef: void 0
    };
  }
  const l = extractEventHandlers({
    ...s,
    ...n
  }), d = omitEventHandlers(n), u = omitEventHandlers(s), c = t(l), p = clsx(c?.className, o?.className, i, s?.className, n?.className), f = {
    ...c?.style,
    ...o?.style,
    ...s?.style,
    ...n?.style
  }, g = {
    ...c,
    ...o,
    ...u,
    ...d
  };
  return p.length > 0 && (g.className = p), Object.keys(f).length > 0 && (g.style = f), {
    props: g,
    internalRef: c.ref
  };
}
function resolveComponentProps(e, t, o) {
  return typeof e == "function" ? e(t, o) : e;
}
function useSlotProps(e) {
  const {
    elementType: t,
    externalSlotProps: o,
    ownerState: n,
    skipResolvingSlotProps: s = !1,
    ...i
  } = e, l = s ? {} : resolveComponentProps(o, n), {
    props: d,
    internalRef: u
  } = mergeSlotProps$1({
    ...i,
    externalSlotProps: l
  }), c = useForkRef(u, l?.ref, e.additionalProps?.ref);
  return appendOwnerState(t, {
    ...d,
    ref: c
  }, n);
}
function chainPropTypes(e, t) {
  return process.env.NODE_ENV === "production" ? () => null : function(...n) {
    return e(...n) || t(...n);
  };
}
const refType = PropTypes.oneOfType([PropTypes.func, PropTypes.object]);
function isClassComponent$1(e) {
  const {
    prototype: t = {}
  } = e;
  return !!t.isReactComponent;
}
function elementTypeAcceptingRef(e, t, o, n, s) {
  const i = e[t], l = s || t;
  if (i == null || // When server-side rendering React doesn't warn either.
  // This is not an accurate check for SSR.
  // This is only in place for emotion compat.
  // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
  typeof window > "u")
    return null;
  let d;
  return typeof i == "function" && !isClassComponent$1(i) && (d = "Did you accidentally provide a plain function component instead?"), i === React.Fragment && (d = "Did you accidentally provide a React.Fragment instead?"), d !== void 0 ? new Error(`Invalid ${n} \`${l}\` supplied to \`${o}\`. Expected an element type that can hold a ref. ${d} For more information see https://mui.com/r/caveat-with-refs-guide`) : null;
}
const elementTypeAcceptingRef$1 = chainPropTypes(PropTypes.elementType, elementTypeAcceptingRef);
function isFocusVisible(e) {
  try {
    return e.matches(":focus-visible");
  } catch {
    process.env.NODE_ENV !== "production" && !window.navigator.userAgent.includes("jsdom") && console.warn(["MUI: The `:focus-visible` pseudo class is not supported in this browser.", "Some components rely on this feature to work properly."].join(`
`));
  }
  return !1;
}
const UNINITIALIZED = {};
function useLazyRef(e, t) {
  const o = React.useRef(UNINITIALIZED);
  return o.current === UNINITIALIZED && (o.current = e(t)), o;
}
class LazyRipple {
  /** React ref to the ripple instance */
  /** If the ripple component should be mounted */
  /** Promise that resolves when the ripple component is mounted */
  /** If the ripple component has been mounted */
  /** React state hook setter */
  static create() {
    return new LazyRipple();
  }
  static use() {
    const t = useLazyRef(LazyRipple.create).current, [o, n] = React.useState(!1);
    return t.shouldMount = o, t.setShouldMount = n, React.useEffect(t.mountEffect, [o]), t;
  }
  constructor() {
    this.ref = {
      current: null
    }, this.mounted = null, this.didMount = !1, this.shouldMount = !1, this.setShouldMount = null;
  }
  mount() {
    return this.mounted || (this.mounted = createControlledPromise(), this.shouldMount = !0, this.setShouldMount(this.shouldMount)), this.mounted;
  }
  mountEffect = () => {
    this.shouldMount && !this.didMount && this.ref.current !== null && (this.didMount = !0, this.mounted.resolve());
  };
  /* Ripple API */
  start(...t) {
    this.mount().then(() => this.ref.current?.start(...t));
  }
  stop(...t) {
    this.mount().then(() => this.ref.current?.stop(...t));
  }
  pulsate(...t) {
    this.mount().then(() => this.ref.current?.pulsate(...t));
  }
}
function useLazyRipple() {
  return LazyRipple.use();
}
function createControlledPromise() {
  let e, t;
  const o = new Promise((n, s) => {
    e = n, t = s;
  });
  return o.resolve = e, o.reject = t, o;
}
function _setPrototypeOf(e, t) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(o, n) {
    return o.__proto__ = n, o;
  }, _setPrototypeOf(e, t);
}
function _inheritsLoose(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, _setPrototypeOf(e, t);
}
function hasClass(e, t) {
  return e.classList ? !!t && e.classList.contains(t) : (" " + (e.className.baseVal || e.className) + " ").indexOf(" " + t + " ") !== -1;
}
function addClass(e, t) {
  e.classList ? e.classList.add(t) : hasClass(e, t) || (typeof e.className == "string" ? e.className = e.className + " " + t : e.setAttribute("class", (e.className && e.className.baseVal || "") + " " + t));
}
function replaceClassName(e, t) {
  return e.replace(new RegExp("(^|\\s)" + t + "(?:\\s|$)", "g"), "$1").replace(/\s+/g, " ").replace(/^\s*|\s*$/g, "");
}
function removeClass$1(e, t) {
  e.classList ? e.classList.remove(t) : typeof e.className == "string" ? e.className = replaceClassName(e.className, t) : e.setAttribute("class", replaceClassName(e.className && e.className.baseVal || "", t));
}
const config = {
  disabled: !1
};
var timeoutsShape = process.env.NODE_ENV !== "production" ? PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
  enter: PropTypes.number,
  exit: PropTypes.number,
  appear: PropTypes.number
}).isRequired]) : null, classNamesShape = process.env.NODE_ENV !== "production" ? PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
  enter: PropTypes.string,
  exit: PropTypes.string,
  active: PropTypes.string
}), PropTypes.shape({
  enter: PropTypes.string,
  enterDone: PropTypes.string,
  enterActive: PropTypes.string,
  exit: PropTypes.string,
  exitDone: PropTypes.string,
  exitActive: PropTypes.string
})]) : null;
const TransitionGroupContext = React__default.createContext(null);
var forceReflow = function e(t) {
  return t.scrollTop;
}, UNMOUNTED = "unmounted", EXITED = "exited", ENTERING = "entering", ENTERED = "entered", EXITING = "exiting", Transition = /* @__PURE__ */ (function(e) {
  _inheritsLoose(t, e);
  function t(n, s) {
    var i;
    i = e.call(this, n, s) || this;
    var l = s, d = l && !l.isMounting ? n.enter : n.appear, u;
    return i.appearStatus = null, n.in ? d ? (u = EXITED, i.appearStatus = ENTERING) : u = ENTERED : n.unmountOnExit || n.mountOnEnter ? u = UNMOUNTED : u = EXITED, i.state = {
      status: u
    }, i.nextCallback = null, i;
  }
  t.getDerivedStateFromProps = function(s, i) {
    var l = s.in;
    return l && i.status === UNMOUNTED ? {
      status: EXITED
    } : null;
  };
  var o = t.prototype;
  return o.componentDidMount = function() {
    this.updateStatus(!0, this.appearStatus);
  }, o.componentDidUpdate = function(s) {
    var i = null;
    if (s !== this.props) {
      var l = this.state.status;
      this.props.in ? l !== ENTERING && l !== ENTERED && (i = ENTERING) : (l === ENTERING || l === ENTERED) && (i = EXITING);
    }
    this.updateStatus(!1, i);
  }, o.componentWillUnmount = function() {
    this.cancelNextCallback();
  }, o.getTimeouts = function() {
    var s = this.props.timeout, i, l, d;
    return i = l = d = s, s != null && typeof s != "number" && (i = s.exit, l = s.enter, d = s.appear !== void 0 ? s.appear : l), {
      exit: i,
      enter: l,
      appear: d
    };
  }, o.updateStatus = function(s, i) {
    if (s === void 0 && (s = !1), i !== null)
      if (this.cancelNextCallback(), i === ENTERING) {
        if (this.props.unmountOnExit || this.props.mountOnEnter) {
          var l = this.props.nodeRef ? this.props.nodeRef.current : ReactDOM__default.findDOMNode(this);
          l && forceReflow(l);
        }
        this.performEnter(s);
      } else
        this.performExit();
    else this.props.unmountOnExit && this.state.status === EXITED && this.setState({
      status: UNMOUNTED
    });
  }, o.performEnter = function(s) {
    var i = this, l = this.props.enter, d = this.context ? this.context.isMounting : s, u = this.props.nodeRef ? [d] : [ReactDOM__default.findDOMNode(this), d], c = u[0], p = u[1], f = this.getTimeouts(), g = d ? f.appear : f.enter;
    if (!s && !l || config.disabled) {
      this.safeSetState({
        status: ENTERED
      }, function() {
        i.props.onEntered(c);
      });
      return;
    }
    this.props.onEnter(c, p), this.safeSetState({
      status: ENTERING
    }, function() {
      i.props.onEntering(c, p), i.onTransitionEnd(g, function() {
        i.safeSetState({
          status: ENTERED
        }, function() {
          i.props.onEntered(c, p);
        });
      });
    });
  }, o.performExit = function() {
    var s = this, i = this.props.exit, l = this.getTimeouts(), d = this.props.nodeRef ? void 0 : ReactDOM__default.findDOMNode(this);
    if (!i || config.disabled) {
      this.safeSetState({
        status: EXITED
      }, function() {
        s.props.onExited(d);
      });
      return;
    }
    this.props.onExit(d), this.safeSetState({
      status: EXITING
    }, function() {
      s.props.onExiting(d), s.onTransitionEnd(l.exit, function() {
        s.safeSetState({
          status: EXITED
        }, function() {
          s.props.onExited(d);
        });
      });
    });
  }, o.cancelNextCallback = function() {
    this.nextCallback !== null && (this.nextCallback.cancel(), this.nextCallback = null);
  }, o.safeSetState = function(s, i) {
    i = this.setNextCallback(i), this.setState(s, i);
  }, o.setNextCallback = function(s) {
    var i = this, l = !0;
    return this.nextCallback = function(d) {
      l && (l = !1, i.nextCallback = null, s(d));
    }, this.nextCallback.cancel = function() {
      l = !1;
    }, this.nextCallback;
  }, o.onTransitionEnd = function(s, i) {
    this.setNextCallback(i);
    var l = this.props.nodeRef ? this.props.nodeRef.current : ReactDOM__default.findDOMNode(this), d = s == null && !this.props.addEndListener;
    if (!l || d) {
      setTimeout(this.nextCallback, 0);
      return;
    }
    if (this.props.addEndListener) {
      var u = this.props.nodeRef ? [this.nextCallback] : [l, this.nextCallback], c = u[0], p = u[1];
      this.props.addEndListener(c, p);
    }
    s != null && setTimeout(this.nextCallback, s);
  }, o.render = function() {
    var s = this.state.status;
    if (s === UNMOUNTED)
      return null;
    var i = this.props, l = i.children;
    i.in, i.mountOnEnter, i.unmountOnExit, i.appear, i.enter, i.exit, i.timeout, i.addEndListener, i.onEnter, i.onEntering, i.onEntered, i.onExit, i.onExiting, i.onExited, i.nodeRef;
    var d = _objectWithoutPropertiesLoose(i, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);
    return (
      // allows for nested Transitions
      /* @__PURE__ */ React__default.createElement(TransitionGroupContext.Provider, {
        value: null
      }, typeof l == "function" ? l(s, d) : React__default.cloneElement(React__default.Children.only(l), d))
    );
  }, t;
})(React__default.Component);
Transition.contextType = TransitionGroupContext;
Transition.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */
  nodeRef: PropTypes.shape({
    current: typeof Element > "u" ? PropTypes.any : function(e, t, o, n, s, i) {
      var l = e[t];
      return PropTypes.instanceOf(l && "ownerDocument" in l ? l.ownerDocument.defaultView.Element : Element)(e, t, o, n, s, i);
    }
  }),
  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,
  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,
  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,
  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,
  /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */
  appear: PropTypes.bool,
  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,
  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,
  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function e(t) {
    var o = timeoutsShape;
    t.addEndListener || (o = o.isRequired);
    for (var n = arguments.length, s = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++)
      s[i - 1] = arguments[i];
    return o.apply(void 0, [t].concat(s));
  },
  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,
  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,
  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,
  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,
  /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,
  /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,
  /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func
} : {};
function noop$3() {
}
Transition.defaultProps = {
  in: !1,
  mountOnEnter: !1,
  unmountOnExit: !1,
  appear: !1,
  enter: !0,
  exit: !0,
  onEnter: noop$3,
  onEntering: noop$3,
  onEntered: noop$3,
  onExit: noop$3,
  onExiting: noop$3,
  onExited: noop$3
};
Transition.UNMOUNTED = UNMOUNTED;
Transition.EXITED = EXITED;
Transition.ENTERING = ENTERING;
Transition.ENTERED = ENTERED;
Transition.EXITING = EXITING;
var _addClass = function e(t, o) {
  return t && o && o.split(" ").forEach(function(n) {
    return addClass(t, n);
  });
}, removeClass = function e(t, o) {
  return t && o && o.split(" ").forEach(function(n) {
    return removeClass$1(t, n);
  });
}, CSSTransition = /* @__PURE__ */ (function(e) {
  _inheritsLoose(t, e);
  function t() {
    for (var n, s = arguments.length, i = new Array(s), l = 0; l < s; l++)
      i[l] = arguments[l];
    return n = e.call.apply(e, [this].concat(i)) || this, n.appliedClasses = {
      appear: {},
      enter: {},
      exit: {}
    }, n.onEnter = function(d, u) {
      var c = n.resolveArguments(d, u), p = c[0], f = c[1];
      n.removeClasses(p, "exit"), n.addClass(p, f ? "appear" : "enter", "base"), n.props.onEnter && n.props.onEnter(d, u);
    }, n.onEntering = function(d, u) {
      var c = n.resolveArguments(d, u), p = c[0], f = c[1], g = f ? "appear" : "enter";
      n.addClass(p, g, "active"), n.props.onEntering && n.props.onEntering(d, u);
    }, n.onEntered = function(d, u) {
      var c = n.resolveArguments(d, u), p = c[0], f = c[1], g = f ? "appear" : "enter";
      n.removeClasses(p, g), n.addClass(p, g, "done"), n.props.onEntered && n.props.onEntered(d, u);
    }, n.onExit = function(d) {
      var u = n.resolveArguments(d), c = u[0];
      n.removeClasses(c, "appear"), n.removeClasses(c, "enter"), n.addClass(c, "exit", "base"), n.props.onExit && n.props.onExit(d);
    }, n.onExiting = function(d) {
      var u = n.resolveArguments(d), c = u[0];
      n.addClass(c, "exit", "active"), n.props.onExiting && n.props.onExiting(d);
    }, n.onExited = function(d) {
      var u = n.resolveArguments(d), c = u[0];
      n.removeClasses(c, "exit"), n.addClass(c, "exit", "done"), n.props.onExited && n.props.onExited(d);
    }, n.resolveArguments = function(d, u) {
      return n.props.nodeRef ? [n.props.nodeRef.current, d] : [d, u];
    }, n.getClassNames = function(d) {
      var u = n.props.classNames, c = typeof u == "string", p = c && u ? u + "-" : "", f = c ? "" + p + d : u[d], g = c ? f + "-active" : u[d + "Active"], y = c ? f + "-done" : u[d + "Done"];
      return {
        baseClassName: f,
        activeClassName: g,
        doneClassName: y
      };
    }, n;
  }
  var o = t.prototype;
  return o.addClass = function(s, i, l) {
    var d = this.getClassNames(i)[l + "ClassName"], u = this.getClassNames("enter"), c = u.doneClassName;
    i === "appear" && l === "done" && c && (d += " " + c), l === "active" && s && forceReflow(s), d && (this.appliedClasses[i][l] = d, _addClass(s, d));
  }, o.removeClasses = function(s, i) {
    var l = this.appliedClasses[i], d = l.base, u = l.active, c = l.done;
    this.appliedClasses[i] = {}, d && removeClass(s, d), u && removeClass(s, u), c && removeClass(s, c);
  }, o.render = function() {
    var s = this.props;
    s.classNames;
    var i = _objectWithoutPropertiesLoose(s, ["classNames"]);
    return /* @__PURE__ */ React__default.createElement(Transition, _extends({}, i, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  }, t;
})(React__default.Component);
CSSTransition.defaultProps = {
  classNames: ""
};
CSSTransition.propTypes = process.env.NODE_ENV !== "production" ? _extends({}, Transition.propTypes, {
  /**
   * The animation classNames applied to the component as it appears, enters,
   * exits or has finished the transition. A single name can be provided, which
   * will be suffixed for each stage, e.g. `classNames="fade"` applies:
   *
   * - `fade-appear`, `fade-appear-active`, `fade-appear-done`
   * - `fade-enter`, `fade-enter-active`, `fade-enter-done`
   * - `fade-exit`, `fade-exit-active`, `fade-exit-done`
   *
   * A few details to note about how these classes are applied:
   *
   * 1. They are _joined_ with the ones that are already defined on the child
   *    component, so if you want to add some base styles, you can use
   *    `className` without worrying that it will be overridden.
   *
   * 2. If the transition component mounts with `in={false}`, no classes are
   *    applied yet. You might be expecting `*-exit-done`, but if you think
   *    about it, a component cannot finish exiting if it hasn't entered yet.
   *
   * 2. `fade-appear-done` and `fade-enter-done` will _both_ be applied. This
   *    allows you to define different behavior for when appearing is done and
   *    when regular entering is done, using selectors like
   *    `.fade-enter-done:not(.fade-appear-done)`. For example, you could apply
   *    an epic entrance animation when element first appears in the DOM using
   *    [Animate.css](https://daneden.github.io/animate.css/). Otherwise you can
   *    simply use `fade-enter-done` for defining both cases.
   *
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  appearDone: 'my-done-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  enterDone: 'my-done-enter',
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   *  exitDone: 'my-done-exit',
   * }}
   * ```
   *
   * If you want to set these classes using CSS Modules:
   *
   * ```js
   * import styles from './styles.css';
   * ```
   *
   * you might want to use camelCase in your CSS file, that way could simply
   * spread them instead of listing them one by one:
   *
   * ```js
   * classNames={{ ...styles }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  appearDone?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  enterDone?: string,
   *  exit?: string,
   *  exitActive?: string,
   *  exitDone?: string,
   * }}
   */
  classNames: classNamesShape,
  /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEnter: PropTypes.func,
  /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,
  /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntered: PropTypes.func,
  /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExit: PropTypes.func,
  /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExiting: PropTypes.func,
  /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** and the `exit-done` class is added to the DOM node.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExited: PropTypes.func
}) : {};
function _assertThisInitialized(e) {
  if (e === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function getChildMapping(e, t) {
  var o = function(i) {
    return t && isValidElement(i) ? t(i) : i;
  }, n = /* @__PURE__ */ Object.create(null);
  return e && Children.map(e, function(s) {
    return s;
  }).forEach(function(s) {
    n[s.key] = o(s);
  }), n;
}
function mergeChildMappings(e, t) {
  e = e || {}, t = t || {};
  function o(p) {
    return p in t ? t[p] : e[p];
  }
  var n = /* @__PURE__ */ Object.create(null), s = [];
  for (var i in e)
    i in t ? s.length && (n[i] = s, s = []) : s.push(i);
  var l, d = {};
  for (var u in t) {
    if (n[u])
      for (l = 0; l < n[u].length; l++) {
        var c = n[u][l];
        d[n[u][l]] = o(c);
      }
    d[u] = o(u);
  }
  for (l = 0; l < s.length; l++)
    d[s[l]] = o(s[l]);
  return d;
}
function getProp(e, t, o) {
  return o[t] != null ? o[t] : e.props[t];
}
function getInitialChildMapping(e, t) {
  return getChildMapping(e.children, function(o) {
    return cloneElement(o, {
      onExited: t.bind(null, o),
      in: !0,
      appear: getProp(o, "appear", e),
      enter: getProp(o, "enter", e),
      exit: getProp(o, "exit", e)
    });
  });
}
function getNextChildMapping(e, t, o) {
  var n = getChildMapping(e.children), s = mergeChildMappings(t, n);
  return Object.keys(s).forEach(function(i) {
    var l = s[i];
    if (isValidElement(l)) {
      var d = i in t, u = i in n, c = t[i], p = isValidElement(c) && !c.props.in;
      u && (!d || p) ? s[i] = cloneElement(l, {
        onExited: o.bind(null, l),
        in: !0,
        exit: getProp(l, "exit", e),
        enter: getProp(l, "enter", e)
      }) : !u && d && !p ? s[i] = cloneElement(l, {
        in: !1
      }) : u && d && isValidElement(c) && (s[i] = cloneElement(l, {
        onExited: o.bind(null, l),
        in: c.props.in,
        exit: getProp(l, "exit", e),
        enter: getProp(l, "enter", e)
      }));
    }
  }), s;
}
var values = Object.values || function(e) {
  return Object.keys(e).map(function(t) {
    return e[t];
  });
}, defaultProps = {
  component: "div",
  childFactory: function e(t) {
    return t;
  }
}, TransitionGroup = /* @__PURE__ */ (function(e) {
  _inheritsLoose(t, e);
  function t(n, s) {
    var i;
    i = e.call(this, n, s) || this;
    var l = i.handleExited.bind(_assertThisInitialized(i));
    return i.state = {
      contextValue: {
        isMounting: !0
      },
      handleExited: l,
      firstRender: !0
    }, i;
  }
  var o = t.prototype;
  return o.componentDidMount = function() {
    this.mounted = !0, this.setState({
      contextValue: {
        isMounting: !1
      }
    });
  }, o.componentWillUnmount = function() {
    this.mounted = !1;
  }, t.getDerivedStateFromProps = function(s, i) {
    var l = i.children, d = i.handleExited, u = i.firstRender;
    return {
      children: u ? getInitialChildMapping(s, d) : getNextChildMapping(s, l, d),
      firstRender: !1
    };
  }, o.handleExited = function(s, i) {
    var l = getChildMapping(this.props.children);
    s.key in l || (s.props.onExited && s.props.onExited(i), this.mounted && this.setState(function(d) {
      var u = _extends({}, d.children);
      return delete u[s.key], {
        children: u
      };
    }));
  }, o.render = function() {
    var s = this.props, i = s.component, l = s.childFactory, d = _objectWithoutPropertiesLoose(s, ["component", "childFactory"]), u = this.state.contextValue, c = values(this.state.children).map(l);
    return delete d.appear, delete d.enter, delete d.exit, i === null ? /* @__PURE__ */ React__default.createElement(TransitionGroupContext.Provider, {
      value: u
    }, c) : /* @__PURE__ */ React__default.createElement(TransitionGroupContext.Provider, {
      value: u
    }, /* @__PURE__ */ React__default.createElement(i, d, c));
  }, t;
})(React__default.Component);
TransitionGroup.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: PropTypes.any,
  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   *
   * While this component is meant for multiple `Transition` or `CSSTransition`
   * children, sometimes you may want to have a single transition child with
   * content that you want to be transitioned out and in when you change it
   * (e.g. routes, images etc.) In that case you can change the `key` prop of
   * the transition child as you change its content, this will cause
   * `TransitionGroup` to transition the child out and back in.
   */
  children: PropTypes.node,
  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: PropTypes.bool,
  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: PropTypes.bool,
  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: PropTypes.bool,
  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: PropTypes.func
} : {};
TransitionGroup.defaultProps = defaultProps;
const EMPTY = [];
function useOnMount(e) {
  React.useEffect(e, EMPTY);
}
class Timeout {
  static create() {
    return new Timeout();
  }
  currentId = null;
  /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */
  start(t, o) {
    this.clear(), this.currentId = setTimeout(() => {
      this.currentId = null, o();
    }, t);
  }
  clear = () => {
    this.currentId !== null && (clearTimeout(this.currentId), this.currentId = null);
  };
  disposeEffect = () => this.clear;
}
function useTimeout() {
  const e = useLazyRef(Timeout.create).current;
  return useOnMount(e.disposeEffect), e;
}
function Ripple(e) {
  const {
    className: t,
    classes: o,
    pulsate: n = !1,
    rippleX: s,
    rippleY: i,
    rippleSize: l,
    in: d,
    onExited: u,
    timeout: c
  } = e, [p, f] = React.useState(!1), g = clsx(t, o.ripple, o.rippleVisible, n && o.ripplePulsate), y = {
    width: l,
    height: l,
    top: -(l / 2) + i,
    left: -(l / 2) + s
  }, h = clsx(o.child, p && o.childLeaving, n && o.childPulsate);
  return !d && !p && f(!0), React.useEffect(() => {
    if (!d && u != null) {
      const T = setTimeout(u, c);
      return () => {
        clearTimeout(T);
      };
    }
  }, [u, d, c]), /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
    className: g,
    style: y,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
      className: h
    })
  });
}
process.env.NODE_ENV !== "production" && (Ripple.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  /**
   * @ignore - injected from TransitionGroup
   */
  in: PropTypes.bool,
  /**
   * @ignore - injected from TransitionGroup
   */
  onExited: PropTypes.func,
  /**
   * If `true`, the ripple pulsates, typically indicating the keyboard focus state of an element.
   */
  pulsate: PropTypes.bool,
  /**
   * Diameter of the ripple.
   */
  rippleSize: PropTypes.number,
  /**
   * Horizontal position of the ripple center.
   */
  rippleX: PropTypes.number,
  /**
   * Vertical position of the ripple center.
   */
  rippleY: PropTypes.number,
  /**
   * exit delay
   */
  timeout: PropTypes.number.isRequired
});
const touchRippleClasses = generateUtilityClasses("MuiTouchRipple", ["root", "ripple", "rippleVisible", "ripplePulsate", "child", "childLeaving", "childPulsate"]), DURATION = 550, DELAY_RIPPLE = 80, enterKeyframe = keyframes$1`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`, exitKeyframe = keyframes$1`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`, pulsateKeyframe = keyframes$1`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`, TouchRippleRoot = styled("span", {
  name: "MuiTouchRipple",
  slot: "Root"
})({
  overflow: "hidden",
  pointerEvents: "none",
  position: "absolute",
  zIndex: 0,
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  borderRadius: "inherit"
}), TouchRippleRipple = styled(Ripple, {
  name: "MuiTouchRipple",
  slot: "Ripple"
})`
  opacity: 0;
  position: absolute;

  &.${touchRippleClasses.rippleVisible} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${enterKeyframe};
    animation-duration: ${DURATION}ms;
    animation-timing-function: ${({
  theme: e
}) => e.transitions.easing.easeInOut};
  }

  &.${touchRippleClasses.ripplePulsate} {
    animation-duration: ${({
  theme: e
}) => e.transitions.duration.shorter}ms;
  }

  & .${touchRippleClasses.child} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${touchRippleClasses.childLeaving} {
    opacity: 0;
    animation-name: ${exitKeyframe};
    animation-duration: ${DURATION}ms;
    animation-timing-function: ${({
  theme: e
}) => e.transitions.easing.easeInOut};
  }

  & .${touchRippleClasses.childPulsate} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${pulsateKeyframe};
    animation-duration: 2500ms;
    animation-timing-function: ${({
  theme: e
}) => e.transitions.easing.easeInOut};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`, TouchRipple = /* @__PURE__ */ React.forwardRef(function e(t, o) {
  const n = useDefaultProps({
    props: t,
    name: "MuiTouchRipple"
  }), {
    center: s = !1,
    classes: i = {},
    className: l,
    ...d
  } = n, [u, c] = React.useState([]), p = React.useRef(0), f = React.useRef(null);
  React.useEffect(() => {
    f.current && (f.current(), f.current = null);
  }, [u]);
  const g = React.useRef(!1), y = useTimeout(), h = React.useRef(null), T = React.useRef(null), P = React.useCallback((C) => {
    const {
      pulsate: x,
      rippleX: _,
      rippleY: D,
      rippleSize: O,
      cb: v
    } = C;
    c((w) => [...w, /* @__PURE__ */ jsxRuntimeExports.jsx(TouchRippleRipple, {
      classes: {
        ripple: clsx(i.ripple, touchRippleClasses.ripple),
        rippleVisible: clsx(i.rippleVisible, touchRippleClasses.rippleVisible),
        ripplePulsate: clsx(i.ripplePulsate, touchRippleClasses.ripplePulsate),
        child: clsx(i.child, touchRippleClasses.child),
        childLeaving: clsx(i.childLeaving, touchRippleClasses.childLeaving),
        childPulsate: clsx(i.childPulsate, touchRippleClasses.childPulsate)
      },
      timeout: DURATION,
      pulsate: x,
      rippleX: _,
      rippleY: D,
      rippleSize: O
    }, p.current)]), p.current += 1, f.current = v;
  }, [i]), E = React.useCallback((C = {}, x = {}, _ = () => {
  }) => {
    const {
      pulsate: D = !1,
      center: O = s || x.pulsate,
      fakeElement: v = !1
      // For test purposes
    } = x;
    if (C?.type === "mousedown" && g.current) {
      g.current = !1;
      return;
    }
    C?.type === "touchstart" && (g.current = !0);
    const w = v ? null : T.current, M = w ? w.getBoundingClientRect() : {
      width: 0,
      height: 0,
      left: 0,
      top: 0
    };
    let S, I, N;
    if (O || C === void 0 || C.clientX === 0 && C.clientY === 0 || !C.clientX && !C.touches)
      S = Math.round(M.width / 2), I = Math.round(M.height / 2);
    else {
      const {
        clientX: F,
        clientY: L
      } = C.touches && C.touches.length > 0 ? C.touches[0] : C;
      S = Math.round(F - M.left), I = Math.round(L - M.top);
    }
    if (O)
      N = Math.sqrt((2 * M.width ** 2 + M.height ** 2) / 3), N % 2 === 0 && (N += 1);
    else {
      const F = Math.max(Math.abs((w ? w.clientWidth : 0) - S), S) * 2 + 2, L = Math.max(Math.abs((w ? w.clientHeight : 0) - I), I) * 2 + 2;
      N = Math.sqrt(F ** 2 + L ** 2);
    }
    C?.touches ? h.current === null && (h.current = () => {
      P({
        pulsate: D,
        rippleX: S,
        rippleY: I,
        rippleSize: N,
        cb: _
      });
    }, y.start(DELAY_RIPPLE, () => {
      h.current && (h.current(), h.current = null);
    })) : P({
      pulsate: D,
      rippleX: S,
      rippleY: I,
      rippleSize: N,
      cb: _
    });
  }, [s, P, y]), $ = React.useCallback(() => {
    E({}, {
      pulsate: !0
    });
  }, [E]), R = React.useCallback((C, x) => {
    if (y.clear(), C?.type === "touchend" && h.current) {
      h.current(), h.current = null, y.start(0, () => {
        R(C, x);
      });
      return;
    }
    h.current = null, c((_) => _.length > 0 ? _.slice(1) : _), f.current = x;
  }, [y]);
  return React.useImperativeHandle(o, () => ({
    pulsate: $,
    start: E,
    stop: R
  }), [$, E, R]), /* @__PURE__ */ jsxRuntimeExports.jsx(TouchRippleRoot, {
    className: clsx(touchRippleClasses.root, i.root, l),
    ref: T,
    ...d,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(TransitionGroup, {
      component: null,
      exit: !0,
      children: u
    })
  });
});
process.env.NODE_ENV !== "production" && (TouchRipple.propTypes = {
  /**
   * If `true`, the ripple starts at the center of the component
   * rather than at the point of interaction.
   */
  center: PropTypes.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string
});
function getButtonBaseUtilityClass(e) {
  return generateUtilityClass("MuiButtonBase", e);
}
const buttonBaseClasses = generateUtilityClasses("MuiButtonBase", ["root", "disabled", "focusVisible"]), useUtilityClasses$P = (e) => {
  const {
    disabled: t,
    focusVisible: o,
    focusVisibleClassName: n,
    classes: s
  } = e, l = composeClasses({
    root: ["root", t && "disabled", o && "focusVisible"]
  }, getButtonBaseUtilityClass, s);
  return o && n && (l.root += ` ${n}`), l;
}, ButtonBaseRoot = styled("button", {
  name: "MuiButtonBase",
  slot: "Root"
})({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
  boxSizing: "border-box",
  WebkitTapHighlightColor: "transparent",
  backgroundColor: "transparent",
  // Reset default value
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0,
  border: 0,
  margin: 0,
  // Remove the margin in Safari
  borderRadius: 0,
  padding: 0,
  // Remove the padding in Firefox
  cursor: "pointer",
  userSelect: "none",
  verticalAlign: "middle",
  MozAppearance: "none",
  // Reset
  WebkitAppearance: "none",
  // Reset
  textDecoration: "none",
  // So we take precedent over the style of a native <a /> element.
  color: "inherit",
  "&::-moz-focus-inner": {
    borderStyle: "none"
    // Remove Firefox dotted outline.
  },
  [`&.${buttonBaseClasses.disabled}`]: {
    pointerEvents: "none",
    // Disable link interactions
    cursor: "default"
  },
  "@media print": {
    colorAdjust: "exact"
  }
}), ButtonBase = /* @__PURE__ */ React.forwardRef(function e(t, o) {
  const n = useDefaultProps({
    props: t,
    name: "MuiButtonBase"
  }), {
    action: s,
    centerRipple: i = !1,
    children: l,
    className: d,
    component: u = "button",
    disabled: c = !1,
    disableRipple: p = !1,
    disableTouchRipple: f = !1,
    focusRipple: g = !1,
    focusVisibleClassName: y,
    LinkComponent: h = "a",
    onBlur: T,
    onClick: P,
    onContextMenu: E,
    onDragLeave: $,
    onFocus: R,
    onFocusVisible: C,
    onKeyDown: x,
    onKeyUp: _,
    onMouseDown: D,
    onMouseLeave: O,
    onMouseUp: v,
    onTouchEnd: w,
    onTouchMove: M,
    onTouchStart: S,
    tabIndex: I = 0,
    TouchRippleProps: N,
    touchRippleRef: F,
    type: L,
    ...k
  } = n, W = React.useRef(null), V = useLazyRipple(), j = useForkRef(V.ref, F), [A, U] = React.useState(!1);
  c && A && U(!1), React.useImperativeHandle(s, () => ({
    focusVisible: () => {
      U(!0), W.current.focus();
    }
  }), []);
  const G = V.shouldMount && !p && !c;
  React.useEffect(() => {
    A && g && !p && V.pulsate();
  }, [p, g, A, V]);
  const Y = useRippleHandler(V, "start", D, f), ee = useRippleHandler(V, "stop", E, f), J = useRippleHandler(V, "stop", $, f), Z = useRippleHandler(V, "stop", v, f), le = useRippleHandler(V, "stop", (ye) => {
    A && ye.preventDefault(), O && O(ye);
  }, f), se = useRippleHandler(V, "start", S, f), K = useRippleHandler(V, "stop", w, f), q = useRippleHandler(V, "stop", M, f), B = useRippleHandler(V, "stop", (ye) => {
    isFocusVisible(ye.target) || U(!1), T && T(ye);
  }, !1), ue = useEventCallback((ye) => {
    W.current || (W.current = ye.currentTarget), isFocusVisible(ye.target) && (U(!0), C && C(ye)), R && R(ye);
  }), re = () => {
    const ye = W.current;
    return u && u !== "button" && !(ye.tagName === "A" && ye.href);
  }, be = useEventCallback((ye) => {
    g && !ye.repeat && A && ye.key === " " && V.stop(ye, () => {
      V.start(ye);
    }), ye.target === ye.currentTarget && re() && ye.key === " " && ye.preventDefault(), x && x(ye), ye.target === ye.currentTarget && re() && ye.key === "Enter" && !c && (ye.preventDefault(), P && P(ye));
  }), X = useEventCallback((ye) => {
    g && ye.key === " " && A && !ye.defaultPrevented && V.stop(ye, () => {
      V.pulsate(ye);
    }), _ && _(ye), P && ye.target === ye.currentTarget && re() && ye.key === " " && !ye.defaultPrevented && P(ye);
  });
  let ge = u;
  ge === "button" && (k.href || k.to) && (ge = h);
  const Ee = {};
  ge === "button" ? (Ee.type = L === void 0 ? "button" : L, Ee.disabled = c) : (!k.href && !k.to && (Ee.role = "button"), c && (Ee["aria-disabled"] = c));
  const xe = useForkRef(o, W), he = {
    ...n,
    centerRipple: i,
    component: u,
    disabled: c,
    disableRipple: p,
    disableTouchRipple: f,
    focusRipple: g,
    tabIndex: I,
    focusVisible: A
  }, Pe = useUtilityClasses$P(he);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(ButtonBaseRoot, {
    as: ge,
    className: clsx(Pe.root, d),
    ownerState: he,
    onBlur: B,
    onClick: P,
    onContextMenu: ee,
    onFocus: ue,
    onKeyDown: be,
    onKeyUp: X,
    onMouseDown: Y,
    onMouseLeave: le,
    onMouseUp: Z,
    onDragLeave: J,
    onTouchEnd: K,
    onTouchMove: q,
    onTouchStart: se,
    ref: xe,
    tabIndex: c ? -1 : I,
    type: L,
    ...Ee,
    ...k,
    children: [l, G ? /* @__PURE__ */ jsxRuntimeExports.jsx(TouchRipple, {
      ref: j,
      center: i,
      ...N
    }) : null]
  });
});
function useRippleHandler(e, t, o, n = !1) {
  return useEventCallback((s) => (o && o(s), n || e[t](s), !0));
}
process.env.NODE_ENV !== "production" && (ButtonBase.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A ref for imperative actions.
   * It currently only supports `focusVisible()` action.
   */
  action: refType,
  /**
   * If `true`, the ripples are centered.
   * They won't start at the cursor interaction position.
   * @default false
   */
  centerRipple: PropTypes.bool,
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: elementTypeAcceptingRef$1,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: PropTypes.bool,
  /**
   * If `true`, the touch ripple effect is disabled.
   * @default false
   */
  disableTouchRipple: PropTypes.bool,
  /**
   * If `true`, the base button will have a keyboard focus ripple.
   * @default false
   */
  focusRipple: PropTypes.bool,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: PropTypes.string,
  /**
   * @ignore
   */
  href: PropTypes.any,
  /**
   * The component used to render a link when the `href` prop is provided.
   * @default 'a'
   */
  LinkComponent: PropTypes.elementType,
  /**
   * @ignore
   */
  onBlur: PropTypes.func,
  /**
   * @ignore
   */
  onClick: PropTypes.func,
  /**
   * @ignore
   */
  onContextMenu: PropTypes.func,
  /**
   * @ignore
   */
  onDragLeave: PropTypes.func,
  /**
   * @ignore
   */
  onFocus: PropTypes.func,
  /**
   * Callback fired when the component is focused with a keyboard.
   * We trigger a `onFocus` callback too.
   */
  onFocusVisible: PropTypes.func,
  /**
   * @ignore
   */
  onKeyDown: PropTypes.func,
  /**
   * @ignore
   */
  onKeyUp: PropTypes.func,
  /**
   * @ignore
   */
  onMouseDown: PropTypes.func,
  /**
   * @ignore
   */
  onMouseLeave: PropTypes.func,
  /**
   * @ignore
   */
  onMouseUp: PropTypes.func,
  /**
   * @ignore
   */
  onTouchEnd: PropTypes.func,
  /**
   * @ignore
   */
  onTouchMove: PropTypes.func,
  /**
   * @ignore
   */
  onTouchStart: PropTypes.func,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * @default 0
   */
  tabIndex: PropTypes.number,
  /**
   * Props applied to the `TouchRipple` element.
   */
  TouchRippleProps: PropTypes.object,
  /**
   * A ref that points to the `TouchRipple` element.
   */
  touchRippleRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.shape({
      pulsate: PropTypes.func.isRequired,
      start: PropTypes.func.isRequired,
      stop: PropTypes.func.isRequired
    })
  })]),
  /**
   * @ignore
   */
  type: PropTypes.oneOfType([PropTypes.oneOf(["button", "reset", "submit"]), PropTypes.string])
});
function getCircularProgressUtilityClass(e) {
  return generateUtilityClass("MuiCircularProgress", e);
}
generateUtilityClasses("MuiCircularProgress", ["root", "determinate", "indeterminate", "colorPrimary", "colorSecondary", "svg", "track", "circle", "circleDeterminate", "circleIndeterminate", "circleDisableShrink"]);
const SIZE = 44, circularRotateKeyframe = keyframes$1`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`, circularDashKeyframe = keyframes$1`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: -126px;
  }
`, rotateAnimation = typeof circularRotateKeyframe != "string" ? css`
        animation: ${circularRotateKeyframe} 1.4s linear infinite;
      ` : null, dashAnimation = typeof circularDashKeyframe != "string" ? css`
        animation: ${circularDashKeyframe} 1.4s ease-in-out infinite;
      ` : null, useUtilityClasses$O = (e) => {
  const {
    classes: t,
    variant: o,
    color: n,
    disableShrink: s
  } = e, i = {
    root: ["root", o, `color${capitalize(n)}`],
    svg: ["svg"],
    track: ["track"],
    circle: ["circle", `circle${capitalize(o)}`, s && "circleDisableShrink"]
  };
  return composeClasses(i, getCircularProgressUtilityClass, t);
}, CircularProgressRoot = styled("span", {
  name: "MuiCircularProgress",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.root, t[o.variant], t[`color${capitalize(o.color)}`]];
  }
})(memoTheme(({
  theme: e
}) => ({
  display: "inline-block",
  variants: [{
    props: {
      variant: "determinate"
    },
    style: {
      transition: e.transitions.create("transform")
    }
  }, {
    props: {
      variant: "indeterminate"
    },
    style: rotateAnimation || {
      animation: `${circularRotateKeyframe} 1.4s linear infinite`
    }
  }, ...Object.entries(e.palette).filter(createSimplePaletteValueFilter()).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      color: (e.vars || e).palette[t].main
    }
  }))]
}))), CircularProgressSVG = styled("svg", {
  name: "MuiCircularProgress",
  slot: "Svg"
})({
  display: "block"
  // Keeps the progress centered
}), CircularProgressCircle = styled("circle", {
  name: "MuiCircularProgress",
  slot: "Circle",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.circle, t[`circle${capitalize(o.variant)}`], o.disableShrink && t.circleDisableShrink];
  }
})(memoTheme(({
  theme: e
}) => ({
  stroke: "currentColor",
  variants: [{
    props: {
      variant: "determinate"
    },
    style: {
      transition: e.transitions.create("stroke-dashoffset")
    }
  }, {
    props: {
      variant: "indeterminate"
    },
    style: {
      // Some default value that looks fine waiting for the animation to kicks in.
      strokeDasharray: "80px, 200px",
      strokeDashoffset: 0
      // Add the unit to fix a Edge 16 and below bug.
    }
  }, {
    props: ({
      ownerState: t
    }) => t.variant === "indeterminate" && !t.disableShrink,
    style: dashAnimation || {
      // At runtime for Pigment CSS, `bufferAnimation` will be null and the generated keyframe will be used.
      animation: `${circularDashKeyframe} 1.4s ease-in-out infinite`
    }
  }]
}))), CircularProgressTrack = styled("circle", {
  name: "MuiCircularProgress",
  slot: "Track"
})(memoTheme(({
  theme: e
}) => ({
  stroke: "currentColor",
  opacity: (e.vars || e).palette.action.activatedOpacity
}))), CircularProgress = /* @__PURE__ */ React.forwardRef(function e(t, o) {
  const n = useDefaultProps({
    props: t,
    name: "MuiCircularProgress"
  }), {
    className: s,
    color: i = "primary",
    disableShrink: l = !1,
    enableTrackSlot: d = !1,
    size: u = 40,
    style: c,
    thickness: p = 3.6,
    value: f = 0,
    variant: g = "indeterminate",
    ...y
  } = n, h = {
    ...n,
    color: i,
    disableShrink: l,
    size: u,
    thickness: p,
    value: f,
    variant: g,
    enableTrackSlot: d
  }, T = useUtilityClasses$O(h), P = {}, E = {}, $ = {};
  if (g === "determinate") {
    const R = 2 * Math.PI * ((SIZE - p) / 2);
    P.strokeDasharray = R.toFixed(3), $["aria-valuenow"] = Math.round(f), P.strokeDashoffset = `${((100 - f) / 100 * R).toFixed(3)}px`, E.transform = "rotate(-90deg)";
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(CircularProgressRoot, {
    className: clsx(T.root, s),
    style: {
      width: u,
      height: u,
      ...E,
      ...c
    },
    ownerState: h,
    ref: o,
    role: "progressbar",
    ...$,
    ...y,
    children: /* @__PURE__ */ jsxRuntimeExports.jsxs(CircularProgressSVG, {
      className: T.svg,
      ownerState: h,
      viewBox: `${SIZE / 2} ${SIZE / 2} ${SIZE} ${SIZE}`,
      children: [d ? /* @__PURE__ */ jsxRuntimeExports.jsx(CircularProgressTrack, {
        className: T.track,
        ownerState: h,
        cx: SIZE,
        cy: SIZE,
        r: (SIZE - p) / 2,
        fill: "none",
        strokeWidth: p,
        "aria-hidden": "true"
      }) : null, /* @__PURE__ */ jsxRuntimeExports.jsx(CircularProgressCircle, {
        className: T.circle,
        style: P,
        ownerState: h,
        cx: SIZE,
        cy: SIZE,
        r: (SIZE - p) / 2,
        fill: "none",
        strokeWidth: p
      })]
    })
  });
});
process.env.NODE_ENV !== "production" && (CircularProgress.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["inherit", "primary", "secondary", "error", "info", "success", "warning"]), PropTypes.string]),
  /**
   * If `true`, the shrink animation is disabled.
   * This only works if variant is `indeterminate`.
   * @default false
   */
  disableShrink: chainPropTypes(PropTypes.bool, (e) => e.disableShrink && e.variant && e.variant !== "indeterminate" ? new Error("MUI: You have provided the `disableShrink` prop with a variant other than `indeterminate`. This will have no effect.") : null),
  /**
   * If `true`, a track circle slot is mounted to show a subtle background for the progress.
   * The `size` and `thickness` apply to the track slot to be consistent with the progress circle.
   * @default false
   */
  enableTrackSlot: PropTypes.bool,
  /**
   * The size of the component.
   * If using a number, the pixel unit is assumed.
   * If using a string, you need to provide the CSS unit, for example '3rem'.
   * @default 40
   */
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * @ignore
   */
  style: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The thickness of the circle.
   * @default 3.6
   */
  thickness: PropTypes.number,
  /**
   * The value of the progress indicator for the determinate variant.
   * Value between 0 and 100.
   * @default 0
   */
  value: PropTypes.number,
  /**
   * The variant to use.
   * Use indeterminate when there is no progress value.
   * @default 'indeterminate'
   */
  variant: PropTypes.oneOf(["determinate", "indeterminate"])
});
function getIconButtonUtilityClass(e) {
  return generateUtilityClass("MuiIconButton", e);
}
const iconButtonClasses = generateUtilityClasses("MuiIconButton", ["root", "disabled", "colorInherit", "colorPrimary", "colorSecondary", "colorError", "colorInfo", "colorSuccess", "colorWarning", "edgeStart", "edgeEnd", "sizeSmall", "sizeMedium", "sizeLarge", "loading", "loadingIndicator", "loadingWrapper"]), useUtilityClasses$N = (e) => {
  const {
    classes: t,
    disabled: o,
    color: n,
    edge: s,
    size: i,
    loading: l
  } = e, d = {
    root: ["root", l && "loading", o && "disabled", n !== "default" && `color${capitalize(n)}`, s && `edge${capitalize(s)}`, `size${capitalize(i)}`],
    loadingIndicator: ["loadingIndicator"],
    loadingWrapper: ["loadingWrapper"]
  };
  return composeClasses(d, getIconButtonUtilityClass, t);
}, IconButtonRoot = styled(ButtonBase, {
  name: "MuiIconButton",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.root, o.loading && t.loading, o.color !== "default" && t[`color${capitalize(o.color)}`], o.edge && t[`edge${capitalize(o.edge)}`], t[`size${capitalize(o.size)}`]];
  }
})(memoTheme(({
  theme: e
}) => ({
  textAlign: "center",
  flex: "0 0 auto",
  fontSize: e.typography.pxToRem(24),
  padding: 8,
  borderRadius: "50%",
  color: (e.vars || e).palette.action.active,
  transition: e.transitions.create("background-color", {
    duration: e.transitions.duration.shortest
  }),
  variants: [{
    props: (t) => !t.disableRipple,
    style: {
      "--IconButton-hoverBg": e.alpha((e.vars || e).palette.action.active, (e.vars || e).palette.action.hoverOpacity),
      "&:hover": {
        backgroundColor: "var(--IconButton-hoverBg)",
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: "transparent"
        }
      }
    }
  }, {
    props: {
      edge: "start"
    },
    style: {
      marginLeft: -12
    }
  }, {
    props: {
      edge: "start",
      size: "small"
    },
    style: {
      marginLeft: -3
    }
  }, {
    props: {
      edge: "end"
    },
    style: {
      marginRight: -12
    }
  }, {
    props: {
      edge: "end",
      size: "small"
    },
    style: {
      marginRight: -3
    }
  }]
})), memoTheme(({
  theme: e
}) => ({
  variants: [{
    props: {
      color: "inherit"
    },
    style: {
      color: "inherit"
    }
  }, ...Object.entries(e.palette).filter(createSimplePaletteValueFilter()).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      color: (e.vars || e).palette[t].main
    }
  })), ...Object.entries(e.palette).filter(createSimplePaletteValueFilter()).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      "--IconButton-hoverBg": e.alpha((e.vars || e).palette[t].main, (e.vars || e).palette.action.hoverOpacity)
    }
  })), {
    props: {
      size: "small"
    },
    style: {
      padding: 5,
      fontSize: e.typography.pxToRem(18)
    }
  }, {
    props: {
      size: "large"
    },
    style: {
      padding: 12,
      fontSize: e.typography.pxToRem(28)
    }
  }],
  [`&.${iconButtonClasses.disabled}`]: {
    backgroundColor: "transparent",
    color: (e.vars || e).palette.action.disabled
  },
  [`&.${iconButtonClasses.loading}`]: {
    color: "transparent"
  }
}))), IconButtonLoadingIndicator = styled("span", {
  name: "MuiIconButton",
  slot: "LoadingIndicator"
})(({
  theme: e
}) => ({
  display: "none",
  position: "absolute",
  visibility: "visible",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  color: (e.vars || e).palette.action.disabled,
  variants: [{
    props: {
      loading: !0
    },
    style: {
      display: "flex"
    }
  }]
})), IconButton = /* @__PURE__ */ React.forwardRef(function e(t, o) {
  const n = useDefaultProps({
    props: t,
    name: "MuiIconButton"
  }), {
    edge: s = !1,
    children: i,
    className: l,
    color: d = "default",
    disabled: u = !1,
    disableFocusRipple: c = !1,
    size: p = "medium",
    id: f,
    loading: g = null,
    loadingIndicator: y,
    ...h
  } = n, T = useId(f), P = y ?? /* @__PURE__ */ jsxRuntimeExports.jsx(CircularProgress, {
    "aria-labelledby": T,
    color: "inherit",
    size: 16
  }), E = {
    ...n,
    edge: s,
    color: d,
    disabled: u,
    disableFocusRipple: c,
    loading: g,
    loadingIndicator: P,
    size: p
  }, $ = useUtilityClasses$N(E);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(IconButtonRoot, {
    id: g ? T : f,
    className: clsx($.root, l),
    centerRipple: !0,
    focusRipple: !c,
    disabled: u || g,
    ref: o,
    ...h,
    ownerState: E,
    children: [typeof g == "boolean" && // use plain HTML span to minimize the runtime overhead
    /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
      className: $.loadingWrapper,
      style: {
        display: "contents"
      },
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(IconButtonLoadingIndicator, {
        className: $.loadingIndicator,
        ownerState: E,
        children: g && P
      })
    }), i]
  });
});
process.env.NODE_ENV !== "production" && (IconButton.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The icon to display.
   */
  children: chainPropTypes(PropTypes.node, (e) => React.Children.toArray(e.children).some((o) => /* @__PURE__ */ React.isValidElement(o) && o.props.onClick) ? new Error(["MUI: You are providing an onClick event listener to a child of a button element.", "Prefer applying it to the IconButton directly.", "This guarantees that the whole <button> will be responsive to click events."].join(`
`)) : null),
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'default'
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["inherit", "default", "primary", "secondary", "error", "info", "success", "warning"]), PropTypes.string]),
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: PropTypes.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: PropTypes.bool,
  /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   * @default false
   */
  edge: PropTypes.oneOf(["end", "start", !1]),
  /**
   * @ignore
   */
  id: PropTypes.string,
  /**
   * If `true`, the loading indicator is visible and the button is disabled.
   * If `true | false`, the loading wrapper is always rendered before the children to prevent [Google Translation Crash](https://github.com/mui/material-ui/issues/27853).
   * @default null
   */
  loading: PropTypes.bool,
  /**
   * Element placed before the children if the button is in loading state.
   * The node should contain an element with `role="progressbar"` with an accessible name.
   * By default, it renders a `CircularProgress` that is labeled by the button itself.
   * @default <CircularProgress color="inherit" size={16} />
   */
  loadingIndicator: PropTypes.node,
  /**
   * The size of the component.
   * `small` is equivalent to the dense button styling.
   * @default 'medium'
   */
  size: PropTypes.oneOfType([PropTypes.oneOf(["small", "medium", "large"]), PropTypes.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
});
const ArrowDropDownIcon$1 = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M7 10l5 5 5-5z"
}), "ArrowDropDown"), ArrowLeftIcon = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"
}), "ArrowLeft"), ArrowRightIcon = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
}), "ArrowRight"), CalendarIcon = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z"
}), "Calendar");
createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsxs(React.Fragment, {
  children: [/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
    d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
  }), /* @__PURE__ */ jsxRuntimeExports.jsx("path", {
    d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
  })]
}), "Clock");
createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z"
}), "DateRange");
createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsxs(React.Fragment, {
  children: [/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
    d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
  }), /* @__PURE__ */ jsxRuntimeExports.jsx("path", {
    d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
  })]
}), "Time");
const ClearIcon$1 = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Clear");
function getPickersArrowSwitcherUtilityClass(e) {
  return generateUtilityClass("MuiPickersArrowSwitcher", e);
}
generateUtilityClasses("MuiPickersArrowSwitcher", ["root", "spacer", "button", "previousIconButton", "nextIconButton", "leftArrowIcon", "rightArrowIcon"]);
const usePickerPrivateContext = () => React.useContext(PickerPrivateContext), _excluded$u = ["children", "className", "slots", "slotProps", "isNextDisabled", "isNextHidden", "onGoToNext", "nextLabel", "isPreviousDisabled", "isPreviousHidden", "onGoToPrevious", "previousLabel", "labelId", "classes"], _excluded2$6 = ["ownerState"], _excluded3$1 = ["ownerState"], PickersArrowSwitcherRoot = styled("div", {
  name: "MuiPickersArrowSwitcher",
  slot: "Root"
})({
  display: "flex"
}), PickersArrowSwitcherSpacer = styled("div", {
  name: "MuiPickersArrowSwitcher",
  slot: "Spacer"
})(({
  theme: e
}) => ({
  width: e.spacing(3)
})), PickersArrowSwitcherButton = styled(IconButton, {
  name: "MuiPickersArrowSwitcher",
  slot: "Button"
})({
  variants: [{
    props: {
      isButtonHidden: !0
    },
    style: {
      visibility: "hidden"
    }
  }]
}), useUtilityClasses$M = (e) => composeClasses({
  root: ["root"],
  spacer: ["spacer"],
  button: ["button"],
  previousIconButton: ["previousIconButton"],
  nextIconButton: ["nextIconButton"],
  leftArrowIcon: ["leftArrowIcon"],
  rightArrowIcon: ["rightArrowIcon"]
}, getPickersArrowSwitcherUtilityClass, e), PickersArrowSwitcher = /* @__PURE__ */ React.forwardRef(function e(t, o) {
  const n = useRtl(), s = useThemeProps({
    props: t,
    name: "MuiPickersArrowSwitcher"
  }), {
    children: i,
    className: l,
    slots: d,
    slotProps: u,
    isNextDisabled: c,
    isNextHidden: p,
    onGoToNext: f,
    nextLabel: g,
    isPreviousDisabled: y,
    isPreviousHidden: h,
    onGoToPrevious: T,
    previousLabel: P,
    labelId: E,
    classes: $
  } = s, R = _objectWithoutPropertiesLoose(s, _excluded$u), {
    ownerState: C
  } = usePickerPrivateContext(), x = useUtilityClasses$M($), _ = {
    isDisabled: c,
    isHidden: p,
    goTo: f,
    label: g
  }, D = {
    isDisabled: y,
    isHidden: h,
    goTo: T,
    label: P
  }, O = d?.previousIconButton ?? PickersArrowSwitcherButton, v = useSlotProps({
    elementType: O,
    externalSlotProps: u?.previousIconButton,
    additionalProps: {
      size: "medium",
      title: D.label,
      "aria-label": D.label,
      disabled: D.isDisabled,
      edge: "end",
      onClick: D.goTo
    },
    ownerState: _extends({}, C, {
      isButtonHidden: D.isHidden ?? !1
    }),
    className: clsx(x.button, x.previousIconButton)
  }), w = d?.nextIconButton ?? PickersArrowSwitcherButton, M = useSlotProps({
    elementType: w,
    externalSlotProps: u?.nextIconButton,
    additionalProps: {
      size: "medium",
      title: _.label,
      "aria-label": _.label,
      disabled: _.isDisabled,
      edge: "start",
      onClick: _.goTo
    },
    ownerState: _extends({}, C, {
      isButtonHidden: _.isHidden ?? !1
    }),
    className: clsx(x.button, x.nextIconButton)
  }), S = d?.leftArrowIcon ?? ArrowLeftIcon, I = useSlotProps({
    elementType: S,
    externalSlotProps: u?.leftArrowIcon,
    additionalProps: {
      fontSize: "inherit"
    },
    ownerState: C,
    className: x.leftArrowIcon
  }), N = _objectWithoutPropertiesLoose(I, _excluded2$6), F = d?.rightArrowIcon ?? ArrowRightIcon, L = useSlotProps({
    elementType: F,
    externalSlotProps: u?.rightArrowIcon,
    additionalProps: {
      fontSize: "inherit"
    },
    ownerState: C,
    className: x.rightArrowIcon
  }), k = _objectWithoutPropertiesLoose(L, _excluded3$1);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(PickersArrowSwitcherRoot, _extends({
    ref: o,
    className: clsx(x.root, l),
    ownerState: C
  }, R, {
    children: [/* @__PURE__ */ jsxRuntimeExports.jsx(O, _extends({}, v, {
      children: n ? /* @__PURE__ */ jsxRuntimeExports.jsx(F, _extends({}, k)) : /* @__PURE__ */ jsxRuntimeExports.jsx(S, _extends({}, N))
    })), i ? /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, {
      variant: "subtitle1",
      component: "span",
      id: E,
      children: i
    }) : /* @__PURE__ */ jsxRuntimeExports.jsx(PickersArrowSwitcherSpacer, {
      className: x.spacer,
      ownerState: C
    }), /* @__PURE__ */ jsxRuntimeExports.jsx(w, _extends({}, M, {
      children: n ? /* @__PURE__ */ jsxRuntimeExports.jsx(S, _extends({}, N)) : /* @__PURE__ */ jsxRuntimeExports.jsx(F, _extends({}, k))
    }))]
  }));
});
process.env.NODE_ENV !== "production" && (PickersArrowSwitcher.displayName = "PickersArrowSwitcher");
const EXPORTED_TIME_VIEWS = ["hours", "minutes", "seconds"], isTimeView = (e) => EXPORTED_TIME_VIEWS.includes(e), getSecondsInDay = (e, t) => t.getHours(e) * 3600 + t.getMinutes(e) * 60 + t.getSeconds(e), createIsAfterIgnoreDatePart = (e, t) => (o, n) => e ? t.isAfter(o, n) : getSecondsInDay(o, t) > getSecondsInDay(n, t), DEFAULT_STEP_NAVIGATION = {
  hasNextStep: !1,
  hasSeveralSteps: !1,
  goToNextStep: () => {
  },
  areViewsInSameStep: () => !0
};
function createStepNavigation(e) {
  const {
    steps: t,
    isViewMatchingStep: o,
    onStepChange: n
  } = e;
  return (s) => {
    if (t == null)
      return DEFAULT_STEP_NAVIGATION;
    const i = t.findIndex((d) => o(s.view, d)), l = i === -1 || i === t.length - 1 ? null : t[i + 1];
    return {
      hasNextStep: l != null,
      hasSeveralSteps: t.length > 1,
      goToNextStep: () => {
        l != null && n(_extends({}, s, {
          step: l
        }));
      },
      areViewsInSameStep: (d, u) => {
        const c = t.find((f) => o(d, f)), p = t.find((f) => o(u, f));
        return c === p;
      }
    };
  };
}
let warnedOnceNotValidView = !1;
function useViews({
  onChange: e,
  onViewChange: t,
  openTo: o,
  view: n,
  views: s,
  autoFocus: i,
  focusedView: l,
  onFocusedViewChange: d,
  getStepNavigation: u
}) {
  process.env.NODE_ENV !== "production" && (warnedOnceNotValidView || (n != null && !s.includes(n) && (console.warn(`MUI X: \`view="${n}"\` is not a valid prop.`, `It must be an element of \`views=["${s.join('", "')}"]\`.`), warnedOnceNotValidView = !0), n == null && o != null && !s.includes(o) && (console.warn(`MUI X: \`openTo="${o}"\` is not a valid prop.`, `It must be an element of \`views=["${s.join('", "')}"]\`.`), warnedOnceNotValidView = !0)));
  const c = React.useRef(o), p = React.useRef(s), f = React.useRef(s.includes(o) ? o : s[0]), [g, y] = useControlled({
    name: "useViews",
    state: "view",
    controlled: n,
    default: f.current
  }), h = React.useRef(i ? g : null), [T, P] = useControlled({
    name: "useViews",
    state: "focusedView",
    controlled: l,
    default: h.current
  }), E = u ? u({
    setView: y,
    view: g,
    defaultView: f.current,
    views: s
  }) : DEFAULT_STEP_NAVIGATION;
  React.useEffect(() => {
    (c.current && c.current !== o || p.current && p.current.some((v) => !s.includes(v))) && (y(s.includes(o) ? o : s[0]), p.current = s, c.current = o);
  }, [o, y, g, s]);
  const $ = s.indexOf(g), R = s[$ - 1] ?? null, C = s[$ + 1] ?? null, x = useEventCallback((v, w) => {
    P(w ? v : (M) => v === M ? null : M), d?.(v, w);
  }), _ = useEventCallback((v) => {
    x(v, !0), v !== g && (y(v), t && t(v));
  }), D = useEventCallback(() => {
    C && _(C);
  }), O = useEventCallback((v, w, M) => {
    const S = w === "finish", I = M ? (
      // handles case like `DateTimePicker`, where a view might return a `finish` selection state
      // but when it's not the final view given all `views` -> overall selection state should be `partial`.
      s.indexOf(M) < s.length - 1
    ) : !!C;
    e(v, S && I ? "partial" : w, M);
    let F = null;
    if (M != null && M !== g ? F = M : S && (F = g), F == null)
      return;
    const L = s[s.indexOf(F) + 1];
    L == null || !E.areViewsInSameStep(F, L) || _(L);
  });
  return _extends({}, E, {
    view: g,
    setView: _,
    focusedView: T,
    setFocusedView: x,
    nextView: C,
    previousView: R,
    // Always return up-to-date default view instead of the initial one (i.e. defaultView.current)
    defaultView: s.includes(o) ? o : s[0],
    goToNextView: D,
    setValueAndGoToNextView: O
  });
}
function useNextMonthDisabled(e, {
  disableFuture: t,
  maxDate: o,
  timezone: n
}) {
  const s = usePickerAdapter();
  return React.useMemo(() => {
    const i = s.date(void 0, n), l = s.startOfMonth(t && s.isBefore(i, o) ? i : o);
    return !s.isAfter(l, e);
  }, [t, o, e, s, n]);
}
function usePreviousMonthDisabled(e, {
  disablePast: t,
  minDate: o,
  timezone: n
}) {
  const s = usePickerAdapter();
  return React.useMemo(() => {
    const i = s.date(void 0, n), l = s.startOfMonth(t && s.isAfter(i, o) ? i : o);
    return !s.isBefore(l, e);
  }, [t, o, e, s, n]);
}
const DAY_SIZE = 36, DAY_MARGIN = 2, DIALOG_WIDTH = 320, MAX_CALENDAR_HEIGHT = 280, VIEW_HEIGHT = 336, PickerViewRoot = styled("div")({
  overflow: "hidden",
  width: DIALOG_WIDTH,
  maxHeight: VIEW_HEIGHT,
  display: "flex",
  flexDirection: "column",
  margin: "0 auto"
}), useControlledValue = ({
  name: e,
  timezone: t,
  value: o,
  defaultValue: n,
  referenceDate: s,
  onChange: i,
  valueManager: l
}) => {
  const d = usePickerAdapter(), [u, c] = useControlled({
    name: e,
    state: "value",
    controlled: o,
    default: n ?? l.emptyValue
  }), p = React.useMemo(() => l.getTimezone(d, u), [d, l, u]), f = useEventCallback((T) => p == null ? T : l.setTimezone(d, p, T)), g = React.useMemo(() => t || p || (s ? d.getTimezone(Array.isArray(s) ? s[0] : s) : "default"), [t, p, s, d]), y = React.useMemo(() => l.setTimezone(d, g, u), [l, d, g, u]), h = useEventCallback((T, ...P) => {
    const E = f(T);
    c(E), i?.(E, ...P);
  });
  return {
    value: y,
    handleValueChange: h,
    timezone: g
  };
}, SECTION_TYPE_GRANULARITY = {
  year: 1,
  month: 2,
  day: 3,
  hours: 4,
  minutes: 5,
  seconds: 6,
  milliseconds: 7
}, getSectionTypeGranularity = (e) => Math.max(...e.map((t) => SECTION_TYPE_GRANULARITY[t.type] ?? 1)), roundDate = (e, t, o) => {
  if (t === SECTION_TYPE_GRANULARITY.year)
    return e.startOfYear(o);
  if (t === SECTION_TYPE_GRANULARITY.month)
    return e.startOfMonth(o);
  if (t === SECTION_TYPE_GRANULARITY.day)
    return e.startOfDay(o);
  let n = o;
  return t < SECTION_TYPE_GRANULARITY.minutes && (n = e.setMinutes(n, 0)), t < SECTION_TYPE_GRANULARITY.seconds && (n = e.setSeconds(n, 0)), t < SECTION_TYPE_GRANULARITY.milliseconds && (n = e.setMilliseconds(n, 0)), n;
}, getDefaultReferenceDate = ({
  props: e,
  adapter: t,
  granularity: o,
  timezone: n,
  getTodayDate: s
}) => {
  let i = s ? s() : roundDate(t, o, getTodayDate(t, n));
  e.minDate != null && t.isAfterDay(e.minDate, i) && (i = roundDate(t, o, e.minDate)), e.maxDate != null && t.isBeforeDay(e.maxDate, i) && (i = roundDate(t, o, e.maxDate));
  const l = createIsAfterIgnoreDatePart(e.disableIgnoringDatePartForTimeValidation ?? !1, t);
  return e.minTime != null && l(e.minTime, i) && (i = roundDate(t, o, e.disableIgnoringDatePartForTimeValidation ? e.minTime : mergeDateAndTime(t, i, e.minTime))), e.maxTime != null && l(i, e.maxTime) && (i = roundDate(t, o, e.disableIgnoringDatePartForTimeValidation ? e.maxTime : mergeDateAndTime(t, i, e.maxTime))), i;
}, _excluded$t = ["value", "referenceDate"], singleItemValueManager = {
  emptyValue: null,
  getTodayValue: getTodayDate,
  getInitialReferenceValue: (e) => {
    let {
      value: t,
      referenceDate: o
    } = e, n = _objectWithoutPropertiesLoose(e, _excluded$t);
    return n.adapter.isValid(t) ? t : o ?? getDefaultReferenceDate(n);
  },
  cleanValue: replaceInvalidDateByNull,
  areValuesEqual: areDatesEqual,
  isSameError: (e, t) => e === t,
  hasError: (e) => e != null,
  defaultErrorState: null,
  getTimezone: (e, t) => e.isValid(t) ? e.getTimezone(t) : null,
  setTimezone: (e, t, o) => o == null ? null : e.setTimezone(o, t)
}, singleItemFieldValueManager = {
  updateReferenceValue: (e, t, o) => e.isValid(t) ? t : o,
  getSectionsFromValue: (e, t) => t(e),
  getV7HiddenInputValueFromSections: createDateStrForV7HiddenInputFromSections,
  getV6InputValueFromSections: createDateStrForV6InputFromSections,
  parseValueStr: (e, t, o) => o(e.trim(), t),
  getDateFromSection: (e) => e,
  getDateSectionsFromValue: (e) => e,
  updateDateInValue: (e, t, o) => o,
  clearDateSections: (e) => e.map((t) => _extends({}, t, {
    value: ""
  }))
}, ListContext = /* @__PURE__ */ React.createContext({});
process.env.NODE_ENV !== "production" && (ListContext.displayName = "ListContext");
function useSlot(e, t) {
  const {
    className: o,
    elementType: n,
    ownerState: s,
    externalForwardedProps: i,
    internalForwardedProps: l,
    shouldForwardComponentProp: d = !1,
    ...u
  } = t, {
    component: c,
    slots: p = {
      [e]: void 0
    },
    slotProps: f = {
      [e]: void 0
    },
    ...g
  } = i, y = p[e] || n, h = resolveComponentProps(f[e], s), {
    props: {
      component: T,
      ...P
    },
    internalRef: E
  } = mergeSlotProps$1({
    className: o,
    ...u,
    externalForwardedProps: e === "root" ? g : void 0,
    externalSlotProps: h
  }), $ = useForkRef(E, h?.ref, t.ref), R = e === "root" ? T || c : T, C = appendOwnerState(y, {
    ...e === "root" && !c && !p[e] && l,
    ...e !== "root" && !p[e] && l,
    ...P,
    ...R && !d && {
      as: R
    },
    ...R && d && {
      component: R
    },
    ref: $
  }, s);
  return [y, C];
}
function getListUtilityClass(e) {
  return generateUtilityClass("MuiList", e);
}
generateUtilityClasses("MuiList", ["root", "padding", "dense", "subheader"]);
const useUtilityClasses$L = (e) => {
  const {
    classes: t,
    disablePadding: o,
    dense: n,
    subheader: s
  } = e;
  return composeClasses({
    root: ["root", !o && "padding", n && "dense", s && "subheader"]
  }, getListUtilityClass, t);
}, ListRoot = styled("ul", {
  name: "MuiList",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.root, !o.disablePadding && t.padding, o.dense && t.dense, o.subheader && t.subheader];
  }
})({
  listStyle: "none",
  margin: 0,
  padding: 0,
  position: "relative",
  variants: [{
    props: ({
      ownerState: e
    }) => !e.disablePadding,
    style: {
      paddingTop: 8,
      paddingBottom: 8
    }
  }, {
    props: ({
      ownerState: e
    }) => e.subheader,
    style: {
      paddingTop: 0
    }
  }]
}), List = /* @__PURE__ */ React.forwardRef(function e(t, o) {
  const n = useDefaultProps({
    props: t,
    name: "MuiList"
  }), {
    children: s,
    className: i,
    component: l = "ul",
    dense: d = !1,
    disablePadding: u = !1,
    subheader: c,
    ...p
  } = n, f = React.useMemo(() => ({
    dense: d
  }), [d]), g = {
    ...n,
    component: l,
    dense: d,
    disablePadding: u
  }, y = useUtilityClasses$L(g);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ListContext.Provider, {
    value: f,
    children: /* @__PURE__ */ jsxRuntimeExports.jsxs(ListRoot, {
      as: l,
      className: clsx(y.root, i),
      ref: o,
      ownerState: g,
      ...p,
      children: [c, s]
    })
  });
});
process.env.NODE_ENV !== "production" && (List.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used for
   * the list and list items.
   * The prop is available to descendant components as the `dense` context.
   * @default false
   */
  dense: PropTypes.bool,
  /**
   * If `true`, vertical padding is removed from the list.
   * @default false
   */
  disablePadding: PropTypes.bool,
  /**
   * The content of the subheader, normally `ListSubheader`.
   */
  subheader: PropTypes.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
});
function getScrollbarSize(e = window) {
  const t = e.document.documentElement.clientWidth;
  return e.innerWidth - t;
}
function nextItem(e, t, o) {
  return e === t ? e.firstChild : t && t.nextElementSibling ? t.nextElementSibling : o ? null : e.firstChild;
}
function previousItem(e, t, o) {
  return e === t ? o ? e.firstChild : e.lastChild : t && t.previousElementSibling ? t.previousElementSibling : o ? null : e.lastChild;
}
function textCriteriaMatches(e, t) {
  if (t === void 0)
    return !0;
  let o = e.innerText;
  return o === void 0 && (o = e.textContent), o = o.trim().toLowerCase(), o.length === 0 ? !1 : t.repeating ? o[0] === t.keys[0] : o.startsWith(t.keys.join(""));
}
function moveFocus(e, t, o, n, s, i) {
  let l = !1, d = s(e, t, t ? o : !1);
  for (; d; ) {
    if (d === e.firstChild) {
      if (l)
        return !1;
      l = !0;
    }
    const u = n ? !1 : d.disabled || d.getAttribute("aria-disabled") === "true";
    if (!d.hasAttribute("tabindex") || !textCriteriaMatches(d, i) || u)
      d = s(e, d, o);
    else
      return d.focus(), !0;
  }
  return !1;
}
const MenuList = /* @__PURE__ */ React.forwardRef(function e(t, o) {
  const {
    // private
    // eslint-disable-next-line react/prop-types
    actions: n,
    autoFocus: s = !1,
    autoFocusItem: i = !1,
    children: l,
    className: d,
    disabledItemsFocusable: u = !1,
    disableListWrap: c = !1,
    onKeyDown: p,
    variant: f = "selectedMenu",
    ...g
  } = t, y = React.useRef(null), h = React.useRef({
    keys: [],
    repeating: !0,
    previousKeyMatched: !0,
    lastTime: null
  });
  useEnhancedEffect(() => {
    s && y.current.focus();
  }, [s]), React.useImperativeHandle(n, () => ({
    adjustStyleForScrollbar: (R, {
      direction: C
    }) => {
      const x = !y.current.style.width;
      if (R.clientHeight < y.current.clientHeight && x) {
        const _ = `${getScrollbarSize(ownerWindow(R))}px`;
        y.current.style[C === "rtl" ? "paddingLeft" : "paddingRight"] = _, y.current.style.width = `calc(100% + ${_})`;
      }
      return y.current;
    }
  }), []);
  const T = (R) => {
    const C = y.current, x = R.key;
    if (R.ctrlKey || R.metaKey || R.altKey) {
      p && p(R);
      return;
    }
    const D = ownerDocument(C).activeElement;
    if (x === "ArrowDown")
      R.preventDefault(), moveFocus(C, D, c, u, nextItem);
    else if (x === "ArrowUp")
      R.preventDefault(), moveFocus(C, D, c, u, previousItem);
    else if (x === "Home")
      R.preventDefault(), moveFocus(C, null, c, u, nextItem);
    else if (x === "End")
      R.preventDefault(), moveFocus(C, null, c, u, previousItem);
    else if (x.length === 1) {
      const O = h.current, v = x.toLowerCase(), w = performance.now();
      O.keys.length > 0 && (w - O.lastTime > 500 ? (O.keys = [], O.repeating = !0, O.previousKeyMatched = !0) : O.repeating && v !== O.keys[0] && (O.repeating = !1)), O.lastTime = w, O.keys.push(v);
      const M = D && !O.repeating && textCriteriaMatches(D, O);
      O.previousKeyMatched && (M || moveFocus(C, D, !1, u, nextItem, O)) ? R.preventDefault() : O.previousKeyMatched = !1;
    }
    p && p(R);
  }, P = useForkRef(y, o);
  let E = -1;
  React.Children.forEach(l, (R, C) => {
    if (!/* @__PURE__ */ React.isValidElement(R)) {
      E === C && (E += 1, E >= l.length && (E = -1));
      return;
    }
    process.env.NODE_ENV !== "production" && reactIsExports.isFragment(R) && console.error(["MUI: The Menu component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`)), R.props.disabled || (f === "selectedMenu" && R.props.selected || E === -1) && (E = C), E === C && (R.props.disabled || R.props.muiSkipListHighlight || R.type.muiSkipListHighlight) && (E += 1, E >= l.length && (E = -1));
  });
  const $ = React.Children.map(l, (R, C) => {
    if (C === E) {
      const x = {};
      return i && (x.autoFocus = !0), R.props.tabIndex === void 0 && f === "selectedMenu" && (x.tabIndex = 0), /* @__PURE__ */ React.cloneElement(R, x);
    }
    return R;
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(List, {
    role: "menu",
    ref: P,
    className: d,
    onKeyDown: T,
    tabIndex: s ? 0 : -1,
    ...g,
    children: $
  });
});
process.env.NODE_ENV !== "production" && (MenuList.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, will focus the `[role="menu"]` container and move into tab order.
   * @default false
   */
  autoFocus: PropTypes.bool,
  /**
   * If `true`, will focus the first menuitem if `variant="menu"` or selected item
   * if `variant="selectedMenu"`.
   * @default false
   */
  autoFocusItem: PropTypes.bool,
  /**
   * MenuList contents, normally `MenuItem`s.
   */
  children: PropTypes.node,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * If `true`, will allow focus on disabled items.
   * @default false
   */
  disabledItemsFocusable: PropTypes.bool,
  /**
   * If `true`, the menu items will not wrap focus.
   * @default false
   */
  disableListWrap: PropTypes.bool,
  /**
   * @ignore
   */
  onKeyDown: PropTypes.func,
  /**
   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus
   * and the vertical alignment relative to the anchor element.
   * @default 'selectedMenu'
   */
  variant: PropTypes.oneOf(["menu", "selectedMenu"])
});
function arrayIncludes(e, t) {
  return Array.isArray(t) ? t.every((o) => e.indexOf(o) !== -1) : e.indexOf(t) !== -1;
}
const executeInTheNextEventLoopTick = (e) => {
  setTimeout(e, 0);
}, getActiveElementInternal = (e = document) => {
  const t = e.activeElement;
  return t ? t.shadowRoot ? getActiveElementInternal(t.shadowRoot) : t : null;
}, getActiveElement = (e) => getActiveElementInternal(ownerDocument(e)), DEFAULT_DESKTOP_MODE_MEDIA_QUERY = "@media (pointer: fine)";
function getPickersDayUtilityClass(e) {
  return generateUtilityClass("MuiPickersDay", e);
}
const pickersDayClasses = generateUtilityClasses("MuiPickersDay", ["root", "dayWithMargin", "dayOutsideMonth", "hiddenDaySpacingFiller", "today", "selected", "disabled"]);
function usePickerDayOwnerState(e) {
  const {
    disabled: t,
    selected: o,
    today: n,
    outsideCurrentMonth: s,
    day: i,
    disableMargin: l,
    disableHighlightToday: d,
    showDaysOutsideCurrentMonth: u
  } = e, c = usePickerAdapter(), {
    ownerState: p
  } = usePickerPrivateContext();
  return React.useMemo(() => _extends({}, p, {
    day: i,
    isDaySelected: o ?? !1,
    isDayDisabled: t ?? !1,
    isDayCurrent: n ?? !1,
    isDayOutsideMonth: s ?? !1,
    isDayStartOfWeek: c.isSameDay(i, c.startOfWeek(i)),
    isDayEndOfWeek: c.isSameDay(i, c.endOfWeek(i)),
    disableMargin: l ?? !1,
    disableHighlightToday: d ?? !1,
    showDaysOutsideCurrentMonth: u ?? !1
  }), [c, p, i, o, t, n, s, l, d, u]);
}
const _excluded$s = ["autoFocus", "className", "classes", "hidden", "isAnimating", "onClick", "onDaySelect", "onFocus", "onBlur", "onKeyDown", "onMouseDown", "onMouseEnter", "children", "isFirstVisibleCell", "isLastVisibleCell", "day", "selected", "disabled", "today", "outsideCurrentMonth", "disableMargin", "disableHighlightToday", "showDaysOutsideCurrentMonth"], useUtilityClasses$K = (e, t) => {
  const {
    isDaySelected: o,
    isDayDisabled: n,
    isDayCurrent: s,
    isDayOutsideMonth: i,
    disableMargin: l,
    disableHighlightToday: d,
    showDaysOutsideCurrentMonth: u
  } = t, c = i && !u;
  return composeClasses({
    root: ["root", o && !c && "selected", n && "disabled", !l && "dayWithMargin", !d && s && "today", i && u && "dayOutsideMonth", c && "hiddenDaySpacingFiller"],
    hiddenDaySpacingFiller: ["hiddenDaySpacingFiller"]
  }, getPickersDayUtilityClass, e);
}, styleArg = ({
  theme: e
}) => _extends({}, e.typography.caption, {
  width: DAY_SIZE,
  height: DAY_SIZE,
  borderRadius: "50%",
  padding: 0,
  // explicitly setting to `transparent` to avoid potentially getting impacted by change from the overridden component
  backgroundColor: "transparent",
  transition: e.transitions.create("background-color", {
    duration: e.transitions.duration.short
  }),
  color: (e.vars || e).palette.text.primary,
  "@media (pointer: fine)": {
    "&:hover": {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.hoverOpacity})` : alpha$1(e.palette.primary.main, e.palette.action.hoverOpacity)
    }
  },
  "&:focus": {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.focusOpacity})` : alpha$1(e.palette.primary.main, e.palette.action.focusOpacity),
    [`&.${pickersDayClasses.selected}`]: {
      willChange: "background-color",
      backgroundColor: (e.vars || e).palette.primary.dark
    }
  },
  [`&.${pickersDayClasses.selected}`]: {
    color: (e.vars || e).palette.primary.contrastText,
    backgroundColor: (e.vars || e).palette.primary.main,
    fontWeight: e.typography.fontWeightMedium,
    "&:hover": {
      willChange: "background-color",
      backgroundColor: (e.vars || e).palette.primary.dark
    }
  },
  [`&.${pickersDayClasses.disabled}:not(.${pickersDayClasses.selected})`]: {
    color: (e.vars || e).palette.text.disabled
  },
  [`&.${pickersDayClasses.disabled}&.${pickersDayClasses.selected}`]: {
    opacity: 0.6
  },
  variants: [{
    props: {
      disableMargin: !1
    },
    style: {
      margin: `0 ${DAY_MARGIN}px`
    }
  }, {
    props: {
      isDayOutsideMonth: !0,
      showDaysOutsideCurrentMonth: !0
    },
    style: {
      color: (e.vars || e).palette.text.secondary
    }
  }, {
    props: {
      disableHighlightToday: !1,
      isDayCurrent: !0
    },
    style: {
      [`&:not(.${pickersDayClasses.selected})`]: {
        border: `1px solid ${(e.vars || e).palette.text.secondary}`
      }
    }
  }]
}), overridesResolver$2 = (e, t) => {
  const {
    ownerState: o
  } = e;
  return [t.root, !o.disableMargin && t.dayWithMargin, !o.disableHighlightToday && o.isDayCurrent && t.today, !o.isDayOutsideMonth && o.showDaysOutsideCurrentMonth && t.dayOutsideMonth, o.isDayOutsideMonth && !o.showDaysOutsideCurrentMonth && t.hiddenDaySpacingFiller];
}, PickersDayRoot = styled(ButtonBase, {
  name: "MuiPickersDay",
  slot: "Root",
  overridesResolver: overridesResolver$2
})(styleArg), PickersDayFiller = styled("div", {
  name: "MuiPickersDay",
  slot: "Root",
  overridesResolver: overridesResolver$2
})(({
  theme: e
}) => _extends({}, styleArg({
  theme: e
}), {
  // visibility: 'hidden' does not work here as it hides the element from screen readers as well
  opacity: 0,
  pointerEvents: "none"
})), noop$2 = () => {
}, PickersDayRaw = /* @__PURE__ */ React.forwardRef(function e(t, o) {
  const n = useThemeProps({
    props: t,
    name: "MuiPickersDay"
  }), {
    autoFocus: s = !1,
    className: i,
    classes: l,
    isAnimating: d,
    onClick: u,
    onDaySelect: c,
    onFocus: p = noop$2,
    onBlur: f = noop$2,
    onKeyDown: g = noop$2,
    onMouseDown: y = noop$2,
    onMouseEnter: h = noop$2,
    children: T,
    day: P,
    selected: E,
    disabled: $,
    today: R,
    outsideCurrentMonth: C,
    disableMargin: x,
    disableHighlightToday: _,
    showDaysOutsideCurrentMonth: D
  } = n, O = _objectWithoutPropertiesLoose(n, _excluded$s), v = usePickerDayOwnerState({
    day: P,
    selected: E,
    disabled: $,
    today: R,
    outsideCurrentMonth: C,
    disableMargin: x,
    disableHighlightToday: _,
    showDaysOutsideCurrentMonth: D
  }), w = useUtilityClasses$K(l, v), M = usePickerAdapter(), S = React.useRef(null), I = useForkRef(S, o);
  useEnhancedEffect(() => {
    s && !$ && !d && !C && S.current.focus();
  }, [s, $, d, C]);
  const N = (L) => {
    y(L), C && L.preventDefault();
  }, F = (L) => {
    L.defaultMuiPrevented = !0, $ || c(P), C && L.currentTarget.focus(), u && u(L);
  };
  return C && !D ? /* @__PURE__ */ jsxRuntimeExports.jsx(PickersDayFiller, {
    className: clsx(w.root, w.hiddenDaySpacingFiller, i),
    ownerState: v,
    role: O.role
  }) : /* @__PURE__ */ jsxRuntimeExports.jsx(PickersDayRoot, _extends({
    className: clsx(w.root, i),
    ref: I,
    centerRipple: !0,
    disabled: $,
    tabIndex: E ? 0 : -1,
    onKeyDown: (L) => g(L, P),
    onFocus: (L) => p(L, P),
    onBlur: (L) => f(L, P),
    onMouseEnter: (L) => h(L, P),
    onClick: F,
    onMouseDown: N
  }, O, {
    ownerState: v,
    children: T ?? M.format(P, "dayOfMonth")
  }));
});
process.env.NODE_ENV !== "production" && (PickersDayRaw.displayName = "PickersDayRaw");
process.env.NODE_ENV !== "production" && (PickersDayRaw.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * A ref for imperative actions.
   * It currently only supports `focusVisible()` action.
   */
  action: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.shape({
      focusVisible: PropTypes.func.isRequired
    })
  })]),
  /**
   * If `true`, the ripples are centered.
   * They won't start at the cursor interaction position.
   * @default false
   */
  centerRipple: PropTypes.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  className: PropTypes.string,
  component: PropTypes.elementType,
  /**
   * The date to show.
   */
  day: PropTypes.object.isRequired,
  /**
   * If `true`, renders as disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: PropTypes.bool,
  /**
   * If `true`, days are rendering without margin. Useful for displaying linked range of days.
   * @default false
   */
  disableMargin: PropTypes.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: PropTypes.bool,
  /**
   * If `true`, the touch ripple effect is disabled.
   * @default false
   */
  disableTouchRipple: PropTypes.bool,
  /**
   * If `true`, the base button will have a keyboard focus ripple.
   * @default false
   */
  focusRipple: PropTypes.bool,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: PropTypes.string,
  isAnimating: PropTypes.bool,
  /**
   * If `true`, day is the first visible cell of the month.
   * Either the first day of the month or the first day of the week depending on `showDaysOutsideCurrentMonth`.
   */
  isFirstVisibleCell: PropTypes.bool.isRequired,
  /**
   * If `true`, day is the last visible cell of the month.
   * Either the last day of the month or the last day of the week depending on `showDaysOutsideCurrentMonth`.
   */
  isLastVisibleCell: PropTypes.bool.isRequired,
  onBlur: PropTypes.func,
  onDaySelect: PropTypes.func.isRequired,
  onFocus: PropTypes.func,
  /**
   * Callback fired when the component is focused with a keyboard.
   * We trigger a `onFocus` callback too.
   */
  onFocusVisible: PropTypes.func,
  onKeyDown: PropTypes.func,
  onMouseEnter: PropTypes.func,
  /**
   * If `true`, day is outside of month and will be hidden.
   */
  outsideCurrentMonth: PropTypes.bool.isRequired,
  /**
   * If `true`, renders as selected.
   * @default false
   */
  selected: PropTypes.bool,
  /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */
  showDaysOutsideCurrentMonth: PropTypes.bool,
  style: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * @default 0
   */
  tabIndex: PropTypes.number,
  /**
   * If `true`, renders as today date.
   * @default false
   */
  today: PropTypes.bool,
  /**
   * Props applied to the `TouchRipple` element.
   */
  TouchRippleProps: PropTypes.object,
  /**
   * A ref that points to the `TouchRipple` element.
   */
  touchRippleRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.shape({
      pulsate: PropTypes.func.isRequired,
      start: PropTypes.func.isRequired,
      stop: PropTypes.func.isRequired
    })
  })])
});
const PickersDay = /* @__PURE__ */ React.memo(PickersDayRaw);
process.env.NODE_ENV !== "production" && (PickersDay.displayName = "PickersDay");
const isQueryResponseWithoutValue = (e) => e.saveQuery != null, useFieldCharacterEditing = ({
  stateResponse: {
    // States and derived states
    localizedDigits: e,
    sectionsValueBoundaries: t,
    state: o,
    timezone: n,
    // Methods to update the states
    setCharacterQuery: s,
    setTempAndroidValueStr: i,
    updateSectionValue: l
  }
}) => {
  const d = usePickerAdapter(), u = ({
    keyPressed: f,
    sectionIndex: g
  }, y, h) => {
    const T = f.toLowerCase(), P = o.sections[g];
    if (o.characterQuery != null && (!h || h(o.characterQuery.value)) && o.characterQuery.sectionIndex === g) {
      const $ = `${o.characterQuery.value}${T}`, R = y($, P);
      if (!isQueryResponseWithoutValue(R))
        return s({
          sectionIndex: g,
          value: $,
          sectionType: P.type
        }), R;
    }
    const E = y(T, P);
    return isQueryResponseWithoutValue(E) && !E.saveQuery ? (s(null), null) : (s({
      sectionIndex: g,
      value: T,
      sectionType: P.type
    }), isQueryResponseWithoutValue(E) ? null : E);
  }, c = (f) => {
    const g = (T, P, E) => {
      const $ = P.filter((R) => R.toLowerCase().startsWith(E));
      return $.length === 0 ? {
        saveQuery: !1
      } : {
        sectionValue: $[0],
        shouldGoToNextSection: $.length === 1
      };
    }, y = (T, P, E, $) => {
      const R = (C) => getLetterEditingOptions(d, n, P.type, C);
      if (P.contentType === "letter")
        return g(P.format, R(P.format), T);
      if (E && $ != null && getDateSectionConfigFromFormatToken(d, E).contentType === "letter") {
        const C = R(E), x = g(E, C, T);
        return isQueryResponseWithoutValue(x) ? {
          saveQuery: !1
        } : _extends({}, x, {
          sectionValue: $(x.sectionValue, C)
        });
      }
      return {
        saveQuery: !1
      };
    };
    return u(f, (T, P) => {
      switch (P.type) {
        case "month": {
          const E = ($) => changeSectionValueFormat(d, $, d.formats.month, P.format);
          return y(T, P, d.formats.month, E);
        }
        case "weekDay": {
          const E = ($, R) => R.indexOf($).toString();
          return y(T, P, d.formats.weekday, E);
        }
        case "meridiem":
          return y(T, P);
        default:
          return {
            saveQuery: !1
          };
      }
    });
  }, p = (f) => {
    const g = ({
      queryValue: h,
      skipIfBelowMinimum: T,
      section: P
    }) => {
      const E = removeLocalizedDigits(h, e), $ = Number(E), R = t[P.type]({
        currentDate: null,
        format: P.format,
        contentType: P.contentType
      });
      if ($ > R.maximum)
        return {
          saveQuery: !1
        };
      if (T && $ < R.minimum)
        return {
          saveQuery: !0
        };
      const C = $ * 10 > R.maximum || E.length === R.maximum.toString().length;
      return {
        sectionValue: cleanDigitSectionValue(d, $, R, e, P),
        shouldGoToNextSection: C
      };
    };
    return u(f, (h, T) => {
      if (T.contentType === "digit" || T.contentType === "digit-with-letter")
        return g({
          queryValue: h,
          skipIfBelowMinimum: !1,
          section: T
        });
      if (T.type === "month") {
        doesSectionFormatHaveLeadingZeros(d, "digit", "month", "MM");
        const P = g({
          queryValue: h,
          skipIfBelowMinimum: !0,
          section: {
            type: T.type,
            format: "MM",
            hasLeadingZerosInInput: !0,
            contentType: "digit",
            maxLength: 2
          }
        });
        if (isQueryResponseWithoutValue(P))
          return P;
        const E = changeSectionValueFormat(d, P.sectionValue, "MM", T.format);
        return _extends({}, P, {
          sectionValue: E
        });
      }
      if (T.type === "weekDay") {
        const P = g({
          queryValue: h,
          skipIfBelowMinimum: !0,
          section: T
        });
        if (isQueryResponseWithoutValue(P))
          return P;
        const E = getDaysInWeekStr(d, T.format)[Number(P.sectionValue) - 1];
        return _extends({}, P, {
          sectionValue: E
        });
      }
      return {
        saveQuery: !1
      };
    }, (h) => isStringNumber(h, e));
  };
  return useEventCallback((f) => {
    const g = o.sections[f.sectionIndex], h = isStringNumber(f.keyPressed, e) ? p(_extends({}, f, {
      keyPressed: applyLocalizedDigits(f.keyPressed, e)
    })) : c(f);
    if (h == null) {
      i(null);
      return;
    }
    l({
      section: g,
      newSectionValue: h.sectionValue,
      shouldGoToNextSection: h.shouldGoToNextSection
    });
  });
}, validateDate = ({
  props: e,
  value: t,
  timezone: o,
  adapter: n
}) => {
  if (t === null)
    return null;
  const {
    shouldDisableDate: s,
    shouldDisableMonth: i,
    shouldDisableYear: l,
    disablePast: d,
    disableFuture: u,
    minDate: c,
    maxDate: p
  } = e, f = n.date(void 0, o);
  switch (!0) {
    case !n.isValid(t):
      return "invalidDate";
    case !!(s && s(t)):
      return "shouldDisableDate";
    case !!(i && i(t)):
      return "shouldDisableMonth";
    case !!(l && l(t)):
      return "shouldDisableYear";
    case !!(u && n.isAfterDay(t, f)):
      return "disableFuture";
    case !!(d && n.isBeforeDay(t, f)):
      return "disablePast";
    case !!(c && n.isBeforeDay(t, c)):
      return "minDate";
    case !!(p && n.isAfterDay(t, p)):
      return "maxDate";
    default:
      return null;
  }
};
validateDate.valueManager = singleItemValueManager;
function useValidation(e) {
  const {
    props: t,
    validator: o,
    value: n,
    timezone: s,
    onError: i
  } = e, l = usePickerAdapter(), d = React.useRef(o.valueManager.defaultErrorState), u = o({
    adapter: l,
    value: n,
    timezone: s,
    props: t
  }), c = o.valueManager.hasError(u);
  React.useEffect(() => {
    i && !o.valueManager.isSameError(u, d.current) && i(u, n), d.current = u;
  }, [o, i, u, n]);
  const p = useEventCallback((f) => o({
    adapter: l,
    value: f,
    timezone: s,
    props: t
  }));
  return {
    validationError: u,
    hasValidationError: c,
    getValidationErrorForNewValue: p
  };
}
const QUERY_LIFE_DURATION_MS = 5e3, useFieldState = (e) => {
  const t = usePickerAdapter(), o = usePickerTranslations(), n = useRtl(), {
    manager: {
      validator: s,
      valueType: i,
      internal_valueManager: l,
      internal_fieldValueManager: d
    },
    internalPropsWithDefaults: u,
    internalPropsWithDefaults: {
      value: c,
      defaultValue: p,
      referenceDate: f,
      onChange: g,
      format: y,
      formatDensity: h = "dense",
      selectedSections: T,
      onSelectedSectionsChange: P,
      shouldRespectLeadingZeros: E = !1,
      timezone: $,
      enableAccessibleFieldDOMStructure: R = !0
    },
    forwardedProps: {
      error: C
    }
  } = e, {
    value: x,
    handleValueChange: _,
    timezone: D
  } = useControlledValue({
    name: "a field component",
    timezone: $,
    value: c,
    defaultValue: p,
    referenceDate: f,
    onChange: g,
    valueManager: l
  }), O = React.useRef(x);
  React.useEffect(() => {
    O.current = x;
  }, [x]);
  const {
    hasValidationError: v
  } = useValidation({
    props: u,
    validator: s,
    timezone: D,
    value: x,
    onError: u.onError
  }), w = React.useMemo(() => C !== void 0 ? C : v, [v, C]), M = React.useMemo(() => getLocalizedDigits(t), [t]), S = React.useMemo(() => getSectionsBoundaries(t, M, D), [t, M, D]), I = React.useCallback((X) => d.getSectionsFromValue(X, (ge) => buildSectionsFromFormat({
    adapter: t,
    localeText: o,
    localizedDigits: M,
    format: y,
    date: ge,
    formatDensity: h,
    shouldRespectLeadingZeros: E,
    enableAccessibleFieldDOMStructure: R,
    isRtl: n
  })), [d, y, o, M, n, E, t, h, R]), [N, F] = React.useState(() => {
    const X = I(x);
    validateSections(X, i);
    const ge = {
      sections: X,
      lastExternalValue: x,
      lastSectionsDependencies: {
        format: y,
        isRtl: n,
        locale: t.locale
      },
      tempValueStrAndroid: null,
      characterQuery: null
    }, Ee = getSectionTypeGranularity(X), xe = l.getInitialReferenceValue({
      referenceDate: f,
      value: x,
      adapter: t,
      props: u,
      granularity: Ee,
      timezone: D
    });
    return _extends({}, ge, {
      referenceValue: xe
    });
  }), [L, k] = useControlled({
    controlled: T,
    default: null,
    name: "useField",
    state: "selectedSections"
  }), W = (X) => {
    k(X), P?.(X);
  }, V = React.useMemo(() => parseSelectedSections(L, N.sections), [L, N.sections]), j = V === "all" ? 0 : V, A = React.useMemo(() => getSectionOrder(N.sections, n && !R), [N.sections, n, R]), U = React.useMemo(() => N.sections.every((X) => X.value === ""), [N.sections]), G = (X) => {
    const ge = {
      validationError: s({
        adapter: t,
        value: X,
        timezone: D,
        props: u
      })
    };
    _(X, ge);
  }, Y = (X, ge) => {
    const Ee = [...N.sections];
    return Ee[X] = _extends({}, Ee[X], {
      value: ge,
      modified: !0
    }), Ee;
  }, ee = React.useRef(null), J = useTimeout(), Z = (X) => {
    j != null && (ee.current = {
      sectionIndex: j,
      value: X
    }, J.start(0, () => {
      ee.current = null;
    }));
  }, le = () => {
    l.areValuesEqual(t, x, l.emptyValue) ? F((X) => _extends({}, X, {
      sections: X.sections.map((ge) => _extends({}, ge, {
        value: ""
      })),
      tempValueStrAndroid: null,
      characterQuery: null
    })) : (F((X) => _extends({}, X, {
      characterQuery: null
    })), G(l.emptyValue));
  }, se = () => {
    if (j == null)
      return;
    const X = N.sections[j];
    X.value !== "" && (Z(""), d.getDateFromSection(x, X) === null ? F((ge) => _extends({}, ge, {
      sections: Y(j, ""),
      tempValueStrAndroid: null,
      characterQuery: null
    })) : (F((ge) => _extends({}, ge, {
      characterQuery: null
    })), G(d.updateDateInValue(x, X, null))));
  }, K = (X) => {
    const ge = (xe, he) => {
      const Pe = t.parse(xe, y);
      if (!t.isValid(Pe))
        return null;
      const ye = buildSectionsFromFormat({
        adapter: t,
        localeText: o,
        localizedDigits: M,
        format: y,
        date: Pe,
        formatDensity: h,
        shouldRespectLeadingZeros: E,
        enableAccessibleFieldDOMStructure: R,
        isRtl: n
      });
      return mergeDateIntoReferenceDate(t, Pe, ye, he, !1);
    }, Ee = d.parseValueStr(X, N.referenceValue, ge);
    G(Ee);
  }, q = useTimeout(), B = ({
    section: X,
    newSectionValue: ge,
    shouldGoToNextSection: Ee
  }) => {
    J.clear(), q.clear();
    const xe = d.getDateFromSection(x, X);
    Ee && j < N.sections.length - 1 && W(j + 1);
    const he = Y(j, ge), Pe = d.getDateSectionsFromValue(he, X), ye = getDateFromDateSections(t, Pe, M);
    if (t.isValid(ye)) {
      const _e = mergeDateIntoReferenceDate(t, ye, Pe, d.getDateFromSection(N.referenceValue, X), !0);
      return xe == null && q.start(0, () => {
        O.current === x && F((Ce) => _extends({}, Ce, {
          sections: d.clearDateSections(N.sections, X),
          tempValueStrAndroid: null
        }));
      }), G(d.updateDateInValue(x, X, _e));
    }
    return Pe.every((_e) => _e.value !== "") && (xe == null || t.isValid(xe)) ? (Z(ge), G(d.updateDateInValue(x, X, ye))) : xe != null ? (Z(ge), G(d.updateDateInValue(x, X, null))) : F((_e) => _extends({}, _e, {
      sections: he,
      tempValueStrAndroid: null
    }));
  }, ue = (X) => F((ge) => _extends({}, ge, {
    tempValueStrAndroid: X
  })), re = useEventCallback((X) => {
    F((ge) => _extends({}, ge, {
      characterQuery: X
    }));
  });
  if (x !== N.lastExternalValue) {
    const X = ee.current != null && !t.isValid(d.getDateFromSection(x, N.sections[ee.current.sectionIndex]));
    let ge;
    X ? ge = Y(ee.current.sectionIndex, ee.current.value) : ge = I(x), F((Ee) => _extends({}, Ee, {
      lastExternalValue: x,
      sections: ge,
      sectionsDependencies: {
        format: y,
        isRtl: n,
        locale: t.locale
      },
      referenceValue: X ? Ee.referenceValue : d.updateReferenceValue(t, x, Ee.referenceValue),
      tempValueStrAndroid: null
    }));
  }
  if (n !== N.lastSectionsDependencies.isRtl || y !== N.lastSectionsDependencies.format || t.locale !== N.lastSectionsDependencies.locale) {
    const X = I(x);
    validateSections(X, i), F((ge) => _extends({}, ge, {
      lastSectionsDependencies: {
        format: y,
        isRtl: n,
        locale: t.locale
      },
      sections: X,
      tempValueStrAndroid: null,
      characterQuery: null
    }));
  }
  N.characterQuery != null && !w && j == null && re(null), N.characterQuery != null && N.sections[N.characterQuery.sectionIndex]?.type !== N.characterQuery.sectionType && re(null), React.useEffect(() => {
    ee.current != null && (ee.current = null);
  });
  const be = useTimeout();
  return React.useEffect(() => (N.characterQuery != null && be.start(QUERY_LIFE_DURATION_MS, () => re(null)), () => {
  }), [N.characterQuery, re, be]), React.useEffect(() => {
    N.tempValueStrAndroid != null && j != null && se();
  }, [N.sections]), {
    // States and derived states
    activeSectionIndex: j,
    areAllSectionsEmpty: U,
    error: w,
    localizedDigits: M,
    parsedSelectedSections: V,
    sectionOrder: A,
    sectionsValueBoundaries: S,
    state: N,
    timezone: D,
    value: x,
    // Methods to update the states
    clearValue: le,
    clearActiveSection: se,
    setCharacterQuery: re,
    setSelectedSections: W,
    setTempAndroidValueStr: ue,
    updateSectionValue: B,
    updateValueFromValueStr: K,
    // Utilities methods
    getSectionsFromValue: I
  };
};
function useFieldInternalPropsWithDefaults(e) {
  const {
    manager: {
      internal_useApplyDefaultValuesToFieldInternalProps: t
    },
    internalProps: o,
    skipContextFieldRefAssignment: n
  } = e, s = useNullablePickerContext(), i = useNullableFieldPrivateContext(), l = useForkRef(o.unstableFieldRef, n ? null : i?.fieldRef), d = s?.setValue, u = React.useCallback((p, f) => d?.(p, {
    validationError: f.validationError,
    shouldClose: !1
  }), [d]), c = React.useMemo(() => i != null && s != null ? _extends({
    value: s.value,
    onChange: u,
    timezone: s.timezone,
    disabled: s.disabled,
    readOnly: s.readOnly,
    autoFocus: s.autoFocus && !s.open,
    focused: s.open ? !0 : void 0,
    format: s.fieldFormat,
    formatDensity: i.formatDensity,
    enableAccessibleFieldDOMStructure: i.enableAccessibleFieldDOMStructure,
    selectedSections: i.selectedSections,
    onSelectedSectionsChange: i.onSelectedSectionsChange,
    unstableFieldRef: l
  }, o) : o, [s, i, o, u, l]);
  return t(c);
}
function syncSelectionToDOM(e) {
  const {
    focused: t,
    domGetters: o,
    stateResponse: {
      // States and derived states
      parsedSelectedSections: n,
      state: s
    }
  } = e;
  if (!o.isReady())
    return;
  const i = ownerDocument(o.getRoot()).getSelection();
  if (!i)
    return;
  if (n == null) {
    i.rangeCount > 0 && // Firefox can return a Restricted object here
    i.getRangeAt(0).startContainer instanceof Node && o.getRoot().contains(i.getRangeAt(0).startContainer) && i.removeAllRanges(), t && o.getRoot().blur();
    return;
  }
  if (!o.getRoot().contains(getActiveElement(o.getRoot())))
    return;
  const l = new window.Range();
  let d;
  n === "all" ? d = o.getRoot() : s.sections[n].type === "empty" ? d = o.getSectionContainer(n) : d = o.getSectionContent(n), l.selectNodeContents(d), d.focus(), i.removeAllRanges(), i.addRange(l);
}
function useFieldRootHandleKeyDown(e) {
  const t = usePickerAdapter(), {
    manager: {
      internal_fieldValueManager: o
    },
    internalPropsWithDefaults: {
      minutesStep: n,
      disabled: s,
      readOnly: i
    },
    stateResponse: {
      // States and derived states
      state: l,
      value: d,
      activeSectionIndex: u,
      parsedSelectedSections: c,
      sectionsValueBoundaries: p,
      localizedDigits: f,
      timezone: g,
      sectionOrder: y,
      // Methods to update the states
      clearValue: h,
      clearActiveSection: T,
      setSelectedSections: P,
      updateSectionValue: E
    }
  } = e;
  return useEventCallback(($) => {
    if (!s)
      switch (!0) {
        // Select all
        case (($.ctrlKey || $.metaKey) && String.fromCharCode($.keyCode) === "A" && !$.shiftKey && !$.altKey): {
          $.preventDefault(), P("all");
          break;
        }
        // Move selection to next section
        case $.key === "ArrowRight": {
          if ($.preventDefault(), c == null)
            P(y.startIndex);
          else if (c === "all")
            P(y.endIndex);
          else {
            const R = y.neighbors[c].rightIndex;
            R !== null && P(R);
          }
          break;
        }
        // Move selection to previous section
        case $.key === "ArrowLeft": {
          if ($.preventDefault(), c == null)
            P(y.endIndex);
          else if (c === "all")
            P(y.startIndex);
          else {
            const R = y.neighbors[c].leftIndex;
            R !== null && P(R);
          }
          break;
        }
        // Reset the value of the selected section
        case $.key === "Delete": {
          if ($.preventDefault(), i)
            break;
          c == null || c === "all" ? h() : T();
          break;
        }
        // Increment / decrement the selected section value
        case ["ArrowUp", "ArrowDown", "Home", "End", "PageUp", "PageDown"].includes($.key): {
          if ($.preventDefault(), i || u == null)
            break;
          c === "all" && P(u);
          const R = l.sections[u], C = adjustSectionValue(t, g, R, $.key, p, f, o.getDateFromSection(d, R), {
            minutesStep: n
          });
          E({
            section: R,
            newSectionValue: C,
            shouldGoToNextSection: !1
          });
          break;
        }
      }
  });
}
function getDeltaFromKeyCode(e) {
  switch (e) {
    case "ArrowUp":
      return 1;
    case "ArrowDown":
      return -1;
    case "PageUp":
      return 5;
    case "PageDown":
      return -5;
    default:
      return 0;
  }
}
function adjustSectionValue(e, t, o, n, s, i, l, d) {
  const u = getDeltaFromKeyCode(n), c = n === "Home", p = n === "End", f = o.value === "" || c || p, g = () => {
    const h = s[o.type]({
      currentDate: l,
      format: o.format,
      contentType: o.contentType
    }), T = ($) => cleanDigitSectionValue(e, $, h, i, o), P = o.type === "minutes" && d?.minutesStep ? d.minutesStep : 1;
    let E;
    if (f) {
      if (o.type === "year" && !p && !c)
        return e.formatByString(e.date(void 0, t), o.format);
      u > 0 || c ? E = h.minimum : E = h.maximum;
    } else
      E = parseInt(removeLocalizedDigits(o.value, i), 10) + u * P;
    return E % P !== 0 && ((u < 0 || c) && (E += P - (P + E) % P), (u > 0 || p) && (E -= E % P)), E > h.maximum ? T(h.minimum + (E - h.maximum - 1) % (h.maximum - h.minimum + 1)) : E < h.minimum ? T(h.maximum - (h.minimum - E - 1) % (h.maximum - h.minimum + 1)) : T(E);
  }, y = () => {
    const h = getLetterEditingOptions(e, t, o.type, o.format);
    if (h.length === 0)
      return o.value;
    if (f)
      return u > 0 || c ? h[0] : h[h.length - 1];
    const E = ((h.indexOf(o.value) + u) % h.length + h.length) % h.length;
    return h[E];
  };
  return o.contentType === "digit" || o.contentType === "digit-with-letter" ? g() : y();
}
function useFieldRootProps(e) {
  const {
    manager: t,
    focused: o,
    setFocused: n,
    domGetters: s,
    stateResponse: i,
    applyCharacterEditing: l,
    internalPropsWithDefaults: d,
    stateResponse: {
      // States and derived states
      parsedSelectedSections: u,
      sectionOrder: c,
      state: p,
      // Methods to update the states
      clearValue: f,
      setCharacterQuery: g,
      setSelectedSections: y,
      updateValueFromValueStr: h
    },
    internalPropsWithDefaults: {
      disabled: T = !1,
      readOnly: P = !1
    }
  } = e, E = useFieldRootHandleKeyDown({
    manager: t,
    internalPropsWithDefaults: d,
    stateResponse: i
  }), $ = useTimeout(), R = useEventCallback((O) => {
    T || !s.isReady() || (n(!0), u === "all" ? $.start(0, () => {
      const v = document.getSelection().getRangeAt(0).startOffset;
      if (v === 0) {
        y(c.startIndex);
        return;
      }
      let w = 0, M = 0;
      for (; M < v && w < p.sections.length; ) {
        const S = p.sections[w];
        w += 1, M += `${S.startSeparator}${S.value || S.placeholder}${S.endSeparator}`.length;
      }
      y(w - 1);
    }) : o ? s.getRoot().contains(O.target) || y(c.startIndex) : (n(!0), y(c.startIndex)));
  }), C = useEventCallback((O) => {
    if (!s.isReady() || u !== "all")
      return;
    const w = O.target.textContent ?? "";
    s.getRoot().innerHTML = p.sections.map((M) => `${M.startSeparator}${M.value || M.placeholder}${M.endSeparator}`).join(""), syncSelectionToDOM({
      focused: o,
      domGetters: s,
      stateResponse: i
    }), w.length === 0 || w.charCodeAt(0) === 10 ? (f(), y("all")) : w.length > 1 ? h(w) : (u === "all" && y(0), l({
      keyPressed: w,
      sectionIndex: 0
    }));
  }), x = useEventCallback((O) => {
    if (P || u !== "all") {
      O.preventDefault();
      return;
    }
    const v = O.clipboardData.getData("text");
    O.preventDefault(), g(null), h(v);
  }), _ = useEventCallback(() => {
    if (o || T || !s.isReady())
      return;
    const O = getActiveElement(s.getRoot());
    n(!0), s.getSectionIndexFromDOMElement(O) != null || y(c.startIndex);
  }), D = useEventCallback(() => {
    setTimeout(() => {
      if (!s.isReady())
        return;
      const O = getActiveElement(s.getRoot());
      !s.getRoot().contains(O) && (n(!1), y(null));
    });
  });
  return {
    // Event handlers
    onKeyDown: E,
    onBlur: D,
    onFocus: _,
    onClick: R,
    onPaste: x,
    onInput: C,
    // Other
    contentEditable: u === "all",
    tabIndex: d.disabled || u === 0 ? -1 : 0
    // TODO: Try to set to undefined when there is a section selected.
  };
}
function useFieldHiddenInputProps(e) {
  const {
    manager: {
      internal_fieldValueManager: t
    },
    stateResponse: {
      // States and derived states
      areAllSectionsEmpty: o,
      state: n,
      // Methods to update the states
      updateValueFromValueStr: s
    }
  } = e, i = useEventCallback((d) => {
    s(d.target.value);
  });
  return {
    value: React.useMemo(() => o ? "" : t.getV7HiddenInputValueFromSections(n.sections), [o, n.sections, t]),
    onChange: i
  };
}
function useFieldSectionContainerProps(e) {
  const {
    stateResponse: {
      // Methods to update the states
      setSelectedSections: t
    },
    internalPropsWithDefaults: {
      disabled: o = !1
    }
  } = e, n = React.useCallback((s) => (i) => {
    o || i.isDefaultPrevented() || t(s);
  }, [o, t]);
  return React.useCallback((s) => ({
    "data-sectionindex": s,
    onClick: n(s)
  }), [n]);
}
function useFieldSectionContentProps(e) {
  const t = usePickerAdapter(), o = usePickerTranslations(), {
    focused: n,
    domGetters: s,
    stateResponse: i,
    applyCharacterEditing: l,
    manager: {
      internal_fieldValueManager: d
    },
    stateResponse: {
      // States and derived states
      parsedSelectedSections: u,
      sectionsValueBoundaries: c,
      state: p,
      value: f,
      // Methods to update the states
      clearActiveSection: g,
      setCharacterQuery: y,
      setSelectedSections: h,
      updateSectionValue: T,
      updateValueFromValueStr: P
    },
    internalPropsWithDefaults: {
      disabled: E = !1,
      readOnly: $ = !1
    }
  } = e, R = u === "all", C = !R && !E && !$, x = useEventCallback((M) => {
    if (!s.isReady())
      return;
    const S = p.sections[M];
    s.getSectionContent(M).innerHTML = S.value || S.placeholder, syncSelectionToDOM({
      focused: n,
      domGetters: s,
      stateResponse: i
    });
  }), _ = useEventCallback((M) => {
    if (!s.isReady())
      return;
    const S = M.target, I = S.textContent ?? "", N = s.getSectionIndexFromDOMElement(S), F = p.sections[N];
    if ($) {
      x(N);
      return;
    }
    if (I.length === 0) {
      if (F.value === "") {
        x(N);
        return;
      }
      const L = M.nativeEvent.inputType;
      if (L === "insertParagraph" || L === "insertLineBreak") {
        x(N);
        return;
      }
      x(N), g();
      return;
    }
    l({
      keyPressed: I,
      sectionIndex: N
    }), x(N);
  }), D = useEventCallback((M) => {
    M.preventDefault();
  }), O = useEventCallback((M) => {
    if (M.preventDefault(), $ || E || typeof u != "number")
      return;
    const S = p.sections[u], I = M.clipboardData.getData("text"), N = /^[a-zA-Z]+$/.test(I), F = /^[0-9]+$/.test(I), L = /^(([a-zA-Z]+)|)([0-9]+)(([a-zA-Z]+)|)$/.test(I);
    S.contentType === "letter" && N || S.contentType === "digit" && F || S.contentType === "digit-with-letter" && L ? (y(null), T({
      section: S,
      newSectionValue: I,
      shouldGoToNextSection: !0
    })) : !N && !F && (y(null), P(I));
  }), v = useEventCallback((M) => {
    M.preventDefault(), M.dataTransfer.dropEffect = "none";
  }), w = React.useCallback((M) => () => {
    E || h(M);
  }, [E, h]);
  return React.useCallback((M, S) => {
    const I = c[M.type]({
      currentDate: d.getDateFromSection(f, M),
      contentType: M.contentType,
      format: M.format
    });
    return {
      // Event handlers
      onInput: _,
      onPaste: O,
      onMouseUp: D,
      onDragOver: v,
      onFocus: w(S),
      // Aria attributes
      "aria-readonly": $,
      "aria-valuenow": getSectionValueNow(M, t),
      "aria-valuemin": I.minimum,
      "aria-valuemax": I.maximum,
      "aria-valuetext": M.value ? getSectionValueText(M, t) : o.empty,
      "aria-label": o[M.type],
      "aria-disabled": E,
      // Other
      tabIndex: !C || R || S > 0 ? -1 : 0,
      contentEditable: !R && !E && !$,
      role: "spinbutton",
      "data-range-position": M.dateName || void 0,
      spellCheck: C ? !1 : void 0,
      // Firefox hydrates this as `'none`' instead of `'off'`. No problems in chromium with both values.
      // For reference https://github.com/mui/mui-x/issues/19012
      autoCapitalize: C ? "none" : void 0,
      autoCorrect: C ? "off" : void 0,
      children: M.value || M.placeholder,
      inputMode: M.contentType === "letter" ? "text" : "numeric"
    };
  }, [c, R, E, $, C, o, t, _, O, D, v, w, d, f]);
}
function getSectionValueText(e, t) {
  if (e.value)
    switch (e.type) {
      case "month": {
        if (e.contentType === "digit") {
          const n = t.setMonth(t.date(), Number(e.value) - 1);
          return t.isValid(n) ? t.format(n, "month") : "";
        }
        const o = t.parse(e.value, e.format);
        return o && t.isValid(o) ? t.format(o, "month") : void 0;
      }
      case "day":
        if (e.contentType === "digit") {
          const o = t.setDate(t.startOfYear(t.date()), Number(e.value));
          return t.isValid(o) ? t.format(o, "dayOfMonthFull") : "";
        }
        return e.value;
      case "weekDay":
        return;
      default:
        return;
    }
}
function getSectionValueNow(e, t) {
  if (e.value)
    switch (e.type) {
      case "weekDay":
        return e.contentType === "letter" ? void 0 : Number(e.value);
      case "meridiem": {
        const o = t.parse(`01:00 ${e.value}`, `${t.formats.hours12h}:${t.formats.minutes} ${e.format}`);
        return o ? t.getHours(o) >= 12 ? 1 : 0 : void 0;
      }
      case "day":
        return e.contentType === "digit-with-letter" ? parseInt(e.value, 10) : Number(e.value);
      case "month": {
        if (e.contentType === "digit")
          return Number(e.value);
        const o = t.parse(e.value, e.format);
        return o ? t.getMonth(o) + 1 : void 0;
      }
      default:
        return e.contentType !== "letter" ? Number(e.value) : void 0;
    }
}
const useFieldV7TextField = (e) => {
  const {
    props: t,
    manager: o,
    skipContextFieldRefAssignment: n,
    manager: {
      valueType: s,
      internal_useOpenPickerButtonAriaLabel: i
    }
  } = e, {
    internalProps: l,
    forwardedProps: d
  } = useSplitFieldProps(t, s), u = useFieldInternalPropsWithDefaults({
    manager: o,
    internalProps: l,
    skipContextFieldRefAssignment: n
  }), {
    sectionListRef: c,
    onBlur: p,
    onClick: f,
    onFocus: g,
    onInput: y,
    onPaste: h,
    onKeyDown: T,
    onClear: P,
    clearable: E
  } = d, {
    disabled: $ = !1,
    readOnly: R = !1,
    autoFocus: C = !1,
    focused: x,
    unstableFieldRef: _
  } = u, D = React.useRef(null), O = useForkRef(c, D), v = React.useMemo(() => ({
    isReady: () => D.current != null,
    getRoot: () => D.current.getRoot(),
    getSectionContainer: (X) => D.current.getSectionContainer(X),
    getSectionContent: (X) => D.current.getSectionContent(X),
    getSectionIndexFromDOMElement: (X) => D.current.getSectionIndexFromDOMElement(X)
  }), [D]), w = useFieldState({
    manager: o,
    internalPropsWithDefaults: u,
    forwardedProps: d
  }), {
    // States and derived states
    areAllSectionsEmpty: M,
    error: S,
    parsedSelectedSections: I,
    sectionOrder: N,
    state: F,
    value: L,
    // Methods to update the states
    clearValue: k,
    setSelectedSections: W
  } = w, V = useFieldCharacterEditing({
    stateResponse: w
  }), j = i(L), [A, U] = React.useState(!1);
  function G(X = 0) {
    if ($ || !D.current || // if the field is already focused, we don't need to focus it again
    getActiveSectionIndex(D) != null)
      return;
    const ge = parseSelectedSections(X, F.sections);
    U(!0), D.current.getSectionContent(ge).focus();
  }
  const Y = useFieldRootProps({
    manager: o,
    internalPropsWithDefaults: u,
    stateResponse: w,
    applyCharacterEditing: V,
    focused: A,
    setFocused: U,
    domGetters: v
  }), ee = useFieldHiddenInputProps({
    manager: o,
    stateResponse: w
  }), J = useFieldSectionContainerProps({
    stateResponse: w,
    internalPropsWithDefaults: u
  }), Z = useFieldSectionContentProps({
    manager: o,
    stateResponse: w,
    applyCharacterEditing: V,
    internalPropsWithDefaults: u,
    domGetters: v,
    focused: A
  }), le = useEventCallback((X) => {
    T?.(X), Y.onKeyDown(X);
  }), se = useEventCallback((X) => {
    p?.(X), Y.onBlur(X);
  }), K = useEventCallback((X) => {
    g?.(X), Y.onFocus(X);
  }), q = useEventCallback((X) => {
    X.isDefaultPrevented() || (f?.(X), Y.onClick(X));
  }), B = useEventCallback((X) => {
    h?.(X), Y.onPaste(X);
  }), ue = useEventCallback((X) => {
    y?.(X), Y.onInput(X);
  }), re = useEventCallback((X, ...ge) => {
    X.preventDefault(), P?.(X, ...ge), k(), isFieldFocused$1(D) ? W(N.startIndex) : G(0);
  }), be = React.useMemo(() => F.sections.map((X, ge) => {
    const Ee = Z(X, ge);
    return {
      container: J(ge),
      content: Z(X, ge),
      before: {
        children: X.startSeparator
      },
      after: {
        children: X.endSeparator,
        "data-range-position": X.isEndFormatSeparator ? Ee["data-range-position"] : void 0
      }
    };
  }), [F.sections, J, Z]);
  return React.useEffect(() => {
    if (D.current == null)
      throw new Error(["MUI X: The `sectionListRef` prop has not been initialized by `PickersSectionList`", "You probably tried to pass a component to the `textField` slot that contains an `<input />` element instead of a `PickersSectionList`.", "", "If you want to keep using an `<input />` HTML element for the editing, please add the `enableAccessibleFieldDOMStructure={false}` prop to your Picker or Field component:", "", "<DatePicker enableAccessibleFieldDOMStructure={false} slots={{ textField: MyCustomTextField }} />", "", "Learn more about the field accessible DOM structure on the MUI documentation: https://mui.com/x/react-date-pickers/fields/#fields-to-edit-a-single-element"].join(`
`));
    C && !$ && D.current && D.current.getSectionContent(N.startIndex).focus();
  }, []), useEnhancedEffect(() => {
    if (!(!A || !D.current)) {
      if (I === "all")
        D.current.getRoot().focus();
      else if (typeof I == "number") {
        const X = D.current.getSectionContent(I);
        X && X.focus();
      }
    }
  }, [I, A]), useEnhancedEffect(() => {
    syncSelectionToDOM({
      focused: A,
      domGetters: v,
      stateResponse: w
    });
  }), React.useImperativeHandle(_, () => ({
    getSections: () => F.sections,
    getActiveSectionIndex: () => getActiveSectionIndex(D),
    setSelectedSections: (X) => {
      if ($ || !D.current)
        return;
      const ge = parseSelectedSections(X, F.sections);
      U((ge === "all" ? 0 : ge) !== null), W(X);
    },
    focusField: G,
    isFieldFocused: () => isFieldFocused$1(D)
  })), _extends({}, d, Y, {
    onBlur: se,
    onClick: q,
    onFocus: K,
    onInput: ue,
    onPaste: B,
    onKeyDown: le,
    onClear: re
  }, ee, {
    error: S,
    clearable: !!(E && !M && !R && !$),
    focused: x ?? A,
    sectionListRef: O,
    // Additional
    enableAccessibleFieldDOMStructure: !0,
    elements: be,
    areAllSectionsEmpty: M,
    disabled: $,
    readOnly: R,
    autoFocus: C,
    openPickerAriaLabel: j
  });
};
function getActiveSectionIndex(e) {
  const t = getActiveElement(e.current?.getRoot());
  return !t || !e.current || !e.current.getRoot().contains(t) ? null : e.current.getSectionIndexFromDOMElement(t);
}
function isFieldFocused$1(e) {
  const t = getActiveElement(e.current?.getRoot());
  return !!e.current && e.current.getRoot().contains(t);
}
const cleanString = (e) => e.replace(/[\u2066\u2067\u2068\u2069]/g, ""), addPositionPropertiesToSections = (e, t, o) => {
  let n = 0, s = o ? 1 : 0;
  const i = [];
  for (let l = 0; l < e.length; l += 1) {
    const d = e[l], u = getSectionVisibleValue(d, o ? "input-rtl" : "input-ltr", t), c = `${d.startSeparator}${u}${d.endSeparator}`, p = cleanString(c).length, f = c.length, g = cleanString(u), y = s + (g === "" ? 0 : u.indexOf(g[0])) + d.startSeparator.length, h = y + g.length;
    i.push(_extends({}, d, {
      start: n,
      end: n + p,
      startInInput: y,
      endInInput: h
    })), n += p, s += f;
  }
  return i;
}, useFieldV6TextField = (e) => {
  const t = useRtl(), o = useTimeout(), n = useTimeout(), {
    props: s,
    manager: i,
    skipContextFieldRefAssignment: l,
    manager: {
      valueType: d,
      internal_valueManager: u,
      internal_fieldValueManager: c,
      internal_useOpenPickerButtonAriaLabel: p
    }
  } = e, {
    internalProps: f,
    forwardedProps: g
  } = useSplitFieldProps(s, d), y = useFieldInternalPropsWithDefaults({
    manager: i,
    internalProps: f,
    skipContextFieldRefAssignment: l
  }), {
    onFocus: h,
    onClick: T,
    onPaste: P,
    onBlur: E,
    onKeyDown: $,
    onClear: R,
    clearable: C,
    inputRef: x,
    placeholder: _
  } = g, {
    readOnly: D = !1,
    disabled: O = !1,
    autoFocus: v = !1,
    focused: w,
    unstableFieldRef: M
  } = y, S = React.useRef(null), I = useForkRef(x, S), N = useFieldState({
    manager: i,
    internalPropsWithDefaults: y,
    forwardedProps: g
  }), {
    // States and derived states
    activeSectionIndex: F,
    areAllSectionsEmpty: L,
    error: k,
    localizedDigits: W,
    parsedSelectedSections: V,
    sectionOrder: j,
    state: A,
    value: U,
    // Methods to update the states
    clearValue: G,
    clearActiveSection: Y,
    setCharacterQuery: ee,
    setSelectedSections: J,
    setTempAndroidValueStr: Z,
    updateSectionValue: le,
    updateValueFromValueStr: se,
    // Utilities methods
    getSectionsFromValue: K
  } = N, q = useFieldCharacterEditing({
    stateResponse: N
  }), B = p(U), ue = React.useMemo(() => addPositionPropertiesToSections(A.sections, W, t), [A.sections, W, t]);
  function re() {
    const ce = S.current.selectionStart ?? 0;
    let me;
    ce <= ue[0].startInInput || ce >= ue[ue.length - 1].endInInput ? me = 1 : me = ue.findIndex((z) => z.startInInput - z.startSeparator.length > ce);
    const pe = me === -1 ? ue.length - 1 : me - 1;
    J(pe);
  }
  function be(ce = 0) {
    getActiveElement(S.current) !== S.current && (S.current?.focus(), J(ce));
  }
  const X = useEventCallback((ce) => {
    h?.(ce);
    const me = S.current;
    o.start(0, () => {
      !me || me !== S.current || F == null && (// avoid selecting all sections when focusing empty field without value
      me.value.length && Number(me.selectionEnd) - Number(me.selectionStart) === me.value.length ? J("all") : re());
    });
  }), ge = useEventCallback((ce, ...me) => {
    ce.isDefaultPrevented() || (T?.(ce, ...me), re());
  }), Ee = useEventCallback((ce) => {
    if (P?.(ce), ce.preventDefault(), D || O)
      return;
    const me = ce.clipboardData.getData("text");
    if (typeof V == "number") {
      const pe = A.sections[V], z = /^[a-zA-Z]+$/.test(me), Q = /^[0-9]+$/.test(me), Te = /^(([a-zA-Z]+)|)([0-9]+)(([a-zA-Z]+)|)$/.test(me);
      if (pe.contentType === "letter" && z || pe.contentType === "digit" && Q || pe.contentType === "digit-with-letter" && Te) {
        ee(null), le({
          section: pe,
          newSectionValue: me,
          shouldGoToNextSection: !0
        });
        return;
      }
      if (z || Q)
        return;
    }
    ee(null), se(me);
  }), xe = useEventCallback((ce) => {
    E?.(ce), J(null);
  }), he = useEventCallback((ce) => {
    if (D)
      return;
    const me = ce.target.value;
    if (me === "") {
      G();
      return;
    }
    const pe = ce.nativeEvent.data, z = pe && pe.length > 1, Q = z ? pe : me, Te = cleanString(Q);
    if (V === "all" && J(F), F == null || z) {
      se(z ? pe : Te);
      return;
    }
    let fe;
    if (V === "all" && Te.length === 1)
      fe = Te;
    else {
      const oe = cleanString(c.getV6InputValueFromSections(ue, W, t));
      let ae = -1, Se = -1;
      for (let ve = 0; ve < oe.length; ve += 1)
        ae === -1 && oe[ve] !== Te[ve] && (ae = ve), Se === -1 && oe[oe.length - ve - 1] !== Te[Te.length - ve - 1] && (Se = ve);
      const $e = ue[F];
      if (ae < $e.start || oe.length - Se - 1 > $e.end)
        return;
      const Oe = Te.length - oe.length + $e.end - cleanString($e.endSeparator || "").length;
      fe = Te.slice($e.start + cleanString($e.startSeparator || "").length, Oe);
    }
    if (fe.length === 0) {
      isAndroid() && Z(Q), Y();
      return;
    }
    q({
      keyPressed: fe,
      sectionIndex: F
    });
  }), Pe = useEventCallback((ce, ...me) => {
    ce.preventDefault(), R?.(ce, ...me), G(), isFieldFocused(S) ? J(j.startIndex) : be(0);
  }), ye = useFieldRootHandleKeyDown({
    manager: i,
    internalPropsWithDefaults: y,
    stateResponse: N
  }), _e = useEventCallback((ce) => {
    $?.(ce), ye(ce);
  }), Ce = React.useMemo(() => _ !== void 0 ? _ : c.getV6InputValueFromSections(K(u.emptyValue), W, t), [_, c, K, u.emptyValue, W, t]), ne = React.useMemo(() => A.tempValueStrAndroid ?? c.getV6InputValueFromSections(A.sections, W, t), [A.sections, c, A.tempValueStrAndroid, W, t]);
  React.useEffect(() => {
    S.current && S.current === getActiveElement(S.current) && J("all");
  }, []), useEnhancedEffect(() => {
    function ce() {
      if (!S.current)
        return;
      if (V == null) {
        S.current.scrollLeft && (S.current.scrollLeft = 0);
        return;
      }
      if (S.current !== getActiveElement(S.current))
        return;
      const me = S.current.scrollTop;
      if (V === "all")
        S.current.select();
      else {
        const pe = ue[V], z = pe.type === "empty" ? pe.startInInput - pe.startSeparator.length : pe.startInInput, Q = pe.type === "empty" ? pe.endInInput + pe.endSeparator.length : pe.endInInput;
        (z !== S.current.selectionStart || Q !== S.current.selectionEnd) && S.current === getActiveElement(S.current) && S.current.setSelectionRange(z, Q), n.start(0, () => {
          S.current && S.current === getActiveElement(S.current) && // The section might loose all selection, where `selectionStart === selectionEnd`
          // https://github.com/mui/mui-x/pull/13652
          S.current.selectionStart === S.current.selectionEnd && (S.current.selectionStart !== z || S.current.selectionEnd !== Q) && ce();
        });
      }
      S.current.scrollTop = me;
    }
    ce();
  });
  const H = React.useMemo(() => F == null || A.sections[F].contentType === "letter" ? "text" : "numeric", [F, A.sections]), ie = !(S.current && S.current === getActiveElement(S.current)) && L;
  return React.useImperativeHandle(M, () => ({
    getSections: () => A.sections,
    getActiveSectionIndex: () => {
      const ce = S.current.selectionStart ?? 0, me = S.current.selectionEnd ?? 0;
      if (ce === 0 && me === 0)
        return null;
      const pe = ce <= ue[0].startInInput ? 1 : ue.findIndex((z) => z.startInInput - z.startSeparator.length > ce);
      return pe === -1 ? ue.length - 1 : pe - 1;
    },
    setSelectedSections: (ce) => J(ce),
    focusField: be,
    isFieldFocused: () => isFieldFocused(S)
  })), _extends({}, g, {
    error: k,
    clearable: !!(C && !L && !D && !O),
    onBlur: xe,
    onClick: ge,
    onFocus: X,
    onPaste: Ee,
    onKeyDown: _e,
    onClear: Pe,
    inputRef: I,
    // Additional
    enableAccessibleFieldDOMStructure: !1,
    placeholder: Ce,
    inputMode: H,
    autoComplete: "off",
    value: ie ? "" : ne,
    onChange: he,
    focused: w,
    disabled: O,
    readOnly: D,
    autoFocus: v,
    openPickerAriaLabel: B
  });
};
function isFieldFocused(e) {
  return e.current === getActiveElement(e.current);
}
const useField = (e) => {
  const t = useNullableFieldPrivateContext();
  return (e.props.enableAccessibleFieldDOMStructure ?? t?.enableAccessibleFieldDOMStructure ?? !0 ? useFieldV7TextField : useFieldV6TextField)(e);
};
function useDateManager(e = {}) {
  const {
    enableAccessibleFieldDOMStructure: t = !0
  } = e;
  return React.useMemo(() => ({
    valueType: "date",
    validator: validateDate,
    internal_valueManager: singleItemValueManager,
    internal_fieldValueManager: singleItemFieldValueManager,
    internal_enableAccessibleFieldDOMStructure: t,
    internal_useApplyDefaultValuesToFieldInternalProps: useApplyDefaultValuesToDateFieldInternalProps,
    internal_useOpenPickerButtonAriaLabel: useOpenPickerButtonAriaLabel
  }), [t]);
}
function useOpenPickerButtonAriaLabel(e) {
  const t = usePickerAdapter(), o = usePickerTranslations();
  return React.useMemo(() => {
    const n = t.isValid(e) ? t.format(e, "fullDate") : null;
    return o.openDatePickerDialogue(n);
  }, [e, o, t]);
}
function useApplyDefaultValuesToDateFieldInternalProps(e) {
  const t = usePickerAdapter(), o = useApplyDefaultValuesToDateValidationProps(e);
  return React.useMemo(() => _extends({}, e, o, {
    format: e.format ?? t.formats.keyboardDate
  }), [e, o, t]);
}
function useApplyDefaultValuesToDateValidationProps(e) {
  const t = usePickerAdapter(), o = useDefaultDates();
  return React.useMemo(() => ({
    disablePast: e.disablePast ?? !1,
    disableFuture: e.disableFuture ?? !1,
    minDate: applyDefaultDate(t, e.minDate, o.minDate),
    maxDate: applyDefaultDate(t, e.maxDate, o.maxDate)
  }), [e.minDate, e.maxDate, e.disableFuture, e.disablePast, t, o]);
}
const useDateField = (e) => {
  const t = useDateManager(e);
  return useField({
    manager: t,
    props: e
  });
};
function getStyleValue(e) {
  return parseInt(e, 10) || 0;
}
const styles$2 = {
  shadow: {
    // Visibility needed to hide the extra text area on iPads
    visibility: "hidden",
    // Remove from the content flow
    position: "absolute",
    // Ignore the scrollbar width
    overflow: "hidden",
    height: 0,
    top: 0,
    left: 0,
    // Create a new layer, increase the isolation of the computed values
    transform: "translateZ(0)"
  }
};
function isObjectEmpty(e) {
  for (const t in e)
    return !1;
  return !0;
}
function isEmpty$1(e) {
  return isObjectEmpty(e) || e.outerHeightStyle === 0 && !e.overflowing;
}
const TextareaAutosize = /* @__PURE__ */ React.forwardRef(function e(t, o) {
  const {
    onChange: n,
    maxRows: s,
    minRows: i = 1,
    style: l,
    value: d,
    ...u
  } = t, {
    current: c
  } = React.useRef(d != null), p = React.useRef(null), f = useForkRef(o, p), g = React.useRef(null), y = React.useRef(null), h = React.useCallback(() => {
    const R = p.current, C = y.current;
    if (!R || !C)
      return;
    const _ = ownerWindow(R).getComputedStyle(R);
    if (_.width === "0px")
      return {
        outerHeightStyle: 0,
        overflowing: !1
      };
    C.style.width = _.width, C.value = R.value || t.placeholder || "x", C.value.slice(-1) === `
` && (C.value += " ");
    const D = _.boxSizing, O = getStyleValue(_.paddingBottom) + getStyleValue(_.paddingTop), v = getStyleValue(_.borderBottomWidth) + getStyleValue(_.borderTopWidth), w = C.scrollHeight;
    C.value = "x";
    const M = C.scrollHeight;
    let S = w;
    i && (S = Math.max(Number(i) * M, S)), s && (S = Math.min(Number(s) * M, S)), S = Math.max(S, M);
    const I = S + (D === "border-box" ? O + v : 0), N = Math.abs(S - w) <= 1;
    return {
      outerHeightStyle: I,
      overflowing: N
    };
  }, [s, i, t.placeholder]), T = useEventCallback(() => {
    const R = p.current, C = h();
    if (!R || !C || isEmpty$1(C))
      return !1;
    const x = C.outerHeightStyle;
    return g.current != null && g.current !== x;
  }), P = React.useCallback(() => {
    const R = p.current, C = h();
    if (!R || !C || isEmpty$1(C))
      return;
    const x = C.outerHeightStyle;
    g.current !== x && (g.current = x, R.style.height = `${x}px`), R.style.overflow = C.overflowing ? "hidden" : "";
  }, [h]), E = React.useRef(-1);
  useEnhancedEffect(() => {
    const R = debounce$1(P), C = p?.current;
    if (!C)
      return;
    const x = ownerWindow(C);
    x.addEventListener("resize", R);
    let _;
    return typeof ResizeObserver < "u" && (_ = new ResizeObserver(() => {
      T() && (_.unobserve(C), cancelAnimationFrame(E.current), P(), E.current = requestAnimationFrame(() => {
        _.observe(C);
      }));
    }), _.observe(C)), () => {
      R.clear(), cancelAnimationFrame(E.current), x.removeEventListener("resize", R), _ && _.disconnect();
    };
  }, [h, P, T]), useEnhancedEffect(() => {
    P();
  });
  const $ = (R) => {
    c || P();
    const C = R.target, x = C.value.length, _ = C.value.endsWith(`
`), D = C.selectionStart === x;
    _ && D && C.setSelectionRange(x, x), n && n(R);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(React.Fragment, {
    children: [/* @__PURE__ */ jsxRuntimeExports.jsx("textarea", {
      value: d,
      onChange: $,
      ref: f,
      rows: i,
      style: l,
      ...u
    }), /* @__PURE__ */ jsxRuntimeExports.jsx("textarea", {
      "aria-hidden": !0,
      className: t.className,
      readOnly: !0,
      ref: y,
      tabIndex: -1,
      style: {
        ...styles$2.shadow,
        ...l,
        paddingTop: 0,
        paddingBottom: 0
      }
    })]
  });
});
process.env.NODE_ENV !== "production" && (TextareaAutosize.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * Maximum number of rows to display.
   */
  maxRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * Minimum number of rows to display.
   * @default 1
   */
  minRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * @ignore
   */
  onChange: PropTypes.func,
  /**
   * @ignore
   */
  placeholder: PropTypes.string,
  /**
   * @ignore
   */
  style: PropTypes.object,
  /**
   * @ignore
   */
  value: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.number, PropTypes.string])
});
function formControlState({
  props: e,
  states: t,
  muiFormControl: o
}) {
  return t.reduce((n, s) => (n[s] = e[s], o && typeof e[s] > "u" && (n[s] = o[s]), n), {});
}
const FormControlContext = /* @__PURE__ */ React.createContext(void 0);
process.env.NODE_ENV !== "production" && (FormControlContext.displayName = "FormControlContext");
function useFormControl() {
  return React.useContext(FormControlContext);
}
function hasValue(e) {
  return e != null && !(Array.isArray(e) && e.length === 0);
}
function isFilled(e, t = !1) {
  return e && (hasValue(e.value) && e.value !== "" || t && hasValue(e.defaultValue) && e.defaultValue !== "");
}
function isAdornedStart(e) {
  return e.startAdornment;
}
function getInputBaseUtilityClass(e) {
  return generateUtilityClass("MuiInputBase", e);
}
const inputBaseClasses = generateUtilityClasses("MuiInputBase", ["root", "formControl", "focused", "disabled", "adornedStart", "adornedEnd", "error", "sizeSmall", "multiline", "colorSecondary", "fullWidth", "hiddenLabel", "readOnly", "input", "inputSizeSmall", "inputMultiline", "inputTypeSearch", "inputAdornedStart", "inputAdornedEnd", "inputHiddenLabel"]);
var _InputGlobalStyles;
const rootOverridesResolver = (e, t) => {
  const {
    ownerState: o
  } = e;
  return [t.root, o.formControl && t.formControl, o.startAdornment && t.adornedStart, o.endAdornment && t.adornedEnd, o.error && t.error, o.size === "small" && t.sizeSmall, o.multiline && t.multiline, o.color && t[`color${capitalize(o.color)}`], o.fullWidth && t.fullWidth, o.hiddenLabel && t.hiddenLabel];
}, inputOverridesResolver = (e, t) => {
  const {
    ownerState: o
  } = e;
  return [t.input, o.size === "small" && t.inputSizeSmall, o.multiline && t.inputMultiline, o.type === "search" && t.inputTypeSearch, o.startAdornment && t.inputAdornedStart, o.endAdornment && t.inputAdornedEnd, o.hiddenLabel && t.inputHiddenLabel];
}, useUtilityClasses$J = (e) => {
  const {
    classes: t,
    color: o,
    disabled: n,
    error: s,
    endAdornment: i,
    focused: l,
    formControl: d,
    fullWidth: u,
    hiddenLabel: c,
    multiline: p,
    readOnly: f,
    size: g,
    startAdornment: y,
    type: h
  } = e, T = {
    root: ["root", `color${capitalize(o)}`, n && "disabled", s && "error", u && "fullWidth", l && "focused", d && "formControl", g && g !== "medium" && `size${capitalize(g)}`, p && "multiline", y && "adornedStart", i && "adornedEnd", c && "hiddenLabel", f && "readOnly"],
    input: ["input", n && "disabled", h === "search" && "inputTypeSearch", p && "inputMultiline", g === "small" && "inputSizeSmall", c && "inputHiddenLabel", y && "inputAdornedStart", i && "inputAdornedEnd", f && "readOnly"]
  };
  return composeClasses(T, getInputBaseUtilityClass, t);
}, InputBaseRoot = styled("div", {
  name: "MuiInputBase",
  slot: "Root",
  overridesResolver: rootOverridesResolver
})(memoTheme(({
  theme: e
}) => ({
  ...e.typography.body1,
  color: (e.vars || e).palette.text.primary,
  lineHeight: "1.4375em",
  // 23px
  boxSizing: "border-box",
  // Prevent padding issue with fullWidth.
  position: "relative",
  cursor: "text",
  display: "inline-flex",
  alignItems: "center",
  [`&.${inputBaseClasses.disabled}`]: {
    color: (e.vars || e).palette.text.disabled,
    cursor: "default"
  },
  variants: [{
    props: ({
      ownerState: t
    }) => t.multiline,
    style: {
      padding: "4px 0 5px"
    }
  }, {
    props: ({
      ownerState: t,
      size: o
    }) => t.multiline && o === "small",
    style: {
      paddingTop: 1
    }
  }, {
    props: ({
      ownerState: t
    }) => t.fullWidth,
    style: {
      width: "100%"
    }
  }]
}))), InputBaseInput = styled("input", {
  name: "MuiInputBase",
  slot: "Input",
  overridesResolver: inputOverridesResolver
})(memoTheme(({
  theme: e
}) => {
  const t = e.palette.mode === "light", o = {
    color: "currentColor",
    ...e.vars ? {
      opacity: e.vars.opacity.inputPlaceholder
    } : {
      opacity: t ? 0.42 : 0.5
    },
    transition: e.transitions.create("opacity", {
      duration: e.transitions.duration.shorter
    })
  }, n = {
    opacity: "0 !important"
  }, s = e.vars ? {
    opacity: e.vars.opacity.inputPlaceholder
  } : {
    opacity: t ? 0.42 : 0.5
  };
  return {
    font: "inherit",
    letterSpacing: "inherit",
    color: "currentColor",
    padding: "4px 0 5px",
    border: 0,
    boxSizing: "content-box",
    background: "none",
    height: "1.4375em",
    // Reset 23pxthe native input line-height
    margin: 0,
    // Reset for Safari
    WebkitTapHighlightColor: "transparent",
    display: "block",
    // Make the flex item shrink with Firefox
    minWidth: 0,
    width: "100%",
    "&::-webkit-input-placeholder": o,
    "&::-moz-placeholder": o,
    // Firefox 19+
    "&::-ms-input-placeholder": o,
    // Edge
    "&:focus": {
      outline: 0
    },
    // Reset Firefox invalid required input style
    "&:invalid": {
      boxShadow: "none"
    },
    "&::-webkit-search-decoration": {
      // Remove the padding when type=search.
      WebkitAppearance: "none"
    },
    // Show and hide the placeholder logic
    [`label[data-shrink=false] + .${inputBaseClasses.formControl} &`]: {
      "&::-webkit-input-placeholder": n,
      "&::-moz-placeholder": n,
      // Firefox 19+
      "&::-ms-input-placeholder": n,
      // Edge
      "&:focus::-webkit-input-placeholder": s,
      "&:focus::-moz-placeholder": s,
      // Firefox 19+
      "&:focus::-ms-input-placeholder": s
      // Edge
    },
    [`&.${inputBaseClasses.disabled}`]: {
      opacity: 1,
      // Reset iOS opacity
      WebkitTextFillColor: (e.vars || e).palette.text.disabled
      // Fix opacity Safari bug
    },
    variants: [{
      props: ({
        ownerState: i
      }) => !i.disableInjectingGlobalStyles,
      style: {
        animationName: "mui-auto-fill-cancel",
        animationDuration: "10ms",
        "&:-webkit-autofill": {
          animationDuration: "5000s",
          animationName: "mui-auto-fill"
        }
      }
    }, {
      props: {
        size: "small"
      },
      style: {
        paddingTop: 1
      }
    }, {
      props: ({
        ownerState: i
      }) => i.multiline,
      style: {
        height: "auto",
        resize: "none",
        padding: 0,
        paddingTop: 0
      }
    }, {
      props: {
        type: "search"
      },
      style: {
        MozAppearance: "textfield"
        // Improve type search style.
      }
    }]
  };
})), InputGlobalStyles = globalCss({
  "@keyframes mui-auto-fill": {
    from: {
      display: "block"
    }
  },
  "@keyframes mui-auto-fill-cancel": {
    from: {
      display: "block"
    }
  }
}), InputBase = /* @__PURE__ */ React.forwardRef(function e(t, o) {
  const n = useDefaultProps({
    props: t,
    name: "MuiInputBase"
  }), {
    "aria-describedby": s,
    autoComplete: i,
    autoFocus: l,
    className: d,
    color: u,
    components: c = {},
    componentsProps: p = {},
    defaultValue: f,
    disabled: g,
    disableInjectingGlobalStyles: y,
    endAdornment: h,
    error: T,
    fullWidth: P = !1,
    id: E,
    inputComponent: $ = "input",
    inputProps: R = {},
    inputRef: C,
    margin: x,
    maxRows: _,
    minRows: D,
    multiline: O = !1,
    name: v,
    onBlur: w,
    onChange: M,
    onClick: S,
    onFocus: I,
    onKeyDown: N,
    onKeyUp: F,
    placeholder: L,
    readOnly: k,
    renderSuffix: W,
    rows: V,
    size: j,
    slotProps: A = {},
    slots: U = {},
    startAdornment: G,
    type: Y = "text",
    value: ee,
    ...J
  } = n, Z = R.value != null ? R.value : ee, {
    current: le
  } = React.useRef(Z != null), se = React.useRef(), K = React.useCallback((pe) => {
    process.env.NODE_ENV !== "production" && pe && pe.nodeName !== "INPUT" && !pe.focus && console.error(["MUI: You have provided a `inputComponent` to the input component", "that does not correctly handle the `ref` prop.", "Make sure the `ref` prop is called with a HTMLInputElement."].join(`
`));
  }, []), q = useForkRef(se, C, R.ref, K), [B, ue] = React.useState(!1), re = useFormControl();
  process.env.NODE_ENV !== "production" && React.useEffect(() => {
    if (re)
      return re.registerEffect();
  }, [re]);
  const be = formControlState({
    props: n,
    muiFormControl: re,
    states: ["color", "disabled", "error", "hiddenLabel", "size", "required", "filled"]
  });
  be.focused = re ? re.focused : B, React.useEffect(() => {
    !re && g && B && (ue(!1), w && w());
  }, [re, g, B, w]);
  const X = re && re.onFilled, ge = re && re.onEmpty, Ee = React.useCallback((pe) => {
    isFilled(pe) ? X && X() : ge && ge();
  }, [X, ge]);
  useEnhancedEffect(() => {
    le && Ee({
      value: Z
    });
  }, [Z, Ee, le]);
  const xe = (pe) => {
    I && I(pe), R.onFocus && R.onFocus(pe), re && re.onFocus ? re.onFocus(pe) : ue(!0);
  }, he = (pe) => {
    w && w(pe), R.onBlur && R.onBlur(pe), re && re.onBlur ? re.onBlur(pe) : ue(!1);
  }, Pe = (pe, ...z) => {
    if (!le) {
      const Q = pe.target || se.current;
      if (Q == null)
        throw new Error(process.env.NODE_ENV !== "production" ? "MUI: Expected valid input target. Did you use a custom `inputComponent` and forget to forward refs? See https://mui.com/r/input-component-ref-interface for more info." : formatMuiErrorMessage(1));
      Ee({
        value: Q.value
      });
    }
    R.onChange && R.onChange(pe, ...z), M && M(pe, ...z);
  };
  React.useEffect(() => {
    Ee(se.current);
  }, []);
  const ye = (pe) => {
    se.current && pe.currentTarget === pe.target && se.current.focus(), S && S(pe);
  };
  let _e = $, Ce = R;
  O && _e === "input" && (V ? (process.env.NODE_ENV !== "production" && (D || _) && console.warn("MUI: You can not use the `minRows` or `maxRows` props when the input `rows` prop is set."), Ce = {
    type: void 0,
    minRows: V,
    maxRows: V,
    ...Ce
  }) : Ce = {
    type: void 0,
    maxRows: _,
    minRows: D,
    ...Ce
  }, _e = TextareaAutosize);
  const ne = (pe) => {
    Ee(pe.animationName === "mui-auto-fill-cancel" ? se.current : {
      value: "x"
    });
  };
  React.useEffect(() => {
    re && re.setAdornedStart(!!G);
  }, [re, G]);
  const H = {
    ...n,
    color: be.color || "primary",
    disabled: be.disabled,
    endAdornment: h,
    error: be.error,
    focused: be.focused,
    formControl: re,
    fullWidth: P,
    hiddenLabel: be.hiddenLabel,
    multiline: O,
    size: be.size,
    startAdornment: G,
    type: Y
  }, te = useUtilityClasses$J(H), ie = U.root || c.Root || InputBaseRoot, ce = A.root || p.root || {}, me = U.input || c.Input || InputBaseInput;
  return Ce = {
    ...Ce,
    ...A.input ?? p.input
  }, /* @__PURE__ */ jsxRuntimeExports.jsxs(React.Fragment, {
    children: [!y && typeof InputGlobalStyles == "function" && // For Emotion/Styled-components, InputGlobalStyles will be a function
    // For Pigment CSS, this has no effect because the InputGlobalStyles will be null.
    (_InputGlobalStyles || (_InputGlobalStyles = /* @__PURE__ */ jsxRuntimeExports.jsx(InputGlobalStyles, {}))), /* @__PURE__ */ jsxRuntimeExports.jsxs(ie, {
      ...ce,
      ref: o,
      onClick: ye,
      ...J,
      ...!isHostComponent(ie) && {
        ownerState: {
          ...H,
          ...ce.ownerState
        }
      },
      className: clsx(te.root, ce.className, d, k && "MuiInputBase-readOnly"),
      children: [G, /* @__PURE__ */ jsxRuntimeExports.jsx(FormControlContext.Provider, {
        value: null,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(me, {
          "aria-invalid": be.error,
          "aria-describedby": s,
          autoComplete: i,
          autoFocus: l,
          defaultValue: f,
          disabled: be.disabled,
          id: E,
          onAnimationStart: ne,
          name: v,
          placeholder: L,
          readOnly: k,
          required: be.required,
          rows: V,
          value: Z,
          onKeyDown: N,
          onKeyUp: F,
          type: Y,
          ...Ce,
          ...!isHostComponent(me) && {
            as: _e,
            ownerState: {
              ...H,
              ...Ce.ownerState
            }
          },
          ref: q,
          className: clsx(te.input, Ce.className, k && "MuiInputBase-readOnly"),
          onBlur: he,
          onChange: Pe,
          onFocus: xe
        })
      }), h, W ? W({
        ...be,
        startAdornment: G
      }) : null]
    })]
  });
});
process.env.NODE_ENV !== "production" && (InputBase.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  "aria-describedby": PropTypes.string,
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: PropTypes.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: PropTypes.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["primary", "secondary", "error", "info", "success", "warning"]), PropTypes.string]),
  /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: PropTypes.shape({
    Input: PropTypes.elementType,
    Root: PropTypes.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: PropTypes.shape({
    input: PropTypes.object,
    root: PropTypes.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, GlobalStyles for the auto-fill keyframes will not be injected/removed on mount/unmount. Make sure to inject them at the top of your application.
   * This option is intended to help with boosting the initial rendering performance if you are loading a big amount of Input components at once.
   * @default false
   */
  disableInjectingGlobalStyles: PropTypes.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: PropTypes.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: PropTypes.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: PropTypes.bool,
  /**
   * The id of the `input` element.
   */
  id: PropTypes.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: elementTypeAcceptingRef$1,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: PropTypes.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: PropTypes.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * If `true`, a [TextareaAutosize](https://mui.com/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: PropTypes.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: PropTypes.string,
  /**
   * Callback fired when the `input` is blurred.
   *
   * Notice that the first argument (event) might be undefined.
   */
  onBlur: PropTypes.func,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: PropTypes.func,
  /**
   * @ignore
   */
  onClick: PropTypes.func,
  /**
   * @ignore
   */
  onFocus: PropTypes.func,
  /**
   * Callback fired when the `input` doesn't satisfy its constraints.
   */
  onInvalid: PropTypes.func,
  /**
   * @ignore
   */
  onKeyDown: PropTypes.func,
  /**
   * @ignore
   */
  onKeyUp: PropTypes.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: PropTypes.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: PropTypes.bool,
  /**
   * @ignore
   */
  renderSuffix: PropTypes.func,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: PropTypes.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * The size of the component.
   */
  size: PropTypes.oneOfType([PropTypes.oneOf(["medium", "small"]), PropTypes.string]),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: PropTypes.shape({
    input: PropTypes.object,
    root: PropTypes.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: PropTypes.shape({
    input: PropTypes.elementType,
    root: PropTypes.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: PropTypes.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#input_types).
   * @default 'text'
   */
  type: PropTypes.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: PropTypes.any
});
function getInputUtilityClass(e) {
  return generateUtilityClass("MuiInput", e);
}
const inputClasses = {
  ...inputBaseClasses,
  ...generateUtilityClasses("MuiInput", ["root", "underline", "input"])
}, useUtilityClasses$I = (e) => {
  const {
    classes: t,
    disableUnderline: o
  } = e, s = composeClasses({
    root: ["root", !o && "underline"],
    input: ["input"]
  }, getInputUtilityClass, t);
  return {
    ...t,
    // forward classes to the InputBase
    ...s
  };
}, InputRoot = styled(InputBaseRoot, {
  shouldForwardProp: (e) => rootShouldForwardProp(e) || e === "classes",
  name: "MuiInput",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [...rootOverridesResolver(e, t), !o.disableUnderline && t.underline];
  }
})(memoTheme(({
  theme: e
}) => {
  let o = e.palette.mode === "light" ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
  return e.vars && (o = e.alpha(e.vars.palette.common.onBackground, e.vars.opacity.inputUnderline)), {
    position: "relative",
    variants: [{
      props: ({
        ownerState: n
      }) => n.formControl,
      style: {
        "label + &": {
          marginTop: 16
        }
      }
    }, {
      props: ({
        ownerState: n
      }) => !n.disableUnderline,
      style: {
        "&::after": {
          left: 0,
          bottom: 0,
          content: '""',
          position: "absolute",
          right: 0,
          transform: "scaleX(0)",
          transition: e.transitions.create("transform", {
            duration: e.transitions.duration.shorter,
            easing: e.transitions.easing.easeOut
          }),
          pointerEvents: "none"
          // Transparent to the hover style.
        },
        [`&.${inputClasses.focused}:after`]: {
          // translateX(0) is a workaround for Safari transform scale bug
          // See https://github.com/mui/material-ui/issues/31766
          transform: "scaleX(1) translateX(0)"
        },
        [`&.${inputClasses.error}`]: {
          "&::before, &::after": {
            borderBottomColor: (e.vars || e).palette.error.main
          }
        },
        "&::before": {
          borderBottom: `1px solid ${o}`,
          left: 0,
          bottom: 0,
          content: '"\\00a0"',
          position: "absolute",
          right: 0,
          transition: e.transitions.create("border-bottom-color", {
            duration: e.transitions.duration.shorter
          }),
          pointerEvents: "none"
          // Transparent to the hover style.
        },
        [`&:hover:not(.${inputClasses.disabled}, .${inputClasses.error}):before`]: {
          borderBottom: `2px solid ${(e.vars || e).palette.text.primary}`,
          // Reset on touch devices, it doesn't add specificity
          "@media (hover: none)": {
            borderBottom: `1px solid ${o}`
          }
        },
        [`&.${inputClasses.disabled}:before`]: {
          borderBottomStyle: "dotted"
        }
      }
    }, ...Object.entries(e.palette).filter(createSimplePaletteValueFilter()).map(([n]) => ({
      props: {
        color: n,
        disableUnderline: !1
      },
      style: {
        "&::after": {
          borderBottom: `2px solid ${(e.vars || e).palette[n].main}`
        }
      }
    }))]
  };
})), InputInput = styled(InputBaseInput, {
  name: "MuiInput",
  slot: "Input",
  overridesResolver: inputOverridesResolver
})({}), Input = /* @__PURE__ */ React.forwardRef(function e(t, o) {
  const n = useDefaultProps({
    props: t,
    name: "MuiInput"
  }), {
    disableUnderline: s = !1,
    components: i = {},
    componentsProps: l,
    fullWidth: d = !1,
    inputComponent: u = "input",
    multiline: c = !1,
    slotProps: p,
    slots: f = {},
    type: g = "text",
    ...y
  } = n, h = useUtilityClasses$I(n), P = {
    root: {
      ownerState: {
        disableUnderline: s
      }
    }
  }, E = p ?? l ? deepmerge(p ?? l, P) : P, $ = f.root ?? i.Root ?? InputRoot, R = f.input ?? i.Input ?? InputInput;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(InputBase, {
    slots: {
      root: $,
      input: R
    },
    slotProps: E,
    fullWidth: d,
    inputComponent: u,
    multiline: c,
    ref: o,
    type: g,
    ...y,
    classes: h
  });
});
process.env.NODE_ENV !== "production" && (Input.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: PropTypes.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: PropTypes.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["primary", "secondary"]), PropTypes.string]),
  /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: PropTypes.shape({
    Input: PropTypes.elementType,
    Root: PropTypes.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: PropTypes.shape({
    input: PropTypes.object,
    root: PropTypes.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the `input` will not have an underline.
   * @default false
   */
  disableUnderline: PropTypes.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: PropTypes.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: PropTypes.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: PropTypes.bool,
  /**
   * The id of the `input` element.
   */
  id: PropTypes.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: PropTypes.elementType,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: PropTypes.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: PropTypes.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * If `true`, a [TextareaAutosize](https://mui.com/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: PropTypes.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: PropTypes.string,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: PropTypes.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: PropTypes.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: PropTypes.bool,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: PropTypes.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: PropTypes.shape({
    input: PropTypes.object,
    root: PropTypes.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: PropTypes.shape({
    input: PropTypes.elementType,
    root: PropTypes.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: PropTypes.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#input_types).
   * @default 'text'
   */
  type: PropTypes.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: PropTypes.any
});
Input.muiName = "Input";
function getFilledInputUtilityClass(e) {
  return generateUtilityClass("MuiFilledInput", e);
}
const filledInputClasses = {
  ...inputBaseClasses,
  ...generateUtilityClasses("MuiFilledInput", ["root", "underline", "input", "adornedStart", "adornedEnd", "sizeSmall", "multiline", "hiddenLabel"])
}, useUtilityClasses$H = (e) => {
  const {
    classes: t,
    disableUnderline: o,
    startAdornment: n,
    endAdornment: s,
    size: i,
    hiddenLabel: l,
    multiline: d
  } = e, u = {
    root: ["root", !o && "underline", n && "adornedStart", s && "adornedEnd", i === "small" && `size${capitalize(i)}`, l && "hiddenLabel", d && "multiline"],
    input: ["input"]
  }, c = composeClasses(u, getFilledInputUtilityClass, t);
  return {
    ...t,
    // forward classes to the InputBase
    ...c
  };
}, FilledInputRoot = styled(InputBaseRoot, {
  shouldForwardProp: (e) => rootShouldForwardProp(e) || e === "classes",
  name: "MuiFilledInput",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [...rootOverridesResolver(e, t), !o.disableUnderline && t.underline];
  }
})(memoTheme(({
  theme: e
}) => {
  const t = e.palette.mode === "light", o = t ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)", n = t ? "rgba(0, 0, 0, 0.06)" : "rgba(255, 255, 255, 0.09)", s = t ? "rgba(0, 0, 0, 0.09)" : "rgba(255, 255, 255, 0.13)", i = t ? "rgba(0, 0, 0, 0.12)" : "rgba(255, 255, 255, 0.12)";
  return {
    position: "relative",
    backgroundColor: e.vars ? e.vars.palette.FilledInput.bg : n,
    borderTopLeftRadius: (e.vars || e).shape.borderRadius,
    borderTopRightRadius: (e.vars || e).shape.borderRadius,
    transition: e.transitions.create("background-color", {
      duration: e.transitions.duration.shorter,
      easing: e.transitions.easing.easeOut
    }),
    "&:hover": {
      backgroundColor: e.vars ? e.vars.palette.FilledInput.hoverBg : s,
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: e.vars ? e.vars.palette.FilledInput.bg : n
      }
    },
    [`&.${filledInputClasses.focused}`]: {
      backgroundColor: e.vars ? e.vars.palette.FilledInput.bg : n
    },
    [`&.${filledInputClasses.disabled}`]: {
      backgroundColor: e.vars ? e.vars.palette.FilledInput.disabledBg : i
    },
    variants: [{
      props: ({
        ownerState: l
      }) => !l.disableUnderline,
      style: {
        "&::after": {
          left: 0,
          bottom: 0,
          content: '""',
          position: "absolute",
          right: 0,
          transform: "scaleX(0)",
          transition: e.transitions.create("transform", {
            duration: e.transitions.duration.shorter,
            easing: e.transitions.easing.easeOut
          }),
          pointerEvents: "none"
          // Transparent to the hover style.
        },
        [`&.${filledInputClasses.focused}:after`]: {
          // translateX(0) is a workaround for Safari transform scale bug
          // See https://github.com/mui/material-ui/issues/31766
          transform: "scaleX(1) translateX(0)"
        },
        [`&.${filledInputClasses.error}`]: {
          "&::before, &::after": {
            borderBottomColor: (e.vars || e).palette.error.main
          }
        },
        "&::before": {
          borderBottom: `1px solid ${e.vars ? e.alpha(e.vars.palette.common.onBackground, e.vars.opacity.inputUnderline) : o}`,
          left: 0,
          bottom: 0,
          content: '"\\00a0"',
          position: "absolute",
          right: 0,
          transition: e.transitions.create("border-bottom-color", {
            duration: e.transitions.duration.shorter
          }),
          pointerEvents: "none"
          // Transparent to the hover style.
        },
        [`&:hover:not(.${filledInputClasses.disabled}, .${filledInputClasses.error}):before`]: {
          borderBottom: `1px solid ${(e.vars || e).palette.text.primary}`
        },
        [`&.${filledInputClasses.disabled}:before`]: {
          borderBottomStyle: "dotted"
        }
      }
    }, ...Object.entries(e.palette).filter(createSimplePaletteValueFilter()).map(([l]) => ({
      props: {
        disableUnderline: !1,
        color: l
      },
      style: {
        "&::after": {
          borderBottom: `2px solid ${(e.vars || e).palette[l]?.main}`
        }
      }
    })), {
      props: ({
        ownerState: l
      }) => l.startAdornment,
      style: {
        paddingLeft: 12
      }
    }, {
      props: ({
        ownerState: l
      }) => l.endAdornment,
      style: {
        paddingRight: 12
      }
    }, {
      props: ({
        ownerState: l
      }) => l.multiline,
      style: {
        padding: "25px 12px 8px"
      }
    }, {
      props: ({
        ownerState: l,
        size: d
      }) => l.multiline && d === "small",
      style: {
        paddingTop: 21,
        paddingBottom: 4
      }
    }, {
      props: ({
        ownerState: l
      }) => l.multiline && l.hiddenLabel,
      style: {
        paddingTop: 16,
        paddingBottom: 17
      }
    }, {
      props: ({
        ownerState: l
      }) => l.multiline && l.hiddenLabel && l.size === "small",
      style: {
        paddingTop: 8,
        paddingBottom: 9
      }
    }]
  };
})), FilledInputInput = styled(InputBaseInput, {
  name: "MuiFilledInput",
  slot: "Input",
  overridesResolver: inputOverridesResolver
})(memoTheme(({
  theme: e
}) => ({
  paddingTop: 25,
  paddingRight: 12,
  paddingBottom: 8,
  paddingLeft: 12,
  ...!e.vars && {
    "&:-webkit-autofill": {
      WebkitBoxShadow: e.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
      WebkitTextFillColor: e.palette.mode === "light" ? null : "#fff",
      caretColor: e.palette.mode === "light" ? null : "#fff",
      borderTopLeftRadius: "inherit",
      borderTopRightRadius: "inherit"
    }
  },
  ...e.vars && {
    "&:-webkit-autofill": {
      borderTopLeftRadius: "inherit",
      borderTopRightRadius: "inherit"
    },
    [e.getColorSchemeSelector("dark")]: {
      "&:-webkit-autofill": {
        WebkitBoxShadow: "0 0 0 100px #266798 inset",
        WebkitTextFillColor: "#fff",
        caretColor: "#fff"
      }
    }
  },
  variants: [{
    props: {
      size: "small"
    },
    style: {
      paddingTop: 21,
      paddingBottom: 4
    }
  }, {
    props: ({
      ownerState: t
    }) => t.hiddenLabel,
    style: {
      paddingTop: 16,
      paddingBottom: 17
    }
  }, {
    props: ({
      ownerState: t
    }) => t.startAdornment,
    style: {
      paddingLeft: 0
    }
  }, {
    props: ({
      ownerState: t
    }) => t.endAdornment,
    style: {
      paddingRight: 0
    }
  }, {
    props: ({
      ownerState: t
    }) => t.hiddenLabel && t.size === "small",
    style: {
      paddingTop: 8,
      paddingBottom: 9
    }
  }, {
    props: ({
      ownerState: t
    }) => t.multiline,
    style: {
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: 0,
      paddingRight: 0
    }
  }]
}))), FilledInput = /* @__PURE__ */ React.forwardRef(function e(t, o) {
  const n = useDefaultProps({
    props: t,
    name: "MuiFilledInput"
  }), {
    disableUnderline: s = !1,
    components: i = {},
    componentsProps: l,
    fullWidth: d = !1,
    hiddenLabel: u,
    // declare here to prevent spreading to DOM
    inputComponent: c = "input",
    multiline: p = !1,
    slotProps: f,
    slots: g = {},
    type: y = "text",
    ...h
  } = n, T = {
    ...n,
    disableUnderline: s,
    fullWidth: d,
    inputComponent: c,
    multiline: p,
    type: y
  }, P = useUtilityClasses$H(n), E = {
    root: {
      ownerState: T
    },
    input: {
      ownerState: T
    }
  }, $ = f ?? l ? deepmerge(E, f ?? l) : E, R = g.root ?? i.Root ?? FilledInputRoot, C = g.input ?? i.Input ?? FilledInputInput;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(InputBase, {
    slots: {
      root: R,
      input: C
    },
    slotProps: $,
    fullWidth: d,
    inputComponent: c,
    multiline: p,
    ref: o,
    type: y,
    ...h,
    classes: P
  });
});
process.env.NODE_ENV !== "production" && (FilledInput.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: PropTypes.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: PropTypes.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["primary", "secondary"]), PropTypes.string]),
  /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: PropTypes.shape({
    Input: PropTypes.elementType,
    Root: PropTypes.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: PropTypes.shape({
    input: PropTypes.object,
    root: PropTypes.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the input will not have an underline.
   * @default false
   */
  disableUnderline: PropTypes.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: PropTypes.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: PropTypes.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: PropTypes.bool,
  /**
   * If `true`, the label is hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   * @default false
   */
  hiddenLabel: PropTypes.bool,
  /**
   * The id of the `input` element.
   */
  id: PropTypes.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: PropTypes.elementType,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: PropTypes.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: PropTypes.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * If `true`, a [TextareaAutosize](https://mui.com/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: PropTypes.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: PropTypes.string,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: PropTypes.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: PropTypes.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: PropTypes.bool,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: PropTypes.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: PropTypes.shape({
    input: PropTypes.object,
    root: PropTypes.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: PropTypes.shape({
    input: PropTypes.elementType,
    root: PropTypes.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: PropTypes.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#input_types).
   * @default 'text'
   */
  type: PropTypes.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: PropTypes.any
});
FilledInput.muiName = "Input";
var _span$3;
const NotchedOutlineRoot$1 = styled("fieldset", {
  name: "MuiNotchedOutlined",
  shouldForwardProp: rootShouldForwardProp
})({
  textAlign: "left",
  position: "absolute",
  bottom: 0,
  right: 0,
  top: -5,
  left: 0,
  margin: 0,
  padding: "0 8px",
  pointerEvents: "none",
  borderRadius: "inherit",
  borderStyle: "solid",
  borderWidth: 1,
  overflow: "hidden",
  minWidth: "0%"
}), NotchedOutlineLegend = styled("legend", {
  name: "MuiNotchedOutlined",
  shouldForwardProp: rootShouldForwardProp
})(memoTheme(({
  theme: e
}) => ({
  float: "unset",
  // Fix conflict with bootstrap
  width: "auto",
  // Fix conflict with bootstrap
  overflow: "hidden",
  // Fix Horizontal scroll when label too long
  variants: [{
    props: ({
      ownerState: t
    }) => !t.withLabel,
    style: {
      padding: 0,
      lineHeight: "11px",
      // sync with `height` in `legend` styles
      transition: e.transitions.create("width", {
        duration: 150,
        easing: e.transitions.easing.easeOut
      })
    }
  }, {
    props: ({
      ownerState: t
    }) => t.withLabel,
    style: {
      display: "block",
      // Fix conflict with normalize.css and sanitize.css
      padding: 0,
      height: 11,
      // sync with `lineHeight` in `legend` styles
      fontSize: "0.75em",
      visibility: "hidden",
      maxWidth: 0.01,
      transition: e.transitions.create("max-width", {
        duration: 50,
        easing: e.transitions.easing.easeOut
      }),
      whiteSpace: "nowrap",
      "& > span": {
        paddingLeft: 5,
        paddingRight: 5,
        display: "inline-block",
        opacity: 0,
        visibility: "visible"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.withLabel && t.notched,
    style: {
      maxWidth: "100%",
      transition: e.transitions.create("max-width", {
        duration: 100,
        easing: e.transitions.easing.easeOut,
        delay: 50
      })
    }
  }]
})));
function NotchedOutline(e) {
  const {
    children: t,
    classes: o,
    className: n,
    label: s,
    notched: i,
    ...l
  } = e, d = s != null && s !== "", u = {
    ...e,
    notched: i,
    withLabel: d
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(NotchedOutlineRoot$1, {
    "aria-hidden": !0,
    className: n,
    ownerState: u,
    ...l,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(NotchedOutlineLegend, {
      ownerState: u,
      children: d ? /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
        children: s
      }) : (
        // notranslate needed while Google Translate will not fix zero-width space issue
        _span$3 || (_span$3 = /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
          className: "notranslate",
          "aria-hidden": !0,
          children: "​"
        }))
      )
    })
  });
}
process.env.NODE_ENV !== "production" && (NotchedOutline.propTypes = {
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The label.
   */
  label: PropTypes.node,
  /**
   * If `true`, the outline is notched to accommodate the label.
   */
  notched: PropTypes.bool.isRequired,
  /**
   * @ignore
   */
  style: PropTypes.object
});
function getOutlinedInputUtilityClass(e) {
  return generateUtilityClass("MuiOutlinedInput", e);
}
const outlinedInputClasses = {
  ...inputBaseClasses,
  ...generateUtilityClasses("MuiOutlinedInput", ["root", "notchedOutline", "input"])
}, useUtilityClasses$G = (e) => {
  const {
    classes: t
  } = e, n = composeClasses({
    root: ["root"],
    notchedOutline: ["notchedOutline"],
    input: ["input"]
  }, getOutlinedInputUtilityClass, t);
  return {
    ...t,
    // forward classes to the InputBase
    ...n
  };
}, OutlinedInputRoot = styled(InputBaseRoot, {
  shouldForwardProp: (e) => rootShouldForwardProp(e) || e === "classes",
  name: "MuiOutlinedInput",
  slot: "Root",
  overridesResolver: rootOverridesResolver
})(memoTheme(({
  theme: e
}) => {
  const t = e.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
  return {
    position: "relative",
    borderRadius: (e.vars || e).shape.borderRadius,
    [`&:hover .${outlinedInputClasses.notchedOutline}`]: {
      borderColor: (e.vars || e).palette.text.primary
    },
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      [`&:hover .${outlinedInputClasses.notchedOutline}`]: {
        borderColor: e.vars ? e.alpha(e.vars.palette.common.onBackground, 0.23) : t
      }
    },
    [`&.${outlinedInputClasses.focused} .${outlinedInputClasses.notchedOutline}`]: {
      borderWidth: 2
    },
    variants: [...Object.entries(e.palette).filter(createSimplePaletteValueFilter()).map(([o]) => ({
      props: {
        color: o
      },
      style: {
        [`&.${outlinedInputClasses.focused} .${outlinedInputClasses.notchedOutline}`]: {
          borderColor: (e.vars || e).palette[o].main
        }
      }
    })), {
      props: {},
      // to override the above style
      style: {
        [`&.${outlinedInputClasses.error} .${outlinedInputClasses.notchedOutline}`]: {
          borderColor: (e.vars || e).palette.error.main
        },
        [`&.${outlinedInputClasses.disabled} .${outlinedInputClasses.notchedOutline}`]: {
          borderColor: (e.vars || e).palette.action.disabled
        }
      }
    }, {
      props: ({
        ownerState: o
      }) => o.startAdornment,
      style: {
        paddingLeft: 14
      }
    }, {
      props: ({
        ownerState: o
      }) => o.endAdornment,
      style: {
        paddingRight: 14
      }
    }, {
      props: ({
        ownerState: o
      }) => o.multiline,
      style: {
        padding: "16.5px 14px"
      }
    }, {
      props: ({
        ownerState: o,
        size: n
      }) => o.multiline && n === "small",
      style: {
        padding: "8.5px 14px"
      }
    }]
  };
})), NotchedOutlineRoot = styled(NotchedOutline, {
  name: "MuiOutlinedInput",
  slot: "NotchedOutline"
})(memoTheme(({
  theme: e
}) => {
  const t = e.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
  return {
    borderColor: e.vars ? e.alpha(e.vars.palette.common.onBackground, 0.23) : t
  };
})), OutlinedInputInput = styled(InputBaseInput, {
  name: "MuiOutlinedInput",
  slot: "Input",
  overridesResolver: inputOverridesResolver
})(memoTheme(({
  theme: e
}) => ({
  padding: "16.5px 14px",
  ...!e.vars && {
    "&:-webkit-autofill": {
      WebkitBoxShadow: e.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
      WebkitTextFillColor: e.palette.mode === "light" ? null : "#fff",
      caretColor: e.palette.mode === "light" ? null : "#fff",
      borderRadius: "inherit"
    }
  },
  ...e.vars && {
    "&:-webkit-autofill": {
      borderRadius: "inherit"
    },
    [e.getColorSchemeSelector("dark")]: {
      "&:-webkit-autofill": {
        WebkitBoxShadow: "0 0 0 100px #266798 inset",
        WebkitTextFillColor: "#fff",
        caretColor: "#fff"
      }
    }
  },
  variants: [{
    props: {
      size: "small"
    },
    style: {
      padding: "8.5px 14px"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.multiline,
    style: {
      padding: 0
    }
  }, {
    props: ({
      ownerState: t
    }) => t.startAdornment,
    style: {
      paddingLeft: 0
    }
  }, {
    props: ({
      ownerState: t
    }) => t.endAdornment,
    style: {
      paddingRight: 0
    }
  }]
}))), OutlinedInput = /* @__PURE__ */ React.forwardRef(function e(t, o) {
  const n = useDefaultProps({
    props: t,
    name: "MuiOutlinedInput"
  }), {
    components: s = {},
    fullWidth: i = !1,
    inputComponent: l = "input",
    label: d,
    multiline: u = !1,
    notched: c,
    slots: p = {},
    slotProps: f = {},
    type: g = "text",
    ...y
  } = n, h = useUtilityClasses$G(n), T = useFormControl(), P = formControlState({
    props: n,
    muiFormControl: T,
    states: ["color", "disabled", "error", "focused", "hiddenLabel", "size", "required"]
  }), E = {
    ...n,
    color: P.color || "primary",
    disabled: P.disabled,
    error: P.error,
    focused: P.focused,
    formControl: T,
    fullWidth: i,
    hiddenLabel: P.hiddenLabel,
    multiline: u,
    size: P.size,
    type: g
  }, $ = p.root ?? s.Root ?? OutlinedInputRoot, R = p.input ?? s.Input ?? OutlinedInputInput, [C, x] = useSlot("notchedOutline", {
    elementType: NotchedOutlineRoot,
    className: h.notchedOutline,
    shouldForwardComponentProp: !0,
    ownerState: E,
    externalForwardedProps: {
      slots: p,
      slotProps: f
    },
    additionalProps: {
      label: d != null && d !== "" && P.required ? /* @__PURE__ */ jsxRuntimeExports.jsxs(React.Fragment, {
        children: [d, " ", "*"]
      }) : d
    }
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(InputBase, {
    slots: {
      root: $,
      input: R
    },
    slotProps: f,
    renderSuffix: (_) => /* @__PURE__ */ jsxRuntimeExports.jsx(C, {
      ...x,
      notched: typeof c < "u" ? c : !!(_.startAdornment || _.filled || _.focused)
    }),
    fullWidth: i,
    inputComponent: l,
    multiline: u,
    ref: o,
    type: g,
    ...y,
    classes: {
      ...h,
      notchedOutline: null
    }
  });
});
process.env.NODE_ENV !== "production" && (OutlinedInput.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: PropTypes.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: PropTypes.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["primary", "secondary"]), PropTypes.string]),
  /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: PropTypes.shape({
    Input: PropTypes.elementType,
    Root: PropTypes.elementType
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: PropTypes.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: PropTypes.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: PropTypes.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: PropTypes.bool,
  /**
   * The id of the `input` element.
   */
  id: PropTypes.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: PropTypes.elementType,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: PropTypes.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType,
  /**
   * The label of the `input`. It is only used for layout. The actual labelling
   * is handled by `InputLabel`.
   */
  label: PropTypes.node,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: PropTypes.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * If `true`, a [TextareaAutosize](https://mui.com/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: PropTypes.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: PropTypes.string,
  /**
   * If `true`, the outline is notched to accommodate the label.
   */
  notched: PropTypes.bool,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: PropTypes.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: PropTypes.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: PropTypes.bool,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: PropTypes.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: PropTypes.shape({
    input: PropTypes.object,
    notchedOutline: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    root: PropTypes.object
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: PropTypes.shape({
    input: PropTypes.elementType,
    notchedOutline: PropTypes.elementType,
    root: PropTypes.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: PropTypes.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#input_types).
   * @default 'text'
   */
  type: PropTypes.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: PropTypes.any
});
OutlinedInput.muiName = "Input";
function getFormLabelUtilityClasses(e) {
  return generateUtilityClass("MuiFormLabel", e);
}
const formLabelClasses = generateUtilityClasses("MuiFormLabel", ["root", "colorSecondary", "focused", "disabled", "error", "filled", "required", "asterisk"]), useUtilityClasses$F = (e) => {
  const {
    classes: t,
    color: o,
    focused: n,
    disabled: s,
    error: i,
    filled: l,
    required: d
  } = e, u = {
    root: ["root", `color${capitalize(o)}`, s && "disabled", i && "error", l && "filled", n && "focused", d && "required"],
    asterisk: ["asterisk", i && "error"]
  };
  return composeClasses(u, getFormLabelUtilityClasses, t);
}, FormLabelRoot = styled("label", {
  name: "MuiFormLabel",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.root, o.color === "secondary" && t.colorSecondary, o.filled && t.filled];
  }
})(memoTheme(({
  theme: e
}) => ({
  color: (e.vars || e).palette.text.secondary,
  ...e.typography.body1,
  lineHeight: "1.4375em",
  padding: 0,
  position: "relative",
  variants: [...Object.entries(e.palette).filter(createSimplePaletteValueFilter()).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      [`&.${formLabelClasses.focused}`]: {
        color: (e.vars || e).palette[t].main
      }
    }
  })), {
    props: {},
    style: {
      [`&.${formLabelClasses.disabled}`]: {
        color: (e.vars || e).palette.text.disabled
      },
      [`&.${formLabelClasses.error}`]: {
        color: (e.vars || e).palette.error.main
      }
    }
  }]
}))), AsteriskComponent = styled("span", {
  name: "MuiFormLabel",
  slot: "Asterisk"
})(memoTheme(({
  theme: e
}) => ({
  [`&.${formLabelClasses.error}`]: {
    color: (e.vars || e).palette.error.main
  }
}))), FormLabel = /* @__PURE__ */ React.forwardRef(function e(t, o) {
  const n = useDefaultProps({
    props: t,
    name: "MuiFormLabel"
  }), {
    children: s,
    className: i,
    color: l,
    component: d = "label",
    disabled: u,
    error: c,
    filled: p,
    focused: f,
    required: g,
    ...y
  } = n, h = useFormControl(), T = formControlState({
    props: n,
    muiFormControl: h,
    states: ["color", "required", "focused", "disabled", "error", "filled"]
  }), P = {
    ...n,
    color: T.color || "primary",
    component: d,
    disabled: T.disabled,
    error: T.error,
    filled: T.filled,
    focused: T.focused,
    required: T.required
  }, E = useUtilityClasses$F(P);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(FormLabelRoot, {
    as: d,
    ownerState: P,
    className: clsx(E.root, i),
    ref: o,
    ...y,
    children: [s, T.required && /* @__PURE__ */ jsxRuntimeExports.jsxs(AsteriskComponent, {
      ownerState: P,
      "aria-hidden": !0,
      className: E.asterisk,
      children: [" ", "*"]
    })]
  });
});
process.env.NODE_ENV !== "production" && (FormLabel.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["error", "info", "primary", "secondary", "success", "warning"]), PropTypes.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * If `true`, the label should be displayed in a disabled state.
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the label is displayed in an error state.
   */
  error: PropTypes.bool,
  /**
   * If `true`, the label should use filled classes key.
   */
  filled: PropTypes.bool,
  /**
   * If `true`, the input of this label is focused (used by `FormGroup` components).
   */
  focused: PropTypes.bool,
  /**
   * If `true`, the label will indicate that the `input` is required.
   */
  required: PropTypes.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
});
function getInputLabelUtilityClasses(e) {
  return generateUtilityClass("MuiInputLabel", e);
}
generateUtilityClasses("MuiInputLabel", ["root", "focused", "disabled", "error", "required", "asterisk", "formControl", "sizeSmall", "shrink", "animated", "standard", "filled", "outlined"]);
const useUtilityClasses$E = (e) => {
  const {
    classes: t,
    formControl: o,
    size: n,
    shrink: s,
    disableAnimation: i,
    variant: l,
    required: d
  } = e, u = {
    root: ["root", o && "formControl", !i && "animated", s && "shrink", n && n !== "medium" && `size${capitalize(n)}`, l],
    asterisk: [d && "asterisk"]
  }, c = composeClasses(u, getInputLabelUtilityClasses, t);
  return {
    ...t,
    // forward the focused, disabled, etc. classes to the FormLabel
    ...c
  };
}, InputLabelRoot = styled(FormLabel, {
  shouldForwardProp: (e) => rootShouldForwardProp(e) || e === "classes",
  name: "MuiInputLabel",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [{
      [`& .${formLabelClasses.asterisk}`]: t.asterisk
    }, t.root, o.formControl && t.formControl, o.size === "small" && t.sizeSmall, o.shrink && t.shrink, !o.disableAnimation && t.animated, o.focused && t.focused, t[o.variant]];
  }
})(memoTheme(({
  theme: e
}) => ({
  display: "block",
  transformOrigin: "top left",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  maxWidth: "100%",
  variants: [{
    props: ({
      ownerState: t
    }) => t.formControl,
    style: {
      position: "absolute",
      left: 0,
      top: 0,
      // slight alteration to spec spacing to match visual spec result
      transform: "translate(0, 20px) scale(1)"
    }
  }, {
    props: {
      size: "small"
    },
    style: {
      // Compensation for the `Input.inputSizeSmall` style.
      transform: "translate(0, 17px) scale(1)"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.shrink,
    style: {
      transform: "translate(0, -1.5px) scale(0.75)",
      transformOrigin: "top left",
      maxWidth: "133%"
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.disableAnimation,
    style: {
      transition: e.transitions.create(["color", "transform", "max-width"], {
        duration: e.transitions.duration.shorter,
        easing: e.transitions.easing.easeOut
      })
    }
  }, {
    props: {
      variant: "filled"
    },
    style: {
      // Chrome's autofill feature gives the input field a yellow background.
      // Since the input field is behind the label in the HTML tree,
      // the input field is drawn last and hides the label with an opaque background color.
      // zIndex: 1 will raise the label above opaque background-colors of input.
      zIndex: 1,
      pointerEvents: "none",
      transform: "translate(12px, 16px) scale(1)",
      maxWidth: "calc(100% - 24px)"
    }
  }, {
    props: {
      variant: "filled",
      size: "small"
    },
    style: {
      transform: "translate(12px, 13px) scale(1)"
    }
  }, {
    props: ({
      variant: t,
      ownerState: o
    }) => t === "filled" && o.shrink,
    style: {
      userSelect: "none",
      pointerEvents: "auto",
      transform: "translate(12px, 7px) scale(0.75)",
      maxWidth: "calc(133% - 24px)"
    }
  }, {
    props: ({
      variant: t,
      ownerState: o,
      size: n
    }) => t === "filled" && o.shrink && n === "small",
    style: {
      transform: "translate(12px, 4px) scale(0.75)"
    }
  }, {
    props: {
      variant: "outlined"
    },
    style: {
      // see comment above on filled.zIndex
      zIndex: 1,
      pointerEvents: "none",
      transform: "translate(14px, 16px) scale(1)",
      maxWidth: "calc(100% - 24px)"
    }
  }, {
    props: {
      variant: "outlined",
      size: "small"
    },
    style: {
      transform: "translate(14px, 9px) scale(1)"
    }
  }, {
    props: ({
      variant: t,
      ownerState: o
    }) => t === "outlined" && o.shrink,
    style: {
      userSelect: "none",
      pointerEvents: "auto",
      // Theoretically, we should have (8+5)*2/0.75 = 34px
      // but it feels a better when it bleeds a bit on the left, so 32px.
      maxWidth: "calc(133% - 32px)",
      transform: "translate(14px, -9px) scale(0.75)"
    }
  }]
}))), InputLabel = /* @__PURE__ */ React.forwardRef(function e(t, o) {
  const n = useDefaultProps({
    name: "MuiInputLabel",
    props: t
  }), {
    disableAnimation: s = !1,
    margin: i,
    shrink: l,
    variant: d,
    className: u,
    ...c
  } = n, p = useFormControl();
  let f = l;
  typeof f > "u" && p && (f = p.filled || p.focused || p.adornedStart);
  const g = formControlState({
    props: n,
    muiFormControl: p,
    states: ["size", "variant", "required", "focused"]
  }), y = {
    ...n,
    disableAnimation: s,
    formControl: p,
    shrink: f,
    size: g.size,
    variant: g.variant,
    required: g.required,
    focused: g.focused
  }, h = useUtilityClasses$E(y);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(InputLabelRoot, {
    "data-shrink": f,
    ref: o,
    className: clsx(h.root, u),
    ...c,
    ownerState: y,
    classes: h
  });
});
process.env.NODE_ENV !== "production" && (InputLabel.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["error", "info", "primary", "secondary", "success", "warning"]), PropTypes.string]),
  /**
   * If `true`, the transition animation is disabled.
   * @default false
   */
  disableAnimation: PropTypes.bool,
  /**
   * If `true`, the component is disabled.
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the label is displayed in an error state.
   */
  error: PropTypes.bool,
  /**
   * If `true`, the `input` of this label is focused.
   */
  focused: PropTypes.bool,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: PropTypes.oneOf(["dense"]),
  /**
   * if `true`, the label will indicate that the `input` is required.
   */
  required: PropTypes.bool,
  /**
   * If `true`, the label is shrunk.
   */
  shrink: PropTypes.bool,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: PropTypes.oneOfType([PropTypes.oneOf(["medium", "small"]), PropTypes.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(["filled", "outlined", "standard"])
});
function getFormControlUtilityClasses(e) {
  return generateUtilityClass("MuiFormControl", e);
}
generateUtilityClasses("MuiFormControl", ["root", "marginNone", "marginNormal", "marginDense", "fullWidth", "disabled"]);
const useUtilityClasses$D = (e) => {
  const {
    classes: t,
    margin: o,
    fullWidth: n
  } = e, s = {
    root: ["root", o !== "none" && `margin${capitalize(o)}`, n && "fullWidth"]
  };
  return composeClasses(s, getFormControlUtilityClasses, t);
}, FormControlRoot = styled("div", {
  name: "MuiFormControl",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.root, t[`margin${capitalize(o.margin)}`], o.fullWidth && t.fullWidth];
  }
})({
  display: "inline-flex",
  flexDirection: "column",
  position: "relative",
  // Reset fieldset default style.
  minWidth: 0,
  padding: 0,
  margin: 0,
  border: 0,
  verticalAlign: "top",
  // Fix alignment issue on Safari.
  variants: [{
    props: {
      margin: "normal"
    },
    style: {
      marginTop: 16,
      marginBottom: 8
    }
  }, {
    props: {
      margin: "dense"
    },
    style: {
      marginTop: 8,
      marginBottom: 4
    }
  }, {
    props: {
      fullWidth: !0
    },
    style: {
      width: "100%"
    }
  }]
}), FormControl = /* @__PURE__ */ React.forwardRef(function e(t, o) {
  const n = useDefaultProps({
    props: t,
    name: "MuiFormControl"
  }), {
    children: s,
    className: i,
    color: l = "primary",
    component: d = "div",
    disabled: u = !1,
    error: c = !1,
    focused: p,
    fullWidth: f = !1,
    hiddenLabel: g = !1,
    margin: y = "none",
    required: h = !1,
    size: T = "medium",
    variant: P = "outlined",
    ...E
  } = n, $ = {
    ...n,
    color: l,
    component: d,
    disabled: u,
    error: c,
    fullWidth: f,
    hiddenLabel: g,
    margin: y,
    required: h,
    size: T,
    variant: P
  }, R = useUtilityClasses$D($), [C, x] = React.useState(() => {
    let L = !1;
    return s && React.Children.forEach(s, (k) => {
      if (!isMuiElement(k, ["Input", "Select"]))
        return;
      const W = isMuiElement(k, ["Select"]) ? k.props.input : k;
      W && isAdornedStart(W.props) && (L = !0);
    }), L;
  }), [_, D] = React.useState(() => {
    let L = !1;
    return s && React.Children.forEach(s, (k) => {
      isMuiElement(k, ["Input", "Select"]) && (isFilled(k.props, !0) || isFilled(k.props.inputProps, !0)) && (L = !0);
    }), L;
  }), [O, v] = React.useState(!1);
  u && O && v(!1);
  const w = p !== void 0 && !u ? p : O;
  let M;
  const S = React.useRef(!1);
  process.env.NODE_ENV !== "production" && (M = () => (S.current && console.error(["MUI: There are multiple `InputBase` components inside a FormControl.", "This creates visual inconsistencies, only use one `InputBase`."].join(`
`)), S.current = !0, () => {
    S.current = !1;
  }));
  const I = React.useCallback(() => {
    D(!0);
  }, []), N = React.useCallback(() => {
    D(!1);
  }, []), F = React.useMemo(() => ({
    adornedStart: C,
    setAdornedStart: x,
    color: l,
    disabled: u,
    error: c,
    filled: _,
    focused: w,
    fullWidth: f,
    hiddenLabel: g,
    size: T,
    onBlur: () => {
      v(!1);
    },
    onFocus: () => {
      v(!0);
    },
    onEmpty: N,
    onFilled: I,
    registerEffect: M,
    required: h,
    variant: P
  }), [C, l, u, c, _, w, f, g, M, N, I, h, T, P]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(FormControlContext.Provider, {
    value: F,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(FormControlRoot, {
      as: d,
      ownerState: $,
      className: clsx(R.root, i),
      ref: o,
      ...E,
      children: s
    })
  });
});
process.env.NODE_ENV !== "production" && (FormControl.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["primary", "secondary", "error", "info", "success", "warning"]), PropTypes.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * If `true`, the label, input and helper text should be displayed in a disabled state.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the label is displayed in an error state.
   * @default false
   */
  error: PropTypes.bool,
  /**
   * If `true`, the component is displayed in focused state.
   */
  focused: PropTypes.bool,
  /**
   * If `true`, the component will take up the full width of its container.
   * @default false
   */
  fullWidth: PropTypes.bool,
  /**
   * If `true`, the label is hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   * @default false
   */
  hiddenLabel: PropTypes.bool,
  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   * @default 'none'
   */
  margin: PropTypes.oneOf(["dense", "none", "normal"]),
  /**
   * If `true`, the label will indicate that the `input` is required.
   * @default false
   */
  required: PropTypes.bool,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: PropTypes.oneOfType([PropTypes.oneOf(["medium", "small"]), PropTypes.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: PropTypes.oneOf(["filled", "outlined", "standard"])
});
function getFormHelperTextUtilityClasses(e) {
  return generateUtilityClass("MuiFormHelperText", e);
}
const formHelperTextClasses = generateUtilityClasses("MuiFormHelperText", ["root", "error", "disabled", "sizeSmall", "sizeMedium", "contained", "focused", "filled", "required"]);
var _span$2;
const useUtilityClasses$C = (e) => {
  const {
    classes: t,
    contained: o,
    size: n,
    disabled: s,
    error: i,
    filled: l,
    focused: d,
    required: u
  } = e, c = {
    root: ["root", s && "disabled", i && "error", n && `size${capitalize(n)}`, o && "contained", d && "focused", l && "filled", u && "required"]
  };
  return composeClasses(c, getFormHelperTextUtilityClasses, t);
}, FormHelperTextRoot = styled("p", {
  name: "MuiFormHelperText",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.root, o.size && t[`size${capitalize(o.size)}`], o.contained && t.contained, o.filled && t.filled];
  }
})(memoTheme(({
  theme: e
}) => ({
  color: (e.vars || e).palette.text.secondary,
  ...e.typography.caption,
  textAlign: "left",
  marginTop: 3,
  marginRight: 0,
  marginBottom: 0,
  marginLeft: 0,
  [`&.${formHelperTextClasses.disabled}`]: {
    color: (e.vars || e).palette.text.disabled
  },
  [`&.${formHelperTextClasses.error}`]: {
    color: (e.vars || e).palette.error.main
  },
  variants: [{
    props: {
      size: "small"
    },
    style: {
      marginTop: 4
    }
  }, {
    props: ({
      ownerState: t
    }) => t.contained,
    style: {
      marginLeft: 14,
      marginRight: 14
    }
  }]
}))), FormHelperText = /* @__PURE__ */ React.forwardRef(function e(t, o) {
  const n = useDefaultProps({
    props: t,
    name: "MuiFormHelperText"
  }), {
    children: s,
    className: i,
    component: l = "p",
    disabled: d,
    error: u,
    filled: c,
    focused: p,
    margin: f,
    required: g,
    variant: y,
    ...h
  } = n, T = useFormControl(), P = formControlState({
    props: n,
    muiFormControl: T,
    states: ["variant", "size", "disabled", "error", "filled", "focused", "required"]
  }), E = {
    ...n,
    component: l,
    contained: P.variant === "filled" || P.variant === "outlined",
    variant: P.variant,
    size: P.size,
    disabled: P.disabled,
    error: P.error,
    filled: P.filled,
    focused: P.focused,
    required: P.required
  };
  delete E.ownerState;
  const $ = useUtilityClasses$C(E);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(FormHelperTextRoot, {
    as: l,
    className: clsx($.root, i),
    ref: o,
    ...h,
    ownerState: E,
    children: s === " " ? (
      // notranslate needed while Google Translate will not fix zero-width space issue
      _span$2 || (_span$2 = /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
        className: "notranslate",
        "aria-hidden": !0,
        children: "​"
      }))
    ) : s
  });
});
process.env.NODE_ENV !== "production" && (FormHelperText.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   *
   * If `' '` is provided, the component reserves one line height for displaying a future message.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * If `true`, the helper text should be displayed in a disabled state.
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, helper text should be displayed in an error state.
   */
  error: PropTypes.bool,
  /**
   * If `true`, the helper text should use filled classes key.
   */
  filled: PropTypes.bool,
  /**
   * If `true`, the helper text should use focused classes key.
   */
  focused: PropTypes.bool,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: PropTypes.oneOf(["dense"]),
  /**
   * If `true`, the helper text should use required classes key.
   */
  required: PropTypes.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The variant to use.
   */
  variant: PropTypes.oneOfType([PropTypes.oneOf(["filled", "outlined", "standard"]), PropTypes.string])
});
function getReactElementRef(e) {
  return parseInt(React.version, 10) >= 19 ? e?.props?.ref || null : e?.ref || null;
}
function HTMLElementType(e, t, o, n, s) {
  if (process.env.NODE_ENV === "production")
    return null;
  const i = e[t], l = s || t;
  return i == null ? null : i && i.nodeType !== 1 ? new Error(`Invalid ${n} \`${l}\` supplied to \`${o}\`. Expected an HTMLElement.`) : null;
}
function getTypeByValue(e) {
  const t = typeof e;
  switch (t) {
    case "number":
      return Number.isNaN(e) ? "NaN" : Number.isFinite(e) ? e !== Math.floor(e) ? "float" : "number" : "Infinity";
    case "object":
      return e === null ? "null" : e.constructor.name;
    default:
      return t;
  }
}
function requiredInteger(e, t, o, n) {
  const s = e[t];
  if (s == null || !Number.isInteger(s)) {
    const i = getTypeByValue(s);
    return new RangeError(`Invalid ${n} \`${t}\` of type \`${i}\` supplied to \`${o}\`, expected \`integer\`.`);
  }
  return null;
}
function validator(e, t, o, n) {
  return e[t] === void 0 ? null : requiredInteger(e, t, o, n);
}
function validatorNoop() {
  return null;
}
validator.isRequired = requiredInteger;
validatorNoop.isRequired = validatorNoop;
const integerPropType = process.env.NODE_ENV === "production" ? validatorNoop : validator;
function isClassComponent(e) {
  const {
    prototype: t = {}
  } = e;
  return !!t.isReactComponent;
}
function acceptingRef(e, t, o, n, s) {
  const i = e[t], l = s || t;
  if (i == null || // When server-side rendering React doesn't warn either.
  // This is not an accurate check for SSR.
  // This is only in place for Emotion compat.
  // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
  typeof window > "u")
    return null;
  let d;
  const u = i.type;
  return typeof u == "function" && !isClassComponent(u) && (d = "Did you accidentally use a plain function component for an element instead?"), d !== void 0 ? new Error(`Invalid ${n} \`${l}\` supplied to \`${o}\`. Expected an element that can hold a ref. ${d} For more information see https://mui.com/r/caveat-with-refs-guide`) : null;
}
const elementAcceptingRef = chainPropTypes(PropTypes.element, acceptingRef);
elementAcceptingRef.isRequired = chainPropTypes(PropTypes.element.isRequired, acceptingRef);
const reflow = (e) => e.scrollTop;
function getTransitionProps(e, t) {
  const {
    timeout: o,
    easing: n,
    style: s = {}
  } = e;
  return {
    duration: s.transitionDuration ?? (typeof o == "number" ? o : o[t.mode] || 0),
    easing: s.transitionTimingFunction ?? (typeof n == "object" ? n[t.mode] : n),
    delay: s.transitionDelay
  };
}
function getScale(e) {
  return `scale(${e}, ${e ** 2})`;
}
const styles$1 = {
  entering: {
    opacity: 1,
    transform: getScale(1)
  },
  entered: {
    opacity: 1,
    transform: "none"
  }
}, isWebKit154 = typeof navigator < "u" && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent), Grow = /* @__PURE__ */ React.forwardRef(function e(t, o) {
  const {
    addEndListener: n,
    appear: s = !0,
    children: i,
    easing: l,
    in: d,
    onEnter: u,
    onEntered: c,
    onEntering: p,
    onExit: f,
    onExited: g,
    onExiting: y,
    style: h,
    timeout: T = "auto",
    // eslint-disable-next-line react/prop-types
    TransitionComponent: P = Transition,
    ...E
  } = t, $ = useTimeout(), R = React.useRef(), C = useTheme(), x = React.useRef(null), _ = useForkRef(x, getReactElementRef(i), o), D = (F) => (L) => {
    if (F) {
      const k = x.current;
      L === void 0 ? F(k) : F(k, L);
    }
  }, O = D(p), v = D((F, L) => {
    reflow(F);
    const {
      duration: k,
      delay: W,
      easing: V
    } = getTransitionProps({
      style: h,
      timeout: T,
      easing: l
    }, {
      mode: "enter"
    });
    let j;
    T === "auto" ? (j = C.transitions.getAutoHeightDuration(F.clientHeight), R.current = j) : j = k, F.style.transition = [C.transitions.create("opacity", {
      duration: j,
      delay: W
    }), C.transitions.create("transform", {
      duration: isWebKit154 ? j : j * 0.666,
      delay: W,
      easing: V
    })].join(","), u && u(F, L);
  }), w = D(c), M = D(y), S = D((F) => {
    const {
      duration: L,
      delay: k,
      easing: W
    } = getTransitionProps({
      style: h,
      timeout: T,
      easing: l
    }, {
      mode: "exit"
    });
    let V;
    T === "auto" ? (V = C.transitions.getAutoHeightDuration(F.clientHeight), R.current = V) : V = L, F.style.transition = [C.transitions.create("opacity", {
      duration: V,
      delay: k
    }), C.transitions.create("transform", {
      duration: isWebKit154 ? V : V * 0.666,
      delay: isWebKit154 ? k : k || V * 0.333,
      easing: W
    })].join(","), F.style.opacity = 0, F.style.transform = getScale(0.75), f && f(F);
  }), I = D(g), N = (F) => {
    T === "auto" && $.start(R.current || 0, F), n && n(x.current, F);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(P, {
    appear: s,
    in: d,
    nodeRef: x,
    onEnter: v,
    onEntered: w,
    onEntering: O,
    onExit: S,
    onExited: I,
    onExiting: M,
    addEndListener: N,
    timeout: T === "auto" ? null : T,
    ...E,
    children: (F, {
      ownerState: L,
      ...k
    }) => /* @__PURE__ */ React.cloneElement(i, {
      style: {
        opacity: 0,
        transform: getScale(0.75),
        visibility: F === "exited" && !d ? "hidden" : void 0,
        ...styles$1[F],
        ...h,
        ...i.props.style
      },
      ref: _,
      ...k
    })
  });
});
process.env.NODE_ENV !== "production" && (Grow.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: PropTypes.func,
  /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */
  appear: PropTypes.bool,
  /**
   * A single child content element.
   */
  children: elementAcceptingRef.isRequired,
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */
  easing: PropTypes.oneOfType([PropTypes.shape({
    enter: PropTypes.string,
    exit: PropTypes.string
  }), PropTypes.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: PropTypes.bool,
  /**
   * @ignore
   */
  onEnter: PropTypes.func,
  /**
   * @ignore
   */
  onEntered: PropTypes.func,
  /**
   * @ignore
   */
  onEntering: PropTypes.func,
  /**
   * @ignore
   */
  onExit: PropTypes.func,
  /**
   * @ignore
   */
  onExited: PropTypes.func,
  /**
   * @ignore
   */
  onExiting: PropTypes.func,
  /**
   * @ignore
   */
  style: PropTypes.object,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default 'auto'
   */
  timeout: PropTypes.oneOfType([PropTypes.oneOf(["auto"]), PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })])
});
Grow && (Grow.muiSupportAuto = !0);
function isOverflowing(e) {
  const t = ownerDocument(e);
  return t.body === e ? ownerWindow(e).innerWidth > t.documentElement.clientWidth : e.scrollHeight > e.clientHeight;
}
function ariaHidden(e, t) {
  t ? e.setAttribute("aria-hidden", "true") : e.removeAttribute("aria-hidden");
}
function getPaddingRight(e) {
  return parseInt(ownerWindow(e).getComputedStyle(e).paddingRight, 10) || 0;
}
function isAriaHiddenForbiddenOnElement(e) {
  const o = ["TEMPLATE", "SCRIPT", "STYLE", "LINK", "MAP", "META", "NOSCRIPT", "PICTURE", "COL", "COLGROUP", "PARAM", "SLOT", "SOURCE", "TRACK"].includes(e.tagName), n = e.tagName === "INPUT" && e.getAttribute("type") === "hidden";
  return o || n;
}
function ariaHiddenSiblings(e, t, o, n, s) {
  const i = [t, o, ...n];
  [].forEach.call(e.children, (l) => {
    const d = !i.includes(l), u = !isAriaHiddenForbiddenOnElement(l);
    d && u && ariaHidden(l, s);
  });
}
function findIndexOf(e, t) {
  let o = -1;
  return e.some((n, s) => t(n) ? (o = s, !0) : !1), o;
}
function handleContainer(e, t) {
  const o = [], n = e.container;
  if (!t.disableScrollLock) {
    if (isOverflowing(n)) {
      const l = getScrollbarSize(ownerWindow(n));
      o.push({
        value: n.style.paddingRight,
        property: "padding-right",
        el: n
      }), n.style.paddingRight = `${getPaddingRight(n) + l}px`;
      const d = ownerDocument(n).querySelectorAll(".mui-fixed");
      [].forEach.call(d, (u) => {
        o.push({
          value: u.style.paddingRight,
          property: "padding-right",
          el: u
        }), u.style.paddingRight = `${getPaddingRight(u) + l}px`;
      });
    }
    let i;
    if (n.parentNode instanceof DocumentFragment)
      i = ownerDocument(n).body;
    else {
      const l = n.parentElement, d = ownerWindow(n);
      i = l?.nodeName === "HTML" && d.getComputedStyle(l).overflowY === "scroll" ? l : n;
    }
    o.push({
      value: i.style.overflow,
      property: "overflow",
      el: i
    }, {
      value: i.style.overflowX,
      property: "overflow-x",
      el: i
    }, {
      value: i.style.overflowY,
      property: "overflow-y",
      el: i
    }), i.style.overflow = "hidden";
  }
  return () => {
    o.forEach(({
      value: i,
      el: l,
      property: d
    }) => {
      i ? l.style.setProperty(d, i) : l.style.removeProperty(d);
    });
  };
}
function getHiddenSiblings(e) {
  const t = [];
  return [].forEach.call(e.children, (o) => {
    o.getAttribute("aria-hidden") === "true" && t.push(o);
  }), t;
}
class ModalManager {
  constructor() {
    this.modals = [], this.containers = [];
  }
  add(t, o) {
    let n = this.modals.indexOf(t);
    if (n !== -1)
      return n;
    n = this.modals.length, this.modals.push(t), t.modalRef && ariaHidden(t.modalRef, !1);
    const s = getHiddenSiblings(o);
    ariaHiddenSiblings(o, t.mount, t.modalRef, s, !0);
    const i = findIndexOf(this.containers, (l) => l.container === o);
    return i !== -1 ? (this.containers[i].modals.push(t), n) : (this.containers.push({
      modals: [t],
      container: o,
      restore: null,
      hiddenSiblings: s
    }), n);
  }
  mount(t, o) {
    const n = findIndexOf(this.containers, (i) => i.modals.includes(t)), s = this.containers[n];
    s.restore || (s.restore = handleContainer(s, o));
  }
  remove(t, o = !0) {
    const n = this.modals.indexOf(t);
    if (n === -1)
      return n;
    const s = findIndexOf(this.containers, (l) => l.modals.includes(t)), i = this.containers[s];
    if (i.modals.splice(i.modals.indexOf(t), 1), this.modals.splice(n, 1), i.modals.length === 0)
      i.restore && i.restore(), t.modalRef && ariaHidden(t.modalRef, o), ariaHiddenSiblings(i.container, t.mount, t.modalRef, i.hiddenSiblings, !1), this.containers.splice(s, 1);
    else {
      const l = i.modals[i.modals.length - 1];
      l.modalRef && ariaHidden(l.modalRef, !1);
    }
    return n;
  }
  isTopModal(t) {
    return this.modals.length > 0 && this.modals[this.modals.length - 1] === t;
  }
}
const candidatesSelector = ["input", "select", "textarea", "a[href]", "button", "[tabindex]", "audio[controls]", "video[controls]", '[contenteditable]:not([contenteditable="false"])'].join(",");
function getTabIndex(e) {
  const t = parseInt(e.getAttribute("tabindex") || "", 10);
  return Number.isNaN(t) ? e.contentEditable === "true" || (e.nodeName === "AUDIO" || e.nodeName === "VIDEO" || e.nodeName === "DETAILS") && e.getAttribute("tabindex") === null ? 0 : e.tabIndex : t;
}
function isNonTabbableRadio(e) {
  if (e.tagName !== "INPUT" || e.type !== "radio" || !e.name)
    return !1;
  const t = (n) => e.ownerDocument.querySelector(`input[type="radio"]${n}`);
  let o = t(`[name="${e.name}"]:checked`);
  return o || (o = t(`[name="${e.name}"]`)), o !== e;
}
function isNodeMatchingSelectorFocusable(e) {
  return !(e.disabled || e.tagName === "INPUT" && e.type === "hidden" || isNonTabbableRadio(e));
}
function defaultGetTabbable(e) {
  const t = [], o = [];
  return Array.from(e.querySelectorAll(candidatesSelector)).forEach((n, s) => {
    const i = getTabIndex(n);
    i === -1 || !isNodeMatchingSelectorFocusable(n) || (i === 0 ? t.push(n) : o.push({
      documentOrder: s,
      tabIndex: i,
      node: n
    }));
  }), o.sort((n, s) => n.tabIndex === s.tabIndex ? n.documentOrder - s.documentOrder : n.tabIndex - s.tabIndex).map((n) => n.node).concat(t);
}
function defaultIsEnabled() {
  return !0;
}
function FocusTrap(e) {
  const {
    children: t,
    disableAutoFocus: o = !1,
    disableEnforceFocus: n = !1,
    disableRestoreFocus: s = !1,
    getTabbable: i = defaultGetTabbable,
    isEnabled: l = defaultIsEnabled,
    open: d
  } = e, u = React.useRef(!1), c = React.useRef(null), p = React.useRef(null), f = React.useRef(null), g = React.useRef(null), y = React.useRef(!1), h = React.useRef(null), T = useForkRef(getReactElementRef(t), h), P = React.useRef(null);
  React.useEffect(() => {
    !d || !h.current || (y.current = !o);
  }, [o, d]), React.useEffect(() => {
    if (!d || !h.current)
      return;
    const R = ownerDocument(h.current);
    return h.current.contains(R.activeElement) || (h.current.hasAttribute("tabIndex") || (process.env.NODE_ENV !== "production" && console.error(["MUI: The modal content node does not accept focus.", 'For the benefit of assistive technologies, the tabIndex of the node is being set to "-1".'].join(`
`)), h.current.setAttribute("tabIndex", "-1")), y.current && h.current.focus()), () => {
      s || (f.current && f.current.focus && (u.current = !0, f.current.focus()), f.current = null);
    };
  }, [d]), React.useEffect(() => {
    if (!d || !h.current)
      return;
    const R = ownerDocument(h.current), C = (D) => {
      P.current = D, !(n || !l() || D.key !== "Tab") && R.activeElement === h.current && D.shiftKey && (u.current = !0, p.current && p.current.focus());
    }, x = () => {
      const D = h.current;
      if (D === null)
        return;
      if (!R.hasFocus() || !l() || u.current) {
        u.current = !1;
        return;
      }
      if (D.contains(R.activeElement) || n && R.activeElement !== c.current && R.activeElement !== p.current)
        return;
      if (R.activeElement !== g.current)
        g.current = null;
      else if (g.current !== null)
        return;
      if (!y.current)
        return;
      let O = [];
      if ((R.activeElement === c.current || R.activeElement === p.current) && (O = i(h.current)), O.length > 0) {
        const v = !!(P.current?.shiftKey && P.current?.key === "Tab"), w = O[0], M = O[O.length - 1];
        typeof w != "string" && typeof M != "string" && (v ? M.focus() : w.focus());
      } else
        D.focus();
    };
    R.addEventListener("focusin", x), R.addEventListener("keydown", C, !0);
    const _ = setInterval(() => {
      R.activeElement && R.activeElement.tagName === "BODY" && x();
    }, 50);
    return () => {
      clearInterval(_), R.removeEventListener("focusin", x), R.removeEventListener("keydown", C, !0);
    };
  }, [o, n, s, l, d, i]);
  const E = (R) => {
    f.current === null && (f.current = R.relatedTarget), y.current = !0, g.current = R.target;
    const C = t.props.onFocus;
    C && C(R);
  }, $ = (R) => {
    f.current === null && (f.current = R.relatedTarget), y.current = !0;
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(React.Fragment, {
    children: [/* @__PURE__ */ jsxRuntimeExports.jsx("div", {
      tabIndex: d ? 0 : -1,
      onFocus: $,
      ref: c,
      "data-testid": "sentinelStart"
    }), /* @__PURE__ */ React.cloneElement(t, {
      ref: T,
      onFocus: E
    }), /* @__PURE__ */ jsxRuntimeExports.jsx("div", {
      tabIndex: d ? 0 : -1,
      onFocus: $,
      ref: p,
      "data-testid": "sentinelEnd"
    })]
  });
}
process.env.NODE_ENV !== "production" && (FocusTrap.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A single child content element.
   */
  children: elementAcceptingRef,
  /**
   * If `true`, the focus trap will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any focus trap children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the focus trap less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableAutoFocus: PropTypes.bool,
  /**
   * If `true`, the focus trap will not prevent focus from leaving the focus trap while open.
   *
   * Generally this should never be set to `true` as it makes the focus trap less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableEnforceFocus: PropTypes.bool,
  /**
   * If `true`, the focus trap will not restore focus to previously focused element once
   * focus trap is hidden or unmounted.
   * @default false
   */
  disableRestoreFocus: PropTypes.bool,
  /**
   * Returns an array of ordered tabbable nodes (i.e. in tab order) within the root.
   * For instance, you can provide the "tabbable" npm dependency.
   * @param {HTMLElement} root
   */
  getTabbable: PropTypes.func,
  /**
   * This prop extends the `open` prop.
   * It allows to toggle the open state without having to wait for a rerender when changing the `open` prop.
   * This prop should be memoized.
   * It can be used to support multiple focus trap mounted at the same time.
   * @default function defaultIsEnabled(): boolean {
   *   return true;
   * }
   */
  isEnabled: PropTypes.func,
  /**
   * If `true`, focus is locked.
   */
  open: PropTypes.bool.isRequired
});
process.env.NODE_ENV !== "production" && (FocusTrap.propTypes = exactProp(FocusTrap.propTypes));
function getContainer$1(e) {
  return typeof e == "function" ? e() : e;
}
const Portal = /* @__PURE__ */ React.forwardRef(function e(t, o) {
  const {
    children: n,
    container: s,
    disablePortal: i = !1
  } = t, [l, d] = React.useState(null), u = useForkRef(/* @__PURE__ */ React.isValidElement(n) ? getReactElementRef(n) : null, o);
  if (useEnhancedEffect(() => {
    i || d(getContainer$1(s) || document.body);
  }, [s, i]), useEnhancedEffect(() => {
    if (l && !i)
      return setRef(o, l), () => {
        setRef(o, null);
      };
  }, [o, l, i]), i) {
    if (/* @__PURE__ */ React.isValidElement(n)) {
      const c = {
        ref: u
      };
      return /* @__PURE__ */ React.cloneElement(n, c);
    }
    return n;
  }
  return l && /* @__PURE__ */ ReactDOM.createPortal(n, l);
});
process.env.NODE_ENV !== "production" && (Portal.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The children to render into the `container`.
   */
  children: PropTypes.node,
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: PropTypes.oneOfType([HTMLElementType, PropTypes.func]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: PropTypes.bool
});
process.env.NODE_ENV !== "production" && (Portal.propTypes = exactProp(Portal.propTypes));
const styles = {
  entering: {
    opacity: 1
  },
  entered: {
    opacity: 1
  }
}, Fade = /* @__PURE__ */ React.forwardRef(function e(t, o) {
  const n = useTheme(), s = {
    enter: n.transitions.duration.enteringScreen,
    exit: n.transitions.duration.leavingScreen
  }, {
    addEndListener: i,
    appear: l = !0,
    children: d,
    easing: u,
    in: c,
    onEnter: p,
    onEntered: f,
    onEntering: g,
    onExit: y,
    onExited: h,
    onExiting: T,
    style: P,
    timeout: E = s,
    // eslint-disable-next-line react/prop-types
    TransitionComponent: $ = Transition,
    ...R
  } = t, C = React.useRef(null), x = useForkRef(C, getReactElementRef(d), o), _ = (N) => (F) => {
    if (N) {
      const L = C.current;
      F === void 0 ? N(L) : N(L, F);
    }
  }, D = _(g), O = _((N, F) => {
    reflow(N);
    const L = getTransitionProps({
      style: P,
      timeout: E,
      easing: u
    }, {
      mode: "enter"
    });
    N.style.webkitTransition = n.transitions.create("opacity", L), N.style.transition = n.transitions.create("opacity", L), p && p(N, F);
  }), v = _(f), w = _(T), M = _((N) => {
    const F = getTransitionProps({
      style: P,
      timeout: E,
      easing: u
    }, {
      mode: "exit"
    });
    N.style.webkitTransition = n.transitions.create("opacity", F), N.style.transition = n.transitions.create("opacity", F), y && y(N);
  }), S = _(h), I = (N) => {
    i && i(C.current, N);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx($, {
    appear: l,
    in: c,
    nodeRef: C,
    onEnter: O,
    onEntered: v,
    onEntering: D,
    onExit: M,
    onExited: S,
    onExiting: w,
    addEndListener: I,
    timeout: E,
    ...R,
    children: (N, {
      ownerState: F,
      ...L
    }) => /* @__PURE__ */ React.cloneElement(d, {
      style: {
        opacity: 0,
        visibility: N === "exited" && !c ? "hidden" : void 0,
        ...styles[N],
        ...P,
        ...d.props.style
      },
      ref: x,
      ...L
    })
  });
});
process.env.NODE_ENV !== "production" && (Fade.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: PropTypes.func,
  /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */
  appear: PropTypes.bool,
  /**
   * A single child content element.
   */
  children: elementAcceptingRef.isRequired,
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */
  easing: PropTypes.oneOfType([PropTypes.shape({
    enter: PropTypes.string,
    exit: PropTypes.string
  }), PropTypes.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: PropTypes.bool,
  /**
   * @ignore
   */
  onEnter: PropTypes.func,
  /**
   * @ignore
   */
  onEntered: PropTypes.func,
  /**
   * @ignore
   */
  onEntering: PropTypes.func,
  /**
   * @ignore
   */
  onExit: PropTypes.func,
  /**
   * @ignore
   */
  onExited: PropTypes.func,
  /**
   * @ignore
   */
  onExiting: PropTypes.func,
  /**
   * @ignore
   */
  style: PropTypes.object,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */
  timeout: PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })])
});
function getBackdropUtilityClass(e) {
  return generateUtilityClass("MuiBackdrop", e);
}
generateUtilityClasses("MuiBackdrop", ["root", "invisible"]);
const useUtilityClasses$B = (e) => {
  const {
    classes: t,
    invisible: o
  } = e;
  return composeClasses({
    root: ["root", o && "invisible"]
  }, getBackdropUtilityClass, t);
}, BackdropRoot = styled("div", {
  name: "MuiBackdrop",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.root, o.invisible && t.invisible];
  }
})({
  position: "fixed",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  right: 0,
  bottom: 0,
  top: 0,
  left: 0,
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  WebkitTapHighlightColor: "transparent",
  variants: [{
    props: {
      invisible: !0
    },
    style: {
      backgroundColor: "transparent"
    }
  }]
}), Backdrop = /* @__PURE__ */ React.forwardRef(function e(t, o) {
  const n = useDefaultProps({
    props: t,
    name: "MuiBackdrop"
  }), {
    children: s,
    className: i,
    component: l = "div",
    invisible: d = !1,
    open: u,
    components: c = {},
    componentsProps: p = {},
    slotProps: f = {},
    slots: g = {},
    TransitionComponent: y,
    transitionDuration: h,
    ...T
  } = n, P = {
    ...n,
    component: l,
    invisible: d
  }, E = useUtilityClasses$B(P), $ = {
    transition: y,
    root: c.Root,
    ...g
  }, R = {
    ...p,
    ...f
  }, C = {
    component: l,
    slots: $,
    slotProps: R
  }, [x, _] = useSlot("root", {
    elementType: BackdropRoot,
    externalForwardedProps: C,
    className: clsx(E.root, i),
    ownerState: P
  }), [D, O] = useSlot("transition", {
    elementType: Fade,
    externalForwardedProps: C,
    ownerState: P
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(D, {
    in: u,
    timeout: h,
    ...T,
    ...O,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(x, {
      "aria-hidden": !0,
      ..._,
      classes: E,
      ref: o,
      children: s
    })
  });
});
process.env.NODE_ENV !== "production" && (Backdrop.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * The components used for each slot inside.
   *
   * @deprecated Use the `slots` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: PropTypes.shape({
    Root: PropTypes.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated Use the `slotProps` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: PropTypes.shape({
    root: PropTypes.object
  }),
  /**
   * If `true`, the backdrop is invisible.
   * It can be used when rendering a popover or a custom select component.
   * @default false
   */
  invisible: PropTypes.bool,
  /**
   * If `true`, the component is shown.
   */
  open: PropTypes.bool.isRequired,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: PropTypes.shape({
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    transition: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: PropTypes.shape({
    root: PropTypes.elementType,
    transition: PropTypes.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The component used for the transition.
   * [Follow this guide](https://mui.com/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Fade
   * @deprecated Use `slots.transition` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  TransitionComponent: PropTypes.elementType,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  transitionDuration: PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })])
});
function getContainer(e) {
  return typeof e == "function" ? e() : e;
}
function getHasTransition(e) {
  return e ? e.props.hasOwnProperty("in") : !1;
}
const noop$1 = () => {
}, manager = new ModalManager();
function useModal(e) {
  const {
    container: t,
    disableEscapeKeyDown: o = !1,
    disableScrollLock: n = !1,
    closeAfterTransition: s = !1,
    onTransitionEnter: i,
    onTransitionExited: l,
    children: d,
    onClose: u,
    open: c,
    rootRef: p
  } = e, f = React.useRef({}), g = React.useRef(null), y = React.useRef(null), h = useForkRef(y, p), [T, P] = React.useState(!c), E = getHasTransition(d);
  let $ = !0;
  (e["aria-hidden"] === "false" || e["aria-hidden"] === !1) && ($ = !1);
  const R = () => ownerDocument(g.current), C = () => (f.current.modalRef = y.current, f.current.mount = g.current, f.current), x = () => {
    manager.mount(C(), {
      disableScrollLock: n
    }), y.current && (y.current.scrollTop = 0);
  }, _ = useEventCallback(() => {
    const F = getContainer(t) || R().body;
    manager.add(C(), F), y.current && x();
  }), D = () => manager.isTopModal(C()), O = useEventCallback((F) => {
    g.current = F, F && (c && D() ? x() : y.current && ariaHidden(y.current, $));
  }), v = React.useCallback(() => {
    manager.remove(C(), $);
  }, [$]);
  React.useEffect(() => () => {
    v();
  }, [v]), React.useEffect(() => {
    c ? _() : (!E || !s) && v();
  }, [c, v, E, s, _]);
  const w = (F) => (L) => {
    F.onKeyDown?.(L), !(L.key !== "Escape" || L.which === 229 || // Wait until IME is settled.
    !D()) && (o || (L.stopPropagation(), u && u(L, "escapeKeyDown")));
  }, M = (F) => (L) => {
    F.onClick?.(L), L.target === L.currentTarget && u && u(L, "backdropClick");
  };
  return {
    getRootProps: (F = {}) => {
      const L = extractEventHandlers(e);
      delete L.onTransitionEnter, delete L.onTransitionExited;
      const k = {
        ...L,
        ...F
      };
      return {
        /*
         * Marking an element with the role presentation indicates to assistive technology
         * that this element should be ignored; it exists to support the web application and
         * is not meant for humans to interact with directly.
         * https://github.com/evcohen/eslint-plugin-jsx-a11y/blob/master/docs/rules/no-static-element-interactions.md
         */
        role: "presentation",
        ...k,
        onKeyDown: w(k),
        ref: h
      };
    },
    getBackdropProps: (F = {}) => {
      const L = F;
      return {
        "aria-hidden": !0,
        ...L,
        onClick: M(L),
        open: c
      };
    },
    getTransitionProps: () => {
      const F = () => {
        P(!1), i && i();
      }, L = () => {
        P(!0), l && l(), s && v();
      };
      return {
        onEnter: createChainedFunction(F, d?.props.onEnter ?? noop$1),
        onExited: createChainedFunction(L, d?.props.onExited ?? noop$1)
      };
    },
    rootRef: h,
    portalRef: O,
    isTopModal: D,
    exited: T,
    hasTransition: E
  };
}
function getModalUtilityClass(e) {
  return generateUtilityClass("MuiModal", e);
}
generateUtilityClasses("MuiModal", ["root", "hidden", "backdrop"]);
const useUtilityClasses$A = (e) => {
  const {
    open: t,
    exited: o,
    classes: n
  } = e;
  return composeClasses({
    root: ["root", !t && o && "hidden"],
    backdrop: ["backdrop"]
  }, getModalUtilityClass, n);
}, ModalRoot = styled("div", {
  name: "MuiModal",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.root, !o.open && o.exited && t.hidden];
  }
})(memoTheme(({
  theme: e
}) => ({
  position: "fixed",
  zIndex: (e.vars || e).zIndex.modal,
  right: 0,
  bottom: 0,
  top: 0,
  left: 0,
  variants: [{
    props: ({
      ownerState: t
    }) => !t.open && t.exited,
    style: {
      visibility: "hidden"
    }
  }]
}))), ModalBackdrop = styled(Backdrop, {
  name: "MuiModal",
  slot: "Backdrop"
})({
  zIndex: -1
}), Modal = /* @__PURE__ */ React.forwardRef(function e(t, o) {
  const n = useDefaultProps({
    name: "MuiModal",
    props: t
  }), {
    BackdropComponent: s = ModalBackdrop,
    BackdropProps: i,
    classes: l,
    className: d,
    closeAfterTransition: u = !1,
    children: c,
    container: p,
    component: f,
    components: g = {},
    componentsProps: y = {},
    disableAutoFocus: h = !1,
    disableEnforceFocus: T = !1,
    disableEscapeKeyDown: P = !1,
    disablePortal: E = !1,
    disableRestoreFocus: $ = !1,
    disableScrollLock: R = !1,
    hideBackdrop: C = !1,
    keepMounted: x = !1,
    onClose: _,
    onTransitionEnter: D,
    onTransitionExited: O,
    open: v,
    slotProps: w = {},
    slots: M = {},
    // eslint-disable-next-line react/prop-types
    theme: S,
    ...I
  } = n, N = {
    ...n,
    closeAfterTransition: u,
    disableAutoFocus: h,
    disableEnforceFocus: T,
    disableEscapeKeyDown: P,
    disablePortal: E,
    disableRestoreFocus: $,
    disableScrollLock: R,
    hideBackdrop: C,
    keepMounted: x
  }, {
    getRootProps: F,
    getBackdropProps: L,
    getTransitionProps: k,
    portalRef: W,
    isTopModal: V,
    exited: j,
    hasTransition: A
  } = useModal({
    ...N,
    rootRef: o
  }), U = {
    ...N,
    exited: j
  }, G = useUtilityClasses$A(U), Y = {};
  if (c.props.tabIndex === void 0 && (Y.tabIndex = "-1"), A) {
    const {
      onEnter: K,
      onExited: q
    } = k();
    Y.onEnter = K, Y.onExited = q;
  }
  const ee = {
    slots: {
      root: g.Root,
      backdrop: g.Backdrop,
      ...M
    },
    slotProps: {
      ...y,
      ...w
    }
  }, [J, Z] = useSlot("root", {
    ref: o,
    elementType: ModalRoot,
    externalForwardedProps: {
      ...ee,
      ...I,
      component: f
    },
    getSlotProps: F,
    ownerState: U,
    className: clsx(d, G?.root, !U.open && U.exited && G?.hidden)
  }), [le, se] = useSlot("backdrop", {
    ref: i?.ref,
    elementType: s,
    externalForwardedProps: ee,
    shouldForwardComponentProp: !0,
    additionalProps: i,
    getSlotProps: (K) => L({
      ...K,
      onClick: (q) => {
        K?.onClick && K.onClick(q);
      }
    }),
    className: clsx(i?.className, G?.backdrop),
    ownerState: U
  });
  return !x && !v && (!A || j) ? null : /* @__PURE__ */ jsxRuntimeExports.jsx(Portal, {
    ref: W,
    container: p,
    disablePortal: E,
    children: /* @__PURE__ */ jsxRuntimeExports.jsxs(J, {
      ...Z,
      children: [!C && s ? /* @__PURE__ */ jsxRuntimeExports.jsx(le, {
        ...se
      }) : null, /* @__PURE__ */ jsxRuntimeExports.jsx(FocusTrap, {
        disableEnforceFocus: T,
        disableAutoFocus: h,
        disableRestoreFocus: $,
        isEnabled: V,
        open: v,
        children: /* @__PURE__ */ React.cloneElement(c, Y)
      })]
    })
  });
});
process.env.NODE_ENV !== "production" && (Modal.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A backdrop component. This prop enables custom backdrop rendering.
   * @deprecated Use `slots.backdrop` instead. While this prop currently works, it will be removed in the next major version.
   * Use the `slots.backdrop` prop to make your application ready for the next version of Material UI.
   * @default styled(Backdrop, {
   *   name: 'MuiModal',
   *   slot: 'Backdrop',
   * })({
   *   zIndex: -1,
   * })
   */
  BackdropComponent: PropTypes.elementType,
  /**
   * Props applied to the [`Backdrop`](https://mui.com/material-ui/api/backdrop/) element.
   * @deprecated Use `slotProps.backdrop` instead.
   */
  BackdropProps: PropTypes.object,
  /**
   * A single child content element.
   */
  children: elementAcceptingRef.isRequired,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * When set to true the Modal waits until a nested Transition is completed before closing.
   * @default false
   */
  closeAfterTransition: PropTypes.bool,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * The components used for each slot inside.
   *
   * @deprecated Use the `slots` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: PropTypes.shape({
    Backdrop: PropTypes.elementType,
    Root: PropTypes.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated Use the `slotProps` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: PropTypes.shape({
    backdrop: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: PropTypes.oneOfType([HTMLElementType, PropTypes.func]),
  /**
   * If `true`, the modal will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any modal children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableAutoFocus: PropTypes.bool,
  /**
   * If `true`, the modal will not prevent focus from leaving the modal while open.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableEnforceFocus: PropTypes.bool,
  /**
   * If `true`, hitting escape will not fire the `onClose` callback.
   * @default false
   */
  disableEscapeKeyDown: PropTypes.bool,
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: PropTypes.bool,
  /**
   * If `true`, the modal will not restore focus to previously focused element once
   * modal is hidden or unmounted.
   * @default false
   */
  disableRestoreFocus: PropTypes.bool,
  /**
   * Disable the scroll lock behavior.
   * @default false
   */
  disableScrollLock: PropTypes.bool,
  /**
   * If `true`, the backdrop is not rendered.
   * @default false
   */
  hideBackdrop: PropTypes.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Modal.
   * @default false
   */
  keepMounted: PropTypes.bool,
  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
   */
  onClose: PropTypes.func,
  /**
   * A function called when a transition enters.
   */
  onTransitionEnter: PropTypes.func,
  /**
   * A function called when a transition has exited.
   */
  onTransitionExited: PropTypes.func,
  /**
   * If `true`, the component is shown.
   */
  open: PropTypes.bool.isRequired,
  /**
   * The props used for each slot inside the Modal.
   * @default {}
   */
  slotProps: PropTypes.shape({
    backdrop: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside the Modal.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: PropTypes.shape({
    backdrop: PropTypes.elementType,
    root: PropTypes.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
});
function getPaperUtilityClass(e) {
  return generateUtilityClass("MuiPaper", e);
}
generateUtilityClasses("MuiPaper", ["root", "rounded", "outlined", "elevation", "elevation0", "elevation1", "elevation2", "elevation3", "elevation4", "elevation5", "elevation6", "elevation7", "elevation8", "elevation9", "elevation10", "elevation11", "elevation12", "elevation13", "elevation14", "elevation15", "elevation16", "elevation17", "elevation18", "elevation19", "elevation20", "elevation21", "elevation22", "elevation23", "elevation24"]);
const useUtilityClasses$z = (e) => {
  const {
    square: t,
    elevation: o,
    variant: n,
    classes: s
  } = e, i = {
    root: ["root", n, !t && "rounded", n === "elevation" && `elevation${o}`]
  };
  return composeClasses(i, getPaperUtilityClass, s);
}, PaperRoot = styled("div", {
  name: "MuiPaper",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.root, t[o.variant], !o.square && t.rounded, o.variant === "elevation" && t[`elevation${o.elevation}`]];
  }
})(memoTheme(({
  theme: e
}) => ({
  backgroundColor: (e.vars || e).palette.background.paper,
  color: (e.vars || e).palette.text.primary,
  transition: e.transitions.create("box-shadow"),
  variants: [{
    props: ({
      ownerState: t
    }) => !t.square,
    style: {
      borderRadius: e.shape.borderRadius
    }
  }, {
    props: {
      variant: "outlined"
    },
    style: {
      border: `1px solid ${(e.vars || e).palette.divider}`
    }
  }, {
    props: {
      variant: "elevation"
    },
    style: {
      boxShadow: "var(--Paper-shadow)",
      backgroundImage: "var(--Paper-overlay)"
    }
  }]
}))), Paper = /* @__PURE__ */ React.forwardRef(function e(t, o) {
  const n = useDefaultProps({
    props: t,
    name: "MuiPaper"
  }), s = useTheme(), {
    className: i,
    component: l = "div",
    elevation: d = 1,
    square: u = !1,
    variant: c = "elevation",
    ...p
  } = n, f = {
    ...n,
    component: l,
    elevation: d,
    square: u,
    variant: c
  }, g = useUtilityClasses$z(f);
  return process.env.NODE_ENV !== "production" && s.shadows[d] === void 0 && console.error([`MUI: The elevation provided <Paper elevation={${d}}> is not available in the theme.`, `Please make sure that \`theme.shadows[${d}]\` is defined.`].join(`
`)), /* @__PURE__ */ jsxRuntimeExports.jsx(PaperRoot, {
    as: l,
    ownerState: f,
    className: clsx(g.root, i),
    ref: o,
    ...p,
    style: {
      ...c === "elevation" && {
        "--Paper-shadow": (s.vars || s).shadows[d],
        ...s.vars && {
          "--Paper-overlay": s.vars.overlays?.[d]
        },
        ...!s.vars && s.palette.mode === "dark" && {
          "--Paper-overlay": `linear-gradient(${alpha$1("#fff", getOverlayAlpha(d))}, ${alpha$1("#fff", getOverlayAlpha(d))})`
        }
      },
      ...p.style
    }
  });
});
process.env.NODE_ENV !== "production" && (Paper.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * Shadow depth, corresponds to `dp` in the spec.
   * It accepts values between 0 and 24 inclusive.
   * @default 1
   */
  elevation: chainPropTypes(integerPropType, (e) => {
    const {
      elevation: t,
      variant: o
    } = e;
    return t > 0 && o === "outlined" ? new Error(`MUI: Combining \`elevation={${t}}\` with \`variant="${o}"\` has no effect. Either use \`elevation={0}\` or use a different \`variant\`.`) : null;
  }),
  /**
   * If `true`, rounded corners are disabled.
   * @default false
   */
  square: PropTypes.bool,
  /**
   * @ignore
   */
  style: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The variant to use.
   * @default 'elevation'
   */
  variant: PropTypes.oneOfType([PropTypes.oneOf(["elevation", "outlined"]), PropTypes.string])
});
function getPopoverUtilityClass(e) {
  return generateUtilityClass("MuiPopover", e);
}
generateUtilityClasses("MuiPopover", ["root", "paper"]);
function getOffsetTop(e, t) {
  let o = 0;
  return typeof t == "number" ? o = t : t === "center" ? o = e.height / 2 : t === "bottom" && (o = e.height), o;
}
function getOffsetLeft(e, t) {
  let o = 0;
  return typeof t == "number" ? o = t : t === "center" ? o = e.width / 2 : t === "right" && (o = e.width), o;
}
function getTransformOriginValue(e) {
  return [e.horizontal, e.vertical].map((t) => typeof t == "number" ? `${t}px` : t).join(" ");
}
function resolveAnchorEl$1(e) {
  return typeof e == "function" ? e() : e;
}
const useUtilityClasses$y = (e) => {
  const {
    classes: t
  } = e;
  return composeClasses({
    root: ["root"],
    paper: ["paper"]
  }, getPopoverUtilityClass, t);
}, PopoverRoot = styled(Modal, {
  name: "MuiPopover",
  slot: "Root"
})({}), PopoverPaper = styled(Paper, {
  name: "MuiPopover",
  slot: "Paper"
})({
  position: "absolute",
  overflowY: "auto",
  overflowX: "hidden",
  // So we see the popover when it's empty.
  // It's most likely on issue on userland.
  minWidth: 16,
  minHeight: 16,
  maxWidth: "calc(100% - 32px)",
  maxHeight: "calc(100% - 32px)",
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
}), Popover = /* @__PURE__ */ React.forwardRef(function e(t, o) {
  const n = useDefaultProps({
    props: t,
    name: "MuiPopover"
  }), {
    action: s,
    anchorEl: i,
    anchorOrigin: l = {
      vertical: "top",
      horizontal: "left"
    },
    anchorPosition: d,
    anchorReference: u = "anchorEl",
    children: c,
    className: p,
    container: f,
    elevation: g = 8,
    marginThreshold: y = 16,
    open: h,
    PaperProps: T = {},
    // TODO: remove in v7
    slots: P = {},
    slotProps: E = {},
    transformOrigin: $ = {
      vertical: "top",
      horizontal: "left"
    },
    TransitionComponent: R,
    // TODO: remove in v7
    transitionDuration: C = "auto",
    TransitionProps: x = {},
    // TODO: remove in v7
    disableScrollLock: _ = !1,
    ...D
  } = n, O = React.useRef(), v = {
    ...n,
    anchorOrigin: l,
    anchorReference: u,
    elevation: g,
    marginThreshold: y,
    transformOrigin: $,
    TransitionComponent: R,
    transitionDuration: C,
    TransitionProps: x
  }, w = useUtilityClasses$y(v), M = React.useCallback(() => {
    if (u === "anchorPosition")
      return process.env.NODE_ENV !== "production" && (d || console.error('MUI: You need to provide a `anchorPosition` prop when using <Popover anchorReference="anchorPosition" />.')), d;
    const K = resolveAnchorEl$1(i), q = K && K.nodeType === 1 ? K : ownerDocument(O.current).body, B = q.getBoundingClientRect();
    if (process.env.NODE_ENV !== "production") {
      const ue = q.getBoundingClientRect();
      process.env.NODE_ENV !== "test" && ue.top === 0 && ue.left === 0 && ue.right === 0 && ue.bottom === 0 && console.warn(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
    }
    return {
      top: B.top + getOffsetTop(B, l.vertical),
      left: B.left + getOffsetLeft(B, l.horizontal)
    };
  }, [i, l.horizontal, l.vertical, d, u]), S = React.useCallback((K) => ({
    vertical: getOffsetTop(K, $.vertical),
    horizontal: getOffsetLeft(K, $.horizontal)
  }), [$.horizontal, $.vertical]), I = React.useCallback((K) => {
    const q = {
      width: K.offsetWidth,
      height: K.offsetHeight
    }, B = S(q);
    if (u === "none")
      return {
        top: null,
        left: null,
        transformOrigin: getTransformOriginValue(B)
      };
    const ue = M();
    let re = ue.top - B.vertical, be = ue.left - B.horizontal;
    const X = re + q.height, ge = be + q.width, Ee = ownerWindow(resolveAnchorEl$1(i)), xe = Ee.innerHeight - y, he = Ee.innerWidth - y;
    if (y !== null && re < y) {
      const Pe = re - y;
      re -= Pe, B.vertical += Pe;
    } else if (y !== null && X > xe) {
      const Pe = X - xe;
      re -= Pe, B.vertical += Pe;
    }
    if (process.env.NODE_ENV !== "production" && q.height > xe && q.height && xe && console.error(["MUI: The popover component is too tall.", `Some part of it can not be seen on the screen (${q.height - xe}px).`, "Please consider adding a `max-height` to improve the user-experience."].join(`
`)), y !== null && be < y) {
      const Pe = be - y;
      be -= Pe, B.horizontal += Pe;
    } else if (ge > he) {
      const Pe = ge - he;
      be -= Pe, B.horizontal += Pe;
    }
    return {
      top: `${Math.round(re)}px`,
      left: `${Math.round(be)}px`,
      transformOrigin: getTransformOriginValue(B)
    };
  }, [i, u, M, S, y]), [N, F] = React.useState(h), L = React.useCallback(() => {
    const K = O.current;
    if (!K)
      return;
    const q = I(K);
    q.top !== null && K.style.setProperty("top", q.top), q.left !== null && (K.style.left = q.left), K.style.transformOrigin = q.transformOrigin, F(!0);
  }, [I]);
  React.useEffect(() => (_ && window.addEventListener("scroll", L), () => window.removeEventListener("scroll", L)), [i, _, L]);
  const k = () => {
    L();
  }, W = () => {
    F(!1);
  };
  React.useEffect(() => {
    h && L();
  }), React.useImperativeHandle(s, () => h ? {
    updatePosition: () => {
      L();
    }
  } : null, [h, L]), React.useEffect(() => {
    if (!h)
      return;
    const K = debounce$1(() => {
      L();
    }), q = ownerWindow(resolveAnchorEl$1(i));
    return q.addEventListener("resize", K), () => {
      K.clear(), q.removeEventListener("resize", K);
    };
  }, [i, h, L]);
  let V = C;
  const j = {
    slots: {
      transition: R,
      ...P
    },
    slotProps: {
      transition: x,
      paper: T,
      ...E
    }
  }, [A, U] = useSlot("transition", {
    elementType: Grow,
    externalForwardedProps: j,
    ownerState: v,
    getSlotProps: (K) => ({
      ...K,
      onEntering: (q, B) => {
        K.onEntering?.(q, B), k();
      },
      onExited: (q) => {
        K.onExited?.(q), W();
      }
    }),
    additionalProps: {
      appear: !0,
      in: h
    }
  });
  C === "auto" && !A.muiSupportAuto && (V = void 0);
  const G = f || (i ? ownerDocument(resolveAnchorEl$1(i)).body : void 0), [Y, {
    slots: ee,
    slotProps: J,
    ...Z
  }] = useSlot("root", {
    ref: o,
    elementType: PopoverRoot,
    externalForwardedProps: {
      ...j,
      ...D
    },
    shouldForwardComponentProp: !0,
    additionalProps: {
      slots: {
        backdrop: P.backdrop
      },
      slotProps: {
        backdrop: mergeSlotProps$2(typeof E.backdrop == "function" ? E.backdrop(v) : E.backdrop, {
          invisible: !0
        })
      },
      container: G,
      open: h
    },
    ownerState: v,
    className: clsx(w.root, p)
  }), [le, se] = useSlot("paper", {
    ref: O,
    className: w.paper,
    elementType: PopoverPaper,
    externalForwardedProps: j,
    shouldForwardComponentProp: !0,
    additionalProps: {
      elevation: g,
      style: N ? void 0 : {
        opacity: 0
      }
    },
    ownerState: v
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Y, {
    ...Z,
    ...!isHostComponent(Y) && {
      slots: ee,
      slotProps: J,
      disableScrollLock: _
    },
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(A, {
      ...U,
      timeout: V,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(le, {
        ...se,
        children: c
      })
    })
  });
});
process.env.NODE_ENV !== "production" && (Popover.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A ref for imperative actions.
   * It currently only supports updatePosition() action.
   */
  action: refType,
  /**
   * An HTML element, [PopoverVirtualElement](https://mui.com/material-ui/react-popover/#virtual-element),
   * or a function that returns either.
   * It's used to set the position of the popover.
   */
  anchorEl: chainPropTypes(PropTypes.oneOfType([HTMLElementType, PropTypes.func]), (e) => {
    if (e.open && (!e.anchorReference || e.anchorReference === "anchorEl")) {
      const t = resolveAnchorEl$1(e.anchorEl);
      if (t && t.nodeType === 1) {
        const o = t.getBoundingClientRect();
        if (process.env.NODE_ENV !== "test" && o.top === 0 && o.left === 0 && o.right === 0 && o.bottom === 0)
          return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
      } else
        return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", `It should be an Element or PopoverVirtualElement instance but it's \`${t}\` instead.`].join(`
`));
    }
    return null;
  }),
  /**
   * This is the point on the anchor where the popover's
   * `anchorEl` will attach to. This is not used when the
   * anchorReference is 'anchorPosition'.
   *
   * Options:
   * vertical: [top, center, bottom];
   * horizontal: [left, center, right].
   * @default {
   *   vertical: 'top',
   *   horizontal: 'left',
   * }
   */
  anchorOrigin: PropTypes.shape({
    horizontal: PropTypes.oneOfType([PropTypes.oneOf(["center", "left", "right"]), PropTypes.number]).isRequired,
    vertical: PropTypes.oneOfType([PropTypes.oneOf(["bottom", "center", "top"]), PropTypes.number]).isRequired
  }),
  /**
   * This is the position that may be used to set the position of the popover.
   * The coordinates are relative to the application's client area.
   */
  anchorPosition: PropTypes.shape({
    left: PropTypes.number.isRequired,
    top: PropTypes.number.isRequired
  }),
  /**
   * This determines which anchor prop to refer to when setting
   * the position of the popover.
   * @default 'anchorEl'
   */
  anchorReference: PropTypes.oneOf(["anchorEl", "anchorPosition", "none"]),
  /**
   * A backdrop component. This prop enables custom backdrop rendering.
   * @deprecated Use `slots.backdrop` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default styled(Backdrop, {
   *   name: 'MuiModal',
   *   slot: 'Backdrop',
   *   overridesResolver: (props, styles) => {
   *     return styles.backdrop;
   *   },
   * })({
   *   zIndex: -1,
   * })
   */
  BackdropComponent: PropTypes.elementType,
  /**
   * Props applied to the [`Backdrop`](/material-ui/api/backdrop/) element.
   * @deprecated Use `slotProps.backdrop` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  BackdropProps: PropTypes.object,
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * An HTML element, component instance, or function that returns either.
   * The `container` will passed to the Modal component.
   *
   * By default, it uses the body of the anchorEl's top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: PropTypes.oneOfType([HTMLElementType, PropTypes.func]),
  /**
   * Disable the scroll lock behavior.
   * @default false
   */
  disableScrollLock: PropTypes.bool,
  /**
   * The elevation of the popover.
   * @default 8
   */
  elevation: integerPropType,
  /**
   * Specifies how close to the edge of the window the popover can appear.
   * If null, the popover will not be constrained by the window.
   * @default 16
   */
  marginThreshold: PropTypes.number,
  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   */
  onClose: PropTypes.func,
  /**
   * If `true`, the component is shown.
   */
  open: PropTypes.bool.isRequired,
  /**
   * Props applied to the [`Paper`](https://mui.com/material-ui/api/paper/) element.
   *
   * This prop is an alias for `slotProps.paper` and will be overridden by it if both are used.
   * @deprecated Use `slotProps.paper` instead.
   *
   * @default {}
   */
  PaperProps: PropTypes.shape({
    component: elementTypeAcceptingRef$1
  }),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: PropTypes.shape({
    backdrop: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    paper: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    transition: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: PropTypes.shape({
    backdrop: PropTypes.elementType,
    paper: PropTypes.elementType,
    root: PropTypes.elementType,
    transition: PropTypes.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * This is the point on the popover which
   * will attach to the anchor's origin.
   *
   * Options:
   * vertical: [top, center, bottom, x(px)];
   * horizontal: [left, center, right, x(px)].
   * @default {
   *   vertical: 'top',
   *   horizontal: 'left',
   * }
   */
  transformOrigin: PropTypes.shape({
    horizontal: PropTypes.oneOfType([PropTypes.oneOf(["center", "left", "right"]), PropTypes.number]).isRequired,
    vertical: PropTypes.oneOfType([PropTypes.oneOf(["bottom", "center", "top"]), PropTypes.number]).isRequired
  }),
  /**
   * The component used for the transition.
   * [Follow this guide](https://mui.com/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @deprecated use the `slots.transition` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default Grow
   */
  TransitionComponent: PropTypes.elementType,
  /**
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default 'auto'
   */
  transitionDuration: PropTypes.oneOfType([PropTypes.oneOf(["auto"]), PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @deprecated use the `slotProps.transition` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default {}
   */
  TransitionProps: PropTypes.object
});
function getMenuUtilityClass(e) {
  return generateUtilityClass("MuiMenu", e);
}
generateUtilityClasses("MuiMenu", ["root", "paper", "list"]);
const RTL_ORIGIN = {
  vertical: "top",
  horizontal: "right"
}, LTR_ORIGIN = {
  vertical: "top",
  horizontal: "left"
}, useUtilityClasses$x = (e) => {
  const {
    classes: t
  } = e;
  return composeClasses({
    root: ["root"],
    paper: ["paper"],
    list: ["list"]
  }, getMenuUtilityClass, t);
}, MenuRoot = styled(Popover, {
  shouldForwardProp: (e) => rootShouldForwardProp(e) || e === "classes",
  name: "MuiMenu",
  slot: "Root"
})({}), MenuPaper = styled(PopoverPaper, {
  name: "MuiMenu",
  slot: "Paper"
})({
  // specZ: The maximum height of a simple menu should be one or more rows less than the view
  // height. This ensures a tappable area outside of the simple menu with which to dismiss
  // the menu.
  maxHeight: "calc(100% - 96px)",
  // Add iOS momentum scrolling for iOS < 13.0
  WebkitOverflowScrolling: "touch"
}), MenuMenuList = styled(MenuList, {
  name: "MuiMenu",
  slot: "List"
})({
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
}), Menu = /* @__PURE__ */ React.forwardRef(function e(t, o) {
  const n = useDefaultProps({
    props: t,
    name: "MuiMenu"
  }), {
    autoFocus: s = !0,
    children: i,
    className: l,
    disableAutoFocusItem: d = !1,
    MenuListProps: u = {},
    onClose: c,
    open: p,
    PaperProps: f = {},
    PopoverClasses: g,
    transitionDuration: y = "auto",
    TransitionProps: {
      onEntering: h,
      ...T
    } = {},
    variant: P = "selectedMenu",
    slots: E = {},
    slotProps: $ = {},
    ...R
  } = n, C = useRtl(), x = {
    ...n,
    autoFocus: s,
    disableAutoFocusItem: d,
    MenuListProps: u,
    onEntering: h,
    PaperProps: f,
    transitionDuration: y,
    TransitionProps: T,
    variant: P
  }, _ = useUtilityClasses$x(x), D = s && !d && p, O = React.useRef(null), v = (V, j) => {
    O.current && O.current.adjustStyleForScrollbar(V, {
      direction: C ? "rtl" : "ltr"
    }), h && h(V, j);
  }, w = (V) => {
    V.key === "Tab" && (V.preventDefault(), c && c(V, "tabKeyDown"));
  };
  let M = -1;
  React.Children.map(i, (V, j) => {
    /* @__PURE__ */ React.isValidElement(V) && (process.env.NODE_ENV !== "production" && reactIsExports.isFragment(V) && console.error(["MUI: The Menu component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`)), V.props.disabled || (P === "selectedMenu" && V.props.selected || M === -1) && (M = j));
  });
  const S = {
    slots: E,
    slotProps: {
      list: u,
      transition: T,
      paper: f,
      ...$
    }
  }, I = useSlotProps({
    elementType: E.root,
    externalSlotProps: $.root,
    ownerState: x,
    className: [_.root, l]
  }), [N, F] = useSlot("paper", {
    className: _.paper,
    elementType: MenuPaper,
    externalForwardedProps: S,
    shouldForwardComponentProp: !0,
    ownerState: x
  }), [L, k] = useSlot("list", {
    className: clsx(_.list, u.className),
    elementType: MenuMenuList,
    shouldForwardComponentProp: !0,
    externalForwardedProps: S,
    getSlotProps: (V) => ({
      ...V,
      onKeyDown: (j) => {
        w(j), V.onKeyDown?.(j);
      }
    }),
    ownerState: x
  }), W = typeof S.slotProps.transition == "function" ? S.slotProps.transition(x) : S.slotProps.transition;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(MenuRoot, {
    onClose: c,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: C ? "right" : "left"
    },
    transformOrigin: C ? RTL_ORIGIN : LTR_ORIGIN,
    slots: {
      root: E.root,
      paper: N,
      backdrop: E.backdrop,
      ...E.transition && {
        // TODO: pass `slots.transition` directly once `TransitionComponent` is removed from Popover
        transition: E.transition
      }
    },
    slotProps: {
      root: I,
      paper: F,
      backdrop: typeof $.backdrop == "function" ? $.backdrop(x) : $.backdrop,
      transition: {
        ...W,
        onEntering: (...V) => {
          v(...V), W?.onEntering?.(...V);
        }
      }
    },
    open: p,
    ref: o,
    transitionDuration: y,
    ownerState: x,
    ...R,
    classes: g,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(L, {
      actions: O,
      autoFocus: s && (M === -1 || d),
      autoFocusItem: D,
      variant: P,
      ...k,
      children: i
    })
  });
});
process.env.NODE_ENV !== "production" && (Menu.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * An HTML element, or a function that returns one.
   * It's used to set the position of the menu.
   */
  anchorEl: PropTypes.oneOfType([HTMLElementType, PropTypes.func]),
  /**
   * If `true` (Default) will focus the `[role="menu"]` if no focusable child is found. Disabled
   * children are not focusable. If you set this prop to `false` focus will be placed
   * on the parent modal container. This has severe accessibility implications
   * and should only be considered if you manage focus otherwise.
   * @default true
   */
  autoFocus: PropTypes.bool,
  /**
   * Menu contents, normally `MenuItem`s.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * When opening the menu will not focus the active item but the `[role="menu"]`
   * unless `autoFocus` is also set to `false`. Not using the default means not
   * following WAI-ARIA authoring practices. Please be considerate about possible
   * accessibility implications.
   * @default false
   */
  disableAutoFocusItem: PropTypes.bool,
  /**
   * Props applied to the [`MenuList`](https://mui.com/material-ui/api/menu-list/) element.
   * @deprecated use the `slotProps.list` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default {}
   */
  MenuListProps: PropTypes.object,
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`, `"tabKeyDown"`.
   */
  onClose: PropTypes.func,
  /**
   * If `true`, the component is shown.
   */
  open: PropTypes.bool.isRequired,
  /**
   * @ignore
   */
  PaperProps: PropTypes.object,
  /**
   * `classes` prop applied to the [`Popover`](https://mui.com/material-ui/api/popover/) element.
   */
  PopoverClasses: PropTypes.object,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: PropTypes.shape({
    backdrop: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    list: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    paper: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    transition: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: PropTypes.shape({
    backdrop: PropTypes.elementType,
    list: PropTypes.elementType,
    paper: PropTypes.elementType,
    root: PropTypes.elementType,
    transition: PropTypes.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The length of the transition in `ms`, or 'auto'
   * @default 'auto'
   */
  transitionDuration: PropTypes.oneOfType([PropTypes.oneOf(["auto"]), PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @deprecated use the `slotProps.transition` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default {}
   */
  TransitionProps: PropTypes.object,
  /**
   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus.
   * @default 'selectedMenu'
   */
  variant: PropTypes.oneOf(["menu", "selectedMenu"])
});
function getNativeSelectUtilityClasses(e) {
  return generateUtilityClass("MuiNativeSelect", e);
}
const nativeSelectClasses = generateUtilityClasses("MuiNativeSelect", ["root", "select", "multiple", "filled", "outlined", "standard", "disabled", "icon", "iconOpen", "iconFilled", "iconOutlined", "iconStandard", "nativeInput", "error"]), useUtilityClasses$w = (e) => {
  const {
    classes: t,
    variant: o,
    disabled: n,
    multiple: s,
    open: i,
    error: l
  } = e, d = {
    select: ["select", o, n && "disabled", s && "multiple", l && "error"],
    icon: ["icon", `icon${capitalize(o)}`, i && "iconOpen", n && "disabled"]
  };
  return composeClasses(d, getNativeSelectUtilityClasses, t);
}, StyledSelectSelect = styled("select", {
  name: "MuiNativeSelect"
})(({
  theme: e
}) => ({
  // Reset
  MozAppearance: "none",
  // Reset
  WebkitAppearance: "none",
  // When interacting quickly, the text can end up selected.
  // Native select can't be selected either.
  userSelect: "none",
  // Reset
  borderRadius: 0,
  cursor: "pointer",
  "&:focus": {
    // Reset Chrome style
    borderRadius: 0
  },
  [`&.${nativeSelectClasses.disabled}`]: {
    cursor: "default"
  },
  "&[multiple]": {
    height: "auto"
  },
  "&:not([multiple]) option, &:not([multiple]) optgroup": {
    backgroundColor: (e.vars || e).palette.background.paper
  },
  variants: [{
    props: ({
      ownerState: t
    }) => t.variant !== "filled" && t.variant !== "outlined",
    style: {
      // Bump specificity to allow extending custom inputs
      "&&&": {
        paddingRight: 24,
        minWidth: 16
        // So it doesn't collapse.
      }
    }
  }, {
    props: {
      variant: "filled"
    },
    style: {
      "&&&": {
        paddingRight: 32
      }
    }
  }, {
    props: {
      variant: "outlined"
    },
    style: {
      borderRadius: (e.vars || e).shape.borderRadius,
      "&:focus": {
        borderRadius: (e.vars || e).shape.borderRadius
        // Reset the reset for Chrome style
      },
      "&&&": {
        paddingRight: 32
      }
    }
  }]
})), NativeSelectSelect = styled(StyledSelectSelect, {
  name: "MuiNativeSelect",
  slot: "Select",
  shouldForwardProp: rootShouldForwardProp,
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.select, t[o.variant], o.error && t.error, {
      [`&.${nativeSelectClasses.multiple}`]: t.multiple
    }];
  }
})({}), StyledSelectIcon = styled("svg", {
  name: "MuiNativeSelect"
})(({
  theme: e
}) => ({
  // We use a position absolute over a flexbox in order to forward the pointer events
  // to the input and to support wrapping tags..
  position: "absolute",
  right: 0,
  // Center vertically, height is 1em
  top: "calc(50% - .5em)",
  // Don't block pointer events on the select under the icon.
  pointerEvents: "none",
  color: (e.vars || e).palette.action.active,
  [`&.${nativeSelectClasses.disabled}`]: {
    color: (e.vars || e).palette.action.disabled
  },
  variants: [{
    props: ({
      ownerState: t
    }) => t.open,
    style: {
      transform: "rotate(180deg)"
    }
  }, {
    props: {
      variant: "filled"
    },
    style: {
      right: 7
    }
  }, {
    props: {
      variant: "outlined"
    },
    style: {
      right: 7
    }
  }]
})), NativeSelectIcon = styled(StyledSelectIcon, {
  name: "MuiNativeSelect",
  slot: "Icon",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.icon, o.variant && t[`icon${capitalize(o.variant)}`], o.open && t.iconOpen];
  }
})({}), NativeSelectInput = /* @__PURE__ */ React.forwardRef(function e(t, o) {
  const {
    className: n,
    disabled: s,
    error: i,
    IconComponent: l,
    inputRef: d,
    variant: u = "standard",
    ...c
  } = t, p = {
    ...t,
    disabled: s,
    variant: u,
    error: i
  }, f = useUtilityClasses$w(p);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(React.Fragment, {
    children: [/* @__PURE__ */ jsxRuntimeExports.jsx(NativeSelectSelect, {
      ownerState: p,
      className: clsx(f.select, n),
      disabled: s,
      ref: d || o,
      ...c
    }), t.multiple ? null : /* @__PURE__ */ jsxRuntimeExports.jsx(NativeSelectIcon, {
      as: l,
      ownerState: p,
      className: f.icon
    })]
  });
});
process.env.NODE_ENV !== "production" && (NativeSelectInput.propTypes = {
  /**
   * The option elements to populate the select with.
   * Can be some `<option>` elements.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * The CSS class name of the select element.
   */
  className: PropTypes.string,
  /**
   * If `true`, the select is disabled.
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the `select input` will indicate an error.
   */
  error: PropTypes.bool,
  /**
   * The icon that displays the arrow.
   */
  IconComponent: PropTypes.elementType.isRequired,
  /**
   * Use that prop to pass a ref to the native select element.
   * @deprecated
   */
  inputRef: refType,
  /**
   * @ignore
   */
  multiple: PropTypes.bool,
  /**
   * Name attribute of the `select` or hidden `input` element.
   */
  name: PropTypes.string,
  /**
   * Callback fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: PropTypes.func,
  /**
   * The input value.
   */
  value: PropTypes.any,
  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(["standard", "outlined", "filled"])
});
function getSelectUtilityClasses(e) {
  return generateUtilityClass("MuiSelect", e);
}
const selectClasses = generateUtilityClasses("MuiSelect", ["root", "select", "multiple", "filled", "outlined", "standard", "disabled", "focused", "icon", "iconOpen", "iconFilled", "iconOutlined", "iconStandard", "nativeInput", "error"]);
var _span$1;
const SelectSelect = styled(StyledSelectSelect, {
  name: "MuiSelect",
  slot: "Select",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [
      // Win specificity over the input base
      {
        [`&.${selectClasses.select}`]: t.select
      },
      {
        [`&.${selectClasses.select}`]: t[o.variant]
      },
      {
        [`&.${selectClasses.error}`]: t.error
      },
      {
        [`&.${selectClasses.multiple}`]: t.multiple
      }
    ];
  }
})({
  // Win specificity over the input base
  [`&.${selectClasses.select}`]: {
    height: "auto",
    // Resets for multiple select with chips
    minHeight: "1.4375em",
    // Required for select\text-field height consistency
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden"
  }
}), SelectIcon = styled(StyledSelectIcon, {
  name: "MuiSelect",
  slot: "Icon",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.icon, o.variant && t[`icon${capitalize(o.variant)}`], o.open && t.iconOpen];
  }
})({}), SelectNativeInput = styled("input", {
  shouldForwardProp: (e) => slotShouldForwardProp(e) && e !== "classes",
  name: "MuiSelect",
  slot: "NativeInput"
})({
  bottom: 0,
  left: 0,
  position: "absolute",
  opacity: 0,
  pointerEvents: "none",
  width: "100%",
  boxSizing: "border-box"
});
function areEqualValues(e, t) {
  return typeof t == "object" && t !== null ? e === t : String(e) === String(t);
}
function isEmpty(e) {
  return e == null || typeof e == "string" && !e.trim();
}
const useUtilityClasses$v = (e) => {
  const {
    classes: t,
    variant: o,
    disabled: n,
    multiple: s,
    open: i,
    error: l
  } = e, d = {
    select: ["select", o, n && "disabled", s && "multiple", l && "error"],
    icon: ["icon", `icon${capitalize(o)}`, i && "iconOpen", n && "disabled"],
    nativeInput: ["nativeInput"]
  };
  return composeClasses(d, getSelectUtilityClasses, t);
}, SelectInput = /* @__PURE__ */ React.forwardRef(function e(t, o) {
  const {
    "aria-describedby": n,
    "aria-label": s,
    autoFocus: i,
    autoWidth: l,
    children: d,
    className: u,
    defaultOpen: c,
    defaultValue: p,
    disabled: f,
    displayEmpty: g,
    error: y = !1,
    IconComponent: h,
    inputRef: T,
    labelId: P,
    MenuProps: E = {},
    multiple: $,
    name: R,
    onBlur: C,
    onChange: x,
    onClose: _,
    onFocus: D,
    onOpen: O,
    open: v,
    readOnly: w,
    renderValue: M,
    required: S,
    SelectDisplayProps: I = {},
    tabIndex: N,
    // catching `type` from Input which makes no sense for SelectInput
    type: F,
    value: L,
    variant: k = "standard",
    ...W
  } = t, [V, j] = useControlled({
    controlled: L,
    default: p,
    name: "Select"
  }), [A, U] = useControlled({
    controlled: v,
    default: c,
    name: "Select"
  }), G = React.useRef(null), Y = React.useRef(null), [ee, J] = React.useState(null), {
    current: Z
  } = React.useRef(v != null), [le, se] = React.useState(), K = useForkRef(o, T), q = React.useCallback((oe) => {
    Y.current = oe, oe && J(oe);
  }, []), B = ee?.parentNode;
  React.useImperativeHandle(K, () => ({
    focus: () => {
      Y.current.focus();
    },
    node: G.current,
    value: V
  }), [V]), React.useEffect(() => {
    c && A && ee && !Z && (se(l ? null : B.clientWidth), Y.current.focus());
  }, [ee, l]), React.useEffect(() => {
    i && Y.current.focus();
  }, [i]), React.useEffect(() => {
    if (!P)
      return;
    const oe = ownerDocument(Y.current).getElementById(P);
    if (oe) {
      const ae = () => {
        getSelection().isCollapsed && Y.current.focus();
      };
      return oe.addEventListener("click", ae), () => {
        oe.removeEventListener("click", ae);
      };
    }
  }, [P]);
  const ue = (oe, ae) => {
    oe ? O && O(ae) : _ && _(ae), Z || (se(l ? null : B.clientWidth), U(oe));
  }, re = (oe) => {
    oe.button === 0 && (oe.preventDefault(), Y.current.focus(), ue(!0, oe));
  }, be = (oe) => {
    ue(!1, oe);
  }, X = React.Children.toArray(d), ge = (oe) => {
    const ae = X.find((Se) => Se.props.value === oe.target.value);
    ae !== void 0 && (j(ae.props.value), x && x(oe, ae));
  }, Ee = (oe) => (ae) => {
    let Se;
    if (ae.currentTarget.hasAttribute("tabindex")) {
      if ($) {
        Se = Array.isArray(V) ? V.slice() : [];
        const $e = V.indexOf(oe.props.value);
        $e === -1 ? Se.push(oe.props.value) : Se.splice($e, 1);
      } else
        Se = oe.props.value;
      if (oe.props.onClick && oe.props.onClick(ae), V !== Se && (j(Se), x)) {
        const $e = ae.nativeEvent || ae, Re = new $e.constructor($e.type, $e);
        Object.defineProperty(Re, "target", {
          writable: !0,
          value: {
            value: Se,
            name: R
          }
        }), x(Re, oe);
      }
      $ || ue(!1, ae);
    }
  }, xe = (oe) => {
    w || [
      " ",
      "ArrowUp",
      "ArrowDown",
      // The native select doesn't respond to enter on macOS, but it's recommended by
      // https://www.w3.org/WAI/ARIA/apg/patterns/combobox/examples/combobox-select-only/
      "Enter"
    ].includes(oe.key) && (oe.preventDefault(), ue(!0, oe));
  }, he = ee !== null && A, Pe = (oe) => {
    !he && C && (Object.defineProperty(oe, "target", {
      writable: !0,
      value: {
        value: V,
        name: R
      }
    }), C(oe));
  };
  delete W["aria-invalid"];
  let ye, _e;
  const Ce = [];
  let ne = !1, H = !1;
  (isFilled({
    value: V
  }) || g) && (M ? ye = M(V) : ne = !0);
  const te = X.map((oe) => {
    if (!/* @__PURE__ */ React.isValidElement(oe))
      return null;
    process.env.NODE_ENV !== "production" && reactIsExports.isFragment(oe) && console.error(["MUI: The Select component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`));
    let ae;
    if ($) {
      if (!Array.isArray(V))
        throw new Error(process.env.NODE_ENV !== "production" ? "MUI: The `value` prop must be an array when using the `Select` component with `multiple`." : formatMuiErrorMessage(2));
      ae = V.some((Se) => areEqualValues(Se, oe.props.value)), ae && ne && Ce.push(oe.props.children);
    } else
      ae = areEqualValues(V, oe.props.value), ae && ne && (_e = oe.props.children);
    return ae && (H = !0), /* @__PURE__ */ React.cloneElement(oe, {
      "aria-selected": ae ? "true" : "false",
      onClick: Ee(oe),
      onKeyUp: (Se) => {
        Se.key === " " && Se.preventDefault(), oe.props.onKeyUp && oe.props.onKeyUp(Se);
      },
      role: "option",
      selected: ae,
      value: void 0,
      // The value is most likely not a valid HTML attribute.
      "data-value": oe.props.value
      // Instead, we provide it as a data attribute.
    });
  });
  process.env.NODE_ENV !== "production" && React.useEffect(() => {
    if (!H && !$ && V !== "") {
      const oe = X.map((ae) => ae.props.value);
      console.warn([`MUI: You have provided an out-of-range value \`${V}\` for the select ${R ? `(name="${R}") ` : ""}component.`, "Consider providing a value that matches one of the available options or ''.", `The available values are ${oe.filter((ae) => ae != null).map((ae) => `\`${ae}\``).join(", ") || '""'}.`].join(`
`));
    }
  }, [H, X, $, R, V]), ne && ($ ? Ce.length === 0 ? ye = null : ye = Ce.reduce((oe, ae, Se) => (oe.push(ae), Se < Ce.length - 1 && oe.push(", "), oe), []) : ye = _e);
  let ie = le;
  !l && Z && ee && (ie = B.clientWidth);
  let ce;
  typeof N < "u" ? ce = N : ce = f ? null : 0;
  const me = I.id || (R ? `mui-component-select-${R}` : void 0), pe = {
    ...t,
    variant: k,
    value: V,
    open: he,
    error: y
  }, z = useUtilityClasses$v(pe), Q = {
    ...E.PaperProps,
    ...typeof E.slotProps?.paper == "function" ? E.slotProps.paper(pe) : E.slotProps?.paper
  }, Te = {
    ...E.MenuListProps,
    ...typeof E.slotProps?.list == "function" ? E.slotProps.list(pe) : E.slotProps?.list
  }, fe = useId();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(React.Fragment, {
    children: [/* @__PURE__ */ jsxRuntimeExports.jsx(SelectSelect, {
      as: "div",
      ref: q,
      tabIndex: ce,
      role: "combobox",
      "aria-controls": he ? fe : void 0,
      "aria-disabled": f ? "true" : void 0,
      "aria-expanded": he ? "true" : "false",
      "aria-haspopup": "listbox",
      "aria-label": s,
      "aria-labelledby": [P, me].filter(Boolean).join(" ") || void 0,
      "aria-describedby": n,
      "aria-required": S ? "true" : void 0,
      "aria-invalid": y ? "true" : void 0,
      onKeyDown: xe,
      onMouseDown: f || w ? null : re,
      onBlur: Pe,
      onFocus: D,
      ...I,
      ownerState: pe,
      className: clsx(I.className, z.select, u),
      id: me,
      children: isEmpty(ye) ? (
        // notranslate needed while Google Translate will not fix zero-width space issue
        _span$1 || (_span$1 = /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
          className: "notranslate",
          "aria-hidden": !0,
          children: "​"
        }))
      ) : ye
    }), /* @__PURE__ */ jsxRuntimeExports.jsx(SelectNativeInput, {
      "aria-invalid": y,
      value: Array.isArray(V) ? V.join(",") : V,
      name: R,
      ref: G,
      "aria-hidden": !0,
      onChange: ge,
      tabIndex: -1,
      disabled: f,
      className: z.nativeInput,
      autoFocus: i,
      required: S,
      ...W,
      ownerState: pe
    }), /* @__PURE__ */ jsxRuntimeExports.jsx(SelectIcon, {
      as: h,
      className: z.icon,
      ownerState: pe
    }), /* @__PURE__ */ jsxRuntimeExports.jsx(Menu, {
      id: `menu-${R || ""}`,
      anchorEl: B,
      open: he,
      onClose: be,
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "center"
      },
      transformOrigin: {
        vertical: "top",
        horizontal: "center"
      },
      ...E,
      slotProps: {
        ...E.slotProps,
        list: {
          "aria-labelledby": P,
          role: "listbox",
          "aria-multiselectable": $ ? "true" : void 0,
          disableListWrap: !0,
          id: fe,
          ...Te
        },
        paper: {
          ...Q,
          style: {
            minWidth: ie,
            ...Q != null ? Q.style : null
          }
        }
      },
      children: te
    })]
  });
});
process.env.NODE_ENV !== "production" && (SelectInput.propTypes = {
  /**
   * @ignore
   */
  "aria-describedby": PropTypes.string,
  /**
   * @ignore
   */
  "aria-label": PropTypes.string,
  /**
   * @ignore
   */
  autoFocus: PropTypes.bool,
  /**
   * If `true`, the width of the popover will automatically be set according to the items inside the
   * menu, otherwise it will be at least the width of the select input.
   */
  autoWidth: PropTypes.bool,
  /**
   * The option elements to populate the select with.
   * Can be some `<MenuItem>` elements.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * The CSS class name of the select element.
   */
  className: PropTypes.string,
  /**
   * If `true`, the component is toggled on mount. Use when the component open state is not controlled.
   * You can only use it when the `native` prop is `false` (default).
   */
  defaultOpen: PropTypes.bool,
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,
  /**
   * If `true`, the select is disabled.
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the selected item is displayed even if its value is empty.
   */
  displayEmpty: PropTypes.bool,
  /**
   * If `true`, the `select input` will indicate an error.
   */
  error: PropTypes.bool,
  /**
   * The icon that displays the arrow.
   */
  IconComponent: PropTypes.elementType.isRequired,
  /**
   * Imperative handle implementing `{ value: T, node: HTMLElement, focus(): void }`
   * Equivalent to `ref`
   */
  inputRef: refType,
  /**
   * The ID of an element that acts as an additional label. The Select will
   * be labelled by the additional label and the selected value.
   */
  labelId: PropTypes.string,
  /**
   * Props applied to the [`Menu`](/material-ui/api/menu/) element.
   */
  MenuProps: PropTypes.object,
  /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   */
  multiple: PropTypes.bool,
  /**
   * Name attribute of the `select` or hidden `input` element.
   */
  name: PropTypes.string,
  /**
   * @ignore
   */
  onBlur: PropTypes.func,
  /**
   * Callback fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (any).
   * @param {object} [child] The react element that was selected.
   */
  onChange: PropTypes.func,
  /**
   * Callback fired when the component requests to be closed.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */
  onClose: PropTypes.func,
  /**
   * @ignore
   */
  onFocus: PropTypes.func,
  /**
   * Callback fired when the component requests to be opened.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */
  onOpen: PropTypes.func,
  /**
   * If `true`, the component is shown.
   */
  open: PropTypes.bool,
  /**
   * @ignore
   */
  readOnly: PropTypes.bool,
  /**
   * Render the selected value.
   *
   * @param {any} value The `value` provided to the component.
   * @returns {ReactNode}
   */
  renderValue: PropTypes.func,
  /**
   * If `true`, the component is required.
   */
  required: PropTypes.bool,
  /**
   * Props applied to the clickable div element.
   */
  SelectDisplayProps: PropTypes.object,
  /**
   * @ignore
   */
  tabIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * @ignore
   */
  type: PropTypes.any,
  /**
   * The input value.
   */
  value: PropTypes.any,
  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(["standard", "outlined", "filled"])
});
const ArrowDropDownIcon = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M7 10l5 5 5-5z"
}), "ArrowDropDown"), useUtilityClasses$u = (e) => {
  const {
    classes: t
  } = e, n = composeClasses({
    root: ["root"]
  }, getSelectUtilityClasses, t);
  return {
    ...t,
    ...n
  };
}, styledRootConfig = {
  name: "MuiSelect",
  slot: "Root",
  shouldForwardProp: (e) => rootShouldForwardProp(e) && e !== "variant"
}, StyledInput = styled(Input, styledRootConfig)(""), StyledOutlinedInput = styled(OutlinedInput, styledRootConfig)(""), StyledFilledInput = styled(FilledInput, styledRootConfig)(""), Select = /* @__PURE__ */ React.forwardRef(function e(t, o) {
  const n = useDefaultProps({
    name: "MuiSelect",
    props: t
  }), {
    autoWidth: s = !1,
    children: i,
    classes: l = {},
    className: d,
    defaultOpen: u = !1,
    displayEmpty: c = !1,
    IconComponent: p = ArrowDropDownIcon,
    id: f,
    input: g,
    inputProps: y,
    label: h,
    labelId: T,
    MenuProps: P,
    multiple: E = !1,
    native: $ = !1,
    onClose: R,
    onOpen: C,
    open: x,
    renderValue: _,
    SelectDisplayProps: D,
    variant: O = "outlined",
    ...v
  } = n, w = $ ? NativeSelectInput : SelectInput, M = useFormControl(), S = formControlState({
    props: n,
    muiFormControl: M,
    states: ["variant", "error"]
  }), I = S.variant || O, N = {
    ...n,
    variant: I,
    classes: l
  }, F = useUtilityClasses$u(N), {
    root: L,
    ...k
  } = F, W = g || {
    standard: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledInput, {
      ownerState: N
    }),
    outlined: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledOutlinedInput, {
      label: h,
      ownerState: N
    }),
    filled: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledFilledInput, {
      ownerState: N
    })
  }[I], V = useForkRef(o, getReactElementRef(W));
  return /* @__PURE__ */ jsxRuntimeExports.jsx(React.Fragment, {
    children: /* @__PURE__ */ React.cloneElement(W, {
      // Most of the logic is implemented in `SelectInput`.
      // The `Select` component is a simple API wrapper to expose something better to play with.
      inputComponent: w,
      inputProps: {
        children: i,
        error: S.error,
        IconComponent: p,
        variant: I,
        type: void 0,
        // We render a select. We can ignore the type provided by the `Input`.
        multiple: E,
        ...$ ? {
          id: f
        } : {
          autoWidth: s,
          defaultOpen: u,
          displayEmpty: c,
          labelId: T,
          MenuProps: P,
          onClose: R,
          onOpen: C,
          open: x,
          renderValue: _,
          SelectDisplayProps: {
            id: f,
            ...D
          }
        },
        ...y,
        classes: y ? deepmerge(k, y.classes) : k,
        ...g ? g.props.inputProps : {}
      },
      ...(E && $ || c) && I === "outlined" ? {
        notched: !0
      } : {},
      ref: V,
      className: clsx(W.props.className, d, F.root),
      // If a custom input is provided via 'input' prop, do not allow 'variant' to be propagated to it's root element. See https://github.com/mui/material-ui/issues/33894.
      ...!g && {
        variant: I
      },
      ...v
    })
  });
});
process.env.NODE_ENV !== "production" && (Select.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the width of the popover will automatically be set according to the items inside the
   * menu, otherwise it will be at least the width of the select input.
   * @default false
   */
  autoWidth: PropTypes.bool,
  /**
   * The option elements to populate the select with.
   * Can be some `MenuItem` when `native` is false and `option` when `native` is true.
   *
   * ⚠️The `MenuItem` elements **must** be direct descendants when `native` is false.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   * @default {}
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * If `true`, the component is initially open. Use when the component open state is not controlled (i.e. the `open` prop is not defined).
   * You can only use it when the `native` prop is `false` (default).
   * @default false
   */
  defaultOpen: PropTypes.bool,
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,
  /**
   * If `true`, a value is displayed even if no items are selected.
   *
   * In order to display a meaningful value, a function can be passed to the `renderValue` prop which
   * returns the value to be displayed when no items are selected.
   *
   * ⚠️ When using this prop, make sure the label doesn't overlap with the empty displayed value.
   * The label should either be hidden or forced to a shrunk state.
   * @default false
   */
  displayEmpty: PropTypes.bool,
  /**
   * The icon that displays the arrow.
   * @default ArrowDropDownIcon
   */
  IconComponent: PropTypes.elementType,
  /**
   * The `id` of the wrapper element or the `select` element when `native`.
   */
  id: PropTypes.string,
  /**
   * An `Input` element; does not have to be a material-ui specific `Input`.
   */
  input: PropTypes.element,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#attributes) applied to the `input` element.
   * When `native` is `true`, the attributes are applied on the `select` element.
   */
  inputProps: PropTypes.object,
  /**
   * See [OutlinedInput#label](https://mui.com/material-ui/api/outlined-input/#props)
   */
  label: PropTypes.node,
  /**
   * The ID of an element that acts as an additional label. The Select will
   * be labelled by the additional label and the selected value.
   */
  labelId: PropTypes.string,
  /**
   * Props applied to the [`Menu`](https://mui.com/material-ui/api/menu/) element.
   */
  MenuProps: PropTypes.object,
  /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   * @default false
   */
  multiple: PropTypes.bool,
  /**
   * If `true`, the component uses a native `select` element.
   * @default false
   */
  native: PropTypes.bool,
  /**
   * Callback fired when a menu item is selected.
   *
   * @param {SelectChangeEvent<Value>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (any).
   * **Warning**: This is a generic event, not a change event, unless the change event is caused by browser autofill.
   * @param {object} [child] The react element that was selected when `native` is `false` (default).
   */
  onChange: PropTypes.func,
  /**
   * Callback fired when the component requests to be closed.
   * Use it in either controlled (see the `open` prop), or uncontrolled mode (to detect when the Select collapses).
   *
   * @param {object} event The event source of the callback.
   */
  onClose: PropTypes.func,
  /**
   * Callback fired when the component requests to be opened.
   * Use it in either controlled (see the `open` prop), or uncontrolled mode (to detect when the Select expands).
   *
   * @param {object} event The event source of the callback.
   */
  onOpen: PropTypes.func,
  /**
   * If `true`, the component is shown.
   * You can only use it when the `native` prop is `false` (default).
   */
  open: PropTypes.bool,
  /**
   * Render the selected value.
   * You can only use it when the `native` prop is `false` (default).
   *
   * @param {any} value The `value` provided to the component.
   * @returns {ReactNode}
   */
  renderValue: PropTypes.func,
  /**
   * Props applied to the clickable div element.
   */
  SelectDisplayProps: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The `input` value. Providing an empty string will select no options.
   * Set to an empty string `''` if you don't want any of the available options to be selected.
   *
   * If the value is an object it must have reference equality with the option in order to be selected.
   * If the value is not an object, the string representation must match with the string representation of the option in order to be selected.
   */
  value: PropTypes.oneOfType([PropTypes.oneOf([""]), PropTypes.any]),
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: PropTypes.oneOf(["filled", "outlined", "standard"])
});
Select.muiName = "Select";
function getTextFieldUtilityClass(e) {
  return generateUtilityClass("MuiTextField", e);
}
generateUtilityClasses("MuiTextField", ["root"]);
const variantComponent = {
  standard: Input,
  filled: FilledInput,
  outlined: OutlinedInput
}, useUtilityClasses$t = (e) => {
  const {
    classes: t
  } = e;
  return composeClasses({
    root: ["root"]
  }, getTextFieldUtilityClass, t);
}, TextFieldRoot = styled(FormControl, {
  name: "MuiTextField",
  slot: "Root"
})({}), TextField = /* @__PURE__ */ React.forwardRef(function e(t, o) {
  const n = useDefaultProps({
    props: t,
    name: "MuiTextField"
  }), {
    autoComplete: s,
    autoFocus: i = !1,
    children: l,
    className: d,
    color: u = "primary",
    defaultValue: c,
    disabled: p = !1,
    error: f = !1,
    FormHelperTextProps: g,
    fullWidth: y = !1,
    helperText: h,
    id: T,
    InputLabelProps: P,
    inputProps: E,
    InputProps: $,
    inputRef: R,
    label: C,
    maxRows: x,
    minRows: _,
    multiline: D = !1,
    name: O,
    onBlur: v,
    onChange: w,
    onFocus: M,
    placeholder: S,
    required: I = !1,
    rows: N,
    select: F = !1,
    SelectProps: L,
    slots: k = {},
    slotProps: W = {},
    type: V,
    value: j,
    variant: A = "outlined",
    ...U
  } = n, G = {
    ...n,
    autoFocus: i,
    color: u,
    disabled: p,
    error: f,
    fullWidth: y,
    multiline: D,
    required: I,
    select: F,
    variant: A
  }, Y = useUtilityClasses$t(G);
  process.env.NODE_ENV !== "production" && F && !l && console.error("MUI: `children` must be passed when using the `TextField` component with `select`.");
  const ee = useId(T), J = h && ee ? `${ee}-helper-text` : void 0, Z = C && ee ? `${ee}-label` : void 0, le = variantComponent[A], se = {
    slots: k,
    slotProps: {
      input: $,
      inputLabel: P,
      htmlInput: E,
      formHelperText: g,
      select: L,
      ...W
    }
  }, K = {}, q = se.slotProps.inputLabel;
  A === "outlined" && (q && typeof q.shrink < "u" && (K.notched = q.shrink), K.label = C), F && ((!L || !L.native) && (K.id = void 0), K["aria-describedby"] = void 0);
  const [B, ue] = useSlot("root", {
    elementType: TextFieldRoot,
    shouldForwardComponentProp: !0,
    externalForwardedProps: {
      ...se,
      ...U
    },
    ownerState: G,
    className: clsx(Y.root, d),
    ref: o,
    additionalProps: {
      disabled: p,
      error: f,
      fullWidth: y,
      required: I,
      color: u,
      variant: A
    }
  }), [re, be] = useSlot("input", {
    elementType: le,
    externalForwardedProps: se,
    additionalProps: K,
    ownerState: G
  }), [X, ge] = useSlot("inputLabel", {
    elementType: InputLabel,
    externalForwardedProps: se,
    ownerState: G
  }), [Ee, xe] = useSlot("htmlInput", {
    elementType: "input",
    externalForwardedProps: se,
    ownerState: G
  }), [he, Pe] = useSlot("formHelperText", {
    elementType: FormHelperText,
    externalForwardedProps: se,
    ownerState: G
  }), [ye, _e] = useSlot("select", {
    elementType: Select,
    externalForwardedProps: se,
    ownerState: G
  }), Ce = /* @__PURE__ */ jsxRuntimeExports.jsx(re, {
    "aria-describedby": J,
    autoComplete: s,
    autoFocus: i,
    defaultValue: c,
    fullWidth: y,
    multiline: D,
    name: O,
    rows: N,
    maxRows: x,
    minRows: _,
    type: V,
    value: j,
    id: ee,
    inputRef: R,
    onBlur: v,
    onChange: w,
    onFocus: M,
    placeholder: S,
    inputProps: xe,
    slots: {
      input: k.htmlInput ? Ee : void 0
    },
    ...be
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(B, {
    ...ue,
    children: [C != null && C !== "" && /* @__PURE__ */ jsxRuntimeExports.jsx(X, {
      htmlFor: ee,
      id: Z,
      ...ge,
      children: C
    }), F ? /* @__PURE__ */ jsxRuntimeExports.jsx(ye, {
      "aria-describedby": J,
      id: ee,
      labelId: Z,
      value: j,
      input: Ce,
      ..._e,
      children: l
    }) : Ce, h && /* @__PURE__ */ jsxRuntimeExports.jsx(he, {
      id: J,
      ...Pe,
      children: h
    })]
  });
});
process.env.NODE_ENV !== "production" && (TextField.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: PropTypes.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   * @default false
   */
  autoFocus: PropTypes.bool,
  /**
   * @ignore
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["primary", "secondary", "error", "info", "success", "warning"]), PropTypes.string]),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the label is displayed in an error state.
   * @default false
   */
  error: PropTypes.bool,
  /**
   * Props applied to the [`FormHelperText`](https://mui.com/material-ui/api/form-helper-text/) element.
   * @deprecated Use `slotProps.formHelperText` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  FormHelperTextProps: PropTypes.object,
  /**
   * If `true`, the input will take up the full width of its container.
   * @default false
   */
  fullWidth: PropTypes.bool,
  /**
   * The helper text content.
   */
  helperText: PropTypes.node,
  /**
   * The id of the `input` element.
   * Use this prop to make `label` and `helperText` accessible for screen readers.
   */
  id: PropTypes.string,
  /**
   * Props applied to the [`InputLabel`](https://mui.com/material-ui/api/input-label/) element.
   * Pointer events like `onClick` are enabled if and only if `shrink` is `true`.
   * @deprecated Use `slotProps.inputLabel` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  InputLabelProps: PropTypes.object,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#attributes) applied to the `input` element.
   * @deprecated Use `slotProps.htmlInput` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  inputProps: PropTypes.object,
  /**
   * Props applied to the Input element.
   * It will be a [`FilledInput`](https://mui.com/material-ui/api/filled-input/),
   * [`OutlinedInput`](https://mui.com/material-ui/api/outlined-input/) or [`Input`](https://mui.com/material-ui/api/input/)
   * component depending on the `variant` prop value.
   * @deprecated Use `slotProps.input` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  InputProps: PropTypes.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType,
  /**
   * The label content.
   */
  label: PropTypes.node,
  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   * @default 'none'
   */
  margin: PropTypes.oneOf(["dense", "none", "normal"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * If `true`, a `textarea` element is rendered instead of an input.
   * @default false
   */
  multiline: PropTypes.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: PropTypes.string,
  /**
   * @ignore
   */
  onBlur: PropTypes.func,
  /**
   * Callback fired when the value is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: PropTypes.func,
  /**
   * @ignore
   */
  onFocus: PropTypes.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: PropTypes.string,
  /**
   * If `true`, the label is displayed as required and the `input` element is required.
   * @default false
   */
  required: PropTypes.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * Render a [`Select`](https://mui.com/material-ui/api/select/) element while passing the Input element to `Select` as `input` parameter.
   * If this option is set you must pass the options of the select as children.
   * @default false
   */
  select: PropTypes.bool,
  /**
   * Props applied to the [`Select`](https://mui.com/material-ui/api/select/) element.
   * @deprecated Use `slotProps.select` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  SelectProps: PropTypes.object,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: PropTypes.oneOfType([PropTypes.oneOf(["medium", "small"]), PropTypes.string]),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: PropTypes.shape({
    formHelperText: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    htmlInput: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    input: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    inputLabel: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    select: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: PropTypes.shape({
    formHelperText: PropTypes.elementType,
    htmlInput: PropTypes.elementType,
    input: PropTypes.elementType,
    inputLabel: PropTypes.elementType,
    root: PropTypes.elementType,
    select: PropTypes.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#input_types).
   */
  type: PropTypes.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: PropTypes.any,
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: PropTypes.oneOf(["filled", "outlined", "standard"])
});
function getInputAdornmentUtilityClass(e) {
  return generateUtilityClass("MuiInputAdornment", e);
}
const inputAdornmentClasses = generateUtilityClasses("MuiInputAdornment", ["root", "filled", "standard", "outlined", "positionStart", "positionEnd", "disablePointerEvents", "hiddenLabel", "sizeSmall"]);
var _span;
const overridesResolver$1 = (e, t) => {
  const {
    ownerState: o
  } = e;
  return [t.root, t[`position${capitalize(o.position)}`], o.disablePointerEvents === !0 && t.disablePointerEvents, t[o.variant]];
}, useUtilityClasses$s = (e) => {
  const {
    classes: t,
    disablePointerEvents: o,
    hiddenLabel: n,
    position: s,
    size: i,
    variant: l
  } = e, d = {
    root: ["root", o && "disablePointerEvents", s && `position${capitalize(s)}`, l, n && "hiddenLabel", i && `size${capitalize(i)}`]
  };
  return composeClasses(d, getInputAdornmentUtilityClass, t);
}, InputAdornmentRoot = styled("div", {
  name: "MuiInputAdornment",
  slot: "Root",
  overridesResolver: overridesResolver$1
})(memoTheme(({
  theme: e
}) => ({
  display: "flex",
  maxHeight: "2em",
  alignItems: "center",
  whiteSpace: "nowrap",
  color: (e.vars || e).palette.action.active,
  variants: [{
    props: {
      variant: "filled"
    },
    style: {
      [`&.${inputAdornmentClasses.positionStart}&:not(.${inputAdornmentClasses.hiddenLabel})`]: {
        marginTop: 16
      }
    }
  }, {
    props: {
      position: "start"
    },
    style: {
      marginRight: 8
    }
  }, {
    props: {
      position: "end"
    },
    style: {
      marginLeft: 8
    }
  }, {
    props: {
      disablePointerEvents: !0
    },
    style: {
      pointerEvents: "none"
    }
  }]
}))), InputAdornment = /* @__PURE__ */ React.forwardRef(function e(t, o) {
  const n = useDefaultProps({
    props: t,
    name: "MuiInputAdornment"
  }), {
    children: s,
    className: i,
    component: l = "div",
    disablePointerEvents: d = !1,
    disableTypography: u = !1,
    position: c,
    variant: p,
    ...f
  } = n, g = useFormControl() || {};
  let y = p;
  p && g.variant && process.env.NODE_ENV !== "production" && p === g.variant && console.error("MUI: The `InputAdornment` variant infers the variant prop you do not have to provide one."), g && !y && (y = g.variant);
  const h = {
    ...n,
    hiddenLabel: g.hiddenLabel,
    size: g.size,
    disablePointerEvents: d,
    position: c,
    variant: y
  }, T = useUtilityClasses$s(h);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(FormControlContext.Provider, {
    value: null,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(InputAdornmentRoot, {
      as: l,
      ownerState: h,
      className: clsx(T.root, i),
      ref: o,
      ...f,
      children: typeof s == "string" && !u ? /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, {
        color: "textSecondary",
        children: s
      }) : /* @__PURE__ */ jsxRuntimeExports.jsxs(React.Fragment, {
        children: [c === "start" ? (
          /* notranslate needed while Google Translate will not fix zero-width space issue */
          _span || (_span = /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
            className: "notranslate",
            "aria-hidden": !0,
            children: "​"
          }))
        ) : null, s]
      })
    })
  });
});
process.env.NODE_ENV !== "production" && (InputAdornment.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component, normally an `IconButton` or string.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * Disable pointer events on the root.
   * This allows for the content of the adornment to focus the `input` on click.
   * @default false
   */
  disablePointerEvents: PropTypes.bool,
  /**
   * If children is a string then disable wrapping in a Typography component.
   * @default false
   */
  disableTypography: PropTypes.bool,
  /**
   * The position this adornment should appear relative to the `Input`.
   */
  position: PropTypes.oneOf(["end", "start"]).isRequired,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The variant to use.
   * Note: If you are using the `TextField` component or the `FormControl` component
   * you do not have to set this manually.
   */
  variant: PropTypes.oneOf(["filled", "outlined", "standard"])
});
const major = 7;
function useFieldOwnerState(e) {
  const {
    ownerState: t
  } = usePickerPrivateContext(), o = useRtl();
  return React.useMemo(() => _extends({}, t, {
    isFieldDisabled: e.disabled ?? !1,
    isFieldReadOnly: e.readOnly ?? !1,
    isFieldRequired: e.required ?? !1,
    fieldDirection: o ? "rtl" : "ltr"
  }), [t, e.disabled, e.readOnly, e.required, o]);
}
function getPickersTextFieldUtilityClass(e) {
  return generateUtilityClass("MuiPickersTextField", e);
}
generateUtilityClasses("MuiPickersTextField", ["root", "focused", "disabled", "error", "required"]);
const visuallyHidden = {
  border: 0,
  clip: "rect(0 0 0 0)",
  height: "1px",
  margin: "-1px",
  overflow: "hidden",
  padding: 0,
  position: "absolute",
  whiteSpace: "nowrap",
  width: "1px"
};
function getPickersInputBaseUtilityClass(e) {
  return generateUtilityClass("MuiPickersInputBase", e);
}
const pickersInputBaseClasses = generateUtilityClasses("MuiPickersInputBase", ["root", "focused", "disabled", "error", "notchedOutline", "sectionContent", "sectionBefore", "sectionAfter", "adornedStart", "adornedEnd", "input", "inputSizeSmall", "activeBar"]);
function getPickersSectionListUtilityClass(e) {
  return generateUtilityClass("MuiPickersSectionList", e);
}
const pickersSectionListClasses = generateUtilityClasses("MuiPickersSectionList", ["root", "section", "sectionContent"]), _excluded$r = ["slots", "slotProps", "elements", "sectionListRef", "classes"], PickersSectionListRoot = styled("div", {
  name: "MuiPickersSectionList",
  slot: "Root"
})({
  direction: "ltr /*! @noflip */",
  outline: "none"
}), PickersSectionListSection = styled("span", {
  name: "MuiPickersSectionList",
  slot: "Section"
})({}), PickersSectionListSectionSeparator = styled("span", {
  name: "MuiPickersSectionList",
  slot: "SectionSeparator"
})({
  whiteSpace: "pre"
}), PickersSectionListSectionContent = styled("span", {
  name: "MuiPickersSectionList",
  slot: "SectionContent"
})({
  outline: "none"
}), useUtilityClasses$r = (e) => composeClasses({
  root: ["root"],
  section: ["section"],
  sectionContent: ["sectionContent"]
}, getPickersSectionListUtilityClass, e);
function PickersSection(e) {
  const {
    slots: t,
    slotProps: o,
    element: n,
    classes: s
  } = e, {
    ownerState: i
  } = usePickerPrivateContext(), l = t?.section ?? PickersSectionListSection, d = useSlotProps({
    elementType: l,
    externalSlotProps: o?.section,
    externalForwardedProps: n.container,
    className: s.section,
    ownerState: i
  }), u = t?.sectionContent ?? PickersSectionListSectionContent, c = useSlotProps({
    elementType: u,
    externalSlotProps: o?.sectionContent,
    externalForwardedProps: n.content,
    additionalProps: {
      suppressContentEditableWarning: !0
    },
    className: s.sectionContent,
    ownerState: i
  }), p = t?.sectionSeparator ?? PickersSectionListSectionSeparator, f = useSlotProps({
    elementType: p,
    externalSlotProps: o?.sectionSeparator,
    externalForwardedProps: n.before,
    ownerState: _extends({}, i, {
      separatorPosition: "before"
    })
  }), g = useSlotProps({
    elementType: p,
    externalSlotProps: o?.sectionSeparator,
    externalForwardedProps: n.after,
    ownerState: _extends({}, i, {
      separatorPosition: "after"
    })
  }), y = React.useRef(null), h = useForkRef(c.ref, y), T = (P) => {
    const E = P.relatedTarget, $ = P.currentTarget.closest(`.${pickersSectionListClasses.root}`);
    if ($ && E instanceof Node && $.contains(E)) {
      P.stopPropagation();
      return;
    }
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(l, _extends({}, d, {
    children: [/* @__PURE__ */ jsxRuntimeExports.jsx(p, _extends({}, f)), /* @__PURE__ */ jsxRuntimeExports.jsx(u, _extends({}, c, {
      ref: h,
      onBlur: T
    })), /* @__PURE__ */ jsxRuntimeExports.jsx(p, _extends({}, g))]
  }));
}
process.env.NODE_ENV !== "production" && (PickersSection.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  classes: PropTypes.object.isRequired,
  element: PropTypes.shape({
    after: PropTypes.object.isRequired,
    before: PropTypes.object.isRequired,
    container: PropTypes.object.isRequired,
    content: PropTypes.object.isRequired
  }).isRequired,
  /**
   * The props used for each component slot.
   */
  slotProps: PropTypes.object,
  /**
   * Overridable component slots.
   */
  slots: PropTypes.object
});
const PickersSectionList = /* @__PURE__ */ React.forwardRef(function e(t, o) {
  const n = useThemeProps({
    props: t,
    name: "MuiPickersSectionList"
  }), {
    slots: s,
    slotProps: i,
    elements: l,
    sectionListRef: d,
    classes: u
  } = n, c = _objectWithoutPropertiesLoose(n, _excluded$r), p = useUtilityClasses$r(u), {
    ownerState: f
  } = usePickerPrivateContext(), g = React.useRef(null), y = useForkRef(o, g), h = (E) => {
    if (!g.current)
      throw new Error(`MUI X: Cannot call sectionListRef.${E} before the mount of the component.`);
    return g.current;
  };
  React.useImperativeHandle(d, () => ({
    getRoot() {
      return h("getRoot");
    },
    getSectionContainer(E) {
      return h("getSectionContainer").querySelector(`.${pickersSectionListClasses.section}[data-sectionindex="${E}"]`);
    },
    getSectionContent(E) {
      return h("getSectionContent").querySelector(`.${pickersSectionListClasses.section}[data-sectionindex="${E}"] .${pickersSectionListClasses.sectionContent}`);
    },
    getSectionIndexFromDOMElement(E) {
      const $ = h("getSectionIndexFromDOMElement");
      if (E == null || !$.contains(E))
        return null;
      let R = null;
      return E.classList.contains(pickersSectionListClasses.section) ? R = E : E.classList.contains(pickersSectionListClasses.sectionContent) && (R = E.parentElement), R == null ? null : Number(R.dataset.sectionindex);
    }
  }));
  const T = s?.root ?? PickersSectionListRoot, P = useSlotProps({
    elementType: T,
    externalSlotProps: i?.root,
    externalForwardedProps: c,
    additionalProps: {
      ref: y,
      suppressContentEditableWarning: !0
    },
    className: p.root,
    ownerState: f
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(T, _extends({}, P, {
    children: P.contentEditable ? l.map(({
      content: E,
      before: $,
      after: R
    }) => `${$.children}${E.children}${R.children}`).join("") : /* @__PURE__ */ jsxRuntimeExports.jsx(React.Fragment, {
      children: l.map((E, $) => /* @__PURE__ */ jsxRuntimeExports.jsx(PickersSection, {
        slots: s,
        slotProps: i,
        element: E,
        classes: p
      }, $))
    })
  }));
});
process.env.NODE_ENV !== "production" && (PickersSectionList.displayName = "PickersSectionList");
process.env.NODE_ENV !== "production" && (PickersSectionList.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * If true, the whole element is editable.
   * Useful when all the sections are selected.
   */
  contentEditable: PropTypes.bool.isRequired,
  /**
   * The elements to render.
   * Each element contains the prop to edit a section of the value.
   */
  elements: PropTypes.arrayOf(PropTypes.shape({
    after: PropTypes.object.isRequired,
    before: PropTypes.object.isRequired,
    container: PropTypes.object.isRequired,
    content: PropTypes.object.isRequired
  })).isRequired,
  sectionListRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.shape({
      getRoot: PropTypes.func.isRequired,
      getSectionContainer: PropTypes.func.isRequired,
      getSectionContent: PropTypes.func.isRequired,
      getSectionIndexFromDOMElement: PropTypes.func.isRequired
    })
  })]),
  /**
   * The props used for each component slot.
   */
  slotProps: PropTypes.object,
  /**
   * Overridable component slots.
   */
  slots: PropTypes.object
});
const PickerTextFieldOwnerStateContext = /* @__PURE__ */ React.createContext(null);
process.env.NODE_ENV !== "production" && (PickerTextFieldOwnerStateContext.displayName = "PickerTextFieldOwnerStateContext");
const usePickerTextFieldOwnerState = () => {
  const e = React.useContext(PickerTextFieldOwnerStateContext);
  if (e == null)
    throw new Error(["MUI X: The `usePickerTextFieldOwnerState` can only be called in components that are used inside a PickerTextField component"].join(`
`));
  return e;
}, _excluded$q = ["elements", "areAllSectionsEmpty", "defaultValue", "label", "value", "onChange", "id", "autoFocus", "endAdornment", "startAdornment", "renderSuffix", "slots", "slotProps", "contentEditable", "tabIndex", "onInput", "onPaste", "onKeyDown", "fullWidth", "name", "readOnly", "inputProps", "inputRef", "sectionListRef", "onFocus", "onBlur", "classes", "ownerState"], round$1 = (e) => Math.round(e * 1e5) / 1e5, PickersInputBaseRoot = styled("div", {
  name: "MuiPickersInputBase",
  slot: "Root"
})(({
  theme: e
}) => _extends({}, e.typography.body1, {
  color: (e.vars || e).palette.text.primary,
  cursor: "text",
  padding: 0,
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  position: "relative",
  boxSizing: "border-box",
  // Prevent padding issue with fullWidth.
  letterSpacing: `${round$1(0.15 / 16)}em`,
  variants: [{
    props: {
      isInputInFullWidth: !0
    },
    style: {
      width: "100%"
    }
  }]
})), PickersInputBaseSectionsContainer = styled(PickersSectionListRoot, {
  name: "MuiPickersInputBase",
  slot: "SectionsContainer"
})(({
  theme: e
}) => ({
  padding: "4px 0 5px",
  fontFamily: e.typography.fontFamily,
  fontSize: "inherit",
  lineHeight: "1.4375em",
  // 23px
  flexGrow: 1,
  outline: "none",
  display: "flex",
  flexWrap: "nowrap",
  overflow: "hidden",
  letterSpacing: "inherit",
  // Baseline behavior
  width: "182px",
  variants: [{
    props: {
      fieldDirection: "rtl"
    },
    style: {
      justifyContent: "end"
    }
  }, {
    props: {
      inputSize: "small"
    },
    style: {
      paddingTop: 1
    }
  }, {
    props: {
      hasStartAdornment: !1,
      isFieldFocused: !1,
      isFieldValueEmpty: !0
    },
    style: {
      color: "currentColor",
      opacity: 0
    }
  }, {
    props: {
      hasStartAdornment: !1,
      isFieldFocused: !1,
      isFieldValueEmpty: !0,
      inputHasLabel: !1
    },
    style: e.vars ? {
      opacity: e.vars.opacity.inputPlaceholder
    } : {
      opacity: e.palette.mode === "light" ? 0.42 : 0.5
    }
  }, {
    props: {
      hasStartAdornment: !1,
      isFieldFocused: !1,
      isFieldValueEmpty: !0,
      inputHasLabel: !0,
      isLabelShrunk: !0
    },
    style: e.vars ? {
      opacity: e.vars.opacity.inputPlaceholder
    } : {
      opacity: e.palette.mode === "light" ? 0.42 : 0.5
    }
  }]
})), PickersInputBaseSection = styled(PickersSectionListSection, {
  name: "MuiPickersInputBase",
  slot: "Section"
})(({
  theme: e
}) => ({
  fontFamily: e.typography.fontFamily,
  fontSize: "inherit",
  letterSpacing: "inherit",
  lineHeight: "1.4375em",
  // 23px
  display: "inline-block",
  whiteSpace: "nowrap"
})), PickersInputBaseSectionContent = styled(PickersSectionListSectionContent, {
  name: "MuiPickersInputBase",
  slot: "SectionContent",
  overridesResolver: (e, t) => t.content
  // FIXME: Inconsistent naming with slot
})(({
  theme: e
}) => ({
  fontFamily: e.typography.fontFamily,
  lineHeight: "1.4375em",
  // 23px
  letterSpacing: "inherit",
  width: "fit-content",
  outline: "none"
})), PickersInputBaseSectionSeparator = styled(PickersSectionListSectionSeparator, {
  name: "MuiPickersInputBase",
  slot: "Separator"
})(() => ({
  whiteSpace: "pre",
  letterSpacing: "inherit"
})), PickersInputBaseInput = styled("input", {
  name: "MuiPickersInputBase",
  slot: "Input",
  overridesResolver: (e, t) => t.hiddenInput
  // FIXME: Inconsistent naming with slot
})(_extends({}, visuallyHidden)), PickersInputBaseActiveBar = styled("div", {
  name: "MuiPickersInputBase",
  slot: "ActiveBar"
})(({
  theme: e,
  ownerState: t
}) => ({
  display: "none",
  position: "absolute",
  height: 2,
  bottom: 2,
  borderTopLeftRadius: 2,
  borderTopRightRadius: 2,
  transition: e.transitions.create(["width", "left"], {
    duration: e.transitions.duration.shortest
  }),
  backgroundColor: (e.vars || e).palette.primary.main,
  '[data-active-range-position="start"] &, [data-active-range-position="end"] &': {
    display: "block"
  },
  '[data-active-range-position="start"] &': {
    left: t.sectionOffsets[0]
  },
  '[data-active-range-position="end"] &': {
    left: t.sectionOffsets[1]
  }
})), useUtilityClasses$q = (e, t) => {
  const {
    isFieldFocused: o,
    isFieldDisabled: n,
    isFieldReadOnly: s,
    hasFieldError: i,
    inputSize: l,
    isInputInFullWidth: d,
    inputColor: u,
    hasStartAdornment: c,
    hasEndAdornment: p
  } = t, f = {
    root: ["root", o && !n && "focused", n && "disabled", s && "readOnly", i && "error", d && "fullWidth", `color${capitalize(u)}`, l === "small" && "inputSizeSmall", c && "adornedStart", p && "adornedEnd"],
    notchedOutline: ["notchedOutline"],
    input: ["input"],
    sectionsContainer: ["sectionsContainer"],
    sectionContent: ["sectionContent"],
    sectionBefore: ["sectionBefore"],
    sectionAfter: ["sectionAfter"],
    activeBar: ["activeBar"]
  };
  return composeClasses(f, getPickersInputBaseUtilityClass, e);
};
function resolveSectionElementWidth(e, t, o, n) {
  if (e.content.id) {
    const s = t.current?.querySelectorAll(`[data-sectionindex="${o}"] [data-range-position="${n}"]`);
    if (s)
      return Array.from(s).reduce((i, l) => i + l.offsetWidth, 0);
  }
  return 0;
}
function resolveSectionWidthAndOffsets(e, t) {
  let o = 0;
  if (t.current?.getAttribute("data-active-range-position") === "end")
    for (let s = e.length - 1; s >= e.length / 2; s -= 1)
      o += resolveSectionElementWidth(e[s], t, s, "end");
  else
    for (let s = 0; s < e.length / 2; s += 1)
      o += resolveSectionElementWidth(e[s], t, s, "start");
  return {
    activeBarWidth: o,
    sectionOffsets: [t.current?.querySelector('[data-sectionindex="0"]')?.offsetLeft || 0, t.current?.querySelector(`[data-sectionindex="${e.length / 2}"]`)?.offsetLeft || 0]
  };
}
const PickersInputBase = /* @__PURE__ */ React.forwardRef(function e(t, o) {
  const n = useThemeProps({
    props: t,
    name: "MuiPickersInputBase"
  }), {
    elements: s,
    areAllSectionsEmpty: i,
    value: l,
    onChange: d,
    id: u,
    endAdornment: c,
    startAdornment: p,
    renderSuffix: f,
    slots: g,
    slotProps: y,
    contentEditable: h,
    tabIndex: T,
    onInput: P,
    onPaste: E,
    onKeyDown: $,
    name: R,
    readOnly: C,
    inputProps: x,
    inputRef: _,
    sectionListRef: D,
    onFocus: O,
    onBlur: v,
    classes: w,
    ownerState: M
  } = n, S = _objectWithoutPropertiesLoose(n, _excluded$q), I = usePickerTextFieldOwnerState(), N = React.useRef(null), F = React.useRef(null), L = React.useRef([]), k = useForkRef(o, N), W = useForkRef(x?.ref, _), V = useFormControl();
  if (!V)
    throw new Error("MUI X: PickersInputBase should always be used inside a PickersTextField component");
  const j = M ?? I, A = (K) => {
    V.onFocus?.(K), O?.(K);
  }, U = (K) => {
    A(K);
  }, G = (K) => {
    if ($?.(K), K.key === "Enter" && !K.defaultMuiPrevented) {
      if (N.current?.dataset.multiInput)
        return;
      const q = N.current?.closest("form"), B = q?.querySelector('[type="submit"]');
      if (!q || !B)
        return;
      K.preventDefault(), q.requestSubmit(B);
    }
  }, Y = (K) => {
    V.onBlur?.(K), v?.(K);
  };
  React.useEffect(() => {
    V && V.setAdornedStart(!!p);
  }, [V, p]), React.useEffect(() => {
    V && (i ? V.onEmpty() : V.onFilled());
  }, [V, i]);
  const ee = useUtilityClasses$q(w, j), J = g?.root || PickersInputBaseRoot, Z = useSlotProps({
    elementType: J,
    externalSlotProps: y?.root,
    externalForwardedProps: S,
    additionalProps: {
      "aria-invalid": V.error,
      ref: k
    },
    className: ee.root,
    ownerState: j
  }), le = g?.input || PickersInputBaseSectionsContainer, se = s.some((K) => K.content["data-range-position"] !== void 0);
  return React.useEffect(() => {
    if (!se || !j.isPickerOpen)
      return;
    const {
      activeBarWidth: K,
      sectionOffsets: q
    } = resolveSectionWidthAndOffsets(s, N);
    L.current = [q[0], q[1]], F.current && (F.current.style.width = `${K}px`);
  }, [s, se, j.isPickerOpen]), /* @__PURE__ */ jsxRuntimeExports.jsxs(J, _extends({}, Z, {
    children: [p, /* @__PURE__ */ jsxRuntimeExports.jsx(PickersSectionList, {
      sectionListRef: D,
      elements: s,
      contentEditable: h,
      tabIndex: T,
      className: ee.sectionsContainer,
      onFocus: A,
      onBlur: Y,
      onInput: P,
      onPaste: E,
      onKeyDown: G,
      slots: {
        root: le,
        section: PickersInputBaseSection,
        sectionContent: PickersInputBaseSectionContent,
        sectionSeparator: PickersInputBaseSectionSeparator
      },
      slotProps: {
        root: _extends({}, y?.input, {
          ownerState: j
        }),
        sectionContent: {
          className: pickersInputBaseClasses.sectionContent
        },
        sectionSeparator: ({
          separatorPosition: K
        }) => ({
          className: K === "before" ? pickersInputBaseClasses.sectionBefore : pickersInputBaseClasses.sectionAfter
        })
      }
    }), c, f ? f(_extends({}, V)) : null, /* @__PURE__ */ jsxRuntimeExports.jsx(PickersInputBaseInput, _extends({
      name: R,
      className: ee.input,
      value: l,
      onChange: d,
      id: u,
      "aria-hidden": "true",
      tabIndex: -1,
      readOnly: C,
      required: V.required,
      disabled: V.disabled,
      onFocus: U
    }, x, {
      ref: W
    })), se && /* @__PURE__ */ jsxRuntimeExports.jsx(PickersInputBaseActiveBar, {
      className: ee.activeBar,
      ref: F,
      ownerState: {
        sectionOffsets: L.current
      }
    })]
  }));
});
process.env.NODE_ENV !== "production" && (PickersInputBase.displayName = "PickersInputBase");
process.env.NODE_ENV !== "production" && (PickersInputBase.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Is `true` if the current values equals the empty value.
   * For a single item value, it means that `value === null`
   * For a range value, it means that `value === [null, null]`
   */
  areAllSectionsEmpty: PropTypes.bool.isRequired,
  className: PropTypes.string,
  component: PropTypes.elementType,
  /**
   * If true, the whole element is editable.
   * Useful when all the sections are selected.
   */
  contentEditable: PropTypes.bool.isRequired,
  "data-multi-input": PropTypes.string,
  /**
   * The elements to render.
   * Each element contains the prop to edit a section of the value.
   */
  elements: PropTypes.arrayOf(PropTypes.shape({
    after: PropTypes.object.isRequired,
    before: PropTypes.object.isRequired,
    container: PropTypes.object.isRequired,
    content: PropTypes.object.isRequired
  })).isRequired,
  endAdornment: PropTypes.node,
  fullWidth: PropTypes.bool,
  id: PropTypes.string,
  inputProps: PropTypes.object,
  inputRef: refType,
  label: PropTypes.node,
  margin: PropTypes.oneOf(["dense", "none", "normal"]),
  name: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
  onInput: PropTypes.func.isRequired,
  onKeyDown: PropTypes.func.isRequired,
  onPaste: PropTypes.func.isRequired,
  ownerState: PropTypes.any,
  readOnly: PropTypes.bool,
  renderSuffix: PropTypes.func,
  sectionListRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.shape({
      getRoot: PropTypes.func.isRequired,
      getSectionContainer: PropTypes.func.isRequired,
      getSectionContent: PropTypes.func.isRequired,
      getSectionIndexFromDOMElement: PropTypes.func.isRequired
    })
  })]),
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: PropTypes.object,
  /**
   * The components used for each slot inside.
   *
   * @default {}
   */
  slots: PropTypes.object,
  startAdornment: PropTypes.node,
  style: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  value: PropTypes.string.isRequired
});
function getPickersOutlinedInputUtilityClass(e) {
  return generateUtilityClass("MuiPickersOutlinedInput", e);
}
const pickersOutlinedInputClasses = _extends({}, pickersInputBaseClasses, generateUtilityClasses("MuiPickersOutlinedInput", ["root", "notchedOutline", "input"])), _excluded$p = ["children", "className", "label", "notched", "shrink"], OutlineRoot = styled("fieldset", {
  name: "MuiPickersOutlinedInput",
  slot: "NotchedOutline"
})(({
  theme: e
}) => {
  const t = e.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
  return {
    textAlign: "left",
    position: "absolute",
    bottom: 0,
    right: 0,
    top: -5,
    left: 0,
    margin: 0,
    padding: "0 8px",
    pointerEvents: "none",
    borderRadius: "inherit",
    borderStyle: "solid",
    borderWidth: 1,
    overflow: "hidden",
    minWidth: "0%",
    borderColor: e.vars ? `rgba(${e.vars.palette.common.onBackgroundChannel} / 0.23)` : t
  };
}), OutlineLabel = styled("span")(({
  theme: e
}) => ({
  fontFamily: e.typography.fontFamily,
  fontSize: "inherit"
})), OutlineLegend = styled("legend", {
  shouldForwardProp: (e) => shouldForwardProp(e) && e !== "notched"
})(({
  theme: e
}) => ({
  float: "unset",
  // Fix conflict with bootstrap
  width: "auto",
  // Fix conflict with bootstrap
  overflow: "hidden",
  // Fix Horizontal scroll when label too long
  variants: [{
    props: {
      inputHasLabel: !1
    },
    style: {
      padding: 0,
      lineHeight: "11px",
      // sync with `height` in `legend` styles
      transition: e.transitions.create("width", {
        duration: 150,
        easing: e.transitions.easing.easeOut
      })
    }
  }, {
    props: {
      inputHasLabel: !0
    },
    style: {
      display: "block",
      // Fix conflict with normalize.css and sanitize.css
      padding: 0,
      height: 11,
      // sync with `lineHeight` in `legend` styles
      fontSize: "0.75em",
      visibility: "hidden",
      maxWidth: 0.01,
      transition: e.transitions.create("max-width", {
        duration: 50,
        easing: e.transitions.easing.easeOut
      }),
      whiteSpace: "nowrap",
      "& > span": {
        paddingLeft: 5,
        paddingRight: 5,
        display: "inline-block",
        opacity: 0,
        visibility: "visible"
      }
    }
  }, {
    props: {
      inputHasLabel: !0,
      notched: !0
    },
    style: {
      maxWidth: "100%",
      transition: e.transitions.create("max-width", {
        duration: 100,
        easing: e.transitions.easing.easeOut,
        delay: 50
      })
    }
  }]
}));
function Outline(e) {
  const {
    className: t,
    label: o,
    notched: n
  } = e, s = _objectWithoutPropertiesLoose(e, _excluded$p), i = usePickerTextFieldOwnerState();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(OutlineRoot, _extends({
    "aria-hidden": !0,
    className: t
  }, s, {
    ownerState: i,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(OutlineLegend, {
      ownerState: i,
      notched: n,
      children: o ? /* @__PURE__ */ jsxRuntimeExports.jsx(OutlineLabel, {
        children: o
      }) : (
        // notranslate needed while Google Translate will not fix zero-width space issue
        /* @__PURE__ */ jsxRuntimeExports.jsx(OutlineLabel, {
          className: "notranslate",
          children: "​"
        })
      )
    })
  }));
}
const _excluded$o = ["label", "autoFocus", "ownerState", "classes", "notched"], PickersOutlinedInputRoot = styled(PickersInputBaseRoot, {
  name: "MuiPickersOutlinedInput",
  slot: "Root"
})(({
  theme: e
}) => {
  const t = e.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
  return {
    padding: "0 14px",
    borderRadius: (e.vars || e).shape.borderRadius,
    [`&:hover .${pickersOutlinedInputClasses.notchedOutline}`]: {
      borderColor: (e.vars || e).palette.text.primary
    },
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      [`&:hover .${pickersOutlinedInputClasses.notchedOutline}`]: {
        borderColor: e.vars ? `rgba(${e.vars.palette.common.onBackgroundChannel} / 0.23)` : t
      }
    },
    [`&.${pickersOutlinedInputClasses.focused} .${pickersOutlinedInputClasses.notchedOutline}`]: {
      borderStyle: "solid",
      borderWidth: 2
    },
    [`&.${pickersOutlinedInputClasses.disabled}`]: {
      [`& .${pickersOutlinedInputClasses.notchedOutline}`]: {
        borderColor: (e.vars || e).palette.action.disabled
      },
      "*": {
        color: (e.vars || e).palette.action.disabled
      }
    },
    [`&.${pickersOutlinedInputClasses.error} .${pickersOutlinedInputClasses.notchedOutline}`]: {
      borderColor: (e.vars || e).palette.error.main
    },
    variants: Object.keys((e.vars ?? e).palette).filter((o) => (e.vars ?? e).palette[o]?.main ?? !1).map((o) => ({
      props: {
        inputColor: o
      },
      style: {
        [`&.${pickersOutlinedInputClasses.focused}:not(.${pickersOutlinedInputClasses.error}) .${pickersOutlinedInputClasses.notchedOutline}`]: {
          // @ts-ignore
          borderColor: (e.vars || e).palette[o].main
        }
      }
    }))
  };
}), PickersOutlinedInputSectionsContainer = styled(PickersInputBaseSectionsContainer, {
  name: "MuiPickersOutlinedInput",
  slot: "SectionsContainer"
})({
  padding: "16.5px 0",
  variants: [{
    props: {
      inputSize: "small"
    },
    style: {
      padding: "8.5px 0"
    }
  }]
}), useUtilityClasses$p = (e) => {
  const o = composeClasses({
    root: ["root"],
    notchedOutline: ["notchedOutline"],
    input: ["input"]
  }, getPickersOutlinedInputUtilityClass, e);
  return _extends({}, e, o);
}, PickersOutlinedInput = /* @__PURE__ */ React.forwardRef(function e(t, o) {
  const n = useThemeProps({
    props: t,
    name: "MuiPickersOutlinedInput"
  }), {
    label: s,
    classes: i,
    notched: l
  } = n, d = _objectWithoutPropertiesLoose(n, _excluded$o), u = useFormControl(), c = useUtilityClasses$p(i);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(PickersInputBase, _extends({
    slots: {
      root: PickersOutlinedInputRoot,
      input: PickersOutlinedInputSectionsContainer
    },
    renderSuffix: (p) => /* @__PURE__ */ jsxRuntimeExports.jsx(Outline, {
      shrink: !!(l || p.adornedStart || p.focused || p.filled),
      notched: !!(l || p.adornedStart || p.focused || p.filled),
      className: c.notchedOutline,
      label: s != null && s !== "" && u?.required ? /* @__PURE__ */ jsxRuntimeExports.jsxs(React.Fragment, {
        children: [s, " ", "*"]
      }) : s
    })
  }, d, {
    label: s,
    classes: c,
    ref: o
  }));
});
process.env.NODE_ENV !== "production" && (PickersOutlinedInput.displayName = "PickersOutlinedInput");
process.env.NODE_ENV !== "production" && (PickersOutlinedInput.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Is `true` if the current values equals the empty value.
   * For a single item value, it means that `value === null`
   * For a range value, it means that `value === [null, null]`
   */
  areAllSectionsEmpty: PropTypes.bool.isRequired,
  className: PropTypes.string,
  component: PropTypes.elementType,
  /**
   * If true, the whole element is editable.
   * Useful when all the sections are selected.
   */
  contentEditable: PropTypes.bool.isRequired,
  "data-multi-input": PropTypes.string,
  /**
   * The elements to render.
   * Each element contains the prop to edit a section of the value.
   */
  elements: PropTypes.arrayOf(PropTypes.shape({
    after: PropTypes.object.isRequired,
    before: PropTypes.object.isRequired,
    container: PropTypes.object.isRequired,
    content: PropTypes.object.isRequired
  })).isRequired,
  endAdornment: PropTypes.node,
  fullWidth: PropTypes.bool,
  id: PropTypes.string,
  inputProps: PropTypes.object,
  inputRef: refType,
  label: PropTypes.node,
  margin: PropTypes.oneOf(["dense", "none", "normal"]),
  name: PropTypes.string,
  notched: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
  onInput: PropTypes.func.isRequired,
  onKeyDown: PropTypes.func.isRequired,
  onPaste: PropTypes.func.isRequired,
  ownerState: PropTypes.any,
  readOnly: PropTypes.bool,
  renderSuffix: PropTypes.func,
  sectionListRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.shape({
      getRoot: PropTypes.func.isRequired,
      getSectionContainer: PropTypes.func.isRequired,
      getSectionContent: PropTypes.func.isRequired,
      getSectionIndexFromDOMElement: PropTypes.func.isRequired
    })
  })]),
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: PropTypes.object,
  /**
   * The components used for each slot inside.
   *
   * @default {}
   */
  slots: PropTypes.object,
  startAdornment: PropTypes.node,
  style: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  value: PropTypes.string.isRequired
});
PickersOutlinedInput.muiName = "Input";
function getPickersFilledInputUtilityClass(e) {
  return generateUtilityClass("MuiPickersFilledInput", e);
}
const pickersFilledInputClasses = _extends({}, pickersInputBaseClasses, generateUtilityClasses("MuiPickersFilledInput", ["root", "underline", "input"])), _excluded$n = ["label", "autoFocus", "disableUnderline", "hiddenLabel", "classes"], PickersFilledInputRoot = styled(PickersInputBaseRoot, {
  name: "MuiPickersFilledInput",
  slot: "Root",
  shouldForwardProp: (e) => shouldForwardProp(e) && e !== "disableUnderline"
})(({
  theme: e
}) => {
  const t = e.palette.mode === "light", o = t ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)", n = t ? "rgba(0, 0, 0, 0.06)" : "rgba(255, 255, 255, 0.09)", s = t ? "rgba(0, 0, 0, 0.09)" : "rgba(255, 255, 255, 0.13)", i = t ? "rgba(0, 0, 0, 0.12)" : "rgba(255, 255, 255, 0.12)";
  return {
    backgroundColor: e.vars ? e.vars.palette.FilledInput.bg : n,
    borderTopLeftRadius: (e.vars || e).shape.borderRadius,
    borderTopRightRadius: (e.vars || e).shape.borderRadius,
    transition: e.transitions.create("background-color", {
      duration: e.transitions.duration.shorter,
      easing: e.transitions.easing.easeOut
    }),
    "&:hover": {
      backgroundColor: e.vars ? e.vars.palette.FilledInput.hoverBg : s,
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: e.vars ? e.vars.palette.FilledInput.bg : n
      }
    },
    [`&.${pickersFilledInputClasses.focused}`]: {
      backgroundColor: e.vars ? e.vars.palette.FilledInput.bg : n
    },
    [`&.${pickersFilledInputClasses.disabled}`]: {
      backgroundColor: e.vars ? e.vars.palette.FilledInput.disabledBg : i
    },
    variants: [...Object.keys((e.vars ?? e).palette).filter((l) => (e.vars ?? e).palette[l].main).map((l) => ({
      props: {
        inputColor: l,
        disableUnderline: !1
      },
      style: {
        "&::after": {
          // @ts-ignore
          borderBottom: `2px solid ${(e.vars || e).palette[l]?.main}`
        }
      }
    })), {
      props: {
        disableUnderline: !1
      },
      style: {
        "&::after": {
          left: 0,
          bottom: 0,
          // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
          content: '""',
          position: "absolute",
          right: 0,
          transform: "scaleX(0)",
          transition: e.transitions.create("transform", {
            duration: e.transitions.duration.shorter,
            easing: e.transitions.easing.easeOut
          }),
          pointerEvents: "none"
          // Transparent to the hover style.
        },
        [`&.${pickersFilledInputClasses.focused}:after`]: {
          // translateX(0) is a workaround for Safari transform scale bug
          // See https://github.com/mui/material-ui/issues/31766
          transform: "scaleX(1) translateX(0)"
        },
        [`&.${pickersFilledInputClasses.error}`]: {
          "&:before, &:after": {
            borderBottomColor: (e.vars || e).palette.error.main
          }
        },
        "&::before": {
          borderBottom: `1px solid ${e.vars ? `rgba(${e.vars.palette.common.onBackgroundChannel} / ${e.vars.opacity.inputUnderline})` : o}`,
          left: 0,
          bottom: 0,
          // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
          content: '"\\00a0"',
          position: "absolute",
          right: 0,
          transition: e.transitions.create("border-bottom-color", {
            duration: e.transitions.duration.shorter
          }),
          pointerEvents: "none"
          // Transparent to the hover style.
        },
        [`&:hover:not(.${pickersFilledInputClasses.disabled}, .${pickersFilledInputClasses.error}):before`]: {
          borderBottom: `1px solid ${(e.vars || e).palette.text.primary}`
        },
        [`&.${pickersFilledInputClasses.disabled}:before`]: {
          borderBottomStyle: "dotted"
        }
      }
    }, {
      props: {
        hasStartAdornment: !0
      },
      style: {
        paddingLeft: 12
      }
    }, {
      props: {
        hasEndAdornment: !0
      },
      style: {
        paddingRight: 12
      }
    }]
  };
}), PickersFilledSectionsContainer = styled(PickersInputBaseSectionsContainer, {
  name: "MuiPickersFilledInput",
  slot: "sectionsContainer",
  shouldForwardProp: (e) => shouldForwardProp(e) && e !== "hiddenLabel"
})({
  paddingTop: 25,
  paddingRight: 12,
  paddingBottom: 8,
  paddingLeft: 12,
  variants: [{
    props: {
      inputSize: "small"
    },
    style: {
      paddingTop: 21,
      paddingBottom: 4
    }
  }, {
    props: {
      hasStartAdornment: !0
    },
    style: {
      paddingLeft: 0
    }
  }, {
    props: {
      hasEndAdornment: !0
    },
    style: {
      paddingRight: 0
    }
  }, {
    props: {
      hiddenLabel: !0
    },
    style: {
      paddingTop: 16,
      paddingBottom: 17
    }
  }, {
    props: {
      hiddenLabel: !0,
      inputSize: "small"
    },
    style: {
      paddingTop: 8,
      paddingBottom: 9
    }
  }]
}), useUtilityClasses$o = (e, t) => {
  const {
    inputHasUnderline: o
  } = t, s = composeClasses({
    root: ["root", o && "underline"],
    input: ["input"]
  }, getPickersFilledInputUtilityClass, e);
  return _extends({}, e, s);
}, PickersFilledInput = /* @__PURE__ */ React.forwardRef(function e(t, o) {
  const n = useThemeProps({
    props: t,
    name: "MuiPickersFilledInput"
  }), {
    label: s,
    disableUnderline: i = !1,
    hiddenLabel: l = !1,
    classes: d
  } = n, u = _objectWithoutPropertiesLoose(n, _excluded$n), c = usePickerTextFieldOwnerState(), p = _extends({}, c, {
    inputHasUnderline: !i
  }), f = useUtilityClasses$o(d, p);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(PickersInputBase, _extends({
    slots: {
      root: PickersFilledInputRoot,
      input: PickersFilledSectionsContainer
    },
    slotProps: {
      root: {
        disableUnderline: i
      },
      input: {
        hiddenLabel: l
      }
    }
  }, u, {
    label: s,
    classes: f,
    ref: o,
    ownerState: p
  }));
});
process.env.NODE_ENV !== "production" && (PickersFilledInput.displayName = "PickersFilledInput");
process.env.NODE_ENV !== "production" && (PickersFilledInput.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Is `true` if the current values equals the empty value.
   * For a single item value, it means that `value === null`
   * For a range value, it means that `value === [null, null]`
   */
  areAllSectionsEmpty: PropTypes.bool.isRequired,
  className: PropTypes.string,
  component: PropTypes.elementType,
  /**
   * If true, the whole element is editable.
   * Useful when all the sections are selected.
   */
  contentEditable: PropTypes.bool.isRequired,
  "data-multi-input": PropTypes.string,
  disableUnderline: PropTypes.bool,
  /**
   * The elements to render.
   * Each element contains the prop to edit a section of the value.
   */
  elements: PropTypes.arrayOf(PropTypes.shape({
    after: PropTypes.object.isRequired,
    before: PropTypes.object.isRequired,
    container: PropTypes.object.isRequired,
    content: PropTypes.object.isRequired
  })).isRequired,
  endAdornment: PropTypes.node,
  fullWidth: PropTypes.bool,
  hiddenLabel: PropTypes.bool,
  id: PropTypes.string,
  inputProps: PropTypes.object,
  inputRef: refType,
  label: PropTypes.node,
  margin: PropTypes.oneOf(["dense", "none", "normal"]),
  name: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
  onInput: PropTypes.func.isRequired,
  onKeyDown: PropTypes.func.isRequired,
  onPaste: PropTypes.func.isRequired,
  ownerState: PropTypes.any,
  readOnly: PropTypes.bool,
  renderSuffix: PropTypes.func,
  sectionListRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.shape({
      getRoot: PropTypes.func.isRequired,
      getSectionContainer: PropTypes.func.isRequired,
      getSectionContent: PropTypes.func.isRequired,
      getSectionIndexFromDOMElement: PropTypes.func.isRequired
    })
  })]),
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: PropTypes.object,
  /**
   * The components used for each slot inside.
   *
   * @default {}
   */
  slots: PropTypes.object,
  startAdornment: PropTypes.node,
  style: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  value: PropTypes.string.isRequired
});
PickersFilledInput.muiName = "Input";
function getPickersInputUtilityClass(e) {
  return generateUtilityClass("MuiPickersFilledInput", e);
}
const pickersInputClasses = _extends({}, pickersInputBaseClasses, generateUtilityClasses("MuiPickersInput", ["root", "underline", "input"])), _excluded$m = ["label", "autoFocus", "disableUnderline", "ownerState", "classes"], PickersInputRoot = styled(PickersInputBaseRoot, {
  name: "MuiPickersInput",
  slot: "Root",
  shouldForwardProp: (e) => shouldForwardProp(e) && e !== "disableUnderline"
})(({
  theme: e
}) => {
  let o = e.palette.mode === "light" ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
  return e.vars && (o = `rgba(${e.vars.palette.common.onBackgroundChannel} / ${e.vars.opacity.inputUnderline})`), {
    "label + &": {
      marginTop: 16
    },
    variants: [...Object.keys((e.vars ?? e).palette).filter((n) => (e.vars ?? e).palette[n].main).map((n) => ({
      props: {
        inputColor: n,
        inputHasUnderline: !0
      },
      style: {
        "&::after": {
          // @ts-ignore
          borderBottom: `2px solid ${(e.vars || e).palette[n].main}`
        }
      }
    })), {
      props: {
        inputHasUnderline: !0
      },
      style: {
        "&::after": {
          background: "red",
          left: 0,
          bottom: 0,
          // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
          content: '""',
          position: "absolute",
          right: 0,
          transform: "scaleX(0)",
          transition: e.transitions.create("transform", {
            duration: e.transitions.duration.shorter,
            easing: e.transitions.easing.easeOut
          }),
          pointerEvents: "none"
          // Transparent to the hover style.
        },
        [`&.${pickersInputClasses.focused}:after`]: {
          // translateX(0) is a workaround for Safari transform scale bug
          // See https://github.com/mui/material-ui/issues/31766
          transform: "scaleX(1) translateX(0)"
        },
        [`&.${pickersInputClasses.error}`]: {
          "&:before, &:after": {
            borderBottomColor: (e.vars || e).palette.error.main
          }
        },
        "&::before": {
          borderBottom: `1px solid ${o}`,
          left: 0,
          bottom: 0,
          // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
          content: '"\\00a0"',
          position: "absolute",
          right: 0,
          transition: e.transitions.create("border-bottom-color", {
            duration: e.transitions.duration.shorter
          }),
          pointerEvents: "none"
          // Transparent to the hover style.
        },
        [`&:hover:not(.${pickersInputClasses.disabled}, .${pickersInputClasses.error}):before`]: {
          borderBottom: `2px solid ${(e.vars || e).palette.text.primary}`,
          // Reset on touch devices, it doesn't add specificity
          "@media (hover: none)": {
            borderBottom: `1px solid ${o}`
          }
        },
        [`&.${pickersInputClasses.disabled}:before`]: {
          borderBottomStyle: "dotted"
        }
      }
    }]
  };
}), useUtilityClasses$n = (e, t) => {
  const {
    inputHasUnderline: o
  } = t, s = composeClasses({
    root: ["root", !o && "underline"],
    input: ["input"]
  }, getPickersInputUtilityClass, e);
  return _extends({}, e, s);
}, PickersInput = /* @__PURE__ */ React.forwardRef(function e(t, o) {
  const n = useThemeProps({
    props: t,
    name: "MuiPickersInput"
  }), {
    label: s,
    disableUnderline: i = !1,
    classes: l
  } = n, d = _objectWithoutPropertiesLoose(n, _excluded$m), u = usePickerTextFieldOwnerState(), c = _extends({}, u, {
    inputHasUnderline: !i
  }), p = useUtilityClasses$n(l, c);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(PickersInputBase, _extends({
    slots: {
      root: PickersInputRoot
    },
    slotProps: {
      root: {
        disableUnderline: i
      }
    }
  }, d, {
    ownerState: c,
    label: s,
    classes: p,
    ref: o
  }));
});
process.env.NODE_ENV !== "production" && (PickersInput.displayName = "PickersInput");
process.env.NODE_ENV !== "production" && (PickersInput.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Is `true` if the current values equals the empty value.
   * For a single item value, it means that `value === null`
   * For a range value, it means that `value === [null, null]`
   */
  areAllSectionsEmpty: PropTypes.bool.isRequired,
  className: PropTypes.string,
  component: PropTypes.elementType,
  /**
   * If true, the whole element is editable.
   * Useful when all the sections are selected.
   */
  contentEditable: PropTypes.bool.isRequired,
  "data-multi-input": PropTypes.string,
  disableUnderline: PropTypes.bool,
  /**
   * The elements to render.
   * Each element contains the prop to edit a section of the value.
   */
  elements: PropTypes.arrayOf(PropTypes.shape({
    after: PropTypes.object.isRequired,
    before: PropTypes.object.isRequired,
    container: PropTypes.object.isRequired,
    content: PropTypes.object.isRequired
  })).isRequired,
  endAdornment: PropTypes.node,
  fullWidth: PropTypes.bool,
  id: PropTypes.string,
  inputProps: PropTypes.object,
  inputRef: refType,
  label: PropTypes.node,
  margin: PropTypes.oneOf(["dense", "none", "normal"]),
  name: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
  onInput: PropTypes.func.isRequired,
  onKeyDown: PropTypes.func.isRequired,
  onPaste: PropTypes.func.isRequired,
  ownerState: PropTypes.any,
  readOnly: PropTypes.bool,
  renderSuffix: PropTypes.func,
  sectionListRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.shape({
      getRoot: PropTypes.func.isRequired,
      getSectionContainer: PropTypes.func.isRequired,
      getSectionContent: PropTypes.func.isRequired,
      getSectionIndexFromDOMElement: PropTypes.func.isRequired
    })
  })]),
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: PropTypes.object,
  /**
   * The components used for each slot inside.
   *
   * @default {}
   */
  slots: PropTypes.object,
  startAdornment: PropTypes.node,
  style: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  value: PropTypes.string.isRequired
});
PickersInput.muiName = "Input";
const _excluded$l = ["onFocus", "onBlur", "className", "classes", "color", "disabled", "error", "variant", "required", "hiddenLabel", "InputProps", "inputProps", "inputRef", "sectionListRef", "elements", "areAllSectionsEmpty", "onClick", "onKeyDown", "onKeyUp", "onPaste", "onInput", "endAdornment", "startAdornment", "tabIndex", "contentEditable", "focused", "value", "onChange", "fullWidth", "id", "name", "helperText", "FormHelperTextProps", "label", "InputLabelProps", "data-active-range-position"], VARIANT_COMPONENT = {
  standard: PickersInput,
  filled: PickersFilledInput,
  outlined: PickersOutlinedInput
}, PickersTextFieldRoot = styled(FormControl, {
  name: "MuiPickersTextField",
  slot: "Root"
})({
  maxWidth: "100%"
}), useUtilityClasses$m = (e, t) => {
  const {
    isFieldFocused: o,
    isFieldDisabled: n,
    isFieldRequired: s
  } = t;
  return composeClasses({
    root: ["root", o && !n && "focused", n && "disabled", s && "required"]
  }, getPickersTextFieldUtilityClass, e);
}, PickersTextField = /* @__PURE__ */ React.forwardRef(function e(t, o) {
  const n = useThemeProps({
    props: t,
    name: "MuiPickersTextField"
  }), {
    // Props used by FormControl
    onFocus: s,
    onBlur: i,
    className: l,
    classes: d,
    color: u = "primary",
    disabled: c = !1,
    error: p = !1,
    variant: f = "outlined",
    required: g = !1,
    hiddenLabel: y = !1,
    // Props used by PickersInput
    InputProps: h,
    inputProps: T,
    inputRef: P,
    sectionListRef: E,
    elements: $,
    areAllSectionsEmpty: R,
    onClick: C,
    onKeyDown: x,
    onKeyUp: _,
    onPaste: D,
    onInput: O,
    endAdornment: v,
    startAdornment: w,
    tabIndex: M,
    contentEditable: S,
    focused: I,
    value: N,
    onChange: F,
    fullWidth: L,
    id: k,
    name: W,
    // Props used by FormHelperText
    helperText: V,
    FormHelperTextProps: j,
    // Props used by InputLabel
    label: A,
    InputLabelProps: U,
    // @ts-ignore
    "data-active-range-position": G
  } = n, Y = _objectWithoutPropertiesLoose(n, _excluded$l), ee = React.useRef(null), J = useForkRef(o, ee), Z = useId(k), le = V && Z ? `${Z}-helper-text` : void 0, se = A && Z ? `${Z}-label` : void 0, K = useFieldOwnerState({
    disabled: n.disabled,
    required: n.required,
    readOnly: h?.readOnly
  }), q = React.useMemo(() => _extends({}, K, {
    isFieldValueEmpty: R,
    isFieldFocused: I ?? !1,
    hasFieldError: p ?? !1,
    inputSize: n.size ?? "medium",
    inputColor: u ?? "primary",
    isInputInFullWidth: L ?? !1,
    hasStartAdornment: !!(w ?? h?.startAdornment),
    hasEndAdornment: !!(v ?? h?.endAdornment),
    inputHasLabel: !!A,
    isLabelShrunk: !!U?.shrink
  }), [K, R, I, p, n.size, u, L, w, v, h?.startAdornment, h?.endAdornment, A, U?.shrink]), B = useUtilityClasses$m(d, q), ue = VARIANT_COMPONENT[f], re = {};
  return f === "outlined" ? (U && typeof U.shrink < "u" && (re.notched = U.shrink), re.label = A) : f === "filled" && (re.hiddenLabel = y), /* @__PURE__ */ jsxRuntimeExports.jsx(PickerTextFieldOwnerStateContext.Provider, {
    value: q,
    children: /* @__PURE__ */ jsxRuntimeExports.jsxs(PickersTextFieldRoot, _extends({
      className: clsx(B.root, l),
      ref: J,
      focused: I,
      disabled: c,
      variant: f,
      error: p,
      color: u,
      fullWidth: L,
      required: g,
      ownerState: q
    }, Y, {
      children: [A != null && A !== "" && /* @__PURE__ */ jsxRuntimeExports.jsx(InputLabel, _extends({
        htmlFor: Z,
        id: se
      }, U, {
        children: A
      })), /* @__PURE__ */ jsxRuntimeExports.jsx(ue, _extends({
        elements: $,
        areAllSectionsEmpty: R,
        onClick: C,
        onKeyDown: x,
        onKeyUp: _,
        onInput: O,
        onPaste: D,
        onFocus: s,
        onBlur: i,
        endAdornment: v,
        startAdornment: w,
        tabIndex: M,
        contentEditable: S,
        value: N,
        onChange: F,
        id: Z,
        fullWidth: L,
        inputProps: T,
        inputRef: P,
        sectionListRef: E,
        label: A,
        name: W,
        role: "group",
        "aria-labelledby": se,
        "aria-describedby": le,
        "aria-live": le ? "polite" : void 0,
        "data-active-range-position": G
      }, re, h)), V && /* @__PURE__ */ jsxRuntimeExports.jsx(FormHelperText, _extends({
        id: le
      }, j, {
        children: V
      }))]
    }))
  });
});
process.env.NODE_ENV !== "production" && (PickersTextField.displayName = "PickersTextField");
process.env.NODE_ENV !== "production" && (PickersTextField.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Is `true` if the current values equals the empty value.
   * For a single item value, it means that `value === null`
   * For a range value, it means that `value === [null, null]`
   */
  areAllSectionsEmpty: PropTypes.bool.isRequired,
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: PropTypes.oneOf(["error", "info", "primary", "secondary", "success", "warning"]),
  component: PropTypes.elementType,
  /**
   * If true, the whole element is editable.
   * Useful when all the sections are selected.
   */
  contentEditable: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
  /**
   * The elements to render.
   * Each element contains the prop to edit a section of the value.
   */
  elements: PropTypes.arrayOf(PropTypes.shape({
    after: PropTypes.object.isRequired,
    before: PropTypes.object.isRequired,
    container: PropTypes.object.isRequired,
    content: PropTypes.object.isRequired
  })).isRequired,
  endAdornment: PropTypes.node,
  error: PropTypes.bool.isRequired,
  /**
   * If `true`, the component is displayed in focused state.
   */
  focused: PropTypes.bool,
  FormHelperTextProps: PropTypes.object,
  fullWidth: PropTypes.bool,
  /**
   * The helper text content.
   */
  helperText: PropTypes.node,
  /**
   * If `true`, the label is hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   * @default false
   */
  hiddenLabel: PropTypes.bool,
  id: PropTypes.string,
  InputLabelProps: PropTypes.object,
  inputProps: PropTypes.object,
  /**
   * Props applied to the Input element.
   * It will be a [`FilledInput`](/material-ui/api/filled-input/),
   * [`OutlinedInput`](/material-ui/api/outlined-input/) or [`Input`](/material-ui/api/input/)
   * component depending on the `variant` prop value.
   */
  InputProps: PropTypes.object,
  inputRef: refType,
  label: PropTypes.node,
  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   * @default 'none'
   */
  margin: PropTypes.oneOf(["dense", "none", "normal"]),
  name: PropTypes.string,
  onBlur: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
  onFocus: PropTypes.func.isRequired,
  onInput: PropTypes.func.isRequired,
  onKeyDown: PropTypes.func.isRequired,
  onPaste: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
  /**
   * If `true`, the label will indicate that the `input` is required.
   * @default false
   */
  required: PropTypes.bool,
  sectionListRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.shape({
      getRoot: PropTypes.func.isRequired,
      getSectionContainer: PropTypes.func.isRequired,
      getSectionContent: PropTypes.func.isRequired,
      getSectionIndexFromDOMElement: PropTypes.func.isRequired
    })
  })]),
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: PropTypes.oneOf(["medium", "small"]),
  startAdornment: PropTypes.node,
  style: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  value: PropTypes.string.isRequired,
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: PropTypes.oneOf(["filled", "outlined", "standard"])
});
const _excluded$k = ["enableAccessibleFieldDOMStructure"], _excluded2$5 = ["InputProps", "readOnly", "onClear", "clearable", "clearButtonPosition", "openPickerButtonPosition", "openPickerAriaLabel"], _excluded3 = ["onPaste", "onKeyDown", "inputMode", "readOnly", "InputProps", "inputProps", "inputRef", "onClear", "clearable", "clearButtonPosition", "openPickerButtonPosition", "openPickerAriaLabel"], _excluded4 = ["ownerState"], _excluded5 = ["ownerState"], _excluded6 = ["ownerState"], _excluded7 = ["ownerState"], _excluded8 = ["InputProps", "inputProps"], noop = () => {
}, cleanFieldResponse = (e) => {
  let {
    enableAccessibleFieldDOMStructure: t
  } = e, o = _objectWithoutPropertiesLoose(e, _excluded$k);
  if (t) {
    const {
      InputProps: $,
      readOnly: R,
      onClear: C,
      clearable: x,
      clearButtonPosition: _,
      openPickerButtonPosition: D,
      openPickerAriaLabel: O
    } = o, v = _objectWithoutPropertiesLoose(o, _excluded2$5), w = major >= 6 && v?.slotProps?.input ? mergeSlotProps(v?.slotProps?.input, $) : noop;
    return {
      clearable: x,
      onClear: C,
      clearButtonPosition: _,
      openPickerButtonPosition: D,
      openPickerAriaLabel: O,
      textFieldProps: _extends({}, v, major >= 6 && v?.slotProps?.input ? {
        slotProps: _extends({}, v?.slotProps, {
          input: (M) => _extends({}, resolveComponentProps(w, M), {
            readOnly: R
          })
        })
      } : {
        InputProps: _extends({}, $ ?? {}, {
          readOnly: R
        })
      })
    };
  }
  const {
    onPaste: n,
    onKeyDown: s,
    inputMode: i,
    readOnly: l,
    InputProps: d,
    inputProps: u,
    inputRef: c,
    onClear: p,
    clearable: f,
    clearButtonPosition: g,
    openPickerButtonPosition: y,
    openPickerAriaLabel: h
  } = o, T = _objectWithoutPropertiesLoose(o, _excluded3), P = major >= 6 && T?.slotProps?.input ? mergeSlotProps(T?.slotProps?.input, d) : noop, E = major >= 6 && T?.slotProps?.htmlInput ? mergeSlotProps(T?.slotProps?.htmlInput, u) : noop;
  return {
    clearable: f,
    onClear: p,
    clearButtonPosition: g,
    openPickerButtonPosition: y,
    openPickerAriaLabel: h,
    textFieldProps: _extends({}, T, major >= 6 && (T?.slotProps?.input || T?.slotProps?.htmlInput) ? {
      slotProps: _extends({}, T?.slotProps, {
        input: ($) => _extends({}, resolveComponentProps(P, $), {
          readOnly: l
        }),
        htmlInput: ($) => _extends({}, resolveComponentProps(E, $), {
          inputMode: i,
          onPaste: n,
          onKeyDown: s,
          ref: c
        })
      })
    } : {
      InputProps: _extends({}, d ?? {}, {
        readOnly: l
      }),
      inputProps: _extends({}, u ?? {}, {
        inputMode: i,
        onPaste: n,
        onKeyDown: s,
        ref: c
      })
    })
  };
}, PickerFieldUIContext = /* @__PURE__ */ React.createContext({
  slots: {},
  slotProps: {},
  inputRef: void 0
});
process.env.NODE_ENV !== "production" && (PickerFieldUIContext.displayName = "PickerFieldUIContext");
function PickerFieldUI(e) {
  const {
    fieldResponse: t,
    defaultOpenPickerIcon: o
  } = e, n = usePickerTranslations(), s = useNullablePickerContext(), i = React.useContext(PickerFieldUIContext), {
    textFieldProps: l,
    onClear: d,
    clearable: u,
    openPickerAriaLabel: c,
    clearButtonPosition: p = "end",
    openPickerButtonPosition: f = "end"
  } = cleanFieldResponse(t), g = useFieldOwnerState(l), y = useEventCallback((j) => {
    j.preventDefault(), s?.setOpen((A) => !A);
  }), h = s ? s.triggerStatus : "hidden", T = u ? p : null, P = h !== "hidden" ? f : null, E = i.slots.textField ?? (t.enableAccessibleFieldDOMStructure === !1 ? TextField : PickersTextField), $ = i.slots.inputAdornment ?? InputAdornment, R = useSlotProps({
    elementType: $,
    externalSlotProps: i.slotProps.inputAdornment,
    additionalProps: {
      position: "start"
    },
    ownerState: _extends({}, g, {
      position: "start"
    })
  }), C = _objectWithoutPropertiesLoose(R, _excluded4), x = useSlotProps({
    elementType: $,
    externalSlotProps: i.slotProps.inputAdornment,
    additionalProps: {
      position: "end"
    },
    ownerState: _extends({}, g, {
      position: "end"
    })
  }), _ = _objectWithoutPropertiesLoose(x, _excluded5), D = i.slots.openPickerButton ?? IconButton, O = useSlotProps({
    elementType: D,
    externalSlotProps: i.slotProps.openPickerButton,
    additionalProps: {
      disabled: h === "disabled",
      onClick: y,
      "aria-label": c,
      edge: (
        // open button is always rendered at the edge
        l.variant !== "standard" ? P : !1
      )
    },
    ownerState: g
  }), v = _objectWithoutPropertiesLoose(O, _excluded6), w = i.slots.openPickerIcon ?? o, M = useSlotProps({
    elementType: w,
    externalSlotProps: i.slotProps.openPickerIcon,
    ownerState: g
  }), S = i.slots.clearButton ?? IconButton, I = useSlotProps({
    elementType: S,
    externalSlotProps: i.slotProps.clearButton,
    className: "clearButton",
    additionalProps: {
      title: n.fieldClearLabel,
      tabIndex: -1,
      onClick: d,
      disabled: t.disabled || t.readOnly,
      edge: (
        // clear button can only be at the edge if it's position differs from the open button
        l.variant !== "standard" && T !== P ? T : !1
      )
    },
    ownerState: g
  }), N = _objectWithoutPropertiesLoose(I, _excluded7), F = i.slots.clearIcon ?? ClearIcon$1, L = useSlotProps({
    elementType: F,
    externalSlotProps: i.slotProps.clearIcon,
    additionalProps: {
      fontSize: "small"
    },
    ownerState: g
  });
  l.ref = useForkRef(l.ref, s?.rootRef);
  const k = {}, W = resolveComponentProps((major >= 6 && l?.slotProps?.input) ?? l.InputProps, g);
  s && (k.ref = s.triggerRef), !W?.startAdornment && (T === "start" || P === "start") && (k.startAdornment = /* @__PURE__ */ jsxRuntimeExports.jsxs($, _extends({}, C, {
    children: [P === "start" && /* @__PURE__ */ jsxRuntimeExports.jsx(D, _extends({}, v, {
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(w, _extends({}, M))
    })), T === "start" && /* @__PURE__ */ jsxRuntimeExports.jsx(S, _extends({}, N, {
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(F, _extends({}, L))
    }))]
  }))), !W?.endAdornment && (T === "end" || P === "end") && (k.endAdornment = /* @__PURE__ */ jsxRuntimeExports.jsxs($, _extends({}, _, {
    children: [T === "end" && /* @__PURE__ */ jsxRuntimeExports.jsx(S, _extends({}, N, {
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(F, _extends({}, L))
    })), P === "end" && /* @__PURE__ */ jsxRuntimeExports.jsx(D, _extends({}, v, {
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(w, _extends({}, M))
    }))]
  }))), !k?.endAdornment && !k?.startAdornment && i.slots.inputAdornment && (k.endAdornment = /* @__PURE__ */ jsxRuntimeExports.jsx($, _extends({}, _))), T != null && (l.sx = [{
    "& .clearButton": {
      opacity: 1
    },
    "@media (pointer: fine)": {
      "& .clearButton": {
        opacity: 0
      },
      "&:hover, &:focus-within": {
        ".clearButton": {
          opacity: 1
        }
      }
    }
  }, ...Array.isArray(l.sx) ? l.sx : [l.sx]]);
  const V = major >= 6 && l?.slotProps?.input ? resolveComponentProps(mergeSlotProps(W, k), g) : _extends({}, W, k);
  return l.inputProps = major >= 6 && l?.slotProps?.htmlInput ? resolveComponentProps(l.slotProps.htmlInput, g) : l.inputProps, delete l?.slotProps?.input, t.enableAccessibleFieldDOMStructure && delete l?.slotProps, /* @__PURE__ */ jsxRuntimeExports.jsx(E, _extends({}, l, {
    InputProps: V
  }));
}
function mergeSlotProps(e, t) {
  return e ? t ? (o) => _extends({}, resolveComponentProps(t, o), resolveComponentProps(e, o)) : e : t;
}
function useFieldTextFieldProps(e) {
  const {
    ref: t,
    externalForwardedProps: o,
    slotProps: n
  } = e, s = React.useContext(PickerFieldUIContext), i = useNullablePickerContext(), l = useFieldOwnerState(o), {
    InputProps: d,
    inputProps: u
  } = o, c = _objectWithoutPropertiesLoose(o, _excluded8), p = useSlotProps({
    elementType: PickersTextField,
    externalSlotProps: mergeSlotProps(s.slotProps.textField, n?.textField),
    externalForwardedProps: c,
    additionalProps: {
      ref: t,
      sx: i?.rootSx,
      label: i?.label,
      name: i?.name,
      className: i?.rootClassName,
      inputRef: s.inputRef
    },
    ownerState: l
  });
  return p.inputProps = _extends({}, u, p.inputProps), p.InputProps = _extends({}, d, p.InputProps), p;
}
function PickerFieldUIContextProvider(e) {
  const {
    slots: t = {},
    slotProps: o = {},
    inputRef: n,
    children: s
  } = e, i = React.useMemo(() => ({
    inputRef: n,
    slots: {
      openPickerButton: t.openPickerButton,
      openPickerIcon: t.openPickerIcon,
      textField: t.textField,
      inputAdornment: t.inputAdornment,
      clearIcon: t.clearIcon,
      clearButton: t.clearButton
    },
    slotProps: {
      openPickerButton: o.openPickerButton,
      openPickerIcon: o.openPickerIcon,
      textField: o.textField,
      inputAdornment: o.inputAdornment,
      clearIcon: o.clearIcon,
      clearButton: o.clearButton
    }
  }), [n, t.openPickerButton, t.openPickerIcon, t.textField, t.inputAdornment, t.clearIcon, t.clearButton, o.openPickerButton, o.openPickerIcon, o.textField, o.inputAdornment, o.clearIcon, o.clearButton]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(PickerFieldUIContext.Provider, {
    value: i,
    children: s
  });
}
const _excluded$j = ["slots", "slotProps"], DateField$1 = /* @__PURE__ */ React.forwardRef(function e(t, o) {
  const n = useThemeProps({
    props: t,
    name: "MuiDateField"
  }), {
    slots: s,
    slotProps: i
  } = n, l = _objectWithoutPropertiesLoose(n, _excluded$j), d = useFieldTextFieldProps({
    slotProps: i,
    ref: o,
    externalForwardedProps: l
  }), u = useDateField(d);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(PickerFieldUIContextProvider, {
    slots: s,
    slotProps: i,
    inputRef: l.inputRef,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(PickerFieldUI, {
      fieldResponse: u,
      defaultOpenPickerIcon: CalendarIcon
    })
  });
});
process.env.NODE_ENV !== "production" && (DateField$1.displayName = "DateField");
process.env.NODE_ENV !== "production" && (DateField$1.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * If `true`, the `input` element is focused during the first mount.
   * @default false
   */
  autoFocus: PropTypes.bool,
  className: PropTypes.string,
  /**
   * If `true`, a clear button will be shown in the field allowing value clearing.
   * @default false
   */
  clearable: PropTypes.bool,
  /**
   * The position at which the clear button is placed.
   * If the field is not clearable, the button is not rendered.
   * @default 'end'
   */
  clearButtonPosition: PropTypes.oneOf(["end", "start"]),
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: PropTypes.oneOf(["error", "info", "primary", "secondary", "success", "warning"]),
  component: PropTypes.elementType,
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.object,
  /**
   * If `true`, the component is disabled.
   * When disabled, the value cannot be changed and no interaction is possible.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: PropTypes.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: PropTypes.bool,
  /**
   * @default true
   */
  enableAccessibleFieldDOMStructure: PropTypes.bool,
  /**
   * If `true`, the component is displayed in focused state.
   */
  focused: PropTypes.bool,
  /**
   * Format of the date when rendered in the input(s).
   */
  format: PropTypes.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: PropTypes.oneOf(["dense", "spacious"]),
  /**
   * Props applied to the [`FormHelperText`](https://mui.com/material-ui/api/form-helper-text/) element.
   * @deprecated Use `slotProps.formHelperText` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  FormHelperTextProps: PropTypes.object,
  /**
   * If `true`, the input will take up the full width of its container.
   * @default false
   */
  fullWidth: PropTypes.bool,
  /**
   * The helper text content.
   */
  helperText: PropTypes.node,
  /**
   * If `true`, the label is hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   * @default false
   */
  hiddenLabel: PropTypes.bool,
  /**
   * The id of the `input` element.
   * Use this prop to make `label` and `helperText` accessible for screen readers.
   */
  id: PropTypes.string,
  /**
   * Props applied to the [`InputLabel`](https://mui.com/material-ui/api/input-label/) element.
   * Pointer events like `onClick` are enabled if and only if `shrink` is `true`.
   * @deprecated Use `slotProps.inputLabel` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  InputLabelProps: PropTypes.object,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#attributes) applied to the `input` element.
   * @deprecated Use `slotProps.htmlInput` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  inputProps: PropTypes.object,
  /**
   * Props applied to the Input element.
   * It will be a [`FilledInput`](https://mui.com/material-ui/api/filled-input/),
   * [`OutlinedInput`](https://mui.com/material-ui/api/outlined-input/) or [`Input`](https://mui.com/material-ui/api/input/)
   * component depending on the `variant` prop value.
   * @deprecated Use `slotProps.input` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  InputProps: PropTypes.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType,
  /**
   * The label content.
   */
  label: PropTypes.node,
  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   * @default 'none'
   */
  margin: PropTypes.oneOf(["dense", "none", "normal"]),
  /**
   * Maximal selectable date.
   * @default 2099-12-31
   */
  maxDate: PropTypes.object,
  /**
   * Minimal selectable date.
   * @default 1900-01-01
   */
  minDate: PropTypes.object,
  /**
   * Name attribute of the `input` element.
   */
  name: PropTypes.string,
  onBlur: PropTypes.func,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onChange: PropTypes.func,
  /**
   * Callback fired when the clear button is clicked.
   */
  onClear: PropTypes.func,
  /**
   * Callback fired when the error associated with the current value changes.
   * When a validation error is detected, the `error` parameter contains a non-null value.
   * This can be used to render an appropriate form error.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @param {TError} error The reason why the current value is not valid.
   * @param {TValue} value The value associated with the error.
   */
  onError: PropTypes.func,
  onFocus: PropTypes.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: PropTypes.func,
  /**
   * The position at which the opening button is placed.
   * If there is no Picker to open, the button is not rendered
   * @default 'end'
   */
  openPickerButtonPosition: PropTypes.oneOf(["end", "start"]),
  /**
   * If `true`, the component is read-only.
   * When read-only, the value cannot be changed but the user can interact with the interface.
   * @default false
   */
  readOnly: PropTypes.bool,
  /**
   * The date used to generate a part of the new value that is not present in the format when both `value` and `defaultValue` are empty.
   * For example, on time fields it will be used to determine the date to set.
   * @default The closest valid date using the validation props, except callbacks such as `shouldDisableDate`. Value is rounded to the most granular section used.
   */
  referenceDate: PropTypes.object,
  /**
   * If `true`, the label is displayed as required and the `input` element is required.
   * @default false
   */
  required: PropTypes.bool,
  /**
   * The currently selected sections.
   * This prop accepts four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 3. If `"all"` is provided, all the sections will be selected.
   * 4. If `null` is provided, no section will be selected.
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: PropTypes.oneOfType([PropTypes.oneOf(["all", "day", "empty", "hours", "meridiem", "minutes", "month", "seconds", "weekDay", "year"]), PropTypes.number]),
  /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (for example when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @param {PickerValidDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */
  shouldDisableDate: PropTypes.func,
  /**
   * Disable specific month.
   * @param {PickerValidDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */
  shouldDisableMonth: PropTypes.func,
  /**
   * Disable specific year.
   * @param {PickerValidDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */
  shouldDisableYear: PropTypes.func,
  /**
   * If `true`, the format will respect the leading zeroes (for example on dayjs, the format `M/D/YYYY` will render `8/16/2018`)
   * If `false`, the format will always add leading zeroes (for example on dayjs, the format `M/D/YYYY` will render `08/16/2018`)
   *
   * Warning n°1: Luxon is not able to respect the leading zeroes when using macro tokens (for example "DD"), so `shouldRespectLeadingZeros={true}` might lead to inconsistencies when using `AdapterLuxon`.
   *
   * Warning n°2: When `shouldRespectLeadingZeros={true}`, the field will add an invisible character on the sections containing a single digit to make sure `onChange` is fired.
   * If you need to get the clean value from the input, you can remove this character using `input.value.replace(/\u200e/g, '')`.
   *
   * Warning n°3: When used in strict mode, dayjs and moment require to respect the leading zeros.
   * This mean that when using `shouldRespectLeadingZeros={false}`, if you retrieve the value directly from the input (not listening to `onChange`) and your format contains tokens without leading zeros, the value will not be parsed by your library.
   *
   * @default false
   */
  shouldRespectLeadingZeros: PropTypes.bool,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: PropTypes.oneOf(["medium", "small"]),
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: PropTypes.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: PropTypes.object,
  style: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: PropTypes.string,
  /**
   * The ref object used to imperatively interact with the field.
   */
  unstableFieldRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: PropTypes.object,
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: PropTypes.oneOf(["filled", "outlined", "standard"])
});
const useIsDateDisabled = ({
  shouldDisableDate: e,
  shouldDisableMonth: t,
  shouldDisableYear: o,
  minDate: n,
  maxDate: s,
  disableFuture: i,
  disablePast: l,
  timezone: d
}) => {
  const u = usePickerAdapter();
  return React.useCallback((c) => validateDate({
    adapter: u,
    value: c,
    timezone: d,
    props: {
      shouldDisableDate: e,
      shouldDisableMonth: t,
      shouldDisableYear: o,
      minDate: n,
      maxDate: s,
      disableFuture: i,
      disablePast: l
    }
  }) !== null, [u, e, t, o, n, s, i, l, d]);
}, createCalendarStateReducer = (e, t) => (o, n) => {
  switch (n.type) {
    case "setVisibleDate":
      return _extends({}, o, {
        slideDirection: n.direction,
        currentMonth: n.month,
        isMonthSwitchingAnimating: !t.isSameMonth(n.month, o.currentMonth) && !e && !n.skipAnimation,
        focusedDay: n.focusedDay
      });
    case "changeMonthTimezone": {
      const s = n.newTimezone;
      if (t.getTimezone(o.currentMonth) === s)
        return o;
      let i = t.setTimezone(o.currentMonth, s);
      return t.getMonth(i) !== t.getMonth(o.currentMonth) && (i = t.setMonth(i, t.getMonth(o.currentMonth))), _extends({}, o, {
        currentMonth: i
      });
    }
    case "finishMonthSwitchingAnimation":
      return _extends({}, o, {
        isMonthSwitchingAnimating: !1
      });
    default:
      throw new Error("missing support");
  }
}, useCalendarState = (e) => {
  const {
    value: t,
    referenceDate: o,
    disableFuture: n,
    disablePast: s,
    maxDate: i,
    minDate: l,
    onMonthChange: d,
    onYearChange: u,
    reduceAnimations: c,
    shouldDisableDate: p,
    timezone: f,
    getCurrentMonthFromVisibleDate: g
  } = e, y = usePickerAdapter(), h = React.useRef(createCalendarStateReducer(!!c, y)).current, T = React.useMemo(
    () => singleItemValueManager.getInitialReferenceValue({
      value: t,
      adapter: y,
      timezone: f,
      props: e,
      referenceDate: o,
      granularity: SECTION_TYPE_GRANULARITY.day
    }),
    // We want the `referenceDate` to update on prop and `timezone` change (https://github.com/mui/mui-x/issues/10804)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [o, f]
  ), [P, E] = React.useReducer(h, {
    isMonthSwitchingAnimating: !1,
    focusedDay: T,
    currentMonth: y.startOfMonth(T),
    slideDirection: "left"
  }), $ = useIsDateDisabled({
    shouldDisableDate: p,
    minDate: l,
    maxDate: i,
    disableFuture: n,
    disablePast: s,
    timezone: f
  });
  React.useEffect(() => {
    E({
      type: "changeMonthTimezone",
      newTimezone: y.getTimezone(T)
    });
  }, [T, y]);
  const R = useEventCallback(({
    target: x,
    reason: _
  }) => {
    if (_ === "cell-interaction" && P.focusedDay != null && y.isSameDay(x, P.focusedDay))
      return;
    const D = _ === "cell-interaction";
    let O, v;
    if (_ === "cell-interaction")
      O = g(x, P.currentMonth), v = x;
    else if (O = y.isSameMonth(x, P.currentMonth) ? P.currentMonth : y.startOfMonth(x), v = x, $(v)) {
      const S = y.startOfMonth(x), I = y.endOfMonth(x);
      v = findClosestEnabledDate({
        adapter: y,
        date: v,
        minDate: y.isBefore(l, S) ? S : l,
        maxDate: y.isAfter(i, I) ? I : i,
        disablePast: s,
        disableFuture: n,
        isDateDisabled: $,
        timezone: f
      });
    }
    const w = !y.isSameMonth(P.currentMonth, O), M = !y.isSameYear(P.currentMonth, O);
    w && d?.(O), M && u?.(y.startOfYear(O)), E({
      type: "setVisibleDate",
      month: O,
      direction: y.isAfterDay(O, P.currentMonth) ? "left" : "right",
      focusedDay: P.focusedDay != null && v != null && y.isSameDay(v, P.focusedDay) ? P.focusedDay : v,
      skipAnimation: D
    });
  }), C = React.useCallback(() => {
    E({
      type: "finishMonthSwitchingAnimation"
    });
  }, []);
  return {
    referenceDate: T,
    calendarState: P,
    setVisibleDate: R,
    isDateDisabled: $,
    onMonthSwitchingAnimationEnd: C
  };
}, getPickersFadeTransitionGroupUtilityClass = (e) => generateUtilityClass("MuiPickersFadeTransitionGroup", e);
generateUtilityClasses("MuiPickersFadeTransitionGroup", ["root"]);
const _excluded$i = ["children"], useUtilityClasses$l = (e) => composeClasses({
  root: ["root"]
}, getPickersFadeTransitionGroupUtilityClass, e), PickersFadeTransitionGroupRoot = styled(TransitionGroup, {
  name: "MuiPickersFadeTransitionGroup",
  slot: "Root"
})({
  display: "block",
  position: "relative"
});
function PickersFadeTransitionGroup(e) {
  const t = useThemeProps({
    props: e,
    name: "MuiPickersFadeTransitionGroup"
  }), {
    className: o,
    reduceAnimations: n,
    transKey: s,
    classes: i
  } = t, {
    children: l
  } = t, d = _objectWithoutPropertiesLoose(t, _excluded$i), u = useUtilityClasses$l(i), c = useTheme();
  return n ? l : /* @__PURE__ */ jsxRuntimeExports.jsx(PickersFadeTransitionGroupRoot, {
    className: clsx(u.root, o),
    ownerState: d,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(Fade, {
      appear: !1,
      mountOnEnter: !0,
      unmountOnExit: !0,
      timeout: {
        appear: c.transitions.duration.enteringScreen,
        enter: c.transitions.duration.enteringScreen,
        exit: 0
      },
      children: l
    }, s)
  });
}
const getPickersSlideTransitionUtilityClass = (e) => generateUtilityClass("MuiPickersSlideTransition", e), pickersSlideTransitionClasses = generateUtilityClasses("MuiPickersSlideTransition", ["root", "slideEnter-left", "slideEnter-right", "slideEnterActive", "slideExit", "slideExitActiveLeft-left", "slideExitActiveLeft-right"]), _excluded$h = ["children", "className", "reduceAnimations", "slideDirection", "transKey", "classes"], useUtilityClasses$k = (e, t) => {
  const {
    slideDirection: o
  } = t, n = {
    root: ["root"],
    exit: ["slideExit"],
    enterActive: ["slideEnterActive"],
    enter: [`slideEnter-${o}`],
    exitActive: [`slideExitActiveLeft-${o}`]
  };
  return composeClasses(n, getPickersSlideTransitionUtilityClass, e);
}, PickersSlideTransitionRoot = styled(TransitionGroup, {
  name: "MuiPickersSlideTransition",
  slot: "Root",
  overridesResolver: (e, t) => [t.root, {
    [`.${pickersSlideTransitionClasses["slideEnter-left"]}`]: t["slideEnter-left"]
  }, {
    [`.${pickersSlideTransitionClasses["slideEnter-right"]}`]: t["slideEnter-right"]
  }, {
    [`.${pickersSlideTransitionClasses.slideEnterActive}`]: t.slideEnterActive
  }, {
    [`.${pickersSlideTransitionClasses.slideExit}`]: t.slideExit
  }, {
    [`.${pickersSlideTransitionClasses["slideExitActiveLeft-left"]}`]: t["slideExitActiveLeft-left"]
  }, {
    [`.${pickersSlideTransitionClasses["slideExitActiveLeft-right"]}`]: t["slideExitActiveLeft-right"]
  }]
})(({
  theme: e
}) => {
  const t = e.transitions.create("transform", {
    duration: e.transitions.duration.complex,
    easing: "cubic-bezier(0.35, 0.8, 0.4, 1)"
  });
  return {
    display: "block",
    position: "relative",
    overflowX: "hidden",
    "& > *": {
      position: "absolute",
      top: 0,
      right: 0,
      left: 0
    },
    [`& .${pickersSlideTransitionClasses["slideEnter-left"]}`]: {
      willChange: "transform",
      transform: "translate(100%)",
      zIndex: 1
    },
    [`& .${pickersSlideTransitionClasses["slideEnter-right"]}`]: {
      willChange: "transform",
      transform: "translate(-100%)",
      zIndex: 1
    },
    [`& .${pickersSlideTransitionClasses.slideEnterActive}`]: {
      transform: "translate(0%)",
      transition: t
    },
    [`& .${pickersSlideTransitionClasses.slideExit}`]: {
      transform: "translate(0%)"
    },
    [`& .${pickersSlideTransitionClasses["slideExitActiveLeft-left"]}`]: {
      willChange: "transform",
      transform: "translate(-100%)",
      transition: t,
      zIndex: 0
    },
    [`& .${pickersSlideTransitionClasses["slideExitActiveLeft-right"]}`]: {
      willChange: "transform",
      transform: "translate(100%)",
      transition: t,
      zIndex: 0
    }
  };
});
function PickersSlideTransition(e) {
  const t = useThemeProps({
    props: e,
    name: "MuiPickersSlideTransition"
  }), {
    children: o,
    className: n,
    reduceAnimations: s,
    slideDirection: i,
    transKey: l,
    classes: d
  } = t, u = _objectWithoutPropertiesLoose(t, _excluded$h), {
    ownerState: c
  } = usePickerPrivateContext(), p = _extends({}, c, {
    slideDirection: i
  }), f = useUtilityClasses$k(d, p), g = useTheme();
  if (s)
    return /* @__PURE__ */ jsxRuntimeExports.jsx("div", {
      className: clsx(f.root, n),
      children: o
    });
  const y = {
    exit: f.exit,
    enterActive: f.enterActive,
    enter: f.enter,
    exitActive: f.exitActive
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(PickersSlideTransitionRoot, {
    className: clsx(f.root, n),
    childFactory: (h) => /* @__PURE__ */ React.cloneElement(h, {
      classNames: y
    }),
    role: "presentation",
    ownerState: p,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(CSSTransition, _extends({
      mountOnEnter: !0,
      unmountOnExit: !0,
      timeout: g.transitions.duration.complex,
      classNames: y
    }, u, {
      children: o
    }), l)
  });
}
const getDayCalendarUtilityClass = (e) => generateUtilityClass("MuiDayCalendar", e);
generateUtilityClasses("MuiDayCalendar", ["root", "header", "weekDayLabel", "loadingContainer", "slideTransition", "monthContainer", "weekContainer", "weekNumberLabel", "weekNumber"]);
const _excluded$g = ["parentProps", "day", "focusedDay", "selectedDays", "isDateDisabled", "currentMonthNumber", "isViewFocused"], _excluded2$4 = ["ownerState"], useUtilityClasses$j = (e) => composeClasses({
  root: ["root"],
  header: ["header"],
  weekDayLabel: ["weekDayLabel"],
  loadingContainer: ["loadingContainer"],
  slideTransition: ["slideTransition"],
  monthContainer: ["monthContainer"],
  weekContainer: ["weekContainer"],
  weekNumberLabel: ["weekNumberLabel"],
  weekNumber: ["weekNumber"]
}, getDayCalendarUtilityClass, e), weeksContainerHeight = (DAY_SIZE + DAY_MARGIN * 2) * 6, PickersCalendarDayRoot = styled("div", {
  name: "MuiDayCalendar",
  slot: "Root"
})({}), PickersCalendarDayHeader = styled("div", {
  name: "MuiDayCalendar",
  slot: "Header"
})({
  display: "flex",
  justifyContent: "center",
  alignItems: "center"
}), PickersCalendarWeekDayLabel = styled(Typography, {
  name: "MuiDayCalendar",
  slot: "WeekDayLabel"
})(({
  theme: e
}) => ({
  width: 36,
  height: 40,
  margin: "0 2px",
  textAlign: "center",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  color: (e.vars || e).palette.text.secondary
})), PickersCalendarWeekNumberLabel = styled(Typography, {
  name: "MuiDayCalendar",
  slot: "WeekNumberLabel"
})(({
  theme: e
}) => ({
  width: 36,
  height: 40,
  margin: "0 2px",
  textAlign: "center",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  color: (e.vars || e).palette.text.disabled
})), PickersCalendarWeekNumber = styled(Typography, {
  name: "MuiDayCalendar",
  slot: "WeekNumber"
})(({
  theme: e
}) => _extends({}, e.typography.caption, {
  width: DAY_SIZE,
  height: DAY_SIZE,
  padding: 0,
  margin: `0 ${DAY_MARGIN}px`,
  color: (e.vars || e).palette.text.disabled,
  fontSize: "0.75rem",
  alignItems: "center",
  justifyContent: "center",
  display: "inline-flex"
})), PickersCalendarLoadingContainer = styled("div", {
  name: "MuiDayCalendar",
  slot: "LoadingContainer"
})({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  minHeight: weeksContainerHeight
}), PickersCalendarSlideTransition = styled(PickersSlideTransition, {
  name: "MuiDayCalendar",
  slot: "SlideTransition"
})({
  minHeight: weeksContainerHeight
}), PickersCalendarWeekContainer = styled("div", {
  name: "MuiDayCalendar",
  slot: "MonthContainer"
})({
  overflow: "hidden"
}), PickersCalendarWeek = styled("div", {
  name: "MuiDayCalendar",
  slot: "WeekContainer"
})({
  margin: `${DAY_MARGIN}px 0`,
  display: "flex",
  justifyContent: "center"
});
function WrappedDay(e) {
  let {
    parentProps: t,
    day: o,
    focusedDay: n,
    selectedDays: s,
    isDateDisabled: i,
    currentMonthNumber: l,
    isViewFocused: d
  } = e, u = _objectWithoutPropertiesLoose(e, _excluded$g);
  const {
    disabled: c,
    disableHighlightToday: p,
    isMonthSwitchingAnimating: f,
    showDaysOutsideCurrentMonth: g,
    slots: y,
    slotProps: h,
    timezone: T
  } = t, P = usePickerAdapter(), E = useNow(T), $ = n != null && P.isSameDay(o, n), R = d && $, C = s.some((N) => P.isSameDay(N, o)), x = P.isSameDay(o, E), _ = React.useMemo(() => c || i(o), [c, i, o]), D = React.useMemo(() => P.getMonth(o) !== l, [P, o, l]), O = usePickerDayOwnerState({
    day: o,
    selected: C,
    disabled: _,
    today: x,
    outsideCurrentMonth: D,
    disableMargin: void 0,
    // This prop can only be defined using slotProps.day so the ownerState for useSlotProps cannot have its value.
    disableHighlightToday: p,
    showDaysOutsideCurrentMonth: g
  }), v = y?.day ?? PickersDay, w = useSlotProps({
    elementType: v,
    externalSlotProps: h?.day,
    additionalProps: _extends({
      disableHighlightToday: p,
      showDaysOutsideCurrentMonth: g,
      role: "gridcell",
      isAnimating: f,
      // it is used in date range dragging logic by accessing `dataset.timestamp`
      "data-timestamp": P.toJsDate(o).valueOf()
    }, u),
    ownerState: _extends({}, O, {
      day: o,
      isDayDisabled: _,
      isDaySelected: C
    })
  }), M = _objectWithoutPropertiesLoose(w, _excluded2$4), S = React.useMemo(() => {
    const N = P.startOfMonth(P.setMonth(o, l));
    return g ? P.isSameDay(o, P.startOfWeek(N)) : P.isSameDay(o, N);
  }, [l, o, g, P]), I = React.useMemo(() => {
    const N = P.endOfMonth(P.setMonth(o, l));
    return g ? P.isSameDay(o, P.endOfWeek(N)) : P.isSameDay(o, N);
  }, [l, o, g, P]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(v, _extends({}, M, {
    day: o,
    disabled: _,
    autoFocus: !D && R,
    today: x,
    outsideCurrentMonth: D,
    isFirstVisibleCell: S,
    isLastVisibleCell: I,
    selected: C,
    tabIndex: $ ? 0 : -1,
    "aria-selected": C,
    "aria-current": x ? "date" : void 0
  }));
}
function DayCalendar(e) {
  const t = useThemeProps({
    props: e,
    name: "MuiDayCalendar"
  }), o = usePickerAdapter(), {
    onFocusedDayChange: n,
    className: s,
    classes: i,
    currentMonth: l,
    selectedDays: d,
    focusedDay: u,
    loading: c,
    onSelectedDaysChange: p,
    onMonthSwitchingAnimationEnd: f,
    readOnly: g,
    reduceAnimations: y,
    renderLoading: h = () => /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
      children: "..."
    }),
    slideDirection: T,
    TransitionProps: P,
    disablePast: E,
    disableFuture: $,
    minDate: R,
    maxDate: C,
    shouldDisableDate: x,
    shouldDisableMonth: _,
    shouldDisableYear: D,
    dayOfWeekFormatter: O = (q) => o.format(q, "weekdayShort").charAt(0).toUpperCase(),
    hasFocus: v,
    onFocusedViewChange: w,
    gridLabelId: M,
    displayWeekNumber: S,
    fixedWeekNumber: I,
    timezone: N
  } = t, F = useNow(N), L = useUtilityClasses$j(i), k = useRtl(), W = useIsDateDisabled({
    shouldDisableDate: x,
    shouldDisableMonth: _,
    shouldDisableYear: D,
    minDate: R,
    maxDate: C,
    disablePast: E,
    disableFuture: $,
    timezone: N
  }), V = usePickerTranslations(), j = useEventCallback((q) => {
    g || p(q);
  }), A = (q) => {
    W(q) || (n(q), w?.(!0));
  }, U = useEventCallback((q, B) => {
    switch (q.key) {
      case "ArrowUp":
        A(o.addDays(B, -7)), q.preventDefault();
        break;
      case "ArrowDown":
        A(o.addDays(B, 7)), q.preventDefault();
        break;
      case "ArrowLeft": {
        const ue = o.addDays(B, k ? 1 : -1), re = o.addMonths(B, k ? 1 : -1), be = findClosestEnabledDate({
          adapter: o,
          date: ue,
          minDate: k ? ue : o.startOfMonth(re),
          maxDate: k ? o.endOfMonth(re) : ue,
          isDateDisabled: W,
          timezone: N
        });
        A(be || ue), q.preventDefault();
        break;
      }
      case "ArrowRight": {
        const ue = o.addDays(B, k ? -1 : 1), re = o.addMonths(B, k ? -1 : 1), be = findClosestEnabledDate({
          adapter: o,
          date: ue,
          minDate: k ? o.startOfMonth(re) : ue,
          maxDate: k ? ue : o.endOfMonth(re),
          isDateDisabled: W,
          timezone: N
        });
        A(be || ue), q.preventDefault();
        break;
      }
      case "Home":
        A(o.startOfWeek(B)), q.preventDefault();
        break;
      case "End":
        A(o.endOfWeek(B)), q.preventDefault();
        break;
      case "PageUp":
        A(o.addMonths(B, 1)), q.preventDefault();
        break;
      case "PageDown":
        A(o.addMonths(B, -1)), q.preventDefault();
        break;
    }
  }), G = useEventCallback((q, B) => A(B)), Y = useEventCallback((q, B) => {
    u != null && o.isSameDay(u, B) && w?.(!1);
  }), ee = o.getMonth(l), J = o.getYear(l), Z = React.useMemo(() => d.filter((q) => !!q).map((q) => o.startOfDay(q)), [o, d]), le = `${J}-${ee}`, se = React.useMemo(() => /* @__PURE__ */ React.createRef(), [le]), K = React.useMemo(() => {
    const q = o.getWeekArray(l);
    let B = o.addMonths(l, 1);
    for (; I && q.length < I; ) {
      const ue = o.getWeekArray(B), re = o.isSameDay(q[q.length - 1][0], ue[0][0]);
      ue.slice(re ? 1 : 0).forEach((be) => {
        q.length < I && q.push(be);
      }), B = o.addMonths(B, 1);
    }
    return q;
  }, [l, I, o]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(PickersCalendarDayRoot, {
    role: "grid",
    "aria-labelledby": M,
    className: L.root,
    children: [/* @__PURE__ */ jsxRuntimeExports.jsxs(PickersCalendarDayHeader, {
      role: "row",
      className: L.header,
      children: [S && /* @__PURE__ */ jsxRuntimeExports.jsx(PickersCalendarWeekNumberLabel, {
        variant: "caption",
        role: "columnheader",
        "aria-label": V.calendarWeekNumberHeaderLabel,
        className: L.weekNumberLabel,
        children: V.calendarWeekNumberHeaderText
      }), getWeekdays(o, F).map((q, B) => /* @__PURE__ */ jsxRuntimeExports.jsx(PickersCalendarWeekDayLabel, {
        variant: "caption",
        role: "columnheader",
        "aria-label": o.format(q, "weekday"),
        className: L.weekDayLabel,
        children: O(q)
      }, B.toString()))]
    }), c ? /* @__PURE__ */ jsxRuntimeExports.jsx(PickersCalendarLoadingContainer, {
      className: L.loadingContainer,
      children: h()
    }) : /* @__PURE__ */ jsxRuntimeExports.jsx(PickersCalendarSlideTransition, _extends({
      transKey: le,
      onExited: f,
      reduceAnimations: y,
      slideDirection: T,
      className: clsx(s, L.slideTransition)
    }, P, {
      nodeRef: se,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(PickersCalendarWeekContainer, {
        ref: se,
        role: "rowgroup",
        className: L.monthContainer,
        children: K.map((q, B) => /* @__PURE__ */ jsxRuntimeExports.jsxs(PickersCalendarWeek, {
          role: "row",
          className: L.weekContainer,
          "aria-rowindex": B + 1,
          children: [S && /* @__PURE__ */ jsxRuntimeExports.jsx(PickersCalendarWeekNumber, {
            className: L.weekNumber,
            role: "rowheader",
            "aria-label": V.calendarWeekNumberAriaLabelText(o.getWeekNumber(q[0])),
            children: V.calendarWeekNumberText(o.getWeekNumber(q[0]))
          }), q.map((ue, re) => /* @__PURE__ */ jsxRuntimeExports.jsx(WrappedDay, {
            parentProps: t,
            day: ue,
            selectedDays: Z,
            isViewFocused: v,
            focusedDay: u,
            onKeyDown: U,
            onFocus: G,
            onBlur: Y,
            onDaySelect: j,
            isDateDisabled: W,
            currentMonthNumber: ee,
            "aria-colindex": re + 1
          }, ue.toString()))]
        }, `week-${q[0]}`))
      })
    }))]
  });
}
function getMonthCalendarUtilityClass(e) {
  return generateUtilityClass("MuiMonthCalendar", e);
}
const monthCalendarClasses = generateUtilityClasses("MuiMonthCalendar", ["root", "button", "disabled", "selected"]), _excluded$f = ["autoFocus", "classes", "disabled", "selected", "value", "onClick", "onKeyDown", "onFocus", "onBlur", "slots", "slotProps"], useUtilityClasses$i = (e, t) => {
  const o = {
    button: ["button", t.isMonthDisabled && "disabled", t.isMonthSelected && "selected"]
  };
  return composeClasses(o, getMonthCalendarUtilityClass, e);
}, DefaultMonthButton = styled("button", {
  name: "MuiMonthCalendar",
  slot: "Button",
  overridesResolver: (e, t) => [t.button, {
    [`&.${monthCalendarClasses.disabled}`]: t.disabled
  }, {
    [`&.${monthCalendarClasses.selected}`]: t.selected
  }]
})(({
  theme: e
}) => _extends({
  color: "unset",
  backgroundColor: "transparent",
  border: 0,
  outline: 0
}, e.typography.subtitle1, {
  height: 36,
  width: 72,
  borderRadius: 18,
  cursor: "pointer",
  "&:focus": {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.action.activeChannel} / ${e.vars.palette.action.hoverOpacity})` : alpha$1(e.palette.action.active, e.palette.action.hoverOpacity)
  },
  "&:hover": {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.action.activeChannel} / ${e.vars.palette.action.hoverOpacity})` : alpha$1(e.palette.action.active, e.palette.action.hoverOpacity)
  },
  "&:disabled": {
    cursor: "auto",
    pointerEvents: "none"
  },
  [`&.${monthCalendarClasses.disabled}`]: {
    color: (e.vars || e).palette.text.secondary
  },
  [`&.${monthCalendarClasses.selected}`]: {
    color: (e.vars || e).palette.primary.contrastText,
    backgroundColor: (e.vars || e).palette.primary.main,
    "&:focus, &:hover": {
      backgroundColor: (e.vars || e).palette.primary.dark
    }
  }
})), MonthCalendarButton = /* @__PURE__ */ React.memo(function e(t) {
  const {
    autoFocus: o,
    classes: n,
    disabled: s,
    selected: i,
    value: l,
    onClick: d,
    onKeyDown: u,
    onFocus: c,
    onBlur: p,
    slots: f,
    slotProps: g
  } = t, y = _objectWithoutPropertiesLoose(t, _excluded$f), h = React.useRef(null), {
    ownerState: T
  } = usePickerPrivateContext(), P = _extends({}, T, {
    isMonthDisabled: s,
    isMonthSelected: i
  }), E = useUtilityClasses$i(n, P);
  useEnhancedEffect(() => {
    o && h.current?.focus();
  }, [o]);
  const $ = f?.monthButton ?? DefaultMonthButton, R = useSlotProps({
    elementType: $,
    externalSlotProps: g?.monthButton,
    externalForwardedProps: y,
    additionalProps: {
      disabled: s,
      ref: h,
      type: "button",
      role: "radio",
      "aria-checked": i,
      onClick: (C) => d(C, l),
      onKeyDown: (C) => u(C, l),
      onFocus: (C) => c(C, l),
      onBlur: (C) => p(C, l)
    },
    ownerState: P,
    className: E.button
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx($, _extends({}, R));
});
process.env.NODE_ENV !== "production" && (MonthCalendarButton.displayName = "MonthCalendarButton");
const _excluded$e = ["autoFocus", "className", "currentMonth", "classes", "value", "defaultValue", "referenceDate", "disabled", "disableFuture", "disablePast", "maxDate", "minDate", "onChange", "shouldDisableMonth", "readOnly", "disableHighlightToday", "onMonthFocus", "hasFocus", "onFocusedViewChange", "monthsPerRow", "timezone", "gridLabelId", "slots", "slotProps"], useUtilityClasses$h = (e) => composeClasses({
  root: ["root"]
}, getMonthCalendarUtilityClass, e);
function useMonthCalendarDefaultizedProps(e, t) {
  const o = useThemeProps({
    props: e,
    name: t
  }), n = useApplyDefaultValuesToDateValidationProps(o);
  return _extends({}, o, n, {
    monthsPerRow: o.monthsPerRow ?? 3
  });
}
const isSameMonth = (e, t, o, n, s) => !!(e === t && n && s.isSameYear(o, n)), MonthCalendarRoot = styled("div", {
  name: "MuiMonthCalendar",
  slot: "Root",
  shouldForwardProp: (e) => shouldForwardProp(e) && e !== "monthsPerRow"
})({
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "space-evenly",
  rowGap: 16,
  padding: "8px 0",
  width: DIALOG_WIDTH,
  // avoid padding increasing width over defined
  boxSizing: "border-box",
  variants: [{
    props: {
      monthsPerRow: 3
    },
    style: {
      columnGap: 24
    }
  }, {
    props: {
      monthsPerRow: 4
    },
    style: {
      columnGap: 0
    }
  }]
}), MonthCalendar = /* @__PURE__ */ React.forwardRef(function e(t, o) {
  const n = useMonthCalendarDefaultizedProps(t, "MuiMonthCalendar"), {
    autoFocus: s,
    className: i,
    currentMonth: l,
    classes: d,
    value: u,
    defaultValue: c,
    referenceDate: p,
    disabled: f,
    disableFuture: g,
    disablePast: y,
    maxDate: h,
    minDate: T,
    onChange: P,
    shouldDisableMonth: E,
    readOnly: $,
    onMonthFocus: R,
    hasFocus: C,
    onFocusedViewChange: x,
    monthsPerRow: _,
    timezone: D,
    gridLabelId: O,
    slots: v,
    slotProps: w
  } = n, M = _objectWithoutPropertiesLoose(n, _excluded$e), {
    value: S,
    handleValueChange: I,
    timezone: N
  } = useControlledValue({
    name: "MonthCalendar",
    timezone: D,
    value: u,
    defaultValue: c,
    referenceDate: p,
    onChange: P,
    valueManager: singleItemValueManager
  }), F = useNow(N), L = useRtl(), k = usePickerAdapter(), {
    ownerState: W
  } = usePickerPrivateContext(), V = React.useMemo(
    () => singleItemValueManager.getInitialReferenceValue({
      value: S,
      adapter: k,
      props: n,
      timezone: N,
      referenceDate: p,
      granularity: SECTION_TYPE_GRANULARITY.month
    }),
    []
    // eslint-disable-line react-hooks/exhaustive-deps
  ), j = useUtilityClasses$h(d), A = React.useMemo(() => k.getMonth(F), [k, F]), U = React.useMemo(() => S != null ? k.getMonth(S) : null, [S, k]), [G, Y] = React.useState(() => U || k.getMonth(V)), [ee, J] = useControlled({
    name: "MonthCalendar",
    state: "hasFocus",
    controlled: C,
    default: s ?? !1
  }), Z = useEventCallback((re) => {
    J(re), x && x(re);
  }), le = React.useCallback((re) => {
    const be = k.startOfMonth(y && k.isAfter(F, T) ? F : T), X = k.startOfMonth(g && k.isBefore(F, h) ? F : h), ge = k.startOfMonth(re);
    return k.isBefore(ge, be) || k.isAfter(ge, X) ? !0 : E ? E(ge) : !1;
  }, [g, y, h, T, F, E, k]), se = useEventCallback((re, be) => {
    if ($)
      return;
    const X = S && l && !k.isSameYear(S, l) ? k.setYear(S, k.getYear(l)) : S, ge = k.setMonth(X ?? V, be);
    I(ge);
  }), K = useEventCallback((re) => {
    le(k.setMonth(S ?? l ?? V, re)) || (Y(re), Z(!0), R && R(re));
  });
  React.useEffect(() => {
    Y((re) => U !== null && re !== U ? U : re);
  }, [U]);
  const q = useEventCallback((re, be) => {
    switch (re.key) {
      case "ArrowUp":
        K((12 + be - 3) % 12), re.preventDefault();
        break;
      case "ArrowDown":
        K((12 + be + 3) % 12), re.preventDefault();
        break;
      case "ArrowLeft":
        K((12 + be + (L ? 1 : -1)) % 12), re.preventDefault();
        break;
      case "ArrowRight":
        K((12 + be + (L ? -1 : 1)) % 12), re.preventDefault();
        break;
    }
  }), B = useEventCallback((re, be) => {
    K(be);
  }), ue = useEventCallback((re, be) => {
    G === be && Z(!1);
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(MonthCalendarRoot, _extends({
    ref: o,
    className: clsx(j.root, i),
    ownerState: W,
    role: "radiogroup",
    "aria-labelledby": O,
    monthsPerRow: _
  }, M, {
    children: getMonthsInYear(k, l ?? S ?? V).map((re) => {
      const be = k.getMonth(re), X = k.format(re, "monthShort"), ge = k.format(re, "month"), Ee = isSameMonth(be, U, re, S, k), xe = f || le(re);
      return /* @__PURE__ */ jsxRuntimeExports.jsx(MonthCalendarButton, {
        selected: Ee,
        value: be,
        onClick: se,
        onKeyDown: q,
        autoFocus: ee && be === G,
        disabled: xe,
        tabIndex: be === G && !xe ? 0 : -1,
        onFocus: B,
        onBlur: ue,
        "aria-current": isSameMonth(be, A, re, F, k) ? "date" : void 0,
        "aria-label": ge,
        slots: v,
        slotProps: w,
        classes: d,
        children: X
      }, X);
    })
  }));
});
process.env.NODE_ENV !== "production" && (MonthCalendar.displayName = "MonthCalendar");
process.env.NODE_ENV !== "production" && (MonthCalendar.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  autoFocus: PropTypes.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  className: PropTypes.string,
  currentMonth: PropTypes.object,
  /**
   * The default selected value.
   * Used when the component is not controlled.
   */
  defaultValue: PropTypes.object,
  /**
   * If `true`, the component is disabled.
   * When disabled, the value cannot be changed and no interaction is possible.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: PropTypes.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: PropTypes.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: PropTypes.bool,
  gridLabelId: PropTypes.string,
  hasFocus: PropTypes.bool,
  /**
   * Maximal selectable date.
   * @default 2099-12-31
   */
  maxDate: PropTypes.object,
  /**
   * Minimal selectable date.
   * @default 1900-01-01
   */
  minDate: PropTypes.object,
  /**
   * Months rendered per row.
   * @default 3
   */
  monthsPerRow: PropTypes.oneOf([3, 4]),
  /**
   * Callback fired when the value changes.
   * @param {PickerValidDate} value The new value.
   */
  onChange: PropTypes.func,
  onFocusedViewChange: PropTypes.func,
  onMonthFocus: PropTypes.func,
  /**
   * If `true`, the component is read-only.
   * When read-only, the value cannot be changed but the user can interact with the interface.
   * @default false
   */
  readOnly: PropTypes.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid month using the validation props, except callbacks such as `shouldDisableMonth`.
   */
  referenceDate: PropTypes.object,
  /**
   * Disable specific month.
   * @param {PickerValidDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */
  shouldDisableMonth: PropTypes.func,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: PropTypes.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: PropTypes.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: PropTypes.object
});
function getYearCalendarUtilityClass(e) {
  return generateUtilityClass("MuiYearCalendar", e);
}
const yearCalendarClasses = generateUtilityClasses("MuiYearCalendar", ["root", "button", "disabled", "selected"]), _excluded$d = ["autoFocus", "classes", "disabled", "selected", "value", "onClick", "onKeyDown", "onFocus", "onBlur", "slots", "slotProps"], useUtilityClasses$g = (e, t) => {
  const o = {
    button: ["button", t.isYearDisabled && "disabled", t.isYearSelected && "selected"]
  };
  return composeClasses(o, getYearCalendarUtilityClass, e);
}, DefaultYearButton = styled("button", {
  name: "MuiYearCalendar",
  slot: "Button",
  overridesResolver: (e, t) => [t.button, {
    [`&.${yearCalendarClasses.disabled}`]: t.disabled
  }, {
    [`&.${yearCalendarClasses.selected}`]: t.selected
  }]
})(({
  theme: e
}) => _extends({
  color: "unset",
  backgroundColor: "transparent",
  border: 0,
  outline: 0
}, e.typography.subtitle1, {
  height: 36,
  width: 72,
  borderRadius: 18,
  cursor: "pointer",
  "&:focus": {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.action.activeChannel} / ${e.vars.palette.action.focusOpacity})` : alpha$1(e.palette.action.active, e.palette.action.focusOpacity)
  },
  "&:hover": {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.action.activeChannel} / ${e.vars.palette.action.hoverOpacity})` : alpha$1(e.palette.action.active, e.palette.action.hoverOpacity)
  },
  "&:disabled": {
    cursor: "auto",
    pointerEvents: "none"
  },
  [`&.${yearCalendarClasses.disabled}`]: {
    color: (e.vars || e).palette.text.secondary
  },
  [`&.${yearCalendarClasses.selected}`]: {
    color: (e.vars || e).palette.primary.contrastText,
    backgroundColor: (e.vars || e).palette.primary.main,
    "&:focus, &:hover": {
      backgroundColor: (e.vars || e).palette.primary.dark
    }
  }
})), YearCalendarButton = /* @__PURE__ */ React.memo(function e(t) {
  const {
    autoFocus: o,
    classes: n,
    disabled: s,
    selected: i,
    value: l,
    onClick: d,
    onKeyDown: u,
    onFocus: c,
    onBlur: p,
    slots: f,
    slotProps: g
  } = t, y = _objectWithoutPropertiesLoose(t, _excluded$d), h = React.useRef(null), {
    ownerState: T
  } = usePickerPrivateContext(), P = _extends({}, T, {
    isYearDisabled: s,
    isYearSelected: i
  }), E = useUtilityClasses$g(n, P);
  useEnhancedEffect(() => {
    o && h.current?.focus();
  }, [o]);
  const $ = f?.yearButton ?? DefaultYearButton, R = useSlotProps({
    elementType: $,
    externalSlotProps: g?.yearButton,
    externalForwardedProps: y,
    additionalProps: {
      disabled: s,
      ref: h,
      type: "button",
      role: "radio",
      "aria-checked": i,
      onClick: (C) => d(C, l),
      onKeyDown: (C) => u(C, l),
      onFocus: (C) => c(C, l),
      onBlur: (C) => p(C, l)
    },
    ownerState: P,
    className: E.button
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx($, _extends({}, R));
});
process.env.NODE_ENV !== "production" && (YearCalendarButton.displayName = "YearCalendarButton");
const _excluded$c = ["autoFocus", "className", "classes", "value", "defaultValue", "referenceDate", "disabled", "disableFuture", "disablePast", "maxDate", "minDate", "onChange", "readOnly", "shouldDisableYear", "disableHighlightToday", "onYearFocus", "hasFocus", "onFocusedViewChange", "yearsOrder", "yearsPerRow", "timezone", "gridLabelId", "slots", "slotProps"], useUtilityClasses$f = (e) => composeClasses({
  root: ["root"]
}, getYearCalendarUtilityClass, e);
function useYearCalendarDefaultizedProps(e, t) {
  const o = useThemeProps({
    props: e,
    name: t
  }), n = useApplyDefaultValuesToDateValidationProps(o);
  return _extends({}, o, n, {
    yearsPerRow: o.yearsPerRow ?? 3,
    yearsOrder: o.yearsOrder ?? "asc"
  });
}
const YearCalendarRoot = styled("div", {
  name: "MuiYearCalendar",
  slot: "Root",
  shouldForwardProp: (e) => shouldForwardProp(e) && e !== "yearsPerRow"
})({
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "space-evenly",
  rowGap: 12,
  padding: "6px 0",
  overflowY: "auto",
  height: "100%",
  width: DIALOG_WIDTH,
  maxHeight: MAX_CALENDAR_HEIGHT,
  // avoid padding increasing width over defined
  boxSizing: "border-box",
  position: "relative",
  variants: [{
    props: {
      yearsPerRow: 3
    },
    style: {
      columnGap: 24
    }
  }, {
    props: {
      yearsPerRow: 4
    },
    style: {
      columnGap: 0,
      padding: "0 2px"
    }
  }]
}), YearCalendarButtonFiller = styled("div", {
  name: "MuiYearCalendar",
  slot: "ButtonFiller"
})({
  height: 36,
  width: 72
}), YearCalendar = /* @__PURE__ */ React.forwardRef(function e(t, o) {
  const n = useYearCalendarDefaultizedProps(t, "MuiYearCalendar"), {
    autoFocus: s,
    className: i,
    classes: l,
    value: d,
    defaultValue: u,
    referenceDate: c,
    disabled: p,
    disableFuture: f,
    disablePast: g,
    maxDate: y,
    minDate: h,
    onChange: T,
    readOnly: P,
    shouldDisableYear: E,
    onYearFocus: $,
    hasFocus: R,
    onFocusedViewChange: C,
    yearsOrder: x,
    yearsPerRow: _,
    timezone: D,
    gridLabelId: O,
    slots: v,
    slotProps: w
  } = n, M = _objectWithoutPropertiesLoose(n, _excluded$c), {
    value: S,
    handleValueChange: I,
    timezone: N
  } = useControlledValue({
    name: "YearCalendar",
    timezone: D,
    value: d,
    defaultValue: u,
    referenceDate: c,
    onChange: T,
    valueManager: singleItemValueManager
  }), F = useNow(N), L = useRtl(), k = usePickerAdapter(), {
    ownerState: W
  } = usePickerPrivateContext(), V = React.useMemo(
    () => singleItemValueManager.getInitialReferenceValue({
      value: S,
      adapter: k,
      props: n,
      timezone: N,
      referenceDate: c,
      granularity: SECTION_TYPE_GRANULARITY.year
    }),
    []
    // eslint-disable-line react-hooks/exhaustive-deps
  ), j = useUtilityClasses$f(l), A = React.useMemo(() => k.getYear(F), [k, F]), U = React.useMemo(() => S != null ? k.getYear(S) : null, [S, k]), [G, Y] = React.useState(() => U || k.getYear(V)), [ee, J] = useControlled({
    name: "YearCalendar",
    state: "hasFocus",
    controlled: R,
    default: s ?? !1
  }), Z = useEventCallback((he) => {
    J(he), C && C(he);
  }), le = React.useCallback((he) => {
    if (g && k.isBeforeYear(he, F) || f && k.isAfterYear(he, F) || h && k.isBeforeYear(he, h) || y && k.isAfterYear(he, y))
      return !0;
    if (!E)
      return !1;
    const Pe = k.startOfYear(he);
    return E(Pe);
  }, [f, g, y, h, F, E, k]), se = useEventCallback((he, Pe) => {
    if (P)
      return;
    const ye = k.setYear(S ?? V, Pe);
    I(ye);
  }), K = useEventCallback((he) => {
    le(k.setYear(S ?? V, he)) || (Y(he), Z(!0), $?.(he));
  });
  React.useEffect(() => {
    Y((he) => U !== null && he !== U ? U : he);
  }, [U]);
  const q = x !== "desc" ? _ * 1 : _ * -1, B = L && x === "asc" || !L && x === "desc" ? -1 : 1, ue = useEventCallback((he, Pe) => {
    switch (he.key) {
      case "ArrowUp":
        K(Pe - q), he.preventDefault();
        break;
      case "ArrowDown":
        K(Pe + q), he.preventDefault();
        break;
      case "ArrowLeft":
        K(Pe - B), he.preventDefault();
        break;
      case "ArrowRight":
        K(Pe + B), he.preventDefault();
        break;
    }
  }), re = useEventCallback((he, Pe) => {
    K(Pe);
  }), be = useEventCallback((he, Pe) => {
    G === Pe && Z(!1);
  }), X = React.useRef(null), ge = useForkRef(o, X);
  React.useEffect(() => {
    if (s || X.current === null)
      return;
    const he = X.current.querySelector('[tabindex="0"]');
    if (!he)
      return;
    const Pe = he.offsetHeight, ye = he.offsetTop, _e = X.current.clientHeight, Ce = X.current.scrollTop, ne = ye + Pe;
    Pe > _e || ye < Ce || (X.current.scrollTop = ne - _e / 2 - Pe / 2);
  }, [s]);
  const Ee = k.getYearRange([h, y]);
  x === "desc" && Ee.reverse();
  let xe = _ - Ee.length % _;
  return xe === _ && (xe = 0), /* @__PURE__ */ jsxRuntimeExports.jsxs(YearCalendarRoot, _extends({
    ref: ge,
    className: clsx(j.root, i),
    ownerState: W,
    role: "radiogroup",
    "aria-labelledby": O,
    yearsPerRow: _
  }, M, {
    children: [Ee.map((he) => {
      const Pe = k.getYear(he), ye = Pe === U, _e = p || le(he);
      return /* @__PURE__ */ jsxRuntimeExports.jsx(YearCalendarButton, {
        selected: ye,
        value: Pe,
        onClick: se,
        onKeyDown: ue,
        autoFocus: ee && Pe === G,
        disabled: _e,
        tabIndex: Pe === G && !_e ? 0 : -1,
        onFocus: re,
        onBlur: be,
        "aria-current": A === Pe ? "date" : void 0,
        slots: v,
        slotProps: w,
        classes: l,
        children: k.format(he, "year")
      }, k.format(he, "year"));
    }), Array.from({
      length: xe
    }, (he, Pe) => /* @__PURE__ */ jsxRuntimeExports.jsx(YearCalendarButtonFiller, {}, Pe))]
  }));
});
process.env.NODE_ENV !== "production" && (YearCalendar.displayName = "YearCalendar");
process.env.NODE_ENV !== "production" && (YearCalendar.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  autoFocus: PropTypes.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  className: PropTypes.string,
  /**
   * The default selected value.
   * Used when the component is not controlled.
   */
  defaultValue: PropTypes.object,
  /**
   * If `true`, the component is disabled.
   * When disabled, the value cannot be changed and no interaction is possible.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: PropTypes.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: PropTypes.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: PropTypes.bool,
  gridLabelId: PropTypes.string,
  hasFocus: PropTypes.bool,
  /**
   * Maximal selectable date.
   * @default 2099-12-31
   */
  maxDate: PropTypes.object,
  /**
   * Minimal selectable date.
   * @default 1900-01-01
   */
  minDate: PropTypes.object,
  /**
   * Callback fired when the value changes.
   * @param {PickerValidDate} value The new value.
   */
  onChange: PropTypes.func,
  onFocusedViewChange: PropTypes.func,
  onYearFocus: PropTypes.func,
  /**
   * If `true`, the component is read-only.
   * When read-only, the value cannot be changed but the user can interact with the interface.
   * @default false
   */
  readOnly: PropTypes.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid year using the validation props, except callbacks such as `shouldDisableYear`.
   */
  referenceDate: PropTypes.object,
  /**
   * Disable specific year.
   * @param {PickerValidDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */
  shouldDisableYear: PropTypes.func,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: PropTypes.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: PropTypes.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: PropTypes.object,
  /**
   * Years are displayed in ascending (chronological) order by default.
   * If `desc`, years are displayed in descending order.
   * @default 'asc'
   */
  yearsOrder: PropTypes.oneOf(["asc", "desc"]),
  /**
   * Years rendered per row.
   * @default 3
   */
  yearsPerRow: PropTypes.oneOf([3, 4])
});
const getPickersCalendarHeaderUtilityClass = (e) => generateUtilityClass("MuiPickersCalendarHeader", e), pickersCalendarHeaderClasses = generateUtilityClasses("MuiPickersCalendarHeader", ["root", "labelContainer", "label", "switchViewButton", "switchViewIcon"]), _excluded$b = ["slots", "slotProps", "currentMonth", "disabled", "disableFuture", "disablePast", "maxDate", "minDate", "onMonthChange", "onViewChange", "view", "reduceAnimations", "views", "labelId", "className", "classes", "timezone", "format"], _excluded2$3 = ["ownerState"], useUtilityClasses$e = (e) => composeClasses({
  root: ["root"],
  labelContainer: ["labelContainer"],
  label: ["label"],
  switchViewButton: ["switchViewButton"],
  switchViewIcon: ["switchViewIcon"]
}, getPickersCalendarHeaderUtilityClass, e), PickersCalendarHeaderRoot = styled("div", {
  name: "MuiPickersCalendarHeader",
  slot: "Root"
})({
  display: "flex",
  alignItems: "center",
  marginTop: 12,
  marginBottom: 4,
  paddingLeft: 24,
  paddingRight: 12,
  // prevent jumping in safari
  maxHeight: 40,
  minHeight: 40
}), PickersCalendarHeaderLabelContainer = styled("div", {
  name: "MuiPickersCalendarHeader",
  slot: "LabelContainer"
})(({
  theme: e
}) => _extends({
  display: "flex",
  overflow: "hidden",
  alignItems: "center",
  cursor: "pointer",
  marginRight: "auto"
}, e.typography.body1, {
  fontWeight: e.typography.fontWeightMedium
})), PickersCalendarHeaderLabel = styled("div", {
  name: "MuiPickersCalendarHeader",
  slot: "Label"
})({
  marginRight: 6
}), PickersCalendarHeaderSwitchViewButton = styled(IconButton, {
  name: "MuiPickersCalendarHeader",
  slot: "SwitchViewButton"
})({
  marginRight: "auto",
  variants: [{
    props: {
      view: "year"
    },
    style: {
      [`.${pickersCalendarHeaderClasses.switchViewIcon}`]: {
        transform: "rotate(180deg)"
      }
    }
  }]
}), PickersCalendarHeaderSwitchViewIcon = styled(ArrowDropDownIcon$1, {
  name: "MuiPickersCalendarHeader",
  slot: "SwitchViewIcon"
})(({
  theme: e
}) => ({
  willChange: "transform",
  transition: e.transitions.create("transform"),
  transform: "rotate(0deg)"
})), PickersCalendarHeader = /* @__PURE__ */ React.forwardRef(function e(t, o) {
  const n = usePickerTranslations(), s = usePickerAdapter(), i = useThemeProps({
    props: t,
    name: "MuiPickersCalendarHeader"
  }), {
    slots: l,
    slotProps: d,
    currentMonth: u,
    disabled: c,
    disableFuture: p,
    disablePast: f,
    maxDate: g,
    minDate: y,
    onMonthChange: h,
    onViewChange: T,
    view: P,
    reduceAnimations: E,
    views: $,
    labelId: R,
    className: C,
    classes: x,
    timezone: _,
    format: D = `${s.formats.month} ${s.formats.year}`
  } = i, O = _objectWithoutPropertiesLoose(i, _excluded$b), {
    ownerState: v
  } = usePickerPrivateContext(), w = useUtilityClasses$e(x), M = l?.switchViewButton ?? PickersCalendarHeaderSwitchViewButton, S = useSlotProps({
    elementType: M,
    externalSlotProps: d?.switchViewButton,
    additionalProps: {
      size: "small",
      "aria-label": n.calendarViewSwitchingButtonAriaLabel(P)
    },
    ownerState: _extends({}, v, {
      view: P
    }),
    className: w.switchViewButton
  }), I = l?.switchViewIcon ?? PickersCalendarHeaderSwitchViewIcon, N = useSlotProps({
    elementType: I,
    externalSlotProps: d?.switchViewIcon,
    ownerState: v,
    className: w.switchViewIcon
  }), F = _objectWithoutPropertiesLoose(N, _excluded2$3), L = () => h(s.addMonths(u, 1)), k = () => h(s.addMonths(u, -1)), W = useNextMonthDisabled(u, {
    disableFuture: p,
    maxDate: g,
    timezone: _
  }), V = usePreviousMonthDisabled(u, {
    disablePast: f,
    minDate: y,
    timezone: _
  }), j = () => {
    if (!($.length === 1 || !T || c))
      if ($.length === 2)
        T($.find((U) => U !== P) || $[0]);
      else {
        const U = $.indexOf(P) !== 0 ? 0 : 1;
        T($[U]);
      }
  };
  if ($.length === 1 && $[0] === "year")
    return null;
  const A = s.formatByString(u, D);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(PickersCalendarHeaderRoot, _extends({}, O, {
    ownerState: v,
    className: clsx(w.root, C),
    ref: o,
    children: [/* @__PURE__ */ jsxRuntimeExports.jsxs(PickersCalendarHeaderLabelContainer, {
      role: "presentation",
      onClick: j,
      ownerState: v,
      "aria-live": "polite",
      className: w.labelContainer,
      children: [/* @__PURE__ */ jsxRuntimeExports.jsx(PickersFadeTransitionGroup, {
        reduceAnimations: E,
        transKey: A,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(PickersCalendarHeaderLabel, {
          id: R,
          ownerState: v,
          className: w.label,
          children: A
        })
      }), $.length > 1 && !c && /* @__PURE__ */ jsxRuntimeExports.jsx(M, _extends({}, S, {
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(I, _extends({}, F))
      }))]
    }), /* @__PURE__ */ jsxRuntimeExports.jsx(Fade, {
      in: P === "day",
      appear: !E,
      enter: !E,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(PickersArrowSwitcher, {
        slots: l,
        slotProps: d,
        onGoToPrevious: k,
        isPreviousDisabled: V,
        previousLabel: n.previousMonth,
        onGoToNext: L,
        isNextDisabled: W,
        nextLabel: n.nextMonth
      })
    })]
  }));
});
process.env.NODE_ENV !== "production" && (PickersCalendarHeader.displayName = "PickersCalendarHeader");
process.env.NODE_ENV !== "production" && (PickersCalendarHeader.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  className: PropTypes.string,
  currentMonth: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
  disableFuture: PropTypes.bool,
  disablePast: PropTypes.bool,
  /**
   * Format used to display the date.
   * @default `${adapter.formats.month} ${adapter.formats.year}`
   */
  format: PropTypes.string,
  /**
   * Id of the calendar text element.
   * It is used to establish an `aria-labelledby` relationship with the calendar `grid` element.
   */
  labelId: PropTypes.string,
  maxDate: PropTypes.object.isRequired,
  minDate: PropTypes.object.isRequired,
  onMonthChange: PropTypes.func.isRequired,
  onViewChange: PropTypes.func,
  reduceAnimations: PropTypes.bool.isRequired,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: PropTypes.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  timezone: PropTypes.string.isRequired,
  view: PropTypes.oneOf(["day", "month", "year"]).isRequired,
  views: PropTypes.arrayOf(PropTypes.oneOf(["day", "month", "year"]).isRequired).isRequired
});
const useMediaQuery = unstable_createUseMediaQuery({
  themeId: THEME_ID
}), PREFERS_REDUCED_MOTION = "@media (prefers-reduced-motion: reduce)", mobileVersionMatches = typeof navigator < "u" && navigator.userAgent.match(/android\s(\d+)|OS\s(\d+)/i), androidVersion = mobileVersionMatches && mobileVersionMatches[1] ? parseInt(mobileVersionMatches[1], 10) : null, iOSVersion = mobileVersionMatches && mobileVersionMatches[2] ? parseInt(mobileVersionMatches[2], 10) : null, slowAnimationDevices = androidVersion && androidVersion < 10 || iOSVersion && iOSVersion < 13 || !1;
function useReduceAnimations(e) {
  const t = useMediaQuery(PREFERS_REDUCED_MOTION, {
    defaultMatches: !1
  });
  return e ?? (t || slowAnimationDevices);
}
const getDateCalendarUtilityClass = (e) => generateUtilityClass("MuiDateCalendar", e);
generateUtilityClasses("MuiDateCalendar", ["root", "viewTransitionContainer"]);
const _excluded$a = ["autoFocus", "onViewChange", "value", "defaultValue", "referenceDate", "disableFuture", "disablePast", "onChange", "onYearChange", "onMonthChange", "reduceAnimations", "shouldDisableDate", "shouldDisableMonth", "shouldDisableYear", "view", "views", "openTo", "className", "classes", "disabled", "readOnly", "minDate", "maxDate", "disableHighlightToday", "focusedView", "onFocusedViewChange", "showDaysOutsideCurrentMonth", "fixedWeekNumber", "dayOfWeekFormatter", "slots", "slotProps", "loading", "renderLoading", "displayWeekNumber", "yearsOrder", "yearsPerRow", "monthsPerRow", "timezone"], useUtilityClasses$d = (e) => composeClasses({
  root: ["root"],
  viewTransitionContainer: ["viewTransitionContainer"]
}, getDateCalendarUtilityClass, e);
function useDateCalendarDefaultizedProps(e, t) {
  const o = useThemeProps({
    props: e,
    name: t
  }), n = useReduceAnimations(o.reduceAnimations), s = useApplyDefaultValuesToDateValidationProps(o);
  return _extends({}, o, s, {
    loading: o.loading ?? !1,
    openTo: o.openTo ?? "day",
    views: o.views ?? ["year", "day"],
    reduceAnimations: n,
    renderLoading: o.renderLoading ?? (() => /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
      children: "..."
    }))
  });
}
const DateCalendarRoot = styled(PickerViewRoot, {
  name: "MuiDateCalendar",
  slot: "Root"
})({
  display: "flex",
  flexDirection: "column",
  height: VIEW_HEIGHT
}), DateCalendarViewTransitionContainer = styled(PickersFadeTransitionGroup, {
  name: "MuiDateCalendar",
  slot: "ViewTransitionContainer"
})({}), DateCalendar = /* @__PURE__ */ React.forwardRef(function e(t, o) {
  const n = usePickerAdapter(), {
    ownerState: s
  } = usePickerPrivateContext(), i = useId(), l = useDateCalendarDefaultizedProps(t, "MuiDateCalendar"), {
    autoFocus: d,
    onViewChange: u,
    value: c,
    defaultValue: p,
    referenceDate: f,
    disableFuture: g,
    disablePast: y,
    onChange: h,
    onMonthChange: T,
    reduceAnimations: P,
    shouldDisableDate: E,
    shouldDisableMonth: $,
    shouldDisableYear: R,
    view: C,
    views: x,
    openTo: _,
    className: D,
    classes: O,
    disabled: v,
    readOnly: w,
    minDate: M,
    maxDate: S,
    disableHighlightToday: I,
    focusedView: N,
    onFocusedViewChange: F,
    showDaysOutsideCurrentMonth: L,
    fixedWeekNumber: k,
    dayOfWeekFormatter: W,
    slots: V,
    slotProps: j,
    loading: A,
    renderLoading: U,
    displayWeekNumber: G,
    yearsOrder: Y,
    yearsPerRow: ee,
    monthsPerRow: J,
    timezone: Z
  } = l, le = _objectWithoutPropertiesLoose(l, _excluded$a), {
    value: se,
    handleValueChange: K,
    timezone: q
  } = useControlledValue({
    name: "DateCalendar",
    timezone: Z,
    value: c,
    defaultValue: p,
    referenceDate: f,
    onChange: h,
    valueManager: singleItemValueManager
  }), {
    view: B,
    setView: ue,
    focusedView: re,
    setFocusedView: be,
    goToNextView: X,
    setValueAndGoToNextView: ge
  } = useViews({
    view: C,
    views: x,
    openTo: _,
    onChange: K,
    onViewChange: u,
    autoFocus: d,
    focusedView: N,
    onFocusedViewChange: F
  }), {
    referenceDate: Ee,
    calendarState: xe,
    setVisibleDate: he,
    isDateDisabled: Pe,
    onMonthSwitchingAnimationEnd: ye
  } = useCalendarState({
    value: se,
    referenceDate: f,
    reduceAnimations: P,
    onMonthChange: T,
    minDate: M,
    maxDate: S,
    shouldDisableDate: E,
    disablePast: y,
    disableFuture: g,
    timezone: q,
    getCurrentMonthFromVisibleDate: (ae, Se) => n.isSameMonth(ae, Se) ? Se : n.startOfMonth(ae)
  }), _e = v && se || M, Ce = v && se || S, ne = `${i}-grid-label`, H = re !== null, te = V?.calendarHeader ?? PickersCalendarHeader, ie = useSlotProps({
    elementType: te,
    externalSlotProps: j?.calendarHeader,
    additionalProps: {
      views: x,
      view: B,
      currentMonth: xe.currentMonth,
      onViewChange: ue,
      onMonthChange: (ae) => he({
        target: ae,
        reason: "header-navigation"
      }),
      minDate: _e,
      maxDate: Ce,
      disabled: v,
      disablePast: y,
      disableFuture: g,
      reduceAnimations: P,
      timezone: q,
      labelId: ne
    },
    ownerState: s
  }), ce = useEventCallback((ae) => {
    const Se = n.startOfMonth(ae), $e = n.endOfMonth(ae), Re = Pe(ae) ? findClosestEnabledDate({
      adapter: n,
      date: ae,
      minDate: n.isBefore(M, Se) ? Se : M,
      maxDate: n.isAfter(S, $e) ? $e : S,
      disablePast: y,
      disableFuture: g,
      isDateDisabled: Pe,
      timezone: q
    }) : ae;
    Re ? (ge(Re, "finish"), he({
      target: Re,
      reason: "cell-interaction"
    })) : (X(), he({
      target: Se,
      reason: "cell-interaction"
    }));
  }), me = useEventCallback((ae) => {
    const Se = n.startOfYear(ae), $e = n.endOfYear(ae), Re = Pe(ae) ? findClosestEnabledDate({
      adapter: n,
      date: ae,
      minDate: n.isBefore(M, Se) ? Se : M,
      maxDate: n.isAfter(S, $e) ? $e : S,
      disablePast: y,
      disableFuture: g,
      isDateDisabled: Pe,
      timezone: q
    }) : ae;
    Re ? (ge(Re, "finish"), he({
      target: Re,
      reason: "cell-interaction"
    })) : (X(), he({
      target: Se,
      reason: "cell-interaction"
    }));
  }), pe = useEventCallback((ae) => K(ae && mergeDateAndTime(n, ae, se ?? Ee), "finish", B));
  React.useEffect(() => {
    n.isValid(se) && he({
      target: se,
      reason: "controlled-value-change"
    });
  }, [se]);
  const z = useUtilityClasses$d(O), Q = {
    disablePast: y,
    disableFuture: g,
    maxDate: S,
    minDate: M
  }, Te = {
    disableHighlightToday: I,
    readOnly: w,
    disabled: v,
    timezone: q,
    gridLabelId: ne,
    slots: V,
    slotProps: j
  }, fe = React.useRef(B);
  React.useEffect(() => {
    fe.current !== B && (re === fe.current && be(B, !0), fe.current = B);
  }, [re, be, B]);
  const oe = React.useMemo(() => [se], [se]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(DateCalendarRoot, _extends({
    ref: o,
    className: clsx(z.root, D),
    ownerState: s
  }, le, {
    children: [/* @__PURE__ */ jsxRuntimeExports.jsx(te, _extends({}, ie, {
      slots: V,
      slotProps: j
    })), /* @__PURE__ */ jsxRuntimeExports.jsx(DateCalendarViewTransitionContainer, {
      reduceAnimations: P,
      className: z.viewTransitionContainer,
      transKey: B,
      ownerState: s,
      children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", {
        children: [B === "year" && /* @__PURE__ */ jsxRuntimeExports.jsx(YearCalendar, _extends({}, Q, Te, {
          value: se,
          onChange: me,
          shouldDisableYear: R,
          hasFocus: H,
          onFocusedViewChange: (ae) => be("year", ae),
          yearsOrder: Y,
          yearsPerRow: ee,
          referenceDate: Ee
        })), B === "month" && /* @__PURE__ */ jsxRuntimeExports.jsx(MonthCalendar, _extends({}, Q, Te, {
          currentMonth: xe.currentMonth,
          hasFocus: H,
          className: D,
          value: se,
          onChange: ce,
          shouldDisableMonth: $,
          onFocusedViewChange: (ae) => be("month", ae),
          monthsPerRow: J,
          referenceDate: Ee
        })), B === "day" && /* @__PURE__ */ jsxRuntimeExports.jsx(DayCalendar, _extends({}, xe, Q, Te, {
          onMonthSwitchingAnimationEnd: ye,
          hasFocus: H,
          onFocusedDayChange: (ae) => he({
            target: ae,
            reason: "cell-interaction"
          }),
          reduceAnimations: P,
          selectedDays: oe,
          onSelectedDaysChange: pe,
          shouldDisableDate: E,
          shouldDisableMonth: $,
          shouldDisableYear: R,
          onFocusedViewChange: (ae) => be("day", ae),
          showDaysOutsideCurrentMonth: L,
          fixedWeekNumber: k,
          dayOfWeekFormatter: W,
          displayWeekNumber: G,
          loading: A,
          renderLoading: U
        }))]
      })
    })]
  }));
});
process.env.NODE_ENV !== "production" && (DateCalendar.displayName = "DateCalendar");
process.env.NODE_ENV !== "production" && (DateCalendar.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: PropTypes.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  className: PropTypes.string,
  /**
   * Formats the day of week displayed in the calendar header.
   * @param {PickerValidDate} date The date of the day of week provided by the adapter.
   * @returns {string} The name to display.
   * @default (date: PickerValidDate) => adapter.format(date, 'weekdayShort').charAt(0).toUpperCase()
   */
  dayOfWeekFormatter: PropTypes.func,
  /**
   * The default selected value.
   * Used when the component is not controlled.
   */
  defaultValue: PropTypes.object,
  /**
   * If `true`, the component is disabled.
   * When disabled, the value cannot be changed and no interaction is possible.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: PropTypes.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: PropTypes.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: PropTypes.bool,
  /**
   * If `true`, the week number will be display in the calendar.
   */
  displayWeekNumber: PropTypes.bool,
  /**
   * The day view will show as many weeks as needed after the end of the current month to match this value.
   * Put it to 6 to have a fixed number of weeks in Gregorian calendars
   */
  fixedWeekNumber: PropTypes.number,
  /**
   * Controlled focused view.
   */
  focusedView: PropTypes.oneOf(["day", "month", "year"]),
  /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */
  loading: PropTypes.bool,
  /**
   * Maximal selectable date.
   * @default 2099-12-31
   */
  maxDate: PropTypes.object,
  /**
   * Minimal selectable date.
   * @default 1900-01-01
   */
  minDate: PropTypes.object,
  /**
   * Months rendered per row.
   * @default 3
   */
  monthsPerRow: PropTypes.oneOf([3, 4]),
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TView The view type. Will be one of date or time views.
   * @param {TValue} value The new value.
   * @param {PickerSelectionState | undefined} selectionState Indicates if the date selection is complete.
   * @param {TView | undefined} selectedView Indicates the view in which the selection has been made.
   */
  onChange: PropTypes.func,
  /**
   * Callback fired on focused view change.
   * @template TView Type of the view. It will vary based on the Picker type and the `views` it uses.
   * @param {TView} view The new view to focus or not.
   * @param {boolean} hasFocus `true` if the view should be focused.
   */
  onFocusedViewChange: PropTypes.func,
  /**
   * Callback fired on month change.
   * @param {PickerValidDate} month The new month.
   */
  onMonthChange: PropTypes.func,
  /**
   * Callback fired on view change.
   * @template TView Type of the view. It will vary based on the Picker type and the `views` it uses.
   * @param {TView} view The new view.
   */
  onViewChange: PropTypes.func,
  /**
   * Callback fired on year change.
   * @param {PickerValidDate} year The new year.
   */
  onYearChange: PropTypes.func,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: PropTypes.oneOf(["day", "month", "year"]),
  /**
   * If `true`, the component is read-only.
   * When read-only, the value cannot be changed but the user can interact with the interface.
   * @default false
   */
  readOnly: PropTypes.bool,
  /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */
  reduceAnimations: PropTypes.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date using the validation props, except callbacks such as `shouldDisableDate`.
   */
  referenceDate: PropTypes.object,
  /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span>...</span>
   */
  renderLoading: PropTypes.func,
  /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (for example when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @param {PickerValidDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */
  shouldDisableDate: PropTypes.func,
  /**
   * Disable specific month.
   * @param {PickerValidDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */
  shouldDisableMonth: PropTypes.func,
  /**
   * Disable specific year.
   * @param {PickerValidDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */
  shouldDisableYear: PropTypes.func,
  /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */
  showDaysOutsideCurrentMonth: PropTypes.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: PropTypes.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: PropTypes.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: PropTypes.object,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: PropTypes.oneOf(["day", "month", "year"]),
  /**
   * Available views.
   */
  views: PropTypes.arrayOf(PropTypes.oneOf(["day", "month", "year"]).isRequired),
  /**
   * Years are displayed in ascending (chronological) order by default.
   * If `desc`, years are displayed in descending order.
   * @default 'asc'
   */
  yearsOrder: PropTypes.oneOf(["asc", "desc"]),
  /**
   * Years rendered per row.
   * @default 3
   */
  yearsPerRow: PropTypes.oneOf([3, 4])
});
function getPickersToolbarUtilityClass(e) {
  return generateUtilityClass("MuiPickersToolbar", e);
}
generateUtilityClasses("MuiPickersToolbar", ["root", "title", "content"]);
function useToolbarOwnerState() {
  const {
    ownerState: e
  } = usePickerPrivateContext(), t = useRtl();
  return React.useMemo(() => _extends({}, e, {
    toolbarDirection: t ? "rtl" : "ltr"
  }), [e, t]);
}
const _excluded$9 = ["children", "className", "classes", "toolbarTitle", "hidden", "titleId", "classes", "landscapeDirection"], useUtilityClasses$c = (e) => composeClasses({
  root: ["root"],
  title: ["title"],
  content: ["content"]
}, getPickersToolbarUtilityClass, e), PickersToolbarRoot = styled("div", {
  name: "MuiPickersToolbar",
  slot: "Root"
})(({
  theme: e
}) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  justifyContent: "space-between",
  padding: e.spacing(2, 3),
  variants: [{
    props: {
      pickerOrientation: "landscape"
    },
    style: {
      height: "auto",
      maxWidth: 160,
      padding: 16,
      justifyContent: "flex-start",
      flexWrap: "wrap"
    }
  }]
})), PickersToolbarContent = styled("div", {
  name: "MuiPickersToolbar",
  slot: "Content",
  shouldForwardProp: (e) => shouldForwardProp(e) && e !== "landscapeDirection"
})({
  display: "flex",
  flexWrap: "wrap",
  width: "100%",
  flex: 1,
  justifyContent: "space-between",
  alignItems: "center",
  flexDirection: "row",
  variants: [{
    props: {
      pickerOrientation: "landscape"
    },
    style: {
      justifyContent: "flex-start",
      alignItems: "flex-start",
      flexDirection: "column"
    }
  }, {
    props: {
      pickerOrientation: "landscape",
      landscapeDirection: "row"
    },
    style: {
      flexDirection: "row"
    }
  }]
}), PickersToolbar = /* @__PURE__ */ React.forwardRef(function e(t, o) {
  const n = useThemeProps({
    props: t,
    name: "MuiPickersToolbar"
  }), {
    children: s,
    className: i,
    classes: l,
    toolbarTitle: d,
    hidden: u,
    titleId: c,
    landscapeDirection: p
  } = n, f = _objectWithoutPropertiesLoose(n, _excluded$9), g = useToolbarOwnerState(), y = useUtilityClasses$c(l);
  return u ? null : /* @__PURE__ */ jsxRuntimeExports.jsxs(PickersToolbarRoot, _extends({
    ref: o,
    className: clsx(y.root, i),
    ownerState: g
  }, f, {
    children: [/* @__PURE__ */ jsxRuntimeExports.jsx(Typography, {
      color: "text.secondary",
      variant: "overline",
      id: c,
      className: y.title,
      children: d
    }), /* @__PURE__ */ jsxRuntimeExports.jsx(PickersToolbarContent, {
      className: y.content,
      ownerState: g,
      landscapeDirection: p,
      children: s
    })]
  }));
});
process.env.NODE_ENV !== "production" && (PickersToolbar.displayName = "PickersToolbar");
function getDatePickerToolbarUtilityClass(e) {
  return generateUtilityClass("MuiDatePickerToolbar", e);
}
generateUtilityClasses("MuiDatePickerToolbar", ["root", "title"]);
const _excluded$8 = ["toolbarFormat", "toolbarPlaceholder", "className", "classes"], useUtilityClasses$b = (e) => composeClasses({
  root: ["root"],
  title: ["title"]
}, getDatePickerToolbarUtilityClass, e), DatePickerToolbarRoot = styled(PickersToolbar, {
  name: "MuiDatePickerToolbar",
  slot: "Root"
})({}), DatePickerToolbarTitle = styled(Typography, {
  name: "MuiDatePickerToolbar",
  slot: "Title"
})({
  variants: [{
    props: {
      pickerOrientation: "landscape"
    },
    style: {
      margin: "auto 16px auto auto"
    }
  }]
}), DatePickerToolbar = /* @__PURE__ */ React.forwardRef(function e(t, o) {
  const n = useThemeProps({
    props: t,
    name: "MuiDatePickerToolbar"
  }), {
    toolbarFormat: s,
    toolbarPlaceholder: i = "––",
    className: l,
    classes: d
  } = n, u = _objectWithoutPropertiesLoose(n, _excluded$8), c = usePickerAdapter(), {
    value: p,
    views: f,
    orientation: g
  } = usePickerContext(), y = usePickerTranslations(), h = useToolbarOwnerState(), T = useUtilityClasses$b(d), P = React.useMemo(() => {
    if (!c.isValid(p))
      return i;
    const E = resolveDateFormat(c, {
      format: s,
      views: f
    }, !0);
    return c.formatByString(p, E);
  }, [p, s, i, c, f]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(DatePickerToolbarRoot, _extends({
    ref: o,
    toolbarTitle: y.datePickerToolbarTitle,
    className: clsx(T.root, l)
  }, u, {
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(DatePickerToolbarTitle, {
      variant: "h4",
      align: g === "landscape" ? "left" : "center",
      ownerState: h,
      className: T.title,
      children: P
    })
  }));
});
process.env.NODE_ENV !== "production" && (DatePickerToolbar.displayName = "DatePickerToolbar");
process.env.NODE_ENV !== "production" && (DatePickerToolbar.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  className: PropTypes.string,
  /**
   * If `true`, show the toolbar even in desktop mode.
   * @default `true` for Desktop, `false` for Mobile.
   */
  hidden: PropTypes.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  titleId: PropTypes.string,
  /**
   * Toolbar date format.
   */
  toolbarFormat: PropTypes.string,
  /**
   * Toolbar value placeholder—it is displayed when the value is empty.
   * @default "––"
   */
  toolbarPlaceholder: PropTypes.node
});
function useDatePickerDefaultizedProps(e, t) {
  const o = useThemeProps({
    props: e,
    name: t
  }), n = useApplyDefaultValuesToDateValidationProps(o), s = React.useMemo(() => o.localeText?.toolbarTitle == null ? o.localeText : _extends({}, o.localeText, {
    datePickerToolbarTitle: o.localeText.toolbarTitle
  }), [o.localeText]);
  return _extends({}, o, n, {
    localeText: s
  }, applyDefaultViewProps({
    views: o.views,
    openTo: o.openTo,
    defaultViews: ["year", "day"],
    defaultOpenTo: "day"
  }), {
    slots: _extends({
      toolbar: DatePickerToolbar
    }, o.slots)
  });
}
var top = "top", bottom = "bottom", right = "right", left = "left", auto = "auto", basePlacements = [top, bottom, right, left], start = "start", end = "end", clippingParents = "clippingParents", viewport = "viewport", popper = "popper", reference = "reference", variationPlacements = /* @__PURE__ */ basePlacements.reduce(function(e, t) {
  return e.concat([t + "-" + start, t + "-" + end]);
}, []), placements = /* @__PURE__ */ [].concat(basePlacements, [auto]).reduce(function(e, t) {
  return e.concat([t, t + "-" + start, t + "-" + end]);
}, []), beforeRead = "beforeRead", read = "read", afterRead = "afterRead", beforeMain = "beforeMain", main$1 = "main", afterMain = "afterMain", beforeWrite = "beforeWrite", write = "write", afterWrite = "afterWrite", modifierPhases = [beforeRead, read, afterRead, beforeMain, main$1, afterMain, beforeWrite, write, afterWrite];
function getNodeName(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function getWindow(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var t = e.ownerDocument;
    return t && t.defaultView || window;
  }
  return e;
}
function isElement(e) {
  var t = getWindow(e).Element;
  return e instanceof t || e instanceof Element;
}
function isHTMLElement$1(e) {
  var t = getWindow(e).HTMLElement;
  return e instanceof t || e instanceof HTMLElement;
}
function isShadowRoot(e) {
  if (typeof ShadowRoot > "u")
    return !1;
  var t = getWindow(e).ShadowRoot;
  return e instanceof t || e instanceof ShadowRoot;
}
function applyStyles(e) {
  var t = e.state;
  Object.keys(t.elements).forEach(function(o) {
    var n = t.styles[o] || {}, s = t.attributes[o] || {}, i = t.elements[o];
    !isHTMLElement$1(i) || !getNodeName(i) || (Object.assign(i.style, n), Object.keys(s).forEach(function(l) {
      var d = s[l];
      d === !1 ? i.removeAttribute(l) : i.setAttribute(l, d === !0 ? "" : d);
    }));
  });
}
function effect$2(e) {
  var t = e.state, o = {
    popper: {
      position: t.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(t.elements.popper.style, o.popper), t.styles = o, t.elements.arrow && Object.assign(t.elements.arrow.style, o.arrow), function() {
    Object.keys(t.elements).forEach(function(n) {
      var s = t.elements[n], i = t.attributes[n] || {}, l = Object.keys(t.styles.hasOwnProperty(n) ? t.styles[n] : o[n]), d = l.reduce(function(u, c) {
        return u[c] = "", u;
      }, {});
      !isHTMLElement$1(s) || !getNodeName(s) || (Object.assign(s.style, d), Object.keys(i).forEach(function(u) {
        s.removeAttribute(u);
      }));
    });
  };
}
const applyStyles$1 = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: applyStyles,
  effect: effect$2,
  requires: ["computeStyles"]
};
function getBasePlacement(e) {
  return e.split("-")[0];
}
var max = Math.max, min = Math.min, round = Math.round;
function getUAString() {
  var e = navigator.userAgentData;
  return e != null && e.brands && Array.isArray(e.brands) ? e.brands.map(function(t) {
    return t.brand + "/" + t.version;
  }).join(" ") : navigator.userAgent;
}
function isLayoutViewport() {
  return !/^((?!chrome|android).)*safari/i.test(getUAString());
}
function getBoundingClientRect(e, t, o) {
  t === void 0 && (t = !1), o === void 0 && (o = !1);
  var n = e.getBoundingClientRect(), s = 1, i = 1;
  t && isHTMLElement$1(e) && (s = e.offsetWidth > 0 && round(n.width) / e.offsetWidth || 1, i = e.offsetHeight > 0 && round(n.height) / e.offsetHeight || 1);
  var l = isElement(e) ? getWindow(e) : window, d = l.visualViewport, u = !isLayoutViewport() && o, c = (n.left + (u && d ? d.offsetLeft : 0)) / s, p = (n.top + (u && d ? d.offsetTop : 0)) / i, f = n.width / s, g = n.height / i;
  return {
    width: f,
    height: g,
    top: p,
    right: c + f,
    bottom: p + g,
    left: c,
    x: c,
    y: p
  };
}
function getLayoutRect(e) {
  var t = getBoundingClientRect(e), o = e.offsetWidth, n = e.offsetHeight;
  return Math.abs(t.width - o) <= 1 && (o = t.width), Math.abs(t.height - n) <= 1 && (n = t.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: o,
    height: n
  };
}
function contains(e, t) {
  var o = t.getRootNode && t.getRootNode();
  if (e.contains(t))
    return !0;
  if (o && isShadowRoot(o)) {
    var n = t;
    do {
      if (n && e.isSameNode(n))
        return !0;
      n = n.parentNode || n.host;
    } while (n);
  }
  return !1;
}
function getComputedStyle$1(e) {
  return getWindow(e).getComputedStyle(e);
}
function isTableElement(e) {
  return ["table", "td", "th"].indexOf(getNodeName(e)) >= 0;
}
function getDocumentElement(e) {
  return ((isElement(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function getParentNode(e) {
  return getNodeName(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    (isShadowRoot(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    getDocumentElement(e)
  );
}
function getTrueOffsetParent(e) {
  return !isHTMLElement$1(e) || // https://github.com/popperjs/popper-core/issues/837
  getComputedStyle$1(e).position === "fixed" ? null : e.offsetParent;
}
function getContainingBlock(e) {
  var t = /firefox/i.test(getUAString()), o = /Trident/i.test(getUAString());
  if (o && isHTMLElement$1(e)) {
    var n = getComputedStyle$1(e);
    if (n.position === "fixed")
      return null;
  }
  var s = getParentNode(e);
  for (isShadowRoot(s) && (s = s.host); isHTMLElement$1(s) && ["html", "body"].indexOf(getNodeName(s)) < 0; ) {
    var i = getComputedStyle$1(s);
    if (i.transform !== "none" || i.perspective !== "none" || i.contain === "paint" || ["transform", "perspective"].indexOf(i.willChange) !== -1 || t && i.willChange === "filter" || t && i.filter && i.filter !== "none")
      return s;
    s = s.parentNode;
  }
  return null;
}
function getOffsetParent(e) {
  for (var t = getWindow(e), o = getTrueOffsetParent(e); o && isTableElement(o) && getComputedStyle$1(o).position === "static"; )
    o = getTrueOffsetParent(o);
  return o && (getNodeName(o) === "html" || getNodeName(o) === "body" && getComputedStyle$1(o).position === "static") ? t : o || getContainingBlock(e) || t;
}
function getMainAxisFromPlacement(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function within(e, t, o) {
  return max(e, min(t, o));
}
function withinMaxClamp(e, t, o) {
  var n = within(e, t, o);
  return n > o ? o : n;
}
function getFreshSideObject() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function mergePaddingObject(e) {
  return Object.assign({}, getFreshSideObject(), e);
}
function expandToHashMap(e, t) {
  return t.reduce(function(o, n) {
    return o[n] = e, o;
  }, {});
}
var toPaddingObject = function e(t, o) {
  return t = typeof t == "function" ? t(Object.assign({}, o.rects, {
    placement: o.placement
  })) : t, mergePaddingObject(typeof t != "number" ? t : expandToHashMap(t, basePlacements));
};
function arrow(e) {
  var t, o = e.state, n = e.name, s = e.options, i = o.elements.arrow, l = o.modifiersData.popperOffsets, d = getBasePlacement(o.placement), u = getMainAxisFromPlacement(d), c = [left, right].indexOf(d) >= 0, p = c ? "height" : "width";
  if (!(!i || !l)) {
    var f = toPaddingObject(s.padding, o), g = getLayoutRect(i), y = u === "y" ? top : left, h = u === "y" ? bottom : right, T = o.rects.reference[p] + o.rects.reference[u] - l[u] - o.rects.popper[p], P = l[u] - o.rects.reference[u], E = getOffsetParent(i), $ = E ? u === "y" ? E.clientHeight || 0 : E.clientWidth || 0 : 0, R = T / 2 - P / 2, C = f[y], x = $ - g[p] - f[h], _ = $ / 2 - g[p] / 2 + R, D = within(C, _, x), O = u;
    o.modifiersData[n] = (t = {}, t[O] = D, t.centerOffset = D - _, t);
  }
}
function effect$1(e) {
  var t = e.state, o = e.options, n = o.element, s = n === void 0 ? "[data-popper-arrow]" : n;
  s != null && (typeof s == "string" && (s = t.elements.popper.querySelector(s), !s) || contains(t.elements.popper, s) && (t.elements.arrow = s));
}
const arrow$1 = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: arrow,
  effect: effect$1,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function getVariation(e) {
  return e.split("-")[1];
}
var unsetSides = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function roundOffsetsByDPR(e, t) {
  var o = e.x, n = e.y, s = t.devicePixelRatio || 1;
  return {
    x: round(o * s) / s || 0,
    y: round(n * s) / s || 0
  };
}
function mapToStyles(e) {
  var t, o = e.popper, n = e.popperRect, s = e.placement, i = e.variation, l = e.offsets, d = e.position, u = e.gpuAcceleration, c = e.adaptive, p = e.roundOffsets, f = e.isFixed, g = l.x, y = g === void 0 ? 0 : g, h = l.y, T = h === void 0 ? 0 : h, P = typeof p == "function" ? p({
    x: y,
    y: T
  }) : {
    x: y,
    y: T
  };
  y = P.x, T = P.y;
  var E = l.hasOwnProperty("x"), $ = l.hasOwnProperty("y"), R = left, C = top, x = window;
  if (c) {
    var _ = getOffsetParent(o), D = "clientHeight", O = "clientWidth";
    if (_ === getWindow(o) && (_ = getDocumentElement(o), getComputedStyle$1(_).position !== "static" && d === "absolute" && (D = "scrollHeight", O = "scrollWidth")), _ = _, s === top || (s === left || s === right) && i === end) {
      C = bottom;
      var v = f && _ === x && x.visualViewport ? x.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        _[D]
      );
      T -= v - n.height, T *= u ? 1 : -1;
    }
    if (s === left || (s === top || s === bottom) && i === end) {
      R = right;
      var w = f && _ === x && x.visualViewport ? x.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        _[O]
      );
      y -= w - n.width, y *= u ? 1 : -1;
    }
  }
  var M = Object.assign({
    position: d
  }, c && unsetSides), S = p === !0 ? roundOffsetsByDPR({
    x: y,
    y: T
  }, getWindow(o)) : {
    x: y,
    y: T
  };
  if (y = S.x, T = S.y, u) {
    var I;
    return Object.assign({}, M, (I = {}, I[C] = $ ? "0" : "", I[R] = E ? "0" : "", I.transform = (x.devicePixelRatio || 1) <= 1 ? "translate(" + y + "px, " + T + "px)" : "translate3d(" + y + "px, " + T + "px, 0)", I));
  }
  return Object.assign({}, M, (t = {}, t[C] = $ ? T + "px" : "", t[R] = E ? y + "px" : "", t.transform = "", t));
}
function computeStyles(e) {
  var t = e.state, o = e.options, n = o.gpuAcceleration, s = n === void 0 ? !0 : n, i = o.adaptive, l = i === void 0 ? !0 : i, d = o.roundOffsets, u = d === void 0 ? !0 : d, c = {
    placement: getBasePlacement(t.placement),
    variation: getVariation(t.placement),
    popper: t.elements.popper,
    popperRect: t.rects.popper,
    gpuAcceleration: s,
    isFixed: t.options.strategy === "fixed"
  };
  t.modifiersData.popperOffsets != null && (t.styles.popper = Object.assign({}, t.styles.popper, mapToStyles(Object.assign({}, c, {
    offsets: t.modifiersData.popperOffsets,
    position: t.options.strategy,
    adaptive: l,
    roundOffsets: u
  })))), t.modifiersData.arrow != null && (t.styles.arrow = Object.assign({}, t.styles.arrow, mapToStyles(Object.assign({}, c, {
    offsets: t.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: u
  })))), t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-placement": t.placement
  });
}
const computeStyles$1 = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: computeStyles,
  data: {}
};
var passive = {
  passive: !0
};
function effect(e) {
  var t = e.state, o = e.instance, n = e.options, s = n.scroll, i = s === void 0 ? !0 : s, l = n.resize, d = l === void 0 ? !0 : l, u = getWindow(t.elements.popper), c = [].concat(t.scrollParents.reference, t.scrollParents.popper);
  return i && c.forEach(function(p) {
    p.addEventListener("scroll", o.update, passive);
  }), d && u.addEventListener("resize", o.update, passive), function() {
    i && c.forEach(function(p) {
      p.removeEventListener("scroll", o.update, passive);
    }), d && u.removeEventListener("resize", o.update, passive);
  };
}
const eventListeners = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function e() {
  },
  effect,
  data: {}
};
var hash$1 = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function getOppositePlacement(e) {
  return e.replace(/left|right|bottom|top/g, function(t) {
    return hash$1[t];
  });
}
var hash = {
  start: "end",
  end: "start"
};
function getOppositeVariationPlacement(e) {
  return e.replace(/start|end/g, function(t) {
    return hash[t];
  });
}
function getWindowScroll(e) {
  var t = getWindow(e), o = t.pageXOffset, n = t.pageYOffset;
  return {
    scrollLeft: o,
    scrollTop: n
  };
}
function getWindowScrollBarX(e) {
  return getBoundingClientRect(getDocumentElement(e)).left + getWindowScroll(e).scrollLeft;
}
function getViewportRect(e, t) {
  var o = getWindow(e), n = getDocumentElement(e), s = o.visualViewport, i = n.clientWidth, l = n.clientHeight, d = 0, u = 0;
  if (s) {
    i = s.width, l = s.height;
    var c = isLayoutViewport();
    (c || !c && t === "fixed") && (d = s.offsetLeft, u = s.offsetTop);
  }
  return {
    width: i,
    height: l,
    x: d + getWindowScrollBarX(e),
    y: u
  };
}
function getDocumentRect(e) {
  var t, o = getDocumentElement(e), n = getWindowScroll(e), s = (t = e.ownerDocument) == null ? void 0 : t.body, i = max(o.scrollWidth, o.clientWidth, s ? s.scrollWidth : 0, s ? s.clientWidth : 0), l = max(o.scrollHeight, o.clientHeight, s ? s.scrollHeight : 0, s ? s.clientHeight : 0), d = -n.scrollLeft + getWindowScrollBarX(e), u = -n.scrollTop;
  return getComputedStyle$1(s || o).direction === "rtl" && (d += max(o.clientWidth, s ? s.clientWidth : 0) - i), {
    width: i,
    height: l,
    x: d,
    y: u
  };
}
function isScrollParent(e) {
  var t = getComputedStyle$1(e), o = t.overflow, n = t.overflowX, s = t.overflowY;
  return /auto|scroll|overlay|hidden/.test(o + s + n);
}
function getScrollParent(e) {
  return ["html", "body", "#document"].indexOf(getNodeName(e)) >= 0 ? e.ownerDocument.body : isHTMLElement$1(e) && isScrollParent(e) ? e : getScrollParent(getParentNode(e));
}
function listScrollParents(e, t) {
  var o;
  t === void 0 && (t = []);
  var n = getScrollParent(e), s = n === ((o = e.ownerDocument) == null ? void 0 : o.body), i = getWindow(n), l = s ? [i].concat(i.visualViewport || [], isScrollParent(n) ? n : []) : n, d = t.concat(l);
  return s ? d : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    d.concat(listScrollParents(getParentNode(l)))
  );
}
function rectToClientRect(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function getInnerBoundingClientRect(e, t) {
  var o = getBoundingClientRect(e, !1, t === "fixed");
  return o.top = o.top + e.clientTop, o.left = o.left + e.clientLeft, o.bottom = o.top + e.clientHeight, o.right = o.left + e.clientWidth, o.width = e.clientWidth, o.height = e.clientHeight, o.x = o.left, o.y = o.top, o;
}
function getClientRectFromMixedType(e, t, o) {
  return t === viewport ? rectToClientRect(getViewportRect(e, o)) : isElement(t) ? getInnerBoundingClientRect(t, o) : rectToClientRect(getDocumentRect(getDocumentElement(e)));
}
function getClippingParents(e) {
  var t = listScrollParents(getParentNode(e)), o = ["absolute", "fixed"].indexOf(getComputedStyle$1(e).position) >= 0, n = o && isHTMLElement$1(e) ? getOffsetParent(e) : e;
  return isElement(n) ? t.filter(function(s) {
    return isElement(s) && contains(s, n) && getNodeName(s) !== "body";
  }) : [];
}
function getClippingRect(e, t, o, n) {
  var s = t === "clippingParents" ? getClippingParents(e) : [].concat(t), i = [].concat(s, [o]), l = i[0], d = i.reduce(function(u, c) {
    var p = getClientRectFromMixedType(e, c, n);
    return u.top = max(p.top, u.top), u.right = min(p.right, u.right), u.bottom = min(p.bottom, u.bottom), u.left = max(p.left, u.left), u;
  }, getClientRectFromMixedType(e, l, n));
  return d.width = d.right - d.left, d.height = d.bottom - d.top, d.x = d.left, d.y = d.top, d;
}
function computeOffsets(e) {
  var t = e.reference, o = e.element, n = e.placement, s = n ? getBasePlacement(n) : null, i = n ? getVariation(n) : null, l = t.x + t.width / 2 - o.width / 2, d = t.y + t.height / 2 - o.height / 2, u;
  switch (s) {
    case top:
      u = {
        x: l,
        y: t.y - o.height
      };
      break;
    case bottom:
      u = {
        x: l,
        y: t.y + t.height
      };
      break;
    case right:
      u = {
        x: t.x + t.width,
        y: d
      };
      break;
    case left:
      u = {
        x: t.x - o.width,
        y: d
      };
      break;
    default:
      u = {
        x: t.x,
        y: t.y
      };
  }
  var c = s ? getMainAxisFromPlacement(s) : null;
  if (c != null) {
    var p = c === "y" ? "height" : "width";
    switch (i) {
      case start:
        u[c] = u[c] - (t[p] / 2 - o[p] / 2);
        break;
      case end:
        u[c] = u[c] + (t[p] / 2 - o[p] / 2);
        break;
    }
  }
  return u;
}
function detectOverflow(e, t) {
  t === void 0 && (t = {});
  var o = t, n = o.placement, s = n === void 0 ? e.placement : n, i = o.strategy, l = i === void 0 ? e.strategy : i, d = o.boundary, u = d === void 0 ? clippingParents : d, c = o.rootBoundary, p = c === void 0 ? viewport : c, f = o.elementContext, g = f === void 0 ? popper : f, y = o.altBoundary, h = y === void 0 ? !1 : y, T = o.padding, P = T === void 0 ? 0 : T, E = mergePaddingObject(typeof P != "number" ? P : expandToHashMap(P, basePlacements)), $ = g === popper ? reference : popper, R = e.rects.popper, C = e.elements[h ? $ : g], x = getClippingRect(isElement(C) ? C : C.contextElement || getDocumentElement(e.elements.popper), u, p, l), _ = getBoundingClientRect(e.elements.reference), D = computeOffsets({
    reference: _,
    element: R,
    placement: s
  }), O = rectToClientRect(Object.assign({}, R, D)), v = g === popper ? O : _, w = {
    top: x.top - v.top + E.top,
    bottom: v.bottom - x.bottom + E.bottom,
    left: x.left - v.left + E.left,
    right: v.right - x.right + E.right
  }, M = e.modifiersData.offset;
  if (g === popper && M) {
    var S = M[s];
    Object.keys(w).forEach(function(I) {
      var N = [right, bottom].indexOf(I) >= 0 ? 1 : -1, F = [top, bottom].indexOf(I) >= 0 ? "y" : "x";
      w[I] += S[F] * N;
    });
  }
  return w;
}
function computeAutoPlacement(e, t) {
  t === void 0 && (t = {});
  var o = t, n = o.placement, s = o.boundary, i = o.rootBoundary, l = o.padding, d = o.flipVariations, u = o.allowedAutoPlacements, c = u === void 0 ? placements : u, p = getVariation(n), f = p ? d ? variationPlacements : variationPlacements.filter(function(h) {
    return getVariation(h) === p;
  }) : basePlacements, g = f.filter(function(h) {
    return c.indexOf(h) >= 0;
  });
  g.length === 0 && (g = f);
  var y = g.reduce(function(h, T) {
    return h[T] = detectOverflow(e, {
      placement: T,
      boundary: s,
      rootBoundary: i,
      padding: l
    })[getBasePlacement(T)], h;
  }, {});
  return Object.keys(y).sort(function(h, T) {
    return y[h] - y[T];
  });
}
function getExpandedFallbackPlacements(e) {
  if (getBasePlacement(e) === auto)
    return [];
  var t = getOppositePlacement(e);
  return [getOppositeVariationPlacement(e), t, getOppositeVariationPlacement(t)];
}
function flip(e) {
  var t = e.state, o = e.options, n = e.name;
  if (!t.modifiersData[n]._skip) {
    for (var s = o.mainAxis, i = s === void 0 ? !0 : s, l = o.altAxis, d = l === void 0 ? !0 : l, u = o.fallbackPlacements, c = o.padding, p = o.boundary, f = o.rootBoundary, g = o.altBoundary, y = o.flipVariations, h = y === void 0 ? !0 : y, T = o.allowedAutoPlacements, P = t.options.placement, E = getBasePlacement(P), $ = E === P, R = u || ($ || !h ? [getOppositePlacement(P)] : getExpandedFallbackPlacements(P)), C = [P].concat(R).reduce(function(Y, ee) {
      return Y.concat(getBasePlacement(ee) === auto ? computeAutoPlacement(t, {
        placement: ee,
        boundary: p,
        rootBoundary: f,
        padding: c,
        flipVariations: h,
        allowedAutoPlacements: T
      }) : ee);
    }, []), x = t.rects.reference, _ = t.rects.popper, D = /* @__PURE__ */ new Map(), O = !0, v = C[0], w = 0; w < C.length; w++) {
      var M = C[w], S = getBasePlacement(M), I = getVariation(M) === start, N = [top, bottom].indexOf(S) >= 0, F = N ? "width" : "height", L = detectOverflow(t, {
        placement: M,
        boundary: p,
        rootBoundary: f,
        altBoundary: g,
        padding: c
      }), k = N ? I ? right : left : I ? bottom : top;
      x[F] > _[F] && (k = getOppositePlacement(k));
      var W = getOppositePlacement(k), V = [];
      if (i && V.push(L[S] <= 0), d && V.push(L[k] <= 0, L[W] <= 0), V.every(function(Y) {
        return Y;
      })) {
        v = M, O = !1;
        break;
      }
      D.set(M, V);
    }
    if (O)
      for (var j = h ? 3 : 1, A = function(ee) {
        var J = C.find(function(Z) {
          var le = D.get(Z);
          if (le)
            return le.slice(0, ee).every(function(se) {
              return se;
            });
        });
        if (J)
          return v = J, "break";
      }, U = j; U > 0; U--) {
        var G = A(U);
        if (G === "break") break;
      }
    t.placement !== v && (t.modifiersData[n]._skip = !0, t.placement = v, t.reset = !0);
  }
}
const flip$1 = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: flip,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function getSideOffsets(e, t, o) {
  return o === void 0 && (o = {
    x: 0,
    y: 0
  }), {
    top: e.top - t.height - o.y,
    right: e.right - t.width + o.x,
    bottom: e.bottom - t.height + o.y,
    left: e.left - t.width - o.x
  };
}
function isAnySideFullyClipped(e) {
  return [top, right, bottom, left].some(function(t) {
    return e[t] >= 0;
  });
}
function hide(e) {
  var t = e.state, o = e.name, n = t.rects.reference, s = t.rects.popper, i = t.modifiersData.preventOverflow, l = detectOverflow(t, {
    elementContext: "reference"
  }), d = detectOverflow(t, {
    altBoundary: !0
  }), u = getSideOffsets(l, n), c = getSideOffsets(d, s, i), p = isAnySideFullyClipped(u), f = isAnySideFullyClipped(c);
  t.modifiersData[o] = {
    referenceClippingOffsets: u,
    popperEscapeOffsets: c,
    isReferenceHidden: p,
    hasPopperEscaped: f
  }, t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-reference-hidden": p,
    "data-popper-escaped": f
  });
}
const hide$1 = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: hide
};
function distanceAndSkiddingToXY(e, t, o) {
  var n = getBasePlacement(e), s = [left, top].indexOf(n) >= 0 ? -1 : 1, i = typeof o == "function" ? o(Object.assign({}, t, {
    placement: e
  })) : o, l = i[0], d = i[1];
  return l = l || 0, d = (d || 0) * s, [left, right].indexOf(n) >= 0 ? {
    x: d,
    y: l
  } : {
    x: l,
    y: d
  };
}
function offset(e) {
  var t = e.state, o = e.options, n = e.name, s = o.offset, i = s === void 0 ? [0, 0] : s, l = placements.reduce(function(p, f) {
    return p[f] = distanceAndSkiddingToXY(f, t.rects, i), p;
  }, {}), d = l[t.placement], u = d.x, c = d.y;
  t.modifiersData.popperOffsets != null && (t.modifiersData.popperOffsets.x += u, t.modifiersData.popperOffsets.y += c), t.modifiersData[n] = l;
}
const offset$1 = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: offset
};
function popperOffsets(e) {
  var t = e.state, o = e.name;
  t.modifiersData[o] = computeOffsets({
    reference: t.rects.reference,
    element: t.rects.popper,
    placement: t.placement
  });
}
const popperOffsets$1 = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: popperOffsets,
  data: {}
};
function getAltAxis(e) {
  return e === "x" ? "y" : "x";
}
function preventOverflow(e) {
  var t = e.state, o = e.options, n = e.name, s = o.mainAxis, i = s === void 0 ? !0 : s, l = o.altAxis, d = l === void 0 ? !1 : l, u = o.boundary, c = o.rootBoundary, p = o.altBoundary, f = o.padding, g = o.tether, y = g === void 0 ? !0 : g, h = o.tetherOffset, T = h === void 0 ? 0 : h, P = detectOverflow(t, {
    boundary: u,
    rootBoundary: c,
    padding: f,
    altBoundary: p
  }), E = getBasePlacement(t.placement), $ = getVariation(t.placement), R = !$, C = getMainAxisFromPlacement(E), x = getAltAxis(C), _ = t.modifiersData.popperOffsets, D = t.rects.reference, O = t.rects.popper, v = typeof T == "function" ? T(Object.assign({}, t.rects, {
    placement: t.placement
  })) : T, w = typeof v == "number" ? {
    mainAxis: v,
    altAxis: v
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, v), M = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null, S = {
    x: 0,
    y: 0
  };
  if (_) {
    if (i) {
      var I, N = C === "y" ? top : left, F = C === "y" ? bottom : right, L = C === "y" ? "height" : "width", k = _[C], W = k + P[N], V = k - P[F], j = y ? -O[L] / 2 : 0, A = $ === start ? D[L] : O[L], U = $ === start ? -O[L] : -D[L], G = t.elements.arrow, Y = y && G ? getLayoutRect(G) : {
        width: 0,
        height: 0
      }, ee = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : getFreshSideObject(), J = ee[N], Z = ee[F], le = within(0, D[L], Y[L]), se = R ? D[L] / 2 - j - le - J - w.mainAxis : A - le - J - w.mainAxis, K = R ? -D[L] / 2 + j + le + Z + w.mainAxis : U + le + Z + w.mainAxis, q = t.elements.arrow && getOffsetParent(t.elements.arrow), B = q ? C === "y" ? q.clientTop || 0 : q.clientLeft || 0 : 0, ue = (I = M?.[C]) != null ? I : 0, re = k + se - ue - B, be = k + K - ue, X = within(y ? min(W, re) : W, k, y ? max(V, be) : V);
      _[C] = X, S[C] = X - k;
    }
    if (d) {
      var ge, Ee = C === "x" ? top : left, xe = C === "x" ? bottom : right, he = _[x], Pe = x === "y" ? "height" : "width", ye = he + P[Ee], _e = he - P[xe], Ce = [top, left].indexOf(E) !== -1, ne = (ge = M?.[x]) != null ? ge : 0, H = Ce ? ye : he - D[Pe] - O[Pe] - ne + w.altAxis, te = Ce ? he + D[Pe] + O[Pe] - ne - w.altAxis : _e, ie = y && Ce ? withinMaxClamp(H, he, te) : within(y ? H : ye, he, y ? te : _e);
      _[x] = ie, S[x] = ie - he;
    }
    t.modifiersData[n] = S;
  }
}
const preventOverflow$1 = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: preventOverflow,
  requiresIfExists: ["offset"]
};
function getHTMLElementScroll(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function getNodeScroll(e) {
  return e === getWindow(e) || !isHTMLElement$1(e) ? getWindowScroll(e) : getHTMLElementScroll(e);
}
function isElementScaled(e) {
  var t = e.getBoundingClientRect(), o = round(t.width) / e.offsetWidth || 1, n = round(t.height) / e.offsetHeight || 1;
  return o !== 1 || n !== 1;
}
function getCompositeRect(e, t, o) {
  o === void 0 && (o = !1);
  var n = isHTMLElement$1(t), s = isHTMLElement$1(t) && isElementScaled(t), i = getDocumentElement(t), l = getBoundingClientRect(e, s, o), d = {
    scrollLeft: 0,
    scrollTop: 0
  }, u = {
    x: 0,
    y: 0
  };
  return (n || !n && !o) && ((getNodeName(t) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  isScrollParent(i)) && (d = getNodeScroll(t)), isHTMLElement$1(t) ? (u = getBoundingClientRect(t, !0), u.x += t.clientLeft, u.y += t.clientTop) : i && (u.x = getWindowScrollBarX(i))), {
    x: l.left + d.scrollLeft - u.x,
    y: l.top + d.scrollTop - u.y,
    width: l.width,
    height: l.height
  };
}
function order(e) {
  var t = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Set(), n = [];
  e.forEach(function(i) {
    t.set(i.name, i);
  });
  function s(i) {
    o.add(i.name);
    var l = [].concat(i.requires || [], i.requiresIfExists || []);
    l.forEach(function(d) {
      if (!o.has(d)) {
        var u = t.get(d);
        u && s(u);
      }
    }), n.push(i);
  }
  return e.forEach(function(i) {
    o.has(i.name) || s(i);
  }), n;
}
function orderModifiers(e) {
  var t = order(e);
  return modifierPhases.reduce(function(o, n) {
    return o.concat(t.filter(function(s) {
      return s.phase === n;
    }));
  }, []);
}
function debounce(e) {
  var t;
  return function() {
    return t || (t = new Promise(function(o) {
      Promise.resolve().then(function() {
        t = void 0, o(e());
      });
    })), t;
  };
}
function mergeByName(e) {
  var t = e.reduce(function(o, n) {
    var s = o[n.name];
    return o[n.name] = s ? Object.assign({}, s, n, {
      options: Object.assign({}, s.options, n.options),
      data: Object.assign({}, s.data, n.data)
    }) : n, o;
  }, {});
  return Object.keys(t).map(function(o) {
    return t[o];
  });
}
var DEFAULT_OPTIONS = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function areValidElements() {
  for (var e = arguments.length, t = new Array(e), o = 0; o < e; o++)
    t[o] = arguments[o];
  return !t.some(function(n) {
    return !(n && typeof n.getBoundingClientRect == "function");
  });
}
function popperGenerator(e) {
  e === void 0 && (e = {});
  var t = e, o = t.defaultModifiers, n = o === void 0 ? [] : o, s = t.defaultOptions, i = s === void 0 ? DEFAULT_OPTIONS : s;
  return function(d, u, c) {
    c === void 0 && (c = i);
    var p = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, DEFAULT_OPTIONS, i),
      modifiersData: {},
      elements: {
        reference: d,
        popper: u
      },
      attributes: {},
      styles: {}
    }, f = [], g = !1, y = {
      state: p,
      setOptions: function(E) {
        var $ = typeof E == "function" ? E(p.options) : E;
        T(), p.options = Object.assign({}, i, p.options, $), p.scrollParents = {
          reference: isElement(d) ? listScrollParents(d) : d.contextElement ? listScrollParents(d.contextElement) : [],
          popper: listScrollParents(u)
        };
        var R = orderModifiers(mergeByName([].concat(n, p.options.modifiers)));
        return p.orderedModifiers = R.filter(function(C) {
          return C.enabled;
        }), h(), y.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!g) {
          var E = p.elements, $ = E.reference, R = E.popper;
          if (areValidElements($, R)) {
            p.rects = {
              reference: getCompositeRect($, getOffsetParent(R), p.options.strategy === "fixed"),
              popper: getLayoutRect(R)
            }, p.reset = !1, p.placement = p.options.placement, p.orderedModifiers.forEach(function(w) {
              return p.modifiersData[w.name] = Object.assign({}, w.data);
            });
            for (var C = 0; C < p.orderedModifiers.length; C++) {
              if (p.reset === !0) {
                p.reset = !1, C = -1;
                continue;
              }
              var x = p.orderedModifiers[C], _ = x.fn, D = x.options, O = D === void 0 ? {} : D, v = x.name;
              typeof _ == "function" && (p = _({
                state: p,
                options: O,
                name: v,
                instance: y
              }) || p);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: debounce(function() {
        return new Promise(function(P) {
          y.forceUpdate(), P(p);
        });
      }),
      destroy: function() {
        T(), g = !0;
      }
    };
    if (!areValidElements(d, u))
      return y;
    y.setOptions(c).then(function(P) {
      !g && c.onFirstUpdate && c.onFirstUpdate(P);
    });
    function h() {
      p.orderedModifiers.forEach(function(P) {
        var E = P.name, $ = P.options, R = $ === void 0 ? {} : $, C = P.effect;
        if (typeof C == "function") {
          var x = C({
            state: p,
            name: E,
            instance: y,
            options: R
          }), _ = function() {
          };
          f.push(x || _);
        }
      });
    }
    function T() {
      f.forEach(function(P) {
        return P();
      }), f = [];
    }
    return y;
  };
}
var defaultModifiers = [eventListeners, popperOffsets$1, computeStyles$1, applyStyles$1, offset$1, flip$1, preventOverflow$1, arrow$1, hide$1], createPopper = /* @__PURE__ */ popperGenerator({
  defaultModifiers
});
function getPopperUtilityClass(e) {
  return generateUtilityClass("MuiPopper", e);
}
generateUtilityClasses("MuiPopper", ["root"]);
function flipPlacement(e, t) {
  if (t === "ltr")
    return e;
  switch (e) {
    case "bottom-end":
      return "bottom-start";
    case "bottom-start":
      return "bottom-end";
    case "top-end":
      return "top-start";
    case "top-start":
      return "top-end";
    default:
      return e;
  }
}
function resolveAnchorEl(e) {
  return typeof e == "function" ? e() : e;
}
function isHTMLElement(e) {
  return e.nodeType !== void 0;
}
function isVirtualElement(e) {
  return !isHTMLElement(e);
}
const useUtilityClasses$a = (e) => {
  const {
    classes: t
  } = e;
  return composeClasses({
    root: ["root"]
  }, getPopperUtilityClass, t);
}, defaultPopperOptions = {}, PopperTooltip = /* @__PURE__ */ React.forwardRef(function e(t, o) {
  const {
    anchorEl: n,
    children: s,
    direction: i,
    disablePortal: l,
    modifiers: d,
    open: u,
    placement: c,
    popperOptions: p,
    popperRef: f,
    slotProps: g = {},
    slots: y = {},
    TransitionProps: h,
    // @ts-ignore internal logic
    ownerState: T,
    // prevent from spreading to DOM, it can come from the parent component e.g. Select.
    ...P
  } = t, E = React.useRef(null), $ = useForkRef(E, o), R = React.useRef(null), C = useForkRef(R, f), x = React.useRef(C);
  useEnhancedEffect(() => {
    x.current = C;
  }, [C]), React.useImperativeHandle(f, () => R.current, []);
  const _ = flipPlacement(c, i), [D, O] = React.useState(_), [v, w] = React.useState(resolveAnchorEl(n));
  React.useEffect(() => {
    R.current && R.current.forceUpdate();
  }), React.useEffect(() => {
    n && w(resolveAnchorEl(n));
  }, [n]), useEnhancedEffect(() => {
    if (!v || !u)
      return;
    const F = (W) => {
      O(W.placement);
    };
    if (process.env.NODE_ENV !== "production" && v && isHTMLElement(v) && v.nodeType === 1) {
      const W = v.getBoundingClientRect();
      process.env.NODE_ENV !== "test" && W.top === 0 && W.left === 0 && W.right === 0 && W.bottom === 0 && console.warn(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
    }
    let L = [{
      name: "preventOverflow",
      options: {
        altBoundary: l
      }
    }, {
      name: "flip",
      options: {
        altBoundary: l
      }
    }, {
      name: "onUpdate",
      enabled: !0,
      phase: "afterWrite",
      fn: ({
        state: W
      }) => {
        F(W);
      }
    }];
    d != null && (L = L.concat(d)), p && p.modifiers != null && (L = L.concat(p.modifiers));
    const k = createPopper(v, E.current, {
      placement: _,
      ...p,
      modifiers: L
    });
    return x.current(k), () => {
      k.destroy(), x.current(null);
    };
  }, [v, l, d, u, p, _]);
  const M = {
    placement: D
  };
  h !== null && (M.TransitionProps = h);
  const S = useUtilityClasses$a(t), I = y.root ?? "div", N = useSlotProps({
    elementType: I,
    externalSlotProps: g.root,
    externalForwardedProps: P,
    additionalProps: {
      role: "tooltip",
      ref: $
    },
    ownerState: t,
    className: S.root
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(I, {
    ...N,
    children: typeof s == "function" ? s(M) : s
  });
}), Popper$1 = /* @__PURE__ */ React.forwardRef(function e(t, o) {
  const {
    anchorEl: n,
    children: s,
    container: i,
    direction: l = "ltr",
    disablePortal: d = !1,
    keepMounted: u = !1,
    modifiers: c,
    open: p,
    placement: f = "bottom",
    popperOptions: g = defaultPopperOptions,
    popperRef: y,
    style: h,
    transition: T = !1,
    slotProps: P = {},
    slots: E = {},
    ...$
  } = t, [R, C] = React.useState(!0), x = () => {
    C(!1);
  }, _ = () => {
    C(!0);
  };
  if (!u && !p && (!T || R))
    return null;
  let D;
  if (i)
    D = i;
  else if (n) {
    const w = resolveAnchorEl(n);
    D = w && isHTMLElement(w) ? ownerDocument(w).body : ownerDocument(null).body;
  }
  const O = !p && u && (!T || R) ? "none" : void 0, v = T ? {
    in: p,
    onEnter: x,
    onExited: _
  } : void 0;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Portal, {
    disablePortal: d,
    container: D,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(PopperTooltip, {
      anchorEl: n,
      direction: l,
      disablePortal: d,
      modifiers: c,
      ref: o,
      open: T ? !R : p,
      placement: f,
      popperOptions: g,
      popperRef: y,
      slotProps: P,
      slots: E,
      ...$,
      style: {
        // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
        position: "fixed",
        // Fix Popper.js display issue
        top: 0,
        left: 0,
        display: O,
        ...h
      },
      TransitionProps: v,
      children: s
    })
  });
});
process.env.NODE_ENV !== "production" && (Popper$1.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * An HTML element, [virtualElement](https://popper.js.org/docs/v2/virtual-elements/),
   * or a function that returns either.
   * It's used to set the position of the popper.
   * The return value will passed as the reference object of the Popper instance.
   */
  anchorEl: chainPropTypes(PropTypes.oneOfType([HTMLElementType, PropTypes.object, PropTypes.func]), (e) => {
    if (e.open) {
      const t = resolveAnchorEl(e.anchorEl);
      if (t && isHTMLElement(t) && t.nodeType === 1) {
        const o = t.getBoundingClientRect();
        if (process.env.NODE_ENV !== "test" && o.top === 0 && o.left === 0 && o.right === 0 && o.bottom === 0)
          return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
      } else if (!t || typeof t.getBoundingClientRect != "function" || isVirtualElement(t) && t.contextElement != null && t.contextElement.nodeType !== 1)
        return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "It should be an HTML element instance or a virtualElement ", "(https://popper.js.org/docs/v2/virtual-elements/)."].join(`
`));
    }
    return null;
  }),
  /**
   * Popper render function or node.
   */
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: PropTypes.oneOfType([HTMLElementType, PropTypes.func]),
  /**
   * Direction of the text.
   * @default 'ltr'
   */
  direction: PropTypes.oneOf(["ltr", "rtl"]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: PropTypes.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Popper.
   * @default false
   */
  keepMounted: PropTypes.bool,
  /**
   * Popper.js is based on a "plugin-like" architecture,
   * most of its features are fully encapsulated "modifiers".
   *
   * A modifier is a function that is called each time Popper.js needs to
   * compute the position of the popper.
   * For this reason, modifiers should be very performant to avoid bottlenecks.
   * To learn how to create a modifier, [read the modifiers documentation](https://popper.js.org/docs/v2/modifiers/).
   */
  modifiers: PropTypes.arrayOf(PropTypes.shape({
    data: PropTypes.object,
    effect: PropTypes.func,
    enabled: PropTypes.bool,
    fn: PropTypes.func,
    name: PropTypes.any,
    options: PropTypes.object,
    phase: PropTypes.oneOf(["afterMain", "afterRead", "afterWrite", "beforeMain", "beforeRead", "beforeWrite", "main", "read", "write"]),
    requires: PropTypes.arrayOf(PropTypes.string),
    requiresIfExists: PropTypes.arrayOf(PropTypes.string)
  })),
  /**
   * If `true`, the component is shown.
   */
  open: PropTypes.bool.isRequired,
  /**
   * Popper placement.
   * @default 'bottom'
   */
  placement: PropTypes.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  /**
   * Options provided to the [`Popper.js`](https://popper.js.org/docs/v2/constructors/#options) instance.
   * @default {}
   */
  popperOptions: PropTypes.shape({
    modifiers: PropTypes.array,
    onFirstUpdate: PropTypes.func,
    placement: PropTypes.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
    strategy: PropTypes.oneOf(["absolute", "fixed"])
  }),
  /**
   * A ref that points to the used popper instance.
   */
  popperRef: refType,
  /**
   * The props used for each slot inside the Popper.
   * @default {}
   */
  slotProps: PropTypes.shape({
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: PropTypes.shape({
    root: PropTypes.elementType
  }),
  /**
   * Help supporting a react-transition-group/Transition component.
   * @default false
   */
  transition: PropTypes.bool
});
const PopperRoot = styled(Popper$1, {
  name: "MuiPopper",
  slot: "Root"
})({}), Popper = /* @__PURE__ */ React.forwardRef(function e(t, o) {
  const n = useRtl(), s = useDefaultProps({
    props: t,
    name: "MuiPopper"
  }), {
    anchorEl: i,
    component: l,
    components: d,
    componentsProps: u,
    container: c,
    disablePortal: p,
    keepMounted: f,
    modifiers: g,
    open: y,
    placement: h,
    popperOptions: T,
    popperRef: P,
    transition: E,
    slots: $,
    slotProps: R,
    ...C
  } = s, x = $?.root ?? d?.Root, _ = {
    anchorEl: i,
    container: c,
    disablePortal: p,
    keepMounted: f,
    modifiers: g,
    open: y,
    placement: h,
    popperOptions: T,
    popperRef: P,
    transition: E,
    ...C
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(PopperRoot, {
    as: l,
    direction: n ? "rtl" : "ltr",
    slots: {
      root: x
    },
    slotProps: R ?? u,
    ..._,
    ref: o
  });
});
process.env.NODE_ENV !== "production" && (Popper.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * An HTML element, [virtualElement](https://popper.js.org/docs/v2/virtual-elements/),
   * or a function that returns either.
   * It's used to set the position of the popper.
   * The return value will passed as the reference object of the Popper instance.
   */
  anchorEl: PropTypes.oneOfType([HTMLElementType, PropTypes.object, PropTypes.func]),
  /**
   * Popper render function or node.
   */
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in a future major release. [How to migrate](/material-ui/migration/migrating-from-deprecated-apis/).
   * @default {}
   */
  components: PropTypes.shape({
    Root: PropTypes.elementType
  }),
  /**
   * The props used for each slot inside the Popper.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in a future major release. [How to migrate](/material-ui/migration/migrating-from-deprecated-apis/).
   * @default {}
   */
  componentsProps: PropTypes.shape({
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: PropTypes.oneOfType([HTMLElementType, PropTypes.func]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: PropTypes.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Popper.
   * @default false
   */
  keepMounted: PropTypes.bool,
  /**
   * Popper.js is based on a "plugin-like" architecture,
   * most of its features are fully encapsulated "modifiers".
   *
   * A modifier is a function that is called each time Popper.js needs to
   * compute the position of the popper.
   * For this reason, modifiers should be very performant to avoid bottlenecks.
   * To learn how to create a modifier, [read the modifiers documentation](https://popper.js.org/docs/v2/modifiers/).
   */
  modifiers: PropTypes.arrayOf(PropTypes.shape({
    data: PropTypes.object,
    effect: PropTypes.func,
    enabled: PropTypes.bool,
    fn: PropTypes.func,
    name: PropTypes.any,
    options: PropTypes.object,
    phase: PropTypes.oneOf(["afterMain", "afterRead", "afterWrite", "beforeMain", "beforeRead", "beforeWrite", "main", "read", "write"]),
    requires: PropTypes.arrayOf(PropTypes.string),
    requiresIfExists: PropTypes.arrayOf(PropTypes.string)
  })),
  /**
   * If `true`, the component is shown.
   */
  open: PropTypes.bool.isRequired,
  /**
   * Popper placement.
   * @default 'bottom'
   */
  placement: PropTypes.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  /**
   * Options provided to the [`Popper.js`](https://popper.js.org/docs/v2/constructors/#options) instance.
   * @default {}
   */
  popperOptions: PropTypes.shape({
    modifiers: PropTypes.array,
    onFirstUpdate: PropTypes.func,
    placement: PropTypes.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
    strategy: PropTypes.oneOf(["absolute", "fixed"])
  }),
  /**
   * A ref that points to the used popper instance.
   */
  popperRef: refType,
  /**
   * The props used for each slot inside the Popper.
   * @default {}
   */
  slotProps: PropTypes.shape({
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: PropTypes.shape({
    root: PropTypes.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Help supporting a react-transition-group/Transition component.
   * @default false
   */
  transition: PropTypes.bool
});
function getPickerPopperUtilityClass(e) {
  return generateUtilityClass("MuiPickerPopper", e);
}
generateUtilityClasses("MuiPickerPopper", ["root", "paper"]);
const _excluded$7 = ["PaperComponent", "ownerState", "children", "paperSlotProps", "paperClasses", "onPaperClick", "onPaperTouchStart"], useUtilityClasses$9 = (e) => composeClasses({
  root: ["root"],
  paper: ["paper"]
}, getPickerPopperUtilityClass, e), PickerPopperRoot = styled(Popper, {
  name: "MuiPickerPopper",
  slot: "Root"
})(({
  theme: e
}) => ({
  zIndex: e.zIndex.modal
})), PickerPopperPaper = styled(Paper, {
  name: "MuiPickerPopper",
  slot: "Paper"
})({
  outline: 0,
  transformOrigin: "top center",
  variants: [{
    props: ({
      popperPlacement: e
    }) => (/* @__PURE__ */ new Set(["top", "top-start", "top-end"])).has(e),
    style: {
      transformOrigin: "bottom center"
    }
  }]
});
function clickedRootScrollbar(e, t) {
  return t.documentElement.clientWidth < e.clientX || t.documentElement.clientHeight < e.clientY;
}
function useClickAwayListener(e, t) {
  const o = React.useRef(!1), n = React.useRef(!1), s = React.useRef(null), i = React.useRef(!1);
  React.useEffect(() => {
    if (!e)
      return;
    function u() {
      i.current = !0;
    }
    return document.addEventListener("mousedown", u, !0), document.addEventListener("touchstart", u, !0), () => {
      document.removeEventListener("mousedown", u, !0), document.removeEventListener("touchstart", u, !0), i.current = !1;
    };
  }, [e]);
  const l = useEventCallback((u) => {
    if (!i.current)
      return;
    const c = n.current;
    n.current = !1;
    const p = ownerDocument(s.current);
    if (!s.current || // is a TouchEvent?
    "clientX" in u && clickedRootScrollbar(u, p))
      return;
    if (o.current) {
      o.current = !1;
      return;
    }
    let f;
    u.composedPath ? f = u.composedPath().indexOf(s.current) > -1 : f = !p.documentElement.contains(u.target) || s.current.contains(u.target), !f && !c && t(u);
  }), d = (u) => {
    u.defaultMuiPrevented || (n.current = !0);
  };
  return React.useEffect(() => {
    if (e) {
      const u = ownerDocument(s.current), c = () => {
        o.current = !0;
      };
      return u.addEventListener("touchstart", l), u.addEventListener("touchmove", c), () => {
        u.removeEventListener("touchstart", l), u.removeEventListener("touchmove", c);
      };
    }
  }, [e, l]), React.useEffect(() => {
    if (e) {
      const u = ownerDocument(s.current);
      return u.addEventListener("click", l), () => {
        u.removeEventListener("click", l), n.current = !1;
      };
    }
  }, [e, l]), [s, d, d];
}
const PickerPopperPaperWrapper = /* @__PURE__ */ React.forwardRef((e, t) => {
  const {
    PaperComponent: o,
    ownerState: n,
    children: s,
    paperSlotProps: i,
    paperClasses: l,
    onPaperClick: d,
    onPaperTouchStart: u
    // picks up the style props provided by `Transition`
    // https://mui.com/material-ui/transitions/#child-requirement
  } = e, c = _objectWithoutPropertiesLoose(e, _excluded$7), p = useSlotProps({
    elementType: o,
    externalSlotProps: i,
    additionalProps: {
      tabIndex: -1,
      elevation: 8,
      ref: t
    },
    className: l,
    ownerState: n
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(o, _extends({}, c, p, {
    onClick: (f) => {
      d(f), p.onClick?.(f);
    },
    onTouchStart: (f) => {
      u(f), p.onTouchStart?.(f);
    },
    ownerState: n,
    children: s
  }));
});
process.env.NODE_ENV !== "production" && (PickerPopperPaperWrapper.displayName = "PickerPopperPaperWrapper");
function PickerPopper(e) {
  const t = useThemeProps({
    props: e,
    name: "MuiPickerPopper"
  }), {
    children: o,
    placement: n = "bottom-start",
    slots: s,
    slotProps: i,
    classes: l
  } = t, {
    open: d,
    popupRef: u,
    reduceAnimations: c
  } = usePickerContext(), {
    ownerState: p,
    rootRefObject: f
  } = usePickerPrivateContext(), {
    dismissViews: g,
    getCurrentViewMode: y,
    onPopperExited: h,
    triggerElement: T,
    viewContainerRole: P
  } = usePickerPrivateContext();
  React.useEffect(() => {
    function k(W) {
      d && W.key === "Escape" && g();
    }
    return document.addEventListener("keydown", k), () => {
      document.removeEventListener("keydown", k);
    };
  }, [g, d]);
  const E = React.useRef(null);
  React.useEffect(() => {
    P === "tooltip" || y() === "field" || (d ? E.current = getActiveElement(f.current) : E.current && E.current instanceof HTMLElement && setTimeout(() => {
      E.current instanceof HTMLElement && E.current.focus();
    }));
  }, [d, P, y, f]);
  const $ = useUtilityClasses$9(l), R = useEventCallback(() => {
    P === "tooltip" ? executeInTheNextEventLoopTick(() => {
      f.current?.contains(getActiveElement(f.current)) || u.current?.contains(getActiveElement(u.current)) || g();
    }) : g();
  }), [C, x, _] = useClickAwayListener(d, R), D = React.useRef(null), O = useForkRef(D, u), v = useForkRef(O, C), w = (k) => {
    k.key === "Escape" && (k.stopPropagation(), g());
  }, M = s?.desktopTransition ?? c ? Fade : Grow, S = s?.desktopTrapFocus ?? FocusTrap, I = s?.desktopPaper ?? PickerPopperPaper, N = s?.popper ?? PickerPopperRoot, F = useSlotProps({
    elementType: N,
    externalSlotProps: i?.popper,
    additionalProps: {
      transition: !0,
      role: P ?? void 0,
      open: d,
      placement: n,
      anchorEl: T,
      onKeyDown: w
    },
    className: $.root,
    ownerState: p
  }), L = React.useMemo(() => _extends({}, p, {
    popperPlacement: F.placement
  }), [p, F.placement]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(N, _extends({}, F, {
    children: ({
      TransitionProps: k
    }) => /* @__PURE__ */ jsxRuntimeExports.jsx(S, _extends({
      open: d,
      disableAutoFocus: !0,
      disableRestoreFocus: !0,
      disableEnforceFocus: P === "tooltip",
      isEnabled: () => !0
    }, i?.desktopTrapFocus, {
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(M, _extends({}, k, i?.desktopTransition, {
        onExited: (W) => {
          h?.(), i?.desktopTransition?.onExited?.(W), k?.onExited?.();
        },
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(PickerPopperPaperWrapper, {
          PaperComponent: I,
          ownerState: L,
          ref: v,
          onPaperClick: x,
          onPaperTouchStart: _,
          paperClasses: $.paper,
          paperSlotProps: i?.desktopPaper,
          children: o
        })
      }))
    }))
  }));
}
function getOrientation() {
  return typeof window > "u" ? "portrait" : window.screen && window.screen.orientation && window.screen.orientation.angle ? Math.abs(window.screen.orientation.angle) === 90 ? "landscape" : "portrait" : window.orientation && Math.abs(Number(window.orientation)) === 90 ? "landscape" : "portrait";
}
function useOrientation(e, t) {
  const [o, n] = React.useState(getOrientation);
  return useEnhancedEffect(() => {
    const s = () => {
      n(getOrientation());
    };
    return window.addEventListener("orientationchange", s), () => {
      window.removeEventListener("orientationchange", s);
    };
  }, []), arrayIncludes(e, ["hours", "minutes", "seconds"]) ? "portrait" : t ?? o;
}
const warnedOnceCache = /* @__PURE__ */ new Set();
function warnOnce(e, t = "warning") {
  if (process.env.NODE_ENV === "production")
    return;
  const o = Array.isArray(e) ? e.join(`
`) : e;
  warnedOnceCache.has(o) || (warnedOnceCache.add(o), t === "error" ? console.error(o) : console.warn(o));
}
function useValueAndOpenStates(e) {
  const {
    props: t,
    valueManager: o,
    validator: n
  } = e, {
    value: s,
    defaultValue: i,
    onChange: l,
    referenceDate: d,
    timezone: u,
    onAccept: c,
    closeOnSelect: p,
    open: f,
    onOpen: g,
    onClose: y
  } = t, {
    current: h
  } = React.useRef(i), {
    current: T
  } = React.useRef(s !== void 0), {
    current: P
  } = React.useRef(f !== void 0), E = usePickerAdapter();
  process.env.NODE_ENV !== "production" && t.renderInput != null && warnOnce(["MUI X: The `renderInput` prop has been removed in version 6.0 of the Date and Time Pickers.", "You can replace it with the `textField` component slot in most cases.", "For more information, please have a look at the migration guide (https://mui.com/x/migration/migration-pickers-v5/#input-renderer-required-in-v5)."]), process.env.NODE_ENV !== "production" && (React.useEffect(() => {
    T !== (s !== void 0) && console.error([`MUI X: A component is changing the ${T ? "" : "un"}controlled value of a Picker to be ${T ? "un" : ""}controlled.`, "Elements should not switch from uncontrolled to controlled (or vice versa).", "Decide between using a controlled or uncontrolled valuefor the lifetime of the component.", "The nature of the state is determined during the first render. It's considered controlled if the value is not `undefined`.", "More info: https://fb.me/react-controlled-components"].join(`
`));
  }, [s]), React.useEffect(() => {
    !T && h !== i && console.error(["MUI X: A component is changing the defaultValue of an uncontrolled Picker after being initialized. To suppress this warning opt to use a controlled value."].join(`
`));
  }, [JSON.stringify(h)]));
  const {
    timezone: $,
    value: R,
    handleValueChange: C
  } = useControlledValue({
    name: "a picker component",
    timezone: u,
    value: s,
    defaultValue: h,
    referenceDate: d,
    onChange: l,
    valueManager: o
  }), [x, _] = React.useState(() => ({
    open: !1,
    lastExternalValue: R,
    clockShallowValue: void 0,
    lastCommittedValue: R,
    hasBeenModifiedSinceMount: !1
  })), {
    getValidationErrorForNewValue: D
  } = useValidation({
    props: t,
    validator: n,
    timezone: $,
    value: R,
    onError: t.onError
  }), O = useEventCallback((S) => {
    const I = typeof S == "function" ? S(x.open) : S;
    P || _((N) => _extends({}, N, {
      open: I
    })), I && g && g(), I || y?.();
  }), v = useEventCallback((S, I) => {
    const {
      changeImportance: N = "accept",
      skipPublicationIfPristine: F = !1,
      validationError: L,
      shortcut: k,
      shouldClose: W = N === "accept"
    } = I ?? {};
    let V, j;
    !F && !T && !x.hasBeenModifiedSinceMount ? (V = !0, j = N === "accept") : (V = !o.areValuesEqual(E, S, R), j = N === "accept" && !o.areValuesEqual(E, S, x.lastCommittedValue)), _((G) => _extends({}, G, {
      // We reset the shallow value whenever we fire onChange.
      clockShallowValue: V ? void 0 : G.clockShallowValue,
      lastCommittedValue: j ? S : G.lastCommittedValue,
      hasBeenModifiedSinceMount: !0
    }));
    let A = null;
    const U = () => (A || (A = {
      validationError: L ?? D(S)
    }, k && (A.shortcut = k)), A);
    V && C(S, U()), j && c && c(S, U()), W && O(!1);
  });
  R !== x.lastExternalValue && _((S) => _extends({}, S, {
    lastExternalValue: R,
    clockShallowValue: void 0,
    hasBeenModifiedSinceMount: !0
  }));
  const w = useEventCallback((S, I = "partial") => {
    if (I === "shallow") {
      _((N) => _extends({}, N, {
        clockShallowValue: S,
        hasBeenModifiedSinceMount: !0
      }));
      return;
    }
    v(S, {
      changeImportance: I === "finish" && p ? "accept" : "set"
    });
  });
  React.useEffect(() => {
    if (P) {
      if (f === void 0)
        throw new Error("You must not mix controlling and uncontrolled mode for `open` prop");
      _((S) => _extends({}, S, {
        open: f
      }));
    }
  }, [P, f]);
  const M = React.useMemo(() => o.cleanValue(E, x.clockShallowValue === void 0 ? R : x.clockShallowValue), [E, o, x.clockShallowValue, R]);
  return {
    timezone: $,
    state: x,
    setValue: v,
    setValueFromView: w,
    setOpen: O,
    value: R,
    viewValue: M
  };
}
const _excluded$6 = ["className", "sx"], usePicker = ({
  ref: e,
  props: t,
  valueManager: o,
  valueType: n,
  variant: s,
  validator: i,
  onPopperExited: l,
  autoFocusView: d,
  rendererInterceptor: u,
  localeText: c,
  viewContainerRole: p,
  getStepNavigation: f
}) => {
  const {
    // View props
    views: g,
    view: y,
    openTo: h,
    onViewChange: T,
    viewRenderers: P,
    reduceAnimations: E,
    orientation: $,
    disableOpenPicker: R,
    closeOnSelect: C,
    // Form props
    disabled: x,
    readOnly: _,
    // Field props
    formatDensity: D,
    enableAccessibleFieldDOMStructure: O,
    selectedSections: v,
    onSelectedSectionsChange: w,
    format: M,
    label: S,
    // Other props
    autoFocus: I,
    name: N
  } = t, {
    className: F,
    sx: L
  } = t, k = _objectWithoutPropertiesLoose(t, _excluded$6), W = useId(), V = usePickerAdapter(), j = useReduceAnimations(E), A = useOrientation(g, $), {
    current: U
  } = React.useRef(h ?? null), [G, Y] = React.useState(null), ee = React.useRef(null), J = React.useRef(null), Z = React.useRef(null), le = useForkRef(e, Z), {
    timezone: se,
    state: K,
    setOpen: q,
    setValue: B,
    setValueFromView: ue,
    value: re,
    viewValue: be
  } = useValueAndOpenStates({
    props: t,
    valueManager: o,
    validator: i
  }), {
    view: X,
    setView: ge,
    defaultView: Ee,
    focusedView: xe,
    setFocusedView: he,
    setValueAndGoToNextView: Pe,
    goToNextStep: ye,
    hasNextStep: _e,
    hasSeveralSteps: Ce
  } = useViews({
    view: y,
    views: g,
    openTo: h,
    onChange: ue,
    onViewChange: T,
    autoFocus: d,
    getStepNavigation: f
  }), ne = useEventCallback(() => B(o.emptyValue)), H = useEventCallback(() => B(o.getTodayValue(V, se, n))), te = useEventCallback(() => B(re)), ie = useEventCallback(() => B(K.lastCommittedValue, {
    skipPublicationIfPristine: !0
  })), ce = useEventCallback(() => {
    B(re, {
      skipPublicationIfPristine: !0
    });
  }), {
    hasUIView: me,
    viewModeLookup: pe,
    timeViewsCount: z
  } = React.useMemo(() => g.reduce((Ne, Ae) => {
    const Le = P[Ae] == null ? "field" : "UI";
    return Ne.viewModeLookup[Ae] = Le, Le === "UI" && (Ne.hasUIView = !0, isTimeView(Ae) && (Ne.timeViewsCount += 1)), Ne;
  }, {
    hasUIView: !1,
    viewModeLookup: {},
    timeViewsCount: 0
  }), [P, g]), Q = pe[X], Te = useEventCallback(() => Q), [fe, oe] = React.useState(Q === "UI" ? X : null);
  fe !== X && pe[X] === "UI" && oe(X), useEnhancedEffect(() => {
    Q === "field" && K.open && (q(!1), setTimeout(() => {
      J?.current?.setSelectedSections(X), J?.current?.focusField(X);
    }));
  }, [X]), useEnhancedEffect(() => {
    if (!K.open)
      return;
    let Ne = X;
    Q === "field" && fe != null && (Ne = fe), Ne !== Ee && pe[Ne] === "UI" && pe[Ee] === "UI" && (Ne = Ee), Ne !== X && ge(Ne), he(Ne, !0);
  }, [K.open]);
  const ae = React.useMemo(() => ({
    isPickerValueEmpty: o.areValuesEqual(V, re, o.emptyValue),
    isPickerOpen: K.open,
    isPickerDisabled: t.disabled ?? !1,
    isPickerReadOnly: t.readOnly ?? !1,
    pickerOrientation: A,
    pickerVariant: s
  }), [V, o, re, K.open, A, s, t.disabled, t.readOnly]), Se = React.useMemo(() => R || !me ? "hidden" : x || _ ? "disabled" : "enabled", [R, me, x, _]), $e = useEventCallback(ye), Re = React.useMemo(() => C && !Ce ? [] : ["cancel", "nextOrAccept"], [C, Ce]), Oe = React.useMemo(() => ({
    setValue: B,
    setOpen: q,
    clearValue: ne,
    setValueToToday: H,
    acceptValueChanges: te,
    cancelValueChanges: ie,
    setView: ge,
    goToNextStep: $e
  }), [B, q, ne, H, te, ie, ge, $e]), ve = React.useMemo(() => _extends({}, Oe, {
    value: re,
    timezone: se,
    open: K.open,
    views: g,
    view: fe,
    initialView: U,
    disabled: x ?? !1,
    readOnly: _ ?? !1,
    autoFocus: I ?? !1,
    variant: s,
    orientation: A,
    popupRef: ee,
    reduceAnimations: j,
    triggerRef: Y,
    triggerStatus: Se,
    hasNextStep: _e,
    fieldFormat: M ?? "",
    name: N,
    label: S,
    rootSx: L,
    rootRef: le,
    rootClassName: F
  }), [Oe, re, le, s, A, j, x, _, M, F, N, S, L, Se, _e, se, K.open, fe, g, U, I]), Ie = React.useMemo(() => ({
    dismissViews: ce,
    ownerState: ae,
    hasUIView: me,
    getCurrentViewMode: Te,
    rootRefObject: Z,
    labelId: W,
    triggerElement: G,
    viewContainerRole: p,
    defaultActionBarActions: Re,
    onPopperExited: l
  }), [ce, ae, me, Te, W, G, p, Re, l]), we = React.useMemo(() => ({
    formatDensity: D,
    enableAccessibleFieldDOMStructure: O,
    selectedSections: v,
    onSelectedSectionsChange: w,
    fieldRef: J
  }), [D, O, v, w, J]);
  return {
    providerProps: {
      localeText: c,
      contextValue: ve,
      privateContextValue: Ie,
      actionsContextValue: Oe,
      fieldPrivateContextValue: we,
      isValidContextValue: (Ne) => {
        const Ae = i({
          adapter: V,
          value: Ne,
          timezone: se,
          props: t
        });
        return !o.hasError(Ae);
      }
    },
    renderCurrentView: () => {
      if (fe == null)
        return null;
      const Ne = P[fe];
      if (Ne == null)
        return null;
      const Ae = _extends({}, k, {
        views: g,
        timezone: se,
        value: be,
        onChange: Pe,
        view: fe,
        onViewChange: ge,
        showViewSwitcher: z > 1,
        timeViewsCount: z
      }, p === "tooltip" ? {
        focusedView: null,
        onFocusedViewChange: () => {
        }
      } : {
        focusedView: xe,
        onFocusedViewChange: he
      });
      return u ? /* @__PURE__ */ jsxRuntimeExports.jsx(u, {
        viewRenderers: P,
        popperView: fe,
        rendererProps: Ae
      }) : Ne(Ae);
    },
    ownerState: ae
  };
};
function getPickersLayoutUtilityClass(e) {
  return generateUtilityClass("MuiPickersLayout", e);
}
const pickersLayoutClasses = generateUtilityClasses("MuiPickersLayout", ["root", "landscape", "contentWrapper", "toolbar", "actionBar", "tabs", "shortcuts"]);
function getButtonUtilityClass(e) {
  return generateUtilityClass("MuiButton", e);
}
const buttonClasses = generateUtilityClasses("MuiButton", ["root", "text", "textInherit", "textPrimary", "textSecondary", "textSuccess", "textError", "textInfo", "textWarning", "outlined", "outlinedInherit", "outlinedPrimary", "outlinedSecondary", "outlinedSuccess", "outlinedError", "outlinedInfo", "outlinedWarning", "contained", "containedInherit", "containedPrimary", "containedSecondary", "containedSuccess", "containedError", "containedInfo", "containedWarning", "disableElevation", "focusVisible", "disabled", "colorInherit", "colorPrimary", "colorSecondary", "colorSuccess", "colorError", "colorInfo", "colorWarning", "textSizeSmall", "textSizeMedium", "textSizeLarge", "outlinedSizeSmall", "outlinedSizeMedium", "outlinedSizeLarge", "containedSizeSmall", "containedSizeMedium", "containedSizeLarge", "sizeMedium", "sizeSmall", "sizeLarge", "fullWidth", "startIcon", "endIcon", "icon", "iconSizeSmall", "iconSizeMedium", "iconSizeLarge", "loading", "loadingWrapper", "loadingIconPlaceholder", "loadingIndicator", "loadingPositionCenter", "loadingPositionStart", "loadingPositionEnd"]), ButtonGroupContext = /* @__PURE__ */ React.createContext({});
process.env.NODE_ENV !== "production" && (ButtonGroupContext.displayName = "ButtonGroupContext");
const ButtonGroupButtonContext = /* @__PURE__ */ React.createContext(void 0);
process.env.NODE_ENV !== "production" && (ButtonGroupButtonContext.displayName = "ButtonGroupButtonContext");
const useUtilityClasses$8 = (e) => {
  const {
    color: t,
    disableElevation: o,
    fullWidth: n,
    size: s,
    variant: i,
    loading: l,
    loadingPosition: d,
    classes: u
  } = e, c = {
    root: ["root", l && "loading", i, `${i}${capitalize(t)}`, `size${capitalize(s)}`, `${i}Size${capitalize(s)}`, `color${capitalize(t)}`, o && "disableElevation", n && "fullWidth", l && `loadingPosition${capitalize(d)}`],
    startIcon: ["icon", "startIcon", `iconSize${capitalize(s)}`],
    endIcon: ["icon", "endIcon", `iconSize${capitalize(s)}`],
    loadingIndicator: ["loadingIndicator"],
    loadingWrapper: ["loadingWrapper"]
  }, p = composeClasses(c, getButtonUtilityClass, u);
  return {
    ...u,
    // forward the focused, disabled, etc. classes to the ButtonBase
    ...p
  };
}, commonIconStyles = [{
  props: {
    size: "small"
  },
  style: {
    "& > *:nth-of-type(1)": {
      fontSize: 18
    }
  }
}, {
  props: {
    size: "medium"
  },
  style: {
    "& > *:nth-of-type(1)": {
      fontSize: 20
    }
  }
}, {
  props: {
    size: "large"
  },
  style: {
    "& > *:nth-of-type(1)": {
      fontSize: 22
    }
  }
}], ButtonRoot = styled(ButtonBase, {
  shouldForwardProp: (e) => rootShouldForwardProp(e) || e === "classes",
  name: "MuiButton",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.root, t[o.variant], t[`${o.variant}${capitalize(o.color)}`], t[`size${capitalize(o.size)}`], t[`${o.variant}Size${capitalize(o.size)}`], o.color === "inherit" && t.colorInherit, o.disableElevation && t.disableElevation, o.fullWidth && t.fullWidth, o.loading && t.loading];
  }
})(memoTheme(({
  theme: e
}) => {
  const t = e.palette.mode === "light" ? e.palette.grey[300] : e.palette.grey[800], o = e.palette.mode === "light" ? e.palette.grey.A100 : e.palette.grey[700];
  return {
    ...e.typography.button,
    minWidth: 64,
    padding: "6px 16px",
    border: 0,
    borderRadius: (e.vars || e).shape.borderRadius,
    transition: e.transitions.create(["background-color", "box-shadow", "border-color", "color"], {
      duration: e.transitions.duration.short
    }),
    "&:hover": {
      textDecoration: "none"
    },
    [`&.${buttonClasses.disabled}`]: {
      color: (e.vars || e).palette.action.disabled
    },
    variants: [{
      props: {
        variant: "contained"
      },
      style: {
        color: "var(--variant-containedColor)",
        backgroundColor: "var(--variant-containedBg)",
        boxShadow: (e.vars || e).shadows[2],
        "&:hover": {
          boxShadow: (e.vars || e).shadows[4],
          // Reset on touch devices, it doesn't add specificity
          "@media (hover: none)": {
            boxShadow: (e.vars || e).shadows[2]
          }
        },
        "&:active": {
          boxShadow: (e.vars || e).shadows[8]
        },
        [`&.${buttonClasses.focusVisible}`]: {
          boxShadow: (e.vars || e).shadows[6]
        },
        [`&.${buttonClasses.disabled}`]: {
          color: (e.vars || e).palette.action.disabled,
          boxShadow: (e.vars || e).shadows[0],
          backgroundColor: (e.vars || e).palette.action.disabledBackground
        }
      }
    }, {
      props: {
        variant: "outlined"
      },
      style: {
        padding: "5px 15px",
        border: "1px solid currentColor",
        borderColor: "var(--variant-outlinedBorder, currentColor)",
        backgroundColor: "var(--variant-outlinedBg)",
        color: "var(--variant-outlinedColor)",
        [`&.${buttonClasses.disabled}`]: {
          border: `1px solid ${(e.vars || e).palette.action.disabledBackground}`
        }
      }
    }, {
      props: {
        variant: "text"
      },
      style: {
        padding: "6px 8px",
        color: "var(--variant-textColor)",
        backgroundColor: "var(--variant-textBg)"
      }
    }, ...Object.entries(e.palette).filter(createSimplePaletteValueFilter()).map(([n]) => ({
      props: {
        color: n
      },
      style: {
        "--variant-textColor": (e.vars || e).palette[n].main,
        "--variant-outlinedColor": (e.vars || e).palette[n].main,
        "--variant-outlinedBorder": e.alpha((e.vars || e).palette[n].main, 0.5),
        "--variant-containedColor": (e.vars || e).palette[n].contrastText,
        "--variant-containedBg": (e.vars || e).palette[n].main,
        "@media (hover: hover)": {
          "&:hover": {
            "--variant-containedBg": (e.vars || e).palette[n].dark,
            "--variant-textBg": e.alpha((e.vars || e).palette[n].main, (e.vars || e).palette.action.hoverOpacity),
            "--variant-outlinedBorder": (e.vars || e).palette[n].main,
            "--variant-outlinedBg": e.alpha((e.vars || e).palette[n].main, (e.vars || e).palette.action.hoverOpacity)
          }
        }
      }
    })), {
      props: {
        color: "inherit"
      },
      style: {
        color: "inherit",
        borderColor: "currentColor",
        "--variant-containedBg": e.vars ? e.vars.palette.Button.inheritContainedBg : t,
        "@media (hover: hover)": {
          "&:hover": {
            "--variant-containedBg": e.vars ? e.vars.palette.Button.inheritContainedHoverBg : o,
            "--variant-textBg": e.alpha((e.vars || e).palette.text.primary, (e.vars || e).palette.action.hoverOpacity),
            "--variant-outlinedBg": e.alpha((e.vars || e).palette.text.primary, (e.vars || e).palette.action.hoverOpacity)
          }
        }
      }
    }, {
      props: {
        size: "small",
        variant: "text"
      },
      style: {
        padding: "4px 5px",
        fontSize: e.typography.pxToRem(13)
      }
    }, {
      props: {
        size: "large",
        variant: "text"
      },
      style: {
        padding: "8px 11px",
        fontSize: e.typography.pxToRem(15)
      }
    }, {
      props: {
        size: "small",
        variant: "outlined"
      },
      style: {
        padding: "3px 9px",
        fontSize: e.typography.pxToRem(13)
      }
    }, {
      props: {
        size: "large",
        variant: "outlined"
      },
      style: {
        padding: "7px 21px",
        fontSize: e.typography.pxToRem(15)
      }
    }, {
      props: {
        size: "small",
        variant: "contained"
      },
      style: {
        padding: "4px 10px",
        fontSize: e.typography.pxToRem(13)
      }
    }, {
      props: {
        size: "large",
        variant: "contained"
      },
      style: {
        padding: "8px 22px",
        fontSize: e.typography.pxToRem(15)
      }
    }, {
      props: {
        disableElevation: !0
      },
      style: {
        boxShadow: "none",
        "&:hover": {
          boxShadow: "none"
        },
        [`&.${buttonClasses.focusVisible}`]: {
          boxShadow: "none"
        },
        "&:active": {
          boxShadow: "none"
        },
        [`&.${buttonClasses.disabled}`]: {
          boxShadow: "none"
        }
      }
    }, {
      props: {
        fullWidth: !0
      },
      style: {
        width: "100%"
      }
    }, {
      props: {
        loadingPosition: "center"
      },
      style: {
        transition: e.transitions.create(["background-color", "box-shadow", "border-color"], {
          duration: e.transitions.duration.short
        }),
        [`&.${buttonClasses.loading}`]: {
          color: "transparent"
        }
      }
    }]
  };
})), ButtonStartIcon = styled("span", {
  name: "MuiButton",
  slot: "StartIcon",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.startIcon, o.loading && t.startIconLoadingStart, t[`iconSize${capitalize(o.size)}`]];
  }
})(({
  theme: e
}) => ({
  display: "inherit",
  marginRight: 8,
  marginLeft: -4,
  variants: [{
    props: {
      size: "small"
    },
    style: {
      marginLeft: -2
    }
  }, {
    props: {
      loadingPosition: "start",
      loading: !0
    },
    style: {
      transition: e.transitions.create(["opacity"], {
        duration: e.transitions.duration.short
      }),
      opacity: 0
    }
  }, {
    props: {
      loadingPosition: "start",
      loading: !0,
      fullWidth: !0
    },
    style: {
      marginRight: -8
    }
  }, ...commonIconStyles]
})), ButtonEndIcon = styled("span", {
  name: "MuiButton",
  slot: "EndIcon",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.endIcon, o.loading && t.endIconLoadingEnd, t[`iconSize${capitalize(o.size)}`]];
  }
})(({
  theme: e
}) => ({
  display: "inherit",
  marginRight: -4,
  marginLeft: 8,
  variants: [{
    props: {
      size: "small"
    },
    style: {
      marginRight: -2
    }
  }, {
    props: {
      loadingPosition: "end",
      loading: !0
    },
    style: {
      transition: e.transitions.create(["opacity"], {
        duration: e.transitions.duration.short
      }),
      opacity: 0
    }
  }, {
    props: {
      loadingPosition: "end",
      loading: !0,
      fullWidth: !0
    },
    style: {
      marginLeft: -8
    }
  }, ...commonIconStyles]
})), ButtonLoadingIndicator = styled("span", {
  name: "MuiButton",
  slot: "LoadingIndicator"
})(({
  theme: e
}) => ({
  display: "none",
  position: "absolute",
  visibility: "visible",
  variants: [{
    props: {
      loading: !0
    },
    style: {
      display: "flex"
    }
  }, {
    props: {
      loadingPosition: "start"
    },
    style: {
      left: 14
    }
  }, {
    props: {
      loadingPosition: "start",
      size: "small"
    },
    style: {
      left: 10
    }
  }, {
    props: {
      variant: "text",
      loadingPosition: "start"
    },
    style: {
      left: 6
    }
  }, {
    props: {
      loadingPosition: "center"
    },
    style: {
      left: "50%",
      transform: "translate(-50%)",
      color: (e.vars || e).palette.action.disabled
    }
  }, {
    props: {
      loadingPosition: "end"
    },
    style: {
      right: 14
    }
  }, {
    props: {
      loadingPosition: "end",
      size: "small"
    },
    style: {
      right: 10
    }
  }, {
    props: {
      variant: "text",
      loadingPosition: "end"
    },
    style: {
      right: 6
    }
  }, {
    props: {
      loadingPosition: "start",
      fullWidth: !0
    },
    style: {
      position: "relative",
      left: -10
    }
  }, {
    props: {
      loadingPosition: "end",
      fullWidth: !0
    },
    style: {
      position: "relative",
      right: -10
    }
  }]
})), ButtonLoadingIconPlaceholder = styled("span", {
  name: "MuiButton",
  slot: "LoadingIconPlaceholder"
})({
  display: "inline-block",
  width: "1em",
  height: "1em"
}), Button$2 = /* @__PURE__ */ React.forwardRef(function e(t, o) {
  const n = React.useContext(ButtonGroupContext), s = React.useContext(ButtonGroupButtonContext), i = resolveProps(n, t), l = useDefaultProps({
    props: i,
    name: "MuiButton"
  }), {
    children: d,
    color: u = "primary",
    component: c = "button",
    className: p,
    disabled: f = !1,
    disableElevation: g = !1,
    disableFocusRipple: y = !1,
    endIcon: h,
    focusVisibleClassName: T,
    fullWidth: P = !1,
    id: E,
    loading: $ = null,
    loadingIndicator: R,
    loadingPosition: C = "center",
    size: x = "medium",
    startIcon: _,
    type: D,
    variant: O = "text",
    ...v
  } = l, w = useId(E), M = R ?? /* @__PURE__ */ jsxRuntimeExports.jsx(CircularProgress, {
    "aria-labelledby": w,
    color: "inherit",
    size: 16
  }), S = {
    ...l,
    color: u,
    component: c,
    disabled: f,
    disableElevation: g,
    disableFocusRipple: y,
    fullWidth: P,
    loading: $,
    loadingIndicator: M,
    loadingPosition: C,
    size: x,
    type: D,
    variant: O
  }, I = useUtilityClasses$8(S), N = (_ || $ && C === "start") && /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonStartIcon, {
    className: I.startIcon,
    ownerState: S,
    children: _ || /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonLoadingIconPlaceholder, {
      className: I.loadingIconPlaceholder,
      ownerState: S
    })
  }), F = (h || $ && C === "end") && /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonEndIcon, {
    className: I.endIcon,
    ownerState: S,
    children: h || /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonLoadingIconPlaceholder, {
      className: I.loadingIconPlaceholder,
      ownerState: S
    })
  }), L = s || "", k = typeof $ == "boolean" ? (
    // use plain HTML span to minimize the runtime overhead
    /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
      className: I.loadingWrapper,
      style: {
        display: "contents"
      },
      children: $ && /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonLoadingIndicator, {
        className: I.loadingIndicator,
        ownerState: S,
        children: M
      })
    })
  ) : null;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(ButtonRoot, {
    ownerState: S,
    className: clsx(n.className, I.root, p, L),
    component: c,
    disabled: f || $,
    focusRipple: !y,
    focusVisibleClassName: clsx(I.focusVisible, T),
    ref: o,
    type: D,
    id: $ ? w : E,
    ...v,
    classes: I,
    children: [N, C !== "end" && k, d, C === "end" && k, F]
  });
});
process.env.NODE_ENV !== "production" && (Button$2.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["inherit", "primary", "secondary", "success", "error", "info", "warning"]), PropTypes.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, no elevation is used.
   * @default false
   */
  disableElevation: PropTypes.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: PropTypes.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: PropTypes.bool,
  /**
   * Element placed after the children.
   */
  endIcon: PropTypes.node,
  /**
   * @ignore
   */
  focusVisibleClassName: PropTypes.string,
  /**
   * If `true`, the button will take up the full width of its container.
   * @default false
   */
  fullWidth: PropTypes.bool,
  /**
   * The URL to link to when the button is clicked.
   * If defined, an `a` element will be used as the root node.
   */
  href: PropTypes.string,
  /**
   * @ignore
   */
  id: PropTypes.string,
  /**
   * If `true`, the loading indicator is visible and the button is disabled.
   * If `true | false`, the loading wrapper is always rendered before the children to prevent [Google Translation Crash](https://github.com/mui/material-ui/issues/27853).
   * @default null
   */
  loading: PropTypes.bool,
  /**
   * Element placed before the children if the button is in loading state.
   * The node should contain an element with `role="progressbar"` with an accessible name.
   * By default, it renders a `CircularProgress` that is labeled by the button itself.
   * @default <CircularProgress color="inherit" size={16} />
   */
  loadingIndicator: PropTypes.node,
  /**
   * The loading indicator can be positioned on the start, end, or the center of the button.
   * @default 'center'
   */
  loadingPosition: PropTypes.oneOf(["center", "end", "start"]),
  /**
   * The size of the component.
   * `small` is equivalent to the dense button styling.
   * @default 'medium'
   */
  size: PropTypes.oneOfType([PropTypes.oneOf(["small", "medium", "large"]), PropTypes.string]),
  /**
   * Element placed before the children.
   */
  startIcon: PropTypes.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * @ignore
   */
  type: PropTypes.oneOfType([PropTypes.oneOf(["button", "reset", "submit"]), PropTypes.string]),
  /**
   * The variant to use.
   * @default 'text'
   */
  variant: PropTypes.oneOfType([PropTypes.oneOf(["contained", "outlined", "text"]), PropTypes.string])
});
function getDialogActionsUtilityClass(e) {
  return generateUtilityClass("MuiDialogActions", e);
}
generateUtilityClasses("MuiDialogActions", ["root", "spacing"]);
const useUtilityClasses$7 = (e) => {
  const {
    classes: t,
    disableSpacing: o
  } = e;
  return composeClasses({
    root: ["root", !o && "spacing"]
  }, getDialogActionsUtilityClass, t);
}, DialogActionsRoot = styled("div", {
  name: "MuiDialogActions",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.root, !o.disableSpacing && t.spacing];
  }
})({
  display: "flex",
  alignItems: "center",
  padding: 8,
  justifyContent: "flex-end",
  flex: "0 0 auto",
  variants: [{
    props: ({
      ownerState: e
    }) => !e.disableSpacing,
    style: {
      "& > :not(style) ~ :not(style)": {
        marginLeft: 8
      }
    }
  }]
}), DialogActions = /* @__PURE__ */ React.forwardRef(function e(t, o) {
  const n = useDefaultProps({
    props: t,
    name: "MuiDialogActions"
  }), {
    className: s,
    disableSpacing: i = !1,
    ...l
  } = n, d = {
    ...n,
    disableSpacing: i
  }, u = useUtilityClasses$7(d);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(DialogActionsRoot, {
    className: clsx(u.root, s),
    ownerState: d,
    ref: o,
    ...l
  });
});
process.env.NODE_ENV !== "production" && (DialogActions.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * If `true`, the actions do not have additional margin.
   * @default false
   */
  disableSpacing: PropTypes.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
});
const _excluded$5 = ["actions"], PickersActionBarRoot = styled(DialogActions, {
  name: "MuiPickersLayout",
  slot: "ActionBar"
})({});
function PickersActionBarComponent(e) {
  const {
    actions: t
  } = e, o = _objectWithoutPropertiesLoose(e, _excluded$5), n = usePickerTranslations(), {
    clearValue: s,
    setValueToToday: i,
    acceptValueChanges: l,
    cancelValueChanges: d,
    goToNextStep: u,
    hasNextStep: c
  } = usePickerContext();
  if (t == null || t.length === 0)
    return null;
  const p = t?.map((f) => {
    switch (f) {
      case "clear":
        return /* @__PURE__ */ jsxRuntimeExports.jsx(Button$2, {
          onClick: s,
          children: n.clearButtonLabel
        }, f);
      case "cancel":
        return /* @__PURE__ */ jsxRuntimeExports.jsx(Button$2, {
          onClick: d,
          children: n.cancelButtonLabel
        }, f);
      case "accept":
        return /* @__PURE__ */ jsxRuntimeExports.jsx(Button$2, {
          onClick: l,
          children: n.okButtonLabel
        }, f);
      case "today":
        return /* @__PURE__ */ jsxRuntimeExports.jsx(Button$2, {
          onClick: i,
          children: n.todayButtonLabel
        }, f);
      case "next":
        return /* @__PURE__ */ jsxRuntimeExports.jsx(Button$2, {
          onClick: u,
          children: n.nextStepButtonLabel
        }, f);
      case "nextOrAccept":
        return c ? /* @__PURE__ */ jsxRuntimeExports.jsx(Button$2, {
          onClick: u,
          children: n.nextStepButtonLabel
        }, f) : /* @__PURE__ */ jsxRuntimeExports.jsx(Button$2, {
          onClick: l,
          children: n.okButtonLabel
        }, f);
      default:
        return null;
    }
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(PickersActionBarRoot, _extends({}, o, {
    children: p
  }));
}
process.env.NODE_ENV !== "production" && (PickersActionBarComponent.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Ordered array of actions to display.
   * If empty, does not display that action bar.
   * @default
   * - `[]` for Pickers with one selection step which `closeOnSelect`.
   * - `['cancel', 'nextOrAccept']` for all other Pickers.
   */
  actions: PropTypes.arrayOf(PropTypes.oneOf(["accept", "cancel", "clear", "next", "nextOrAccept", "today"]).isRequired),
  /**
   * If `true`, the actions do not have additional margin.
   * @default false
   */
  disableSpacing: PropTypes.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
});
const PickersActionBar = /* @__PURE__ */ React.memo(PickersActionBarComponent);
process.env.NODE_ENV !== "production" && (PickersActionBar.displayName = "PickersActionBar");
function getListItemUtilityClass(e) {
  return generateUtilityClass("MuiListItem", e);
}
generateUtilityClasses("MuiListItem", ["root", "container", "dense", "alignItemsFlexStart", "divider", "gutters", "padding", "secondaryAction"]);
const listItemButtonClasses = generateUtilityClasses("MuiListItemButton", ["root", "focusVisible", "dense", "alignItemsFlexStart", "disabled", "divider", "gutters", "selected"]);
function getListItemSecondaryActionClassesUtilityClass(e) {
  return generateUtilityClass("MuiListItemSecondaryAction", e);
}
generateUtilityClasses("MuiListItemSecondaryAction", ["root", "disableGutters"]);
const useUtilityClasses$6 = (e) => {
  const {
    disableGutters: t,
    classes: o
  } = e;
  return composeClasses({
    root: ["root", t && "disableGutters"]
  }, getListItemSecondaryActionClassesUtilityClass, o);
}, ListItemSecondaryActionRoot = styled("div", {
  name: "MuiListItemSecondaryAction",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.root, o.disableGutters && t.disableGutters];
  }
})({
  position: "absolute",
  right: 16,
  top: "50%",
  transform: "translateY(-50%)",
  variants: [{
    props: ({
      ownerState: e
    }) => e.disableGutters,
    style: {
      right: 0
    }
  }]
}), ListItemSecondaryAction = /* @__PURE__ */ React.forwardRef(function e(t, o) {
  const n = useDefaultProps({
    props: t,
    name: "MuiListItemSecondaryAction"
  }), {
    className: s,
    ...i
  } = n, l = React.useContext(ListContext), d = {
    ...n,
    disableGutters: l.disableGutters
  }, u = useUtilityClasses$6(d);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ListItemSecondaryActionRoot, {
    className: clsx(u.root, s),
    ownerState: d,
    ref: o,
    ...i
  });
});
process.env.NODE_ENV !== "production" && (ListItemSecondaryAction.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component, normally an `IconButton` or selection control.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
});
ListItemSecondaryAction.muiName = "ListItemSecondaryAction";
const overridesResolver = (e, t) => {
  const {
    ownerState: o
  } = e;
  return [t.root, o.dense && t.dense, o.alignItems === "flex-start" && t.alignItemsFlexStart, o.divider && t.divider, !o.disableGutters && t.gutters, !o.disablePadding && t.padding, o.hasSecondaryAction && t.secondaryAction];
}, useUtilityClasses$5 = (e) => {
  const {
    alignItems: t,
    classes: o,
    dense: n,
    disableGutters: s,
    disablePadding: i,
    divider: l,
    hasSecondaryAction: d
  } = e;
  return composeClasses({
    root: ["root", n && "dense", !s && "gutters", !i && "padding", l && "divider", t === "flex-start" && "alignItemsFlexStart", d && "secondaryAction"],
    container: ["container"]
  }, getListItemUtilityClass, o);
}, ListItemRoot = styled("div", {
  name: "MuiListItem",
  slot: "Root",
  overridesResolver
})(memoTheme(({
  theme: e
}) => ({
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  position: "relative",
  textDecoration: "none",
  width: "100%",
  boxSizing: "border-box",
  textAlign: "left",
  variants: [{
    props: ({
      ownerState: t
    }) => !t.disablePadding,
    style: {
      paddingTop: 8,
      paddingBottom: 8
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.disablePadding && t.dense,
    style: {
      paddingTop: 4,
      paddingBottom: 4
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.disablePadding && !t.disableGutters,
    style: {
      paddingLeft: 16,
      paddingRight: 16
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.disablePadding && !!t.secondaryAction,
    style: {
      // Add some space to avoid collision as `ListItemSecondaryAction`
      // is absolutely positioned.
      paddingRight: 48
    }
  }, {
    props: ({
      ownerState: t
    }) => !!t.secondaryAction,
    style: {
      [`& > .${listItemButtonClasses.root}`]: {
        paddingRight: 48
      }
    }
  }, {
    props: {
      alignItems: "flex-start"
    },
    style: {
      alignItems: "flex-start"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.divider,
    style: {
      borderBottom: `1px solid ${(e.vars || e).palette.divider}`,
      backgroundClip: "padding-box"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.button,
    style: {
      transition: e.transitions.create("background-color", {
        duration: e.transitions.duration.shortest
      }),
      "&:hover": {
        textDecoration: "none",
        backgroundColor: (e.vars || e).palette.action.hover,
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: "transparent"
        }
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.hasSecondaryAction,
    style: {
      // Add some space to avoid collision as `ListItemSecondaryAction`
      // is absolutely positioned.
      paddingRight: 48
    }
  }]
}))), ListItemContainer = styled("li", {
  name: "MuiListItem",
  slot: "Container"
})({
  position: "relative"
}), ListItem = /* @__PURE__ */ React.forwardRef(function e(t, o) {
  const n = useDefaultProps({
    props: t,
    name: "MuiListItem"
  }), {
    alignItems: s = "center",
    children: i,
    className: l,
    component: d,
    components: u = {},
    componentsProps: c = {},
    ContainerComponent: p = "li",
    ContainerProps: {
      className: f,
      ...g
    } = {},
    dense: y = !1,
    disableGutters: h = !1,
    disablePadding: T = !1,
    divider: P = !1,
    secondaryAction: E,
    slotProps: $ = {},
    slots: R = {},
    ...C
  } = n, x = React.useContext(ListContext), _ = React.useMemo(() => ({
    dense: y || x.dense || !1,
    alignItems: s,
    disableGutters: h
  }), [s, x.dense, y, h]), D = React.useRef(null), O = React.Children.toArray(i), v = O.length && isMuiElement(O[O.length - 1], ["ListItemSecondaryAction"]), w = {
    ...n,
    alignItems: s,
    dense: _.dense,
    disableGutters: h,
    disablePadding: T,
    divider: P,
    hasSecondaryAction: v
  }, M = useUtilityClasses$5(w), S = useForkRef(D, o), I = R.root || u.Root || ListItemRoot, N = $.root || c.root || {}, F = {
    className: clsx(M.root, N.className, l),
    ...C
  };
  let L = d || "li";
  return v ? (L = !F.component && !d ? "div" : L, p === "li" && (L === "li" ? L = "div" : F.component === "li" && (F.component = "div")), /* @__PURE__ */ jsxRuntimeExports.jsx(ListContext.Provider, {
    value: _,
    children: /* @__PURE__ */ jsxRuntimeExports.jsxs(ListItemContainer, {
      as: p,
      className: clsx(M.container, f),
      ref: S,
      ownerState: w,
      ...g,
      children: [/* @__PURE__ */ jsxRuntimeExports.jsx(I, {
        ...N,
        ...!isHostComponent(I) && {
          as: L,
          ownerState: {
            ...w,
            ...N.ownerState
          }
        },
        ...F,
        children: O
      }), O.pop()]
    })
  })) : /* @__PURE__ */ jsxRuntimeExports.jsx(ListContext.Provider, {
    value: _,
    children: /* @__PURE__ */ jsxRuntimeExports.jsxs(I, {
      ...N,
      as: L,
      ref: S,
      ...!isHostComponent(I) && {
        ownerState: {
          ...w,
          ...N.ownerState
        }
      },
      ...F,
      children: [O, E && /* @__PURE__ */ jsxRuntimeExports.jsx(ListItemSecondaryAction, {
        children: E
      })]
    })
  });
});
process.env.NODE_ENV !== "production" && (ListItem.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Defines the `align-items` style property.
   * @default 'center'
   */
  alignItems: PropTypes.oneOf(["center", "flex-start"]),
  /**
   * The content of the component if a `ListItemSecondaryAction` is used it must
   * be the last child.
   */
  children: chainPropTypes(PropTypes.node, (e) => {
    const t = React.Children.toArray(e.children);
    let o = -1;
    for (let n = t.length - 1; n >= 0; n -= 1) {
      const s = t[n];
      if (isMuiElement(s, ["ListItemSecondaryAction"])) {
        o = n;
        break;
      }
    }
    return o !== -1 && o !== t.length - 1 ? new Error("MUI: You used an element after ListItemSecondaryAction. For ListItem to detect that it has a secondary action you must pass it as the last child to ListItem.") : null;
  }),
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * The components used for each slot inside.
   *
   * @deprecated Use the `slots` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default {}
   */
  components: PropTypes.shape({
    Root: PropTypes.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated Use the `slotProps` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default {}
   */
  componentsProps: PropTypes.shape({
    root: PropTypes.object
  }),
  /**
   * The container component used when a `ListItemSecondaryAction` is the last child.
   * @default 'li'
   * @deprecated Use the `component` or `slots.root` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  ContainerComponent: elementTypeAcceptingRef$1,
  /**
   * Props applied to the container component if used.
   * @default {}
   * @deprecated Use the `slotProps.root` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  ContainerProps: PropTypes.object,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used.
   * The prop defaults to the value inherited from the parent List component.
   * @default false
   */
  dense: PropTypes.bool,
  /**
   * If `true`, the left and right padding is removed.
   * @default false
   */
  disableGutters: PropTypes.bool,
  /**
   * If `true`, all padding is removed.
   * @default false
   */
  disablePadding: PropTypes.bool,
  /**
   * If `true`, a 1px light border is added to the bottom of the list item.
   * @default false
   */
  divider: PropTypes.bool,
  /**
   * The element to display at the end of ListItem.
   */
  secondaryAction: PropTypes.node,
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @default {}
   */
  slotProps: PropTypes.shape({
    root: PropTypes.object
  }),
  /**
   * The components used for each slot inside.
   *
   * @default {}
   */
  slots: PropTypes.shape({
    root: PropTypes.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
});
const CancelIcon = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
}), "Cancel");
function getChipUtilityClass(e) {
  return generateUtilityClass("MuiChip", e);
}
const chipClasses = generateUtilityClasses("MuiChip", ["root", "sizeSmall", "sizeMedium", "colorDefault", "colorError", "colorInfo", "colorPrimary", "colorSecondary", "colorSuccess", "colorWarning", "disabled", "clickable", "clickableColorPrimary", "clickableColorSecondary", "deletable", "deletableColorPrimary", "deletableColorSecondary", "outlined", "filled", "outlinedPrimary", "outlinedSecondary", "filledPrimary", "filledSecondary", "avatar", "avatarSmall", "avatarMedium", "avatarColorPrimary", "avatarColorSecondary", "icon", "iconSmall", "iconMedium", "iconColorPrimary", "iconColorSecondary", "label", "labelSmall", "labelMedium", "deleteIcon", "deleteIconSmall", "deleteIconMedium", "deleteIconColorPrimary", "deleteIconColorSecondary", "deleteIconOutlinedColorPrimary", "deleteIconOutlinedColorSecondary", "deleteIconFilledColorPrimary", "deleteIconFilledColorSecondary", "focusVisible"]), useUtilityClasses$4 = (e) => {
  const {
    classes: t,
    disabled: o,
    size: n,
    color: s,
    iconColor: i,
    onDelete: l,
    clickable: d,
    variant: u
  } = e, c = {
    root: ["root", u, o && "disabled", `size${capitalize(n)}`, `color${capitalize(s)}`, d && "clickable", d && `clickableColor${capitalize(s)}`, l && "deletable", l && `deletableColor${capitalize(s)}`, `${u}${capitalize(s)}`],
    label: ["label", `label${capitalize(n)}`],
    avatar: ["avatar", `avatar${capitalize(n)}`, `avatarColor${capitalize(s)}`],
    icon: ["icon", `icon${capitalize(n)}`, `iconColor${capitalize(i)}`],
    deleteIcon: ["deleteIcon", `deleteIcon${capitalize(n)}`, `deleteIconColor${capitalize(s)}`, `deleteIcon${capitalize(u)}Color${capitalize(s)}`]
  };
  return composeClasses(c, getChipUtilityClass, t);
}, ChipRoot = styled("div", {
  name: "MuiChip",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e, {
      color: n,
      iconColor: s,
      clickable: i,
      onDelete: l,
      size: d,
      variant: u
    } = o;
    return [{
      [`& .${chipClasses.avatar}`]: t.avatar
    }, {
      [`& .${chipClasses.avatar}`]: t[`avatar${capitalize(d)}`]
    }, {
      [`& .${chipClasses.avatar}`]: t[`avatarColor${capitalize(n)}`]
    }, {
      [`& .${chipClasses.icon}`]: t.icon
    }, {
      [`& .${chipClasses.icon}`]: t[`icon${capitalize(d)}`]
    }, {
      [`& .${chipClasses.icon}`]: t[`iconColor${capitalize(s)}`]
    }, {
      [`& .${chipClasses.deleteIcon}`]: t.deleteIcon
    }, {
      [`& .${chipClasses.deleteIcon}`]: t[`deleteIcon${capitalize(d)}`]
    }, {
      [`& .${chipClasses.deleteIcon}`]: t[`deleteIconColor${capitalize(n)}`]
    }, {
      [`& .${chipClasses.deleteIcon}`]: t[`deleteIcon${capitalize(u)}Color${capitalize(n)}`]
    }, t.root, t[`size${capitalize(d)}`], t[`color${capitalize(n)}`], i && t.clickable, i && n !== "default" && t[`clickableColor${capitalize(n)})`], l && t.deletable, l && n !== "default" && t[`deletableColor${capitalize(n)}`], t[u], t[`${u}${capitalize(n)}`]];
  }
})(memoTheme(({
  theme: e
}) => {
  const t = e.palette.mode === "light" ? e.palette.grey[700] : e.palette.grey[300];
  return {
    maxWidth: "100%",
    fontFamily: e.typography.fontFamily,
    fontSize: e.typography.pxToRem(13),
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    height: 32,
    lineHeight: 1.5,
    color: (e.vars || e).palette.text.primary,
    backgroundColor: (e.vars || e).palette.action.selected,
    borderRadius: 32 / 2,
    whiteSpace: "nowrap",
    transition: e.transitions.create(["background-color", "box-shadow"]),
    // reset cursor explicitly in case ButtonBase is used
    cursor: "unset",
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    textDecoration: "none",
    border: 0,
    // Remove `button` border
    padding: 0,
    // Remove `button` padding
    verticalAlign: "middle",
    boxSizing: "border-box",
    [`&.${chipClasses.disabled}`]: {
      opacity: (e.vars || e).palette.action.disabledOpacity,
      pointerEvents: "none"
    },
    [`& .${chipClasses.avatar}`]: {
      marginLeft: 5,
      marginRight: -6,
      width: 24,
      height: 24,
      color: e.vars ? e.vars.palette.Chip.defaultAvatarColor : t,
      fontSize: e.typography.pxToRem(12)
    },
    [`& .${chipClasses.avatarColorPrimary}`]: {
      color: (e.vars || e).palette.primary.contrastText,
      backgroundColor: (e.vars || e).palette.primary.dark
    },
    [`& .${chipClasses.avatarColorSecondary}`]: {
      color: (e.vars || e).palette.secondary.contrastText,
      backgroundColor: (e.vars || e).palette.secondary.dark
    },
    [`& .${chipClasses.avatarSmall}`]: {
      marginLeft: 4,
      marginRight: -4,
      width: 18,
      height: 18,
      fontSize: e.typography.pxToRem(10)
    },
    [`& .${chipClasses.icon}`]: {
      marginLeft: 5,
      marginRight: -6
    },
    [`& .${chipClasses.deleteIcon}`]: {
      WebkitTapHighlightColor: "transparent",
      color: e.alpha((e.vars || e).palette.text.primary, 0.26),
      fontSize: 22,
      cursor: "pointer",
      margin: "0 5px 0 -6px",
      "&:hover": {
        color: e.alpha((e.vars || e).palette.text.primary, 0.4)
      }
    },
    variants: [{
      props: {
        size: "small"
      },
      style: {
        height: 24,
        [`& .${chipClasses.icon}`]: {
          fontSize: 18,
          marginLeft: 4,
          marginRight: -4
        },
        [`& .${chipClasses.deleteIcon}`]: {
          fontSize: 16,
          marginRight: 4,
          marginLeft: -4
        }
      }
    }, ...Object.entries(e.palette).filter(createSimplePaletteValueFilter(["contrastText"])).map(([o]) => ({
      props: {
        color: o
      },
      style: {
        backgroundColor: (e.vars || e).palette[o].main,
        color: (e.vars || e).palette[o].contrastText,
        [`& .${chipClasses.deleteIcon}`]: {
          color: e.alpha((e.vars || e).palette[o].contrastText, 0.7),
          "&:hover, &:active": {
            color: (e.vars || e).palette[o].contrastText
          }
        }
      }
    })), {
      props: (o) => o.iconColor === o.color,
      style: {
        [`& .${chipClasses.icon}`]: {
          color: e.vars ? e.vars.palette.Chip.defaultIconColor : t
        }
      }
    }, {
      props: (o) => o.iconColor === o.color && o.color !== "default",
      style: {
        [`& .${chipClasses.icon}`]: {
          color: "inherit"
        }
      }
    }, {
      props: {
        onDelete: !0
      },
      style: {
        [`&.${chipClasses.focusVisible}`]: {
          backgroundColor: e.alpha((e.vars || e).palette.action.selected, `${(e.vars || e).palette.action.selectedOpacity} + ${(e.vars || e).palette.action.focusOpacity}`)
        }
      }
    }, ...Object.entries(e.palette).filter(createSimplePaletteValueFilter(["dark"])).map(([o]) => ({
      props: {
        color: o,
        onDelete: !0
      },
      style: {
        [`&.${chipClasses.focusVisible}`]: {
          background: (e.vars || e).palette[o].dark
        }
      }
    })), {
      props: {
        clickable: !0
      },
      style: {
        userSelect: "none",
        WebkitTapHighlightColor: "transparent",
        cursor: "pointer",
        "&:hover": {
          backgroundColor: e.alpha((e.vars || e).palette.action.selected, `${(e.vars || e).palette.action.selectedOpacity} + ${(e.vars || e).palette.action.hoverOpacity}`)
        },
        [`&.${chipClasses.focusVisible}`]: {
          backgroundColor: e.alpha((e.vars || e).palette.action.selected, `${(e.vars || e).palette.action.selectedOpacity} + ${(e.vars || e).palette.action.focusOpacity}`)
        },
        "&:active": {
          boxShadow: (e.vars || e).shadows[1]
        }
      }
    }, ...Object.entries(e.palette).filter(createSimplePaletteValueFilter(["dark"])).map(([o]) => ({
      props: {
        color: o,
        clickable: !0
      },
      style: {
        [`&:hover, &.${chipClasses.focusVisible}`]: {
          backgroundColor: (e.vars || e).palette[o].dark
        }
      }
    })), {
      props: {
        variant: "outlined"
      },
      style: {
        backgroundColor: "transparent",
        border: e.vars ? `1px solid ${e.vars.palette.Chip.defaultBorder}` : `1px solid ${e.palette.mode === "light" ? e.palette.grey[400] : e.palette.grey[700]}`,
        [`&.${chipClasses.clickable}:hover`]: {
          backgroundColor: (e.vars || e).palette.action.hover
        },
        [`&.${chipClasses.focusVisible}`]: {
          backgroundColor: (e.vars || e).palette.action.focus
        },
        [`& .${chipClasses.avatar}`]: {
          marginLeft: 4
        },
        [`& .${chipClasses.avatarSmall}`]: {
          marginLeft: 2
        },
        [`& .${chipClasses.icon}`]: {
          marginLeft: 4
        },
        [`& .${chipClasses.iconSmall}`]: {
          marginLeft: 2
        },
        [`& .${chipClasses.deleteIcon}`]: {
          marginRight: 5
        },
        [`& .${chipClasses.deleteIconSmall}`]: {
          marginRight: 3
        }
      }
    }, ...Object.entries(e.palette).filter(createSimplePaletteValueFilter()).map(([o]) => ({
      props: {
        variant: "outlined",
        color: o
      },
      style: {
        color: (e.vars || e).palette[o].main,
        border: `1px solid ${e.alpha((e.vars || e).palette[o].main, 0.7)}`,
        [`&.${chipClasses.clickable}:hover`]: {
          backgroundColor: e.alpha((e.vars || e).palette[o].main, (e.vars || e).palette.action.hoverOpacity)
        },
        [`&.${chipClasses.focusVisible}`]: {
          backgroundColor: e.alpha((e.vars || e).palette[o].main, (e.vars || e).palette.action.focusOpacity)
        },
        [`& .${chipClasses.deleteIcon}`]: {
          color: e.alpha((e.vars || e).palette[o].main, 0.7),
          "&:hover, &:active": {
            color: (e.vars || e).palette[o].main
          }
        }
      }
    }))]
  };
})), ChipLabel = styled("span", {
  name: "MuiChip",
  slot: "Label",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e, {
      size: n
    } = o;
    return [t.label, t[`label${capitalize(n)}`]];
  }
})({
  overflow: "hidden",
  textOverflow: "ellipsis",
  paddingLeft: 12,
  paddingRight: 12,
  whiteSpace: "nowrap",
  variants: [{
    props: {
      variant: "outlined"
    },
    style: {
      paddingLeft: 11,
      paddingRight: 11
    }
  }, {
    props: {
      size: "small"
    },
    style: {
      paddingLeft: 8,
      paddingRight: 8
    }
  }, {
    props: {
      size: "small",
      variant: "outlined"
    },
    style: {
      paddingLeft: 7,
      paddingRight: 7
    }
  }]
});
function isDeleteKeyboardEvent(e) {
  return e.key === "Backspace" || e.key === "Delete";
}
const Chip = /* @__PURE__ */ React.forwardRef(function e(t, o) {
  const n = useDefaultProps({
    props: t,
    name: "MuiChip"
  }), {
    avatar: s,
    className: i,
    clickable: l,
    color: d = "default",
    component: u,
    deleteIcon: c,
    disabled: p = !1,
    icon: f,
    label: g,
    onClick: y,
    onDelete: h,
    onKeyDown: T,
    onKeyUp: P,
    size: E = "medium",
    variant: $ = "filled",
    tabIndex: R,
    skipFocusWhenDisabled: C = !1,
    // TODO v6: Rename to `focusableWhenDisabled`.
    slots: x = {},
    slotProps: _ = {},
    ...D
  } = n, O = React.useRef(null), v = useForkRef(O, o), w = (J) => {
    J.stopPropagation(), h && h(J);
  }, M = (J) => {
    J.currentTarget === J.target && isDeleteKeyboardEvent(J) && J.preventDefault(), T && T(J);
  }, S = (J) => {
    J.currentTarget === J.target && h && isDeleteKeyboardEvent(J) && h(J), P && P(J);
  }, I = l !== !1 && y ? !0 : l, N = I || h ? ButtonBase : u || "div", F = {
    ...n,
    component: N,
    disabled: p,
    size: E,
    color: d,
    iconColor: /* @__PURE__ */ React.isValidElement(f) && f.props.color || d,
    onDelete: !!h,
    clickable: I,
    variant: $
  }, L = useUtilityClasses$4(F), k = N === ButtonBase ? {
    component: u || "div",
    focusVisibleClassName: L.focusVisible,
    ...h && {
      disableRipple: !0
    }
  } : {};
  let W = null;
  h && (W = c && /* @__PURE__ */ React.isValidElement(c) ? /* @__PURE__ */ React.cloneElement(c, {
    className: clsx(c.props.className, L.deleteIcon),
    onClick: w
  }) : /* @__PURE__ */ jsxRuntimeExports.jsx(CancelIcon, {
    className: L.deleteIcon,
    onClick: w
  }));
  let V = null;
  s && /* @__PURE__ */ React.isValidElement(s) && (V = /* @__PURE__ */ React.cloneElement(s, {
    className: clsx(L.avatar, s.props.className)
  }));
  let j = null;
  f && /* @__PURE__ */ React.isValidElement(f) && (j = /* @__PURE__ */ React.cloneElement(f, {
    className: clsx(L.icon, f.props.className)
  })), process.env.NODE_ENV !== "production" && V && j && console.error("MUI: The Chip component can not handle the avatar and the icon prop at the same time. Pick one.");
  const A = {
    slots: x,
    slotProps: _
  }, [U, G] = useSlot("root", {
    elementType: ChipRoot,
    externalForwardedProps: {
      ...A,
      ...D
    },
    ownerState: F,
    // The `component` prop is preserved because `Chip` relies on it for internal logic. If `shouldForwardComponentProp` were `false`, `useSlot` would remove the `component` prop, potentially breaking the component's behavior.
    shouldForwardComponentProp: !0,
    ref: v,
    className: clsx(L.root, i),
    additionalProps: {
      disabled: I && p ? !0 : void 0,
      tabIndex: C && p ? -1 : R,
      ...k
    },
    getSlotProps: (J) => ({
      ...J,
      onClick: (Z) => {
        J.onClick?.(Z), y?.(Z);
      },
      onKeyDown: (Z) => {
        J.onKeyDown?.(Z), M(Z);
      },
      onKeyUp: (Z) => {
        J.onKeyUp?.(Z), S(Z);
      }
    })
  }), [Y, ee] = useSlot("label", {
    elementType: ChipLabel,
    externalForwardedProps: A,
    ownerState: F,
    className: L.label
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(U, {
    as: N,
    ...G,
    children: [V || j, /* @__PURE__ */ jsxRuntimeExports.jsx(Y, {
      ...ee,
      children: g
    }), W]
  });
});
process.env.NODE_ENV !== "production" && (Chip.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The Avatar element to display.
   */
  avatar: PropTypes.element,
  /**
   * This prop isn't supported.
   * Use the `component` prop if you need to change the children structure.
   */
  children: unsupportedProp,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * If `true`, the chip will appear clickable, and will raise when pressed,
   * even if the onClick prop is not defined.
   * If `false`, the chip will not appear clickable, even if onClick prop is defined.
   * This can be used, for example,
   * along with the component prop to indicate an anchor Chip is clickable.
   * Note: this controls the UI and does not affect the onClick event.
   */
  clickable: PropTypes.bool,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'default'
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["default", "primary", "secondary", "error", "info", "success", "warning"]), PropTypes.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * Override the default delete icon element. Shown only if `onDelete` is set.
   */
  deleteIcon: PropTypes.element,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * Icon element.
   */
  icon: PropTypes.element,
  /**
   * The content of the component.
   */
  label: PropTypes.node,
  /**
   * @ignore
   */
  onClick: PropTypes.func,
  /**
   * Callback fired when the delete icon is clicked.
   * If set, the delete icon will be shown.
   */
  onDelete: PropTypes.func,
  /**
   * @ignore
   */
  onKeyDown: PropTypes.func,
  /**
   * @ignore
   */
  onKeyUp: PropTypes.func,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: PropTypes.oneOfType([PropTypes.oneOf(["medium", "small"]), PropTypes.string]),
  /**
   * If `true`, allows the disabled chip to escape focus.
   * If `false`, allows the disabled chip to receive focus.
   * @default false
   */
  skipFocusWhenDisabled: PropTypes.bool,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: PropTypes.shape({
    label: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: PropTypes.shape({
    label: PropTypes.elementType,
    root: PropTypes.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * @ignore
   */
  tabIndex: PropTypes.number,
  /**
   * The variant to use.
   * @default 'filled'
   */
  variant: PropTypes.oneOfType([PropTypes.oneOf(["filled", "outlined"]), PropTypes.string])
});
const _excluded$4 = ["items", "changeImportance"], _excluded2$2 = ["getValue"], PickersShortcutsRoot = styled(List, {
  name: "MuiPickersLayout",
  slot: "Shortcuts"
})({});
function PickersShortcuts(e) {
  const {
    items: t,
    changeImportance: o = "accept"
  } = e, n = _objectWithoutPropertiesLoose(e, _excluded$4), {
    setValue: s
  } = usePickerActionsContext(), i = useIsValidValue();
  if (t == null || t.length === 0)
    return null;
  const l = t.map((d) => {
    let {
      getValue: u
    } = d, c = _objectWithoutPropertiesLoose(d, _excluded2$2);
    const p = u({
      isValid: i
    });
    return _extends({}, c, {
      label: c.label,
      onClick: () => {
        s(p, {
          changeImportance: o,
          shortcut: c
        });
      },
      disabled: !i(p)
    });
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(PickersShortcutsRoot, _extends({
    dense: !0,
    sx: [{
      maxHeight: VIEW_HEIGHT,
      maxWidth: 200,
      overflow: "auto"
    }, ...Array.isArray(n.sx) ? n.sx : [n.sx]]
  }, n, {
    children: l.map((d) => /* @__PURE__ */ jsxRuntimeExports.jsx(ListItem, {
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(Chip, _extends({}, d))
    }, d.id ?? d.label))
  }));
}
process.env.NODE_ENV !== "production" && (PickersShortcuts.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Importance of the change when picking a shortcut:
   * - "accept": fires `onChange`, fires `onAccept` and closes the Picker.
   * - "set": fires `onChange` but do not fire `onAccept` and does not close the Picker.
   * @default "accept"
   */
  changeImportance: PropTypes.oneOf(["accept", "set"]),
  className: PropTypes.string,
  component: PropTypes.elementType,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used for
   * the list and list items.
   * The prop is available to descendant components as the `dense` context.
   * @default false
   */
  dense: PropTypes.bool,
  /**
   * If `true`, vertical padding is removed from the list.
   * @default false
   */
  disablePadding: PropTypes.bool,
  /**
   * Ordered array of shortcuts to display.
   * If empty, does not display the shortcuts.
   * @default []
   */
  items: PropTypes.arrayOf(PropTypes.shape({
    getValue: PropTypes.func.isRequired,
    id: PropTypes.string,
    label: PropTypes.string.isRequired
  })),
  style: PropTypes.object,
  /**
   * The content of the subheader, normally `ListSubheader`.
   */
  subheader: PropTypes.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
});
const _excluded$3 = ["ownerState"];
function toolbarHasView(e) {
  return e.view !== null;
}
const useUtilityClasses$3 = (e, t) => {
  const {
    pickerOrientation: o
  } = t;
  return composeClasses({
    root: ["root", o === "landscape" && "landscape"],
    contentWrapper: ["contentWrapper"],
    toolbar: ["toolbar"],
    actionBar: ["actionBar"],
    tabs: ["tabs"],
    landscape: ["landscape"],
    shortcuts: ["shortcuts"]
  }, getPickersLayoutUtilityClass, e);
}, usePickerLayout = (e) => {
  const {
    ownerState: t,
    defaultActionBarActions: o
  } = usePickerPrivateContext(), {
    view: n
  } = usePickerContext(), s = useRtl(), {
    children: i,
    slots: l,
    slotProps: d,
    classes: u
  } = e, c = React.useMemo(() => _extends({}, t, {
    layoutDirection: s ? "rtl" : "ltr",
    hasShortcuts: !1
  }), [t, s]), p = useUtilityClasses$3(u, c), f = l?.actionBar ?? PickersActionBar, g = useSlotProps({
    elementType: f,
    externalSlotProps: d?.actionBar,
    additionalProps: {
      actions: o
    },
    className: p.actionBar,
    ownerState: c
  }), y = _objectWithoutPropertiesLoose(g, _excluded$3), h = /* @__PURE__ */ jsxRuntimeExports.jsx(f, _extends({}, y)), T = l?.toolbar, P = useSlotProps({
    elementType: T,
    externalSlotProps: d?.toolbar,
    className: p.toolbar,
    ownerState: c
  }), E = toolbarHasView(P) && T ? /* @__PURE__ */ jsxRuntimeExports.jsx(T, _extends({}, P)) : null, $ = i, R = l?.tabs, C = n && R ? /* @__PURE__ */ jsxRuntimeExports.jsx(R, _extends({
    className: p.tabs
  }, d?.tabs)) : null, x = l?.shortcuts ?? PickersShortcuts, _ = useSlotProps({
    elementType: x,
    externalSlotProps: d?.shortcuts,
    className: p.shortcuts,
    ownerState: c
  }), D = Array.isArray(_?.items) && _.items.length > 0, O = n && x ? /* @__PURE__ */ jsxRuntimeExports.jsx(x, _extends({}, _)) : null;
  return {
    toolbar: E,
    content: $,
    tabs: C,
    actionBar: h,
    shortcuts: O,
    ownerState: _extends({}, c, {
      hasShortcuts: D
    })
  };
}, useUtilityClasses$2 = (e, t) => {
  const {
    pickerOrientation: o
  } = t;
  return composeClasses({
    root: ["root", o === "landscape" && "landscape"],
    contentWrapper: ["contentWrapper"]
  }, getPickersLayoutUtilityClass, e);
}, PickersLayoutRoot = styled("div", {
  name: "MuiPickersLayout",
  slot: "Root"
})({
  display: "grid",
  gridAutoColumns: "max-content auto max-content",
  gridAutoRows: "max-content auto max-content",
  [`& .${pickersLayoutClasses.actionBar}`]: {
    gridColumn: "1 / 4",
    gridRow: 3
  },
  variants: [{
    props: {
      pickerOrientation: "landscape",
      hasShortcuts: !1
    },
    style: {
      [`& .${pickersLayoutClasses.toolbar}`]: {
        gridColumn: 1,
        gridRow: "1 / 3"
      }
    }
  }, {
    props: {
      pickerOrientation: "landscape",
      hasShortcuts: !0
    },
    style: {
      [`& .${pickersLayoutClasses.toolbar}`]: {
        gridColumn: "2 / 4",
        gridRow: 1,
        maxWidth: "max-content"
      },
      [`& .${pickersLayoutClasses.shortcuts}`]: {
        gridColumn: 1,
        gridRow: 2
      }
    }
  }, {
    props: {
      pickerOrientation: "portrait"
    },
    style: {
      [`& .${pickersLayoutClasses.toolbar}`]: {
        gridColumn: "2 / 4",
        gridRow: 1
      },
      [`& .${pickersLayoutClasses.shortcuts}`]: {
        gridColumn: 1,
        gridRow: "2 / 3"
      }
    }
  }, {
    props: {
      hasShortcuts: !0,
      layoutDirection: "rtl"
    },
    style: {
      [`& .${pickersLayoutClasses.shortcuts}`]: {
        gridColumn: 4
      }
    }
  }]
}), PickersLayoutContentWrapper = styled("div", {
  name: "MuiPickersLayout",
  slot: "ContentWrapper"
})({
  gridColumn: "2 / 4",
  gridRow: 2,
  display: "flex",
  flexDirection: "column"
}), PickersLayout = /* @__PURE__ */ React.forwardRef(function e(t, o) {
  const n = useThemeProps({
    props: t,
    name: "MuiPickersLayout"
  }), {
    toolbar: s,
    content: i,
    tabs: l,
    actionBar: d,
    shortcuts: u,
    ownerState: c
  } = usePickerLayout(n), {
    orientation: p,
    variant: f
  } = usePickerContext(), {
    sx: g,
    className: y,
    classes: h
  } = n, T = useUtilityClasses$2(h, c);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(PickersLayoutRoot, {
    ref: o,
    sx: g,
    className: clsx(T.root, y),
    ownerState: c,
    children: [p === "landscape" ? u : s, p === "landscape" ? s : u, /* @__PURE__ */ jsxRuntimeExports.jsx(PickersLayoutContentWrapper, {
      className: T.contentWrapper,
      ownerState: c,
      children: f === "desktop" ? /* @__PURE__ */ jsxRuntimeExports.jsxs(React.Fragment, {
        children: [i, l]
      }) : /* @__PURE__ */ jsxRuntimeExports.jsxs(React.Fragment, {
        children: [l, i]
      })
    }), d]
  });
});
process.env.NODE_ENV !== "production" && (PickersLayout.displayName = "PickersLayout");
process.env.NODE_ENV !== "production" && (PickersLayout.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  className: PropTypes.string,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: PropTypes.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
});
function createNonRangePickerStepNavigation(e) {
  const {
    steps: t
  } = e;
  return createStepNavigation({
    steps: t,
    isViewMatchingStep: (o, n) => n.views == null || n.views.includes(o),
    onStepChange: ({
      step: o,
      defaultView: n,
      setView: s,
      view: i,
      views: l
    }) => {
      const d = o.views == null ? n : o.views.find((u) => l.includes(u));
      d !== i && s(d);
    }
  });
}
const _excluded$2 = ["props", "steps"], _excluded2$1 = ["ownerState"], useDesktopPicker = (e) => {
  let {
    props: t,
    steps: o
  } = e, n = _objectWithoutPropertiesLoose(e, _excluded$2);
  const {
    slots: s,
    slotProps: i,
    label: l,
    inputRef: d,
    localeText: u
  } = t, c = createNonRangePickerStepNavigation({
    steps: o
  }), {
    providerProps: p,
    renderCurrentView: f,
    ownerState: g
  } = usePicker(_extends({}, n, {
    props: t,
    localeText: u,
    autoFocusView: !0,
    viewContainerRole: "dialog",
    variant: "desktop",
    getStepNavigation: c
  })), y = p.privateContextValue.labelId, h = i?.toolbar?.hidden ?? !1, T = s.field, P = useSlotProps({
    elementType: T,
    externalSlotProps: i?.field,
    additionalProps: _extends({}, h && {
      id: y
    }),
    ownerState: g
  }), E = _objectWithoutPropertiesLoose(P, _excluded2$1), $ = s.layout ?? PickersLayout;
  let R = y;
  h && (l ? R = `${y}-label` : R = void 0);
  const C = _extends({}, i, {
    toolbar: _extends({}, i?.toolbar, {
      titleId: y
    }),
    popper: _extends({
      "aria-labelledby": R
    }, i?.popper)
  }), x = () => /* @__PURE__ */ jsxRuntimeExports.jsxs(PickerProvider, _extends({}, p, {
    children: [/* @__PURE__ */ jsxRuntimeExports.jsx(T, _extends({}, E, {
      slots: s,
      slotProps: C,
      inputRef: d
    })), /* @__PURE__ */ jsxRuntimeExports.jsx(PickerPopper, {
      slots: s,
      slotProps: C,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx($, _extends({}, C?.layout, {
        slots: s,
        slotProps: C,
        children: f()
      }))
    })]
  }));
  return process.env.NODE_ENV !== "production" && (x.displayName = "renderPicker"), {
    renderPicker: x
  };
}, renderDateViewCalendar = ({
  view: e,
  onViewChange: t,
  views: o,
  focusedView: n,
  onFocusedViewChange: s,
  value: i,
  defaultValue: l,
  referenceDate: d,
  onChange: u,
  className: c,
  classes: p,
  disableFuture: f,
  disablePast: g,
  minDate: y,
  maxDate: h,
  shouldDisableDate: T,
  shouldDisableMonth: P,
  shouldDisableYear: E,
  reduceAnimations: $,
  onMonthChange: R,
  monthsPerRow: C,
  onYearChange: x,
  yearsOrder: _,
  yearsPerRow: D,
  slots: O,
  slotProps: v,
  loading: w,
  renderLoading: M,
  disableHighlightToday: S,
  readOnly: I,
  disabled: N,
  showDaysOutsideCurrentMonth: F,
  dayOfWeekFormatter: L,
  sx: k,
  autoFocus: W,
  fixedWeekNumber: V,
  displayWeekNumber: j,
  timezone: A
}) => /* @__PURE__ */ jsxRuntimeExports.jsx(DateCalendar, {
  view: e,
  onViewChange: t,
  views: o.filter(isDatePickerView),
  focusedView: n && isDatePickerView(n) ? n : null,
  onFocusedViewChange: s,
  value: i,
  defaultValue: l,
  referenceDate: d,
  onChange: u,
  className: c,
  classes: p,
  disableFuture: f,
  disablePast: g,
  minDate: y,
  maxDate: h,
  shouldDisableDate: T,
  shouldDisableMonth: P,
  shouldDisableYear: E,
  reduceAnimations: $,
  onMonthChange: R,
  monthsPerRow: C,
  onYearChange: x,
  yearsOrder: _,
  yearsPerRow: D,
  slots: O,
  slotProps: v,
  loading: w,
  renderLoading: M,
  disableHighlightToday: S,
  readOnly: I,
  disabled: N,
  showDaysOutsideCurrentMonth: F,
  dayOfWeekFormatter: L,
  sx: k,
  autoFocus: W,
  fixedWeekNumber: V,
  displayWeekNumber: j,
  timezone: A
});
process.env.NODE_ENV !== "production" && (renderDateViewCalendar.displayName = "renderDateViewCalendar");
const DesktopDatePicker = /* @__PURE__ */ React.forwardRef(function e(t, o) {
  const n = usePickerAdapter(), s = useDatePickerDefaultizedProps(t, "MuiDesktopDatePicker"), i = _extends({
    day: renderDateViewCalendar,
    month: renderDateViewCalendar,
    year: renderDateViewCalendar
  }, s.viewRenderers), l = _extends({}, s, {
    closeOnSelect: s.closeOnSelect ?? !0,
    viewRenderers: i,
    format: resolveDateFormat(n, s, !1),
    yearsPerRow: s.yearsPerRow ?? 4,
    slots: _extends({
      field: DateField$1
    }, s.slots),
    slotProps: _extends({}, s.slotProps, {
      field: (u) => _extends({}, resolveComponentProps(s.slotProps?.field, u), extractValidationProps(s)),
      toolbar: _extends({
        hidden: !0
      }, s.slotProps?.toolbar)
    })
  }), {
    renderPicker: d
  } = useDesktopPicker({
    ref: o,
    props: l,
    valueManager: singleItemValueManager,
    valueType: "date",
    validator: validateDate,
    steps: null
  });
  return d();
});
process.env.NODE_ENV !== "production" && (DesktopDatePicker.displayName = "DesktopDatePicker");
DesktopDatePicker.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: PropTypes.bool,
  className: PropTypes.string,
  /**
   * If `true`, the Picker will close after submitting the full date.
   * @default true
   */
  closeOnSelect: PropTypes.bool,
  /**
   * Formats the day of week displayed in the calendar header.
   * @param {PickerValidDate} date The date of the day of week provided by the adapter.
   * @returns {string} The name to display.
   * @default (date: PickerValidDate) => adapter.format(date, 'weekdayShort').charAt(0).toUpperCase()
   */
  dayOfWeekFormatter: PropTypes.func,
  /**
   * The default value.
   * Used when the component is not controlled.
   */
  defaultValue: PropTypes.object,
  /**
   * If `true`, the component is disabled.
   * When disabled, the value cannot be changed and no interaction is possible.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: PropTypes.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: PropTypes.bool,
  /**
   * If `true`, the button to open the Picker will not be rendered (it will only render the field).
   * @deprecated Use the [field component](https://mui.com/x/react-date-pickers/fields/) instead.
   * @default false
   */
  disableOpenPicker: PropTypes.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: PropTypes.bool,
  /**
   * If `true`, the week number will be display in the calendar.
   */
  displayWeekNumber: PropTypes.bool,
  /**
   * @default true
   */
  enableAccessibleFieldDOMStructure: PropTypes.any,
  /**
   * The day view will show as many weeks as needed after the end of the current month to match this value.
   * Put it to 6 to have a fixed number of weeks in Gregorian calendars
   */
  fixedWeekNumber: PropTypes.number,
  /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */
  format: PropTypes.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: PropTypes.oneOf(["dense", "spacious"]),
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType,
  /**
   * The label content.
   */
  label: PropTypes.node,
  /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */
  loading: PropTypes.bool,
  /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */
  localeText: PropTypes.object,
  /**
   * Maximal selectable date.
   * @default 2099-12-31
   */
  maxDate: PropTypes.object,
  /**
   * Minimal selectable date.
   * @default 1900-01-01
   */
  minDate: PropTypes.object,
  /**
   * Months rendered per row.
   * @default 3
   */
  monthsPerRow: PropTypes.oneOf([3, 4]),
  /**
   * Name attribute used by the `input` element in the Field.
   */
  name: PropTypes.string,
  /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onAccept: PropTypes.func,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onChange: PropTypes.func,
  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */
  onClose: PropTypes.func,
  /**
   * Callback fired when the error associated with the current value changes.
   * When a validation error is detected, the `error` parameter contains a non-null value.
   * This can be used to render an appropriate form error.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @param {TError} error The reason why the current value is not valid.
   * @param {TValue} value The value associated with the error.
   */
  onError: PropTypes.func,
  /**
   * Callback fired on month change.
   * @param {PickerValidDate} month The new month.
   */
  onMonthChange: PropTypes.func,
  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */
  onOpen: PropTypes.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: PropTypes.func,
  /**
   * Callback fired on view change.
   * @template TView Type of the view. It will vary based on the Picker type and the `views` it uses.
   * @param {TView} view The new view.
   */
  onViewChange: PropTypes.func,
  /**
   * Callback fired on year change.
   * @param {PickerValidDate} year The new year.
   */
  onYearChange: PropTypes.func,
  /**
   * Control the popup or dialog open state.
   * @default false
   */
  open: PropTypes.bool,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: PropTypes.oneOf(["day", "month", "year"]),
  /**
   * Force rendering in particular orientation.
   */
  orientation: PropTypes.oneOf(["landscape", "portrait"]),
  /**
   * If `true`, the component is read-only.
   * When read-only, the value cannot be changed but the user can interact with the interface.
   * @default false
   */
  readOnly: PropTypes.bool,
  /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */
  reduceAnimations: PropTypes.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */
  referenceDate: PropTypes.object,
  /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span>...</span>
   */
  renderLoading: PropTypes.func,
  /**
   * The currently selected sections.
   * This prop accepts four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 3. If `"all"` is provided, all the sections will be selected.
   * 4. If `null` is provided, no section will be selected.
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: PropTypes.oneOfType([PropTypes.oneOf(["all", "day", "empty", "hours", "meridiem", "minutes", "month", "seconds", "weekDay", "year"]), PropTypes.number]),
  /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (for example when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @param {PickerValidDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */
  shouldDisableDate: PropTypes.func,
  /**
   * Disable specific month.
   * @param {PickerValidDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */
  shouldDisableMonth: PropTypes.func,
  /**
   * Disable specific year.
   * @param {PickerValidDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */
  shouldDisableYear: PropTypes.func,
  /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */
  showDaysOutsideCurrentMonth: PropTypes.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: PropTypes.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: PropTypes.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: PropTypes.object,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: PropTypes.oneOf(["day", "month", "year"]),
  /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be used.
   */
  viewRenderers: PropTypes.shape({
    day: PropTypes.func,
    month: PropTypes.func,
    year: PropTypes.func
  }),
  /**
   * Available views.
   */
  views: PropTypes.arrayOf(PropTypes.oneOf(["day", "month", "year"]).isRequired),
  /**
   * Years are displayed in ascending (chronological) order by default.
   * If `desc`, years are displayed in descending order.
   * @default 'asc'
   */
  yearsOrder: PropTypes.oneOf(["asc", "desc"]),
  /**
   * Years rendered per row.
   * @default 4
   */
  yearsPerRow: PropTypes.oneOf([3, 4])
};
function getDialogContentUtilityClass(e) {
  return generateUtilityClass("MuiDialogContent", e);
}
generateUtilityClasses("MuiDialogContent", ["root", "dividers"]);
const dialogTitleClasses = generateUtilityClasses("MuiDialogTitle", ["root"]), useUtilityClasses$1 = (e) => {
  const {
    classes: t,
    dividers: o
  } = e;
  return composeClasses({
    root: ["root", o && "dividers"]
  }, getDialogContentUtilityClass, t);
}, DialogContentRoot = styled("div", {
  name: "MuiDialogContent",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.root, o.dividers && t.dividers];
  }
})(memoTheme(({
  theme: e
}) => ({
  flex: "1 1 auto",
  // Add iOS momentum scrolling for iOS < 13.0
  WebkitOverflowScrolling: "touch",
  overflowY: "auto",
  padding: "20px 24px",
  variants: [{
    props: ({
      ownerState: t
    }) => t.dividers,
    style: {
      padding: "16px 24px",
      borderTop: `1px solid ${(e.vars || e).palette.divider}`,
      borderBottom: `1px solid ${(e.vars || e).palette.divider}`
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.dividers,
    style: {
      [`.${dialogTitleClasses.root} + &`]: {
        paddingTop: 0
      }
    }
  }]
}))), DialogContent = /* @__PURE__ */ React.forwardRef(function e(t, o) {
  const n = useDefaultProps({
    props: t,
    name: "MuiDialogContent"
  }), {
    className: s,
    dividers: i = !1,
    ...l
  } = n, d = {
    ...n,
    dividers: i
  }, u = useUtilityClasses$1(d);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(DialogContentRoot, {
    className: clsx(u.root, s),
    ownerState: d,
    ref: o,
    ...l
  });
});
process.env.NODE_ENV !== "production" && (DialogContent.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * Display the top and bottom dividers.
   * @default false
   */
  dividers: PropTypes.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
});
function getDialogUtilityClass(e) {
  return generateUtilityClass("MuiDialog", e);
}
const dialogClasses = generateUtilityClasses("MuiDialog", ["root", "scrollPaper", "scrollBody", "container", "paper", "paperScrollPaper", "paperScrollBody", "paperWidthFalse", "paperWidthXs", "paperWidthSm", "paperWidthMd", "paperWidthLg", "paperWidthXl", "paperFullWidth", "paperFullScreen"]), DialogContext = /* @__PURE__ */ React.createContext({});
process.env.NODE_ENV !== "production" && (DialogContext.displayName = "DialogContext");
const DialogBackdrop = styled(Backdrop, {
  name: "MuiDialog",
  slot: "Backdrop",
  overrides: (e, t) => t.backdrop
})({
  // Improve scrollable dialog support.
  zIndex: -1
}), useUtilityClasses = (e) => {
  const {
    classes: t,
    scroll: o,
    maxWidth: n,
    fullWidth: s,
    fullScreen: i
  } = e, l = {
    root: ["root"],
    container: ["container", `scroll${capitalize(o)}`],
    paper: ["paper", `paperScroll${capitalize(o)}`, `paperWidth${capitalize(String(n))}`, s && "paperFullWidth", i && "paperFullScreen"]
  };
  return composeClasses(l, getDialogUtilityClass, t);
}, DialogRoot = styled(Modal, {
  name: "MuiDialog",
  slot: "Root"
})({
  "@media print": {
    // Use !important to override the Modal inline-style.
    position: "absolute !important"
  }
}), DialogContainer = styled("div", {
  name: "MuiDialog",
  slot: "Container",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.container, t[`scroll${capitalize(o.scroll)}`]];
  }
})({
  height: "100%",
  "@media print": {
    height: "auto"
  },
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0,
  variants: [{
    props: {
      scroll: "paper"
    },
    style: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    }
  }, {
    props: {
      scroll: "body"
    },
    style: {
      overflowY: "auto",
      overflowX: "hidden",
      textAlign: "center",
      "&::after": {
        content: '""',
        display: "inline-block",
        verticalAlign: "middle",
        height: "100%",
        width: "0"
      }
    }
  }]
}), DialogPaper = styled(Paper, {
  name: "MuiDialog",
  slot: "Paper",
  overridesResolver: (e, t) => {
    const {
      ownerState: o
    } = e;
    return [t.paper, t[`scrollPaper${capitalize(o.scroll)}`], t[`paperWidth${capitalize(String(o.maxWidth))}`], o.fullWidth && t.paperFullWidth, o.fullScreen && t.paperFullScreen];
  }
})(memoTheme(({
  theme: e
}) => ({
  margin: 32,
  position: "relative",
  overflowY: "auto",
  "@media print": {
    overflowY: "visible",
    boxShadow: "none"
  },
  variants: [{
    props: {
      scroll: "paper"
    },
    style: {
      display: "flex",
      flexDirection: "column",
      maxHeight: "calc(100% - 64px)"
    }
  }, {
    props: {
      scroll: "body"
    },
    style: {
      display: "inline-block",
      verticalAlign: "middle",
      textAlign: "initial"
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.maxWidth,
    style: {
      maxWidth: "calc(100% - 64px)"
    }
  }, {
    props: {
      maxWidth: "xs"
    },
    style: {
      maxWidth: e.breakpoints.unit === "px" ? Math.max(e.breakpoints.values.xs, 444) : `max(${e.breakpoints.values.xs}${e.breakpoints.unit}, 444px)`,
      [`&.${dialogClasses.paperScrollBody}`]: {
        [e.breakpoints.down(Math.max(e.breakpoints.values.xs, 444) + 64)]: {
          maxWidth: "calc(100% - 64px)"
        }
      }
    }
  }, ...Object.keys(e.breakpoints.values).filter((t) => t !== "xs").map((t) => ({
    props: {
      maxWidth: t
    },
    style: {
      maxWidth: `${e.breakpoints.values[t]}${e.breakpoints.unit}`,
      [`&.${dialogClasses.paperScrollBody}`]: {
        [e.breakpoints.down(e.breakpoints.values[t] + 64)]: {
          maxWidth: "calc(100% - 64px)"
        }
      }
    }
  })), {
    props: ({
      ownerState: t
    }) => t.fullWidth,
    style: {
      width: "calc(100% - 64px)"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.fullScreen,
    style: {
      margin: 0,
      width: "100%",
      maxWidth: "100%",
      height: "100%",
      maxHeight: "none",
      borderRadius: 0,
      [`&.${dialogClasses.paperScrollBody}`]: {
        margin: 0,
        maxWidth: "100%"
      }
    }
  }]
}))), Dialog = /* @__PURE__ */ React.forwardRef(function e(t, o) {
  const n = useDefaultProps({
    props: t,
    name: "MuiDialog"
  }), s = useTheme(), i = {
    enter: s.transitions.duration.enteringScreen,
    exit: s.transitions.duration.leavingScreen
  }, {
    "aria-describedby": l,
    "aria-labelledby": d,
    "aria-modal": u = !0,
    BackdropComponent: c,
    BackdropProps: p,
    children: f,
    className: g,
    disableEscapeKeyDown: y = !1,
    fullScreen: h = !1,
    fullWidth: T = !1,
    maxWidth: P = "sm",
    onClick: E,
    onClose: $,
    open: R,
    PaperComponent: C = Paper,
    PaperProps: x = {},
    scroll: _ = "paper",
    slots: D = {},
    slotProps: O = {},
    TransitionComponent: v = Fade,
    transitionDuration: w = i,
    TransitionProps: M,
    ...S
  } = n, I = {
    ...n,
    disableEscapeKeyDown: y,
    fullScreen: h,
    fullWidth: T,
    maxWidth: P,
    scroll: _
  }, N = useUtilityClasses(I), F = React.useRef(), L = (ue) => {
    F.current = ue.target === ue.currentTarget;
  }, k = (ue) => {
    E && E(ue), F.current && (F.current = null, $ && $(ue, "backdropClick"));
  }, W = useId(d), V = React.useMemo(() => ({
    titleId: W
  }), [W]), j = {
    transition: v,
    ...D
  }, A = {
    transition: M,
    paper: x,
    backdrop: p,
    ...O
  }, U = {
    slots: j,
    slotProps: A
  }, [G, Y] = useSlot("root", {
    elementType: DialogRoot,
    shouldForwardComponentProp: !0,
    externalForwardedProps: U,
    ownerState: I,
    className: clsx(N.root, g),
    ref: o
  }), [ee, J] = useSlot("backdrop", {
    elementType: DialogBackdrop,
    shouldForwardComponentProp: !0,
    externalForwardedProps: U,
    ownerState: I
  }), [Z, le] = useSlot("paper", {
    elementType: DialogPaper,
    shouldForwardComponentProp: !0,
    externalForwardedProps: U,
    ownerState: I,
    className: clsx(N.paper, x.className)
  }), [se, K] = useSlot("container", {
    elementType: DialogContainer,
    externalForwardedProps: U,
    ownerState: I,
    className: N.container
  }), [q, B] = useSlot("transition", {
    elementType: Fade,
    externalForwardedProps: U,
    ownerState: I,
    additionalProps: {
      appear: !0,
      in: R,
      timeout: w,
      role: "presentation"
    }
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(G, {
    closeAfterTransition: !0,
    slots: {
      backdrop: ee
    },
    slotProps: {
      backdrop: {
        transitionDuration: w,
        as: c,
        ...J
      }
    },
    disableEscapeKeyDown: y,
    onClose: $,
    open: R,
    onClick: k,
    ...Y,
    ...S,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(q, {
      ...B,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(se, {
        onMouseDown: L,
        ...K,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(Z, {
          as: C,
          elevation: 24,
          role: "dialog",
          "aria-describedby": l,
          "aria-labelledby": W,
          "aria-modal": u,
          ...le,
          children: /* @__PURE__ */ jsxRuntimeExports.jsx(DialogContext.Provider, {
            value: V,
            children: f
          })
        })
      })
    })
  });
});
process.env.NODE_ENV !== "production" && (Dialog.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The id(s) of the element(s) that describe the dialog.
   */
  "aria-describedby": PropTypes.string,
  /**
   * The id(s) of the element(s) that label the dialog.
   */
  "aria-labelledby": PropTypes.string,
  /**
   * Informs assistive technologies that the element is modal.
   * It's added on the element with role="dialog".
   * @default true
   */
  "aria-modal": PropTypes.oneOfType([PropTypes.oneOf(["false", "true"]), PropTypes.bool]),
  /**
   * A backdrop component. This prop enables custom backdrop rendering.
   * @deprecated Use `slots.backdrop` instead. While this prop currently works, it will be removed in the next major version.
   * Use the `slots.backdrop` prop to make your application ready for the next version of Material UI.
   * @default styled(Backdrop, {
   *   name: 'MuiModal',
   *   slot: 'Backdrop',
   * })({
   *   zIndex: -1,
   * })
   */
  BackdropComponent: PropTypes.elementType,
  /**
   * @ignore
   */
  BackdropProps: PropTypes.object,
  /**
   * Dialog children, usually the included sub-components.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * If `true`, hitting escape will not fire the `onClose` callback.
   * @default false
   */
  disableEscapeKeyDown: PropTypes.bool,
  /**
   * If `true`, the dialog is full-screen.
   * @default false
   */
  fullScreen: PropTypes.bool,
  /**
   * If `true`, the dialog stretches to `maxWidth`.
   *
   * Notice that the dialog width grow is limited by the default margin.
   * @default false
   */
  fullWidth: PropTypes.bool,
  /**
   * Determine the max-width of the dialog.
   * The dialog width grows with the size of the screen.
   * Set to `false` to disable `maxWidth`.
   * @default 'sm'
   */
  maxWidth: PropTypes.oneOfType([PropTypes.oneOf(["xs", "sm", "md", "lg", "xl", !1]), PropTypes.string]),
  /**
   * @ignore
   */
  onClick: PropTypes.func,
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
   */
  onClose: PropTypes.func,
  /**
   * If `true`, the component is shown.
   */
  open: PropTypes.bool.isRequired,
  /**
   * The component used to render the body of the dialog.
   * @default Paper
   */
  PaperComponent: PropTypes.elementType,
  /**
   * Props applied to the [`Paper`](https://mui.com/material-ui/api/paper/) element.
   * @default {}
   * @deprecated Use `slotProps.paper` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  PaperProps: PropTypes.object,
  /**
   * Determine the container for scrolling the dialog.
   * @default 'paper'
   */
  scroll: PropTypes.oneOf(["body", "paper"]),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: PropTypes.shape({
    backdrop: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    container: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    paper: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    transition: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: PropTypes.shape({
    backdrop: PropTypes.elementType,
    container: PropTypes.elementType,
    paper: PropTypes.elementType,
    root: PropTypes.elementType,
    transition: PropTypes.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The component used for the transition.
   * [Follow this guide](https://mui.com/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Fade
   * @deprecated Use `slots.transition` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  TransitionComponent: PropTypes.elementType,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */
  transitionDuration: PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @deprecated Use `slotProps.transition` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  TransitionProps: PropTypes.object
});
const PickersModalDialogRoot = styled(Dialog)({
  [`& .${dialogClasses.container}`]: {
    outline: 0
  },
  [`& .${dialogClasses.paper}`]: {
    outline: 0,
    minWidth: DIALOG_WIDTH
  }
}), PickersModalDialogContent = styled(DialogContent)({
  "&:first-of-type": {
    padding: 0
  }
});
function PickersModalDialog(e) {
  const {
    children: t,
    slots: o,
    slotProps: n
  } = e, {
    open: s
  } = usePickerContext(), {
    dismissViews: i,
    onPopperExited: l
  } = usePickerPrivateContext(), d = o?.dialog ?? PickersModalDialogRoot, u = o?.mobileTransition ?? Fade;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(d, _extends({
    open: s,
    onClose: () => {
      i(), l?.();
    }
  }, n?.dialog, {
    TransitionComponent: u,
    TransitionProps: n?.mobileTransition,
    PaperComponent: o?.mobilePaper,
    PaperProps: n?.mobilePaper,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(PickersModalDialogContent, {
      children: t
    })
  }));
}
const _excluded$1 = ["props", "steps"], _excluded2 = ["ownerState"], useMobilePicker = (e) => {
  let {
    props: t,
    steps: o
  } = e, n = _objectWithoutPropertiesLoose(e, _excluded$1);
  const {
    slots: s,
    slotProps: i,
    label: l,
    inputRef: d,
    localeText: u
  } = t, c = createNonRangePickerStepNavigation({
    steps: o
  }), {
    providerProps: p,
    renderCurrentView: f,
    ownerState: g
  } = usePicker(_extends({}, n, {
    props: t,
    localeText: u,
    autoFocusView: !0,
    viewContainerRole: "dialog",
    variant: "mobile",
    getStepNavigation: c
  })), y = p.privateContextValue.labelId, h = i?.toolbar?.hidden ?? !1, T = s.field, P = useSlotProps({
    elementType: T,
    externalSlotProps: i?.field,
    additionalProps: _extends({}, h && {
      id: y
    }),
    ownerState: g
  }), E = _objectWithoutPropertiesLoose(P, _excluded2), $ = s.layout ?? PickersLayout;
  let R = y;
  h && (l ? R = `${y}-label` : R = void 0);
  const C = _extends({}, i, {
    toolbar: _extends({}, i?.toolbar, {
      titleId: y
    }),
    mobilePaper: _extends({
      "aria-labelledby": R
    }, i?.mobilePaper)
  }), x = () => /* @__PURE__ */ jsxRuntimeExports.jsxs(PickerProvider, _extends({}, p, {
    children: [/* @__PURE__ */ jsxRuntimeExports.jsx(T, _extends({}, E, {
      slots: s,
      slotProps: C,
      inputRef: d
    })), /* @__PURE__ */ jsxRuntimeExports.jsx(PickersModalDialog, {
      slots: s,
      slotProps: C,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx($, _extends({}, C?.layout, {
        slots: s,
        slotProps: C,
        children: f()
      }))
    })]
  }));
  return process.env.NODE_ENV !== "production" && (x.displayName = "renderPicker"), {
    renderPicker: x
  };
}, MobileDatePicker = /* @__PURE__ */ React.forwardRef(function e(t, o) {
  const n = usePickerAdapter(), s = useDatePickerDefaultizedProps(t, "MuiMobileDatePicker"), i = _extends({
    day: renderDateViewCalendar,
    month: renderDateViewCalendar,
    year: renderDateViewCalendar
  }, s.viewRenderers), l = _extends({}, s, {
    viewRenderers: i,
    format: resolveDateFormat(n, s, !1),
    slots: _extends({
      field: DateField$1
    }, s.slots),
    slotProps: _extends({}, s.slotProps, {
      field: (u) => _extends({}, resolveComponentProps(s.slotProps?.field, u), extractValidationProps(s)),
      toolbar: _extends({
        hidden: !1
      }, s.slotProps?.toolbar)
    })
  }), {
    renderPicker: d
  } = useMobilePicker({
    ref: o,
    props: l,
    valueManager: singleItemValueManager,
    valueType: "date",
    validator: validateDate,
    steps: null
  });
  return d();
});
process.env.NODE_ENV !== "production" && (MobileDatePicker.displayName = "MobileDatePicker");
MobileDatePicker.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: PropTypes.bool,
  className: PropTypes.string,
  /**
   * If `true`, the Picker will close after submitting the full date.
   * @default false
   */
  closeOnSelect: PropTypes.bool,
  /**
   * Formats the day of week displayed in the calendar header.
   * @param {PickerValidDate} date The date of the day of week provided by the adapter.
   * @returns {string} The name to display.
   * @default (date: PickerValidDate) => adapter.format(date, 'weekdayShort').charAt(0).toUpperCase()
   */
  dayOfWeekFormatter: PropTypes.func,
  /**
   * The default value.
   * Used when the component is not controlled.
   */
  defaultValue: PropTypes.object,
  /**
   * If `true`, the component is disabled.
   * When disabled, the value cannot be changed and no interaction is possible.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: PropTypes.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: PropTypes.bool,
  /**
   * If `true`, the button to open the Picker will not be rendered (it will only render the field).
   * @deprecated Use the [field component](https://mui.com/x/react-date-pickers/fields/) instead.
   * @default false
   */
  disableOpenPicker: PropTypes.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: PropTypes.bool,
  /**
   * If `true`, the week number will be display in the calendar.
   */
  displayWeekNumber: PropTypes.bool,
  /**
   * @default true
   */
  enableAccessibleFieldDOMStructure: PropTypes.any,
  /**
   * The day view will show as many weeks as needed after the end of the current month to match this value.
   * Put it to 6 to have a fixed number of weeks in Gregorian calendars
   */
  fixedWeekNumber: PropTypes.number,
  /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */
  format: PropTypes.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: PropTypes.oneOf(["dense", "spacious"]),
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType,
  /**
   * The label content.
   */
  label: PropTypes.node,
  /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */
  loading: PropTypes.bool,
  /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */
  localeText: PropTypes.object,
  /**
   * Maximal selectable date.
   * @default 2099-12-31
   */
  maxDate: PropTypes.object,
  /**
   * Minimal selectable date.
   * @default 1900-01-01
   */
  minDate: PropTypes.object,
  /**
   * Months rendered per row.
   * @default 3
   */
  monthsPerRow: PropTypes.oneOf([3, 4]),
  /**
   * Name attribute used by the `input` element in the Field.
   */
  name: PropTypes.string,
  /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onAccept: PropTypes.func,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onChange: PropTypes.func,
  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */
  onClose: PropTypes.func,
  /**
   * Callback fired when the error associated with the current value changes.
   * When a validation error is detected, the `error` parameter contains a non-null value.
   * This can be used to render an appropriate form error.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @param {TError} error The reason why the current value is not valid.
   * @param {TValue} value The value associated with the error.
   */
  onError: PropTypes.func,
  /**
   * Callback fired on month change.
   * @param {PickerValidDate} month The new month.
   */
  onMonthChange: PropTypes.func,
  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */
  onOpen: PropTypes.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: PropTypes.func,
  /**
   * Callback fired on view change.
   * @template TView Type of the view. It will vary based on the Picker type and the `views` it uses.
   * @param {TView} view The new view.
   */
  onViewChange: PropTypes.func,
  /**
   * Callback fired on year change.
   * @param {PickerValidDate} year The new year.
   */
  onYearChange: PropTypes.func,
  /**
   * Control the popup or dialog open state.
   * @default false
   */
  open: PropTypes.bool,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: PropTypes.oneOf(["day", "month", "year"]),
  /**
   * Force rendering in particular orientation.
   */
  orientation: PropTypes.oneOf(["landscape", "portrait"]),
  /**
   * If `true`, the component is read-only.
   * When read-only, the value cannot be changed but the user can interact with the interface.
   * @default false
   */
  readOnly: PropTypes.bool,
  /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */
  reduceAnimations: PropTypes.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */
  referenceDate: PropTypes.object,
  /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span>...</span>
   */
  renderLoading: PropTypes.func,
  /**
   * The currently selected sections.
   * This prop accepts four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 3. If `"all"` is provided, all the sections will be selected.
   * 4. If `null` is provided, no section will be selected.
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: PropTypes.oneOfType([PropTypes.oneOf(["all", "day", "empty", "hours", "meridiem", "minutes", "month", "seconds", "weekDay", "year"]), PropTypes.number]),
  /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (for example when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @param {PickerValidDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */
  shouldDisableDate: PropTypes.func,
  /**
   * Disable specific month.
   * @param {PickerValidDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */
  shouldDisableMonth: PropTypes.func,
  /**
   * Disable specific year.
   * @param {PickerValidDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */
  shouldDisableYear: PropTypes.func,
  /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */
  showDaysOutsideCurrentMonth: PropTypes.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: PropTypes.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: PropTypes.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: PropTypes.object,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: PropTypes.oneOf(["day", "month", "year"]),
  /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be used.
   */
  viewRenderers: PropTypes.shape({
    day: PropTypes.func,
    month: PropTypes.func,
    year: PropTypes.func
  }),
  /**
   * Available views.
   */
  views: PropTypes.arrayOf(PropTypes.oneOf(["day", "month", "year"]).isRequired),
  /**
   * Years are displayed in ascending (chronological) order by default.
   * If `desc`, years are displayed in descending order.
   * @default 'asc'
   */
  yearsOrder: PropTypes.oneOf(["asc", "desc"]),
  /**
   * Years rendered per row.
   * @default 3
   */
  yearsPerRow: PropTypes.oneOf([3, 4])
};
const _excluded = ["desktopModeMediaQuery"], DatePicker = /* @__PURE__ */ React.forwardRef(function e(t, o) {
  const n = useThemeProps({
    props: t,
    name: "MuiDatePicker"
  }), {
    desktopModeMediaQuery: s = DEFAULT_DESKTOP_MODE_MEDIA_QUERY
  } = n, i = _objectWithoutPropertiesLoose(n, _excluded);
  return useMediaQuery(s, {
    defaultMatches: !0
  }) ? /* @__PURE__ */ jsxRuntimeExports.jsx(DesktopDatePicker, _extends({
    ref: o
  }, i)) : /* @__PURE__ */ jsxRuntimeExports.jsx(MobileDatePicker, _extends({
    ref: o
  }, i));
});
process.env.NODE_ENV !== "production" && (DatePicker.displayName = "DatePicker");
process.env.NODE_ENV !== "production" && (DatePicker.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: PropTypes.bool,
  className: PropTypes.string,
  /**
   * If `true`, the Picker will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */
  closeOnSelect: PropTypes.bool,
  /**
   * Formats the day of week displayed in the calendar header.
   * @param {PickerValidDate} date The date of the day of week provided by the adapter.
   * @returns {string} The name to display.
   * @default (date: PickerValidDate) => adapter.format(date, 'weekdayShort').charAt(0).toUpperCase()
   */
  dayOfWeekFormatter: PropTypes.func,
  /**
   * The default value.
   * Used when the component is not controlled.
   */
  defaultValue: PropTypes.object,
  /**
   * CSS media query when `Mobile` mode will be changed to `Desktop`.
   * @default '@media (pointer: fine)'
   * @example '@media (min-width: 720px)' or theme.breakpoints.up("sm")
   */
  desktopModeMediaQuery: PropTypes.string,
  /**
   * If `true`, the component is disabled.
   * When disabled, the value cannot be changed and no interaction is possible.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: PropTypes.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: PropTypes.bool,
  /**
   * If `true`, the button to open the Picker will not be rendered (it will only render the field).
   * @deprecated Use the [field component](https://mui.com/x/react-date-pickers/fields/) instead.
   * @default false
   */
  disableOpenPicker: PropTypes.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: PropTypes.bool,
  /**
   * If `true`, the week number will be display in the calendar.
   */
  displayWeekNumber: PropTypes.bool,
  /**
   * @default true
   */
  enableAccessibleFieldDOMStructure: PropTypes.any,
  /**
   * The day view will show as many weeks as needed after the end of the current month to match this value.
   * Put it to 6 to have a fixed number of weeks in Gregorian calendars
   */
  fixedWeekNumber: PropTypes.number,
  /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */
  format: PropTypes.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: PropTypes.oneOf(["dense", "spacious"]),
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType,
  /**
   * The label content.
   */
  label: PropTypes.node,
  /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */
  loading: PropTypes.bool,
  /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */
  localeText: PropTypes.object,
  /**
   * Maximal selectable date.
   * @default 2099-12-31
   */
  maxDate: PropTypes.object,
  /**
   * Minimal selectable date.
   * @default 1900-01-01
   */
  minDate: PropTypes.object,
  /**
   * Months rendered per row.
   * @default 3
   */
  monthsPerRow: PropTypes.oneOf([3, 4]),
  /**
   * Name attribute used by the `input` element in the Field.
   */
  name: PropTypes.string,
  /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onAccept: PropTypes.func,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onChange: PropTypes.func,
  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */
  onClose: PropTypes.func,
  /**
   * Callback fired when the error associated with the current value changes.
   * When a validation error is detected, the `error` parameter contains a non-null value.
   * This can be used to render an appropriate form error.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @param {TError} error The reason why the current value is not valid.
   * @param {TValue} value The value associated with the error.
   */
  onError: PropTypes.func,
  /**
   * Callback fired on month change.
   * @param {PickerValidDate} month The new month.
   */
  onMonthChange: PropTypes.func,
  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */
  onOpen: PropTypes.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: PropTypes.func,
  /**
   * Callback fired on view change.
   * @template TView Type of the view. It will vary based on the Picker type and the `views` it uses.
   * @param {TView} view The new view.
   */
  onViewChange: PropTypes.func,
  /**
   * Callback fired on year change.
   * @param {PickerValidDate} year The new year.
   */
  onYearChange: PropTypes.func,
  /**
   * Control the popup or dialog open state.
   * @default false
   */
  open: PropTypes.bool,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: PropTypes.oneOf(["day", "month", "year"]),
  /**
   * Force rendering in particular orientation.
   */
  orientation: PropTypes.oneOf(["landscape", "portrait"]),
  /**
   * If `true`, the component is read-only.
   * When read-only, the value cannot be changed but the user can interact with the interface.
   * @default false
   */
  readOnly: PropTypes.bool,
  /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */
  reduceAnimations: PropTypes.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */
  referenceDate: PropTypes.object,
  /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span>...</span>
   */
  renderLoading: PropTypes.func,
  /**
   * The currently selected sections.
   * This prop accepts four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 3. If `"all"` is provided, all the sections will be selected.
   * 4. If `null` is provided, no section will be selected.
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: PropTypes.oneOfType([PropTypes.oneOf(["all", "day", "empty", "hours", "meridiem", "minutes", "month", "seconds", "weekDay", "year"]), PropTypes.number]),
  /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (for example when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @param {PickerValidDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */
  shouldDisableDate: PropTypes.func,
  /**
   * Disable specific month.
   * @param {PickerValidDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */
  shouldDisableMonth: PropTypes.func,
  /**
   * Disable specific year.
   * @param {PickerValidDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */
  shouldDisableYear: PropTypes.func,
  /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */
  showDaysOutsideCurrentMonth: PropTypes.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: PropTypes.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: PropTypes.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: PropTypes.object,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: PropTypes.oneOf(["day", "month", "year"]),
  /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be used.
   */
  viewRenderers: PropTypes.shape({
    day: PropTypes.func,
    month: PropTypes.func,
    year: PropTypes.func
  }),
  /**
   * Available views.
   */
  views: PropTypes.arrayOf(PropTypes.oneOf(["day", "month", "year"]).isRequired),
  /**
   * Years are displayed in ascending (chronological) order by default.
   * If `desc`, years are displayed in descending order.
   * @default 'asc'
   */
  yearsOrder: PropTypes.oneOf(["asc", "desc"]),
  /**
   * Years rendered per row.
   * @default 4 on desktop, 3 on mobile
   */
  yearsPerRow: PropTypes.oneOf([3, 4])
});
const formatTokenMap = {
  // Year
  y: {
    sectionType: "year",
    contentType: "digit",
    maxLength: 4
  },
  yy: "year",
  yyy: {
    sectionType: "year",
    contentType: "digit",
    maxLength: 4
  },
  yyyy: "year",
  // Month
  M: {
    sectionType: "month",
    contentType: "digit",
    maxLength: 2
  },
  MM: "month",
  MMMM: {
    sectionType: "month",
    contentType: "letter"
  },
  MMM: {
    sectionType: "month",
    contentType: "letter"
  },
  L: {
    sectionType: "month",
    contentType: "digit",
    maxLength: 2
  },
  LL: "month",
  LLL: {
    sectionType: "month",
    contentType: "letter"
  },
  LLLL: {
    sectionType: "month",
    contentType: "letter"
  },
  // Day of the month
  d: {
    sectionType: "day",
    contentType: "digit",
    maxLength: 2
  },
  dd: "day",
  do: {
    sectionType: "day",
    contentType: "digit-with-letter"
  },
  // Day of the week
  E: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  EE: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  EEE: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  EEEE: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  EEEEE: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  i: {
    sectionType: "weekDay",
    contentType: "digit",
    maxLength: 1
  },
  ii: "weekDay",
  iii: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  iiii: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  // eslint-disable-next-line id-denylist
  e: {
    sectionType: "weekDay",
    contentType: "digit",
    maxLength: 1
  },
  ee: "weekDay",
  eee: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  eeee: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  eeeee: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  eeeeee: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  c: {
    sectionType: "weekDay",
    contentType: "digit",
    maxLength: 1
  },
  cc: "weekDay",
  ccc: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  cccc: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  ccccc: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  cccccc: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  // Meridiem
  a: "meridiem",
  aa: "meridiem",
  aaa: "meridiem",
  // Hours
  H: {
    sectionType: "hours",
    contentType: "digit",
    maxLength: 2
  },
  HH: "hours",
  h: {
    sectionType: "hours",
    contentType: "digit",
    maxLength: 2
  },
  hh: "hours",
  // Minutes
  m: {
    sectionType: "minutes",
    contentType: "digit",
    maxLength: 2
  },
  mm: "minutes",
  // Seconds
  s: {
    sectionType: "seconds",
    contentType: "digit",
    maxLength: 2
  },
  ss: "seconds"
}, defaultFormats = {
  year: "yyyy",
  month: "LLLL",
  monthShort: "MMM",
  dayOfMonth: "d",
  dayOfMonthFull: "do",
  weekday: "EEEE",
  weekdayShort: "EEEEEE",
  hours24h: "HH",
  hours12h: "hh",
  meridiem: "aa",
  minutes: "mm",
  seconds: "ss",
  fullDate: "PP",
  keyboardDate: "P",
  shortDate: "MMM d",
  normalDate: "d MMMM",
  normalDateWithWeekday: "EEE, MMM d",
  fullTime12h: "hh:mm aa",
  fullTime24h: "HH:mm",
  keyboardDateTime12h: "P hh:mm aa",
  keyboardDateTime24h: "P HH:mm"
};
class AdapterDateFnsBase {
  isMUIAdapter = !0;
  isTimezoneCompatible = !1;
  formatTokenMap = formatTokenMap;
  escapedCharacters = {
    start: "'",
    end: "'"
  };
  constructor(t) {
    const {
      locale: o,
      formats: n,
      longFormatters: s,
      lib: i
    } = t;
    this.locale = o, this.formats = _extends({}, defaultFormats, n), this.longFormatters = s, this.lib = i || "date-fns";
  }
  date = (t) => typeof t > "u" ? /* @__PURE__ */ new Date() : t === null ? null : new Date(t);
  getInvalidDate = () => /* @__PURE__ */ new Date("Invalid Date");
  getTimezone = () => "default";
  setTimezone = (t) => t;
  toJsDate = (t) => t;
  getCurrentLocaleCode = () => this.locale.code;
  // Note: date-fns input types are more lenient than this adapter, so we need to expose our more
  // strict signature and delegate to the more lenient signature. Otherwise, we have downstream type errors upon usage.
  is12HourCycleInCurrentLocale = () => /a/.test(this.locale.formatLong.time({
    width: "short"
  }));
  expandFormat = (t) => {
    const o = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
    return t.match(o).map((n) => {
      const s = n[0];
      if (s === "p" || s === "P") {
        const i = this.longFormatters[s];
        return i(n, this.locale.formatLong);
      }
      return n;
    }).join("");
  };
  formatNumber = (t) => t;
  getDayOfWeek = (t) => t.getDay() + 1;
}
class AdapterDateFns extends AdapterDateFnsBase {
  constructor({
    locale: t,
    formats: o
  } = {}) {
    if (process.env.NODE_ENV !== "production") {
      if (typeof addDays != "function")
        throw new Error(["MUI: The `date-fns` package v2.x is not compatible with this adapter.", "Please, install v3.x or v4.x of the package or use the `AdapterDateFnsV2` instead."].join(`
`));
      if (!longFormatters)
        throw new Error("MUI: The minimum supported `date-fns` package version compatible with this adapter is `3.2.x`.");
    }
    super({
      locale: t ?? enUS,
      formats: o,
      longFormatters
    });
  }
  // TODO: explicit return types can be removed once there is only one date-fns version supported
  parse = (t, o) => t === "" ? null : parse(t, o, /* @__PURE__ */ new Date(), {
    locale: this.locale
  });
  isValid = (t) => t == null ? !1 : isValid(t);
  format = (t, o) => this.formatByString(t, this.formats[o]);
  formatByString = (t, o) => format(t, o, {
    locale: this.locale
  });
  isEqual = (t, o) => t === null && o === null ? !0 : t === null || o === null ? !1 : isEqual(t, o);
  isSameYear = (t, o) => isSameYear(t, o);
  isSameMonth = (t, o) => isSameMonth$1(t, o);
  isSameDay = (t, o) => isSameDay(t, o);
  isSameHour = (t, o) => isSameHour(t, o);
  isAfter = (t, o) => isAfter(t, o);
  isAfterYear = (t, o) => isAfter(t, endOfYear(o));
  isAfterDay = (t, o) => isAfter(t, endOfDay(o));
  isBefore = (t, o) => isBefore(t, o);
  isBeforeYear = (t, o) => isBefore(t, this.startOfYear(o));
  isBeforeDay = (t, o) => isBefore(t, this.startOfDay(o));
  isWithinRange = (t, [o, n]) => isWithinInterval(t, {
    start: o,
    end: n
  });
  startOfYear = (t) => startOfYear(t);
  startOfMonth = (t) => startOfMonth(t);
  startOfWeek = (t) => startOfWeek(t, {
    locale: this.locale
  });
  startOfDay = (t) => startOfDay(t);
  endOfYear = (t) => endOfYear(t);
  endOfMonth = (t) => endOfMonth(t);
  endOfWeek = (t) => endOfWeek(t, {
    locale: this.locale
  });
  endOfDay = (t) => endOfDay(t);
  addYears = (t, o) => addYears(t, o);
  addMonths = (t, o) => addMonths(t, o);
  addWeeks = (t, o) => addWeeks(t, o);
  addDays = (t, o) => addDays(t, o);
  addHours = (t, o) => addHours(t, o);
  addMinutes = (t, o) => addMinutes(t, o);
  addSeconds = (t, o) => addSeconds(t, o);
  getYear = (t) => getYear(t);
  getMonth = (t) => getMonth(t);
  getDate = (t) => getDate(t);
  getHours = (t) => getHours(t);
  getMinutes = (t) => getMinutes(t);
  getSeconds = (t) => getSeconds(t);
  getMilliseconds = (t) => getMilliseconds(t);
  setYear = (t, o) => setYear(t, o);
  setMonth = (t, o) => setMonth(t, o);
  setDate = (t, o) => setDate(t, o);
  setHours = (t, o) => setHours(t, o);
  setMinutes = (t, o) => setMinutes(t, o);
  setSeconds = (t, o) => setSeconds(t, o);
  setMilliseconds = (t, o) => setMilliseconds(t, o);
  getDaysInMonth = (t) => getDaysInMonth(t);
  getWeekArray = (t) => {
    const o = this.startOfWeek(this.startOfMonth(t)), n = this.endOfWeek(this.endOfMonth(t));
    let s = 0, i = o;
    const l = [];
    for (; this.isBefore(i, n); ) {
      const d = Math.floor(s / 7);
      l[d] = l[d] || [], l[d].push(i), i = this.addDays(i, 1), s += 1;
    }
    return l;
  };
  getWeekNumber = (t) => getWeek(t, {
    locale: this.locale
  });
  getYearRange = ([t, o]) => {
    const n = this.startOfYear(t), s = this.endOfYear(o), i = [];
    let l = n;
    for (; this.isBefore(l, s); )
      i.push(l), l = this.addYears(l, 1);
    return i;
  };
}
const DeliveryInformation = ({
  firstAttendee: e,
  initialAddress: t,
  addressExtension: o,
  deliveryTimeFrame: n,
  deliveryDate: s,
  deliveryTimeFrames: i,
  deliveryTimeFrameEnabled: l,
  deliveryDateEnabled: d,
  deliveryDateMinimumDays: u,
  onChangeDeliveryTimeFrame: c,
  onChangeDeliveryDate: p,
  onChangeAddress: f,
  onChangeAddressExtension: g,
  isSignatureDisabled: y,
  signature: h,
  onChangeSignature: T,
  disable: P
}) => {
  const { t: E } = useTranslation(), { dateLocale: $ } = useDateLocale(), R = useTheme$4(), [C, x] = useState(!0), [_, D] = useState(void 0), O = (N, F) => {
    const L = {
      content: N.addressType === AddressTypeDataEnum.STANDARD ? E("components.address.type.standard") : N.addressType === AddressTypeDataEnum.DELIVERY ? E("components.address.type.delivery") : N.addressType === AddressTypeDataEnum.LEGAL ? E("components.address.type.legal") : N.addressType === AddressTypeDataEnum.VISIT ? E("components.address.type.visit") : "",
      textColor: R.palette.text.disabled
    }, k = {
      content: (F?.rootOrganization?.id === F?.id ? F?.name : F?.rootOrganization?.name) ?? "",
      icon: /* @__PURE__ */ jsxRuntimeExports.jsx(LocalHospital, { fontSize: "small" })
    }, W = {
      content: getOneLineAddress(N),
      textColor: R.palette.text.disabled,
      icon: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledLocationOn, {})
    }, V = [
      L,
      k
    ];
    return F?.rootOrganization?.id !== F?.id && V.push({
      content: F?.name ?? "",
      icon: /* @__PURE__ */ jsxRuntimeExports.jsx(MedicalServices, { fontSize: "small" })
    }), V.push(W), V;
  }, v = e?.employments?.flatMap((N) => {
    const F = N?.organization?.addresses?.map((k) => ({
      oid: k?.oid ?? "",
      data: O(k, N?.organization)
    })) ?? [], L = N?.addresses?.map((k) => ({
      oid: k?.oid ?? "",
      data: O(k, N?.organization)
    })) ?? [];
    return F.concat(L);
  }) ?? [];
  useEffect(() => {
    if (t) {
      const N = v.find(
        (F) => F.oid === t
      );
      D(N);
    }
  }, [t]);
  const w = () => {
    x(!0);
  }, M = () => {
    x(!1);
  }, S = (N, F) => {
    D(F), f?.(F.oid);
  }, I = () => add(/* @__PURE__ */ new Date(), { days: u ?? 0 });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    LocalizationProvider,
    {
      dateAdapter: AdapterDateFns,
      adapterLocale: $,
      children: /* @__PURE__ */ jsxRuntimeExports.jsxs(DeliveryInformationWrapper, { "data-testid": "delivery-information", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs(Title$1, { variant: "subtitle2", children: [
          E("components.interaction.expand.deliveryInformation"),
          ":"
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(Grid, { container: !0, spacing: 3, children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12, md: 6 }, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(MediumStack, { children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(Typography$2, { variant: "body2", children: `${E(
              "components.interaction.expand.address"
            )} ${getPersonFullNameWithTitle(e)}` }),
            v.length === 1 && /* @__PURE__ */ jsxRuntimeExports.jsx(ParentStack$1, { "data-testid": "single-address-block", children: v[0]?.data.map((N, F) => /* @__PURE__ */ jsxRuntimeExports.jsx(Stack, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledBox$3, { children: [
              N.icon && /* @__PURE__ */ jsxRuntimeExports.jsx(IconWrapper, { size: 20, children: N.icon }),
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                Typography$2,
                {
                  variant: "caption",
                  color: N.textColor ?? R.palette.text.primary,
                  children: N.content
                }
              )
            ] }) }, F)) }),
            v.length > 1 && /* @__PURE__ */ jsxRuntimeExports.jsx(
              MultiLineSingleSelect,
              {
                availableOptions: v,
                selectedOption: _,
                label: E("components.interaction.expand.selectAddress"),
                disable: P,
                onSelect: S
              }
            ),
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              TextField$1,
              {
                "data-testid": "additional-address-input",
                value: o,
                disabled: P,
                label: E(
                  "components.interaction.expand.additionalInformationLabel"
                ),
                placeholder: E(
                  "components.interaction.expand.additionalInformationPlaceholder"
                ),
                onChange: g
              }
            ),
            /* @__PURE__ */ jsxRuntimeExports.jsxs(DeliveryInfoRow, { children: [
              d && /* @__PURE__ */ jsxRuntimeExports.jsx(
                DatePicker,
                {
                  label: E("components.interaction.expand.deliveryDate"),
                  value: s,
                  slotProps: {
                    textField: /* @__PURE__ */ jsxRuntimeExports.jsx(DateField, { onClick: w })
                  },
                  disabled: P,
                  open: C,
                  minDate: I(),
                  desktopModeMediaQuery: R.breakpoints.up("xs"),
                  onClose: M,
                  onChange: (N) => p?.(N)
                }
              ),
              l && /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControl$1, { fullWidth: !0, children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx(
                  InputLabel$1,
                  {
                    id: "test-select-label",
                    shrink: !!n,
                    children: E("components.interaction.expand.deliveryTimeFrame")
                  }
                ),
                /* @__PURE__ */ jsxRuntimeExports.jsx(
                  Select$2,
                  {
                    id: "time-frame-select",
                    value: n ?? "",
                    disabled: P,
                    notched: !!n,
                    label: E(
                      "components.interaction.expand.deliveryTimeFrame"
                    ),
                    onChange: c,
                    children: i?.map((N) => /* @__PURE__ */ jsxRuntimeExports.jsx(MenuItem, { value: N.oid, children: N.name }, N.oid))
                  }
                )
              ] })
            ] })
          ] }) }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { size: { xs: 12, md: 6 }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            SignatureBox,
            {
              isClearable: !0,
              disable: y,
              mandatory: !0,
              signature: h,
              signatureLabel: E("components.interaction.signature"),
              onChangeSignature: T
            }
          ) })
        ] })
      ] })
    }
  );
}, DeliveryInformationWrapper = styled(Stack)(({ theme: e }) => ({
  gap: e.spacing(3),
  [e.breakpoints.down("md")]: {
    gap: e.spacing(2)
  }
})), MediumStack = styled(Stack)(({ theme: e }) => ({
  gap: e.spacing(3)
})), Title$1 = styled(Typography$2)(({ theme: e }) => ({
  color: e.palette.text.secondary
})), DateField = styled(TextField$1)(({ theme: e }) => ({
  width: "100%",
  ".MuiInputBase-input": {
    cursor: "pointer",
    // removes the blinking input caret
    caretColor: "transparent"
  },
  ".MuiInputAdornment-root": {
    [e.breakpoints.down("md")]: {
      display: "none"
    }
  }
})), DeliveryInfoRow = styled(Box)(({ theme: e }) => ({
  display: "flex",
  gap: e.spacing(2),
  [e.breakpoints.down("md")]: {
    display: "grid"
  }
})), StyledLocationOn = styled(LocationOn)(({ theme: e }) => ({
  color: e.palette.text.disabled,
  height: "1.125rem",
  width: "1.125rem"
})), ParentStack$1 = styled(Stack)(({ theme: e }) => ({
  gap: e.spacing(1)
})), StyledBox$3 = styled(Box)(({ theme: e }) => ({
  display: "flex",
  gap: e.spacing(1),
  alignItems: "center"
})), PromotionalMaterialBatchInformation = ({
  batch: e
}) => {
  const { t } = useTranslation(), { formatLocalizedDate: o } = useFormatDate(), n = (d) => d === StockTypeDataEnum.PHYSICAL ? "components.interaction.physical" : "components.interaction.virtual", s = e?.expiryDate ? o(new Date(e?.expiryDate)) : "", i = `${t(
    "components.interaction.expiryDate"
  )}: ${s}`, l = `${t(
    "components.interaction.expiryDateShort"
  )}: ${s}`;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(InfoBox, { "data-testid": "promat-batch-info", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(TinyStack, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(DesktopTypography, { variant: "caption", children: i }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(MobileTypography, { variant: "caption", children: l }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(DesktopTypography, { variant: "caption", children: `${t(
        "components.interaction.batchNumber"
      )}: ${e.name}` }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(MobileTypography, { variant: "caption", children: e.name })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(MediumBox, { children: [
      e.physicalStock.requestedQuantity > 0 && /* @__PURE__ */ jsxRuntimeExports.jsxs(SmallBox, { "data-testid": "physical-stock", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs(Typography$2, { variant: "caption", children: [
          t(n(StockTypeDataEnum.PHYSICAL)),
          ":"
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Typography$2, { variant: "overline", children: e.physicalStock.requestedQuantity })
      ] }),
      e.virtualStock.requestedQuantity > 0 && /* @__PURE__ */ jsxRuntimeExports.jsxs(SmallBox, { "data-testid": "virtual-stock", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs(Typography$2, { variant: "caption", children: [
          t(n(StockTypeDataEnum.VIRTUAL)),
          ":"
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Typography$2, { variant: "overline", children: e.virtualStock.requestedQuantity })
      ] })
    ] })
  ] });
}, InfoBox = styled(Box)({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "space-between"
}), TinyStack = styled(Stack)(({ theme: e }) => ({
  gap: e.spacing(0.5)
})), MediumBox = styled(Box)(({ theme: e }) => ({
  display: "flex",
  gap: e.spacing(2)
})), SmallBox = styled(Box)(({ theme: e }) => ({
  display: "flex",
  gap: e.spacing(1)
})), DesktopTypography = styled(Typography$2)(({ theme: e }) => ({
  [e.breakpoints.down("md")]: {
    display: "none"
  }
})), MobileTypography = styled(Typography$2)(({ theme: e }) => ({
  [e.breakpoints.up("md")]: {
    display: "none"
  }
})), RequestedSamples = ({
  title: e,
  promats: t,
  isSigned: o
}) => {
  const n = t.filter(
    (i) => !!i.requestedQuantity
  ), s = sortPromotionalMaterialGroup(
    n
  );
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(SamplesWrapper, { "data-testid": "requested-samples", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Title, { variant: "subtitle2", children: e }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(StyledCard, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledCardContent, { children: s.map((i, l) => /* @__PURE__ */ jsxRuntimeExports.jsxs(Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(SampleItem, { promotionalMaterial: i, isSigned: o }),
      l !== s.length - 1 && /* @__PURE__ */ jsxRuntimeExports.jsx(Divider, {})
    ] }, l)) }) })
  ] });
}, SamplesWrapper = styled(Stack)(({ theme: e }) => ({
  gap: e.spacing(2),
  flexGrow: 1
})), Title = styled(Typography$2)(({ theme: e }) => ({
  color: e.palette.text.secondary
})), StyledCard = styled(Card$1)({
  height: "100%",
  flexGrow: 1
}), StyledCardContent = styled(CardContent)(({ theme: e }) => ({
  display: "flex",
  flexDirection: "column",
  gap: e.spacing(2),
  padding: e.spacing(2)
})), SampleItem = ({
  promotionalMaterial: e,
  isSigned: t
}) => {
  const o = useTheme$4(), { t: n } = useTranslation(), { batches: s } = e, i = e.promotionalMaterial?.type, l = i === PromotionalMaterialTypeDataEnum.PRODUCT, d = e.requestedQuantity, u = `${n("components.interaction.available")}: ${e.requestedQuantity}/${e.maximumQuantityInCurrentPeriod}`;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(SampleItemWrapper, { "data-testid": "sample-item", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(SmallStack, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs(TitleLine, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          IconWrapper,
          {
            size: 20,
            backgroundColor: i === PromotionalMaterialTypeDataEnum.PRODUCT ? o.palette.info.dark : o.palette.error.light,
            children: /* @__PURE__ */ jsxRuntimeExports.jsx(IconContainer, { children: i === PromotionalMaterialTypeDataEnum.PRODUCT ? /* @__PURE__ */ jsxRuntimeExports.jsx(MedicationIcon, {}) : /* @__PURE__ */ jsxRuntimeExports.jsx(LibraryBooksIcon, {}) })
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Typography$2, { variant: "subtitle2", children: e.promotionalMaterial?.name })
      ] }),
      e.promotionalMaterial?.signatureRequired && /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        Label,
        {
          color: t ? "success" : "warning",
          "data-testid": "signature-label",
          children: n(t ? "components.interaction.signatureCollected" : "components.interaction.signatureRequired")
        }
      ) })
    ] }),
    s?.filter(
      (c) => c.physicalStock.requestedQuantity || c.virtualStock.requestedQuantity
    ).map((c, p) => /* @__PURE__ */ jsxRuntimeExports.jsx(PromotionalMaterialBatchInformation, { batch: c }, p)),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledBox$2, { children: [
      l && e.maximumQuantityInCurrentPeriod ? /* @__PURE__ */ jsxRuntimeExports.jsx(Label, { children: u }) : /* @__PURE__ */ jsxRuntimeExports.jsx(Box, {}),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Typography$2, { variant: "overline", children: `${n(
        "components.interaction.total"
      )}: ${d}` })
    ] })
  ] });
}, SampleItemWrapper = styled(Stack)(({ theme: e }) => ({
  gap: e.spacing(2)
})), SmallStack = styled(Stack)(({ theme: e }) => ({
  gap: e.spacing(1)
})), TitleLine = styled(Stack)(({ theme: e }) => ({
  alignItems: "center",
  flexDirection: "row",
  gap: e.spacing(1)
})), IconContainer = styled(Box)(({ theme: e }) => ({
  display: "flex",
  alignContent: "center",
  svg: {
    color: e.palette.common.white,
    fontSize: "12px"
  }
})), StyledBox$2 = styled(Box)({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "space-between"
}), SampleRequestPreview = ({ state: e }) => {
  const t = useRef(null);
  return useEffect(() => {
    const n = t.current?.contentWindow?.document;
    n && e?.step === "preview" && (n.open(), n.write(e.content ?? ""), n.close());
  }, [e]), /* @__PURE__ */ jsxRuntimeExports.jsx(Content, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    FormFrame,
    {
      ref: t,
      "data-testid": "sample-request-preview",
      id: "form-frame"
    }
  ) });
}, Content = styled(Box)({
  flexGrow: 1,
  height: "100%"
}), FormFrame = styled("iframe")(({ theme: e }) => ({
  backgroundColor: e.palette.common.white,
  border: "none",
  height: "100%",
  width: "100%"
})), AudioMutedIndicator = () => /* @__PURE__ */ jsxRuntimeExports.jsx(Wrapper$7, { "data-testid": "audio-muted", children: /* @__PURE__ */ jsxRuntimeExports.jsx(MutedIcon, {}) }), Wrapper$7 = styled(Box)(({ theme: e }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  position: "absolute",
  bottom: 8,
  left: 8,
  zIndex: 10,
  height: 24,
  width: 32,
  color: e.palette.error.main,
  borderRadius: typeof e.shape.borderRadius == "number" ? e.shape.borderRadius * 2 : Number(e.shape.borderRadius) * 2,
  background: alpha$1(e.palette.common.black, 0.48)
})), MutedIcon = styled(MicOffIcon)(() => ({
  fontSize: "1.25rem"
})), ColumnHeader = ({ title: e }) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  Header,
  {
    title: e,
    titleTypographyProps: {
      variant: "subtitle2"
    }
  }
), Header = styled(CardHeader)(({ theme: e }) => ({
  padding: 0,
  color: e.palette.text.secondary,
  [e.breakpoints.down("md")]: {
    display: "none"
  }
})), InteractionItemsColumn = ({
  children: e,
  testId: t,
  isSharing: o = !0,
  isHidden: n = !1,
  flex: s
}) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  Wrapper$6,
  {
    isSharing: o,
    isHidden: n,
    flexValue: s,
    "data-testid": t ?? "interaction-items-column",
    children: e
  }
), Wrapper$6 = styled(Box, {
  shouldForwardProp: (e) => e !== "isHidden" && e !== "isSharing" && e !== "flexValue"
})(({ theme: e, flexValue: t, isSharing: o, isHidden: n }) => ({
  display: n ? "none" : "flex",
  /**
   * For waiting room: Video "column" will have flex 2, Content "column" flex 1
   * For remote room: Video "column" will have 1, Content "column" flex 2
   */
  flex: t,
  height: "100%",
  overflow: "hidden",
  background: e.palette.common.white,
  padding: e.spacing(2),
  borderRadius: Number(e.shape.borderRadius) * 2,
  [e.breakpoints.down("md")]: {
    flex: n ? "none" : 1,
    height: o ? "100%" : "fit-content",
    borderRadius: 0,
    borderTopLeftRadius: e.shape.borderRadius,
    borderTopRightRadius: e.shape.borderRadius
  },
  [`@media only screen and (max-height: ${CUSTOM_BREAKPOINTS.MOBILE_LANDSCAPE_MAX_HEIGHT})`]: {
    borderRadius: 0,
    borderTopLeftRadius: Number(e.shape.borderRadius) * 2,
    borderBottomLeftRadius: o ? Number(e.shape.borderRadius) * 2 : 0,
    borderTopRightRadius: o ? 0 : Number(e.shape.borderRadius) * 2,
    overflow: "initial",
    maxHeight: "100%"
  }
})), PageContainer = ({ children: e }) => /* @__PURE__ */ jsxRuntimeExports.jsx(Container, { "data-testid": "remote-interaction-container", children: e }), Container = styled(Box)(({ theme: e }) => ({
  display: "flex",
  flexDirection: "column",
  gap: e.spacing(3),
  height: "100%",
  width: "100%",
  [e.breakpoints.down("md")]: {
    gap: "initial"
  },
  [`@media only screen and (max-height: ${CUSTOM_BREAKPOINTS.MOBILE_LANDSCAPE_MAX_HEIGHT})`]: {
    flexDirection: "row"
  }
})), ParticipantName = ({ name: e }) => /* @__PURE__ */ jsxRuntimeExports.jsx(Wrapper$5, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Typography$2, { noWrap: !0, variant: "body2", children: e }) }), Wrapper$5 = styled(Box)(({ theme: e }) => ({
  position: "absolute",
  left: 8,
  top: 8,
  padding: `0 ${e.spacing(1)}`,
  width: "fit-content",
  borderRadius: Number(e.shape.borderRadius) * 2,
  maxWidth: "75%",
  background: alpha$1(e.palette.common.black, 0.48),
  color: e.palette.common.white,
  fontSize: 12,
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  overflow: "hidden"
})), RoomContentWrapper = ({ children: e }) => /* @__PURE__ */ jsxRuntimeExports.jsx(Wrapper$4, { "data-testid": "room-content-wrapper", children: e }), Wrapper$4 = styled(Box)(({ theme: e }) => ({
  display: "flex",
  flexDirection: "row",
  gap: e.spacing(3),
  height: "100%",
  overflow: "hidden",
  [e.breakpoints.down("md")]: {
    background: e.palette.grey[800],
    flexDirection: "column",
    gap: "initial"
  },
  [`@media only screen and (max-height: ${CUSTOM_BREAKPOINTS.MOBILE_LANDSCAPE_MAX_HEIGHT})`]: {
    background: e.palette.grey[800],
    flexDirection: "column",
    width: "100%",
    gap: e.spacing(1),
    padding: e.spacing(1),
    paddingBottom: 0
  }
})), RoomHeaderWrapper = ({ children: e }) => /* @__PURE__ */ jsxRuntimeExports.jsx(Wrapper$3, { "data-testid": "room-header-wrapper", children: e }), Wrapper$3 = styled(Box)(({ theme: e }) => ({
  [e.breakpoints.down("md")]: {
    display: "none"
  },
  [`@media only screen and (max-height: ${CUSTOM_BREAKPOINTS.MOBILE_LANDSCAPE_MAX_HEIGHT})`]: {
    display: "none"
  }
})), VideoControlsWrapper = ({
  children: e
}) => useMediaQuery$1(
  `@media only screen and (max-height: ${CUSTOM_BREAKPOINTS.MOBILE_LANDSCAPE_MAX_HEIGHT})`
) ? /* @__PURE__ */ jsxRuntimeExports.jsx(Wrapper$2, { "data-testid": "video-controls-wrapper", children: e }) : null, Wrapper$2 = styled(Box)(({ theme: e }) => ({
  display: "flex",
  height: "100%",
  width: REMOTE_INTERACTION.MOBILE.AUDIO_VIDEO_CONTROLS_WIDTH_LANDSCAPE,
  background: e.palette.grey[800]
})), ResetButton = ({
  disableButton: e = !1,
  color: t,
  onClick: o,
  testId: n = "reset-button"
}) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  RestartButton,
  {
    "data-testid": n,
    disabled: e,
    variant: "outlined",
    size: "small",
    color: t,
    onClick: o,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(RestartAltIcon, {})
  }
), RestartButton = styled(Button$5)(({ theme: e }) => ({
  padding: e.spacing(0.5),
  minWidth: 36
})), RoundButton = ({
  variant: e,
  size: t,
  inactive: o = !1,
  disabled: n = !1,
  onClick: s,
  children: i,
  testId: l
}) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  Button$1,
  {
    size: t,
    variant: e,
    inactive: o,
    disabled: n,
    "data-testid": l,
    onClick: s,
    children: i
  }
), getButtonColor = (e, t) => e === "primary" ? t.palette.primary.main : e === "danger" ? t.palette.error.main : alpha$1(t.palette.common.white, 0.16), getButtonHoverColor = (e, t) => e === "primary" ? t.palette.primary.dark : e === "danger" ? t.palette.error.dark : alpha$1(t.palette.common.white, 0.12), Button$1 = styled(IconButton$1, {
  shouldForwardProp: (e) => !(e === "inactive" || e === "variant")
})(({ theme: e, inactive: t, disabled: o, variant: n }) => ({
  svg: {
    color: o ? e.palette.action.disabled : e.palette.common.white
  },
  background: t ? e.palette.error.main : getButtonColor(n, e),
  "&:hover": {
    background: t ? e.palette.error.main : getButtonHoverColor(n, e)
  },
  "&:disabled": {
    background: e.palette.action.disabledBackground
  }
})), SearchTextField = ({
  testId: e,
  placeholder: t,
  clearButtonText: o,
  searchQuery: n,
  onClearSearchQuery: s,
  onChangeSearchQuery: i
}) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  SearchInputField,
  {
    "data-testid": e,
    autoComplete: "off",
    size: "small",
    fullWidth: !0,
    placeholder: t,
    value: n,
    InputProps: {
      startAdornment: /* @__PURE__ */ jsxRuntimeExports.jsx(InputAdornment$1, { position: "start", children: /* @__PURE__ */ jsxRuntimeExports.jsx(Search, {}) }),
      endAdornment: n && /* @__PURE__ */ jsxRuntimeExports.jsx(InputAdornment$1, { position: "end", children: /* @__PURE__ */ jsxRuntimeExports.jsx(ClearButton$1, { variant: "text", onClick: s, children: o }) })
    },
    onChange: i
  }
), SearchInputField = styled(TextField$1)({
  width: "100%"
}), ClearButton$1 = styled(Button$5)(({ theme: e }) => ({
  textTransform: "uppercase",
  color: e.palette.text.disabled
})), MultiLineSingleSelect = ({
  availableOptions: e,
  selectedOption: t,
  label: o,
  onSelect: n,
  disable: s
}) => {
  const i = useTheme$4(), l = (d, u) => /* @__PURE__ */ jsxRuntimeExports.jsx(ParentStack, { children: d?.data.map((c, p) => /* @__PURE__ */ jsxRuntimeExports.jsx(Stack, { children: (p === 0 ? u : !0) && /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledBox$1, { children: [
    c.icon && /* @__PURE__ */ jsxRuntimeExports.jsx(IconWrapper, { size: 20, children: c.icon }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Typography$2,
      {
        variant: "caption",
        color: c.textColor ?? i.palette.text.primary,
        children: c.content
      }
    )
  ] }) }, p)) });
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Autocomplete$1,
      {
        fullWidth: !0,
        disableClearable: !0,
        disabled: s,
        "data-testid": "multi-line-select",
        noOptionsText: "No search result",
        options: e,
        getOptionLabel: (d) => d?.data[0]?.content,
        value: t,
        isOptionEqualToValue: (d, u) => d?.oid === u?.oid,
        renderOption: (d, u) => /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { component: "li", ...d, children: l(u, !0) }),
        renderInput: (d) => {
          const { InputProps: u, ...c } = d;
          return /* @__PURE__ */ jsxRuntimeExports.jsx(TextField$1, { ...c, label: o, InputProps: u });
        },
        onChange: n
      }
    ),
    t && l(t, !1)
  ] });
}, ParentStack = styled(Stack)(({ theme: e }) => ({
  gap: e.spacing(1)
})), StyledBox$1 = styled(Box)(({ theme: e }) => ({
  display: "flex",
  gap: e.spacing(1),
  alignItems: "center"
})), SettingsButton = ({
  disableButton: e = !1,
  color: t,
  onClick: o,
  testId: n = "filter-setting-button"
}) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  SettingButton,
  {
    "data-testid": n,
    disabled: e,
    variant: "outlined",
    size: "small",
    color: t,
    onClick: o,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(SettingsIcon, {})
  }
), SettingButton = styled(Button$5)(({ theme: e }) => ({
  padding: e.spacing(0.5),
  minWidth: 36
}));
var build$3 = { exports: {} };
function Point(e, t, o) {
  this.x = e, this.y = t, this.time = o || (/* @__PURE__ */ new Date()).getTime();
}
Point.prototype.velocityFrom = function(e) {
  return this.time !== e.time ? this.distanceTo(e) / (this.time - e.time) : 1;
};
Point.prototype.distanceTo = function(e) {
  return Math.sqrt(Math.pow(this.x - e.x, 2) + Math.pow(this.y - e.y, 2));
};
Point.prototype.equals = function(e) {
  return this.x === e.x && this.y === e.y && this.time === e.time;
};
function Bezier(e, t, o, n) {
  this.startPoint = e, this.control1 = t, this.control2 = o, this.endPoint = n;
}
Bezier.prototype.length = function() {
  for (var e = 10, t = 0, o = void 0, n = void 0, s = 0; s <= e; s += 1) {
    var i = s / e, l = this._point(i, this.startPoint.x, this.control1.x, this.control2.x, this.endPoint.x), d = this._point(i, this.startPoint.y, this.control1.y, this.control2.y, this.endPoint.y);
    if (s > 0) {
      var u = l - o, c = d - n;
      t += Math.sqrt(u * u + c * c);
    }
    o = l, n = d;
  }
  return t;
};
Bezier.prototype._point = function(e, t, o, n, s) {
  return t * (1 - e) * (1 - e) * (1 - e) + 3 * o * (1 - e) * (1 - e) * e + 3 * n * (1 - e) * e * e + s * e * e * e;
};
function throttle(e, t, o) {
  var n, s, i, l = null, d = 0;
  o || (o = {});
  var u = function() {
    d = o.leading === !1 ? 0 : Date.now(), l = null, i = e.apply(n, s), l || (n = s = null);
  };
  return function() {
    var c = Date.now();
    !d && o.leading === !1 && (d = c);
    var p = t - (c - d);
    return n = this, s = arguments, p <= 0 || p > t ? (l && (clearTimeout(l), l = null), d = c, i = e.apply(n, s), l || (n = s = null)) : !l && o.trailing !== !1 && (l = setTimeout(u, p)), i;
  };
}
function SignaturePad$1(e, t) {
  var o = this, n = t || {};
  this.velocityFilterWeight = n.velocityFilterWeight || 0.7, this.minWidth = n.minWidth || 0.5, this.maxWidth = n.maxWidth || 2.5, this.throttle = "throttle" in n ? n.throttle : 16, this.minDistance = "minDistance" in n ? n.minDistance : 5, this.throttle ? this._strokeMoveUpdate = throttle(SignaturePad$1.prototype._strokeUpdate, this.throttle) : this._strokeMoveUpdate = SignaturePad$1.prototype._strokeUpdate, this.dotSize = n.dotSize || function() {
    return (this.minWidth + this.maxWidth) / 2;
  }, this.penColor = n.penColor || "black", this.backgroundColor = n.backgroundColor || "rgba(0,0,0,0)", this.onBegin = n.onBegin, this.onEnd = n.onEnd, this._canvas = e, this._ctx = e.getContext("2d"), this.clear(), this._handleMouseDown = function(s) {
    s.which === 1 && (o._mouseButtonDown = !0, o._strokeBegin(s));
  }, this._handleMouseMove = function(s) {
    o._mouseButtonDown && o._strokeMoveUpdate(s);
  }, this._handleMouseUp = function(s) {
    s.which === 1 && o._mouseButtonDown && (o._mouseButtonDown = !1, o._strokeEnd(s));
  }, this._handleTouchStart = function(s) {
    if (s.targetTouches.length === 1) {
      var i = s.changedTouches[0];
      o._strokeBegin(i);
    }
  }, this._handleTouchMove = function(s) {
    s.preventDefault();
    var i = s.targetTouches[0];
    o._strokeMoveUpdate(i);
  }, this._handleTouchEnd = function(s) {
    var i = s.target === o._canvas;
    i && (s.preventDefault(), o._strokeEnd(s));
  }, this.on();
}
SignaturePad$1.prototype.clear = function() {
  var e = this._ctx, t = this._canvas;
  e.fillStyle = this.backgroundColor, e.clearRect(0, 0, t.width, t.height), e.fillRect(0, 0, t.width, t.height), this._data = [], this._reset(), this._isEmpty = !0;
};
SignaturePad$1.prototype.fromDataURL = function(e) {
  var t = this, o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = new Image(), s = o.ratio || window.devicePixelRatio || 1, i = o.width || this._canvas.width / s, l = o.height || this._canvas.height / s;
  this._reset(), n.src = e, n.onload = function() {
    t._ctx.drawImage(n, 0, 0, i, l);
  }, this._isEmpty = !1;
};
SignaturePad$1.prototype.toDataURL = function(e) {
  var t;
  switch (e) {
    case "image/svg+xml":
      return this._toSVG();
    default:
      for (var o = arguments.length, n = Array(o > 1 ? o - 1 : 0), s = 1; s < o; s++)
        n[s - 1] = arguments[s];
      return (t = this._canvas).toDataURL.apply(t, [e].concat(n));
  }
};
SignaturePad$1.prototype.on = function() {
  this._handleMouseEvents(), this._handleTouchEvents();
};
SignaturePad$1.prototype.off = function() {
  this._canvas.removeEventListener("mousedown", this._handleMouseDown), this._canvas.removeEventListener("mousemove", this._handleMouseMove), document.removeEventListener("mouseup", this._handleMouseUp), this._canvas.removeEventListener("touchstart", this._handleTouchStart), this._canvas.removeEventListener("touchmove", this._handleTouchMove), this._canvas.removeEventListener("touchend", this._handleTouchEnd);
};
SignaturePad$1.prototype.isEmpty = function() {
  return this._isEmpty;
};
SignaturePad$1.prototype._strokeBegin = function(e) {
  this._data.push([]), this._reset(), this._strokeUpdate(e), typeof this.onBegin == "function" && this.onBegin(e);
};
SignaturePad$1.prototype._strokeUpdate = function(e) {
  var t = e.clientX, o = e.clientY, n = this._createPoint(t, o), s = this._data[this._data.length - 1], i = s && s[s.length - 1], l = i && n.distanceTo(i) < this.minDistance;
  if (!(i && l)) {
    var d = this._addPoint(n), u = d.curve, c = d.widths;
    u && c && this._drawCurve(u, c.start, c.end), this._data[this._data.length - 1].push({
      x: n.x,
      y: n.y,
      time: n.time,
      color: this.penColor
    });
  }
};
SignaturePad$1.prototype._strokeEnd = function(e) {
  var t = this.points.length > 2, o = this.points[0];
  if (!t && o && this._drawDot(o), o) {
    var n = this._data[this._data.length - 1], s = n[n.length - 1];
    o.equals(s) || n.push({
      x: o.x,
      y: o.y,
      time: o.time,
      color: this.penColor
    });
  }
  typeof this.onEnd == "function" && this.onEnd(e);
};
SignaturePad$1.prototype._handleMouseEvents = function() {
  this._mouseButtonDown = !1, this._canvas.addEventListener("mousedown", this._handleMouseDown), this._canvas.addEventListener("mousemove", this._handleMouseMove), document.addEventListener("mouseup", this._handleMouseUp);
};
SignaturePad$1.prototype._handleTouchEvents = function() {
  this._canvas.style.msTouchAction = "none", this._canvas.style.touchAction = "none", this._canvas.addEventListener("touchstart", this._handleTouchStart), this._canvas.addEventListener("touchmove", this._handleTouchMove), this._canvas.addEventListener("touchend", this._handleTouchEnd);
};
SignaturePad$1.prototype._reset = function() {
  this.points = [], this._lastVelocity = 0, this._lastWidth = (this.minWidth + this.maxWidth) / 2, this._ctx.fillStyle = this.penColor;
};
SignaturePad$1.prototype._createPoint = function(e, t, o) {
  var n = this._canvas.getBoundingClientRect();
  return new Point(e - n.left, t - n.top, o || (/* @__PURE__ */ new Date()).getTime());
};
SignaturePad$1.prototype._addPoint = function(e) {
  var t = this.points, o = void 0;
  if (t.push(e), t.length > 2) {
    t.length === 3 && t.unshift(t[0]), o = this._calculateCurveControlPoints(t[0], t[1], t[2]);
    var n = o.c2;
    o = this._calculateCurveControlPoints(t[1], t[2], t[3]);
    var s = o.c1, i = new Bezier(t[1], n, s, t[2]), l = this._calculateCurveWidths(i);
    return t.shift(), { curve: i, widths: l };
  }
  return {};
};
SignaturePad$1.prototype._calculateCurveControlPoints = function(e, t, o) {
  var n = e.x - t.x, s = e.y - t.y, i = t.x - o.x, l = t.y - o.y, d = { x: (e.x + t.x) / 2, y: (e.y + t.y) / 2 }, u = { x: (t.x + o.x) / 2, y: (t.y + o.y) / 2 }, c = Math.sqrt(n * n + s * s), p = Math.sqrt(i * i + l * l), f = d.x - u.x, g = d.y - u.y, y = p / (c + p), h = { x: u.x + f * y, y: u.y + g * y }, T = t.x - h.x, P = t.y - h.y;
  return {
    c1: new Point(d.x + T, d.y + P),
    c2: new Point(u.x + T, u.y + P)
  };
};
SignaturePad$1.prototype._calculateCurveWidths = function(e) {
  var t = e.startPoint, o = e.endPoint, n = { start: null, end: null }, s = this.velocityFilterWeight * o.velocityFrom(t) + (1 - this.velocityFilterWeight) * this._lastVelocity, i = this._strokeWidth(s);
  return n.start = this._lastWidth, n.end = i, this._lastVelocity = s, this._lastWidth = i, n;
};
SignaturePad$1.prototype._strokeWidth = function(e) {
  return Math.max(this.maxWidth / (e + 1), this.minWidth);
};
SignaturePad$1.prototype._drawPoint = function(e, t, o) {
  var n = this._ctx;
  n.moveTo(e, t), n.arc(e, t, o, 0, 2 * Math.PI, !1), this._isEmpty = !1;
};
SignaturePad$1.prototype._drawCurve = function(e, t, o) {
  var n = this._ctx, s = o - t, i = Math.floor(e.length());
  n.beginPath();
  for (var l = 0; l < i; l += 1) {
    var d = l / i, u = d * d, c = u * d, p = 1 - d, f = p * p, g = f * p, y = g * e.startPoint.x;
    y += 3 * f * d * e.control1.x, y += 3 * p * u * e.control2.x, y += c * e.endPoint.x;
    var h = g * e.startPoint.y;
    h += 3 * f * d * e.control1.y, h += 3 * p * u * e.control2.y, h += c * e.endPoint.y;
    var T = t + c * s;
    this._drawPoint(y, h, T);
  }
  n.closePath(), n.fill();
};
SignaturePad$1.prototype._drawDot = function(e) {
  var t = this._ctx, o = typeof this.dotSize == "function" ? this.dotSize() : this.dotSize;
  t.beginPath(), this._drawPoint(e.x, e.y, o), t.closePath(), t.fill();
};
SignaturePad$1.prototype._fromData = function(e, t, o) {
  for (var n = 0; n < e.length; n += 1) {
    var s = e[n];
    if (s.length > 1)
      for (var i = 0; i < s.length; i += 1) {
        var l = s[i], d = new Point(l.x, l.y, l.time), u = l.color;
        if (i === 0)
          this.penColor = u, this._reset(), this._addPoint(d);
        else if (i !== s.length - 1) {
          var c = this._addPoint(d), p = c.curve, f = c.widths;
          p && f && t(p, f, u);
        }
      }
    else {
      this._reset();
      var g = s[0];
      o(g);
    }
  }
};
SignaturePad$1.prototype._toSVG = function() {
  var e = this, t = this._data, o = this._canvas, n = Math.max(window.devicePixelRatio || 1, 1), s = 0, i = 0, l = o.width / n, d = o.height / n, u = document.createElementNS("http://www.w3.org/2000/svg", "svg");
  u.setAttributeNS(null, "width", o.width), u.setAttributeNS(null, "height", o.height), this._fromData(t, function(E, $, R) {
    var C = document.createElement("path");
    if (!isNaN(E.control1.x) && !isNaN(E.control1.y) && !isNaN(E.control2.x) && !isNaN(E.control2.y)) {
      var x = "M " + E.startPoint.x.toFixed(3) + "," + E.startPoint.y.toFixed(3) + " " + ("C " + E.control1.x.toFixed(3) + "," + E.control1.y.toFixed(3) + " ") + (E.control2.x.toFixed(3) + "," + E.control2.y.toFixed(3) + " ") + (E.endPoint.x.toFixed(3) + "," + E.endPoint.y.toFixed(3));
      C.setAttribute("d", x), C.setAttribute("stroke-width", ($.end * 2.25).toFixed(3)), C.setAttribute("stroke", R), C.setAttribute("fill", "none"), C.setAttribute("stroke-linecap", "round"), u.appendChild(C);
    }
  }, function(E) {
    var $ = document.createElement("circle"), R = typeof e.dotSize == "function" ? e.dotSize() : e.dotSize;
    $.setAttribute("r", R), $.setAttribute("cx", E.x), $.setAttribute("cy", E.y), $.setAttribute("fill", E.color), u.appendChild($);
  });
  var c = "data:image/svg+xml;base64,", p = '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"' + (' viewBox="' + s + " " + i + " " + l + " " + d + '"') + (' width="' + l + '"') + (' height="' + d + '"') + ">", f = u.innerHTML;
  if (f === void 0) {
    var g = document.createElement("dummy"), y = u.childNodes;
    g.innerHTML = "";
    for (var h = 0; h < y.length; h += 1)
      g.appendChild(y[h].cloneNode(!0));
    f = g.innerHTML;
  }
  var T = "</svg>", P = p + f + T;
  return c + btoa(P);
};
SignaturePad$1.prototype.fromData = function(e) {
  var t = this;
  this.clear(), this._fromData(e, function(o, n) {
    return t._drawCurve(o, n.start, n.end);
  }, function(o) {
    return t._drawDot(o);
  }), this._data = e;
};
SignaturePad$1.prototype.toData = function() {
  return this._data;
};
const signature_pad = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: SignaturePad$1
}, Symbol.toStringTag, { value: "Module" })), require$$2 = /* @__PURE__ */ getAugmentedNamespace(signature_pad);
var build$2 = { exports: {} }, build$1 = build$2.exports, hasRequiredBuild$1;
function requireBuild$1() {
  return hasRequiredBuild$1 || (hasRequiredBuild$1 = 1, (function(e, t) {
    (function(o, n) {
      e.exports = n();
    })(build$1, function() {
      return (function(o) {
        function n(i) {
          if (s[i]) return s[i].exports;
          var l = s[i] = { exports: {}, id: i, loaded: !1 };
          return o[i].call(l.exports, l, l.exports, n), l.loaded = !0, l.exports;
        }
        var s = {};
        return n.m = o, n.c = s, n.p = "", n(0);
      })([function(o, n) {
        function s(c) {
          var p = c.getContext("2d"), f = c.width, g = c.height, y = p.getImageData(0, 0, f, g).data, h = d(!0, f, g, y), T = d(!1, f, g, y), P = u(!0, f, g, y), E = u(!1, f, g, y), $ = E - P + 1, R = T - h + 1, C = p.getImageData(P, h, $, R);
          return c.width = $, c.height = R, p.clearRect(0, 0, $, R), p.putImageData(C, 0, 0), c;
        }
        function i(c, p, f, g) {
          return { red: g[4 * (f * p + c)], green: g[4 * (f * p + c) + 1], blue: g[4 * (f * p + c) + 2], alpha: g[4 * (f * p + c) + 3] };
        }
        function l(c, p, f, g) {
          return i(c, p, f, g).alpha;
        }
        function d(c, p, f, g) {
          for (var y = c ? 1 : -1, h = c ? 0 : f - 1, T = h; c ? T < f : T > -1; T += y) for (var P = 0; P < p; P++) if (l(P, T, p, g)) return T;
          return null;
        }
        function u(c, p, f, g) {
          for (var y = c ? 1 : -1, h = c ? 0 : p - 1, T = h; c ? T < p : T > -1; T += y) for (var P = 0; P < f; P++) if (l(T, P, p, g)) return T;
          return null;
        }
        Object.defineProperty(n, "__esModule", { value: !0 }), n.default = s;
      }]);
    });
  })(build$2)), build$2.exports;
}
var build = build$3.exports, hasRequiredBuild;
function requireBuild() {
  return hasRequiredBuild || (hasRequiredBuild = 1, (function(e, t) {
    (function(o, n) {
      e.exports = n(/* @__PURE__ */ requirePropTypes(), React__default, require$$2, requireBuild$1());
    })(build, function(o, n, s, i) {
      return (function(l) {
        function d(c) {
          if (u[c]) return u[c].exports;
          var p = u[c] = { exports: {}, id: c, loaded: !1 };
          return l[c].call(p.exports, p, p.exports, d), p.loaded = !0, p.exports;
        }
        var u = {};
        return d.m = l, d.c = u, d.p = "", d(0);
      })([function(l, d, u) {
        function c(v) {
          return v && v.__esModule ? v : { default: v };
        }
        function p(v, w) {
          var M = {};
          for (var S in v) w.indexOf(S) >= 0 || Object.prototype.hasOwnProperty.call(v, S) && (M[S] = v[S]);
          return M;
        }
        function f(v, w) {
          if (!(v instanceof w)) throw new TypeError("Cannot call a class as a function");
        }
        function g(v, w) {
          if (!v) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !w || typeof w != "object" && typeof w != "function" ? v : w;
        }
        function y(v, w) {
          if (typeof w != "function" && w !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof w);
          v.prototype = Object.create(w && w.prototype, { constructor: { value: v, enumerable: !1, writable: !0, configurable: !0 } }), w && (Object.setPrototypeOf ? Object.setPrototypeOf(v, w) : v.__proto__ = w);
        }
        Object.defineProperty(d, "__esModule", { value: !0 });
        var h = Object.assign || function(v) {
          for (var w = 1; w < arguments.length; w++) {
            var M = arguments[w];
            for (var S in M) Object.prototype.hasOwnProperty.call(M, S) && (v[S] = M[S]);
          }
          return v;
        }, T = /* @__PURE__ */ (function() {
          function v(w, M) {
            for (var S = 0; S < M.length; S++) {
              var I = M[S];
              I.enumerable = I.enumerable || !1, I.configurable = !0, "value" in I && (I.writable = !0), Object.defineProperty(w, I.key, I);
            }
          }
          return function(w, M, S) {
            return M && v(w.prototype, M), S && v(w, S), w;
          };
        })(), P = u(1), E = c(P), $ = u(2), R = c($), C = u(3), x = c(C), _ = u(4), D = c(_), O = (function(v) {
          function w() {
            var M, S, I, N;
            f(this, w);
            for (var F = arguments.length, L = Array(F), k = 0; k < F; k++) L[k] = arguments[k];
            return S = I = g(this, (M = w.__proto__ || Object.getPrototypeOf(w)).call.apply(M, [this].concat(L))), I._sigPad = null, I._excludeOurProps = function() {
              var W = I.props, V = (W.canvasProps, W.clearOnResize, p(W, ["canvasProps", "clearOnResize"]));
              return V;
            }, I.getCanvas = function() {
              return I._canvas;
            }, I.getTrimmedCanvas = function() {
              var W = document.createElement("canvas");
              return W.width = I._canvas.width, W.height = I._canvas.height, W.getContext("2d").drawImage(I._canvas, 0, 0), (0, D.default)(W);
            }, I.getSignaturePad = function() {
              return I._sigPad;
            }, I._checkClearOnResize = function() {
              I.props.clearOnResize && I._resizeCanvas();
            }, I._resizeCanvas = function() {
              var W = I.props.canvasProps || {}, V = W.width, j = W.height;
              if (!V || !j) {
                var A = I._canvas, U = Math.max(window.devicePixelRatio || 1, 1);
                V || (A.width = A.offsetWidth * U), j || (A.height = A.offsetHeight * U), A.getContext("2d").scale(U, U), I.clear();
              }
            }, I.on = function() {
              return window.addEventListener("resize", I._checkClearOnResize), I._sigPad.on();
            }, I.off = function() {
              return window.removeEventListener("resize", I._checkClearOnResize), I._sigPad.off();
            }, I.clear = function() {
              return I._sigPad.clear();
            }, I.isEmpty = function() {
              return I._sigPad.isEmpty();
            }, I.fromDataURL = function(W, V) {
              return I._sigPad.fromDataURL(W, V);
            }, I.toDataURL = function(W, V) {
              return I._sigPad.toDataURL(W, V);
            }, I.fromData = function(W) {
              return I._sigPad.fromData(W);
            }, I.toData = function() {
              return I._sigPad.toData();
            }, N = S, g(I, N);
          }
          return y(w, v), T(w, [{ key: "componentDidMount", value: function() {
            this._sigPad = new x.default(this._canvas, this._excludeOurProps()), this._resizeCanvas(), this.on();
          } }, { key: "componentWillUnmount", value: function() {
            this.off();
          } }, { key: "componentDidUpdate", value: function() {
            Object.assign(this._sigPad, this._excludeOurProps());
          } }, { key: "render", value: function() {
            var M = this, S = this.props.canvasProps;
            return R.default.createElement("canvas", h({ ref: function(I) {
              M._canvas = I;
            } }, S));
          } }]), w;
        })($.Component);
        O.propTypes = { velocityFilterWeight: E.default.number, minWidth: E.default.number, maxWidth: E.default.number, minDistance: E.default.number, dotSize: E.default.oneOfType([E.default.number, E.default.func]), penColor: E.default.string, throttle: E.default.number, onEnd: E.default.func, onBegin: E.default.func, canvasProps: E.default.object, clearOnResize: E.default.bool }, O.defaultProps = { clearOnResize: !0 }, d.default = O;
      }, function(l, d) {
        l.exports = o;
      }, function(l, d) {
        l.exports = n;
      }, function(l, d) {
        l.exports = s;
      }, function(l, d) {
        l.exports = i;
      }]);
    });
  })(build$3)), build$3.exports;
}
var buildExports = requireBuild();
const SignaturePad = /* @__PURE__ */ getDefaultExportFromCjs(buildExports), SignatureBox = ({
  onChangeSignature: e,
  signature: t,
  isClearable: o,
  disable: n,
  signatureLabel: s,
  mandatory: i,
  clearLabel: l,
  errorLabel: d
}) => {
  const { formatLocalizedDate: u } = useFormatDate(), [c, p] = useState(!1), [f, g] = useState(!1), y = useRef(null), h = () => {
    y?.current && (p(!0), countNumberOfDataPoints(
      y.current.toData()
    ) < 20 ? g(!0) : (g(!1), e?.(
      y.current.getCanvas().toDataURL("image/png")
    )));
  }, T = () => {
    o && (y.current?.clear?.(), e?.(""), g(!1), p(!1));
  };
  return useEffect(() => {
    t ? y.current?.fromDataURL(t) : y.current?.clear?.();
  }, [t]), useEffect(() => {
    n && y.current?.off();
  }, [n]), /* @__PURE__ */ jsxRuntimeExports.jsxs(SignatureBoxWrapper, { "data-testid": "signature-pad-wrapper", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(StyledBox, { isSignatureTooShort: f, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs(SignatureLabelBox, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          SignatureLabel,
          {
            variant: "caption",
            isSignatureTooShort: f,
            children: s
          }
        ),
        i && /* @__PURE__ */ jsxRuntimeExports.jsx(AsteriskField, { variant: "caption", children: " *" })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        SignaturePad,
        {
          ref: y,
          clearOnResize: !1,
          onEnd: h
        }
      ),
      c && o && /* @__PURE__ */ jsxRuntimeExports.jsx(
        ClearButton,
        {
          variant: "text",
          startIcon: /* @__PURE__ */ jsxRuntimeExports.jsx(ClearIcon, {}),
          onClick: T,
          children: l
        }
      )
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ErrorMessage, { variant: "caption", isSignatureTooShort: f, children: d }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Typography$2, { variant: "subtitle2", children: u(/* @__PURE__ */ new Date()) })
  ] });
}, SignatureBoxWrapper = styled(Stack)(({ theme: e }) => ({
  gap: e.spacing(1),
  height: "100%",
  canvas: {
    width: "100%",
    height: 200
  },
  [e.breakpoints.down("md")]: {
    canvas: {
      height: 120
    }
  }
})), StyledBox = styled(Box, {
  shouldForwardProp: (e) => e !== "isSignatureTooShort"
})(({ theme: e, isSignatureTooShort: t }) => ({
  position: "relative",
  border: "1px solid",
  borderRadius: e.shape.borderRadius,
  borderColor: t ? e.palette.error.main : e.palette.grey[300]
})), SignatureLabelBox = styled(Box)(({ theme: e }) => ({
  display: "flex",
  alignItems: "center",
  position: "absolute",
  top: 0,
  left: e.spacing(1),
  background: e.palette.common.white,
  transform: "translate(0, -50%)",
  padding: `0 ${e.spacing(0.5)}`
})), SignatureLabel = styled(Typography$2, {
  shouldForwardProp: (e) => e !== "isSignatureTooShort"
})(({ theme: e, isSignatureTooShort: t }) => ({
  color: t ? e.palette.error.main : e.palette.text.disabled
})), AsteriskField = styled(Typography$2)(({ theme: e }) => ({
  color: e.palette.error.main
})), ClearButton = styled(Button$5)(({ theme: e }) => ({
  position: "absolute",
  bottom: e.spacing(1),
  right: e.spacing(1),
  textTransform: "uppercase"
})), ClearIcon = styled(Close)({
  height: 18,
  width: 18
}), ErrorMessage = styled(Typography$2, {
  shouldForwardProp: (e) => e !== "isSignatureTooShort"
})(({ theme: e, isSignatureTooShort: t }) => ({
  visibility: t ? "visible" : "hidden",
  color: e.palette.error.main
})), SquareButton = ({
  children: e,
  disabled: t = !1,
  handleClick: o,
  testId: n = "",
  variant: s = "primary",
  buttonSize: i = 45,
  ...l
}) => /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { ...l, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
  Button,
  {
    variant: s,
    disabled: t,
    "data-testid": n,
    buttonSize: i,
    onClick: o,
    children: e
  }
) }) }), getBackgroundColor = ({
  variant: e,
  theme: t,
  isHover: o
}) => e === "outlined" ? "transparent" : e === "primary" ? o ? t.palette.primary.dark : t.palette.primary.main : e === "secondary" ? alpha$2(t.palette.grey[500], o ? 0.48 : 0.24) : "none", Button = styled(IconButtonAnimate, {
  shouldForwardProp: (e) => !(e === "buttonSize" || e === "variant" || e === "outlined")
})(({ variant: e, theme: t, buttonSize: o }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: o,
  height: o,
  cursor: "pointer",
  borderRadius: t.shape.borderRadius,
  border: e === "outlined" ? `1px solid ${t.palette.primary.main}` : "none",
  color: e === "outlined" ? t.palette.primary.main : t.palette.common.white,
  backgroundColor: getBackgroundColor({
    variant: e,
    theme: t,
    isHover: !1
  }),
  "&:hover": {
    backgroundColor: getBackgroundColor({
      variant: e,
      theme: t,
      isHover: !0
    })
  },
  "&:disabled": {
    opacity: 0.12,
    backgroundColor: t.palette.grey[500]
  }
})), TabPanel = (e) => {
  const { children: t, value: o, index: n, ...s } = e;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      "data-testid": `tab-panel-${n}`,
      role: "tabpanel",
      hidden: o !== n,
      id: `tab-panel-${n}`,
      "aria-labelledby": `tab-${n}`,
      ...s,
      children: o === n && t
    }
  );
}, TabsPanel = ({ tabs: e, testId: t = "tabs-panel" }) => {
  const [o, n] = useState(0), s = (i, l) => {
    n(l);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Box, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Tabs$1, { value: o, "data-testid": t, onChange: s, children: e.filter(({ visible: i }) => i).map(({ index: i, label: l }) => /* @__PURE__ */ jsxRuntimeExports.jsx(Tab, { label: l }, i)) }),
    e.filter(({ visible: i }) => i).map(({ index: i, children: l }) => /* @__PURE__ */ jsxRuntimeExports.jsx(TabPanel, { value: o, index: i, children: l }, i))
  ] });
};
var main = { exports: {} }, hasRequiredMain;
function requireMain() {
  return hasRequiredMain || (hasRequiredMain = 1, (function(e) {
    e.exports = /******/
    (function(t) {
      var o = {};
      function n(s) {
        if (o[s])
          return o[s].exports;
        var i = o[s] = {
          /******/
          exports: {},
          /******/
          id: s,
          /******/
          loaded: !1
          /******/
        };
        return t[s].call(i.exports, i, i.exports, n), i.loaded = !0, i.exports;
      }
      return n.m = t, n.c = o, n.p = "", n(0);
    })([
      /* 0 */
      /***/
      (function(t, o, n) {
        t.exports = n(1);
      }),
      /* 1 */
      /***/
      (function(t, o, n) {
        Object.defineProperty(o, "__esModule", {
          value: !0
        });
        function s(d) {
          return d && d.__esModule ? d : { default: d };
        }
        var i = n(2), l = s(i);
        o.default = l.default, t.exports = o.default;
      }),
      /* 2 */
      /***/
      (function(t, o, n) {
        Object.defineProperty(o, "__esModule", {
          value: !0
        });
        var s = Object.assign || function(g) {
          for (var y = 1; y < arguments.length; y++) {
            var h = arguments[y];
            for (var T in h)
              Object.prototype.hasOwnProperty.call(h, T) && (g[T] = h[T]);
          }
          return g;
        };
        o.default = f;
        function i(g) {
          return g && g.__esModule ? g : { default: g };
        }
        function l(g, y) {
          var h = {};
          for (var T in g)
            y.indexOf(T) >= 0 || Object.prototype.hasOwnProperty.call(g, T) && (h[T] = g[T]);
          return h;
        }
        var d = n(3), u = n(4), c = n(5), p = i(c);
        function f(g) {
          var y = g.activeClassName, h = y === void 0 ? "" : y, T = g.activeIndex, P = T === void 0 ? -1 : T, E = g.activeStyle, $ = g.autoEscape, R = g.caseSensitive, C = R === void 0 ? !1 : R, x = g.className, _ = g.findChunks, D = g.highlightClassName, O = D === void 0 ? "" : D, v = g.highlightStyle, w = v === void 0 ? {} : v, M = g.highlightTag, S = M === void 0 ? "mark" : M, I = g.sanitize, N = g.searchWords, F = g.textToHighlight, L = g.unhighlightTag, k = L === void 0 ? "span" : L, W = g.unhighlightClassName, V = W === void 0 ? "" : W, j = g.unhighlightStyle, A = l(g, ["activeClassName", "activeIndex", "activeStyle", "autoEscape", "caseSensitive", "className", "findChunks", "highlightClassName", "highlightStyle", "highlightTag", "sanitize", "searchWords", "textToHighlight", "unhighlightTag", "unhighlightClassName", "unhighlightStyle"]), U = (0, d.findAll)({
            autoEscape: $,
            caseSensitive: C,
            findChunks: _,
            sanitize: I,
            searchWords: N,
            textToHighlight: F
          }), G = S, Y = -1, ee = "", J = void 0, Z = function(K) {
            var q = {};
            for (var B in K)
              q[B.toLowerCase()] = K[B];
            return q;
          }, le = (0, p.default)(Z);
          return (0, u.createElement)("span", s({
            className: x
          }, A, {
            children: U.map(function(se, K) {
              var q = F.substr(se.start, se.end - se.start);
              if (se.highlight) {
                Y++;
                var B = void 0;
                typeof O == "object" ? C ? B = O[q] : (O = le(O), B = O[q.toLowerCase()]) : B = O;
                var ue = Y === +P;
                ee = B + " " + (ue ? h : ""), J = ue === !0 && E != null ? Object.assign({}, w, E) : w;
                var re = {
                  children: q,
                  className: ee,
                  key: K,
                  style: J
                };
                return typeof G != "string" && (re.highlightIndex = Y), (0, u.createElement)(G, re);
              } else
                return (0, u.createElement)(k, {
                  children: q,
                  className: V,
                  key: K,
                  style: j
                });
            })
          }));
        }
        t.exports = o.default;
      }),
      /* 3 */
      /***/
      (function(t, o) {
        t.exports = /******/
        (function(n) {
          var s = {};
          function i(l) {
            if (s[l])
              return s[l].exports;
            var d = s[l] = {
              /******/
              exports: {},
              /******/
              id: l,
              /******/
              loaded: !1
              /******/
            };
            return n[l].call(d.exports, d, d.exports, i), d.loaded = !0, d.exports;
          }
          return i.m = n, i.c = s, i.p = "", i(0);
        })([
          /* 0 */
          /***/
          (function(n, s, i) {
            n.exports = i(1);
          }),
          /* 1 */
          /***/
          (function(n, s, i) {
            Object.defineProperty(s, "__esModule", {
              value: !0
            });
            var l = i(2);
            Object.defineProperty(s, "combineChunks", {
              enumerable: !0,
              get: function() {
                return l.combineChunks;
              }
            }), Object.defineProperty(s, "fillInChunks", {
              enumerable: !0,
              get: function() {
                return l.fillInChunks;
              }
            }), Object.defineProperty(s, "findAll", {
              enumerable: !0,
              get: function() {
                return l.findAll;
              }
            }), Object.defineProperty(s, "findChunks", {
              enumerable: !0,
              get: function() {
                return l.findChunks;
              }
            });
          }),
          /* 2 */
          /***/
          (function(n, s) {
            Object.defineProperty(s, "__esModule", {
              value: !0
            }), s.findAll = function(f) {
              var g = f.autoEscape, y = f.caseSensitive, h = y === void 0 ? !1 : y, T = f.findChunks, P = T === void 0 ? l : T, E = f.sanitize, $ = f.searchWords, R = f.textToHighlight;
              return d({
                chunksToHighlight: i({
                  chunks: P({
                    autoEscape: g,
                    caseSensitive: h,
                    sanitize: E,
                    searchWords: $,
                    textToHighlight: R
                  })
                }),
                totalLength: R ? R.length : 0
              });
            };
            var i = s.combineChunks = function(f) {
              var g = f.chunks;
              return g = g.sort(function(y, h) {
                return y.start - h.start;
              }).reduce(function(y, h) {
                if (y.length === 0)
                  return [h];
                var T = y.pop();
                if (h.start <= T.end) {
                  var P = Math.max(T.end, h.end);
                  y.push({ start: T.start, end: P });
                } else
                  y.push(T, h);
                return y;
              }, []), g;
            }, l = function(f) {
              var g = f.autoEscape, y = f.caseSensitive, h = f.sanitize, T = h === void 0 ? u : h, P = f.searchWords, E = f.textToHighlight;
              return E = T(E), P.filter(function($) {
                return $;
              }).reduce(function($, R) {
                R = T(R), g && (R = c(R));
                for (var C = new RegExp(R, y ? "g" : "gi"), x = void 0; x = C.exec(E); ) {
                  var _ = x.index, D = C.lastIndex;
                  D > _ && $.push({ start: _, end: D }), x.index == C.lastIndex && C.lastIndex++;
                }
                return $;
              }, []);
            };
            s.findChunks = l;
            var d = s.fillInChunks = function(f) {
              var g = f.chunksToHighlight, y = f.totalLength, h = [], T = function($, R, C) {
                R - $ > 0 && h.push({
                  start: $,
                  end: R,
                  highlight: C
                });
              };
              if (g.length === 0)
                T(0, y, !1);
              else {
                var P = 0;
                g.forEach(function(E) {
                  T(P, E.start, !1), T(E.start, E.end, !0), P = E.end;
                }), T(P, y, !1);
              }
              return h;
            };
            function u(p) {
              return p;
            }
            function c(p) {
              return p.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
            }
          })
          /******/
        ]);
      }),
      /* 4 */
      /***/
      (function(t, o) {
        t.exports = React__default;
      }),
      /* 5 */
      /***/
      (function(t, o) {
        var n = function(l, d) {
          return l === d;
        };
        function s(i) {
          var l = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : n, d = void 0, u = [], c = void 0, p = !1, f = function(h, T) {
            return l(h, u[T]);
          }, g = function() {
            for (var h = arguments.length, T = Array(h), P = 0; P < h; P++)
              T[P] = arguments[P];
            return p && d === this && T.length === u.length && T.every(f) || (p = !0, d = this, u = T, c = i.apply(this, T)), c;
          };
          return g;
        }
        t.exports = s;
      })
      /******/
    ]);
  })(main)), main.exports;
}
var mainExports = requireMain();
const Highlighter = /* @__PURE__ */ getDefaultExportFromCjs(mainExports), TextHighlighter = ({
  searchQueryArray: e,
  text: t,
  testId: o = "text-highlighter"
}) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  Highlighter,
  {
    "data-testid": o,
    searchWords: e,
    textToHighlight: t,
    autoEscape: !0
  }
), Video = ({
  isVideoActive: e,
  isAudioActive: t,
  showAsThumbnail: o,
  currentStep: n,
  name: s,
  identifier: i
}) => {
  const l = n === "interaction", d = !o && !!s?.length, u = "video-container-" + i;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    MainVideoWrapper,
    {
      showAsThumbnail: o,
      "data-testid": "wrapper-" + i,
      children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Wrapper$1, { showAsThumbnail: o, "data-testid": i, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          VideoWrapper,
          {
            id: u,
            "data-testid": u,
            isHidden: !l || !e
          }
        ),
        l && !e && /* @__PURE__ */ jsxRuntimeExports.jsx(NoVideoPlaceholder, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          ParticipantBox,
          {
            attendeeName: s,
            showAsThumbnail: o
          }
        ) }),
        !l && /* @__PURE__ */ jsxRuntimeExports.jsx(NoVideoPlaceholder, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(ParticipantStatusIcon, { children: [
          n === "waiting-room" && /* @__PURE__ */ jsxRuntimeExports.jsx(InWaitingRoomIcon, {}),
          n !== "waiting-room" && /* @__PURE__ */ jsxRuntimeExports.jsx(NotJoinedIcon, {})
        ] }) }),
        d && /* @__PURE__ */ jsxRuntimeExports.jsx(ParticipantName, { name: s }),
        !t && !o && /* @__PURE__ */ jsxRuntimeExports.jsx(AudioMutedIndicator, {})
      ] })
    }
  );
}, MainVideoWrapper = styled(Box, {
  shouldForwardProp: (e) => e !== "showAsThumbnail"
})(({ showAsThumbnail: e }) => ({
  display: "flex",
  objectFit: "cover",
  justifyContent: "center",
  flex: 1,
  height: e ? 48 : "100%",
  width: e ? 48 : "100%"
})), Wrapper$1 = styled(Box, {
  shouldForwardProp: (e) => e !== "showAsThumbnail"
})(({ theme: e, showAsThumbnail: t }) => ({
  width: "100%",
  overflow: "hidden",
  position: "relative",
  borderRadius: t ? Number(e.shape.borderRadius) : Number(e.shape.borderRadius) * 2
})), NoVideoPlaceholder = styled(Box)(({ theme: e }) => ({
  height: "100%",
  width: "100%",
  background: e.palette.grey[700],
  display: "grid",
  placeContent: "center"
})), ParticipantStatusIcon = styled(Box)(({ theme: e }) => ({
  height: e.spacing(6),
  width: e.spacing(6)
})), NotJoinedIcon = styled(PersonOffRoundedIcon)(({ theme: e }) => ({
  color: e.palette.common.white,
  width: "100%",
  height: "100%"
})), InWaitingRoomIcon = styled(ManageAccountsRoundedIcon)(({ theme: e }) => ({
  color: e.palette.common.white,
  width: "100%",
  height: "100%"
})), VideoWrapper = styled(Box, {
  shouldForwardProp: (e) => e !== "isHidden"
})(({ theme: e, isHidden: t }) => ({
  height: "100%",
  width: "100%",
  display: t ? "none" : "block",
  // These styles will be applied to the video element inserted by OpenVidu
  video: {
    height: "100%",
    width: "100%",
    objectFit: "cover",
    border: "unset",
    position: "absolute",
    top: "0",
    left: "0"
  },
  [e.breakpoints.down("md")]: {
    textAlign: "center"
  }
})), VideoContainer = ({
  topCameras: e,
  bottomCamera: t,
  showAsThumbnail: o,
  hideCameraInMobile: n,
  cameraDirection: s
}) => {
  const i = e.length < 3 ? 12 : 6;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    Wrapper,
    {
      "data-testid": "videos-container",
      showAsThumbnail: o,
      hideCameraInMobile: n,
      cameraDirection: s,
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          TopCameraContainer,
          {
            cameraDirection: s,
            showAsThumbnail: o,
            children: /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { container: !0, sx: { width: "100%" }, children: e.map((l, d) => /* @__PURE__ */ jsxRuntimeExports.jsx(StyledGridItem, { size: { xs: i }, children: l }, d)) })
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          BottomCameraContainer,
          {
            cameraDirection: s,
            showAsThumbnail: o,
            children: /* @__PURE__ */ jsxRuntimeExports.jsx(
              BottomCamera,
              {
                showAsThumbnail: o,
                cameraDirection: s,
                children: t
              }
            )
          }
        ),
        o && /* @__PURE__ */ jsxRuntimeExports.jsx(ThumbnailGrid, { container: !0, children: e.map((l, d) => /* @__PURE__ */ jsxRuntimeExports.jsx(StyledGridItem, { size: { xs: 12 }, children: l }, d)) })
      ]
    }
  );
}, Wrapper = styled(Box, {
  shouldForwardProp: (e) => ["cameraDirection", "hideCameraInMobile"].indexOf(e) === -1
})(({ cameraDirection: e, hideCameraInMobile: t, theme: o }) => ({
  display: "flex",
  flexDirection: e === "horizontal" ? "row" : "column",
  alignItems: e === "horizontal" ? "center" : "unset",
  height: "100%",
  padding: "0 5px",
  [o.breakpoints.down("md")]: {
    display: t ? "none" : "flex"
  }
})), TopCameraContainer = styled(Box, {
  shouldForwardProp: (e) => ["cameraDirection", "showAsThumbnail"].indexOf(e) === -1
})(({ cameraDirection: e, showAsThumbnail: t }) => ({
  display: t ? "none" : "flex",
  flex: 4,
  height: e === "horizontal" ? "100%" : "80%",
  width: e === "horizontal" ? "70%" : "100%"
})), BottomCameraContainer = styled(Box, {
  shouldForwardProp: (e) => ["cameraDirection", "showAsThumbnail"].indexOf(e) === -1
})(({ cameraDirection: e, showAsThumbnail: t }) => ({
  display: t ? "block" : "flex",
  height: e === "horizontal" ? "33%" : "unset",
  width: e === "horizontal" ? "unset" : "100%",
  flex: e === "horizontal" ? 2 : 1,
  minHeight: t ? "48px" : "100px",
  justifyContent: "center"
})), BottomCamera = styled(Box, {
  shouldForwardProp: (e) => ["showAsThumbnail", "cameraDirection"].indexOf(e) === -1
})(({ showAsThumbnail: e, cameraDirection: t }) => ({
  width: !e && t === "vertical" ? "50%" : "100%",
  display: "flex",
  justifyContent: "center"
})), ThumbnailGrid = styled(Grid)(({ theme: e }) => ({
  width: "100%",
  display: "flex",
  height: "100%",
  justifyContent: "center",
  alignContent: "start",
  paddingTop: e.spacing(1)
})), StyledGridItem = styled(Grid)(({ theme: e }) => ({
  padding: e.spacing(0.5),
  display: "flex",
  justifyContent: "center"
}));
export {
  IconButtonAnimate as $,
  ActivityStatusDataEnum as A,
  BooleanEnumData as B,
  CallTypeDataEnum as C,
  DataPermissionTypeDataEnum as D,
  EntityFilterTypeDataEnum as E,
  palette as F,
  GenderDataEnum as G,
  shadows as H,
  ThemeProvider as I,
  typography as J,
  AddItemIcon as K,
  LifecycleStatusDataEnum as L,
  AudioMutedIndicator as M,
  ColumnHeader as N,
  OrganizationBaseTypeDataEnum as O,
  PersonAssignmentBaseTypeDataEnum as P,
  ConsentCollectionColumn as Q,
  ReactionDataEnum as R,
  SpecialityClassificationDataEnum as S,
  TemplateTypeDataEnum as T,
  ConsentFormPreview as U,
  DeliveryInformation as V,
  WAITING_ROOM as W,
  DoubleListItem as X,
  DoubleListItemSkeleton as Y,
  ErrorPage as Z,
  HTMLMedia as _,
  ActivityTypeBaseTypeDataEnum as a,
  getPersonFullNameWithTitle as a$,
  IconWrapper as a0,
  Image$1 as a1,
  InfiniteScrollingOrganizationCardSkeleton as a2,
  InfiniteScrollingPersonCardSkeleton as a3,
  InteractionItemsColumn as a4,
  Label as a5,
  Loader as a6,
  MediaSharingColumn as a7,
  MenuPopover as a8,
  MultiLineSingleSelect as a9,
  SelectedItemIcon as aA,
  SettingsButton as aB,
  SignatureBox as aC,
  SimpleDialog as aD,
  SnackbarIcon as aE,
  SquareButton as aF,
  TabPanel as aG,
  TabsPanel as aH,
  TextHighlighter as aI,
  TextWithEllipsis as aJ,
  varFade as aK,
  varTranEnter as aL,
  varTranExit as aM,
  varTranHover as aN,
  Video as aO,
  VideoContainer as aP,
  VideoControlsWrapper as aQ,
  convertMediaDataToMediaEvent as aR,
  convertMediaPayloadToMediaData as aS,
  countNumberOfDataPoints as aT,
  emailRegex as aU,
  filterNonNull as aV,
  FIRST_LINE_ICON_SIZE as aW,
  getConsentInputName as aX,
  getFormikInitialValues as aY,
  getInitialValues as aZ,
  getOneLineAddress as a_,
  NoItemPlaceholder as aa,
  OrganizationCard as ab,
  OrganizationCardSkeleton as ac,
  OrganizationInfo as ad,
  OverviewCard as ae,
  PageContainer as af,
  PageOverlay as ag,
  ParticipantBox as ah,
  ParticipantName as ai,
  PersonCard as aj,
  PersonCardSkeleton as ak,
  PersonInfo as al,
  PersonInfoSkeleton as am,
  PersonSimpleInfo as an,
  PointerAnimate as ao,
  PointerContainer as ap,
  PromotionalMaterialBatchInformation as aq,
  RemoveItemIcon as ar,
  RequestedSamples as as,
  ResetButton as at,
  RoomContentWrapper as au,
  RoomHeaderWrapper as av,
  RoundButton as aw,
  SampleItem as ax,
  SampleRequestPreview as ay,
  SearchTextField as az,
  ActivityTypeSchedulingDataEnum as b,
  getValidationSchema as b0,
  getVideoElementStatus as b1,
  handleRoomReplayEvents as b2,
  isMobileDevice as b3,
  SECOND_LINE_ICON_SIZE as b4,
  sortPromotionalMaterialGroup as b5,
  unpackNodeId as b6,
  commonjsGlobal as c,
  AddressTypeDataEnum as d,
  AttributeTypeDataEnum as e,
  CommentTargetTypeDataEnum as f,
  getDefaultExportFromCjs as g,
  CommunicationDataBaseTypeDataEnum as h,
  ConsentActionDataEnum as i,
  ConsentItemStateChangeDataEnum as j,
  ConsentTypeValidityModeDateEnum as k,
  GivenPromotionalMaterialChangeReasonDataEnum as l,
  PersonConsentLifecycleStateDataEnum as m,
  PromotionalMaterialTypeDataEnum as n,
  ResponsibleBodyDataEnum as o,
  StateDataEnum as p,
  StockTypeDataEnum as q,
  SupportedMediaTypeDataEnum as r,
  TouchpointStatusTypeDataEnum as s,
  CUSTOM_BREAKPOINTS as t,
  REMOTE_INTERACTION as u,
  useFormatDate as v,
  useElementSize as w,
  useLocalStorage as x,
  breakpoints as y,
  customShadows as z
};
//# sourceMappingURL=index-BruEUReA.js.map
